var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
define("app/basic-utils", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DistinctTracker;
    (function (DistinctTracker) {
        function GetNative() {
            return new ComparandTracker(function (x) { return x; });
        }
        DistinctTracker.GetNative = GetNative;
        var ComparandTracker = (function () {
            function ComparandTracker(GetComparand) {
                this.GetComparand = GetComparand;
                this.Values = new Map();
            }
            ComparandTracker.prototype[Symbol.iterator] = function () {
                return this.Values.values();
            };
            ComparandTracker.prototype.IsTracked = function (value) {
                return this.Values.has(this.GetComparand(value));
            };
            ComparandTracker.prototype.CheckThenTrack = function (value) {
                var comparand = this.GetComparand(value);
                if (this.Values.has(comparand))
                    return true;
                this.Values.set(comparand, value);
                return false;
            };
            ComparandTracker.prototype.Untrack = function (value) {
                var comparand = this.GetComparand(value);
                if (!this.Values.has(comparand))
                    return false;
                this.Values.delete(comparand);
                return true;
            };
            ComparandTracker.prototype.Clear = function () {
                this.Values.clear();
            };
            ComparandTracker.prototype.TryGetTracked = function (value) {
                var comparand = this.GetComparand(value);
                if (!this.Values.has(comparand))
                    return { value: value, isTracked: false, };
                return { value: this.Values.get(comparand), isTracked: true, };
            };
            return ComparandTracker;
        }());
        DistinctTracker.ComparandTracker = ComparandTracker;
        var ComparerTracker = (function () {
            function ComparerTracker(AreEqual) {
                this.AreEqual = AreEqual;
                this.Values = new Array();
            }
            ComparerTracker.prototype[Symbol.iterator] = function () {
                return this.Values[Symbol.iterator]();
            };
            ComparerTracker.prototype.IsTracked = function (value) {
                var _this = this;
                return this.Values.findIndex(function (x) { return !!_this.AreEqual(x, value); }) >= 0;
            };
            ComparerTracker.prototype.CheckThenTrack = function (value) {
                if (this.IsTracked(value))
                    return true;
                this.Values.push(value);
                return false;
            };
            ComparerTracker.prototype.Untrack = function (value) {
                var _this = this;
                var found = Collection.ArrayRemoveWhere(this.Values, function (x) { return _this.AreEqual(x, value); });
                return found.length > 0;
            };
            ComparerTracker.prototype.Clear = function () {
                this.Values.length = 0;
            };
            ComparerTracker.prototype.TryGetTracked = function (value) {
                var _this = this;
                var index = this.Values.findIndex(function (x) { return !!_this.AreEqual(x, value); });
                if (index < 0)
                    return { value: value, isTracked: false, };
                return { value: this.Values[index], isTracked: true, };
            };
            return ComparerTracker;
        }());
        DistinctTracker.ComparerTracker = ComparerTracker;
    })(DistinctTracker = exports.DistinctTracker || (exports.DistinctTracker = {}));
    function BaseToString(value) {
        return Object.prototype.toString.call(value);
    }
    function IsPrimitive(value) {
        switch (typeof value) {
            case "number":
            case "boolean":
            case "string":
                return true;
            default:
                return false;
        }
    }
    exports.IsPrimitive = IsPrimitive;
    function IsWritable(array) {
        return !Object.isFrozen(array);
    }
    exports.IsWritable = IsWritable;
    function IsArray(value) {
        return Array.isArray(value);
    }
    exports.IsArray = IsArray;
    function IsIterable(value) {
        return Collection.IsIterable(value);
    }
    exports.IsIterable = IsIterable;
    function IsObject(value) {
        return value !== null && typeof value === "object";
    }
    exports.IsObject = IsObject;
    function IsPromiseLike(value) {
        if (IsVoid(value) || (!IsObject(value) && !IsFunction(value)))
            return false;
        return IsFunction(value.then);
    }
    exports.IsPromiseLike = IsPromiseLike;
    function IsFunction(value) {
        return typeof value === "function";
    }
    exports.IsFunction = IsFunction;
    function IsSymbol(value) {
        return typeof value === "symbol";
    }
    exports.IsSymbol = IsSymbol;
    function IsObjectLike(value) {
        return IsObject(value) || IsFunction(value) || IsSymbol(value);
    }
    exports.IsObjectLike = IsObjectLike;
    function IsString(value) {
        return typeof value === "string";
    }
    exports.IsString = IsString;
    function IsBuiltInObject(builtInObjectName, value) {
        return !IsString(value) && BaseToString(value) === "[object " + builtInObjectName + "]";
    }
    function IsDate(value) {
        return IsBuiltInObject("Date", value);
    }
    exports.IsDate = IsDate;
    function IsRegExp(value) {
        return IsBuiltInObject("RegExp", value);
    }
    exports.IsRegExp = IsRegExp;
    function IsError(value) {
        return IsBuiltInObject("Error", value);
    }
    exports.IsError = IsError;
    function IsNumber(value) {
        return typeof value === "number";
    }
    exports.IsNumber = IsNumber;
    function IsScope(obj) {
        return obj && obj["$evalAsync"] && obj["$watch"];
    }
    exports.IsScope = IsScope;
    function IsVoid(value) {
        return IsUndefined(value) || value === null;
    }
    exports.IsVoid = IsVoid;
    function AssertNotVoid(value) {
        if (IsVoid(value))
            throw new Error("value is void");
        return value;
    }
    exports.AssertNotVoid = AssertNotVoid;
    function AsOptional(value) {
        return value;
    }
    exports.AsOptional = AsOptional;
    function IsSpecified(value) {
        return !IsVoid(value);
    }
    exports.IsSpecified = IsSpecified;
    function IsNotSpecified(value) {
        return IsVoid(value);
    }
    exports.IsNotSpecified = IsNotSpecified;
    function IsDefined(value) {
        return !IsUndefined(value);
    }
    exports.IsDefined = IsDefined;
    function IsUndefined(value) {
        return typeof (value) === "undefined";
    }
    exports.IsUndefined = IsUndefined;
    function HasProp(source, property, inherited) {
        if (inherited === void 0) { inherited = false; }
        if (IsVoid(source))
            return false;
        if (Object.prototype.hasOwnProperty.call(source, property))
            return true;
        if (!inherited)
            return false;
        if (!IsObjectLike(source))
            return HasProp(Object.getPrototypeOf(source), property, inherited);
        return property in source;
    }
    exports.HasProp = HasProp;
    (function (HasProp) {
        function _OfType(inherited, source, property, predicate) {
            if (!HasProp(source, property, inherited))
                return false;
            var value = source[property];
            return predicate(value, property);
        }
        var Direct;
        (function (Direct) {
            function OfType(source, property, predicate) {
                return _OfType(false, source, property, predicate);
            }
            Direct.OfType = OfType;
        })(Direct = HasProp.Direct || (HasProp.Direct = {}));
        function OfType(source, property, predicate) {
            return _OfType(true, source, property, predicate);
        }
        HasProp.OfType = OfType;
    })(HasProp = exports.HasProp || (exports.HasProp = {}));
    function IsBoolean(arg) {
        return typeof arg === "boolean";
    }
    exports.IsBoolean = IsBoolean;
    var MakeKeyedCollection = Global.Selcomm.Utils.MakeKeyedCollection;
    exports.MakeKeyedCollection = MakeKeyedCollection;
    var MakeNumberedCollection = Global.Selcomm.Utils.MakeNumberedCollection;
    exports.MakeNumberedCollection = MakeNumberedCollection;
    var List;
    (function (List) {
        function Create(source) {
            var arr = source.Items.slice();
            arr.Items = arr;
            arr.TotalFilteredRecords = source.TotalFilteredRecords;
            arr.TotalUnfilteredRecords = source.TotalUnfilteredRecords;
            return arr;
        }
        List.Create = Create;
        function Map(source, callbackFn, thisArg) {
            if (thisArg === void 0) { thisArg = source; }
            if (!source)
                return null;
            if (IsListData(source))
                return Create({ Items: source.Items.map(function (value, index) { return callbackFn(value, index, source); }, thisArg), TotalFilteredRecords: source.TotalFilteredRecords, TotalUnfilteredRecords: source.TotalUnfilteredRecords });
            else
                return source.map(callbackFn, thisArg);
        }
        List.Map = Map;
        function Filter(source, callbackFn, thisArg) {
            if (thisArg === void 0) { thisArg = source; }
            if (!source)
                return null;
            if (IsListData(source))
                return Create({ Items: source.Items.filter(function (value, index) { return callbackFn(value, index, source); }, thisArg), TotalFilteredRecords: source.TotalFilteredRecords, TotalUnfilteredRecords: source.TotalUnfilteredRecords });
            else
                return source.filter(callbackFn, thisArg);
        }
        List.Filter = Filter;
        function IsListData(item) {
            if (!item)
                return false;
            if (IsArray(item["Items"]))
                return true;
            return false;
        }
        List.IsListData = IsListData;
    })(List = exports.List || (exports.List = {}));
    var Registar = (function () {
        function Registar() {
            this.items = Object.freeze([]);
        }
        Object.defineProperty(Registar.prototype, "Items", {
            get: function () {
                return this.items;
            },
            enumerable: true,
            configurable: true
        });
        Registar.prototype.Register = function (item) {
            var _this = this;
            if (this.items.indexOf(item) <= 0)
                this.items = Object.freeze(__spread(this.items, [item]));
            return function () { return _this.Unregister(item); };
        };
        Registar.prototype.Unregister = function (item) {
            this.UnregisterWhere(function (x) { return x === item; });
        };
        Registar.prototype.UnregisterWhere = function (predicate) {
            this.items = Object.freeze(this.Items.filter(function (x) { return !predicate(x); }));
        };
        Registar.prototype.Clear = function () {
            this.items = Object.freeze([]);
        };
        return Registar;
    }());
    exports.Registar = Registar;
    function HasFlag(source, flag) {
        return (source & flag) === flag;
    }
    exports.HasFlag = HasFlag;
    function HasOtherFlags(source, flag) {
        return (source & ~flag) !== 0;
    }
    exports.HasOtherFlags = HasOtherFlags;
    function HasFlagWithOthers(source, flag) {
        return HasFlag(source, flag) && HasOtherFlags(source, flag);
    }
    exports.HasFlagWithOthers = HasFlagWithOthers;
    var RangeType;
    (function (RangeType) {
        RangeType[RangeType["Exclusive"] = 0] = "Exclusive";
        RangeType[RangeType["LeftInclusive"] = 1] = "LeftInclusive";
        RangeType[RangeType["RightInclusive"] = 2] = "RightInclusive";
        RangeType[RangeType["Inclusive"] = 3] = "Inclusive";
    })(RangeType = exports.RangeType || (exports.RangeType = {}));
    var RangeCheckResult;
    (function (RangeCheckResult) {
        RangeCheckResult[RangeCheckResult["OutsideRange"] = 0] = "OutsideRange";
        RangeCheckResult[RangeCheckResult["OutsideLeft"] = 2] = "OutsideLeft";
        RangeCheckResult[RangeCheckResult["OutsideRight"] = 4] = "OutsideRight";
        RangeCheckResult[RangeCheckResult["OutsideBoth"] = 6] = "OutsideBoth";
        RangeCheckResult[RangeCheckResult["InRange"] = 1] = "InRange";
        RangeCheckResult[RangeCheckResult["InRangeLeftMost"] = 9] = "InRangeLeftMost";
        RangeCheckResult[RangeCheckResult["InRangeRightMost"] = 17] = "InRangeRightMost";
        RangeCheckResult[RangeCheckResult["InRangeBoth"] = 25] = "InRangeBoth";
    })(RangeCheckResult = exports.RangeCheckResult || (exports.RangeCheckResult = {}));
    var Range = (function () {
        function Range(other, right, type) {
            if (IsObject(other)) {
                this.Left = other.Left;
                this.Right = other.Right;
                this.Type = other.Type;
            }
            else {
                this.Left = other;
                this.Right = right;
                this.Type = type;
            }
        }
        Object.defineProperty(Range.prototype, "IsLeftInclusive", {
            get: function () {
                return HasFlag(this.Type, RangeType.LeftInclusive);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Range.prototype, "IsRightInclusive", {
            get: function () {
                return HasFlag(this.Type, RangeType.RightInclusive);
            },
            enumerable: true,
            configurable: true
        });
        Range.AreEqual = function (x, y) {
            if (!x && !y)
                return true;
            if (!x || !y)
                return false;
            return x.Right === y.Right && x.Left == y.Left && x.Type === y.Type;
        };
        Object.defineProperty(Range.prototype, "Integers", {
            get: function () {
                if (this._integers === undefined) {
                    var clampedLeft = Math.ceil(this.Left);
                    var clampedRight = Math.max(this.Right);
                    if (clampedLeft === this.Left && !this.IsLeftInclusive)
                        clampedLeft++;
                    if (clampedRight === this.Right && !this.IsRightInclusive)
                        clampedRight++;
                    this._integers = new IntegerRange(clampedLeft, clampedRight, RangeType.Inclusive);
                }
                return this._integers;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Range.prototype, "HasValues", {
            get: function () {
                if (this.Right > this.Left)
                    return true;
                else if (this.Right === this.Left)
                    return this.Type !== RangeType.Exclusive;
                else
                    return false;
            },
            enumerable: true,
            configurable: true
        });
        Range.prototype.InRange = function (value) {
            return HasFlag(this.Check(value), RangeCheckResult.InRange);
        };
        Range.prototype.Check = function (value) {
            if (!IsSpecified(value) || Number.isNaN(value))
                return RangeCheckResult.OutsideRange;
            var _a = this, IsLeftInclusive = _a.IsLeftInclusive, IsRightInclusive = _a.IsRightInclusive, Left = _a.Left, Right = _a.Right;
            {
                var outsideLeft = IsLeftInclusive ? value < Left : value <= Left;
                var outsideRight = IsRightInclusive ? value > Right : value >= Right;
                if (outsideLeft && outsideRight)
                    return RangeCheckResult.OutsideLeft | RangeCheckResult.OutsideRight;
                if (outsideLeft)
                    return RangeCheckResult.OutsideLeft;
                if (outsideRight)
                    return RangeCheckResult.OutsideRight;
            }
            {
                var atLeft = IsLeftInclusive && Left === value;
                var atRight = IsRightInclusive && Right === value;
                if (atLeft && atRight)
                    return RangeCheckResult.InRangeBoth;
                if (atLeft)
                    return RangeCheckResult.InRangeLeftMost;
                if (atRight)
                    return RangeCheckResult.InRangeRightMost;
                return RangeCheckResult.InRange;
            }
        };
        Range.prototype.WithType = function (type) {
            return new Range(this.Left, this.Right, type);
        };
        Range.prototype.GetLeftIntersector = function (other) {
            if (this.Left > other.Left)
                return this;
            else if (this.Left < other.Left)
                return other;
            else if (!this.IsLeftInclusive)
                return this;
            else
                return other;
        };
        Range.prototype.GetRightIntersector = function (other) {
            if (this.Right < other.Right)
                return this;
            else if (this.Right > other.Right)
                return other;
            else if (!this.IsRightInclusive)
                return this;
            else
                return other;
        };
        Range.prototype.IntersectLeft = function (other) {
            return Range.Mix(this.GetLeftIntersector(other), this);
        };
        Range.prototype.IntersectRight = function (other) {
            return Range.Mix(this, this.GetRightIntersector(other));
        };
        Range.prototype.Intersect = function (other) {
            return Range.Mix(this.GetLeftIntersector(other), this.GetRightIntersector(other));
        };
        Range.Mix = function (left, right) {
            return new Range(left.Left, right.Right, (RangeType.LeftInclusive & left.Type) | (RangeType.RightInclusive & right.Type));
        };
        Range.prototype.toString = function () {
            return "" + (this.IsLeftInclusive ? "[" : "(") + this.Left + "," + this.Right + (this.IsRightInclusive ? "]" : ")");
        };
        return Range;
    }());
    exports.Range = Range;
    var IntegerRange = (function (_super) {
        __extends(IntegerRange, _super);
        function IntegerRange(other, right, type) {
            var _this = this;
            if (IsObject(other)) {
                _this = _super.call(this, other) || this;
            }
            else {
                _this = _super.call(this, other, right, type) || this;
            }
            return _this;
        }
        Object.defineProperty(IntegerRange.prototype, "All", {
            get: function () {
                if (!this._all) {
                    var integers = [];
                    var x = this.AsType(RangeType.Inclusive);
                    for (var i = x.Left; i <= x.Right; i++) {
                        integers.push(i);
                    }
                    this._all = Object.freeze(integers);
                }
                return this._all;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(IntegerRange.prototype, "Integers", {
            get: function () {
                return this;
            },
            enumerable: true,
            configurable: true
        });
        IntegerRange.prototype.AsType = function (newType) {
            if (newType === this.Type)
                return this;
            var newLeft = this.Left;
            {
                var oldLeftInclusive = HasFlag(this.Type, RangeType.LeftInclusive);
                var newLeftInclusive = HasFlag(newType, RangeType.LeftInclusive);
                if (oldLeftInclusive !== newLeftInclusive) {
                    if (newLeftInclusive)
                        newLeft++;
                    else
                        newLeft--;
                }
            }
            var newRight = this.Right;
            {
                var oldRightInclusive = HasFlag(this.Type, RangeType.RightInclusive);
                var newRightInclusive = HasFlag(newType, RangeType.RightInclusive);
                if (oldRightInclusive !== newRightInclusive) {
                    if (newRightInclusive)
                        newRight--;
                    else
                        newRight++;
                }
            }
            return new IntegerRange(newLeft, newRight, newType);
        };
        IntegerRange.prototype.IntersectLeft = function (other) {
            return new IntegerRange(_super.prototype.IntersectLeft.call(this, other));
        };
        IntegerRange.prototype.IntersectRight = function (other) {
            return new IntegerRange(_super.prototype.IntersectRight.call(this, other));
        };
        IntegerRange.prototype.Intersect = function (other) {
            return new IntegerRange(_super.prototype.Intersect.call(this, other));
        };
        Object.defineProperty(IntegerRange.prototype, "OutsideLeftEdge", {
            get: function () {
                return this.IsLeftInclusive ? this.Left - 1 : this.Left;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(IntegerRange.prototype, "OutsideRightEdge", {
            get: function () {
                return this.IsRightInclusive ? this.Right + 1 : this.Right;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(IntegerRange.prototype, "InsideLeftEdge", {
            get: function () {
                return this.IsLeftInclusive ? this.Left : this.Left + 1;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(IntegerRange.prototype, "InsideRightEdge", {
            get: function () {
                return this.IsRightInclusive ? this.Right : this.Right - 1;
            },
            enumerable: true,
            configurable: true
        });
        IntegerRange.prototype.Check = function (value) {
            var superResult = _super.prototype.Check.call(this, value);
            if (!HasFlag(superResult, RangeCheckResult.InRange))
                return superResult;
            var _a = this, IsLeftInclusive = _a.IsLeftInclusive, IsRightInclusive = _a.IsRightInclusive, Left = _a.Left, Right = _a.Right;
            {
                var atExclusiveLeft = !IsLeftInclusive && Left + 1 === value;
                var atExclusiveRight = !IsRightInclusive && Right - 1 === value;
                var newResult = superResult;
                if (atExclusiveLeft)
                    newResult |= RangeCheckResult.InRangeLeftMost;
                if (atExclusiveRight)
                    newResult |= RangeCheckResult.InRangeRightMost;
                return newResult;
            }
        };
        IntegerRange.Mix = function (left, right) {
            return new IntegerRange(left.Left, right.Right, (RangeType.LeftInclusive & left.Type) | (RangeType.RightInclusive & right.Type));
        };
        return IntegerRange;
    }(Range));
    exports.IntegerRange = IntegerRange;
    function Capitalise(text, forceRemainingToLower) {
        if (forceRemainingToLower === void 0) { forceRemainingToLower = true; }
        if (!text)
            return "";
        return text[0].toUpperCase() + (forceRemainingToLower ? text.substr(1).toLowerCase() : text.substr(1));
    }
    exports.Capitalise = Capitalise;
    function EncodeUriComponent(uriComponent) {
        if (!IsSpecified(uriComponent))
            return "";
        else
            return encodeURIComponent(uriComponent);
    }
    exports.EncodeUriComponent = EncodeUriComponent;
    function FormatTemplateString(formatArg, literals, args) {
        return Collection.Interleave(literals, args.map(formatArg)).map(function (s) { return IsSpecified(s) ? s : ""; }).join("");
    }
    exports.FormatTemplateString = FormatTemplateString;
    function EncodeUri(literals) {
        var placeholders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            placeholders[_i - 1] = arguments[_i];
        }
        return FormatTemplateString(EncodeUriComponent, literals, placeholders);
    }
    exports.EncodeUri = EncodeUri;
    function FormatJson(literals) {
        var placeholders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            placeholders[_i - 1] = arguments[_i];
        }
        return FormatTemplateString(function (placeholder) { return JSON.stringify(placeholder); }, literals, placeholders);
    }
    exports.FormatJson = FormatJson;
    var Collection;
    (function (Collection) {
        function Interleave() {
            var arrays = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                arrays[_i] = arguments[_i];
            }
            var maxLength = arrays.reduce(function (max, curr) { return Math.max(max, curr.length); }, Number.MIN_SAFE_INTEGER);
            var interleaved = [];
            for (var i = 0; i < maxLength; i++) {
                try {
                    for (var arrays_1 = __values(arrays), arrays_1_1 = arrays_1.next(); !arrays_1_1.done; arrays_1_1 = arrays_1.next()) {
                        var array = arrays_1_1.value;
                        if (i >= array.length)
                            continue;
                        interleaved.push(array[i]);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (arrays_1_1 && !arrays_1_1.done && (_a = arrays_1.return)) _a.call(arrays_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            return interleaved;
            var e_1, _a;
        }
        Collection.Interleave = Interleave;
        function SequenceEqual(first, second, areEqual) {
            if (areEqual === void 0) { areEqual = function (first, second) { return first === second; }; }
            return Collection.All(Collection.IterateTogether({ first: Collection.ToIterable(first), second: Collection.ToIterable(second) }), function (x) { return !x.first.done && !x.second.done && areEqual(x.first.value, x.second.value); });
        }
        Collection.SequenceEqual = SequenceEqual;
    })(Collection = exports.Collection || (exports.Collection = {}));
    function BaseAreEqual(x, y, equalityFn) {
        if (!IsSpecified(x) || !IsSpecified(y))
            return IsSpecified(x) == IsSpecified(y);
        else
            return equalityFn(x, y);
    }
    exports.BaseAreEqual = BaseAreEqual;
    function BindFunctions(source) {
        var prototype = extendedConstructor.prototype = source.prototype;
        var descriptors = Object.getOwnPropertyDescriptors(source);
        try {
            for (var _a = __values(Object.keys(source).concat(TryGetOwnPropertySymbols(source)).concat("name", "length")), _b = _a.next(); !_b.done; _b = _a.next()) {
                var key = _b.value;
                var descriptor = Object.getOwnPropertyDescriptor(source, key);
                if (!descriptor)
                    continue;
                TryDefineProperty(extendedConstructor, key, descriptor);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return extendedConstructor;
        function extendedConstructor() {
            var result = source.apply(this, arguments);
            for (var protoProp in prototype) {
                if (!HasProp(prototype, protoProp))
                    continue;
                if (HasProp(this, protoProp))
                    continue;
                var value = this[protoProp];
                if (!IsFunction(value))
                    continue;
                this[protoProp] = value.bind(this);
            }
            return result;
        }
        var e_2, _c;
    }
    exports.BindFunctions = BindFunctions;
    function IsWhitespace(source) {
        return IsString(source) ? IsWhitespace.String(source) : IsWhitespace.Nodes(source);
    }
    exports.IsWhitespace = IsWhitespace;
    (function (IsWhitespace) {
        function String(source) {
            return /^\s*$/.test(source);
        }
        IsWhitespace.String = String;
        function Nodes(nodes) {
            try {
                for (var _a = __values(Collection.ToIterable(nodes)), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var node = _b.value;
                    if (node.nodeType !== 3 || IsWhitespace.String(node.nodeValue))
                        return false;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return true;
            var e_3, _c;
        }
        IsWhitespace.Nodes = Nodes;
    })(IsWhitespace = exports.IsWhitespace || (exports.IsWhitespace = {}));
    function IsNullOrWhitespace(source) {
        return IsVoid(source) || IsWhitespace(source);
    }
    exports.IsNullOrWhitespace = IsNullOrWhitespace;
    function IsNotNullOrWhitespace(source) {
        return !IsNullOrWhitespace(source);
    }
    exports.IsNotNullOrWhitespace = IsNotNullOrWhitespace;
    function IsNullOrEmpty(source) {
        return IsVoid(source) || source === "";
    }
    exports.IsNullOrEmpty = IsNullOrEmpty;
    function IsNotNullOrEmpty(source) {
        return !IsNullOrEmpty(source);
    }
    exports.IsNotNullOrEmpty = IsNotNullOrEmpty;
    function TrimEnd(source) {
        return IsString(source) ? /^(.*?)\s*$/.exec(source)[1] : source;
    }
    exports.TrimEnd = TrimEnd;
    function Flatten(items, format) {
        if (format === void 0) { format = function (x) { return x; }; }
        var flattened = [];
        try {
            for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                var item = items_1_1.value;
                if (Array.isArray(item)) {
                    var asArray = item;
                    flattened.push.apply(flattened, __spread(Flatten(asArray, format)));
                }
                else {
                    var formatted = format(item);
                    if (Array.isArray(formatted))
                        flattened.push.apply(flattened, __spread(formatted));
                    else
                        flattened.push(formatted);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return flattened;
        var e_4, _a;
    }
    exports.Flatten = Flatten;
    function RegexEscape(val) {
        return String(val).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    exports.RegexEscape = RegexEscape;
    function RegexPattern(literals) {
        var placeholders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            placeholders[_i - 1] = arguments[_i];
        }
        function parsePlaceholder(placeholder) {
            if (placeholder instanceof RegExp)
                return placeholder.source;
            else if (!IsArray(placeholder))
                return RegexEscape(placeholder);
            else {
                return parsePlaceholder(placeholder.join(""));
            }
        }
        return FormatTemplateString(parsePlaceholder, literals, placeholders);
    }
    function Regex(flagsOrLiterals) {
        var placeholders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            placeholders[_i - 1] = arguments[_i];
        }
        if (IsArray(flagsOrLiterals))
            return new RegExp(RegexPattern.apply(void 0, __spread([flagsOrLiterals], placeholders)));
        else
            return function (literals) {
                var placeholders = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    placeholders[_i - 1] = arguments[_i];
                }
                return new RegExp(RegexPattern.apply(void 0, __spread([literals], placeholders)), flagsOrLiterals);
            };
    }
    exports.Regex = Regex;
    function Extend(first) {
        var additionalSources = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            additionalSources[_i - 1] = arguments[_i];
        }
        if (IsPrimitive(first))
            return first;
        var extended = ShallowCopy(first, true);
        try {
            for (var additionalSources_1 = __values(additionalSources), additionalSources_1_1 = additionalSources_1.next(); !additionalSources_1_1.done; additionalSources_1_1 = additionalSources_1.next()) {
                var source = additionalSources_1_1.value;
                FullAssign(extended, source, { CopyEnumerability: false, Predicate: FullAssign.IsNotNgHashKeyAndSourceEnumerable });
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (additionalSources_1_1 && !additionalSources_1_1.done && (_a = additionalSources_1.return)) _a.call(additionalSources_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return extended;
        var e_5, _a;
    }
    exports.Extend = Extend;
    function FullAssign(destination, source, options) {
        if (options === void 0) { options = {}; }
        if (!IsSpecified(destination) || !IsSpecified(source))
            return destination;
        if (IsPrimitive(destination))
            return destination;
        var copyEnumerability = FullAssign.Options.SourceOrDefault(options, "CopyEnumerability");
        var predicate = FullAssign.Options.SourceOrDefault(options, "Predicate");
        var map = FullAssign.Options.SourceOrDefault(options, "Map");
        var keys = Object.getOwnPropertyNames(source).concat(TryGetOwnPropertySymbols(source));
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                var sourceDescriptor = Object.getOwnPropertyDescriptor(source, key);
                var destinationDescriptor = Object.getOwnPropertyDescriptor(destination, key);
                if (!HasProp(sourceDescriptor, "value") && !HasProp(sourceDescriptor, "get"))
                    continue;
                if ((!destinationDescriptor || (destinationDescriptor.writable || destinationDescriptor.set)) && !copyEnumerability || sourceDescriptor.enumerable) {
                    if (!predicate(key, destination, destinationDescriptor, source, sourceDescriptor))
                        continue;
                    destination[key] = map(source[key]);
                }
                else if (!destinationDescriptor || destinationDescriptor.configurable) {
                    if (!predicate(key, destination, destinationDescriptor, source, sourceDescriptor))
                        continue;
                    Object.defineProperty(destination, key, {
                        enumerable: copyEnumerability ? sourceDescriptor.enumerable : true,
                        configurable: true,
                        value: map(source[key]),
                        writable: true,
                    });
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return destination;
        var e_6, _a;
    }
    (function (FullAssign) {
        var Options;
        (function (Options) {
            Options.Defaults = Object.freeze({
                CopyEnumerability: true,
                Predicate: IsNotNgHashKey,
                Map: function (source) { return source; },
            });
            function SourceOrDefault(source, key) {
                if (!source)
                    return Options.Defaults[key];
                var sourceValue = source[key];
                if (IsVoid(sourceValue))
                    return Options.Defaults[key];
                return sourceValue;
            }
            Options.SourceOrDefault = SourceOrDefault;
        })(Options = FullAssign.Options || (FullAssign.Options = {}));
        function IsNotNgHashKeyAndSourceEnumerable(key, destination, destinationDescriptor, source, sourceDescriptor) {
            return IsSourceEnumerable(key, destination, destinationDescriptor, source, sourceDescriptor) && IsNotNgHashKey(key, destination, destinationDescriptor, source, sourceDescriptor);
        }
        FullAssign.IsNotNgHashKeyAndSourceEnumerable = IsNotNgHashKeyAndSourceEnumerable;
        function IsSourceEnumerable(key, destination, destinationDescriptor, source, sourceDescriptor) {
            return !!sourceDescriptor.enumerable;
        }
        FullAssign.IsSourceEnumerable = IsSourceEnumerable;
        function IsNotNgHashKey(key, destination, destinationDescriptor, source, sourceDescriptor) {
            return key !== "$$hashKey";
        }
        FullAssign.IsNotNgHashKey = IsNotNgHashKey;
    })(FullAssign || (FullAssign = {}));
    function ShallowCopy(source, withPrototype) {
        if (withPrototype === void 0) { withPrototype = true; }
        if (!IsSpecified(source))
            return source;
        if (IsSymbol(source))
            throw new Error("Cannot shallow copy symbols");
        if (IsPrimitive(source))
            return source;
        if (IsFunction(source)) {
            var asFn_1 = source;
            var stringValue_1 = String(source);
            var length_1 = source.length;
            var name_1 = source.name;
            var clone = function () { return asFn_1.apply(this, arguments); };
            TryDefineProperty(clone, "toString", {
                writable: true,
                configurable: true,
                value: function () { return stringValue_1; },
            });
            TryDefineProperty(clone, "name", {
                writable: false,
                configurable: true,
                value: name_1,
            });
            TryDefineProperty(clone, "length", {
                writable: false,
                configurable: true,
                value: length_1,
            });
            clone.prototype = source.prototype;
            return FullAssign(clone, source);
        }
        if (IsArray(source))
            return FullAssign(source.slice(), source);
        if (IsObject(source))
            return FullAssign(Object.create(withPrototype ? Object.getPrototypeOf(source) : Object.prototype), source);
        throw new Error("Unknown type passed: " + typeof source);
    }
    exports.ShallowCopy = ShallowCopy;
    function DeepCopy(source, withPrototype) {
        if (withPrototype === void 0) { withPrototype = true; }
        var sourceObjects = new Array();
        var copiedObjects = new Array();
        var shouldUsePrototype = !IsFunction(withPrototype) ? function () { return withPrototype; } : withPrototype;
        if (IsSymbol(source))
            throw new Error("Cannot copy symbols");
        var fullAssignOptions = { Map: _DeepCopy };
        return _DeepCopy(source);
        function _DeepCopy(source) {
            if (!IsSpecified(source))
                return source;
            if (IsSymbol(source))
                return source;
            if (IsPrimitive(source))
                return source;
            var existingIndex = sourceObjects.indexOf(source);
            if (existingIndex >= 0)
                return copiedObjects[existingIndex];
            if (IsFunction(source)) {
                var asFn_2 = source;
                var stringValue_2 = String(source);
                var length_2 = source.length;
                var name_2 = source.name;
                var clone = function () { return asFn_2.apply(this, arguments); };
                TryDefineProperty(clone, "toString", {
                    writable: true,
                    configurable: true,
                    value: function () { return stringValue_2; },
                });
                TryDefineProperty(clone, "name", {
                    writable: false,
                    configurable: true,
                    value: name_2,
                });
                TryDefineProperty(clone, "length", {
                    writable: false,
                    configurable: true,
                    value: length_2,
                });
                clone.prototype = source.prototype;
                var fullCopy = FullAssign(clone, source, fullAssignOptions);
                sourceObjects.push(source);
                copiedObjects.push(fullCopy);
                return fullCopy;
            }
            if (IsArray(source)) {
                var fullCopy = FullAssign(source.slice(), source, fullAssignOptions);
                sourceObjects.push(source);
                copiedObjects.push(fullCopy);
                return fullCopy;
            }
            if (IsObject(source)) {
                var fullCopy = FullAssign(Object.create(shouldUsePrototype(source) ? Object.getPrototypeOf(source) : Object.prototype), source, fullAssignOptions);
                sourceObjects.push(source);
                copiedObjects.push(fullCopy);
                return fullCopy;
            }
            throw new Error("Unknown type passed: " + typeof source);
        }
    }
    exports.DeepCopy = DeepCopy;
    function ToString(value) {
        if (IsVoid(value))
            return null;
        return String(value);
    }
    exports.ToString = ToString;
    function Urlify() {
        var parts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parts[_i] = arguments[_i];
        }
        var joined = parts.map(ToString).filter(IsNotNullOrWhitespace).map(function (p) { return p.trim(); }).join("-");
        var prettified = joined
            .toLowerCase()
            .replace(/[<>"'%()+]/g, "")
            .replace(/[\s:\\\/]+/g, "-");
        return prettified;
    }
    exports.Urlify = Urlify;
    (function (Collection) {
        function ArrayRemove(array, value) {
            var i = array.indexOf(value);
            if (i >= 0)
                array.splice(i, 1);
            return i;
        }
        Collection.ArrayRemove = ArrayRemove;
        function ArrayRemoveAll(array, value) {
            while (ArrayRemove(array, value) >= 0)
                ;
        }
        Collection.ArrayRemoveAll = ArrayRemoveAll;
        function ArrayInsertEnd(array, value) {
            array.push(value);
            return value;
        }
        Collection.ArrayInsertEnd = ArrayInsertEnd;
        function ArrayRemoveWhere(source, predicate, limit) {
            if (limit === void 0) { limit = Number.POSITIVE_INFINITY; }
            if (!IsArray(source))
                throw new TypeError(FormatJson(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Source was of type ", "", ", expected an array."], ["Source was of type ", "", ", expected an array."])), typeof (source), source === null ? " (null)" : ""));
            var allRemoved = [];
            for (var i = 0; i < source.length && allRemoved.length < limit; i++) {
                if (!predicate(source[i], i))
                    continue;
                var removed = source.splice(i, 1);
                allRemoved.push.apply(allRemoved, __spread(removed));
                i--;
            }
            return allRemoved;
        }
        Collection.ArrayRemoveWhere = ArrayRemoveWhere;
        function ArrayReplaceWhere(source, predicate, valueFactory, limit) {
            if (limit === void 0) { limit = Number.POSITIVE_INFINITY; }
            var allReplaced = new Array();
            for (var i = 0; i < source.length && allReplaced.length < limit; i++) {
                var originalValue = source[i];
                if (!predicate(originalValue, i))
                    continue;
                var newValue = source[i] = valueFactory(originalValue, i);
                allReplaced.push({
                    Index: i,
                    OriginalValue: originalValue,
                    NewValue: newValue,
                });
            }
            return allReplaced;
        }
        Collection.ArrayReplaceWhere = ArrayReplaceWhere;
    })(Collection = exports.Collection || (exports.Collection = {}));
    function IsInjectable(source) {
        return IsArray(source) || source && IsArray(source.$inject);
    }
    exports.IsInjectable = IsInjectable;
    function Require(moduleId) {
        return new Promise(function (resolve, reject) { return require([moduleId], resolve, reject); });
    }
    exports.Require = Require;
    (function (Collection) {
        var EmptyCollectionError = (function (_super) {
            __extends(EmptyCollectionError, _super);
            function EmptyCollectionError() {
                return _super.call(this, "The collection was empty") || this;
            }
            EmptyCollectionError = __decorate([
                FixExtendBuiltIn
            ], EmptyCollectionError);
            return EmptyCollectionError;
        }(Error));
        Collection.EmptyCollectionError = EmptyCollectionError;
        function IndexOf(source, predicate, fromIndex) {
            if (fromIndex === void 0) { fromIndex = 0; }
            if (IsArray(source))
                return source.findIndex(function (value, index, obj) { return index >= fromIndex && !!predicate(value, index, obj); });
            try {
                for (var _a = __values(ToEnumerable(source).Skip(fromIndex).Select(function (value, i) { return ({ value: value, i: i + fromIndex }); })), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var item = _b.value;
                    var value = item.value, i = item.i;
                    if (predicate(value, i, source))
                        return i;
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_7) throw e_7.error; }
            }
            return -1;
            var e_7, _c;
        }
        Collection.IndexOf = IndexOf;
        function FirstOrFunc(source, predicate, onEmpty) {
            if (predicate === void 0) { predicate = function () { return true; }; }
            if (IsVoid(source))
                return onEmpty();
            var i = 0;
            try {
                for (var _a = __values(ToIterable(source)), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var value = _b.value;
                    if (predicate(value, i++))
                        return value;
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_8) throw e_8.error; }
            }
            return onEmpty();
            var e_8, _c;
        }
        function FirstOrDefault(source, predicate, defaultValue) {
            if (predicate === void 0) { predicate = function () { return true; }; }
            return FirstOrFunc(source, predicate, function () { return defaultValue; });
        }
        Collection.FirstOrDefault = FirstOrDefault;
        function First(source, predicate) {
            if (predicate === void 0) { predicate = function () { return true; }; }
            return FirstOrFunc(source, predicate, function () { throw new EmptyCollectionError(); });
        }
        Collection.First = First;
        function GetOrAdd(source, predicate, add, fromIndex) {
            if (fromIndex === void 0) { fromIndex = 0; }
            var index = IndexOf(source, predicate, fromIndex);
            if (index >= 0)
                return source[index];
            var newItem = add(source);
            source.push(newItem);
            return newItem;
        }
        Collection.GetOrAdd = GetOrAdd;
        function AddOrUpdate(source, predicate, add, update, fromIndex) {
            if (fromIndex === void 0) { fromIndex = 0; }
            var index = IndexOf(source, predicate, fromIndex);
            if (index >= 0)
                return source[index] = update(source[index], index, source);
            var newItem = add(source);
            source.push(newItem);
            return newItem;
        }
        Collection.AddOrUpdate = AddOrUpdate;
        function Distinct(source, areEqual) {
            return __spread(AsIterator.Distinct(source, areEqual ? new DistinctTracker.ComparerTracker(areEqual) : DistinctTracker.GetNative()));
        }
        Collection.Distinct = Distinct;
        function Concat(source) {
            var items = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                items[_i - 1] = arguments[_i];
            }
            return __spread(GetArray(source), items);
        }
        Collection.Concat = Concat;
        function ConcatArrays(source) {
            var arrays = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                arrays[_i - 1] = arguments[_i];
            }
            return JoinArrays.apply(void 0, __spread([source], arrays));
        }
        Collection.ConcatArrays = ConcatArrays;
        function JoinArrays() {
            var sources = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                sources[_i] = arguments[_i];
            }
            return (_a = new Array()).concat.apply(_a, __spread(sources.map(function (x) { return GetArray(x); })));
            var _a;
        }
        Collection.JoinArrays = JoinArrays;
        function MapMany(source, mapFn) {
            return JoinArrays.apply(void 0, __spread(GetArray(source).map(mapFn)));
        }
        Collection.MapMany = MapMany;
        function Union(predicateOrSource) {
            var sources = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                sources[_i - 1] = arguments[_i];
            }
            var areEqual;
            if (IsArray(predicateOrSource))
                sources.unshift(predicateOrSource);
            else
                areEqual = predicateOrSource;
            var unionedArray = [];
            var alreadyDefined;
            if (!IsSpecified(areEqual))
                alreadyDefined = function (x) { return unionedArray.indexOf(x) >= 0; };
            else {
                var _areEqual_1 = areEqual;
                alreadyDefined = function (x) { return IndexOf(unionedArray, function (item) { return _areEqual_1(x, item); }) >= 0; };
            }
            try {
                for (var sources_1 = __values(sources), sources_1_1 = sources_1.next(); !sources_1_1.done; sources_1_1 = sources_1.next()) {
                    var source = sources_1_1.value;
                    try {
                        for (var source_1 = __values(source), source_1_1 = source_1.next(); !source_1_1.done; source_1_1 = source_1.next()) {
                            var item = source_1_1.value;
                            if (alreadyDefined(item))
                                continue;
                            unionedArray.push(item);
                        }
                    }
                    catch (e_9_1) { e_9 = { error: e_9_1 }; }
                    finally {
                        try {
                            if (source_1_1 && !source_1_1.done && (_a = source_1.return)) _a.call(source_1);
                        }
                        finally { if (e_9) throw e_9.error; }
                    }
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (sources_1_1 && !sources_1_1.done && (_b = sources_1.return)) _b.call(sources_1);
                }
                finally { if (e_10) throw e_10.error; }
            }
            return unionedArray;
            var e_10, _b, e_9, _a;
        }
        Collection.Union = Union;
        function IterateTogether(iterables) {
            var iterators, anyOpen, results, iterators_1, iterators_1_1, iterator, result, e_11, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        iterators = Object.keys(iterables).map(function (k) { return ({ Key: k, Iterator: IsIterable(iterables[k]) ? iterables[k][Symbol.iterator]() : iterables[k] }); });
                        _b.label = 1;
                    case 1:
                        results = Object.create(null);
                        anyOpen = false;
                        try {
                            for (iterators_1 = __values(iterators), iterators_1_1 = iterators_1.next(); !iterators_1_1.done; iterators_1_1 = iterators_1.next()) {
                                iterator = iterators_1_1.value;
                                result = results[iterator.Key] = iterator.Iterator.next();
                                if (!result.done)
                                    anyOpen = true;
                            }
                        }
                        catch (e_11_1) { e_11 = { error: e_11_1 }; }
                        finally {
                            try {
                                if (iterators_1_1 && !iterators_1_1.done && (_a = iterators_1.return)) _a.call(iterators_1);
                            }
                            finally { if (e_11) throw e_11.error; }
                        }
                        if (!anyOpen) return [3, 3];
                        return [4, results];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        if (anyOpen) return [3, 1];
                        _b.label = 4;
                    case 4: return [2];
                }
            });
        }
        Collection.IterateTogether = IterateTogether;
        function ToIterable(source) {
            if (IsVoid(source))
                return [];
            if (IsIterable(source))
                return source;
            return new ArrayLikeIterable(source);
        }
        Collection.ToIterable = ToIterable;
        function GetIterator(source) {
            return ToIterable(source)[Symbol.iterator]();
        }
        Collection.GetIterator = GetIterator;
        function GroupBy(source, getKey, areEqual) {
            return !IsVoid(areEqual) ? GroupBy.CustomEquality(source, getKey, areEqual) : GroupBy.NativeEquality(source, getKey);
        }
        Collection.GroupBy = GroupBy;
        (function (GroupBy) {
            function NativeEquality(source, getKey) {
                if (IsVoid(getKey))
                    throw new Error("getKey must be specified");
                if (IsVoid(source))
                    return [];
                var groupsByKey = new Map();
                try {
                    for (var _a = __values(ToIterable(source)), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var item = _b.value;
                        var key = getKey(item);
                        var group = groupsByKey.get(key);
                        if (IsVoid(group))
                            groupsByKey.set(key, group = { Key: key, Values: [] });
                        group.Values.push(item);
                    }
                }
                catch (e_12_1) { e_12 = { error: e_12_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_12) throw e_12.error; }
                }
                return __spread(groupsByKey.values());
                var e_12, _c;
            }
            GroupBy.NativeEquality = NativeEquality;
            function MappedKey(source, getKey, getEquatableKey) {
                if (IsVoid(getKey))
                    throw new Error("getKey must be specified");
                if (IsVoid(source))
                    return [];
                var groupsByEquatableKey = new MappedKeyMap(getEquatableKey);
                try {
                    for (var _a = __values(ToIterable(source)), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var item = _b.value;
                        var key = getKey(item);
                        var group = groupsByEquatableKey.get(key);
                        if (IsVoid(group))
                            groupsByEquatableKey.set(key, group = { Key: key, Values: [] });
                        group.Values.push(item);
                    }
                }
                catch (e_13_1) { e_13 = { error: e_13_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_13) throw e_13.error; }
                }
                return __spread(groupsByEquatableKey.values());
                var e_13, _c;
            }
            GroupBy.MappedKey = MappedKey;
            function CustomEquality(source, getKey, areEqual) {
                if (IsVoid(getKey))
                    throw new Error("getKey must be specified");
                if (IsVoid(areEqual))
                    throw new Error("areEqual must be specified");
                if (IsVoid(source))
                    return [];
                var groups = new Array();
                var _loop_1 = function (item) {
                    var key = getKey(item);
                    var group = groups.find(function (g) { return areEqual(g.Key, key); });
                    if (IsVoid(group))
                        groups.push(group = { Key: key, Values: [] });
                    group.Values.push(item);
                };
                try {
                    for (var _a = __values(ToIterable(source)), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var item = _b.value;
                        _loop_1(item);
                    }
                }
                catch (e_14_1) { e_14 = { error: e_14_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_14) throw e_14.error; }
                }
                return groups;
                var e_14, _c;
            }
            GroupBy.CustomEquality = CustomEquality;
        })(GroupBy = Collection.GroupBy || (Collection.GroupBy = {}));
        function GetArray(source) {
            if (IsVoid(source))
                return source;
            if (IsArray(source))
                return source;
            if (IsIterable(source))
                return __spread(ToIterable(source));
            return new Array(source.length).fill(undefined).map(function (value, index) { return source[index]; });
        }
        Collection.GetArray = GetArray;
        var ArrayLikeIterable = (function () {
            function ArrayLikeIterable(Source) {
                this.Source = Source;
            }
            ArrayLikeIterable.prototype[Symbol.iterator] = function () {
                return new ArrayLikeIterator(this.Source);
            };
            return ArrayLikeIterable;
        }());
        var ArrayLikeIterator = (function (_super) {
            __extends(ArrayLikeIterator, _super);
            function ArrayLikeIterator() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.nextIndex = 0;
                return _this;
            }
            ArrayLikeIterator.prototype.next = function () {
                return {
                    value: this.Source[this.nextIndex],
                    done: ++this.nextIndex > this.Source.length,
                };
            };
            return ArrayLikeIterator;
        }(ArrayLikeIterable));
        function FromArrayLike(source) {
            return new ArrayLikeIterator(source);
        }
        Collection.FromArrayLike = FromArrayLike;
        function IsIterable(source) {
            return !IsVoid(source) && IsFunction(source[Symbol.iterator]);
        }
        Collection.IsIterable = IsIterable;
        var MappedKeyMap = (function () {
            function MappedKeyMap(GetEquatableKey, entries) {
                this.GetEquatableKey = GetEquatableKey;
                this.ValuesByEquatableKey = new Map();
                this.KeysByEquatableKey = new Map();
                if (!entries)
                    return;
                try {
                    for (var _a = __values(ToIterable(entries)), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var entry = _b.value;
                        this.set(entry[0], entry[1]);
                    }
                }
                catch (e_15_1) { e_15 = { error: e_15_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_15) throw e_15.error; }
                }
                var e_15, _c;
            }
            MappedKeyMap.prototype[Symbol.iterator] = function () {
                return this.entries();
            };
            MappedKeyMap.prototype.entries = function () {
                var _a, _b, entry, e_16_1, e_16, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 5, 6, 7]);
                            _a = __values(this.ValuesByEquatableKey), _b = _a.next();
                            _d.label = 1;
                        case 1:
                            if (!!_b.done) return [3, 4];
                            entry = _b.value;
                            return [4, [this.KeysByEquatableKey.get(entry[0]), entry[1]]];
                        case 2:
                            _d.sent();
                            _d.label = 3;
                        case 3:
                            _b = _a.next();
                            return [3, 1];
                        case 4: return [3, 7];
                        case 5:
                            e_16_1 = _d.sent();
                            e_16 = { error: e_16_1 };
                            return [3, 7];
                        case 6:
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_16) throw e_16.error; }
                            return [7];
                        case 7: return [2];
                    }
                });
            };
            MappedKeyMap.prototype.keys = function () {
                return this.KeysByEquatableKey.values();
            };
            MappedKeyMap.prototype.values = function () {
                return this.ValuesByEquatableKey.values();
            };
            MappedKeyMap.prototype.clear = function () {
                this.ValuesByEquatableKey.clear();
                this.KeysByEquatableKey.clear();
            };
            MappedKeyMap.prototype.delete = function (key) {
                var equatableKey = this.GetEquatableKey(key);
                var deletedValue = this.ValuesByEquatableKey.delete(equatableKey);
                var deletedKey = this.KeysByEquatableKey.delete(equatableKey);
                return deletedValue || deletedKey;
            };
            MappedKeyMap.prototype.forEach = function (callbackfn) {
                var _this = this;
                this.ValuesByEquatableKey.forEach(function (value, equatableKey, map) { return callbackfn(value, _this.KeysByEquatableKey.get(equatableKey), _this); });
            };
            MappedKeyMap.prototype.get = function (key) {
                var equatableKey = this.GetEquatableKey(key);
                return this.ValuesByEquatableKey.get(equatableKey);
            };
            MappedKeyMap.prototype.has = function (key) {
                var equatableKey = this.GetEquatableKey(key);
                return this.ValuesByEquatableKey.has(equatableKey);
            };
            MappedKeyMap.prototype.set = function (key, value) {
                var equatableKey = this.GetEquatableKey(key);
                this.ValuesByEquatableKey.set(equatableKey, value);
                this.KeysByEquatableKey.set(equatableKey, key);
                return this;
            };
            Object.defineProperty(MappedKeyMap.prototype, "size", {
                get: function () {
                    return this.ValuesByEquatableKey.size;
                },
                enumerable: true,
                configurable: true
            });
            return MappedKeyMap;
        }());
        Collection.MappedKeyMap = MappedKeyMap;
        var AsIterator;
        (function (AsIterator) {
            function Select(source, select) {
                var i, _a, _b, value, e_17_1, e_17, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            i = 0;
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 6, 7, 8]);
                            _a = __values(ToIterable(source)), _b = _a.next();
                            _d.label = 2;
                        case 2:
                            if (!!_b.done) return [3, 5];
                            value = _b.value;
                            return [4, select(value, i++)];
                        case 3:
                            _d.sent();
                            _d.label = 4;
                        case 4:
                            _b = _a.next();
                            return [3, 2];
                        case 5: return [3, 8];
                        case 6:
                            e_17_1 = _d.sent();
                            e_17 = { error: e_17_1 };
                            return [3, 8];
                        case 7:
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_17) throw e_17.error; }
                            return [7];
                        case 8: return [2];
                    }
                });
            }
            AsIterator.Select = Select;
            function SelectMany(source, select) {
                var i, _a, _b, value, e_18_1, e_18, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            i = 0;
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 6, 7, 8]);
                            _a = __values(ToIterable(source)), _b = _a.next();
                            _d.label = 2;
                        case 2:
                            if (!!_b.done) return [3, 5];
                            value = _b.value;
                            return [5, __values(ToIterable(select(value, i++)))];
                        case 3:
                            _d.sent();
                            _d.label = 4;
                        case 4:
                            _b = _a.next();
                            return [3, 2];
                        case 5: return [3, 8];
                        case 6:
                            e_18_1 = _d.sent();
                            e_18 = { error: e_18_1 };
                            return [3, 8];
                        case 7:
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_18) throw e_18.error; }
                            return [7];
                        case 8: return [2];
                    }
                });
            }
            AsIterator.SelectMany = SelectMany;
            function Skip(source, count) {
                var enumerator, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            enumerator = IEnumerator.Get(ToIterable(source));
                            for (i = 0; i < count; i++) {
                                enumerator.MoveNext();
                            }
                            _a.label = 1;
                        case 1:
                            if (!enumerator.MoveNext()) return [3, 3];
                            return [4, enumerator.Current];
                        case 2:
                            _a.sent();
                            return [3, 1];
                        case 3: return [2];
                    }
                });
            }
            AsIterator.Skip = Skip;
            function Take(source, count) {
                var enumerator, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (IsArray(source))
                                return [2, source.slice(0, count)];
                            enumerator = IEnumerator.Get(ToIterable(source));
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < count)) return [3, 4];
                            if (!enumerator.MoveNext())
                                return [3, 4];
                            return [4, enumerator.Current];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3, 1];
                        case 4: return [2];
                    }
                });
            }
            AsIterator.Take = Take;
            function Concat() {
                var sources = [];
                for (_i = 0; _i < arguments.length; _i++) {
                    sources[_i] = arguments[_i];
                }
                var _i, sources_2, sources_2_1, source, e_19_1, e_19, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 5, 6, 7]);
                            sources_2 = __values(sources), sources_2_1 = sources_2.next();
                            _b.label = 1;
                        case 1:
                            if (!!sources_2_1.done) return [3, 4];
                            source = sources_2_1.value;
                            return [5, __values(ToIterable(source))];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            sources_2_1 = sources_2.next();
                            return [3, 1];
                        case 4: return [3, 7];
                        case 5:
                            e_19_1 = _b.sent();
                            e_19 = { error: e_19_1 };
                            return [3, 7];
                        case 6:
                            try {
                                if (sources_2_1 && !sources_2_1.done && (_a = sources_2.return)) _a.call(sources_2);
                            }
                            finally { if (e_19) throw e_19.error; }
                            return [7];
                        case 7: return [2];
                    }
                });
            }
            AsIterator.Concat = Concat;
            function Where(source, predicate) {
                var i, source_2, source_2_1, item, e_20_1, e_20, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            i = 0;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 6, 7, 8]);
                            source_2 = __values(source), source_2_1 = source_2.next();
                            _b.label = 2;
                        case 2:
                            if (!!source_2_1.done) return [3, 5];
                            item = source_2_1.value;
                            if (!predicate(item, i++)) return [3, 4];
                            return [4, item];
                        case 3:
                            _b.sent();
                            _b.label = 4;
                        case 4:
                            source_2_1 = source_2.next();
                            return [3, 2];
                        case 5: return [3, 8];
                        case 6:
                            e_20_1 = _b.sent();
                            e_20 = { error: e_20_1 };
                            return [3, 8];
                        case 7:
                            try {
                                if (source_2_1 && !source_2_1.done && (_a = source_2.return)) _a.call(source_2);
                            }
                            finally { if (e_20) throw e_20.error; }
                            return [7];
                        case 8: return [2];
                    }
                });
            }
            AsIterator.Where = Where;
            function Distinct(source, distinctTracker) {
                if (distinctTracker === void 0) { distinctTracker = DistinctTracker.GetNative(); }
                var _a, _b, item, e_21_1, e_21, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            distinctTracker = IsFunction(distinctTracker) ? distinctTracker() : distinctTracker;
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 6, 7, 8]);
                            _a = __values(ToIterable(source)), _b = _a.next();
                            _d.label = 2;
                        case 2:
                            if (!!_b.done) return [3, 5];
                            item = _b.value;
                            if (!!distinctTracker.CheckThenTrack(item)) return [3, 4];
                            return [4, item];
                        case 3:
                            _d.sent();
                            _d.label = 4;
                        case 4:
                            _b = _a.next();
                            return [3, 2];
                        case 5: return [3, 8];
                        case 6:
                            e_21_1 = _d.sent();
                            e_21 = { error: e_21_1 };
                            return [3, 8];
                        case 7:
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_21) throw e_21.error; }
                            return [7];
                        case 8: return [2];
                    }
                });
            }
            AsIterator.Distinct = Distinct;
        })(AsIterator = Collection.AsIterator || (Collection.AsIterator = {}));
        function ToEnumerable(source) {
            if (IsFunction(source))
                source = (_a = {}, _a[Symbol.iterator] = source, _a);
            return new ValueBackedEnumerable(source);
            var _a;
        }
        Collection.ToEnumerable = ToEnumerable;
        var Enumerable = (function () {
            function Enumerable() {
            }
            Enumerable.prototype[Symbol.iterator] = function () {
                return this.GetIterator();
            };
            Enumerable.prototype.GetIterator = function () {
                return GetIterator(this.GetEnumerableSource());
            };
            Enumerable.prototype.ToIterable = function () {
                return ToIterable(this.GetEnumerableSource());
            };
            Enumerable.prototype.ToArray = function () {
                return __spread(this);
            };
            Enumerable.prototype.GetEnumerator = function () {
                return IEnumerator.Get(ToIterable(this.GetEnumerableSource()));
            };
            Enumerable.prototype.Select = function (select) {
                var _this = this;
                return ToEnumerable(function () { return AsIterator.Select(_this.ToIterable(), select); });
            };
            Enumerable.prototype.SelectMany = function (selector) {
                var _this = this;
                return ToEnumerable(function () { return AsIterator.SelectMany(_this.ToIterable(), selector); });
            };
            Enumerable.prototype.Where = function (predicate) {
                var _this = this;
                return ToEnumerable(function () { return AsIterator.Where(_this.ToIterable(), predicate); });
            };
            Enumerable.prototype.Skip = function (count) {
                var _this = this;
                return ToEnumerable(function () { return AsIterator.Skip(_this.ToIterable(), count); });
            };
            Enumerable.prototype.Take = function (count) {
                var _this = this;
                return ToEnumerable(function () { return AsIterator.Take(_this.ToIterable(), count); });
            };
            Enumerable.prototype.GroupBy = function (selectKey, areEqual) {
                return ToEnumerable(GroupBy(this.ToIterable(), selectKey, areEqual));
            };
            Enumerable.prototype.Distinct = function (distinctTracker) {
                var _this = this;
                return ToEnumerable(function () { return AsIterator.Distinct(_this.ToIterable(), distinctTracker); });
            };
            Enumerable.prototype.Concat = function () {
                var _this = this;
                var items = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    items[_i] = arguments[_i];
                }
                return ToEnumerable(function () { return AsIterator.Concat(_this.ToIterable(), items); });
            };
            Enumerable.prototype.ConcatMany = function () {
                var _this = this;
                var items = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    items[_i] = arguments[_i];
                }
                return ToEnumerable(function () { return AsIterator.Concat.apply(AsIterator, __spread([_this.ToIterable()], items)); });
            };
            Enumerable.prototype.Any = function (predicate) {
                return Collection.Any(this.ToIterable(), predicate);
            };
            Enumerable.prototype.All = function (predicate) {
                return Collection.All(this.ToIterable(), predicate);
            };
            Enumerable.prototype.Reverse = function () {
                return ToEnumerable(Collection.Reverse(this.GetEnumerableSource() || Enumerable.Empty));
            };
            Enumerable.prototype.FirstOrDefault = function (predicate, defaultValue) {
                return FirstOrDefault(this.ToIterable(), predicate, defaultValue);
            };
            Enumerable.prototype.First = function (predicate) {
                return First(this.ToIterable(), predicate);
            };
            Enumerable.prototype.MaxOrDefault = function (defaultValue) {
                return Collection.Max(this.GetEnumerableSource(), undefined, defaultValue);
            };
            Enumerable.prototype.MaxOnOrDefault = function (selectOperand, defaultValue) {
                return Collection.Max(this.GetEnumerableSource(), selectOperand, defaultValue);
            };
            Enumerable.prototype.MinOrDefault = function (defaultValue) {
                return Collection.Min(this.GetEnumerableSource(), undefined, defaultValue);
            };
            Enumerable.prototype.MinOnOrDefault = function (selectOperand, defaultValue) {
                return Collection.Min(this.GetEnumerableSource(), selectOperand, defaultValue);
            };
            return Enumerable;
        }());
        Collection.Enumerable = Enumerable;
        var ValueBackedEnumerable = (function (_super) {
            __extends(ValueBackedEnumerable, _super);
            function ValueBackedEnumerable(source) {
                var _this = _super.call(this) || this;
                _this.source = source;
                return _this;
            }
            ValueBackedEnumerable.prototype.GetEnumerableSource = function () {
                return this.source;
            };
            return ValueBackedEnumerable;
        }(Enumerable));
        (function (Enumerable) {
            Enumerable.Empty = new ValueBackedEnumerable(null);
        })(Enumerable = Collection.Enumerable || (Collection.Enumerable = {}));
        var IEnumerator;
        (function (IEnumerator) {
            var IteratorEnumerator = (function () {
                function IteratorEnumerator(underlyingIterator) {
                    this.underlyingIterator = underlyingIterator;
                }
                Object.defineProperty(IteratorEnumerator.prototype, "Current", {
                    get: function () {
                        if (!this.Result)
                            return void undefined;
                        return this.Result.value;
                    },
                    enumerable: true,
                    configurable: true
                });
                IteratorEnumerator.prototype.MoveNext = function () {
                    this.Result = this.underlyingIterator.next();
                    return !this.Result.done;
                };
                return IteratorEnumerator;
            }());
            function Get(source) {
                return new IteratorEnumerator(IsIterable(source) ? source[Symbol.iterator]() : source);
            }
            IEnumerator.Get = Get;
        })(IEnumerator = Collection.IEnumerator || (Collection.IEnumerator = {}));
    })(Collection = exports.Collection || (exports.Collection = {}));
    function CollectionEquals(x, y) {
        if (!x || !IsObject(x))
            x = {};
        if (!y || !IsObject(y))
            y = {};
        try {
            for (var _a = __values(Collection.Union(Object.keys(x), Object.keys(y))), _b = _a.next(); !_b.done; _b = _a.next()) {
                var prop = _b.value;
                if (HasProp(x, prop) !== HasProp(y, prop))
                    return false;
                if (x[prop] !== y[prop])
                    return false;
            }
        }
        catch (e_22_1) { e_22 = { error: e_22_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_22) throw e_22.error; }
        }
        return true;
        var e_22, _c;
    }
    exports.CollectionEquals = CollectionEquals;
    function DerivedFactory(sourceFactory, resultFactory, areEqual) {
        if (areEqual === void 0) { areEqual = CollectionEquals; }
        var first = true;
        var lastSource;
        var lastResult;
        return Factory;
        function Factory() {
            var newSource = sourceFactory();
            try {
                var makeNew = void 0;
                if (first)
                    makeNew = true;
                else
                    makeNew = !areEqual(lastSource, newSource);
                if (makeNew)
                    lastResult = resultFactory(newSource);
                return lastResult;
            }
            finally {
                lastSource = ShallowCopy(newSource);
            }
        }
    }
    exports.DerivedFactory = DerivedFactory;
    var Stopwatch = (function () {
        function Stopwatch() {
            this.frames = [];
            this.curr = null;
        }
        Object.defineProperty(Stopwatch, "CurrentMilliseconds", {
            get: function () {
                return performance.now();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Stopwatch.prototype, "IsRunning", {
            get: function () {
                return IsSpecified(this.curr);
            },
            enumerable: true,
            configurable: true
        });
        Stopwatch.prototype.Start = function () {
            if (this.IsRunning)
                return;
            this.curr = Stopwatch.CurrentMilliseconds;
        };
        Stopwatch.prototype.Stop = function () {
            var end = Stopwatch.CurrentMilliseconds;
            if (!IsSpecified(this.curr))
                return;
            this.frames.push({ start: this.curr, end: end });
            this.curr = null;
        };
        Stopwatch.prototype.Reset = function () {
            this.Stop();
            this.frames.length = 0;
        };
        Stopwatch.prototype.Restart = function () {
            this.Reset();
            this.Start();
        };
        Object.defineProperty(Stopwatch.prototype, "ElapsedMilliseconds", {
            get: function () {
                var now = Stopwatch.CurrentMilliseconds;
                var elapsedMilliseconds = 0;
                try {
                    for (var _a = __values(this.frames), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var frame = _b.value;
                        elapsedMilliseconds += (frame.end - frame.start);
                    }
                }
                catch (e_23_1) { e_23 = { error: e_23_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_23) throw e_23.error; }
                }
                if (IsSpecified(this.curr))
                    elapsedMilliseconds += (now - this.curr);
                return elapsedMilliseconds;
                var e_23, _c;
            },
            enumerable: true,
            configurable: true
        });
        Stopwatch.StartNew = function () {
            var newSw = new Stopwatch();
            newSw.Start();
            return newSw;
        };
        return Stopwatch;
    }());
    exports.Stopwatch = Stopwatch;
    function FixExtendBuiltIn(source) {
        var stringValue = source.toString();
        var length = source.length;
        var name = source.name;
        var clone = callUnderylingAndFixPrototype;
        TryDefineProperty(clone, "toString", {
            writable: true,
            configurable: true,
            value: function () { return stringValue; },
        });
        TryDefineProperty(clone, "name", {
            writable: false,
            configurable: true,
            value: name,
        });
        TryDefineProperty(clone, "length", {
            writable: false,
            configurable: true,
            value: length,
        });
        clone.prototype = source.prototype;
        return FullAssign(clone, source);
        function callUnderylingAndFixPrototype() {
            var retValue = source.apply(this, arguments);
            if (retValue instanceof Object.getPrototypeOf(source) && !(retValue instanceof clone))
                Object.setPrototypeOf(retValue, clone.prototype);
            return retValue;
        }
    }
    exports.FixExtendBuiltIn = FixExtendBuiltIn;
    var AlreadyDoingActionError = (function (_super) {
        __extends(AlreadyDoingActionError, _super);
        function AlreadyDoingActionError(ActionName) {
            var _this = _super.call(this, "Already " + ActionName + ".") || this;
            _this.ActionName = ActionName;
            return _this;
        }
        AlreadyDoingActionError = __decorate([
            FixExtendBuiltIn
        ], AlreadyDoingActionError);
        return AlreadyDoingActionError;
    }(Error));
    exports.AlreadyDoingActionError = AlreadyDoingActionError;
    var FormInvalidError = (function (_super) {
        __extends(FormInvalidError, _super);
        function FormInvalidError(TargetForm) {
            var _this = _super.call(this, "Form is invalid") || this;
            _this.TargetForm = TargetForm;
            SetEnumerability(_this, "TargetForm", false);
            return _this;
        }
        FormInvalidError = __decorate([
            FixExtendBuiltIn
        ], FormInvalidError);
        return FormInvalidError;
    }(Error));
    exports.FormInvalidError = FormInvalidError;
    function SetEnumerability(target, propertyKey, enumerability) {
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || { writable: true, configurable: true, enumerable: true, value: void undefined };
        if (descriptor.enumerable === enumerability)
            return;
        descriptor.enumerable = enumerability;
        Object.defineProperty(target, propertyKey, descriptor);
    }
    exports.SetEnumerability = SetEnumerability;
    function GenerateHash(source) {
        var hash = 0;
        var text = IsString(source) ? "string:" + source : "json:" + ToJson(source);
        if (text.length == 0)
            return hash;
        var len = text.length;
        for (var i = 0; i < len; i++) {
            var chr = text.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0;
        }
        return hash;
    }
    exports.GenerateHash = GenerateHash;
    function GetRandomFor(source, seed) {
        if (IsVoid(source))
            throw new Error("source cannot be void");
        if (source.length <= 0)
            throw new Error("source cannot be empty");
        var num = Math.abs(GenerateHash(seed));
        return source[num % source.length];
    }
    exports.GetRandomFor = GetRandomFor;
    function ToJson(source) {
        return JSON.stringify(source);
    }
    exports.ToJson = ToJson;
    function FromJson(json) {
        return JSON.parse(json);
    }
    exports.FromJson = FromJson;
    function ReverseArray(array) {
        if (IsVoid(array))
            return array;
        return Collection.Reverse(array);
    }
    exports.ReverseArray = ReverseArray;
    var Element;
    (function (Element) {
        function SetAttribute(element, attributeName, value) {
            if (IsVoid(value) || IsString(value) || IsNumber(value))
                element.attr(attributeName, value);
            else
                element.attr(attributeName, value.toString());
        }
        Element.SetAttribute = SetAttribute;
        function ApplyAttributes(element, attributeDefinitons) {
            try {
                for (var attributeDefinitons_1 = __values(attributeDefinitons), attributeDefinitons_1_1 = attributeDefinitons_1.next(); !attributeDefinitons_1_1.done; attributeDefinitons_1_1 = attributeDefinitons_1.next()) {
                    var attrDefinition = attributeDefinitons_1_1.value;
                    if (!attrDefinition)
                        continue;
                    SetAttribute(element, attrDefinition.Name, attrDefinition.Value);
                }
            }
            catch (e_24_1) { e_24 = { error: e_24_1 }; }
            finally {
                try {
                    if (attributeDefinitons_1_1 && !attributeDefinitons_1_1.done && (_a = attributeDefinitons_1.return)) _a.call(attributeDefinitons_1);
                }
                finally { if (e_24) throw e_24.error; }
            }
            var e_24, _a;
        }
        Element.ApplyAttributes = ApplyAttributes;
        function ApplyAttributeMap(element, attributesDefinition) {
            for (var attrName in attributesDefinition) {
                if (!HasProp(attributesDefinition, attrName))
                    continue;
                var attrValue = attributesDefinition[attrName];
                SetAttribute(element, attrName, attrValue);
            }
        }
        Element.ApplyAttributeMap = ApplyAttributeMap;
        function AddBlockElements(nodes, text) {
            for (var i = nodes.length++; i > 0; i--) {
                nodes[i] = nodes[i - 1];
            }
            nodes[0] = document.createComment("BlockStart: " + text);
            nodes[nodes.length++] = document.createComment("BlockEnd: " + text);
        }
        Element.AddBlockElements = AddBlockElements;
        function AsBlock(nodes, text) {
            var clone = $(nodes);
            AddBlockElements(clone, text);
            return clone;
        }
        Element.AsBlock = AsBlock;
        function GetBlockNodes(nodes) {
            var node = nodes[0];
            var endNode = nodes[nodes.length - 1];
            var blockNodes = [node];
            do {
                node = node.nextSibling;
                if (!node)
                    break;
                blockNodes.push(node);
            } while (node !== endNode);
            return $(blockNodes);
        }
        Element.GetBlockNodes = GetBlockNodes;
    })(Element = exports.Element || (exports.Element = {}));
    var MathUtils;
    (function (MathUtils) {
        function Clamp(value, min, max) {
            return Math.min(max, Math.min(value, max));
        }
        MathUtils.Clamp = Clamp;
    })(MathUtils || (MathUtils = {}));
    exports.Math = MathUtils;
    (function (Collection) {
        function Any(source, predicate) {
            if (IsVoid(source))
                return false;
            if (IsVoid(predicate) && (IsArray(source) || !Collection.IsIterable(source)))
                return source.length > 0;
            var i = 0;
            if (IsVoid(predicate))
                predicate = function () { return true; };
            try {
                for (var _a = __values(Collection.ToIterable(source)), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var item = _b.value;
                    if (predicate(item, i++))
                        return true;
                }
            }
            catch (e_25_1) { e_25 = { error: e_25_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_25) throw e_25.error; }
            }
            return false;
            var e_25, _c;
        }
        Collection.Any = Any;
        function All(source, predicate) {
            if (IsVoid(source))
                throw new Error("source cannot be void.");
            if (IsArray(source) && source.length == 0)
                return true;
            var i = 0;
            try {
                for (var source_3 = __values(source), source_3_1 = source_3.next(); !source_3_1.done; source_3_1 = source_3.next()) {
                    var item = source_3_1.value;
                    if (!predicate(item, i++))
                        return false;
                }
            }
            catch (e_26_1) { e_26 = { error: e_26_1 }; }
            finally {
                try {
                    if (source_3_1 && !source_3_1.done && (_a = source_3.return)) _a.call(source_3);
                }
                finally { if (e_26) throw e_26.error; }
            }
            return true;
            var e_26, _a;
        }
        Collection.All = All;
        function Reverse(source) {
            if (IsArray(source))
                return source.slice().reverse();
            else if (Collection.IsIterable(source))
                return __spread(source).reverse();
            else
                return Reverse(Collection.ToIterable(source));
        }
        Collection.Reverse = Reverse;
        function FromArrayOrObject(source) {
            return IsArray(source) ? source : Object.values(source);
        }
        Collection.FromArrayOrObject = FromArrayOrObject;
        function Max(values, selectOperand, valueIfEmpty) {
            if (IsVoid(values))
                return valueIfEmpty;
            var arr = Collection.GetArray(values);
            if (IsVoid(selectOperand))
                return arr.reduce(function (prev, curr) { return prev >= curr ? prev : curr; }, valueIfEmpty);
            if (IsArray(arr)) {
                switch (arr.length) {
                    case 0:
                        return valueIfEmpty;
                    case 1:
                        return values[0];
                }
            }
            return arr
                .map(function (value, i) { return ({ Value: value, Operand: selectOperand(value, i) }); })
                .reduce(function (prev, curr) { return prev.Operand >= curr.Operand ? prev : curr; }).Value;
        }
        Collection.Max = Max;
        function Min(values, selectOperand, valueIfEmpty) {
            if (IsVoid(values))
                return valueIfEmpty;
            var arr = Collection.GetArray(values);
            if (IsVoid(selectOperand))
                return arr.reduce(function (prev, curr) { return prev >= curr ? prev : curr; }, valueIfEmpty);
            if (IsArray(arr)) {
                switch (arr.length) {
                    case 0:
                        return valueIfEmpty;
                    case 1:
                        return values[0];
                }
            }
            return arr
                .map(function (value, i) { return ({ Value: value, Operand: selectOperand(value, i), }); })
                .reduce(function (prev, curr) { return prev.Operand <= curr.Operand ? prev : curr; }).Value;
        }
        Collection.Min = Min;
        function NonVoid(arr) {
            return arr.filter(function (x) { return !IsVoid(x); });
        }
        Collection.NonVoid = NonVoid;
        function OfType(arr, classCtor) {
            return arr.filter(function (value) { return value instanceof classCtor; });
        }
        Collection.OfType = OfType;
    })(Collection = exports.Collection || (exports.Collection = {}));
    var TranscludeFn;
    (function (TranscludeFn) {
        function InterceptTranscludeFn(transcludeFn, interceptor) {
            if (IsVoid(transcludeFn))
                return transcludeFn;
            var underlying = transcludeFn;
            var interceptedTranscludeFn = InterceptedTranscludeFn;
            interceptedTranscludeFn.isSlotFilled = function (slotName) { return underlying.isSlotFilled(slotName); };
            MirrorProp("$$boundTransclude");
            MirrorProp("$$slots");
            return interceptedTranscludeFn;
            function InterceptedTranscludeFn(scopeOrCloneAttachFn, cloneAttachFnOrFutureParentElement, futureParentElementOrSlotName, slotNameOrVoid) {
                var args = ParseControllerBoundTranscludeArgs(scopeOrCloneAttachFn, cloneAttachFnOrFutureParentElement, futureParentElementOrSlotName, slotNameOrVoid);
                interceptor(CallUnderylingTranscludeFn, args);
            }
            function CallUnderylingTranscludeFn(args) {
                var scope = args.scope, cloneAttachFn = args.cloneAttachFn, futureParentElement = args.futureParentElement, slotName = args.slotName;
                if (IsVoid(scope))
                    return underlying(cloneAttachFn, futureParentElement, slotName);
                else
                    return underlying(scope, cloneAttachFn, futureParentElement, slotName);
            }
            function MirrorProp(propertyKey) {
                Object.defineProperty(interceptedTranscludeFn, propertyKey, {
                    get: function () {
                        return underlying[propertyKey];
                    }
                });
            }
        }
        TranscludeFn.InterceptTranscludeFn = InterceptTranscludeFn;
        function CreateFromSlotTransclude(transcludeFn, slotName) {
            if (!IsVoid(slotName) && !transcludeFn.isSlotFilled(slotName))
                return null;
            var wrappedTransclude = CallUnderylingTranscludeFn;
            wrappedTransclude.isSlotFilled = function () { return false; };
            wrappedTransclude["$$slots"] = {};
            return wrappedTransclude;
            function CallUnderylingTranscludeFn(scopeOrCloneAttachFn, cloneAttachFnOrFutureParentElement, futureParentElementOrSlotName, slotNameOrVoid) {
                var _a = ParseControllerBoundTranscludeArgs(scopeOrCloneAttachFn, cloneAttachFnOrFutureParentElement, futureParentElementOrSlotName, slotNameOrVoid), scope = _a.scope, cloneAttachFn = _a.cloneAttachFn, futureParentElement = _a.futureParentElement, passedSlotName = _a.slotName;
                if (passedSlotName)
                    throw new Error("Slot \"" + passedSlotName + "\" not defined.");
                if (IsVoid(scope))
                    return transcludeFn(cloneAttachFn, futureParentElement, slotName);
                else
                    return transcludeFn(scope, cloneAttachFn, futureParentElement, slotName);
            }
            ;
        }
        TranscludeFn.CreateFromSlotTransclude = CreateFromSlotTransclude;
        function ParseControllerBoundTranscludeArgs(scope, cloneAttachFn, futureParentElement, slotName) {
            if (!IsScope(scope)) {
                return {
                    scope: undefined,
                    cloneAttachFn: scope,
                    futureParentElement: cloneAttachFn,
                    slotName: futureParentElement,
                };
            }
            else {
                return {
                    scope: scope,
                    cloneAttachFn: cloneAttachFn,
                    futureParentElement: futureParentElement,
                    slotName: slotName,
                };
            }
        }
        TranscludeFn.ParseControllerBoundTranscludeArgs = ParseControllerBoundTranscludeArgs;
        function CreateFromTemplateLinkingFn(templateLinkFn, defaultScope, optionDefaults) {
            if (optionDefaults === void 0) { optionDefaults = {}; }
            var transclude = transcludeFn;
            transclude.isSlotFilled = function (slotName) { return !!slotName; };
            transclude["$$slots"] = {};
            return transclude;
            function transcludeFn(scopeOrCloneAttachFn, cloneAttachFnOrFutureParentElement, futureParentElementOrSlotName, slotNameOrVoid) {
                var _a = ParseControllerBoundTranscludeArgs(scopeOrCloneAttachFn, cloneAttachFnOrFutureParentElement, futureParentElementOrSlotName, slotNameOrVoid), scope = _a.scope, cloneAttachFn = _a.cloneAttachFn, futureParentElement = _a.futureParentElement, slotName = _a.slotName;
                if (slotName)
                    throw new Error("Slot \"" + slotName + "\" not defined.");
                var targetScope = scope || defaultScope;
                if (targetScope)
                    targetScope = targetScope.$new();
                return templateLinkFn(targetScope, cloneAttachFn, {
                    futureParentElement: futureParentElement || optionDefaults.futureParentElement,
                    parentBoundTranscludeFn: optionDefaults.parentBoundTranscludeFn,
                    transcludeControllers: optionDefaults.transcludeControllers,
                });
            }
        }
        TranscludeFn.CreateFromTemplateLinkingFn = CreateFromTemplateLinkingFn;
        function CreateBasic(fn) {
            var transcludeFn = basicTranscludeFn;
            transcludeFn.isSlotFilled = function (slotName) { return false; };
            return transcludeFn;
            function basicTranscludeFn(scope, cloneAttachFn, futureParentElement, slotName) {
                var args = ParseControllerBoundTranscludeArgs(scope, cloneAttachFn, futureParentElement, slotName);
                return fn(args);
            }
        }
        TranscludeFn.CreateBasic = CreateBasic;
        function CallWithArgs(transcludeFn, args) {
            if (!IsVoid(args.scope))
                return transcludeFn(args.scope, args.cloneAttachFn, args.futureParentElement, args.slotName);
            else
                return transcludeFn(args.cloneAttachFn, args.futureParentElement, args.slotName);
        }
        TranscludeFn.CallWithArgs = CallWithArgs;
        TranscludeFn.EmptyTransclude = CreateFromTemplateLinkingFn(function () { return $(); }, null);
    })(TranscludeFn = exports.TranscludeFn || (exports.TranscludeFn = {}));
    var ClosableRegistar = (function () {
        function ClosableRegistar() {
            this.explicitlyInUse = false;
            this.items = new Array();
            this.isOpen = true;
        }
        Object.defineProperty(ClosableRegistar.prototype, "IsOpen", {
            get: function () {
                return this.isOpen;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ClosableRegistar.prototype, "InUse", {
            get: function () {
                this.AssertIsClosed();
                return this.items.length > 0 || this.explicitlyInUse;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ClosableRegistar.prototype, "Items", {
            get: function () {
                this.AssertIsClosed();
                return this.items;
            },
            enumerable: true,
            configurable: true
        });
        ClosableRegistar.prototype.Close = function () {
            this.isOpen = false;
        };
        ClosableRegistar.prototype.Add = function (item) {
            this.AssertIsOpen();
            this.items.push(item);
        };
        ClosableRegistar.prototype.MarkAsInUse = function () {
            this.AssertIsOpen();
            this.explicitlyInUse = true;
        };
        ClosableRegistar.prototype.AssertIsOpen = function () {
            if (!this.isOpen)
                throw new Error("Registar already closed");
        };
        ClosableRegistar.prototype.AssertIsClosed = function () {
            if (this.isOpen)
                throw new Error("Registar is still open");
        };
        return ClosableRegistar;
    }());
    exports.ClosableRegistar = ClosableRegistar;
    var ClosableRegistarCollection = (function () {
        function ClosableRegistarCollection(nameNormalizer) {
            if (nameNormalizer === void 0) { nameNormalizer = ClosableRegistarCollection.DefaultNormalizeName; }
            this.nameNormalizer = nameNormalizer;
            this.registars = Object.create(null);
        }
        ClosableRegistarCollection.prototype.IsDefined = function (name) {
            var registarName = this.NormalizeName(name);
            var registar = this.registars[registarName];
            return !IsVoid(registar);
        };
        ClosableRegistarCollection.prototype.GetOpen = function (name) {
            var registar = this.Get(name);
            registar.AssertIsOpen();
            return registar;
        };
        ClosableRegistarCollection.prototype.Get = function (name) {
            var registarName = this.NormalizeName(name);
            var registar = this.registars[registarName];
            if (IsVoid(registar))
                registar = this.registars[registarName] = new ClosableRegistarCollection.Item(registarName);
            return registar;
        };
        Object.defineProperty(ClosableRegistarCollection.prototype, "Names", {
            get: function () {
                return Object.keys(this.registars);
            },
            enumerable: true,
            configurable: true
        });
        ClosableRegistarCollection.DefaultNormalizeName = function (name) {
            return name;
        };
        ClosableRegistarCollection.prototype.NormalizeName = function (name) {
            return this.nameNormalizer(name);
        };
        return ClosableRegistarCollection;
    }());
    exports.ClosableRegistarCollection = ClosableRegistarCollection;
    (function (ClosableRegistarCollection) {
        var Item = (function (_super) {
            __extends(Item, _super);
            function Item(Name) {
                var _this = _super.call(this) || this;
                _this.Name = Name;
                return _this;
            }
            return Item;
        }(ClosableRegistar));
        ClosableRegistarCollection.Item = Item;
    })(ClosableRegistarCollection = exports.ClosableRegistarCollection || (exports.ClosableRegistarCollection = {}));
    exports.ClosableRegistarCollection = ClosableRegistarCollection;
    function TryDefineProperty(target, key, descriptor) {
        if (IsVoid(descriptor))
            return false;
        if (IsVoid(target))
            return false;
        var originalDescriptor = Object.getOwnPropertyDescriptor(target, key);
        if (originalDescriptor && !originalDescriptor.configurable)
            return false;
        Object.defineProperty(target, key, descriptor);
        return true;
    }
    function TryGetOwnPropertySymbols(target) {
        return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target) : [];
    }
    function MakeNotEnumerable(target, propertyKey) {
        return SetEnumerability(target, propertyKey, false);
    }
    exports.MakeNotEnumerable = MakeNotEnumerable;
    function AreEqualHelper(x, y, equalityChecker, options) {
        if (options === void 0) { options = {}; }
        var voidIsVoid = IsVoid(options.VoidIsVoid) ? true : false;
        if (IsVoid(x) && IsVoid(y))
            return voidIsVoid ? true : (x === y);
        else if (IsVoid(x) || IsVoid(y))
            return false;
        else
            return equalityChecker(x, y);
    }
    exports.AreEqualHelper = AreEqualHelper;
    var Text;
    (function (Text) {
        var RegExpFlags;
        (function (RegExpFlags) {
            RegExpFlags[RegExpFlags["None"] = 0] = "None";
            RegExpFlags[RegExpFlags["Global"] = 1] = "Global";
            RegExpFlags[RegExpFlags["IgnoreCase"] = 2] = "IgnoreCase";
            RegExpFlags[RegExpFlags["Multiline"] = 4] = "Multiline";
            RegExpFlags[RegExpFlags["Unicode"] = 8] = "Unicode";
            RegExpFlags[RegExpFlags["Sticky"] = 16] = "Sticky";
            RegExpFlags[RegExpFlags["All"] = 31] = "All";
        })(RegExpFlags = Text.RegExpFlags || (Text.RegExpFlags = {}));
        (function (RegExpFlags) {
            function ToString(enumFlags) {
                if (!IsNumber(enumFlags))
                    return enumFlags;
                var stringFlags = "";
                if (HasFlag(enumFlags, RegExpFlags.Global))
                    stringFlags += "g";
                if (HasFlag(enumFlags, RegExpFlags.IgnoreCase))
                    stringFlags += "i";
                if (HasFlag(enumFlags, RegExpFlags.Multiline))
                    stringFlags += "m";
                if (HasFlag(enumFlags, RegExpFlags.Unicode))
                    stringFlags += "u";
                if (HasFlag(enumFlags, RegExpFlags.Sticky))
                    stringFlags += "y";
                return stringFlags;
            }
            RegExpFlags.ToString = ToString;
            function FromString(stringFlags) {
                if (!IsString(stringFlags))
                    return stringFlags;
                var enumFlags = RegExpFlags.None;
                if (/g/.test(stringFlags))
                    enumFlags |= RegExpFlags.Global;
                if (/i/.test(stringFlags))
                    enumFlags |= RegExpFlags.IgnoreCase;
                if (/m/.test(stringFlags))
                    enumFlags |= RegExpFlags.Multiline;
                if (/u/.test(stringFlags))
                    enumFlags |= RegExpFlags.Unicode;
                if (/y/.test(stringFlags))
                    enumFlags |= RegExpFlags.Sticky;
                return enumFlags;
            }
            RegExpFlags.FromString = FromString;
        })(RegExpFlags = Text.RegExpFlags || (Text.RegExpFlags = {}));
        function EnsureFlags(source, newFlags) {
            for (var i = 0; i < newFlags.length; i++) {
                if (source.indexOf(newFlags[i]) >= 0)
                    continue;
                source += newFlags[i];
            }
            return source;
        }
        Text.EnsureFlags = EnsureFlags;
        function CloneRegExp(source, getFlags) {
            if (!IsRegExp(source))
                return source;
            var pattern = source.source;
            var flags = getFlags(RegExpFlags.FromString(source.flags));
            return new RegExp(pattern, RegExpFlags.ToString(flags));
        }
        Text.CloneRegExp = CloneRegExp;
        function AllMatches(regex, text) {
            var flags = RegExpFlags.FromString(regex.flags);
            if (!HasFlag(flags, RegExpFlags.Global))
                throw new Error("Must use a global regex");
            var allMatches = new Array();
            var matches = regex.exec(text);
            while (!IsVoid(matches)) {
                allMatches.push(matches);
                matches = regex.exec(text);
            }
            return allMatches;
        }
        Text.AllMatches = AllMatches;
    })(Text = exports.Text || (exports.Text = {}));
    function Execute(func) {
        return func();
    }
    exports.Execute = Execute;
    var LegacySupport;
    (function (LegacySupport) {
        function LegacyName(legacyName, mode, warnOn) {
            if (mode === void 0) { mode = LegacyName.Mode.ReadWrite; }
            if (warnOn === void 0) { warnOn = LegacyName.Action.Write; }
            return function (target, currentName) {
                var legacyPropertyDefinition = {
                    configurable: !HasFlag(mode, LegacyName.Mode.NotConfigurable),
                    enumerable: !HasFlag(mode, LegacyName.Mode.NotEnumerable),
                };
                if (HasFlag(mode, LegacyName.Mode.Read)) {
                    var warnOnRead_1 = HasFlag(warnOn, LegacyName.Action.Read);
                    legacyPropertyDefinition.get = function legacyGetter() {
                        if (warnOnRead_1 && console && IsFunction(console.warn))
                            console.warn(FormatJson(templateObject_2 || (templateObject_2 = __makeTemplateObject(["The property ", " is deprecated, use ", " instead."], ["The property ", " is deprecated, use ", " instead."])), legacyName, currentName), { legacyName: legacyName, currentName: currentName });
                        return this[currentName];
                    };
                }
                if (HasFlag(mode, LegacyName.Mode.Write)) {
                    var warnOnWrite_1 = HasFlag(warnOn, LegacyName.Action.Read);
                    legacyPropertyDefinition.set = function legacySetter(value) {
                        if (warnOnWrite_1 && console && IsFunction(console.warn))
                            console.warn(FormatJson(templateObject_3 || (templateObject_3 = __makeTemplateObject(["The property ", " is deprecated, use ", " instead."], ["The property ", " is deprecated, use ", " instead."])), legacyName, currentName), { legacyName: legacyName, currentName: currentName });
                        this[currentName] = value;
                    };
                }
                Object.defineProperty(target, legacyName, legacyPropertyDefinition);
            };
        }
        LegacySupport.LegacyName = LegacyName;
        (function (LegacyName) {
            var Mode;
            (function (Mode) {
                Mode[Mode["Read"] = 1] = "Read";
                Mode[Mode["Write"] = 2] = "Write";
                Mode[Mode["ReadWrite"] = 3] = "ReadWrite";
                Mode[Mode["NotEnumerable"] = 4] = "NotEnumerable";
                Mode[Mode["NotConfigurable"] = 8] = "NotConfigurable";
            })(Mode = LegacyName.Mode || (LegacyName.Mode = {}));
            var Action;
            (function (Action) {
                Action[Action["None"] = 0] = "None";
                Action[Action["Read"] = 1] = "Read";
                Action[Action["Write"] = 2] = "Write";
            })(Action = LegacyName.Action || (LegacyName.Action = {}));
        })(LegacyName = LegacySupport.LegacyName || (LegacySupport.LegacyName = {}));
    })(LegacySupport = exports.LegacySupport || (exports.LegacySupport = {}));
    function Enumerable(enumerable) {
        if (enumerable === void 0) { enumerable = true; }
        return function (prototype, propertyKey) {
            var backingField = Symbol("" + propertyKey);
            var protoDescriptor = Object.getOwnPropertyDescriptor(prototype, propertyKey);
            var configurable = Boolean(!protoDescriptor || protoDescriptor.configurable);
            var readable = Boolean(!protoDescriptor || protoDescriptor.get || !protoDescriptor.set);
            var writable = Boolean(!protoDescriptor || protoDescriptor.set || protoDescriptor.writable);
            if (!IsVoid(protoDescriptor)) {
                if (!protoDescriptor.configurable)
                    throw new Error(FormatJson(templateObject_4 || (templateObject_4 = __makeTemplateObject(["The property ", " was not configurable."], ["The property ", " was not configurable."])), propertyKey));
                throw new Error("Cannot define properties with enumerability at this stage");
            }
            var newProtoDescriptor = __assign({ configurable: configurable,
                enumerable: enumerable }, (readable && { get: get }), (writable && { set: set }));
            Object.defineProperty(prototype, propertyKey, newProtoDescriptor);
            function get() {
                if (HasProp(this, backingField))
                    return this[backingField];
                var thisProto = Object.getPrototypeOf(this);
                if (!thisProto)
                    return;
                return thisProto[propertyKey];
            }
            function set(value) {
                this[backingField] = value;
            }
        };
    }
    var Deferred = (function () {
        function Deferred() {
            var _this = this;
            this.Promise = new Promise(function (resolve, reject) {
                _this.Resolver = resolve;
                _this.Rejector = reject;
            });
        }
        Deferred.prototype.Resolve = function (value) {
            this.Resolver(value);
        };
        Deferred.prototype.Reject = function (reason) {
            this.Rejector(reason);
        };
        return Deferred;
    }());
    exports.Deferred = Deferred;
    function Delay(duration) {
        return new Promise(function (resolve) {
            var milliseconds = IsNumber(duration) || IsVoid(duration) ? duration : duration.milliseconds();
            setTimeout(resolve, milliseconds);
        });
    }
    exports.Delay = Delay;
    var Timeout = (function () {
        function Timeout(duration) {
            this.duration = duration;
            this.hasExpired = false;
        }
        Object.defineProperty(Timeout.prototype, "HasExpired", {
            get: function () {
                return this.hasExpired;
            },
            enumerable: true,
            configurable: true
        });
        Timeout.prototype.Start = function () {
            var _this = this;
            this.hasExpired = false;
            var milliseconds = IsNumber(this.duration) ? this.duration : this.duration.milliseconds();
            if (milliseconds === Number.POSITIVE_INFINITY) {
                this.promise = null;
                return;
            }
            this.promise = Delay(this.duration).then(function () { return void (_this.hasExpired = true); });
        };
        Timeout.prototype.Race = function (promise) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!IsVoid(this.promise)) return [3, 2];
                            return [4, promise];
                        case 1: return [2, _a.sent()];
                        case 2: return [4, Promise.race([
                                promise,
                                this.promise.then(function () { throw new Timeout.TimeoutExpiredError(_this); }),
                            ])];
                        case 3:
                            result = _a.sent();
                            return [2, result];
                    }
                });
            });
        };
        Timeout.Race = function (timeout, promise) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!IsVoid(timeout)) return [3, 2];
                            return [4, promise];
                        case 1: return [2, _a.sent()];
                        case 2: return [2, timeout.Race(promise)];
                    }
                });
            });
        };
        Timeout.Start = function (duration) {
            var timeout = new Timeout(IsVoid(duration) ? Number.POSITIVE_INFINITY : duration);
            timeout.Start();
            return timeout;
        };
        return Timeout;
    }());
    exports.Timeout = Timeout;
    (function (Timeout_1) {
        var TimeoutExpiredError = (function (_super) {
            __extends(TimeoutExpiredError, _super);
            function TimeoutExpiredError(Timeout) {
                var _this = _super.call(this) || this;
                _this.Timeout = Timeout;
                return _this;
            }
            TimeoutExpiredError = __decorate([
                FixExtendBuiltIn
            ], TimeoutExpiredError);
            return TimeoutExpiredError;
        }(Error));
        Timeout_1.TimeoutExpiredError = TimeoutExpiredError;
    })(Timeout = exports.Timeout || (exports.Timeout = {}));
    exports.Timeout = Timeout;
    var Window;
    (function (Window) {
        var WindowFeaturesBag = (function () {
            function WindowFeaturesBag() {
            }
            WindowFeaturesBag.prototype.Format = function () {
                return Collection.GetArray(this.FormatParts()).join(",");
            };
            WindowFeaturesBag.prototype.toString = function () {
                return this.Format();
            };
            return WindowFeaturesBag;
        }());
        Window.WindowFeaturesBag = WindowFeaturesBag;
        var WindowFeatures = (function (_super) {
            __extends(WindowFeatures, _super);
            function WindowFeatures(source) {
                var _this = _super.call(this) || this;
                _this.Rectangle = (source && source.Rectangle) || new Window.Rectangle();
                _this.Chrome = (source && source.Chrome) || new Window.Chrome();
                _this.WindowFunctionality = (source && source.WindowFunctionality) || new Window.Functionality();
                return _this;
            }
            WindowFeatures.prototype.FormatParts = function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.Rectangle) return [3, 2];
                            return [5, __values(this.Rectangle.FormatParts())];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!this.Chrome) return [3, 4];
                            return [5, __values(this.Chrome.FormatParts())];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (!this.WindowFunctionality) return [3, 6];
                            return [5, __values(this.WindowFunctionality.FormatParts())];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6: return [2];
                    }
                });
            };
            return WindowFeatures;
        }(WindowFeaturesBag));
        Window.WindowFeatures = WindowFeatures;
        var Rectangle = (function (_super) {
            __extends(Rectangle, _super);
            function Rectangle(source) {
                var _this = _super.call(this) || this;
                _this.CenterScreen = false;
                if (IsVoid(source))
                    return _this;
                if ("Position" in source)
                    _this.Position = source.Position;
                if ("Size" in source)
                    _this.Size = source.Size;
                if (!IsVoid(source.CenterScreen))
                    _this.CenterScreen = source.CenterScreen;
                return _this;
            }
            Rectangle.prototype.FormatParts = function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.Position) return [3, 2];
                            return [5, __values(this.Position.FormatParts())];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!this.Size) return [3, 4];
                            return [5, __values(this.Size.FormatParts())];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (!this.CenterScreen) return [3, 6];
                            return [4, "centerscreen=true"];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6: return [2];
                    }
                });
            };
            return Rectangle;
        }(WindowFeaturesBag));
        Window.Rectangle = Rectangle;
        (function (Rectangle) {
            var Position = (function (_super) {
                __extends(Position, _super);
                function Position(Left, Top) {
                    var _this = _super.call(this) || this;
                    _this.Left = Left;
                    _this.Top = Top;
                    return _this;
                }
                Position.prototype.FormatParts = function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!IsNumber(this.Left)) return [3, 2];
                                return [4, "left==" + this.Left];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!IsNumber(this.Top)) return [3, 4];
                                return [4, "top=" + this.Top];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4: return [2];
                        }
                    });
                };
                return Position;
            }(WindowFeaturesBag));
            Rectangle.Position = Position;
            var Size = (function (_super) {
                __extends(Size, _super);
                function Size(Width, Height) {
                    var _this = _super.call(this) || this;
                    _this.Width = Width;
                    _this.Height = Height;
                    return _this;
                }
                return Size;
            }(WindowFeaturesBag));
            Rectangle.Size = Size;
            var OuterSize = (function (_super) {
                __extends(OuterSize, _super);
                function OuterSize(width, height) {
                    return _super.call(this, width, height) || this;
                }
                OuterSize.prototype.FormatParts = function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!IsNumber(this.Width)) return [3, 2];
                                return [4, "outerWidth=" + this.Width];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!IsNumber(this.Height)) return [3, 4];
                                return [4, "outerHeight=" + this.Height];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4: return [2];
                        }
                    });
                };
                return OuterSize;
            }(Size));
            Rectangle.OuterSize = OuterSize;
            var InnerSize = (function (_super) {
                __extends(InnerSize, _super);
                function InnerSize(width, height) {
                    return _super.call(this, width, height) || this;
                }
                InnerSize.prototype.FormatParts = function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!IsNumber(this.Width)) return [3, 2];
                                return [4, "innerWidth=" + this.Width];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!IsNumber(this.Height)) return [3, 4];
                                return [4, "innerHeight=" + this.Height];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4: return [2];
                        }
                    });
                };
                return InnerSize;
            }(Size));
            Rectangle.InnerSize = InnerSize;
        })(Rectangle = Window.Rectangle || (Window.Rectangle = {}));
        var Chrome = (function (_super) {
            __extends(Chrome, _super);
            function Chrome(source) {
                var _this = _super.call(this) || this;
                _this.MenuBar = true;
                _this.Toolbar = true;
                _this.Location = true;
                _this.PersonalBar = true;
                _this.Status = true;
                if (IsVoid(source))
                    return _this;
                if (IsBoolean(source)) {
                    _this.MenuBar = source;
                    _this.Toolbar = source;
                    _this.Location = source;
                    _this.PersonalBar = source;
                    _this.Status = source;
                    return _this;
                }
                if (IsBoolean(source.MenuBar))
                    _this.MenuBar = source.MenuBar;
                if (IsBoolean(source.Toolbar))
                    _this.Toolbar = source.Toolbar;
                if (IsBoolean(source.Location))
                    _this.Location = source.Location;
                if (IsBoolean(source.PersonalBar))
                    _this.PersonalBar = source.PersonalBar;
                if (IsBoolean(source.Status))
                    _this.Status = source.Status;
                return _this;
            }
            Chrome.prototype.FormatParts = function () {
                return [
                    "menubar=" + (this.MenuBar ? "1" : "0"),
                    "toolbar=" + (this.Toolbar ? "1" : "0"),
                    "location=" + (this.Location ? "1" : "0"),
                    "personalbar=" + (this.PersonalBar ? "1" : "0"),
                    "status=" + (this.Status ? "1" : "0"),
                ];
            };
            return Chrome;
        }(WindowFeaturesBag));
        Window.Chrome = Chrome;
        var Functionality = (function (_super) {
            __extends(Functionality, _super);
            function Functionality(source) {
                var _this = _super.call(this) || this;
                _this.Dependant = false;
                _this.NoOpener = true;
                _this.Resizable = true;
                _this.ScrollBars = true;
                if (IsVoid(source))
                    return _this;
                if (IsBoolean(source.Dependant))
                    _this.Dependant = source.Dependant;
                if (IsBoolean(source.NoOpener))
                    _this.NoOpener = source.NoOpener;
                if (IsBoolean(source.Resizable))
                    _this.Resizable = source.Resizable;
                if (IsBoolean(source.ScrollBars))
                    _this.ScrollBars = source.ScrollBars;
                return _this;
            }
            Functionality.prototype.FormatParts = function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.Dependant) return [3, 2];
                            return [4, "dependent=1"];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!this.NoOpener) return [3, 4];
                            return [4, "noopener=1"];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (!this.Resizable) return [3, 6];
                            return [4, "resizable=1"];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6:
                            if (!this.ScrollBars) return [3, 8];
                            return [4, "scrollbars=1"];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8: return [2];
                    }
                });
            };
            return Functionality;
        }(WindowFeaturesBag));
        Window.Functionality = Functionality;
    })(Window = exports.Window || (exports.Window = {}));
    var CancellationToken = (function () {
        function CancellationToken(cancelled, CanBeCancelled) {
            if (cancelled === void 0) { cancelled = false; }
            if (CanBeCancelled === void 0) { CanBeCancelled = false; }
            this.cancelled = cancelled;
            this.CanBeCancelled = CanBeCancelled;
        }
        Object.defineProperty(CancellationToken.prototype, "IsCancellationRequested", {
            get: function () {
                return this.cancelled;
            },
            enumerable: true,
            configurable: true
        });
        CancellationToken.prototype.RequestCancellation = function () {
            this.cancelled = true;
        };
        CancellationToken.prototype.CreateSubToken = function (cancelled, canBeCancelled) {
            return new CancellationToken.SubCancellationToken(this, cancelled, canBeCancelled);
        };
        return CancellationToken;
    }());
    exports.CancellationToken = CancellationToken;
    (function (CancellationToken) {
        var SubCancellationToken = (function (_super) {
            __extends(SubCancellationToken, _super);
            function SubCancellationToken(dependant, cancelled, canBeCancelled) {
                var _this = _super.call(this, cancelled, canBeCancelled) || this;
                _this.dependant = dependant;
                return _this;
            }
            Object.defineProperty(SubCancellationToken.prototype, "IsCancellationRequested", {
                get: function () {
                    return this.dependant.IsCancellationRequested || this.cancelled;
                },
                enumerable: true,
                configurable: true
            });
            return SubCancellationToken;
        }(CancellationToken));
        CancellationToken.SubCancellationToken = SubCancellationToken;
    })(CancellationToken = exports.CancellationToken || (exports.CancellationToken = {}));
    exports.CancellationToken = CancellationToken;
    var StepPath = (function (_super) {
        __extends(StepPath, _super);
        function StepPath(InitialStep) {
            var _this = _super.call(this) || this;
            _this.InitialStep = InitialStep;
            _this.StepsArray = new Array();
            _this.momentum = StepPath.Direction.Forward;
            return _this;
        }
        StepPath.Create = function (initialStep) {
            return new StepPath(initialStep);
        };
        StepPath.prototype.GetEnumerableSource = function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [5, __values(this.StepsArray)];
                    case 1:
                        _a.sent();
                        if (!!IsVoid(this.InitialStep)) return [3, 3];
                        return [4, this.InitialStep];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        };
        StepPath.prototype[Symbol.iterator] = function () {
            return __generator(this, function (_a) {
                return [2, Collection.GetIterator(this)];
            });
        };
        Object.defineProperty(StepPath.prototype, "PreviousStep", {
            get: function () {
                return this
                    .Skip(1)
                    .FirstOrDefault();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(StepPath.prototype, "CurrentStep", {
            get: function () {
                return this
                    .First();
            },
            enumerable: true,
            configurable: true
        });
        StepPath.prototype.NavigateForward = function () {
            var steps = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                steps[_i] = arguments[_i];
            }
            (_a = this.StepsArray).unshift.apply(_a, __spread(Collection.Reverse(steps)));
            this.momentum = StepPath.Direction.Forward;
            var _a;
        };
        StepPath.prototype.GoBack = function () {
            if (this.StepsArray.length <= 0)
                return;
            this.StepsArray.shift();
            this.momentum = StepPath.Direction.Back;
        };
        StepPath.prototype.GoBackWhile = function (predicate) {
            while (this.StepsArray.length > 0 && predicate(this.CurrentStep, this)) {
                this.GoBack();
            }
        };
        Object.defineProperty(StepPath.prototype, "Momentum", {
            get: function () {
                return this.momentum;
            },
            enumerable: true,
            configurable: true
        });
        return StepPath;
    }(Collection.Enumerable));
    exports.StepPath = StepPath;
    (function (StepPath) {
        var Direction;
        (function (Direction) {
            Direction[Direction["Forward"] = 0] = "Forward";
            Direction[Direction["Back"] = 1] = "Back";
        })(Direction = StepPath.Direction || (StepPath.Direction = {}));
    })(StepPath = exports.StepPath || (exports.StepPath = {}));
    exports.StepPath = StepPath;
    (function (Collection) {
        function DeferredArray(sourceCollection, delay, loadingValue) {
            var _this = this;
            var sourceArray = Object.freeze(__spread(Collection.GetArray(sourceCollection)));
            var outArray = Extend([], {
                LoadNow: LoadNow,
                LoadIndexNow: LoadIndexNow,
            });
            outArray.push.apply(outArray, __spread(sourceArray.map(function (value, i) { return i <= 1 ? value : loadingValue(value, i, outArray); })));
            var loadedIndicies = new Set();
            function LoadNow(item) {
                for (var i = 0; i < outArray.length; i++) {
                    if (outArray[i] !== item)
                        continue;
                    LoadIndexNow(i);
                }
            }
            function LoadIndexNow(i) {
                if (loadedIndicies.has(i))
                    return;
                outArray[i] = sourceArray[i];
                loadedIndicies.add(i);
            }
            var finished = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var _loop_2, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _loop_2 = function (i) {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (loadedIndicies.has(i))
                                                return [2, "continue"];
                                            return [4, new Promise(function (resolve, reject) {
                                                    delay()
                                                        .then(function () {
                                                        try {
                                                            while (loadedIndicies.has(i) && i < sourceArray.length) {
                                                                return resolve();
                                                            }
                                                            if (i >= sourceArray.length)
                                                                return resolve();
                                                            outArray[i] = sourceArray[i];
                                                        }
                                                        catch (err) {
                                                            reject(err);
                                                        }
                                                        resolve();
                                                        loadedIndicies.add(i);
                                                    }, function (err) {
                                                        reject(err);
                                                    });
                                                })];
                                        case 1:
                                            _a.sent();
                                            return [2];
                                    }
                                });
                            };
                            i = 1;
                            _a.label = 1;
                        case 1:
                            if (!(i < sourceArray.length)) return [3, 4];
                            return [5, _loop_2(i)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3, 1];
                        case 4: return [2];
                    }
                });
            }); });
            return outArray;
        }
        Collection.DeferredArray = DeferredArray;
    })(Collection = exports.Collection || (exports.Collection = {}));
    var HttpError = (function (_super) {
        __extends(HttpError, _super);
        function HttpError(HttpStatus, Description, message) {
            if (message === void 0) { message = "An HTTP error occurred " + HttpStatus + ": " + Description; }
            var _this = _super.call(this, message) || this;
            _this.HttpStatus = HttpStatus;
            _this.Description = Description;
            return _this;
        }
        HttpError = __decorate([
            FixExtendBuiltIn
        ], HttpError);
        return HttpError;
    }(Error));
    exports.HttpError = HttpError;
    var FormatError = (function (_super) {
        __extends(FormatError, _super);
        function FormatError(MimeType, Content) {
            var _this = _super.call(this, "Content of an invalid type was returned: " + MimeType) || this;
            _this.MimeType = MimeType;
            _this.Content = Content;
            return _this;
        }
        FormatError = __decorate([
            FixExtendBuiltIn
        ], FormatError);
        return FormatError;
    }(Error));
    exports.FormatError = FormatError;
    var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
});
define("scripts/lib/select-development/app-modules", ["require", "exports", "app/basic-utils", "app-modules-loader!"], function (require, exports, utils, appModules) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Names = Object.freeze(appModules.slice());
    exports.NamesByAlias = Object.freeze(Object.assign({}, appModules.$modules));
    exports.Aliases = Object.freeze(Object.keys(appModules.$modules).filter(function (key) { return appModules.indexOf(key) < 0; }));
    function IsValid(name) {
        return exports.Names.indexOf(name) >= 0;
    }
    exports.IsValid = IsValid;
    function GetName(aliasOrName) {
        if (!utils.HasProp(exports.NamesByAlias, aliasOrName))
            return null;
        return exports.NamesByAlias[aliasOrName];
    }
    exports.GetName = GetName;
});
define("scripts/lib/select-development/sss-names-basic", ["require", "exports", "app/basic-utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var SpecialCharacters = Object.freeze([":", "-", "-", "_"]);
    var SpecialCharactersRegex = /[\:\-\_]+/g;
    var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
    var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
    var FlexiblePrefixRegex = /^(?:((?:[xX]|[dD][aA][tT][aA])[\:\-_])|((?:x|data)([A-Z])))/;
    var MOZ_HACK_REGEXP = /^moz([A-Z])/;
    var DIRECTIVE_SPLIT_MATCHER = /(.(?=[A-Z]))/g;
    var CaseBoundary = /([A-Z])/g;
    function CamelCase(name) {
        return (!utils.IsVoid(name) ? String(name) : "")
            .replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
            return offset ? letter.toUpperCase() : letter;
        })
            .replace(MOZ_HACK_REGEXP, 'Moz$1');
    }
    exports.CamelCase = CamelCase;
    function SnakeCase(name, seperator, otherSeperators) {
        if (seperator === void 0) { seperator = "-"; }
        if (otherSeperators === void 0) { otherSeperators = SpecialCharactersRegex; }
        return (!utils.IsVoid(name) ? String(name) : "")
            .replace(CaseBoundary, function (letter) { return seperator + letter.toLowerCase(); })
            .replace(otherSeperators, seperator);
    }
    exports.SnakeCase = SnakeCase;
    function StripHtmlNoConflictPrefixes(source) {
        return source
            .replace(FlexiblePrefixRegex, function (_, snakeCased, camelCased, camelCasedLetter) { return snakeCased ? "" : camelCasedLetter.toLowerCase(); });
    }
    exports.StripHtmlNoConflictPrefixes = StripHtmlNoConflictPrefixes;
    function ComponentNameNormalize(name) {
        return CamelCase(StripHtmlNoConflictPrefixes(name || ""));
    }
    exports.ComponentNameNormalize = ComponentNameNormalize;
    function ComponentNameParts(componentName) {
        if (!componentName) {
            var splitName_1 = [];
            splitName_1.Normalized = "";
            splitName_1["normalized"] = "";
            return splitName_1;
        }
        var normalizedName = ComponentNameNormalize(componentName);
        var splitName = normalizedName.replace(DIRECTIVE_SPLIT_MATCHER, "$& ").split(" ").map(function (part) {
            return part.toLowerCase();
        });
        splitName.Normalized = normalizedName;
        splitName["normalized"] = normalizedName;
        return splitName;
    }
    exports.ComponentNameParts = ComponentNameParts;
    function ComponentNameSnakeCase(name) {
        return StripHtmlNoConflictPrefixes(SnakeCase(name));
    }
    exports.ComponentNameSnakeCase = ComponentNameSnakeCase;
    function CanonicalDefinitionName(componentName, componentType) {
        var baseName = SnakeCase(componentName, "/") + "/" + SnakeCase(componentName, "-");
        if (utils.IsVoid(componentType))
            return baseName;
        switch (componentType) {
            case CanonicalDefinitionName.Type.Directive:
                return baseName;
            case CanonicalDefinitionName.Type.Template:
                return baseName + ".html";
            default:
                return baseName + "-" + componentType;
        }
    }
    exports.CanonicalDefinitionName = CanonicalDefinitionName;
    (function (CanonicalDefinitionName) {
        var Type;
        (function (Type) {
            Type["Directive"] = "directive";
            Type["Template"] = "template";
            Type["Provider"] = "provider";
            Type["Factory"] = "factory";
            Type["Service"] = "service";
            Type["Constant"] = "constant";
            Type["Filter"] = "filter";
            Type["Value"] = "value";
        })(Type = CanonicalDefinitionName.Type || (CanonicalDefinitionName.Type = {}));
    })(CanonicalDefinitionName = exports.CanonicalDefinitionName || (exports.CanonicalDefinitionName = {}));
    function DirectiveDefinitionModuleId(componentName) {
        return CanonicalDefinitionName(componentName);
    }
    exports.DirectiveDefinitionModuleId = DirectiveDefinitionModuleId;
    function TemplateDefinitionModuleId(templateName) {
        return CanonicalDefinitionName(templateName, CanonicalDefinitionName.Type.Template);
    }
    exports.TemplateDefinitionModuleId = TemplateDefinitionModuleId;
    function TemplateModuleId(templateName) {
        return "template!" + SnakeCase(templateName);
    }
    exports.TemplateModuleId = TemplateModuleId;
    function FilterDefinitionModuleId(filterName) {
        return CanonicalDefinitionName(filterName, CanonicalDefinitionName.Type.Filter);
    }
    exports.FilterDefinitionModuleId = FilterDefinitionModuleId;
    function HtmlFor(tagOrDirective, attrs) {
        if (!tagOrDirective)
            return "";
        return ElementFor(tagOrDirective, attrs).prop('outerHTML');
    }
    exports.HtmlFor = HtmlFor;
    function ElementFor(tagOrDirective) {
        var attributeDefinitions = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            attributeDefinitions[_i - 1] = arguments[_i];
        }
        if (!tagOrDirective)
            return null;
        var element = $(document.createElement(Standardify(tagOrDirective)));
        try {
            for (var attributeDefinitions_1 = __values(attributeDefinitions), attributeDefinitions_1_1 = attributeDefinitions_1.next(); !attributeDefinitions_1_1.done; attributeDefinitions_1_1 = attributeDefinitions_1.next()) {
                var attributeDefinition = attributeDefinitions_1_1.value;
                if (!attributeDefinition)
                    continue;
                utils.Element.ApplyAttributeMap(element, attributeDefinition);
            }
        }
        catch (e_27_1) { e_27 = { error: e_27_1 }; }
        finally {
            try {
                if (attributeDefinitions_1_1 && !attributeDefinitions_1_1.done && (_a = attributeDefinitions_1.return)) _a.call(attributeDefinitions_1);
            }
            finally { if (e_27) throw e_27.error; }
        }
        return element;
        var e_27, _a;
    }
    exports.ElementFor = ElementFor;
    function Standardify(name) {
        return SnakeCase(StripHtmlNoConflictPrefixes(name || ""));
    }
    exports.Standardify = Standardify;
    var ValidClassDirectives = Object.freeze(["sdcMdBackground"].map(CamelCase));
    function IsValidClassTarget(className) {
        try {
            for (var ValidClassDirectives_1 = __values(ValidClassDirectives), ValidClassDirectives_1_1 = ValidClassDirectives_1.next(); !ValidClassDirectives_1_1.done; ValidClassDirectives_1_1 = ValidClassDirectives_1.next()) {
                var validator = ValidClassDirectives_1_1.value;
                if (validator instanceof RegExp) {
                    if (validator.test(className))
                        return true;
                }
                else if (validator.toString() === className)
                    return true;
            }
        }
        catch (e_28_1) { e_28 = { error: e_28_1 }; }
        finally {
            try {
                if (ValidClassDirectives_1_1 && !ValidClassDirectives_1_1.done && (_a = ValidClassDirectives_1.return)) _a.call(ValidClassDirectives_1);
            }
            finally { if (e_28) throw e_28.error; }
        }
        return false;
        var e_28, _a;
    }
    exports.IsValidClassTarget = IsValidClassTarget;
    function ControllerRequireParts(requireString) {
        var _a = __read(exports.RequireRegex.exec(requireString), 3), prefix = _a[1], controller = _a[2];
        return {
            prefix: prefix,
            controller: controller,
        };
    }
    exports.ControllerRequireParts = ControllerRequireParts;
    function NormalizeControllerRequire(requireString) {
        var _a = ControllerRequireParts(requireString), prefix = _a.prefix, controller = _a.controller;
        return prefix + (controller && CamelCase(controller));
    }
    exports.NormalizeControllerRequire = NormalizeControllerRequire;
    function GetComponentNameFromModuleId(moduleId) {
        if (!utils.IsString(moduleId))
            return moduleId;
        var _a = __read(/^((?:[^/]*[/]+)*)([^/]*)$/.exec(moduleId), 3), directoryName = _a[1], componentName = _a[2];
        if (directoryName !== "app/" + componentName.replace(/-/g, "/") + "/")
            throw new Error(utils.FormatJson(templateObject_5 || (templateObject_5 = __makeTemplateObject(["The string was not in a valid format ", ""], ["The string was not in a valid format ", ""])), moduleId));
        return componentName;
    }
    exports.GetComponentNameFromModuleId = GetComponentNameFromModuleId;
    exports.RequireRegex = new RegExp([
        "^(",
        ["^^?", "^^", "^?", "^", "?", ""].map(function (s) { return s.replace(/(.)/g, "\\$1"); }).join("|"),
        ")(.*)$"
    ].join(""));
    var templateObject_5;
});
define("scripts/lib/select-development/sss-names", ["require", "exports", "scripts/lib/select-development/app-modules", "scripts/lib/select-development/sss-names-basic", "scripts/lib/select-development/sss-names-basic"], function (require, exports, appModules, sss_names_basic_1, sss_names_basic_2) {
    "use strict";
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    Object.defineProperty(exports, "__esModule", { value: true });
    __export(sss_names_basic_2);
    var separators = "[\\:\\-_]";
    var SelectComponentRegex = new RegExp("^((x|data)" + separators + ")?(" + appModules.Names.join("|") + ")(" + separators + "|[A-Z]|$)");
    function IsSelectComponent(tagOrDirective) {
        return SelectComponentRegex.test(tagOrDirective);
    }
    exports.IsSelectComponent = IsSelectComponent;
    function DependenciesFor(target, currentName) {
        var t$ = (jQuery || $);
        return DependenciesFor.getDependencies(t$, t$(target), currentName);
    }
    exports.DependenciesFor = DependenciesFor;
    (function (DependenciesFor) {
        function getDependencies($, target, currentName) {
            var requires = [];
            var allChildren = target.find("*");
            var allElements = allChildren.addBack();
            var allComments = allElements.contents().toArray().filter(function (e) { return e.nodeType === 8; });
            try {
                for (var _a = __values(allElements.toArray()), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var element = _b.value;
                    if (!element)
                        continue;
                    var normalizedTagName = TryAddName(element.tagName && element.tagName.toLowerCase());
                    TryAddAttributes(element, normalizedTagName);
                    TryAddClasses(element);
                }
            }
            catch (e_29_1) { e_29 = { error: e_29_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_29) throw e_29.error; }
            }
            try {
                for (var allComments_1 = __values(allComments), allComments_1_1 = allComments_1.next(); !allComments_1_1.done; allComments_1_1 = allComments_1.next()) {
                    var comment = allComments_1_1.value;
                    var match = /^\s*directive:\s*([\w-]+)\s+(.*)$/.exec(comment.nodeValue);
                    if (!match)
                        continue;
                    var _d = __read(match, 2), _ = _d[0], directiveName = _d[1];
                    TryAddName(directiveName);
                }
            }
            catch (e_30_1) { e_30 = { error: e_30_1 }; }
            finally {
                try {
                    if (allComments_1_1 && !allComments_1_1.done && (_e = allComments_1.return)) _e.call(allComments_1);
                }
                finally { if (e_30) throw e_30.error; }
            }
            return requires;
            function TryAddName(name, isClass) {
                if (isClass === void 0) { isClass = false; }
                if (!name)
                    return null;
                if (!IsSelectComponent(name))
                    return null;
                var parts = sss_names_basic_1.ComponentNameParts(name.toLowerCase());
                if (!parts.length)
                    return null;
                switch (parts[parts.length - 1]) {
                    case "start":
                    case "end":
                        return null;
                }
                var normalizedName = parts.Normalized;
                if (currentName === normalizedName)
                    return null;
                var moduleId = "directive!" + normalizedName;
                if (isClass && !sss_names_basic_1.IsValidClassTarget(normalizedName))
                    return null;
                if (requires.indexOf(moduleId) >= 0)
                    return null;
                requires.push(moduleId);
                return normalizedName;
            }
            function TryAddAttributes(element, normalizedTagName) {
                if (!element.attributes)
                    return;
                for (var i = 0; i < element.attributes.length; i++) {
                    var attribute = element.attributes[i];
                    var normalizedName = TryAddName(attribute.name);
                    if (normalizedName === "sdcRequire" || normalizedTagName === "sdcRequire" && normalizedName === "module") {
                        var matches = /^'([^']*)'|"([^"]*)"$/.exec($(element).attr(attribute.name));
                        if (matches && matches[1]) {
                            TryAddName(matches[1]);
                        }
                    }
                }
            }
            function TryAddClasses(element) {
                if (typeof (element.className) !== "string")
                    return;
                try {
                    for (var _a = __values(element.className.split(/\s+/)), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var className = _b.value;
                        TryAddName(className, true);
                    }
                }
                catch (e_31_1) { e_31 = { error: e_31_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_31) throw e_31.error; }
                }
                var e_31, _c;
            }
            var e_29, _c, e_30, _e;
        }
        DependenciesFor.getDependencies = getDependencies;
    })(DependenciesFor = exports.DependenciesFor || (exports.DependenciesFor = {}));
});
define("app/amd-directive-registar", ["require", "exports", "scripts/lib/select-development/sss-names", "app/basic-utils", "ngAmd"], function (require, exports, names, utils, ngAmd) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var directives = new utils.ClosableRegistarCollection(names.ComponentNameSnakeCase);
    function GetRegistarPromise(registarName) {
        var registar = directives.Get(registarName);
        registar.Close();
        return Promise.all(registar.Items).then(function (x) { });
    }
    exports.GetRegistarPromise = GetRegistarPromise;
    function RegisterInUse(name) {
        var registar = directives.Get(name);
        registar.Close();
        return registar.InUse;
    }
    exports.RegisterInUse = RegisterInUse;
    function MarkAsInUse(name) {
        var registar = directives.Get(name);
        registar.MarkAsInUse();
    }
    exports.MarkAsInUse = MarkAsInUse;
    function DefineFor(registarName, directiveName, definition) {
        var registar = directives.GetOpen(registarName);
        registar.Add(Promise.resolve(definition).then(function (definition) {
            if (!utils.IsSpecified(definition))
                return;
            if (utils.IsFunction(definition))
                ngAmd.directive(names.CamelCase(directiveName), definition);
            else
                ngAmd.directive(names.CamelCase(directiveName), [function () { return definition; }]);
        }));
    }
    exports.DefineFor = DefineFor;
    function Define(name, definition) {
        return DefineFor(name, name, definition);
    }
    exports.Define = Define;
    function OpenRegistar(name) {
        return directives.GetOpen(name);
    }
    exports.OpenRegistar = OpenRegistar;
    function PendingRegistars() {
        return directives.Names
            .filter(function (n) { return directives.Get(n).IsOpen; });
    }
    exports.PendingRegistars = PendingRegistars;
});
define("app/amd-name-utils", ["require", "exports", "scripts/lib/select-development/sss-names", "app/basic-utils"], function (require, exports, names, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = Symbol("ComponentName");
    function AssignName(target, name) {
        var _a = TryGetComponentName(target), ExistingName = _a.Name, HasName = _a.HasName;
        if (HasName && ExistingName === name)
            throw new Error(utils.FormatJson(templateObject_6 || (templateObject_6 = __makeTemplateObject(["The Controller ", " does not represent a different component \"", "\" to the one requested ", "."], ["The Controller ", " does not represent a different component \"", "\" to the one requested ", "."])), target.name, ExistingName, name));
        target[Name] = names.CamelCase(name);
    }
    exports.AssignName = AssignName;
    function GetComponentName(target) {
        var _a = TryGetComponentName(target), Name = _a.Name, HasName = _a.HasName;
        if (!HasName)
            throw new Error("The Controller " + target.name + " does not represent a component.");
        return Name;
    }
    exports.GetComponentName = GetComponentName;
    function TryGetComponentName(target) {
        var HasName = utils.HasProp(target, Name);
        var name = HasName ? target[Name] : undefined;
        return {
            HasName: HasName,
            Name: name
        };
    }
    exports.TryGetComponentName = TryGetComponentName;
    var templateObject_6;
});
define("scripts/lib/select-development/sss-binds", ["require", "exports", "app/basic-utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Attribute;
    (function (Attribute) {
        var Controller;
        (function (Controller) {
            function ApplyTo(options) {
                var attrs = options.attrs, definitions = options.definitions, destination = options.destination, interpolateService = options.interpolateService, name = options.name, newScope = options.newScope, parseService = options.parseService, useParentScope = options.useParentScope;
                var scope = useParentScope ? newScope.$parent : newScope;
                var onNewScopeDestroyed = [];
                try {
                    for (var _a = __values(utils.Collection.ToIterable(definitions)), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var binding = _b.value;
                        var destroy = binding.ApplyAsScopelessTo({
                            destination: destination,
                            attrs: attrs,
                            scope: scope,
                            interpolateService: interpolateService,
                            parseService: parseService,
                        });
                        if (!utils.IsVoid(destroy))
                            onNewScopeDestroyed.push(destroy);
                    }
                }
                catch (e_32_1) { e_32 = { error: e_32_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_32) throw e_32.error; }
                }
                var destroyBindings = onNewScopeDestroyed.length ? function destroyBindings() {
                    for (var i = 0, ii = onNewScopeDestroyed.length; i < ii; ++i) {
                        onNewScopeDestroyed[i]();
                    }
                } : angular.noop;
                if (newScope && destroyBindings !== angular.noop) {
                    newScope.$on('$destroy', destroyBindings);
                    return angular.noop;
                }
                return destroyBindings;
                var e_32, _c;
            }
            Controller.ApplyTo = ApplyTo;
            Controller.ControllerBindingsSymbol = Symbol("ScoplessBindingsSymbol");
            function GetAll(target) {
                var bindingCollection = target[Controller.ControllerBindingsSymbol];
                if (utils.IsVoid(bindingCollection))
                    return target[Controller.ControllerBindingsSymbol] = BindingCollection.CreateRoot();
                else if (!utils.HasProp(target, Controller.ControllerBindingsSymbol))
                    return target[Controller.ControllerBindingsSymbol] = bindingCollection.CreateInherited();
                return bindingCollection;
            }
            Controller.GetAll = GetAll;
            function CreateBindingDecorator(createBindDefinition) {
                return _bind;
                function _bind(target, propertyKey) {
                    var bindingCollection = GetAll(target);
                    var newDefinition = createBindDefinition(propertyKey);
                    bindingCollection.AddBinding(newDefinition);
                }
            }
            Controller.CreateBindingDecorator = CreateBindingDecorator;
        })(Controller = Attribute.Controller || (Attribute.Controller = {}));
        function ApplyDefaults(target, defaults, binds, attrs) {
            defaults = angular.copy(defaults);
            if (defaults) {
                try {
                    for (var _a = __values(binds.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var bind = _b.value;
                        var remoteName = bind.CamelCasedAttributeName, localName = bind.DestinationName;
                        if (utils.IsVoid(attrs[remoteName])) {
                            if (utils.HasProp(defaults, localName))
                                target[localName] = defaults[localName];
                        }
                        delete defaults[localName];
                    }
                }
                catch (e_33_1) { e_33 = { error: e_33_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_33) throw e_33.error; }
                }
            }
            angular.forEach(defaults, function (value, key) { return target[key] = value; });
            var e_33, _c;
        }
        Attribute.ApplyDefaults = ApplyDefaults;
        ;
        var BindingCollection = (function () {
            function BindingCollection(bindings) {
                this.bindings = bindings;
            }
            BindingCollection.CreateRoot = function () {
                return new BindingCollection(new Map());
            };
            BindingCollection.prototype.CreateInherited = function () {
                return new BindingCollection(new Map(this.bindings));
            };
            BindingCollection.prototype.AddBinding = function (bindDefiniton) {
                var key = bindDefiniton.DestinationName;
                if (this.bindings.has(key))
                    throw new Error("Cannot define multiple bindings on the same property: " + bindDefiniton.DestinationName);
                this.bindings.set(key, bindDefiniton);
            };
            BindingCollection.prototype[Symbol.iterator] = function () {
                return this.bindings[Symbol.iterator]();
            };
            BindingCollection.prototype.entries = function () {
                return this.bindings.entries();
            };
            BindingCollection.prototype.keys = function () {
                return this.bindings.keys();
            };
            BindingCollection.prototype.values = function () {
                return this.bindings.values();
            };
            BindingCollection.prototype.forEach = function (callbackfn, thisArg) {
                return this.bindings.forEach(callbackfn, thisArg);
            };
            BindingCollection.prototype.get = function (key) {
                return this.bindings.get(key);
            };
            BindingCollection.prototype.has = function (key) {
                return this.bindings.has(key);
            };
            Object.defineProperty(BindingCollection.prototype, "size", {
                get: function () {
                    return this.bindings.size;
                },
                enumerable: true,
                configurable: true
            });
            return BindingCollection;
        }());
        Attribute.BindingCollection = BindingCollection;
    })(Attribute = exports.Attribute || (exports.Attribute = {}));
});
define("scripts/lib/select-development/sss-watch", ["require", "exports", "app/basic-utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function mapArrToObj(keys, arr) {
        var obj = {};
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (arr.length > i) {
                obj[key] = arr[i];
            }
            else {
                obj[key] = undefined;
            }
        }
        return obj;
    }
    function WrapListener(originalListener, keys) {
        return mapToObj;
        function mapToObj(newValues, oldValues) {
            var rest = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                rest[_i - 2] = arguments[_i];
            }
            var singleReference = newValues === oldValues;
            var objNewValues = mapArrToObj(keys, newValues);
            var objOldValues = singleReference ? newValues : mapArrToObj(keys, oldValues);
            return originalListener.call.apply(originalListener, __spread([this, objNewValues, objOldValues], rest));
        }
    }
    function ListenerWithContext(originalListener, context) {
        return ListenerWrappedWithContext;
        function ListenerWrappedWithContext() {
            return originalListener.apply(context, arguments);
        }
    }
    function objectGroup(watchExpr, listener) {
        if (!angular.isObject(watchExpr))
            throw new Error("Cannot $watch.group on a non-object");
        if (angular.isArray(watchExpr))
            return [watchExpr, listener];
        var keys = Object.keys(watchExpr);
        return [keys.map(function (k) { return watchExpr[k]; }), WrapListener(listener, keys)];
    }
    function parseForContext(context, expr, parseService) {
        var parsedExpr = parseService(expr), boundExpr = angular.extend(function (c) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return parsedExpr.call.apply(parsedExpr, __spread([null, context], args));
        }, parsedExpr);
        if (boundExpr.assign) {
            boundExpr.assign = angular.extend(function (c) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                return (_a = parsedExpr.assign).call.apply(_a, __spread([parsedExpr, context], args));
                var _a;
            }, boundExpr.assign);
        }
        return boundExpr;
    }
    function WatchService($parse, scope, controller) {
        var controllerBoundWatch = CreateContextBoundWatch(controller);
        return utils.Extend(Watch, {
            collection: WatchCollection,
            Collection: WatchCollection,
            Deep: function (watchExpression, listener) { return Watch(watchExpression, listener, true); },
            controller: controllerBoundWatch,
            Controller: controllerBoundWatch,
            context: CreateContextBoundWatch,
            group: WatchGroup,
            Group: utils.Extend(WatchGroup, { Array: WatchGroup }),
            Once: angular.extend(WatchOnce, {
                Collection: WatchCollectionOnce,
                Deep: function (watchExpression, listener) { return WatchOnce(watchExpression, listener, true); },
            }),
            Custom: WatchCustomEquality,
        });
        function WatchCustomEquality(getValue, getStableOrAreEqual, areEqualOrListener, listenerOrVoid) {
            var watchHash = null;
            var getStable;
            var areEqual;
            var listener;
            if (utils.IsVoid(listenerOrVoid)) {
                listener = areEqualOrListener;
                areEqual = getStableOrAreEqual;
                getStable = function (x) { return x; };
            }
            else {
                listener = listenerOrVoid;
                areEqual = areEqualOrListener;
                getStable = getStableOrAreEqual;
            }
            return scope.$watch(function () {
                var nextValue = getValue();
                if (!watchHash || !areEqual(nextValue, watchHash.Value))
                    watchHash = { Value: getStable(nextValue), };
                return watchHash;
            }, function (hash, lastHash) { return listener(hash.Value, lastHash.Value); });
        }
        function Watch() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return scope.$watch.apply(scope, args);
        }
        function WatchCollection() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return scope.$watchCollection.apply(scope, args);
        }
        function WatchOnce(watchExpression, listener, objectEquality) {
            if (!watchExpression)
                throw new Error("watchExpression is required");
            var compiled = $parse("::fn(this)");
            var bound = angular.extend(function (scope) { return compiled(scope, { fn: watchExpression }); }, compiled);
            return scope.$watch(bound, listener, objectEquality);
        }
        function WatchCollectionOnce(watchExpression, listener) {
            if (!watchExpression)
                throw new Error("watchExpression is required");
            var compiled = $parse("::fn(this)");
            var bound = angular.extend(function (scope) { return compiled(scope, { fn: watchExpression }); }, compiled);
            return scope.$watchCollection(bound, listener);
        }
        function WatchGroup(watchExpr, listener) {
            var rest = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                rest[_i - 2] = arguments[_i];
            }
            return (_a = scope.$watchGroup).call.apply(_a, __spread([scope], objectGroup(watchExpr, listener).concat(rest)));
            var _a;
        }
        function CreateContextBoundWatch(context) {
            if (!context)
                return null;
            return angular.extend(ContextBoundWatch, {
                collection: ContextBoundCollectionWatch,
                group: ContextBoundGroupWatch,
                context: CreateContextBoundWatch,
            });
            function ContextBoundWatch(expr, listener) {
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                expr = parseForContext(context, expr, $parse);
                if (angular.isFunction(listener))
                    listener = listener.bind(context);
                return (_a = scope.$watch).call.apply(_a, __spread([scope, expr, listener], args));
                var _a;
            }
            function ContextBoundCollectionWatch(expr, listener) {
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                expr = parseForContext(context, expr, $parse);
                if (angular.isFunction(listener))
                    listener = listener.bind(context);
                return (_a = scope.$watchCollection).call.apply(_a, __spread([scope, expr, listener], args));
                var _a;
            }
            function ContextBoundGroupWatch(expressions, listener) {
                var rest = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    rest[_i - 2] = arguments[_i];
                }
                var parsedExpressions = angular.map(expressions, function (expr) { return parseForContext(context, expr, $parse); });
                if (angular.isFunction(listener))
                    listener = ListenerWithContext(listener, context);
                return (_a = scope.$watchGroup).call.apply(_a, __spread([scope], objectGroup(parsedExpressions, listener).concat(rest)));
                var _a;
            }
        }
    }
    exports.WatchService = WatchService;
});
define("scripts/lib/select-development/sss-bind-definitions", ["require", "exports", "app/basic-utils", "scripts/lib/select-development/sss-names", "scripts/lib/select-development/sss-binds"], function (require, exports, utils, names, binds) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Attribute;
    (function (Attribute) {
        Attribute.ApplyDefaults = binds.Attribute.ApplyDefaults;
        Attribute.BindingCollection = binds.Attribute.BindingCollection;
        Attribute.Controller = binds.Attribute.Controller;
        var BindDefinitionBase = (function () {
            function BindDefinitionBase() {
            }
            Object.defineProperty(BindDefinitionBase.prototype, "CamelCasedAttributeName", {
                get: function () {
                    return names.CamelCase(this.AttributeName);
                },
                enumerable: true,
                configurable: true
            });
            return BindDefinitionBase;
        }());
        Attribute.BindDefinitionBase = BindDefinitionBase;
        var LiteralBindDefinition = (function (_super) {
            __extends(LiteralBindDefinition, _super);
            function LiteralBindDefinition(DestinationName, AttributeName, options) {
                var _this = _super.call(this) || this;
                _this.DestinationName = DestinationName;
                _this.AttributeName = AttributeName;
                var useOptions = __assign({}, LiteralBindDefinition.Options.Default, (options || {}));
                _this.Optional = useOptions.optional;
                return _this;
            }
            LiteralBindDefinition.prototype.ApplyAsScopelessTo = function (args) {
                var attrs = args.attrs, destination = args.destination, scope = args.scope, interpolateService = args.interpolateService;
                var _a = this, destName = _a.DestinationName, attrName = _a.CamelCasedAttributeName, optional = _a.Optional;
                if (!optional && !utils.HasProp(attrs, attrName))
                    destination[destName] = attrs[attrName] = undefined;
                var unwatch = attrs.$observe(attrName, function (value) {
                    if (!utils.IsString(value) && !utils.IsBoolean(value))
                        return;
                    destination[destName] = value;
                });
                attrs["$$observers"][attrName].$$scope = scope;
                var lastValue = attrs[attrName];
                if (utils.IsString(lastValue)) {
                    destination[destName] = interpolateService(lastValue)(scope);
                }
                else if (utils.IsBoolean(lastValue)) {
                    destination[destName] = lastValue;
                }
                return unwatch;
            };
            return LiteralBindDefinition;
        }(BindDefinitionBase));
        Attribute.LiteralBindDefinition = LiteralBindDefinition;
        (function (LiteralBindDefinition) {
            var Options;
            (function (Options) {
                Options.Default = Object.freeze({
                    optional: false,
                });
            })(Options = LiteralBindDefinition.Options || (LiteralBindDefinition.Options = {}));
            function CreateAsDecorator(attributeName, options) {
                if (options === void 0) { options = LiteralBindDefinition.Options.Default; }
                return binds.Attribute.Controller.CreateBindingDecorator(function (destName) { return new LiteralBindDefinition(destName, attributeName, options); });
            }
            LiteralBindDefinition.CreateAsDecorator = CreateAsDecorator;
            (function (CreateAsDecorator) {
                CreateAsDecorator.Options = LiteralBindDefinition.Options;
            })(CreateAsDecorator = LiteralBindDefinition.CreateAsDecorator || (LiteralBindDefinition.CreateAsDecorator = {}));
        })(LiteralBindDefinition = Attribute.LiteralBindDefinition || (Attribute.LiteralBindDefinition = {}));
        var TwoWayBindDefinition = (function (_super) {
            __extends(TwoWayBindDefinition, _super);
            function TwoWayBindDefinition(DestinationName, AttributeName, options) {
                var _this = _super.call(this) || this;
                _this.DestinationName = DestinationName;
                _this.AttributeName = AttributeName;
                var useOptions = __assign({}, TwoWayBindDefinition.Options.Default, (options || {}));
                _this.Optional = useOptions.optional;
                _this.Shallow = useOptions.shallow;
                return _this;
            }
            TwoWayBindDefinition.prototype.ApplyAsScopelessTo = function (args) {
                var attrs = args.attrs, destination = args.destination, scope = args.scope, parseService = args.parseService;
                var _a = this, destName = _a.DestinationName, attrName = _a.CamelCasedAttributeName, optional = _a.Optional, shallow = _a.Shallow;
                if (!utils.HasProp(attrs, attrName)) {
                    if (optional)
                        return;
                    attrs[attrName] = undefined;
                }
                if (optional && !attrs[attrName])
                    return;
                var parentGet = parseService(attrs[attrName]);
                var compare;
                if (parentGet.literal) {
                    compare = angular.equals;
                }
                else {
                    compare = function (a, b) { return a === b || (a !== a && b !== b); };
                    ;
                }
                var lastValue = destination[destName] = parentGet(scope);
                var parentSet = parentGet.assign || (function () {
                    lastValue = destination[destName] = parentGet(scope);
                    throw new Error("Expression '" + attrs[attrName] + "' used with directive '" + name + "' is non-assignable!");
                });
                var parentValueWatch = function (parentValue) {
                    if (!compare(parentValue, destination[destName])) {
                        if (!compare(parentValue, lastValue)) {
                            destination[destName] = parentValue;
                        }
                        else {
                            parentSet(scope, parentValue = destination[destName]);
                        }
                    }
                    lastValue = parentValue;
                    return lastValue;
                };
                parentValueWatch["$stateful"] = true;
                var unwatch;
                if (shallow) {
                    unwatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
                }
                else {
                    unwatch = scope.$watch(parseService(attrs[attrName], parentValueWatch), null, parentGet.literal);
                }
                return unwatch;
            };
            return TwoWayBindDefinition;
        }(BindDefinitionBase));
        Attribute.TwoWayBindDefinition = TwoWayBindDefinition;
        (function (TwoWayBindDefinition) {
            var Options;
            (function (Options) {
                Options.Default = Object.freeze({
                    optional: false,
                    shallow: false,
                });
            })(Options = TwoWayBindDefinition.Options || (TwoWayBindDefinition.Options = {}));
            function CreateAsDecorator(attributeName, options) {
                if (options === void 0) { options = TwoWayBindDefinition.Options.Default; }
                return binds.Attribute.Controller.CreateBindingDecorator(function (destName) { return new TwoWayBindDefinition(destName, attributeName, options); });
            }
            TwoWayBindDefinition.CreateAsDecorator = CreateAsDecorator;
            (function (CreateAsDecorator) {
                CreateAsDecorator.Options = TwoWayBindDefinition.Options;
            })(CreateAsDecorator = TwoWayBindDefinition.CreateAsDecorator || (TwoWayBindDefinition.CreateAsDecorator = {}));
        })(TwoWayBindDefinition = Attribute.TwoWayBindDefinition || (Attribute.TwoWayBindDefinition = {}));
        var InBindDefinition = (function (_super) {
            __extends(InBindDefinition, _super);
            function InBindDefinition(DestinationName, AttributeName, options) {
                var _this = _super.call(this) || this;
                _this.DestinationName = DestinationName;
                _this.AttributeName = AttributeName;
                var useOptions = __assign({}, InBindDefinition.Options.Default, (options || {}));
                _this.Optional = useOptions.optional;
                return _this;
            }
            InBindDefinition.prototype.ApplyAsScopelessTo = function (args) {
                var attrs = args.attrs, destination = args.destination, scope = args.scope, parseService = args.parseService;
                var _a = this, destName = _a.DestinationName, attrName = _a.CamelCasedAttributeName, optional = _a.Optional;
                if (!utils.HasProp(attrs, attrName)) {
                    if (optional)
                        return;
                    attrs[attrName] = undefined;
                }
                if (optional && !attrs[attrName])
                    return;
                var parentGet = parseService(attrs[attrName]);
                var deepWatch = parentGet.literal;
                var initalValue = destination[destName] = parentGet(scope);
                var unwatch = scope.$watch(parentGet, function (newValue, oldValue) {
                    if (oldValue === newValue) {
                        if (oldValue === initalValue || (deepWatch && angular.equals(oldValue, initalValue)))
                            return;
                        oldValue = initalValue;
                    }
                    destination[destName] = newValue;
                }, deepWatch);
                return unwatch;
            };
            return InBindDefinition;
        }(BindDefinitionBase));
        Attribute.InBindDefinition = InBindDefinition;
        (function (InBindDefinition) {
            var Options;
            (function (Options) {
                Options.Default = Object.freeze({
                    optional: false,
                });
            })(Options = InBindDefinition.Options || (InBindDefinition.Options = {}));
            function CreateAsDecorator(attributeName, options) {
                if (options === void 0) { options = InBindDefinition.Options.Default; }
                return binds.Attribute.Controller.CreateBindingDecorator(function (destName) { return new InBindDefinition(destName, attributeName, options); });
            }
            InBindDefinition.CreateAsDecorator = CreateAsDecorator;
            (function (CreateAsDecorator) {
                CreateAsDecorator.Options = InBindDefinition.Options;
            })(CreateAsDecorator = InBindDefinition.CreateAsDecorator || (InBindDefinition.CreateAsDecorator = {}));
        })(InBindDefinition = Attribute.InBindDefinition || (Attribute.InBindDefinition = {}));
        var OutBindDefinition = (function (_super) {
            __extends(OutBindDefinition, _super);
            function OutBindDefinition(DestinationName, AttributeName, options) {
                var _this = _super.call(this) || this;
                _this.DestinationName = DestinationName;
                _this.AttributeName = AttributeName;
                var useOptions = __assign({}, OutBindDefinition.Options.Default, (options || {}));
                _this.Optional = useOptions.optional;
                _this.Shallow = useOptions.shallow;
                return _this;
            }
            OutBindDefinition.prototype.ApplyAsScopelessTo = function (args) {
                var attrs = args.attrs, destination = args.destination, scope = args.scope, parseService = args.parseService;
                var _a = this, destName = _a.DestinationName, attrName = _a.CamelCasedAttributeName, optional = _a.Optional, shallow = _a.Shallow;
                if (!utils.HasProp(attrs, attrName)) {
                    if (optional)
                        return;
                    attrs[attrName] = undefined;
                }
                if (optional && !attrs[attrName])
                    return;
                var destGet = function () { return destination[destName]; };
                var parentGet = parseService(attrs[attrName]);
                var parentSet = parentGet.assign ? (function (value) { return parentGet.assign(scope, value); }) : function () {
                    throw new Error("Expression '" + attrs[attrName] + "' used with directive '" + name + "' is non-assignable!");
                };
                var unwatch;
                if (shallow) {
                    unwatch = scope.$watchCollection(destGet, parentSet);
                }
                else {
                    unwatch = scope.$watch(destGet, parentSet);
                }
                return unwatch;
            };
            return OutBindDefinition;
        }(BindDefinitionBase));
        Attribute.OutBindDefinition = OutBindDefinition;
        (function (OutBindDefinition) {
            var Options;
            (function (Options) {
                Options.Default = Object.freeze({
                    optional: false,
                    shallow: false,
                });
            })(Options = OutBindDefinition.Options || (OutBindDefinition.Options = {}));
            function CreateAsDecorator(attributeName, options) {
                if (options === void 0) { options = OutBindDefinition.Options.Default; }
                return binds.Attribute.Controller.CreateBindingDecorator(function (destName) { return new OutBindDefinition(destName, attributeName, options); });
            }
            OutBindDefinition.CreateAsDecorator = CreateAsDecorator;
            (function (CreateAsDecorator) {
                CreateAsDecorator.Options = OutBindDefinition.Options;
            })(CreateAsDecorator = OutBindDefinition.CreateAsDecorator || (OutBindDefinition.CreateAsDecorator = {}));
        })(OutBindDefinition = Attribute.OutBindDefinition || (Attribute.OutBindDefinition = {}));
        var InvokableExpressionBindDefinition = (function (_super) {
            __extends(InvokableExpressionBindDefinition, _super);
            function InvokableExpressionBindDefinition(DestinationName, AttributeName, options) {
                var _this = _super.call(this) || this;
                _this.DestinationName = DestinationName;
                _this.AttributeName = AttributeName;
                var useOptions = __assign({}, InvokableExpressionBindDefinition.Options.Default, (options || {}));
                _this.Optional = useOptions.optional;
                return _this;
            }
            InvokableExpressionBindDefinition.prototype.ApplyAsScopelessTo = function (args) {
                var attrs = args.attrs, destination = args.destination, scope = args.scope, parseService = args.parseService;
                var _a = this, destName = _a.DestinationName, attrName = _a.CamelCasedAttributeName, optional = _a.Optional;
                var parentGet = attrs.hasOwnProperty(attrName) ? parseService(attrs[attrName]) : angular.noop;
                if (parentGet === angular.noop && optional)
                    return;
                destination[destName] = (function (locals) {
                    return parentGet(scope, locals);
                });
            };
            return InvokableExpressionBindDefinition;
        }(BindDefinitionBase));
        Attribute.InvokableExpressionBindDefinition = InvokableExpressionBindDefinition;
        (function (InvokableExpressionBindDefinition) {
            var Options;
            (function (Options) {
                Options.Default = Object.freeze({
                    optional: false,
                });
            })(Options = InvokableExpressionBindDefinition.Options || (InvokableExpressionBindDefinition.Options = {}));
            function CreateAsDecorator(attributeName, options) {
                if (options === void 0) { options = OutBindDefinition.Options.Default; }
                return binds.Attribute.Controller.CreateBindingDecorator(function (destName) { return new InvokableExpressionBindDefinition(destName, attributeName, options); });
            }
            InvokableExpressionBindDefinition.CreateAsDecorator = CreateAsDecorator;
            (function (CreateAsDecorator) {
                CreateAsDecorator.Options = InvokableExpressionBindDefinition.Options;
            })(CreateAsDecorator = InvokableExpressionBindDefinition.CreateAsDecorator || (InvokableExpressionBindDefinition.CreateAsDecorator = {}));
        })(InvokableExpressionBindDefinition = Attribute.InvokableExpressionBindDefinition || (Attribute.InvokableExpressionBindDefinition = {}));
        var LOCAL_REGEXP = /^\s*([@&<]|[=>](\*?))(\??)\s*(\w*)\s*$/;
        function NgParseBind(destName, definition, directiveName) {
            var match = definition.match(LOCAL_REGEXP);
            if (!match)
                throw new Error("Invalid scopeless bindings definition for directive '" + directiveName + "'. Definition: {... " + destName + ": '" + definition + "' ...}");
            return {
                mode: match[1][0],
                collection: match[2] === '*',
                optional: match[3] === '?',
                attrName: match[4] || destName,
            };
        }
        function ParseBinds(name, definitions) {
            if (utils.IsVoid(definitions))
                return [];
            return Object.entries(definitions)
                .map(function (entry) {
                var _a = __read(entry, 2), destName = _a[0], definition = _a[1];
                var _b = NgParseBind(destName, definition, name), mode = _b.mode, attrName = _b.attrName, optional = _b.optional, collection = _b.collection;
                switch (mode) {
                    case "@":
                        return new LiteralBindDefinition(destName, attrName, { optional: optional, });
                    case "=":
                        return new TwoWayBindDefinition(destName, attrName, { optional: optional, shallow: collection, });
                    case "<":
                        return new InBindDefinition(destName, attrName, { optional: optional, });
                    case ">":
                        return new OutBindDefinition(destName, attrName, { optional: optional, shallow: collection, });
                    case "&":
                        return new InvokableExpressionBindDefinition(destName, attrName, { optional: optional, });
                    default:
                        return null;
                }
            })
                .filter(function (x) { return !utils.IsVoid(x); });
        }
        Attribute.ParseBinds = ParseBinds;
    })(Attribute = exports.Attribute || (exports.Attribute = {}));
});
define("scripts/lib/select-development/sss-decorators", ["require", "exports", "app/basic-utils", "scripts/lib/select-development/sss-names", "scripts/lib/select-development/sss-bind-definitions", "app/amd-name-utils"], function (require, exports, utils, names, bind, amd_name_utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    (console.debug || console.log).call(console, "Decorators init (MUST OCCUR ONLY ONCE)");
    var Defaults = Symbol("Defaults");
    var Require = Symbol("Require");
    function GetBindControllerModeString(mode) {
        if (mode === void 0) { mode = Bind.Controller.Mode.Self; }
        switch (mode) {
            case Bind.Controller.Mode.Self:
                return "";
            case Bind.Controller.Mode.Parents:
                return "^^";
            case Bind.Controller.Mode.SelfOrParents:
                return "^";
            default:
                throw new Error("Unknown Bind.ControllerMode: " + mode);
        }
    }
    var Bind;
    (function (Bind) {
        function DefaultValue(value) {
            return function _bind(target, propertyKey) {
                var defaults = target[Defaults];
                if (!defaults)
                    target[Defaults] = defaults = {};
                else if (!target.hasOwnProperty(Defaults))
                    defaults = target[Defaults] = Object.assign({}, target[Defaults]);
                if (Object.prototype.hasOwnProperty.call(defaults, propertyKey)) {
                    throw new Error("Cannot define multiple defaults on the same property");
                }
                defaults[propertyKey] = value;
            };
        }
        Bind.DefaultValue = DefaultValue;
        function Controller(name, options) {
            if (options === void 0) { options = {}; }
            if (utils.IsFunction(name))
                name = amd_name_utils_1.GetComponentName(name);
            else if (utils.IsObject(name))
                name = name.Name;
            var mode;
            var searchModifier = GetBindControllerModeString(options.mode);
            var optionalModifier = options.optional ? "?" : "";
            var requireString = "" + optionalModifier + searchModifier + names.CamelCase(name);
            return _bindController;
            function _bindController(target, propertyKey) {
                var require = target[Require];
                if (!require)
                    target[Require] = require = {};
                else if (!target.hasOwnProperty(Require))
                    require = target[Require] = Object.assign({}, target[Require]);
                if (Object.prototype.hasOwnProperty.call(require, propertyKey))
                    throw new Error("Cannot redefine controller binding for " + propertyKey + ".");
                require[propertyKey] = requireString;
            }
        }
        Bind.Controller = Controller;
        (function (Controller) {
            var Mode;
            (function (Mode) {
                Mode[Mode["Self"] = 1] = "Self";
                Mode[Mode["Parents"] = 2] = "Parents";
                Mode[Mode["SelfOrParents"] = 3] = "SelfOrParents";
            })(Mode = Controller.Mode || (Controller.Mode = {}));
        })(Controller = Bind.Controller || (Bind.Controller = {}));
        Bind.ControllerMode = Controller.Mode;
        Bind.TwoWay = bind.Attribute.TwoWayBindDefinition.CreateAsDecorator;
        Bind.Out = bind.Attribute.OutBindDefinition.CreateAsDecorator;
        Bind.In = bind.Attribute.InBindDefinition.CreateAsDecorator;
        Bind.Getter = bind.Attribute.InvokableExpressionBindDefinition.CreateAsDecorator;
        Bind.Literal = bind.Attribute.LiteralBindDefinition.CreateAsDecorator;
        function Transclude(mode) {
            if (mode === void 0) { mode = Transclude.Mode.Contents; }
            return CreateTranscludeDecorator(mode);
        }
        Bind.Transclude = Transclude;
        (function (Transclude) {
            var Mode;
            (function (Mode) {
                Mode[Mode["Contents"] = 0] = "Contents";
                Mode[Mode["Element"] = 1] = "Element";
            })(Mode = Transclude.Mode || (Transclude.Mode = {}));
        })(Transclude = Bind.Transclude || (Bind.Transclude = {}));
        function TranscludeSlot(tagName, options) {
            if (options === void 0) { options = {}; }
            return CreateTranscludeDecorator(new CreateTranscludeDecorator.SlotTranscludeDefinition(tagName, !!options.optional, !!options.unwrap));
        }
        Bind.TranscludeSlot = TranscludeSlot;
    })(Bind = exports.Bind || (exports.Bind = {}));
    function Inject(name) {
        return function addInjection(target, propertyKey, parameterIndex) {
            if (!target.hasOwnProperty("$inject"))
                target["$inject"] = [];
            target["$inject"][parameterIndex] = name.toString();
        };
    }
    exports.Inject = Inject;
    function GetRequire(target) {
        return target[Require] || {};
    }
    exports.GetRequire = GetRequire;
    function GetDefaults(target) {
        return target[Defaults] || {};
    }
    exports.GetDefaults = GetDefaults;
    function GetBindings(target) {
        return bind.Attribute.Controller.GetAll(target);
    }
    exports.GetBindings = GetBindings;
    function ScopelessBind(target) {
        target["scopelessBind"] = true;
    }
    exports.ScopelessBind = ScopelessBind;
    function GetTranscludes(target) {
        return CreateTranscludeDecorator.TryGetCurrent(target);
    }
    exports.GetTranscludes = GetTranscludes;
    function CreateTranscludeDecorator(transcludeDef) {
        if (utils.IsNumber(transcludeDef)) {
            switch (transcludeDef) {
                case CreateTranscludeDecorator.Mode.Contents:
                    return CreateTranscludeDecorator.ContentsDecorator;
                case CreateTranscludeDecorator.Mode.Element:
                    return CreateTranscludeDecorator.ElementDecorator;
                default:
                    throw new Error("Unknown definition mode " + transcludeDef);
            }
        }
        if (transcludeDef instanceof CreateTranscludeDecorator.SlotTranscludeDefinition)
            return function (target, propertyKey) { return CreateTranscludeDecorator.MultislotDecorator(transcludeDef, target, propertyKey); };
        throw new Error("Bad definition.");
    }
    (function (CreateTranscludeDecorator) {
        var SlotTranscludeDefinition = (function () {
            function SlotTranscludeDefinition(RawTagName, Optional, Unwrap) {
                this.RawTagName = RawTagName;
                this.Optional = Optional;
                this.Unwrap = Unwrap;
                this.TagName = names.ComponentNameNormalize(this.RawTagName);
                this.AngularOptionalText = this.Optional ? "?" : "";
                this.AngularSlotDefinition = "" + this.AngularOptionalText + this.TagName;
            }
            return SlotTranscludeDefinition;
        }());
        CreateTranscludeDecorator.SlotTranscludeDefinition = SlotTranscludeDefinition;
        var Mode;
        (function (Mode) {
            Mode[Mode["Contents"] = 0] = "Contents";
            Mode[Mode["Element"] = 1] = "Element";
        })(Mode = CreateTranscludeDecorator.Mode || (CreateTranscludeDecorator.Mode = {}));
        var Transcludes = Symbol("Transcludes");
        var TranscludeDefinition = (function () {
            function TranscludeDefinition(Targets, Definition) {
                if (Targets === void 0) { Targets = []; }
                if (Definition === void 0) { Definition = false; }
                this.Targets = Targets;
                this.Definition = Definition;
            }
            Object.defineProperty(TranscludeDefinition.prototype, "AngularDefinition", {
                get: function () {
                    if (!utils.IsObject(this.Definition))
                        return this.Definition;
                    var ngSlots = {};
                    for (var propertyName in this.Definition) {
                        if (!utils.HasProp(this.Definition, propertyName))
                            continue;
                        ngSlots[propertyName] = this.Definition[propertyName].AngularSlotDefinition;
                    }
                    return ngSlots;
                },
                enumerable: true,
                configurable: true
            });
            return TranscludeDefinition;
        }());
        CreateTranscludeDecorator.TranscludeDefinition = TranscludeDefinition;
        function TryGetCurrent(target) {
            var foundValue = target[Transcludes];
            if (!foundValue || utils.HasProp(target, Transcludes))
                return foundValue;
            return new TranscludeDefinition(utils.ShallowCopy(foundValue.Targets), utils.ShallowCopy(foundValue.Definition));
        }
        CreateTranscludeDecorator.TryGetCurrent = TryGetCurrent;
        function GetCurrent(target) {
            return TryGetCurrent(target) || new TranscludeDefinition();
        }
        function SetCurrent(target, transcludeDefinition) {
            return target[Transcludes] = transcludeDefinition || false;
        }
        function ContentsDecorator(target, propertyKey) {
            var current = GetCurrent(target);
            if (current.Definition === "element")
                throw new Error("Cannot mix element transclude with anything else.");
            if (!current.Definition)
                current.Definition = true;
            current.Targets.push(propertyKey);
            SetCurrent(target, current);
        }
        CreateTranscludeDecorator.ContentsDecorator = ContentsDecorator;
        function ElementDecorator(target, propertyKey) {
            var current = GetCurrent(target);
            if (current.Definition && current.Definition !== "element")
                throw new Error("Cannot mix element transclude with anything else.");
            current.Definition = "element";
            current.Targets.push(propertyKey);
            SetCurrent(target, current);
        }
        CreateTranscludeDecorator.ElementDecorator = ElementDecorator;
        function MultislotDecorator(definition, target, propertyKey) {
            var current = GetCurrent(target);
            if (current.Definition === "element")
                throw new Error("Cannot mix element transclude with anything else.");
            if (!utils.IsString(propertyKey))
                throw new Error("Cannot bind a multi-slot transclude to a symbol");
            var slotName = propertyKey;
            var existingSlots = current.Definition = utils.IsBoolean(current.Definition) ? {} : current.Definition;
            if (utils.HasProp(existingSlots, slotName)) {
                var existing = existingSlots[slotName];
                if (existing.TagName !== definition.TagName)
                    throw new Error("The new definition of the slot " + slotName + " is not compatible with the existing one.");
                definition = new SlotTranscludeDefinition(definition.TagName, definition.Optional && existing.Optional, definition.Unwrap);
            }
            existingSlots[slotName] = definition;
            SetCurrent(target, current);
        }
        CreateTranscludeDecorator.MultislotDecorator = MultislotDecorator;
    })(CreateTranscludeDecorator || (CreateTranscludeDecorator = {}));
});
define("app/amd-utils", ["require", "exports", "scripts/lib/select-development/sss-binds", "app/amd-directive-registar", "scripts/lib/select-development/sss-watch", "scripts/lib/select-development/sss-decorators", "scripts/lib/select-development/sss-names", "app/basic-utils", "app/amd-name-utils", "app/amd-name-utils"], function (require, exports, binds, directives, watch, decorators, names, utils, amd_name_utils_2, amd_name_utils_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TryGetComponentName = amd_name_utils_2.TryGetComponentName;
    exports.GetComponentName = amd_name_utils_2.GetComponentName;
    var TransclusionMode;
    (function (TransclusionMode) {
        TransclusionMode[TransclusionMode["NoTransclude"] = 0] = "NoTransclude";
        TransclusionMode[TransclusionMode["Element"] = 1] = "Element";
        TransclusionMode[TransclusionMode["Contents"] = 2] = "Contents";
    })(TransclusionMode = exports.TransclusionMode || (exports.TransclusionMode = {}));
    var MultislotTransclusion = (function () {
        function MultislotTransclusion(slots) {
            if (slots === void 0) { slots = {}; }
            this.slots = slots;
            this.IfYoureCreatingAThingHereYoureDoingItWrong = "Yes, yes I am";
        }
        MultislotTransclusion.prototype.ToAngular = function () {
            var fixedSlots = {};
            try {
                for (var _a = __values(Object.keys(this.slots)), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var key = _b.value;
                    var _c = __read(/^(\??)(.*)/.exec(this.slots[key]), 3), options = _c[1], target = _c[2];
                    fixedSlots[key] = "" + options + names.ComponentNameNormalize(target);
                }
            }
            catch (e_34_1) { e_34 = { error: e_34_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                }
                finally { if (e_34) throw e_34.error; }
            }
            return fixedSlots;
            var e_34, _d;
        };
        return MultislotTransclusion;
    }());
    exports.MultislotTransclusion = MultislotTransclusion;
    var ScopeMode;
    (function (ScopeMode) {
        ScopeMode[ScopeMode["ParentScope"] = 0] = "ParentScope";
        ScopeMode[ScopeMode["NewInheritedScope"] = 1] = "NewInheritedScope";
    })(ScopeMode = exports.ScopeMode || (exports.ScopeMode = {}));
    var IsolateScope = (function () {
        function IsolateScope(bindings) {
            if (bindings === void 0) { bindings = {}; }
            this.bindings = bindings;
            this.IfYoureCreatingAThingHereYoureDoingItWrong = "Yes, yes I am";
        }
        IsolateScope.prototype.ToAngular = function () {
            return angular.copy(this.bindings);
        };
        return IsolateScope;
    }());
    exports.IsolateScope = IsolateScope;
    var Target;
    (function (Target) {
        Target[Target["Element"] = 1] = "Element";
        Target[Target["Attribute"] = 2] = "Attribute";
        Target[Target["Class"] = 4] = "Class";
        Target[Target["Comment"] = 8] = "Comment";
        Target[Target["ElementOrAttribute"] = 3] = "ElementOrAttribute";
    })(Target = exports.Target || (exports.Target = {}));
    function TargetToAngularRestrict(source) {
        var ngRestrict = "";
        if (!source)
            return ngRestrict;
        if (utils.HasFlag(source, Target.Attribute))
            ngRestrict += "A";
        if (utils.HasFlag(source, Target.Element))
            ngRestrict += "E";
        if (utils.HasFlag(source, Target.Class))
            ngRestrict += "C";
        if (utils.HasFlag(source, Target.Comment))
            ngRestrict += "M";
        return ngRestrict;
    }
    function ScopeToAngular(source) {
        if (utils.IsNumber(source))
            return !!source;
        else
            return source.ToAngular();
    }
    function TransclusionToAngular(source) {
        if (utils.IsVoid(source))
            return false;
        switch (source) {
            case TransclusionMode.Contents:
                return true;
            case TransclusionMode.Element:
                return "element";
            case TransclusionMode.NoTransclude:
                return false;
            default:
                return source.ToAngular();
        }
    }
    var SelectDefinition;
    (function (SelectDefinition) {
        var Deferred;
        (function (Deferred) {
            function GetTemplate(name, definition) {
                if (!utils.HasProp(definition, "Template")) {
                    return Template(name)
                        .catch(function (error) {
                        console.log("Failed to load the template for " + name, {
                            definition: definition,
                            error: error,
                        });
                        return Promise.reject(error);
                    });
                }
                else if (utils.IsString(definition.Template) || utils.IsVoid(definition.Template))
                    return definition.Template;
                else
                    return Promise.resolve(definition.Template);
            }
            function Directive(selectDefinition, registar) {
                var _a = Create(selectDefinition), NgDefinition = _a.NgDefinition, Name = _a.Name;
                return Define(Name, selectDefinition, NgDefinition, registar);
            }
            Deferred.Directive = Directive;
            function Component(selectDefinition, controller, registar) {
                var _a = Create(selectDefinition, controller), NgDefinition = _a.NgDefinition, Name = _a.Name;
                if (names.CamelCase(Name) === names.CamelCase(controller.name))
                    console.warn && console.warn("Relying on the name of the controller function will cause issues in prod after minification: " + Name);
                Define(Name, selectDefinition, NgDefinition, registar);
            }
            Deferred.Component = Component;
            function Define(name, selectDefinition, ngDefinition, registar) {
                var template = GetTemplate(name, selectDefinition);
                directives.DefineFor(registar || name, name, Promise.resolve(template).then(function (template) {
                    InjectTemplateAndReturnDefinition.$inject = ["$injector"];
                    function InjectTemplateAndReturnDefinition($injector) {
                        var def = ngDefinition($injector);
                        def.template = template || void undefined;
                        return def;
                    }
                    return InjectTemplateAndReturnDefinition;
                }));
            }
        })(Deferred = SelectDefinition.Deferred || (SelectDefinition.Deferred = {}));
        var Immediate;
        (function (Immediate) {
            function GetTemplate(name, selectDefinition) {
                return selectDefinition.Template;
            }
            function Directive(selectDefinition) {
                return Create(selectDefinition);
            }
            Immediate.Directive = Directive;
            function Component(selectDefinition, controller) {
                return Create(selectDefinition, controller);
            }
            Immediate.Component = Component;
        })(Immediate = SelectDefinition.Immediate || (SelectDefinition.Immediate = {}));
        function Create(selectDefinition, controller) {
            var angularDef;
            var name = names.CamelCase(selectDefinition.Name);
            if (!utils.IsVoid(controller))
                angularDef = SelectNgComponent.Create(name, selectDefinition, controller);
            else
                angularDef = SelectNgDirective.Create(name, selectDefinition);
            return {
                Name: name,
                NgDefinition: angularDef,
            };
        }
        var SpecialController;
        (function (SpecialController) {
            SpecialController[SpecialController["Self"] = 0] = "Self";
            SpecialController[SpecialController["SingleBound"] = 1] = "SingleBound";
            SpecialController[SpecialController["ArrayBound"] = 2] = "ArrayBound";
        })(SpecialController || (SpecialController = {}));
        var SelectNgDirective = (function () {
            function SelectNgDirective(name, $injector, definition) {
                this.name = name;
                this.$injector = $injector;
                this.definition = definition;
                this.OnCompile = this.definition.OnCompile;
                this.OnLink = this.definition.OnLink;
                this.ScopeMode = utils.HasProp(this.definition, "Scope") ? this.definition.Scope : new IsolateScope();
                this.RequireLookup = [];
                this.bindToController = false;
                this.restrict = TargetToAngularRestrict(this.definition.Restrict || Target.Element);
                this.priority = this.definition.Priority;
                this.replace = false;
                this.require = [];
                this.scope = ScopeToAngular(this.ScopeMode);
                this.template = this.definition.Template;
                this.templateNamespace = this.definition.TemplateNamespace;
                this.terminal = this.definition.Terminal;
                this.transclude = TransclusionToAngular(this.definition.Transclude);
                this.multiElement = this.definition.MultiElement;
                if (utils.IsArray(definition.Require)) {
                    (_a = this.require).push.apply(_a, __spread(definition.Require));
                    (_b = this.RequireLookup).push.apply(_b, __spread(definition.Require.map(function () { return SpecialController.ArrayBound; })));
                }
                else if (utils.IsString(definition.Require)) {
                    this.require.push(definition.Require);
                    this.RequireLookup.push(SpecialController.SingleBound);
                }
                this.require.push("?" + name);
                this.RequireLookup.push(SpecialController.Self);
                var _a, _b;
            }
            SelectNgDirective_1 = SelectNgDirective;
            SelectNgDirective.Create = function (name, definition) {
                return utils.Extend(function ($injector) { return new SelectNgDirective_1(name, $injector, definition); }, { $inject: ["$injector"], });
            };
            SelectNgDirective.prototype.InvokeUnderlyingCompile = function (tElement, tAttrs) {
                var onLink;
                if (this.OnCompile)
                    onLink = this.OnCompile(tElement, tAttrs);
                else
                    onLink = this.OnLink;
                if (utils.IsSpecified(onLink)) {
                    if (utils.IsArray(onLink) || utils.IsFunction(onLink))
                        return { post: onLink };
                    else
                        return onLink;
                }
                else
                    return {};
            };
            SelectNgDirective.prototype.compile = function (tElement, tAttrs) {
                var _this = this;
                var _a = this.InvokeUnderlyingCompile(tElement, tAttrs), pre = _a.pre, post = _a.post;
                return {
                    pre: function (scope, iElement, iAttrs, controllers, transcludeFn) {
                        _this.InvokeLink(pre, scope, iElement, iAttrs, controllers, transcludeFn);
                    },
                    post: function (scope, iElement, iAttrs, controllers, transcludeFn) {
                        _this.InvokeLink(post, scope, iElement, iAttrs, controllers, transcludeFn);
                    }
                };
            };
            SelectNgDirective.prototype.GetSelf = function (controllers) {
                return controllers[this.RequireLookup.indexOf(SpecialController.Self)];
            };
            SelectNgDirective.prototype.LinkCleanedControllers = function (controllers) {
                var singleBoundControllerIndex = this.RequireLookup.indexOf(SpecialController.SingleBound);
                if (singleBoundControllerIndex >= 0)
                    return controllers[singleBoundControllerIndex];
                else {
                    var arrayBoundControllerIndecies = [];
                    for (var i = 0; i < this.RequireLookup.length; i++) {
                        if (this.RequireLookup[i] !== SpecialController.ArrayBound)
                            continue;
                        arrayBoundControllerIndecies.push(i);
                    }
                    var cleanedControllers = new Array(arrayBoundControllerIndecies.length);
                    var _loop_3 = function (i) {
                        var sourceIndex = arrayBoundControllerIndecies[i];
                        Object.defineProperty(cleanedControllers, i, {
                            get: function () { return controllers[sourceIndex]; },
                            set: function (value) { return controllers[sourceIndex] = value; },
                        });
                    };
                    for (var i = 0; i < arrayBoundControllerIndecies.length; i++) {
                        _loop_3(i);
                    }
                    return cleanedControllers;
                }
            };
            SelectNgDirective.prototype.InvokeLink = function (linkFn, scope, iElement, iAttrs, controllers, transcludeFn) {
                var linkCleanedControllers = this.LinkCleanedControllers(controllers);
                if (utils.IsSpecified(linkFn)) {
                    if (!utils.IsInjectable(linkFn)) {
                        linkFn(scope, iElement, iAttrs, linkCleanedControllers, transcludeFn);
                    }
                    else {
                        this.$injector.invoke(linkFn, this, {
                            $scope: scope,
                            $element: iElement,
                            $attrs: iAttrs,
                            $controllers: linkCleanedControllers,
                            $controller: linkCleanedControllers,
                            $transclude: transcludeFn,
                            $self: this.GetSelf(controllers),
                        });
                    }
                }
            };
            SelectNgDirective = SelectNgDirective_1 = __decorate([
                utils.BindFunctions
            ], SelectNgDirective);
            return SelectNgDirective;
            var SelectNgDirective_1;
        }());
        var SelectNgComponent = (function (_super) {
            __extends(SelectNgComponent, _super);
            function SelectNgComponent(name, $injector, definition, underlyingController) {
                var _this = _super.call(this, name, $injector, definition) || this;
                _this.definition = definition;
                if (utils.IsSpecified(underlyingController)) {
                    var controllerTranscludes = decorators.GetTranscludes(underlyingController.prototype);
                    if (!utils.IsVoid(controllerTranscludes)) {
                        if (!_this.transclude) {
                            _this.transclude = controllerTranscludes.AngularDefinition;
                        }
                        else if (_this.transclude === "element") {
                            if (controllerTranscludes.Definition !== "element")
                                throw new Error("Cannot mix element transclude with anything else.");
                        }
                        else if (controllerTranscludes.Definition === "element") {
                            throw new Error("Cannot mix element transclude with anything else.");
                        }
                        else if (_this.transclude === true) {
                            _this.transclude = controllerTranscludes.AngularDefinition;
                        }
                        else if (!utils.IsBoolean(controllerTranscludes.Definition)) {
                            _this.transclude = utils.ShallowCopy(_this.transclude);
                            for (var slotName in controllerTranscludes.Definition) {
                                if (!utils.HasProp(controllerTranscludes.Definition, slotName))
                                    continue;
                                var newDef = controllerTranscludes.Definition[slotName];
                                var _a = __read(/^(\??)(.*)$/.exec(_this.transclude[slotName]), 3), existingSelector = _a[0], existingOptional = _a[1], exisitingTagName = _a[2];
                                if (exisitingTagName !== newDef.TagName)
                                    throw new Error("The new definition of the slot " + slotName + " is not compatible with the existing one.");
                                _this.transclude[slotName] = (existingOptional && newDef.AngularOptionalText) + exisitingTagName;
                            }
                        }
                    }
                    _this.controller = _this.WrapController(underlyingController, _this.ScopeMode, _this.name, controllerTranscludes);
                    {
                        var controllerBindings = decorators.GetRequire(underlyingController.prototype);
                        try {
                            for (var _b = __values(Object.keys(controllerBindings)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var prop = _c.value;
                                _this.require.push(controllerBindings[prop]);
                                _this.RequireLookup.push(prop);
                            }
                        }
                        catch (e_35_1) { e_35 = { error: e_35_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                            }
                            finally { if (e_35) throw e_35.error; }
                        }
                    }
                }
                _this.controllerAs = (utils.IsSpecified(_this.controller) && utils.IsObject(_this.scope)) ? "vm" : null;
                return _this;
                var e_35, _d;
            }
            SelectNgComponent_1 = SelectNgComponent;
            SelectNgComponent.Create = function (name, definition, underlyingController) {
                return utils.Extend(function ($injector) { return new SelectNgComponent_1(name, $injector, definition, underlyingController); }, { $inject: ["$injector"], });
            };
            SelectNgComponent.prototype.compile = function (tElement, tAttrs) {
                var _this = this;
                var _a = _super.prototype.compile.call(this, tElement, tAttrs), pre = _a.pre, post = _a.post;
                return {
                    pre: function (scope, iElement, iAttrs, controllers, transcludeFn) {
                        _this.BindControllers(controllers);
                        pre(scope, iElement, iAttrs, controllers, transcludeFn);
                        _this.InvokeOnLink(LinkMode.Pre, controllers);
                    },
                    post: function (scope, iElement, iAttrs, controllers, transcludeFn) {
                        post(scope, iElement, iAttrs, controllers, transcludeFn);
                        _this.InvokeOnLink(LinkMode.Post, controllers);
                    }
                };
            };
            SelectNgComponent.prototype.BindControllers = function (controllers) {
                var self = this.GetSelf(controllers);
                var _loop_4 = function (i) {
                    var propertyKey = this_1.RequireLookup[i];
                    if (utils.IsString(propertyKey)) {
                        Object.defineProperty(self, propertyKey, {
                            get: function () { return controllers[i]; },
                            set: function (value) { return controllers[i] = value; },
                        });
                    }
                };
                var this_1 = this;
                for (var i = 0; i < this.RequireLookup.length; i++) {
                    _loop_4(i);
                }
            };
            SelectNgComponent.prototype.InvokeOnLink = function (targetMode, controllers) {
                var self = this.GetSelf(controllers);
                InvokeLinkBinds(targetMode, self);
            };
            SelectNgComponent.prototype.WrapController = function (controller, scopeMode, name, controllerTranscludes) {
                var $injector = this.$injector;
                var $interpolate = this.$injector.get("$interpolate");
                var $parse = this.$injector.get("$parse");
                DirectiveController.prototype = controller.prototype;
                DirectiveController.$inject = ["$scope", "$element", "$transclude", "$attrs"];
                var controllerBinds = decorators.GetBindings(controller.prototype);
                var defaults = decorators.GetDefaults(controller.prototype);
                return DirectiveController;
                function initialiser(context, $scope, $element, $transclude, $attrs) {
                    if (!utils.IsVoid(controllerTranscludes)) {
                        if (controllerTranscludes.Definition) {
                            try {
                                for (var _a = __values(controllerTranscludes.Targets), _b = _a.next(); !_b.done; _b = _a.next()) {
                                    var propertyName = _b.value;
                                    context[propertyName] = $transclude;
                                }
                            }
                            catch (e_36_1) { e_36 = { error: e_36_1 }; }
                            finally {
                                try {
                                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                }
                                finally { if (e_36) throw e_36.error; }
                            }
                        }
                        if (controllerTranscludes.Definition != "element" && utils.IsObject(controllerTranscludes.Definition)) {
                            var _loop_5 = function (propertyName) {
                                if (!utils.HasProp(controllerTranscludes.Definition, propertyName))
                                    return "continue";
                                var definition = controllerTranscludes.Definition[propertyName];
                                var slotName = propertyName;
                                var transcludeFn = utils.TranscludeFn.CreateFromSlotTransclude($transclude, slotName);
                                if (definition.Unwrap) {
                                    transcludeFn = utils.TranscludeFn.InterceptTranscludeFn(transcludeFn, function (transclude, args) {
                                        var clone = transclude(args);
                                        if (!definition.Unwrap)
                                            return clone;
                                        var unwrapped = new Array();
                                        for (var i = 0; i < clone.length; i++) {
                                            var wrappingNode = $(clone[i]);
                                            var content = wrappingNode.contents();
                                            wrappingNode.after(content);
                                            wrappingNode.remove();
                                            unwrapped.push.apply(unwrapped, __spread(content.toArray()));
                                        }
                                        return $(unwrapped);
                                    });
                                }
                                context[propertyName] = transcludeFn;
                            };
                            for (var propertyName in controllerTranscludes.Definition) {
                                _loop_5(propertyName);
                            }
                        }
                    }
                    binds.Attribute.Controller.ApplyTo({
                        interpolateService: $interpolate,
                        parseService: $parse,
                        name: name,
                        destination: context,
                        attrs: $attrs,
                        newScope: $scope,
                        useParentScope: !!scopeMode,
                        definitions: controllerBinds.values(),
                    });
                    binds.Attribute.ApplyDefaults(context, defaults, controllerBinds, $attrs);
                    var e_36, _c;
                }
                function DirectiveController($scope, $element, $transclude, $attrs) {
                    var _this = this;
                    var $watch = watch.WatchService($parse, $scope, this);
                    ControllerBaseFields.Set(this, {
                        Attributes: $attrs,
                        Element: $element,
                        Scope: $scope,
                        Transclude: $transclude,
                        Watch: $watch,
                    });
                    if (this instanceof ControllerBase)
                        ControllerBaseInitialiser.Set(this, function () { return initialiser(_this, $scope, $element, $transclude, $attrs); });
                    else
                        initialiser(this, $scope, $element, $transclude, $attrs);
                    return $injector.invoke(controller, this, {
                        $scope: $scope,
                        $element: $element,
                        $transclude: $transclude,
                        $attrs: $attrs,
                        $watch: $watch,
                    });
                }
            };
            SelectNgComponent = SelectNgComponent_1 = __decorate([
                utils.BindFunctions
            ], SelectNgComponent);
            return SelectNgComponent;
            var SelectNgComponent_1;
        }(SelectNgDirective));
    })(SelectDefinition || (SelectDefinition = {}));
    function HasName(source) {
        return utils.HasProp(source, "Name") && utils.IsString(source.Name);
    }
    function HasModuleId(source) {
        return utils.HasProp(source, "ModuleId") && utils.IsString(source.ModuleId);
    }
    function Directive(registarName, definition) {
        if (!utils.IsString(registarName)) {
            definition = registarName;
            registarName = void (0);
        }
        if (!HasName(definition)) {
            definition = __assign({ Name: names.GetComponentNameFromModuleId(definition.ModuleId || "") }, definition);
        }
        return SelectDefinition.Deferred.Directive(definition, registarName);
    }
    exports.Directive = Directive;
    function Component(registarName, definition) {
        if (!utils.IsString(registarName)) {
            definition = registarName;
            registarName = void (0);
        }
        var RegistarName = registarName;
        return function (controller) {
            var completeDef;
            if (HasName(definition))
                completeDef = definition;
            else {
                if (HasModuleId(definition)) {
                    completeDef = __assign({ Name: names.GetComponentNameFromModuleId(definition.ModuleId) }, definition);
                }
                else if (HasName(controller)) {
                    completeDef = __assign({ Name: controller.Name }, definition);
                }
                else
                    throw new Error("Name could not be inferred for the component");
            }
            amd_name_utils_3.AssignName(controller, completeDef.Name);
            SelectDefinition.Deferred.Component(completeDef, controller, RegistarName);
        };
    }
    exports.Component = Component;
    function Template(templateName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, new Promise(function (resolve_1, reject_1) { require([names.TemplateModuleId(templateName)], resolve_1, reject_1); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    }
    exports.Template = Template;
    function MakePlaceholder(parent, name, bind, unbind, mode) {
        if (mode === void 0) { mode = TransclusionMode.Element; }
        Directive({
            Name: name,
            Priority: 100,
            MultiElement: true,
            Transclude: mode,
            Require: "^" + amd_name_utils_3.GetComponentName(parent),
            Template: null,
            OnLink: ["$controller", "$transclude", "$scope", function (parent, $transclude, $scope) {
                    rebind(parent);
                    var unwatch = $scope.$watch(function () { return parent; }, function ($new) { return rebind($new); });
                    $scope.$on("$destroy", function () { unwatch(); rebind(null); });
                    var lastBound;
                    var lastValue;
                    function rebind($new) {
                        if ($new === lastBound)
                            return;
                        if (lastBound)
                            unbind(lastBound, $transclude, lastValue);
                        lastValue = void (0);
                        if ($new)
                            lastValue = bind($new, $transclude);
                        lastBound = $new;
                    }
                }]
        });
    }
    exports.MakePlaceholder = MakePlaceholder;
    var LinkMode;
    (function (LinkMode) {
        LinkMode[LinkMode["Pre"] = 1] = "Pre";
        LinkMode[LinkMode["Post"] = 2] = "Post";
        LinkMode[LinkMode["PreAndPost"] = 3] = "PreAndPost";
    })(LinkMode = exports.LinkMode || (exports.LinkMode = {}));
    var LinkBinds = Symbol("OnLink");
    var LinkBind = (function () {
        function LinkBind(PropertyKey, LinkMode) {
            this.PropertyKey = PropertyKey;
            this.LinkMode = LinkMode;
        }
        LinkBind.Create = function (passMode, propertyKey, linkMode) {
            return passMode ? new LinkBindWithPassMode(propertyKey, linkMode) : new LinkBind(propertyKey, linkMode);
        };
        LinkBind.prototype.Copy = function (newTargetMode) {
            if (newTargetMode === void 0) { newTargetMode = this.LinkMode; }
            return new LinkBind(this.PropertyKey, newTargetMode);
        };
        LinkBind.prototype.Invoke = function (target, currentLinkMode) {
            return target[this.PropertyKey]();
        };
        return LinkBind;
    }());
    var LinkBindWithPassMode = (function (_super) {
        __extends(LinkBindWithPassMode, _super);
        function LinkBindWithPassMode(propertyKey, linkMode) {
            return _super.call(this, propertyKey, linkMode) || this;
        }
        LinkBindWithPassMode.prototype.Copy = function (newTargetMode) {
            if (newTargetMode === void 0) { newTargetMode = this.LinkMode; }
            return new LinkBindWithPassMode(this.PropertyKey, newTargetMode);
        };
        LinkBindWithPassMode.prototype.Invoke = function (target, currentLinkMode) {
            return target[this.PropertyKey](currentLinkMode);
        };
        return LinkBindWithPassMode;
    }(LinkBind));
    function InvokeLinkBinds(targetMode, target) {
        if (!utils.IsObject(target))
            return;
        var linkBinds = target[LinkBinds];
        if (!utils.IsArray(linkBinds))
            return;
        try {
            for (var linkBinds_1 = __values(linkBinds), linkBinds_1_1 = linkBinds_1.next(); !linkBinds_1_1.done; linkBinds_1_1 = linkBinds_1.next()) {
                var bind = linkBinds_1_1.value;
                if (!utils.HasFlag(bind.LinkMode, targetMode))
                    continue;
                bind.Invoke(target, targetMode);
            }
        }
        catch (e_37_1) { e_37 = { error: e_37_1 }; }
        finally {
            try {
                if (linkBinds_1_1 && !linkBinds_1_1.done && (_a = linkBinds_1.return)) _a.call(linkBinds_1);
            }
            finally { if (e_37) throw e_37.error; }
        }
        var e_37, _a;
    }
    function BindOnLink(target, propertyKey, descriptor, targetMode, passMode) {
        if (targetMode === void 0) { targetMode = LinkMode.Post; }
        var linkBinds;
        if (utils.HasProp(target, LinkBinds))
            linkBinds = target[LinkBinds];
        else {
            var parentValue = target[LinkBinds];
            if (!parentValue)
                linkBinds = [];
            else
                linkBinds = linkBinds.slice();
            target[LinkBinds] = linkBinds;
        }
        utils.Collection.AddOrUpdate(linkBinds, function (b) { return b.PropertyKey === propertyKey; }, function () { return LinkBind.Create(passMode, propertyKey, targetMode); }, function (b) { return b.Copy(b.LinkMode | targetMode); });
    }
    function OnLink(targetMode) {
        if (targetMode === void 0) { targetMode = LinkMode.Post; }
        return function (target, propertyKey, descriptor) { return BindOnLink(target, propertyKey, descriptor, targetMode, false); };
    }
    exports.OnLink = OnLink;
    (function (OnLink) {
        function PreAndPost() {
            return function (target, propertyKey, descriptor) { return BindOnLink(target, propertyKey, descriptor, LinkMode.Pre | LinkMode.Post, true); };
        }
        OnLink.PreAndPost = PreAndPost;
    })(OnLink = exports.OnLink || (exports.OnLink = {}));
    var ControllerBaseFields;
    (function (ControllerBaseFields) {
        var Key = Symbol("ControllerBaseFields");
        function Set(target, fields) {
            target[Key] = fields;
        }
        ControllerBaseFields.Set = Set;
        function Get(target) {
            var fields = ControllerBaseFields.TryGet(target);
            if (!fields)
                throw new Error("ControllerBaseFields have no been set on the target.");
            return fields;
        }
        ControllerBaseFields.Get = Get;
        function TryGet(target) {
            if (!utils.HasProp(target, Key))
                return null;
            return target[Key];
        }
        ControllerBaseFields.TryGet = TryGet;
    })(ControllerBaseFields || (ControllerBaseFields = {}));
    var ControllerBaseInitialiser;
    (function (ControllerBaseInitialiser) {
        var Key = Symbol("ControllerBaseInitialiser");
        function Set(target, initialiser) {
            target[Key] = initialiser;
        }
        ControllerBaseInitialiser.Set = Set;
        function TryGet(target) {
            if (!utils.HasProp(target, Key))
                return null;
            return target[Key];
        }
        ControllerBaseInitialiser.TryGet = TryGet;
        function TryExecute(target, fields) {
            var inititialise = ControllerBaseInitialiser.TryGet(target);
            if (utils.IsVoid(inititialise))
                return false;
            inititialise(target, fields.Scope, fields.Element, fields.Transclude, fields.Attributes);
            return true;
        }
        ControllerBaseInitialiser.TryExecute = TryExecute;
    })(ControllerBaseInitialiser || (ControllerBaseInitialiser = {}));
    var ControllerBase = (function () {
        function ControllerBase(source) {
            var fields = (source instanceof ControllerBase && ControllerBaseFields.TryGet(source)) || source || ControllerBaseFields.TryGet(this);
            if (utils.IsVoid(fields))
                return;
            this.Scope = fields.Scope;
            this.Watch = fields.Watch;
            this.Attributes = fields.Attributes;
            this.Element = fields.Element;
            if (this instanceof Controller)
                return;
            ControllerBaseInitialiser.TryExecute(this, fields);
        }
        ControllerBase.prototype.OnDispose = function (handler) {
            var Scope = ControllerBaseFields.Get(this).Scope;
            return Scope.$on("$destroy", handler);
        };
        return ControllerBase;
    }());
    exports.ControllerBase = ControllerBase;
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller(source) {
            var _this = _super.call(this, source) || this;
            var fields = (source instanceof ControllerBase && ControllerBaseFields.TryGet(source)) || source || ControllerBaseFields.TryGet(_this);
            if (utils.IsVoid(fields))
                return _this;
            _this.Transclude = fields.Transclude;
            _this.OnDispose(function () { return _this.Dispose(); });
            ControllerBaseInitialiser.TryExecute(_this, fields);
            return _this;
        }
        Controller.prototype.Dispose = function () { };
        return Controller;
    }(ControllerBase));
    exports.Controller = Controller;
    (function (Directive) {
        function DefineInModule(module, definition) {
            if (!HasName(definition)) {
                definition = __assign({ Name: names.GetComponentNameFromModuleId(definition.ModuleId || "") }, definition);
            }
            var ngDirective = SelectDefinition.Immediate.Directive(definition);
            module.directive(ngDirective.Name, ngDirective.NgDefinition);
        }
        Directive.DefineInModule = DefineInModule;
    })(Directive = exports.Directive || (exports.Directive = {}));
    (function (Component) {
        function DefineInModule(module, definition) {
            return function (controller) {
                if (!HasName(definition)) {
                    definition = __assign({ Name: names.GetComponentNameFromModuleId(definition.ModuleId || "") }, definition);
                }
                amd_name_utils_3.AssignName(controller, definition.Name);
                var ngComponent = SelectDefinition.Immediate.Component(definition, controller);
                module.directive(ngComponent.Name, ngComponent.NgDefinition);
            };
        }
        Component.DefineInModule = DefineInModule;
    })(Component = exports.Component || (exports.Component = {}));
    function EnsureNoLegacyFallback(name) {
        return directives.MarkAsInUse(name);
    }
    exports.EnsureNoLegacyFallback = EnsureNoLegacyFallback;
});
define("app/permission-utils", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function ValidatePermissions(permissions) {
        return Object.freeze(Global.Selcomm.Utils.MakeKeyedCollection(permissions, function (x) { return Object.freeze(x); }));
    }
    exports.ValidatePermissions = ValidatePermissions;
});
define("app/permissions", ["require", "exports", "app/permission-utils"], function (require, exports, permission_utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Permissions = permission_utils_1.ValidatePermissions({
        View_Services: [1000, 5],
        View_Events: [1000, 3]
    });
});
define("app/ng-utils", ["require", "exports", "$q", "$window", "$document", "$timeout", "$interval", "$compile", "$parse", "$anchorScroll", "$animate", "$exceptionHandler", "$interpolate", "$location", "$log", "$injector", "$http", "$httpBackend", "$filter", "$rootScope", "$mdUtil", "$mdDialog", "$mdMedia", "$mdToast", "$mdSidenav", "$mdTheming", "$cookies"], function (require, exports, $q, $window, $document, $timeout, $interval, $compile, $parse, $anchorScroll, $animate, $exceptionHandler, $interpolate, $location, $log, $injector, $http, $httpBackend, $filter, $rootScope, $mdUtil, $mdDialog, $mdMedia, $mdToast, $mdSidenav, $mdTheming, $cookies) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.$q = $q;
    exports.$window = $window;
    exports.$document = $document;
    exports.$timeout = $timeout;
    exports.$interval = $interval;
    exports.$compile = $compile;
    exports.$parse = $parse;
    exports.$anchorScroll = $anchorScroll;
    exports.$animate = $animate;
    exports.$exceptionHandler = $exceptionHandler;
    exports.$interpolate = $interpolate;
    exports.$location = $location;
    exports.$log = $log;
    exports.$injector = $injector;
    exports.$http = $http;
    exports.$httpBackend = $httpBackend;
    exports.$filter = $filter;
    exports.$rootScope = $rootScope;
    exports.$mdUtil = $mdUtil;
    exports.$mdDialog = $mdDialog;
    exports.$mdMedia = $mdMedia;
    exports.$mdToast = $mdToast;
    exports.$mdSidenav = $mdSidenav;
    exports.$mdTheming = $mdTheming;
    exports.$cookies = $cookies;
});
define("app/sss/sites", ["require", "exports", "app/basic-utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Site = (function () {
        function Site(nameOrISite, mode, displayName, hash) {
            if (utils.IsString(nameOrISite)) {
                this.Name = nameOrISite;
                this.Mode = mode;
                this.DisplayName = displayName;
                this.Hash = hash;
            }
            else if (nameOrISite) {
                this.Name = nameOrISite.Name || nameOrISite.name;
                this.Mode = nameOrISite.Mode || nameOrISite.mode;
                this.DisplayName = nameOrISite.DisplayName || nameOrISite.displayName;
                this.Hash = nameOrISite.Hash;
            }
            Object.freeze(this);
        }
        Site.AreEqual = function (x, y) {
            return utils.AreEqualHelper(x, y, function (x, y) { return x.Name === y.Name && x.Mode === y.Mode && x.DisplayName === y.DisplayName; });
        };
        Object.defineProperty(Site.prototype, "name", {
            get: function () {
                return this.Name;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Site.prototype, "mode", {
            get: function () {
                return this.Mode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Site.prototype, "displayName", {
            get: function () {
                return this.DisplayName;
            },
            enumerable: true,
            configurable: true
        });
        Site.prototype.toString = function () {
            return this.Name;
        };
        Site.SpecifiedOrDefault = function (specified, defaultSite) {
            if (defaultSite === void 0) { defaultSite = Site.DefaultDefaultSite; }
            var outSite;
            if (!specified || !utils.IsObject(specified))
                specified = {};
            if (specified instanceof Site)
                outSite = specified;
            else {
                var name_3 = specified.Name || specified.name || defaultSite.Name;
                var mode = specified.Mode || specified.mode || defaultSite.Mode;
                var displayName = specified.DisplayName || specified.displayName || defaultSite.DisplayName;
                var hash = specified.Hash || (name_3 === defaultSite.Name ? defaultSite.Hash : "");
                outSite = new Site(name_3, mode, displayName, hash);
            }
            return outSite;
        };
        Site.NameFor = function (siteOrSiteName) {
            if (utils.IsString(siteOrSiteName))
                return siteOrSiteName;
            var asSite;
            if (siteOrSiteName instanceof Site)
                asSite = siteOrSiteName;
            else
                asSite = Site.SpecifiedOrDefault(siteOrSiteName, this.Default);
            return asSite.Name;
        };
        Object.defineProperty(Site, "Current", {
            get: function () {
                return this.currentSite || this.Default;
            },
            set: function (newSite) {
                this.currentSite = Site.SpecifiedOrDefault(newSite, this.Default);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Site, "Default", {
            get: function () {
                return this.defaultSite || Site.DefaultDefaultSite;
            },
            set: function (newDefaultSite) {
                this.defaultSite = Site.SpecifiedOrDefault(newDefaultSite, Site.DefaultDefaultSite);
            },
            enumerable: true,
            configurable: true
        });
        return Site;
    }());
    exports.Site = Site;
    (function (Site) {
        var Mode;
        (function (Mode) {
            Mode["Default"] = "Default";
            Mode["TelcoDemo"] = "TelcoDemo";
            Mode["EnergyDemo"] = "EnergyDemo";
            Mode["CloudDemo"] = "CloudDemo";
            Mode["IotDemo"] = "IotDemo";
            Mode["BusinessAnalysisDemo"] = "BusinessAnalysisDemo";
        })(Mode = Site.Mode || (Site.Mode = {}));
        Site.DefaultDefaultSite = new Site("demo", Site.Mode.Default, "", "0de1d3662faa75febb600c9ef2eaa479235da6354c1e4c1a139360c17686b195");
    })(Site = exports.Site || (exports.Site = {}));
    exports.Site = Site;
    var SiteServiceWrapper = (function () {
        function SiteServiceWrapper(Underlying) {
            this.Underlying = Underlying;
        }
        SiteServiceWrapper.prototype.NameFor = function (siteOrSiteName) {
            return this.Underlying.NameFor(siteOrSiteName);
        };
        Object.defineProperty(SiteServiceWrapper.prototype, "Current", {
            get: function () {
                return this.Underlying.Current;
            },
            set: function (value) {
                this.Underlying.Current = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SiteServiceWrapper.prototype, "Default", {
            get: function () {
                return this.Underlying.Default;
            },
            set: function (value) {
                this.Underlying.Default = value;
            },
            enumerable: true,
            configurable: true
        });
        return SiteServiceWrapper;
    }());
    var LegacyJsSiteServiceWrapper = (function (_super) {
        __extends(LegacyJsSiteServiceWrapper, _super);
        function LegacyJsSiteServiceWrapper(underlying) {
            return _super.call(this, underlying) || this;
        }
        LegacyJsSiteServiceWrapper.prototype.nameFor = function (siteOrSiteName) {
            return this.NameFor(siteOrSiteName);
        };
        Object.defineProperty(LegacyJsSiteServiceWrapper.prototype, "current", {
            get: function () {
                return this.Current;
            },
            set: function (value) {
                this.Current = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LegacyJsSiteServiceWrapper.prototype, "default", {
            get: function () {
                return this.Default;
            },
            set: function (value) {
                this.Default = value;
            },
            enumerable: true,
            configurable: true
        });
        return LegacyJsSiteServiceWrapper;
    }(SiteServiceWrapper));
    exports.Service = new LegacyJsSiteServiceWrapper(Site);
    exports.default = Site;
});
define("scripts/lib/select-development/sss-paths", ["require", "exports", "app/basic-utils", "sss-config", "core-js"], function (require, exports, utils, config) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ServerAppRoot = config && config.ServerRoot || "";
    exports.BaseHref = config && config.BaseHref || "";
    exports.DefaultDirectorySeparator = "/";
    exports.DirectorySeparators = Object.freeze([exports.DefaultDirectorySeparator, "\\"]);
    exports.LeadingDirectorySeparator = utils.Regex(templateObject_7 || (templateObject_7 = __makeTemplateObject(["^[", "]"], ["^[", "]"])), exports.DirectorySeparators);
    exports.TrailingDirectorySeparator = utils.Regex(templateObject_8 || (templateObject_8 = __makeTemplateObject(["[", "]$"], ["[", "]$"])), exports.DirectorySeparators);
    function HasLeadingDirectorySeparator(path) {
        return exports.LeadingDirectorySeparator.test(path);
    }
    exports.HasLeadingDirectorySeparator = HasLeadingDirectorySeparator;
    function HasTrailingDirectorySeparator(path) {
        return exports.TrailingDirectorySeparator.test(path);
    }
    exports.HasTrailingDirectorySeparator = HasTrailingDirectorySeparator;
    function Combine(isRootFnOrFirstPath) {
        var paths = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            paths[_i - 1] = arguments[_i];
        }
        var isRoot = HasLeadingDirectorySeparator;
        if (arguments.length > 0) {
            if (utils.IsFunction(isRootFnOrFirstPath))
                isRoot = isRootFnOrFirstPath;
            else
                paths.unshift(isRootFnOrFirstPath);
        }
        paths = paths.filter(function (p) { return !!p; });
        {
            var start = 0;
            for (var i = 0; i < paths.length; i++) {
                if (isRoot(paths[i]))
                    start = i;
            }
            paths = paths.slice(start);
        }
        var combined = "";
        for (var i = 0; i < paths.length; i++) {
            var part = paths[i];
            combined += part;
            if (i < paths.length - 1 && !HasTrailingDirectorySeparator(part))
                combined += exports.DefaultDirectorySeparator;
        }
        return combined;
    }
    exports.Combine = Combine;
    function StripLeadingSlashes(path) {
        return path.replace(/^[\\\/]+/, "");
    }
    exports.StripLeadingSlashes = StripLeadingSlashes;
    function _decodeUriComponent(component) {
        if (!utils.IsSpecified(component))
            return "";
        return decodeURIComponent(component.replace(/\+/g, " "));
    }
    exports.PathToServerRoot = StripLeadingSlashes(exports.BaseHref.replace(utils.Regex("g")(templateObject_9 || (templateObject_9 = __makeTemplateObject(["[^", "]+"], ["[^", "]+"])), exports.DirectorySeparators), ".."));
    exports.PathToServerApplicationRoot = Combine(exports.PathToServerRoot, StripLeadingSlashes(exports.ServerAppRoot));
    function ParseQueryString(url) {
        var queryStringStart = url.indexOf("?");
        var queryString = queryStringStart >= 0 ? url.substr(queryStringStart) : "";
        var queryStringParts = queryString.split("&");
        var queryStringObject = {};
        try {
            for (var queryStringParts_1 = __values(queryStringParts), queryStringParts_1_1 = queryStringParts_1.next(); !queryStringParts_1_1.done; queryStringParts_1_1 = queryStringParts_1.next()) {
                var part = queryStringParts_1_1.value;
                var _a = __read(part.split("=", 2), 2), rawKey = _a[0], rawValue = _a[1];
                var key = _decodeUriComponent(rawKey);
                var value = _decodeUriComponent(rawValue);
                queryStringObject[key] = value;
            }
        }
        catch (e_38_1) { e_38 = { error: e_38_1 }; }
        finally {
            try {
                if (queryStringParts_1_1 && !queryStringParts_1_1.done && (_b = queryStringParts_1.return)) _b.call(queryStringParts_1);
            }
            finally { if (e_38) throw e_38.error; }
        }
        return queryStringObject;
        var e_38, _b;
    }
    exports.ParseQueryString = ParseQueryString;
    function ServerPath() {
        var paths = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            paths[_i] = arguments[_i];
        }
        var uri = new UriBuilder(Origin());
        uri.Fragment = null;
        uri.Query = null;
        uri.Path = Combine(StripLeadingSlashes(exports.ServerAppRoot), StripLeadingSlashes(Combine.apply(void 0, __spread(paths))));
        return uri.toString();
    }
    exports.ServerPath = ServerPath;
    function QualifyUrl(url) {
        var a = document.createElement("a");
        a.href = url;
        return a.href;
    }
    exports.QualifyUrl = QualifyUrl;
    function ToAbsolute(url, location) {
        url = QualifyUrl(url || "");
        var origin = Origin(location);
        if (url.indexOf(origin) === 0) {
            return url.substr(origin.length);
        }
        else {
            return url;
        }
    }
    exports.ToAbsolute = ToAbsolute;
    function Origin(location) {
        if (location === void 0) { location = window.location; }
        return location.origin || (location.protocol + "//" + location.hostname + (location.port && (":" + location.port)));
    }
    exports.Origin = Origin;
    function IsDirectorySeparator(str) {
        return exports.DirectorySeparators.indexOf(str) >= 0;
    }
    exports.IsDirectorySeparator = IsDirectorySeparator;
    var ParseExtendedRootResult = (function () {
        function ParseExtendedRootResult(formatter, root, subPath) {
            this.formatter = formatter;
            this.Root = root;
            this.SubPath = subPath;
        }
        Object.defineProperty(ParseExtendedRootResult.prototype, "Root", {
            get: function () {
                return this.root;
            },
            set: function (value) {
                if (IsDirectorySeparator(value))
                    value = "/";
                this.root = (utils.IsSpecified(value) && (IsDirectorySeparator(value) ? value : value.replace(exports.TrailingDirectorySeparator, ""))) || null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParseExtendedRootResult.prototype, "IsRooted", {
            get: function () {
                return !!this.Root;
            },
            enumerable: true,
            configurable: true
        });
        ParseExtendedRootResult.prototype.toString = function () {
            var subPath = StripLeadingSlashes(this.SubPath);
            if (!this.IsRooted)
                return subPath;
            else
                return this.formatter(this.Root, subPath);
        };
        return ParseExtendedRootResult;
    }());
    var RootParser = (function () {
        function RootParser(rootFormatters) {
            this.rootFormatters = Object.assign({}, rootFormatters);
            var allRootTypes = new RegExp("(?:" + Object.keys(this.rootFormatters).filter(function (p) { return !IsDirectorySeparator(p); }).sort(function (a, b) { return b.length - a.length; }).map(utils.RegexEscape).join("|") + ")");
            this.extendedRootRegex = utils.Regex(templateObject_10 || (templateObject_10 = __makeTemplateObject(["^([", "]|", "(?:$|[", "]))"], ["^([", "]|", "(?:$|[", "]))"])), exports.DirectorySeparators, allRootTypes, exports.DirectorySeparators);
            this.parseExtendedRootRegex = utils.Regex(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", "?(.*)$"], ["", "?(.*)$"])), this.extendedRootRegex);
        }
        RootParser.prototype.formatRoot = function (rootType, subPath) {
            if (!utils.HasProp(this.rootFormatters, rootType))
                throw new Error("Unknown root type " + rootType);
            var result = this.rootFormatters[rootType](subPath);
            if (utils.IsArray(result))
                return Combine.apply(void 0, __spread(result));
            else
                return result;
        };
        RootParser.prototype.Parse = function (path) {
            var _this = this;
            var _a = __read(this.parseExtendedRootRegex.exec(path), 3), root = _a[1], subPath = _a[2];
            return new ParseExtendedRootResult(function (rootType, subPath) { return _this.formatRoot(rootType, subPath); }, root, subPath);
        };
        RootParser.prototype.Format = function (path) {
            return this.Parse(path).toString();
        };
        RootParser.prototype.IsRoot = function (path) {
            return this.extendedRootRegex.test(path);
        };
        RootParser = __decorate([
            utils.BindFunctions
        ], RootParser);
        return RootParser;
    }());
    exports.RootParser = RootParser;
    var UriBuilder = (function () {
        function UriBuilder(uriOrSource) {
            if (utils.IsVoid(uriOrSource) || utils.IsString(uriOrSource) && utils.IsWhitespace.String(uriOrSource)) {
                this.Scheme = "";
                this.Authority = "";
                this.Path = "";
                this.Query = "";
                this.Fragment = "";
            }
            else if (utils.IsString(uriOrSource)) {
                var uri = uriOrSource;
                var _a = __read(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/.exec(uri), 10), scheme = _a[2], authority = _a[4], path = _a[5], query = _a[7], fragment = _a[9];
                this.Scheme = scheme;
                this.Authority = authority;
                this.Path = path;
                this.Query = query;
                this.Fragment = fragment;
            }
            else {
                var source = uriOrSource;
                this.Scheme = source.Scheme || "";
                this.Authority = source.Authority || "";
                this.Path = source.Path || "";
                this.Query = (!utils.IsObjectLike(source.Query) ? source.Query : QueryPart.Format(source.Query)) || "";
                this.Fragment = source.Fragment || "";
            }
        }
        Object.defineProperty(UriBuilder.prototype, "Scheme", {
            get: function () { return this.scheme || ""; },
            set: function (value) { this.scheme = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "HasScheme", {
            get: function () { return !!this.scheme; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "Authority", {
            get: function () { return this.authority || ""; },
            set: function (value) { this.authority = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "HasAuthority", {
            get: function () { return !!this.authority; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "Path", {
            get: function () { return this.path || ""; },
            set: function (value) { this.path = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "HasPath", {
            get: function () { return !!this.path; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "Query", {
            get: function () { return this.query || ""; },
            set: function (value) { this.query = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "HasQuery", {
            get: function () { return !!this.query; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "QueryParts", {
            get: function () {
                return Object.freeze(utils.Collection.GetArray(QueryPart.Parse(this.Query)).map(function (qp) { return Object.freeze(qp); }));
            },
            set: function (value) {
                this.query = QueryPart.Format(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "Fragment", {
            get: function () { return this.fragment || ""; },
            set: function (value) { this.fragment = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "HasFragment", {
            get: function () { return !!this.fragment; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "IsValid", {
            get: function () {
                return this.HasScheme === this.HasAuthority;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UriBuilder.prototype, "IsAbsolute", {
            get: function () {
                return this.HasScheme || this.HasAuthority;
            },
            enumerable: true,
            configurable: true
        });
        UriBuilder.prototype.toString = function () {
            var uri = "";
            if (this.HasScheme) {
                uri += this.Scheme + ":";
                if (this.HasAuthority)
                    uri += "//";
            }
            if (this.HasAuthority) {
                uri += this.Authority;
                if (this.HasPath && !HasLeadingDirectorySeparator(this.Path) && !HasTrailingDirectorySeparator(uri))
                    uri += exports.DefaultDirectorySeparator;
            }
            if (this.HasPath)
                uri += this.Path;
            if (this.HasQuery) {
                if (!this.Query.startsWith("?"))
                    uri += "?";
                uri += this.Query;
            }
            if (this.HasFragment)
                uri += "#" + this.Fragment;
            return uri;
        };
        return UriBuilder;
    }());
    exports.UriBuilder = UriBuilder;
    var QueryPart = (function () {
        function QueryPart(Key, Value) {
            this.Key = Key;
            this.Value = Value;
        }
        QueryPart.Parse = function (query) {
            var _a, _b, part, e_39_1, _c, _d, part, _e, rawKey, rawValue, e_40_1, e_39, _f, e_40, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!utils.IsVoid(query)) return [3, 1];
                        return [3, 17];
                    case 1:
                        if (!!utils.IsString(query)) return [3, 10];
                        _h.label = 2;
                    case 2:
                        _h.trys.push([2, 7, 8, 9]);
                        _a = __values(Object.entries(query)), _b = _a.next();
                        _h.label = 3;
                    case 3:
                        if (!!_b.done) return [3, 6];
                        part = _b.value;
                        return [4, new QueryPart(part[0], part[1])];
                    case 4:
                        _h.sent();
                        _h.label = 5;
                    case 5:
                        _b = _a.next();
                        return [3, 3];
                    case 6: return [3, 9];
                    case 7:
                        e_39_1 = _h.sent();
                        e_39 = { error: e_39_1 };
                        return [3, 9];
                    case 8:
                        try {
                            if (_b && !_b.done && (_f = _a.return)) _f.call(_a);
                        }
                        finally { if (e_39) throw e_39.error; }
                        return [7];
                    case 9: return [3, 17];
                    case 10:
                        _h.trys.push([10, 15, 16, 17]);
                        _c = __values((query || "").split("&")), _d = _c.next();
                        _h.label = 11;
                    case 11:
                        if (!!_d.done) return [3, 14];
                        part = _d.value;
                        _e = __read(part.split("="), 2), rawKey = _e[0], rawValue = _e[1];
                        return [4, new QueryPart(decodeURIComponent(rawKey), decodeURIComponent(rawValue))];
                    case 12:
                        _h.sent();
                        _h.label = 13;
                    case 13:
                        _d = _c.next();
                        return [3, 11];
                    case 14: return [3, 17];
                    case 15:
                        e_40_1 = _h.sent();
                        e_40 = { error: e_40_1 };
                        return [3, 17];
                    case 16:
                        try {
                            if (_d && !_d.done && (_g = _c.return)) _g.call(_c);
                        }
                        finally { if (e_40) throw e_40.error; }
                        return [7];
                    case 17: return [2];
                }
            });
        };
        QueryPart.Format = function (parts) {
            return utils.Collection.GetArray(parts || [])
                .map(function (p) { return p.Format(); })
                .join("&");
        };
        QueryPart.prototype.Format = function () {
            return encodeURIComponent(this.Key) + "=" + encodeURIComponent(this.Value);
        };
        return QueryPart;
    }());
    exports.QueryPart = QueryPart;
    function MapPath(rootParser, uriOrBuilder, currentPath) {
        var builder;
        if (utils.IsString(uriOrBuilder)) {
            var uri = uriOrBuilder;
            builder = new UriBuilder(uri);
            if (builder.IsAbsolute)
                return builder.toString();
        }
        else if (uriOrBuilder instanceof UriBuilder) {
            builder = uriOrBuilder;
            if (builder.IsAbsolute)
                return builder.toString();
            builder = new UriBuilder(builder);
        }
        else {
            builder = new UriBuilder(uriOrBuilder);
            if (builder.IsAbsolute)
                return builder.toString();
        }
        builder.Path = rootParser.Format(Combine(function (path) { return rootParser.IsRoot(path); }, currentPath, builder.Path));
        return builder.toString();
    }
    exports.MapPath = MapPath;
    var templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
});
define("app/raw-path-utils", ["require", "exports", "app/sss/sites", "app/basic-utils", "scripts/lib/select-development/sss-paths"], function (require, exports, sites, utils, sssPaths) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var RootParsers;
    (function (RootParsers) {
        var Formatter;
        (function (Formatter) {
            var AtBase;
            (function (AtBase) {
                function serverRoot(subPath) {
                    return sssPaths.Combine(sssPaths.PathToServerRoot, subPath);
                }
                AtBase.serverRoot = serverRoot;
                function clientAppRoot(subPath) {
                    return subPath;
                }
                AtBase.clientAppRoot = clientAppRoot;
                function serverAppRoot() {
                    var subPaths = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        subPaths[_i] = arguments[_i];
                    }
                    return sssPaths.Combine.apply(sssPaths, __spread([sssPaths.PathToServerApplicationRoot], subPaths));
                }
                AtBase.serverAppRoot = serverAppRoot;
                function contentRoot() {
                    var subPaths = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        subPaths[_i] = arguments[_i];
                    }
                    return serverAppRoot.apply(void 0, __spread(["Content"], subPaths));
                }
                AtBase.contentRoot = contentRoot;
                function themeRoot() {
                    var subPaths = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        subPaths[_i] = arguments[_i];
                    }
                    return contentRoot.apply(void 0, __spread(["themes", utils.EncodeUriComponent(sites.Service.Current.Name)], subPaths));
                }
                AtBase.themeRoot = themeRoot;
            })(AtBase = Formatter.AtBase || (Formatter.AtBase = {}));
            var AtServerRoot;
            (function (AtServerRoot) {
                function serverRoot(subPath) {
                    return sssPaths.Combine("/", subPath);
                }
                AtServerRoot.serverRoot = serverRoot;
                function clientAppRoot(subPath) {
                    return sssPaths.Combine(sssPaths.BaseHref, subPath);
                }
                AtServerRoot.clientAppRoot = clientAppRoot;
                function serverAppRoot() {
                    var subPaths = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        subPaths[_i] = arguments[_i];
                    }
                    return sssPaths.Combine.apply(sssPaths, __spread([sssPaths.ServerAppRoot], subPaths));
                }
                AtServerRoot.serverAppRoot = serverAppRoot;
                function contentRoot() {
                    var subPaths = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        subPaths[_i] = arguments[_i];
                    }
                    return serverAppRoot.apply(void 0, __spread(["Content"], subPaths));
                }
                AtServerRoot.contentRoot = contentRoot;
                function themeRoot() {
                    var subPaths = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        subPaths[_i] = arguments[_i];
                    }
                    return contentRoot.apply(void 0, __spread(["themes", utils.EncodeUriComponent(sites.Service.Current.Name)], subPaths));
                }
                AtServerRoot.themeRoot = themeRoot;
            })(AtServerRoot = Formatter.AtServerRoot || (Formatter.AtServerRoot = {}));
        })(Formatter || (Formatter = {}));
        RootParsers.AtBase = new sssPaths.RootParser({
            "/": Formatter.AtBase.serverRoot,
            "!": Formatter.AtBase.clientAppRoot,
            "~": Formatter.AtBase.serverAppRoot,
            "!content": Formatter.AtBase.contentRoot,
            "!theme": Formatter.AtBase.themeRoot,
        });
        RootParsers.AtServerRoot = new sssPaths.RootParser({
            "/": Formatter.AtServerRoot.serverRoot,
            "!": Formatter.AtServerRoot.clientAppRoot,
            "~": Formatter.AtServerRoot.serverAppRoot,
            "!content": Formatter.AtServerRoot.contentRoot,
            "!theme": Formatter.AtServerRoot.themeRoot,
        });
    })(RootParsers = exports.RootParsers || (exports.RootParsers = {}));
    function MapPath(rootParser, locationServiceOrCurrentPath, uriOrBuilderOrLiterals, placeholders) {
        var currentPath;
        if (utils.IsString(locationServiceOrCurrentPath))
            currentPath = locationServiceOrCurrentPath;
        else {
            var $location = locationServiceOrCurrentPath;
            currentPath = $location.path();
        }
        var uriOrBuilder;
        if (utils.IsString(uriOrBuilderOrLiterals))
            uriOrBuilder = uriOrBuilderOrLiterals;
        else {
            if (utils.IsArray(uriOrBuilderOrLiterals))
                uriOrBuilder = utils.EncodeUri.apply(utils, __spread([uriOrBuilderOrLiterals], placeholders));
            else
                uriOrBuilder = uriOrBuilderOrLiterals;
        }
        return sssPaths.MapPath(rootParser, uriOrBuilder, sssPaths.StripLeadingSlashes(currentPath));
    }
    exports.MapPath = MapPath;
    function WatchedMapPath(rootParser, args) {
        var oldUri;
        var $watch = args.$watch, getCurrentPath = args.getCurrentPath, uriOrBuilder = args.uriOrBuilder, watchFn = args.watchFn;
        return $watch.Collection(function () { return ({
            SiteName: sites.Service.Current.Name,
            Path: getCurrentPath()
        }); }, function ($new, $old) {
            var Path = $new.Path;
            var newUri = sssPaths.MapPath(rootParser, uriOrBuilder, sssPaths.StripLeadingSlashes(Path));
            if ($new === $old)
                oldUri = newUri;
            if ($new === $old || newUri !== oldUri)
                watchFn(newUri);
        });
    }
    exports.WatchedMapPath = WatchedMapPath;
    function Combine(isRootFnOrFirstPath) {
        var paths = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            paths[_i - 1] = arguments[_i];
        }
        var isRoot = RootParsers.AtBase.IsRoot;
        if (arguments.length > 0) {
            if (utils.IsFunction(isRootFnOrFirstPath))
                isRoot = isRootFnOrFirstPath;
            else
                paths.unshift(isRootFnOrFirstPath);
        }
        return sssPaths.Combine.apply(sssPaths, __spread([isRoot], paths));
    }
    exports.Combine = Combine;
});
define("app/path-utils", ["require", "exports", "$location", "app/raw-path-utils", "scripts/lib/select-development/sss-paths", "app/raw-path-utils"], function (require, exports, $location, paths, sss_paths_1, raw_path_utils_1) {
    "use strict";
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    Object.defineProperty(exports, "__esModule", { value: true });
    __export(sss_paths_1);
    exports.Combine = raw_path_utils_1.Combine;
    function MapPath(uriOrLiterals) {
        var placeholders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            placeholders[_i - 1] = arguments[_i];
        }
        return paths.MapPath(paths.RootParsers.AtBase, $location, uriOrLiterals, placeholders);
    }
    exports.MapPath = MapPath;
    (function (MapPath) {
        function FromTrueRoot(uriOrLiterals) {
            var placeholders = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                placeholders[_i - 1] = arguments[_i];
            }
            return paths.MapPath(paths.RootParsers.AtServerRoot, $location, uriOrLiterals, placeholders);
        }
        MapPath.FromTrueRoot = FromTrueRoot;
    })(MapPath = exports.MapPath || (exports.MapPath = {}));
});
define("app/pre-angular-bootstrap-utils", ["require", "exports", "scripts/lib/select-development/sss-names", "app/basic-utils", "app/basic-utils", "app/amd-utils", "app/amd-utils", "app/amd-utils", "scripts/lib/select-development/sss-decorators"], function (require, exports, sss_names_1, basic_utils_1, utils, amd_utils_1, amdUtils, amd_utils_2, sss_decorators_1) {
    "use strict";
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CamelCase = sss_names_1.CamelCase;
    exports.SnakeCase = sss_names_1.ComponentNameSnakeCase;
    exports.GetComponentNameFromModuleId = sss_names_1.GetComponentNameFromModuleId;
    __export(basic_utils_1);
    __export(amd_utils_1);
    exports.EnsureNoLegacyFallback = amd_utils_2.EnsureNoLegacyFallback;
    exports.Bind = sss_decorators_1.Bind;
    exports.Inject = sss_decorators_1.Inject;
    function Directive(module, definition) {
        return amdUtils.Directive.DefineInModule(module, definition);
    }
    exports.Directive = Directive;
    function Component(module, definition) {
        return amdUtils.Component.DefineInModule(module, definition);
    }
    exports.Component = Component;
    var Form;
    (function (Form) {
        function IsSubmitted(formCtrl) {
            if (utils.IsVoid(formCtrl))
                return false;
            if (formCtrl.$submitted)
                return true;
            if (!formCtrl.$$parentForm || formCtrl === formCtrl.$$parentForm)
                return false;
            return IsSubmitted(formCtrl.$$parentForm);
        }
        Form.IsSubmitted = IsSubmitted;
    })(Form = exports.Form || (exports.Form = {}));
});
define("app/sdc/toast/content/template/sdc-toast-content-template", ["require", "exports", "app/utils", "$mdToast", "$compile"], function (require, exports, utils, $mdToast, $compile) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            var templateNodes = utils.IsString(_this.Options.Template) ? Controller_1.CompileHtml(_this.Options.Template) : _this.Options.Template;
            var link = $compile(templateNodes);
            link(_this.Scope.$new(), function (clone, scope) {
                _this.Element.append(clone);
                if (_this.Options.Link)
                    _this.Options.Link(clone, scope);
            }, {
                parentBoundTranscludeFn: _this.Options.Transclude,
            });
            return _this;
        }
        Controller_1 = Controller;
        Controller.CompileHtml = function (html) {
            return $(document.createElement(Controller_1.Name)).html(html).contents();
        };
        Controller.Name = "sdc-toast-content-template";
        Controller.DefaultLocals = {
            resolve: function () { $mdToast.hide("ok"); }
        };
        __decorate([
            utils.Bind.In("options")
        ], Controller.prototype, "Options", void 0);
        Controller = Controller_1 = __decorate([
            utils.Component({
                Name: Controller_1.Name,
                Terminal: true,
                Template: null,
            })
        ], Controller);
        return Controller;
        var Controller_1;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/selcomm/service-reference/selcomm-data-types", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
define("app/selcomm/service-reference/selcomm-types", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var System;
    (function (System) {
        var Exception = (function (_super) {
            __extends(Exception, _super);
            function Exception(args) {
                var _this = _super.call(this, args ? args.Message : void undefined) || this;
                _this.$type = System.ServiceModel.FaultException.Type;
                if (!args)
                    return _this;
                Object.setPrototypeOf(_this, System.Exception.prototype);
                _this.Message = args.Message;
                return _this;
            }
            Object.defineProperty(Exception.prototype, "Message", {
                get: function () {
                    return this.message;
                },
                set: function (value) {
                    this.message = value;
                },
                enumerable: true,
                configurable: true
            });
            Exception.Type = "System.Exception";
            Exception.TypeParameters = Object.freeze([]);
            return Exception;
        }(Error));
        System.Exception = Exception;
        var ServiceModel;
        (function (ServiceModel) {
            var FaultCode = (function () {
                function FaultCode(args) {
                    this.$type = System.ServiceModel.FaultReasonText.Type;
                    if (!args)
                        return;
                    this.IsPredefinedFault = args.IsPredefinedFault;
                    this.IsReceiverFault = args.IsReceiverFault;
                    this.IsSenderFault = args.IsSenderFault;
                    this.Name = args.Name;
                    this.Namespace = args.Namespace;
                    this.SubCode = args.SubCode;
                }
                FaultCode.Type = "System.ServiceModel.FaultCode";
                FaultCode.TypeParameters = Object.freeze([]);
                return FaultCode;
            }());
            ServiceModel.FaultCode = FaultCode;
            var FaultReason = (function () {
                function FaultReason(args) {
                    this.$type = System.ServiceModel.FaultReasonText.Type;
                    if (!args)
                        return;
                    this.Translations = args.Translations;
                }
                FaultReason.Type = "System.ServiceModel.FaultReason";
                FaultReason.TypeParameters = Object.freeze([]);
                return FaultReason;
            }());
            ServiceModel.FaultReason = FaultReason;
            var FaultReasonText = (function () {
                function FaultReasonText(args) {
                    this.$type = System.ServiceModel.FaultReasonText.Type;
                    if (!args)
                        return;
                    this.Text = args.Text;
                    this.XmlLang = args.XmlLang;
                }
                FaultReasonText.Type = "System.ServiceModel.FaultReasonText";
                FaultReasonText.TypeParameters = Object.freeze([]);
                return FaultReasonText;
            }());
            ServiceModel.FaultReasonText = FaultReasonText;
            var FaultException = (function (_super) {
                __extends(FaultException, _super);
                function FaultException(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = System.ServiceModel.FaultException.Type;
                    if (!args)
                        return _this;
                    Object.setPrototypeOf(_this, FaultException.prototype);
                    _this.Code = args.Code;
                    _this.Detail = args.Detail;
                    _this.Reason = args.Reason;
                    if ("Detail" in args)
                        _this.Detail = args.Detail;
                    return _this;
                }
                FaultException.Type = "System.ServiceModel.FaultException";
                FaultException.TypeParameters = Object.freeze(["TDetail"]);
                return FaultException;
            }(System.Exception));
            ServiceModel.FaultException = FaultException;
        })(ServiceModel = System.ServiceModel || (System.ServiceModel = {}));
    })(System = exports.System || (exports.System = {}));
    var Selcomm;
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var DataObject = (function () {
                function DataObject(args) {
                    this.$type = Selcomm.Objects.DataObject.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Created = args.Created;
                    this.CreatedBy = args.CreatedBy;
                    this.LastUpdated = args.LastUpdated;
                    this.UpdatedBy = args.UpdatedBy;
                    this.RestrictedPropertiesNames = args.RestrictedPropertiesNames;
                }
                DataObject.Type = "Selcomm.Objects.DataObject";
                DataObject.TypeParameters = [];
                return DataObject;
            }());
            Objects.DataObject = DataObject;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var AddressType = (function (_super) {
                __extends(AddressType, _super);
                function AddressType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.AddressType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.ContactRelated = args.ContactRelated;
                    _this.ServiceRelated = args.ServiceRelated;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.AddressUsageList = args.AddressUsageList;
                    return _this;
                }
                AddressType.Type = "Selcomm.Address.AddressType";
                AddressType.TypeParameters = [];
                return AddressType;
            }(Selcomm.Objects.DataObject));
            Address.AddressType = AddressType;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var AddressUsage = (function (_super) {
                __extends(AddressUsage, _super);
                function AddressUsage(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.AddressUsage.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ContactCode = args.ContactCode;
                    _this.AddressTypeCode = args.AddressTypeCode;
                    _this.StartDate = args.StartDate;
                    _this.AddressRef = args.AddressRef;
                    _this.AddressType = args.AddressType;
                    return _this;
                }
                AddressUsage.Type = "Selcomm.Address.AddressUsage";
                AddressUsage.TypeParameters = [];
                return AddressUsage;
            }(Selcomm.Objects.DataObject));
            Address.AddressUsage = AddressUsage;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var ExtendedDataList = (function () {
                function ExtendedDataList(args, $type) {
                    if (!args) {
                        return;
                    }
                    ;
                    this.TotalFilteredRecords = args.TotalFilteredRecords;
                    this.TotalUnfilteredRecords = args.TotalUnfilteredRecords;
                    this.Items = args.Items;
                    this.$type = $type;
                }
                ExtendedDataList.TypeWith = function (T) {
                    return Selcomm.Objects.ExtendedDataList.Type + "\u003c" + T + "\u003e";
                };
                ExtendedDataList.Type = "Selcomm.Objects.ExtendedDataList";
                ExtendedDataList.TypeParameters = ["T"];
                return ExtendedDataList;
            }());
            Objects.ExtendedDataList = ExtendedDataList;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var AddressUsageList = (function (_super) {
                __extends(AddressUsageList, _super);
                function AddressUsageList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.AddressUsageList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AddressUsageList.Type = "Selcomm.Address.AddressUsageList";
                AddressUsageList.TypeParameters = [];
                return AddressUsageList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.AddressUsageList = AddressUsageList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var AddressTypeList = (function (_super) {
                __extends(AddressTypeList, _super);
                function AddressTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.AddressTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AddressTypeList.Type = "Selcomm.Address.AddressTypeList";
                AddressTypeList.TypeParameters = [];
                return AddressTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.AddressTypeList = AddressTypeList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address_1) {
            var Address = (function (_super) {
                __extends(Address, _super);
                function Address(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.Address.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Address1 = args.Address1;
                    _this.Address2 = args.Address2;
                    _this.Suburb = args.Suburb;
                    _this.City = args.City;
                    _this.State = args.State;
                    _this.PostCode = args.PostCode;
                    _this.Country = args.Country;
                    _this.AddressType = args.AddressType;
                    _this.InValid = args.InValid;
                    return _this;
                }
                Address.Type = "Selcomm.Address.Address";
                Address.TypeParameters = [];
                return Address;
            }(Selcomm.Objects.DataObject));
            Address_1.Address = Address;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var State = (function (_super) {
                __extends(State, _super);
                function State(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.State.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.CountryCode = args.CountryCode;
                    return _this;
                }
                State.Type = "Selcomm.Address.State";
                State.TypeParameters = [];
                return State;
            }(Selcomm.Objects.DataObject));
            Address.State = State;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var PostCode = (function (_super) {
                __extends(PostCode, _super);
                function PostCode(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.PostCode.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Ref = args.Ref;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.StateCode = args.StateCode;
                    return _this;
                }
                PostCode.Type = "Selcomm.Address.PostCode";
                PostCode.TypeParameters = [];
                return PostCode;
            }(Selcomm.Objects.DataObject));
            Address.PostCode = PostCode;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var Country = (function (_super) {
                __extends(Country, _super);
                function Country(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.Country.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                Country.Type = "Selcomm.Address.Country";
                Country.TypeParameters = [];
                return Country;
            }(Selcomm.Objects.DataObject));
            Address.Country = Country;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var ExtendedAddress = (function (_super) {
                __extends(ExtendedAddress, _super);
                function ExtendedAddress(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.ExtendedAddress.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Ref = args.Ref;
                    _this.DPID = args.DPID;
                    _this.Company = args.Company;
                    _this.BuildingName = args.BuildingName;
                    _this.BuildingLocation = args.BuildingLocation;
                    _this.LevelNumber = args.LevelNumber;
                    _this.LevelNumberSuffix = args.LevelNumberSuffix;
                    _this.LevelType = args.LevelType;
                    _this.Locality = args.Locality;
                    _this.LotNumber = args.LotNumber;
                    _this.POBoxNumber = args.POBoxNumber;
                    _this.POBoxNumberPrefix = args.POBoxNumberPrefix;
                    _this.POBoxNumberSuffix = args.POBoxNumberSuffix;
                    _this.POBoxType = args.POBoxType;
                    _this.extendedPostCode = args.extendedPostCode;
                    _this.SortPlan = args.SortPlan;
                    _this.StateCode = args.StateCode;
                    _this.StreetName = args.StreetName;
                    _this.StreetNumber = args.StreetNumber;
                    _this.StreetNumberSuffix = args.StreetNumberSuffix;
                    _this.StreetNumber2 = args.StreetNumber2;
                    _this.StreetNumber2Suffix = args.StreetNumber2Suffix;
                    _this.StreetType = args.StreetType;
                    _this.StreetTypeSuffix = args.StreetTypeSuffix;
                    _this.UnitNumber = args.UnitNumber;
                    _this.UnitNumberSuffix = args.UnitNumberSuffix;
                    _this.UnitNumber2 = args.UnitNumber2;
                    _this.UnitNumber2Suffix = args.UnitNumber2Suffix;
                    _this.UnitType = args.UnitType;
                    _this.GroupDID = args.GroupDID;
                    _this.Barcode = args.Barcode;
                    _this.AlternativePostcode = args.AlternativePostcode;
                    _this.AlternativeLocality = args.AlternativeLocality;
                    _this.AlternativeStreetName = args.AlternativeStreetName;
                    _this.AlternativeStreetType = args.AlternativeStreetType;
                    _this.AlternativeStreetTypeSuffix = args.AlternativeStreetTypeSuffix;
                    _this.StreetName2 = args.StreetName2;
                    _this.StreetType2 = args.StreetType2;
                    _this.StreetType2Suffix = args.StreetType2Suffix;
                    _this.FindingName = args.FindingName;
                    _this.FindingName2 = args.FindingName2;
                    _this.FindingTitle = args.FindingTitle;
                    return _this;
                }
                ExtendedAddress.Type = "Selcomm.Address.ExtendedAddress";
                ExtendedAddress.TypeParameters = [];
                return ExtendedAddress;
            }(Selcomm.Address.Address));
            Address.ExtendedAddress = ExtendedAddress;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var AddressList = (function (_super) {
                __extends(AddressList, _super);
                function AddressList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.AddressList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AddressList.Type = "Selcomm.Address.AddressList";
                AddressList.TypeParameters = [];
                return AddressList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.AddressList = AddressList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var ExtendedAddressList = (function (_super) {
                __extends(ExtendedAddressList, _super);
                function ExtendedAddressList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.ExtendedAddressList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ExtendedAddressList.Type = "Selcomm.Address.ExtendedAddressList";
                ExtendedAddressList.TypeParameters = [];
                return ExtendedAddressList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.ExtendedAddressList = ExtendedAddressList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var UnitType = (function (_super) {
                __extends(UnitType, _super);
                function UnitType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.UnitType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                UnitType.Type = "Selcomm.Address.UnitType";
                UnitType.TypeParameters = [];
                return UnitType;
            }(Selcomm.Objects.DataObject));
            Address.UnitType = UnitType;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var UnitTypeList = (function (_super) {
                __extends(UnitTypeList, _super);
                function UnitTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.UnitTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                UnitTypeList.Type = "Selcomm.Address.UnitTypeList";
                UnitTypeList.TypeParameters = [];
                return UnitTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.UnitTypeList = UnitTypeList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var StreetType = (function (_super) {
                __extends(StreetType, _super);
                function StreetType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.StreetType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                StreetType.Type = "Selcomm.Address.StreetType";
                StreetType.TypeParameters = [];
                return StreetType;
            }(Selcomm.Objects.DataObject));
            Address.StreetType = StreetType;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var StreetTypeList = (function (_super) {
                __extends(StreetTypeList, _super);
                function StreetTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.StreetTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                StreetTypeList.Type = "Selcomm.Address.StreetTypeList";
                StreetTypeList.TypeParameters = [];
                return StreetTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.StreetTypeList = StreetTypeList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var Locality = (function (_super) {
                __extends(Locality, _super);
                function Locality(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.Locality.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Ref = args.Ref;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.StateCode = args.StateCode;
                    _this.SortIndex = args.SortIndex;
                    return _this;
                }
                Locality.Type = "Selcomm.Address.Locality";
                Locality.TypeParameters = [];
                return Locality;
            }(Selcomm.Objects.DataObject));
            Address.Locality = Locality;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var LocalityList = (function (_super) {
                __extends(LocalityList, _super);
                function LocalityList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.LocalityList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                LocalityList.Type = "Selcomm.Address.LocalityList";
                LocalityList.TypeParameters = [];
                return LocalityList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.LocalityList = LocalityList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var StateList = (function (_super) {
                __extends(StateList, _super);
                function StateList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.StateList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                StateList.Type = "Selcomm.Address.StateList";
                StateList.TypeParameters = [];
                return StateList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.StateList = StateList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var CountryList = (function (_super) {
                __extends(CountryList, _super);
                function CountryList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.CountryList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                CountryList.Type = "Selcomm.Address.CountryList";
                CountryList.TypeParameters = [];
                return CountryList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.CountryList = CountryList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var AddressSimple = (function () {
                function AddressSimple(args) {
                    this.$type = Selcomm.Address.AddressSimple.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Address = args.Address;
                }
                AddressSimple.Type = "Selcomm.Address.AddressSimple";
                AddressSimple.TypeParameters = [];
                return AddressSimple;
            }());
            Address.AddressSimple = AddressSimple;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var AddressSimpleList = (function (_super) {
                __extends(AddressSimpleList, _super);
                function AddressSimpleList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.AddressSimpleList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AddressSimpleList.Type = "Selcomm.Address.AddressSimpleList";
                AddressSimpleList.TypeParameters = [];
                return AddressSimpleList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.AddressSimpleList = AddressSimpleList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Alert;
        (function (Alert) {
            var SpendAlert = (function (_super) {
                __extends(SpendAlert, _super);
                function SpendAlert(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Alert.SpendAlert.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.ContactCode = args.ContactCode;
                    _this.ServiceRef = args.ServiceRef;
                    _this.AlertEnabled = args.AlertEnabled;
                    _this.SendSMS = args.SendSMS;
                    _this.SendEmail = args.SendEmail;
                    _this.Alert1Percentage = args.Alert1Percentage;
                    _this.Alert2Percentage = args.Alert2Percentage;
                    _this.Alert3Percentage = args.Alert3Percentage;
                    _this.Alert4Percentage = args.Alert4Percentage;
                    _this.Alert5Percentage = args.Alert5Percentage;
                    return _this;
                }
                SpendAlert.Type = "Selcomm.Alert.SpendAlert";
                SpendAlert.TypeParameters = [];
                return SpendAlert;
            }(Selcomm.Objects.DataObject));
            Alert.SpendAlert = SpendAlert;
        })(Alert = Selcomm.Alert || (Selcomm.Alert = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Attributes;
        (function (Attributes) {
            var Attribute = (function (_super) {
                __extends(Attribute, _super);
                function Attribute(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Attributes.Attribute.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Reference = args.Reference;
                    _this.AttributeTemplate = args.AttributeTemplate;
                    _this.Event = args.Event;
                    _this.Key = args.Key;
                    _this.Value = args.Value;
                    _this.Value2 = args.Value2;
                    _this.From = args.From;
                    _this.To = args.To;
                    return _this;
                }
                Attribute.Type = "Selcomm.Attributes.Attribute";
                Attribute.TypeParameters = [];
                return Attribute;
            }(Selcomm.Objects.DataObject));
            Attributes.Attribute = Attribute;
        })(Attributes = Selcomm.Attributes || (Selcomm.Attributes = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Attributes;
        (function (Attributes) {
            var AttributeTemplate = (function (_super) {
                __extends(AttributeTemplate, _super);
                function AttributeTemplate(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Attributes.AttributeTemplate.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.AttribCode = args.AttribCode;
                    _this.EntityId = args.EntityId;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.MenuId = args.MenuId;
                    _this.ObjectId = args.ObjectId;
                    _this.DataTypeControl = args.DataTypeControl;
                    _this.MaximumNumber = args.MaximumNumber;
                    _this.MinimumNumber = args.MinimumNumber;
                    _this.StringTypeCode = args.StringTypeCode;
                    _this.KeyType = args.KeyType;
                    _this.DefaultLength = args.DefaultLength;
                    _this.DefaultValue = args.DefaultValue;
                    _this.PossibleValues = args.PossibleValues;
                    _this.IsParent = args.IsParent;
                    return _this;
                }
                AttributeTemplate.Type = "Selcomm.Attributes.AttributeTemplate";
                AttributeTemplate.TypeParameters = [];
                return AttributeTemplate;
            }(Selcomm.Objects.DataObject));
            Attributes.AttributeTemplate = AttributeTemplate;
        })(Attributes = Selcomm.Attributes || (Selcomm.Attributes = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event_1) {
            var Event = (function (_super) {
                __extends(Event, _super);
                function Event(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.Event.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.EventType = args.EventType;
                    _this.Schedule = args.Schedule;
                    _this.Note = args.Note;
                    _this.EventReason = args.EventReason;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.ContactCode = args.ContactCode;
                    _this.ServiceReference = args.ServiceReference;
                    _this.Attachments = args.Attachments;
                    return _this;
                }
                Event.Type = "Selcomm.Event.Event";
                Event.TypeParameters = [];
                return Event;
            }(Selcomm.Objects.DataObject));
            Event_1.Event = Event;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventType = (function (_super) {
                __extends(EventType, _super);
                function EventType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.EventType = args.EventType;
                    _this.EventCode = args.EventCode;
                    _this.Description = args.Description;
                    _this.StartDate = args.StartDate;
                    _this.EndDateTime = args.EndDateTime;
                    _this.EventCategory = args.EventCategory;
                    _this.Source = args.Source;
                    _this.ResidentEvent = args.ResidentEvent;
                    _this.Schedulable = args.Schedulable;
                    _this.SetReference = args.SetReference;
                    _this.ChgScheduleDate = args.ChgScheduleDate;
                    _this.VisibleInCustomerCare = args.VisibleInCustomerCare;
                    _this.VisibleInSelfCare = args.VisibleInSelfCare;
                    _this.Department = args.Department;
                    _this.ContactStatus = args.ContactStatus;
                    _this.DefaultPriority = args.DefaultPriority;
                    _this.AutoCode = args.AutoCode;
                    _this.CodePrefix = args.CodePrefix;
                    _this.ArchiveDays = args.ArchiveDays;
                    _this.Template = args.Template;
                    _this.EventMessage = args.EventMessage;
                    _this.CanUploadDocuments = args.CanUploadDocuments;
                    _this.CanViewDocuments = args.CanViewDocuments;
                    _this.InitialSlaPeriod = args.InitialSlaPeriod;
                    _this.SubsequentSlaPeriod = args.SubsequentSlaPeriod;
                    _this.MaxmimumSlaNotifications = args.MaxmimumSlaNotifications;
                    _this.OpenSlaPeriod = args.OpenSlaPeriod;
                    _this.SystemRecord = args.SystemRecord;
                    _this.RecurringInterval = args.RecurringInterval;
                    _this.RecurringIntervalType = args.RecurringIntervalType;
                    _this.RecurInstances = args.RecurInstances;
                    _this.VisbleToCustomer = args.VisbleToCustomer;
                    _this.EditableByCustomer = args.EditableByCustomer;
                    _this.SchedulableByCustomer = args.SchedulableByCustomer;
                    _this.DefaultNote = args.DefaultNote;
                    _this.SlaIntervalType = args.SlaIntervalType;
                    _this.EventReasonList = args.EventReasonList;
                    return _this;
                }
                EventType.Type = "Selcomm.Event.EventType";
                EventType.TypeParameters = [];
                return EventType;
            }(Selcomm.Objects.DataObject));
            Event.EventType = EventType;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventCategory = (function (_super) {
                __extends(EventCategory, _super);
                function EventCategory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventCategory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    return _this;
                }
                EventCategory.Type = "Selcomm.Event.EventCategory";
                EventCategory.TypeParameters = [];
                return EventCategory;
            }(Selcomm.Objects.DataObject));
            Event.EventCategory = EventCategory;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var Department = (function (_super) {
                __extends(Department, _super);
                function Department(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.Department.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.OperatorDepartment = args.OperatorDepartment;
                    return _this;
                }
                Department.Type = "Selcomm.Event.Department";
                Department.TypeParameters = [];
                return Department;
            }(Selcomm.Objects.DataObject));
            Event.Department = Department;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactStatus = (function (_super) {
                __extends(ContactStatus, _super);
                function ContactStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Status = args.Status;
                    _this.Description = args.Description;
                    _this.Order = args.Order;
                    _this.Default = args.Default;
                    _this.DisplayOnline = args.DisplayOnline;
                    _this.DisplayReport = args.DisplayReport;
                    _this.ReturnReason = args.ReturnReason;
                    _this.SystemStatus = args.SystemStatus;
                    return _this;
                }
                ContactStatus.Type = "Selcomm.Contact.ContactStatus";
                ContactStatus.TypeParameters = [];
                return ContactStatus;
            }(Selcomm.Objects.DataObject));
            Contact.ContactStatus = ContactStatus;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ReturnReason = (function (_super) {
                __extends(ReturnReason, _super);
                function ReturnReason(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ReturnReason.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.Print = args.Print;
                    return _this;
                }
                ReturnReason.Type = "Selcomm.Contact.ReturnReason";
                ReturnReason.TypeParameters = [];
                return ReturnReason;
            }(Selcomm.Objects.DataObject));
            Contact.ReturnReason = ReturnReason;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Status;
        (function (Status) {
            var SystemStatus = (function (_super) {
                __extends(SystemStatus, _super);
                function SystemStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Status.SystemStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    return _this;
                }
                SystemStatus.Type = "Selcomm.Status.SystemStatus";
                SystemStatus.TypeParameters = [];
                return SystemStatus;
            }(Selcomm.Objects.DataObject));
            Status.SystemStatus = SystemStatus;
        })(Status = Selcomm.Status || (Selcomm.Status = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Templates;
        (function (Templates) {
            var Template = (function (_super) {
                __extends(Template, _super);
                function Template(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Templates.Template.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.Narrative = args.Narrative;
                    _this.CategoryCode = args.CategoryCode;
                    _this.Subject = args.Subject;
                    _this.Body = args.Body;
                    _this.Contact = args.Contact;
                    _this.Service = args.Service;
                    _this.Email = args.Email;
                    _this.Print = args.Print;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Location = args.Location;
                    _this.LocalPath = args.LocalPath;
                    return _this;
                }
                Template.Type = "Selcomm.Templates.Template";
                Template.TypeParameters = [];
                return Template;
            }(Selcomm.Objects.DataObject));
            Templates.Template = Template;
        })(Templates = Selcomm.Templates || (Selcomm.Templates = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var RecurringIntervalTypes;
            (function (RecurringIntervalTypes) {
                RecurringIntervalTypes[RecurringIntervalTypes["Unknown"] = 0] = "Unknown";
                RecurringIntervalTypes[RecurringIntervalTypes["Daily"] = 1] = "Daily";
                RecurringIntervalTypes[RecurringIntervalTypes["Weekly"] = 2] = "Weekly";
                RecurringIntervalTypes[RecurringIntervalTypes["Monthly"] = 3] = "Monthly";
            })(RecurringIntervalTypes = Event.RecurringIntervalTypes || (Event.RecurringIntervalTypes = {}));
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventReasonType = (function (_super) {
                __extends(EventReasonType, _super);
                function EventReasonType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventReasonType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.Display = args.Display;
                    _this.EventType = args.EventType;
                    return _this;
                }
                EventReasonType.Type = "Selcomm.Event.EventReasonType";
                EventReasonType.TypeParameters = [];
                return EventReasonType;
            }(Selcomm.Objects.DataObject));
            Event.EventReasonType = EventReasonType;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventSchedule = (function (_super) {
                __extends(EventSchedule, _super);
                function EventSchedule(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventSchedule.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Event = args.Event;
                    _this.ToLogin = args.ToLogin;
                    _this.ToDepartment = args.ToDepartment;
                    _this.EventScheduleType = args.EventScheduleType;
                    _this.DueDate = args.DueDate;
                    _this.EventScheduleStatus = args.EventScheduleStatus;
                    _this.EventScheduleStatusDate = args.EventScheduleStatusDate;
                    _this.EventScheduleStatusBy = args.EventScheduleStatusBy;
                    return _this;
                }
                EventSchedule.Type = "Selcomm.Event.EventSchedule";
                EventSchedule.TypeParameters = [];
                return EventSchedule;
            }(Selcomm.Objects.DataObject));
            Event.EventSchedule = EventSchedule;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventScheduleType = (function (_super) {
                __extends(EventScheduleType, _super);
                function EventScheduleType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventScheduleType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    return _this;
                }
                EventScheduleType.Type = "Selcomm.Event.EventScheduleType";
                EventScheduleType.TypeParameters = [];
                return EventScheduleType;
            }(Selcomm.Objects.DataObject));
            Event.EventScheduleType = EventScheduleType;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventScheduleStatus = (function (_super) {
                __extends(EventScheduleStatus, _super);
                function EventScheduleStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventScheduleStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    return _this;
                }
                EventScheduleStatus.Type = "Selcomm.Event.EventScheduleStatus";
                EventScheduleStatus.TypeParameters = [];
                return EventScheduleStatus;
            }(Selcomm.Objects.DataObject));
            Event.EventScheduleStatus = EventScheduleStatus;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventAttachment = (function (_super) {
                __extends(EventAttachment, _super);
                function EventAttachment(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventAttachment.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.AttachedEvent = args.AttachedEvent;
                    _this.Location = args.Location;
                    _this.UnattachedEvent = args.UnattachedEvent;
                    _this.CustomerEditable = args.CustomerEditable;
                    _this.CustomerVisible = args.CustomerVisible;
                    _this.UserEditable = args.UserEditable;
                    _this.FileName = args.FileName;
                    _this.Note = args.Note;
                    _this.FileContent = args.FileContent;
                    return _this;
                }
                EventAttachment.Type = "Selcomm.Event.EventAttachment";
                EventAttachment.TypeParameters = [];
                return EventAttachment;
            }(Selcomm.Objects.DataObject));
            Event.EventAttachment = EventAttachment;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAttribute = (function (_super) {
                __extends(ServiceAttribute, _super);
                function ServiceAttribute(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceAttribute.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceId = args.ServiceId;
                    return _this;
                }
                ServiceAttribute.Type = "Selcomm.Service.ServiceAttribute";
                ServiceAttribute.TypeParameters = [];
                return ServiceAttribute;
            }(Selcomm.Attributes.Attribute));
            Service.ServiceAttribute = ServiceAttribute;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Attributes;
        (function (Attributes) {
            var AttributeList = (function (_super) {
                __extends(AttributeList, _super);
                function AttributeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Attributes.AttributeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AttributeList.Type = "Selcomm.Attributes.AttributeList";
                AttributeList.TypeParameters = [];
                return AttributeList;
            }(Selcomm.Objects.ExtendedDataList));
            Attributes.AttributeList = AttributeList;
        })(Attributes = Selcomm.Attributes || (Selcomm.Attributes = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceType = (function (_super) {
                __extends(ServiceType, _super);
                function ServiceType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Display = args.Display;
                    _this.OrderNumber = args.OrderNumber;
                    _this.Description = args.Description;
                    _this.BillNarrative = args.BillNarrative;
                    _this.Icon = args.Icon;
                    _this.ServiceDestNarrative = args.ServiceDestNarrative;
                    _this.IPND = args.IPND;
                    _this.ExcludeIPND = args.ExcludeIPND;
                    _this.LockSimPUK = args.LockSimPUK;
                    _this.AdditionalInfo1 = args.AdditionalInfo1;
                    _this.AdditionalInfo2 = args.AdditionalInfo2;
                    _this.AdditionalInfo3 = args.AdditionalInfo3;
                    _this.AdditionalInfo4 = args.AdditionalInfo4;
                    _this.OrderEntryDisplay = args.OrderEntryDisplay;
                    _this.AttributeTemplateList = args.AttributeTemplateList;
                    return _this;
                }
                ServiceType.Type = "Selcomm.Service.ServiceType";
                ServiceType.TypeParameters = [];
                return ServiceType;
            }(Selcomm.Objects.DataObject));
            Service.ServiceType = ServiceType;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Attributes;
        (function (Attributes) {
            var AttributeTemplateList = (function (_super) {
                __extends(AttributeTemplateList, _super);
                function AttributeTemplateList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Attributes.AttributeTemplateList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AttributeTemplateList.Type = "Selcomm.Attributes.AttributeTemplateList";
                AttributeTemplateList.TypeParameters = [];
                return AttributeTemplateList;
            }(Selcomm.Objects.ExtendedDataList));
            Attributes.AttributeTemplateList = AttributeTemplateList;
        })(Attributes = Selcomm.Attributes || (Selcomm.Attributes = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Authorisation;
        (function (Authorisation) {
            var AuthorisationObjectToken = (function () {
                function AuthorisationObjectToken(args) {
                    this.$type = Selcomm.Authorisation.AuthorisationObjectToken.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.AuthorisationObjectId = args.AuthorisationObjectId;
                    this.AuthorisationToken = args.AuthorisationToken;
                }
                AuthorisationObjectToken.Type = "Selcomm.Authorisation.AuthorisationObjectToken";
                AuthorisationObjectToken.TypeParameters = [];
                return AuthorisationObjectToken;
            }());
            Authorisation.AuthorisationObjectToken = AuthorisationObjectToken;
        })(Authorisation = Selcomm.Authorisation || (Selcomm.Authorisation = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Authorisation;
        (function (Authorisation) {
            var AuthorisationToken;
            (function (AuthorisationToken) {
                AuthorisationToken[AuthorisationToken["Unknown"] = 0] = "Unknown";
                AuthorisationToken[AuthorisationToken["NoAccess"] = 1] = "NoAccess";
                AuthorisationToken[AuthorisationToken["ReadOnly"] = 3] = "ReadOnly";
                AuthorisationToken[AuthorisationToken["FullAccess"] = 5] = "FullAccess";
            })(AuthorisationToken = Authorisation.AuthorisationToken || (Authorisation.AuthorisationToken = {}));
        })(Authorisation = Selcomm.Authorisation || (Selcomm.Authorisation = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Authorisation;
        (function (Authorisation) {
            var AuthorisationObjectTokenList = (function (_super) {
                __extends(AuthorisationObjectTokenList, _super);
                function AuthorisationObjectTokenList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Authorisation.AuthorisationObjectTokenList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AuthorisationObjectTokenList.Type = "Selcomm.Authorisation.AuthorisationObjectTokenList";
                AuthorisationObjectTokenList.TypeParameters = [];
                return AuthorisationObjectTokenList;
            }(Selcomm.Objects.ExtendedDataList));
            Authorisation.AuthorisationObjectTokenList = AuthorisationObjectTokenList;
        })(Authorisation = Selcomm.Authorisation || (Selcomm.Authorisation = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var PagingSortsAndFilters = (function () {
                function PagingSortsAndFilters(args) {
                    this.$type = Selcomm.Filters.PagingSortsAndFilters.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Filter = args.Filter;
                    this.SkipRecords = args.SkipRecords;
                    this.TakeRecords = args.TakeRecords;
                    this.Sorts = args.Sorts;
                }
                PagingSortsAndFilters.Type = "Selcomm.Filters.PagingSortsAndFilters";
                PagingSortsAndFilters.TypeParameters = [];
                return PagingSortsAndFilters;
            }());
            Filters.PagingSortsAndFilters = PagingSortsAndFilters;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var Filter = (function () {
                function Filter(args) {
                    this.$type = Selcomm.Filters.Filter.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                Filter.Type = "Selcomm.Filters.Filter";
                Filter.TypeParameters = [];
                return Filter;
            }());
            Filters.Filter = Filter;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var PropertyFilter = (function (_super) {
                __extends(PropertyFilter, _super);
                function PropertyFilter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.PropertyFilter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.PropertyName = args.PropertyName;
                    return _this;
                }
                PropertyFilter.Type = "Selcomm.Filters.PropertyFilter";
                PropertyFilter.TypeParameters = [];
                return PropertyFilter;
            }(Selcomm.Filters.Filter));
            Filters.PropertyFilter = PropertyFilter;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var BasicPropertyFilter = (function (_super) {
                __extends(BasicPropertyFilter, _super);
                function BasicPropertyFilter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.BasicPropertyFilter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Value = args.Value;
                    _this.CompareOperator = args.CompareOperator;
                    return _this;
                }
                BasicPropertyFilter.Type = "Selcomm.Filters.BasicPropertyFilter";
                BasicPropertyFilter.TypeParameters = [];
                return BasicPropertyFilter;
            }(Selcomm.Filters.PropertyFilter));
            Filters.BasicPropertyFilter = BasicPropertyFilter;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var BasicCompareOperator;
            (function (BasicCompareOperator) {
                BasicCompareOperator[BasicCompareOperator["Equals"] = 0] = "Equals";
                BasicCompareOperator[BasicCompareOperator["NotEquals"] = 1] = "NotEquals";
                BasicCompareOperator[BasicCompareOperator["LessThan"] = 2] = "LessThan";
                BasicCompareOperator[BasicCompareOperator["LessThanOrEquals"] = 3] = "LessThanOrEquals";
                BasicCompareOperator[BasicCompareOperator["GreaterThan"] = 4] = "GreaterThan";
                BasicCompareOperator[BasicCompareOperator["GreaterThanOrEquals"] = 5] = "GreaterThanOrEquals";
            })(BasicCompareOperator = Filters.BasicCompareOperator || (Filters.BasicCompareOperator = {}));
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var BetweenPropertyFilter = (function (_super) {
                __extends(BetweenPropertyFilter, _super);
                function BetweenPropertyFilter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.BetweenPropertyFilter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.StartValue = args.StartValue;
                    _this.EndValue = args.EndValue;
                    return _this;
                }
                BetweenPropertyFilter.Type = "Selcomm.Filters.BetweenPropertyFilter";
                BetweenPropertyFilter.TypeParameters = [];
                return BetweenPropertyFilter;
            }(Selcomm.Filters.PropertyFilter));
            Filters.BetweenPropertyFilter = BetweenPropertyFilter;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var KeywordPropertyFilter = (function (_super) {
                __extends(KeywordPropertyFilter, _super);
                function KeywordPropertyFilter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.KeywordPropertyFilter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Value = args.Value;
                    return _this;
                }
                KeywordPropertyFilter.Type = "Selcomm.Filters.KeywordPropertyFilter";
                KeywordPropertyFilter.TypeParameters = [];
                return KeywordPropertyFilter;
            }(Selcomm.Filters.PropertyFilter));
            Filters.KeywordPropertyFilter = KeywordPropertyFilter;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var InPropertyFilter = (function (_super) {
                __extends(InPropertyFilter, _super);
                function InPropertyFilter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.InPropertyFilter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Values = args.Values;
                    return _this;
                }
                InPropertyFilter.Type = "Selcomm.Filters.InPropertyFilter";
                InPropertyFilter.TypeParameters = [];
                return InPropertyFilter;
            }(Selcomm.Filters.PropertyFilter));
            Filters.InPropertyFilter = InPropertyFilter;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var FilterGroup = (function (_super) {
                __extends(FilterGroup, _super);
                function FilterGroup(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.FilterGroup.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Filters = args.Filters;
                    return _this;
                }
                FilterGroup.Type = "Selcomm.Filters.FilterGroup";
                FilterGroup.TypeParameters = [];
                return FilterGroup;
            }(Selcomm.Filters.Filter));
            Filters.FilterGroup = FilterGroup;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var AllFilterGroup = (function (_super) {
                __extends(AllFilterGroup, _super);
                function AllFilterGroup(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.AllFilterGroup.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AllFilterGroup.Type = "Selcomm.Filters.AllFilterGroup";
                AllFilterGroup.TypeParameters = [];
                return AllFilterGroup;
            }(Selcomm.Filters.FilterGroup));
            Filters.AllFilterGroup = AllFilterGroup;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var AnyFilterGroup = (function (_super) {
                __extends(AnyFilterGroup, _super);
                function AnyFilterGroup(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.AnyFilterGroup.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AnyFilterGroup.Type = "Selcomm.Filters.AnyFilterGroup";
                AnyFilterGroup.TypeParameters = [];
                return AnyFilterGroup;
            }(Selcomm.Filters.FilterGroup));
            Filters.AnyFilterGroup = AnyFilterGroup;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var NotFilter = (function (_super) {
                __extends(NotFilter, _super);
                function NotFilter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.NotFilter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Filter = args.Filter;
                    return _this;
                }
                NotFilter.Type = "Selcomm.Filters.NotFilter";
                NotFilter.TypeParameters = [];
                return NotFilter;
            }(Selcomm.Filters.Filter));
            Filters.NotFilter = NotFilter;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var ConditionalFilter = (function (_super) {
                __extends(ConditionalFilter, _super);
                function ConditionalFilter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Filters.ConditionalFilter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Condition = args.Condition;
                    _this.IfConditionTrue = args.IfConditionTrue;
                    _this.IfConditionFalse = args.IfConditionFalse;
                    return _this;
                }
                ConditionalFilter.Type = "Selcomm.Filters.ConditionalFilter";
                ConditionalFilter.TypeParameters = [];
                return ConditionalFilter;
            }(Selcomm.Filters.Filter));
            Filters.ConditionalFilter = ConditionalFilter;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var Sort = (function () {
                function Sort(args) {
                    this.$type = Selcomm.Filters.Sort.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.TargetProperty = args.TargetProperty;
                    this.Direction = args.Direction;
                }
                Sort.Type = "Selcomm.Filters.Sort";
                Sort.TypeParameters = [];
                return Sort;
            }());
            Filters.Sort = Sort;
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Filters;
        (function (Filters) {
            var SortDirection;
            (function (SortDirection) {
                SortDirection[SortDirection["None"] = 0] = "None";
                SortDirection[SortDirection["Ascending"] = 1] = "Ascending";
                SortDirection[SortDirection["Descending"] = 2] = "Descending";
            })(SortDirection = Filters.SortDirection || (Filters.SortDirection = {}));
        })(Filters = Selcomm.Filters || (Selcomm.Filters = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill_1) {
            var Bill = (function (_super) {
                __extends(Bill, _super);
                function Bill(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.Bill.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Date = args.Date;
                    _this.DueDate = args.DueDate;
                    _this.Number = args.Number;
                    _this.Sequence = args.Sequence;
                    _this.Source = args.Source;
                    _this.BillPeriod = args.BillPeriod;
                    _this.BillCycle = args.BillCycle;
                    _this.BillFormat = args.BillFormat;
                    _this.Currency = args.Currency;
                    _this.PreviousAmount = args.PreviousAmount;
                    _this.PayAndAdjustmentAmount = args.PayAndAdjustmentAmount;
                    _this.Balance = args.Balance;
                    _this.InstallmentAmount = args.InstallmentAmount;
                    _this.DepositAmount = args.DepositAmount;
                    _this.NewCharges = args.NewCharges;
                    _this.AmountDue = args.AmountDue;
                    _this.ContactCode = args.ContactCode;
                    return _this;
                }
                Bill.Type = "Selcomm.Bill.Bill";
                Bill.TypeParameters = [];
                return Bill;
            }(Selcomm.Objects.DataObject));
            Bill_1.Bill = Bill;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var FinancialTransactionSource = (function (_super) {
                __extends(FinancialTransactionSource, _super);
                function FinancialTransactionSource(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Financials.FinancialTransactionSource.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.SystemStatus = args.SystemStatus;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    _this.System = args.System;
                    return _this;
                }
                FinancialTransactionSource.Type = "Selcomm.Financials.FinancialTransactionSource";
                FinancialTransactionSource.TypeParameters = [];
                return FinancialTransactionSource;
            }(Selcomm.Objects.DataObject));
            Financials.FinancialTransactionSource = FinancialTransactionSource;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SelcommSystem;
        (function (SelcommSystem) {
            var RecordType;
            (function (RecordType) {
                RecordType[RecordType["SystemRecordMustBeVisible"] = 0] = "SystemRecordMustBeVisible";
                RecordType[RecordType["SystemRecordCanBeInVisible"] = 1] = "SystemRecordCanBeInVisible";
                RecordType[RecordType["UserRecordMustBeVisible"] = 10] = "UserRecordMustBeVisible";
                RecordType[RecordType["UserRecordCanBeInVisible"] = 11] = "UserRecordCanBeInVisible";
            })(RecordType = SelcommSystem.RecordType || (SelcommSystem.RecordType = {}));
        })(SelcommSystem = Selcomm.SelcommSystem || (Selcomm.SelcommSystem = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillPeriod = (function (_super) {
                __extends(BillPeriod, _super);
                function BillPeriod(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillPeriod.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.CycleCode = args.CycleCode;
                    _this.Code = args.Code;
                    _this.From = args.From;
                    _this.Description = args.Description;
                    _this.To = args.To;
                    _this.AdvanceDate = args.AdvanceDate;
                    return _this;
                }
                BillPeriod.Type = "Selcomm.Bill.BillPeriod";
                BillPeriod.TypeParameters = [];
                return BillPeriod;
            }(Selcomm.Objects.DataObject));
            Bill.BillPeriod = BillPeriod;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillCycle = (function (_super) {
                __extends(BillCycle, _super);
                function BillCycle(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillCycle.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.Default = args.Default;
                    _this.ConfigurationCode = args.ConfigurationCode;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.DayOfMonth = args.DayOfMonth;
                    _this.CycleIntervalUnits = args.CycleIntervalUnits;
                    _this.CycleInterval = args.CycleInterval;
                    _this.Display = args.Display;
                    return _this;
                }
                BillCycle.Type = "Selcomm.Bill.BillCycle";
                BillCycle.TypeParameters = [];
                return BillCycle;
            }(Selcomm.Objects.DataObject));
            Bill.BillCycle = BillCycle;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var CycleIntervalUnits;
            (function (CycleIntervalUnits) {
                CycleIntervalUnits[CycleIntervalUnits["Month"] = 0] = "Month";
            })(CycleIntervalUnits = Bill.CycleIntervalUnits || (Bill.CycleIntervalUnits = {}));
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillFormat = (function (_super) {
                __extends(BillFormat, _super);
                function BillFormat(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillFormat.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.Default = args.Default;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Display = args.Display;
                    return _this;
                }
                BillFormat.Type = "Selcomm.Bill.BillFormat";
                BillFormat.TypeParameters = [];
                return BillFormat;
            }(Selcomm.Objects.DataObject));
            Bill.BillFormat = BillFormat;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var Currency = (function (_super) {
                __extends(Currency, _super);
                function Currency(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Financials.Currency.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    _this.DefaultTax = args.DefaultTax;
                    return _this;
                }
                Currency.Type = "Selcomm.Financials.Currency";
                Currency.TypeParameters = [];
                return Currency;
            }(Selcomm.Objects.DataObject));
            Financials.Currency = Currency;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var Tax = (function () {
                function Tax(args) {
                    this.$type = Selcomm.Financials.Tax.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Code = args.Code;
                    this.Name = args.Name;
                    this.DisplayOrder = args.DisplayOrder;
                    this.Active = args.Active;
                    this.Default = args.Default;
                }
                Tax.Type = "Selcomm.Financials.Tax";
                Tax.TypeParameters = [];
                return Tax;
            }());
            Financials.Tax = Tax;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillList = (function (_super) {
                __extends(BillList, _super);
                function BillList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillList.Type;
                    if (!args) {
                        return _this;
                    }
                    _this.ExcelBillEnabled = args.ExcelBillEnabled;
                    _this.ErrorMessage = args.ErrorMessage;
                    return _this;
                }
                BillList.Type = "Selcomm.Bill.BillList";
                BillList.TypeParameters = [];
                return BillList;
            }(Selcomm.Objects.ExtendedDataList));
            Bill.BillList = BillList;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillFile = (function (_super) {
                __extends(BillFile, _super);
                function BillFile(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillFile.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Date = args.Date;
                    _this.Number = args.Number;
                    _this.FileName = args.FileName;
                    _this.Content = args.Content;
                    console.log("Here is the args:" + args.FileName);
                    return _this;
                }
                BillFile.Type = "Selcomm.Bill.BillFile";
                BillFile.TypeParameters = [];
                return BillFile;
            }(Selcomm.Objects.DataObject));
            Bill.BillFile = BillFile;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillSummaryItem = (function (_super) {
                __extends(BillSummaryItem, _super);
                function BillSummaryItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillSummaryItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Type = args.Type;
                    _this.Description = args.Description;
                    _this.From = args.From;
                    _this.To = args.To;
                    _this.Count = args.Count;
                    _this.AmountTaxEx = args.AmountTaxEx;
                    _this.AmountTaxInc = args.AmountTaxInc;
                    return _this;
                }
                BillSummaryItem.Type = "Selcomm.Bill.BillSummaryItem";
                BillSummaryItem.TypeParameters = [];
                return BillSummaryItem;
            }(Selcomm.Objects.DataObject));
            Bill.BillSummaryItem = BillSummaryItem;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillSummaryItemList = (function (_super) {
                __extends(BillSummaryItemList, _super);
                function BillSummaryItemList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillSummaryItemList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                BillSummaryItemList.Type = "Selcomm.Bill.BillSummaryItemList";
                BillSummaryItemList.TypeParameters = [];
                return BillSummaryItemList;
            }(Selcomm.Objects.ExtendedDataList));
            Bill.BillSummaryItemList = BillSummaryItemList;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var DisplayBaseObject = (function () {
                function DisplayBaseObject(args) {
                    this.$type = Selcomm.Objects.DisplayBaseObject.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.LastUpdated = args.LastUpdated;
                    this.UpdatedBy = args.UpdatedBy;
                    this.Created = args.Created;
                    this.CreatedBy = args.CreatedBy;
                    this.RestrictedPropertiesNames = args.RestrictedPropertiesNames;
                }
                DisplayBaseObject.Type = "Selcomm.Objects.DisplayBaseObject";
                DisplayBaseObject.TypeParameters = [];
                return DisplayBaseObject;
            }());
            Objects.DisplayBaseObject = DisplayBaseObject;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Usage;
        (function (Usage) {
            var UsageTransactionDisplay = (function (_super) {
                __extends(UsageTransactionDisplay, _super);
                function UsageTransactionDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Usage.UsageTransactionDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.StartDateTime = args.StartDateTime;
                    _this.BParty = args.BParty;
                    _this.BPartyDescription = args.BPartyDescription;
                    _this.Duration = args.Duration;
                    _this.UnitQuantity = args.UnitQuantity;
                    _this.UnitOfMeasure = args.UnitOfMeasure;
                    _this.PriceTaxEx = args.PriceTaxEx;
                    _this.DiscountedPrice = args.DiscountedPrice;
                    _this.NonDiscountedPrice = args.NonDiscountedPrice;
                    _this.PriceTaxExNonDiscounted = args.PriceTaxExNonDiscounted;
                    _this.Tax = args.Tax;
                    _this.TaxNonDiscounted = args.TaxNonDiscounted;
                    _this.CostTaxEx = args.CostTaxEx;
                    _this.CostTax = args.CostTax;
                    _this.UsageGroup = args.UsageGroup;
                    _this.UsageGroupCode = args.UsageGroupCode;
                    _this.UsageGroupOrder = args.UsageGroupOrder;
                    _this.RateBandDescription = args.RateBandDescription;
                    _this.TariffCode = args.TariffCode;
                    _this.TariffDescription = args.TariffDescription;
                    _this.Origin = args.Origin;
                    _this.ThirdParty = args.ThirdParty;
                    _this.Band1RateUnit = args.Band1RateUnit;
                    _this.Band2RateUnit = args.Band2RateUnit;
                    _this.Band3RateUnit = args.Band3RateUnit;
                    _this.Band4RateUnit = args.Band4RateUnit;
                    _this.TaxFree = args.TaxFree;
                    _this.Suppressed = args.Suppressed;
                    _this.PrintCode = args.PrintCode;
                    _this.SpCnNarrative = args.SpCnNarrative;
                    return _this;
                }
                UsageTransactionDisplay.Type = "Selcomm.Usage.UsageTransactionDisplay";
                UsageTransactionDisplay.TypeParameters = [];
                return UsageTransactionDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Usage.UsageTransactionDisplay = UsageTransactionDisplay;
        })(Usage = Selcomm.Usage || (Selcomm.Usage = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Usage;
        (function (Usage) {
            var UsageTransactionDisplayList = (function (_super) {
                __extends(UsageTransactionDisplayList, _super);
                function UsageTransactionDisplayList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Usage.UsageTransactionDisplayList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                UsageTransactionDisplayList.Type = "Selcomm.Usage.UsageTransactionDisplayList";
                UsageTransactionDisplayList.TypeParameters = [];
                return UsageTransactionDisplayList;
            }(Selcomm.Objects.ExtendedDataList));
            Usage.UsageTransactionDisplayList = UsageTransactionDisplayList;
        })(Usage = Selcomm.Usage || (Selcomm.Usage = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Charges;
        (function (Charges) {
            var ChargeDisplay = (function (_super) {
                __extends(ChargeDisplay, _super);
                function ChargeDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Charges.ChargeDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.From = args.From;
                    _this.To = args.To;
                    _this.Frequency = args.Frequency;
                    _this.AdvancePeriods = args.AdvancePeriods;
                    _this.ChargeInAdvance = args.ChargeInAdvance;
                    _this.ProRate = args.ProRate;
                    _this.Taxable = args.Taxable;
                    _this.Price = args.Price;
                    _this.Tax = args.Tax;
                    _this.NonDiscountedPrice = args.NonDiscountedPrice;
                    _this.NonDiscountedTax = args.NonDiscountedTax;
                    _this.TotalNumberOfRecords = args.TotalNumberOfRecords;
                    _this.Unit = args.Unit;
                    _this.UnitQuantity = args.UnitQuantity;
                    _this.UnitRate = args.UnitRate;
                    _this.UnitDiscountAmount = args.UnitDiscountAmount;
                    _this.UnitDiscountPercentage = args.UnitDiscountPercentage;
                    _this.DefaultAmount = args.DefaultAmount;
                    return _this;
                }
                ChargeDisplay.Type = "Selcomm.Charges.ChargeDisplay";
                ChargeDisplay.TypeParameters = [];
                return ChargeDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Charges.ChargeDisplay = ChargeDisplay;
        })(Charges = Selcomm.Charges || (Selcomm.Charges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Charges;
        (function (Charges) {
            var ChargeFrequency;
            (function (ChargeFrequency) {
                ChargeFrequency[ChargeFrequency["OneOff"] = 0] = "OneOff";
                ChargeFrequency[ChargeFrequency["Daily"] = 1] = "Daily";
                ChargeFrequency[ChargeFrequency["Weekly"] = 2] = "Weekly";
                ChargeFrequency[ChargeFrequency["Fortnightly"] = 3] = "Fortnightly";
                ChargeFrequency[ChargeFrequency["Monthly"] = 4] = "Monthly";
                ChargeFrequency[ChargeFrequency["LunarMonthly"] = 5] = "LunarMonthly";
                ChargeFrequency[ChargeFrequency["BiMonthly"] = 6] = "BiMonthly";
                ChargeFrequency[ChargeFrequency["Quarterly"] = 7] = "Quarterly";
                ChargeFrequency[ChargeFrequency["Biennially"] = 8] = "Biennially";
                ChargeFrequency[ChargeFrequency["Annually"] = 9] = "Annually";
                ChargeFrequency[ChargeFrequency["BiAnnually"] = 10] = "BiAnnually";
                ChargeFrequency[ChargeFrequency["TriAnnually"] = 11] = "TriAnnually";
                ChargeFrequency[ChargeFrequency["NumberOfTimes"] = 12] = "NumberOfTimes";
            })(ChargeFrequency = Charges.ChargeFrequency || (Charges.ChargeFrequency = {}));
        })(Charges = Selcomm.Charges || (Selcomm.Charges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Charges;
        (function (Charges) {
            var ChargeDisplayList = (function (_super) {
                __extends(ChargeDisplayList, _super);
                function ChargeDisplayList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Charges.ChargeDisplayList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.TotalNumberOfRecords = args.TotalNumberOfRecords;
                    return _this;
                }
                ChargeDisplayList.Type = "Selcomm.Charges.ChargeDisplayList";
                ChargeDisplayList.TypeParameters = [];
                return ChargeDisplayList;
            }(Selcomm.Objects.ExtendedDataList));
            Charges.ChargeDisplayList = ChargeDisplayList;
        })(Charges = Selcomm.Charges || (Selcomm.Charges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillSummaryByServiceTypeItem = (function (_super) {
                __extends(BillSummaryByServiceTypeItem, _super);
                function BillSummaryByServiceTypeItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillSummaryByServiceTypeItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceTypeDescription = args.ServiceTypeDescription;
                    _this.NumberOfServices = args.NumberOfServices;
                    _this.UsageAmountTaxEx = args.UsageAmountTaxEx;
                    _this.UsageAmountTaxInc = args.UsageAmountTaxInc;
                    _this.ChargesAmountTaxEx = args.ChargesAmountTaxEx;
                    _this.ChargesAmountTaxInc = args.ChargesAmountTaxInc;
                    _this.ServiceTypeBillDescription = args.ServiceTypeBillDescription;
                    return _this;
                }
                BillSummaryByServiceTypeItem.Type = "Selcomm.Bill.BillSummaryByServiceTypeItem";
                BillSummaryByServiceTypeItem.TypeParameters = [];
                return BillSummaryByServiceTypeItem;
            }(Selcomm.Objects.DataObject));
            Bill.BillSummaryByServiceTypeItem = BillSummaryByServiceTypeItem;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillSummaryByServiceTypeItemList = (function (_super) {
                __extends(BillSummaryByServiceTypeItemList, _super);
                function BillSummaryByServiceTypeItemList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillSummaryByServiceTypeItemList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                BillSummaryByServiceTypeItemList.Type = "Selcomm.Bill.BillSummaryByServiceTypeItemList";
                BillSummaryByServiceTypeItemList.TypeParameters = [];
                return BillSummaryByServiceTypeItemList;
            }(Selcomm.Objects.ExtendedDataList));
            Bill.BillSummaryByServiceTypeItemList = BillSummaryByServiceTypeItemList;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillSummaryByServiceItem = (function (_super) {
                __extends(BillSummaryByServiceItem, _super);
                function BillSummaryByServiceItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillSummaryByServiceItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.UsageAmountTaxEx = args.UsageAmountTaxEx;
                    _this.UsageAmountTaxInc = args.UsageAmountTaxInc;
                    _this.ChargesAmountTaxEx = args.ChargesAmountTaxEx;
                    _this.ChargesAmountTaxInc = args.ChargesAmountTaxInc;
                    _this.TotalNumberOfRecords = args.TotalNumberOfRecords;
                    return _this;
                }
                BillSummaryByServiceItem.Type = "Selcomm.Bill.BillSummaryByServiceItem";
                BillSummaryByServiceItem.TypeParameters = [];
                return BillSummaryByServiceItem;
            }(Selcomm.Objects.DataObject));
            Bill.BillSummaryByServiceItem = BillSummaryByServiceItem;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillSummaryByServiceItemList = (function (_super) {
                __extends(BillSummaryByServiceItemList, _super);
                function BillSummaryByServiceItemList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillSummaryByServiceItemList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.TotalNumberOfRecords = args.TotalNumberOfRecords;
                    return _this;
                }
                BillSummaryByServiceItemList.Type = "Selcomm.Bill.BillSummaryByServiceItemList";
                BillSummaryByServiceItemList.TypeParameters = [];
                return BillSummaryByServiceItemList;
            }(Selcomm.Objects.ExtendedDataList));
            Bill.BillSummaryByServiceItemList = BillSummaryByServiceItemList;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillServiceSummaryItem = (function (_super) {
                __extends(BillServiceSummaryItem, _super);
                function BillServiceSummaryItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillServiceSummaryItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.GroupOrder = args.GroupOrder;
                    _this.GroupDescription = args.GroupDescription;
                    _this.SubGroupOrder = args.SubGroupOrder;
                    _this.SubGroupDescription = args.SubGroupDescription;
                    _this.ItemDescription = args.ItemDescription;
                    _this.ItemAmount = args.ItemAmount;
                    _this.ItemCount = args.ItemCount;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.ServiceTypeCode = args.ServiceTypeCode;
                    _this.ServiceTypeDescription = args.ServiceTypeDescription;
                    _this.CostCentreDescription = args.CostCentreDescription;
                    _this.ItemTax = args.ItemTax;
                    _this.ServiceDescription = args.ServiceDescription;
                    _this.ParentCostCentreDescription = args.ParentCostCentreDescription;
                    _this.PackageDescription = args.PackageDescription;
                    _this.SumUnitQuantity = args.SumUnitQuantity;
                    _this.Unit = args.Unit;
                    return _this;
                }
                BillServiceSummaryItem.Type = "Selcomm.Bill.BillServiceSummaryItem";
                BillServiceSummaryItem.TypeParameters = [];
                return BillServiceSummaryItem;
            }(Selcomm.Objects.DisplayBaseObject));
            Bill.BillServiceSummaryItem = BillServiceSummaryItem;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillServiceSummaryItemList = (function (_super) {
                __extends(BillServiceSummaryItemList, _super);
                function BillServiceSummaryItemList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillServiceSummaryItemList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Bill = args.Bill;
                    return _this;
                }
                BillServiceSummaryItemList.Type = "Selcomm.Bill.BillServiceSummaryItemList";
                BillServiceSummaryItemList.TypeParameters = [];
                return BillServiceSummaryItemList;
            }(Selcomm.Objects.ExtendedDataList));
            Bill.BillServiceSummaryItemList = BillServiceSummaryItemList;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillServiceSummaryItemListList = (function (_super) {
                __extends(BillServiceSummaryItemListList, _super);
                function BillServiceSummaryItemListList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillServiceSummaryItemListList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                BillServiceSummaryItemListList.Type = "Selcomm.Bill.BillServiceSummaryItemListList";
                BillServiceSummaryItemListList.TypeParameters = [];
                return BillServiceSummaryItemListList;
            }(Selcomm.Objects.ExtendedDataList));
            Bill.BillServiceSummaryItemListList = BillServiceSummaryItemListList;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillCycleList = (function (_super) {
                __extends(BillCycleList, _super);
                function BillCycleList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bill.BillCycleList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                BillCycleList.Type = "Selcomm.Bill.BillCycleList";
                BillCycleList.TypeParameters = [];
                return BillCycleList;
            }(Selcomm.Objects.ExtendedDataList));
            Bill.BillCycleList = BillCycleList;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bill;
        (function (Bill) {
            var BillTotalSummary = (function () {
                function BillTotalSummary(args) {
                    this.$type = Selcomm.Bill.BillTotalSummary.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.LastBillAmount = args.LastBillAmount;
                    this.Bill = args.Bill;
                    this.Payments = args.Payments;
                    this.Adjustment = args.Adjustment;
                    this.TaxExemptCharges = args.TaxExemptCharges;
                    this.TaxableCharges = args.TaxableCharges;
                    this.TaxAmount = args.TaxAmount;
                    this.FullName = args.FullName;
                    this.AdjustableTax = args.AdjustableTax;
                    this.CreditNoteTotal = args.CreditNoteTotal;
                    this.CreditNoteTotalIncTax = args.CreditNoteTotalIncTax;
                    this.FinancialTransaction = args.FinancialTransaction;
                    this.StartDate = args.StartDate;
                    this.EndDate = args.EndDate;
                    this.Contact = args.Contact;
                    this.ContactAlias = args.ContactAlias;
                    this.Currency = args.Currency;
                    this.Account = args.Account;
                    this.PurchaseOrderNumber = args.PurchaseOrderNumber;
                }
                BillTotalSummary.Type = "Selcomm.Bill.BillTotalSummary";
                BillTotalSummary.TypeParameters = [];
                return BillTotalSummary;
            }());
            Bill.BillTotalSummary = BillTotalSummary;
        })(Bill = Selcomm.Bill || (Selcomm.Bill = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var FinancialTransaction = (function (_super) {
                __extends(FinancialTransaction, _super);
                function FinancialTransaction(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Financials.FinancialTransaction.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Date = args.Date;
                    _this.DueDate = args.DueDate;
                    _this.Number = args.Number;
                    _this.Contact = args.Contact;
                    _this.BusinessUnit = args.BusinessUnit;
                    _this.Parent = args.Parent;
                    _this.Source = args.Source;
                    _this.Type = args.Type;
                    _this.Category = args.Category;
                    _this.Status = args.Status;
                    _this.Reason = args.Reason;
                    _this.BillId = args.BillId;
                    _this.OpenAmount = args.OpenAmount;
                    _this.Total = args.Total;
                    _this.Tax = args.Tax;
                    _this.RoundingAmount = args.RoundingAmount;
                    _this.TaxRoundingAmount = args.TaxRoundingAmount;
                    _this.DisputedAmount = args.DisputedAmount;
                    _this.Reference = args.Reference;
                    _this.Banked = args.Banked;
                    _this.AccountType = args.AccountType;
                    _this.PaymentRequestList = args.PaymentRequestList;
                    _this.TotalNumberOfRecords = args.TotalNumberOfRecords;
                    return _this;
                }
                FinancialTransaction.Type = "Selcomm.Financials.FinancialTransaction";
                FinancialTransaction.TypeParameters = [];
                return FinancialTransaction;
            }(Selcomm.Objects.DataObject));
            Financials.FinancialTransaction = FinancialTransaction;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact_1) {
            var Contact = (function (_super) {
                __extends(Contact, _super);
                function Contact(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.Contact.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.ExternalReference = args.ExternalReference;
                    _this.SubType = args.SubType;
                    _this.Name = args.Name;
                    _this.FullName = args.FullName;
                    _this.FullNameWithCode = args.FullNameWithCode;
                    _this.ContactStatus = args.ContactStatus;
                    _this.Aliases = args.Aliases;
                    _this.ABN = args.ABN;
                    _this.ACN = args.ACN;
                    _this.ABR = args.ABR;
                    _this.CompanyName = args.CompanyName;
                    _this.FirstName = args.FirstName;
                    _this.LastName = args.LastName;
                    _this.Title = args.Title;
                    _this.DateOfBirth = args.DateOfBirth;
                    _this.Occupation = args.Occupation;
                    _this.Initial = args.Initial;
                    _this.Gender = args.Gender;
                    _this.AddressList = args.AddressList;
                    _this.ContactPhoneList = args.ContactPhoneList;
                    _this.ContactEmailAddressList = args.ContactEmailAddressList;
                    _this.CollectionPlan = args.CollectionPlan;
                    _this.RoleList = args.RoleList;
                    _this.SecretQuestionAndAnswerList = args.SecretQuestionAndAnswerList;
                    _this.CurrentBusinessUnit = args.CurrentBusinessUnit;
                    _this.RelationshipList = args.RelationshipList;
                    _this.TaskList = args.TaskList;
                    _this.IdentityList = args.IdentityList;
                    _this.FeedBackList = args.FeedBackList;
                    _this.LastFeedBack = args.LastFeedBack;
                    _this.DocumentList = args.DocumentList;
                    _this.CurrentEmployment = args.CurrentEmployment;
                    _this.PreviousEmployment = args.PreviousEmployment;
                    return _this;
                }
                Contact.Type = "Selcomm.Contact.Contact";
                Contact.TypeParameters = [];
                return Contact;
            }(Selcomm.Objects.DataObject));
            Contact_1.Contact = Contact;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactSubType = (function (_super) {
                __extends(ContactSubType, _super);
                function ContactSubType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactSubType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Type = args.Type;
                    _this.SubTypeCode = args.SubTypeCode;
                    _this.SubTypeNarr = args.SubTypeNarr;
                    return _this;
                }
                ContactSubType.Type = "Selcomm.Contact.ContactSubType";
                ContactSubType.TypeParameters = [];
                return ContactSubType;
            }(Selcomm.Objects.DataObject));
            Contact.ContactSubType = ContactSubType;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactAlias = (function (_super) {
                __extends(ContactAlias, _super);
                function ContactAlias(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactAlias.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Type = args.Type;
                    _this.ContactCode = args.ContactCode;
                    _this.Name = args.Name;
                    return _this;
                }
                ContactAlias.Type = "Selcomm.Contact.ContactAlias";
                ContactAlias.TypeParameters = [];
                return ContactAlias;
            }(Selcomm.Objects.DataObject));
            Contact.ContactAlias = ContactAlias;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactAliasType = (function (_super) {
                __extends(ContactAliasType, _super);
                function ContactAliasType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactAliasType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    return _this;
                }
                ContactAliasType.Type = "Selcomm.Contact.ContactAliasType";
                ContactAliasType.TypeParameters = [];
                return ContactAliasType;
            }(Selcomm.Objects.DataObject));
            Contact.ContactAliasType = ContactAliasType;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactTitle = (function (_super) {
                __extends(ContactTitle, _super);
                function ContactTitle(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactTitle.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.Default = args.Default;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                ContactTitle.Type = "Selcomm.Contact.ContactTitle";
                ContactTitle.TypeParameters = [];
                return ContactTitle;
            }(Selcomm.Objects.DataObject));
            Contact.ContactTitle = ContactTitle;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var ContactPhones;
        (function (ContactPhones) {
            var ContactPhone = (function (_super) {
                __extends(ContactPhone, _super);
                function ContactPhone(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.ContactPhones.ContactPhone.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Reference = args.Reference;
                    _this.ContactPhoneType = args.ContactPhoneType;
                    _this.AreaCode = args.AreaCode;
                    _this.Number = args.Number;
                    _this.InValid = args.InValid;
                    _this.SupportsText = args.SupportsText;
                    _this.ContactCode = args.ContactCode;
                    return _this;
                }
                ContactPhone.Type = "Selcomm.ContactPhones.ContactPhone";
                ContactPhone.TypeParameters = [];
                return ContactPhone;
            }(Selcomm.Objects.DataObject));
            ContactPhones.ContactPhone = ContactPhone;
        })(ContactPhones = Selcomm.ContactPhones || (Selcomm.ContactPhones = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var ContactPhones;
        (function (ContactPhones) {
            var ContactPhoneType = (function (_super) {
                __extends(ContactPhoneType, _super);
                function ContactPhoneType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.ContactPhones.ContactPhoneType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.ContactRelated = args.ContactRelated;
                    _this.ServiceRelated = args.ServiceRelated;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                ContactPhoneType.Type = "Selcomm.ContactPhones.ContactPhoneType";
                ContactPhoneType.TypeParameters = [];
                return ContactPhoneType;
            }(Selcomm.Objects.DataObject));
            ContactPhones.ContactPhoneType = ContactPhoneType;
        })(ContactPhones = Selcomm.ContactPhones || (Selcomm.ContactPhones = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Email;
        (function (Email) {
            var EmailAddress = (function (_super) {
                __extends(EmailAddress, _super);
                function EmailAddress(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Email.EmailAddress.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.EmailAddress = args.EmailAddress;
                    _this.Invalid = args.Invalid;
                    return _this;
                }
                EmailAddress.Type = "Selcomm.Email.EmailAddress";
                EmailAddress.TypeParameters = [];
                return EmailAddress;
            }(Selcomm.Objects.DataObject));
            Email.EmailAddress = EmailAddress;
        })(Email = Selcomm.Email || (Selcomm.Email = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Email;
        (function (Email) {
            var ContactEmailAddress = (function (_super) {
                __extends(ContactEmailAddress, _super);
                function ContactEmailAddress(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Email.ContactEmailAddress.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ContactEmailType = args.ContactEmailType;
                    _this.ContactCode = args.ContactCode;
                    return _this;
                }
                ContactEmailAddress.Type = "Selcomm.Email.ContactEmailAddress";
                ContactEmailAddress.TypeParameters = [];
                return ContactEmailAddress;
            }(Selcomm.Email.EmailAddress));
            Email.ContactEmailAddress = ContactEmailAddress;
        })(Email = Selcomm.Email || (Selcomm.Email = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Email;
        (function (Email) {
            var ContactEmailType = (function (_super) {
                __extends(ContactEmailType, _super);
                function ContactEmailType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Email.ContactEmailType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    return _this;
                }
                ContactEmailType.Type = "Selcomm.Email.ContactEmailType";
                ContactEmailType.TypeParameters = [];
                return ContactEmailType;
            }(Selcomm.Objects.DataObject));
            Email.ContactEmailType = ContactEmailType;
        })(Email = Selcomm.Email || (Selcomm.Email = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Collections;
        (function (Collections) {
            var CollectionPlan = (function (_super) {
                __extends(CollectionPlan, _super);
                function CollectionPlan(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Collections.CollectionPlan.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                CollectionPlan.Type = "Selcomm.Collections.CollectionPlan";
                CollectionPlan.TypeParameters = [];
                return CollectionPlan;
            }(Selcomm.Objects.DataObject));
            Collections.CollectionPlan = CollectionPlan;
        })(Collections = Selcomm.Collections || (Selcomm.Collections = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Roles;
        (function (Roles) {
            var Role = (function (_super) {
                __extends(Role, _super);
                function Role(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Roles.Role.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    return _this;
                }
                Role.Type = "Selcomm.Roles.Role";
                Role.TypeParameters = [];
                return Role;
            }(Selcomm.Objects.DataObject));
            Roles.Role = Role;
        })(Roles = Selcomm.Roles || (Selcomm.Roles = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Authentication;
        (function (Authentication) {
            var SecretQuestionAndAnswers = (function (_super) {
                __extends(SecretQuestionAndAnswers, _super);
                function SecretQuestionAndAnswers(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Authentication.SecretQuestionAndAnswers.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ContactCode = args.ContactCode;
                    _this.Question = args.Question;
                    _this.QuestionText = args.QuestionText;
                    _this.Answer = args.Answer;
                    return _this;
                }
                SecretQuestionAndAnswers.Type = "Selcomm.Authentication.SecretQuestionAndAnswers";
                SecretQuestionAndAnswers.TypeParameters = [];
                return SecretQuestionAndAnswers;
            }(Selcomm.Objects.DataObject));
            Authentication.SecretQuestionAndAnswers = SecretQuestionAndAnswers;
        })(Authentication = Selcomm.Authentication || (Selcomm.Authentication = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Authentication;
        (function (Authentication) {
            var Question = (function (_super) {
                __extends(Question, _super);
                function Question(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Authentication.Question.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Question = args.Question;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                Question.Type = "Selcomm.Authentication.Question";
                Question.TypeParameters = [];
                return Question;
            }(Selcomm.Objects.DataObject));
            Authentication.Question = Question;
        })(Authentication = Selcomm.Authentication || (Selcomm.Authentication = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Authentication;
        (function (Authentication) {
            var SecretQuestionAndAnswersList = (function (_super) {
                __extends(SecretQuestionAndAnswersList, _super);
                function SecretQuestionAndAnswersList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Authentication.SecretQuestionAndAnswersList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                SecretQuestionAndAnswersList.Type = "Selcomm.Authentication.SecretQuestionAndAnswersList";
                SecretQuestionAndAnswersList.TypeParameters = [];
                return SecretQuestionAndAnswersList;
            }(Selcomm.Objects.ExtendedDataList));
            Authentication.SecretQuestionAndAnswersList = SecretQuestionAndAnswersList;
        })(Authentication = Selcomm.Authentication || (Selcomm.Authentication = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var BusinessUnits;
        (function (BusinessUnits) {
            var BusinessUnit = (function (_super) {
                __extends(BusinessUnit, _super);
                function BusinessUnit(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.BusinessUnits.BusinessUnit.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.Logo = args.Logo;
                    _this.BusinessName = args.BusinessName;
                    _this.ABN = args.ABN;
                    _this.ACN = args.ACN;
                    _this.Address = args.Address;
                    _this.ContactName = args.ContactName;
                    _this.ContactNumber = args.ContactNumber;
                    _this.ContactFax = args.ContactFax;
                    _this.ContactEmail = args.ContactEmail;
                    _this.WebsiteUrl = args.WebsiteUrl;
                    return _this;
                }
                BusinessUnit.Type = "Selcomm.BusinessUnits.BusinessUnit";
                BusinessUnit.TypeParameters = [];
                return BusinessUnit;
            }(Selcomm.Objects.DataObject));
            BusinessUnits.BusinessUnit = BusinessUnit;
        })(BusinessUnits = Selcomm.BusinessUnits || (Selcomm.BusinessUnits = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactRelationship = (function (_super) {
                __extends(ContactRelationship, _super);
                function ContactRelationship(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactRelationship.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ContactCode = args.ContactCode;
                    _this.Type = args.Type;
                    _this.RelatedContactCode = args.RelatedContactCode;
                    _this.Start = args.Start;
                    _this.RoleList = args.RoleList;
                    return _this;
                }
                ContactRelationship.Type = "Selcomm.Contact.ContactRelationship";
                ContactRelationship.TypeParameters = [];
                return ContactRelationship;
            }(Selcomm.Objects.DataObject));
            Contact.ContactRelationship = ContactRelationship;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactRelationshipType = (function (_super) {
                __extends(ContactRelationshipType, _super);
                function ContactRelationshipType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactRelationshipType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Visible = args.Visible;
                    _this.MinimumOccurences = args.MinimumOccurences;
                    _this.MaximumOccurences = args.MaximumOccurences;
                    _this.SelfRefer = args.SelfRefer;
                    _this.ContactRelated = args.ContactRelated;
                    _this.ServiceRelated = args.ServiceRelated;
                    _this.Note = args.Note;
                    _this.ObjectId = args.ObjectId;
                    _this.DeviceRelated = args.DeviceRelated;
                    _this.SiteRelated = args.SiteRelated;
                    return _this;
                }
                ContactRelationshipType.Type = "Selcomm.Contact.ContactRelationshipType";
                ContactRelationshipType.TypeParameters = [];
                return ContactRelationshipType;
            }(Selcomm.Objects.DataObject));
            Contact.ContactRelationshipType = ContactRelationshipType;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactRelationshipList = (function (_super) {
                __extends(ContactRelationshipList, _super);
                function ContactRelationshipList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactRelationshipList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ContactRelationshipList.Type = "Selcomm.Contact.ContactRelationshipList";
                ContactRelationshipList.TypeParameters = [];
                return ContactRelationshipList;
            }(Selcomm.Objects.ExtendedDataList));
            Contact.ContactRelationshipList = ContactRelationshipList;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task_1) {
            var Task = (function (_super) {
                __extends(Task, _super);
                function Task(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.Task.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Type = args.Type;
                    _this.Number = args.Number;
                    _this.ContactName = args.ContactName;
                    _this.RequesterName = args.RequesterName;
                    _this.Priority = args.Priority;
                    _this.Description = args.Description;
                    _this.Details = args.Details;
                    _this.VisibleToCustomer = args.VisibleToCustomer;
                    _this.PercentComplete = args.PercentComplete;
                    _this.ContactCode = args.ContactCode;
                    _this.ServiceId = args.ServiceId;
                    _this.CustomerReference = args.CustomerReference;
                    _this.Thread = args.Thread;
                    _this.EmailAddress = args.EmailAddress;
                    _this.TaskGroup = args.TaskGroup;
                    _this.Category = args.Category;
                    _this.CustomerOfClient = args.CustomerOfClient;
                    _this.Status = args.Status;
                    _this.StatusHistoryList = args.StatusHistoryList;
                    _this.ResolutionDetails = args.ResolutionDetails;
                    _this.Resolution = args.Resolution;
                    _this.Required = args.Required;
                    _this.Completed = args.Completed;
                    _this.EstimatedCompletion = args.EstimatedCompletion;
                    _this.SLADate = args.SLADate;
                    _this.FollowupDate = args.FollowupDate;
                    _this.FAQItem = args.FAQItem;
                    _this.FAQTag = args.FAQTag;
                    _this.QuotedHours = args.QuotedHours;
                    _this.QuotedPrice = args.QuotedPrice;
                    _this.QuotedFixed = args.QuotedFixed;
                    _this.InvoiceNumber = args.InvoiceNumber;
                    return _this;
                }
                Task.Type = "Selcomm.Task.Task";
                Task.TypeParameters = [];
                return Task;
            }(Selcomm.Objects.DataObject));
            Task_1.Task = Task;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var Type = (function (_super) {
                __extends(Type, _super);
                function Type(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.Type.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Narrative = args.Narrative;
                    _this.Category = args.Category;
                    _this.SLAInitialMinutes = args.SLAInitialMinutes;
                    _this.SLASubsequentMinutes = args.SLASubsequentMinutes;
                    _this.SLAMaximumReminders = args.SLAMaximumReminders;
                    _this.OpenSLAMinutes = args.OpenSLAMinutes;
                    _this.CustomerVisible = args.CustomerVisible;
                    _this.UserPromptMinutes = args.UserPromptMinutes;
                    _this.ResourcePromptMinutes = args.ResourcePromptMinutes;
                    _this.Active = args.Active;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Note = args.Note;
                    _this.ApprovalRequired = args.ApprovalRequired;
                    _this.CustomerEditable = args.CustomerEditable;
                    _this.ResourceLock = args.ResourceLock;
                    _this.AutomaticClosePeriod = args.AutomaticClosePeriod;
                    _this.Group = args.Group;
                    _this.DefaultPriority = args.DefaultPriority;
                    _this.DefaultStatus = args.DefaultStatus;
                    return _this;
                }
                Type.Type = "Selcomm.Task.Type";
                Type.TypeParameters = [];
                return Type;
            }(Selcomm.Objects.DataObject));
            Task.Type = Type;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var Category = (function (_super) {
                __extends(Category, _super);
                function Category(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.Category.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.Narrative = args.Narrative;
                    _this.Active = args.Active;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Note = args.Note;
                    return _this;
                }
                Category.Type = "Selcomm.Task.Category";
                Category.TypeParameters = [];
                return Category;
            }(Selcomm.Objects.DataObject));
            Task.Category = Category;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var TaskGroup = (function (_super) {
                __extends(TaskGroup, _super);
                function TaskGroup(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.TaskGroup.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.Active = args.Active;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                TaskGroup.Type = "Selcomm.Task.TaskGroup";
                TaskGroup.TypeParameters = [];
                return TaskGroup;
            }(Selcomm.Objects.DataObject));
            Task.TaskGroup = TaskGroup;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var Priority = (function (_super) {
                __extends(Priority, _super);
                function Priority(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.Priority.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.Narrative = args.Narrative;
                    _this.Active = args.Active;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                Priority.Type = "Selcomm.Task.Priority";
                Priority.TypeParameters = [];
                return Priority;
            }(Selcomm.Objects.DataObject));
            Task.Priority = Priority;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var Status = (function (_super) {
                __extends(Status, _super);
                function Status(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.Status.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.Narrative = args.Narrative;
                    _this.Active = args.Active;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.SystemStatus = args.SystemStatus;
                    _this.Dependency = args.Dependency;
                    return _this;
                }
                Status.Type = "Selcomm.Task.Status";
                Status.TypeParameters = [];
                return Status;
            }(Selcomm.Objects.DataObject));
            Task.Status = Status;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Status;
        (function (Status) {
            var SystemStatusType;
            (function (SystemStatusType) {
                SystemStatusType[SystemStatusType["Open"] = 0] = "Open";
                SystemStatusType[SystemStatusType["Completed"] = 1] = "Completed";
                SystemStatusType[SystemStatusType["Pending"] = 2] = "Pending";
                SystemStatusType[SystemStatusType["PendingApproval"] = 3] = "PendingApproval";
                SystemStatusType[SystemStatusType["Approved"] = 4] = "Approved";
                SystemStatusType[SystemStatusType["Declined"] = 5] = "Declined";
                SystemStatusType[SystemStatusType["Suspended"] = 6] = "Suspended";
                SystemStatusType[SystemStatusType["Cancelled"] = 7] = "Cancelled";
                SystemStatusType[SystemStatusType["Failed"] = 10] = "Failed";
                SystemStatusType[SystemStatusType["Unknown"] = 100] = "Unknown";
            })(SystemStatusType = Status.SystemStatusType || (Status.SystemStatusType = {}));
        })(Status = Selcomm.Status || (Selcomm.Status = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Dependency;
        (function (Dependency_1) {
            var Dependency;
            (function (Dependency) {
                Dependency[Dependency["Internal"] = 0] = "Internal";
                Dependency[Dependency["External"] = 1] = "External";
                Dependency[Dependency["Customer"] = 2] = "Customer";
            })(Dependency = Dependency_1.Dependency || (Dependency_1.Dependency = {}));
        })(Dependency = Selcomm.Dependency || (Selcomm.Dependency = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Threads;
        (function (Threads) {
            var Thread = (function (_super) {
                __extends(Thread, _super);
                function Thread(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Threads.Thread.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Reference = args.Reference;
                    _this.Header = args.Header;
                    _this.ThreadItemList = args.ThreadItemList;
                    return _this;
                }
                Thread.Type = "Selcomm.Threads.Thread";
                Thread.TypeParameters = [];
                return Thread;
            }(Selcomm.Objects.DataObject));
            Threads.Thread = Thread;
        })(Threads = Selcomm.Threads || (Selcomm.Threads = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Threads;
        (function (Threads) {
            var ThreadItem = (function (_super) {
                __extends(ThreadItem, _super);
                function ThreadItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Threads.ThreadItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Thread = args.Thread;
                    _this.Reference = args.Reference;
                    _this.Narrative = args.Narrative;
                    _this.Contact = args.Contact;
                    _this.Text = args.Text;
                    _this.Internal = args.Internal;
                    return _this;
                }
                ThreadItem.Type = "Selcomm.Threads.ThreadItem";
                ThreadItem.TypeParameters = [];
                return ThreadItem;
            }(Selcomm.Objects.DataObject));
            Threads.ThreadItem = ThreadItem;
        })(Threads = Selcomm.Threads || (Selcomm.Threads = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var StatusHistory = (function (_super) {
                __extends(StatusHistory, _super);
                function StatusHistory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.StatusHistory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.Task = args.Task;
                    _this.Status = args.Status;
                    _this.DateTime = args.DateTime;
                    _this.ChangedBy = args.ChangedBy;
                    return _this;
                }
                StatusHistory.Type = "Selcomm.Task.StatusHistory";
                StatusHistory.TypeParameters = [];
                return StatusHistory;
            }(Selcomm.Objects.DataObject));
            Task.StatusHistory = StatusHistory;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var Resolution = (function (_super) {
                __extends(Resolution, _super);
                function Resolution(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.Resolution.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.Narrative = args.Narrative;
                    _this.Active = args.Active;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                Resolution.Type = "Selcomm.Task.Resolution";
                Resolution.TypeParameters = [];
                return Resolution;
            }(Selcomm.Objects.DataObject));
            Task.Resolution = Resolution;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Identity;
        (function (Identity_1) {
            var Identity = (function (_super) {
                __extends(Identity, _super);
                function Identity(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Identity.Identity.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ContactCode = args.ContactCode;
                    _this.IdType = args.IdType;
                    _this.IdDetail = args.IdDetail;
                    _this.ExpiryDate = args.ExpiryDate;
                    return _this;
                }
                Identity.Type = "Selcomm.Identity.Identity";
                Identity.TypeParameters = [];
                return Identity;
            }(Selcomm.Objects.DataObject));
            Identity_1.Identity = Identity;
        })(Identity = Selcomm.Identity || (Selcomm.Identity = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Feedback;
        (function (Feedback_1) {
            var Feedback = (function (_super) {
                __extends(Feedback, _super);
                function Feedback(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Feedback.Feedback.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.CustomerFeedback = args.CustomerFeedback;
                    _this.ServiceProviderFeedback = args.ServiceProviderFeedback;
                    _this.ServiceProviderResponder = args.ServiceProviderResponder;
                    _this.ServiceProviderResponseDateTime = args.ServiceProviderResponseDateTime;
                    return _this;
                }
                Feedback.Type = "Selcomm.Feedback.Feedback";
                Feedback.TypeParameters = [];
                return Feedback;
            }(Selcomm.Objects.DataObject));
            Feedback_1.Feedback = Feedback;
        })(Feedback = Selcomm.Feedback || (Selcomm.Feedback = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Documents;
        (function (Documents) {
            var DocumentDisplay = (function (_super) {
                __extends(DocumentDisplay, _super);
                function DocumentDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Documents.DocumentDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.URL = args.URL;
                    _this.Note = args.Note;
                    _this.Author = args.Author;
                    _this.DateAuthored = args.DateAuthored;
                    _this.UserEditable = args.UserEditable;
                    _this.CustomerEditable = args.CustomerEditable;
                    _this.CustomerVisible = args.CustomerVisible;
                    return _this;
                }
                DocumentDisplay.Type = "Selcomm.Documents.DocumentDisplay";
                DocumentDisplay.TypeParameters = [];
                return DocumentDisplay;
            }(Selcomm.Objects.DataObject));
            Documents.DocumentDisplay = DocumentDisplay;
        })(Documents = Selcomm.Documents || (Selcomm.Documents = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Documents;
        (function (Documents) {
            var Document = (function (_super) {
                __extends(Document, _super);
                function Document(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Documents.Document.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Content = args.Content;
                    return _this;
                }
                Document.Type = "Selcomm.Documents.Document";
                Document.TypeParameters = [];
                return Document;
            }(Selcomm.Documents.DocumentDisplay));
            Documents.Document = Document;
        })(Documents = Selcomm.Documents || (Selcomm.Documents = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var EmploymentInfo = (function () {
                function EmploymentInfo(args) {
                    this.$type = Selcomm.Contact.EmploymentInfo.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Type = args.Type;
                    this.Occupation = args.Occupation;
                    this.EmployerName = args.EmployerName;
                    this.Country = args.Country;
                    this.EmploymentStart = args.EmploymentStart;
                    this.EmployerPhone = args.EmployerPhone;
                }
                EmploymentInfo.Type = "Selcomm.Contact.EmploymentInfo";
                EmploymentInfo.TypeParameters = [];
                return EmploymentInfo;
            }());
            Contact.EmploymentInfo = EmploymentInfo;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var EmploymentType;
            (function (EmploymentType) {
                EmploymentType[EmploymentType["Umemployed"] = 0] = "Umemployed";
                EmploymentType[EmploymentType["Casual"] = 1] = "Casual";
                EmploymentType[EmploymentType["Seasonal"] = 2] = "Seasonal";
                EmploymentType[EmploymentType["PartTime"] = 3] = "PartTime";
                EmploymentType[EmploymentType["FullTime"] = 4] = "FullTime";
                EmploymentType[EmploymentType["Contract"] = 5] = "Contract";
                EmploymentType[EmploymentType["SelfEmployed"] = 6] = "SelfEmployed";
            })(EmploymentType = Contact.EmploymentType || (Contact.EmploymentType = {}));
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var OccupationType;
            (function (OccupationType) {
                OccupationType[OccupationType["Other"] = 0] = "Other";
                OccupationType[OccupationType["Benefit"] = 1] = "Benefit";
                OccupationType[OccupationType["Retired"] = 2] = "Retired";
                OccupationType[OccupationType["Unskilled"] = 3] = "Unskilled";
                OccupationType[OccupationType["Trade"] = 4] = "Trade";
                OccupationType[OccupationType["Clerical"] = 5] = "Clerical";
                OccupationType[OccupationType["OfficeStaff"] = 6] = "OfficeStaff";
                OccupationType[OccupationType["Professional"] = 7] = "Professional";
                OccupationType[OccupationType["Executive"] = 8] = "Executive";
            })(OccupationType = Contact.OccupationType || (Contact.OccupationType = {}));
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var FinancialTransactionType = (function (_super) {
                __extends(FinancialTransactionType, _super);
                function FinancialTransactionType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Financials.FinancialTransactionType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.System = args.System;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    return _this;
                }
                FinancialTransactionType.Type = "Selcomm.Financials.FinancialTransactionType";
                FinancialTransactionType.TypeParameters = [];
                return FinancialTransactionType;
            }(Selcomm.Objects.DataObject));
            Financials.FinancialTransactionType = FinancialTransactionType;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var FinancialTransactionCategory = (function (_super) {
                __extends(FinancialTransactionCategory, _super);
                function FinancialTransactionCategory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Financials.FinancialTransactionCategory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    return _this;
                }
                FinancialTransactionCategory.Type = "Selcomm.Financials.FinancialTransactionCategory";
                FinancialTransactionCategory.TypeParameters = [];
                return FinancialTransactionCategory;
            }(Selcomm.Objects.DataObject));
            Financials.FinancialTransactionCategory = FinancialTransactionCategory;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var FinancialTransactionStatus = (function (_super) {
                __extends(FinancialTransactionStatus, _super);
                function FinancialTransactionStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Financials.FinancialTransactionStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    _this.System = args.System;
                    return _this;
                }
                FinancialTransactionStatus.Type = "Selcomm.Financials.FinancialTransactionStatus";
                FinancialTransactionStatus.TypeParameters = [];
                return FinancialTransactionStatus;
            }(Selcomm.Objects.DataObject));
            Financials.FinancialTransactionStatus = FinancialTransactionStatus;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var FinancialTransactionReason = (function (_super) {
                __extends(FinancialTransactionReason, _super);
                function FinancialTransactionReason(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Financials.FinancialTransactionReason.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.System = args.System;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    return _this;
                }
                FinancialTransactionReason.Type = "Selcomm.Financials.FinancialTransactionReason";
                FinancialTransactionReason.TypeParameters = [];
                return FinancialTransactionReason;
            }(Selcomm.Objects.DataObject));
            Financials.FinancialTransactionReason = FinancialTransactionReason;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var AccountType;
            (function (AccountType) {
                AccountType[AccountType["Debtor"] = 0] = "Debtor";
                AccountType[AccountType["Creditor"] = 1] = "Creditor";
            })(AccountType = Financials.AccountType || (Financials.AccountType = {}));
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentRequest = (function (_super) {
                __extends(PaymentRequest, _super);
                function PaymentRequest(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentRequest.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Priority = args.Priority;
                    _this.ContactCode = args.ContactCode;
                    _this.FinancialTransaction = args.FinancialTransaction;
                    _this.AccountPaymentMethod = args.AccountPaymentMethod;
                    _this.PaymentBatch = args.PaymentBatch;
                    _this.PaymentProvider = args.PaymentProvider;
                    _this.PaymentSource = args.PaymentSource;
                    _this.PayRequestType = args.PayRequestType;
                    _this.PayRequestStatus = args.PayRequestStatus;
                    _this.SystemStatus = args.SystemStatus;
                    _this.PaymentRequestStatusReason = args.PaymentRequestStatusReason;
                    _this.RequestDateTime = args.RequestDateTime;
                    _this.NumberOfPolls = args.NumberOfPolls;
                    _this.LastPolled = args.LastPolled;
                    _this.LastSubmitted = args.LastSubmitted;
                    _this.NumberOfSubmissions = args.NumberOfSubmissions;
                    _this.SettlementDate = args.SettlementDate;
                    _this.Reconciled = args.Reconciled;
                    _this.ManuallyAuthorised = args.ManuallyAuthorised;
                    _this.SurchargeAmount = args.SurchargeAmount;
                    _this.RequestAmount = args.RequestAmount;
                    _this.TaxAmount = args.TaxAmount;
                    _this.ReferenceNumber = args.ReferenceNumber;
                    _this.AuthorisationNumber = args.AuthorisationNumber;
                    _this.PreAuthorisationNumber = args.PreAuthorisationNumber;
                    _this.STAN = args.STAN;
                    _this.ProviderReferenceNumber = args.ProviderReferenceNumber;
                    _this.MerchantNumber = args.MerchantNumber;
                    _this.LastErrorCode = args.LastErrorCode;
                    _this.LastError = args.LastError;
                    _this.RequestingUser = args.RequestingUser;
                    _this.OriginalRequestId = args.OriginalRequestId;
                    return _this;
                }
                PaymentRequest.Type = "Selcomm.Payment.PaymentRequest";
                PaymentRequest.TypeParameters = [];
                return PaymentRequest;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentRequest = PaymentRequest;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var AccountPaymentMethod = (function (_super) {
                __extends(AccountPaymentMethod, _super);
                function AccountPaymentMethod(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.AccountPaymentMethod.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.PaymentMethod = args.PaymentMethod;
                    _this.Status = args.Status;
                    _this.AccountNumber = args.AccountNumber;
                    _this.AccountName = args.AccountName;
                    _this.BSB = args.BSB;
                    _this.ExpiryDate = args.ExpiryDate;
                    _this.SubscriberOwns = args.SubscriberOwns;
                    _this.Protected = args.Protected;
                    _this.Masked = args.Masked;
                    _this.Exported = args.Exported;
                    _this.ExternalReference1 = args.ExternalReference1;
                    _this.ExternalReference2 = args.ExternalReference2;
                    _this.ContactCode = args.ContactCode;
                    _this.StartDate = args.StartDate;
                    _this.EndDate = args.EndDate;
                    _this.Used = args.Used;
                    _this.LastUsedDate = args.LastUsedDate;
                    _this.BillingHoldActive = args.BillingHoldActive;
                    _this.Default = args.Default;
                    _this.StandingAuthorisationDefault = args.StandingAuthorisationDefault;
                    _this.FinancialTransactionList = args.FinancialTransactionList;
                    _this.AccountPaymentMethodHistoryList = args.AccountPaymentMethodHistoryList;
                    return _this;
                }
                AccountPaymentMethod.Type = "Selcomm.Payment.AccountPaymentMethod";
                AccountPaymentMethod.TypeParameters = [];
                return AccountPaymentMethod;
            }(Selcomm.Objects.DataObject));
            Payment.AccountPaymentMethod = AccountPaymentMethod;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentMethod = (function (_super) {
                __extends(PaymentMethod, _super);
                function PaymentMethod(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentMethod.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Type = args.Type;
                    _this.Description = args.Description;
                    _this.Protectable = args.Protectable;
                    _this.Exportable = args.Exportable;
                    _this.Mask = args.Mask;
                    _this.BankAccount = args.BankAccount;
                    _this.ClearingAccount = args.ClearingAccount;
                    _this.SurchargeRevenueAccount = args.SurchargeRevenueAccount;
                    _this.PaymentProvider = args.PaymentProvider;
                    return _this;
                }
                PaymentMethod.Type = "Selcomm.Payment.PaymentMethod";
                PaymentMethod.TypeParameters = [];
                return PaymentMethod;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentMethod = PaymentMethod;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentMethodType = (function (_super) {
                __extends(PaymentMethodType, _super);
                function PaymentMethodType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentMethodType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    _this.AccountNumberDisplayLabel = args.AccountNumberDisplayLabel;
                    _this.AccountNameDisplayLabel = args.AccountNameDisplayLabel;
                    _this.BSBDisplayLabel = args.BSBDisplayLabel;
                    _this.BSBRequired = args.BSBRequired;
                    _this.ExpiryDisplayLabel = args.ExpiryDisplayLabel;
                    _this.ExpiryDateRequired = args.ExpiryDateRequired;
                    _this.SubscriberOwnsDisplayLabel = args.SubscriberOwnsDisplayLabel;
                    _this.SubscriberOwnsRequired = args.SubscriberOwnsRequired;
                    _this.ValidationTypeCode = args.ValidationTypeCode;
                    return _this;
                }
                PaymentMethodType.Type = "Selcomm.Payment.PaymentMethodType";
                PaymentMethodType.TypeParameters = [];
                return PaymentMethodType;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentMethodType = PaymentMethodType;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bank;
        (function (Bank) {
            var BankAccount = (function (_super) {
                __extends(BankAccount, _super);
                function BankAccount(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bank.BankAccount.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.BSB = args.BSB;
                    _this.AccountNumber = args.AccountNumber;
                    _this.Currency = args.Currency;
                    _this.Bank = args.Bank;
                    _this.ClearingAccount = args.ClearingAccount;
                    return _this;
                }
                BankAccount.Type = "Selcomm.Bank.BankAccount";
                BankAccount.TypeParameters = [];
                return BankAccount;
            }(Selcomm.Objects.DataObject));
            Bank.BankAccount = BankAccount;
        })(Bank = Selcomm.Bank || (Selcomm.Bank = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Bank;
        (function (Bank_1) {
            var Bank = (function (_super) {
                __extends(Bank, _super);
                function Bank(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Bank.Bank.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    return _this;
                }
                Bank.Type = "Selcomm.Bank.Bank";
                Bank.TypeParameters = [];
                return Bank;
            }(Selcomm.Objects.DataObject));
            Bank_1.Bank = Bank;
        })(Bank = Selcomm.Bank || (Selcomm.Bank = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var GeneralLedger;
        (function (GeneralLedger) {
            var GeneralLedgerAccount = (function (_super) {
                __extends(GeneralLedgerAccount, _super);
                function GeneralLedgerAccount(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.GeneralLedger.GeneralLedgerAccount.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Display = args.Display;
                    _this.Type = args.Type;
                    return _this;
                }
                GeneralLedgerAccount.Type = "Selcomm.GeneralLedger.GeneralLedgerAccount";
                GeneralLedgerAccount.TypeParameters = [];
                return GeneralLedgerAccount;
            }(Selcomm.Objects.DataObject));
            GeneralLedger.GeneralLedgerAccount = GeneralLedgerAccount;
        })(GeneralLedger = Selcomm.GeneralLedger || (Selcomm.GeneralLedger = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var GeneralLedger;
        (function (GeneralLedger) {
            var GeneralLedgerAccountType = (function (_super) {
                __extends(GeneralLedgerAccountType, _super);
                function GeneralLedgerAccountType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.GeneralLedger.GeneralLedgerAccountType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                GeneralLedgerAccountType.Type = "Selcomm.GeneralLedger.GeneralLedgerAccountType";
                GeneralLedgerAccountType.TypeParameters = [];
                return GeneralLedgerAccountType;
            }(Selcomm.Objects.DataObject));
            GeneralLedger.GeneralLedgerAccountType = GeneralLedgerAccountType;
        })(GeneralLedger = Selcomm.GeneralLedger || (Selcomm.GeneralLedger = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentProvider = (function (_super) {
                __extends(PaymentProvider, _super);
                function PaymentProvider(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentProvider.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    _this.OnlineAvailable = args.OnlineAvailable;
                    _this.MaximumNumberOfThreads = args.MaximumNumberOfThreads;
                    _this.Application = args.Application;
                    _this.ApprovalsProvided = args.ApprovalsProvided;
                    _this.GenerateReceiptNotifications = args.GenerateReceiptNotifications;
                    _this.SupportsRefunds = args.SupportsRefunds;
                    _this.GenerateEmptyFiles = args.GenerateEmptyFiles;
                    _this.FileType = args.FileType;
                    _this.DefaultCurrency = args.DefaultCurrency;
                    _this.SupportedCurrenciesList = args.SupportedCurrenciesList;
                    _this.AttributeList = args.AttributeList;
                    _this.CardUpdatesAllowed = args.CardUpdatesAllowed;
                    _this.IsTokanised = args.IsTokanised;
                    _this.IsProcessedImmediately = args.IsProcessedImmediately;
                    return _this;
                }
                PaymentProvider.Type = "Selcomm.Payment.PaymentProvider";
                PaymentProvider.TypeParameters = [];
                return PaymentProvider;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentProvider = PaymentProvider;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentProviderAttibute = (function (_super) {
                __extends(PaymentProviderAttibute, _super);
                function PaymentProviderAttibute(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentProviderAttibute.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Key = args.Key;
                    _this.Value = args.Value;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    return _this;
                }
                PaymentProviderAttibute.Type = "Selcomm.Payment.PaymentProviderAttibute";
                PaymentProviderAttibute.TypeParameters = [];
                return PaymentProviderAttibute;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentProviderAttibute = PaymentProviderAttibute;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var AccountPaymentMethodStatus = (function (_super) {
                __extends(AccountPaymentMethodStatus, _super);
                function AccountPaymentMethodStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.AccountPaymentMethodStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.SystemStatus = args.SystemStatus;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    return _this;
                }
                AccountPaymentMethodStatus.Type = "Selcomm.Payment.AccountPaymentMethodStatus";
                AccountPaymentMethodStatus.TypeParameters = [];
                return AccountPaymentMethodStatus;
            }(Selcomm.Objects.DataObject));
            Payment.AccountPaymentMethodStatus = AccountPaymentMethodStatus;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var FinancialTransactionList = (function (_super) {
                __extends(FinancialTransactionList, _super);
                function FinancialTransactionList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Financials.FinancialTransactionList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.TotalNumberOfRecords = args.TotalNumberOfRecords;
                    return _this;
                }
                FinancialTransactionList.Type = "Selcomm.Financials.FinancialTransactionList";
                FinancialTransactionList.TypeParameters = [];
                return FinancialTransactionList;
            }(Selcomm.Objects.ExtendedDataList));
            Financials.FinancialTransactionList = FinancialTransactionList;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var AccountPaymentMethodStatusHistory = (function (_super) {
                __extends(AccountPaymentMethodStatusHistory, _super);
                function AccountPaymentMethodStatusHistory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.AccountPaymentMethodStatusHistory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.AccountPaymentMethodStatus = args.AccountPaymentMethodStatus;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                AccountPaymentMethodStatusHistory.Type = "Selcomm.Payment.AccountPaymentMethodStatusHistory";
                AccountPaymentMethodStatusHistory.TypeParameters = [];
                return AccountPaymentMethodStatusHistory;
            }(Selcomm.Objects.DataObject));
            Payment.AccountPaymentMethodStatusHistory = AccountPaymentMethodStatusHistory;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentBatch = (function (_super) {
                __extends(PaymentBatch, _super);
                function PaymentBatch(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentBatch.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.CreatedDateTime = args.CreatedDateTime;
                    _this.SentDateTime = args.SentDateTime;
                    return _this;
                }
                PaymentBatch.Type = "Selcomm.Payment.PaymentBatch";
                PaymentBatch.TypeParameters = [];
                return PaymentBatch;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentBatch = PaymentBatch;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentSource = (function (_super) {
                __extends(PaymentSource, _super);
                function PaymentSource(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentSource.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    return _this;
                }
                PaymentSource.Type = "Selcomm.Payment.PaymentSource";
                PaymentSource.TypeParameters = [];
                return PaymentSource;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentSource = PaymentSource;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentRequestType = (function (_super) {
                __extends(PaymentRequestType, _super);
                function PaymentRequestType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentRequestType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    return _this;
                }
                PaymentRequestType.Type = "Selcomm.Payment.PaymentRequestType";
                PaymentRequestType.TypeParameters = [];
                return PaymentRequestType;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentRequestType = PaymentRequestType;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentRequestStatus = (function (_super) {
                __extends(PaymentRequestStatus, _super);
                function PaymentRequestStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentRequestStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.SystemStatus = args.SystemStatus;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    return _this;
                }
                PaymentRequestStatus.Type = "Selcomm.Payment.PaymentRequestStatus";
                PaymentRequestStatus.TypeParameters = [];
                return PaymentRequestStatus;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentRequestStatus = PaymentRequestStatus;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentRequestStatusReason = (function (_super) {
                __extends(PaymentRequestStatusReason, _super);
                function PaymentRequestStatusReason(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentRequestStatusReason.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    return _this;
                }
                PaymentRequestStatusReason.Type = "Selcomm.Payment.PaymentRequestStatusReason";
                PaymentRequestStatusReason.TypeParameters = [];
                return PaymentRequestStatusReason;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentRequestStatusReason = PaymentRequestStatusReason;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentRequestList = (function (_super) {
                __extends(PaymentRequestList, _super);
                function PaymentRequestList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentRequestList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                PaymentRequestList.Type = "Selcomm.Payment.PaymentRequestList";
                PaymentRequestList.TypeParameters = [];
                return PaymentRequestList;
            }(Selcomm.Objects.ExtendedDataList));
            Payment.PaymentRequestList = PaymentRequestList;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Account;
        (function (Account_1) {
            var Account = (function (_super) {
                __extends(Account, _super);
                function Account(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Account.Account.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.BillFormat = args.BillFormat;
                    _this.BillCycle = args.BillCycle;
                    _this.AccountKey = args.AccountKey;
                    return _this;
                }
                Account.Type = "Selcomm.Account.Account";
                Account.TypeParameters = [];
                return Account;
            }(Selcomm.Contact.Contact));
            Account_1.Account = Account;
        })(Account = Selcomm.Account || (Selcomm.Account = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var BusinessUnits;
        (function (BusinessUnits) {
            var BusinessUnitList = (function (_super) {
                __extends(BusinessUnitList, _super);
                function BusinessUnitList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.BusinessUnits.BusinessUnitList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                BusinessUnitList.Type = "Selcomm.BusinessUnits.BusinessUnitList";
                BusinessUnitList.TypeParameters = [];
                return BusinessUnitList;
            }(Selcomm.Objects.ExtendedDataList));
            BusinessUnits.BusinessUnitList = BusinessUnitList;
        })(BusinessUnits = Selcomm.BusinessUnits || (Selcomm.BusinessUnits = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Charges;
        (function (Charges) {
            var Charge = (function (_super) {
                __extends(Charge, _super);
                function Charge(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Charges.Charge.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.ChargeGroup = args.ChargeGroup;
                    _this.Description = args.Description;
                    _this.DisplayDescription = args.DisplayDescription;
                    _this.Unit = args.Unit;
                    _this.Frequency = args.Frequency;
                    _this.ChargeInAdvance = args.ChargeInAdvance;
                    _this.AdvanceChargePeriods = args.AdvanceChargePeriods;
                    _this.ProRate = args.ProRate;
                    _this.StandardRate = args.StandardRate;
                    _this.ChargeAnniversaryType = args.ChargeAnniversaryType;
                    _this.PrintOnInvoice = args.PrintOnInvoice;
                    _this.CostTaxEx = args.CostTaxEx;
                    _this.ChargeAmount = args.ChargeAmount;
                    _this.ChargeAmountTax = args.ChargeAmountTax;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Consolidate = args.Consolidate;
                    _this.ChargeInvoiceGroup = args.ChargeInvoiceGroup;
                    _this.ServiceProviderChargeCode = args.ServiceProviderChargeCode;
                    _this.GeneralLedgerAccount = args.GeneralLedgerAccount;
                    return _this;
                }
                Charge.Type = "Selcomm.Charges.Charge";
                Charge.TypeParameters = [];
                return Charge;
            }(Selcomm.Objects.DataObject));
            Charges.Charge = Charge;
        })(Charges = Selcomm.Charges || (Selcomm.Charges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Charges;
        (function (Charges) {
            var ChargeGroup = (function (_super) {
                __extends(ChargeGroup, _super);
                function ChargeGroup(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Charges.ChargeGroup.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.ParentChargeGroup = args.ParentChargeGroup;
                    return _this;
                }
                ChargeGroup.Type = "Selcomm.Charges.ChargeGroup";
                ChargeGroup.TypeParameters = [];
                return ChargeGroup;
            }(Selcomm.Objects.DataObject));
            Charges.ChargeGroup = ChargeGroup;
        })(Charges = Selcomm.Charges || (Selcomm.Charges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Charges;
        (function (Charges) {
            var ChargeAnniversaryType = (function (_super) {
                __extends(ChargeAnniversaryType, _super);
                function ChargeAnniversaryType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Charges.ChargeAnniversaryType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                ChargeAnniversaryType.Type = "Selcomm.Charges.ChargeAnniversaryType";
                ChargeAnniversaryType.TypeParameters = [];
                return ChargeAnniversaryType;
            }(Selcomm.Objects.DataObject));
            Charges.ChargeAnniversaryType = ChargeAnniversaryType;
        })(Charges = Selcomm.Charges || (Selcomm.Charges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Charges;
        (function (Charges) {
            var ChargeInvoiceGroup = (function (_super) {
                __extends(ChargeInvoiceGroup, _super);
                function ChargeInvoiceGroup(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Charges.ChargeInvoiceGroup.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                ChargeInvoiceGroup.Type = "Selcomm.Charges.ChargeInvoiceGroup";
                ChargeInvoiceGroup.TypeParameters = [];
                return ChargeInvoiceGroup;
            }(Selcomm.Objects.DataObject));
            Charges.ChargeInvoiceGroup = ChargeInvoiceGroup;
        })(Charges = Selcomm.Charges || (Selcomm.Charges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Charges;
        (function (Charges) {
            var ChargeList = (function (_super) {
                __extends(ChargeList, _super);
                function ChargeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Charges.ChargeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ChargeList.Type = "Selcomm.Charges.ChargeList";
                ChargeList.TypeParameters = [];
                return ChargeList;
            }(Selcomm.Objects.ExtendedDataList));
            Charges.ChargeList = ChargeList;
        })(Charges = Selcomm.Charges || (Selcomm.Charges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Chart;
        (function (Chart_1) {
            var Chart = (function (_super) {
                __extends(Chart, _super);
                function Chart(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Chart.Chart.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Name = args.Name;
                    _this.SeriesList = args.SeriesList;
                    _this.XAxisTitle = args.XAxisTitle;
                    _this.YAxisTitle = args.YAxisTitle;
                    _this.Filter = args.Filter;
                    return _this;
                }
                Chart.Type = "Selcomm.Chart.Chart";
                Chart.TypeParameters = [];
                return Chart;
            }(Selcomm.Objects.DisplayBaseObject));
            Chart_1.Chart = Chart;
        })(Chart = Selcomm.Chart || (Selcomm.Chart = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Chart;
        (function (Chart) {
            var Series = (function () {
                function Series(args) {
                    this.$type = Selcomm.Chart.Series.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Name = args.Name;
                    this.DataPointList = args.DataPointList;
                }
                Series.Type = "Selcomm.Chart.Series";
                Series.TypeParameters = [];
                return Series;
            }());
            Chart.Series = Series;
        })(Chart = Selcomm.Chart || (Selcomm.Chart = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Chart;
        (function (Chart) {
            var DataPoint = (function () {
                function DataPoint(args) {
                    this.$type = Selcomm.Chart.DataPoint.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.XValue = args.XValue;
                    this.YValue = args.YValue;
                    this.Annotation = args.Annotation;
                }
                DataPoint.Type = "Selcomm.Chart.DataPoint";
                DataPoint.TypeParameters = [];
                return DataPoint;
            }());
            Chart.DataPoint = DataPoint;
        })(Chart = Selcomm.Chart || (Selcomm.Chart = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Chart;
        (function (Chart) {
            var Filter = (function () {
                function Filter(args) {
                    this.$type = Selcomm.Chart.Filter.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Name = args.Name;
                    this.FilterItems = args.FilterItems;
                }
                Filter.Type = "Selcomm.Chart.Filter";
                Filter.TypeParameters = [];
                return Filter;
            }());
            Chart.Filter = Filter;
        })(Chart = Selcomm.Chart || (Selcomm.Chart = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Chart;
        (function (Chart) {
            var FilterItem = (function () {
                function FilterItem(args) {
                    this.$type = Selcomm.Chart.FilterItem.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Label = args.Label;
                    this.ToolTip = args.ToolTip;
                    this.DataType = args.DataType;
                    this.Mandatory = args.Mandatory;
                    this.ValueList = args.ValueList;
                }
                FilterItem.Type = "Selcomm.Chart.FilterItem";
                FilterItem.TypeParameters = [];
                return FilterItem;
            }());
            Chart.FilterItem = FilterItem;
        })(Chart = Selcomm.Chart || (Selcomm.Chart = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var DataTypes;
        (function (DataTypes) {
            var DataType;
            (function (DataType) {
                DataType[DataType["Undefined"] = 0] = "Undefined";
                DataType[DataType["String"] = 100] = "String";
                DataType[DataType["Boolean"] = 200] = "Boolean";
                DataType[DataType["StringList"] = 300] = "StringList";
                DataType[DataType["Date"] = 400] = "Date";
                DataType[DataType["DateTime"] = 500] = "DateTime";
                DataType[DataType["Long"] = 600] = "Long";
                DataType[DataType["Decimal"] = 700] = "Decimal";
                DataType[DataType["Currency"] = 800] = "Currency";
                DataType[DataType["DateRange"] = 900] = "DateRange";
                DataType[DataType["QBF"] = 1000] = "QBF";
                DataType[DataType["Time"] = 1100] = "Time";
                DataType[DataType["Account"] = 1200] = "Account";
                DataType[DataType["ReportPeriod"] = 1300] = "ReportPeriod";
                DataType[DataType["FromDate"] = 1400] = "FromDate";
                DataType[DataType["ToDate"] = 1500] = "ToDate";
            })(DataType = DataTypes.DataType || (DataTypes.DataType = {}));
        })(DataTypes = Selcomm.DataTypes || (Selcomm.DataTypes = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Chart;
        (function (Chart) {
            var FilterItemValueItem = (function () {
                function FilterItemValueItem(args) {
                    this.$type = Selcomm.Chart.FilterItemValueItem.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Key = args.Key;
                    this.Value = args.Value;
                    this.UserValue = args.UserValue;
                }
                FilterItemValueItem.Type = "Selcomm.Chart.FilterItemValueItem";
                FilterItemValueItem.TypeParameters = [];
                return FilterItemValueItem;
            }());
            Chart.FilterItemValueItem = FilterItemValueItem;
        })(Chart = Selcomm.Chart || (Selcomm.Chart = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var Type = (function (_super) {
                __extends(Type, _super);
                function Type(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.Type.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ContactTypeCategory = args.ContactTypeCategory;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.Display = args.Display;
                    _this.Default = args.Default;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.System = args.System;
                    return _this;
                }
                Type.Type = "Selcomm.Contact.Type";
                Type.TypeParameters = [];
                return Type;
            }(Selcomm.Objects.DataObject));
            Contact.Type = Type;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactTypeCategory;
            (function (ContactTypeCategory) {
                ContactTypeCategory[ContactTypeCategory["Personal"] = 0] = "Personal";
                ContactTypeCategory[ContactTypeCategory["Corporate"] = 1] = "Corporate";
            })(ContactTypeCategory = Contact.ContactTypeCategory || (Contact.ContactTypeCategory = {}));
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Authentication;
        (function (Authentication) {
            var AuthenticationResultType;
            (function (AuthenticationResultType) {
                AuthenticationResultType[AuthenticationResultType["UnknownError"] = 0] = "UnknownError";
                AuthenticationResultType[AuthenticationResultType["Success"] = 1] = "Success";
                AuthenticationResultType[AuthenticationResultType["LoginCodeOrPasswordError"] = 2] = "LoginCodeOrPasswordError";
                AuthenticationResultType[AuthenticationResultType["NotAuthorised"] = 3] = "NotAuthorised";
                AuthenticationResultType[AuthenticationResultType["MustChangePassword"] = 4] = "MustChangePassword";
                AuthenticationResultType[AuthenticationResultType["LoginBlocked"] = 5] = "LoginBlocked";
                AuthenticationResultType[AuthenticationResultType["TFACodeNotFound"] = 6] = "TFACodeNotFound";
                AuthenticationResultType[AuthenticationResultType["TFACodeIncorrect"] = 7] = "TFACodeIncorrect";
                AuthenticationResultType[AuthenticationResultType["TFACodeExpired"] = 8] = "TFACodeExpired";
                AuthenticationResultType[AuthenticationResultType["TFACodeRetriesExceeded"] = 9] = "TFACodeRetriesExceeded";
                AuthenticationResultType[AuthenticationResultType["InvalidEmailAddress"] = 10] = "InvalidEmailAddress";
                AuthenticationResultType[AuthenticationResultType["InvalidPhoneNum"] = 11] = "InvalidPhoneNum";
                AuthenticationResultType[AuthenticationResultType["WrongSite"] = 12] = "WrongSite";
            })(AuthenticationResultType = Authentication.AuthenticationResultType || (Authentication.AuthenticationResultType = {}));
            var TfaVerificationCodeSendOptionsAndInfoLink = (function () {
                function TfaVerificationCodeSendOptionsAndInfoLink(args) {
                    this.$type = Selcomm.Authentication.TfaVerificationCodeSendOptionsAndInfoLink.Type;
                    if (!args) {
                        return;
                    }
                    this.Status = args.Status;
                    this.ObvoscatedEmailAddr = args.ObvoscatedEmailAddr;
                    this.ObvoscatedPhoneNum = args.ObvoscatedPhoneNum;
                    this.TfaMoreInfoHelpUrl = args.TfaMoreInfoHelpUrl;
                    this.ErrorMessage = args.ErrorMessage;
                }
                TfaVerificationCodeSendOptionsAndInfoLink.Type = "Selcomm.Authentication.TfaVerificationCodeSendOptionsAndInfoLink";
                TfaVerificationCodeSendOptionsAndInfoLink.TypeParameters = [];
                return TfaVerificationCodeSendOptionsAndInfoLink;
            }());
            Authentication.TfaVerificationCodeSendOptionsAndInfoLink = TfaVerificationCodeSendOptionsAndInfoLink;
            var TfaSendCodeReponse = (function () {
                function TfaSendCodeReponse(args) {
                    this.$type = Selcomm.Authentication.TfaSendCodeReponse.Type;
                    if (!args) {
                        return;
                    }
                    this.Status = args.Status;
                    this.ObvoscatedEmailAddr = args.ObvoscatedEmailAddr;
                    this.ObvoscatedPhoneNum = args.ObvoscatedPhoneNum;
                    this.ErrorMessage = args.ErrorMessage;
                }
                TfaSendCodeReponse.Type = "Selcomm.Authentication.TfaSendCodeReponse";
                TfaSendCodeReponse.TypeParameters = [];
                return TfaSendCodeReponse;
            }());
            Authentication.TfaSendCodeReponse = TfaSendCodeReponse;
        })(Authentication = Selcomm.Authentication || (Selcomm.Authentication = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var AuthorisedAccount = (function (_super) {
                __extends(AuthorisedAccount, _super);
                function AuthorisedAccount(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.AuthorisedAccount.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AuthorisedAccount.Type = "Selcomm.Contact.AuthorisedAccount";
                AuthorisedAccount.TypeParameters = [];
                return AuthorisedAccount;
            }(Selcomm.Account.Account));
            Contact.AuthorisedAccount = AuthorisedAccount;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var AuthorisedAccountDisplay = (function () {
                function AuthorisedAccountDisplay(args) {
                    this.$type = Selcomm.Contact.AuthorisedAccountDisplay.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Code = args.Code;
                    this.Name = args.Name;
                    this.Relationships = args.Relationships;
                    this.RoleList = args.RoleList;
                }
                AuthorisedAccountDisplay.Type = "Selcomm.Contact.AuthorisedAccountDisplay";
                AuthorisedAccountDisplay.TypeParameters = [];
                return AuthorisedAccountDisplay;
            }());
            Contact.AuthorisedAccountDisplay = AuthorisedAccountDisplay;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var UI;
        (function (UI) {
            var UIAttributeItem = (function (_super) {
                __extends(UIAttributeItem, _super);
                function UIAttributeItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.UI.UIAttributeItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.AttributeId = args.AttributeId;
                    _this.AttributeLabel = args.AttributeLabel;
                    _this.AttributeValue = args.AttributeValue;
                    _this.IconId = args.IconId;
                    _this.MenuId = args.MenuId;
                    _this.EditType = args.EditType;
                    _this.AttributeType = args.AttributeType;
                    _this.AttributeDataType = args.AttributeDataType;
                    _this.AttributeKey = args.AttributeKey;
                    _this.ObjectID = args.ObjectID;
                    _this.TokenID = args.TokenID;
                    _this.Value = args.Value;
                    return _this;
                }
                UIAttributeItem.Type = "Selcomm.UI.UIAttributeItem";
                UIAttributeItem.TypeParameters = [];
                return UIAttributeItem;
            }(Selcomm.Objects.DisplayBaseObject));
            UI.UIAttributeItem = UIAttributeItem;
        })(UI = Selcomm.UI || (Selcomm.UI = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactDisplay = (function (_super) {
                __extends(ContactDisplay, _super);
                function ContactDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Type = args.Type;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.Address = args.Address;
                    _this.ContactPhone = args.ContactPhone;
                    _this.Email = args.Email;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.BusinessUnit = args.BusinessUnit;
                    _this.Status = args.Status;
                    _this.ServiceDisplayList = args.ServiceDisplayList;
                    return _this;
                }
                ContactDisplay.Type = "Selcomm.Contact.ContactDisplay";
                ContactDisplay.TypeParameters = [];
                return ContactDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Contact.ContactDisplay = ContactDisplay;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceDisplay = (function (_super) {
                __extends(ServiceDisplay, _super);
                function ServiceDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ConnectionDateTime = args.ConnectionDateTime;
                    _this.DisconnectionDateTime = args.DisconnectionDateTime;
                    _this.HasChildren = args.HasChildren;
                    _this.BillingStartDateTime = args.BillingStartDateTime;
                    _this.BillingEndDateTime = args.BillingEndDateTime;
                    _this.Id = args.Id;
                    _this.ParentServiceId = args.ParentServiceId;
                    _this.ServiceSalesPerson = args.ServiceSalesPerson;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.Description = args.Description;
                    _this.ServiceType = args.ServiceType;
                    _this.ServiceTypeCode = args.ServiceTypeCode;
                    _this.ServiceTypeBillDescription = args.ServiceTypeBillDescription;
                    _this.ServiceStatus = args.ServiceStatus;
                    _this.ServiceStatusCode = args.ServiceStatusCode;
                    _this.ServiceStatusPhase = args.ServiceStatusPhase;
                    _this.ServiceSystemStatus = args.ServiceSystemStatus;
                    _this.ServiceSystemStatusCode = args.ServiceSystemStatusCode;
                    _this.ServiceSystemStatusPhase = args.ServiceSystemStatusPhase;
                    _this.Subscriber = args.Subscriber;
                    _this.SubscriberCode = args.SubscriberCode;
                    _this.UserLabel = args.UserLabel;
                    return _this;
                }
                ServiceDisplay.Type = "Selcomm.Service.ServiceDisplay";
                ServiceDisplay.TypeParameters = [];
                return ServiceDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Service.ServiceDisplay = ServiceDisplay;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceStatusPhase;
            (function (ServiceStatusPhase) {
                ServiceStatusPhase[ServiceStatusPhase["Unknown"] = 0] = "Unknown";
                ServiceStatusPhase[ServiceStatusPhase["Dispatch"] = 1] = "Dispatch";
                ServiceStatusPhase[ServiceStatusPhase["Connected"] = 2] = "Connected";
                ServiceStatusPhase[ServiceStatusPhase["Disconnected"] = 3] = "Disconnected";
            })(ServiceStatusPhase = Service.ServiceStatusPhase || (Service.ServiceStatusPhase = {}));
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceDisplayList = (function (_super) {
                __extends(ServiceDisplayList, _super);
                function ServiceDisplayList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceDisplayList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ServiceDisplayList.Type = "Selcomm.Service.ServiceDisplayList";
                ServiceDisplayList.TypeParameters = [];
                return ServiceDisplayList;
            }(Selcomm.Objects.ExtendedDataList));
            Service.ServiceDisplayList = ServiceDisplayList;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Search;
        (function (Search) {
            var SearchResult = (function () {
                function SearchResult(args, $type) {
                    if (!args) {
                        return;
                    }
                    ;
                    this.Result = args.Result;
                    this.Elements = args.Elements;
                    this.$type = $type;
                }
                SearchResult.TypeWith = function (T) {
                    return Selcomm.Search.SearchResult.Type + "\u003c" + T + "\u003e";
                };
                SearchResult.Type = "Selcomm.Search.SearchResult";
                SearchResult.TypeParameters = ["T"];
                return SearchResult;
            }());
            Search.SearchResult = SearchResult;
        })(Search = Selcomm.Search || (Selcomm.Search = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Search;
        (function (Search) {
            var SearchResultElement = (function () {
                function SearchResultElement(args) {
                    this.$type = Selcomm.Search.SearchResultElement.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.DisplayName = args.DisplayName;
                    this.DisplayValue = args.DisplayValue;
                    this.IsMatch = args.IsMatch;
                }
                SearchResultElement.Type = "Selcomm.Search.SearchResultElement";
                SearchResultElement.TypeParameters = [];
                return SearchResultElement;
            }());
            Search.SearchResultElement = SearchResultElement;
        })(Search = Selcomm.Search || (Selcomm.Search = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Email;
        (function (Email_1) {
            var Email = (function (_super) {
                __extends(Email, _super);
                function Email(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Email.Email.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Status = args.Status;
                    _this.ToAddressList = args.ToAddressList;
                    _this.CCAddressList = args.CCAddressList;
                    _this.BCCAddressList = args.BCCAddressList;
                    _this.FromAddress = args.FromAddress;
                    _this.ImageList = args.ImageList;
                    _this.AttachmentList = args.AttachmentList;
                    _this.Subject = args.Subject;
                    _this.Body = args.Body;
                    _this.BodyFileWithPath = args.BodyFileWithPath;
                    _this.StatusMessage = args.StatusMessage;
                    _this.SMTPServer = args.SMTPServer;
                    return _this;
                }
                Email.Type = "Selcomm.Email.Email";
                Email.TypeParameters = [];
                return Email;
            }(Selcomm.Objects.DataObject));
            Email_1.Email = Email;
        })(Email = Selcomm.Email || (Selcomm.Email = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Email;
        (function (Email) {
            var EmailStatus;
            (function (EmailStatus) {
                EmailStatus[EmailStatus["Pending"] = 0] = "Pending";
                EmailStatus[EmailStatus["SendInProgress"] = 1] = "SendInProgress";
                EmailStatus[EmailStatus["Sent"] = 2] = "Sent";
                EmailStatus[EmailStatus["SendFailed"] = 3] = "SendFailed";
                EmailStatus[EmailStatus["Received"] = 4] = "Received";
            })(EmailStatus = Email.EmailStatus || (Email.EmailStatus = {}));
        })(Email = Selcomm.Email || (Selcomm.Email = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Images;
        (function (Images) {
            var ImageFile = (function () {
                function ImageFile(args) {
                    this.$type = Selcomm.Images.ImageFile.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Name = args.Name;
                    this.Path = args.Path;
                    this.Stream = args.Stream;
                }
                ImageFile.Type = "Selcomm.Images.ImageFile";
                ImageFile.TypeParameters = [];
                return ImageFile;
            }());
            Images.ImageFile = ImageFile;
        })(Images = Selcomm.Images || (Selcomm.Images = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Files;
        (function (Files) {
            var File = (function () {
                function File(args) {
                    this.$type = Selcomm.Files.File.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Name = args.Name;
                    this.Path = args.Path;
                    this.Content = args.Content;
                }
                File.Type = "Selcomm.Files.File";
                File.TypeParameters = [];
                return File;
            }());
            Files.File = File;
        })(Files = Selcomm.Files || (Selcomm.Files = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Email;
        (function (Email) {
            var Attachment = (function (_super) {
                __extends(Attachment, _super);
                function Attachment(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Email.Attachment.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                Attachment.Type = "Selcomm.Email.Attachment";
                Attachment.TypeParameters = [];
                return Attachment;
            }(Selcomm.Files.File));
            Email.Attachment = Attachment;
        })(Email = Selcomm.Email || (Selcomm.Email = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var KeyValuePair = (function () {
                function KeyValuePair(args) {
                    this.$type = Selcomm.Contact.KeyValuePair.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Key = args.Key;
                    this.Value = args.Value;
                }
                KeyValuePair.Type = "Selcomm.Contact.KeyValuePair";
                KeyValuePair.TypeParameters = [];
                return KeyValuePair;
            }());
            Contact.KeyValuePair = KeyValuePair;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var IdentificationType = (function (_super) {
                __extends(IdentificationType, _super);
                function IdentificationType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.IdentificationType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.Points = args.Points;
                    _this.PortalVisibility = args.PortalVisibility;
                    _this.HasExpiryDate = args.HasExpiryDate;
                    return _this;
                }
                IdentificationType.Type = "Selcomm.Contact.IdentificationType";
                IdentificationType.TypeParameters = [];
                return IdentificationType;
            }(Selcomm.Objects.DataObject));
            Contact.IdentificationType = IdentificationType;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var AdditionalField;
        (function (AdditionalField) {
            var AdditionalFieldData = (function (_super) {
                __extends(AdditionalFieldData, _super);
                function AdditionalFieldData(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.AdditionalField.AdditionalFieldData.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.AdditionalField = args.AdditionalField;
                    _this.KeyValue = args.KeyValue;
                    _this.InformationCode = args.InformationCode;
                    _this.Key2Value = args.Key2Value;
                    _this.Information = args.Information;
                    return _this;
                }
                AdditionalFieldData.Type = "Selcomm.AdditionalField.AdditionalFieldData";
                AdditionalFieldData.TypeParameters = [];
                return AdditionalFieldData;
            }(Selcomm.Objects.DataObject));
            AdditionalField.AdditionalFieldData = AdditionalFieldData;
        })(AdditionalField = Selcomm.AdditionalField || (Selcomm.AdditionalField = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var AdditionalField;
        (function (AdditionalField_1) {
            var AdditionalField = (function (_super) {
                __extends(AdditionalField, _super);
                function AdditionalField(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.AdditionalField.AdditionalField.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.TableName = args.TableName;
                    _this.InfoType = args.InfoType;
                    _this.StringTypeCode = args.StringTypeCode;
                    _this.ServiceTypeCode = args.ServiceTypeCode;
                    _this.InfoNarrative = args.InfoNarrative;
                    _this.LabelNarrative = args.LabelNarrative;
                    _this.Message = args.Message;
                    _this.DefaultValue = args.DefaultValue;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.StartDate = args.StartDate;
                    _this.EndDate = args.EndDate;
                    _this.ObjectId = args.ObjectId;
                    _this.PossibleValues = args.PossibleValues;
                    return _this;
                }
                AdditionalField.Type = "Selcomm.AdditionalField.AdditionalField";
                AdditionalField.TypeParameters = [];
                return AdditionalField;
            }(Selcomm.Objects.DataObject));
            AdditionalField_1.AdditionalField = AdditionalField;
        })(AdditionalField = Selcomm.AdditionalField || (Selcomm.AdditionalField = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactRelationshipTypeList = (function (_super) {
                __extends(ContactRelationshipTypeList, _super);
                function ContactRelationshipTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactRelationshipTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ContactRelationshipTypeList.Type = "Selcomm.Contact.ContactRelationshipTypeList";
                ContactRelationshipTypeList.TypeParameters = [];
                return ContactRelationshipTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Contact.ContactRelationshipTypeList = ContactRelationshipTypeList;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var ContactPhones;
        (function (ContactPhones) {
            var ContactPhoneUsage = (function (_super) {
                __extends(ContactPhoneUsage, _super);
                function ContactPhoneUsage(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.ContactPhones.ContactPhoneUsage.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ContactCode = args.ContactCode;
                    _this.PhoneTypeCode = args.PhoneTypeCode;
                    _this.PhoneRef = args.PhoneRef;
                    _this.StartDate = args.StartDate;
                    _this.ContactPhoneType = args.ContactPhoneType;
                    return _this;
                }
                ContactPhoneUsage.Type = "Selcomm.ContactPhones.ContactPhoneUsage";
                ContactPhoneUsage.TypeParameters = [];
                return ContactPhoneUsage;
            }(Selcomm.Objects.DataObject));
            ContactPhones.ContactPhoneUsage = ContactPhoneUsage;
        })(ContactPhones = Selcomm.ContactPhones || (Selcomm.ContactPhones = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contract;
        (function (Contract) {
            var ContractPenalty = (function (_super) {
                __extends(ContractPenalty, _super);
                function ContractPenalty(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contract.ContractPenalty.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.Length = args.Length;
                    return _this;
                }
                ContractPenalty.Type = "Selcomm.Contract.ContractPenalty";
                ContractPenalty.TypeParameters = [];
                return ContractPenalty;
            }(Selcomm.Objects.DataObject));
            Contract.ContractPenalty = ContractPenalty;
        })(Contract = Selcomm.Contract || (Selcomm.Contract = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contract;
        (function (Contract_1) {
            var Contract = (function (_super) {
                __extends(Contract, _super);
                function Contract(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contract.Contract.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.Term = args.Term;
                    _this.TermUnit = args.TermUnit;
                    _this.ContractPenalty = args.ContractPenalty;
                    _this.ContractPenaltyPercentage = args.ContractPenaltyPercentage;
                    _this.Disconnection = args.Disconnection;
                    _this.DisconnectionUnit = args.DisconnectionUnit;
                    _this.DisconnectionFee = args.DisconnectionFee;
                    _this.CoolOffDays = args.CoolOffDays;
                    _this.ContactRelated = args.ContactRelated;
                    _this.ServiceRelated = args.ServiceRelated;
                    return _this;
                }
                Contract.Type = "Selcomm.Contract.Contract";
                Contract.TypeParameters = [];
                return Contract;
            }(Selcomm.Objects.DataObject));
            Contract_1.Contract = Contract;
        })(Contract = Selcomm.Contract || (Selcomm.Contract = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contract;
        (function (Contract) {
            var ContractTermUnits;
            (function (ContractTermUnits) {
                ContractTermUnits[ContractTermUnits["Unknown"] = 0] = "Unknown";
                ContractTermUnits[ContractTermUnits["Day"] = 1] = "Day";
                ContractTermUnits[ContractTermUnits["Month"] = 2] = "Month";
                ContractTermUnits[ContractTermUnits["Year"] = 3] = "Year";
            })(ContractTermUnits = Contract.ContractTermUnits || (Contract.ContractTermUnits = {}));
        })(Contract = Selcomm.Contract || (Selcomm.Contract = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contract;
        (function (Contract) {
            var TerminationNoticePeriodUnits;
            (function (TerminationNoticePeriodUnits) {
                TerminationNoticePeriodUnits[TerminationNoticePeriodUnits["Unknown"] = 0] = "Unknown";
                TerminationNoticePeriodUnits[TerminationNoticePeriodUnits["Day"] = 1] = "Day";
                TerminationNoticePeriodUnits[TerminationNoticePeriodUnits["Month"] = 2] = "Month";
                TerminationNoticePeriodUnits[TerminationNoticePeriodUnits["Year"] = 3] = "Year";
            })(TerminationNoticePeriodUnits = Contract.TerminationNoticePeriodUnits || (Contract.TerminationNoticePeriodUnits = {}));
        })(Contract = Selcomm.Contract || (Selcomm.Contract = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contract;
        (function (Contract) {
            var ContractPenaltyCharge = (function (_super) {
                __extends(ContractPenaltyCharge, _super);
                function ContractPenaltyCharge(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contract.ContractPenaltyCharge.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ContractPenalty = args.ContractPenalty;
                    _this.Charge = args.Charge;
                    _this.IncludeFutureCharges = args.IncludeFutureCharges;
                    return _this;
                }
                ContractPenaltyCharge.Type = "Selcomm.Contract.ContractPenaltyCharge";
                ContractPenaltyCharge.TypeParameters = [];
                return ContractPenaltyCharge;
            }(Selcomm.Objects.DataObject));
            Contract.ContractPenaltyCharge = ContractPenaltyCharge;
        })(Contract = Selcomm.Contract || (Selcomm.Contract = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contract;
        (function (Contract) {
            var ContractExtension = (function (_super) {
                __extends(ContractExtension, _super);
                function ContractExtension(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contract.ContractExtension.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Contract = args.Contract;
                    _this.Description = args.Description;
                    _this.Discount = args.Discount;
                    _this.Term = args.Term;
                    _this.Commission = args.Commission;
                    _this.ContractExtensionWhenFrom = args.ContractExtensionWhenFrom;
                    _this.ContractExtensionWhenTo = args.ContractExtensionWhenTo;
                    return _this;
                }
                ContractExtension.Type = "Selcomm.Contract.ContractExtension";
                ContractExtension.TypeParameters = [];
                return ContractExtension;
            }(Selcomm.Objects.DataObject));
            Contract.ContractExtension = ContractExtension;
        })(Contract = Selcomm.Contract || (Selcomm.Contract = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Correspondences;
        (function (Correspondences) {
            var Correspondence = (function (_super) {
                __extends(Correspondence, _super);
                function Correspondence(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Correspondences.Correspondence.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ContactCode = args.ContactCode;
                    _this.Header = args.Header;
                    _this.Type = args.Type;
                    _this.Status = args.Status;
                    _this.Template = args.Template;
                    _this.EventDefinition = args.EventDefinition;
                    _this.EventReference = args.EventReference;
                    _this.SentDate = args.SentDate;
                    _this.AnsweredDate = args.AnsweredDate;
                    _this.CorrNumber = args.CorrNumber;
                    _this.Task = args.Task;
                    _this.FTP = args.FTP;
                    _this.EmailRecipient = args.EmailRecipient;
                    _this.TotalNumbeOfRecords = args.TotalNumbeOfRecords;
                    _this.Team = args.Team;
                    return _this;
                }
                Correspondence.Type = "Selcomm.Correspondences.Correspondence";
                Correspondence.TypeParameters = [];
                return Correspondence;
            }(Selcomm.Objects.DataObject));
            Correspondences.Correspondence = Correspondence;
        })(Correspondences = Selcomm.Correspondences || (Selcomm.Correspondences = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Correspondences;
        (function (Correspondences) {
            var CorrespondenceType = (function (_super) {
                __extends(CorrespondenceType, _super);
                function CorrespondenceType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Correspondences.CorrespondenceType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.TypeCode = args.TypeCode;
                    _this.TypeNarr = args.TypeNarr;
                    _this.EventType = args.EventType;
                    return _this;
                }
                CorrespondenceType.Type = "Selcomm.Correspondences.CorrespondenceType";
                CorrespondenceType.TypeParameters = [];
                return CorrespondenceType;
            }(Selcomm.Objects.DataObject));
            Correspondences.CorrespondenceType = CorrespondenceType;
        })(Correspondences = Selcomm.Correspondences || (Selcomm.Correspondences = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Correspondences;
        (function (Correspondences) {
            var CorrespondenceStatus = (function (_super) {
                __extends(CorrespondenceStatus, _super);
                function CorrespondenceStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Correspondences.CorrespondenceStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.StatusCode = args.StatusCode;
                    _this.StatusNarr = args.StatusNarr;
                    return _this;
                }
                CorrespondenceStatus.Type = "Selcomm.Correspondences.CorrespondenceStatus";
                CorrespondenceStatus.TypeParameters = [];
                return CorrespondenceStatus;
            }(Selcomm.Objects.DataObject));
            Correspondences.CorrespondenceStatus = CorrespondenceStatus;
        })(Correspondences = Selcomm.Correspondences || (Selcomm.Correspondences = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var FTP;
        (function (FTP_1) {
            var FTP = (function (_super) {
                __extends(FTP, _super);
                function FTP(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.FTP.FTP.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.FTPServerURL = args.FTPServerURL;
                    _this.FTPFilePath = args.FTPFilePath;
                    _this.LocalFilePath = args.LocalFilePath;
                    _this.FileName = args.FileName;
                    _this.PathWithFileName = args.PathWithFileName;
                    _this.FTPServerUserId = args.FTPServerUserId;
                    _this.FTPServerPassword = args.FTPServerPassword;
                    return _this;
                }
                FTP.Type = "Selcomm.FTP.FTP";
                FTP.TypeParameters = [];
                return FTP;
            }(Selcomm.Objects.DataObject));
            FTP_1.FTP = FTP;
        })(FTP = Selcomm.FTP || (Selcomm.FTP = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Correspondences;
        (function (Correspondences) {
            var CorrespondenceEmailRecipient = (function () {
                function CorrespondenceEmailRecipient(args) {
                    this.$type = Selcomm.Correspondences.CorrespondenceEmailRecipient.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.RecipientBusinessUnitCode = args.RecipientBusinessUnitCode;
                    this.RecipientEmail = args.RecipientEmail;
                    this.EmailBCC = args.EmailBCC;
                    this.EmailCC = args.EmailCC;
                    this.EmailFrom = args.EmailFrom;
                }
                CorrespondenceEmailRecipient.Type = "Selcomm.Correspondences.CorrespondenceEmailRecipient";
                CorrespondenceEmailRecipient.TypeParameters = [];
                return CorrespondenceEmailRecipient;
            }());
            Correspondences.CorrespondenceEmailRecipient = CorrespondenceEmailRecipient;
        })(Correspondences = Selcomm.Correspondences || (Selcomm.Correspondences = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Team;
        (function (Team_1) {
            var Team = (function (_super) {
                __extends(Team, _super);
                function Team(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Team.Team.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Sales = args.Sales;
                    _this.Tasks = args.Tasks;
                    _this.CSR = args.CSR;
                    _this.Provisioning = args.Provisioning;
                    _this.WinBack = args.WinBack;
                    _this.MemberList = args.MemberList;
                    return _this;
                }
                Team.Type = "Selcomm.Team.Team";
                Team.TypeParameters = [];
                return Team;
            }(Selcomm.Objects.DataObject));
            Team_1.Team = Team;
        })(Team = Selcomm.Team || (Selcomm.Team = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Contact;
        (function (Contact) {
            var ContactList = (function (_super) {
                __extends(ContactList, _super);
                function ContactList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Contact.ContactList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ContactList.Type = "Selcomm.Contact.ContactList";
                ContactList.TypeParameters = [];
                return ContactList;
            }(Selcomm.Objects.ExtendedDataList));
            Contact.ContactList = ContactList;
        })(Contact = Selcomm.Contact || (Selcomm.Contact = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Correspondences;
        (function (Correspondences) {
            var CorrespondenceDestination = (function (_super) {
                __extends(CorrespondenceDestination, _super);
                function CorrespondenceDestination(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Correspondences.CorrespondenceDestination.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Correspondence = args.Correspondence;
                    _this.Type = args.Type;
                    _this.EmailReference = args.EmailReference;
                    _this.Destination = args.Destination;
                    return _this;
                }
                CorrespondenceDestination.Type = "Selcomm.Correspondences.CorrespondenceDestination";
                CorrespondenceDestination.TypeParameters = [];
                return CorrespondenceDestination;
            }(Selcomm.Objects.DataObject));
            Correspondences.CorrespondenceDestination = CorrespondenceDestination;
        })(Correspondences = Selcomm.Correspondences || (Selcomm.Correspondences = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Correspondences;
        (function (Correspondences) {
            var CorrespondenceDestinationType = (function (_super) {
                __extends(CorrespondenceDestinationType, _super);
                function CorrespondenceDestinationType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Correspondences.CorrespondenceDestinationType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    return _this;
                }
                CorrespondenceDestinationType.Type = "Selcomm.Correspondences.CorrespondenceDestinationType";
                CorrespondenceDestinationType.TypeParameters = [];
                return CorrespondenceDestinationType;
            }(Selcomm.Objects.DataObject));
            Correspondences.CorrespondenceDestinationType = CorrespondenceDestinationType;
        })(Correspondences = Selcomm.Correspondences || (Selcomm.Correspondences = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CostCentre;
        (function (CostCentre) {
            var CostCentreStatus = (function (_super) {
                __extends(CostCentreStatus, _super);
                function CostCentreStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.CostCentre.CostCentreStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.SystemStatus = args.SystemStatus;
                    return _this;
                }
                CostCentreStatus.Type = "Selcomm.CostCentre.CostCentreStatus";
                CostCentreStatus.TypeParameters = [];
                return CostCentreStatus;
            }(Selcomm.Objects.DataObject));
            CostCentre.CostCentreStatus = CostCentreStatus;
        })(CostCentre = Selcomm.CostCentre || (Selcomm.CostCentre = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CostCentre;
        (function (CostCentre_1) {
            var CostCentre = (function (_super) {
                __extends(CostCentre, _super);
                function CostCentre(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.CostCentre.CostCentre.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ClientCode = args.ClientCode;
                    _this.Name = args.Name;
                    _this.UserInformation = args.UserInformation;
                    _this.AggregationPoint = args.AggregationPoint;
                    _this.Status = args.Status;
                    _this.StatusDateTime = args.StatusDateTime;
                    _this.GeneralLedgerAccount = args.GeneralLedgerAccount;
                    _this.AllocationType = args.AllocationType;
                    _this.Deletable = args.Deletable;
                    return _this;
                }
                CostCentre.Type = "Selcomm.CostCentre.CostCentre";
                CostCentre.TypeParameters = [];
                return CostCentre;
            }(Selcomm.Objects.DataObject));
            CostCentre_1.CostCentre = CostCentre;
        })(CostCentre = Selcomm.CostCentre || (Selcomm.CostCentre = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CostCentre;
        (function (CostCentre) {
            var AllocationType;
            (function (AllocationType) {
                AllocationType[AllocationType["DateRange"] = 0] = "DateRange";
                AllocationType[AllocationType["BillPeriod"] = 1] = "BillPeriod";
            })(AllocationType = CostCentre.AllocationType || (CostCentre.AllocationType = {}));
        })(CostCentre = Selcomm.CostCentre || (Selcomm.CostCentre = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CostCentre;
        (function (CostCentre) {
            var CostCentreDistributionDisplay = (function () {
                function CostCentreDistributionDisplay(args) {
                    this.$type = Selcomm.CostCentre.CostCentreDistributionDisplay.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.BillPeriod = args.BillPeriod;
                    this.CostCentre = args.CostCentre;
                    this.Comment = args.Comment;
                    this.Status = args.Status;
                    this.Total = args.Total;
                    this.Tax = args.Tax;
                    this.RoundingTotal = args.RoundingTotal;
                    this.RoundingTax = args.RoundingTax;
                }
                CostCentreDistributionDisplay.Type = "Selcomm.CostCentre.CostCentreDistributionDisplay";
                CostCentreDistributionDisplay.TypeParameters = [];
                return CostCentreDistributionDisplay;
            }());
            CostCentre.CostCentreDistributionDisplay = CostCentreDistributionDisplay;
        })(CostCentre = Selcomm.CostCentre || (Selcomm.CostCentre = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CostCentre;
        (function (CostCentre) {
            var CostCentreDistributionStatus = (function (_super) {
                __extends(CostCentreDistributionStatus, _super);
                function CostCentreDistributionStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.CostCentre.CostCentreDistributionStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    return _this;
                }
                CostCentreDistributionStatus.Type = "Selcomm.CostCentre.CostCentreDistributionStatus";
                CostCentreDistributionStatus.TypeParameters = [];
                return CostCentreDistributionStatus;
            }(Selcomm.Objects.DataObject));
            CostCentre.CostCentreDistributionStatus = CostCentreDistributionStatus;
        })(CostCentre = Selcomm.CostCentre || (Selcomm.CostCentre = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CreditCheck;
        (function (CreditCheck) {
            var CreditRequest = (function (_super) {
                __extends(CreditRequest, _super);
                function CreditRequest(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.CreditCheck.CreditRequest.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.CreditAmountRequired = args.CreditAmountRequired;
                    _this.Event = args.Event;
                    _this.PrimaryContact = args.PrimaryContact;
                    _this.Applicants = args.Applicants;
                    _this.Guarantors = args.Guarantors;
                    _this.References = args.References;
                    _this.PromotionalInfo = args.PromotionalInfo;
                    _this.AllApplicantsAndGaurantorsConsentToCreditCheck = args.AllApplicantsAndGaurantorsConsentToCreditCheck;
                    return _this;
                }
                CreditRequest.Type = "Selcomm.CreditCheck.CreditRequest";
                CreditRequest.TypeParameters = [];
                return CreditRequest;
            }(Selcomm.Objects.DataObject));
            CreditCheck.CreditRequest = CreditRequest;
        })(CreditCheck = Selcomm.CreditCheck || (Selcomm.CreditCheck = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CreditCheck;
        (function (CreditCheck) {
            var CreditResult = (function (_super) {
                __extends(CreditResult, _super);
                function CreditResult(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.CreditCheck.CreditResult.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.CreditAmount = args.CreditAmount;
                    _this.Event = args.Event;
                    _this.Decision = args.Decision;
                    _this.Applicants = args.Applicants;
                    _this.Guarantors = args.Guarantors;
                    _this.References = args.References;
                    return _this;
                }
                CreditResult.Type = "Selcomm.CreditCheck.CreditResult";
                CreditResult.TypeParameters = [];
                return CreditResult;
            }(Selcomm.Objects.DataObject));
            CreditCheck.CreditResult = CreditResult;
        })(CreditCheck = Selcomm.CreditCheck || (Selcomm.CreditCheck = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CreditCheck;
        (function (CreditCheck) {
            var Decision;
            (function (Decision) {
                Decision[Decision["Unknown"] = 0] = "Unknown";
                Decision[Decision["Withdraw"] = 1] = "Withdraw";
                Decision[Decision["Decline"] = 2] = "Decline";
                Decision[Decision["Refer"] = 3] = "Refer";
                Decision[Decision["Approve"] = 4] = "Approve";
            })(Decision = CreditCheck.Decision || (CreditCheck.Decision = {}));
        })(CreditCheck = Selcomm.CreditCheck || (Selcomm.CreditCheck = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CreditCheck;
        (function (CreditCheck) {
            var ContactCreditResult = (function (_super) {
                __extends(ContactCreditResult, _super);
                function ContactCreditResult(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.CreditCheck.ContactCreditResult.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Contact = args.Contact;
                    _this.Decision = args.Decision;
                    _this.Reasons = args.Reasons;
                    return _this;
                }
                ContactCreditResult.Type = "Selcomm.CreditCheck.ContactCreditResult";
                ContactCreditResult.TypeParameters = [];
                return ContactCreditResult;
            }(Selcomm.Objects.DataObject));
            CreditCheck.ContactCreditResult = ContactCreditResult;
        })(CreditCheck = Selcomm.CreditCheck || (Selcomm.CreditCheck = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var CreditCheck;
        (function (CreditCheck) {
            var Reason = (function (_super) {
                __extends(Reason, _super);
                function Reason(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.CreditCheck.Reason.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Description = args.Description;
                    _this.RuleCode = args.RuleCode;
                    _this.ReasonCode = args.ReasonCode;
                    return _this;
                }
                Reason.Type = "Selcomm.CreditCheck.Reason";
                Reason.TypeParameters = [];
                return Reason;
            }(Selcomm.Objects.DataObject));
            CreditCheck.Reason = Reason;
        })(CreditCheck = Selcomm.CreditCheck || (Selcomm.CreditCheck = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Dealer;
        (function (Dealer_1) {
            var Dealer = (function (_super) {
                __extends(Dealer, _super);
                function Dealer(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Dealer.Dealer.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ContactCode = args.ContactCode;
                    return _this;
                }
                Dealer.Type = "Selcomm.Dealer.Dealer";
                Dealer.TypeParameters = [];
                return Dealer;
            }(Selcomm.Objects.DataObject));
            Dealer_1.Dealer = Dealer;
        })(Dealer = Selcomm.Dealer || (Selcomm.Dealer = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Dealer;
        (function (Dealer) {
            var DealerList = (function (_super) {
                __extends(DealerList, _super);
                function DealerList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Dealer.DealerList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DealerList.Type = "Selcomm.Dealer.DealerList";
                DealerList.TypeParameters = [];
                return DealerList;
            }(Selcomm.Objects.ExtendedDataList));
            Dealer.DealerList = DealerList;
        })(Dealer = Selcomm.Dealer || (Selcomm.Dealer = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var Device = (function (_super) {
                __extends(Device, _super);
                function Device(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.Device.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Reference = args.Reference;
                    _this.Status = args.Status;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.Type = args.Type;
                    _this.Note = args.Note;
                    _this.Reference2 = args.Reference2;
                    _this.Password = args.Password;
                    _this.IsVirtual = args.IsVirtual;
                    _this.ConsolidateBillingData = args.ConsolidateBillingData;
                    _this.ConsolidateAnalyticData = args.ConsolidateAnalyticData;
                    return _this;
                }
                Device.Type = "Selcomm.Devices.Device";
                Device.TypeParameters = [];
                return Device;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.Device = Device;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceStatus = (function (_super) {
                __extends(DeviceStatus, _super);
                function DeviceStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.SystemStatus = args.SystemStatus;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceStatus.Type = "Selcomm.Devices.DeviceStatus";
                DeviceStatus.TypeParameters = [];
                return DeviceStatus;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceStatus = DeviceStatus;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceType = (function (_super) {
                __extends(DeviceType, _super);
                function DeviceType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.Category = args.Category;
                    _this.Model = args.Model;
                    _this.AttributeSet = args.AttributeSet;
                    _this.PollingScheme = args.PollingScheme;
                    _this.FramingScheme = args.FramingScheme;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceType.Type = "Selcomm.Devices.DeviceType";
                DeviceType.TypeParameters = [];
                return DeviceType;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceType = DeviceType;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceCategory = (function (_super) {
                __extends(DeviceCategory, _super);
                function DeviceCategory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceCategory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceCategory.Type = "Selcomm.Devices.DeviceCategory";
                DeviceCategory.TypeParameters = [];
                return DeviceCategory;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceCategory = DeviceCategory;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceModel = (function (_super) {
                __extends(DeviceModel, _super);
                function DeviceModel(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceModel.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ModelCode = args.ModelCode;
                    _this.Name = args.Name;
                    _this.Manufacturer = args.Manufacturer;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceModel.Type = "Selcomm.Devices.DeviceModel";
                DeviceModel.TypeParameters = [];
                return DeviceModel;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceModel = DeviceModel;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceManufacturer = (function (_super) {
                __extends(DeviceManufacturer, _super);
                function DeviceManufacturer(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceManufacturer.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Narrative = args.Narrative;
                    _this.ContactCode = args.ContactCode;
                    _this.Note = args.Note;
                    _this.Enabled = args.Enabled;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                DeviceManufacturer.Type = "Selcomm.Devices.DeviceManufacturer";
                DeviceManufacturer.TypeParameters = [];
                return DeviceManufacturer;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceManufacturer = DeviceManufacturer;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceAttributeSet = (function (_super) {
                __extends(DeviceAttributeSet, _super);
                function DeviceAttributeSet(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceAttributeSet.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.SetId = args.SetId;
                    _this.Name = args.Name;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceAttributeSet.Type = "Selcomm.Devices.DeviceAttributeSet";
                DeviceAttributeSet.TypeParameters = [];
                return DeviceAttributeSet;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceAttributeSet = DeviceAttributeSet;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DevicePollingScheme = (function (_super) {
                __extends(DevicePollingScheme, _super);
                function DevicePollingScheme(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DevicePollingScheme.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    return _this;
                }
                DevicePollingScheme.Type = "Selcomm.Devices.DevicePollingScheme";
                DevicePollingScheme.TypeParameters = [];
                return DevicePollingScheme;
            }(Selcomm.Objects.DataObject));
            Devices.DevicePollingScheme = DevicePollingScheme;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceFramingScheme = (function (_super) {
                __extends(DeviceFramingScheme, _super);
                function DeviceFramingScheme(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceFramingScheme.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    return _this;
                }
                DeviceFramingScheme.Type = "Selcomm.Devices.DeviceFramingScheme";
                DeviceFramingScheme.TypeParameters = [];
                return DeviceFramingScheme;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceFramingScheme = DeviceFramingScheme;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceRelationship = (function (_super) {
                __extends(DeviceRelationship, _super);
                function DeviceRelationship(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceRelationship.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ParentDevice = args.ParentDevice;
                    _this.ChildDevice = args.ChildDevice;
                    _this.RelationshipType = args.RelationshipType;
                    _this.StartDate = args.StartDate;
                    _this.EndDate = args.EndDate;
                    return _this;
                }
                DeviceRelationship.Type = "Selcomm.Devices.DeviceRelationship";
                DeviceRelationship.TypeParameters = [];
                return DeviceRelationship;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceRelationship = DeviceRelationship;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceRelationshipType = (function (_super) {
                __extends(DeviceRelationshipType, _super);
                function DeviceRelationshipType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceRelationshipType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceRelationshipType.Type = "Selcomm.Devices.DeviceRelationshipType";
                DeviceRelationshipType.TypeParameters = [];
                return DeviceRelationshipType;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceRelationshipType = DeviceRelationshipType;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceAttribute = (function (_super) {
                __extends(DeviceAttribute, _super);
                function DeviceAttribute(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceAttribute.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.DeviceId = args.DeviceId;
                    _this.DateFrom = args.DateFrom;
                    _this.DateTo = args.DateTo;
                    _this.AttributeValue = args.AttributeValue;
                    _this.AttributeDefinition = args.AttributeDefinition;
                    return _this;
                }
                DeviceAttribute.Type = "Selcomm.Devices.DeviceAttribute";
                DeviceAttribute.TypeParameters = [];
                return DeviceAttribute;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceAttribute = DeviceAttribute;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceAttributeDef = (function (_super) {
                __extends(DeviceAttributeDef, _super);
                function DeviceAttributeDef(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceAttributeDef.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.AttributeNarrative = args.AttributeNarrative;
                    _this.EntityId = args.EntityId;
                    _this.MenuId = args.MenuId;
                    _this.ObjectId = args.ObjectId;
                    _this.KeyType = args.KeyType;
                    _this.StrTypeCode = args.StrTypeCode;
                    _this.UseStrTypeNarr = args.UseStrTypeNarr;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.DataTypeCtrl = args.DataTypeCtrl;
                    _this.MinNum = args.MinNum;
                    _this.MaxNum = args.MaxNum;
                    _this.SPAttribCode = args.SPAttribCode;
                    _this.MedAttribute = args.MedAttribute;
                    return _this;
                }
                DeviceAttributeDef.Type = "Selcomm.Devices.DeviceAttributeDef";
                DeviceAttributeDef.TypeParameters = [];
                return DeviceAttributeDef;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceAttributeDef = DeviceAttributeDef;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceAttributeList = (function (_super) {
                __extends(DeviceAttributeList, _super);
                function DeviceAttributeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceAttributeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceAttributeList.Type = "Selcomm.Devices.DeviceAttributeList";
                DeviceAttributeList.TypeParameters = [];
                return DeviceAttributeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceAttributeList = DeviceAttributeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceAttributeDefList = (function (_super) {
                __extends(DeviceAttributeDefList, _super);
                function DeviceAttributeDefList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceAttributeDefList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceAttributeDefList.Type = "Selcomm.Devices.DeviceAttributeDefList";
                DeviceAttributeDefList.TypeParameters = [];
                return DeviceAttributeDefList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceAttributeDefList = DeviceAttributeDefList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceAttributeSetAssignment = (function (_super) {
                __extends(DeviceAttributeSetAssignment, _super);
                function DeviceAttributeSetAssignment(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceAttributeSetAssignment.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Device = args.Device;
                    _this.SetId = args.SetId;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceAttributeSetAssignment.Type = "Selcomm.Devices.DeviceAttributeSetAssignment";
                DeviceAttributeSetAssignment.TypeParameters = [];
                return DeviceAttributeSetAssignment;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceAttributeSetAssignment = DeviceAttributeSetAssignment;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceAttributeSetAssignmentList = (function (_super) {
                __extends(DeviceAttributeSetAssignmentList, _super);
                function DeviceAttributeSetAssignmentList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceAttributeSetAssignmentList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceAttributeSetAssignmentList.Type = "Selcomm.Devices.DeviceAttributeSetAssignmentList";
                DeviceAttributeSetAssignmentList.TypeParameters = [];
                return DeviceAttributeSetAssignmentList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceAttributeSetAssignmentList = DeviceAttributeSetAssignmentList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceAttributeSetAssignmentDetail = (function (_super) {
                __extends(DeviceAttributeSetAssignmentDetail, _super);
                function DeviceAttributeSetAssignmentDetail(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceAttributeSetAssignmentDetail.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.AttributeSet = args.AttributeSet;
                    _this.Attribute = args.Attribute;
                    _this.FromDate = args.FromDate;
                    return _this;
                }
                DeviceAttributeSetAssignmentDetail.Type = "Selcomm.Devices.DeviceAttributeSetAssignmentDetail";
                DeviceAttributeSetAssignmentDetail.TypeParameters = [];
                return DeviceAttributeSetAssignmentDetail;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceAttributeSetAssignmentDetail = DeviceAttributeSetAssignmentDetail;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceAttributeSetAssignmentDetailList = (function (_super) {
                __extends(DeviceAttributeSetAssignmentDetailList, _super);
                function DeviceAttributeSetAssignmentDetailList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceAttributeSetAssignmentDetailList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceAttributeSetAssignmentDetailList.Type = "Selcomm.Devices.DeviceAttributeSetAssignmentDetailList";
                DeviceAttributeSetAssignmentDetailList.TypeParameters = [];
                return DeviceAttributeSetAssignmentDetailList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceAttributeSetAssignmentDetailList = DeviceAttributeSetAssignmentDetailList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceSiteHistoryDisplay = (function (_super) {
                __extends(DeviceSiteHistoryDisplay, _super);
                function DeviceSiteHistoryDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceSiteHistoryDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Device = args.Device;
                    _this.Site = args.Site;
                    _this.DeviceAssignmentStart = args.DeviceAssignmentStart;
                    _this.DeviceAssignmentEnd = args.DeviceAssignmentEnd;
                    return _this;
                }
                DeviceSiteHistoryDisplay.Type = "Selcomm.Devices.DeviceSiteHistoryDisplay";
                DeviceSiteHistoryDisplay.TypeParameters = [];
                return DeviceSiteHistoryDisplay;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceSiteHistoryDisplay = DeviceSiteHistoryDisplay;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceSite = (function (_super) {
                __extends(DeviceSite, _super);
                function DeviceSite(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceSite.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Note = args.Note;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.SiteType = args.SiteType;
                    _this.SiteStatusId = args.SiteStatusId;
                    return _this;
                }
                DeviceSite.Type = "Selcomm.Devices.DeviceSite";
                DeviceSite.TypeParameters = [];
                return DeviceSite;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceSite = DeviceSite;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceSiteType = (function (_super) {
                __extends(DeviceSiteType, _super);
                function DeviceSiteType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceSiteType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    return _this;
                }
                DeviceSiteType.Type = "Selcomm.Devices.DeviceSiteType";
                DeviceSiteType.TypeParameters = [];
                return DeviceSiteType;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceSiteType = DeviceSiteType;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceSiteHistoryDisplayList = (function (_super) {
                __extends(DeviceSiteHistoryDisplayList, _super);
                function DeviceSiteHistoryDisplayList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceSiteHistoryDisplayList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceSiteHistoryDisplayList.Type = "Selcomm.Devices.DeviceSiteHistoryDisplayList";
                DeviceSiteHistoryDisplayList.TypeParameters = [];
                return DeviceSiteHistoryDisplayList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceSiteHistoryDisplayList = DeviceSiteHistoryDisplayList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceSiteList = (function (_super) {
                __extends(DeviceSiteList, _super);
                function DeviceSiteList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceSiteList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceSiteList.Type = "Selcomm.Devices.DeviceSiteList";
                DeviceSiteList.TypeParameters = [];
                return DeviceSiteList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceSiteList = DeviceSiteList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceStatusList = (function (_super) {
                __extends(DeviceStatusList, _super);
                function DeviceStatusList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceStatusList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceStatusList.Type = "Selcomm.Devices.DeviceStatusList";
                DeviceStatusList.TypeParameters = [];
                return DeviceStatusList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceStatusList = DeviceStatusList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceCondition = (function (_super) {
                __extends(DeviceCondition, _super);
                function DeviceCondition(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceCondition.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.DefaultStatus = args.DefaultStatus;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceCondition.Type = "Selcomm.Devices.DeviceCondition";
                DeviceCondition.TypeParameters = [];
                return DeviceCondition;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceCondition = DeviceCondition;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceConditionList = (function (_super) {
                __extends(DeviceConditionList, _super);
                function DeviceConditionList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceConditionList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceConditionList.Type = "Selcomm.Devices.DeviceConditionList";
                DeviceConditionList.TypeParameters = [];
                return DeviceConditionList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceConditionList = DeviceConditionList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceSiteRelationshipType = (function (_super) {
                __extends(DeviceSiteRelationshipType, _super);
                function DeviceSiteRelationshipType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceSiteRelationshipType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Description = args.Description;
                    return _this;
                }
                DeviceSiteRelationshipType.Type = "Selcomm.Devices.DeviceSiteRelationshipType";
                DeviceSiteRelationshipType.TypeParameters = [];
                return DeviceSiteRelationshipType;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceSiteRelationshipType = DeviceSiteRelationshipType;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceSiteRelationshipTypeList = (function (_super) {
                __extends(DeviceSiteRelationshipTypeList, _super);
                function DeviceSiteRelationshipTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceSiteRelationshipTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceSiteRelationshipTypeList.Type = "Selcomm.Devices.DeviceSiteRelationshipTypeList";
                DeviceSiteRelationshipTypeList.TypeParameters = [];
                return DeviceSiteRelationshipTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceSiteRelationshipTypeList = DeviceSiteRelationshipTypeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeList = (function (_super) {
                __extends(DeviceTypeList, _super);
                function DeviceTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTypeList.Type = "Selcomm.Devices.DeviceTypeList";
                DeviceTypeList.TypeParameters = [];
                return DeviceTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTypeList = DeviceTypeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeActions = (function (_super) {
                __extends(DeviceTypeActions, _super);
                function DeviceTypeActions(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeActions.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Type = args.Type;
                    _this.Action = args.Action;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    _this.Direction = args.Direction;
                    _this.MessageBroker = args.MessageBroker;
                    _this.SetReference = args.SetReference;
                    return _this;
                }
                DeviceTypeActions.Type = "Selcomm.Devices.DeviceTypeActions";
                DeviceTypeActions.TypeParameters = [];
                return DeviceTypeActions;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceTypeActions = DeviceTypeActions;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceActions = (function (_super) {
                __extends(DeviceActions, _super);
                function DeviceActions(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceActions.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    return _this;
                }
                DeviceActions.Type = "Selcomm.Devices.DeviceActions";
                DeviceActions.TypeParameters = [];
                return DeviceActions;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceActions = DeviceActions;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMessageBroker = (function (_super) {
                __extends(DeviceMessageBroker, _super);
                function DeviceMessageBroker(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMessageBroker.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.StatusId = args.StatusId;
                    _this.TypeId = args.TypeId;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceMessageBroker.Type = "Selcomm.Devices.DeviceMessageBroker";
                DeviceMessageBroker.TypeParameters = [];
                return DeviceMessageBroker;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMessageBroker = DeviceMessageBroker;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMessageBrokerStatus = (function (_super) {
                __extends(DeviceMessageBrokerStatus, _super);
                function DeviceMessageBrokerStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMessageBrokerStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Narrative = args.Narrative;
                    _this.SystemStatus = args.SystemStatus;
                    return _this;
                }
                DeviceMessageBrokerStatus.Type = "Selcomm.Devices.DeviceMessageBrokerStatus";
                DeviceMessageBrokerStatus.TypeParameters = [];
                return DeviceMessageBrokerStatus;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMessageBrokerStatus = DeviceMessageBrokerStatus;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMessageBrokerType = (function (_super) {
                __extends(DeviceMessageBrokerType, _super);
                function DeviceMessageBrokerType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMessageBrokerType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Narrative = args.Narrative;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceMessageBrokerType.Type = "Selcomm.Devices.DeviceMessageBrokerType";
                DeviceMessageBrokerType.TypeParameters = [];
                return DeviceMessageBrokerType;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMessageBrokerType = DeviceMessageBrokerType;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeActionsList = (function (_super) {
                __extends(DeviceTypeActionsList, _super);
                function DeviceTypeActionsList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeActionsList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTypeActionsList.Type = "Selcomm.Devices.DeviceTypeActionsList";
                DeviceTypeActionsList.TypeParameters = [];
                return DeviceTypeActionsList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTypeActionsList = DeviceTypeActionsList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeAttribute = (function (_super) {
                __extends(DeviceTypeAttribute, _super);
                function DeviceTypeAttribute(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeAttribute.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Type = args.Type;
                    _this.DefaultValue = args.DefaultValue;
                    return _this;
                }
                DeviceTypeAttribute.Type = "Selcomm.Devices.DeviceTypeAttribute";
                DeviceTypeAttribute.TypeParameters = [];
                return DeviceTypeAttribute;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceTypeAttribute = DeviceTypeAttribute;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeAttributeList = (function (_super) {
                __extends(DeviceTypeAttributeList, _super);
                function DeviceTypeAttributeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeAttributeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTypeAttributeList.Type = "Selcomm.Devices.DeviceTypeAttributeList";
                DeviceTypeAttributeList.TypeParameters = [];
                return DeviceTypeAttributeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTypeAttributeList = DeviceTypeAttributeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeAttributeSet = (function (_super) {
                __extends(DeviceTypeAttributeSet, _super);
                function DeviceTypeAttributeSet(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeAttributeSet.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Type = args.Type;
                    _this.AttributeSet = args.AttributeSet;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceTypeAttributeSet.Type = "Selcomm.Devices.DeviceTypeAttributeSet";
                DeviceTypeAttributeSet.TypeParameters = [];
                return DeviceTypeAttributeSet;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceTypeAttributeSet = DeviceTypeAttributeSet;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeAttributeSetList = (function (_super) {
                __extends(DeviceTypeAttributeSetList, _super);
                function DeviceTypeAttributeSetList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeAttributeSetList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTypeAttributeSetList.Type = "Selcomm.Devices.DeviceTypeAttributeSetList";
                DeviceTypeAttributeSetList.TypeParameters = [];
                return DeviceTypeAttributeSetList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTypeAttributeSetList = DeviceTypeAttributeSetList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeDocument = (function (_super) {
                __extends(DeviceTypeDocument, _super);
                function DeviceTypeDocument(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeDocument.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Type = args.Type;
                    _this.DocumentId = args.DocumentId;
                    return _this;
                }
                DeviceTypeDocument.Type = "Selcomm.Devices.DeviceTypeDocument";
                DeviceTypeDocument.TypeParameters = [];
                return DeviceTypeDocument;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceTypeDocument = DeviceTypeDocument;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeDocumentList = (function (_super) {
                __extends(DeviceTypeDocumentList, _super);
                function DeviceTypeDocumentList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeDocumentList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTypeDocumentList.Type = "Selcomm.Devices.DeviceTypeDocumentList";
                DeviceTypeDocumentList.TypeParameters = [];
                return DeviceTypeDocumentList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTypeDocumentList = DeviceTypeDocumentList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeImage = (function (_super) {
                __extends(DeviceTypeImage, _super);
                function DeviceTypeImage(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeImage.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Type = args.Type;
                    return _this;
                }
                DeviceTypeImage.Type = "Selcomm.Devices.DeviceTypeImage";
                DeviceTypeImage.TypeParameters = [];
                return DeviceTypeImage;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceTypeImage = DeviceTypeImage;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeImageList = (function (_super) {
                __extends(DeviceTypeImageList, _super);
                function DeviceTypeImageList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeImageList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTypeImageList.Type = "Selcomm.Devices.DeviceTypeImageList";
                DeviceTypeImageList.TypeParameters = [];
                return DeviceTypeImageList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTypeImageList = DeviceTypeImageList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeProduct = (function (_super) {
                __extends(DeviceTypeProduct, _super);
                function DeviceTypeProduct(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeProduct.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Type = args.Type;
                    _this.ProductCode = args.ProductCode;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceTypeProduct.Type = "Selcomm.Devices.DeviceTypeProduct";
                DeviceTypeProduct.TypeParameters = [];
                return DeviceTypeProduct;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceTypeProduct = DeviceTypeProduct;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTypeProductList = (function (_super) {
                __extends(DeviceTypeProductList, _super);
                function DeviceTypeProductList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTypeProductList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTypeProductList.Type = "Selcomm.Devices.DeviceTypeProductList";
                DeviceTypeProductList.TypeParameters = [];
                return DeviceTypeProductList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTypeProductList = DeviceTypeProductList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceCategoryList = (function (_super) {
                __extends(DeviceCategoryList, _super);
                function DeviceCategoryList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceCategoryList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceCategoryList.Type = "Selcomm.Devices.DeviceCategoryList";
                DeviceCategoryList.TypeParameters = [];
                return DeviceCategoryList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceCategoryList = DeviceCategoryList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceRelationshipTypeList = (function (_super) {
                __extends(DeviceRelationshipTypeList, _super);
                function DeviceRelationshipTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceRelationshipTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceRelationshipTypeList.Type = "Selcomm.Devices.DeviceRelationshipTypeList";
                DeviceRelationshipTypeList.TypeParameters = [];
                return DeviceRelationshipTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceRelationshipTypeList = DeviceRelationshipTypeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceRelationshipList = (function (_super) {
                __extends(DeviceRelationshipList, _super);
                function DeviceRelationshipList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceRelationshipList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceRelationshipList.Type = "Selcomm.Devices.DeviceRelationshipList";
                DeviceRelationshipList.TypeParameters = [];
                return DeviceRelationshipList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceRelationshipList = DeviceRelationshipList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationData = (function (_super) {
                __extends(DeviceMediationData, _super);
                function DeviceMediationData(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationData.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.FileNum = args.FileNum;
                    _this.FileRecNum = args.FileRecNum;
                    _this.DataSource = args.DataSource;
                    _this.Type = args.Type;
                    _this.Value = args.Value;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    _this.Status = args.Status;
                    _this.Device = args.Device;
                    _this.RawValue = args.RawValue;
                    _this.OriginalDeviceReference = args.OriginalDeviceReference;
                    _this.RawValue2 = args.RawValue2;
                    _this.MediationParent = args.MediationParent;
                    _this.MediationStatusReason = args.MediationStatusReason;
                    _this.MedationParentType = args.MedationParentType;
                    _this.EstimationType = args.EstimationType;
                    return _this;
                }
                DeviceMediationData.Type = "Selcomm.Devices.DeviceMediationData";
                DeviceMediationData.TypeParameters = [];
                return DeviceMediationData;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationData = DeviceMediationData;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataSource = (function (_super) {
                __extends(DeviceMediationDataSource, _super);
                function DeviceMediationDataSource(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataSource.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceMediationDataSource.Type = "Selcomm.Devices.DeviceMediationDataSource";
                DeviceMediationDataSource.TypeParameters = [];
                return DeviceMediationDataSource;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationDataSource = DeviceMediationDataSource;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationType = (function (_super) {
                __extends(DeviceMediationType, _super);
                function DeviceMediationType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Unit = args.Unit;
                    _this.BillableUsage = args.BillableUsage;
                    _this.Alert = args.Alert;
                    _this.Editable = args.Editable;
                    return _this;
                }
                DeviceMediationType.Type = "Selcomm.Devices.DeviceMediationType";
                DeviceMediationType.TypeParameters = [];
                return DeviceMediationType;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationType = DeviceMediationType;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceUnit = (function (_super) {
                __extends(DeviceUnit, _super);
                function DeviceUnit(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceUnit.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.ShortNameSingular = args.ShortNameSingular;
                    _this.ShortNamePlural = args.ShortNamePlural;
                    _this.QuantityName = args.QuantityName;
                    return _this;
                }
                DeviceUnit.Type = "Selcomm.Devices.DeviceUnit";
                DeviceUnit.TypeParameters = [];
                return DeviceUnit;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceUnit = DeviceUnit;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationStatus = (function (_super) {
                __extends(DeviceMediationStatus, _super);
                function DeviceMediationStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.SystemStatus = args.SystemStatus;
                    _this.Description = args.Description;
                    return _this;
                }
                DeviceMediationStatus.Type = "Selcomm.Devices.DeviceMediationStatus";
                DeviceMediationStatus.TypeParameters = [];
                return DeviceMediationStatus;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationStatus = DeviceMediationStatus;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationStatusReason = (function (_super) {
                __extends(DeviceMediationStatusReason, _super);
                function DeviceMediationStatusReason(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationStatusReason.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    return _this;
                }
                DeviceMediationStatusReason.Type = "Selcomm.Devices.DeviceMediationStatusReason";
                DeviceMediationStatusReason.TypeParameters = [];
                return DeviceMediationStatusReason;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationStatusReason = DeviceMediationStatusReason;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataList = (function (_super) {
                __extends(DeviceMediationDataList, _super);
                function DeviceMediationDataList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationDataList.Type = "Selcomm.Devices.DeviceMediationDataList";
                DeviceMediationDataList.TypeParameters = [];
                return DeviceMediationDataList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationDataList = DeviceMediationDataList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataException = (function (_super) {
                __extends(DeviceMediationDataException, _super);
                function DeviceMediationDataException(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataException.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.MediationData = args.MediationData;
                    _this.FileFieldNumber = args.FileFieldNumber;
                    _this.StatusHistoryItem = args.StatusHistoryItem;
                    _this.Type = args.Type;
                    _this.Number = args.Number;
                    _this.Message = args.Message;
                    _this.Resolved = args.Resolved;
                    return _this;
                }
                DeviceMediationDataException.Type = "Selcomm.Devices.DeviceMediationDataException";
                DeviceMediationDataException.TypeParameters = [];
                return DeviceMediationDataException;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceMediationDataException = DeviceMediationDataException;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationStatusHistory = (function (_super) {
                __extends(DeviceMediationStatusHistory, _super);
                function DeviceMediationStatusHistory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationStatusHistory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.MediationData = args.MediationData;
                    _this.Status = args.Status;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceMediationStatusHistory.Type = "Selcomm.Devices.DeviceMediationStatusHistory";
                DeviceMediationStatusHistory.TypeParameters = [];
                return DeviceMediationStatusHistory;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationStatusHistory = DeviceMediationStatusHistory;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataExceptionList = (function (_super) {
                __extends(DeviceMediationDataExceptionList, _super);
                function DeviceMediationDataExceptionList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataExceptionList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationDataExceptionList.Type = "Selcomm.Devices.DeviceMediationDataExceptionList";
                DeviceMediationDataExceptionList.TypeParameters = [];
                return DeviceMediationDataExceptionList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationDataExceptionList = DeviceMediationDataExceptionList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataExceptionGroup = (function (_super) {
                __extends(DeviceMediationDataExceptionGroup, _super);
                function DeviceMediationDataExceptionGroup(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataExceptionGroup.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Device = args.Device;
                    _this.DeviceReference = args.DeviceReference;
                    _this.MediationDataType = args.MediationDataType;
                    _this.Oldest = args.Oldest;
                    _this.Newest = args.Newest;
                    _this.Count = args.Count;
                    return _this;
                }
                DeviceMediationDataExceptionGroup.Type = "Selcomm.Devices.DeviceMediationDataExceptionGroup";
                DeviceMediationDataExceptionGroup.TypeParameters = [];
                return DeviceMediationDataExceptionGroup;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceMediationDataExceptionGroup = DeviceMediationDataExceptionGroup;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataExceptionGroupList = (function (_super) {
                __extends(DeviceMediationDataExceptionGroupList, _super);
                function DeviceMediationDataExceptionGroupList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataExceptionGroupList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationDataExceptionGroupList.Type = "Selcomm.Devices.DeviceMediationDataExceptionGroupList";
                DeviceMediationDataExceptionGroupList.TypeParameters = [];
                return DeviceMediationDataExceptionGroupList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationDataExceptionGroupList = DeviceMediationDataExceptionGroupList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataSourceList = (function (_super) {
                __extends(DeviceMediationDataSourceList, _super);
                function DeviceMediationDataSourceList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataSourceList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationDataSourceList.Type = "Selcomm.Devices.DeviceMediationDataSourceList";
                DeviceMediationDataSourceList.TypeParameters = [];
                return DeviceMediationDataSourceList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationDataSourceList = DeviceMediationDataSourceList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataCons = (function (_super) {
                __extends(DeviceMediationDataCons, _super);
                function DeviceMediationDataCons(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataCons.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.FileNumber = args.FileNumber;
                    _this.FileRecNumber = args.FileRecNumber;
                    _this.DeviceReference = args.DeviceReference;
                    _this.Attribute = args.Attribute;
                    _this.Value = args.Value;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceMediationDataCons.Type = "Selcomm.Devices.DeviceMediationDataCons";
                DeviceMediationDataCons.TypeParameters = [];
                return DeviceMediationDataCons;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationDataCons = DeviceMediationDataCons;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataConsList = (function (_super) {
                __extends(DeviceMediationDataConsList, _super);
                function DeviceMediationDataConsList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataConsList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationDataConsList.Type = "Selcomm.Devices.DeviceMediationDataConsList";
                DeviceMediationDataConsList.TypeParameters = [];
                return DeviceMediationDataConsList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationDataConsList = DeviceMediationDataConsList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataConMap = (function (_super) {
                __extends(DeviceMediationDataConMap, _super);
                function DeviceMediationDataConMap(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataConMap.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Reference = args.Reference;
                    _this.AttributeId = args.AttributeId;
                    _this.MapFromDate = args.MapFromDate;
                    _this.MapToDate = args.MapToDate;
                    _this.TariffClassCode = args.TariffClassCode;
                    _this.RateMethod = args.RateMethod;
                    _this.Description = args.Description;
                    return _this;
                }
                DeviceMediationDataConMap.Type = "Selcomm.Devices.DeviceMediationDataConMap";
                DeviceMediationDataConMap.TypeParameters = [];
                return DeviceMediationDataConMap;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationDataConMap = DeviceMediationDataConMap;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationDataConMapList = (function (_super) {
                __extends(DeviceMediationDataConMapList, _super);
                function DeviceMediationDataConMapList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationDataConMapList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationDataConMapList.Type = "Selcomm.Devices.DeviceMediationDataConMapList";
                DeviceMediationDataConMapList.TypeParameters = [];
                return DeviceMediationDataConMapList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationDataConMapList = DeviceMediationDataConMapList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationRule = (function (_super) {
                __extends(DeviceMediationRule, _super);
                function DeviceMediationRule(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationRule.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.EventType = args.EventType;
                    _this.EventCode = args.EventCode;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceMediationRule.Type = "Selcomm.Devices.DeviceMediationRule";
                DeviceMediationRule.TypeParameters = [];
                return DeviceMediationRule;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationRule = DeviceMediationRule;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationRuleList = (function (_super) {
                __extends(DeviceMediationRuleList, _super);
                function DeviceMediationRuleList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationRuleList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationRuleList.Type = "Selcomm.Devices.DeviceMediationRuleList";
                DeviceMediationRuleList.TypeParameters = [];
                return DeviceMediationRuleList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationRuleList = DeviceMediationRuleList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationRuleSet = (function (_super) {
                __extends(DeviceMediationRuleSet, _super);
                function DeviceMediationRuleSet(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationRuleSet.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceMediationRuleSet.Type = "Selcomm.Devices.DeviceMediationRuleSet";
                DeviceMediationRuleSet.TypeParameters = [];
                return DeviceMediationRuleSet;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationRuleSet = DeviceMediationRuleSet;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationRuleSetList = (function (_super) {
                __extends(DeviceMediationRuleSetList, _super);
                function DeviceMediationRuleSetList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationRuleSetList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationRuleSetList.Type = "Selcomm.Devices.DeviceMediationRuleSetList";
                DeviceMediationRuleSetList.TypeParameters = [];
                return DeviceMediationRuleSetList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationRuleSetList = DeviceMediationRuleSetList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationEditValue = (function (_super) {
                __extends(DeviceMediationEditValue, _super);
                function DeviceMediationEditValue(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationEditValue.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.MediationData = args.MediationData;
                    _this.Note = args.Note;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    _this.Device = args.Device;
                    _this.Value = args.Value;
                    _this.RawValue1 = args.RawValue1;
                    _this.RawValue2 = args.RawValue2;
                    return _this;
                }
                DeviceMediationEditValue.Type = "Selcomm.Devices.DeviceMediationEditValue";
                DeviceMediationEditValue.TypeParameters = [];
                return DeviceMediationEditValue;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationEditValue = DeviceMediationEditValue;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationStatusList = (function (_super) {
                __extends(DeviceMediationStatusList, _super);
                function DeviceMediationStatusList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationStatusList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationStatusList.Type = "Selcomm.Devices.DeviceMediationStatusList";
                DeviceMediationStatusList.TypeParameters = [];
                return DeviceMediationStatusList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationStatusList = DeviceMediationStatusList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationStatusHistoryList = (function (_super) {
                __extends(DeviceMediationStatusHistoryList, _super);
                function DeviceMediationStatusHistoryList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationStatusHistoryList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationStatusHistoryList.Type = "Selcomm.Devices.DeviceMediationStatusHistoryList";
                DeviceMediationStatusHistoryList.TypeParameters = [];
                return DeviceMediationStatusHistoryList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationStatusHistoryList = DeviceMediationStatusHistoryList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationStatusReasonList = (function (_super) {
                __extends(DeviceMediationStatusReasonList, _super);
                function DeviceMediationStatusReasonList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationStatusReasonList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationStatusReasonList.Type = "Selcomm.Devices.DeviceMediationStatusReasonList";
                DeviceMediationStatusReasonList.TypeParameters = [];
                return DeviceMediationStatusReasonList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationStatusReasonList = DeviceMediationStatusReasonList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationValueRuleException = (function (_super) {
                __extends(DeviceMediationValueRuleException, _super);
                function DeviceMediationValueRuleException(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationValueRuleException.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.StringTypeCode = args.StringTypeCode;
                    _this.ServiceTypeCode = args.ServiceTypeCode;
                    return _this;
                }
                DeviceMediationValueRuleException.Type = "Selcomm.Devices.DeviceMediationValueRuleException";
                DeviceMediationValueRuleException.TypeParameters = [];
                return DeviceMediationValueRuleException;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationValueRuleException = DeviceMediationValueRuleException;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationValueRuleExceptionList = (function (_super) {
                __extends(DeviceMediationValueRuleExceptionList, _super);
                function DeviceMediationValueRuleExceptionList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationValueRuleExceptionList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationValueRuleExceptionList.Type = "Selcomm.Devices.DeviceMediationValueRuleExceptionList";
                DeviceMediationValueRuleExceptionList.TypeParameters = [];
                return DeviceMediationValueRuleExceptionList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationValueRuleExceptionList = DeviceMediationValueRuleExceptionList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationValueRuleExceptionHistory = (function (_super) {
                __extends(DeviceMediationValueRuleExceptionHistory, _super);
                function DeviceMediationValueRuleExceptionHistory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationValueRuleExceptionHistory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.RuleSetDtlId = args.RuleSetDtlId;
                    _this.MediationId = args.MediationId;
                    _this.Description = args.Description;
                    return _this;
                }
                DeviceMediationValueRuleExceptionHistory.Type = "Selcomm.Devices.DeviceMediationValueRuleExceptionHistory";
                DeviceMediationValueRuleExceptionHistory.TypeParameters = [];
                return DeviceMediationValueRuleExceptionHistory;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationValueRuleExceptionHistory = DeviceMediationValueRuleExceptionHistory;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationRuleSetDtl = (function (_super) {
                __extends(DeviceMediationRuleSetDtl, _super);
                function DeviceMediationRuleSetDtl(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationRuleSetDtl.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.RuleSet = args.RuleSet;
                    _this.RuleSetSequenceNumber = args.RuleSetSequenceNumber;
                    _this.Rule = args.Rule;
                    _this.Attribute = args.Attribute;
                    _this.ExceptionRule = args.ExceptionRule;
                    _this.ExceptionStatus = args.ExceptionStatus;
                    _this.SuccessStatus = args.SuccessStatus;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceMediationRuleSetDtl.Type = "Selcomm.Devices.DeviceMediationRuleSetDtl";
                DeviceMediationRuleSetDtl.TypeParameters = [];
                return DeviceMediationRuleSetDtl;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMediationRuleSetDtl = DeviceMediationRuleSetDtl;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMediationValueRuleExceptionHistoryList = (function (_super) {
                __extends(DeviceMediationValueRuleExceptionHistoryList, _super);
                function DeviceMediationValueRuleExceptionHistoryList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMediationValueRuleExceptionHistoryList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMediationValueRuleExceptionHistoryList.Type = "Selcomm.Devices.DeviceMediationValueRuleExceptionHistoryList";
                DeviceMediationValueRuleExceptionHistoryList.TypeParameters = [];
                return DeviceMediationValueRuleExceptionHistoryList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMediationValueRuleExceptionHistoryList = DeviceMediationValueRuleExceptionHistoryList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceModelList = (function (_super) {
                __extends(DeviceModelList, _super);
                function DeviceModelList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceModelList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceModelList.Type = "Selcomm.Devices.DeviceModelList";
                DeviceModelList.TypeParameters = [];
                return DeviceModelList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceModelList = DeviceModelList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceGroups = (function (_super) {
                __extends(DeviceGroups, _super);
                function DeviceGroups(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceGroups.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceGroups.Type = "Selcomm.Devices.DeviceGroups";
                DeviceGroups.TypeParameters = [];
                return DeviceGroups;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceGroups = DeviceGroups;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceGroupList = (function (_super) {
                __extends(DeviceGroupList, _super);
                function DeviceGroupList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceGroupList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceGroupList.Type = "Selcomm.Devices.DeviceGroupList";
                DeviceGroupList.TypeParameters = [];
                return DeviceGroupList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceGroupList = DeviceGroupList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceGroupsContact = (function (_super) {
                __extends(DeviceGroupsContact, _super);
                function DeviceGroupsContact(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceGroupsContact.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.GroupId = args.GroupId;
                    _this.ContactCode = args.ContactCode;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceGroupsContact.Type = "Selcomm.Devices.DeviceGroupsContact";
                DeviceGroupsContact.TypeParameters = [];
                return DeviceGroupsContact;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceGroupsContact = DeviceGroupsContact;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceGroupsContactList = (function (_super) {
                __extends(DeviceGroupsContactList, _super);
                function DeviceGroupsContactList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceGroupsContactList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceGroupsContactList.Type = "Selcomm.Devices.DeviceGroupsContactList";
                DeviceGroupsContactList.TypeParameters = [];
                return DeviceGroupsContactList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceGroupsContactList = DeviceGroupsContactList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var EventDevice = (function (_super) {
                __extends(EventDevice, _super);
                function EventDevice(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.EventDevice.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Device = args.Device;
                    _this.Event = args.Event;
                    return _this;
                }
                EventDevice.Type = "Selcomm.Devices.EventDevice";
                EventDevice.TypeParameters = [];
                return EventDevice;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.EventDevice = EventDevice;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRuns = (function (_super) {
                __extends(DeviceReadRuns, _super);
                function DeviceReadRuns(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRuns.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceReadRuns.Type = "Selcomm.Devices.DeviceReadRuns";
                DeviceReadRuns.TypeParameters = [];
                return DeviceReadRuns;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceReadRuns = DeviceReadRuns;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRunsList = (function (_super) {
                __extends(DeviceReadRunsList, _super);
                function DeviceReadRunsList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRunsList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceReadRunsList.Type = "Selcomm.Devices.DeviceReadRunsList";
                DeviceReadRunsList.TypeParameters = [];
                return DeviceReadRunsList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceReadRunsList = DeviceReadRunsList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRunDetailStatus = (function (_super) {
                __extends(DeviceReadRunDetailStatus, _super);
                function DeviceReadRunDetailStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRunDetailStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.SystemStatus = args.SystemStatus;
                    return _this;
                }
                DeviceReadRunDetailStatus.Type = "Selcomm.Devices.DeviceReadRunDetailStatus";
                DeviceReadRunDetailStatus.TypeParameters = [];
                return DeviceReadRunDetailStatus;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceReadRunDetailStatus = DeviceReadRunDetailStatus;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRunDetailStatusList = (function (_super) {
                __extends(DeviceReadRunDetailStatusList, _super);
                function DeviceReadRunDetailStatusList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRunDetailStatusList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceReadRunDetailStatusList.Type = "Selcomm.Devices.DeviceReadRunDetailStatusList";
                DeviceReadRunDetailStatusList.TypeParameters = [];
                return DeviceReadRunDetailStatusList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceReadRunDetailStatusList = DeviceReadRunDetailStatusList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRunDtlInstance = (function (_super) {
                __extends(DeviceReadRunDtlInstance, _super);
                function DeviceReadRunDtlInstance(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRunDtlInstance.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.DtlId = args.DtlId;
                    _this.Status = args.Status;
                    _this.StatusDate = args.StatusDate;
                    _this.ContactCode = args.ContactCode;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceReadRunDtlInstance.Type = "Selcomm.Devices.DeviceReadRunDtlInstance";
                DeviceReadRunDtlInstance.TypeParameters = [];
                return DeviceReadRunDtlInstance;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceReadRunDtlInstance = DeviceReadRunDtlInstance;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRunsDetail = (function (_super) {
                __extends(DeviceReadRunsDetail, _super);
                function DeviceReadRunsDetail(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRunsDetail.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.RunId = args.RunId;
                    _this.DeviceId = args.DeviceId;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    _this.SequenceNumber = args.SequenceNumber;
                    return _this;
                }
                DeviceReadRunsDetail.Type = "Selcomm.Devices.DeviceReadRunsDetail";
                DeviceReadRunsDetail.TypeParameters = [];
                return DeviceReadRunsDetail;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceReadRunsDetail = DeviceReadRunsDetail;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRunDtlInstanceList = (function (_super) {
                __extends(DeviceReadRunDtlInstanceList, _super);
                function DeviceReadRunDtlInstanceList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRunDtlInstanceList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceReadRunDtlInstanceList.Type = "Selcomm.Devices.DeviceReadRunDtlInstanceList";
                DeviceReadRunDtlInstanceList.TypeParameters = [];
                return DeviceReadRunDtlInstanceList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceReadRunDtlInstanceList = DeviceReadRunDtlInstanceList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRunsDetailList = (function (_super) {
                __extends(DeviceReadRunsDetailList, _super);
                function DeviceReadRunsDetailList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRunsDetailList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceReadRunsDetailList.Type = "Selcomm.Devices.DeviceReadRunsDetailList";
                DeviceReadRunsDetailList.TypeParameters = [];
                return DeviceReadRunsDetailList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceReadRunsDetailList = DeviceReadRunsDetailList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRunsContact = (function (_super) {
                __extends(DeviceReadRunsContact, _super);
                function DeviceReadRunsContact(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRunsContact.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.RunId = args.RunId;
                    _this.ContactCode = args.ContactCode;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceReadRunsContact.Type = "Selcomm.Devices.DeviceReadRunsContact";
                DeviceReadRunsContact.TypeParameters = [];
                return DeviceReadRunsContact;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceReadRunsContact = DeviceReadRunsContact;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceReadRunsContactList = (function (_super) {
                __extends(DeviceReadRunsContactList, _super);
                function DeviceReadRunsContactList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceReadRunsContactList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceReadRunsContactList.Type = "Selcomm.Devices.DeviceReadRunsContactList";
                DeviceReadRunsContactList.TypeParameters = [];
                return DeviceReadRunsContactList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceReadRunsContactList = DeviceReadRunsContactList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceProtocol = (function (_super) {
                __extends(DeviceProtocol, _super);
                function DeviceProtocol(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceProtocol.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.DeviceId = args.DeviceId;
                    _this.Protocol = args.Protocol;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceProtocol.Type = "Selcomm.Devices.DeviceProtocol";
                DeviceProtocol.TypeParameters = [];
                return DeviceProtocol;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceProtocol = DeviceProtocol;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceProtocolDefinition = (function (_super) {
                __extends(DeviceProtocolDefinition, _super);
                function DeviceProtocolDefinition(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceProtocolDefinition.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Category = args.Category;
                    _this.QOS = args.QOS;
                    _this.MessageBroker = args.MessageBroker;
                    _this.Name = args.Name;
                    _this.Direction = args.Direction;
                    return _this;
                }
                DeviceProtocolDefinition.Type = "Selcomm.Devices.DeviceProtocolDefinition";
                DeviceProtocolDefinition.TypeParameters = [];
                return DeviceProtocolDefinition;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceProtocolDefinition = DeviceProtocolDefinition;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceProtocolCategory = (function (_super) {
                __extends(DeviceProtocolCategory, _super);
                function DeviceProtocolCategory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceProtocolCategory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Direction = args.Direction;
                    return _this;
                }
                DeviceProtocolCategory.Type = "Selcomm.Devices.DeviceProtocolCategory";
                DeviceProtocolCategory.TypeParameters = [];
                return DeviceProtocolCategory;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceProtocolCategory = DeviceProtocolCategory;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMessageQos = (function (_super) {
                __extends(DeviceMessageQos, _super);
                function DeviceMessageQos(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMessageQos.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Narrative = args.Narrative;
                    return _this;
                }
                DeviceMessageQos.Type = "Selcomm.Devices.DeviceMessageQos";
                DeviceMessageQos.TypeParameters = [];
                return DeviceMessageQos;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceMessageQos = DeviceMessageQos;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceProtocolList = (function (_super) {
                __extends(DeviceProtocolList, _super);
                function DeviceProtocolList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceProtocolList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceProtocolList.Type = "Selcomm.Devices.DeviceProtocolList";
                DeviceProtocolList.TypeParameters = [];
                return DeviceProtocolList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceProtocolList = DeviceProtocolList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceProtocolCategoryList = (function (_super) {
                __extends(DeviceProtocolCategoryList, _super);
                function DeviceProtocolCategoryList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceProtocolCategoryList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceProtocolCategoryList.Type = "Selcomm.Devices.DeviceProtocolCategoryList";
                DeviceProtocolCategoryList.TypeParameters = [];
                return DeviceProtocolCategoryList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceProtocolCategoryList = DeviceProtocolCategoryList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTestStatus = (function (_super) {
                __extends(DeviceTestStatus, _super);
                function DeviceTestStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTestStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Narrative = args.Narrative;
                    _this.SystemStatus = args.SystemStatus;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceTestStatus.Type = "Selcomm.Devices.DeviceTestStatus";
                DeviceTestStatus.TypeParameters = [];
                return DeviceTestStatus;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceTestStatus = DeviceTestStatus;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTestStatusList = (function (_super) {
                __extends(DeviceTestStatusList, _super);
                function DeviceTestStatusList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTestStatusList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTestStatusList.Type = "Selcomm.Devices.DeviceTestStatusList";
                DeviceTestStatusList.TypeParameters = [];
                return DeviceTestStatusList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTestStatusList = DeviceTestStatusList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTestTypes = (function (_super) {
                __extends(DeviceTestTypes, _super);
                function DeviceTestTypes(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTestTypes.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Narrative = args.Narrative;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceTestTypes.Type = "Selcomm.Devices.DeviceTestTypes";
                DeviceTestTypes.TypeParameters = [];
                return DeviceTestTypes;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceTestTypes = DeviceTestTypes;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTestTypeList = (function (_super) {
                __extends(DeviceTestTypeList, _super);
                function DeviceTestTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTestTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTestTypeList.Type = "Selcomm.Devices.DeviceTestTypeList";
                DeviceTestTypeList.TypeParameters = [];
                return DeviceTestTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTestTypeList = DeviceTestTypeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTests = (function (_super) {
                __extends(DeviceTests, _super);
                function DeviceTests(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTests.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Narrative = args.Narrative;
                    _this.Type = args.Type;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceTests.Type = "Selcomm.Devices.DeviceTests";
                DeviceTests.TypeParameters = [];
                return DeviceTests;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceTests = DeviceTests;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceTestsList = (function (_super) {
                __extends(DeviceTestsList, _super);
                function DeviceTestsList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceTestsList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceTestsList.Type = "Selcomm.Devices.DeviceTestsList";
                DeviceTestsList.TypeParameters = [];
                return DeviceTestsList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceTestsList = DeviceTestsList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceFramingSchemeList = (function (_super) {
                __extends(DeviceFramingSchemeList, _super);
                function DeviceFramingSchemeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceFramingSchemeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceFramingSchemeList.Type = "Selcomm.Devices.DeviceFramingSchemeList";
                DeviceFramingSchemeList.TypeParameters = [];
                return DeviceFramingSchemeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceFramingSchemeList = DeviceFramingSchemeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DevicePollingSchemeList = (function (_super) {
                __extends(DevicePollingSchemeList, _super);
                function DevicePollingSchemeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DevicePollingSchemeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DevicePollingSchemeList.Type = "Selcomm.Devices.DevicePollingSchemeList";
                DevicePollingSchemeList.TypeParameters = [];
                return DevicePollingSchemeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DevicePollingSchemeList = DevicePollingSchemeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceStock = (function (_super) {
                __extends(DeviceStock, _super);
                function DeviceStock(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceStock.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Device = args.Device;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    _this.Status = args.Status;
                    _this.SerialNumber = args.SerialNumber;
                    _this.Warranty = args.Warranty;
                    _this.Note = args.Note;
                    return _this;
                }
                DeviceStock.Type = "Selcomm.Devices.DeviceStock";
                DeviceStock.TypeParameters = [];
                return DeviceStock;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceStock = DeviceStock;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceStockStatus = (function (_super) {
                __extends(DeviceStockStatus, _super);
                function DeviceStockStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceStockStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.StatusId = args.StatusId;
                    _this.Name = args.Name;
                    _this.SystemStatus = args.SystemStatus;
                    return _this;
                }
                DeviceStockStatus.Type = "Selcomm.Devices.DeviceStockStatus";
                DeviceStockStatus.TypeParameters = [];
                return DeviceStockStatus;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceStockStatus = DeviceStockStatus;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceStockList = (function (_super) {
                __extends(DeviceStockList, _super);
                function DeviceStockList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceStockList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceStockList.Type = "Selcomm.Devices.DeviceStockList";
                DeviceStockList.TypeParameters = [];
                return DeviceStockList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceStockList = DeviceStockList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceStockStatusList = (function (_super) {
                __extends(DeviceStockStatusList, _super);
                function DeviceStockStatusList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceStockStatusList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceStockStatusList.Type = "Selcomm.Devices.DeviceStockStatusList";
                DeviceStockStatusList.TypeParameters = [];
                return DeviceStockStatusList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceStockStatusList = DeviceStockStatusList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceSiteTypeList = (function (_super) {
                __extends(DeviceSiteTypeList, _super);
                function DeviceSiteTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceSiteTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceSiteTypeList.Type = "Selcomm.Devices.DeviceSiteTypeList";
                DeviceSiteTypeList.TypeParameters = [];
                return DeviceSiteTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceSiteTypeList = DeviceSiteTypeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceActionsList = (function (_super) {
                __extends(DeviceActionsList, _super);
                function DeviceActionsList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceActionsList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceActionsList.Type = "Selcomm.Devices.DeviceActionsList";
                DeviceActionsList.TypeParameters = [];
                return DeviceActionsList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceActionsList = DeviceActionsList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceImages = (function (_super) {
                __extends(DeviceImages, _super);
                function DeviceImages(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceImages.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Device = args.Device;
                    _this.ImageId = args.ImageId;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceImages.Type = "Selcomm.Devices.DeviceImages";
                DeviceImages.TypeParameters = [];
                return DeviceImages;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DeviceImages = DeviceImages;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceImagesList = (function (_super) {
                __extends(DeviceImagesList, _super);
                function DeviceImagesList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceImagesList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceImagesList.Type = "Selcomm.Devices.DeviceImagesList";
                DeviceImagesList.TypeParameters = [];
                return DeviceImagesList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceImagesList = DeviceImagesList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceManufacturerList = (function (_super) {
                __extends(DeviceManufacturerList, _super);
                function DeviceManufacturerList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceManufacturerList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceManufacturerList.Type = "Selcomm.Devices.DeviceManufacturerList";
                DeviceManufacturerList.TypeParameters = [];
                return DeviceManufacturerList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceManufacturerList = DeviceManufacturerList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMessageBrokerList = (function (_super) {
                __extends(DeviceMessageBrokerList, _super);
                function DeviceMessageBrokerList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMessageBrokerList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMessageBrokerList.Type = "Selcomm.Devices.DeviceMessageBrokerList";
                DeviceMessageBrokerList.TypeParameters = [];
                return DeviceMessageBrokerList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMessageBrokerList = DeviceMessageBrokerList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMessageBrokerStatusList = (function (_super) {
                __extends(DeviceMessageBrokerStatusList, _super);
                function DeviceMessageBrokerStatusList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMessageBrokerStatusList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMessageBrokerStatusList.Type = "Selcomm.Devices.DeviceMessageBrokerStatusList";
                DeviceMessageBrokerStatusList.TypeParameters = [];
                return DeviceMessageBrokerStatusList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMessageBrokerStatusList = DeviceMessageBrokerStatusList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMessageBrokerTypeList = (function (_super) {
                __extends(DeviceMessageBrokerTypeList, _super);
                function DeviceMessageBrokerTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMessageBrokerTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMessageBrokerTypeList.Type = "Selcomm.Devices.DeviceMessageBrokerTypeList";
                DeviceMessageBrokerTypeList.TypeParameters = [];
                return DeviceMessageBrokerTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMessageBrokerTypeList = DeviceMessageBrokerTypeList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceMessageQosList = (function (_super) {
                __extends(DeviceMessageQosList, _super);
                function DeviceMessageQosList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceMessageQosList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceMessageQosList.Type = "Selcomm.Devices.DeviceMessageQosList";
                DeviceMessageQosList.TypeParameters = [];
                return DeviceMessageQosList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceMessageQosList = DeviceMessageQosList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DevicePackage = (function (_super) {
                __extends(DevicePackage, _super);
                function DevicePackage(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DevicePackage.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Device = args.Device;
                    _this.PackageCode = args.PackageCode;
                    _this.PackageOption = args.PackageOption;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DevicePackage.Type = "Selcomm.Devices.DevicePackage";
                DevicePackage.TypeParameters = [];
                return DevicePackage;
            }(Selcomm.Objects.DisplayBaseObject));
            Devices.DevicePackage = DevicePackage;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DevicePackageList = (function (_super) {
                __extends(DevicePackageList, _super);
                function DevicePackageList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DevicePackageList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DevicePackageList.Type = "Selcomm.Devices.DevicePackageList";
                DevicePackageList.TypeParameters = [];
                return DevicePackageList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DevicePackageList = DevicePackageList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceProduct = (function (_super) {
                __extends(DeviceProduct, _super);
                function DeviceProduct(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceProduct.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.TypeCode = args.TypeCode;
                    _this.ProductManufacturerCode = args.ProductManufacturerCode;
                    _this.Narrative = args.Narrative;
                    _this.Cost = args.Cost;
                    _this.Price = args.Price;
                    _this.PriceTax = args.PriceTax;
                    _this.Dispatchable = args.Dispatchable;
                    _this.DispatchCompCode = args.DispatchCompCode;
                    _this.MinimumQuantity = args.MinimumQuantity;
                    _this.MaximumQuantity = args.MaximumQuantity;
                    _this.DispatchOrder = args.DispatchOrder;
                    _this.Enabled = args.Enabled;
                    _this.Serialisable = args.Serialisable;
                    _this.AutomaticNumberCode = args.AutomaticNumberCode;
                    _this.StringTypeCode = args.StringTypeCode;
                    _this.Url = args.Url;
                    _this.Note = args.Note;
                    _this.ManufacturerCode = args.ManufacturerCode;
                    _this.BrandId = args.BrandId;
                    _this.ColorId = args.ColorId;
                    return _this;
                }
                DeviceProduct.Type = "Selcomm.Devices.DeviceProduct";
                DeviceProduct.TypeParameters = [];
                return DeviceProduct;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceProduct = DeviceProduct;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceProductList = (function (_super) {
                __extends(DeviceProductList, _super);
                function DeviceProductList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceProductList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                DeviceProductList.Type = "Selcomm.Devices.DeviceProductList";
                DeviceProductList.TypeParameters = [];
                return DeviceProductList;
            }(Selcomm.Objects.ExtendedDataList));
            Devices.DeviceProductList = DeviceProductList;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceServiceConnection = (function (_super) {
                __extends(DeviceServiceConnection, _super);
                function DeviceServiceConnection(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceServiceConnection.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Device = args.Device;
                    _this.ServiceReference = args.ServiceReference;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceServiceConnection.Type = "Selcomm.Devices.DeviceServiceConnection";
                DeviceServiceConnection.TypeParameters = [];
                return DeviceServiceConnection;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceServiceConnection = DeviceServiceConnection;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Devices;
        (function (Devices) {
            var DeviceContact = (function (_super) {
                __extends(DeviceContact, _super);
                function DeviceContact(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Devices.DeviceContact.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.RelationshipType = args.RelationshipType;
                    _this.Contact = args.Contact;
                    _this.Device = args.Device;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                DeviceContact.Type = "Selcomm.Devices.DeviceContact";
                DeviceContact.TypeParameters = [];
                return DeviceContact;
            }(Selcomm.Objects.DataObject));
            Devices.DeviceContact = DeviceContact;
        })(Devices = Selcomm.Devices || (Selcomm.Devices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service_1) {
            var Service = (function (_super) {
                __extends(Service, _super);
                function Service(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.Service.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceId = args.ServiceId;
                    _this.Dealer = args.Dealer;
                    _this.ConnectionType = args.ConnectionType;
                    _this.AddressDisplayList = args.AddressDisplayList;
                    _this.AddressList = args.AddressList;
                    _this.AddressExtendedList = args.AddressExtendedList;
                    _this.AvailableAddresses = args.AvailableAddresses;
                    _this.AlertList = args.AlertList;
                    _this.ConnectionDateTime = args.ConnectionDateTime;
                    _this.DisconnectionDateTime = args.DisconnectionDateTime;
                    _this.BillingStartDateTime = args.BillingStartDateTime;
                    _this.BillingEndDateTime = args.BillingEndDateTime;
                    _this.ContactList = args.ContactList;
                    _this.AttributesList = args.AttributesList;
                    _this.ContactPhoneList = args.ContactPhoneList;
                    _this.AvailableContactPhones = args.AvailableContactPhones;
                    _this.AutoBarList = args.AutoBarList;
                    _this.AutoTopUpList = args.AutoTopUpList;
                    _this.AvailableNumberList = args.AvailableNumberList;
                    _this.BookingList = args.BookingList;
                    _this.ChargeList = args.ChargeList;
                    _this.ChargeDefinitionList = args.ChargeDefinitionList;
                    _this.PriceOverrideChargeList = args.PriceOverrideChargeList;
                    _this.ChildServiceList = args.ChildServiceList;
                    _this.CommissionList = args.CommissionList;
                    _this.CommunicationList = args.CommunicationList;
                    _this.ContractList = args.ContractList;
                    _this.DelegationList = args.DelegationList;
                    _this.DeviceList = args.DeviceList;
                    _this.DocumentList = args.DocumentList;
                    _this.EquipmentList = args.EquipmentList;
                    _this.EventList = args.EventList;
                    _this.InvoiceInterval = args.InvoiceInterval;
                    _this.LocationList = args.LocationList;
                    _this.NetworkList = args.NetworkList;
                    _this.NetworkActionList = args.NetworkActionList;
                    _this.NetworkElementList = args.NetworkElementList;
                    _this.NetworkIdentifierList = args.NetworkIdentifierList;
                    _this.NetworkIdentifierChangeRequestList = args.NetworkIdentifierChangeRequestList;
                    _this.NoteList = args.NoteList;
                    _this.OrderList = args.OrderList;
                    _this.PackageList = args.PackageList;
                    _this.PackageChangeRequestList = args.PackageChangeRequestList;
                    _this.ParentService = args.ParentService;
                    _this.PasswordList = args.PasswordList;
                    _this.PaymentMethodList = args.PaymentMethodList;
                    _this.PortingInformationList = args.PortingInformationList;
                    _this.PromotionList = args.PromotionList;
                    _this.RechargeVoucherList = args.RechargeVoucherList;
                    _this.RegistrationList = args.RegistrationList;
                    _this.ReportList = args.ReportList;
                    _this.RetentionList = args.RetentionList;
                    _this.SalesPerson = args.SalesPerson;
                    _this.SellOnList = args.SellOnList;
                    _this.ServiceElementList = args.ServiceElementList;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.ServiceType = args.ServiceType;
                    _this.SiteList = args.SiteList;
                    _this.StatusList = args.StatusList;
                    _this.SystemStatusList = args.SystemStatusList;
                    _this.Subscriber = args.Subscriber;
                    _this.SuspensionList = args.SuspensionList;
                    _this.TaskList = args.TaskList;
                    _this.PriceOverrideUsageList = args.PriceOverrideUsageList;
                    _this.UsageList = args.UsageList;
                    _this.UsageSummaryList = args.UsageSummaryList;
                    _this.UserList = args.UserList;
                    _this.UserLabel = args.UserLabel;
                    _this.ValueAddedServiceList = args.ValueAddedServiceList;
                    _this.WinbackList = args.WinbackList;
                    _this.IMEI = args.IMEI;
                    return _this;
                }
                Service.Type = "Selcomm.Service.Service";
                Service.TypeParameters = [];
                return Service;
            }(Selcomm.Objects.DataObject));
            Service_1.Service = Service;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAction = (function (_super) {
                __extends(ServiceAction, _super);
                function ServiceAction(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceAction.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Narrative = args.Narrative;
                    _this.DisplayFlag = args.DisplayFlag;
                    _this.ObjectID = args.ObjectID;
                    _this.Reference = args.Reference;
                    _this.ActionCategory = args.ActionCategory;
                    return _this;
                }
                ServiceAction.Type = "Selcomm.Service.ServiceAction";
                ServiceAction.TypeParameters = [];
                return ServiceAction;
            }(Selcomm.Objects.DataObject));
            Service.ServiceAction = ServiceAction;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceActionCategory = (function (_super) {
                __extends(ServiceActionCategory, _super);
                function ServiceActionCategory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceActionCategory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ServiceActionCategory.Type = "Selcomm.Service.ServiceActionCategory";
                ServiceActionCategory.TypeParameters = [];
                return ServiceActionCategory;
            }(Selcomm.Objects.DataObject));
            Service.ServiceActionCategory = ServiceActionCategory;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var AddressDisplay = (function () {
                function AddressDisplay(args) {
                    this.$type = Selcomm.Address.AddressDisplay.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Description = args.Description;
                }
                AddressDisplay.Type = "Selcomm.Address.AddressDisplay";
                AddressDisplay.TypeParameters = [];
                return AddressDisplay;
            }());
            Address.AddressDisplay = AddressDisplay;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Address;
        (function (Address) {
            var AddressDisplayList = (function (_super) {
                __extends(AddressDisplayList, _super);
                function AddressDisplayList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Address.AddressDisplayList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AddressDisplayList.Type = "Selcomm.Address.AddressDisplayList";
                AddressDisplayList.TypeParameters = [];
                return AddressDisplayList;
            }(Selcomm.Objects.ExtendedDataList));
            Address.AddressDisplayList = AddressDisplayList;
        })(Address = Selcomm.Address || (Selcomm.Address = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAddress = (function (_super) {
                __extends(ServiceAddress, _super);
                function ServiceAddress(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceAddress.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceId = args.ServiceId;
                    _this.Type = args.Type;
                    _this.From = args.From;
                    _this.To = args.To;
                    _this.Address = args.Address;
                    return _this;
                }
                ServiceAddress.Type = "Selcomm.Service.ServiceAddress";
                ServiceAddress.TypeParameters = [];
                return ServiceAddress;
            }(Selcomm.Objects.DataObject));
            Service.ServiceAddress = ServiceAddress;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAddressType = (function (_super) {
                __extends(ServiceAddressType, _super);
                function ServiceAddressType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceAddressType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ServiceAddressType.Type = "Selcomm.Service.ServiceAddressType";
                ServiceAddressType.TypeParameters = [];
                return ServiceAddressType;
            }(Selcomm.Address.AddressType));
            Service.ServiceAddressType = ServiceAddressType;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAddressExtended = (function () {
                function ServiceAddressExtended(args) {
                    this.$type = Selcomm.Service.ServiceAddressExtended.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ServiceId = args.ServiceId;
                    this.AddressTypeList = args.AddressTypeList;
                    this.From = args.From;
                    this.To = args.To;
                    this.ExtendedAddress = args.ExtendedAddress;
                }
                ServiceAddressExtended.Type = "Selcomm.Service.ServiceAddressExtended";
                ServiceAddressExtended.TypeParameters = [];
                return ServiceAddressExtended;
            }());
            Service.ServiceAddressExtended = ServiceAddressExtended;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Alert;
        (function (Alert_1) {
            var Alert = (function (_super) {
                __extends(Alert, _super);
                function Alert(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Alert.Alert.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.From = args.From;
                    _this.To = args.To;
                    return _this;
                }
                Alert.Type = "Selcomm.Alert.Alert";
                Alert.TypeParameters = [];
                return Alert;
            }(Selcomm.Objects.DataObject));
            Alert_1.Alert = Alert;
        })(Alert = Selcomm.Alert || (Selcomm.Alert = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAlert = (function (_super) {
                __extends(ServiceAlert, _super);
                function ServiceAlert(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceAlert.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceRef = args.ServiceRef;
                    _this.AlertAmount = args.AlertAmount;
                    _this.AlertDate = args.AlertDate;
                    return _this;
                }
                ServiceAlert.Type = "Selcomm.Service.ServiceAlert";
                ServiceAlert.TypeParameters = [];
                return ServiceAlert;
            }(Selcomm.Alert.Alert));
            Service.ServiceAlert = ServiceAlert;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceContact = (function () {
                function ServiceContact(args) {
                    this.$type = Selcomm.Service.ServiceContact.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ServiceId = args.ServiceId;
                    this.ContactType = args.ContactType;
                    this.From = args.From;
                    this.To = args.To;
                    this.Contact = args.Contact;
                }
                ServiceContact.Type = "Selcomm.Service.ServiceContact";
                ServiceContact.TypeParameters = [];
                return ServiceContact;
            }());
            Service.ServiceContact = ServiceContact;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceContactType = (function () {
                function ServiceContactType(args) {
                    this.$type = Selcomm.Service.ServiceContactType.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceContactType.Type = "Selcomm.Service.ServiceContactType";
                ServiceContactType.TypeParameters = [];
                return ServiceContactType;
            }());
            Service.ServiceContactType = ServiceContactType;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceContactPhone = (function (_super) {
                __extends(ServiceContactPhone, _super);
                function ServiceContactPhone(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceContactPhone.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceId = args.ServiceId;
                    _this.ContactPhoneTypeList = args.ContactPhoneTypeList;
                    _this.From = args.From;
                    _this.To = args.To;
                    _this.ContactPhone = args.ContactPhone;
                    return _this;
                }
                ServiceContactPhone.Type = "Selcomm.Service.ServiceContactPhone";
                ServiceContactPhone.TypeParameters = [];
                return ServiceContactPhone;
            }(Selcomm.ContactPhones.ContactPhone));
            Service.ServiceContactPhone = ServiceContactPhone;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAutoBar = (function () {
                function ServiceAutoBar(args) {
                    this.$type = Selcomm.Service.ServiceAutoBar.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceAutoBar.Type = "Selcomm.Service.ServiceAutoBar";
                ServiceAutoBar.TypeParameters = [];
                return ServiceAutoBar;
            }());
            Service.ServiceAutoBar = ServiceAutoBar;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAutoTopUp = (function () {
                function ServiceAutoTopUp(args) {
                    this.$type = Selcomm.Service.ServiceAutoTopUp.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceAutoTopUp.Type = "Selcomm.Service.ServiceAutoTopUp";
                ServiceAutoTopUp.TypeParameters = [];
                return ServiceAutoTopUp;
            }());
            Service.ServiceAutoTopUp = ServiceAutoTopUp;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAvailableNumber = (function () {
                function ServiceAvailableNumber(args) {
                    this.$type = Selcomm.Service.ServiceAvailableNumber.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceAvailableNumber.Type = "Selcomm.Service.ServiceAvailableNumber";
                ServiceAvailableNumber.TypeParameters = [];
                return ServiceAvailableNumber;
            }());
            Service.ServiceAvailableNumber = ServiceAvailableNumber;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceBooking = (function () {
                function ServiceBooking(args) {
                    this.$type = Selcomm.Service.ServiceBooking.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceBooking.Type = "Selcomm.Service.ServiceBooking";
                ServiceBooking.TypeParameters = [];
                return ServiceBooking;
            }());
            Service.ServiceBooking = ServiceBooking;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceCharge = (function () {
                function ServiceCharge(args) {
                    this.$type = Selcomm.Service.ServiceCharge.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceCharge.Type = "Selcomm.Service.ServiceCharge";
                ServiceCharge.TypeParameters = [];
                return ServiceCharge;
            }());
            Service.ServiceCharge = ServiceCharge;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceChargeDefinition = (function () {
                function ServiceChargeDefinition(args) {
                    this.$type = Selcomm.Service.ServiceChargeDefinition.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceChargeDefinition.Type = "Selcomm.Service.ServiceChargeDefinition";
                ServiceChargeDefinition.TypeParameters = [];
                return ServiceChargeDefinition;
            }());
            Service.ServiceChargeDefinition = ServiceChargeDefinition;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePriceOverrideCharge = (function () {
                function ServicePriceOverrideCharge(args) {
                    this.$type = Selcomm.Service.ServicePriceOverrideCharge.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServicePriceOverrideCharge.Type = "Selcomm.Service.ServicePriceOverrideCharge";
                ServicePriceOverrideCharge.TypeParameters = [];
                return ServicePriceOverrideCharge;
            }());
            Service.ServicePriceOverrideCharge = ServicePriceOverrideCharge;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceCommission = (function () {
                function ServiceCommission(args) {
                    this.$type = Selcomm.Service.ServiceCommission.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceCommission.Type = "Selcomm.Service.ServiceCommission";
                ServiceCommission.TypeParameters = [];
                return ServiceCommission;
            }());
            Service.ServiceCommission = ServiceCommission;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceCommunication = (function () {
                function ServiceCommunication(args) {
                    this.$type = Selcomm.Service.ServiceCommunication.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceCommunication.Type = "Selcomm.Service.ServiceCommunication";
                ServiceCommunication.TypeParameters = [];
                return ServiceCommunication;
            }());
            Service.ServiceCommunication = ServiceCommunication;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceContract = (function (_super) {
                __extends(ServiceContract, _super);
                function ServiceContract(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceContract.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ContractRef = args.ContractRef;
                    _this.ServiceReference = args.ServiceReference;
                    _this.StartDate = args.StartDate;
                    _this.Contract = args.Contract;
                    _this.ContractNumber = args.ContractNumber;
                    _this.EndDate = args.EndDate;
                    _this.SalesPerson = args.SalesPerson;
                    return _this;
                }
                ServiceContract.Type = "Selcomm.Service.ServiceContract";
                ServiceContract.TypeParameters = [];
                return ServiceContract;
            }(Selcomm.Objects.DataObject));
            Service.ServiceContract = ServiceContract;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceDelegation = (function () {
                function ServiceDelegation(args) {
                    this.$type = Selcomm.Service.ServiceDelegation.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceDelegation.Type = "Selcomm.Service.ServiceDelegation";
                ServiceDelegation.TypeParameters = [];
                return ServiceDelegation;
            }());
            Service.ServiceDelegation = ServiceDelegation;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceDevice = (function () {
                function ServiceDevice(args) {
                    this.$type = Selcomm.Service.ServiceDevice.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceDevice.Type = "Selcomm.Service.ServiceDevice";
                ServiceDevice.TypeParameters = [];
                return ServiceDevice;
            }());
            Service.ServiceDevice = ServiceDevice;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceDocument = (function (_super) {
                __extends(ServiceDocument, _super);
                function ServiceDocument(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceDocument.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceId = args.ServiceId;
                    return _this;
                }
                ServiceDocument.Type = "Selcomm.Service.ServiceDocument";
                ServiceDocument.TypeParameters = [];
                return ServiceDocument;
            }(Selcomm.Documents.Document));
            Service.ServiceDocument = ServiceDocument;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceEquipment = (function () {
                function ServiceEquipment(args) {
                    this.$type = Selcomm.Service.ServiceEquipment.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceEquipment.Type = "Selcomm.Service.ServiceEquipment";
                ServiceEquipment.TypeParameters = [];
                return ServiceEquipment;
            }());
            Service.ServiceEquipment = ServiceEquipment;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceEvent = (function (_super) {
                __extends(ServiceEvent, _super);
                function ServiceEvent(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceEvent.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Event = args.Event;
                    return _this;
                }
                ServiceEvent.Type = "Selcomm.Service.ServiceEvent";
                ServiceEvent.TypeParameters = [];
                return ServiceEvent;
            }(Selcomm.Objects.DataObject));
            Service.ServiceEvent = ServiceEvent;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceInvoiceInterval;
            (function (ServiceInvoiceInterval) {
                ServiceInvoiceInterval[ServiceInvoiceInterval["Monthly"] = 0] = "Monthly";
                ServiceInvoiceInterval[ServiceInvoiceInterval["Quarterly"] = 1] = "Quarterly";
                ServiceInvoiceInterval[ServiceInvoiceInterval["BiAnnually"] = 2] = "BiAnnually";
                ServiceInvoiceInterval[ServiceInvoiceInterval["Annually"] = 3] = "Annually";
            })(ServiceInvoiceInterval = Service.ServiceInvoiceInterval || (Service.ServiceInvoiceInterval = {}));
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceLocation = (function () {
                function ServiceLocation(args) {
                    this.$type = Selcomm.Service.ServiceLocation.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceLocation.Type = "Selcomm.Service.ServiceLocation";
                ServiceLocation.TypeParameters = [];
                return ServiceLocation;
            }());
            Service.ServiceLocation = ServiceLocation;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network_1) {
            var Network = (function (_super) {
                __extends(Network, _super);
                function Network(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.Network.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.NetworkId = args.NetworkId;
                    _this.NetworkName = args.NetworkName;
                    _this.DisplayFlag = args.DisplayFlag;
                    _this.ContactCode = args.ContactCode;
                    _this.TransactionList = args.TransactionList;
                    return _this;
                }
                Network.Type = "Selcomm.Network.Network";
                Network.TypeParameters = [];
                return Network;
            }(Selcomm.Objects.DataObject));
            Network_1.Network = Network;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkTransaction = (function (_super) {
                __extends(NetworkTransaction, _super);
                function NetworkTransaction(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.NetworkTransaction.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.File = args.File;
                    _this.Status = args.Status;
                    _this.TypeCode = args.TypeCode;
                    _this.Network = args.Network;
                    _this.Flow = args.Flow;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.ServiceReference = args.ServiceReference;
                    _this.SelcommReference = args.SelcommReference;
                    _this.NetworkReference = args.NetworkReference;
                    _this.DestDB = args.DestDB;
                    _this.DateTimeStamp = args.DateTimeStamp;
                    _this.DelimitedContent = args.DelimitedContent;
                    _this.TransactionEvent = args.TransactionEvent;
                    return _this;
                }
                NetworkTransaction.Type = "Selcomm.Network.NetworkTransaction";
                NetworkTransaction.TypeParameters = [];
                return NetworkTransaction;
            }(Selcomm.Objects.DataObject));
            Network.NetworkTransaction = NetworkTransaction;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkFile = (function (_super) {
                __extends(NetworkFile, _super);
                function NetworkFile(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.NetworkFile.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Number = args.Number;
                    _this.Customer = args.Customer;
                    _this.TypeCode = args.TypeCode;
                    _this.Sequence = args.Sequence;
                    _this.Status = args.Status;
                    _this.Name = args.Name;
                    _this.FileDate = args.FileDate;
                    _this.Header = args.Header;
                    _this.Trailer = args.Trailer;
                    _this.TransactionList = args.TransactionList;
                    return _this;
                }
                NetworkFile.Type = "Selcomm.Network.NetworkFile";
                NetworkFile.TypeParameters = [];
                return NetworkFile;
            }(Selcomm.Objects.DataObject));
            Network.NetworkFile = NetworkFile;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkCustomer = (function () {
                function NetworkCustomer(args) {
                    this.$type = Selcomm.Network.NetworkCustomer.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Number = args.Number;
                    this.Narrative = args.Narrative;
                    this.DefaultCustomer = args.DefaultCustomer;
                    this.FileList = args.FileList;
                }
                NetworkCustomer.Type = "Selcomm.Network.NetworkCustomer";
                NetworkCustomer.TypeParameters = [];
                return NetworkCustomer;
            }());
            Network.NetworkCustomer = NetworkCustomer;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkFileStatus = (function () {
                function NetworkFileStatus(args) {
                    this.$type = Selcomm.Network.NetworkFileStatus.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ID = args.ID;
                    this.Narrative = args.Narrative;
                    this.FileList = args.FileList;
                }
                NetworkFileStatus.Type = "Selcomm.Network.NetworkFileStatus";
                NetworkFileStatus.TypeParameters = [];
                return NetworkFileStatus;
            }());
            Network.NetworkFileStatus = NetworkFileStatus;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkFileHeader = (function () {
                function NetworkFileHeader(args) {
                    this.$type = Selcomm.Network.NetworkFileHeader.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.EarliestCall = args.EarliestCall;
                    this.LatestCall = args.LatestCall;
                    this.ProcessedDate = args.ProcessedDate;
                    this.ProcessedTime = args.ProcessedTime;
                    this.BatchNumber = args.BatchNumber;
                    this.TotalInBatch = args.TotalInBatch;
                    this.FilesInBatch = args.FilesInBatch;
                    this.InvoiceNumber = args.InvoiceNumber;
                    this.InvoiceMonth = args.InvoiceMonth;
                    this.Number = args.Number;
                    this.Customer = args.Customer;
                }
                NetworkFileHeader.Type = "Selcomm.Network.NetworkFileHeader";
                NetworkFileHeader.TypeParameters = [];
                return NetworkFileHeader;
            }());
            Network.NetworkFileHeader = NetworkFileHeader;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkFileTrailer = (function () {
                function NetworkFileTrailer(args) {
                    this.$type = Selcomm.Network.NetworkFileTrailer.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Number = args.Number;
                    this.Customer = args.Customer;
                    this.EarliestCall = args.EarliestCall;
                    this.LatestCall = args.LatestCall;
                    this.ProcessedDate = args.ProcessedDate;
                    this.ProcessedTime = args.ProcessedTime;
                    this.TotalQuantity = args.TotalQuantity;
                    this.TotalCost = args.TotalCost;
                    this.TotalRecord = args.TotalRecord;
                    this.TotalNonDiscount = args.TotalNonDiscount;
                    this.BatchNumber = args.BatchNumber;
                    this.TotalInBatch = args.TotalInBatch;
                    this.FilesInBatch = args.FilesInBatch;
                    this.InvoiceNumber = args.InvoiceNumber;
                    this.InvoiceMonth = args.InvoiceMonth;
                    this.TotalRecordBatch = args.TotalRecordBatch;
                }
                NetworkFileTrailer.Type = "Selcomm.Network.NetworkFileTrailer";
                NetworkFileTrailer.TypeParameters = [];
                return NetworkFileTrailer;
            }());
            Network.NetworkFileTrailer = NetworkFileTrailer;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkTransactionStatus = (function () {
                function NetworkTransactionStatus(args) {
                    this.$type = Selcomm.Network.NetworkTransactionStatus.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Narrative = args.Narrative;
                    this.TransactionList = args.TransactionList;
                }
                NetworkTransactionStatus.Type = "Selcomm.Network.NetworkTransactionStatus";
                NetworkTransactionStatus.TypeParameters = [];
                return NetworkTransactionStatus;
            }());
            Network.NetworkTransactionStatus = NetworkTransactionStatus;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkTransationType = (function () {
                function NetworkTransationType(args) {
                    this.$type = Selcomm.Network.NetworkTransationType.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Code = args.Code;
                    this.Narrative = args.Narrative;
                    this.TabName = args.TabName;
                    this.TransactionList = args.TransactionList;
                    this.TransactionLayoutList = args.TransactionLayoutList;
                }
                NetworkTransationType.Type = "Selcomm.Network.NetworkTransationType";
                NetworkTransationType.TypeParameters = [];
                return NetworkTransationType;
            }());
            Network.NetworkTransationType = NetworkTransationType;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkTransactionLayout = (function (_super) {
                __extends(NetworkTransactionLayout, _super);
                function NetworkTransactionLayout(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.NetworkTransactionLayout.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.TransactionType = args.TransactionType;
                    _this.DefinitionWithEffectiveFrom = args.DefinitionWithEffectiveFrom;
                    _this.DefinitionWithEffectiveTo = args.DefinitionWithEffectiveTo;
                    _this.DelimiterHeading = args.DelimiterHeading;
                    return _this;
                }
                NetworkTransactionLayout.Type = "Selcomm.Network.NetworkTransactionLayout";
                NetworkTransactionLayout.TypeParameters = [];
                return NetworkTransactionLayout;
            }(Selcomm.Objects.DataObject));
            Network.NetworkTransactionLayout = NetworkTransactionLayout;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkTransactionEvent = (function () {
                function NetworkTransactionEvent(args) {
                    this.$type = Selcomm.Network.NetworkTransactionEvent.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.TransactionList = args.TransactionList;
                    this.EventList = args.EventList;
                }
                NetworkTransactionEvent.Type = "Selcomm.Network.NetworkTransactionEvent";
                NetworkTransactionEvent.TypeParameters = [];
                return NetworkTransactionEvent;
            }());
            Network.NetworkTransactionEvent = NetworkTransactionEvent;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceNetwork = (function (_super) {
                __extends(ServiceNetwork, _super);
                function ServiceNetwork(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceNetwork.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ServiceNetwork.Type = "Selcomm.Service.ServiceNetwork";
                ServiceNetwork.TypeParameters = [];
                return ServiceNetwork;
            }(Selcomm.Network.Network));
            Service.ServiceNetwork = ServiceNetwork;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceNetworkAction = (function (_super) {
                __extends(ServiceNetworkAction, _super);
                function ServiceNetworkAction(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceNetworkAction.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ServiceNetworkAction.Type = "Selcomm.Service.ServiceNetworkAction";
                ServiceNetworkAction.TypeParameters = [];
                return ServiceNetworkAction;
            }(Selcomm.Network.Network));
            Service.ServiceNetworkAction = ServiceNetworkAction;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceNetworkElement = (function () {
                function ServiceNetworkElement(args) {
                    this.$type = Selcomm.Service.ServiceNetworkElement.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceNetworkElement.Type = "Selcomm.Service.ServiceNetworkElement";
                ServiceNetworkElement.TypeParameters = [];
                return ServiceNetworkElement;
            }());
            Service.ServiceNetworkElement = ServiceNetworkElement;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceNetworkIdentifier = (function () {
                function ServiceNetworkIdentifier(args) {
                    this.$type = Selcomm.Service.ServiceNetworkIdentifier.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceNetworkIdentifier.Type = "Selcomm.Service.ServiceNetworkIdentifier";
                ServiceNetworkIdentifier.TypeParameters = [];
                return ServiceNetworkIdentifier;
            }());
            Service.ServiceNetworkIdentifier = ServiceNetworkIdentifier;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceNetworkIdentifierChangeRequest = (function () {
                function ServiceNetworkIdentifierChangeRequest(args) {
                    this.$type = Selcomm.Service.ServiceNetworkIdentifierChangeRequest.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceNetworkIdentifierChangeRequest.Type = "Selcomm.Service.ServiceNetworkIdentifierChangeRequest";
                ServiceNetworkIdentifierChangeRequest.TypeParameters = [];
                return ServiceNetworkIdentifierChangeRequest;
            }());
            Service.ServiceNetworkIdentifierChangeRequest = ServiceNetworkIdentifierChangeRequest;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceNote = (function () {
                function ServiceNote(args) {
                    this.$type = Selcomm.Service.ServiceNote.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceNote.Type = "Selcomm.Service.ServiceNote";
                ServiceNote.TypeParameters = [];
                return ServiceNote;
            }());
            Service.ServiceNote = ServiceNote;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceOrder = (function () {
                function ServiceOrder(args) {
                    this.$type = Selcomm.Service.ServiceOrder.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceOrder.Type = "Selcomm.Service.ServiceOrder";
                ServiceOrder.TypeParameters = [];
                return ServiceOrder;
            }());
            Service.ServiceOrder = ServiceOrder;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePackage = (function (_super) {
                __extends(ServicePackage, _super);
                function ServicePackage(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServicePackage.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServicePackageId = args.ServicePackageId;
                    _this.PackageOption = args.PackageOption;
                    _this.Service = args.Service;
                    _this.ServicePlanId = args.ServicePlanId;
                    _this.Start = args.Start;
                    _this.Stop = args.Stop;
                    _this.EventSchedule = args.EventSchedule;
                    _this.SchedFlags = args.SchedFlags;
                    _this.Status = args.Status;
                    return _this;
                }
                ServicePackage.Type = "Selcomm.Service.ServicePackage";
                ServicePackage.TypeParameters = [];
                return ServicePackage;
            }(Selcomm.Objects.DataObject));
            Service.ServicePackage = ServicePackage;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageOption = (function (_super) {
                __extends(PackageOption, _super);
                function PackageOption(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageOption.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Option = args.Option;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Default = args.Default;
                    _this.Enabled = args.Enabled;
                    _this.AdditionalInformation1 = args.AdditionalInformation1;
                    _this.AdditionalInformation2 = args.AdditionalInformation2;
                    _this.AdditionalInformation3 = args.AdditionalInformation3;
                    _this.AdditionalInformation4 = args.AdditionalInformation4;
                    _this.ContractTemplate = args.ContractTemplate;
                    _this.Package = args.Package;
                    _this.Note = args.Note;
                    _this.DiscountList = args.DiscountList;
                    _this.PackageOptionProductList = args.PackageOptionProductList;
                    _this.ServicePackageList = args.ServicePackageList;
                    return _this;
                }
                PackageOption.Type = "Selcomm.Package.PackageOption";
                PackageOption.TypeParameters = [];
                return PackageOption;
            }(Selcomm.Objects.DataObject));
            Package.PackageOption = PackageOption;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package_1) {
            var Package = (function (_super) {
                __extends(Package, _super);
                function Package(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.Package.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.PackageGroup = args.PackageGroup;
                    _this.PackageType = args.PackageType;
                    _this.Name = args.Name;
                    _this.DisplayName = args.DisplayName;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.StartDate = args.StartDate;
                    _this.EndDate = args.EndDate;
                    _this.SalesValueRank = args.SalesValueRank;
                    _this.AdditionalInformation1 = args.AdditionalInformation1;
                    _this.AdditionalInformation2 = args.AdditionalInformation2;
                    _this.AdditionalInformation3 = args.AdditionalInformation3;
                    _this.AdditionalInformation4 = args.AdditionalInformation4;
                    _this.RequestingUser = args.RequestingUser;
                    _this.URL = args.URL;
                    _this.CycleLock = args.CycleLock;
                    _this.ContractTemplate = args.ContractTemplate;
                    _this.Note = args.Note;
                    _this.Plan = args.Plan;
                    _this.PackageOptionList = args.PackageOptionList;
                    _this.OrderSourceList = args.OrderSourceList;
                    return _this;
                }
                Package.Type = "Selcomm.Package.Package";
                Package.TypeParameters = [];
                return Package;
            }(Selcomm.Objects.DataObject));
            Package_1.Package = Package;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageGroup = (function (_super) {
                __extends(PackageGroup, _super);
                function PackageGroup(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageGroup.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ParentGroup = args.ParentGroup;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Enabled = args.Enabled;
                    _this.IsRootGroup = args.IsRootGroup;
                    _this.PackageList = args.PackageList;
                    return _this;
                }
                PackageGroup.Type = "Selcomm.Package.PackageGroup";
                PackageGroup.TypeParameters = [];
                return PackageGroup;
            }(Selcomm.Objects.DataObject));
            Package.PackageGroup = PackageGroup;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageList = (function (_super) {
                __extends(PackageList, _super);
                function PackageList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                PackageList.Type = "Selcomm.Package.PackageList";
                PackageList.TypeParameters = [];
                return PackageList;
            }(Selcomm.Objects.ExtendedDataList));
            Package.PackageList = PackageList;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageType = (function (_super) {
                __extends(PackageType, _super);
                function PackageType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Default = args.Default;
                    return _this;
                }
                PackageType.Type = "Selcomm.Package.PackageType";
                PackageType.TypeParameters = [];
                return PackageType;
            }(Selcomm.Objects.DataObject));
            Package.PackageType = PackageType;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var Plan = (function (_super) {
                __extends(Plan, _super);
                function Plan(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.Plan.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                Plan.Type = "Selcomm.Package.Plan";
                Plan.TypeParameters = [];
                return Plan;
            }(Selcomm.Objects.DataObject));
            Package.Plan = Plan;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderSource = (function (_super) {
                __extends(OrderSource, _super);
                function OrderSource(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderSource.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    return _this;
                }
                OrderSource.Type = "Selcomm.Orders.OrderSource";
                OrderSource.TypeParameters = [];
                return OrderSource;
            }(Selcomm.Objects.DataObject));
            Orders.OrderSource = OrderSource;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageDiscount = (function (_super) {
                __extends(PackageDiscount, _super);
                function PackageDiscount(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageDiscount.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Discount = args.Discount;
                    _this.AutomaticallyApplied = args.AutomaticallyApplied;
                    _this.Start = args.Start;
                    _this.End = args.End;
                    return _this;
                }
                PackageDiscount.Type = "Selcomm.Package.PackageDiscount";
                PackageDiscount.TypeParameters = [];
                return PackageDiscount;
            }(Selcomm.Objects.DataObject));
            Package.PackageDiscount = PackageDiscount;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Discount;
        (function (Discount_1) {
            var Discount = (function (_super) {
                __extends(Discount, _super);
                function Discount(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Discount.Discount.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.DiscountType = args.DiscountType;
                    _this.Name = args.Name;
                    _this.LongName = args.LongName;
                    _this.BillingName = args.BillingName;
                    _this.DiscountIntervalUnit = args.DiscountIntervalUnit;
                    _this.DiscountOrder = args.DiscountOrder;
                    _this.Start = args.Start;
                    _this.End = args.End;
                    _this.Terminal = args.Terminal;
                    _this.DelayStartInterval = args.DelayStartInterval;
                    _this.RoundToStartOfMonth = args.RoundToStartOfMonth;
                    _this.RoundToEndOfMonth = args.RoundToEndOfMonth;
                    _this.NumberOfIntervals = args.NumberOfIntervals;
                    return _this;
                }
                Discount.Type = "Selcomm.Discount.Discount";
                Discount.TypeParameters = [];
                return Discount;
            }(Selcomm.Objects.DataObject));
            Discount_1.Discount = Discount;
        })(Discount = Selcomm.Discount || (Selcomm.Discount = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Discount;
        (function (Discount) {
            var DiscountType = (function (_super) {
                __extends(DiscountType, _super);
                function DiscountType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Discount.DiscountType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                DiscountType.Type = "Selcomm.Discount.DiscountType";
                DiscountType.TypeParameters = [];
                return DiscountType;
            }(Selcomm.Objects.DataObject));
            Discount.DiscountType = DiscountType;
        })(Discount = Selcomm.Discount || (Selcomm.Discount = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Discount;
        (function (Discount) {
            var DiscountIntervalUnit;
            (function (DiscountIntervalUnit) {
                DiscountIntervalUnit[DiscountIntervalUnit["Day"] = 0] = "Day";
                DiscountIntervalUnit[DiscountIntervalUnit["Month"] = 1] = "Month";
            })(DiscountIntervalUnit = Discount.DiscountIntervalUnit || (Discount.DiscountIntervalUnit = {}));
        })(Discount = Selcomm.Discount || (Selcomm.Discount = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageOptionProduct = (function (_super) {
                __extends(PackageOptionProduct, _super);
                function PackageOptionProduct(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageOptionProduct.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    _this.Comments = args.Comments;
                    _this.URL = args.URL;
                    _this.PartShipmentAllowed = args.PartShipmentAllowed;
                    _this.PackageOptionProductItemList = args.PackageOptionProductItemList;
                    return _this;
                }
                PackageOptionProduct.Type = "Selcomm.Package.PackageOptionProduct";
                PackageOptionProduct.TypeParameters = [];
                return PackageOptionProduct;
            }(Selcomm.Objects.DataObject));
            Package.PackageOptionProduct = PackageOptionProduct;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageOptionProductItem = (function (_super) {
                __extends(PackageOptionProductItem, _super);
                function PackageOptionProductItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageOptionProductItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Product = args.Product;
                    _this.MaximumQuantity = args.MaximumQuantity;
                    _this.MinimumQuantity = args.MinimumQuantity;
                    _this.DefaultQuantityAtBasePrice = args.DefaultQuantityAtBasePrice;
                    _this.PriceTaxIncluded = args.PriceTaxIncluded;
                    _this.Tax = args.Tax;
                    _this.AdditionalPriceTaxIncluded = args.AdditionalPriceTaxIncluded;
                    _this.AdditionalTax = args.AdditionalTax;
                    _this.MaximumNumberOfInstallments = args.MaximumNumberOfInstallments;
                    _this.InstallmentFrequency = args.InstallmentFrequency;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                PackageOptionProductItem.Type = "Selcomm.Package.PackageOptionProductItem";
                PackageOptionProductItem.TypeParameters = [];
                return PackageOptionProductItem;
            }(Selcomm.Objects.DataObject));
            Package.PackageOptionProductItem = PackageOptionProductItem;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Product;
        (function (Product_1) {
            var Product = (function (_super) {
                __extends(Product, _super);
                function Product(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Product.Product.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.ProductType = args.ProductType;
                    _this.Description = args.Description;
                    _this.URL = args.URL;
                    _this.Manufacturer = args.Manufacturer;
                    _this.Brand = args.Brand;
                    _this.ManufacturersIdentificationCode = args.ManufacturersIdentificationCode;
                    _this.CostExTax = args.CostExTax;
                    _this.PriceExTax = args.PriceExTax;
                    _this.PriceTaxIncluded = args.PriceTaxIncluded;
                    _this.Dispatchable = args.Dispatchable;
                    _this.MinimumQuantity = args.MinimumQuantity;
                    _this.MaximumQuantity = args.MaximumQuantity;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Enabled = args.Enabled;
                    _this.Serializable = args.Serializable;
                    _this.AutonumberCode = args.AutonumberCode;
                    _this.ProductDispatchType = args.ProductDispatchType;
                    _this.Note = args.Note;
                    _this.Service = args.Service;
                    return _this;
                }
                Product.Type = "Selcomm.Product.Product";
                Product.TypeParameters = [];
                return Product;
            }(Selcomm.Objects.DataObject));
            Product_1.Product = Product;
        })(Product = Selcomm.Product || (Selcomm.Product = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Product;
        (function (Product) {
            var ProductType = (function (_super) {
                __extends(ProductType, _super);
                function ProductType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Product.ProductType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Default = args.Default;
                    _this.Enabled = args.Enabled;
                    return _this;
                }
                ProductType.Type = "Selcomm.Product.ProductType";
                ProductType.TypeParameters = [];
                return ProductType;
            }(Selcomm.Objects.DataObject));
            Product.ProductType = ProductType;
        })(Product = Selcomm.Product || (Selcomm.Product = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Product;
        (function (Product) {
            var Manufacturer = (function (_super) {
                __extends(Manufacturer, _super);
                function Manufacturer(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Product.Manufacturer.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Enabled = args.Enabled;
                    _this.Note = args.Note;
                    return _this;
                }
                Manufacturer.Type = "Selcomm.Product.Manufacturer";
                Manufacturer.TypeParameters = [];
                return Manufacturer;
            }(Selcomm.Objects.DataObject));
            Product.Manufacturer = Manufacturer;
        })(Product = Selcomm.Product || (Selcomm.Product = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Product;
        (function (Product) {
            var Brand = (function (_super) {
                __extends(Brand, _super);
                function Brand(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Product.Brand.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.ManufactureCode = args.ManufactureCode;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Enabled = args.Enabled;
                    _this.AdditionalInformation = args.AdditionalInformation;
                    _this.URL = args.URL;
                    _this.Note = args.Note;
                    return _this;
                }
                Brand.Type = "Selcomm.Product.Brand";
                Brand.TypeParameters = [];
                return Brand;
            }(Selcomm.Objects.DataObject));
            Product.Brand = Brand;
        })(Product = Selcomm.Product || (Selcomm.Product = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Product;
        (function (Product) {
            var ProductDispatchType = (function (_super) {
                __extends(ProductDispatchType, _super);
                function ProductDispatchType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Product.ProductDispatchType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Default = args.Default;
                    _this.Enabled = args.Enabled;
                    return _this;
                }
                ProductDispatchType.Type = "Selcomm.Product.ProductDispatchType";
                ProductDispatchType.TypeParameters = [];
                return ProductDispatchType;
            }(Selcomm.Objects.DataObject));
            Product.ProductDispatchType = ProductDispatchType;
        })(Product = Selcomm.Product || (Selcomm.Product = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Product;
        (function (Product) {
            var ProductService = (function (_super) {
                __extends(ProductService, _super);
                function ProductService(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Product.ProductService.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.ServiceTypeCode = args.ServiceTypeCode;
                    _this.PackageCode = args.PackageCode;
                    _this.PackageOption = args.PackageOption;
                    _this.EventType = args.EventType;
                    _this.ServiceAsGsnVNumber = args.ServiceAsGsnVNumber;
                    _this.NetworkId = args.NetworkId;
                    return _this;
                }
                ProductService.Type = "Selcomm.Product.ProductService";
                ProductService.TypeParameters = [];
                return ProductService;
            }(Selcomm.Objects.DataObject));
            Product.ProductService = ProductService;
        })(Product = Selcomm.Product || (Selcomm.Product = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePackageStatus;
            (function (ServicePackageStatus) {
                ServicePackageStatus[ServicePackageStatus["Pending"] = 0] = "Pending";
                ServicePackageStatus[ServicePackageStatus["Voided"] = 1] = "Voided";
                ServicePackageStatus[ServicePackageStatus["Future"] = 2] = "Future";
                ServicePackageStatus[ServicePackageStatus["Active"] = 3] = "Active";
                ServicePackageStatus[ServicePackageStatus["Closed"] = 4] = "Closed";
            })(ServicePackageStatus = Service.ServicePackageStatus || (Service.ServicePackageStatus = {}));
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePackageChangeRequest = (function (_super) {
                __extends(ServicePackageChangeRequest, _super);
                function ServicePackageChangeRequest(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServicePackageChangeRequest.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceReference = args.ServiceReference;
                    _this.ServicePackageReference = args.ServicePackageReference;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.EventReference = args.EventReference;
                    _this.PackageCode = args.PackageCode;
                    _this.PackageName = args.PackageName;
                    _this.PackageOption = args.PackageOption;
                    _this.Note = args.Note;
                    _this.ScheduledDateTime = args.ScheduledDateTime;
                    _this.Status = args.Status;
                    _this.StartAtStartOfNextBillRun = args.StartAtStartOfNextBillRun;
                    _this.ApplyToAllServicesOnAccount = args.ApplyToAllServicesOnAccount;
                    _this.ApplyToAllChildServices = args.ApplyToAllChildServices;
                    _this.ApplyToAllSiblingServices = args.ApplyToAllSiblingServices;
                    return _this;
                }
                ServicePackageChangeRequest.Type = "Selcomm.Service.ServicePackageChangeRequest";
                ServicePackageChangeRequest.TypeParameters = [];
                return ServicePackageChangeRequest;
            }(Selcomm.Objects.DataObject));
            Service.ServicePackageChangeRequest = ServicePackageChangeRequest;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePassword = (function () {
                function ServicePassword(args) {
                    this.$type = Selcomm.Service.ServicePassword.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Password = args.Password;
                }
                ServicePassword.Type = "Selcomm.Service.ServicePassword";
                ServicePassword.TypeParameters = [];
                return ServicePassword;
            }());
            Service.ServicePassword = ServicePassword;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePaymentMethod = (function () {
                function ServicePaymentMethod(args) {
                    this.$type = Selcomm.Service.ServicePaymentMethod.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServicePaymentMethod.Type = "Selcomm.Service.ServicePaymentMethod";
                ServicePaymentMethod.TypeParameters = [];
                return ServicePaymentMethod;
            }());
            Service.ServicePaymentMethod = ServicePaymentMethod;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePortingInformation = (function () {
                function ServicePortingInformation(args) {
                    this.$type = Selcomm.Service.ServicePortingInformation.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.AccountNumber = args.AccountNumber;
                    this.LCSP = args.LCSP;
                    this.PortReason = args.PortReason;
                    this.TechnologyType = args.TechnologyType;
                    this.LCSPID = args.LCSPID;
                    this.BillingName = args.BillingName;
                }
                ServicePortingInformation.Type = "Selcomm.Service.ServicePortingInformation";
                ServicePortingInformation.TypeParameters = [];
                return ServicePortingInformation;
            }());
            Service.ServicePortingInformation = ServicePortingInformation;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePromotion = (function () {
                function ServicePromotion(args) {
                    this.$type = Selcomm.Service.ServicePromotion.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServicePromotion.Type = "Selcomm.Service.ServicePromotion";
                ServicePromotion.TypeParameters = [];
                return ServicePromotion;
            }());
            Service.ServicePromotion = ServicePromotion;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceRechargeVoucher = (function () {
                function ServiceRechargeVoucher(args) {
                    this.$type = Selcomm.Service.ServiceRechargeVoucher.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceRechargeVoucher.Type = "Selcomm.Service.ServiceRechargeVoucher";
                ServiceRechargeVoucher.TypeParameters = [];
                return ServiceRechargeVoucher;
            }());
            Service.ServiceRechargeVoucher = ServiceRechargeVoucher;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceRegistration = (function () {
                function ServiceRegistration(args) {
                    this.$type = Selcomm.Service.ServiceRegistration.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceRegistration.Type = "Selcomm.Service.ServiceRegistration";
                ServiceRegistration.TypeParameters = [];
                return ServiceRegistration;
            }());
            Service.ServiceRegistration = ServiceRegistration;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceReport = (function () {
                function ServiceReport(args) {
                    this.$type = Selcomm.Service.ServiceReport.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceReport.Type = "Selcomm.Service.ServiceReport";
                ServiceReport.TypeParameters = [];
                return ServiceReport;
            }());
            Service.ServiceReport = ServiceReport;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceRetention = (function () {
                function ServiceRetention(args) {
                    this.$type = Selcomm.Service.ServiceRetention.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceRetention.Type = "Selcomm.Service.ServiceRetention";
                ServiceRetention.TypeParameters = [];
                return ServiceRetention;
            }());
            Service.ServiceRetention = ServiceRetention;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceSalesPerson = (function () {
                function ServiceSalesPerson(args) {
                    this.$type = Selcomm.Service.ServiceSalesPerson.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceSalesPerson.Type = "Selcomm.Service.ServiceSalesPerson";
                ServiceSalesPerson.TypeParameters = [];
                return ServiceSalesPerson;
            }());
            Service.ServiceSalesPerson = ServiceSalesPerson;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceSellOn = (function () {
                function ServiceSellOn(args) {
                    this.$type = Selcomm.Service.ServiceSellOn.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceSellOn.Type = "Selcomm.Service.ServiceSellOn";
                ServiceSellOn.TypeParameters = [];
                return ServiceSellOn;
            }());
            Service.ServiceSellOn = ServiceSellOn;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceElement = (function () {
                function ServiceElement(args) {
                    this.$type = Selcomm.Service.ServiceElement.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceElement.Type = "Selcomm.Service.ServiceElement";
                ServiceElement.TypeParameters = [];
                return ServiceElement;
            }());
            Service.ServiceElement = ServiceElement;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceSite = (function () {
                function ServiceSite(args) {
                    this.$type = Selcomm.Service.ServiceSite.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceSite.Type = "Selcomm.Service.ServiceSite";
                ServiceSite.TypeParameters = [];
                return ServiceSite;
            }());
            Service.ServiceSite = ServiceSite;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceStatus = (function (_super) {
                __extends(ServiceStatus, _super);
                function ServiceStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Phase = args.Phase;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Visibility = args.Visibility;
                    return _this;
                }
                ServiceStatus.Type = "Selcomm.Service.ServiceStatus";
                ServiceStatus.TypeParameters = [];
                return ServiceStatus;
            }(Selcomm.Objects.DataObject));
            Service.ServiceStatus = ServiceStatus;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceSystemStatus = (function () {
                function ServiceSystemStatus(args) {
                    this.$type = Selcomm.Service.ServiceSystemStatus.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceSystemStatus.Type = "Selcomm.Service.ServiceSystemStatus";
                ServiceSystemStatus.TypeParameters = [];
                return ServiceSystemStatus;
            }());
            Service.ServiceSystemStatus = ServiceSystemStatus;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceSuspension = (function () {
                function ServiceSuspension(args) {
                    this.$type = Selcomm.Service.ServiceSuspension.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceSuspension.Type = "Selcomm.Service.ServiceSuspension";
                ServiceSuspension.TypeParameters = [];
                return ServiceSuspension;
            }());
            Service.ServiceSuspension = ServiceSuspension;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceTask = (function () {
                function ServiceTask(args) {
                    this.$type = Selcomm.Service.ServiceTask.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceTask.Type = "Selcomm.Service.ServiceTask";
                ServiceTask.TypeParameters = [];
                return ServiceTask;
            }());
            Service.ServiceTask = ServiceTask;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePriceOverrideUsage = (function () {
                function ServicePriceOverrideUsage(args) {
                    this.$type = Selcomm.Service.ServicePriceOverrideUsage.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServicePriceOverrideUsage.Type = "Selcomm.Service.ServicePriceOverrideUsage";
                ServicePriceOverrideUsage.TypeParameters = [];
                return ServicePriceOverrideUsage;
            }());
            Service.ServicePriceOverrideUsage = ServicePriceOverrideUsage;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceUsage = (function () {
                function ServiceUsage(args) {
                    this.$type = Selcomm.Service.ServiceUsage.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceUsage.Type = "Selcomm.Service.ServiceUsage";
                ServiceUsage.TypeParameters = [];
                return ServiceUsage;
            }());
            Service.ServiceUsage = ServiceUsage;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceUsageSummary = (function () {
                function ServiceUsageSummary(args) {
                    this.$type = Selcomm.Service.ServiceUsageSummary.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceUsageSummary.Type = "Selcomm.Service.ServiceUsageSummary";
                ServiceUsageSummary.TypeParameters = [];
                return ServiceUsageSummary;
            }());
            Service.ServiceUsageSummary = ServiceUsageSummary;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceUser = (function () {
                function ServiceUser(args) {
                    this.$type = Selcomm.Service.ServiceUser.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceUser.Type = "Selcomm.Service.ServiceUser";
                ServiceUser.TypeParameters = [];
                return ServiceUser;
            }());
            Service.ServiceUser = ServiceUser;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceValueAddedService = (function () {
                function ServiceValueAddedService(args) {
                    this.$type = Selcomm.Service.ServiceValueAddedService.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceValueAddedService.Type = "Selcomm.Service.ServiceValueAddedService";
                ServiceValueAddedService.TypeParameters = [];
                return ServiceValueAddedService;
            }());
            Service.ServiceValueAddedService = ServiceValueAddedService;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceWinback = (function () {
                function ServiceWinback(args) {
                    this.$type = Selcomm.Service.ServiceWinback.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceWinback.Type = "Selcomm.Service.ServiceWinback";
                ServiceWinback.TypeParameters = [];
                return ServiceWinback;
            }());
            Service.ServiceWinback = ServiceWinback;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventNote = (function (_super) {
                __extends(EventNote, _super);
                function EventNote(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventNote.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.EventReference = args.EventReference;
                    _this.Text = args.Text;
                    return _this;
                }
                EventNote.Type = "Selcomm.Event.EventNote";
                EventNote.TypeParameters = [];
                return EventNote;
            }(Selcomm.Objects.DataObject));
            Event.EventNote = EventNote;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventDisplay = (function (_super) {
                __extends(EventDisplay, _super);
                function EventDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.EventId = args.EventId;
                    _this.ScheduleStatusCode = args.ScheduleStatusCode;
                    _this.ScheduleStatusDescription = args.ScheduleStatusDescription;
                    _this.ScheduleCreatedBy = args.ScheduleCreatedBy;
                    _this.ScheduleCreatedTime = args.ScheduleCreatedTime;
                    _this.ScheduleToDepartmentName = args.ScheduleToDepartmentName;
                    _this.ScheduleToLoginCode = args.ScheduleToLoginCode;
                    _this.ContactCode = args.ContactCode;
                    _this.ServiceId = args.ServiceId;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.Description = args.Description;
                    _this.DateCompleted = args.DateCompleted;
                    _this.Notes = args.Notes;
                    return _this;
                }
                EventDisplay.Type = "Selcomm.Event.EventDisplay";
                EventDisplay.TypeParameters = [];
                return EventDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Event.EventDisplay = EventDisplay;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventReasonTypeDisplay = (function (_super) {
                __extends(EventReasonTypeDisplay, _super);
                function EventReasonTypeDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventReasonTypeDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Narrative = args.Narrative;
                    return _this;
                }
                EventReasonTypeDisplay.Type = "Selcomm.Event.EventReasonTypeDisplay";
                EventReasonTypeDisplay.TypeParameters = [];
                return EventReasonTypeDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Event.EventReasonTypeDisplay = EventReasonTypeDisplay;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventDispatcher = (function (_super) {
                __extends(EventDispatcher, _super);
                function EventDispatcher(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventDispatcher.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ServiceTypeCode = args.ServiceTypeCode;
                    _this.ServiceId = args.ServiceId;
                    _this.EventCode = args.EventCode;
                    _this.EventType = args.EventType;
                    _this.Enabled = args.Enabled;
                    _this.ScheduleStatus = args.ScheduleStatus;
                    return _this;
                }
                EventDispatcher.Type = "Selcomm.Event.EventDispatcher";
                EventDispatcher.TypeParameters = [];
                return EventDispatcher;
            }(Selcomm.Objects.DataObject));
            Event.EventDispatcher = EventDispatcher;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Event;
        (function (Event) {
            var EventData = (function (_super) {
                __extends(EventData, _super);
                function EventData(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Event.EventData.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.GroupName = args.GroupName;
                    _this.Index = args.Index;
                    _this.Name = args.Name;
                    _this.Value = args.Value;
                    _this.EventReference = args.EventReference;
                    return _this;
                }
                EventData.Type = "Selcomm.Event.EventData";
                EventData.TypeParameters = [];
                return EventData;
            }(Selcomm.Objects.DataObject));
            Event.EventData = EventData;
        })(Event = Selcomm.Event || (Selcomm.Event = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var FinancialPreAuthorisation = (function (_super) {
                __extends(FinancialPreAuthorisation, _super);
                function FinancialPreAuthorisation(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Financials.FinancialPreAuthorisation.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Reference = args.Reference;
                    _this.AuthorisationNumber = args.AuthorisationNumber;
                    _this.AccountNumber = args.AccountNumber;
                    _this.Amount = args.Amount;
                    _this.OpenAmount = args.OpenAmount;
                    _this.DateTime = args.DateTime;
                    _this.ExpiryDateTime = args.ExpiryDateTime;
                    _this.StatusChangeDateTime = args.StatusChangeDateTime;
                    _this.RequestingUser = args.RequestingUser;
                    _this.Status = args.Status;
                    _this.FinacialTransactionList = args.FinacialTransactionList;
                    return _this;
                }
                FinancialPreAuthorisation.Type = "Selcomm.Financials.FinancialPreAuthorisation";
                FinancialPreAuthorisation.TypeParameters = [];
                return FinancialPreAuthorisation;
            }(Selcomm.Objects.DataObject));
            Financials.FinancialPreAuthorisation = FinancialPreAuthorisation;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var PreAuthorisationStatus;
            (function (PreAuthorisationStatus) {
                PreAuthorisationStatus[PreAuthorisationStatus["New"] = 0] = "New";
                PreAuthorisationStatus[PreAuthorisationStatus["PartiallySettled"] = 1] = "PartiallySettled";
                PreAuthorisationStatus[PreAuthorisationStatus["Settled"] = 2] = "Settled";
                PreAuthorisationStatus[PreAuthorisationStatus["Cancelled"] = 10] = "Cancelled";
            })(PreAuthorisationStatus = Financials.PreAuthorisationStatus || (Financials.PreAuthorisationStatus = {}));
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Financials;
        (function (Financials) {
            var FinancialAccountInformation = (function () {
                function FinancialAccountInformation(args) {
                    this.$type = Selcomm.Financials.FinancialAccountInformation.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.AttributeName = args.AttributeName;
                    this.AttributeValue = args.AttributeValue;
                    this.AttributeCode = args.AttributeCode;
                    this.StatusLevel = args.StatusLevel;
                    this.DataType = args.DataType;
                }
                FinancialAccountInformation.Type = "Selcomm.Financials.FinancialAccountInformation";
                FinancialAccountInformation.TypeParameters = [];
                return FinancialAccountInformation;
            }());
            Financials.FinancialAccountInformation = FinancialAccountInformation;
        })(Financials = Selcomm.Financials || (Selcomm.Financials = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Hardware;
        (function (Hardware) {
            var EquipmentType = (function (_super) {
                __extends(EquipmentType, _super);
                function EquipmentType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Hardware.EquipmentType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.Category = args.Category;
                    _this.Brand = args.Brand;
                    _this.Model = args.Model;
                    _this.Display = args.Display;
                    _this.InUse = args.InUse;
                    _this.Price = args.Price;
                    return _this;
                }
                EquipmentType.Type = "Selcomm.Hardware.EquipmentType";
                EquipmentType.TypeParameters = [];
                return EquipmentType;
            }(Selcomm.Objects.DataObject));
            Hardware.EquipmentType = EquipmentType;
        })(Hardware = Selcomm.Hardware || (Selcomm.Hardware = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Hardware;
        (function (Hardware) {
            var EquipmentCategory = (function (_super) {
                __extends(EquipmentCategory, _super);
                function EquipmentCategory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Hardware.EquipmentCategory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.Narrative = args.Narrative;
                    return _this;
                }
                EquipmentCategory.Type = "Selcomm.Hardware.EquipmentCategory";
                EquipmentCategory.TypeParameters = [];
                return EquipmentCategory;
            }(Selcomm.Objects.DataObject));
            Hardware.EquipmentCategory = EquipmentCategory;
        })(Hardware = Selcomm.Hardware || (Selcomm.Hardware = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Hardware;
        (function (Hardware) {
            var EquipmentTypeList = (function (_super) {
                __extends(EquipmentTypeList, _super);
                function EquipmentTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Hardware.EquipmentTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                EquipmentTypeList.Type = "Selcomm.Hardware.EquipmentTypeList";
                EquipmentTypeList.TypeParameters = [];
                return EquipmentTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Hardware.EquipmentTypeList = EquipmentTypeList;
        })(Hardware = Selcomm.Hardware || (Selcomm.Hardware = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Hardware;
        (function (Hardware) {
            var ModelDisplay = (function (_super) {
                __extends(ModelDisplay, _super);
                function ModelDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Hardware.ModelDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ModelId = args.ModelId;
                    _this.ModelName = args.ModelName;
                    return _this;
                }
                ModelDisplay.Type = "Selcomm.Hardware.ModelDisplay";
                ModelDisplay.TypeParameters = [];
                return ModelDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Hardware.ModelDisplay = ModelDisplay;
        })(Hardware = Selcomm.Hardware || (Selcomm.Hardware = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkIdentity = (function (_super) {
                __extends(NetworkIdentity, _super);
                function NetworkIdentity(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.NetworkIdentity.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.NetworkId = args.NetworkId;
                    _this.PersonalUnblockingCode = args.PersonalUnblockingCode;
                    return _this;
                }
                NetworkIdentity.Type = "Selcomm.Network.NetworkIdentity";
                NetworkIdentity.TypeParameters = [];
                return NetworkIdentity;
            }(Selcomm.Objects.DataObject));
            Network.NetworkIdentity = NetworkIdentity;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var Sim = (function (_super) {
                __extends(Sim, _super);
                function Sim(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.Sim.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Created = args.Created;
                    _this.CreatedBy = args.CreatedBy;
                    return _this;
                }
                Sim.Type = "Selcomm.Network.Sim";
                Sim.TypeParameters = [];
                return Sim;
            }(Selcomm.Network.NetworkIdentity));
            Network.Sim = Sim;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Invoices;
        (function (Invoices) {
            var Invoice = (function (_super) {
                __extends(Invoice, _super);
                function Invoice(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Invoices.Invoice.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ConnectionReference = args.ConnectionReference;
                    _this.ConnectionNarrative = args.ConnectionNarrative;
                    _this.CallValue = args.CallValue;
                    _this.ChargesValue = args.ChargesValue;
                    _this.TaxValue = args.TaxValue;
                    _this.ServiceTypeNarrative = args.ServiceTypeNarrative;
                    _this.PhoneNumber = args.PhoneNumber;
                    _this.ServiceTypeBillNarrative = args.ServiceTypeBillNarrative;
                    return _this;
                }
                Invoice.Type = "Selcomm.Invoices.Invoice";
                Invoice.TypeParameters = [];
                return Invoice;
            }(Selcomm.Objects.DataObject));
            Invoices.Invoice = Invoice;
        })(Invoices = Selcomm.Invoices || (Selcomm.Invoices = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var CrudVObject = (function () {
                function CrudVObject(args, $type) {
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.$type = $type;
                }
                CrudVObject.TypeWith = function (T) {
                    return Selcomm.Objects.CrudVObject.Type + "\u003c" + T + "\u003e";
                };
                CrudVObject.Type = "Selcomm.Objects.CrudVObject";
                CrudVObject.TypeParameters = ["T"];
                return CrudVObject;
            }());
            Objects.CrudVObject = CrudVObject;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Leads;
        (function (Leads) {
            var Lead = (function (_super) {
                __extends(Lead, _super);
                function Lead(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Leads.Lead.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.LeadSource = args.LeadSource;
                    _this.LeadStatus = args.LeadStatus;
                    _this.ContactCode = args.ContactCode;
                    _this.IPAddress = args.IPAddress;
                    _this.Title = args.Title;
                    _this.FirstName = args.FirstName;
                    _this.Name = args.Name;
                    _this.Company = args.Company;
                    _this.Department = args.Department;
                    _this.JobTitle = args.JobTitle;
                    _this.Industry = args.Industry;
                    _this.CompanySize = args.CompanySize;
                    _this.WorkPhone = args.WorkPhone;
                    _this.HomePhone = args.HomePhone;
                    _this.MobilePhone = args.MobilePhone;
                    _this.Fax = args.Fax;
                    _this.Address1 = args.Address1;
                    _this.Address2 = args.Address2;
                    _this.Suburb = args.Suburb;
                    _this.City = args.City;
                    _this.State = args.State;
                    _this.Postcode = args.Postcode;
                    _this.Country = args.Country;
                    _this.Note = args.Note;
                    _this.HeardFrom = args.HeardFrom;
                    _this.Email1 = args.Email1;
                    _this.Email2 = args.Email2;
                    _this.EmailOptOut = args.EmailOptOut;
                    _this.DoNotCall = args.DoNotCall;
                    _this.InvalidEmail = args.InvalidEmail;
                    _this.AssignedTo = args.AssignedTo;
                    _this.AllocatedDealerId = args.AllocatedDealerId;
                    _this.ContactCreatedDate = args.ContactCreatedDate;
                    _this.FollowUpDate = args.FollowUpDate;
                    _this.LeadType = args.LeadType;
                    return _this;
                }
                Lead.Type = "Selcomm.Leads.Lead";
                Lead.TypeParameters = [];
                return Lead;
            }(Selcomm.Objects.CrudVObject));
            Leads.Lead = Lead;
        })(Leads = Selcomm.Leads || (Selcomm.Leads = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Leads;
        (function (Leads) {
            var LeadSource = (function (_super) {
                __extends(LeadSource, _super);
                function LeadSource(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Leads.LeadSource.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Name = args.Name;
                    _this.Active = args.Active;
                    return _this;
                }
                LeadSource.Type = "Selcomm.Leads.LeadSource";
                LeadSource.TypeParameters = [];
                return LeadSource;
            }(Selcomm.Objects.CrudVObject));
            Leads.LeadSource = LeadSource;
        })(Leads = Selcomm.Leads || (Selcomm.Leads = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Leads;
        (function (Leads) {
            var LeadStatus = (function (_super) {
                __extends(LeadStatus, _super);
                function LeadStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Leads.LeadStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Description = args.Description;
                    _this.Active = args.Active;
                    return _this;
                }
                LeadStatus.Type = "Selcomm.Leads.LeadStatus";
                LeadStatus.TypeParameters = [];
                return LeadStatus;
            }(Selcomm.Objects.CrudVObject));
            Leads.LeadStatus = LeadStatus;
        })(Leads = Selcomm.Leads || (Selcomm.Leads = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Leads;
        (function (Leads) {
            var LeadType;
            (function (LeadType) {
                LeadType[LeadType["Personal"] = 0] = "Personal";
                LeadType[LeadType["Business"] = 1] = "Business";
            })(LeadType = Leads.LeadType || (Leads.LeadType = {}));
        })(Leads = Selcomm.Leads || (Selcomm.Leads = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var Mode;
            (function (Mode) {
                Mode[Mode["New"] = 100] = "New";
                Mode[Mode["Update"] = 200] = "Update";
                Mode[Mode["Delete"] = 300] = "Delete";
                Mode[Mode["Unchanged"] = 1000] = "Unchanged";
            })(Mode = Objects.Mode || (Objects.Mode = {}));
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Library;
        (function (Library_1) {
            var Library = (function (_super) {
                __extends(Library, _super);
                function Library(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Library.Library.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Documents = args.Documents;
                    return _this;
                }
                Library.Type = "Selcomm.Library.Library";
                Library.TypeParameters = [];
                return Library;
            }(Selcomm.Objects.DataObject));
            Library_1.Library = Library;
        })(Library = Selcomm.Library || (Selcomm.Library = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Maps;
        (function (Maps) {
            var MapPoint = (function (_super) {
                __extends(MapPoint, _super);
                function MapPoint(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Maps.MapPoint.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Text = args.Text;
                    _this.Address = args.Address;
                    _this.Longtitude = args.Longtitude;
                    _this.Latitude = args.Latitude;
                    return _this;
                }
                MapPoint.Type = "Selcomm.Maps.MapPoint";
                MapPoint.TypeParameters = [];
                return MapPoint;
            }(Selcomm.Objects.DataObject));
            Maps.MapPoint = MapPoint;
        })(Maps = Selcomm.Maps || (Selcomm.Maps = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Menu;
        (function (Menu_1) {
            var Menu = (function (_super) {
                __extends(Menu, _super);
                function Menu(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Menu.Menu.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ObjectId = args.ObjectId;
                    _this.Name = args.Name;
                    _this.MenuItemList = args.MenuItemList;
                    return _this;
                }
                Menu.Type = "Selcomm.Menu.Menu";
                Menu.TypeParameters = [];
                return Menu;
            }(Selcomm.Objects.DataObject));
            Menu_1.Menu = Menu;
        })(Menu = Selcomm.Menu || (Selcomm.Menu = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Menu;
        (function (Menu) {
            var MenuItem = (function (_super) {
                __extends(MenuItem, _super);
                function MenuItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Menu.MenuItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Caption = args.Caption;
                    _this.Command = args.Command;
                    _this.CommandText = args.CommandText;
                    _this.ModeName = args.ModeName;
                    _this.ItemMode = args.ItemMode;
                    _this.Tooltip = args.Tooltip;
                    _this.ParentId = args.ParentId;
                    _this.ParentMenuId = args.ParentMenuId;
                    _this.ObjectID = args.ObjectID;
                    _this.Order = args.Order;
                    _this.Group = args.Group;
                    _this.ItemChecked = args.ItemChecked;
                    _this.ItemDefault = args.ItemDefault;
                    _this.DLL = args.DLL;
                    _this.Visible = args.Visible;
                    _this.ImageURL = args.ImageURL;
                    _this.ChildMenuItems = args.ChildMenuItems;
                    return _this;
                }
                MenuItem.Type = "Selcomm.Menu.MenuItem";
                MenuItem.TypeParameters = [];
                return MenuItem;
            }(Selcomm.Objects.DataObject));
            Menu.MenuItem = MenuItem;
        })(Menu = Selcomm.Menu || (Selcomm.Menu = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Menu;
        (function (Menu) {
            var MenuItemMode;
            (function (MenuItemMode) {
                MenuItemMode[MenuItemMode["Unknown"] = 0] = "Unknown";
                MenuItemMode[MenuItemMode["Default"] = 1] = "Default";
                MenuItemMode[MenuItemMode["Page"] = 2] = "Page";
                MenuItemMode[MenuItemMode["Pagelet"] = 3] = "Pagelet";
                MenuItemMode[MenuItemMode["UserControl"] = 4] = "UserControl";
                MenuItemMode[MenuItemMode["IFrame"] = 5] = "IFrame";
            })(MenuItemMode = Menu.MenuItemMode || (Menu.MenuItemMode = {}));
        })(Menu = Selcomm.Menu || (Selcomm.Menu = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var LCSPDisplay = (function (_super) {
                __extends(LCSPDisplay, _super);
                function LCSPDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.LCSPDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.LCSPName = args.LCSPName;
                    return _this;
                }
                LCSPDisplay.Type = "Selcomm.Network.LCSPDisplay";
                LCSPDisplay.TypeParameters = [];
                return LCSPDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Network.LCSPDisplay = LCSPDisplay;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var News;
        (function (News) {
            var NewsItem = (function (_super) {
                __extends(NewsItem, _super);
                function NewsItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.News.NewsItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Text = args.Text;
                    _this.ImageList = args.ImageList;
                    _this.ExpiryDate = args.ExpiryDate;
                    _this.DisplayOrder = args.DisplayOrder;
                    return _this;
                }
                NewsItem.Type = "Selcomm.News.NewsItem";
                NewsItem.TypeParameters = [];
                return NewsItem;
            }(Selcomm.Objects.DataObject));
            News.NewsItem = NewsItem;
        })(News = Selcomm.News || (Selcomm.News = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Opportunities;
        (function (Opportunities_1) {
            var Opportunities = (function (_super) {
                __extends(Opportunities, _super);
                function Opportunities(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Opportunities.Opportunities.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Reference = args.Reference;
                    _this.Type = args.Type;
                    _this.Name = args.Name;
                    _this.Description = args.Description;
                    _this.LeadSourceId = args.LeadSourceId;
                    _this.StageID = args.StageID;
                    _this.CurrencyCode = args.CurrencyCode;
                    _this.ContactCode = args.ContactCode;
                    _this.Amount = args.Amount;
                    _this.ExpectedClosedDate = args.ExpectedClosedDate;
                    _this.NextStep = args.NextStep;
                    _this.FollowUpDate = args.FollowUpDate;
                    _this.Probability = args.Probability;
                    return _this;
                }
                Opportunities.Type = "Selcomm.Opportunities.Opportunities";
                Opportunities.TypeParameters = [];
                return Opportunities;
            }(Selcomm.Objects.DataObject));
            Opportunities_1.Opportunities = Opportunities;
        })(Opportunities = Selcomm.Opportunities || (Selcomm.Opportunities = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Opportunities;
        (function (Opportunities) {
            var OpportunityType = (function (_super) {
                __extends(OpportunityType, _super);
                function OpportunityType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Opportunities.OpportunityType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                OpportunityType.Type = "Selcomm.Opportunities.OpportunityType";
                OpportunityType.TypeParameters = [];
                return OpportunityType;
            }(Selcomm.Objects.DataObject));
            Opportunities.OpportunityType = OpportunityType;
        })(Opportunities = Selcomm.Opportunities || (Selcomm.Opportunities = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var Order = (function (_super) {
                __extends(Order, _super);
                function Order(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.Order.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.OrderNumber = args.OrderNumber;
                    _this.DebitorCode = args.DebitorCode;
                    _this.ContactCode = args.ContactCode;
                    _this.OrderDate = args.OrderDate;
                    _this.Class = args.Class;
                    _this.Type = args.Type;
                    _this.Source = args.Source;
                    _this.Priority = args.Priority;
                    _this.Status = args.Status;
                    _this.AuthorizingContactCode = args.AuthorizingContactCode;
                    _this.OrderRepresentative = args.OrderRepresentative;
                    _this.Dealer = args.Dealer;
                    _this.OrderReference = args.OrderReference;
                    _this.Note = args.Note;
                    _this.AccountPaymentMethod = args.AccountPaymentMethod;
                    _this.Address = args.Address;
                    _this.WaitReason = args.WaitReason;
                    _this.CampaignCode = args.CampaignCode;
                    _this.MediaCode = args.MediaCode;
                    _this.BusUnit = args.BusUnit;
                    _this.Salesperson = args.Salesperson;
                    _this.StatusReason = args.StatusReason;
                    _this.StatusDateTime = args.StatusDateTime;
                    _this.RequiredDate = args.RequiredDate;
                    _this.ExpectedResolutionDate = args.ExpectedResolutionDate;
                    _this.FollowUpDate = args.FollowUpDate;
                    _this.FollowReason = args.FollowReason;
                    _this.ContactName = args.ContactName;
                    _this.ContactPhoneNumber = args.ContactPhoneNumber;
                    _this.ContactReference = args.ContactReference;
                    _this.CustomerSigned = args.CustomerSigned;
                    _this.CustomerVoiceSigned = args.CustomerVoiceSigned;
                    _this.BillOnWholeOrderOnly = args.BillOnWholeOrderOnly;
                    _this.BillOnQuoteOnly = args.BillOnQuoteOnly;
                    _this.AllowBilling = args.AllowBilling;
                    _this.ProjectCode = args.ProjectCode;
                    _this.ProjectName = args.ProjectName;
                    _this.Courier = args.Courier;
                    _this.DeliveryMethod = args.DeliveryMethod;
                    _this.AdvertisingMedia = args.AdvertisingMedia;
                    _this.Promotions = args.Promotions;
                    _this.OrderItemList = args.OrderItemList;
                    return _this;
                }
                Order.Type = "Selcomm.Orders.Order";
                Order.TypeParameters = [];
                return Order;
            }(Selcomm.Objects.DataObject));
            Orders.Order = Order;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderClass = (function (_super) {
                __extends(OrderClass, _super);
                function OrderClass(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderClass.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    return _this;
                }
                OrderClass.Type = "Selcomm.Orders.OrderClass";
                OrderClass.TypeParameters = [];
                return OrderClass;
            }(Selcomm.Objects.DataObject));
            Orders.OrderClass = OrderClass;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderType = (function (_super) {
                __extends(OrderType, _super);
                function OrderType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    return _this;
                }
                OrderType.Type = "Selcomm.Orders.OrderType";
                OrderType.TypeParameters = [];
                return OrderType;
            }(Selcomm.Objects.DataObject));
            Orders.OrderType = OrderType;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderPriority = (function (_super) {
                __extends(OrderPriority, _super);
                function OrderPriority(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderPriority.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    return _this;
                }
                OrderPriority.Type = "Selcomm.Orders.OrderPriority";
                OrderPriority.TypeParameters = [];
                return OrderPriority;
            }(Selcomm.Objects.DataObject));
            Orders.OrderPriority = OrderPriority;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderStatus = (function (_super) {
                __extends(OrderStatus, _super);
                function OrderStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    return _this;
                }
                OrderStatus.Type = "Selcomm.Orders.OrderStatus";
                OrderStatus.TypeParameters = [];
                return OrderStatus;
            }(Selcomm.Objects.DataObject));
            Orders.OrderStatus = OrderStatus;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderWaitReason = (function (_super) {
                __extends(OrderWaitReason, _super);
                function OrderWaitReason(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderWaitReason.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    return _this;
                }
                OrderWaitReason.Type = "Selcomm.Orders.OrderWaitReason";
                OrderWaitReason.TypeParameters = [];
                return OrderWaitReason;
            }(Selcomm.Objects.DataObject));
            Orders.OrderWaitReason = OrderWaitReason;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderCampaign = (function (_super) {
                __extends(OrderCampaign, _super);
                function OrderCampaign(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderCampaign.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    return _this;
                }
                OrderCampaign.Type = "Selcomm.Orders.OrderCampaign";
                OrderCampaign.TypeParameters = [];
                return OrderCampaign;
            }(Selcomm.Objects.DataObject));
            Orders.OrderCampaign = OrderCampaign;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderFollowupReason = (function (_super) {
                __extends(OrderFollowupReason, _super);
                function OrderFollowupReason(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderFollowupReason.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    return _this;
                }
                OrderFollowupReason.Type = "Selcomm.Orders.OrderFollowupReason";
                OrderFollowupReason.TypeParameters = [];
                return OrderFollowupReason;
            }(Selcomm.Objects.DataObject));
            Orders.OrderFollowupReason = OrderFollowupReason;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderCourier = (function (_super) {
                __extends(OrderCourier, _super);
                function OrderCourier(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderCourier.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.AccountNumber = args.AccountNumber;
                    return _this;
                }
                OrderCourier.Type = "Selcomm.Orders.OrderCourier";
                OrderCourier.TypeParameters = [];
                return OrderCourier;
            }(Selcomm.Objects.DataObject));
            Orders.OrderCourier = OrderCourier;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderAdvertisingMedia = (function (_super) {
                __extends(OrderAdvertisingMedia, _super);
                function OrderAdvertisingMedia(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderAdvertisingMedia.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.ImageLocation = args.ImageLocation;
                    return _this;
                }
                OrderAdvertisingMedia.Type = "Selcomm.Orders.OrderAdvertisingMedia";
                OrderAdvertisingMedia.TypeParameters = [];
                return OrderAdvertisingMedia;
            }(Selcomm.Objects.DataObject));
            Orders.OrderAdvertisingMedia = OrderAdvertisingMedia;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Promotions;
        (function (Promotions) {
            var Promotion = (function (_super) {
                __extends(Promotion, _super);
                function Promotion(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Promotions.Promotion.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                Promotion.Type = "Selcomm.Promotions.Promotion";
                Promotion.TypeParameters = [];
                return Promotion;
            }(Selcomm.Objects.DataObject));
            Promotions.Promotion = Promotion;
        })(Promotions = Selcomm.Promotions || (Selcomm.Promotions = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderItem = (function (_super) {
                __extends(OrderItem, _super);
                function OrderItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.OrderId = args.OrderId;
                    _this.OrderItemType = args.OrderItemType;
                    _this.LineNumber = args.LineNumber;
                    _this.ParentOrderItemId = args.ParentOrderItemId;
                    _this.OrderItemProductType = args.OrderItemProductType;
                    _this.Product = args.Product;
                    _this.Description = args.Description;
                    _this.OrderItemStatus = args.OrderItemStatus;
                    _this.StatusChangeDateTime = args.StatusChangeDateTime;
                    _this.Quantity = args.Quantity;
                    _this.PriceTaxExclusive = args.PriceTaxExclusive;
                    _this.PriceTaxInclusive = args.PriceTaxInclusive;
                    _this.CostTaxExclusive = args.CostTaxExclusive;
                    _this.Note = args.Note;
                    _this.InvoiceNote = args.InvoiceNote;
                    _this.SupplierNote = args.SupplierNote;
                    _this.SupplierName = args.SupplierName;
                    _this.RequiredDateTime = args.RequiredDateTime;
                    _this.Reference = args.Reference;
                    _this.SupplierReference = args.SupplierReference;
                    _this.SupplierPromisedDeliveryDate = args.SupplierPromisedDeliveryDate;
                    _this.Amended = args.Amended;
                    _this.OrderItemActionType = args.OrderItemActionType;
                    _this.RelatedServiceReference = args.RelatedServiceReference;
                    _this.StockCode = args.StockCode;
                    _this.ChildItems = args.ChildItems;
                    return _this;
                }
                OrderItem.Type = "Selcomm.Orders.OrderItem";
                OrderItem.TypeParameters = [];
                return OrderItem;
            }(Selcomm.Objects.DataObject));
            Orders.OrderItem = OrderItem;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderItemType;
            (function (OrderItemType) {
                OrderItemType[OrderItemType["Product"] = 0] = "Product";
                OrderItemType[OrderItemType["Action"] = 1] = "Action";
            })(OrderItemType = Orders.OrderItemType || (Orders.OrderItemType = {}));
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderItemProductType;
            (function (OrderItemProductType) {
                OrderItemProductType[OrderItemProductType["Set"] = 0] = "Set";
                OrderItemProductType[OrderItemProductType["Equipment"] = 1] = "Equipment";
                OrderItemProductType[OrderItemProductType["Sim"] = 2] = "Sim";
                OrderItemProductType[OrderItemProductType["Service"] = 3] = "Service";
                OrderItemProductType[OrderItemProductType["Hardware"] = 4] = "Hardware";
                OrderItemProductType[OrderItemProductType["Azure"] = 5] = "Azure";
            })(OrderItemProductType = Orders.OrderItemProductType || (Orders.OrderItemProductType = {}));
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderItemStatus = (function (_super) {
                __extends(OrderItemStatus, _super);
                function OrderItemStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderItemStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Description = args.Description;
                    _this.SystemStatus = args.SystemStatus;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Active = args.Active;
                    _this.Default = args.Default;
                    _this.OperatorActionNeedsAuthorisation = args.OperatorActionNeedsAuthorisation;
                    return _this;
                }
                OrderItemStatus.Type = "Selcomm.Orders.OrderItemStatus";
                OrderItemStatus.TypeParameters = [];
                return OrderItemStatus;
            }(Selcomm.Objects.DataObject));
            Orders.OrderItemStatus = OrderItemStatus;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderItemActionType = (function (_super) {
                __extends(OrderItemActionType, _super);
                function OrderItemActionType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderItemActionType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    return _this;
                }
                OrderItemActionType.Type = "Selcomm.Orders.OrderItemActionType";
                OrderItemActionType.TypeParameters = [];
                return OrderItemActionType;
            }(Selcomm.Objects.DataObject));
            Orders.OrderItemActionType = OrderItemActionType;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var ServiceOrderItem = (function (_super) {
                __extends(ServiceOrderItem, _super);
                function ServiceOrderItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.ServiceOrderItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.OrderNetworkActionType = args.OrderNetworkActionType;
                    _this.ServiceTypeCode = args.ServiceTypeCode;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.ServicePassword = args.ServicePassword;
                    _this.ServicePIN = args.ServicePIN;
                    _this.PackageCode = args.PackageCode;
                    _this.PackageOption = args.PackageOption;
                    _this.ServiceId = args.ServiceId;
                    _this.LosingCarriageServiceProviderCode = args.LosingCarriageServiceProviderCode;
                    _this.LosingCarriageServiceProviderAccountNumber = args.LosingCarriageServiceProviderAccountNumber;
                    _this.PortingDateOfBirth = args.PortingDateOfBirth;
                    _this.ParentOtherOrderItemServiceId = args.ParentOtherOrderItemServiceId;
                    _this.ParentExistingServiceReference = args.ParentExistingServiceReference;
                    _this.Attributes = args.Attributes;
                    _this.Charges = args.Charges;
                    _this.Discounts = args.Discounts;
                    _this.Addresses = args.Addresses;
                    return _this;
                }
                ServiceOrderItem.Type = "Selcomm.Orders.ServiceOrderItem";
                ServiceOrderItem.TypeParameters = [];
                return ServiceOrderItem;
            }(Selcomm.Orders.OrderItem));
            Orders.ServiceOrderItem = ServiceOrderItem;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var ServiceOrderItemAttribute = (function (_super) {
                __extends(ServiceOrderItemAttribute, _super);
                function ServiceOrderItemAttribute(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.ServiceOrderItemAttribute.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.OrderItemId = args.OrderItemId;
                    _this.AttributeId = args.AttributeId;
                    _this.Value = args.Value;
                    return _this;
                }
                ServiceOrderItemAttribute.Type = "Selcomm.Orders.ServiceOrderItemAttribute";
                ServiceOrderItemAttribute.TypeParameters = [];
                return ServiceOrderItemAttribute;
            }(Selcomm.Objects.DataObject));
            Orders.ServiceOrderItemAttribute = ServiceOrderItemAttribute;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var ServiceOrderItemCharge = (function (_super) {
                __extends(ServiceOrderItemCharge, _super);
                function ServiceOrderItemCharge(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.ServiceOrderItemCharge.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.OrderItemId = args.OrderItemId;
                    _this.Charge = args.Charge;
                    _this.Description = args.Description;
                    _this.DefaultAmount = args.DefaultAmount;
                    return _this;
                }
                ServiceOrderItemCharge.Type = "Selcomm.Orders.ServiceOrderItemCharge";
                ServiceOrderItemCharge.TypeParameters = [];
                return ServiceOrderItemCharge;
            }(Selcomm.Objects.DataObject));
            Orders.ServiceOrderItemCharge = ServiceOrderItemCharge;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var ServiceOrderItemDiscount = (function (_super) {
                __extends(ServiceOrderItemDiscount, _super);
                function ServiceOrderItemDiscount(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.ServiceOrderItemDiscount.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.OrderItemId = args.OrderItemId;
                    _this.DiscountId = args.DiscountId;
                    _this.ContactCode = args.ContactCode;
                    _this.DiscountAmount = args.DiscountAmount;
                    _this.DiscountInformation1 = args.DiscountInformation1;
                    _this.DiscountInformation2 = args.DiscountInformation2;
                    _this.DiscountInformation3 = args.DiscountInformation3;
                    return _this;
                }
                ServiceOrderItemDiscount.Type = "Selcomm.Orders.ServiceOrderItemDiscount";
                ServiceOrderItemDiscount.TypeParameters = [];
                return ServiceOrderItemDiscount;
            }(Selcomm.Objects.DataObject));
            Orders.ServiceOrderItemDiscount = ServiceOrderItemDiscount;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var ServiceOrderItemAddress = (function (_super) {
                __extends(ServiceOrderItemAddress, _super);
                function ServiceOrderItemAddress(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.ServiceOrderItemAddress.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.OrderItemId = args.OrderItemId;
                    _this.Address = args.Address;
                    _this.AddressType = args.AddressType;
                    return _this;
                }
                ServiceOrderItemAddress.Type = "Selcomm.Orders.ServiceOrderItemAddress";
                ServiceOrderItemAddress.TypeParameters = [];
                return ServiceOrderItemAddress;
            }(Selcomm.Objects.DataObject));
            Orders.ServiceOrderItemAddress = ServiceOrderItemAddress;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var EquipmentOrderItem = (function (_super) {
                __extends(EquipmentOrderItem, _super);
                function EquipmentOrderItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.EquipmentOrderItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.EquipmentType = args.EquipmentType;
                    _this.EquipmentSerialNumber = args.EquipmentSerialNumber;
                    return _this;
                }
                EquipmentOrderItem.Type = "Selcomm.Orders.EquipmentOrderItem";
                EquipmentOrderItem.TypeParameters = [];
                return EquipmentOrderItem;
            }(Selcomm.Orders.OrderItem));
            Orders.EquipmentOrderItem = EquipmentOrderItem;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var SimOrderItem = (function (_super) {
                __extends(SimOrderItem, _super);
                function SimOrderItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.SimOrderItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.SimNumber = args.SimNumber;
                    _this.Puk = args.Puk;
                    return _this;
                }
                SimOrderItem.Type = "Selcomm.Orders.SimOrderItem";
                SimOrderItem.TypeParameters = [];
                return SimOrderItem;
            }(Selcomm.Orders.OrderItem));
            Orders.SimOrderItem = SimOrderItem;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var UC1;
            (function (UC1) {
                var Order = (function (_super) {
                    __extends(Order, _super);
                    function Order(args) {
                        var _this = _super.call(this, args) || this;
                        _this.$type = Selcomm.Orders.UC1.Order.Type;
                        if (!args) {
                            return _this;
                        }
                        ;
                        _this.Password = args.Password;
                        _this.SendEmailBills = args.SendEmailBills;
                        _this.SendPaperBills = args.SendPaperBills;
                        _this.ParentContactCode = args.ParentContactCode;
                        _this.Contact = args.Contact;
                        _this.PrimaryContact = args.PrimaryContact;
                        _this.Attachments = args.Attachments;
                        return _this;
                    }
                    Order.Type = "Selcomm.Orders.UC1.Order";
                    Order.TypeParameters = [];
                    return Order;
                }(Selcomm.Orders.Order));
                UC1.Order = Order;
            })(UC1 = Orders.UC1 || (Orders.UC1 = {}));
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Product;
        (function (Product) {
            var ProductList = (function (_super) {
                __extends(ProductList, _super);
                function ProductList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Product.ProductList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ProductList.Type = "Selcomm.Product.ProductList";
                ProductList.TypeParameters = [];
                return ProductList;
            }(Selcomm.Objects.ExtendedDataList));
            Product.ProductList = ProductList;
        })(Product = Selcomm.Product || (Selcomm.Product = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderDisplay = (function (_super) {
                __extends(OrderDisplay, _super);
                function OrderDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Number = args.Number;
                    _this.DebtorCode = args.DebtorCode;
                    _this.ContactCode = args.ContactCode;
                    _this.OrderDate = args.OrderDate;
                    _this.Status = args.Status;
                    _this.StatusCode = args.StatusCode;
                    _this.StatusDate = args.StatusDate;
                    _this.DealerId = args.DealerId;
                    _this.Note = args.Note;
                    _this.ContactName = args.ContactName;
                    _this.CustomerVoiceSigned = args.CustomerVoiceSigned;
                    return _this;
                }
                OrderDisplay.Type = "Selcomm.Orders.OrderDisplay";
                OrderDisplay.TypeParameters = [];
                return OrderDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Orders.OrderDisplay = OrderDisplay;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderDisplayList = (function (_super) {
                __extends(OrderDisplayList, _super);
                function OrderDisplayList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderDisplayList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                OrderDisplayList.Type = "Selcomm.Orders.OrderDisplayList";
                OrderDisplayList.TypeParameters = [];
                return OrderDisplayList;
            }(Selcomm.Objects.ExtendedDataList));
            Orders.OrderDisplayList = OrderDisplayList;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var OrderItemCharge = (function (_super) {
                __extends(OrderItemCharge, _super);
                function OrderItemCharge(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.OrderItemCharge.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ChargeCode = args.ChargeCode;
                    _this.OrderItemId = args.OrderItemId;
                    _this.Cost = args.Cost;
                    _this.Price = args.Price;
                    return _this;
                }
                OrderItemCharge.Type = "Selcomm.Orders.OrderItemCharge";
                OrderItemCharge.TypeParameters = [];
                return OrderItemCharge;
            }(Selcomm.Objects.DataObject));
            Orders.OrderItemCharge = OrderItemCharge;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var UC4 = (function (_super) {
                __extends(UC4, _super);
                function UC4(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.UC4.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Contact = args.Contact;
                    _this.PrimaryContact = args.PrimaryContact;
                    _this.Order = args.Order;
                    _this.Password = args.Password;
                    _this.AccountPaymentMethod = args.AccountPaymentMethod;
                    _this.PackageOption = args.PackageOption;
                    _this.Package = args.Package;
                    _this.Product = args.Product;
                    _this.OpportunityList = args.OpportunityList;
                    _this.NewNumberType = args.NewNumberType;
                    _this.PackageOptionChargeDisplay = args.PackageOptionChargeDisplay;
                    _this.BeenAtCurrentAddressMoreThanThreeYears = args.BeenAtCurrentAddressMoreThanThreeYears;
                    _this.BillingAddressSameAsCurrentAddress = args.BillingAddressSameAsCurrentAddress;
                    _this.BillingAddressIsPostBox = args.BillingAddressIsPostBox;
                    _this.SendBillsToEmail = args.SendBillsToEmail;
                    _this.IdTypeList = args.IdTypeList;
                    _this.IdentityList = args.IdentityList;
                    _this.MonthlyNewsLetter = args.MonthlyNewsLetter;
                    _this.SavingWithPartner = args.SavingWithPartner;
                    _this.SaverCardProgramme = args.SaverCardProgramme;
                    _this.ReferrerName = args.ReferrerName;
                    _this.ReferrerEmail = args.ReferrerEmail;
                    _this.ReferrerPhone = args.ReferrerPhone;
                    _this.EmploymentPosition = args.EmploymentPosition;
                    _this.SelfEmployment = args.SelfEmployment;
                    _this.IncomeBracket = args.IncomeBracket;
                    _this.EmployerName = args.EmployerName;
                    _this.EmployerAddress = args.EmployerAddress;
                    _this.EmployerPhoneNumber = args.EmployerPhoneNumber;
                    _this.EmployerContactName = args.EmployerContactName;
                    _this.NextOfKinName = args.NextOfKinName;
                    _this.NextOfKinAddress = args.NextOfKinAddress;
                    _this.NextOfKinPhone = args.NextOfKinPhone;
                    _this.CreditDefault = args.CreditDefault;
                    _this.NameChanged = args.NameChanged;
                    _this.LastCreditApplied = args.LastCreditApplied;
                    _this.SimOnly = args.SimOnly;
                    _this.ExpressPostageForSim = args.ExpressPostageForSim;
                    _this.NanoSim = args.NanoSim;
                    _this.MicroSim = args.MicroSim;
                    _this.MobilePortingDetails = args.MobilePortingDetails;
                    _this.CallToConfirmOrder = args.CallToConfirmOrder;
                    _this.ConfirmOrderContactNumber = args.ConfirmOrderContactNumber;
                    _this.ConfirmOrderContactTime = args.ConfirmOrderContactTime;
                    _this.TermsAndConditionsAccepted = args.TermsAndConditionsAccepted;
                    _this.AccountHolderPortingToDifferentName = args.AccountHolderPortingToDifferentName;
                    return _this;
                }
                UC4.Type = "Selcomm.Orders.UC4";
                UC4.TypeParameters = [];
                return UC4;
            }(Selcomm.Objects.DataObject));
            Orders.UC4 = UC4;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var NewNumberTypes;
            (function (NewNumberTypes) {
                NewNumberTypes[NewNumberTypes["Free"] = 0] = "Free";
                NewNumberTypes[NewNumberTypes["Silver"] = 1] = "Silver";
                NewNumberTypes[NewNumberTypes["Gold"] = 2] = "Gold";
                NewNumberTypes[NewNumberTypes["Platinum"] = 3] = "Platinum";
                NewNumberTypes[NewNumberTypes["PhoneWord"] = 4] = "PhoneWord";
            })(NewNumberTypes = Orders.NewNumberTypes || (Orders.NewNumberTypes = {}));
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageOptionChargeDisplay = (function (_super) {
                __extends(PackageOptionChargeDisplay, _super);
                function PackageOptionChargeDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageOptionChargeDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.PackageChargeId = args.PackageChargeId;
                    _this.ChargeTemplateCode = args.ChargeTemplateCode;
                    _this.ChargeTemplateDescription = args.ChargeTemplateDescription;
                    _this.ChargeTemplateDefaultAmount = args.ChargeTemplateDefaultAmount;
                    _this.Amount = args.Amount;
                    _this.FrequencyDescription = args.FrequencyDescription;
                    _this.ProRate = args.ProRate;
                    return _this;
                }
                PackageOptionChargeDisplay.Type = "Selcomm.Package.PackageOptionChargeDisplay";
                PackageOptionChargeDisplay.TypeParameters = [];
                return PackageOptionChargeDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Package.PackageOptionChargeDisplay = PackageOptionChargeDisplay;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var SelfEmploymentDetails = (function () {
                function SelfEmploymentDetails(args) {
                    this.$type = Selcomm.Orders.SelfEmploymentDetails.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.AccountantName = args.AccountantName;
                    this.AccountantFirm = args.AccountantFirm;
                    this.AccountantContactNumber = args.AccountantContactNumber;
                }
                SelfEmploymentDetails.Type = "Selcomm.Orders.SelfEmploymentDetails";
                SelfEmploymentDetails.TypeParameters = [];
                return SelfEmploymentDetails;
            }());
            Orders.SelfEmploymentDetails = SelfEmploymentDetails;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var PortingDetails = (function () {
                function PortingDetails(args) {
                    this.$type = Selcomm.Orders.PortingDetails.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.MobileNumber = args.MobileNumber;
                    this.Carrier = args.Carrier;
                    this.ServiceProvider = args.ServiceProvider;
                    this.OwnerOfAccount = args.OwnerOfAccount;
                    this.AddAdditionalServicesToAccount = args.AddAdditionalServicesToAccount;
                }
                PortingDetails.Type = "Selcomm.Orders.PortingDetails";
                PortingDetails.TypeParameters = [];
                return PortingDetails;
            }());
            Orders.PortingDetails = PortingDetails;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var PostPaidPortingDetails = (function (_super) {
                __extends(PostPaidPortingDetails, _super);
                function PostPaidPortingDetails(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.PostPaidPortingDetails.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.AccountNumber = args.AccountNumber;
                    return _this;
                }
                PostPaidPortingDetails.Type = "Selcomm.Orders.PostPaidPortingDetails";
                PostPaidPortingDetails.TypeParameters = [];
                return PostPaidPortingDetails;
            }(Selcomm.Orders.PortingDetails));
            Orders.PostPaidPortingDetails = PostPaidPortingDetails;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var PrePaidPortingDetails = (function (_super) {
                __extends(PrePaidPortingDetails, _super);
                function PrePaidPortingDetails(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.PrePaidPortingDetails.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.DateOfBirth = args.DateOfBirth;
                    return _this;
                }
                PrePaidPortingDetails.Type = "Selcomm.Orders.PrePaidPortingDetails";
                PrePaidPortingDetails.TypeParameters = [];
                return PrePaidPortingDetails;
            }(Selcomm.Orders.PortingDetails));
            Orders.PrePaidPortingDetails = PrePaidPortingDetails;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    var SelcommOSSAAPT;
    (function (SelcommOSSAAPT) {
        var ResponseOfQualifyProductResponseModelsmRyUdve = (function () {
            function ResponseOfQualifyProductResponseModelsmRyUdve(args) {
                this.$type = SelcommOSSAAPT.ResponseOfQualifyProductResponseModelsmRyUdve.Type;
                if (!args) {
                    return;
                }
                ;
                this.Error = args.Error;
                this.Message = args.Message;
                this.ProviderResponse = args.ProviderResponse;
                this.Status = args.Status;
                this.StatusCode = args.StatusCode;
            }
            ResponseOfQualifyProductResponseModelsmRyUdve.Type = "SelcommOSSAAPT.ResponseOfQualifyProductResponseModelsmRyUdve";
            ResponseOfQualifyProductResponseModelsmRyUdve.TypeParameters = [];
            return ResponseOfQualifyProductResponseModelsmRyUdve;
        }());
        SelcommOSSAAPT.ResponseOfQualifyProductResponseModelsmRyUdve = ResponseOfQualifyProductResponseModelsmRyUdve;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var ResponseError = (function () {
            function ResponseError(args) {
                this.$type = SelcommOSSAAPT.ResponseError.Type;
                if (!args) {
                    return;
                }
                ;
                this.Code = args.Code;
                this.Message = args.Message;
            }
            ResponseError.Type = "SelcommOSSAAPT.ResponseError";
            ResponseError.TypeParameters = [];
            return ResponseError;
        }());
        SelcommOSSAAPT.ResponseError = ResponseError;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var ResponseProviderOfQualifyProductResponseModelsmRyUdve = (function () {
            function ResponseProviderOfQualifyProductResponseModelsmRyUdve(args) {
                this.$type = SelcommOSSAAPT.ResponseProviderOfQualifyProductResponseModelsmRyUdve.Type;
                if (!args) {
                    return;
                }
                ;
                this.Code = args.Code;
                this.Data = args.Data;
                this.Message = args.Message;
                this.ProviderReference = args.ProviderReference;
            }
            ResponseProviderOfQualifyProductResponseModelsmRyUdve.Type = "SelcommOSSAAPT.ResponseProviderOfQualifyProductResponseModelsmRyUdve";
            ResponseProviderOfQualifyProductResponseModelsmRyUdve.TypeParameters = [];
            return ResponseProviderOfQualifyProductResponseModelsmRyUdve;
        }());
        SelcommOSSAAPT.ResponseProviderOfQualifyProductResponseModelsmRyUdve = ResponseProviderOfQualifyProductResponseModelsmRyUdve;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var QualifyProductResponseModel = (function () {
            function QualifyProductResponseModel(args) {
                this.$type = SelcommOSSAAPT.QualifyProductResponseModel.Type;
                if (!args) {
                    return;
                }
                ;
                this.AccessQualifications = args.AccessQualifications;
                this.EndCSN = args.EndCSN;
                this.QualificationID = args.QualificationID;
                this.QualificationSiteDetails = args.QualificationSiteDetails;
                this.SiteAddress = args.SiteAddress;
                this.TelstraCableDetails = args.TelstraCableDetails;
            }
            QualifyProductResponseModel.Type = "SelcommOSSAAPT.QualifyProductResponseModel";
            QualifyProductResponseModel.TypeParameters = [];
            return QualifyProductResponseModel;
        }());
        SelcommOSSAAPT.QualifyProductResponseModel = QualifyProductResponseModel;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var AccessQualification = (function () {
            function AccessQualification(args) {
                this.$type = SelcommOSSAAPT.AccessQualification.Type;
                if (!args) {
                    return;
                }
                ;
                this.accessMethodField = args.accessMethodField;
                this.accessMethodFieldSpecified = args.accessMethodFieldSpecified;
                this.accessTypeField = args.accessTypeField;
                this.accessTypeFieldSpecified = args.accessTypeFieldSpecified;
                this.availableServiceSpeedsField = args.availableServiceSpeedsField;
                this.idField = args.idField;
                this.maximumDownBandwidthField = args.maximumDownBandwidthField;
                this.maximumUpBandwidthField = args.maximumUpBandwidthField;
                this.nbnCopperPairListField = args.nbnCopperPairListField;
                this.nbnNetworkTerminationDeviceListField = args.nbnNetworkTerminationDeviceListField;
                this.nbnNewDevelopmentsChargeAppliesField = args.nbnNewDevelopmentsChargeAppliesField;
                this.priceZoneField = args.priceZoneField;
                this.priceZoneFieldSpecified = args.priceZoneFieldSpecified;
                this.qualificationResultField = args.qualificationResultField;
                this.testOutcomesField = args.testOutcomesField;
            }
            AccessQualification.Type = "SelcommOSSAAPT.AccessQualification";
            AccessQualification.TypeParameters = [];
            return AccessQualification;
        }());
        SelcommOSSAAPT.AccessQualification = AccessQualification;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var AccessMethod;
        (function (AccessMethod) {
            AccessMethod[AccessMethod["AAPTADSL2"] = 0] = "AAPTADSL2";
            AccessMethod[AccessMethod["AAPTSHDSL"] = 1] = "AAPTSHDSL";
            AccessMethod[AccessMethod["iiNetADSL2"] = 2] = "iiNetADSL2";
            AccessMethod[AccessMethod["TelstraL2IG"] = 3] = "TelstraL2IG";
            AccessMethod[AccessMethod["NBN"] = 4] = "NBN";
            AccessMethod[AccessMethod["OnNetADSL2AnnexATypeii"] = 5] = "OnNetADSL2AnnexATypeii";
            AccessMethod[AccessMethod["AAPTMBETCPAM64128"] = 6] = "AAPTMBETCPAM64128";
            AccessMethod[AccessMethod["AAPTMBE"] = 7] = "AAPTMBE";
            AccessMethod[AccessMethod["AAPTFibreMetroE"] = 8] = "AAPTFibreMetroE";
            AccessMethod[AccessMethod["AAPTFibreSDH"] = 9] = "AAPTFibreSDH";
            AccessMethod[AccessMethod["AAPTFibre"] = 10] = "AAPTFibre";
            AccessMethod[AccessMethod["OptuseLink"] = 11] = "OptuseLink";
            AccessMethod[AccessMethod["TelstraTWBGE"] = 12] = "TelstraTWBGE";
            AccessMethod[AccessMethod["XYZedZedE"] = 13] = "XYZedZedE";
            AccessMethod[AccessMethod["TelstraTWBDSL"] = 14] = "TelstraTWBDSL";
            AccessMethod[AccessMethod["TelstraDAMLLS"] = 15] = "TelstraDAMLLS";
            AccessMethod[AccessMethod["TelstraDAMLLE"] = 16] = "TelstraDAMLLE";
            AccessMethod[AccessMethod["TelstraDAEthernetAccessCopper"] = 17] = "TelstraDAEthernetAccessCopper";
            AccessMethod[AccessMethod["TelstraDAEthernetAccessFibre"] = 18] = "TelstraDAEthernetAccessFibre";
            AccessMethod[AccessMethod["EFM4Wire"] = 19] = "EFM4Wire";
            AccessMethod[AccessMethod["EFM6Wire"] = 20] = "EFM6Wire";
            AccessMethod[AccessMethod["EFM8Wire"] = 21] = "EFM8Wire";
            AccessMethod[AccessMethod["ADSL2MSAN"] = 22] = "ADSL2MSAN";
            AccessMethod[AccessMethod["MetroEthernet"] = 23] = "MetroEthernet";
        })(AccessMethod = SelcommOSSAAPT.AccessMethod || (SelcommOSSAAPT.AccessMethod = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var AccessType;
        (function (AccessType) {
            AccessType[AccessType["SSS"] = 0] = "SSS";
            AccessType[AccessType["DSLL2"] = 1] = "DSLL2";
            AccessType[AccessType["IULL"] = 2] = "IULL";
            AccessType[AccessType["VULL"] = 3] = "VULL";
            AccessType[AccessType["NFAS"] = 4] = "NFAS";
            AccessType[AccessType["NWAS"] = 5] = "NWAS";
            AccessType[AccessType["NCAS"] = 6] = "NCAS";
            AccessType[AccessType["NHAS"] = 7] = "NHAS";
            AccessType[AccessType["NSAS"] = 8] = "NSAS";
        })(AccessType = SelcommOSSAAPT.AccessType || (SelcommOSSAAPT.AccessType = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var SpeedStatus = (function () {
            function SpeedStatus(args) {
                this.$type = SelcommOSSAAPT.SpeedStatus.Type;
                if (!args) {
                    return;
                }
                ;
                this.serviceSpeedField = args.serviceSpeedField;
                this.statusField = args.statusField;
            }
            SpeedStatus.Type = "SelcommOSSAAPT.SpeedStatus";
            SpeedStatus.TypeParameters = [];
            return SpeedStatus;
        }());
        SelcommOSSAAPT.SpeedStatus = SpeedStatus;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var ServiceSpeed;
        (function (ServiceSpeed) {
            ServiceSpeed[ServiceSpeed["Upto256kbps64kbps"] = 0] = "Upto256kbps64kbps";
            ServiceSpeed[ServiceSpeed["Upto512kbps128kbps"] = 1] = "Upto512kbps128kbps";
            ServiceSpeed[ServiceSpeed["Upto512kbps512kbps"] = 2] = "Upto512kbps512kbps";
            ServiceSpeed[ServiceSpeed["Upto1Mbps1Mbps"] = 3] = "Upto1Mbps1Mbps";
            ServiceSpeed[ServiceSpeed["Upto15Mbps256kbps"] = 4] = "Upto15Mbps256kbps";
            ServiceSpeed[ServiceSpeed["Upto15Mbps15Mbps"] = 5] = "Upto15Mbps15Mbps";
            ServiceSpeed[ServiceSpeed["Upto2Mbps384kbps"] = 6] = "Upto2Mbps384kbps";
            ServiceSpeed[ServiceSpeed["Upto2Mbps2Mbps"] = 7] = "Upto2Mbps2Mbps";
            ServiceSpeed[ServiceSpeed["Upto8Mbps384kbps"] = 8] = "Upto8Mbps384kbps";
            ServiceSpeed[ServiceSpeed["Upto8Mbps768kbps"] = 9] = "Upto8Mbps768kbps";
            ServiceSpeed[ServiceSpeed["Upto20Mbps1Mbps"] = 10] = "Upto20Mbps1Mbps";
            ServiceSpeed[ServiceSpeed["Upto20Mbps3MbpsAnnexM"] = 11] = "Upto20Mbps3MbpsAnnexM";
            ServiceSpeed[ServiceSpeed["Upto24Mbps1MbpsAnnexA"] = 12] = "Upto24Mbps1MbpsAnnexA";
            ServiceSpeed[ServiceSpeed["Item12Mbps1Mbps"] = 13] = "Item12Mbps1Mbps";
            ServiceSpeed[ServiceSpeed["Item25Mbps5Mbps"] = 14] = "Item25Mbps5Mbps";
            ServiceSpeed[ServiceSpeed["Item25Mbps10Mbps"] = 15] = "Item25Mbps10Mbps";
            ServiceSpeed[ServiceSpeed["Item50Mbps20Mbps"] = 16] = "Item50Mbps20Mbps";
            ServiceSpeed[ServiceSpeed["Item100Mbps40Mbps"] = 17] = "Item100Mbps40Mbps";
            ServiceSpeed[ServiceSpeed["Item25Mbps510Mbps"] = 18] = "Item25Mbps510Mbps";
            ServiceSpeed[ServiceSpeed["Item2550Mbps520Mbps"] = 19] = "Item2550Mbps520Mbps";
            ServiceSpeed[ServiceSpeed["Item25100Mbps540Mbps"] = 20] = "Item25100Mbps540Mbps";
            ServiceSpeed[ServiceSpeed["Upto10Mbps"] = 21] = "Upto10Mbps";
            ServiceSpeed[ServiceSpeed["Upto20Mbps"] = 22] = "Upto20Mbps";
        })(ServiceSpeed = SelcommOSSAAPT.ServiceSpeed || (SelcommOSSAAPT.ServiceSpeed = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var TestResult;
        (function (TestResult) {
            TestResult[TestResult["NOT_APPLICABLE"] = 0] = "NOT_APPLICABLE";
            TestResult[TestResult["PASS"] = 1] = "PASS";
            TestResult[TestResult["CONDITIONAL"] = 2] = "CONDITIONAL";
            TestResult[TestResult["FAIL"] = 3] = "FAIL";
            TestResult[TestResult["ERROR"] = 4] = "ERROR";
            TestResult[TestResult["UNKNOWN"] = 5] = "UNKNOWN";
        })(TestResult = SelcommOSSAAPT.TestResult || (SelcommOSSAAPT.TestResult = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var Speed = (function () {
            function Speed(args) {
                this.$type = SelcommOSSAAPT.Speed.Type;
                if (!args) {
                    return;
                }
                ;
                this.quantifierField = args.quantifierField;
                this.valueField = args.valueField;
            }
            Speed.Type = "SelcommOSSAAPT.Speed";
            Speed.TypeParameters = [];
            return Speed;
        }());
        SelcommOSSAAPT.Speed = Speed;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var SpeedQuantifier;
        (function (SpeedQuantifier) {
            SpeedQuantifier[SpeedQuantifier["bps"] = 0] = "bps";
            SpeedQuantifier[SpeedQuantifier["kbps"] = 1] = "kbps";
            SpeedQuantifier[SpeedQuantifier["mbps"] = 2] = "mbps";
            SpeedQuantifier[SpeedQuantifier["gbps"] = 3] = "gbps";
        })(SpeedQuantifier = SelcommOSSAAPT.SpeedQuantifier || (SelcommOSSAAPT.SpeedQuantifier = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var NBNCopperPair = (function () {
            function NBNCopperPair(args) {
                this.$type = SelcommOSSAAPT.NBNCopperPair.Type;
                if (!args) {
                    return;
                }
                ;
                this.idField = args.idField;
                this.isCoexistingNetworkField = args.isCoexistingNetworkField;
                this.isCoexistingNetworkFieldSpecified = args.isCoexistingNetworkFieldSpecified;
                this.isCopperActiveField = args.isCopperActiveField;
                this.isCopperActiveFieldSpecified = args.isCopperActiveFieldSpecified;
                this.isLineInUseField = args.isLineInUseField;
                this.isLineInUseFieldSpecified = args.isLineInUseFieldSpecified;
                this.isPOTSInterconnectMatchField = args.isPOTSInterconnectMatchField;
                this.isPOTSInterconnectMatchFieldSpecified = args.isPOTSInterconnectMatchFieldSpecified;
                this.pOTSInterconnectField = args.pOTSInterconnectField;
                this.serviceTypeField = args.serviceTypeField;
                this.serviceabilityClassField = args.serviceabilityClassField;
                this.tC4DownstreamLowerRateField = args.tC4DownstreamLowerRateField;
                this.tC4DownstreamUpperRateField = args.tC4DownstreamUpperRateField;
                this.tC4UpstreamLowerRateField = args.tC4UpstreamLowerRateField;
                this.tC4UpstreamUpperRateField = args.tC4UpstreamUpperRateField;
            }
            NBNCopperPair.Type = "SelcommOSSAAPT.NBNCopperPair";
            NBNCopperPair.TypeParameters = [];
            return NBNCopperPair;
        }());
        SelcommOSSAAPT.NBNCopperPair = NBNCopperPair;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var NBNNetworkTerminationDevice = (function () {
            function NBNNetworkTerminationDevice(args) {
                this.$type = SelcommOSSAAPT.NBNNetworkTerminationDevice.Type;
                if (!args) {
                    return;
                }
                ;
                this.batteryPowerUnitInstalledField = args.batteryPowerUnitInstalledField;
                this.batteryPowerUnitInstalledFieldSpecified = args.batteryPowerUnitInstalledFieldSpecified;
                this.batteryPowerUnitMonitoringField = args.batteryPowerUnitMonitoringField;
                this.batteryPowerUnitMonitoringFieldSpecified = args.batteryPowerUnitMonitoringFieldSpecified;
                this.ntdIdField = args.ntdIdField;
                this.userNetworkInterfaceListField = args.userNetworkInterfaceListField;
            }
            NBNNetworkTerminationDevice.Type = "SelcommOSSAAPT.NBNNetworkTerminationDevice";
            NBNNetworkTerminationDevice.TypeParameters = [];
            return NBNNetworkTerminationDevice;
        }());
        SelcommOSSAAPT.NBNNetworkTerminationDevice = NBNNetworkTerminationDevice;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var YesNo;
        (function (YesNo) {
            YesNo[YesNo["Yes"] = 0] = "Yes";
            YesNo[YesNo["No"] = 1] = "No";
            YesNo[YesNo["yes1"] = 2] = "yes1";
            YesNo[YesNo["no1"] = 3] = "no1";
            YesNo[YesNo["YES2"] = 4] = "YES2";
            YesNo[YesNo["NO2"] = 5] = "NO2";
        })(YesNo = SelcommOSSAAPT.YesNo || (SelcommOSSAAPT.YesNo = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var BatteryPowerUnitMonitoring;
        (function (BatteryPowerUnitMonitoring) {
            BatteryPowerUnitMonitoring[BatteryPowerUnitMonitoring["ENABLED"] = 0] = "ENABLED";
            BatteryPowerUnitMonitoring[BatteryPowerUnitMonitoring["DISABLED"] = 1] = "DISABLED";
        })(BatteryPowerUnitMonitoring = SelcommOSSAAPT.BatteryPowerUnitMonitoring || (SelcommOSSAAPT.BatteryPowerUnitMonitoring = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var NBNUserNetworkInterfaceDetails = (function () {
            function NBNUserNetworkInterfaceDetails(args) {
                this.$type = SelcommOSSAAPT.NBNUserNetworkInterfaceDetails.Type;
                if (!args) {
                    return;
                }
                ;
                this.portIdField = args.portIdField;
                this.productInstanceIdField = args.productInstanceIdField;
                this.serviceProviderIdField = args.serviceProviderIdField;
                this.statusField = args.statusField;
                this.uniIdField = args.uniIdField;
                this.uniTypeField = args.uniTypeField;
            }
            NBNUserNetworkInterfaceDetails.Type = "SelcommOSSAAPT.NBNUserNetworkInterfaceDetails";
            NBNUserNetworkInterfaceDetails.TypeParameters = [];
            return NBNUserNetworkInterfaceDetails;
        }());
        SelcommOSSAAPT.NBNUserNetworkInterfaceDetails = NBNUserNetworkInterfaceDetails;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var PriceZone;
        (function (PriceZone) {
            PriceZone[PriceZone["Metro"] = 0] = "Metro";
            PriceZone[PriceZone["Regional"] = 1] = "Regional";
            PriceZone[PriceZone["Zone1"] = 2] = "Zone1";
            PriceZone[PriceZone["Zone2"] = 3] = "Zone2";
            PriceZone[PriceZone["Zone3"] = 4] = "Zone3";
            PriceZone[PriceZone["CBD"] = 5] = "CBD";
            PriceZone[PriceZone["Region1"] = 6] = "Region1";
            PriceZone[PriceZone["Region2"] = 7] = "Region2";
            PriceZone[PriceZone["Region3"] = 8] = "Region3";
            PriceZone[PriceZone["Region4"] = 9] = "Region4";
            PriceZone[PriceZone["Class1Metro"] = 10] = "Class1Metro";
            PriceZone[PriceZone["Class2Metro"] = 11] = "Class2Metro";
            PriceZone[PriceZone["Regional2"] = 12] = "Regional2";
            PriceZone[PriceZone["Rural"] = 13] = "Rural";
        })(PriceZone = SelcommOSSAAPT.PriceZone || (SelcommOSSAAPT.PriceZone = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var QualificationTestOutcome = (function () {
            function QualificationTestOutcome(args) {
                this.$type = SelcommOSSAAPT.QualificationTestOutcome.Type;
                if (!args) {
                    return;
                }
                ;
                this.testDescriptionField = args.testDescriptionField;
                this.testNumberField = args.testNumberField;
                this.testResponseField = args.testResponseField;
                this.testResultField = args.testResultField;
            }
            QualificationTestOutcome.Type = "SelcommOSSAAPT.QualificationTestOutcome";
            QualificationTestOutcome.TypeParameters = [];
            return QualificationTestOutcome;
        }());
        SelcommOSSAAPT.QualificationTestOutcome = QualificationTestOutcome;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var QualificationSiteDetails = (function () {
            function QualificationSiteDetails(args) {
                this.$type = SelcommOSSAAPT.QualificationSiteDetails.Type;
                if (!args) {
                    return;
                }
                ;
                this.copperCableSourceField = args.copperCableSourceField;
                this.distanceToExchangeField = args.distanceToExchangeField;
                this.distanceToExchangeFieldSpecified = args.distanceToExchangeFieldSpecified;
                this.dslCodesOnLineField = args.dslCodesOnLineField;
                this.dslCodesOnLineFieldSpecified = args.dslCodesOnLineFieldSpecified;
                this.exchangeCodeField = args.exchangeCodeField;
                this.exchangeServiceAreaField = args.exchangeServiceAreaField;
                this.firstCvcField = args.firstCvcField;
                this.firstCvcFieldSpecified = args.firstCvcFieldSpecified;
                this.gpsLocationField = args.gpsLocationField;
                this.nbnCustomerServiceAreaIdField = args.nbnCustomerServiceAreaIdField;
                this.nbnLocationIDField = args.nbnLocationIDField;
                this.nbnPoiIdField = args.nbnPoiIdField;
                this.nbnServiceabilityClassField = args.nbnServiceabilityClassField;
                this.nbnServiceabilityClassFieldSpecified = args.nbnServiceabilityClassFieldSpecified;
                this.telstraLocationIDField = args.telstraLocationIDField;
            }
            QualificationSiteDetails.Type = "SelcommOSSAAPT.QualificationSiteDetails";
            QualificationSiteDetails.TypeParameters = [];
            return QualificationSiteDetails;
        }());
        SelcommOSSAAPT.QualificationSiteDetails = QualificationSiteDetails;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var GeoCoordinates = (function () {
            function GeoCoordinates(args) {
                this.$type = SelcommOSSAAPT.GeoCoordinates.Type;
                if (!args) {
                    return;
                }
                ;
                this.latitudeField = args.latitudeField;
                this.longitudeField = args.longitudeField;
            }
            GeoCoordinates.Type = "SelcommOSSAAPT.GeoCoordinates";
            GeoCoordinates.TypeParameters = [];
            return GeoCoordinates;
        }());
        SelcommOSSAAPT.GeoCoordinates = GeoCoordinates;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var NbnServiceabilityClass;
        (function (NbnServiceabilityClass) {
            NbnServiceabilityClass[NbnServiceabilityClass["Item0"] = 0] = "Item0";
            NbnServiceabilityClass[NbnServiceabilityClass["Item1"] = 1] = "Item1";
            NbnServiceabilityClass[NbnServiceabilityClass["Item2"] = 2] = "Item2";
            NbnServiceabilityClass[NbnServiceabilityClass["Item3"] = 3] = "Item3";
            NbnServiceabilityClass[NbnServiceabilityClass["Item4"] = 4] = "Item4";
            NbnServiceabilityClass[NbnServiceabilityClass["Item5"] = 5] = "Item5";
            NbnServiceabilityClass[NbnServiceabilityClass["Item6"] = 6] = "Item6";
            NbnServiceabilityClass[NbnServiceabilityClass["Item7"] = 7] = "Item7";
            NbnServiceabilityClass[NbnServiceabilityClass["Item8"] = 8] = "Item8";
            NbnServiceabilityClass[NbnServiceabilityClass["Item9"] = 9] = "Item9";
            NbnServiceabilityClass[NbnServiceabilityClass["Item10"] = 10] = "Item10";
            NbnServiceabilityClass[NbnServiceabilityClass["Item11"] = 11] = "Item11";
            NbnServiceabilityClass[NbnServiceabilityClass["Item12"] = 12] = "Item12";
            NbnServiceabilityClass[NbnServiceabilityClass["Item13"] = 13] = "Item13";
            NbnServiceabilityClass[NbnServiceabilityClass["Item20"] = 14] = "Item20";
            NbnServiceabilityClass[NbnServiceabilityClass["Item21"] = 15] = "Item21";
            NbnServiceabilityClass[NbnServiceabilityClass["Item22"] = 16] = "Item22";
            NbnServiceabilityClass[NbnServiceabilityClass["Item23"] = 17] = "Item23";
            NbnServiceabilityClass[NbnServiceabilityClass["Item24"] = 18] = "Item24";
        })(NbnServiceabilityClass = SelcommOSSAAPT.NbnServiceabilityClass || (SelcommOSSAAPT.NbnServiceabilityClass = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var SiteAddress = (function () {
            function SiteAddress(args) {
                this.$type = SelcommOSSAAPT.SiteAddress.Type;
                if (!args) {
                    return;
                }
                ;
                this.addressInformationField = args.addressInformationField;
                this.postcodeField = args.postcodeField;
                this.stateField = args.stateField;
                this.streetNameField = args.streetNameField;
                this.streetNumberField = args.streetNumberField;
                this.streetNumberSuffixField = args.streetNumberSuffixField;
                this.streetSuffixField = args.streetSuffixField;
                this.streetTypeField = args.streetTypeField;
                this.subAddressNumberField = args.subAddressNumberField;
                this.subAddressTypeField = args.subAddressTypeField;
                this.suburbField = args.suburbField;
            }
            SiteAddress.Type = "SelcommOSSAAPT.SiteAddress";
            SiteAddress.TypeParameters = [];
            return SiteAddress;
        }());
        SelcommOSSAAPT.SiteAddress = SiteAddress;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var State;
        (function (State) {
            State[State["NSW"] = 0] = "NSW";
            State[State["QLD"] = 1] = "QLD";
            State[State["VIC"] = 2] = "VIC";
            State[State["TAS"] = 3] = "TAS";
            State[State["SA"] = 4] = "SA";
            State[State["NT"] = 5] = "NT";
            State[State["WA"] = 6] = "WA";
            State[State["ACT"] = 7] = "ACT";
        })(State = SelcommOSSAAPT.State || (SelcommOSSAAPT.State = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var CableDetails = (function () {
            function CableDetails(args) {
                this.$type = SelcommOSSAAPT.CableDetails.Type;
                if (!args) {
                    return;
                }
                ;
                this.cablePairField = args.cablePairField;
                this.transmissionPathStatusField = args.transmissionPathStatusField;
            }
            CableDetails.Type = "SelcommOSSAAPT.CableDetails";
            CableDetails.TypeParameters = [];
            return CableDetails;
        }());
        SelcommOSSAAPT.CableDetails = CableDetails;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var CablePair = (function () {
            function CablePair(args) {
                this.$type = SelcommOSSAAPT.CablePair.Type;
                if (!args) {
                    return;
                }
                ;
                this.copperCableField = args.copperCableField;
                this.pairKeyField = args.pairKeyField;
                this.pairTypeField = args.pairTypeField;
            }
            CablePair.Type = "SelcommOSSAAPT.CablePair";
            CablePair.TypeParameters = [];
            return CablePair;
        }());
        SelcommOSSAAPT.CablePair = CablePair;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var CopperCable = (function () {
            function CopperCable(args) {
                this.$type = SelcommOSSAAPT.CopperCable.Type;
                if (!args) {
                    return;
                }
                ;
                this.bridgeTapField = args.bridgeTapField;
                this.bridgeTapFieldSpecified = args.bridgeTapFieldSpecified;
                this.cableTypeField = args.cableTypeField;
                this.gaugeField = args.gaugeField;
                this.lengthField = args.lengthField;
                this.sequenceField = args.sequenceField;
            }
            CopperCable.Type = "SelcommOSSAAPT.CopperCable";
            CopperCable.TypeParameters = [];
            return CopperCable;
        }());
        SelcommOSSAAPT.CopperCable = CopperCable;
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (SelcommOSSAAPT) {
        var HttpStatusCode;
        (function (HttpStatusCode) {
            HttpStatusCode[HttpStatusCode["Continue"] = 100] = "Continue";
            HttpStatusCode[HttpStatusCode["SwitchingProtocols"] = 101] = "SwitchingProtocols";
            HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
            HttpStatusCode[HttpStatusCode["Created"] = 201] = "Created";
            HttpStatusCode[HttpStatusCode["Accepted"] = 202] = "Accepted";
            HttpStatusCode[HttpStatusCode["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
            HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
            HttpStatusCode[HttpStatusCode["ResetContent"] = 205] = "ResetContent";
            HttpStatusCode[HttpStatusCode["PartialContent"] = 206] = "PartialContent";
            HttpStatusCode[HttpStatusCode["MultipleChoices"] = 300] = "MultipleChoices";
            HttpStatusCode[HttpStatusCode["Ambiguous"] = 300] = "Ambiguous";
            HttpStatusCode[HttpStatusCode["MovedPermanently"] = 301] = "MovedPermanently";
            HttpStatusCode[HttpStatusCode["Moved"] = 301] = "Moved";
            HttpStatusCode[HttpStatusCode["Found"] = 302] = "Found";
            HttpStatusCode[HttpStatusCode["Redirect"] = 302] = "Redirect";
            HttpStatusCode[HttpStatusCode["SeeOther"] = 303] = "SeeOther";
            HttpStatusCode[HttpStatusCode["RedirectMethod"] = 303] = "RedirectMethod";
            HttpStatusCode[HttpStatusCode["NotModified"] = 304] = "NotModified";
            HttpStatusCode[HttpStatusCode["UseProxy"] = 305] = "UseProxy";
            HttpStatusCode[HttpStatusCode["Unused"] = 306] = "Unused";
            HttpStatusCode[HttpStatusCode["TemporaryRedirect"] = 307] = "TemporaryRedirect";
            HttpStatusCode[HttpStatusCode["RedirectKeepVerb"] = 307] = "RedirectKeepVerb";
            HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
            HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
            HttpStatusCode[HttpStatusCode["PaymentRequired"] = 402] = "PaymentRequired";
            HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
            HttpStatusCode[HttpStatusCode["NotFound"] = 404] = "NotFound";
            HttpStatusCode[HttpStatusCode["MethodNotAllowed"] = 405] = "MethodNotAllowed";
            HttpStatusCode[HttpStatusCode["NotAcceptable"] = 406] = "NotAcceptable";
            HttpStatusCode[HttpStatusCode["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
            HttpStatusCode[HttpStatusCode["RequestTimeout"] = 408] = "RequestTimeout";
            HttpStatusCode[HttpStatusCode["Conflict"] = 409] = "Conflict";
            HttpStatusCode[HttpStatusCode["Gone"] = 410] = "Gone";
            HttpStatusCode[HttpStatusCode["LengthRequired"] = 411] = "LengthRequired";
            HttpStatusCode[HttpStatusCode["PreconditionFailed"] = 412] = "PreconditionFailed";
            HttpStatusCode[HttpStatusCode["RequestEntityTooLarge"] = 413] = "RequestEntityTooLarge";
            HttpStatusCode[HttpStatusCode["RequestUriTooLong"] = 414] = "RequestUriTooLong";
            HttpStatusCode[HttpStatusCode["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
            HttpStatusCode[HttpStatusCode["RequestedRangeNotSatisfiable"] = 416] = "RequestedRangeNotSatisfiable";
            HttpStatusCode[HttpStatusCode["ExpectationFailed"] = 417] = "ExpectationFailed";
            HttpStatusCode[HttpStatusCode["UpgradeRequired"] = 426] = "UpgradeRequired";
            HttpStatusCode[HttpStatusCode["InternalServerError"] = 500] = "InternalServerError";
            HttpStatusCode[HttpStatusCode["NotImplemented"] = 501] = "NotImplemented";
            HttpStatusCode[HttpStatusCode["BadGateway"] = 502] = "BadGateway";
            HttpStatusCode[HttpStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
            HttpStatusCode[HttpStatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
            HttpStatusCode[HttpStatusCode["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
        })(HttpStatusCode = SelcommOSSAAPT.HttpStatusCode || (SelcommOSSAAPT.HttpStatusCode = {}));
    })(SelcommOSSAAPT = exports.SelcommOSSAAPT || (exports.SelcommOSSAAPT = {}));
    (function (Selcomm) {
        var Orders;
        (function (Orders) {
            var ServiceProviderLocationId = (function (_super) {
                __extends(ServiceProviderLocationId, _super);
                function ServiceProviderLocationId(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Orders.ServiceProviderLocationId.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.TelstraLocationId = args.TelstraLocationId;
                    _this.NBNLocationId = args.NBNLocationId;
                    _this.DisplayAddress = args.DisplayAddress;
                    return _this;
                }
                ServiceProviderLocationId.Type = "Selcomm.Orders.ServiceProviderLocationId";
                ServiceProviderLocationId.TypeParameters = [];
                return ServiceProviderLocationId;
            }(Selcomm.Objects.DataObject));
            Orders.ServiceProviderLocationId = ServiceProviderLocationId;
        })(Orders = Selcomm.Orders || (Selcomm.Orders = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageOptionCharge = (function (_super) {
                __extends(PackageOptionCharge, _super);
                function PackageOptionCharge(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageOptionCharge.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.PackageGroup = args.PackageGroup;
                    _this.ChargeTemplate = args.ChargeTemplate;
                    _this.Start = args.Start;
                    _this.End = args.End;
                    _this.PackageOptionChargePricingType = args.PackageOptionChargePricingType;
                    _this.PriceTaxExcluded = args.PriceTaxExcluded;
                    _this.CostMarkupPercentage = args.CostMarkupPercentage;
                    _this.AutomaticallyApplied = args.AutomaticallyApplied;
                    _this.DelayStartInterval = args.DelayStartInterval;
                    _this.RoundToStartOfMonth = args.RoundToStartOfMonth;
                    _this.RoundToEndOfMonth = args.RoundToEndOfMonth;
                    _this.NumberOfIntervals = args.NumberOfIntervals;
                    return _this;
                }
                PackageOptionCharge.Type = "Selcomm.Package.PackageOptionCharge";
                PackageOptionCharge.TypeParameters = [];
                return PackageOptionCharge;
            }(Selcomm.Objects.DataObject));
            Package.PackageOptionCharge = PackageOptionCharge;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageOptionChargePricingType;
            (function (PackageOptionChargePricingType) {
                PackageOptionChargePricingType[PackageOptionChargePricingType["Fixed"] = 0] = "Fixed";
                PackageOptionChargePricingType[PackageOptionChargePricingType["CostMarkup"] = 1] = "CostMarkup";
            })(PackageOptionChargePricingType = Package.PackageOptionChargePricingType || (Package.PackageOptionChargePricingType = {}));
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageGroupDisplay = (function (_super) {
                __extends(PackageGroupDisplay, _super);
                function PackageGroupDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageGroupDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ParentGroupId = args.ParentGroupId;
                    _this.Name = args.Name;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Enabled = args.Enabled;
                    _this.IsRootGroup = args.IsRootGroup;
                    _this.PackageOptionDisplayList = args.PackageOptionDisplayList;
                    _this.PackageDisplayList = args.PackageDisplayList;
                    return _this;
                }
                PackageGroupDisplay.Type = "Selcomm.Package.PackageGroupDisplay";
                PackageGroupDisplay.TypeParameters = [];
                return PackageGroupDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Package.PackageGroupDisplay = PackageGroupDisplay;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageDisplay = (function (_super) {
                __extends(PackageDisplay, _super);
                function PackageDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.DisplayName = args.DisplayName;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.StartDate = args.StartDate;
                    _this.EndDate = args.EndDate;
                    _this.SalesValueRank = args.SalesValueRank;
                    _this.AdditionalInformation1 = args.AdditionalInformation1;
                    _this.AdditionalInformation2 = args.AdditionalInformation2;
                    _this.AdditionalInformation3 = args.AdditionalInformation3;
                    _this.AdditionalInformation4 = args.AdditionalInformation4;
                    _this.URL = args.URL;
                    _this.ContractDescription = args.ContractDescription;
                    _this.Note = args.Note;
                    return _this;
                }
                PackageDisplay.Type = "Selcomm.Package.PackageDisplay";
                PackageDisplay.TypeParameters = [];
                return PackageDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Package.PackageDisplay = PackageDisplay;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Package;
        (function (Package) {
            var PackageOptionDisplay = (function (_super) {
                __extends(PackageOptionDisplay, _super);
                function PackageOptionDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Package.PackageOptionDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.PackageOption = args.PackageOption;
                    _this.PackageOptionName = args.PackageOptionName;
                    return _this;
                }
                PackageOptionDisplay.Type = "Selcomm.Package.PackageOptionDisplay";
                PackageOptionDisplay.TypeParameters = [];
                return PackageOptionDisplay;
            }(Selcomm.Package.PackageDisplay));
            Package.PackageOptionDisplay = PackageOptionDisplay;
        })(Package = Selcomm.Package || (Selcomm.Package = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentResponse = (function () {
                function PaymentResponse(args) {
                    this.$type = Selcomm.Payment.PaymentResponse.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ClientReference = args.ClientReference;
                    this.Response = args.Response;
                    this.AccountDetails = args.AccountDetails;
                }
                PaymentResponse.Type = "Selcomm.Payment.PaymentResponse";
                PaymentResponse.TypeParameters = [];
                return PaymentResponse;
            }());
            Payment.PaymentResponse = PaymentResponse;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentRequestResponseDisplay = (function (_super) {
                __extends(PaymentRequestResponseDisplay, _super);
                function PaymentRequestResponseDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentRequestResponseDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.FinancialTransactionNumber = args.FinancialTransactionNumber;
                    _this.PayRequestStatus = args.PayRequestStatus;
                    _this.SystemStatus = args.SystemStatus;
                    _this.PaymentRequestStatusReason = args.PaymentRequestStatusReason;
                    _this.RequestDateTime = args.RequestDateTime;
                    _this.NumberOfPolls = args.NumberOfPolls;
                    _this.LastPolled = args.LastPolled;
                    _this.SurchargeAmount = args.SurchargeAmount;
                    _this.RequestAmount = args.RequestAmount;
                    _this.ReferenceNumber = args.ReferenceNumber;
                    _this.AuthorisationNumber = args.AuthorisationNumber;
                    _this.PreAuthorisationNumber = args.PreAuthorisationNumber;
                    _this.ProviderReferenceNumber = args.ProviderReferenceNumber;
                    _this.LastErrorCode = args.LastErrorCode;
                    _this.LastError = args.LastError;
                    return _this;
                }
                PaymentRequestResponseDisplay.Type = "Selcomm.Payment.PaymentRequestResponseDisplay";
                PaymentRequestResponseDisplay.TypeParameters = [];
                return PaymentRequestResponseDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Payment.PaymentRequestResponseDisplay = PaymentRequestResponseDisplay;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var NewAccountPaymentMethodOption;
            (function (NewAccountPaymentMethodOption) {
                NewAccountPaymentMethodOption[NewAccountPaymentMethodOption["NewOrReopen"] = 0] = "NewOrReopen";
                NewAccountPaymentMethodOption[NewAccountPaymentMethodOption["AlwaysCreate"] = 1] = "AlwaysCreate";
                NewAccountPaymentMethodOption[NewAccountPaymentMethodOption["NewOnly"] = 2] = "NewOnly";
            })(NewAccountPaymentMethodOption = Payment.NewAccountPaymentMethodOption || (Payment.NewAccountPaymentMethodOption = {}));
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentSurcharge = (function (_super) {
                __extends(PaymentSurcharge, _super);
                function PaymentSurcharge(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Payment.PaymentSurcharge.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.SurchargePercentage = args.SurchargePercentage;
                    _this.SurchargeAmount = args.SurchargeAmount;
                    return _this;
                }
                PaymentSurcharge.Type = "Selcomm.Payment.PaymentSurcharge";
                PaymentSurcharge.TypeParameters = [];
                return PaymentSurcharge;
            }(Selcomm.Objects.DataObject));
            Payment.PaymentSurcharge = PaymentSurcharge;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var PaymentMethodOnlineRegisterToken = (function () {
                function PaymentMethodOnlineRegisterToken(args) {
                    this.$type = Selcomm.Payment.PaymentMethodOnlineRegisterToken.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.RegistrationURL = args.RegistrationURL;
                    this.RegistrationRequestId = args.RegistrationRequestId;
                    this.InitialToken = args.InitialToken;
                    this.ProviderId = args.ProviderId;
                }
                PaymentMethodOnlineRegisterToken.Type = "Selcomm.Payment.PaymentMethodOnlineRegisterToken";
                PaymentMethodOnlineRegisterToken.TypeParameters = [];
                return PaymentMethodOnlineRegisterToken;
            }());
            Payment.PaymentMethodOnlineRegisterToken = PaymentMethodOnlineRegisterToken;
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Payment;
        (function (Payment) {
            var OnlineRegistrationResult;
            (function (OnlineRegistrationResult) {
                OnlineRegistrationResult[OnlineRegistrationResult["Success"] = 1] = "Success";
                OnlineRegistrationResult[OnlineRegistrationResult["Failure"] = 2] = "Failure";
            })(OnlineRegistrationResult = Payment.OnlineRegistrationResult || (Payment.OnlineRegistrationResult = {}));
        })(Payment = Selcomm.Payment || (Selcomm.Payment = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Product;
        (function (Product) {
            var BrandDisplay = (function (_super) {
                __extends(BrandDisplay, _super);
                function BrandDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Product.BrandDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    return _this;
                }
                BrandDisplay.Type = "Selcomm.Product.BrandDisplay";
                BrandDisplay.TypeParameters = [];
                return BrandDisplay;
            }(Selcomm.Objects.DataObject));
            Product.BrandDisplay = BrandDisplay;
        })(Product = Selcomm.Product || (Selcomm.Product = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Product;
        (function (Product) {
            var ProductDisplay = (function (_super) {
                __extends(ProductDisplay, _super);
                function ProductDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Product.ProductDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.BrandId = args.BrandId;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                ProductDisplay.Type = "Selcomm.Product.ProductDisplay";
                ProductDisplay.TypeParameters = [];
                return ProductDisplay;
            }(Selcomm.Objects.DataObject));
            Product.ProductDisplay = ProductDisplay;
        })(Product = Selcomm.Product || (Selcomm.Product = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeBatchStatus = (function (_super) {
                __extends(RechargeBatchStatus, _super);
                function RechargeBatchStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeBatchStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.SystemStatus = args.SystemStatus;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    return _this;
                }
                RechargeBatchStatus.Type = "Selcomm.Recharges.RechargeBatchStatus";
                RechargeBatchStatus.TypeParameters = [];
                return RechargeBatchStatus;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeBatchStatus = RechargeBatchStatus;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeBatchStatusReason = (function (_super) {
                __extends(RechargeBatchStatusReason, _super);
                function RechargeBatchStatusReason(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeBatchStatusReason.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    return _this;
                }
                RechargeBatchStatusReason.Type = "Selcomm.Recharges.RechargeBatchStatusReason";
                RechargeBatchStatusReason.TypeParameters = [];
                return RechargeBatchStatusReason;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeBatchStatusReason = RechargeBatchStatusReason;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePricingRequest = (function (_super) {
                __extends(RechargePricingRequest, _super);
                function RechargePricingRequest(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargePricingRequest.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.RequestDateTime = args.RequestDateTime;
                    _this.RechargeId = args.RechargeId;
                    _this.PromotionCode = args.PromotionCode;
                    _this.Asynchronous = args.Asynchronous;
                    _this.RechargePricingRequestItemList = args.RechargePricingRequestItemList;
                    return _this;
                }
                RechargePricingRequest.Type = "Selcomm.Recharges.RechargePricingRequest";
                RechargePricingRequest.TypeParameters = [];
                return RechargePricingRequest;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargePricingRequest = RechargePricingRequest;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePricingRequestItem = (function (_super) {
                __extends(RechargePricingRequestItem, _super);
                function RechargePricingRequestItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargePricingRequestItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Status = args.Status;
                    _this.RequestDateTime = args.RequestDateTime;
                    _this.Type = args.Type;
                    _this.ItemCode = args.ItemCode;
                    _this.Quantity = args.Quantity;
                    _this.PriceTaxExcluded = args.PriceTaxExcluded;
                    _this.PriceTaxIncluded = args.PriceTaxIncluded;
                    _this.QuantityAvailable = args.QuantityAvailable;
                    return _this;
                }
                RechargePricingRequestItem.Type = "Selcomm.Recharges.RechargePricingRequestItem";
                RechargePricingRequestItem.TypeParameters = [];
                return RechargePricingRequestItem;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargePricingRequestItem = RechargePricingRequestItem;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePricingRequestItemStatus;
            (function (RechargePricingRequestItemStatus) {
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["Pending"] = 0] = "Pending";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["Priced"] = 1] = "Priced";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["InvalidItemCode"] = 2] = "InvalidItemCode";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["InvalidQuantity"] = 3] = "InvalidQuantity";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["NoPricingPlan"] = 4] = "NoPricingPlan";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["NoPricingForThisItem"] = 5] = "NoPricingForThisItem";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["Expired"] = 6] = "Expired";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["Refer"] = 7] = "Refer";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["ApprovalRequired"] = 8] = "ApprovalRequired";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["InvalidItemType"] = 9] = "InvalidItemType";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["ItemCurrentlyNotAvailable"] = 10] = "ItemCurrentlyNotAvailable";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["ItemCurrentlyNotAvailableForThisRecharge"] = 11] = "ItemCurrentlyNotAvailableForThisRecharge";
                RechargePricingRequestItemStatus[RechargePricingRequestItemStatus["Other"] = 12] = "Other";
            })(RechargePricingRequestItemStatus = Recharges.RechargePricingRequestItemStatus || (Recharges.RechargePricingRequestItemStatus = {}));
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePricingRequestItemType;
            (function (RechargePricingRequestItemType) {
                RechargePricingRequestItemType[RechargePricingRequestItemType["UsageTransaction"] = 0] = "UsageTransaction";
                RechargePricingRequestItemType[RechargePricingRequestItemType["OneOffOrRecurringCharge"] = 1] = "OneOffOrRecurringCharge";
                RechargePricingRequestItemType[RechargePricingRequestItemType["Hardware"] = 2] = "Hardware";
                RechargePricingRequestItemType[RechargePricingRequestItemType["Event"] = 3] = "Event";
                RechargePricingRequestItemType[RechargePricingRequestItemType["Other"] = 4] = "Other";
            })(RechargePricingRequestItemType = Recharges.RechargePricingRequestItemType || (Recharges.RechargePricingRequestItemType = {}));
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePricingRequestItemList = (function (_super) {
                __extends(RechargePricingRequestItemList, _super);
                function RechargePricingRequestItemList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargePricingRequestItemList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargePricingRequestItemList.Type = "Selcomm.Recharges.RechargePricingRequestItemList";
                RechargePricingRequestItemList.TypeParameters = [];
                return RechargePricingRequestItemList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargePricingRequestItemList = RechargePricingRequestItemList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePricingRequestList = (function (_super) {
                __extends(RechargePricingRequestList, _super);
                function RechargePricingRequestList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargePricingRequestList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargePricingRequestList.Type = "Selcomm.Recharges.RechargePricingRequestList";
                RechargePricingRequestList.TypeParameters = [];
                return RechargePricingRequestList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargePricingRequestList = RechargePricingRequestList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeAutomaticPurchase = (function (_super) {
                __extends(RechargeAutomaticPurchase, _super);
                function RechargeAutomaticPurchase(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeAutomaticPurchase.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ServiceReference = args.ServiceReference;
                    _this.RechargeAutomaticPurchaseType = args.RechargeAutomaticPurchaseType;
                    _this.RechargeTypeId = args.RechargeTypeId;
                    _this.FromDateTime = args.FromDateTime;
                    _this.ToDateTime = args.ToDateTime;
                    _this.OverRidePrice = args.OverRidePrice;
                    _this.OverRideMainCurrencyAmount = args.OverRideMainCurrencyAmount;
                    _this.TriggerThreshold = args.TriggerThreshold;
                    _this.Status = args.Status;
                    _this.MaximumNumberOfRecharges = args.MaximumNumberOfRecharges;
                    _this.DayOfMonth = args.DayOfMonth;
                    _this.Note = args.Note;
                    return _this;
                }
                RechargeAutomaticPurchase.Type = "Selcomm.Recharges.RechargeAutomaticPurchase";
                RechargeAutomaticPurchase.TypeParameters = [];
                return RechargeAutomaticPurchase;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeAutomaticPurchase = RechargeAutomaticPurchase;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeAutomaticPurchaseType;
            (function (RechargeAutomaticPurchaseType) {
                RechargeAutomaticPurchaseType[RechargeAutomaticPurchaseType["TopUp"] = 0] = "TopUp";
                RechargeAutomaticPurchaseType[RechargeAutomaticPurchaseType["Scheduled"] = 1] = "Scheduled";
            })(RechargeAutomaticPurchaseType = Recharges.RechargeAutomaticPurchaseType || (Recharges.RechargeAutomaticPurchaseType = {}));
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeAutomaticPurchaseStatus = (function (_super) {
                __extends(RechargeAutomaticPurchaseStatus, _super);
                function RechargeAutomaticPurchaseStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeAutomaticPurchaseStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.SystemStatus = args.SystemStatus;
                    return _this;
                }
                RechargeAutomaticPurchaseStatus.Type = "Selcomm.Recharges.RechargeAutomaticPurchaseStatus";
                RechargeAutomaticPurchaseStatus.TypeParameters = [];
                return RechargeAutomaticPurchaseStatus;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeAutomaticPurchaseStatus = RechargeAutomaticPurchaseStatus;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeAutomaticPurchaseList = (function (_super) {
                __extends(RechargeAutomaticPurchaseList, _super);
                function RechargeAutomaticPurchaseList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeAutomaticPurchaseList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeAutomaticPurchaseList.Type = "Selcomm.Recharges.RechargeAutomaticPurchaseList";
                RechargeAutomaticPurchaseList.TypeParameters = [];
                return RechargeAutomaticPurchaseList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeAutomaticPurchaseList = RechargeAutomaticPurchaseList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeAutomaticPurchaseStatusList = (function (_super) {
                __extends(RechargeAutomaticPurchaseStatusList, _super);
                function RechargeAutomaticPurchaseStatusList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeAutomaticPurchaseStatusList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeAutomaticPurchaseStatusList.Type = "Selcomm.Recharges.RechargeAutomaticPurchaseStatusList";
                RechargeAutomaticPurchaseStatusList.TypeParameters = [];
                return RechargeAutomaticPurchaseStatusList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeAutomaticPurchaseStatusList = RechargeAutomaticPurchaseStatusList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeIncludedElementBundle = (function (_super) {
                __extends(RechargeIncludedElementBundle, _super);
                function RechargeIncludedElementBundle(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeIncludedElementBundle.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.LowerCreditLimit = args.LowerCreditLimit;
                    _this.UpperCreditLimit = args.UpperCreditLimit;
                    return _this;
                }
                RechargeIncludedElementBundle.Type = "Selcomm.Recharges.RechargeIncludedElementBundle";
                RechargeIncludedElementBundle.TypeParameters = [];
                return RechargeIncludedElementBundle;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeIncludedElementBundle = RechargeIncludedElementBundle;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementEvent = (function (_super) {
                __extends(RechargeElementEvent, _super);
                function RechargeElementEvent(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeElementEvent.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ElementInstance = args.ElementInstance;
                    _this.EventDisplay = args.EventDisplay;
                    return _this;
                }
                RechargeElementEvent.Type = "Selcomm.Recharges.RechargeElementEvent";
                RechargeElementEvent.TypeParameters = [];
                return RechargeElementEvent;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeElementEvent = RechargeElementEvent;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElement = (function (_super) {
                __extends(RechargeElement, _super);
                function RechargeElement(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeElement.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Type = args.Type;
                    _this.UnitOfMeasure = args.UnitOfMeasure;
                    _this.EventType = args.EventType;
                    _this.ExternalId = args.ExternalId;
                    return _this;
                }
                RechargeElement.Type = "Selcomm.Recharges.RechargeElement";
                RechargeElement.TypeParameters = [];
                return RechargeElement;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeElement = RechargeElement;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementType;
            (function (RechargeElementType) {
                RechargeElementType[RechargeElementType["Calls"] = 0] = "Calls";
                RechargeElementType[RechargeElementType["Data"] = 1] = "Data";
                RechargeElementType[RechargeElementType["Time"] = 2] = "Time";
                RechargeElementType[RechargeElementType["Messages"] = 3] = "Messages";
                RechargeElementType[RechargeElementType["Points"] = 4] = "Points";
                RechargeElementType[RechargeElementType["UsageTransactions"] = 5] = "UsageTransactions";
                RechargeElementType[RechargeElementType["OneOffAndRecurringCharges"] = 6] = "OneOffAndRecurringCharges";
                RechargeElementType[RechargeElementType["SubscriptionCharges"] = 7] = "SubscriptionCharges";
                RechargeElementType[RechargeElementType["Other"] = 8] = "Other";
                RechargeElementType[RechargeElementType["E"] = 9] = "E";
                RechargeElementType[RechargeElementType["V"] = 10] = "V";
            })(RechargeElementType = Recharges.RechargeElementType || (Recharges.RechargeElementType = {}));
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementUnitOfMeasure;
            (function (RechargeElementUnitOfMeasure) {
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Each"] = 0] = "Each";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Seconds"] = 1] = "Seconds";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Minutes"] = 2] = "Minutes";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Hours"] = 3] = "Hours";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Days"] = 4] = "Days";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["BusinessDays"] = 5] = "BusinessDays";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Weeks"] = 6] = "Weeks";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Months"] = 7] = "Months";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Years"] = 8] = "Years";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Time"] = 9] = "Time";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Count"] = 10] = "Count";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Volume"] = 11] = "Volume";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["Currency"] = 12] = "Currency";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["KiloBytes"] = 13] = "KiloBytes";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["MegaBytes"] = 14] = "MegaBytes";
                RechargeElementUnitOfMeasure[RechargeElementUnitOfMeasure["GigaBytes"] = 15] = "GigaBytes";
            })(RechargeElementUnitOfMeasure = Recharges.RechargeElementUnitOfMeasure || (Recharges.RechargeElementUnitOfMeasure = {}));
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeTypeElement = (function (_super) {
                __extends(RechargeTypeElement, _super);
                function RechargeTypeElement(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeTypeElement.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.RechargeTypeId = args.RechargeTypeId;
                    _this.ExpiryDays = args.ExpiryDays;
                    _this.ExpireOnNewRecharge = args.ExpireOnNewRecharge;
                    _this.DefaultElement = args.DefaultElement;
                    _this.DefaultValue = args.DefaultValue;
                    _this.AllowVariableValue = args.AllowVariableValue;
                    _this.AllowVariableExpiry = args.AllowVariableExpiry;
                    _this.CostPerUnit = args.CostPerUnit;
                    return _this;
                }
                RechargeTypeElement.Type = "Selcomm.Recharges.RechargeTypeElement";
                RechargeTypeElement.TypeParameters = [];
                return RechargeTypeElement;
            }(Selcomm.Recharges.RechargeElement));
            Recharges.RechargeTypeElement = RechargeTypeElement;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementInstance = (function (_super) {
                __extends(RechargeElementInstance, _super);
                function RechargeElementInstance(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeElementInstance.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Recharge = args.Recharge;
                    _this.ElementId = args.ElementId;
                    _this.ExpiryDate = args.ExpiryDate;
                    _this.OriginalValue = args.OriginalValue;
                    _this.OpenValue = args.OpenValue;
                    _this.PreAuthorisedValue = args.PreAuthorisedValue;
                    _this.NetworkId = args.NetworkId;
                    _this.StartDateTime = args.StartDateTime;
                    _this.EndDateTime = args.EndDateTime;
                    return _this;
                }
                RechargeElementInstance.Type = "Selcomm.Recharges.RechargeElementInstance";
                RechargeElementInstance.TypeParameters = [];
                return RechargeElementInstance;
            }(Selcomm.Recharges.RechargeTypeElement));
            Recharges.RechargeElementInstance = RechargeElementInstance;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var Recharge = (function (_super) {
                __extends(Recharge, _super);
                function Recharge(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.Recharge.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.RechargeTypeId = args.RechargeTypeId;
                    _this.Status = args.Status;
                    _this.StatusChangedDateTime = args.StatusChangedDateTime;
                    _this.StatusReason = args.StatusReason;
                    _this.ExpiryDateTime = args.ExpiryDateTime;
                    _this.ShelfExpiryDate = args.ShelfExpiryDate;
                    _this.ChannelPartnerDeliveryDateTime = args.ChannelPartnerDeliveryDateTime;
                    _this.IssueDateTime = args.IssueDateTime;
                    _this.ActivationDateTime = args.ActivationDateTime;
                    _this.MainCurrencyAmount = args.MainCurrencyAmount;
                    _this.MainCurrencyOpenAmount = args.MainCurrencyOpenAmount;
                    _this.PreAuthorisedAmount = args.PreAuthorisedAmount;
                    _this.PriceTaxIncluded = args.PriceTaxIncluded;
                    _this.PriceTax = args.PriceTax;
                    _this.ServiceReference = args.ServiceReference;
                    _this.MaskedPIN = args.MaskedPIN;
                    _this.PIN = args.PIN;
                    _this.UnAssigned = args.UnAssigned;
                    _this.RechargeElementInstanceList = args.RechargeElementInstanceList;
                    _this.RechargeServiceAssignmentHistoryList = args.RechargeServiceAssignmentHistoryList;
                    _this.RechargePreAuthorisationList = args.RechargePreAuthorisationList;
                    _this.RechargeEventList = args.RechargeEventList;
                    _this.NetworkId = args.NetworkId;
                    _this.FinancialTransactions = args.FinancialTransactions;
                    _this.RechargeElementEventList = args.RechargeElementEventList;
                    _this.StartDateTime = args.StartDateTime;
                    _this.EndDateTime = args.EndDateTime;
                    return _this;
                }
                Recharge.Type = "Selcomm.Recharges.Recharge";
                Recharge.TypeParameters = [];
                return Recharge;
            }(Selcomm.Objects.DataObject));
            Recharges.Recharge = Recharge;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeStatus = (function (_super) {
                __extends(RechargeStatus, _super);
                function RechargeStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.SystemStatus = args.SystemStatus;
                    return _this;
                }
                RechargeStatus.Type = "Selcomm.Recharges.RechargeStatus";
                RechargeStatus.TypeParameters = [];
                return RechargeStatus;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeStatus = RechargeStatus;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeStatusReason = (function (_super) {
                __extends(RechargeStatusReason, _super);
                function RechargeStatusReason(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeStatusReason.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    return _this;
                }
                RechargeStatusReason.Type = "Selcomm.Recharges.RechargeStatusReason";
                RechargeStatusReason.TypeParameters = [];
                return RechargeStatusReason;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeStatusReason = RechargeStatusReason;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementInstanceList = (function (_super) {
                __extends(RechargeElementInstanceList, _super);
                function RechargeElementInstanceList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeElementInstanceList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeElementInstanceList.Type = "Selcomm.Recharges.RechargeElementInstanceList";
                RechargeElementInstanceList.TypeParameters = [];
                return RechargeElementInstanceList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeElementInstanceList = RechargeElementInstanceList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeServiceAssignmentHistory = (function (_super) {
                __extends(RechargeServiceAssignmentHistory, _super);
                function RechargeServiceAssignmentHistory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeServiceAssignmentHistory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ServiceReference = args.ServiceReference;
                    _this.AssignmentDateTime = args.AssignmentDateTime;
                    return _this;
                }
                RechargeServiceAssignmentHistory.Type = "Selcomm.Recharges.RechargeServiceAssignmentHistory";
                RechargeServiceAssignmentHistory.TypeParameters = [];
                return RechargeServiceAssignmentHistory;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeServiceAssignmentHistory = RechargeServiceAssignmentHistory;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeServiceAssignmentHistoryList = (function (_super) {
                __extends(RechargeServiceAssignmentHistoryList, _super);
                function RechargeServiceAssignmentHistoryList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeServiceAssignmentHistoryList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeServiceAssignmentHistoryList.Type = "Selcomm.Recharges.RechargeServiceAssignmentHistoryList";
                RechargeServiceAssignmentHistoryList.TypeParameters = [];
                return RechargeServiceAssignmentHistoryList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeServiceAssignmentHistoryList = RechargeServiceAssignmentHistoryList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePreAuthorisation = (function (_super) {
                __extends(RechargePreAuthorisation, _super);
                function RechargePreAuthorisation(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargePreAuthorisation.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ElementId = args.ElementId;
                    _this.PreAuthorisationNumber = args.PreAuthorisationNumber;
                    _this.Value = args.Value;
                    _this.OpenValue = args.OpenValue;
                    _this.DateTime = args.DateTime;
                    _this.ExpiryDateTime = args.ExpiryDateTime;
                    _this.StatusChangeDateTime = args.StatusChangeDateTime;
                    _this.RequestingUser = args.RequestingUser;
                    _this.RechargeId = args.RechargeId;
                    _this.Status = args.Status;
                    _this.RechargePreAuthorisationAllocationList = args.RechargePreAuthorisationAllocationList;
                    _this.FinancialTransactionList = args.FinancialTransactionList;
                    return _this;
                }
                RechargePreAuthorisation.Type = "Selcomm.Recharges.RechargePreAuthorisation";
                RechargePreAuthorisation.TypeParameters = [];
                return RechargePreAuthorisation;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargePreAuthorisation = RechargePreAuthorisation;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePreAuthorisationAllocation = (function (_super) {
                __extends(RechargePreAuthorisationAllocation, _super);
                function RechargePreAuthorisationAllocation(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargePreAuthorisationAllocation.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.PreAllocationId = args.PreAllocationId;
                    _this.RechargeId = args.RechargeId;
                    _this.ElementId = args.ElementId;
                    _this.Value = args.Value;
                    _this.OpenValue = args.OpenValue;
                    return _this;
                }
                RechargePreAuthorisationAllocation.Type = "Selcomm.Recharges.RechargePreAuthorisationAllocation";
                RechargePreAuthorisationAllocation.TypeParameters = [];
                return RechargePreAuthorisationAllocation;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargePreAuthorisationAllocation = RechargePreAuthorisationAllocation;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePreAuthorisationAllocationList = (function (_super) {
                __extends(RechargePreAuthorisationAllocationList, _super);
                function RechargePreAuthorisationAllocationList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargePreAuthorisationAllocationList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargePreAuthorisationAllocationList.Type = "Selcomm.Recharges.RechargePreAuthorisationAllocationList";
                RechargePreAuthorisationAllocationList.TypeParameters = [];
                return RechargePreAuthorisationAllocationList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargePreAuthorisationAllocationList = RechargePreAuthorisationAllocationList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargePreAuthorisationList = (function (_super) {
                __extends(RechargePreAuthorisationList, _super);
                function RechargePreAuthorisationList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargePreAuthorisationList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargePreAuthorisationList.Type = "Selcomm.Recharges.RechargePreAuthorisationList";
                RechargePreAuthorisationList.TypeParameters = [];
                return RechargePreAuthorisationList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargePreAuthorisationList = RechargePreAuthorisationList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementEventList = (function (_super) {
                __extends(RechargeElementEventList, _super);
                function RechargeElementEventList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeElementEventList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeElementEventList.Type = "Selcomm.Recharges.RechargeElementEventList";
                RechargeElementEventList.TypeParameters = [];
                return RechargeElementEventList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeElementEventList = RechargeElementEventList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeTypeRulesMatrix = (function () {
                function RechargeTypeRulesMatrix(args) {
                    this.$type = Selcomm.Recharges.RechargeTypeRulesMatrix.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.NewRechargeTypeId = args.NewRechargeTypeId;
                    this.ExistingRechargeTypeId = args.ExistingRechargeTypeId;
                    this.FromDate = args.FromDate;
                    this.IsolationLevel = args.IsolationLevel;
                    this.AlignEndDate = args.AlignEndDate;
                    this.AlignStartDate = args.AlignStartDate;
                    this.MaximumNumberCurrentRecharges = args.MaximumNumberCurrentRecharges;
                    this.MaximumNumberFutureRecharges = args.MaximumNumberFutureRecharges;
                    this.Parent = args.Parent;
                }
                RechargeTypeRulesMatrix.Type = "Selcomm.Recharges.RechargeTypeRulesMatrix";
                RechargeTypeRulesMatrix.TypeParameters = [];
                return RechargeTypeRulesMatrix;
            }());
            Recharges.RechargeTypeRulesMatrix = RechargeTypeRulesMatrix;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeIsolationLevel;
            (function (RechargeIsolationLevel) {
                RechargeIsolationLevel[RechargeIsolationLevel["Isolated"] = 0] = "Isolated";
                RechargeIsolationLevel[RechargeIsolationLevel["Preserved"] = 1] = "Preserved";
                RechargeIsolationLevel[RechargeIsolationLevel["Complimentary"] = 2] = "Complimentary";
            })(RechargeIsolationLevel = Recharges.RechargeIsolationLevel || (Recharges.RechargeIsolationLevel = {}));
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeTypeElementRulesMatrix = (function () {
                function RechargeTypeElementRulesMatrix(args) {
                    this.$type = Selcomm.Recharges.RechargeTypeElementRulesMatrix.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.NewRechargeTypeId = args.NewRechargeTypeId;
                    this.NewElementId = args.NewElementId;
                    this.ExistingRechargeTypeId = args.ExistingRechargeTypeId;
                    this.ExistingElementId = args.ExistingElementId;
                    this.FromDate = args.FromDate;
                    this.IsolationLevel = args.IsolationLevel;
                    this.AlignEndDate = args.AlignEndDate;
                    this.AlignStartDate = args.AlignStartDate;
                    this.MaximumNumberCurrentRecharges = args.MaximumNumberCurrentRecharges;
                    this.MaximumNumberFutureRecharges = args.MaximumNumberFutureRecharges;
                    this.Parent = args.Parent;
                }
                RechargeTypeElementRulesMatrix.Type = "Selcomm.Recharges.RechargeTypeElementRulesMatrix";
                RechargeTypeElementRulesMatrix.TypeParameters = [];
                return RechargeTypeElementRulesMatrix;
            }());
            Recharges.RechargeTypeElementRulesMatrix = RechargeTypeElementRulesMatrix;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeNewRechargeActions = (function () {
                function RechargeNewRechargeActions(args) {
                    this.$type = Selcomm.Recharges.RechargeNewRechargeActions.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Approved = args.Approved;
                    this.Comments = args.Comments;
                    this.RechargeElementInstanceActionList = args.RechargeElementInstanceActionList;
                    this.RechargeInstanceActionList = args.RechargeInstanceActionList;
                }
                RechargeNewRechargeActions.Type = "Selcomm.Recharges.RechargeNewRechargeActions";
                RechargeNewRechargeActions.TypeParameters = [];
                return RechargeNewRechargeActions;
            }());
            Recharges.RechargeNewRechargeActions = RechargeNewRechargeActions;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementInstanceAction = (function () {
                function RechargeElementInstanceAction(args) {
                    this.$type = Selcomm.Recharges.RechargeElementInstanceAction.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.RechargeId = args.RechargeId;
                    this.ElementId = args.ElementId;
                    this.Action = args.Action;
                    this.NewDate = args.NewDate;
                    this.Note = args.Note;
                }
                RechargeElementInstanceAction.Type = "Selcomm.Recharges.RechargeElementInstanceAction";
                RechargeElementInstanceAction.TypeParameters = [];
                return RechargeElementInstanceAction;
            }());
            Recharges.RechargeElementInstanceAction = RechargeElementInstanceAction;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var ActionRules;
            (function (ActionRules) {
                ActionRules[ActionRules["NoAction"] = 0] = "NoAction";
                ActionRules[ActionRules["Expire"] = 1] = "Expire";
                ActionRules[ActionRules["AlignEndDate"] = 2] = "AlignEndDate";
                ActionRules[ActionRules["AlignStartDate"] = 3] = "AlignStartDate";
            })(ActionRules = Recharges.ActionRules || (Recharges.ActionRules = {}));
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeInstanceAction = (function () {
                function RechargeInstanceAction(args) {
                    this.$type = Selcomm.Recharges.RechargeInstanceAction.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.RechargeId = args.RechargeId;
                    this.Action = args.Action;
                    this.NewDate = args.NewDate;
                    this.Note = args.Note;
                }
                RechargeInstanceAction.Type = "Selcomm.Recharges.RechargeInstanceAction";
                RechargeInstanceAction.TypeParameters = [];
                return RechargeInstanceAction;
            }());
            Recharges.RechargeInstanceAction = RechargeInstanceAction;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementList = (function (_super) {
                __extends(RechargeElementList, _super);
                function RechargeElementList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeElementList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeElementList.Type = "Selcomm.Recharges.RechargeElementList";
                RechargeElementList.TypeParameters = [];
                return RechargeElementList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeElementList = RechargeElementList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeCategory = (function (_super) {
                __extends(RechargeCategory, _super);
                function RechargeCategory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeCategory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Description = args.Description;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.RechargeTypeServiceTypeList = args.RechargeTypeServiceTypeList;
                    return _this;
                }
                RechargeCategory.Type = "Selcomm.Recharges.RechargeCategory";
                RechargeCategory.TypeParameters = [];
                return RechargeCategory;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeCategory = RechargeCategory;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeTypeServiceType = (function (_super) {
                __extends(RechargeTypeServiceType, _super);
                function RechargeTypeServiceType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeTypeServiceType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.TypeId = args.TypeId;
                    _this.ServiceTypeCode = args.ServiceTypeCode;
                    _this.AssignmentOrder = args.AssignmentOrder;
                    _this.AutomaticallyAssign = args.AutomaticallyAssign;
                    _this.AutomaticallyCreateService = args.AutomaticallyCreateService;
                    _this.PackageCode = args.PackageCode;
                    _this.PackageOption = args.PackageOption;
                    return _this;
                }
                RechargeTypeServiceType.Type = "Selcomm.Recharges.RechargeTypeServiceType";
                RechargeTypeServiceType.TypeParameters = [];
                return RechargeTypeServiceType;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeTypeServiceType = RechargeTypeServiceType;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeTypeServiceTypeList = (function (_super) {
                __extends(RechargeTypeServiceTypeList, _super);
                function RechargeTypeServiceTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeTypeServiceTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeTypeServiceTypeList.Type = "Selcomm.Recharges.RechargeTypeServiceTypeList";
                RechargeTypeServiceTypeList.TypeParameters = [];
                return RechargeTypeServiceTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeTypeServiceTypeList = RechargeTypeServiceTypeList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeCategoryList = (function (_super) {
                __extends(RechargeCategoryList, _super);
                function RechargeCategoryList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeCategoryList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeCategoryList.Type = "Selcomm.Recharges.RechargeCategoryList";
                RechargeCategoryList.TypeParameters = [];
                return RechargeCategoryList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeCategoryList = RechargeCategoryList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeType = (function (_super) {
                __extends(RechargeType, _super);
                function RechargeType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Type = args.Type;
                    _this.Name = args.Name;
                    _this.DefaultPrice = args.DefaultPrice;
                    _this.DefaultPriceTaxEx = args.DefaultPriceTaxEx;
                    _this.DefaultExpiryDays = args.DefaultExpiryDays;
                    _this.ShelfLifeDays = args.ShelfLifeDays;
                    _this.NumberOfDaysToAct = args.NumberOfDaysToAct;
                    _this.DefaultMainCurrencyAmount = args.DefaultMainCurrencyAmount;
                    _this.AllowVariableAccountBalanceUpdateAmount = args.AllowVariableAccountBalanceUpdateAmount;
                    _this.PackageCode = args.PackageCode;
                    _this.PackageOption = args.PackageOption;
                    _this.TriggerPackageChange = args.TriggerPackageChange;
                    _this.AvailableInStore = args.AvailableInStore;
                    _this.AvailableForDealers = args.AvailableForDealers;
                    _this.AvailableToVNOs = args.AvailableToVNOs;
                    _this.AvailableOnLine = args.AvailableOnLine;
                    _this.AvailableNewCustomers = args.AvailableNewCustomers;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.NetworkPlanId = args.NetworkPlanId;
                    _this.NetworkProductCode = args.NetworkProductCode;
                    _this.NetworkStockCode = args.NetworkStockCode;
                    _this.Note = args.Note;
                    _this.Image = args.Image;
                    _this.URL = args.URL;
                    _this.StartDate = args.StartDate;
                    _this.EndDate = args.EndDate;
                    _this.LowerCreditLimit = args.LowerCreditLimit;
                    _this.UpperCreditLimit = args.UpperCreditLimit;
                    _this.RechargeTypeElementList = args.RechargeTypeElementList;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.AutoRenew = args.AutoRenew;
                    _this.Parent = args.Parent;
                    return _this;
                }
                RechargeType.Type = "Selcomm.Recharges.RechargeType";
                RechargeType.TypeParameters = [];
                return RechargeType;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeType = RechargeType;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeTypeElementList = (function (_super) {
                __extends(RechargeTypeElementList, _super);
                function RechargeTypeElementList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeTypeElementList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeTypeElementList.Type = "Selcomm.Recharges.RechargeTypeElementList";
                RechargeTypeElementList.TypeParameters = [];
                return RechargeTypeElementList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeTypeElementList = RechargeTypeElementList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeTypeList = (function (_super) {
                __extends(RechargeTypeList, _super);
                function RechargeTypeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeTypeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeTypeList.Type = "Selcomm.Recharges.RechargeTypeList";
                RechargeTypeList.TypeParameters = [];
                return RechargeTypeList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeTypeList = RechargeTypeList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeStatusList = (function (_super) {
                __extends(RechargeStatusList, _super);
                function RechargeStatusList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeStatusList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeStatusList.Type = "Selcomm.Recharges.RechargeStatusList";
                RechargeStatusList.TypeParameters = [];
                return RechargeStatusList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeStatusList = RechargeStatusList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeStatusReasonList = (function (_super) {
                __extends(RechargeStatusReasonList, _super);
                function RechargeStatusReasonList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeStatusReasonList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeStatusReasonList.Type = "Selcomm.Recharges.RechargeStatusReasonList";
                RechargeStatusReasonList.TypeParameters = [];
                return RechargeStatusReasonList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeStatusReasonList = RechargeStatusReasonList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeBalance = (function (_super) {
                __extends(RechargeBalance, _super);
                function RechargeBalance(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeBalance.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.EffectiveDateTime = args.EffectiveDateTime;
                    _this.OriginalMainCurrencyTotal = args.OriginalMainCurrencyTotal;
                    _this.MainCurrencyOpenAmountTotal = args.MainCurrencyOpenAmountTotal;
                    _this.PreAuthorisationAmountTotal = args.PreAuthorisationAmountTotal;
                    _this.RechargeCount = args.RechargeCount;
                    _this.RechargeElementBalanceList = args.RechargeElementBalanceList;
                    return _this;
                }
                RechargeBalance.Type = "Selcomm.Recharges.RechargeBalance";
                RechargeBalance.TypeParameters = [];
                return RechargeBalance;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeBalance = RechargeBalance;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementBalance = (function (_super) {
                __extends(RechargeElementBalance, _super);
                function RechargeElementBalance(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeElementBalance.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.OriginalValueTotal = args.OriginalValueTotal;
                    _this.OpenValueTotal = args.OpenValueTotal;
                    _this.PreAuthorisationAmountTotal = args.PreAuthorisationAmountTotal;
                    _this.RechargeElementCount = args.RechargeElementCount;
                    return _this;
                }
                RechargeElementBalance.Type = "Selcomm.Recharges.RechargeElementBalance";
                RechargeElementBalance.TypeParameters = [];
                return RechargeElementBalance;
            }(Selcomm.Recharges.RechargeElement));
            Recharges.RechargeElementBalance = RechargeElementBalance;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeElementBalanceList = (function (_super) {
                __extends(RechargeElementBalanceList, _super);
                function RechargeElementBalanceList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeElementBalanceList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeElementBalanceList.Type = "Selcomm.Recharges.RechargeElementBalanceList";
                RechargeElementBalanceList.TypeParameters = [];
                return RechargeElementBalanceList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeElementBalanceList = RechargeElementBalanceList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeAddRequest = (function (_super) {
                __extends(RechargeAddRequest, _super);
                function RechargeAddRequest(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeAddRequest.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.AssociatedEntityKey = args.AssociatedEntityKey;
                    _this.TypeId = args.TypeId;
                    _this.OverRideMainCurrencyAmount = args.OverRideMainCurrencyAmount;
                    _this.MainCurrencyAmount = args.MainCurrencyAmount;
                    _this.OverRideExpiryDateTime = args.OverRideExpiryDateTime;
                    _this.ExpiryDateTime = args.ExpiryDateTime;
                    _this.EffectiveDateTime = args.EffectiveDateTime;
                    _this.Activate = args.Activate;
                    _this.RechargeAddRequestElementList = args.RechargeAddRequestElementList;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    return _this;
                }
                RechargeAddRequest.Type = "Selcomm.Recharges.RechargeAddRequest";
                RechargeAddRequest.TypeParameters = [];
                return RechargeAddRequest;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeAddRequest = RechargeAddRequest;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeAddRequestElement = (function (_super) {
                __extends(RechargeAddRequestElement, _super);
                function RechargeAddRequestElement(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeAddRequestElement.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ElementId = args.ElementId;
                    _this.OverRideValueAmount = args.OverRideValueAmount;
                    _this.ValueAmount = args.ValueAmount;
                    _this.OverRideExpiryDateTime = args.OverRideExpiryDateTime;
                    _this.ExpiryDateTime = args.ExpiryDateTime;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    return _this;
                }
                RechargeAddRequestElement.Type = "Selcomm.Recharges.RechargeAddRequestElement";
                RechargeAddRequestElement.TypeParameters = [];
                return RechargeAddRequestElement;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeAddRequestElement = RechargeAddRequestElement;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeList = (function (_super) {
                __extends(RechargeList, _super);
                function RechargeList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeList.Type = "Selcomm.Recharges.RechargeList";
                RechargeList.TypeParameters = [];
                return RechargeList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeList = RechargeList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeSuggestionSingletonResponse = (function (_super) {
                __extends(RechargeSuggestionSingletonResponse, _super);
                function RechargeSuggestionSingletonResponse(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeSuggestionSingletonResponse.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.RechargeTypeId = args.RechargeTypeId;
                    _this.ElementUnitPrice = args.ElementUnitPrice;
                    return _this;
                }
                RechargeSuggestionSingletonResponse.Type = "Selcomm.Recharges.RechargeSuggestionSingletonResponse";
                RechargeSuggestionSingletonResponse.TypeParameters = [];
                return RechargeSuggestionSingletonResponse;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeSuggestionSingletonResponse = RechargeSuggestionSingletonResponse;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeConsumeTransaction = (function (_super) {
                __extends(RechargeConsumeTransaction, _super);
                function RechargeConsumeTransaction(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeConsumeTransaction.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.RechargeId = args.RechargeId;
                    _this.ElementId = args.ElementId;
                    _this.PreAuthorisationReference = args.PreAuthorisationReference;
                    _this.Value = args.Value;
                    _this.DateTime = args.DateTime;
                    _this.ExternalReference = args.ExternalReference;
                    _this.FinancialTransactionReference = args.FinancialTransactionReference;
                    return _this;
                }
                RechargeConsumeTransaction.Type = "Selcomm.Recharges.RechargeConsumeTransaction";
                RechargeConsumeTransaction.TypeParameters = [];
                return RechargeConsumeTransaction;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeConsumeTransaction = RechargeConsumeTransaction;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeConsumeTransactionList = (function (_super) {
                __extends(RechargeConsumeTransactionList, _super);
                function RechargeConsumeTransactionList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeConsumeTransactionList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeConsumeTransactionList.Type = "Selcomm.Recharges.RechargeConsumeTransactionList";
                RechargeConsumeTransactionList.TypeParameters = [];
                return RechargeConsumeTransactionList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeConsumeTransactionList = RechargeConsumeTransactionList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeBatchStatusList = (function (_super) {
                __extends(RechargeBatchStatusList, _super);
                function RechargeBatchStatusList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeBatchStatusList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeBatchStatusList.Type = "Selcomm.Recharges.RechargeBatchStatusList";
                RechargeBatchStatusList.TypeParameters = [];
                return RechargeBatchStatusList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeBatchStatusList = RechargeBatchStatusList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeBatchStatusReasonList = (function (_super) {
                __extends(RechargeBatchStatusReasonList, _super);
                function RechargeBatchStatusReasonList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeBatchStatusReasonList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeBatchStatusReasonList.Type = "Selcomm.Recharges.RechargeBatchStatusReasonList";
                RechargeBatchStatusReasonList.TypeParameters = [];
                return RechargeBatchStatusReasonList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeBatchStatusReasonList = RechargeBatchStatusReasonList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeBatch = (function (_super) {
                __extends(RechargeBatch, _super);
                function RechargeBatch(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeBatch.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Reference = args.Reference;
                    _this.RechargeBatchStatus = args.RechargeBatchStatus;
                    _this.RechargeBatchStatusReason = args.RechargeBatchStatusReason;
                    _this.Note = args.Note;
                    _this.DownloadPassword = args.DownloadPassword;
                    _this.DownloadDateTime = args.DownloadDateTime;
                    _this.DownloadUserCode = args.DownloadUserCode;
                    _this.ChannelPartnerCode = args.ChannelPartnerCode;
                    _this.ActivationPassword = args.ActivationPassword;
                    _this.ActivationDateTime = args.ActivationDateTime;
                    _this.ActivationserCode = args.ActivationserCode;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.EventList = args.EventList;
                    return _this;
                }
                RechargeBatch.Type = "Selcomm.Recharges.RechargeBatch";
                RechargeBatch.TypeParameters = [];
                return RechargeBatch;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeBatch = RechargeBatch;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeBatchList = (function (_super) {
                __extends(RechargeBatchList, _super);
                function RechargeBatchList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeBatchList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RechargeBatchList.Type = "Selcomm.Recharges.RechargeBatchList";
                RechargeBatchList.TypeParameters = [];
                return RechargeBatchList;
            }(Selcomm.Objects.ExtendedDataList));
            Recharges.RechargeBatchList = RechargeBatchList;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Recharges;
        (function (Recharges) {
            var RechargeBatchFile = (function (_super) {
                __extends(RechargeBatchFile, _super);
                function RechargeBatchFile(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Recharges.RechargeBatchFile.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.DownloadedDateTime = args.DownloadedDateTime;
                    _this.NumberOfVouchers = args.NumberOfVouchers;
                    _this.FileName = args.FileName;
                    _this.FileFormatName = args.FileFormatName;
                    _this.FileFormatVersion = args.FileFormatVersion;
                    _this.Content = args.Content;
                    return _this;
                }
                RechargeBatchFile.Type = "Selcomm.Recharges.RechargeBatchFile";
                RechargeBatchFile.TypeParameters = [];
                return RechargeBatchFile;
            }(Selcomm.Objects.DataObject));
            Recharges.RechargeBatchFile = RechargeBatchFile;
        })(Recharges = Selcomm.Recharges || (Selcomm.Recharges = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var Report = (function (_super) {
                __extends(Report, _super);
                function Report(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.Report.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ReportId = args.ReportId;
                    _this.Name = args.Name;
                    _this.FilePrefix = args.FilePrefix;
                    _this.Category = args.Category;
                    _this.ObjectId = args.ObjectId;
                    _this.BusinessUnit = args.BusinessUnit;
                    _this.Enabled = args.Enabled;
                    _this.Isolated = args.Isolated;
                    _this.Output = args.Output;
                    _this.Host = args.Host;
                    _this.Command = args.Command;
                    _this.LongDescription = args.LongDescription;
                    _this.Synchronise = args.Synchronise;
                    _this.Schedulable = args.Schedulable;
                    _this.ContactRequired = args.ContactRequired;
                    _this.AvailableParameterList = args.AvailableParameterList;
                    _this.AvailableEmailList = args.AvailableEmailList;
                    _this.Note = args.Note;
                    return _this;
                }
                Report.Type = "Selcomm.Reports.Report";
                Report.TypeParameters = [];
                return Report;
            }(Selcomm.Objects.DataObject));
            Reports.Report = Report;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportCategory = (function (_super) {
                __extends(ReportCategory, _super);
                function ReportCategory(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ReportCategory.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Note = args.Note;
                    _this.ImageURL = args.ImageURL;
                    _this.Group = args.Group;
                    _this.ObjectId = args.ObjectId;
                    _this.BusinessUnit = args.BusinessUnit;
                    return _this;
                }
                ReportCategory.Type = "Selcomm.Reports.ReportCategory";
                ReportCategory.TypeParameters = [];
                return ReportCategory;
            }(Selcomm.Objects.DataObject));
            Reports.ReportCategory = ReportCategory;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportGroup = (function (_super) {
                __extends(ReportGroup, _super);
                function ReportGroup(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ReportGroup.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.ImageURL = args.ImageURL;
                    return _this;
                }
                ReportGroup.Type = "Selcomm.Reports.ReportGroup";
                ReportGroup.TypeParameters = [];
                return ReportGroup;
            }(Selcomm.Objects.DataObject));
            Reports.ReportGroup = ReportGroup;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var NoYesMandatory;
            (function (NoYesMandatory) {
                NoYesMandatory[NoYesMandatory["No"] = 0] = "No";
                NoYesMandatory[NoYesMandatory["Yes"] = 1] = "Yes";
                NoYesMandatory[NoYesMandatory["Mandatory"] = 2] = "Mandatory";
            })(NoYesMandatory = Objects.NoYesMandatory || (Objects.NoYesMandatory = {}));
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportParameter = (function (_super) {
                __extends(ReportParameter, _super);
                function ReportParameter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ReportParameter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    _this.Flag = args.Flag;
                    _this.Default = args.Default;
                    _this.Optional = args.Optional;
                    _this.Locked = args.Locked;
                    _this.MultipleSelection = args.MultipleSelection;
                    _this.Deleted = args.Deleted;
                    _this.Tooltip = args.Tooltip;
                    _this.Included = args.Included;
                    _this.DataType = args.DataType;
                    _this.ValidationType = args.ValidationType;
                    _this.ReportParameterLookupValueList = args.ReportParameterLookupValueList;
                    _this.Report = args.Report;
                    return _this;
                }
                ReportParameter.Type = "Selcomm.Reports.ReportParameter";
                ReportParameter.TypeParameters = [];
                return ReportParameter;
            }(Selcomm.Objects.DataObject));
            Reports.ReportParameter = ReportParameter;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var NoYesUnused;
            (function (NoYesUnused) {
                NoYesUnused[NoYesUnused["No"] = 0] = "No";
                NoYesUnused[NoYesUnused["Yes"] = 1] = "Yes";
                NoYesUnused[NoYesUnused["Unused"] = 2] = "Unused";
            })(NoYesUnused = Objects.NoYesUnused || (Objects.NoYesUnused = {}));
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var DataTypes;
        (function (DataTypes) {
            var ValidationType = (function (_super) {
                __extends(ValidationType, _super);
                function ValidationType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.DataTypes.ValidationType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    return _this;
                }
                ValidationType.Type = "Selcomm.DataTypes.ValidationType";
                ValidationType.TypeParameters = [];
                return ValidationType;
            }(Selcomm.Objects.DataObject));
            DataTypes.ValidationType = ValidationType;
        })(DataTypes = Selcomm.DataTypes || (Selcomm.DataTypes = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportParameterLookupValue = (function (_super) {
                __extends(ReportParameterLookupValue, _super);
                function ReportParameterLookupValue(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ReportParameterLookupValue.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Value = args.Value;
                    return _this;
                }
                ReportParameterLookupValue.Type = "Selcomm.Reports.ReportParameterLookupValue";
                ReportParameterLookupValue.TypeParameters = [];
                return ReportParameterLookupValue;
            }(Selcomm.Objects.DataObject));
            Reports.ReportParameterLookupValue = ReportParameterLookupValue;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportEmail = (function (_super) {
                __extends(ReportEmail, _super);
                function ReportEmail(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ReportEmail.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Address = args.Address;
                    _this.Deleted = args.Deleted;
                    _this.DisplayOrder = args.DisplayOrder;
                    _this.Report = args.Report;
                    return _this;
                }
                ReportEmail.Type = "Selcomm.Reports.ReportEmail";
                ReportEmail.TypeParameters = [];
                return ReportEmail;
            }(Selcomm.Objects.DataObject));
            Reports.ReportEmail = ReportEmail;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportList = (function (_super) {
                __extends(ReportList, _super);
                function ReportList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ReportList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ReportList.Type = "Selcomm.Reports.ReportList";
                ReportList.TypeParameters = [];
                return ReportList;
            }(Selcomm.Objects.ExtendedDataList));
            Reports.ReportList = ReportList;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ScheduledReport = (function (_super) {
                __extends(ScheduledReport, _super);
                function ScheduledReport(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ScheduledReport.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ScheduleId = args.ScheduleId;
                    _this.Report = args.Report;
                    _this.Requested = args.Requested;
                    _this.From = args.From;
                    _this.To = args.To;
                    _this.WeekDays = args.WeekDays;
                    _this.DayOfMonth = args.DayOfMonth;
                    _this.Priority = args.Priority;
                    _this.RequestingContactCode = args.RequestingContactCode;
                    _this.Comments = args.Comments;
                    _this.OutputFileName = args.OutputFileName;
                    _this.ScheduledParameterList = args.ScheduledParameterList;
                    _this.ScheduledEmailList = args.ScheduledEmailList;
                    _this.RequestedReportsList = args.RequestedReportsList;
                    return _this;
                }
                ScheduledReport.Type = "Selcomm.Reports.ScheduledReport";
                ScheduledReport.TypeParameters = [];
                return ScheduledReport;
            }(Selcomm.Objects.DataObject));
            Reports.ScheduledReport = ScheduledReport;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Dates;
        (function (Dates) {
            var Days;
            (function (Days) {
                Days[Days["NoDays"] = 0] = "NoDays";
                Days[Days["Sunday"] = 1] = "Sunday";
                Days[Days["Monday"] = 2] = "Monday";
                Days[Days["Tuesday"] = 4] = "Tuesday";
                Days[Days["Wednesday"] = 8] = "Wednesday";
                Days[Days["Thursday"] = 16] = "Thursday";
                Days[Days["Friday"] = 32] = "Friday";
                Days[Days["WeekDays"] = 62] = "WeekDays";
                Days[Days["Saturday"] = 64] = "Saturday";
                Days[Days["Weekend"] = 65] = "Weekend";
                Days[Days["AllDays"] = 127] = "AllDays";
            })(Days = Dates.Days || (Dates.Days = {}));
        })(Dates = Selcomm.Dates || (Selcomm.Dates = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ScheduledReportParameter = (function (_super) {
                __extends(ScheduledReportParameter, _super);
                function ScheduledReportParameter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ScheduledReportParameter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ParameterId = args.ParameterId;
                    _this.ReportParameter = args.ReportParameter;
                    _this.ScheduledReport = args.ScheduledReport;
                    _this.Flag = args.Flag;
                    _this.Value = args.Value;
                    _this.Included = args.Included;
                    return _this;
                }
                ScheduledReportParameter.Type = "Selcomm.Reports.ScheduledReportParameter";
                ScheduledReportParameter.TypeParameters = [];
                return ScheduledReportParameter;
            }(Selcomm.Objects.DataObject));
            Reports.ScheduledReportParameter = ScheduledReportParameter;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ScheduledReportEmail = (function (_super) {
                __extends(ScheduledReportEmail, _super);
                function ScheduledReportEmail(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ScheduledReportEmail.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ReportEmail = args.ReportEmail;
                    _this.ScheduledReport = args.ScheduledReport;
                    _this.Log = args.Log;
                    _this.Output = args.Output;
                    return _this;
                }
                ScheduledReportEmail.Type = "Selcomm.Reports.ScheduledReportEmail";
                ScheduledReportEmail.TypeParameters = [];
                return ScheduledReportEmail;
            }(Selcomm.Objects.DataObject));
            Reports.ScheduledReportEmail = ScheduledReportEmail;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var RequestedReport = (function (_super) {
                __extends(RequestedReport, _super);
                function RequestedReport(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.RequestedReport.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.RequestId = args.RequestId;
                    _this.Report = args.Report;
                    _this.ScheduleId = args.ScheduleId;
                    _this.Requested = args.Requested;
                    _this.StartDateTime = args.StartDateTime;
                    _this.Priority = args.Priority;
                    _this.RequestingContactCode = args.RequestingContactCode;
                    _this.RequestingUser = args.RequestingUser;
                    _this.Comments = args.Comments;
                    _this.OutputFileName = args.OutputFileName;
                    _this.Deleted = args.Deleted;
                    _this.Status = args.Status;
                    _this.StatusDateTime = args.StatusDateTime;
                    _this.RequestedParameterList = args.RequestedParameterList;
                    _this.RequestedEmailList = args.RequestedEmailList;
                    return _this;
                }
                RequestedReport.Type = "Selcomm.Reports.RequestedReport";
                RequestedReport.TypeParameters = [];
                return RequestedReport;
            }(Selcomm.Objects.DataObject));
            Reports.RequestedReport = RequestedReport;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var Statuses;
            (function (Statuses) {
                Statuses[Statuses["Unknown"] = 0] = "Unknown";
                Statuses[Statuses["Waiting"] = 1] = "Waiting";
                Statuses[Statuses["Running"] = 2] = "Running";
                Statuses[Statuses["Aborted"] = 3] = "Aborted";
                Statuses[Statuses["Completed"] = 4] = "Completed";
            })(Statuses = Reports.Statuses || (Reports.Statuses = {}));
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var RequestedReportParameter = (function (_super) {
                __extends(RequestedReportParameter, _super);
                function RequestedReportParameter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.RequestedReportParameter.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ReportParameter = args.ReportParameter;
                    _this.RequestedReport = args.RequestedReport;
                    _this.Flag = args.Flag;
                    _this.Value = args.Value;
                    _this.Included = args.Included;
                    return _this;
                }
                RequestedReportParameter.Type = "Selcomm.Reports.RequestedReportParameter";
                RequestedReportParameter.TypeParameters = [];
                return RequestedReportParameter;
            }(Selcomm.Objects.DataObject));
            Reports.RequestedReportParameter = RequestedReportParameter;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var RequestedReportEmail = (function (_super) {
                __extends(RequestedReportEmail, _super);
                function RequestedReportEmail(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.RequestedReportEmail.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ReportEmail = args.ReportEmail;
                    _this.RequestedReport = args.RequestedReport;
                    _this.Log = args.Log;
                    _this.Output = args.Output;
                    return _this;
                }
                RequestedReportEmail.Type = "Selcomm.Reports.RequestedReportEmail";
                RequestedReportEmail.TypeParameters = [];
                return RequestedReportEmail;
            }(Selcomm.Objects.DataObject));
            Reports.RequestedReportEmail = RequestedReportEmail;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var RequestedReportList = (function (_super) {
                __extends(RequestedReportList, _super);
                function RequestedReportList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.RequestedReportList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                RequestedReportList.Type = "Selcomm.Reports.RequestedReportList";
                RequestedReportList.TypeParameters = [];
                return RequestedReportList;
            }(Selcomm.Objects.ExtendedDataList));
            Reports.RequestedReportList = RequestedReportList;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ScheduleStates;
            (function (ScheduleStates) {
                ScheduleStates[ScheduleStates["All"] = 0] = "All";
                ScheduleStates[ScheduleStates["None"] = 0] = "None";
                ScheduleStates[ScheduleStates["Active"] = 1] = "Active";
                ScheduleStates[ScheduleStates["Inactive"] = 2] = "Inactive";
            })(ScheduleStates = Reports.ScheduleStates || (Reports.ScheduleStates = {}));
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var RequestedReportDisplay = (function (_super) {
                __extends(RequestedReportDisplay, _super);
                function RequestedReportDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.RequestedReportDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.RequestId = args.RequestId;
                    _this.ReportDescription = args.ReportDescription;
                    _this.Requested = args.Requested;
                    _this.StartDateTime = args.StartDateTime;
                    _this.StatusDateTime = args.StatusDateTime;
                    _this.RequestingUserCode = args.RequestingUserCode;
                    _this.Comments = args.Comments;
                    _this.OutputFileName = args.OutputFileName;
                    _this.StatusCode = args.StatusCode;
                    _this.Status = args.Status;
                    _this.RequestedParameters = args.RequestedParameters;
                    _this.RequestedEmails = args.RequestedEmails;
                    return _this;
                }
                RequestedReportDisplay.Type = "Selcomm.Reports.RequestedReportDisplay";
                RequestedReportDisplay.TypeParameters = [];
                return RequestedReportDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Reports.RequestedReportDisplay = RequestedReportDisplay;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportFile = (function (_super) {
                __extends(ReportFile, _super);
                function ReportFile(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ReportFile.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ReportPath = args.ReportPath;
                    _this.RequestedReport = args.RequestedReport;
                    _this.Description = args.Description;
                    _this.Content = args.Content;
                    return _this;
                }
                ReportFile.Type = "Selcomm.Reports.ReportFile";
                ReportFile.TypeParameters = [];
                return ReportFile;
            }(Selcomm.Objects.DataObject));
            Reports.ReportFile = ReportFile;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportOutputFileTypes;
            (function (ReportOutputFileTypes) {
                ReportOutputFileTypes[ReportOutputFileTypes["PDF"] = 0] = "PDF";
                ReportOutputFileTypes[ReportOutputFileTypes["XLSX"] = 1] = "XLSX";
                ReportOutputFileTypes[ReportOutputFileTypes["HTML"] = 2] = "HTML";
                ReportOutputFileTypes[ReportOutputFileTypes["PNG"] = 3] = "PNG";
                ReportOutputFileTypes[ReportOutputFileTypes["CSV"] = 4] = "CSV";
                ReportOutputFileTypes[ReportOutputFileTypes["WORD"] = 5] = "WORD";
            })(ReportOutputFileTypes = Reports.ReportOutputFileTypes || (Reports.ReportOutputFileTypes = {}));
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportCategoryList = (function (_super) {
                __extends(ReportCategoryList, _super);
                function ReportCategoryList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ReportCategoryList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ReportCategoryList.Type = "Selcomm.Reports.ReportCategoryList";
                ReportCategoryList.TypeParameters = [];
                return ReportCategoryList;
            }(Selcomm.Objects.ExtendedDataList));
            Reports.ReportCategoryList = ReportCategoryList;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var RequestedReportStatus = (function (_super) {
                __extends(RequestedReportStatus, _super);
                function RequestedReportStatus(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.RequestedReportStatus.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Name = args.Name;
                    return _this;
                }
                RequestedReportStatus.Type = "Selcomm.Reports.RequestedReportStatus";
                RequestedReportStatus.TypeParameters = [];
                return RequestedReportStatus;
            }(Selcomm.Objects.DataObject));
            Reports.RequestedReportStatus = RequestedReportStatus;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Reports;
        (function (Reports) {
            var ReportPeriod = (function (_super) {
                __extends(ReportPeriod, _super);
                function ReportPeriod(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Reports.ReportPeriod.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Name = args.Name;
                    _this.Description = args.Description;
                    _this.Category = args.Category;
                    _this.Enabled = args.Enabled;
                    _this.Order = args.Order;
                    return _this;
                }
                ReportPeriod.Type = "Selcomm.Reports.ReportPeriod";
                ReportPeriod.TypeParameters = [];
                return ReportPeriod;
            }(Selcomm.Objects.DataObject));
            Reports.ReportPeriod = ReportPeriod;
        })(Reports = Selcomm.Reports || (Selcomm.Reports = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var BusinessObject = (function (_super) {
                __extends(BusinessObject, _super);
                function BusinessObject(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Objects.BusinessObject.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ObjectId = args.ObjectId;
                    _this.Name = args.Name;
                    _this.Note = args.Note;
                    _this.PropertyList = args.PropertyList;
                    _this.ChildObjectList = args.ChildObjectList;
                    _this.HasLastUpdated = args.HasLastUpdated;
                    _this.HasCreatedBy = args.HasCreatedBy;
                    _this.Reportable = args.Reportable;
                    _this.AuthorisationToken = args.AuthorisationToken;
                    _this.AdditionalMethodList = args.AdditionalMethodList;
                    return _this;
                }
                BusinessObject.Type = "Selcomm.Objects.BusinessObject";
                BusinessObject.TypeParameters = [];
                return BusinessObject;
            }(Selcomm.Objects.DataObject));
            Objects.BusinessObject = BusinessObject;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var Property = (function () {
                function Property(args) {
                    this.$type = Selcomm.Objects.Property.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ObjectId = args.ObjectId;
                    this.Name = args.Name;
                    this.Note = args.Note;
                    this.ToolTip = args.ToolTip;
                    this.DataType = args.DataType;
                    this.DisplayOrder = args.DisplayOrder;
                    this.Label = args.Label;
                    this.Reportable = args.Reportable;
                    this.PrimaryKey = args.PrimaryKey;
                    this.ForeignKeyObject = args.ForeignKeyObject;
                    this.ForeignKeyProperty = args.ForeignKeyProperty;
                    this.Group = args.Group;
                    this.AuthorisationToken = args.AuthorisationToken;
                    this.DefaultValue = args.DefaultValue;
                    this.Length = args.Length;
                    this.MaximumValue = args.MaximumValue;
                    this.MinimumValue = args.MinimumValue;
                    this.Mandatory = args.Mandatory;
                    this.EnumerationList = args.EnumerationList;
                    this.SQL = args.SQL;
                    this.ValidationPatternList = args.ValidationPatternList;
                }
                Property.Type = "Selcomm.Objects.Property";
                Property.TypeParameters = [];
                return Property;
            }());
            Objects.Property = Property;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var PropertyGroup = (function () {
                function PropertyGroup(args) {
                    this.$type = Selcomm.Objects.PropertyGroup.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Name = args.Name;
                }
                PropertyGroup.Type = "Selcomm.Objects.PropertyGroup";
                PropertyGroup.TypeParameters = [];
                return PropertyGroup;
            }());
            Objects.PropertyGroup = PropertyGroup;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var Enumeration = (function () {
                function Enumeration(args) {
                    this.$type = Selcomm.Objects.Enumeration.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Value = args.Value;
                    this.Name = args.Name;
                }
                Enumeration.Type = "Selcomm.Objects.Enumeration";
                Enumeration.TypeParameters = [];
                return Enumeration;
            }());
            Objects.Enumeration = Enumeration;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var ValidationPattern = (function () {
                function ValidationPattern(args) {
                    this.$type = Selcomm.Objects.ValidationPattern.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Sequence = args.Sequence;
                    this.RegularExpression = args.RegularExpression;
                    this.Message = args.Message;
                }
                ValidationPattern.Type = "Selcomm.Objects.ValidationPattern";
                ValidationPattern.TypeParameters = [];
                return ValidationPattern;
            }());
            Objects.ValidationPattern = ValidationPattern;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var BusinessObjectRelationship = (function () {
                function BusinessObjectRelationship(args) {
                    this.$type = Selcomm.Objects.BusinessObjectRelationship.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.MaximumChildren = args.MaximumChildren;
                    this.MinimumChildren = args.MinimumChildren;
                    this.ChildBusinessObject = args.ChildBusinessObject;
                }
                BusinessObjectRelationship.Type = "Selcomm.Objects.BusinessObjectRelationship";
                BusinessObjectRelationship.TypeParameters = [];
                return BusinessObjectRelationship;
            }());
            Objects.BusinessObjectRelationship = BusinessObjectRelationship;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var Method = (function () {
                function Method(args) {
                    this.$type = Selcomm.Objects.Method.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ObjectId = args.ObjectId;
                    this.Name = args.Name;
                    this.Note = args.Note;
                    this.ToolTip = args.ToolTip;
                    this.Label = args.Label;
                    this.AuthorisationToken = args.AuthorisationToken;
                }
                Method.Type = "Selcomm.Objects.Method";
                Method.TypeParameters = [];
                return Method;
            }());
            Objects.Method = Method;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ValueAddedServiceAddRequest = (function () {
                function ValueAddedServiceAddRequest(args) {
                    this.$type = Selcomm.Service.ValueAddedServiceAddRequest.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.RequestId = args.RequestId;
                    this.ScheduledDateTime = args.ScheduledDateTime;
                    this.Note = args.Note;
                    this.ValueAddedServiceCode = args.ValueAddedServiceCode;
                    this.DescriptionOverride = args.DescriptionOverride;
                    this.Price = args.Price;
                }
                ValueAddedServiceAddRequest.Type = "Selcomm.Service.ValueAddedServiceAddRequest";
                ValueAddedServiceAddRequest.TypeParameters = [];
                return ValueAddedServiceAddRequest;
            }());
            Service.ValueAddedServiceAddRequest = ValueAddedServiceAddRequest;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ValueAddedServiceDeleteRequest = (function () {
                function ValueAddedServiceDeleteRequest(args) {
                    this.$type = Selcomm.Service.ValueAddedServiceDeleteRequest.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.RequestId = args.RequestId;
                    this.ServiceReference = args.ServiceReference;
                    this.ScheduledDateTime = args.ScheduledDateTime;
                    this.ValueAddedServiceCode = args.ValueAddedServiceCode;
                }
                ValueAddedServiceDeleteRequest.Type = "Selcomm.Service.ValueAddedServiceDeleteRequest";
                ValueAddedServiceDeleteRequest.TypeParameters = [];
                return ValueAddedServiceDeleteRequest;
            }());
            Service.ValueAddedServiceDeleteRequest = ValueAddedServiceDeleteRequest;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Usage;
        (function (Usage) {
            var ClientServiceUsageGraphDisplayList = (function () {
                function ClientServiceUsageGraphDisplayList(args) {
                    this.$type = Selcomm.Usage.ClientServiceUsageGraphDisplayList.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ServiceUsage = args.ServiceUsage;
                    this.ServiceUsageType = args.ServiceUsageType;
                }
                ClientServiceUsageGraphDisplayList.Type = "Selcomm.Usage.ClientServiceUsageGraphDisplayList";
                ClientServiceUsageGraphDisplayList.TypeParameters = [];
                return ClientServiceUsageGraphDisplayList;
            }());
            Usage.ClientServiceUsageGraphDisplayList = ClientServiceUsageGraphDisplayList;
        })(Usage = Selcomm.Usage || (Selcomm.Usage = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Usage;
        (function (Usage) {
            var ServiceUsageGraphDisplay = (function (_super) {
                __extends(ServiceUsageGraphDisplay, _super);
                function ServiceUsageGraphDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Usage.ServiceUsageGraphDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceReference = args.ServiceReference;
                    _this.BillPeriod = args.BillPeriod;
                    _this.UsagePeriod = args.UsagePeriod;
                    _this.StartDate = args.StartDate;
                    _this.EndDate = args.EndDate;
                    _this.DiscountID = args.DiscountID;
                    _this.Narrative = args.Narrative;
                    _this.UsageNarrative = args.UsageNarrative;
                    _this.UnitNarrative = args.UnitNarrative;
                    _this.Type = args.Type;
                    _this.TotalAvailableAmount = args.TotalAvailableAmount;
                    _this.UsageTiers = args.UsageTiers;
                    _this.AmountUsedThisPeriod = args.AmountUsedThisPeriod;
                    _this.AmountUsedOtherPeriods = args.AmountUsedOtherPeriods;
                    _this.Unit = args.Unit;
                    return _this;
                }
                ServiceUsageGraphDisplay.Type = "Selcomm.Usage.ServiceUsageGraphDisplay";
                ServiceUsageGraphDisplay.TypeParameters = [];
                return ServiceUsageGraphDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Usage.ServiceUsageGraphDisplay = ServiceUsageGraphDisplay;
        })(Usage = Selcomm.Usage || (Selcomm.Usage = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Usage;
        (function (Usage) {
            var UsageGraphType;
            (function (UsageGraphType) {
                UsageGraphType[UsageGraphType["Bundled"] = 0] = "Bundled";
                UsageGraphType[UsageGraphType["Tiered"] = 1] = "Tiered";
            })(UsageGraphType = Usage.UsageGraphType || (Usage.UsageGraphType = {}));
        })(Usage = Selcomm.Usage || (Selcomm.Usage = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Usage;
        (function (Usage) {
            var NonDiscountedUsageDisplay = (function (_super) {
                __extends(NonDiscountedUsageDisplay, _super);
                function NonDiscountedUsageDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Usage.NonDiscountedUsageDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.PlanId = args.PlanId;
                    _this.UsagePeriod = args.UsagePeriod;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    _this.CallGroupCode = args.CallGroupCode;
                    _this.CallGroupDescription = args.CallGroupDescription;
                    _this.Amount = args.Amount;
                    _this.AmountTax = args.AmountTax;
                    _this.DiscountedAmount = args.DiscountedAmount;
                    _this.DiscountedAmountTax = args.DiscountedAmountTax;
                    _this.Count = args.Count;
                    _this.UnitQuantity = args.UnitQuantity;
                    _this.Unit = args.Unit;
                    _this.UnitDetails = args.UnitDetails;
                    return _this;
                }
                NonDiscountedUsageDisplay.Type = "Selcomm.Usage.NonDiscountedUsageDisplay";
                NonDiscountedUsageDisplay.TypeParameters = [];
                return NonDiscountedUsageDisplay;
            }(Selcomm.Objects.DataObject));
            Usage.NonDiscountedUsageDisplay = NonDiscountedUsageDisplay;
        })(Usage = Selcomm.Usage || (Selcomm.Usage = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Usage;
        (function (Usage) {
            var Unit = (function (_super) {
                __extends(Unit, _super);
                function Unit(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Usage.Unit.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.UnitCode = args.UnitCode;
                    _this.Description = args.Description;
                    _this.ShortDescription = args.ShortDescription;
                    _this.ShortPluralDescription = args.ShortPluralDescription;
                    _this.TypeDescription = args.TypeDescription;
                    return _this;
                }
                Unit.Type = "Selcomm.Usage.Unit";
                Unit.TypeParameters = [];
                return Unit;
            }(Selcomm.Objects.DataObject));
            Usage.Unit = Unit;
        })(Usage = Selcomm.Usage || (Selcomm.Usage = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceTypeDisplay = (function (_super) {
                __extends(ServiceTypeDisplay, _super);
                function ServiceTypeDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceTypeDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Code = args.Code;
                    _this.Narrative = args.Narrative;
                    return _this;
                }
                ServiceTypeDisplay.Type = "Selcomm.Service.ServiceTypeDisplay";
                ServiceTypeDisplay.TypeParameters = [];
                return ServiceTypeDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Service.ServiceTypeDisplay = ServiceTypeDisplay;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceNetworkStatus = (function () {
                function ServiceNetworkStatus(args) {
                    this.$type = Selcomm.Service.ServiceNetworkStatus.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Service = args.Service;
                    this.ExternalNetworkStatus = args.ExternalNetworkStatus;
                }
                ServiceNetworkStatus.Type = "Selcomm.Service.ServiceNetworkStatus";
                ServiceNetworkStatus.TypeParameters = [];
                return ServiceNetworkStatus;
            }());
            Service.ServiceNetworkStatus = ServiceNetworkStatus;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var ExternalNetworkStatus = (function () {
                function ExternalNetworkStatus(args) {
                    this.$type = Selcomm.Network.ExternalNetworkStatus.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Code = args.Code;
                    this.Status = args.Status;
                    this.Description = args.Description;
                    this.NetworkDescription = args.NetworkDescription;
                }
                ExternalNetworkStatus.Type = "Selcomm.Network.ExternalNetworkStatus";
                ExternalNetworkStatus.TypeParameters = [];
                return ExternalNetworkStatus;
            }());
            Network.ExternalNetworkStatus = ExternalNetworkStatus;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceNetworkPortStatus = (function () {
                function ServiceNetworkPortStatus(args) {
                    this.$type = Selcomm.Service.ServiceNetworkPortStatus.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Service = args.Service;
                    this.ExternalNetworkPortStatus = args.ExternalNetworkPortStatus;
                }
                ServiceNetworkPortStatus.Type = "Selcomm.Service.ServiceNetworkPortStatus";
                ServiceNetworkPortStatus.TypeParameters = [];
                return ServiceNetworkPortStatus;
            }());
            Service.ServiceNetworkPortStatus = ServiceNetworkPortStatus;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var ExternalNetworkPortStatus = (function () {
                function ExternalNetworkPortStatus(args) {
                    this.$type = Selcomm.Network.ExternalNetworkPortStatus.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Code = args.Code;
                    this.Status = args.Status;
                    this.Message = args.Message;
                    this.NameValueList = args.NameValueList;
                    this.Data = args.Data;
                    this.NetworkDescription = args.NetworkDescription;
                }
                ExternalNetworkPortStatus.Type = "Selcomm.Network.ExternalNetworkPortStatus";
                ExternalNetworkPortStatus.TypeParameters = [];
                return ExternalNetworkPortStatus;
            }());
            Network.ExternalNetworkPortStatus = ExternalNetworkPortStatus;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NameValue = (function () {
                function NameValue(args) {
                    this.$type = Selcomm.Network.NameValue.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.DisplayLabel = args.DisplayLabel;
                    this.Value = args.Value;
                }
                NameValue.Type = "Selcomm.Network.NameValue";
                NameValue.TypeParameters = [];
                return NameValue;
            }());
            Network.NameValue = NameValue;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceNetworkBalance = (function () {
                function ServiceNetworkBalance(args) {
                    this.$type = Selcomm.Service.ServiceNetworkBalance.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Service = args.Service;
                    this.ExternalNetworkBalance = args.ExternalNetworkBalance;
                }
                ServiceNetworkBalance.Type = "Selcomm.Service.ServiceNetworkBalance";
                ServiceNetworkBalance.TypeParameters = [];
                return ServiceNetworkBalance;
            }());
            Service.ServiceNetworkBalance = ServiceNetworkBalance;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var ExternalNetworkBalance = (function () {
                function ExternalNetworkBalance(args) {
                    this.$type = Selcomm.Network.ExternalNetworkBalance.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Data = args.Data;
                    this.NetworkDescription = args.NetworkDescription;
                    this.BalanceInfoItems = args.BalanceInfoItems;
                }
                ExternalNetworkBalance.Type = "Selcomm.Network.ExternalNetworkBalance";
                ExternalNetworkBalance.TypeParameters = [];
                return ExternalNetworkBalance;
            }());
            Network.ExternalNetworkBalance = ExternalNetworkBalance;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var ExternalNetworkBalanceItem = (function () {
                function ExternalNetworkBalanceItem(args) {
                    this.$type = Selcomm.Network.ExternalNetworkBalanceItem.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.DisplayLabel = args.DisplayLabel;
                    this.DisplayMajorValue = args.DisplayMajorValue;
                    this.DisplayOtherText = args.DisplayOtherText;
                }
                ExternalNetworkBalanceItem.Type = "Selcomm.Network.ExternalNetworkBalanceItem";
                ExternalNetworkBalanceItem.TypeParameters = [];
                return ExternalNetworkBalanceItem;
            }());
            Network.ExternalNetworkBalanceItem = ExternalNetworkBalanceItem;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkNotification = (function (_super) {
                __extends(NetworkNotification, _super);
                function NetworkNotification(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.NetworkNotification.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.NetworkTransactionTypeCode = args.NetworkTransactionTypeCode;
                    _this.NetworkTransactionType = args.NetworkTransactionType;
                    _this.NetworkTransactionStatus = args.NetworkTransactionStatus;
                    _this.NetworkTransactionDateTime = args.NetworkTransactionDateTime;
                    _this.ServiceReference = args.ServiceReference;
                    _this.NetworkTransactionFlowDirection = args.NetworkTransactionFlowDirection;
                    _this.NetworkNotificationItems = args.NetworkNotificationItems;
                    return _this;
                }
                NetworkNotification.Type = "Selcomm.Network.NetworkNotification";
                NetworkNotification.TypeParameters = [];
                return NetworkNotification;
            }(Selcomm.Objects.DataObject));
            Network.NetworkNotification = NetworkNotification;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkNotificationItem = (function (_super) {
                __extends(NetworkNotificationItem, _super);
                function NetworkNotificationItem(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.NetworkNotificationItem.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Attribute = args.Attribute;
                    _this.Value = args.Value;
                    return _this;
                }
                NetworkNotificationItem.Type = "Selcomm.Network.NetworkNotificationItem";
                NetworkNotificationItem.TypeParameters = [];
                return NetworkNotificationItem;
            }(Selcomm.Objects.DataObject));
            Network.NetworkNotificationItem = NetworkNotificationItem;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceSellOnRequest = (function () {
                function ServiceSellOnRequest(args) {
                    this.$type = Selcomm.Service.ServiceSellOnRequest.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceSellOnRequest.Type = "Selcomm.Service.ServiceSellOnRequest";
                ServiceSellOnRequest.TypeParameters = [];
                return ServiceSellOnRequest;
            }());
            Service.ServiceSellOnRequest = ServiceSellOnRequest;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var SimStatus;
            (function (SimStatus) {
                SimStatus[SimStatus["L"] = 0] = "L";
                SimStatus[SimStatus["E"] = 1] = "E";
                SimStatus[SimStatus["P"] = 2] = "P";
            })(SimStatus = Service.SimStatus || (Service.SimStatus = {}));
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var SimUsage = (function (_super) {
                __extends(SimUsage, _super);
                function SimUsage(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.SimUsage.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Sim = args.Sim;
                    _this.NetworkConnection = args.NetworkConnection;
                    _this.Service = args.Service;
                    _this.SimLinkStartDate = args.SimLinkStartDate;
                    _this.SimLinkEndDate = args.SimLinkEndDate;
                    _this.SimStatus = args.SimStatus;
                    _this.PhoneNumber = args.PhoneNumber;
                    _this.ConnectionDate = args.ConnectionDate;
                    return _this;
                }
                SimUsage.Type = "Selcomm.Service.SimUsage";
                SimUsage.TypeParameters = [];
                return SimUsage;
            }(Selcomm.Objects.DataObject));
            Service.SimUsage = SimUsage;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var Sim = (function (_super) {
                __extends(Sim, _super);
                function Sim(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.Sim.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.SimId = args.SimId;
                    _this.SimNumber = args.SimNumber;
                    _this.PUK = args.PUK;
                    _this.IMSI = args.IMSI;
                    _this.PIN = args.PIN;
                    _this.SimNarrative = args.SimNarrative;
                    _this.SimUsageList = args.SimUsageList;
                    return _this;
                }
                Sim.Type = "Selcomm.Service.Sim";
                Sim.TypeParameters = [];
                return Sim;
            }(Selcomm.Objects.DataObject));
            Service.Sim = Sim;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Network;
        (function (Network) {
            var NetworkConnection = (function (_super) {
                __extends(NetworkConnection, _super);
                function NetworkConnection(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Network.NetworkConnection.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Reference = args.Reference;
                    _this.PhoneNumber = args.PhoneNumber;
                    _this.ConnectionDate = args.ConnectionDate;
                    _this.DisconnectionDate = args.DisconnectionDate;
                    _this.EnquiryPassword = args.EnquiryPassword;
                    _this.MailBoxNumber = args.MailBoxNumber;
                    _this.SimUsageList = args.SimUsageList;
                    return _this;
                }
                NetworkConnection.Type = "Selcomm.Network.NetworkConnection";
                NetworkConnection.TypeParameters = [];
                return NetworkConnection;
            }(Selcomm.Objects.DataObject));
            Network.NetworkConnection = NetworkConnection;
        })(Network = Selcomm.Network || (Selcomm.Network = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceSubscriber = (function (_super) {
                __extends(ServiceSubscriber, _super);
                function ServiceSubscriber(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceSubscriber.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                ServiceSubscriber.Type = "Selcomm.Service.ServiceSubscriber";
                ServiceSubscriber.TypeParameters = [];
                return ServiceSubscriber;
            }(Selcomm.Contact.Contact));
            Service.ServiceSubscriber = ServiceSubscriber;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceSuspensionRequest = (function () {
                function ServiceSuspensionRequest(args) {
                    this.$type = Selcomm.Service.ServiceSuspensionRequest.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceSuspensionRequest.Type = "Selcomm.Service.ServiceSuspensionRequest";
                ServiceSuspensionRequest.TypeParameters = [];
                return ServiceSuspensionRequest;
            }());
            Service.ServiceSuspensionRequest = ServiceSuspensionRequest;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceDisconnectionRequest = (function (_super) {
                __extends(ServiceDisconnectionRequest, _super);
                function ServiceDisconnectionRequest(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceDisconnectionRequest.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServiceReference = args.ServiceReference;
                    _this.ScheduledDateTime = args.ScheduledDateTime;
                    _this.ReasonCode = args.ReasonCode;
                    _this.PayoutPenaltyOverrideAmount = args.PayoutPenaltyOverrideAmount;
                    _this.Note = args.Note;
                    _this.CloseNetworkEvent = args.CloseNetworkEvent;
                    _this.CloseAllOpenEvents = args.CloseAllOpenEvents;
                    _this.CreditFutureCharges = args.CreditFutureCharges;
                    _this.BillFutureChargesImmediately = args.BillFutureChargesImmediately;
                    _this.UseCurrentPackageForPayout = args.UseCurrentPackageForPayout;
                    _this.PackageCodeToUseForPayout = args.PackageCodeToUseForPayout;
                    _this.PackageOptionToUseForPayout = args.PackageOptionToUseForPayout;
                    return _this;
                }
                ServiceDisconnectionRequest.Type = "Selcomm.Service.ServiceDisconnectionRequest";
                ServiceDisconnectionRequest.TypeParameters = [];
                return ServiceDisconnectionRequest;
            }(Selcomm.Objects.DataObject));
            Service.ServiceDisconnectionRequest = ServiceDisconnectionRequest;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceSearchFilter = (function () {
                function ServiceSearchFilter(args) {
                    this.$type = Selcomm.Service.ServiceSearchFilter.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceSearchFilter.Type = "Selcomm.Service.ServiceSearchFilter";
                ServiceSearchFilter.TypeParameters = [];
                return ServiceSearchFilter;
            }());
            Service.ServiceSearchFilter = ServiceSearchFilter;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceBarRequest = (function (_super) {
                __extends(ServiceBarRequest, _super);
                function ServiceBarRequest(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceBarRequest.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.BarReference = args.BarReference;
                    _this.ReasonCode = args.ReasonCode;
                    _this.ServiceReference = args.ServiceReference;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.AccountNumber = args.AccountNumber;
                    _this.Note = args.Note;
                    _this.ActivateDate = args.ActivateDate;
                    _this.DeactivateDate = args.DeactivateDate;
                    _this.BulkApply = args.BulkApply;
                    _this.RequestID = args.RequestID;
                    _this.RequestDateTime = args.RequestDateTime;
                    return _this;
                }
                ServiceBarRequest.Type = "Selcomm.Service.ServiceBarRequest";
                ServiceBarRequest.TypeParameters = [];
                return ServiceBarRequest;
            }(Selcomm.Objects.DataObject));
            Service.ServiceBarRequest = ServiceBarRequest;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var BarUnBarBulkApply;
            (function (BarUnBarBulkApply) {
                BarUnBarBulkApply[BarUnBarBulkApply["N"] = 0] = "N";
                BarUnBarBulkApply[BarUnBarBulkApply["A"] = 1] = "A";
                BarUnBarBulkApply[BarUnBarBulkApply["T"] = 2] = "T";
                BarUnBarBulkApply[BarUnBarBulkApply["C"] = 3] = "C";
                BarUnBarBulkApply[BarUnBarBulkApply["S"] = 4] = "S";
            })(BarUnBarBulkApply = Service.BarUnBarBulkApply || (Service.BarUnBarBulkApply = {}));
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceBarResponse = (function () {
                function ServiceBarResponse(args) {
                    this.$type = Selcomm.Service.ServiceBarResponse.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Status = args.Status;
                    this.Message = args.Message;
                    this.Reference = args.Reference;
                    this.RequestID = args.RequestID;
                    this.ResponseDateTime = args.ResponseDateTime;
                    this.ServiceReference = args.ServiceReference;
                    this.ServiceNumber = args.ServiceNumber;
                    this.AccountNumber = args.AccountNumber;
                }
                ServiceBarResponse.Type = "Selcomm.Service.ServiceBarResponse";
                ServiceBarResponse.TypeParameters = [];
                return ServiceBarResponse;
            }());
            Service.ServiceBarResponse = ServiceBarResponse;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var BarAction;
            (function (BarAction) {
                BarAction[BarAction["BAR"] = 0] = "BAR";
                BarAction[BarAction["UNBAR"] = 1] = "UNBAR";
                BarAction[BarAction["ALL"] = 2] = "ALL";
            })(BarAction = Service.BarAction || (Service.BarAction = {}));
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceBarType = (function (_super) {
                __extends(ServiceBarType, _super);
                function ServiceBarType(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceBarType.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.EventType = args.EventType;
                    _this.EventCode = args.EventCode;
                    _this.EventNarrative = args.EventNarrative;
                    _this.HasOpenEvent = args.HasOpenEvent;
                    _this.EventReasonList = args.EventReasonList;
                    return _this;
                }
                ServiceBarType.Type = "Selcomm.Service.ServiceBarType";
                ServiceBarType.TypeParameters = [];
                return ServiceBarType;
            }(Selcomm.Objects.DataObject));
            Service.ServiceBarType = ServiceBarType;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceBar = (function (_super) {
                __extends(ServiceBar, _super);
                function ServiceBar(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceBar.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.EventReference = args.EventReference;
                    _this.ServiceReference = args.ServiceReference;
                    _this.EventType = args.EventType;
                    _this.EventCode = args.EventCode;
                    _this.ReasonCode = args.ReasonCode;
                    _this.ActivateDate = args.ActivateDate;
                    _this.DeactivateDate = args.DeactivateDate;
                    _this.Note = args.Note;
                    _this.SetBar = args.SetBar;
                    _this.BulkApply = args.BulkApply;
                    return _this;
                }
                ServiceBar.Type = "Selcomm.Service.ServiceBar";
                ServiceBar.TypeParameters = [];
                return ServiceBar;
            }(Selcomm.Objects.DataObject));
            Service.ServiceBar = ServiceBar;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceActionDisplay = (function (_super) {
                __extends(ServiceActionDisplay, _super);
                function ServiceActionDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceActionDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Reference = args.Reference;
                    _this.Narrative = args.Narrative;
                    _this.ActionCategory = args.ActionCategory;
                    _this.ServiceType = args.ServiceType;
                    _this.ServiceTypeDescription = args.ServiceTypeDescription;
                    _this.ActionSubCategory = args.ActionSubCategory;
                    _this.NetworkId = args.NetworkId;
                    _this.NetworkName = args.NetworkName;
                    _this.Reasons = args.Reasons;
                    return _this;
                }
                ServiceActionDisplay.Type = "Selcomm.Service.ServiceActionDisplay";
                ServiceActionDisplay.TypeParameters = [];
                return ServiceActionDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Service.ServiceActionDisplay = ServiceActionDisplay;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceActionCategoryType;
            (function (ServiceActionCategoryType) {
                ServiceActionCategoryType[ServiceActionCategoryType["NewService"] = 0] = "NewService";
                ServiceActionCategoryType[ServiceActionCategoryType["PortService"] = 1] = "PortService";
                ServiceActionCategoryType[ServiceActionCategoryType["BarService"] = 2] = "BarService";
                ServiceActionCategoryType[ServiceActionCategoryType["UnbarService"] = 3] = "UnbarService";
                ServiceActionCategoryType[ServiceActionCategoryType["BarUnbarService"] = 4] = "BarUnbarService";
                ServiceActionCategoryType[ServiceActionCategoryType["Sellon"] = 5] = "Sellon";
                ServiceActionCategoryType[ServiceActionCategoryType["ChangePackage"] = 6] = "ChangePackage";
                ServiceActionCategoryType[ServiceActionCategoryType["Disconnection"] = 7] = "Disconnection";
                ServiceActionCategoryType[ServiceActionCategoryType["ChangeServiceNarrative"] = 8] = "ChangeServiceNarrative";
                ServiceActionCategoryType[ServiceActionCategoryType["ChangeServicePassword"] = 9] = "ChangeServicePassword";
                ServiceActionCategoryType[ServiceActionCategoryType["ChangeSIM"] = 10] = "ChangeSIM";
            })(ServiceActionCategoryType = Service.ServiceActionCategoryType || (Service.ServiceActionCategoryType = {}));
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var AddressMoveRequest = (function () {
                function AddressMoveRequest(args) {
                    this.$type = Selcomm.Service.AddressMoveRequest.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ServiceReference = args.ServiceReference;
                    this.ScheduledDateTime = args.ScheduledDateTime;
                    this.NewAddressSimple = args.NewAddressSimple;
                    this.NewAddressExtended = args.NewAddressExtended;
                    this.ContactName = args.ContactName;
                    this.ContactPhone = args.ContactPhone;
                    this.PreferredBookingDateTime = args.PreferredBookingDateTime;
                    this.TransferValueAddedServices = args.TransferValueAddedServices;
                    this.AdditionalInformation1 = args.AdditionalInformation1;
                    this.AdditionalInformation2 = args.AdditionalInformation2;
                    this.AdditionalInformation3 = args.AdditionalInformation3;
                    this.AdditionalInformation4 = args.AdditionalInformation4;
                    this.AdditionalInformation5 = args.AdditionalInformation5;
                }
                AddressMoveRequest.Type = "Selcomm.Service.AddressMoveRequest";
                AddressMoveRequest.TypeParameters = [];
                return AddressMoveRequest;
            }());
            Service.AddressMoveRequest = AddressMoveRequest;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAutoBarLog = (function () {
                function ServiceAutoBarLog(args) {
                    this.$type = Selcomm.Service.ServiceAutoBarLog.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceAutoBarLog.Type = "Selcomm.Service.ServiceAutoBarLog";
                ServiceAutoBarLog.TypeParameters = [];
                return ServiceAutoBarLog;
            }());
            Service.ServiceAutoBarLog = ServiceAutoBarLog;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceAutoTopUpLog = (function () {
                function ServiceAutoTopUpLog(args) {
                    this.$type = Selcomm.Service.ServiceAutoTopUpLog.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceAutoTopUpLog.Type = "Selcomm.Service.ServiceAutoTopUpLog";
                ServiceAutoTopUpLog.TypeParameters = [];
                return ServiceAutoTopUpLog;
            }());
            Service.ServiceAutoTopUpLog = ServiceAutoTopUpLog;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceChannelPartner = (function () {
                function ServiceChannelPartner(args) {
                    this.$type = Selcomm.Service.ServiceChannelPartner.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceChannelPartner.Type = "Selcomm.Service.ServiceChannelPartner";
                ServiceChannelPartner.TypeParameters = [];
                return ServiceChannelPartner;
            }());
            Service.ServiceChannelPartner = ServiceChannelPartner;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceChannelPartnerCommissionPlan = (function () {
                function ServiceChannelPartnerCommissionPlan(args) {
                    this.$type = Selcomm.Service.ServiceChannelPartnerCommissionPlan.Type;
                    if (!args) {
                        return;
                    }
                    ;
                }
                ServiceChannelPartnerCommissionPlan.Type = "Selcomm.Service.ServiceChannelPartnerCommissionPlan";
                ServiceChannelPartnerCommissionPlan.TypeParameters = [];
                return ServiceChannelPartnerCommissionPlan;
            }());
            Service.ServiceChannelPartnerCommissionPlan = ServiceChannelPartnerCommissionPlan;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceCostCentre = (function () {
                function ServiceCostCentre(args) {
                    this.$type = Selcomm.Service.ServiceCostCentre.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Service = args.Service;
                    this.AssignedCostCenter = args.AssignedCostCenter;
                    this.StartDate = args.StartDate;
                    this.EndDate = args.EndDate;
                    this.StartBillPeriod = args.StartBillPeriod;
                    this.EndBillPeriod = args.EndBillPeriod;
                    this.Weighting = args.Weighting;
                    this.Comments = args.Comments;
                    this.LastUpdated = args.LastUpdated;
                    this.UpdatedBy = args.UpdatedBy;
                    this.Created = args.Created;
                    this.CreatedBy = args.CreatedBy;
                }
                ServiceCostCentre.Type = "Selcomm.Service.ServiceCostCentre";
                ServiceCostCentre.TypeParameters = [];
                return ServiceCostCentre;
            }());
            Service.ServiceCostCentre = ServiceCostCentre;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServiceDiscount = (function (_super) {
                __extends(ServiceDiscount, _super);
                function ServiceDiscount(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServiceDiscount.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ServicePlan = args.ServicePlan;
                    _this.Service = args.Service;
                    _this.Discount = args.Discount;
                    _this.StartDate = args.StartDate;
                    _this.EndDate = args.EndDate;
                    _this.Auto = args.Auto;
                    _this.BulkApply = args.BulkApply;
                    _this.ChildAccount = args.ChildAccount;
                    _this.SkipChecks = args.SkipChecks;
                    _this.SkipExistingError = args.SkipExistingError;
                    _this.AdjustDates = args.AdjustDates;
                    _this.ParentDiscountId = args.ParentDiscountId;
                    return _this;
                }
                ServiceDiscount.Type = "Selcomm.Service.ServiceDiscount";
                ServiceDiscount.TypeParameters = [];
                return ServiceDiscount;
            }(Selcomm.Objects.DataObject));
            Service.ServiceDiscount = ServiceDiscount;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Service;
        (function (Service) {
            var ServicePlan = (function (_super) {
                __extends(ServicePlan, _super);
                function ServicePlan(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Service.ServicePlan.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.ID = args.ID;
                    _this.Service = args.Service;
                    _this.Option = args.Option;
                    _this.Start = args.Start;
                    _this.Stop = args.Stop;
                    _this.EventSchedule = args.EventSchedule;
                    _this.ScheduleFlag = args.ScheduleFlag;
                    return _this;
                }
                ServicePlan.Type = "Selcomm.Service.ServicePlan";
                ServicePlan.TypeParameters = [];
                return ServicePlan;
            }(Selcomm.Objects.DataObject));
            Service.ServicePlan = ServicePlan;
        })(Service = Selcomm.Service || (Selcomm.Service = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Request;
        (function (Request) {
            var Response = (function () {
                function Response(args) {
                    this.$type = Selcomm.Request.Response.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Success = args.Success;
                    this.Code = args.Code;
                    this.Value = args.Value;
                }
                Response.Type = "Selcomm.Request.Response";
                Response.TypeParameters = [];
                return Response;
            }());
            Request.Response = Response;
        })(Request = Selcomm.Request || (Selcomm.Request = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Account;
        (function (Account) {
            var AccountBalance = (function (_super) {
                __extends(AccountBalance, _super);
                function AccountBalance(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Account.AccountBalance.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.AccountNumber = args.AccountNumber;
                    _this.EffectiveDate = args.EffectiveDate;
                    _this.Balance = args.Balance;
                    _this.DisputedAmount = args.DisputedAmount;
                    _this.PreAuthorisedAmount = args.PreAuthorisedAmount;
                    _this.UnbilledUsage = args.UnbilledUsage;
                    _this.UnbilledOneOffAndRecurringCharges = args.UnbilledOneOffAndRecurringCharges;
                    _this.UnbilledAmount = args.UnbilledAmount;
                    _this.MaximumPreAuthorisedDate = args.MaximumPreAuthorisedDate;
                    _this.Currency = args.Currency;
                    return _this;
                }
                AccountBalance.Type = "Selcomm.Account.AccountBalance";
                AccountBalance.TypeParameters = [];
                return AccountBalance;
            }(Selcomm.Objects.DataObject));
            Account.AccountBalance = AccountBalance;
        })(Account = Selcomm.Account || (Selcomm.Account = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Account;
        (function (Account) {
            var AccountAutomaticRechargeConfiguration = (function (_super) {
                __extends(AccountAutomaticRechargeConfiguration, _super);
                function AccountAutomaticRechargeConfiguration(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Account.AccountAutomaticRechargeConfiguration.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Reference = args.Reference;
                    _this.AccountNumber = args.AccountNumber;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    _this.Status = args.Status;
                    _this.DefaultRechargeAmount = args.DefaultRechargeAmount;
                    _this.TriggerBalance = args.TriggerBalance;
                    _this.RechargeAmountFixed = args.RechargeAmountFixed;
                    _this.Note = args.Note;
                    return _this;
                }
                AccountAutomaticRechargeConfiguration.Type = "Selcomm.Account.AccountAutomaticRechargeConfiguration";
                AccountAutomaticRechargeConfiguration.TypeParameters = [];
                return AccountAutomaticRechargeConfiguration;
            }(Selcomm.Objects.DataObject));
            Account.AccountAutomaticRechargeConfiguration = AccountAutomaticRechargeConfiguration;
        })(Account = Selcomm.Account || (Selcomm.Account = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Account;
        (function (Account) {
            var AutomaticRechargeConfigurationStatus;
            (function (AutomaticRechargeConfigurationStatus) {
                AutomaticRechargeConfigurationStatus[AutomaticRechargeConfigurationStatus["Active"] = 0] = "Active";
                AutomaticRechargeConfigurationStatus[AutomaticRechargeConfigurationStatus["Suspended"] = 1] = "Suspended";
                AutomaticRechargeConfigurationStatus[AutomaticRechargeConfigurationStatus["Cancelled"] = 10] = "Cancelled";
                AutomaticRechargeConfigurationStatus[AutomaticRechargeConfigurationStatus["Superceded"] = 20] = "Superceded";
            })(AutomaticRechargeConfigurationStatus = Account.AutomaticRechargeConfigurationStatus || (Account.AutomaticRechargeConfigurationStatus = {}));
        })(Account = Selcomm.Account || (Selcomm.Account = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Accounts;
        (function (Accounts) {
            var BalanceBucket = (function () {
                function BalanceBucket(args) {
                    this.$type = Selcomm.Accounts.BalanceBucket.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Code = args.Code;
                    this.Description = args.Description;
                    this.From = args.From;
                    this.To = args.To;
                    this.Amount = args.Amount;
                }
                BalanceBucket.Type = "Selcomm.Accounts.BalanceBucket";
                BalanceBucket.TypeParameters = [];
                return BalanceBucket;
            }());
            Accounts.BalanceBucket = BalanceBucket;
        })(Accounts = Selcomm.Accounts || (Selcomm.Accounts = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Accounts;
        (function (Accounts) {
            var BalanceSummary = (function () {
                function BalanceSummary(args) {
                    this.$type = Selcomm.Accounts.BalanceSummary.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.OverdueAmount = args.OverdueAmount;
                }
                BalanceSummary.Type = "Selcomm.Accounts.BalanceSummary";
                BalanceSummary.TypeParameters = [];
                return BalanceSummary;
            }());
            Accounts.BalanceSummary = BalanceSummary;
        })(Accounts = Selcomm.Accounts || (Selcomm.Accounts = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Session;
        (function (Session) {
            var NewSessionArguments = (function () {
                function NewSessionArguments(args) {
                    this.$type = Selcomm.Session.NewSessionArguments.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ProviderCode = args.ProviderCode;
                    this.UserCode = args.UserCode;
                    this.Password = args.Password;
                    this.EntryPoint = args.EntryPoint;
                    this.LoginMode = args.LoginMode;
                    this.ThemeId = args.ThemeId;
                    this.ThemeName = args.ThemeName;
                    this.SiteName = args.SiteName;
                }
                NewSessionArguments.Type = "Selcomm.Session.NewSessionArguments";
                NewSessionArguments.TypeParameters = [];
                return NewSessionArguments;
            }());
            Session.NewSessionArguments = NewSessionArguments;
        })(Session = Selcomm.Session || (Selcomm.Session = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Session;
        (function (Session) {
            var ClientSession = (function (_super) {
                __extends(ClientSession, _super);
                function ClientSession(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Session.ClientSession.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.SessionKey = args.SessionKey;
                    _this.UserCode = args.UserCode;
                    _this.UserName = args.UserName;
                    _this.CurrentContactCode = args.CurrentContactCode;
                    _this.CurrentContactName = args.CurrentContactName;
                    _this.RoleId = args.RoleId;
                    _this.RoleName = args.RoleName;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.BusinessUnitName = args.BusinessUnitName;
                    _this.ThemeId = args.ThemeId;
                    _this.ThemeName = args.ThemeName;
                    _this.SiteName = args.SiteName;
                    _this.EntryPoint = args.EntryPoint;
                    _this.LoginMode = args.LoginMode;
                    _this.CreditCardAgreement_HTML = args.CreditCardAgreement_HTML;
                    _this.DirectDebitAgreement_HTML = args.DirectDebitAgreement_HTML;
                    _this.EnableDirectDebitPaymentMethod = args.EnableDirectDebitPaymentMethod;
                    return _this;
                }
                ClientSession.Type = "Selcomm.Session.ClientSession";
                ClientSession.TypeParameters = [];
                return ClientSession;
            }(Selcomm.Objects.DataObject));
            Session.ClientSession = ClientSession;
        })(Session = Selcomm.Session || (Selcomm.Session = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SimType;
            (function (SimType) {
                SimType[SimType["Unspecified"] = 0] = "Unspecified";
                SimType[SimType["FullSize"] = 1] = "FullSize";
                SimType[SimType["Mini"] = 2] = "Mini";
                SimType[SimType["Micro"] = 3] = "Micro";
                SimType[SimType["Nano"] = 4] = "Nano";
                SimType[SimType["MiniMicro"] = 5] = "MiniMicro";
                SimType[SimType["MiniMicroNano"] = 6] = "MiniMicroNano";
                SimType[SimType["Embedded"] = 7] = "Embedded";
            })(SimType = SIM.SimType || (SIM.SimType = {}));
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Objects;
        (function (Objects) {
            var EnumDetails = (function () {
                function EnumDetails(args, $type) {
                    if (!args) {
                        return;
                    }
                    ;
                    this.Value = args.Value;
                    this.Label = args.Label;
                    this.PascalLabel = args.PascalLabel;
                    this.Description = args.Description;
                    this.$type = $type;
                }
                EnumDetails.TypeWith = function (TEnum) {
                    return Selcomm.Objects.EnumDetails.Type + "\u003c" + TEnum + "\u003e";
                };
                EnumDetails.Type = "Selcomm.Objects.EnumDetails";
                EnumDetails.TypeParameters = ["TEnum"];
                return EnumDetails;
            }());
            Objects.EnumDetails = EnumDetails;
        })(Objects = Selcomm.Objects || (Selcomm.Objects = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SimStatus;
            (function (SimStatus) {
                SimStatus[SimStatus["Unspecified"] = 0] = "Unspecified";
                SimStatus[SimStatus["Active"] = 1] = "Active";
                SimStatus[SimStatus["Inactive"] = 2] = "Inactive";
                SimStatus[SimStatus["Defective"] = 3] = "Defective";
                SimStatus[SimStatus["Alien"] = 4] = "Alien";
            })(SimStatus = SIM.SimStatus || (SIM.SimStatus = {}));
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var AccessPointNameStatus;
            (function (AccessPointNameStatus) {
                AccessPointNameStatus[AccessPointNameStatus["Active"] = 0] = "Active";
                AccessPointNameStatus[AccessPointNameStatus["InActive"] = 1] = "InActive";
            })(AccessPointNameStatus = SIM.AccessPointNameStatus || (SIM.AccessPointNameStatus = {}));
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SimBatchStatus;
            (function (SimBatchStatus) {
                SimBatchStatus[SimBatchStatus["Unspecified"] = 0] = "Unspecified";
                SimBatchStatus[SimBatchStatus["AddingSims"] = 1] = "AddingSims";
                SimBatchStatus[SimBatchStatus["Held"] = 2] = "Held";
                SimBatchStatus[SimBatchStatus["OnBoarding"] = 3] = "OnBoarding";
                SimBatchStatus[SimBatchStatus["Open"] = 4] = "Open";
                SimBatchStatus[SimBatchStatus["ReverseOnBoarding"] = 5] = "ReverseOnBoarding";
                SimBatchStatus[SimBatchStatus["Removed"] = 6] = "Removed";
                SimBatchStatus[SimBatchStatus["Cancelled"] = 7] = "Cancelled";
                SimBatchStatus[SimBatchStatus["InTransit"] = 8] = "InTransit";
                SimBatchStatus[SimBatchStatus["TransitRejected"] = 9] = "TransitRejected";
                SimBatchStatus[SimBatchStatus["TransitAccepted"] = 10] = "TransitAccepted";
                SimBatchStatus[SimBatchStatus["LostInTransit"] = 11] = "LostInTransit";
                SimBatchStatus[SimBatchStatus["Stolen"] = 12] = "Stolen";
            })(SimBatchStatus = SIM.SimBatchStatus || (SIM.SimBatchStatus = {}));
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var Sim = (function (_super) {
                __extends(Sim, _super);
                function Sim(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.SIM.Sim.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.SimType = args.SimType;
                    _this.SimStatus = args.SimStatus;
                    _this.Number = args.Number;
                    _this.PUK = args.PUK;
                    _this.PIN = args.PIN;
                    _this.IMSI = args.IMSI;
                    _this.Note = args.Note;
                    _this.ServiceNumber = args.ServiceNumber;
                    return _this;
                }
                Sim.Type = "Selcomm.SIM.Sim";
                Sim.TypeParameters = [];
                return Sim;
            }(Selcomm.Objects.DataObject));
            SIM.Sim = Sim;
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SIMReplacementValidationResponse = (function (_super) {
                __extends(SIMReplacementValidationResponse, _super);
                function SIMReplacementValidationResponse(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.SIM.SIMReplacementValidationResponse.Type;
                    if (!args) {
                        return _this;
                    }
                    _this.IsEligibleForReplacement = args.IsEligibleForReplacement;
                    _this.IsSIMReplacementRequested = args.IsSIMReplacementRequested;
                    _this.ErrorMessage = args.ErrorMessage;
                    return _this;
                }
                SIMReplacementValidationResponse.Type = "Selcomm.SIM.SIMReplacementValidationResponse";
                SIMReplacementValidationResponse.TypeParameters = [];
                return SIMReplacementValidationResponse;
            }(Selcomm.Objects.DataObject));
            SIM.SIMReplacementValidationResponse = SIMReplacementValidationResponse;
            var ServiceTypeCounter = (function (_super) {
                __extends(ServiceTypeCounter, _super);
                function ServiceTypeCounter(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.SIM.ServiceTypeCounter.Type;
                    if (!args) {
                        return _this;
                    }
                    _this.ServiceTypeCode = args.ServiceTypeCode;
                    _this.ServiceType = args.ServiceType;
                    _this.Count = args.Count;
                    return _this;
                }
                ServiceTypeCounter.Type = "Selcomm.SIM.ServiceTypeCounter";
                ServiceTypeCounter.TypeParameters = [];
                return ServiceTypeCounter;
            }(Selcomm.Objects.DataObject));
            SIM.ServiceTypeCounter = ServiceTypeCounter;
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SimChangeValidatorResponse = (function (_super) {
                __extends(SimChangeValidatorResponse, _super);
                function SimChangeValidatorResponse(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.SIM.SimChangeValidatorResponse.Type;
                    if (!args) {
                        _this.IsSimChangeAvailable = false;
                        return _this;
                    }
                    _this.SIMCaption = args.SIMCaption;
                    _this.PUKCaption = args.PUKCaption;
                    _this.IsPUKVisible = args.IsPUKVisible;
                    _this.IsSimChangeAvailable = args.IsSimChangeAvailable;
                    _this.SIMStartingNumber = args.SIMStartingNumber;
                    _this.SIMMaxLength = args.SIMMaxLength;
                    _this.IsBarVisible = args.IsBarVisible;
                    _this.BarEnabled = args.BarEnabled;
                    _this.BarValue = args.BarValue;
                    _this.IsCloseNetworkEventVisible = args.IsCloseNetworkEventVisible;
                    _this.CloseNetworkEventEnabled = args.CloseNetworkEventEnabled;
                    _this.CloseNetworkEventValue = args.CloseNetworkEventValue;
                    _this.MinDate = args.MinDate;
                    _this.MaxDate = args.MaxDate;
                    _this.Message = args.Message;
                    return _this;
                }
                SimChangeValidatorResponse.Type = "Selcomm.SIM.SimChangeValidatorResponse";
                SimChangeValidatorResponse.TypeParameters = [];
                return SimChangeValidatorResponse;
            }(Selcomm.Objects.DataObject));
            SIM.SimChangeValidatorResponse = SimChangeValidatorResponse;
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SimAccessPointName = (function (_super) {
                __extends(SimAccessPointName, _super);
                function SimAccessPointName(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.SIM.SimAccessPointName.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.AccessPointName = args.AccessPointName;
                    _this.Sim = args.Sim;
                    _this.StartDate = args.StartDate;
                    _this.EndDate = args.EndDate;
                    _this.AccessPointNameStatus = args.AccessPointNameStatus;
                    _this.Note = args.Note;
                    return _this;
                }
                SimAccessPointName.Type = "Selcomm.SIM.SimAccessPointName";
                SimAccessPointName.TypeParameters = [];
                return SimAccessPointName;
            }(Selcomm.Objects.DataObject));
            SIM.SimAccessPointName = SimAccessPointName;
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var AccessPointName = (function (_super) {
                __extends(AccessPointName, _super);
                function AccessPointName(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.SIM.AccessPointName.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.APN = args.APN;
                    _this.AccessPointNameStatus = args.AccessPointNameStatus;
                    _this.PrivateFlag = args.PrivateFlag;
                    _this.Note = args.Note;
                    return _this;
                }
                AccessPointName.Type = "Selcomm.SIM.AccessPointName";
                AccessPointName.TypeParameters = [];
                return AccessPointName;
            }(Selcomm.Objects.DataObject));
            SIM.AccessPointName = AccessPointName;
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SimBatch = (function (_super) {
                __extends(SimBatch, _super);
                function SimBatch(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.SIM.SimBatch.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.SimBatchType = args.SimBatchType;
                    _this.BusinessUnitCode = args.BusinessUnitCode;
                    _this.BatchDate = args.BatchDate;
                    _this.Number = args.Number;
                    _this.NetworkOperatorCode = args.NetworkOperatorCode;
                    _this.SimBatchStatus = args.SimBatchStatus;
                    _this.ContactCode = args.ContactCode;
                    _this.Note = args.Note;
                    return _this;
                }
                SimBatch.Type = "Selcomm.SIM.SimBatch";
                SimBatch.TypeParameters = [];
                return SimBatch;
            }(Selcomm.Objects.DataObject));
            SIM.SimBatch = SimBatch;
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SimBatchType;
            (function (SimBatchType) {
                SimBatchType[SimBatchType["Unspecified"] = 0] = "Unspecified";
                SimBatchType[SimBatchType["NetworkOnBoarding"] = 1] = "NetworkOnBoarding";
                SimBatchType[SimBatchType["CustomerTransfer"] = 2] = "CustomerTransfer";
                SimBatchType[SimBatchType["CustomerReturn"] = 3] = "CustomerReturn";
                SimBatchType[SimBatchType["NetworkReturn"] = 4] = "NetworkReturn";
                SimBatchType[SimBatchType["WarrantyReturn"] = 5] = "WarrantyReturn";
                SimBatchType[SimBatchType["Transfer"] = 6] = "Transfer";
                SimBatchType[SimBatchType["BusinessUnitTransfer"] = 7] = "BusinessUnitTransfer";
                SimBatchType[SimBatchType["NetworkAction"] = 8] = "NetworkAction";
            })(SimBatchType = SIM.SimBatchType || (SIM.SimBatchType = {}));
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SimBatchSim = (function (_super) {
                __extends(SimBatchSim, _super);
                function SimBatchSim(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.SIM.SimBatchSim.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.SimBatchId = args.SimBatchId;
                    _this.SimId = args.SimId;
                    return _this;
                }
                SimBatchSim.Type = "Selcomm.SIM.SimBatchSim";
                SimBatchSim.TypeParameters = [];
                return SimBatchSim;
            }(Selcomm.Objects.DataObject));
            SIM.SimBatchSim = SimBatchSim;
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var SIM;
        (function (SIM) {
            var SimContact = (function (_super) {
                __extends(SimContact, _super);
                function SimContact(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.SIM.SimContact.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.ContactRelationship = args.ContactRelationship;
                    _this.Contact = args.Contact;
                    _this.Sim = args.Sim;
                    _this.FromDate = args.FromDate;
                    _this.ToDate = args.ToDate;
                    return _this;
                }
                SimContact.Type = "Selcomm.SIM.SimContact";
                SimContact.TypeParameters = [];
                return SimContact;
            }(Selcomm.Objects.DataObject));
            SIM.SimContact = SimContact;
        })(SIM = Selcomm.SIM || (Selcomm.SIM = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var TaskDisplay = (function (_super) {
                __extends(TaskDisplay, _super);
                function TaskDisplay(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.TaskDisplay.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Type = args.Type;
                    _this.Number = args.Number;
                    _this.PriorityID = args.PriorityID;
                    _this.Priority = args.Priority;
                    _this.Description = args.Description;
                    _this.ContactCode = args.ContactCode;
                    _this.DependencyType = args.DependencyType;
                    _this.ContactName = args.ContactName;
                    _this.CategoryId = args.CategoryId;
                    _this.ServiceId = args.ServiceId;
                    _this.ServiceNumber = args.ServiceNumber;
                    _this.Status = args.Status;
                    _this.StatusId = args.StatusId;
                    _this.SystemStatusCode = args.SystemStatusCode;
                    _this.Completed = args.Completed;
                    _this.SLADate = args.SLADate;
                    _this.RequiredDate = args.RequiredDate;
                    _this.FollowUpDate = args.FollowUpDate;
                    return _this;
                }
                TaskDisplay.Type = "Selcomm.Task.TaskDisplay";
                TaskDisplay.TypeParameters = [];
                return TaskDisplay;
            }(Selcomm.Objects.DisplayBaseObject));
            Task.TaskDisplay = TaskDisplay;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var TaskDisplayList = (function (_super) {
                __extends(TaskDisplayList, _super);
                function TaskDisplayList(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.TaskDisplayList.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.TotalNumberOfRecords = args.TotalNumberOfRecords;
                    return _this;
                }
                TaskDisplayList.Type = "Selcomm.Task.TaskDisplayList";
                TaskDisplayList.TypeParameters = [];
                return TaskDisplayList;
            }(Selcomm.Objects.ExtendedDataList));
            Task.TaskDisplayList = TaskDisplayList;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var TaskTimeLog = (function (_super) {
                __extends(TaskTimeLog, _super);
                function TaskTimeLog(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.TaskTimeLog.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Id = args.Id;
                    _this.Task = args.Task;
                    _this.Contact = args.Contact;
                    _this.FromDate = args.FromDate;
                    _this.NumMinutes = args.NumMinutes;
                    _this.Chargeable = args.Chargeable;
                    _this.Note = args.Note;
                    _this.TotalNumberOfRecord = args.TotalNumberOfRecord;
                    return _this;
                }
                TaskTimeLog.Type = "Selcomm.Task.TaskTimeLog";
                TaskTimeLog.TypeParameters = [];
                return TaskTimeLog;
            }(Selcomm.Objects.DataObject));
            Task.TaskTimeLog = TaskTimeLog;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var Resource = (function (_super) {
                __extends(Resource, _super);
                function Resource(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.Resource.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Contact = args.Contact;
                    _this.Active = args.Active;
                    _this.Type = args.Type;
                    return _this;
                }
                Resource.Type = "Selcomm.Task.Resource";
                Resource.TypeParameters = [];
                return Resource;
            }(Selcomm.Objects.DataObject));
            Task.Resource = Resource;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var ResourceType;
            (function (ResourceType) {
                ResourceType[ResourceType["Internal"] = 0] = "Internal";
                ResourceType[ResourceType["External"] = 1] = "External";
                ResourceType[ResourceType["Customer"] = 2] = "Customer";
            })(ResourceType = Task.ResourceType || (Task.ResourceType = {}));
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Task;
        (function (Task) {
            var ResourceRelation = (function (_super) {
                __extends(ResourceRelation, _super);
                function ResourceRelation(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Task.ResourceRelation.Type;
                    if (!args) {
                        return _this;
                    }
                    ;
                    _this.Task = args.Task;
                    _this.Resource = args.Resource;
                    _this.FromDateTime = args.FromDateTime;
                    _this.ToDateTime = args.ToDateTime;
                    _this.LastNotified = args.LastNotified;
                    _this.NumberOfRecord = args.NumberOfRecord;
                    return _this;
                }
                ResourceRelation.Type = "Selcomm.Task.ResourceRelation";
                ResourceRelation.TypeParameters = [];
                return ResourceRelation;
            }(Selcomm.Objects.DataObject));
            Task.ResourceRelation = ResourceRelation;
        })(Task = Selcomm.Task || (Selcomm.Task = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var UI;
        (function (UI) {
            var UIElement = (function () {
                function UIElement(args) {
                    this.$type = Selcomm.UI.UIElement.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Name = args.Name;
                    this.TextItemList = args.TextItemList;
                    this.ImageItemList = args.ImageItemList;
                }
                UIElement.Type = "Selcomm.UI.UIElement";
                UIElement.TypeParameters = [];
                return UIElement;
            }());
            UI.UIElement = UIElement;
        })(UI = Selcomm.UI || (Selcomm.UI = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Content;
        (function (Content) {
            var TextItem = (function () {
                function TextItem(args) {
                    this.$type = Selcomm.Content.TextItem.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Label = args.Label;
                    this.Text = args.Text;
                    this.ToolTip = args.ToolTip;
                    this.HyperLinkAddress = args.HyperLinkAddress;
                    this.Position = args.Position;
                }
                TextItem.Type = "Selcomm.Content.TextItem";
                TextItem.TypeParameters = [];
                return TextItem;
            }());
            Content.TextItem = TextItem;
        })(Content = Selcomm.Content || (Selcomm.Content = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Content;
        (function (Content) {
            var Position = (function () {
                function Position(args) {
                    this.$type = Selcomm.Content.Position.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.XPosition = args.XPosition;
                    this.YPosition = args.YPosition;
                    this.Width = args.Width;
                    this.Height = args.Height;
                    this.ZOrder = args.ZOrder;
                }
                Position.Type = "Selcomm.Content.Position";
                Position.TypeParameters = [];
                return Position;
            }());
            Content.Position = Position;
        })(Content = Selcomm.Content || (Selcomm.Content = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Content;
        (function (Content) {
            var ImageItem = (function () {
                function ImageItem(args) {
                    this.$type = Selcomm.Content.ImageItem.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Id = args.Id;
                    this.Label = args.Label;
                    this.ToolTip = args.ToolTip;
                    this.HyperLinkAddress = args.HyperLinkAddress;
                    this.Position = args.Position;
                    this.ImageFile = args.ImageFile;
                    this.EmbeddedInTextItem = args.EmbeddedInTextItem;
                }
                ImageItem.Type = "Selcomm.Content.ImageItem";
                ImageItem.TypeParameters = [];
                return ImageItem;
            }());
            Content.ImageItem = ImageItem;
        })(Content = Selcomm.Content || (Selcomm.Content = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Configuration;
        (function (Configuration) {
            var ConfigurationEntry = (function () {
                function ConfigurationEntry(args) {
                    this.$type = Selcomm.Configuration.ConfigurationEntry.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Key = args.Key;
                    this.Value = args.Value;
                    this.Description = args.Description;
                    this.Area = args.Area;
                }
                ConfigurationEntry.Type = "Selcomm.Configuration.ConfigurationEntry";
                ConfigurationEntry.TypeParameters = [];
                return ConfigurationEntry;
            }());
            Configuration.ConfigurationEntry = ConfigurationEntry;
        })(Configuration = Selcomm.Configuration || (Selcomm.Configuration = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Validation;
        (function (Validation) {
            var StringValidationResult = (function () {
                function StringValidationResult(args) {
                    this.$type = Selcomm.Validation.StringValidationResult.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.ResultCode = args.ResultCode;
                    this.Result = args.Result;
                    this.ValidationMessage = args.ValidationMessage;
                    this.ValidationCategory = args.ValidationCategory;
                }
                StringValidationResult.Type = "Selcomm.Validation.StringValidationResult";
                StringValidationResult.TypeParameters = [];
                return StringValidationResult;
            }());
            Validation.StringValidationResult = StringValidationResult;
        })(Validation = Selcomm.Validation || (Selcomm.Validation = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Validation;
        (function (Validation) {
            var ValidationResults;
            (function (ValidationResults) {
                ValidationResults[ValidationResults["Error"] = 0] = "Error";
                ValidationResults[ValidationResults["Okay"] = 1] = "Okay";
                ValidationResults[ValidationResults["Warning"] = 2] = "Warning";
            })(ValidationResults = Validation.ValidationResults || (Validation.ValidationResults = {}));
        })(Validation = Selcomm.Validation || (Selcomm.Validation = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Authorisation;
        (function (Authorisation) {
            var AuthorisationException = (function (_super) {
                __extends(AuthorisationException, _super);
                function AuthorisationException(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Authorisation.AuthorisationException.Type;
                    Object.setPrototypeOf(_this, Selcomm.Authorisation.AuthorisationException.prototype);
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                AuthorisationException.Type = "Selcomm.Authorisation.AuthorisationException";
                AuthorisationException.TypeParameters = [];
                return AuthorisationException;
            }(System.Exception));
            Authorisation.AuthorisationException = AuthorisationException;
        })(Authorisation = Selcomm.Authorisation || (Selcomm.Authorisation = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Error;
        (function (Error) {
            var InvalidSessionKeyException = (function (_super) {
                __extends(InvalidSessionKeyException, _super);
                function InvalidSessionKeyException(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Error.InvalidSessionKeyException.Type;
                    Object.setPrototypeOf(_this, Selcomm.Error.InvalidSessionKeyException.prototype);
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                InvalidSessionKeyException.Type = "Selcomm.Error.InvalidSessionKeyException";
                InvalidSessionKeyException.TypeParameters = [];
                return InvalidSessionKeyException;
            }(System.ServiceModel.FaultException));
            Error.InvalidSessionKeyException = InvalidSessionKeyException;
        })(Error = Selcomm.Error || (Selcomm.Error = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Error;
        (function (Error) {
            var NoDataException = (function (_super) {
                __extends(NoDataException, _super);
                function NoDataException(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Error.NoDataException.Type;
                    Object.setPrototypeOf(_this, Selcomm.Error.NoDataException.prototype);
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                NoDataException.Type = "Selcomm.Error.NoDataException";
                NoDataException.TypeParameters = [];
                return NoDataException;
            }(System.Exception));
            Error.NoDataException = NoDataException;
        })(Error = Selcomm.Error || (Selcomm.Error = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Error;
        (function (Error) {
            var TooManyRecordsException = (function (_super) {
                __extends(TooManyRecordsException, _super);
                function TooManyRecordsException(args) {
                    var _this = _super.call(this, args) || this;
                    _this.$type = Selcomm.Error.TooManyRecordsException.Type;
                    Object.setPrototypeOf(_this, Selcomm.Error.TooManyRecordsException.prototype);
                    if (!args) {
                        return _this;
                    }
                    ;
                    return _this;
                }
                TooManyRecordsException.Type = "Selcomm.Error.TooManyRecordsException";
                TooManyRecordsException.TypeParameters = [];
                return TooManyRecordsException;
            }(System.Exception));
            Error.TooManyRecordsException = TooManyRecordsException;
        })(Error = Selcomm.Error || (Selcomm.Error = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
    (function (Selcomm) {
        var Error;
        (function (Error) {
            var SelcommFaultDetail = (function () {
                function SelcommFaultDetail(args) {
                    this.$type = Selcomm.Error.SelcommFaultDetail.Type;
                    if (!args) {
                        return;
                    }
                    ;
                    this.Type = args.Type;
                }
                SelcommFaultDetail.Type = "Selcomm.Error.SelcommFaultDetail";
                SelcommFaultDetail.TypeParameters = [];
                return SelcommFaultDetail;
            }());
            Error.SelcommFaultDetail = SelcommFaultDetail;
        })(Error = Selcomm.Error || (Selcomm.Error = {}));
    })(Selcomm = exports.Selcomm || (exports.Selcomm = {}));
});
define("app/selcomm/service-reference/service-client-request-api", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
define("app/selcomm/service-reference/service-client", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ServiceClientBase = (function () {
        function ServiceClientBase(proxy) {
            this.proxy = proxy;
        }
        return ServiceClientBase;
    }());
    exports.ServiceClientBase = ServiceClientBase;
    var Services = (function () {
        function Services(proxy) {
            this.Address = new SelcommWebService.IAddress.Client(proxy);
            this.Alert = new SelcommWebService.IAlert.Client(proxy);
            this.Attribute = new SelcommWebService.IAttribute.Client(proxy);
            this.Authentication = new SelcommWebService.IAuthentication.Client(proxy);
            this.Authorisation = new SelcommWebService.IAuthorisation.Client(proxy);
            this.Bill = new SelcommWebService.IBill.Client(proxy);
            this.BusinessUnit = new SelcommWebService.IBusinessUnit.Client(proxy);
            this.Charges = new SelcommWebService.ICharges.Client(proxy);
            this.Chart = new SelcommWebService.IChart.Client(proxy);
            this.Collection = new SelcommWebService.ICollection.Client(proxy);
            this.Configuration = new SelcommWebService.IConfiguration.Client(proxy);
            this.Contact = new SelcommWebService.IContact.Client(proxy);
            this.ContactPhone = new SelcommWebService.IContactPhone.Client(proxy);
            this.Contract = new SelcommWebService.IContract.Client(proxy);
            this.Correspondence = new SelcommWebService.ICorrespondence.Client(proxy);
            this.CostCentre = new SelcommWebService.ICostCentre.Client(proxy);
            this.CreditCheck = new SelcommWebService.ICreditCheck.Client(proxy);
            this.Customisation = new SelcommWebService.ICustomisation.Client(proxy);
            this.Dealer = new SelcommWebService.IDealer.Client(proxy);
            this.Device = new SelcommWebService.IDevice.Client(proxy);
            this.Document = new SelcommWebService.IDocument.Client(proxy);
            this.Email = new SelcommWebService.IEmail.Client(proxy);
            this.Error = new SelcommWebService.IError.Client(proxy);
            this.Event = new SelcommWebService.IEvent.Client(proxy);
            this.FeedBack = new SelcommWebService.IFeedBack.Client(proxy);
            this.Financial = new SelcommWebService.IFinancial.Client(proxy);
            this.GeneralLedger = new SelcommWebService.IGeneralLedger.Client(proxy);
            this.Hardware = new SelcommWebService.IHardware.Client(proxy);
            this.Inventory = new SelcommWebService.IInventory.Client(proxy);
            this.Invoice = new SelcommWebService.IInvoice.Client(proxy);
            this.Leads = new SelcommWebService.ILeads.Client(proxy);
            this.Library = new SelcommWebService.ILibrary.Client(proxy);
            this.Maps = new SelcommWebService.IMaps.Client(proxy);
            this.Menu = new SelcommWebService.IMenu.Client(proxy);
            this.Network = new SelcommWebService.INetwork.Client(proxy);
            this.News = new SelcommWebService.INews.Client(proxy);
            this.Opportunities = new SelcommWebService.IOpportunities.Client(proxy);
            this.OrderEntry = new SelcommWebService.IOrderEntry.Client(proxy);
            this.Order = new SelcommWebService.IOrder.Client(proxy);
            this.Packages = new SelcommWebService.IPackages.Client(proxy);
            this.Payment = new SelcommWebService.IPayment.Client(proxy);
            this.Products = new SelcommWebService.IProducts.Client(proxy);
            this.Recharge = new SelcommWebService.IRecharge.Client(proxy);
            this.Reports = new SelcommWebService.IReports.Client(proxy);
            this.Roles = new SelcommWebService.IRoles.Client(proxy);
            this.Service = new SelcommWebService.IService.Client(proxy);
            this.Account = new SelcommWebService.IAccount.Client(proxy);
            this.Session = new SelcommWebService.ISession.Client(proxy);
            this.SIM = new SelcommWebService.ISIM.Client(proxy);
            this.Status = new SelcommWebService.IStatus.Client(proxy);
            this.Task = new SelcommWebService.ITask.Client(proxy);
            this.Team = new SelcommWebService.ITeam.Client(proxy);
            this.Template = new SelcommWebService.ITemplate.Client(proxy);
            this.Threads = new SelcommWebService.IThreads.Client(proxy);
            this.UISupport = new SelcommWebService.IUISupport.Client(proxy);
            this.Usage = new SelcommWebService.IUsage.Client(proxy);
            this.Validation = new SelcommWebService.IValidation.Client(proxy);
        }
        return Services;
    }());
    exports.Services = Services;
    var SelcommWebService;
    (function (SelcommWebService) {
        var IAddress;
        (function (IAddress) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.AddressTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "AddressTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.GetAddressTypeCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "GetAddressTypeCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AddressNarrative=" + this.proxy.FormatUriArgument(args.AddressNarrative) + "", args);
                };
                Client.prototype.AddressType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "AddressType/" + this.proxy.FormatUriArgument(args.SessionKey) + "/" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.AddressTypeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "AddressTypeAdd", args);
                };
                Client.prototype.AddressTypeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "AddressTypeUpdate", args);
                };
                Client.prototype.AddressTypeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAddress", "AddressTypeDelete/" + this.proxy.FormatUriArgument(args.SessionKey) + "/" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.AddressUsageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "AddressUsageList/" + this.proxy.FormatUriArgument(args.SessionKey) + "/" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AddressByContactCodeAndAddressType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "AddressByContactCodeAndAddressType/" + this.proxy.FormatUriArgument(args.SessionKey) + "/" + this.proxy.FormatUriArgument(args.ContactCode) + "/" + this.proxy.FormatUriArgument(args.AddressType) + "", args);
                };
                Client.prototype.Address = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "Address/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.AddressAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "AddressAdd", args);
                };
                Client.prototype.AddressAddByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "AddressAddByContact?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AddressAddByContactSimple = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "AddressAddByContactSimple?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AddressUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "AddressUpdate", args);
                };
                Client.prototype.AddressUpdateByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "AddressUpdateByContact?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AddressUpdateByAddressTypes = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "AddressUpdateByAddressTypes?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AddressDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAddress", "AddressDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.AddressDeleteByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "AddressDeleteByContact?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AddressList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "AddressList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ExtendedAddressList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "ExtendedAddressList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ExtendedAddress = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "ExtendedAddress/" + this.proxy.FormatUriArgument(args.SessionKey) + "/" + this.proxy.FormatUriArgument(args.AddressTypeCode) + "/" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ExtendedAddressAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "ExtendedAddressAdd", args);
                };
                Client.prototype.ExtendedAddressUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "ExtendedAddressUpdate", args);
                };
                Client.prototype.ExtendedAddressUpdateList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "ExtendedAddressUpdateList", args);
                };
                Client.prototype.ExtendedAddressDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAddress", "ExtendedAddressDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.UnitTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "UnitTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.UnitType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "UnitType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.UnitTypeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "UnitTypeAdd", args);
                };
                Client.prototype.UnitTypeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "UnitTypeUpdate", args);
                };
                Client.prototype.UnitTypeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAddress", "UnitTypeDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.StreetTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "StreetTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.StreetType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "StreetType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.StreetTypeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "StreetTypeAdd", args);
                };
                Client.prototype.StreetTypeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "StreetTypeUpdate", args);
                };
                Client.prototype.StreetTypeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAddress", "StreetTypeDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.PostCodeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "PostCodeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PostCodeListByState = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "PostCodeListByState/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026StateCode=" + this.proxy.FormatUriArgument(args.StateCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PostCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "PostCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.PostCodeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "PostCodeAdd", args);
                };
                Client.prototype.PostCodeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "PostCodeUpdate", args);
                };
                Client.prototype.PostCodeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAddress", "PostCodeDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.LocalityList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "LocalityList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.LocalityListByPostCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "LocalityListByPostCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PostCode=" + this.proxy.FormatUriArgument(args.PostCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.Locality = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "Locality/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.LocalityAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "LocalityAdd", args);
                };
                Client.prototype.LocalityUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "LocalityUpdate", args);
                };
                Client.prototype.LocalityDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAddress", "LocalityDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.StateList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "StateList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.StateListByCountry = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "StateListByCountry/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CountryCode=" + this.proxy.FormatUriArgument(args.CountryCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.StateListByPostCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "StateListByPostCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PostCode=" + this.proxy.FormatUriArgument(args.PostCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.StateListByPostCodeLocality = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "StateListByPostCodeLocality/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PostCode=" + this.proxy.FormatUriArgument(args.PostCode) + "\u0026Locality=" + this.proxy.FormatUriArgument(args.Locality) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.State = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "State/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.StateAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "StateAdd", args);
                };
                Client.prototype.StateUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "StateUpdate", args);
                };
                Client.prototype.StateDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAddress", "StateDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.CountryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "CountryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.Country = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "Country/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.CountryAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "CountryAdd", args);
                };
                Client.prototype.CountryUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAddress", "CountryUpdate", args);
                };
                Client.prototype.CountryDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAddress", "CountryDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.AutoComplete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAddress", "AutoComplete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PartialAddress=" + this.proxy.FormatUriArgument(args.PartialAddress) + "\u0026MaximumResultCount=" + this.proxy.FormatUriArgument(args.MaximumResultCount) + "", args);
                };
                Client.prototype.ParseSimpleAddress = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAddress", "ParseSimpleAddress", args);
                };
                return Client;
            }(ServiceClientBase));
            IAddress.Client = Client;
        })(IAddress = SelcommWebService.IAddress || (SelcommWebService.IAddress = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IAlert;
        (function (IAlert) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.SpendAlert = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAlert", "SpendAlert/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026ServiceRef=" + this.proxy.FormatUriArgument(args.ServiceRef) + "", args);
                };
                Client.prototype.SpendAlertUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAlert", "SpendAlertUpdate", args);
                };
                return Client;
            }(ServiceClientBase));
            IAlert.Client = Client;
        })(IAlert = SelcommWebService.IAlert || (SelcommWebService.IAlert = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IAttribute;
        (function (IAttribute) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.AttributeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAttribute", "AttributeAdd", args);
                };
                Client.prototype.AttributeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAttribute", "AttributeUpdate", args);
                };
                Client.prototype.AttributeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAttribute", "AttributeDelete/?SessionId=" + this.proxy.FormatUriArgument(args.SessionId) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.Attribute = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAttribute", "Attribute/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.AttributeListByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAttribute", "AttributeListByContact/?sessionKey=" + this.proxy.FormatUriArgument(args.sessionKey) + "\u0026contactCode=" + this.proxy.FormatUriArgument(args.contactCode) + "", args);
                };
                Client.prototype.AttributeListByEvent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAttribute", "AttributeListByEvent/?sessionKey=" + this.proxy.FormatUriArgument(args.sessionKey) + "\u0026eventReference=" + this.proxy.FormatUriArgument(args.eventReference) + "", args);
                };
                Client.prototype.AttributeListByPackage = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAttribute", "AttributeListByPackage/?sessionKey=" + this.proxy.FormatUriArgument(args.sessionKey) + "\u0026packageCode=" + this.proxy.FormatUriArgument(args.packageCode) + "", args);
                };
                Client.prototype.AttributeListByEventAndService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAttribute", "AttributeListByEventAndService/?sessionKey=" + this.proxy.FormatUriArgument(args.sessionKey) + "\u0026eventReference=" + this.proxy.FormatUriArgument(args.eventReference) + "\u0026serviceReference=" + this.proxy.FormatUriArgument(args.serviceReference) + "", args);
                };
                Client.prototype.AttributeTemplateList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAttribute", "AttributeTemplateList", args);
                };
                Client.prototype.AttributeTemplateListByEvent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAttribute", "AttributeTemplateListByEvent", args);
                };
                return Client;
            }(ServiceClientBase));
            IAttribute.Client = Client;
        })(IAttribute = SelcommWebService.IAttribute || (SelcommWebService.IAttribute = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IAuthentication;
        (function (IAuthentication) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.AuthenticateSimpleCreateSessionAndAuthenticateContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAuthentication", "AuthenticateSimpleCreateSessionAndAuthenticateContact", args);
                };
                return Client;
            }(ServiceClientBase));
            IAuthentication.Client = Client;
        })(IAuthentication = SelcommWebService.IAuthentication || (SelcommWebService.IAuthentication = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IAuthorisation;
        (function (IAuthorisation) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.AuthorisationObjectTokenListByRole = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAuthorisation", "AuthorisationObjectTokenListByRole/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ObjectId=" + this.proxy.FormatUriArgument(args.ObjectId) + "", args);
                };
                Client.prototype.AuthorisationObjectTokenByRole = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAuthorisation", "AuthorisationObjectTokenByRole/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ObjectId=" + this.proxy.FormatUriArgument(args.ObjectId) + "", args);
                };
                Client.prototype.AuthoriseBusinessUnit = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAuthorisation", "AuthoriseBusinessUnit/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.AuthoriseRole = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAuthorisation", "AuthoriseRole/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RoleId=" + this.proxy.FormatUriArgument(args.RoleId) + "", args);
                };
                Client.prototype.AuthoriseContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAuthorisation", "AuthoriseContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AuthoriseService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAuthorisation", "AuthoriseService/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IAuthorisation.Client = Client;
        })(IAuthorisation = SelcommWebService.IAuthorisation || (SelcommWebService.IAuthorisation = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IBill;
        (function (IBill) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.BillList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IBill", "BillList", args);
                };
                Client.prototype.BillFile = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillFile/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026BillNumber=" + this.proxy.FormatUriArgument(args.BillNumber) + "\u0026BillType=" + this.proxy.FormatUriArgument(args.BillType) + "", args);
                };
                Client.prototype.BillSummaryItemList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillSummaryItemList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "", args);
                };
                Client.prototype.UsageTransactionDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IBill", "UsageTransactionDisplayList", args);
                };
                Client.prototype.UsageTransactionDisplayListAll = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "UsageTransactionDisplayListAll/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "", args);
                };
                Client.prototype.UsageTransactionDisplayListByPrice = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IBill", "UsageTransactionDisplayListByPrice", args);
                };
                Client.prototype.ChargeDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "ChargeDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.ChargeDisplayListWithSearchAndSort = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IBill", "ChargeDisplayListWithSearchAndSort", args);
                };
                Client.prototype.ChargeDisplayListAll = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "ChargeDisplayListAll/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "", args);
                };
                Client.prototype.ChargeDisplayListByPrice = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "ChargeDisplayListByPrice/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.BillSummaryByServiceTypeItemList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillSummaryByServiceTypeItemList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "\u0026SearchTerm=" + this.proxy.FormatUriArgument(args.SearchTerm) + "\u0026SortBy=" + this.proxy.FormatUriArgument(args.SortBy) + "\u0026SortOrder=" + this.proxy.FormatUriArgument(args.SortOrder) + "", args);
                };
                Client.prototype.BillSummaryByServiceItemList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillSummaryByServiceItemList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.BillSummaryByServiceItemListSearchAndSort = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillSummaryByServiceItemListSearchAndSort/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026SearchTerm=" + this.proxy.FormatUriArgument(args.SearchTerm) + "\u0026SortBy=" + this.proxy.FormatUriArgument(args.SortBy) + "\u0026SortOrder=" + this.proxy.FormatUriArgument(args.SortOrder) + "", args);
                };
                Client.prototype.BillSummaryByServiceItemListAll = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillSummaryByServiceItemListAll/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "", args);
                };
                Client.prototype.BillPeriodByDebtor = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillPeriodByDebtor/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026DebtorCode=" + this.proxy.FormatUriArgument(args.DebtorCode) + "", args);
                };
                Client.prototype.BillPeriodRecentByDebtor = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillPeriodRecentByDebtor/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026DebtorCode=" + this.proxy.FormatUriArgument(args.DebtorCode) + "\u0026NumberOfPreviousBillPeriod=" + this.proxy.FormatUriArgument(args.NumberOfPreviousBillPeriod) + "", args);
                };
                Client.prototype.BillServiceSummaryItemListList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IBill", "BillServiceSummaryItemListList", args);
                };
                Client.prototype.BillPeriodCurrent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillPeriodCurrent/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.BillCycle = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillCycle/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.BillCycleAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IBill", "BillCycleAdd", args);
                };
                Client.prototype.BillCycleUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IBill", "BillCycleUpdate", args);
                };
                Client.prototype.BillCycleDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillCycleDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.BillCycleList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillCycleList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026ShowHidden=" + this.proxy.FormatUriArgument(args.ShowHidden) + "", args);
                };
                Client.prototype.BillTotalSummary = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBill", "BillTotalSummary/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillRef=" + this.proxy.FormatUriArgument(args.BillRef) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IBill.Client = Client;
        })(IBill = SelcommWebService.IBill || (SelcommWebService.IBill = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IBusinessUnit;
        (function (IBusinessUnit) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.BusinessUnitList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBusinessUnit", "BusinessUnitList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.Authorise = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBusinessUnit", "Authorise/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.BusinessUnit = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBusinessUnit", "BusinessUnit/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.BusinessUnitLogo = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBusinessUnit", "BusinessUnitLogo/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.CustomerCareDetails = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBusinessUnit", "CustomerCareDetails/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.AllCustomerCareDetails = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IBusinessUnit", "AllCustomerCareDetails/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IBusinessUnit.Client = Client;
        })(IBusinessUnit = SelcommWebService.IBusinessUnit || (SelcommWebService.IBusinessUnit = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ICharges;
        (function (ICharges) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.ChargeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ICharges", "ChargeAdd", args);
                };
                Client.prototype.ChargeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ICharges", "ChargeUpdate", args);
                };
                Client.prototype.ChargeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ICharges", "ChargeDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.Charge = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICharges", "Charge/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ChargeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICharges", "ChargeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ICharges.Client = Client;
        })(ICharges = SelcommWebService.ICharges || (SelcommWebService.ICharges = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IChart;
        (function (IChart) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.BillSeries = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IChart", "BillSeries/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026StartDate=" + this.proxy.FormatUriArgument(args.StartDate) + "\u0026NumberOfMonths=" + this.proxy.FormatUriArgument(args.NumberOfMonths) + "", args);
                };
                Client.prototype.BillSeriesLastThreeMonths = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IChart", "BillSeriesLastThreeMonths/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.BillSeriesLastTwelveMonths = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IChart", "BillSeriesLastTwelveMonths/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.BillSeriesChargesByServiceTypeLastThreeBills = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IChart", "BillSeriesChargesByServiceTypeLastThreeBills/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IChart.Client = Client;
        })(IChart = SelcommWebService.IChart || (SelcommWebService.IChart = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ICollection;
        (function (ICollection) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.CollectionPlanList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICollection", "CollectionPlanList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.CollectionPlanListSpecific = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICollection", "CollectionPlanListSpecific/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026Option=" + this.proxy.FormatUriArgument(args.Option) + "\u0026CustomerType=" + this.proxy.FormatUriArgument(args.CustomerType) + "\u0026PaymentTypeCode=" + this.proxy.FormatUriArgument(args.PaymentTypeCode) + "", args);
                };
                Client.prototype.CollectionPlanListWithPackageCredit = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICollection", "CollectionPlanList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ICollection.Client = Client;
        })(ICollection = SelcommWebService.ICollection || (SelcommWebService.ICollection = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IConfiguration;
        (function (IConfiguration) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.GetConfigValue = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IConfiguration", "GetConfigValue", args);
                };
                Client.prototype.Autonumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IConfiguration", "Autonumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AutoNumberCode=" + this.proxy.FormatUriArgument(args.AutoNumberCode) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IConfiguration.Client = Client;
        })(IConfiguration = SelcommWebService.IConfiguration || (SelcommWebService.IConfiguration = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IContact;
        (function (IContact) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.BillFileLoad = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "BillFileLoad/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026BillNumber=" + this.proxy.FormatUriArgument(args.BillNumber) + "\u0026BillType=" + this.proxy.FormatUriArgument(args.BillType) + "", args);
                };
                Client.prototype.ContactCodeConfirm = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactCodeConfirm/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.Contact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "Contact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026LoadAddress=" + this.proxy.FormatUriArgument(args.LoadAddress) + "\u0026LoadContactPhones=" + this.proxy.FormatUriArgument(args.LoadContactPhones) + "\u0026LoadContactEmailAddresses=" + this.proxy.FormatUriArgument(args.LoadContactEmailAddresses) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContactPrimary = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactPrimary/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026LoadAddress=" + this.proxy.FormatUriArgument(args.LoadAddress) + "\u0026LoadContactPhones=" + this.proxy.FormatUriArgument(args.LoadContactPhones) + "\u0026LoadContactEmailAddresses=" + this.proxy.FormatUriArgument(args.LoadContactEmailAddresses) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "TypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.Authenticate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "Authenticate?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026LoginCode=" + this.proxy.FormatUriArgument(args.LoginCode) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026ResetPasswordUrl=" + this.proxy.FormatUriArgument(args.ResetPasswordUrl) + "\u0026IP_Address=" + this.proxy.FormatUriArgument(args.IP_Address) + "\u0026TfaCode=" + this.proxy.FormatUriArgument(args.TfaCode) + "", args);
                };
                Client.prototype.AuthenticateByObject = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "AuthenticateByObject/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026LoginCode=" + this.proxy.FormatUriArgument(args.LoginCode) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026ObjectId=" + this.proxy.FormatUriArgument(args.ObjectId) + "", args);
                };
                Client.prototype.Get2faVerificationCodeSendOptionsAndInfoLink = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "Get2faVerificationCodeSendOptionsAndInfoLink?LoginCode=" + this.proxy.FormatUriArgument(args.LoginCode) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026ProviderKey=" + this.proxy.FormatUriArgument(args.ProviderKey) + "\u0026SiteName=" + this.proxy.FormatUriArgument(args.SiteName) + "", args);
                };
                Client.prototype.SendLogin2faVerificationCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "SendLogin2faVerificationCode?LoginCode=" + this.proxy.FormatUriArgument(args.LoginCode) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026ProviderKey=" + this.proxy.FormatUriArgument(args.ProviderKey) + "\u0026SiteName=" + this.proxy.FormatUriArgument(args.SiteName) + "\u0026BySms=" + this.proxy.FormatUriArgument(args.BySms) + "", args);
                };
                Client.prototype.Login = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "Login/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026LoginCode=" + this.proxy.FormatUriArgument(args.LoginCode) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "", args);
                };
                Client.prototype.LoginByPIN = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "LoginByPIN/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026LoginCode=" + this.proxy.FormatUriArgument(args.LoginCode) + "\u0026PIN=" + this.proxy.FormatUriArgument(args.PIN) + "", args);
                };
                Client.prototype.IsLoginBlocked = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "IsLoginBlocked/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.LoginByBillNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "LoginByBillNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026LoginCode=" + this.proxy.FormatUriArgument(args.LoginCode) + "\u0026BillNumber=" + this.proxy.FormatUriArgument(args.BillNumber) + "", args);
                };
                Client.prototype.FirstLogin = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "FirstLogin/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.Logout = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "Logout/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.SecretQuestionAndAnswerList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "SecretQuestionAndAnswerList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.SecretQuestionAnswerConfirm = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "SecretQuestionAnswerConfirm/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026SecretAnswer=" + this.proxy.FormatUriArgument(args.SecretAnswer) + "", args);
                };
                Client.prototype.SecretQuestion = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "SecretQuestion/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.PasswordExists = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "PasswordExists/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.GetContactStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "GetContactStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ContactSessionAuthorise = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactSessionAuthorise/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.PersonalNameUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "PersonalNameUpdate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026FirstName=" + this.proxy.FormatUriArgument(args.FirstName) + "\u0026LastName=" + this.proxy.FormatUriArgument(args.LastName) + "", args);
                };
                Client.prototype.BusinessNameUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "BusinessNameUpdate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026BusinessName=" + this.proxy.FormatUriArgument(args.BusinessName) + "", args);
                };
                Client.prototype.EmailUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "EmailUpdate", args);
                };
                Client.prototype.AuthorisedAccountList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "AuthorisedAccountList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AuthorisedAccountDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "AuthorisedAccountDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.RoleListByAuthorisedAccountRelationship = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "RoleListByAuthorisedAccountRelationship/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountCode=" + this.proxy.FormatUriArgument(args.AccountCode) + "\u0026RelationshipCode=" + this.proxy.FormatUriArgument(args.RelationshipCode) + "", args);
                };
                Client.prototype.DisplayDetailsUIAttributeItemList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "DisplayDetailsUIAttributeItemList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ContactDisplay = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactDisplay/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ContactDisplayListLoad = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactDisplayListLoad?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026SearchString=" + this.proxy.FormatUriArgument(args.SearchString) + "\u0026LimitTo=" + this.proxy.FormatUriArgument(args.LimitTo) + "", args);
                };
                Client.prototype.ContactSearch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactSearch?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026SearchString=" + this.proxy.FormatUriArgument(args.SearchString) + "\u0026Skip=" + this.proxy.FormatUriArgument(args.Skip) + "\u0026Take=" + this.proxy.FormatUriArgument(args.Take) + "", args);
                };
                Client.prototype.NewsLetterSubscribe = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "NewsLetterSubscribe/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.NewsLetterEmailAddressChange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "NewsLetterEmailAddressChange/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026EmailAddress=" + this.proxy.FormatUriArgument(args.EmailAddress) + "", args);
                };
                Client.prototype.MarketingNoticesSMSSubscribe = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "MarketingNoticesSMSSubscribe/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.MarketingNoticesSMSServiceNumberChange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "MarketingNoticesSMSServiceNumberChange/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026ServiceNumber=" + this.proxy.FormatUriArgument(args.ServiceNumber) + "", args);
                };
                Client.prototype.PasswordUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "PasswordUpdate", args);
                };
                Client.prototype.PINUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "PINUpdate", args);
                };
                Client.prototype.PasswordGenerateAndUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "PasswordGenerateAndUpdate", args);
                };
                Client.prototype.PINGenerateAndUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "PINGenerateAndUpdate", args);
                };
                Client.prototype.PasswordByCodeAndEmail = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "PasswordByCodeAndEmail/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026EmailAddress=" + this.proxy.FormatUriArgument(args.EmailAddress) + "", args);
                };
                Client.prototype.PasswordAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "PasswordAdd", args);
                };
                Client.prototype.RolesList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "RolesList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AuthorisationForObject = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "AuthorisationForObject/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ObjectId=" + this.proxy.FormatUriArgument(args.ObjectId) + "", args);
                };
                Client.prototype.ContactPhoneList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactPhoneList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ContactPhone = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactPhone/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PhoneTypeCode=" + this.proxy.FormatUriArgument(args.PhoneTypeCode) + "", args);
                };
                Client.prototype.ContactPhoneAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "ContactPhoneAdd", args);
                };
                Client.prototype.ContactPhoneUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "ContactPhoneUpdate", args);
                };
                Client.prototype.ContactPhoneDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IContact", "ContactPhoneDelete", args);
                };
                Client.prototype.EmailSend = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "EmailSend", args);
                };
                Client.prototype.DefaultEmailAddress = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "DefaultEmailAddress/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.BusinessUnitList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "BusinessUnitList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.DocumentDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "DocumentDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026Library=" + this.proxy.FormatUriArgument(args.Library) + "", args);
                };
                Client.prototype.Document = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "Document/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.DocumentAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "DocumentAdd", args);
                };
                Client.prototype.DocumentUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "DocumentUpdate", args);
                };
                Client.prototype.DocumentDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IContact", "DocumentDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.DocumentValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "DocumentValidate", args);
                };
                Client.prototype.FeedBackAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "FeedBackAdd", args);
                };
                Client.prototype.TitleList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "TitleList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContactAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "ContactAdd", args);
                };
                Client.prototype.AccountAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "AccountAdd", args);
                };
                Client.prototype.AccountAddSimpleIndividual = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "AccountAddSimpleIndividual", args);
                };
                Client.prototype.AccountAddSimpleCompany = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "AccountAddSimpleCompany", args);
                };
                Client.prototype.ContactAddWithoutAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "ContactAddWithoutAccount", args);
                };
                Client.prototype.ContactUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "ContactUpdate", args);
                };
                Client.prototype.ContactUpdatePersonSimple = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "ContactUpdatePersonSimple", args);
                };
                Client.prototype.ContactUpdateBusinessSimple = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "ContactUpdateBusinessSimple", args);
                };
                Client.prototype.ContactDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "ContactDelete", args);
                };
                Client.prototype.ContactNames = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactNames/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContactDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "ContactDisplayList", args);
                };
                Client.prototype.IdType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "IdType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026IdTypeId=" + this.proxy.FormatUriArgument(args.IdTypeId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.IdTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "IdTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContactAdditionalFieldDataList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactAdditionalFieldDataList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContactAdditionalFieldDataUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "ContactAdditionalFieldDataUpdate", args);
                };
                Client.prototype.ContactAdditionalFieldDataDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContact", "ContactAdditionalFieldDataDelete", args);
                };
                Client.prototype.ContactRelationshipType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactRelationshipType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RelationshipCode=" + this.proxy.FormatUriArgument(args.RelationshipCode) + "", args);
                };
                Client.prototype.ContactRelationshipTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContact", "ContactRelationshipTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ContactRelationshipAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "ContactRelationshipAdd", args);
                };
                Client.prototype.ContactRelationshipList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContact", "ContactRelationshipList", args);
                };
                Client.prototype.ContactRelationshipDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IContact", "ContactRelationshipDelete", args);
                };
                return Client;
            }(ServiceClientBase));
            IContact.Client = Client;
        })(IContact = SelcommWebService.IContact || (SelcommWebService.IContact = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IContactPhone;
        (function (IContactPhone) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Phone = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContactPhone", "Phone/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PhoneType=" + this.proxy.FormatUriArgument(args.PhoneType) + "", args);
                };
                Client.prototype.ContactPhoneAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContactPhone", "ContactPhoneAdd?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ContactPhoneAddSimple = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContactPhone", "ContactPhoneAddSimple?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ContactPhoneUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContactPhone", "ContactPhoneUpdate?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ContactPhoneUpdateList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IContactPhone", "ContactPhoneUpdateList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ContactPhoneDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IContactPhone", "ContactPhoneDelete?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ContactPhoneType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContactPhone", "ContactPhoneType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PhoneTypeCode=" + this.proxy.FormatUriArgument(args.PhoneTypeCode) + "", args);
                };
                Client.prototype.ContactPhoneTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContactPhone", "ContactPhoneTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.GetPhoneTypeCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContactPhone", "GetPhoneTypeCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PhoneNarrative=" + this.proxy.FormatUriArgument(args.PhoneNarrative) + "", args);
                };
                Client.prototype.ContactPhoneUsageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContactPhone", "ContactPhoneUsageList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IContactPhone.Client = Client;
        })(IContactPhone = SelcommWebService.IContactPhone || (SelcommWebService.IContactPhone = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IContract;
        (function (IContract) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.ContractPenalty = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContract", "ContractPenalty/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContractPenaltyCode=" + this.proxy.FormatUriArgument(args.ContractPenaltyCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContractPenaltyList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContract", "ContractPenaltyList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.Contract = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContract", "Contract/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContractList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContract", "ContractList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContractListByPackage = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContract", "ContractListByPackage/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContractPenaltyCharge = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContract", "ContractPenaltyCharge/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContractPenaltyCode=" + this.proxy.FormatUriArgument(args.ContractPenaltyCode) + "\u0026ChargeCode=" + this.proxy.FormatUriArgument(args.ChargeCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContractPenaltyChargeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContract", "ContractPenaltyChargeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContractExtension = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContract", "ContractExtension/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ContractExtensionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IContract", "ContractExtensionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IContract.Client = Client;
        })(IContract = SelcommWebService.IContract || (SelcommWebService.IContract = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ICorrespondence;
        (function (ICorrespondence) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Correspondence = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICorrespondence", "Correspondence/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.CorrespondenceByEventAndContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICorrespondence", "CorrespondenceByEventAndContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventId=" + this.proxy.FormatUriArgument(args.EventId) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.CorrespondenceList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICorrespondence", "CorrespondenceList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TaskId=" + this.proxy.FormatUriArgument(args.TaskId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.CorrespondenceAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ICorrespondence", "CorrespondenceAdd", args);
                };
                Client.prototype.CorrespondenceUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ICorrespondence", "CorrespondenceUpdate", args);
                };
                Client.prototype.CorrespondenceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICorrespondence", "CorrespondenceType/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TypeCode=" + this.proxy.FormatUriArgument(args.TypeCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.CorrespondenceStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICorrespondence", "CorrespondenceStatus/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026StatusCode=" + this.proxy.FormatUriArgument(args.StatusCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.CorrespondenceDestinationAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ICorrespondence", "CorrespondenceDestinationAdd", args);
                };
                Client.prototype.CorrespondenceDestination = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICorrespondence", "CorrespondenceDestination/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.CorrespondenceDestinationList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICorrespondence", "CorrespondenceDestinationList/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CorrespondenceId=" + this.proxy.FormatUriArgument(args.CorrespondenceId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.CorrespondenceDestinationType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICorrespondence", "CorrespondenceDestinationType/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026DestinationTypeCode=" + this.proxy.FormatUriArgument(args.DestinationTypeCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.CorrespondenceDestinationTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICorrespondence", "CorrespondenceDestinationTypeList/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ICorrespondence.Client = Client;
        })(ICorrespondence = SelcommWebService.ICorrespondence || (SelcommWebService.ICorrespondence = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ICostCentre;
        (function (ICostCentre) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.CostCentreStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICostCentre", "CostCentreStatusList/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.CostCentreList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICostCentre", "CostCentreList/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.CostCentreAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ICostCentre", "CostCentreAdd", args);
                };
                Client.prototype.CostCentreUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ICostCentre", "CostCentreUpdate", args);
                };
                Client.prototype.CostCentreDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ICostCentre", "CostCentreDelete/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.CostCentreDistributionDisplayByContactList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICostCentre", "CostCentreDistributionDisplayByContactList/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.CostCentreDistributionDisplayByCostCentreList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICostCentre", "CostCentreDistributionDisplayByCostCentreList/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.CostCentreDistributionDisplayByBillList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICostCentre", "CostCentreDistributionDisplayByBillList/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ICostCentre.Client = Client;
        })(ICostCentre = SelcommWebService.ICostCentre || (SelcommWebService.ICostCentre = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ICreditCheck;
        (function (ICreditCheck) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.DaemonRun = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICreditCheck", "DaemonRun/?EncryptedProviderCode=" + this.proxy.FormatUriArgument(args.EncryptedProviderCode) + "\u0026LoginCode=" + this.proxy.FormatUriArgument(args.LoginCode) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "", args);
                };
                Client.prototype.CheckCredit = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ICreditCheck", "CheckCredit/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.Resume = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ICreditCheck", "Resume/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ChangeDecision = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ICreditCheck", "ChangeDecision/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.CreditResult = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("Get", "SelcommWebService.ICreditCheck", "CreditResult/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RequestId=" + this.proxy.FormatUriArgument(args.RequestId) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ICreditCheck.Client = Client;
        })(ICreditCheck = SelcommWebService.ICreditCheck || (SelcommWebService.ICreditCheck = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ICustomisation;
        (function (ICustomisation) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.CustomiseString = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ICustomisation", "CustomiseString/?SesionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Application=" + this.proxy.FormatUriArgument(args.Application) + "\u0026ObjectId=" + this.proxy.FormatUriArgument(args.ObjectId) + "\u0026SourceString=" + this.proxy.FormatUriArgument(args.SourceString) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ICustomisation.Client = Client;
        })(ICustomisation = SelcommWebService.ICustomisation || (SelcommWebService.ICustomisation = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IDealer;
        (function (IDealer) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.DealerForContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDealer", "DealerForContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.DealerListForContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDealer", "DealerListForContact", args);
                };
                return Client;
            }(ServiceClientBase));
            IDealer.Client = Client;
        })(IDealer = SelcommWebService.IDealer || (SelcommWebService.IDealer = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IDevice;
        (function (IDevice) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.DevicesDisplay = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDevice", "DeviceDisplay/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026DeviceId=" + this.proxy.FormatUriArgument(args.DeviceId) + "\u0026IncludeFullDetails=" + this.proxy.FormatUriArgument(args.IncludeFullDetails) + "", args);
                };
                Client.prototype.DevicesDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesDisplayListParentsOf = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceDisplayListParentsOf/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceSetRelatedParents = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IDevice", "DeviceSetRelatedParents?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesDisplayListChildrenOf = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceDisplayListChildrenOf/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesListBySite = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesListBySite", args);
                };
                Client.prototype.DevicesListByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesListByContact", args);
                };
                Client.prototype.ContactListForDevice = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDevice", "ContactListForDevice/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026DeviceId=" + this.proxy.FormatUriArgument(args.DeviceId) + "", args);
                };
                Client.prototype.DeviceAttributesListForDevice = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDevice", "DeviceAttributesListForDevice/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026DeviceId=" + this.proxy.FormatUriArgument(args.DeviceId) + "", args);
                };
                Client.prototype.DevicesAttributeDefList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesAttributeDefList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesAttributeSetList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesAttributeSetList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesAttributeSetDetailList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesAttributeSetDetailList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceSiteHistoryListByDevice = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDevice", "DeviceSiteHistoryListByDevice/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026DeviceId=" + this.proxy.FormatUriArgument(args.DeviceId) + "", args);
                };
                Client.prototype.SiteDisplay = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDevice", "SiteDisplay/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026SiteId=" + this.proxy.FormatUriArgument(args.SiteId) + "", args);
                };
                Client.prototype.SiteDisplayListChildren = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "SiteDisplayListChildren/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SiteDisplayListParents = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "SiteDisplayListParents/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDevice", "DeviceStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesConditionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDevice", "DeviceConditionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesSiteRelationshipTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesSiteRelationshipTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceTypeActionsList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceTypeActionsList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceTypeAttributeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceTypeAttributeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceTypeAttributeSetList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceTypeAttributeSetList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceTypeDocumentList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceTypeDocumentList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceTypeImageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceTypeImageList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceTypeProductList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceTypeProductList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesCategoryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceCategoryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesRelationshipTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceRelationshipTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesRelationshipList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceRelationshipList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.MediationDataList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "MediationDataList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.MediationDataListByDevice = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "MediationDataListByDevice/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.MediationDataExceptionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "MediationDataExceptionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.MediationDataExceptionListByMediationDataFilter = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "MediationDataExceptionListByMediationDataFilter/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.MediationDataExceptionListBySpecificDevice = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "MediationDataExceptionListBySpecificDevice/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationDataExceptionGroupListUnresolvedDeviceExceptions = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationDataExceptionGroupListUnresolvedDeviceExceptions/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationDataSourceList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationDataSourceList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationDataConsList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationDataConsList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationDataConMapList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationDataConMapList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationRuleList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationRuleList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationRuleSetList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationRuleSetList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationEditValueList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationEditValueList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationEditValueListByMediationFilter = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationEditValueListByMediationFilter/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationStatusHistoryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationStatusHistoryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationStatusReasonList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationStatusReasonList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationValueRuleExceptionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationValueRuleExceptionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMediationValueRuleExceptionHistoryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMediationValueRuleExceptionHistoryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesModelList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesModelList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesGroupList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesGroupList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesGroupsContactList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesGroupsContactList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesEventList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesEventList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesReadRunsList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesReadRunsList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesReadRunDetailStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesReadRunDetailStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesReadRunDtlInstanceList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesReadRunDtlInstanceList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesReadRunsDetailList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesReadRunsDetailList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesReadRunsContactList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesReadRunsContactList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesProtocolsList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesProtocolsList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesProtocolCategoryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesProtocolCategoryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesTestStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesTestStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesTestTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesTestTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesTestsList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesTestsList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesFramingSchemeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesFramingSchemeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesPollingSchemeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesPollingSchemeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesStockList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesStockList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesStockStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesStockStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesSiteTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesSiteTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesActionsList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesActionsList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesImagesList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesImagesList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesManufacturerList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesManufacturerList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMessageBrokerList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMessageBrokerList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMessageBrokerStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMessageBrokerStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMessageBrokerTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMessageBrokerTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesMessageQosList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesMessageQosList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesPackageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesPackageList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesProductList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesProductList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DevicesServiceConnectionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DevicesServiceConnectionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.MediationDataUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "MediationDataUpdate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.MediationDataImport = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "MediationDataImport/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceActivateReasons = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDevice", "DeviceActivateReasons?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceActivate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceActivate?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceDeactivateReasons = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDevice", "DeviceDectivateReasons?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceDeactivate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceDeactivate?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IDevice", "DeviceAdd?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceUpdate?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceDelete?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceListByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceListByContact?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceSetServices = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDevice", "DeviceSetServices?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.DeviceRelationshipAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IDevice", "DeviceRelationshipAdd?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IDevice.Client = Client;
        })(IDevice = SelcommWebService.IDevice || (SelcommWebService.IDevice = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IDocument;
        (function (IDocument) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.DocumentAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDocument", "DocumentAdd", args);
                };
                Client.prototype.DocumentAddByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDocument", "DocumentAddByContact", args);
                };
                Client.prototype.DocumentAddByService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDocument", "DocumentAddByService", args);
                };
                Client.prototype.DocumentUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IDocument", "DocumentUpdate", args);
                };
                Client.prototype.DocumentDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IDocument", "DocumentDelete/?SessionId=" + this.proxy.FormatUriArgument(args.SessionId) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.DocumentDeleteByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IDocument", "DocumentDeleteByContact/?SessionId=" + this.proxy.FormatUriArgument(args.SessionId) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.DocumentDeleteByService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IDocument", "DocumentDeleteByService/?SessionId=" + this.proxy.FormatUriArgument(args.SessionId) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.Document = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDocument", "Document/?SessionId=" + this.proxy.FormatUriArgument(args.SessionId) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.DocumentValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IDocument", "DocumentValidate", args);
                };
                Client.prototype.DocumentDisplayListByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDocument", "DocumentDisplayListByContact/?SessionId=" + this.proxy.FormatUriArgument(args.SessionId) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026Library=" + this.proxy.FormatUriArgument(args.Library) + "", args);
                };
                Client.prototype.DocumentDisplayListByService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IDocument", "DocumentDisplayListByService/?SessionId=" + this.proxy.FormatUriArgument(args.SessionId) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IDocument.Client = Client;
        })(IDocument = SelcommWebService.IDocument || (SelcommWebService.IDocument = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IEmail;
        (function (IEmail) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.EmailAddressValidateFormat = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEmail", "EmailAddressValidateFormat/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EmailAddress=" + this.proxy.FormatUriArgument(args.EmailAddress) + "", args);
                };
                Client.prototype.EmailAddressValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEmail", "EmailAddressValidate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EmailAddress=" + this.proxy.FormatUriArgument(args.EmailAddress) + "\u0026CheckEmailExists=" + this.proxy.FormatUriArgument(args.CheckEmailExists) + "", args);
                };
                Client.prototype.EmailAddress = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEmail", "EmailAddress/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EmailAddresses = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEmail", "EmailAddresses/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EmailAddressAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEmail", "EmailAddressAdd", args);
                };
                Client.prototype.ContactEmailAddressAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEmail", "ContactEmailAddressAdd", args);
                };
                Client.prototype.EmailAddressAddSimple = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEmail", "EmailAddressAddSimple", args);
                };
                Client.prototype.EmailAddressUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IEmail", "EmailAddressUpdate", args);
                };
                Client.prototype.ContactEmailAddressUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IEmail", "ContactEmailAddressUpdate", args);
                };
                Client.prototype.EmailAddressDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IEmail", "EmailAddressDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ContactEmailAddressDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IEmail", "ContactEmailAddressDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026InfoType=" + this.proxy.FormatUriArgument(args.InfoType) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IEmail.Client = Client;
        })(IEmail = SelcommWebService.IEmail || (SelcommWebService.IEmail = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IError;
        (function (IError) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.ErrorLog = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IError", "ErrorLog", args);
                };
                Client.prototype.Trace = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IError", "Trace/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Message=" + this.proxy.FormatUriArgument(args.Message) + "\u0026ApplicationName=" + this.proxy.FormatUriArgument(args.ApplicationName) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IError.Client = Client;
        })(IError = SelcommWebService.IError || (SelcommWebService.IError = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IEvent;
        (function (IEvent) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.EventAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventAdd", args);
                };
                Client.prototype.EventAddForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventAddForService", args);
                };
                Client.prototype.EventOpenService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventOpenService", args);
                };
                Client.prototype.EventForServiceCreation = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventForServiceCreation", args);
                };
                Client.prototype.EventScheduleStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventScheduleStatus", args);
                };
                Client.prototype.Post = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "Post/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventId=" + this.proxy.FormatUriArgument(args.EventId) + "", args);
                };
                Client.prototype.EventList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventList", args);
                };
                Client.prototype.EventListInDateRange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventListInDateRange", args);
                };
                Client.prototype.EventListForBusinessUnitsInDateRange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventListForBusinessUnitsInDateRange", args);
                };
                Client.prototype.EventListByServiceTypeInDateRange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventListByServiceTypeInDateRange", args);
                };
                Client.prototype.EventListByServiceId = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventListByServiceId/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventListByMatchingDispatcherServiceIds = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventListByMatchingDispatcherServiceIds/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceIdText=" + this.proxy.FormatUriArgument(args.ServiceIdText) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventListByConnectionServiceId = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventListByConnectionServiceId/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventListByServiceEventTypeAndCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventListByServiceEventTypeAndCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "\u0026EventType=" + this.proxy.FormatUriArgument(args.EventType) + "\u0026EventCode=" + this.proxy.FormatUriArgument(args.EventCode) + "\u0026SchedStatCode=" + this.proxy.FormatUriArgument(args.SchedStatCode) + "", args);
                };
                Client.prototype.EventType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventType=" + this.proxy.FormatUriArgument(args.EventType) + "\u0026EventCode=" + this.proxy.FormatUriArgument(args.EventCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventNoteAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventNoteAdd", args);
                };
                Client.prototype.EventNoteUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IEvent", "EventNoteUpdate", args);
                };
                Client.prototype.EventNoteList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventNoteList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventReference=" + this.proxy.FormatUriArgument(args.EventReference) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventDisplay = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventDisplay/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventId=" + this.proxy.FormatUriArgument(args.EventId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventDisplayNotes = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventDisplayNotes/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventId=" + this.proxy.FormatUriArgument(args.EventId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventDisplayList", args);
                };
                Client.prototype.EventScheduleUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IEvent", "EventScheduleUpdate", args);
                };
                Client.prototype.EventSchedule = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventSchedule/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventId=" + this.proxy.FormatUriArgument(args.EventId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ServiceBarTypeLoadEventReasonList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "ServiceBarTypeLoadEventReasonList", args);
                };
                Client.prototype.EventReasonTypeDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventReasonTypeDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ActionReference=" + this.proxy.FormatUriArgument(args.ActionReference) + "\u0026ServiceType=" + this.proxy.FormatUriArgument(args.ServiceType) + "", args);
                };
                Client.prototype.EventAttachmentAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IEvent", "EventAttachmentAdd", args);
                };
                Client.prototype.EventAttachment = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventAttachment/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventAttachmentList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventAttachmentList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventReference=" + this.proxy.FormatUriArgument(args.EventReference) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventAttachmentDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IEvent", "EventAttachmentDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventDispatcherList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventDispatcherList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventData = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventData/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventId=" + this.proxy.FormatUriArgument(args.EventId) + "\u0026Name=" + this.proxy.FormatUriArgument(args.Name) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EventDataList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IEvent", "EventDataList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventId=" + this.proxy.FormatUriArgument(args.EventId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026GroupName=" + this.proxy.FormatUriArgument(args.GroupName) + "\u0026Name=" + this.proxy.FormatUriArgument(args.Name) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IEvent.Client = Client;
        })(IEvent = SelcommWebService.IEvent || (SelcommWebService.IEvent = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IFeedBack;
        (function (IFeedBack) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.FeedbackList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFeedBack", "FeedbackList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.FeedbackListLastItemOnly = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFeedBack", "FeedbackListLastItemOnly?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.FeedBackAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IFeedBack", "FeedBackAdd", args);
                };
                Client.prototype.FeedBack = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFeedBack", "FeedBack/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IFeedBack.Client = Client;
        })(IFeedBack = SelcommWebService.IFeedBack || (SelcommWebService.IFeedBack = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IFinancial;
        (function (IFinancial) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.FinancialPreAuthorisationAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IFinancial", "FinancialPreAuthorisationAdd", args);
                };
                Client.prototype.FinancialPreAuthorisationCancel = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IFinancial", "FinancialPreAuthorisationCancel", args);
                };
                Client.prototype.FinancialPreAuthorisationRelease = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IFinancial", "FinancialPreAuthorisationRelease", args);
                };
                Client.prototype.FinancialPreAuthorisationSettle = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IFinancial", "FinancialPreAuthorisationSettle", args);
                };
                Client.prototype.FinancialTransactionListByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialTransactionListByContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026NumberToLoad=" + this.proxy.FormatUriArgument(args.NumberToLoad) + "", args);
                };
                Client.prototype.FinancialTransactionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IFinancial", "FinancialTransactionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.FinancialTransactionListByBill = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialTransactionListByBill/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026SearchTerm=" + this.proxy.FormatUriArgument(args.SearchTerm) + "\u0026SortBy=" + this.proxy.FormatUriArgument(args.SortBy) + "\u0026SortOrder=" + this.proxy.FormatUriArgument(args.SortOrder) + "", args);
                };
                Client.prototype.FinancialTransactionListByBillAll = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialTransactionListByBillAll/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BillId=" + this.proxy.FormatUriArgument(args.BillId) + "", args);
                };
                Client.prototype.FinancialTransactionListByReceipt = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IFinancial", "FinancialTransactionListByReceipt", args);
                };
                Client.prototype.FinancialTransactionListFailedReceiptsBySource = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialTransactionListFailedReceiptsBySource/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026SourceCode=" + this.proxy.FormatUriArgument(args.SourceCode) + "\u0026StartDate=" + this.proxy.FormatUriArgument(args.StartDate) + "\u0026EndDate=" + this.proxy.FormatUriArgument(args.EndDate) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "", args);
                };
                Client.prototype.FinancialTransactionListFailedReceiptsBySourceForContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialTransactionListFailedReceiptsBySourceForContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026SourceCode=" + this.proxy.FormatUriArgument(args.SourceCode) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026StartDate=" + this.proxy.FormatUriArgument(args.StartDate) + "\u0026EndDate=" + this.proxy.FormatUriArgument(args.EndDate) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "", args);
                };
                Client.prototype.FinancialAccountInfos = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialAccountInfos/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.FinancialAccountBalance = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialAccountBalance/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.FinancialTransactionSourceInfo = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialTransactionSourceInfo/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.FinancialTransactionTypeInfo = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialTransactionTypeInfo/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.FinancialTransactionReasonInfo = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialTransactionReasonInfo/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.FinancialTransactionCategoryInfo = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "FinancialTransactionCategoryInfo/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.CurrencyByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "CurrencyByContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.CurrencyList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "CurrencyList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.TaxInfo = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IFinancial", "TaxInfo/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IFinancial.Client = Client;
        })(IFinancial = SelcommWebService.IFinancial || (SelcommWebService.IFinancial = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IGeneralLedger;
        (function (IGeneralLedger) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.GeneralLedgerAccountTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IGeneralLedger", "GeneralLedgerAccountTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.GeneralLedgerAccountList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IGeneralLedger", "GeneralLedgerAccountList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.GeneralLedgerRevenueAccountList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IGeneralLedger", "GeneralLedgerRevenueAccountList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IGeneralLedger.Client = Client;
        })(IGeneralLedger = SelcommWebService.IGeneralLedger || (SelcommWebService.IGeneralLedger = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IHardware;
        (function (IHardware) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.EquipmentType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IHardware", "EquipmentType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ID=" + this.proxy.FormatUriArgument(args.ID) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EquipmentTypeByModelAndBrand = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IHardware", "EquipmentTypeByModelAndBrand/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Brand=" + this.proxy.FormatUriArgument(args.Brand) + "\u0026Model=" + this.proxy.FormatUriArgument(args.Model) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.EquipmentTypeListForServiceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IHardware", "EquipmentTypeListForServiceType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.BrandDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IHardware", "BrandDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ModelDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IHardware", "ModelDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Brand=" + this.proxy.FormatUriArgument(args.Brand) + "\u0026DisplayAll=" + this.proxy.FormatUriArgument(args.DisplayAll) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IHardware.Client = Client;
        })(IHardware = SelcommWebService.IHardware || (SelcommWebService.IHardware = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IInventory;
        (function (IInventory) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.NetworkIdentityForStockItem = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IInventory", "NetworkIdentityForStockItem/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Pcn=" + this.proxy.FormatUriArgument(args.Pcn) + "", args);
                };
                Client.prototype.NetworkIdentityForStockItemAndServiceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IInventory", "NetworkIdentityForStockItemAndServiceType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Pcn=" + this.proxy.FormatUriArgument(args.Pcn) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IInventory.Client = Client;
        })(IInventory = SelcommWebService.IInventory || (SelcommWebService.IInventory = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IInvoice;
        (function (IInvoice) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.LoadForInvoice = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IInvoice", "LoadForInvoice/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ConnectionReference=" + this.proxy.FormatUriArgument(args.ConnectionReference) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IInvoice.Client = Client;
        })(IInvoice = SelcommWebService.IInvoice || (SelcommWebService.IInvoice = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ILeads;
        (function (ILeads) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Lead = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ILeads", "Lead/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.LeadList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ILeads", "LeadList", args);
                };
                Client.prototype.LeadAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ILeads", "LeadAdd", args);
                };
                Client.prototype.LeadUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ILeads", "LeadUpdate", args);
                };
                Client.prototype.LeadDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ILeads", "LeadDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.LeadValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ILeads", "LeadValidate", args);
                };
                Client.prototype.LeadSource = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ILeads", "LeadSource/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.LeadSourceList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ILeads", "LeadSourceList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.LeadSourceAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ILeads", "LeadSourceAdd", args);
                };
                Client.prototype.LeadSourceUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ILeads", "LeadSourceUpdate", args);
                };
                Client.prototype.LeadSourceDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ILeads", "LeadSourceDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.LeadSourceValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ILeads", "LeadSourceValidate", args);
                };
                Client.prototype.LeadStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ILeads", "LeadStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.LeadStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ILeads", "LeadStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.LeadStatusAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ILeads", "LeadStatusAdd", args);
                };
                Client.prototype.LeadStatusUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ILeads", "LeadStatusUpdate", args);
                };
                Client.prototype.LeadStatusDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ILeads", "LeadStatusDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.LeadStatusValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ILeads", "LeadStatusValidate", args);
                };
                return Client;
            }(ServiceClientBase));
            ILeads.Client = Client;
        })(ILeads = SelcommWebService.ILeads || (SelcommWebService.ILeads = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ILibrary;
        (function (ILibrary) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Library = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ILibrary", "Library/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "\u0026CustomerType=" + this.proxy.FormatUriArgument(args.CustomerType) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026TeamCode=" + this.proxy.FormatUriArgument(args.TeamCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ILibrary.Client = Client;
        })(ILibrary = SelcommWebService.ILibrary || (SelcommWebService.ILibrary = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IMaps;
        (function (IMaps) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.MapPointCustomerList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IMaps", "MapPointCustomerList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.MapPointServiceProviderList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IMaps", "MapPointServiceProviderList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.MapPointServiceProviderAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IMaps", "MapPointServiceProviderAdd", args);
                };
                Client.prototype.MapPointServiceProviderUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IMaps", "MapPointServiceProviderUpdate", args);
                };
                Client.prototype.MapPointServiceProviderDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IMaps", "MapPointServiceProviderDelete", args);
                };
                return Client;
            }(ServiceClientBase));
            IMaps.Client = Client;
        })(IMaps = SelcommWebService.IMaps || (SelcommWebService.IMaps = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IMenu;
        (function (IMenu) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Menu = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IMenu", "Menu/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026MenuId=" + this.proxy.FormatUriArgument(args.MenuId) + "\u0026Recurrent=" + this.proxy.FormatUriArgument(args.Recurrent) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.MenuForServiceDetails = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IMenu", "MenuForServiceDetails/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026MenuId=" + this.proxy.FormatUriArgument(args.MenuId) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026ServiceSystemStatusCode=" + this.proxy.FormatUriArgument(args.ServiceSystemStatusCode) + "\u0026Recurrent=" + this.proxy.FormatUriArgument(args.Recurrent) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IMenu.Client = Client;
        })(IMenu = SelcommWebService.IMenu || (SelcommWebService.IMenu = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var INetwork;
        (function (INetwork) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.LCSPList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.INetwork", "LCSPList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.NetworkTransaction = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.INetwork", "NetworkTransaction", args);
                };
                Client.prototype.NetworkTransactionLayout = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.INetwork", "NetworkTransactionLayout/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026NetworkTransactionTypeCode=" + this.proxy.FormatUriArgument(args.NetworkTransactionTypeCode) + "", args);
                };
                Client.prototype.NetworkServiceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.INetwork", "NetworkServiceType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceType=" + this.proxy.FormatUriArgument(args.ServiceType) + "", args);
                };
                Client.prototype.NetworkServiceActivate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.INetwork", "NetworkServiceActivate", args);
                };
                return Client;
            }(ServiceClientBase));
            INetwork.Client = Client;
        })(INetwork = SelcommWebService.INetwork || (SelcommWebService.INetwork = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var INews;
        (function (INews) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.NewsItemList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.INews", "NewsItemList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026LoadExpired=" + this.proxy.FormatUriArgument(args.LoadExpired) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.NewsItem = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.INews", "NewsItem", args);
                };
                Client.prototype.NewsItemAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.INews", "NewsItemAdd", args);
                };
                Client.prototype.NewsItemUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.INews", "NewsItemUpdate", args);
                };
                Client.prototype.NewsItemDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.INews", "NewsItemDelete", args);
                };
                return Client;
            }(ServiceClientBase));
            INews.Client = Client;
        })(INews = SelcommWebService.INews || (SelcommWebService.INews = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IOpportunities;
        (function (IOpportunities) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Opportunity = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOpportunities", "Opportunity/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Ref=" + this.proxy.FormatUriArgument(args.Ref) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OpportunitiesList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOpportunities", "OpportunitiesList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OpportunityAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOpportunities", "OpportunityAdd", args);
                };
                Client.prototype.OpportunityUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOpportunities", "OpportunityUpdate", args);
                };
                Client.prototype.OpportunityDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IOpportunities", "OpportunityDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Ref=" + this.proxy.FormatUriArgument(args.Ref) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IOpportunities.Client = Client;
        })(IOpportunities = SelcommWebService.IOpportunities || (SelcommWebService.IOpportunities = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IOrderEntry;
        (function (IOrderEntry) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.EmploymentPositionsDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrderEntry", "EmploymentPositionsDisplayList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.IncomeBracketsDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrderEntry", "IncomeBracketsDisplayList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.PrimaryIdentificationDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrderEntry", "PrimaryIdentificationDisplayList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SecondaryIndentificationDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrderEntry", "SecondaryIndentificationDisplayList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.LastCreditApplicationTimesDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrderEntry", "LastCreditApplicationTimesDisplayList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountVerify = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrderEntry", "AccountVerify?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.PortingOptionsDisplayListLoad = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrderEntry", "PortingOptionsDisplayListLoad?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ContractTermDisplayListLoad = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrderEntry", "ContractTermDisplayListLoad?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.PackageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrderEntry", "PackageList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactType=" + this.proxy.FormatUriArgument(args.ContactType) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "", args);
                };
                Client.prototype.OrderAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOrderEntry", "OrderAdd?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.NetworkDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrderEntry", "NetworkDisplayList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.OrderStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrderEntry", "OrderStatusList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026CacheRefresh=" + this.proxy.FormatUriArgument(args.CacheRefresh) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IOrderEntry.Client = Client;
        })(IOrderEntry = SelcommWebService.IOrderEntry || (SelcommWebService.IOrderEntry = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IOrder;
        (function (IOrder) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Order = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "Order/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OrderID=" + this.proxy.FormatUriArgument(args.OrderID) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.GetOrderNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "GetOrderNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.OrderByNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderByNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OrderNumber=" + this.proxy.FormatUriArgument(args.OrderNumber) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOrder", "OrderUpdate?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.OrderVoid = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOrder", "OrderVoid?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.OrderAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderAdd?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.OrderCommit = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderCommit?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.OrderGeneratePDF = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderGeneratePDF?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.Uc1OrderGeneratePDF = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "Uc1OrderGeneratePDF?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.OrderEventLink = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderEventLink?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.OrderSaveVoiceSign = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderSaveVoiceSign?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.OrderDisplayListForContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderDisplayListForContact", args);
                };
                Client.prototype.OrderDisplayListForPCN = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderDisplayListForPCN/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PCN=" + this.proxy.FormatUriArgument(args.PCN) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderSource = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderSource/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderSourceList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderSourceList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItem = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItem/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderItemAdd", args);
                };
                Client.prototype.OrderItemUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOrder", "OrderItemUpdate", args);
                };
                Client.prototype.OrderItemUpdateStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOrder", "OrderItemUpdateStatus", args);
                };
                Client.prototype.OrderItemList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OrderId=" + this.proxy.FormatUriArgument(args.OrderId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderClass = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderClass/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OrderClassCode=" + this.proxy.FormatUriArgument(args.OrderClassCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderClassList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderClassList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderPriority = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderPriority/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderPriorityList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderPriorityList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderFollowupReason = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderFollowupReason/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderFollowUpReasonList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderFollowUpReasonList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderCourier = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderCourier/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderCourierList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderCourierList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemCharges = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemCharges/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemChargesList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemChargesList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemChargeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderItemChargeAdd", args);
                };
                Client.prototype.OrderItemChargeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOrder", "OrderItemChargeUpdate", args);
                };
                Client.prototype.OrderItemServiceCharge = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemServiceCharge/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemServiceChargeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemServiceChargeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OrderItemId=" + this.proxy.FormatUriArgument(args.OrderItemId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemServiceChargeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderItemServiceChargeAdd", args);
                };
                Client.prototype.OrderItemServiceChargeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOrder", "OrderItemServiceChargeUpdate", args);
                };
                Client.prototype.OrderItemServiceDiscount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemServiceDiscount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemServiceDiscountList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemServiceDiscountList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OrderItemId=" + this.proxy.FormatUriArgument(args.OrderItemId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemServiceDiscountAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderItemServiceDiscountAdd", args);
                };
                Client.prototype.OrderItemServiceDiscountUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOrder", "OrderItemServiceDiscountUpdate", args);
                };
                Client.prototype.OrderItemServiceAttribute = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemServiceAttribute/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemServiceAttributeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "OrderItemServiceAttributeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OrderItemId=" + this.proxy.FormatUriArgument(args.OrderItemId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.OrderItemServiceAttributeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "OrderItemServiceAttributeAdd", args);
                };
                Client.prototype.OrderItemServiceAttributeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IOrder", "OrderItemServiceAttributeUpdate", args);
                };
                Client.prototype.EmploymentPositionsDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "EmploymentPositionsDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.IncomeBracketsDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "IncomeBracketsDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.UC4CompleteOrder = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "UC4CompleteOrder", args);
                };
                Client.prototype.UC4 = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "UC4/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ServiceQualificationsByNumberOrLocationId = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "ServiceQualificationsByNumberOrLocationId?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CustomerNumber=" + this.proxy.FormatUriArgument(args.CustomerNumber) + "\u0026TelstraLocationId=" + this.proxy.FormatUriArgument(args.TelstraLocationId) + "\u0026NbnLocationId=" + this.proxy.FormatUriArgument(args.NbnLocationId) + "", args);
                };
                Client.prototype.ServiceProviderLocationIdByAddress = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IOrder", "ServiceProviderLocationIdByAddress", args);
                };
                Client.prototype.PackageListByServiceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IOrder", "PackageListByServiceType?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IOrder.Client = Client;
        })(IOrder = SelcommWebService.IOrder || (SelcommWebService.IOrder = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IPackages;
        (function (IPackages) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.PackageGroup = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageGroup/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageGroupList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageGroupList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026LoadPackages=" + this.proxy.FormatUriArgument(args.LoadPackages) + "", args);
                };
                Client.prototype.PackageGroupListWithOptions = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageGroupListWithOptions/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OnlyUsedPackageGroups=" + this.proxy.FormatUriArgument(args.OnlyUsedPackageGroups) + "\u0026CurrentPackagesOnly=" + this.proxy.FormatUriArgument(args.CurrentPackagesOnly) + "\u0026LoadPackages=" + this.proxy.FormatUriArgument(args.LoadPackages) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageGroupListForServiceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageGroupListForServiceType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026CurrentPackagesOnly=" + this.proxy.FormatUriArgument(args.CurrentPackagesOnly) + "\u0026LoadPackages=" + this.proxy.FormatUriArgument(args.LoadPackages) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageGroupAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IPackages", "PackageGroupAdd", args);
                };
                Client.prototype.PackageGroupUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IPackages", "PackageGroupUpdate", args);
                };
                Client.prototype.PackageOptionChargeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageOptionChargeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026PackageOptionCode=" + this.proxy.FormatUriArgument(args.PackageOptionCode) + "\u0026ChargeType=" + this.proxy.FormatUriArgument(args.ChargeType) + "", args);
                };
                Client.prototype.PackageOptionChargeListLoadForPackageOptionAndCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageOptionChargeListLoadForPackageOptionAndCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026PackageOptionCode=" + this.proxy.FormatUriArgument(args.PackageOptionCode) + "", args);
                };
                Client.prototype.PackageOptionChargeDisplayListLoadForPackageOptionAndCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageOptionChargeDisplayListLoadForPackageOptionAndCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026PackageOptionCode=" + this.proxy.FormatUriArgument(args.PackageOptionCode) + "", args);
                };
                Client.prototype.PackageType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageTypeCode=" + this.proxy.FormatUriArgument(args.PackageTypeCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageGroupDisplay = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageGroupDisplay/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageGroupDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageGroupDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026LoadPackages=" + this.proxy.FormatUriArgument(args.LoadPackages) + "", args);
                };
                Client.prototype.PackageGroupDisplayListWithOptions = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageGroupDisplayListWithOptions/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OnlyUsedPackageGroups=" + this.proxy.FormatUriArgument(args.OnlyUsedPackageGroups) + "\u0026CurrentPackagesOnly=" + this.proxy.FormatUriArgument(args.CurrentPackagesOnly) + "\u0026LoadPackages=" + this.proxy.FormatUriArgument(args.LoadPackages) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageGroupDisplayListForServiceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageGroupDisplayListForServiceType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026CurrentPackagesOnly=" + this.proxy.FormatUriArgument(args.CurrentPackagesOnly) + "\u0026LoadPackages=" + this.proxy.FormatUriArgument(args.LoadPackages) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026LoadPackageOptions=" + this.proxy.FormatUriArgument(args.LoadPackageOptions) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageListForSeviceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageListForSeviceType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026LoadPackageOptions=" + this.proxy.FormatUriArgument(args.LoadPackageOptions) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageListByServiceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageListByServiceType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026LoadPackageOptions=" + this.proxy.FormatUriArgument(args.LoadPackageOptions) + "\u0026CurrentPackageOnly=" + this.proxy.FormatUriArgument(args.CurrentPackageOnly) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageListByServiceTypeAndCreditScore = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageListByServiceTypeAndCreditScore/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026CreditScore=" + this.proxy.FormatUriArgument(args.CreditScore) + "\u0026LoadPackageOptions=" + this.proxy.FormatUriArgument(args.LoadPackageOptions) + "\u0026CurrentPackageOnly=" + this.proxy.FormatUriArgument(args.CurrentPackageOnly) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.Package = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "Package/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageDisplay = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDisplay/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageDisplayListCurrent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDisplayListCurrent/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageDisplayListForServiceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDisplayListForServiceType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageDisplayListForServiceTypeCurrent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDisplayListForServiceTypeCurrent/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "", args);
                };
                Client.prototype.PackageDisplayListForServiceTypeAndPackageGroupCurrent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDisplayListForServiceTypeAndPackageGroupCurrent/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026PackageGroupId=" + this.proxy.FormatUriArgument(args.PackageGroupId) + "", args);
                };
                Client.prototype.PackageDisplayListForServiceTypeAndPackageGroup = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDisplayListForServiceTypeAndPackageGroup/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026Currently=" + this.proxy.FormatUriArgument(args.Currently) + "\u0026PackageGroupId=" + this.proxy.FormatUriArgument(args.PackageGroupId) + "", args);
                };
                Client.prototype.packageDisplayListForPackageGroup = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "packageDisplayListForPackageGroup/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageGroupId=" + this.proxy.FormatUriArgument(args.PackageGroupId) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IPackages", "PackageAdd", args);
                };
                Client.prototype.PackageUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IPackages", "PackageUpdate", args);
                };
                Client.prototype.PackageDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IPackages", "PackageDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "", args);
                };
                Client.prototype.PackageOption = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageOption/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026Option=" + this.proxy.FormatUriArgument(args.Option) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageOptionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageOptionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageOptionListForPaymentMethodTypeAndContactSubType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageOptionListForPaymentMethodTypeAndContactSubType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026PaymentMethodTypeCode=" + this.proxy.FormatUriArgument(args.PaymentMethodTypeCode) + "\u0026ContactSubType=" + this.proxy.FormatUriArgument(args.ContactSubType) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageOptionListForPaymentMethodTypeAndContactType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageOptionListForPaymentMethodTypeAndContactType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026PaymentMethodTypeCode=" + this.proxy.FormatUriArgument(args.PaymentMethodTypeCode) + "\u0026ContactType=" + this.proxy.FormatUriArgument(args.ContactType) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageOptionAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IPackages", "PackageOptionAdd", args);
                };
                Client.prototype.PackageOptionUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IPackages", "PackageOptionUpdate", args);
                };
                Client.prototype.PackageOptionDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IPackages", "PackageOptionDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026Option=" + this.proxy.FormatUriArgument(args.Option) + "", args);
                };
                Client.prototype.PackageDiscount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDiscount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageDiscountList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDiscountList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026Option=" + this.proxy.FormatUriArgument(args.Option) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PackageDiscountListForOption = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPackages", "PackageDiscountListForOption/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Option=" + this.proxy.FormatUriArgument(args.Option) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IPackages.Client = Client;
        })(IPackages = SelcommWebService.IPackages || (SelcommWebService.IPackages = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IPayment;
        (function (IPayment) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.PaymentRequestCreate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IPayment", "PaymentRequestCreate", args);
                };
                Client.prototype.PaymentRequestStatusGetForPaymentRequest = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentRequestStatusGetForPaymentRequest/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PaymentRequestId=" + this.proxy.FormatUriArgument(args.PaymentRequestId) + "", args);
                };
                Client.prototype.PaymentRequestSimpleByCreditCard = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentRequestSimpleByCreditCard/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026CardNumber=" + this.proxy.FormatUriArgument(args.CardNumber) + "\u0026CardName=" + this.proxy.FormatUriArgument(args.CardName) + "\u0026ExpiryDate=" + this.proxy.FormatUriArgument(args.ExpiryDate) + "\u0026Amount=" + this.proxy.FormatUriArgument(args.Amount) + "", args);
                };
                Client.prototype.PaymentRequestSimpleByPaymentMethod = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentRequestSimpleByPaymentMethod/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Amount=" + this.proxy.FormatUriArgument(args.Amount) + "\u0026PaymentMethodReference=" + this.proxy.FormatUriArgument(args.PaymentMethodReference) + "", args);
                };
                Client.prototype.PaymentRequestSimpleByDefaultPaymentMethod = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentRequestSimpleByDefaultPaymentMethod/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026Amount=" + this.proxy.FormatUriArgument(args.Amount) + "", args);
                };
                Client.prototype.PaymentRequestLoadByFinancialReference = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentRequestLoadByFinancialReference/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026FinancialReceipt=" + this.proxy.FormatUriArgument(args.FinancialReceipt) + "", args);
                };
                Client.prototype.PaymentRequestRegisterToProvider = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentRequestRegisterToProvider/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PaymentRequestId=" + this.proxy.FormatUriArgument(args.PaymentRequestId) + "", args);
                };
                Client.prototype.PaymentMethodTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentMethodTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PaymentMethodTypeListOnline = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentMethodTypeListOnline/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PaymentMethodTypeAccepted = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentMethodTypeAccepted/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PaymentMethodTypeCode=" + this.proxy.FormatUriArgument(args.PaymentMethodTypeCode) + "", args);
                };
                Client.prototype.PaymentMethod = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentMethod/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "", args);
                };
                Client.prototype.PaymentMethodGetDescription = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentMethodGetDescription/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PaymentMethodCode=" + this.proxy.FormatUriArgument(args.PaymentMethodCode) + "\u0026PaymentMethodTypeCode=" + this.proxy.FormatUriArgument(args.PaymentMethodTypeCode) + "", args);
                };
                Client.prototype.PaymentMethodFromAccountNumberAndType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentMethodFromAccountNumberAndType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026PaymentMethodTypeCode=" + this.proxy.FormatUriArgument(args.PaymentMethodTypeCode) + "", args);
                };
                Client.prototype.PaymentMethodList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentMethodList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountPaymentMethodExists = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodExists/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PayCode=" + this.proxy.FormatUriArgument(args.PayCode) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "", args);
                };
                Client.prototype.AccountPaymentMethodExistsAndIsActive = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodExistsAndIsActive/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PayCode=" + this.proxy.FormatUriArgument(args.PayCode) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026BSB=" + this.proxy.FormatUriArgument(args.BSB) + "", args);
                };
                Client.prototype.AccountPaymentMethodAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IPayment", "AccountPaymentMethodAdd", args);
                };
                Client.prototype.AccountPaymentMethodUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IPayment", "AccountPaymentMethodUpdate", args);
                };
                Client.prototype.AccountPaymentMethodDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IPayment", "AccountPaymentMethodDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.AccountPaymentMethod = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethod/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.AccountPaymentMethodDefault = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodDefault/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AccountPaymentMethodByNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodByNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AccountPaymentMethodMakeDefault = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IPayment", "AccountPaymentMethodMakeDefault", args);
                };
                Client.prototype.AccountPaymentMethodCancel = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IPayment", "AccountPaymentMethodCancel", args);
                };
                Client.prototype.AccountPaymentMethodChangeStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IPayment", "AccountPaymentMethodChangeStatus", args);
                };
                Client.prototype.AccountPaymentMethodAssignToService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IPayment", "AccountPaymentMethodAssignToService", args);
                };
                Client.prototype.AccountPaymentMethodList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AccountPaymentMethodListValid = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodListValid/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AccountPaymentMethodListValidOnline = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodListValidOnline/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PaymentSource=" + this.proxy.FormatUriArgument(args.PaymentSource) + "", args);
                };
                Client.prototype.AccountPaymentMethodStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PaymentProviderExists = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentProviderExists/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PaymentSourceID=" + this.proxy.FormatUriArgument(args.PaymentSourceID) + "", args);
                };
                Client.prototype.PaymentProvider = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentProvider/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PaymentSourceID=" + this.proxy.FormatUriArgument(args.PaymentSourceID) + "", args);
                };
                Client.prototype.PaymentSurchargeForPaymentMethodProviderAndSource = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentSurchargeForPaymentMethodProviderAndSource/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PaymentMethodCode=" + this.proxy.FormatUriArgument(args.PaymentMethodCode) + "\u0026PaymentProviderID=" + this.proxy.FormatUriArgument(args.PaymentProviderID) + "\u0026PaymentSourceID=" + this.proxy.FormatUriArgument(args.PaymentSourceID) + "", args);
                };
                Client.prototype.PaymentSurcharge = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentSurcharge/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PaymentMethodCode=" + this.proxy.FormatUriArgument(args.PaymentMethodCode) + "\u0026PaymentSource=" + this.proxy.FormatUriArgument(args.PaymentSource) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PaymentSurchargeAmount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentSurchargeAmount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PaymentRequestAmount=" + this.proxy.FormatUriArgument(args.PaymentRequestAmount) + "\u0026PaymentMethodCode=" + this.proxy.FormatUriArgument(args.PaymentMethodCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026PaymentSourceId=" + this.proxy.FormatUriArgument(args.PaymentSourceId) + "\u0026PaymentProviderId=" + this.proxy.FormatUriArgument(args.PaymentProviderId) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AccountPaymentMethodListRegisterToProviderFileType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodListRegisterToProviderFileType/?ProviderCode=" + this.proxy.FormatUriArgument(args.ProviderCode) + "\u0026UserName=" + this.proxy.FormatUriArgument(args.UserName) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026FileType=" + this.proxy.FormatUriArgument(args.FileType) + "", args);
                };
                Client.prototype.AccountPaymentMethodListRegistrationStatusUpdateCheck = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodListRegistrationStatusUpdateCheck/?ProviderCode=" + this.proxy.FormatUriArgument(args.ProviderCode) + "\u0026UserName=" + this.proxy.FormatUriArgument(args.UserName) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026FileType=" + this.proxy.FormatUriArgument(args.FileType) + "", args);
                };
                Client.prototype.PaymentRequestListProcessPending = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentRequestListProcessPending/?ProviderCode=" + this.proxy.FormatUriArgument(args.ProviderCode) + "\u0026UserName=" + this.proxy.FormatUriArgument(args.UserName) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026FileType=" + this.proxy.FormatUriArgument(args.FileType) + "", args);
                };
                Client.prototype.PaymentRequestListInProgressPoll = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentRequestListInProgressPoll/?ProviderCode=" + this.proxy.FormatUriArgument(args.ProviderCode) + "\u0026UserName=" + this.proxy.FormatUriArgument(args.UserName) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026FileType=" + this.proxy.FormatUriArgument(args.FileType) + "", args);
                };
                Client.prototype.AccountPaymentMethodListUpdateToProviderFileType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "AccountPaymentMethodListUpdateToProviderFileType/?ProviderCode=" + this.proxy.FormatUriArgument(args.ProviderCode) + "\u0026UserName=" + this.proxy.FormatUriArgument(args.UserName) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026FileType=" + this.proxy.FormatUriArgument(args.FileType) + "", args);
                };
                Client.prototype.PaymentRequestListUpdateFromExternalPayments = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentRequestListUpdateFromExternalPayments/?ProviderCode=" + this.proxy.FormatUriArgument(args.ProviderCode) + "\u0026UserName=" + this.proxy.FormatUriArgument(args.UserName) + "\u0026Password=" + this.proxy.FormatUriArgument(args.Password) + "\u0026FileType=" + this.proxy.FormatUriArgument(args.FileType) + "", args);
                };
                Client.prototype.PaymentDaemonProcessWithProviders = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "PaymentDaemonProcessWithProviders/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026FileType=" + this.proxy.FormatUriArgument(args.FileType) + "", args);
                };
                Client.prototype.CreditCardCCVEnable = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IPayment", "CreditCardCCVEnabe/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.AccountPaymentMethodOnlineRegister = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IPayment", "AccountPaymentMethodOnlineRegister", args);
                };
                Client.prototype.AccountPaymentMethodOnlineComplete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IPayment", "AccountPaymentMethodOnlineComplete", args);
                };
                return Client;
            }(ServiceClientBase));
            IPayment.Client = Client;
        })(IPayment = SelcommWebService.IPayment || (SelcommWebService.IPayment = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IProducts;
        (function (IProducts) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.ProductType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "ProductType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ProductTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "ProductTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.Product = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "Product/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Code=" + this.proxy.FormatUriArgument(args.Code) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ProductListByProductType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IProducts", "ProductListByProductType", args);
                };
                Client.prototype.ProductList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "ProductList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ProductListByPackageCodeAndOption = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "ProductListByPackageCodeAndOption/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026PackageOption=" + this.proxy.FormatUriArgument(args.PackageOption) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.BrandDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "BrandDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.BrandListByPackageCodeAndOption = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "BrandListByPackageCodeAndOption/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PackageCode=" + this.proxy.FormatUriArgument(args.PackageCode) + "\u0026PackageOption=" + this.proxy.FormatUriArgument(args.PackageOption) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ProductDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "ProductDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BrandId=" + this.proxy.FormatUriArgument(args.BrandId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PlanProductList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IProducts", "PlanProductList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.HardwareProductList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IProducts", "HardwareProductList?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ProductPackageOption = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "ProductPackageOption/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ProductCode=" + this.proxy.FormatUriArgument(args.ProductCode) + "", args);
                };
                Client.prototype.ProductPlanCharges = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IProducts", "ProductPlanCharges/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ProductCode=" + this.proxy.FormatUriArgument(args.ProductCode) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IProducts.Client = Client;
        })(IProducts = SelcommWebService.IProducts || (SelcommWebService.IProducts = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IRecharge;
        (function (IRecharge) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.RechargeBatchActivate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeBatchActivate", args);
                };
                Client.prototype.RechargeBatchDespatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeBatchDespatch", args);
                };
                Client.prototype.RechargeBatchReceive = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeBatchReceive", args);
                };
                Client.prototype.RechargeBatchChangeStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeBatchChangeStatus", args);
                };
                Client.prototype.RechargeBatchNote = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeBatchNote", args);
                };
                Client.prototype.RechargeBatchCancel = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeBatchCancel", args);
                };
                Client.prototype.RechargeBatchEventList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBatchEventList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BatchId=" + this.proxy.FormatUriArgument(args.BatchId) + "", args);
                };
                Client.prototype.RechargePricingRequest = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePricingRequest", args);
                };
                Client.prototype.RechargePricingRequestForSingleUsageTransactionItem = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePricingRequestForSingleUsageTransactionItem/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ItemCode=" + this.proxy.FormatUriArgument(args.ItemCode) + "\u0026Quantity=" + this.proxy.FormatUriArgument(args.Quantity) + "\u0026PromotionCode=" + this.proxy.FormatUriArgument(args.PromotionCode) + "", args);
                };
                Client.prototype.RechargePricingRequestForSingleChargeItem = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePricingRequestForSingleChargeItem/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ItemCode=" + this.proxy.FormatUriArgument(args.ItemCode) + "\u0026Quantity=" + this.proxy.FormatUriArgument(args.Quantity) + "\u0026PromotionCode=" + this.proxy.FormatUriArgument(args.PromotionCode) + "", args);
                };
                Client.prototype.RechargePricingRequestForSingleHardwareItem = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePricingRequestForSingleHardwareItem/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ItemCode=" + this.proxy.FormatUriArgument(args.ItemCode) + "\u0026Quantity=" + this.proxy.FormatUriArgument(args.Quantity) + "\u0026PromotionCode=" + this.proxy.FormatUriArgument(args.PromotionCode) + "", args);
                };
                Client.prototype.RechargePricingRequestForSingleOtherItem = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePricingRequestForSingleOtherItem/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ItemCode=" + this.proxy.FormatUriArgument(args.ItemCode) + "\u0026Quantity=" + this.proxy.FormatUriArgument(args.Quantity) + "\u0026PromotionCode=" + this.proxy.FormatUriArgument(args.PromotionCode) + "", args);
                };
                Client.prototype.RechargePricingRequestLoadById = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePricingRequestLoadById/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargePricingRequestList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePricingRequestList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.RechargePricingRequestListForRecharge = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePricingRequestListForRecharge/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeId=" + this.proxy.FormatUriArgument(args.RechargeId) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.RechargePricingRequestListForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePricingRequestListForService/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.RechargePricingRequestListForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePricingRequestListForAccount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.RechargeAutomaticPurchase = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeAutomaticPurchase/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeAutomaticPurchaseListForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeAutomaticPurchaseListForAccount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountCode=" + this.proxy.FormatUriArgument(args.AccountCode) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "", args);
                };
                Client.prototype.RechargeAutomaticPurchaseListForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeAutomaticPurchaseListForService/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "", args);
                };
                Client.prototype.RechargeAutomaticPurchaseAddForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAutomaticPurchaseAddForAccount", args);
                };
                Client.prototype.RechargeAutomaticPurchaseAddForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAutomaticPurchaseAddForService", args);
                };
                Client.prototype.RechargeAutomaticPurchaseCancel = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeAutomaticPurchaseUpdate", args);
                };
                Client.prototype.RechargeAutomaticPurchaseTriggerForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAutomaticPurchaseTriggerForAccount", args);
                };
                Client.prototype.RechargeAutomaticPurchaseStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeAutomaticPurchaseStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeAutomaticPurchaseStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeAutomaticPurchaseStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeIncludedElementBundle = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeIncludedElementBundle/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeTypeId=" + this.proxy.FormatUriArgument(args.RechargeTypeId) + "\u0026ElementId=" + this.proxy.FormatUriArgument(args.ElementId) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeFinancialTransactionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeFinancialTransactionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeId=" + this.proxy.FormatUriArgument(args.RechargeId) + "", args);
                };
                Client.prototype.RechargeSmsAccountPinAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeSmsAccountPinAdd", args);
                };
                Client.prototype.RechargeSmsAccountPinUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeSmsAccountPinUpdate", args);
                };
                Client.prototype.RechargeSmsAccountPinDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeSmsAccountPinDelete", args);
                };
                Client.prototype.RechargeSmsServiceActivate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeSmsServiceActivate", args);
                };
                Client.prototype.RechargeSmsServiceDeactivate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeSmsServiceDeactivate", args);
                };
                Client.prototype.RechargeSmsAccountPinVerify = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeSmsAccountPinVerify/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountCode=" + this.proxy.FormatUriArgument(args.AccountCode) + "\u0026PIN=" + this.proxy.FormatUriArgument(args.PIN) + "", args);
                };
                Client.prototype.RechargeSmsServiceStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeSMSServiceStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "", args);
                };
                Client.prototype.RechargeSendInvoiceToCustomer = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeSendInvoiceToCustomer?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026FinancialTransactionNumber=" + this.proxy.FormatUriArgument(args.FinancialTransactionNumber) + "", args);
                };
                Client.prototype.RechargeElementEvent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeElementEvent/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EventReference=" + this.proxy.FormatUriArgument(args.EventReference) + "", args);
                };
                Client.prototype.RechargeElementInstanceUpdateNetwork = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeElementInstanceUpdateNetwork", args);
                };
                Client.prototype.RechargeElementInstanceUpdateExpiryDate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeElementInstanceUpdateExpiryDate", args);
                };
                Client.prototype.RechargeElementInstanceUpdateEndDate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeElementInstanceUpdateEndDate", args);
                };
                Client.prototype.RechargeAutoRenew = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeAutoRenew/?ProviderCode=" + this.proxy.FormatUriArgument(args.ProviderCode) + "", args);
                };
                Client.prototype.RechargeTypeRulesMatrixList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeRulesMatrixList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeTypeId=" + this.proxy.FormatUriArgument(args.RechargeTypeId) + "", args);
                };
                Client.prototype.RechargeTypeElementRulesMatrixList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeElementRulesMatrixList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeTypeId=" + this.proxy.FormatUriArgument(args.RechargeTypeId) + "", args);
                };
                Client.prototype.RechargeNewRechargeActions = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeNewRechargeActions/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeTypeId=" + this.proxy.FormatUriArgument(args.RechargeTypeId) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "\u0026CreateEvent=" + this.proxy.FormatUriArgument(args.CreateEvent) + "\u0026NewRechargeStartDate=" + this.proxy.FormatUriArgument(args.NewRechargeStartDate) + "", args);
                };
                Client.prototype.RechargeUpdateStatusToExpire = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeUpdateStatusToExpire/?ProviderCode=" + this.proxy.FormatUriArgument(args.ProviderCode) + "", args);
                };
                Client.prototype.RechargeElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeElement/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeElementList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeElementList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeElementAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeElementAdd", args);
                };
                Client.prototype.RechargeElementUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeElementUpdate", args);
                };
                Client.prototype.RechargeElementDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeElementDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeCategory = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeCategory/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeCategoryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeCategoryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeCategoryListForBusinessUnit = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeCategoryListForBusinessUnit/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeCategoryAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeCategoryAdd", args);
                };
                Client.prototype.RechargeCategoryUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeCategoryUpdate", args);
                };
                Client.prototype.RechargeCategoryDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeCategoryDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TypeId=" + this.proxy.FormatUriArgument(args.TypeId) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026AccountCode=" + this.proxy.FormatUriArgument(args.AccountCode) + "", args);
                };
                Client.prototype.RechargeTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeTypeListByCategory = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeListByCategory/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CategoryId=" + this.proxy.FormatUriArgument(args.CategoryId) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeTypeListByStore = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeListByStore/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeTypeListByDealers = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeListByDealers/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeTypeListByVNOs = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeListByVNOs/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeTypeListByOnLine = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeListByOnLine/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeTypeListByNewCustomers = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeListByNewCustomers/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeTypeListForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeListForAccount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountCode=" + this.proxy.FormatUriArgument(args.AccountCode) + "\u0026CategoryId=" + this.proxy.FormatUriArgument(args.CategoryId) + "\u0026CurrentOnly=" + this.proxy.FormatUriArgument(args.CurrentOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeTypeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeTypeAdd", args);
                };
                Client.prototype.RechargeTypeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeTypeUpdate", args);
                };
                Client.prototype.RechargeTypeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeTypeDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeTypeElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeElement/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TypeId=" + this.proxy.FormatUriArgument(args.TypeId) + "\u0026ElementId=" + this.proxy.FormatUriArgument(args.ElementId) + "", args);
                };
                Client.prototype.RechargeTypeElementList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeTypeElementList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TypeId=" + this.proxy.FormatUriArgument(args.TypeId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeTypeElementAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeTypeElementAdd", args);
                };
                Client.prototype.RechargeTypeElementUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeTypeElementUpdate", args);
                };
                Client.prototype.RechargeTypeElementDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeTypeElementDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TypeId=" + this.proxy.FormatUriArgument(args.TypeId) + "\u0026ElementId=" + this.proxy.FormatUriArgument(args.ElementId) + "", args);
                };
                Client.prototype.RechargeStatusAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeStatusAdd", args);
                };
                Client.prototype.RechargeStatusUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeStatusUpdate", args);
                };
                Client.prototype.RechargeStatusDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeStatusDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeStatusReason = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeStatusReason/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeStatusReasonList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeReasonList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeStatusReasonAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeStatusReasonAdd", args);
                };
                Client.prototype.RechargeStatusReasonUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeStatusReasonUpdate", args);
                };
                Client.prototype.RechargeStatusReasonDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeStatusReasonDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeBalanceForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBalanceForAccount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountCode=" + this.proxy.FormatUriArgument(args.AccountCode) + "", args);
                };
                Client.prototype.RechargeBalanceForServiceNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBalanceForServiceNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceNumber=" + this.proxy.FormatUriArgument(args.ServiceNumber) + "", args);
                };
                Client.prototype.RechargeBalanceForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBalanceForService/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "", args);
                };
                Client.prototype.RechargeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAdd", args);
                };
                Client.prototype.RechargeAddForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAddForAccount", args);
                };
                Client.prototype.RechargePaymentAddForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePaymentAddForAccount", args);
                };
                Client.prototype.RechargeAddForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAddForService", args);
                };
                Client.prototype.RechargeAddForServiceNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAddForServiceNumber", args);
                };
                Client.prototype.RechargeAddRequest = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAddRequest", args);
                };
                Client.prototype.RechargeAddForAccountRequest = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAddForAccountRequest", args);
                };
                Client.prototype.RechargeAddForServiceRequest = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAddForServiceRequest", args);
                };
                Client.prototype.RechargeAddForServiceNumberRequest = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAddForServiceNumberRequest", args);
                };
                Client.prototype.RechargePaymentRequestCreate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePaymentRequestCreate", args);
                };
                Client.prototype.RechargePaymentRequestSimpleByCreditCard = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePaymentRequestSimpleByCreditCard", args);
                };
                Client.prototype.RechargePaymentRequestSimpleByPaymentMethod = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePaymentRequestSimpleByPaymentMethod", args);
                };
                Client.prototype.RechargePaymentRequestForServiceSimpleByPaymentMethod = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePaymentRequestForServiceSimpleByPaymentMethod", args);
                };
                Client.prototype.RechargePaymentRequestSimpleByDefaultPaymentMethod = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePaymentRequestSimpleByDefaultPaymentMethod", args);
                };
                Client.prototype.RechargeCreditAddForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeCreditAddForAccount", args);
                };
                Client.prototype.Recharge = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "Recharge/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeId=" + this.proxy.FormatUriArgument(args.RechargeId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeByFinancialReceiptNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeByFinancialReceiptNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReceiptNumber=" + this.proxy.FormatUriArgument(args.ReceiptNumber) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeListForContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeListForContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "", args);
                };
                Client.prototype.RechargeListForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeListForService/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "", args);
                };
                Client.prototype.RechargeListForServiceNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeListForServiceNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceNumber=" + this.proxy.FormatUriArgument(args.ServiceNumber) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeListUnAssigned = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeListUnAssigned/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeListForChannelPartner = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeListForChannelPartner/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeListForBatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeListForBatch/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BatchId=" + this.proxy.FormatUriArgument(args.BatchId) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeListAddForServiceReference = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeListAddForServiceReference", args);
                };
                Client.prototype.RechargeListAddForServiceNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeListAddForServiceNumber", args);
                };
                Client.prototype.RechargeServiceReAssignment = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeServiceReAssignment", args);
                };
                Client.prototype.RechargeAccountReAssignment = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeAccountReAssignment", args);
                };
                Client.prototype.RechargeServiceAssignmentHistoryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeServiceAssignmentHistoryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeId=" + this.proxy.FormatUriArgument(args.RechargeId) + "", args);
                };
                Client.prototype.RechargeCancel = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeCancel", args);
                };
                Client.prototype.RechargeSuspend = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeSuspend", args);
                };
                Client.prototype.RechargeUnSuspend = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeUnSuspend", args);
                };
                Client.prototype.RechargeChangeExpiryDateTime = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeChangeExpiryDateTime", args);
                };
                Client.prototype.RechargeChangeStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeChangeStatus", args);
                };
                Client.prototype.RechargeActivate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeActivate", args);
                };
                Client.prototype.RechargeDeliver = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeDeliver", args);
                };
                Client.prototype.RechargeIssue = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeIssue", args);
                };
                Client.prototype.RechargeEventList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeEventList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeId=" + this.proxy.FormatUriArgument(args.RechargeId) + "", args);
                };
                Client.prototype.RechargeSuggestRechargeSingleton = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeSuggestRechargeSingleton/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ElementId=" + this.proxy.FormatUriArgument(args.ElementId) + "\u0026Amount=" + this.proxy.FormatUriArgument(args.Amount) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026RechargeCategoryId=" + this.proxy.FormatUriArgument(args.RechargeCategoryId) + "", args);
                };
                Client.prototype.RechargeCustomPricingAddForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeCustomPricingAddForAccount", args);
                };
                Client.prototype.RechargeCustomPricingDeleteForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeCustomPricingDeleteForAccount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "", args);
                };
                Client.prototype.RechargeCustomPricingForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeCustomPricingForAccount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargePreAuthorisation = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePreAuthorisation/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargePreAuthorisationList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePreAuthorisationList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargePreAuthorisationListForCustomer = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePreAuthorisationListForCustomer/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountCode=" + this.proxy.FormatUriArgument(args.AccountCode) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026CountTotalRecords=" + this.proxy.FormatUriArgument(args.CountTotalRecords) + "", args);
                };
                Client.prototype.RechargePreAuthorisationListForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePreAuthorisationListForService/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargePreAuthorisationListForRecharge = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePreAuthorisationListForRecharge/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeId=" + this.proxy.FormatUriArgument(args.RechargeId) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargePreAuthorisationListForRechargeElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargePreAuthorisationListForRechargeElement/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeId=" + this.proxy.FormatUriArgument(args.RechargeId) + "\u0026ElementId=" + this.proxy.FormatUriArgument(args.ElementId) + "\u0026OpenOnly=" + this.proxy.FormatUriArgument(args.OpenOnly) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargePreAuthorisationAddForMainCurrency = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePreAuthorisationAddForMainCurrency", args);
                };
                Client.prototype.RechargePreAuthorisationAddForElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePreAuthorisationAddForElement", args);
                };
                Client.prototype.RechargePreAuthorisationAddForCustomerMainCurrency = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePreAuthorisationAddForCustomerMainCurrency", args);
                };
                Client.prototype.RechargePreAuthorisationAddForCustomerElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePreAuthorisationAddForCustomerElement", args);
                };
                Client.prototype.RechargePreAuthorisationAddForServiceMainCurrency = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePreAuthorisationAddForServiceMainCurrency", args);
                };
                Client.prototype.RechargePreAuthorisationAddForServiceElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePreAuthorisationAddForServiceElement", args);
                };
                Client.prototype.RechargePreAuthorisationCancel = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePreAuthorisationCancel", args);
                };
                Client.prototype.RechargePreAuthorisationRelease = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePreAuthorisationRelease", args);
                };
                Client.prototype.RechargePreAuthorisationSettle = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargePreAuthorisationSettle", args);
                };
                Client.prototype.RechargeConsumeTransactionAddForPreAuthorisation = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeConsumeTransactionAddForPreAuthorisation", args);
                };
                Client.prototype.RechargeConsumeTransaction = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeConsumeTransaction/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeConsumeTransactionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeConsumeTransactionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeConsumeTransactionListForCustomer = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeConsumeTransactionListForCustomer/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountCode=" + this.proxy.FormatUriArgument(args.AccountCode) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeConsumeTransactionListForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeConsumeTransactionListForService/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeConsumeTransactionListForRecharge = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeConsumeTransactionListForRecharge/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeId=" + this.proxy.FormatUriArgument(args.RechargeId) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeConsumeTransactionListForRechargeElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeConsumeTransactionListForRechargeElement/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RechargeId=" + this.proxy.FormatUriArgument(args.RechargeId) + "\u0026ElementId=" + this.proxy.FormatUriArgument(args.ElementId) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeConsumeTransactionAddForMainCurrency = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeConsumeTransactionAddForMainCurrency", args);
                };
                Client.prototype.RechargeConsumeTransactionAddForElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeConsumeTransactionAddForElement", args);
                };
                Client.prototype.RechargeConsumeTransactionAddForCustomerMainCurrency = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeConsumeTransactionAddForCustomerMainCurrency", args);
                };
                Client.prototype.RechargeConsumeTransactionAddForCustomerElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeConsumeTransactionAddForCustomerElement", args);
                };
                Client.prototype.RechargeConsumeTransactionAddForServiceMainCurrency = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeConsumeTransactionAddForServiceMainCurrency", args);
                };
                Client.prototype.RechargeConsumeTransactionAddForServiceElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeConsumeTransactionAddForServiceElement", args);
                };
                Client.prototype.RechargeBatchStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBatchStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeBatchStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBatchStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeBatchStatusAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeBatchStatusAdd", args);
                };
                Client.prototype.RechargeBatchStatusUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeBatchStatusUpdate", args);
                };
                Client.prototype.RechargeBatchStatusDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeBatchStatusDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeBatchStatusReason = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBatchStatusReason/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeBatchStatusReasonList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBatchStatusReasonList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RechargeBatchStatusReasonAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeBatchStatusReasonAdd", args);
                };
                Client.prototype.RechargeBatchStatusReasonUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeStatusBatchReasonUpdate", args);
                };
                Client.prototype.RechargeBatchStatusReasonDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeStatusBatchReasonDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeBatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBatch/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeBatchList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBatchList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026BusinessUnitCode=" + this.proxy.FormatUriArgument(args.BusinessUnitCode) + "", args);
                };
                Client.prototype.RechargeBatchAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRecharge", "RechargeBatchAdd", args);
                };
                Client.prototype.RechargeBatchUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeBatchUpdate", args);
                };
                Client.prototype.RechargeBatchDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRecharge", "RechargeBatchDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RechargeBatchCreateRecharges = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRecharge", "RechargeBatchCreateRecharges", args);
                };
                Client.prototype.RechargeBatchFileDownload = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRecharge", "RechargeBatchFileDownload/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026FileFileFormatName=" + this.proxy.FormatUriArgument(args.FileFileFormatName) + "\u0026FileFormatVersion=" + this.proxy.FormatUriArgument(args.FileFormatVersion) + "\u0026Note=" + this.proxy.FormatUriArgument(args.Note) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IRecharge.Client = Client;
        })(IRecharge = SelcommWebService.IRecharge || (SelcommWebService.IRecharge = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IReports;
        (function (IReports) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.ReportAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "ReportAdd", args);
                };
                Client.prototype.ReportUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IReports", "ReportUpdate", args);
                };
                Client.prototype.ReportDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IReports", "ReportDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "", args);
                };
                Client.prototype.Report = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "Report/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "", args);
                };
                Client.prototype.ReportList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "ReportList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ReportListByCategoryId = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportListByCategoryId/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CategoryId=" + this.proxy.FormatUriArgument(args.CategoryId) + "", args);
                };
                Client.prototype.ReportListByContactCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportListByContactCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ReportListByServiceTypeCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportListByServiceTypeCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "", args);
                };
                Client.prototype.ReportParameterList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportParameterList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "", args);
                };
                Client.prototype.ReportEmailList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportEmailList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "", args);
                };
                Client.prototype.ReportFormatAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "ReportFormatAdd", args);
                };
                Client.prototype.ReportFormatUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IReports", "ReportFormatUpdate", args);
                };
                Client.prototype.ReportFormatDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IReports", "ReportFormatDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "", args);
                };
                Client.prototype.ReportFormatAddForContactCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "ReportFormatAddForContactCode", args);
                };
                Client.prototype.ReportFormatUpdateForContactCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IReports", "ReportFormatUpdateForContactCode", args);
                };
                Client.prototype.ReportFormatDeleteForContactCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IReports", "ReportFormatDeleteForContactCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ScheduledReportAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "ScheduledReportAdd", args);
                };
                Client.prototype.ScheduledReportUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IReports", "ScheduledReportUpdate", args);
                };
                Client.prototype.ScheduledReportDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IReports", "ScheduledReportDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ScheduleId=" + this.proxy.FormatUriArgument(args.ScheduleId) + "", args);
                };
                Client.prototype.ScheduledReport = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ScheduledReport/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ScheduleId=" + this.proxy.FormatUriArgument(args.ScheduleId) + "", args);
                };
                Client.prototype.ScheduledReportListAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "ScheduledReportListAdd", args);
                };
                Client.prototype.ScheduledReportList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ScheduledReportList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ScheduledReportListByReportId = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ScheduledReportListByReportId/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "", args);
                };
                Client.prototype.ScheduledReportListByContactCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ScheduledReportListByContactCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ReportListByServiceId = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportListByServiceId/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ScheduledReportParameterList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ScheduledReportParameterList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ScheduleId=" + this.proxy.FormatUriArgument(args.ScheduleId) + "", args);
                };
                Client.prototype.ScheduledReportEmailList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ScheduledReportEmailList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ScheduleId=" + this.proxy.FormatUriArgument(args.ScheduleId) + "", args);
                };
                Client.prototype.ScheduledReportsByReportAndState = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "ScheduledReportsByReportAndState", args);
                };
                Client.prototype.RequestedReportAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "RequestedReportAdd", args);
                };
                Client.prototype.RequestedReportUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "RequestedReportUpdate", args);
                };
                Client.prototype.RequestedReportRun = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "RequestedReportRun", args);
                };
                Client.prototype.RequestedReportDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IReports", "RequestedReportDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RequestId=" + this.proxy.FormatUriArgument(args.RequestId) + "", args);
                };
                Client.prototype.RequestedReport = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReport/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RequestId=" + this.proxy.FormatUriArgument(args.RequestId) + "", args);
                };
                Client.prototype.RequestedReportListForReport = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportListForReport/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "", args);
                };
                Client.prototype.UnscheduledRequestedReportList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "UnscheduledRequestedReportList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "", args);
                };
                Client.prototype.RequestedReportListForScheduledReport = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportListForScheduledReport/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ScheduledID=" + this.proxy.FormatUriArgument(args.ScheduledId) + "", args);
                };
                Client.prototype.RequestedReportListByContactCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportListByContactCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.RequestedReportDisplayListByReportIdContactCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportDisplayListByReportIdContactCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.RequestedReportDisplayListByReportId = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportDisplayListByReportId/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.RequestedReportListByServiceId = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportListByServiceId/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.RequestedReportParameterList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportParameterList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RequestId=" + this.proxy.FormatUriArgument(args.RequestId) + "", args);
                };
                Client.prototype.RequestedReportEmailList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportEmailList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RequestId=" + this.proxy.FormatUriArgument(args.RequestId) + "", args);
                };
                Client.prototype.RequestedReportDownloadAsString = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportDownloadAsString/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RequestId=" + this.proxy.FormatUriArgument(args.RequestId) + "", args);
                };
                Client.prototype.RequestedReportDownloadAsByte = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportDownloadAsByte/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RequestId=" + this.proxy.FormatUriArgument(args.RequestId) + "", args);
                };
                Client.prototype.ReportRequestedDownload = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportRequestedDownload/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RequestId=" + this.proxy.FormatUriArgument(args.RequestId) + "\u0026ReportOutputFileType=" + this.proxy.FormatUriArgument(args.ReportOutputFileType) + "", args);
                };
                Client.prototype.OnDemandRequestedReports = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "OnDemandRequestedReports/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReportId=" + this.proxy.FormatUriArgument(args.ReportId) + "", args);
                };
                Client.prototype.ReportGroupAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "ReportGroupAdd", args);
                };
                Client.prototype.ReportGroupUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IReports", "ReportGroupUpdate", args);
                };
                Client.prototype.ReportGroupDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IReports", "ReportGroupDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.ReportGroup = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportGroup/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.ReportGroupList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportGroupList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ReportCategoryAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "ReportCategoryAdd", args);
                };
                Client.prototype.ReportCategoryUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IReports", "ReportCategoryUpdate", args);
                };
                Client.prototype.ReportCategoryDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IReports", "ReportCategoryDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.ReportCategory = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportCategory/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.ReportCategoryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportCategoryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.RequestedReportStatusAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IReports", "RequestedReportStatusAdd", args);
                };
                Client.prototype.RequestedReportStatusUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IReports", "RequestedReportStatusUpdate", args);
                };
                Client.prototype.RequestedReportStatusDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IReports", "RequestedReportStatusDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RequestedReportStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RequestedReportStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "RequestedReportStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ReportPeriodList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IReports", "ReportPeriodList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IReports.Client = Client;
        })(IReports = SelcommWebService.IReports || (SelcommWebService.IReports = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IRoles;
        (function (IRoles) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.RoleAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IRoles", "RoleAdd", args);
                };
                Client.prototype.RoleUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IRoles", "RoleUpdate", args);
                };
                Client.prototype.RoleDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IRoles", "RoleDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.Role = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRoles", "RoleDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.RoleConfiguration = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRoles", "RoleConfiguration/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.RoleList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRoles", "RoleList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.RoleListObjectPermission = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IRoles", "RoleListObjectPermission/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ObjectID=" + this.proxy.FormatUriArgument(args.ObjectID) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IRoles.Client = Client;
        })(IRoles = SelcommWebService.IRoles || (SelcommWebService.IRoles = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IService;
        (function (IService) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.ValueAddedServiceAddRequestAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ValueAddedServiceRequestAdd", args);
                };
                Client.prototype.ValueAddedServiceDeleteRequestAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ValueAddedServiceDeleteRequest", args);
                };
                Client.prototype.ServiceValueAddedServiceList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceValueAddedServiceList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceValueAddedServiceAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceValueAddedServiceAdd", args);
                };
                Client.prototype.ServiceValueAddedServiceUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceValueAddedServiceUpdate", args);
                };
                Client.prototype.ServiceValueAddedServiceDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceValueAddedServiceDelete", args);
                };
                Client.prototype.ServiceWinbackList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceWinbackList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceWinbackAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceWinbackAdd", args);
                };
                Client.prototype.ServiceWinbackUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceWinbackUpdate", args);
                };
                Client.prototype.ServiceWinbackDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceWinbackDelete", args);
                };
                Client.prototype.ServiceIMEILoad = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceIMEILoad/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceUsageGraphDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceUsageGraphDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceRef=" + this.proxy.FormatUriArgument(args.ServiceRef) + "", args);
                };
                Client.prototype.ServiceUsageGraphDisplayListByBillPeriod = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceUsageGraphDisplayListByBillPeriod/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceRef=" + this.proxy.FormatUriArgument(args.ServiceRef) + "\u0026BillPeriod=" + this.proxy.FormatUriArgument(args.BillPeriod) + "", args);
                };
                Client.prototype.ServiceUsageDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceUsageDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceID=" + this.proxy.FormatUriArgument(args.ServiceID) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026SearchTerm=" + this.proxy.FormatUriArgument(args.SearchTerm) + "\u0026SortBy=" + this.proxy.FormatUriArgument(args.SortBy) + "\u0026SortOrder=" + this.proxy.FormatUriArgument(args.SortOrder) + "\u0026currUsgPeriod=" + this.proxy.FormatUriArgument(args.currUsgPeriod) + "", args);
                };
                Client.prototype.UsageTransactionDisplayListForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "UsageTransactionDisplayListForService", args);
                };
                Client.prototype.NetworkUsageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "NetworkUsageList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceNumber=" + this.proxy.FormatUriArgument(args.ServiceNumber) + "", args);
                };
                Client.prototype.NonDiscountedUsageDisplayListForBillPeriod = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "NonDiscountedUsageDisplayListForBillPeriod/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceRef=" + this.proxy.FormatUriArgument(args.ServiceRef) + "\u0026BillPeriod=" + this.proxy.FormatUriArgument(args.BillPeriod) + "", args);
                };
                Client.prototype.NonDiscountedUsageDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "NonDiscountedUsageDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceRef=" + this.proxy.FormatUriArgument(args.ServiceRef) + "", args);
                };
                Client.prototype.ServiceType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "", args);
                };
                Client.prototype.ServiceTypeByService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceTypeByService/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceNumber=" + this.proxy.FormatUriArgument(args.ServiceNumber) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "", args);
                };
                Client.prototype.ServiceTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ServiceTypeDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceTypeDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ServiceTypeListForOrder = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceTypeListForOrder/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.UnitList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "UnitList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ServicePackageDefault = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePackageDefault/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ServicePackageListCurrent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePackageListCurrent/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ServicePackageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePackageList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ServiceNetworkStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "", args);
                };
                Client.prototype.ServiceNetworkPortStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkPortStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "", args);
                };
                Client.prototype.ServiceNetworkStatusByContactAndPhoneNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkStatusByContactAndPhoneNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PhoneNumber=" + this.proxy.FormatUriArgument(args.PhoneNumber) + "", args);
                };
                Client.prototype.ServiceNetworkBalance = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkBalance/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "", args);
                };
                Client.prototype.ServiceNetworkBalanceByContactAndPhoneNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkBalanceByContactAndPhoneNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PhoneNumber=" + this.proxy.FormatUriArgument(args.PhoneNumber) + "", args);
                };
                Client.prototype.ServiceNetworkNotifications = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkNotifications/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "", args);
                };
                Client.prototype.DocumentLoad = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "DocumentLoad/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.DocumentAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "DocumentAdd", args);
                };
                Client.prototype.DocumentUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "DocumentUpdate", args);
                };
                Client.prototype.DocumentDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "DocumentDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.DocumentValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "DocumentValidate", args);
                };
                Client.prototype.ServiceEquipmentList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceEquipmentList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceEquipmentAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceEquipmentAdd", args);
                };
                Client.prototype.ServiceEquipmentUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceEquipmentUpdate", args);
                };
                Client.prototype.ServiceEquipmentDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceEquipmentDelete", args);
                };
                Client.prototype.ServiceEventList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceEventList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceEventAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceEventAdd", args);
                };
                Client.prototype.ServiceEventUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceEventUpdate", args);
                };
                Client.prototype.ServiceEventConnectionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceEventConnectionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceInvoiceInterval = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceInvoiceInterval/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceInvoiceIntervalAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceInvoiceIntervalAdd", args);
                };
                Client.prototype.ServiceInvoiceIntervalUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceInvoiceIntervalUpdate", args);
                };
                Client.prototype.ServiceInvoiceIntervalDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceInvoiceIntervalDelete", args);
                };
                Client.prototype.ServiceLocationList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceLocationList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceLocationAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceLocationAdd", args);
                };
                Client.prototype.ServiceLocationUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceLocationUpdate", args);
                };
                Client.prototype.ServiceLocationDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceLocationDelete", args);
                };
                Client.prototype.ServiceNetworkList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceNetworkAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceNetworkAdd", args);
                };
                Client.prototype.ServiceNetworkUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceNetworkUpdate", args);
                };
                Client.prototype.ServiceNetworkDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceNetworkDelete", args);
                };
                Client.prototype.ServiceNetworkActionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkActionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceNetworkActionAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceNetworkActionAdd", args);
                };
                Client.prototype.ServiceNetworkActionUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceNetworkActionUpdate", args);
                };
                Client.prototype.ServiceNetworkActionDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceNetworkActionDelete", args);
                };
                Client.prototype.ServiceNetworkElementList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkElementList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceNetworkElementAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceNetworkElementAdd", args);
                };
                Client.prototype.ServiceNetworkElementUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceNetworkElementUpdate", args);
                };
                Client.prototype.ServiceNetworkElementDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceNetworkElementDelete", args);
                };
                Client.prototype.ServiceNetworkIdentifierList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNetworkIdentifierList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceNetworkIdentifierAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceNetworkIdentifierAdd", args);
                };
                Client.prototype.ServiceNetworkIdentifierUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceNetworkIdentifierUpdate", args);
                };
                Client.prototype.ServiceNetworkIdentifierDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceNetworkIdentifierDelete", args);
                };
                Client.prototype.ServiceNoteList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceNoteList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceNoteAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceNoteAdd", args);
                };
                Client.prototype.ServiceNoteUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceNoteUpdate", args);
                };
                Client.prototype.ServiceNoteDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceNoteDelete", args);
                };
                Client.prototype.ServiceOrderList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceOrderList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceOrderAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceOrderAdd", args);
                };
                Client.prototype.ServiceOrderUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceOrderUpdate", args);
                };
                Client.prototype.ServiceOrderDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceOrderDelete", args);
                };
                Client.prototype.ServicePackageByService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServicePackageByService", args);
                };
                Client.prototype.ServicePackageChangeRequestList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePackageChangeRequestList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServicePackageChangeRequestAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServicePackageChangeRequestAdd", args);
                };
                Client.prototype.ServicePackageChangeRequestUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServicePackageChangeRequestUpdate", args);
                };
                Client.prototype.ServicePackageChangeRequestDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServicePackageChangeRequestDelete", args);
                };
                Client.prototype.ServiceParent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceParent/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServicePasswordList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePasswordList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServicePasswordAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServicePasswordAdd", args);
                };
                Client.prototype.ServicePasswordUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServicePasswordUpdate", args);
                };
                Client.prototype.ServicePasswordDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServicePasswordDelete", args);
                };
                Client.prototype.ServicePaymentMethodList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePaymentMethodList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServicePaymentMethodAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServicePaymentMethodAdd", args);
                };
                Client.prototype.ServicePaymentMethodUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServicePaymentMethodUpdate", args);
                };
                Client.prototype.ServicePaymentMethodDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServicePaymentMethodDelete", args);
                };
                Client.prototype.ServicePortingInformationList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePortingInformationList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServicePortingInformationAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServicePortingInformationAdd", args);
                };
                Client.prototype.ServicePortingInformationUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServicePortingInformationUpdate", args);
                };
                Client.prototype.ServicePortingInformationDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServicePortingInformationDelete", args);
                };
                Client.prototype.ServicePromotionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePromotionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServicePromotionAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServicePromotionAdd", args);
                };
                Client.prototype.ServicePromotionUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServicePromotionUpdate", args);
                };
                Client.prototype.ServicePromotionDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServicePromotionDelete", args);
                };
                Client.prototype.ServiceRechargeVoucherList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceRechargeVoucherList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceRechargeVoucherAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceRechargeVoucherAdd", args);
                };
                Client.prototype.ServiceRechargeVoucherUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceRechargeVoucherUpdate", args);
                };
                Client.prototype.ServiceRechargeVoucherDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceRechargeVoucherDelete", args);
                };
                Client.prototype.ServiceRegistrationList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceRegistrationList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceRegistrationAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceRegistrationAdd", args);
                };
                Client.prototype.ServiceRegistrationUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceRegistrationUpdate", args);
                };
                Client.prototype.ServiceRegistrationDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceRegistrationDelete", args);
                };
                Client.prototype.ServiceReportList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceReportList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceReportRun = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceReportRun", args);
                };
                Client.prototype.ServiceRetentionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceRetentionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceRetentionAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceRetentionAdd", args);
                };
                Client.prototype.ServiceRetentionUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceRetentionUpdate", args);
                };
                Client.prototype.ServiceRetentionDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceRetentionDelete", args);
                };
                Client.prototype.ServiceSalesPersonList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceSalesPersonList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceSalesPersonAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceSalesPersonAdd", args);
                };
                Client.prototype.ServiceSalesPersonUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceSalesPersonUpdate", args);
                };
                Client.prototype.ServiceSalesPersonDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceSalesPersonDelete", args);
                };
                Client.prototype.ServiceSellOnList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceSellOnList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceSellOnRequestList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceSellOnRequestList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceSellOnRequestAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceSellOnRequestAdd", args);
                };
                Client.prototype.ServiceSellOnRequestUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceSellOnRequestUpdate", args);
                };
                Client.prototype.ServiceSellOnRequestDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceSellOnRequestDelete", args);
                };
                Client.prototype.ServiceElementList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceElementList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceServiceElementAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceServiceElementAdd", args);
                };
                Client.prototype.ServiceServiceElementUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceServiceElementUpdate", args);
                };
                Client.prototype.ServiceServiceElementDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceServiceElementDelete", args);
                };
                Client.prototype.ServiceSiteList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceSiteList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceSiteAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceSiteAdd", args);
                };
                Client.prototype.ServiceSiteUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceSiteUpdate", args);
                };
                Client.prototype.ServiceSiteDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceSiteDelete", args);
                };
                Client.prototype.SimUsageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "SimUsageList", args);
                };
                Client.prototype.ServiceStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceSystemStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceSystemStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceStatusUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceStatusUpdate", args);
                };
                Client.prototype.ServiceStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceRef=" + this.proxy.FormatUriArgument(args.ServiceRef) + "", args);
                };
                Client.prototype.ServiceSubscriber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceSubscriber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceSuspensionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceSuspensionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceSuspensionRequestList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceSuspensionRequestList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceSuspensionRequestAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceSuspensionRequestAdd", args);
                };
                Client.prototype.ServiceSuspensionRequestUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceSuspensionRequestUpdate", args);
                };
                Client.prototype.ServiceSuspensionRequestDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceSuspensionRequestDelete", args);
                };
                Client.prototype.ServiceTaskList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceTaskList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceTaskAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceTaskAdd", args);
                };
                Client.prototype.ServiceTaskUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceTaskUpdate", args);
                };
                Client.prototype.ServiceTaskDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceTaskDelete", args);
                };
                Client.prototype.ServicePriceOverrideUsageList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePriceOverrideUsageList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServicePriceOverrideUsageAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServicePriceOverrideUsageAdd", args);
                };
                Client.prototype.ServicePriceOverrideUsageUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServicePriceOverrideUsageUpdate", args);
                };
                Client.prototype.ServicePriceOverrideUsageDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServicePriceOverrideUsageDelete", args);
                };
                Client.prototype.ServiceUsageSummaryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceUsageSummaryList", args);
                };
                Client.prototype.ServiceUsageSummaryListByPackage = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceUsageSummaryListByPackage", args);
                };
                Client.prototype.ServiceUsageSummaryListByUsageType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceUsageSummaryListByUsageType", args);
                };
                Client.prototype.ServiceUsageSummaryListByTimeBandType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceUsageSummaryListByTimeBandType", args);
                };
                Client.prototype.ServiceUserList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceUserList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceUserAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceUserAdd", args);
                };
                Client.prototype.ServiceUserUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceUserUpdate", args);
                };
                Client.prototype.ServiceUserDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceUserDelete", args);
                };
                Client.prototype.ServiceUserLabel = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceUserLabel/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceUserLabelUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceUserLabelUpdate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "\u0026ServiceUserLabel=" + this.proxy.FormatUriArgument(args.ServiceUserLabel) + "", args);
                };
                Client.prototype.ValueAddedServiceAddRequestListAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ValueAddedServiceAddRequestList", args);
                };
                Client.prototype.ServiceAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAdd", args);
                };
                Client.prototype.ServiceAddNewSimple = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAddSimple", args);
                };
                Client.prototype.ServiceAddPortSimple = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAddPortSimple", args);
                };
                Client.prototype.ServiceUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceUpdate", args);
                };
                Client.prototype.ServiceDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceDelete", args);
                };
                Client.prototype.ServiceValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceValidate", args);
                };
                Client.prototype.ServiceIsExists = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceIsExists/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceNumber=" + this.proxy.FormatUriArgument(args.ServiceNumber) + "", args);
                };
                Client.prototype.Service = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "Service/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceConnectionCount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceConnectionCount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "", args);
                };
                Client.prototype.ServiceConnect = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceConnect", args);
                };
                Client.prototype.ServiceDisconnect = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceDisconnect", args);
                };
                Client.prototype.ServiceSimpleDisconnect = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceSimpleDisconnect", args);
                };
                Client.prototype.ServiceDisconnectionRequestAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceDisconnectionRequest", args);
                };
                Client.prototype.ServiceRequestSimChange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceRequestSimChange", args);
                };
                Client.prototype.ServiceCompleteSimChange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceCompleteSimChange", args);
                };
                Client.prototype.ServiceUpdateServiceNarrative = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceUpdateServiceNarrative", args);
                };
                Client.prototype.ServiceUpdateServiceNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceUpdateServiceNumber", args);
                };
                Client.prototype.ServiceListByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceListByContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ServiceListByFilter = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceListByFilter", args);
                };
                Client.prototype.ServiceDisplay = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceDisplay", args);
                };
                Client.prototype.ServiceParentDisplay = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceParentDisplay/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceReference=" + this.proxy.FormatUriArgument(args.ServiceReference) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ServiceDisplayByServiceNumberAndAccountNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceDisplayByServiceNumberAndAccountNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceNumber=" + this.proxy.FormatUriArgument(args.ServiceNumber) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ServiceCountByTypeThenPhase = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceCountByTypeThenPhase/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ServiceDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026LoadDirectChild=" + this.proxy.FormatUriArgument(args.LoadDirectChild) + "", args);
                };
                Client.prototype.ServiceDisplayListByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceDisplayListByContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "\u0026SearchTerm=" + this.proxy.FormatUriArgument(args.SearchTerm) + "\u0026SortBy=" + this.proxy.FormatUriArgument(args.SortBy) + "\u0026SortOrder=" + this.proxy.FormatUriArgument(args.SortOrder) + "", args);
                };
                Client.prototype.ServiceDisplayListByFilter = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceDisplayListByFilter", args);
                };
                Client.prototype.ServiceBarUnbarRequest = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceBarUnbarRequest", args);
                };
                Client.prototype.ServiceBarRequest = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceBarRequest", args);
                };
                Client.prototype.ServiceBarUnbarTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceBarUnbarTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Action=" + this.proxy.FormatUriArgument(args.Action) + "\u0026ServiceNumber=" + this.proxy.FormatUriArgument(args.ServiceNumber) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "", args);
                };
                Client.prototype.ServiceBarTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceBarTypeList", args);
                };
                Client.prototype.ServiceBarTypesList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceBarTypesList", args);
                };
                Client.prototype.ServiceBarReasonList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceBarReasonList", args);
                };
                Client.prototype.ServiceBarList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceBarList", args);
                };
                Client.prototype.ServiceDisplayListByReceiptNumber = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceDisplayListByReceiptNumber/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ReceiptNumber=" + this.proxy.FormatUriArgument(args.ReceiptNumber) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ServiceActionDisplay = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceActionDisplay/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ActionReference=" + this.proxy.FormatUriArgument(args.ActionReference) + "\u0026ServiceType=" + this.proxy.FormatUriArgument(args.ServiceType) + "", args);
                };
                Client.prototype.ServiceActionDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceActionDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Action=" + this.proxy.FormatUriArgument(args.Action) + "\u0026ServiceType=" + this.proxy.FormatUriArgument(args.ServiceType) + "", args);
                };
                Client.prototype.ServiceActionDisplayListByServiceID = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceActionDisplayListByServiceID/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Action=" + this.proxy.FormatUriArgument(args.Action) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceActionDisplayListByService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceActionDisplayListByService/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Action=" + this.proxy.FormatUriArgument(args.Action) + "\u0026ServiceNumber=" + this.proxy.FormatUriArgument(args.ServiceNumber) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "", args);
                };
                Client.prototype.ServiceAddressMoveRequest = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAddressMoveRequest", args);
                };
                Client.prototype.ServiceAvailableAddressesList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAvailableAddressesList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAddressDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAddressDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAddressList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAddressList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAddressExtendedList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAddressExtendedList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAddressListUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAddressListUpdate", args);
                };
                Client.prototype.ServiceAddressExtendedListUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAddressExtendedListUpdate", args);
                };
                Client.prototype.ServiceAddressAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAddressAdd", args);
                };
                Client.prototype.ServiceAddressUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAddressUpdate", args);
                };
                Client.prototype.ServiceAddressDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceAddressDelete", args);
                };
                Client.prototype.ServiceAddressExtendedAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAddressExtendedAdd", args);
                };
                Client.prototype.ServiceAddressExtendedUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAddressExtendedUpdate", args);
                };
                Client.prototype.ServiceAddressExtendedDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceAddressExtendedUpdate", args);
                };
                Client.prototype.ServiceAlertList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAlertList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAlertAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAlertAdd", args);
                };
                Client.prototype.ServiceAlertUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAlertUpdate", args);
                };
                Client.prototype.ServiceAlertDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceAlertDelete", args);
                };
                Client.prototype.ServiceContactList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceContactList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceContactListUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceContactListUpdate", args);
                };
                Client.prototype.ServiceAttributeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAttributeList", args);
                };
                Client.prototype.ServiceAttributeListBySpecificAttribute = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAttributeListBySpecificAttribute", args);
                };
                Client.prototype.ServiceAttribute = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAttribute", args);
                };
                Client.prototype.ServiceAttributeRecent = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAttributeRecent", args);
                };
                Client.prototype.ServiceAttributeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAttributeAdd", args);
                };
                Client.prototype.ServiceAttributeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAttributeUpdate", args);
                };
                Client.prototype.ServiceAttributeUpdateAttribValue2 = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAttributeUpdateAttribValue2", args);
                };
                Client.prototype.ServiceAttributeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceAttributeDelete", args);
                };
                Client.prototype.ServiceAttributeListForOpenServices = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAttributeListForOpenServices/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AttributeTemplateId=" + this.proxy.FormatUriArgument(args.AttributeTemplateId) + "\u0026Value=" + this.proxy.FormatUriArgument(args.Value) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.AuthoriseSessionAccess = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "AuthoriseSessionAccess/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAutoBarList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAutoBarList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAutoBarLogList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAutoBarLogList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAutoBarAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAutoBarAdd", args);
                };
                Client.prototype.ServiceAutoBarUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAutoBarUpdate", args);
                };
                Client.prototype.ServiceAutoBarDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceAutoBarDelete", args);
                };
                Client.prototype.ServiceAutoTopUpList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAutoTopUpList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAutoTopUpLogList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAutoTopUpLogList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAutoTopUpAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAutoTopUpAdd", args);
                };
                Client.prototype.ServiceAutoTopUpUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAutoTopUpUpdate", args);
                };
                Client.prototype.ServiceAutoTopUpDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceAutoTopUpDelete", args);
                };
                Client.prototype.ServiceAvailableNumberList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAvailableNumberList", args);
                };
                Client.prototype.ServiceAvailableNumberListAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceAvailableNumberListAdd", args);
                };
                Client.prototype.ServiceAvailableNumberListUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceAvailableNumberListUpdate", args);
                };
                Client.prototype.ServiceAvailableNumberListDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceAvailableNumberListDelete", args);
                };
                Client.prototype.ServiceBookingList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceBookingList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceBookingAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceBookingAdd", args);
                };
                Client.prototype.ServiceBookingUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceBookingUpdate", args);
                };
                Client.prototype.ServiceBookingDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceBookingDelete", args);
                };
                Client.prototype.ServiceChannelPartnerList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceChannelPartnerList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceChannelPartnerAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceChannelPartnerAdd", args);
                };
                Client.prototype.ServiceChannelPartnerUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceChannelPartnerUpdate", args);
                };
                Client.prototype.ServiceChannelPartnerDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceChannelPartnerDelete", args);
                };
                Client.prototype.ServiceChargeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceChargeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceChargeDefinitionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceChargeDefinitionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceChargeDefinitionAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceChargeDefinitionAdd", args);
                };
                Client.prototype.ServiceChargeDefinitionUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceChargeDefinitionUpdate", args);
                };
                Client.prototype.ServiceChargeDefinitionDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceChargeDefinitionDelete", args);
                };
                Client.prototype.ServicePriceOverrideChargeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServicePriceOverrideChargeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServicePriceOverrideChargeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServicePriceOverrideChargeAdd", args);
                };
                Client.prototype.ServicePriceOverrideChargeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServicePriceOverrideChargeUpdate", args);
                };
                Client.prototype.ServicePriceOverrideChargeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServicePriceOverrideChargeDelete", args);
                };
                Client.prototype.ServiceChildServiceDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceChildServiceDisplayListForContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceChildServiceDisplayListForContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceChildServiceDisplayListForContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceCommissionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceCommissionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceChannelPartnerCommissionPlanList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceChannelPartnerCommissionPlanList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceCommunicationList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceCommunicationList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceCommunicationAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceCommunicationAdd", args);
                };
                Client.prototype.ServiceCommunicationUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceCommunicationUpdate", args);
                };
                Client.prototype.ServiceCommunicationDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceCommunicationDelete", args);
                };
                Client.prototype.ServiceContactPhoneList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceContactPhoneList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceAvailableContactPhonesList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceAvailableContactPhonesList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceContactPhoneAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceContactPhoneAdd", args);
                };
                Client.prototype.ServiceContactPhoneUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceContactPhoneUpdate", args);
                };
                Client.prototype.ServiceContactPhoneDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceContactPhoneDelete", args);
                };
                Client.prototype.ServiceContractList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceContractList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceContractAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceContractAdd", args);
                };
                Client.prototype.ServiceContractUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceContractUpdate", args);
                };
                Client.prototype.ServiceContractDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceContractDelete", args);
                };
                Client.prototype.ServiceCostCentreList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceCostCentreList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceCostCentreAssign = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceCostCentreAssign", args);
                };
                Client.prototype.ServiceCostCentreDeassign = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceCostCentreDeassign", args);
                };
                Client.prototype.ServiceDelegationList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceDelegationList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceDelegationAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceDelegationAdd", args);
                };
                Client.prototype.ServiceDelegationUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceDelegationUpdate", args);
                };
                Client.prototype.ServiceDelegationDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceDelegationDelete", args);
                };
                Client.prototype.ServiceDeviceList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "ServiceDeviceList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.ServiceDeviceAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceDeviceAdd", args);
                };
                Client.prototype.ServiceDeviceUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IService", "ServiceDeviceUpdate", args);
                };
                Client.prototype.ServiceDeviceDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IService", "ServiceDeviceDelete", args);
                };
                Client.prototype.ServiceDiscountAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IService", "ServiceDiscountAdd", args);
                };
                Client.prototype.DisplayDetailsUIAttributeItemList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "DisplayDetailsUIAttributeItemList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                Client.prototype.DocumentDisplayList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IService", "DocumentDisplayList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ServiceId=" + this.proxy.FormatUriArgument(args.ServiceId) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IService.Client = Client;
        })(IService = SelcommWebService.IService || (SelcommWebService.IService = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IAccount;
        (function (IAccount) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Account = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAccount", "Account/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.AccountBillCycle = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAccount", "AccountBillCycle/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.AccountBillCreate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAccount", "AccountBillCreate", args);
                };
                Client.prototype.AccountBalance = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAccount", "AccountBalance/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026IncludeUnbilledUsage=" + this.proxy.FormatUriArgument(args.IncludeUnbilledUsage) + "\u0026IncludeOneOffAndRecurringCharges=" + this.proxy.FormatUriArgument(args.IncludeOneOffAndRecurringCharges) + "", args);
                };
                Client.prototype.AccountBalanceDecrease = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAccount", "AccountBalanceDecrease?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountBalanceIncrease = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAccount", "AccountBalanceIncrease?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AutomaticRechargeConfigurationListByAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAccount", "AutomaticRechargeConfigurationListByAccount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "", args);
                };
                Client.prototype.AutomaticRechargeConfigurationCurrentForAccount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAccount", "AutomaticRechargeConfigurationCurrentForAccount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "", args);
                };
                Client.prototype.AccountAutomaticRechargeConfigurationAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAccount", "AccountAutomaticRechargeConfigurationAdd?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountAutomaticRechargeConfigurationSuspend = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "AccountAutomaticRechargeConfigurationSuspend?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountAutomaticRechargeConfigurationUnSuspend = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "AccountAutomaticRechargeConfigurationUnSuspend?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountAutomaticRechargeConfigurationCancel = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "AccountAutomaticRechargeConfigurationCancel?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.IAccount", "AccountDelete?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountCode=" + this.proxy.FormatUriArgument(args.AccountCode) + "\u0026Note=" + this.proxy.FormatUriArgument(args.Note) + "\u0026DeleteParentAccount=" + this.proxy.FormatUriArgument(args.DeleteParentAccount) + "", args);
                };
                Client.prototype.AccountContractAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAccount", "AccountContractAdd", args);
                };
                Client.prototype.AccountContractUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "AccountContractUpdate", args);
                };
                Client.prototype.AccountPasswordResetRequestKey = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "AccountPasswordResetRequestKey?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountPasswordResetSimpleRequestKey = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAccount", "AccountPasswordResetSimpleRequestKey/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026Url=" + this.proxy.FormatUriArgument(args.Url) + "", args);
                };
                Client.prototype.AccountForgotPasswordToken = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "AccountForgotPasswordToken?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountPasswordReset = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "AccountPasswordReset?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountPasswordResetByToken = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "AccountPasswordResetByToken?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ValidateEncryptedKey = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAccount", "ValidateEncryptedKey?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EncryptedKey=" + this.proxy.FormatUriArgument(args.EncryptedKey) + "", args);
                };
                Client.prototype.ValidateEncryptedToken = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IAccount", "ValidateEncryptedToken?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026EncryptedToken=" + this.proxy.FormatUriArgument(args.EncryptedToken) + "", args);
                };
                Client.prototype.NewUserVerify = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "NewUserVerify?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountPasswordSetUp = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "AccountPasswordSetUp?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.FirstTimeLoginEventGenerate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.IAccount", "FirstTimeLoginEventGenerate?AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "\u0026Url=" + this.proxy.FormatUriArgument(args.Url) + "", args);
                };
                Client.prototype.AccountBalanceBucketList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAccount", "AccountBalanceBucketList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccountBalanceSummary = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IAccount", "AccountBalanceSummary/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IAccount.Client = Client;
        })(IAccount = SelcommWebService.IAccount || (SelcommWebService.IAccount = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ISession;
        (function (ISession) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.SessionCreate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISession", "SessionCreate", args);
                };
                Client.prototype.SessionCreateByPrivateKey = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISession", "SessionCreateByPrivateKey", args);
                };
                Client.prototype.SessionClone = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISession", "SessionClone?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SessionHasExpired = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISession", "SessionHasExpired?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SessionExpire = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISession", "SessionExpire?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ClientSessionUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISession", "ClientSessionUpdate", args);
                };
                Client.prototype.ClientSession = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISession", "ClientSession?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.ClientSessionNoException = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISession", "ClientSessionNoException?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ISession.Client = Client;
        })(ISession = SelcommWebService.ISession || (SelcommWebService.ISession = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ISIM;
        (function (ISIM) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.SimType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "SimType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SimStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "SIMStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccessPointNameStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "AccessPointNameStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SimBatchStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "SimBatchStatus/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.Sim = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "Sim/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.SimAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimAdd", args);
                };
                Client.prototype.SimUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimUpdate", args);
                };
                Client.prototype.SimDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ISIM", "SimDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.id) + "", args);
                };
                Client.prototype.SimValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimValidate", args);
                };
                Client.prototype.SimList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimList", args);
                };
                Client.prototype.SimStatusChange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimStatusChange", args);
                };
                Client.prototype.SimSimAccessPointNameList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "SimSimAccessPointNameList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.SimId) + "", args);
                };
                Client.prototype.AccessPointName = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "AccessPointName/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.AccessPointNameAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "AccessPointNameAdd", args);
                };
                Client.prototype.AccessPointNameUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "AccessPointNameUpdate", args);
                };
                Client.prototype.AccessPointNameDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ISIM", "AccessPointNameDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.AccessPointNameValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "AccessPointNameValidate", args);
                };
                Client.prototype.AccessPointNameList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "AccessPointNameList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.AccessPointNameStatusChange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "AccessPointNameStatusChange", args);
                };
                Client.prototype.SimAccessPointName = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "SimAccessPointName/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccessPointNameId=" + this.proxy.FormatUriArgument(args.AccessPointNameId) + "\u0026SimId=" + this.proxy.FormatUriArgument(args.SimId) + "", args);
                };
                Client.prototype.SimAccessPointNameAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimAccessPointNameAdd", args);
                };
                Client.prototype.SimAccessPointNameUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimAccessPointNameUpdate", args);
                };
                Client.prototype.SimAccessPointNameDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ISIM", "SimAccessPointNameDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026SimId=" + this.proxy.FormatUriArgument(args.SimId) + "\u0026AccessPointNameId=" + this.proxy.FormatUriArgument(args.AccessPointNameId) + "", args);
                };
                Client.prototype.SimAccessPointNameValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimAccessPointNameValidate", args);
                };
                Client.prototype.SimAccessPointNameList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "SimAccessPointNameList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SimAccessPointNameStatusChange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimAccessPointNameStatusChange", args);
                };
                Client.prototype.SimBatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "SimBatch/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.SimBatchAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimBatchAdd", args);
                };
                Client.prototype.SimBatchUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimBatchUpdate", args);
                };
                Client.prototype.SimBatchDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ISIM", "SimBatchDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.SimBatchValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimBatchValidate", args);
                };
                Client.prototype.SimBatchList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimBatchList", args);
                };
                Client.prototype.SimBatchSimList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "SimBatchSimList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.SimAddToBatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimAddToBatch", args);
                };
                Client.prototype.SimRemoveFromBatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ISIM", "SimRemoveFromBatch/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BatchId=" + this.proxy.FormatUriArgument(args.BatchId) + "\u0026SimId=" + this.proxy.FormatUriArgument(args.SimId) + "", args);
                };
                Client.prototype.SimListAddToBatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimListAddToBatch", args);
                };
                Client.prototype.SimListCreateAndAddToBatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimListCreateAndAddToBatch", args);
                };
                Client.prototype.SimListRemoveFromBatchAndDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimListRemoveFromBatchAndDelete", args);
                };
                Client.prototype.SimListRemoveFromBatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimListRemoveFromBatch", args);
                };
                Client.prototype.SimCreateAndAddToBatch = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimCreateAndAddToBatch", args);
                };
                Client.prototype.SimRemoveFromBatchAndDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ISIM", "SimRemoveFromBatchAndDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026BatchId=" + this.proxy.FormatUriArgument(args.BatchId) + "\u0026SimId=" + this.proxy.FormatUriArgument(args.SimId) + "", args);
                };
                Client.prototype.SimBatchSimValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimBatchSimValidate", args);
                };
                Client.prototype.SimContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "SimContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.SimContactAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimContactAdd/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SimContactUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ISIM", "SimContactUpdate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SimContactDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ISIM", "SimContactDelete/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "", args);
                };
                Client.prototype.SimContactValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimContactValidate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SimContactListByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimContactListByContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SimListByContact = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimListByContact/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SimChange = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimChange/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.CheckSimChangeable = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "CheckSimChangeable/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ConnectionRef=" + this.proxy.FormatUriArgument(args.ConnectionRef) + "", args);
                };
                Client.prototype.ReplaceSIM = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimReplacement/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.SimReplacementForAllApplicable = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ISIM", "SimReplacementForAllApplicable/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                Client.prototype.CheckSimReplaceable = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "CheckSimReplaceable/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ConnectionRef=" + this.proxy.FormatUriArgument(args.ConnectionRef) + "", args);
                };
                Client.prototype.GetReplaceableSIMCount = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ISIM", "GetReplaceableSIMCount/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Account=" + this.proxy.FormatUriArgument(args.Account) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ISIM.Client = Client;
        })(ISIM = SelcommWebService.ISIM || (SelcommWebService.ISIM = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IStatus;
        (function (IStatus) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.SystemStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IStatus", "SystemStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IStatus.Client = Client;
        })(IStatus = SelcommWebService.IStatus || (SelcommWebService.IStatus = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ITask;
        (function (ITask) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Task = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "Task/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TaskId=" + this.proxy.FormatUriArgument(args.TaskId) + "", args);
                };
                Client.prototype.TaskDisplayByServiceList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskDisplayByServiceList", args);
                };
                Client.prototype.TaskDisplayByContactList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskDisplayByContactList", args);
                };
                Client.prototype.TaskDisplayListByResource = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskDisplayListByResource", args);
                };
                Client.prototype.TaskRequesterList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskRequesterList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskEmailList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskEmailList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskAdd", args);
                };
                Client.prototype.TaskUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ITask", "TaskUpdate", args);
                };
                Client.prototype.TaskSelfCareAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskSelfCareAdd", args);
                };
                Client.prototype.TaskUpdateDetails = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ITask", "TaskUpdateDetails", args);
                };
                Client.prototype.TaskPriorityList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskPriorityList", args);
                };
                Client.prototype.TaskPriority = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskPriority", args);
                };
                Client.prototype.TaskPriorityAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskPriorityAdd", args);
                };
                Client.prototype.TaskPriorityUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskPriorityUpdate", args);
                };
                Client.prototype.TaskPriorityDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ITask", "TaskPriorityDelete", args);
                };
                Client.prototype.TaskCategoryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskCategoryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskTypeList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskTypeList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskTypeListSelfCare = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskTypeListSelfCare/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskTypeListByCategory = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskTypeListByCategory/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TaskCategoryId=" + this.proxy.FormatUriArgument(args.TaskCategoryId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskType", args);
                };
                Client.prototype.TaskTypeAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskTypeAdd", args);
                };
                Client.prototype.TaskTypeUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ITask", "TaskTypeUpdate", args);
                };
                Client.prototype.TaskTypeDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ITask", "TaskTypeDelete", args);
                };
                Client.prototype.TaskGroupList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskGroupList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskResolutionList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskResolutionList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskResolutionListByCategory = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskResolutionListByCategory/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CategoryId=" + this.proxy.FormatUriArgument(args.CategoryId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskResolutionUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ITask", "TaskResolutionUpdate", args);
                };
                Client.prototype.TaskStatusList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskStatusList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskStatusListByTaskType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskStatusListByTaskType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TypeId=" + this.proxy.FormatUriArgument(args.TypeId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskStatus = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskStatus", args);
                };
                Client.prototype.TaskStatusAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskStatusAdd", args);
                };
                Client.prototype.TaskStatusUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ITask", "TaskStatusUpdate", args);
                };
                Client.prototype.TaskStatusDelete = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("DELETE", "SelcommWebService.ITask", "TaskStatusDelete", args);
                };
                Client.prototype.TaskStatusHistoryList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskStatusHistoryList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TaskId=" + this.proxy.FormatUriArgument(args.TaskId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskTimeLogAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.ITask", "TaskTimeLogAdd", args);
                };
                Client.prototype.TaskTimeLog = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskTimeLog/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskTimeLogList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskTimeLogList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TaskId=" + this.proxy.FormatUriArgument(args.TaskId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                Client.prototype.TaskResource = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskResource/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskResourceList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskResourceList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TaskResourceListByCategory = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "TaskResourceListByCategory/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026CategoryId=" + this.proxy.FormatUriArgument(args.CategoryId) + "\u0026TaskId=" + this.proxy.FormatUriArgument(args.TaskId) + "", args);
                };
                Client.prototype.ResourceRelation = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "ResourceRelation/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TaskId=" + this.proxy.FormatUriArgument(args.TaskId) + "\u0026ContactCode=" + this.proxy.FormatUriArgument(args.ContactCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ResourceRelationUpdate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("PUT", "SelcommWebService.ITask", "ResourceRelationUpdate", args);
                };
                Client.prototype.ResourceRelationList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITask", "ResourceRelationList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TaskId=" + this.proxy.FormatUriArgument(args.TaskId) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026PageNumber=" + this.proxy.FormatUriArgument(args.PageNumber) + "\u0026PageSize=" + this.proxy.FormatUriArgument(args.PageSize) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ITask.Client = Client;
        })(ITask = SelcommWebService.ITask || (SelcommWebService.ITask = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ITeam;
        (function (ITeam) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Team = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITeam", "Team/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TeamList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITeam", "TeamList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ITeam.Client = Client;
        })(ITeam = SelcommWebService.ITeam || (SelcommWebService.ITeam = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var ITemplate;
        (function (ITemplate) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Template = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITemplate", "Template/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Id=" + this.proxy.FormatUriArgument(args.Id) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.TemplateList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.ITemplate", "TemplateList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            ITemplate.Client = Client;
        })(ITemplate = SelcommWebService.ITemplate || (SelcommWebService.ITemplate = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IThreads;
        (function (IThreads) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.Thread = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IThreads", "Thread/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ThreadReference=" + this.proxy.FormatUriArgument(args.ThreadReference) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.ThreadAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IThreads", "ThreadAdd", args);
                };
                Client.prototype.ThreadItemsByThread = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IThreads", "ThreadItemsByThread/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ThreadReference=" + this.proxy.FormatUriArgument(args.ThreadReference) + "", args);
                };
                Client.prototype.ThreadItemList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IThreads", "ThreadItemList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ThreadReference=" + this.proxy.FormatUriArgument(args.ThreadReference) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "\u0026Internal=" + this.proxy.FormatUriArgument(args.Internal) + "", args);
                };
                Client.prototype.ThreadItemAdd = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IThreads", "ThreadItemAdd", args);
                };
                return Client;
            }(ServiceClientBase));
            IThreads.Client = Client;
        })(IThreads = SelcommWebService.IThreads || (SelcommWebService.IThreads = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IUISupport;
        (function (IUISupport) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.UIElement = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IUISupport", "UIElement/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026Name=" + this.proxy.FormatUriArgument(args.Name) + "", args);
                };
                Client.prototype.UIElementConfigurationList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IUISupport", "UIElementConfigurationList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026UIElementName=" + this.proxy.FormatUriArgument(args.UIElementName) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.NewsItemList = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IUISupport", "NewsItemList/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026UIElementName=" + this.proxy.FormatUriArgument(args.UIElementName) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IUISupport.Client = Client;
        })(IUISupport = SelcommWebService.IUISupport || (SelcommWebService.IUISupport = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IUsage;
        (function (IUsage) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.UsageTransactionCreateForService = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("POST", "SelcommWebService.IUsage", "UsageTransactionCreateForService?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IUsage.Client = Client;
        })(IUsage = SelcommWebService.IUsage || (SelcommWebService.IUsage = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
    (function (SelcommWebService) {
        var IValidation;
        (function (IValidation) {
            var Client = (function (_super) {
                __extends(Client, _super);
                function Client(proxy) {
                    return _super.call(this, proxy) || this;
                }
                Client.prototype.CreditCardValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IValidation", "CreditCardValidate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ValidationString=" + this.proxy.FormatUriArgument(args.ValidationString) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.CreditCardType = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IValidation", "CreditCardType/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026ValidationString=" + this.proxy.FormatUriArgument(args.ValidationString) + "", args);
                };
                Client.prototype.AccountValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IValidation", "AccountValidate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026AccountNumber=" + this.proxy.FormatUriArgument(args.AccountNumber) + "", args);
                };
                Client.prototype.StringValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IValidation", "StringValidate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TestString=" + this.proxy.FormatUriArgument(args.TestString) + "\u0026StringType=" + this.proxy.FormatUriArgument(args.StringType) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.StringValidateForServiceTypeCode = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IValidation", "StringValidateForServiceTypeCode/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026TestString=" + this.proxy.FormatUriArgument(args.TestString) + "\u0026StringType=" + this.proxy.FormatUriArgument(args.StringType) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.PCNValidate = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IValidation", "PCNValidate/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026PCN=" + this.proxy.FormatUriArgument(args.PCN) + "\u0026ServiceTypeCode=" + this.proxy.FormatUriArgument(args.ServiceTypeCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                Client.prototype.StringTypePossibleValues = function (args) {
                    args = this.proxy.FormatRequestArguments(args);
                    return this.proxy.SendRequest("GET", "SelcommWebService.IValidation", "StringTypePossibleValues/?SessionKey=" + this.proxy.FormatUriArgument(args.SessionKey) + "\u0026StringTypeCode=" + this.proxy.FormatUriArgument(args.StringTypeCode) + "\u0026RefreshCache=" + this.proxy.FormatUriArgument(args.RefreshCache) + "", args);
                };
                return Client;
            }(ServiceClientBase));
            IValidation.Client = Client;
        })(IValidation = SelcommWebService.IValidation || (SelcommWebService.IValidation = {}));
    })(SelcommWebService = exports.SelcommWebService || (exports.SelcommWebService = {}));
});
define("app/selcomm/service-reference/call/selcomm-data-types", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
define("app/selcomm/service-reference/call/service-client-api", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
define("app/selcomm/service-reference/call-thin/selcomm-data-types", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
define("app/selcomm/service-reference/call-thin/service-client-api", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
define("app/selcomm/selcomm-api", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Progress = (function () {
        function Progress(Loaded, Total) {
            this.Loaded = Loaded;
            this.Total = Total;
        }
        Progress.IsProgress = function (obj) {
            if (!angular.isObject(obj))
                return false;
            return obj instanceof Progress;
        };
        Progress.Normalize = function (x) {
            if (x !== 1)
                return x;
            else
                return undefined;
        };
        Progress.Get = function (obj) {
            if (Progress.IsProgress(obj))
                return Progress.Normalize(obj.Progress);
            else if (angular.isNumber(obj))
                return Progress.Normalize(obj);
            else
                return undefined;
        };
        Progress.prototype.valueOf = function () {
            return this.Progress;
        };
        Progress.prototype.toString = function () {
            return (this.Progress * 100).toString();
        };
        Object.defineProperty(Progress.prototype, "Progress", {
            get: function () {
                return this.Loaded / this.Total;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Progress.prototype, "progress", {
            get: function () {
                return this.Progress;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Progress.prototype, "loaded", {
            get: function () {
                return this.Loaded;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Progress.prototype, "total", {
            get: function () {
                return this.Total;
            },
            enumerable: true,
            configurable: true
        });
        return Progress;
    }());
    exports.Progress = Progress;
    var RemovedSession = (function () {
        function RemovedSession(SessionKey, LocalKeys) {
            this.SessionKey = SessionKey;
            this.LocalKeys = LocalKeys;
        }
        return RemovedSession;
    }());
    exports.RemovedSession = RemovedSession;
});
define("app/selcomm/service-transformers", ["require", "exports", "app/basic-utils", "app/selcomm/service-reference/selcomm-types", "moment", "$exceptionHandler", "$http"], function (require, exports, utils, serviceReference, moment, $exceptionHandler, $http) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var NgTransformers;
    (function (NgTransformers) {
        function AsArray(parserOrParsers) {
            return !parserOrParsers ? [] : (Array.isArray(parserOrParsers) ? parserOrParsers.slice() : [parserOrParsers]);
        }
        NgTransformers.AsArray = AsArray;
    })(NgTransformers || (NgTransformers = {}));
    var PropertyPath = (function () {
        function PropertyPath(ownerPathParts, property, isRoot) {
            if (isRoot === void 0) { isRoot = false; }
            this.Owner = ownerPathParts && "$" + ownerPathParts.map(PropertyPath.AsJpath).join("");
            this.Property = property;
            this.IsRoot = isRoot;
        }
        PropertyPath.AsJpath = function (propName) {
            return "['" + propName
                .replace(/(['\\])/g, '\\$1')
                .replace(/[\f]/g, "\\f")
                .replace(/[\b]/g, "\\b")
                .replace(/[\n]/g, "\\n")
                .replace(/[\t]/g, "\\t")
                .replace(/[\r]/g, "\\r")
                .replace(/[\u2028]/g, "\\u2028")
                .replace(/[\u2029]/g, "\\u2029") + "']";
        };
        PropertyPath.FromParts = function (pathParts) {
            if (!pathParts || !pathParts.length)
                return PropertyPath.Root;
            else
                return new PropertyPath(pathParts.slice(0, -1), pathParts[pathParts.length - 1]);
        };
        PropertyPath.prototype.toString = function () {
            if (this.IsRoot)
                return "$root";
            return angular.toJson({
                property: this.Property,
                owner: this.Owner
            });
        };
        PropertyPath.Root = new PropertyPath(null, null, true);
        return PropertyPath;
    }());
    var FoundBlob = (function () {
        function FoundBlob(data, key) {
            if (key === void 0) { key = []; }
            this.Data = data;
            if (!(key instanceof PropertyPath))
                key = PropertyPath.FromParts(key);
            this.Key = key;
        }
        Object.defineProperty(FoundBlob.prototype, "IsRoot", {
            get: function () {
                return this.Key.IsRoot;
            },
            enumerable: true,
            configurable: true
        });
        FoundBlob.prototype.AttachTo = function (form) {
            var rawName = this.Key.toString();
            var name = btoa(rawName).replace(/=/g, "-");
            form.append(name, this.Data);
        };
        FoundBlob.JsonFor = function (value, key) {
            return new FoundBlob(new Blob([angular.toJson(value)], { type: "application/json" }), key);
        };
        return FoundBlob;
    }());
    var ExtractBlobsResult = (function () {
        function ExtractBlobsResult(valueToSend, foundBlobs) {
            if (foundBlobs === void 0) { foundBlobs = []; }
            this.ValueToSend = valueToSend;
            this.FoundBlobs = foundBlobs;
        }
        ExtractBlobsResult._From = function (currentValue, formatter, propertyChain) {
            if (propertyChain === void 0) { propertyChain = []; }
            currentValue = formatter(currentValue);
            if (!angular.isObject(currentValue))
                return new ExtractBlobsResult(currentValue);
            if (currentValue instanceof Blob)
                return new ExtractBlobsResult(undefined, [new FoundBlob(currentValue, propertyChain)]);
            var foundBlobs = [];
            var valueToSend = angular.map(currentValue, function (nextValue, nextProperty) {
                var result = ExtractBlobsResult._From(nextValue, formatter, propertyChain.concat(nextProperty));
                foundBlobs.push.apply(foundBlobs, result.FoundBlobs);
                return result.ValueToSend;
            });
            return new ExtractBlobsResult(valueToSend, foundBlobs);
        };
        ExtractBlobsResult.From = function (value, formatter) {
            if (formatter === void 0) { formatter = function (x) { return x; }; }
            return ExtractBlobsResult._From(value, formatter);
        };
        return ExtractBlobsResult;
    }());
    function FormatDates(currentValue) {
        var allowTimezone = currentValue ? currentValue.$timezone : false;
        if (!allowTimezone && moment.isDate(currentValue)) {
            currentValue = moment(currentValue);
        }
        if (moment.isMoment(currentValue)) {
            var asMoment = currentValue;
            if (allowTimezone)
                return asMoment.toJSON();
            else
                return asMoment.format("YYYY-MM-DDTHH:mm:ss");
        }
        return currentValue;
    }
    function FormatRequest(target) {
        var _a = ExtractBlobsResult.From(target, FormatDates), FoundBlobs = _a.FoundBlobs, ValueToSend = _a.ValueToSend;
        if (!FoundBlobs.length)
            return ValueToSend;
        if (!FoundBlobs.filter(function (fb) { return fb.IsRoot; }).length)
            FoundBlobs = FoundBlobs.concat(FoundBlob.JsonFor(ValueToSend));
        var form = new FormData();
        try {
            for (var FoundBlobs_1 = __values(FoundBlobs), FoundBlobs_1_1 = FoundBlobs_1.next(); !FoundBlobs_1_1.done; FoundBlobs_1_1 = FoundBlobs_1.next()) {
                var blob = FoundBlobs_1_1.value;
                blob.AttachTo(form);
            }
        }
        catch (e_41_1) { e_41 = { error: e_41_1 }; }
        finally {
            try {
                if (FoundBlobs_1_1 && !FoundBlobs_1_1.done && (_b = FoundBlobs_1.return)) _b.call(FoundBlobs_1);
            }
            finally { if (e_41) throw e_41.error; }
        }
        return form;
        var e_41, _b;
    }
    exports.FormatRequest = FormatRequest;
    var SelcommClass;
    (function (SelcommClass) {
        function HasProp(source, prop) {
            if (!source)
                return false;
            else
                return Object.prototype.hasOwnProperty.call(source, prop);
        }
        var ClassCache = (function () {
            function ClassCache(parse) {
                if (parse === void 0) { parse = function (x) { return x; }; }
                this.parse = parse;
                this.classCache = {};
            }
            Object.defineProperty(ClassCache, "Default", {
                get: function () {
                    return ClassCache.default;
                },
                enumerable: true,
                configurable: true
            });
            ClassCache.prototype.GetClass = function ($type) {
                if (HasProp(this.classCache, $type))
                    return this.classCache[$type];
                var parsed = this.parse($type);
                var parts = this.parse(parsed).split(/\./g);
                var context = serviceReference;
                try {
                    for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                        var part = parts_1_1.value;
                        context = context[part];
                    }
                }
                catch (e_42_1) { e_42 = { error: e_42_1 }; }
                finally {
                    try {
                        if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
                    }
                    finally { if (e_42) throw e_42.error; }
                }
                if (!angular.isFunction(context))
                    throw new Error(utils.FormatJson(templateObject_12 || (templateObject_12 = __makeTemplateObject(["Unknown $type ", ", (parsed: ", ")"], ["Unknown $type ", ", (parsed: ", ")"])), $type, parsed));
                else if (context.Type !== parsed)
                    throw new Error(utils.FormatJson(templateObject_13 || (templateObject_13 = __makeTemplateObject(["Found the type ", " for ", ", (parsed: ", ")"], ["Found the type ", " for ", ", (parsed: ", ")"])), context.Type, $type, parsed));
                else
                    return this.classCache[parsed] = this.classCache[$type] = context;
                var e_42, _a;
            };
            ClassCache.default = new ClassCache();
            return ClassCache;
        }());
        var CleanedClassesCache = new ClassCache(function ($type) { return $type.match(/^[^,<`]+(?=[,<`]|$)/)[0]; });
        function ReviveFast(value) {
            if (utils.IsArray(value)) {
                if (!utils.IsWritable(value))
                    return value.map(function (itm) { return ReviveFast(itm); });
                for (var i = 0; i < value.length; i++) {
                    value[i] = ReviveFast(value[i]);
                }
                return value;
            }
            else
                return ReviveSingle(value, function (x) { return RevivePropertiesInPlace(x, ReviveFast); });
        }
        SelcommClass.ReviveFast = ReviveFast;
        function Revive(value) {
            if (utils.IsArray(value))
                return value.map(function (so) { return Revive(so); });
            else
                return ReviveSingle(value, function (x) { return RevivePropertiesOnClone(x, Revive); });
        }
        SelcommClass.Revive = Revive;
        function RevivePropertiesOnClone(value, reviver) {
            value = utils.ShallowCopy(value, true);
            for (var key in value) {
                if (!utils.HasProp(value, key))
                    continue;
                value[key] = reviver(value[key]);
            }
            return value;
        }
        function RevivePropertiesInPlace(value, reviver) {
            if (Object.isFrozen(value))
                return RevivePropertiesOnClone(value, reviver);
            for (var key in value) {
                if (!utils.HasProp(value, key))
                    continue;
                value[key] = reviver(value[key]);
            }
            return value;
        }
        function IsSelcommObject(value) {
            if (!value || !utils.IsObject(value) || utils.IsArray(value))
                return false;
            else if (!value.$type || !utils.IsString(value.$type))
                return false;
            return true;
        }
        function ReviveSingle(value, makeCtorArg) {
            if (makeCtorArg === void 0) { makeCtorArg = function (x) { return x; }; }
            if (!IsSelcommObject(value))
                return value;
            var $type = value.$type;
            var ctor = CleanedClassesCache.GetClass($type);
            return new ctor(makeCtorArg(value), $type);
        }
    })(SelcommClass = exports.SelcommClass || (exports.SelcommClass = {}));
    function ParseResponse(original) {
        var dateRevived;
        try {
            dateRevived = Dates.ReviveFast(original);
        }
        catch (err) {
            $exceptionHandler(err, "Failed to revive dates");
        }
        var classRevived;
        try {
            classRevived = SelcommClass.ReviveFast(dateRevived);
        }
        catch (err) {
            $exceptionHandler(err, "Failed to revive classes");
            throw err;
        }
        return classRevived;
    }
    exports.ParseResponse = ParseResponse;
    var Dates;
    (function (Dates) {
        Dates.JsonNetDateRegex = /^\d{4}\d*-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.[0-9]+)?(Z|[-+]\d{2}\:\d{2})?$/;
        function Revive(value) {
            if (!utils.IsString(value))
                return value;
            else {
                var matches = value.match(Dates.JsonNetDateRegex);
                if (!matches)
                    return value;
                var _a = __read(matches, 1), match = _a[0];
                if (!match)
                    return value;
                var milliseconds = Date.parse(match);
                if (Number.isNaN(milliseconds))
                    return value;
                return new Date(milliseconds);
            }
        }
        Dates.Revive = Revive;
        function ReviveFast(input, key) {
            if (utils.IsVoid(input) || !utils.IsObject(input))
                return Revive(input);
            else if (utils.IsArray(input)) {
                for (var i = 0; i < input.length; i++) {
                    input[i] = ReviveFast(input[i], i);
                }
                return input;
            }
            else {
                for (var key_1 in input) {
                    if (!utils.HasProp(input, key_1))
                        continue;
                    input[key_1] = ReviveFast(input[key_1], key_1);
                }
                return input;
            }
        }
        Dates.ReviveFast = ReviveFast;
    })(Dates = exports.Dates || (exports.Dates = {}));
    var Legacy;
    (function (Legacy) {
        function IsExtendedDataList(target) {
            if (utils.IsDate(target))
                return false;
            if (!target.$ExtendedDataList)
                return false;
            return true;
        }
        function TransformDates(data) {
            return Dates.ReviveFast(data);
        }
        function TransformExtendedDataList(data) {
            if (!utils.IsObject(data))
                return data;
            if (utils.IsDate(data))
                return data;
            if (!IsExtendedDataList(data))
                return angular.map(data, TransformExtendedDataList);
            var output = angular.extend(data.Items = angular.map(data.Items, TransformExtendedDataList), data);
            Object.defineProperties(output, {
                "Items": {
                    enumerable: false,
                    configurable: true,
                    get: function Items_get() { return this; }
                }
            });
            return output;
        }
        Legacy.ResponseTransforms = Object.freeze(NgTransformers.AsArray($http && $http.defaults && $http.defaults.transformResponse).concat(TransformDates, TransformExtendedDataList));
    })(Legacy = exports.Legacy || (exports.Legacy = {}));
    var templateObject_12, templateObject_13;
});
define("app/selcomm/url", ["require", "exports", "app/basic-utils", "scripts/lib/select-development/sss-paths", "app/sss/sites"], function (require, exports, utils, paths, sites) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function CreateFactory(localEndpointName) {
        return urlFactory;
        function urlFactory() {
            var partsOrPartsArrays = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                partsOrPartsArrays[_i] = arguments[_i];
            }
            var parts = (_a = []).concat.apply(_a, __spread(partsOrPartsArrays));
            return paths.ServerPath.apply(paths, __spread([utils.EncodeUriComponent(sites.Service.Current.Name), "$$/SelcommWS", localEndpointName], parts));
            var _a;
        }
    }
    exports.CreateFactory = CreateFactory;
    exports.Download = CreateFactory("Download");
    exports.Call = CreateFactory("call");
});
define("app/selcomm/service-proxy", ["require", "exports", "app/selcomm/service-transformers", "$q", "$http", "$window", "$log", "$cacheFactory", "app/selcomm/selcomm-api", "app/selcomm/url", "app/basic-utils", "app/ng-utils", "app/selcomm/service-reference/selcomm-types"], function (require, exports, serviceTransformers, $q, $http, $window, $log, $cacheFactory, api, Url, utils, ng_utils_1, selcomm_types_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Legacy;
    (function (Legacy) {
        var ProxyBase = (function () {
            function ProxyBase(authenticationService) {
                this.authenticationService = authenticationService;
            }
            Object.defineProperty(ProxyBase.prototype, "AuthenticationService", {
                get: function () {
                    return this.authenticationService;
                },
                enumerable: true,
                configurable: true
            });
            return ProxyBase;
        }());
        var StandardProxy = (function (_super) {
            __extends(StandardProxy, _super);
            function StandardProxy() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            StandardProxy.prototype.Invoke = function (httpMethod, service, method, data, config) {
                var _this = this;
                var deferred = $q.defer();
                var underlyingPromise = utils.Execute(function () { return __awaiter(_this, void 0, $q, function () {
                    var sessionKey, baseParams, baseHeaders, url, prop, formData, actualConfig, dataFormatting, paramsFormatting, formattedData, _a, formattedParams, _b, response, response_1;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                sessionKey = this.AuthenticationService.CurrentSession && this.AuthenticationService.CurrentSession.SessionKey || "";
                                baseParams = {
                                    SessionKey: sessionKey
                                };
                                baseHeaders = {
                                    __setXHR_: function () {
                                        return function attachToXhr(xhr) {
                                            if (!xhr)
                                                return;
                                            xhr.upload.addEventListener('progress', function (evt) {
                                                if (evt) {
                                                    deferred.notify(new api.Progress(evt.loaded, evt.total));
                                                }
                                            }, false);
                                            xhr.upload.addEventListener('load', function (evt) {
                                                if (evt.lengthComputable) {
                                                    deferred.notify(new api.Progress(evt.loaded, evt.total));
                                                }
                                            }, false);
                                        };
                                    }
                                };
                                url = Url.Call(service, method);
                                switch (httpMethod) {
                                    case "GET":
                                    case "DELETE":
                                        if (angular.isObject(data)) {
                                            for (prop in data) {
                                                if (!Object.hasOwnProperty.call(data, prop)) {
                                                    continue;
                                                }
                                                if (angular.isObject(data[prop]) && !(angular.isDate(data[prop]) || angular.isFunction(data[prop]))) {
                                                    $log.warn(['Deprecated fallback!: The SelcommWS method "', url, '" does not support ', httpMethod, ' requests and has been automatically changed to a POST request.'].join(""), {
                                                        url: url,
                                                        service: service,
                                                        method: method,
                                                        httpMethod: httpMethod
                                                    });
                                                    this.Invoke("POST", service, method, data, config).then(function (value) { return deferred.resolve(value); }, function (reason) { return deferred.reject(reason); }, function (state) { return deferred.notify(state); });
                                                    return [2];
                                                }
                                            }
                                        }
                                        break;
                                }
                                if (data instanceof Blob) {
                                    formData = new FormData();
                                    formData.append("", data);
                                    data = formData;
                                    angular.extend(baseHeaders, {
                                        "Content-Type": "multipart/form-data"
                                    });
                                }
                                else if (!(data instanceof FormData)) {
                                    data = angular.extend(angular.copy(baseParams), data);
                                }
                                switch (httpMethod) {
                                    case "GET":
                                    case "DELETE":
                                        config = angular.extend({
                                            params: angular.extend(baseParams, data, config && config.params)
                                        });
                                        break;
                                    default:
                                        config = angular.extend({
                                            params: angular.extend(baseParams, config && config.params),
                                            data: data
                                        }, config);
                                        break;
                                }
                                actualConfig = angular.extend({}, {
                                    method: httpMethod
                                }, {
                                    url: url,
                                    headers: angular.extend(baseHeaders, config.headers),
                                    transformResponse: serviceTransformers.Legacy.ResponseTransforms,
                                }, config);
                                if (!actualConfig.headers)
                                    actualConfig.headers = {};
                                dataFormatting = serviceTransformers.FormatRequest(actualConfig.data);
                                paramsFormatting = serviceTransformers.FormatRequest(actualConfig.params);
                                _a = actualConfig;
                                return [4, dataFormatting];
                            case 1:
                                formattedData = _a.data = _c.sent();
                                _b = actualConfig;
                                return [4, paramsFormatting];
                            case 2:
                                formattedParams = _b.params = _c.sent();
                                if (formattedData instanceof FormData) {
                                    actualConfig.headers = angular.extend(actualConfig.headers || {}, {
                                        "Content-Type": undefined,
                                        "Content-Length": undefined
                                    });
                                }
                                _c.label = 3;
                            case 3:
                                _c.trys.push([3, 5, , 6]);
                                return [4, $http(actualConfig)];
                            case 4:
                                response = _c.sent();
                                deferred.resolve(response.data);
                                return [3, 6];
                            case 5:
                                response_1 = _c.sent();
                                deferred.reject(response_1);
                                if (utils.IsObject(response_1.data)) {
                                    if (response_1.data.$type === selcomm_types_1.Selcomm.Error.InvalidSessionKeyException.Type) {
                                        this.AuthenticationService.ValidateSessions(sessionKey);
                                    }
                                }
                                throw response_1;
                            case 6: return [2];
                        }
                    });
                }); });
                return deferred.promise;
            };
            return StandardProxy;
        }(ProxyBase));
        Legacy.StandardProxy = StandardProxy;
        var CachedProxy = (function (_super) {
            __extends(CachedProxy, _super);
            function CachedProxy(underlyingServiceProxy, authenticationService) {
                var _this = _super.call(this, (underlyingServiceProxy instanceof ProxyBase) ? underlyingServiceProxy.AuthenticationService : authenticationService) || this;
                _this.underlyingServiceProxy = underlyingServiceProxy;
                _this.cache = $cacheFactory("CachedProxy:{5A5D9C32-4AF2-4C63-92CF-616B10747931}");
                return _this;
            }
            CachedProxy.prototype.CacheKey = function (args) {
                var currentSession = this.AuthenticationService.CurrentSession;
                return angular.toJson({
                    SessionKey: currentSession && currentSession.SessionKey || "",
                    Arguments: args
                });
            };
            CachedProxy.prototype.GetOrPut = function (args, ifMissingFactory) {
                var cacheKey = this.CacheKey(args);
                var result = this.cache.get(cacheKey);
                if (!result)
                    this.cache.put(cacheKey, result = $q.when(ifMissingFactory(args)));
                return result.then(angular.copy);
            };
            CachedProxy.prototype.Invoke = function (httpMethod, service, method, data, config) {
                var _this = this;
                var args = Array.prototype.slice.call(arguments, 0);
                return this.GetOrPut(args, function (args) { return _this.underlyingServiceProxy.Invoke.apply(_this.underlyingServiceProxy, args); });
            };
            return CachedProxy;
        }(ProxyBase));
        Legacy.CachedProxy = CachedProxy;
    })(Legacy = exports.Legacy || (exports.Legacy = {}));
    function ResolveServiceTypeName(serviceTypeFullName) {
        return /^SelcommWebService\.I(.*)$/.exec(serviceTypeFullName)[1];
    }
    function autoResolver(serviceInterfaceFullName) {
        var serviceInterfaceName = ResolveServiceTypeName(serviceInterfaceFullName);
        var serviceName = ResolveServiceName(serviceInterfaceName);
        return serviceName;
    }
    function ResolveServiceName(serviceTypeName) {
        switch (serviceTypeName) {
            case "Products":
                return serviceTypeName.substr(0, serviceTypeName.length - 1);
            default:
                return serviceTypeName;
        }
    }
    function FormatUriArgument(arg) {
        if (arg === undefined)
            return "";
        return encodeURIComponent(arg);
    }
    function FormatRequestArguments(authService, args) {
        if (args === void (0) || args === null)
            args = {};
        if (typeof (args) === "object") {
            if (!Object.prototype.hasOwnProperty.call(args, "SessionKey") && authService.CurrentSession) {
                args.SessionKey = authService.CurrentSession.SessionKey;
            }
        }
        return args;
    }
    var ServiceReferenceProxy = (function () {
        function ServiceReferenceProxy(authService) {
            this.UnderlyingProxy = new ServiceReferenceProxy.ThinServiceProxy(authService);
        }
        ServiceReferenceProxy.prototype.SendRequest = function (httpMethod, service, method, args) {
            var _this = this;
            return $q(function (resolve, reject) { return _this.UnderlyingProxy.SendRequest(httpMethod, service, method, args).then(resolve, reject); });
        };
        ServiceReferenceProxy.prototype.FormatUriArgument = function (arg) {
            return this.UnderlyingProxy.FormatUriArgument(arg);
        };
        ServiceReferenceProxy.prototype.FormatRequestArguments = function (args) {
            return this.UnderlyingProxy.FormatRequestArguments(args);
        };
        return ServiceReferenceProxy;
    }());
    exports.ServiceReferenceProxy = ServiceReferenceProxy;
    (function (ServiceReferenceProxy) {
        var SelcommWsApplicationError = (function (_super) {
            __extends(SelcommWsApplicationError, _super);
            function SelcommWsApplicationError(httpStatus, Description, Data) {
                var _this = _super.call(this, httpStatus, Description, (Data instanceof Error) ? Data.message : void undefined) || this;
                _this.Data = Data;
                return _this;
            }
            SelcommWsApplicationError = __decorate([
                utils.FixExtendBuiltIn
            ], SelcommWsApplicationError);
            return SelcommWsApplicationError;
        }(utils.HttpError));
        ServiceReferenceProxy.SelcommWsApplicationError = SelcommWsApplicationError;
        var ApplicationJson = 'application/json';
        var TextPlain = 'text/plain';
        var ContentType = "Content-Type";
        var ContentTypeApplicationJson = Object.freeze((_a = {}, _a[ContentType] = ApplicationJson + ";charset=utf-8", _a));
        var ThinServiceProxy = (function () {
            function ThinServiceProxy(AuthService) {
                this.AuthService = AuthService;
            }
            ThinServiceProxy.GenerateRequestOptions = function (httpMethod, service, serviceMethod, args) {
                var urlPart = autoResolver(service);
                var url = Url.Call(urlPart, serviceMethod);
                switch (httpMethod) {
                    case "GET":
                    case "DELETE":
                        return {
                            url: url,
                            method: httpMethod,
                            accepts: ApplicationJson,
                        };
                    case "PUT":
                    case "POST":
                        var data = serviceTransformers.FormatRequest(args);
                        if (data instanceof FormData) {
                            return {
                                url: url,
                                method: httpMethod,
                                accepts: ApplicationJson,
                                data: data,
                            };
                        }
                        else {
                            return {
                                url: url,
                                method: httpMethod,
                                headers: ContentTypeApplicationJson,
                                accepts: ApplicationJson,
                                data: angular.toJson(data),
                            };
                        }
                    default:
                        throw new Error("Unsupported http method: " + httpMethod);
                }
            };
            ThinServiceProxy.prototype.SendRequest = function (httpMethod, service, method, args) {
                return __awaiter(this, void 0, void 0, function () {
                    var requestOptions, request, err_1, data, contentType, _a, mimeType;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                requestOptions = ThinServiceProxy.GenerateRequestOptions(httpMethod, service, method, args);
                                request = $.ajax(requestOptions);
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 3, , 4]);
                                return [4, request];
                            case 2:
                                _b.sent();
                                return [3, 4];
                            case 3:
                                err_1 = _b.sent();
                                if (request.readyState === 0 && request.status === 0) {
                                    switch (request.statusText) {
                                        case "error":
                                            throw new Error("An unknown error occurred whilst trying to send the request");
                                    }
                                }
                                switch (request.getResponseHeader(ContentType)) {
                                    case ApplicationJson:
                                        data = serviceTransformers.ParseResponse(request.responseJSON);
                                        if (data instanceof Error)
                                            throw data;
                                        throw new SelcommWsApplicationError(request.status, request.statusText, data);
                                    case TextPlain:
                                        throw new SelcommWsApplicationError(request.status, request.statusText, request.responseText);
                                    default:
                                        throw new utils.HttpError(request.status, request.statusText);
                                }
                                return [3, 4];
                            case 4:
                                contentType = request.getResponseHeader(ContentType);
                                if (utils.IsVoid(contentType) && utils.IsNullOrEmpty(request.responseText))
                                    return [2, void undefined];
                                _a = __read(/^\s*([^\s;]*)/.exec(contentType), 2), mimeType = _a[1];
                                switch (mimeType) {
                                    case ApplicationJson:
                                        return [2, serviceTransformers.ParseResponse(request.responseJSON)];
                                    default:
                                        throw new utils.FormatError(mimeType, request.responseText);
                                }
                                return [2];
                        }
                    });
                });
            };
            ThinServiceProxy.prototype.FormatUriArgument = function (arg) {
                return FormatUriArgument(arg);
            };
            ThinServiceProxy.prototype.FormatRequestArguments = function (args) {
                return FormatRequestArguments(this.AuthService, args);
            };
            return ThinServiceProxy;
        }());
        ServiceReferenceProxy.ThinServiceProxy = ThinServiceProxy;
        var _a;
    })(ServiceReferenceProxy = exports.ServiceReferenceProxy || (exports.ServiceReferenceProxy = {}));
    exports.ServiceReferenceProxy = ServiceReferenceProxy;
    var CachedServiceReferenceProxy = (function () {
        function CachedServiceReferenceProxy(underlying) {
            this.underlying = underlying;
        }
        CachedServiceReferenceProxy.CacheKey = function (args) {
            return angular.toJson(args);
        };
        CachedServiceReferenceProxy.prototype.GetOrPut = function (args, ifMissingFactory) {
            var cacheKey = CachedServiceReferenceProxy.CacheKey(args);
            var result = CachedServiceReferenceProxy.cache.get(cacheKey);
            if (!result)
                CachedServiceReferenceProxy.cache.put(cacheKey, result = $q.when(ifMissingFactory(args)));
            return result.then(angular.copy);
        };
        CachedServiceReferenceProxy.prototype.SendRequest = function (httpMethod, service, method, args) {
            var _this = this;
            return this.GetOrPut({ httpMethod: httpMethod, service: service, method: method, args: args }, function (args) { return _this.underlying.SendRequest(args.httpMethod, args.service, args.method, args.args); });
        };
        CachedServiceReferenceProxy.prototype.FormatUriArgument = function (arg) {
            return this.underlying.FormatUriArgument(arg);
        };
        CachedServiceReferenceProxy.prototype.FormatRequestArguments = function (args) {
            return this.underlying.FormatRequestArguments(args);
        };
        CachedServiceReferenceProxy.cache = $cacheFactory("CachedServiceReferenceProxy:{4E964521-2DC3-4F13-99C4-93A39E46D00E}");
        return CachedServiceReferenceProxy;
    }());
    exports.CachedServiceReferenceProxy = CachedServiceReferenceProxy;
    var DownloadProxy = (function () {
        function DownloadProxy(authService) {
            this.authService = authService;
        }
        DownloadProxy.prototype.SendRequest = function (httpMethod, service, method, args) {
            var urlPart = autoResolver(service);
            var url = Url.Download(urlPart, method);
            if (url.indexOf("?") < 0)
                url += "?";
            var content;
            switch (httpMethod) {
                case "PUT":
                case "POST":
                    content = serviceTransformers.FormatRequest(args);
                    if (content instanceof FormData)
                        throw new Error("Cannot download using a request that has Blobs.");
                    url += utils.EncodeUri(templateObject_14 || (templateObject_14 = __makeTemplateObject(["&$$Content=", "&$$ContentType=", ""], ["&$$Content=", "&$$ContentType=", ""])), content, 'application/json');
                    break;
            }
            $window.open("" + url + utils.EncodeUri(templateObject_15 || (templateObject_15 = __makeTemplateObject(["&$$Method=", ""], ["&$$Method=", ""])), httpMethod), "_blank");
            if (args.hasOwnProperty("ShowErrorNotification")) {
                if (JSON.parse(JSON.stringify(args)).ShowErrorNotification) {
                    var messageReceived_1 = false;
                    var handleMessage = function (e) {
                        if (e.data.length > 0) {
                            messageReceived_1 = true;
                            var alertDlg = ng_utils_1.$mdDialog
                                .alert()
                                .disableParentScroll(false)
                                .title("File Not Found")
                                .textContent(e.data)
                                .ok("ok");
                            ng_utils_1.$mdDialog.show(alertDlg);
                        }
                        $window.removeEventListener("message", handleMessage, false);
                    };
                    $window.addEventListener('message', handleMessage);
                    setTimeout(function () {
                        if (!messageReceived_1) {
                            $window.removeEventListener("message", handleMessage, false);
                        }
                    }, 2000);
                }
            }
        };
        DownloadProxy.prototype.FormatUriArgument = function (arg) {
            return FormatUriArgument(arg);
        };
        DownloadProxy.prototype.FormatRequestArguments = function (args) {
            return FormatRequestArguments(this.authService, args);
        };
        return DownloadProxy;
    }());
    exports.DownloadProxy = DownloadProxy;
    var templateObject_14, templateObject_15;
});
define("app/sss/decorators", ["require", "exports", "app/utils"], function (require, exports, utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BindFunctions = utils_1.BindFunctions;
});
define("app/selcomm/service-reference/download/selcomm-data-types", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
define("app/selcomm/service-reference/download/service-client-api", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
define("app/selcomm/service", ["require", "exports", "app/basic-utils", "app/selcomm/service-proxy", "app/selcomm/auth", "app/sss/decorators", "app/selcomm/service-reference/selcomm-types", "app/selcomm/service-reference/service-client", "app/utils", "app/selcomm/selcomm-api", "app/selcomm/auth", "app/selcomm/service-reference/selcomm-types"], function (require, exports, utils, proxy, authentication, decorators_1, selcomm_types_2, ServiceImplementation, utils_2, selcomm_api_1, auth_1, selcomm_types_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.List = utils_2.List;
    exports.Progress = selcomm_api_1.Progress;
    exports.ExtendedSession = auth_1.ExtendedSession;
    exports.Selcomm = selcomm_types_3.Selcomm;
    exports.SelcommOSSAAPT = selcomm_types_3.SelcommOSSAAPT;
    exports.System = selcomm_types_3.System;
    var LegacyService = (function () {
        function LegacyService(LegacyServiceProxy) {
            this.LegacyServiceProxy = LegacyServiceProxy;
            this.Prepare = new Preparer(this);
        }
        LegacyService.prototype.get = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return this.Get.apply(this, args);
        };
        LegacyService.prototype.Get = function (service, method, data, config) {
            return this.LegacyServiceProxy.Invoke("GET", service, method, data, config);
        };
        LegacyService.prototype.post = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return this.Post.apply(this, args);
        };
        LegacyService.prototype.Post = function (service, method, data, config) {
            return this.LegacyServiceProxy.Invoke("POST", service, method, data, config);
        };
        LegacyService.prototype.put = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return this.Put.apply(this, args);
        };
        LegacyService.prototype.Put = function (service, method, data, config) {
            return this.LegacyServiceProxy.Invoke("PUT", service, method, data, config);
        };
        LegacyService.prototype.delete = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return this.Delete.apply(this, args);
        };
        LegacyService.prototype.Delete = function (service, method, data, config) {
            return this.LegacyServiceProxy.Invoke("DELETE", service, method, data, config);
        };
        Object.defineProperty(LegacyService.prototype, "prepare", {
            get: function () {
                return this.Prepare;
            },
            enumerable: true,
            configurable: true
        });
        LegacyService = __decorate([
            decorators_1.BindFunctions
        ], LegacyService);
        return LegacyService;
    }());
    var Preparer = (function () {
        function Preparer(underlyingService, cachedService) {
            this.underlyingService = underlyingService;
            if (cachedService)
                this.cached = new Preparer(cachedService);
        }
        Preparer.prototype.get = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return this.Get.apply(this, args);
        };
        Preparer.prototype.Get = function (service, method, data, config) {
            var underlyingService = this.underlyingService;
            var leftArgs = Array.prototype.slice.call(arguments, 0);
            return function () {
                var rightArgs = Array.prototype.slice.call(arguments, 0);
                return underlyingService.Get.apply(underlyingService, leftArgs.concat(rightArgs));
            };
        };
        Preparer.prototype.post = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return this.Post.apply(this, args);
        };
        Preparer.prototype.Post = function (service, method, data, config) {
            var underlyingService = this.underlyingService;
            var leftArgs = Array.prototype.slice.call(arguments, 0);
            return function () {
                var rightArgs = Array.prototype.slice.call(arguments, 0);
                return underlyingService.Post.apply(underlyingService, leftArgs.concat(rightArgs));
            };
        };
        Preparer.prototype.put = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return this.Put.apply(this, args);
        };
        Preparer.prototype.Put = function (service, method, data, config) {
            var underlyingService = this.underlyingService;
            var leftArgs = Array.prototype.slice.call(arguments, 0);
            return function () {
                var rightArgs = Array.prototype.slice.call(arguments, 0);
                return underlyingService.Put.apply(underlyingService, leftArgs.concat(rightArgs));
            };
        };
        Preparer.prototype.delete = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return this.Delete.apply(this, args);
        };
        Preparer.prototype.Delete = function (service, method, data, config) {
            var underlyingService = this.underlyingService;
            var leftArgs = Array.prototype.slice.call(arguments, 0);
            return function () {
                var rightArgs = Array.prototype.slice.call(arguments, 0);
                return underlyingService.Delete.apply(underlyingService, leftArgs.concat(rightArgs));
            };
        };
        return Preparer;
    }());
    var CachableServices = (function (_super) {
        __extends(CachableServices, _super);
        function CachableServices(serviceProxy) {
            var _this = _super.call(this, serviceProxy) || this;
            _this.Cached = new ServiceImplementation.Services(new proxy.CachedServiceReferenceProxy(serviceProxy));
            return _this;
        }
        return CachableServices;
    }(ServiceImplementation.Services));
    var ExtendedServices = (function (_super) {
        __extends(ExtendedServices, _super);
        function ExtendedServices(proxies) {
            var _this = _super.call(this, proxies.Standard) || this;
            _this.Thin = new CachableServices(proxies.Thin);
            return _this;
        }
        Object.defineProperty(ExtendedServices.prototype, "Thick", {
            get: function () {
                return this;
            },
            enumerable: true,
            configurable: true
        });
        return ExtendedServices;
    }(CachableServices));
    var SelcommService = (function (_super) {
        __extends(SelcommService, _super);
        function SelcommService() {
            var _this = _super.call(this) || this;
            _this.Auth = new authentication.Service(_this);
            var legacyProxy = _this.LegacyServiceProxy = new proxy.Legacy.StandardProxy(_this.Auth);
            _this.Cached = new LegacyService(new proxy.Legacy.CachedProxy(legacyProxy));
            _this.Prepare = new Preparer(_this, _this.Cached);
            _this.ServiceProxy = new proxy.ServiceReferenceProxy(_this.Auth);
            _this.ThinServiceProxy = new proxy.ServiceReferenceProxy.ThinServiceProxy(_this.Auth);
            _this.Service = new ExtendedServices({ Standard: _this.ServiceProxy, Thin: _this.ThinServiceProxy, });
            _this.Auth.ValidateSessions();
            return _this;
        }
        Object.defineProperty(SelcommService.prototype, "cached", {
            get: function () {
                return this.Cached;
            },
            set: function (value) {
                throw new Error("Dude WTF!?");
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SelcommService.prototype, "authentication", {
            get: function () {
                return this.Auth;
            },
            set: function (value) {
                this.Auth = value;
            },
            enumerable: true,
            configurable: true
        });
        SelcommService = __decorate([
            decorators_1.BindFunctions
        ], SelcommService);
        return SelcommService;
    }(LegacyService));
    var singleton = new SelcommService();
    exports.Cached = singleton.Cached;
    exports.cached = exports.Cached;
    exports.Auth = singleton.Auth;
    exports.Authentication = exports.Auth;
    exports.authentication = exports.Auth;
    function Delete(service, method, data, config) {
        return singleton.Delete(service, method, data, config);
    }
    exports.Delete = Delete;
    exports.delete = Delete;
    function Get(service, method, data, config) {
        return singleton.Get(service, method, data, config);
    }
    exports.Get = Get;
    exports.get = Get;
    function Post(service, method, data, config) {
        return singleton.Post(service, method, data, config);
    }
    exports.Post = Post;
    exports.post = Post;
    function Put(service, method, data, config) {
        return singleton.Put(service, method, data, config);
    }
    exports.Put = Put;
    exports.put = Put;
    exports.Prepare = singleton.Prepare;
    exports.prepare = exports.Prepare;
    var service = singleton.Service;
    exports.Service = service;
    var cachedService = new ServiceImplementation.Services(new proxy.CachedServiceReferenceProxy(singleton.ServiceProxy));
    exports.CachedService = cachedService;
    var downloadService = new ServiceImplementation.Services(new proxy.DownloadProxy(singleton.Auth));
    exports.DownloadService = downloadService;
    function ExtendFilter(filter) {
        return utils.Extend(filter, {
            Or: function () {
                var otherFilters = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    otherFilters[_i] = arguments[_i];
                }
                return FilterService.Any.apply(FilterService, __spread([filter], otherFilters));
            },
            And: function () {
                var otherFilters = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    otherFilters[_i] = arguments[_i];
                }
                return FilterService.All.apply(FilterService, __spread([filter], otherFilters));
            },
        });
    }
    var FilterService = (function () {
        function FilterService() {
        }
        FilterService.For = function () {
            return new FilterService();
        };
        FilterService.prototype.On = function () {
            var propertyNames = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                propertyNames[_i] = arguments[_i];
            }
            return new PropertyBoundFilterService(propertyNames.join("."));
        };
        return FilterService;
    }());
    exports.Filter = FilterService;
    exports.Filters = FilterService;
    (function (FilterService) {
        function BasicPropertyFilter(propertyName, compareOperator, value) {
            return ExtendFilter(new selcomm_types_2.Selcomm.Filters.BasicPropertyFilter({ CompareOperator: compareOperator, PropertyName: propertyName, Value: value }));
        }
        FilterService.BasicPropertyFilter = BasicPropertyFilter;
        function Equals(propertyName, value) {
            return BasicPropertyFilter(propertyName, selcomm_types_2.Selcomm.Filters.BasicCompareOperator.Equals, value);
        }
        FilterService.Equals = Equals;
        function NotEquals(propertyName, value) {
            return BasicPropertyFilter(propertyName, selcomm_types_2.Selcomm.Filters.BasicCompareOperator.NotEquals, value);
        }
        FilterService.NotEquals = NotEquals;
        function LessThan(propertyName, value) {
            return BasicPropertyFilter(propertyName, selcomm_types_2.Selcomm.Filters.BasicCompareOperator.LessThan, value);
        }
        FilterService.LessThan = LessThan;
        function LessThanOrEquals(propertyName, value) {
            return BasicPropertyFilter(propertyName, selcomm_types_2.Selcomm.Filters.BasicCompareOperator.LessThanOrEquals, value);
        }
        FilterService.LessThanOrEquals = LessThanOrEquals;
        function GreaterThan(propertyName, value) {
            return BasicPropertyFilter(propertyName, selcomm_types_2.Selcomm.Filters.BasicCompareOperator.GreaterThan, value);
        }
        FilterService.GreaterThan = GreaterThan;
        function GreaterThanOrEquals(propertyName, value) {
            return BasicPropertyFilter(propertyName, selcomm_types_2.Selcomm.Filters.BasicCompareOperator.GreaterThanOrEquals, value);
        }
        FilterService.GreaterThanOrEquals = GreaterThanOrEquals;
        function Not(filter) {
            return ExtendFilter(new selcomm_types_2.Selcomm.Filters.NotFilter({ Filter: filter }));
        }
        FilterService.Not = Not;
        function All() {
            var filters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                filters[_i] = arguments[_i];
            }
            return ExtendFilter(new selcomm_types_2.Selcomm.Filters.AllFilterGroup({ Filters: filters }));
        }
        FilterService.All = All;
        function Any() {
            var filters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                filters[_i] = arguments[_i];
            }
            return ExtendFilter(new selcomm_types_2.Selcomm.Filters.AnyFilterGroup({ Filters: filters }));
        }
        FilterService.Any = Any;
        function Between(propertyName, startValue, endValue) {
            return ExtendFilter(new selcomm_types_2.Selcomm.Filters.BetweenPropertyFilter({ PropertyName: propertyName, StartValue: startValue, EndValue: endValue }));
        }
        FilterService.Between = Between;
        function In(propertyName, values) {
            return ExtendFilter(new selcomm_types_2.Selcomm.Filters.InPropertyFilter({ PropertyName: propertyName, Values: values }));
        }
        FilterService.In = In;
        function Keyword(propertyName, value) {
            return ExtendFilter(new selcomm_types_2.Selcomm.Filters.KeywordPropertyFilter({ PropertyName: propertyName, Value: value }));
        }
        FilterService.Keyword = Keyword;
        FilterService.Direction = selcomm_types_2.Selcomm.Filters.SortDirection;
    })(FilterService || (FilterService = {}));
    exports.Filter = FilterService;
    exports.Filters = FilterService;
    var PropertyBoundFilterService = (function (_super) {
        __extends(PropertyBoundFilterService, _super);
        function PropertyBoundFilterService(PropertyChain) {
            var _this = _super.call(this) || this;
            _this.PropertyChain = PropertyChain;
            return _this;
        }
        PropertyBoundFilterService.prototype.On = function () {
            var propertyNames = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                propertyNames[_i] = arguments[_i];
            }
            return new PropertyBoundFilterService(__spread([this.PropertyChain], propertyNames).join("."));
        };
        PropertyBoundFilterService.prototype.Equals = function (value) {
            return FilterService.Equals(this.PropertyChain, value);
        };
        PropertyBoundFilterService.prototype.NotEquals = function (value) {
            return FilterService.NotEquals(this.PropertyChain, value);
        };
        PropertyBoundFilterService.prototype.LessThan = function (value) {
            return FilterService.LessThan(this.PropertyChain, value);
        };
        PropertyBoundFilterService.prototype.LessThanOrEquals = function (value) {
            return FilterService.LessThanOrEquals(this.PropertyChain, value);
        };
        PropertyBoundFilterService.prototype.GreaterThan = function (value) {
            return FilterService.GreaterThan(this.PropertyChain, value);
        };
        PropertyBoundFilterService.prototype.GreaterThanOrEquals = function (value) {
            return FilterService.NotEquals(this.PropertyChain, value);
        };
        PropertyBoundFilterService.prototype.Between = function (startValue, endValue) {
            return FilterService.Between(this.PropertyChain, startValue, endValue);
        };
        PropertyBoundFilterService.prototype.In = function (values) {
            return FilterService.In(this.PropertyChain, values);
        };
        PropertyBoundFilterService.prototype.NotIn = function (values) {
            return FilterService.Not(this.In(values));
        };
        PropertyBoundFilterService.prototype.Keyword = function (value) {
            return FilterService.Keyword(this.PropertyChain, value);
        };
        return PropertyBoundFilterService;
    }(FilterService));
    exports.SelcommWsApplicationError = proxy.ServiceReferenceProxy.SelcommWsApplicationError;
    var SortService = (function () {
        function SortService() {
        }
        SortService.For = function () {
            return new SortService();
        };
        SortService.prototype.On = function () {
            var propertyNames = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                propertyNames[_i] = arguments[_i];
            }
            return new SortService.PropertyBound(propertyNames.join("."));
        };
        return SortService;
    }());
    exports.SortService = SortService;
    (function (SortService) {
        SortService.Direction = selcomm_types_2.Selcomm.Filters.SortDirection;
        var PropertyBound = (function (_super) {
            __extends(PropertyBound, _super);
            function PropertyBound(PropertyChain) {
                var _this = _super.call(this) || this;
                _this.PropertyChain = PropertyChain;
                return _this;
            }
            PropertyBound.prototype.On = function () {
                var propertyNames = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    propertyNames[_i] = arguments[_i];
                }
                return new SortService.PropertyBound(__spread([this.PropertyChain], propertyNames).join("."));
            };
            PropertyBound.prototype.Ascending = function () {
                return this.Direction(SortService.Direction.Ascending);
            };
            PropertyBound.prototype.Descending = function () {
                return this.Direction(SortService.Direction.Descending);
            };
            PropertyBound.prototype.Direction = function (direction) {
                return new selcomm_types_2.Selcomm.Filters.Sort({
                    TargetProperty: this.PropertyChain,
                    Direction: direction,
                });
            };
            return PropertyBound;
        }(SortService));
        SortService.PropertyBound = PropertyBound;
    })(SortService = exports.SortService || (exports.SortService = {}));
    exports.SortService = SortService;
    function Sort(propertyName, direction) {
        return new selcomm_types_2.Selcomm.Filters.Sort({
            TargetProperty: propertyName,
            Direction: direction,
        });
    }
    exports.Sort = Sort;
    (function (Sort) {
        Sort.Direction = selcomm_types_2.Selcomm.Filters.SortDirection;
    })(Sort = exports.Sort || (exports.Sort = {}));
});
define("app/sdc/md/helpers", ["require", "exports", "app/ng-utils", "app/basic-utils"], function (require, exports, ng_utils_2, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var StaticItems = (function () {
        function StaticItems(items) {
            this.items = items;
        }
        StaticItems.prototype.getItemAtIndex = function (index) {
            return this.items[index];
        };
        StaticItems.prototype.getLength = function () {
            return this.items.length;
        };
        return StaticItems;
    }());
    exports.StaticItems = StaticItems;
    var DynamicItems = (function () {
        function DynamicItems(PageSize, PageFetcher, PrefetchFirstPage) {
            if (PrefetchFirstPage === void 0) { PrefetchFirstPage = true; }
            this.PageSize = PageSize;
            this.PageFetcher = PageFetcher;
            this.PrefetchFirstPage = PrefetchFirstPage;
            this.loadedPages = Object.create(null);
            this.loadingPages = Object.create(null);
            this.fetchCount = 0;
            if (PrefetchFirstPage)
                this.FetchPage(0);
        }
        Object.defineProperty(DynamicItems.prototype, "IsLoading", {
            get: function () {
                return this.fetchCount > 0;
            },
            enumerable: true,
            configurable: true
        });
        DynamicItems.prototype.getItemAtIndex = function (index) {
            var pageSubIndex = index % this.PageSize;
            var pageIndex = (index - pageSubIndex) / this.PageSize;
            var page = this.loadedPages[pageIndex];
            if (!utils.IsVoid(page))
                return page[pageSubIndex];
            this.FetchPage(pageIndex);
            return null;
        };
        DynamicItems.prototype.FetchPage = function (pageIndex) {
            var promise = this.loadingPages[pageIndex];
            if (!utils.IsVoid(promise))
                return promise;
            return this.loadingPages[pageIndex] = this.InnerFetchPage(pageIndex);
        };
        DynamicItems.prototype.InnerFetchPage = function (pageIndex) {
            return __awaiter(this, void 0, void 0, function () {
                var results, newTotalCount;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.fetchCount++;
                            ng_utils_2.$rootScope.$applyAsync();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4, this.PageFetcher({
                                    PageIndex: pageIndex,
                                    PageNumber: pageIndex + 1,
                                    PageSize: this.PageSize,
                                    SkipRecords: this.PageSize * pageIndex,
                                    TakeRecords: this.PageSize
                                })];
                        case 2:
                            results = _a.sent();
                            newTotalCount = results.TotalFilteredRecords;
                            if (utils.IsVoid(results.TotalFilteredRecords)) {
                                if (results.Items.length < this.PageSize && (results.Items.length > 0 || pageIndex === 0))
                                    this.TotalCount = ((pageIndex) * this.PageSize) + results.Items.length;
                            }
                            else if (newTotalCount === 0) {
                                if (!utils.IsVoid(this.TotalCount) || results.Items.length > 0)
                                    newTotalCount = null;
                            }
                            if (!utils.IsVoid(newTotalCount))
                                this.TotalCount = newTotalCount;
                            if (results.Items.length) {
                                if (utils.IsVoid(this.LargestKnownPage))
                                    this.LargestKnownPage = pageIndex;
                                else
                                    this.LargestKnownPage = Math.max(this.LargestKnownPage, pageIndex);
                            }
                            this.loadedPages[pageIndex] = results.Items;
                            return [2, results.Items];
                        case 3:
                            this.fetchCount--;
                            ng_utils_2.$rootScope.$applyAsync();
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        DynamicItems.prototype.getLength = function () {
            if (utils.IsVoid(this.TotalCount)) {
                if (this.PrefetchFirstPage && utils.IsVoid(this.LargestKnownPage))
                    return 1;
                else
                    return ((this.LargestKnownPage || 0) + 1) * this.PageSize;
            }
            return this.TotalCount || 0;
        };
        return DynamicItems;
    }());
    exports.DynamicItems = DynamicItems;
});
define("app/sdc/md/interim-element", ["require", "exports", "app/pre-angular-bootstrap-utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PassThroughRegisteredControllerNames = new Array();
    function PassThrough(controllerName) {
        if (!arguments.length)
            return function (controller) { return PassThrough(controller); };
        if (!utils.IsString(controllerName))
            controllerName = utils.GetComponentName(controllerName);
        PassThroughRegisteredControllerNames.push("$" + utils.CamelCase(controllerName) + "Controller");
        return (void null);
    }
    exports.PassThrough = PassThrough;
    (function (PassThrough) {
        PassThrough.RegisteredControllerNames = PassThroughRegisteredControllerNames;
    })(PassThrough = exports.PassThrough || (exports.PassThrough = {}));
});
define("app/sdc/storage/sdc-storage", ["require", "exports", "$window", "app/basic-utils", "app/selcomm/service-transformers"], function (require, exports, $window, utils, service_transformers_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ExtendedStorage = (function () {
        function ExtendedStorage() {
        }
        return ExtendedStorage;
    }());
    exports.ExtendedStorage = ExtendedStorage;
    (function (ExtendedStorage) {
        var IStorageWrapper = (function (_super) {
            __extends(IStorageWrapper, _super);
            function IStorageWrapper(source) {
                var _this = _super.call(this) || this;
                _this.source = source;
                if (!source)
                    throw new Error("source cannot be falsey");
                return _this;
            }
            Object.defineProperty(IStorageWrapper.prototype, "Length", {
                get: function () {
                    return this.source.length;
                },
                set: function (value) {
                    this.source.length = value;
                },
                enumerable: true,
                configurable: true
            });
            IStorageWrapper.prototype.Clear = function () {
                this.source.clear();
            };
            IStorageWrapper.prototype.GetItem = function (key) {
                return this.source.getItem(key);
            };
            IStorageWrapper.prototype.Key = function (index) {
                return this.source.key(index);
            };
            IStorageWrapper.prototype.RemoveItem = function (key) {
                this.source.removeItem(key);
            };
            IStorageWrapper.prototype.SetItem = function (key, data) {
                this.source.setItem(key, data);
            };
            IStorageWrapper.prototype.GetKeys = function () {
                var keys = new Array();
                for (var i = 0; i < this.source.length; i++) {
                    keys.push(this.source.key(i));
                }
                return keys;
            };
            IStorageWrapper.prototype.GetKeysIterable = function () {
                var i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < this.source.length)) return [3, 4];
                            return [4, this.source.key(i)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3, 1];
                        case 4: return [2];
                    }
                });
            };
            Object.defineProperty(IStorageWrapper.prototype, "Keys", {
                get: function () {
                    var _this = this;
                    return utils.Collection.ToEnumerable(function () { return _this.GetKeysIterable(); });
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(IStorageWrapper.prototype, "Entries", {
                get: function () {
                    var _this = this;
                    return this.Keys
                        .Select(function (key) { return ({
                        Key: key,
                        Value: _this.GetItem(key),
                    }); });
                },
                enumerable: true,
                configurable: true
            });
            IStorageWrapper.prototype.HasKey = function (key) {
                return utils.Collection.IndexOf(this.Keys, function (k) { return k === key; }) >= 0;
            };
            return IStorageWrapper;
        }(ExtendedStorage));
        function EnsureExtendedStorage(source) {
            return (source instanceof ExtendedStorage) ? source : new IStorageWrapper(source);
        }
        ExtendedStorage.EnsureExtendedStorage = EnsureExtendedStorage;
    })(ExtendedStorage = exports.ExtendedStorage || (exports.ExtendedStorage = {}));
    exports.ExtendedStorage = ExtendedStorage;
    var PrefixedStorage = (function (_super) {
        __extends(PrefixedStorage, _super);
        function PrefixedStorage(prefix, underlyingStorage) {
            var _this = _super.call(this) || this;
            _this.prefix = prefix;
            underlyingStorage = ExtendedStorage.EnsureExtendedStorage(underlyingStorage);
            if (underlyingStorage instanceof PrefixedStorage) {
                var _underlyingPrefixed = underlyingStorage;
                _this.underlyingStorage = _underlyingPrefixed.underlyingStorage;
                _this.prefix = "" + _underlyingPrefixed.prefix + _this.prefix;
            }
            else {
                _this.underlyingStorage = underlyingStorage;
            }
            return _this;
        }
        PrefixedStorage.prototype.ValidateKey = function (rawKey) {
            return rawKey ? rawKey.startsWith(this.prefix) : false;
        };
        PrefixedStorage.prototype.formatKey = function (key) {
            return this.prefix + key;
        };
        PrefixedStorage.prototype.ParseKey = function (key) {
            return key.substr(this.prefix.length);
        };
        Object.defineProperty(PrefixedStorage.prototype, "Length", {
            get: function () {
                var count = 0;
                for (var i = 0; i < this.underlyingStorage.Length; i++) {
                    if (this.ValidateKey(this.underlyingStorage.Key(i)))
                        count++;
                }
                return count;
            },
            enumerable: true,
            configurable: true
        });
        PrefixedStorage.prototype.Clear = function () {
            var _this = this;
            var keysToRemove = new Array();
            for (var i = 0; i < this.underlyingStorage.Length; i++) {
                var key = this.underlyingStorage.Key(i);
                if (this.ValidateKey(key))
                    keysToRemove.push(key);
            }
            keysToRemove.forEach(function (key) { return _this.underlyingStorage.RemoveItem(key); });
        };
        PrefixedStorage.prototype.GetItem = function (key) {
            return this.underlyingStorage.GetItem(this.formatKey(key));
        };
        PrefixedStorage.prototype.HasKey = function (key) {
            var formattedKey = this.formatKey(key);
            return utils.Collection.IndexOf(this.underlyingStorage.Keys, function (k) { return k === formattedKey; }) >= 0;
        };
        PrefixedStorage.prototype.Key = function (index) {
            var n = 0;
            for (var i = 0; i < this.underlyingStorage.Length; i++) {
                var key = this.underlyingStorage.Key(i);
                if (!this.ValidateKey(key))
                    continue;
                if (n === index)
                    return key;
                else
                    n++;
            }
            return null;
        };
        PrefixedStorage.prototype.RemoveItem = function (key) {
            this.underlyingStorage.RemoveItem(this.formatKey(key));
        };
        PrefixedStorage.prototype.SetItem = function (key, data) {
            this.underlyingStorage.SetItem(this.formatKey(key), data);
        };
        Object.defineProperty(PrefixedStorage.prototype, "Keys", {
            get: function () {
                var _this = this;
                return this.underlyingStorage.Keys
                    .Where(function (key) { return _this.ValidateKey(key); })
                    .Select(function (key) { return _this.ParseKey(key); });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PrefixedStorage.prototype, "Entries", {
            get: function () {
                var _this = this;
                return this.underlyingStorage.Keys
                    .Where(function (key) { return _this.ValidateKey(key); })
                    .Select(function (key) { return ({
                    Key: _this.ParseKey(key),
                    Value: _this.underlyingStorage.GetItem(key),
                }); });
            },
            enumerable: true,
            configurable: true
        });
        return PrefixedStorage;
    }(ExtendedStorage));
    var ObjectStorage = (function () {
        function ObjectStorage(source, Serializer) {
            if (Serializer === void 0) { Serializer = ObjectStorage.DefaultSerializer; }
            this.Serializer = Serializer;
            this.source = ExtendedStorage.EnsureExtendedStorage(source);
        }
        Object.defineProperty(ObjectStorage.prototype, "Length", {
            get: function () {
                return this.source.Length;
            },
            enumerable: true,
            configurable: true
        });
        ObjectStorage.prototype.Clear = function () {
            this.source.Clear();
        };
        ObjectStorage.prototype.GetItem = function (key) {
            var json = this.source.GetItem(key);
            var parsed = this.Serializer.Parse(json);
            return parsed;
        };
        ObjectStorage.prototype.GetKey = function (index) {
            return this.source.Key(index);
        };
        ObjectStorage.prototype.RemoveItem = function (key) {
            this.source.RemoveItem(key);
        };
        ObjectStorage.prototype.SetItem = function (key, data) {
            var jsonData = this.Serializer.Format(data);
            this.source.SetItem(key, jsonData);
        };
        Object.defineProperty(ObjectStorage.prototype, "Keys", {
            get: function () {
                return this.source.Keys;
            },
            enumerable: true,
            configurable: true
        });
        ObjectStorage.prototype.HasKey = function (key) {
            return this.source.HasKey(key);
        };
        Object.defineProperty(ObjectStorage.prototype, "Entries", {
            get: function () {
                var _this = this;
                return this.source.Entries
                    .Select(function (e) { return new ObjectStorage.Entry(_this, _this.Serializer, e.Key, e.Value); });
            },
            enumerable: true,
            configurable: true
        });
        ObjectStorage.prototype.Prefixed = function (prefix, serialiser) {
            return new ObjectStorage(new PrefixedStorage(prefix, this.source), serialiser || this.Serializer);
        };
        return ObjectStorage;
    }());
    exports.ObjectStorage = ObjectStorage;
    (function (ObjectStorage) {
        ObjectStorage.DefaultSerializer = Object.freeze({
            Parse: function (data) {
                if (utils.IsVoid(data))
                    return data;
                if (data === String(undefined))
                    return void data;
                var parsed = JSON.parse(data);
                var revived = service_transformers_1.Dates.ReviveFast(service_transformers_1.SelcommClass.ReviveFast(parsed));
                return revived;
            },
            Format: function (obj) {
                return JSON.stringify(obj);
            },
        });
        var Entry = (function () {
            function Entry(Source, Serialiser, Key, Data) {
                this.Source = Source;
                this.Serialiser = Serialiser;
                this.Key = Key;
                this.Data = Data;
                this.hasParsedValue = false;
            }
            Object.defineProperty(Entry.prototype, "Value", {
                get: function () {
                    if (!this.hasParsedValue) {
                        this.parsedValue = this.Serialiser.Parse(this.Data);
                        this.hasParsedValue = true;
                    }
                    return this.parsedValue;
                },
                enumerable: true,
                configurable: true
            });
            return Entry;
        }());
        ObjectStorage.Entry = Entry;
    })(ObjectStorage = exports.ObjectStorage || (exports.ObjectStorage = {}));
    exports.ObjectStorage = ObjectStorage;
    exports.Session = new ObjectStorage($window.sessionStorage);
    exports.Local = new ObjectStorage($window.localStorage);
});
define("app/utils", ["require", "exports", "app/ng-utils", "app/path-utils", "app/pre-angular-bootstrap-utils", "app/pre-angular-bootstrap-utils", "app/amd-utils", "app/amd-utils", "moment", "scripts/lib/select-development/sss-names", "app/selcomm/service-transformers", "app/sdc/md/helpers", "scripts/lib/select-development/sss-watch", "app/sdc/md/interim-element", "app/selcomm/service-reference/selcomm-types", "app/sdc/storage/sdc-storage"], function (require, exports, ng_utils_3, paths, utils, pre_angular_bootstrap_utils_1, amd_utils_3, amdUtils, moment, names, service_transformers_2, mdHelpers, sss_watch_1, InterimElement, selcomm_types_4, Storage) {
    "use strict";
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Paths = paths;
    __export(pre_angular_bootstrap_utils_1);
    exports.Component = amd_utils_3.Component;
    exports.Directive = amd_utils_3.Directive;
    exports.EnsureNoLegacyFallback = amd_utils_3.EnsureNoLegacyFallback;
    exports.md = mdHelpers;
    exports.InterimElement = InterimElement;
    exports.Storage = Storage;
    function ReviveClasses(value) {
        return service_transformers_2.SelcommClass.Revive(value);
    }
    exports.ReviveClasses = ReviveClasses;
    var Context = (function () {
        function Context(Item) {
            this._IsDeleteVisible = false;
            this.Value = Item;
        }
        Context.DefaultGetItems = function (x) {
            return x;
        };
        Context.prototype.ToggleDeleteVisibility = function () {
            this.IsDeleteVisible = !this.IsDeleteVisible;
        };
        Context.prototype.ToggleEditVisibility = function () {
            this.IsEditVisible = !this.IsEditVisible;
        };
        Object.defineProperty(Context.prototype, "IsAnyVisible", {
            get: function () {
                return this.IsDeleteVisible || this.IsEditVisible;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Context.prototype, "IsDeleteVisible", {
            get: function () {
                return this._IsDeleteVisible;
            },
            set: function (value) {
                if (value === this.IsDeleteVisible)
                    return;
                if (value)
                    this.ShowDelete();
                else
                    this.HideDelete();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Context.prototype, "IsEditVisible", {
            get: function () {
                return !this.IsDeleteVisible && !!(this.EditValue || this.Loading || this.Error);
            },
            set: function (newState) {
                if (newState === this.IsEditVisible)
                    return;
                if (newState)
                    this.ShowEdit();
                else
                    this.HideEdit();
            },
            enumerable: true,
            configurable: true
        });
        Context.prototype.ShowDelete = function () {
            this.HideEdit();
            this._IsDeleteVisible = true;
        };
        Context.prototype.HideAny = function () {
            this.HideDelete();
            this.HideEdit();
        };
        Context.prototype.HideDelete = function () {
            this._IsDeleteVisible = false;
            this.Loading = null;
        };
        Context.prototype.ShowEdit = function () {
            var _this = this;
            this.Error = null;
            this.IsDeleteVisible = false;
            if (this.showPromise === this.Loading && this.showPromise)
                return this.showPromise;
            var promise = utils.Execute(function () { return __awaiter(_this, void 0, ng_utils_3.$q, function () {
                var editingValue, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 5]);
                            return [4, this.GetEditableItem()];
                        case 1:
                            editingValue = _a.sent();
                            return [3, 5];
                        case 2:
                            err_2 = _a.sent();
                            if (!(promise !== this.Loading)) return [3, 4];
                            return [4, ng_utils_3.$q.reject("Cancelled")];
                        case 3: return [2, _a.sent()];
                        case 4:
                            this.EditValue = null;
                            this.Error = err_2;
                            throw err_2;
                        case 5:
                            if (!(promise !== this.Loading)) return [3, 7];
                            return [4, ng_utils_3.$q.reject("Cancelled")];
                        case 6: return [2, _a.sent()];
                        case 7:
                            this.EditValue = editingValue;
                            this.Error = null;
                            return [2, editingValue];
                    }
                });
            }); }).finally(function () {
                if (promise === _this.Loading)
                    _this.Loading = null;
            });
            this.Loading = this.showPromise = promise;
            return promise;
        };
        Context.prototype.HideEdit = function () {
            this.EditValue = null;
            this.Loading = null;
            this.Error = null;
        };
        Context.CreateList = function (source, getEditableItem) {
            if (getEditableItem === void 0) { getEditableItem = Context.DefaultGetItems; }
            if (utils.List.IsListData(source))
                return utils.List.Map(source, function (value) { return new AdHocContext(value, getEditableItem); });
            else
                return source.map(function (value) { return new AdHocContext(value, getEditableItem); });
        };
        return Context;
    }());
    exports.Context = Context;
    function PassErrorThrough(setErrorMessage) {
        return function (err) {
            setErrorMessage(err);
            return ng_utils_3.$q.reject(err);
        };
    }
    exports.PassErrorThrough = PassErrorThrough;
    var AdHocContext = (function (_super) {
        __extends(AdHocContext, _super);
        function AdHocContext(Item, editableItemFactory) {
            var _this = _super.call(this, Item) || this;
            _this.editableItemFactory = editableItemFactory;
            return _this;
        }
        AdHocContext.prototype.GetEditableItem = function () {
            return this.editableItemFactory(this.Value);
        };
        return AdHocContext;
    }(Context));
    var SimpleContext = (function (_super) {
        __extends(SimpleContext, _super);
        function SimpleContext() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SimpleContext.CreateList = function (source) {
            if (utils.List.IsListData(source))
                return utils.List.Map(source, function (value) { return new SimpleContext(value); });
            else
                return source.map(function (value) { return new SimpleContext(value); });
        };
        SimpleContext.prototype.GetEditableItem = function () {
            return angular.copy(this.Value);
        };
        return SimpleContext;
    }(Context));
    exports.SimpleContext = SimpleContext;
    function IsMoment(arg) {
        return moment.isMoment(arg);
    }
    exports.IsMoment = IsMoment;
    function IsDuration(arg) {
        return moment.isDuration(arg);
    }
    exports.IsDuration = IsDuration;
    function ChartOptionsDiscreteBar(options) {
        return {
            "chart": {
                "type": "discreteBarChart",
                "height": 450,
                "margin": {
                    "top": 10,
                    "right": 0,
                    "bottom": 45,
                    "left": 85
                },
                x: options.X.ValueSelectorFunction,
                y: options.Y.ValueSelectorFunction,
                "showValues": options.ShowValues,
                "duration": 500,
                "xAxis": {
                    "axisLabel": options.X.Label,
                    "staggerLabels": true,
                    tickFormat: options.X.TickFormat,
                    "tickValues": options.X.TickValues,
                },
                "yAxis": {
                    "axisLabel": options.Y.Label,
                    "axisLabelDistance": 20,
                    tickFormat: options.Y.TickFormat,
                    "tickValues": options.Y.TickValues,
                },
                noData: options.NoDataMessage,
                "valueFormat": options.Y.ValueFormat,
            }
        };
    }
    exports.ChartOptionsDiscreteBar = ChartOptionsDiscreteBar;
    function ChartOptionsLineChart(options) {
        return {
            "chart": {
                "type": "lineChart",
                "height": 450,
                "margin": {
                    "top": 10,
                    "right": 0,
                    "bottom": 65,
                    "left": 85
                },
                x: options.X.ValueSelectorFunction,
                y: options.Y.ValueSelectorFunction,
                "showValues": options.ShowValues,
                "duration": 500,
                "xAxis": {
                    "axisLabel": options.X.Label,
                    "staggerLabels": true,
                    "ticks": 12,
                    "tickValues": options.X.TickValues,
                    "rotateLabels": options.X.RotateLabels,
                },
                "yAxis": {
                    "axisLabel": options.Y.Label,
                    "axisLabelDistance": 20,
                    "tickValues": options.Y.TickValues,
                    "rotateLabels": options.Y.RotateLabels,
                },
                noData: options.NoDataMessage,
                "valueFormat": options.Y.ValueFormat,
                xTickFormat: options.X.TickFormat,
                yTickFormat: options.Y.TickFormat,
            }
        };
    }
    exports.ChartOptionsLineChart = ChartOptionsLineChart;
    var HashKeyFactory = (function () {
        function HashKeyFactory(description) {
            this.description = description;
            this.i = 0;
        }
        HashKeyFactory.prototype.NextId = function () {
            return this.i++;
        };
        Object.defineProperty(HashKeyFactory.prototype, "Description", {
            get: function () {
                return this.description;
            },
            enumerable: true,
            configurable: true
        });
        HashKeyFactory.prototype.GetKey = function (source) {
            var key = source && source.$$hashKey;
            if (key) {
                if (typeof key === "function") {
                    key = key.call(source);
                }
                return key;
            }
            var sourceType = typeof source;
            if (sourceType === "function" || (sourceType === "object" && source !== null))
                key = source.$$hashKey = this.description + ":" + sourceType + ":" + this.NextId();
            else
                key = sourceType + ":" + source;
            return key;
        };
        return HashKeyFactory;
    }());
    exports.HashKeyFactory = HashKeyFactory;
    var thingMap = Object.freeze({
        OnCompile: "compile",
        OnLink: "link",
        Priority: "priority",
        Replace: "replace",
        Restrict: "restrict",
        ScopeBindings: "scope",
        Template: "template",
        TemplateNamespace: "templateNamespace",
        Terminal: "terminal",
        TransclusionMode: "transclude",
        MultiElement: "multiElement",
        ControllerAs: "controllerAs",
        bindToController: "bindToController",
    });
    var DirectiveDefinition = (function () {
        function DirectiveDefinition(name, options) {
            if (options === void 0) { options = {}; }
            this._options = options;
            this.setName(name);
        }
        DirectiveDefinition.prototype.setName = function (value) {
            this._directiveName = names.CamelCase(value);
            this._tagName = names.Standardify(value);
        };
        DirectiveDefinition.prototype.lateBoundSetName = function (value) {
            if (!this._directiveName && !this._tagName) {
                this.setName(value);
                return;
            }
            var directiveName = names.CamelCase(value);
            var tagName = names.Standardify(value);
            if (this._directiveName !== directiveName || this._tagName !== tagName)
                throw new Error("The directive \"" + directiveName + "\" has been configured with the incorrect name \"" + this._directiveName + "\"");
        };
        Object.defineProperty(DirectiveDefinition.prototype, "TagName", {
            get: function () {
                return this._tagName;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DirectiveDefinition.prototype, "Name", {
            get: function () {
                return this._directiveName;
            },
            enumerable: true,
            configurable: true
        });
        DirectiveDefinition.prototype.toDirective = function (name) {
            var definition = {};
            this.initialiseDirective(name, definition);
            return definition;
        };
        DirectiveDefinition.prototype.initialiseDirective = function (name, definition) {
            try {
                for (var _a = __values(Object.keys(this._options)), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var key = _b.value;
                    var value = this._options[key];
                    if (!Object.prototype.hasOwnProperty.call(thingMap, key))
                        return;
                    definition[thingMap[key]] = value;
                }
            }
            catch (e_43_1) { e_43 = { error: e_43_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_43) throw e_43.error; }
            }
            this.lateBoundSetName(name);
            var e_43, _c;
        };
        return DirectiveDefinition;
    }());
    exports.DirectiveDefinition = DirectiveDefinition;
    function AsMoment(value) {
        if (moment.isMoment(value))
            return value.clone();
        if (moment.isDate(value))
            return moment(value);
        return value;
    }
    exports.AsMoment = AsMoment;
    function Debounce(wait, invokeApply) {
        return Decorator;
        function Decorator(target, propertyKey, descriptor) {
            var debouncedKey = Symbol(utils.FormatJson(templateObject_16 || (templateObject_16 = __makeTemplateObject(["Debouced[", "]"], ["Debouced[", "]"])), String(propertyKey)));
            var underlyingFn = target[propertyKey];
            var underlyingProp = Object.getOwnPropertyDescriptor(target, propertyKey);
            makeAndCall["Underlying"] = underlyingFn;
            return {
                configurable: true,
                enumerable: underlyingProp ? underlyingProp.enumerable : true,
                value: makeAndCall
            };
            function makeAndCall() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var exposed;
                if (utils.HasProp(this, debouncedKey))
                    exposed = this[debouncedKey];
                else {
                    var debounced_1 = ng_utils_3.$mdUtil.debounce(function (context) {
                        var args = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            args[_i - 1] = arguments[_i];
                        }
                        return underlyingFn.apply(context, args);
                    }, wait, void (0), invokeApply);
                    exposed = this[debouncedKey] = function exposed(context, args) { debounced_1.apply(void 0, __spread([context], args)); };
                }
                exposed(this, args);
            }
        }
    }
    exports.Debounce = Debounce;
    var EnumItem = (function () {
        function EnumItem(Value, Name, DisplayName) {
            if (DisplayName === void 0) { DisplayName = Name.replace(/[a-z](?=[A-Z])/, function (s) { return s + " "; }); }
            this.Value = Value;
            this.Name = Name;
            this.DisplayName = DisplayName;
        }
        return EnumItem;
    }());
    function EnumItems(enumDeclaration) {
        var items = [];
        var EnumMap = {};
        try {
            for (var _a = __values(Object.keys(enumDeclaration)), _b = _a.next(); !_b.done; _b = _a.next()) {
                var key = _b.value;
                if (!/^NaN$|^[\d]/.test(key))
                    continue;
                var item = new EnumItem(Number(key), enumDeclaration[key]);
                items.push(item);
                EnumMap[item.Value] = item;
                EnumMap[item.Name] = item;
            }
        }
        catch (e_44_1) { e_44 = { error: e_44_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_44) throw e_44.error; }
        }
        return utils.Extend(items, { EnumMap: EnumMap });
        var e_44, _c;
    }
    exports.EnumItems = EnumItems;
    var Toast;
    (function (Toast) {
        function Simple(text, dismissAfter) {
            if (dismissAfter === void 0) { dismissAfter = 30000; }
            var options = ng_utils_3.$mdToast.simple();
            options.textContent(text);
            options.hideDelay(dismissAfter);
            options.action("Dismiss");
            options.position("top right");
            return ng_utils_3.$mdToast.show(options);
        }
        Toast.Simple = Simple;
        function Templated(options) {
            return ng_utils_3.$mdToast.show({
                autoWrap: false,
                hideDelay: options.DismissAfter,
                position: "top right",
                template: "\n<md-toast>\n    <div class=\"md-toast-content\">\n        <span class=\"md-toast-text\" role=\"alert\" aria-relevant=\"all\" aria-atomic=\"true\">\n            <sdc-toast-content-template options=\"toast.Options\"></sdc-toast-content-template>\n        </span>\n        <md-button class=\"md-action\" ng-click=\"toast.Resolve()\" ng-class=\"highlightClasses\">\n            Dismiss\n        </md-button>\n    </div>\n</md-toast>",
                controller: (function () {
                    function TemplatedController() {
                        this.Options = options;
                    }
                    TemplatedController.prototype.Resolve = function () {
                        ng_utils_3.$mdToast.hide("ok");
                    };
                    return TemplatedController;
                }()),
                controllerAs: 'toast',
                bindToController: true,
                resolve: {
                    directive: function () { return Require("directive!sdc-toast-content-template"); },
                },
            });
        }
        Toast.Templated = Templated;
    })(Toast = exports.Toast || (exports.Toast = {}));
    function Require(moduleId) {
        return ng_utils_3.$q.resolve(utils.Require(moduleId));
    }
    exports.Require = Require;
    function FromJson(json) {
        return angular.fromJson(json);
    }
    exports.FromJson = FromJson;
    function ToJson(source, pretty) {
        if (pretty === void 0) { pretty = false; }
        return angular.toJson(source, pretty);
    }
    exports.ToJson = ToJson;
    function InjectLocalsToBoundTransclude(boundTransclude, link, slotName) {
        if (!boundTransclude)
            return boundTransclude;
        var underlying = boundTransclude;
        if (underlying.$$slots) {
            return angular.extend(wrapped, underlying, {
                $$slots: angular.map(underlying.$$slots, function (bt, key) { return InjectLocalsToBoundTransclude(bt, link, key); }),
            });
        }
        return angular.extend(wrapped, underlying);
        function wrapped(transcludeScope, cloneFn, controllers, futureParentElement, containingScope) {
            return underlying(transcludeScope, extendScope, controllers, futureParentElement, containingScope);
            function extendScope(clone, scope) {
                var retVal;
                if (cloneFn)
                    retVal = cloneFn(clone, scope);
                link(clone, scope, slotName);
                return retVal;
            }
        }
    }
    function InjectLocalsToTransclude($transclude, link) {
        if (!$transclude || !link)
            return $transclude;
        var underyling = $transclude;
        var _link = link;
        return utils.Extend(WrappedTransclude, {
            isSlotFilled: function (slotName) { return underyling.isSlotFilled(slotName); },
            $$boundTransclude: InjectLocalsToBoundTransclude(underyling.$$boundTransclude, _link, null),
        });
        function WrappedTransclude(scopeOrCloneAttachFn, cloneAttachFnOrFutureParentElement, futureParentElementOrSlotName, slotNameOrNothing) {
            var scope = utils.IsFunction(scopeOrCloneAttachFn) ? null : scopeOrCloneAttachFn;
            var cloneAttachFn = utils.IsFunction(scopeOrCloneAttachFn) ? scopeOrCloneAttachFn : (utils.IsFunction(cloneAttachFnOrFutureParentElement) ? cloneAttachFnOrFutureParentElement : null);
            var futureParentElement = !utils.IsFunction(cloneAttachFnOrFutureParentElement) ? cloneAttachFnOrFutureParentElement : (!utils.IsString(futureParentElementOrSlotName) ? futureParentElementOrSlotName : null);
            var slotName = utils.IsString(futureParentElementOrSlotName) ? futureParentElementOrSlotName : slotNameOrNothing;
            function wrappingCloneAttachFn(clonedElement, scope) {
                var retVal;
                if (cloneAttachFn)
                    retVal = cloneAttachFn(clonedElement, scope);
                _link(clonedElement, scope, slotName || null);
                return retVal;
            }
            if (scope)
                return underyling(scope, wrappingCloneAttachFn, futureParentElement, slotName);
            else
                return underyling(wrappingCloneAttachFn, futureParentElement, slotName);
        }
    }
    exports.InjectLocalsToTransclude = InjectLocalsToTransclude;
    var TranscludeFn;
    (function (TranscludeFn) {
        TranscludeFn.CreateBasic = utils.TranscludeFn.CreateBasic;
        TranscludeFn.CallWithArgs = utils.TranscludeFn.CallWithArgs;
        TranscludeFn.CreateFromSlotTransclude = utils.TranscludeFn.CreateFromSlotTransclude;
        TranscludeFn.ParseControllerBoundTranscludeArgs = utils.TranscludeFn.ParseControllerBoundTranscludeArgs;
        TranscludeFn.CreateFromTemplateLinkingFn = utils.TranscludeFn.CreateFromTemplateLinkingFn;
        TranscludeFn.EmptyTransclude = utils.TranscludeFn.EmptyTransclude;
        function CreateFromTemplate(template, scope, optionDefaults) {
            if (optionDefaults === void 0) { optionDefaults = {}; }
            if (utils.IsString(template)) {
                var container = void 0;
                if (optionDefaults.futureParentElement)
                    container = optionDefaults.futureParentElement.clone(false, false);
                else
                    container = $(document.createElement("div"));
                template = container.html(template).contents();
            }
            return TranscludeFn.CreateFromTemplateLinkingFn(ng_utils_3.$compile(template), scope, optionDefaults);
        }
        TranscludeFn.CreateFromTemplate = CreateFromTemplate;
    })(TranscludeFn = exports.TranscludeFn || (exports.TranscludeFn = {}));
    var Element;
    (function (Element) {
        Element.ApplyAttributes = utils.Element.ApplyAttributes;
        Element.SetAttribute = utils.Element.SetAttribute;
        Element.ApplyAttributeMap = utils.Element.ApplyAttributeMap;
        Element.AddBlockElements = utils.Element.AddBlockElements;
        Element.AsBlock = utils.Element.AsBlock;
        Element.GetBlockNodes = utils.Element.GetBlockNodes;
        function CreateElement(tagOrDirective) {
            var element = $(document.createElement(names.Standardify(tagOrDirective)));
            return element;
        }
        Element.CreateElement = CreateElement;
        function GetDependencies(element) {
            return names.DependenciesFor(element);
        }
        Element.GetDependencies = GetDependencies;
        function RequireDependencies(element) {
            var dependencies = GetDependencies(element);
            return ng_utils_3.$q(function (resolve, reject) { return require(dependencies, function () { return resolve(); }, reject); });
        }
        Element.RequireDependencies = RequireDependencies;
        (function (RequireDependencies) {
            function GetMissing(element) {
                return GetDependencies(element)
                    .filter(function (dep) { return !require.defined(dep); });
            }
            RequireDependencies.GetMissing = GetMissing;
            function IfNeeded(element) {
                var missingDependencies = GetMissing(element);
                if (!missingDependencies.length)
                    return null;
                return ng_utils_3.$q(function (resolve, reject) { return require(missingDependencies, function () { return resolve(); }, reject); });
            }
            RequireDependencies.IfNeeded = IfNeeded;
        })(RequireDependencies = Element.RequireDependencies || (Element.RequireDependencies = {}));
        function CreateElementWithBindings(parentScope, tagOrDirective, bindings) {
            var element = CreateElement(tagOrDirective);
            var scope = parentScope.$new();
            scope._elementBindings = bindings;
            for (var bindingName in bindings) {
                var expr = utils.FormatJson(templateObject_17 || (templateObject_17 = __makeTemplateObject(["this._elementBindings[", "]"], ["this._elementBindings[", "]"])), bindingName);
                var attrName = bindingName;
                Element.SetAttribute(element, attrName, expr);
            }
            return {
                element: element,
                scope: scope,
            };
        }
        Element.CreateElementWithBindings = CreateElementWithBindings;
    })(Element = exports.Element || (exports.Element = {}));
    var Ng;
    (function (Ng) {
        function CamelCase(snakeCasedName) {
            return names.CamelCase(snakeCasedName);
        }
        Ng.CamelCase = CamelCase;
        function SnakeCase(camelCasedName) {
            return names.ComponentNameSnakeCase(camelCasedName);
        }
        Ng.SnakeCase = SnakeCase;
    })(Ng = exports.Ng || (exports.Ng = {}));
    function DurableInvoke(retries, _delayDuration, action) {
        return __awaiter(this, void 0, ng_utils_3.$q, function () {
            var delayDuration, remainingRetries, lastError, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (utils.IsFunction(_delayDuration)) {
                            action = _delayDuration;
                            _delayDuration = null;
                        }
                        else if (!utils.IsFunction(action))
                            throw new Error("An action must be specified.");
                        delayDuration = (!utils.IsVoid(_delayDuration) && !utils.IsNumber(_delayDuration) ? _delayDuration.milliseconds() : _delayDuration) || 200;
                        remainingRetries = retries;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, action()];
                    case 2: return [2, _a.sent()];
                    case 3:
                        err_3 = _a.sent();
                        lastError = err_3;
                        return [3, 4];
                    case 4: return [4, Delay(delayDuration)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        if (remainingRetries-- > 0) return [3, 1];
                        _a.label = 7;
                    case 7: throw lastError;
                }
            });
        });
    }
    exports.DurableInvoke = DurableInvoke;
    (function (Element) {
        Element.Create = names.ElementFor;
    })(Element = exports.Element || (exports.Element = {}));
    function Delay(millisecondsOrDuration, invokeApply) {
        if (invokeApply === void 0) { invokeApply = true; }
        if (moment.isDuration(millisecondsOrDuration))
            millisecondsOrDuration = millisecondsOrDuration.milliseconds();
        return ng_utils_3.$timeout(millisecondsOrDuration, invokeApply);
    }
    exports.Delay = Delay;
    (function (Delay) {
        Delay.Thin = utils.Delay;
    })(Delay = exports.Delay || (exports.Delay = {}));
    var ActivityController = (function () {
        function ActivityController(Name) {
            this.Name = Name;
        }
        ActivityController.IsToken = function (obj) {
            return obj instanceof ActivityController.Token;
        };
        Object.defineProperty(ActivityController.prototype, "ActiveToken", {
            get: function () {
                return this.activeToken;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ActivityController.prototype, "IsActive", {
            get: function () {
                return !utils.IsVoid(this.ActiveToken);
            },
            enumerable: true,
            configurable: true
        });
        ActivityController.prototype.CloseAndEnter = function () {
            this._ExitAnyToken(true);
            return this.Enter();
        };
        ActivityController.prototype.Enter = function (options) {
            var newToken = this.TryEnter();
            if (!newToken) {
                try {
                    options && utils.IsFunction(options.onFail) && options.onFail();
                }
                catch (err) {
                    ng_utils_3.$exceptionHandler(err);
                }
                throw new utils.AlreadyDoingActionError(utils.FormatJson(templateObject_18 || (templateObject_18 = __makeTemplateObject(["The ActivityController ", " is already active."], ["The ActivityController ", " is already active."])), this.Name));
            }
            return newToken;
        };
        ActivityController.prototype.TryEnter = function () {
            if (this.IsActive)
                return null;
            this.IgnoreReopenInactivePromise = new utils.Deferred();
            this.InactivePromise = new utils.Deferred();
            return this.activeToken = new ActivityController.Token(this);
        };
        ActivityController.prototype._ExitToken = function (token, reopening) {
            if (reopening === void 0) { reopening = false; }
            if (!(token instanceof ActivityController.Token))
                throw new Error("Unexpected type of token.");
            if (token.Owner !== this)
                throw new Error("Token is not for this ActivityController.");
            if (token !== this.activeToken)
                return false;
            this.activeToken = null;
            token.NotifyExited();
            if (!utils.IsVoid(this.InactivePromise)) {
                this.InactivePromise.Resolve(null);
                this.InactivePromise = null;
            }
            if (!utils.IsVoid(this.IgnoreReopenInactivePromise) && !reopening) {
                this.IgnoreReopenInactivePromise.Resolve(null);
                this.IgnoreReopenInactivePromise = null;
            }
            return true;
        };
        ActivityController.prototype.ExitToken = function (token) {
            return this._ExitToken(token);
        };
        ActivityController.prototype._ExitAnyToken = function (reopening) {
            if (utils.IsVoid(this.ActiveToken))
                return false;
            return this._ExitToken(this.ActiveToken, reopening);
        };
        ActivityController.prototype.ExitAnyToken = function () {
            if (utils.IsVoid(this.ActiveToken))
                return false;
            return this.ExitToken(this.ActiveToken);
        };
        ActivityController.prototype.WaitForInactive = function (ignoreReopen) {
            if (ignoreReopen === void 0) { ignoreReopen = true; }
            if (utils.IsVoid(this.ActiveToken))
                return Promise.resolve();
            if (ignoreReopen) {
                if (utils.IsVoid(this.IgnoreReopenInactivePromise))
                    this.IgnoreReopenInactivePromise = new utils.Deferred();
                return this.IgnoreReopenInactivePromise.Promise;
            }
            else {
                if (utils.IsVoid(this.InactivePromise))
                    this.InactivePromise = new utils.Deferred();
                return this.InactivePromise.Promise;
            }
        };
        ActivityController.Token = (function () {
            function Token(Owner) {
                var _this = this;
                this.Owner = Owner;
                this.ExitPromise = new Promise(function (resolve) { return _this.NotifyExited = resolve; });
            }
            Token.prototype.NotifyExited = function () {
                throw new Error("Failed to init promise");
            };
            Object.defineProperty(Token.prototype, "HasExited", {
                get: function () {
                    return this.Owner.ActiveToken !== this;
                },
                enumerable: true,
                configurable: true
            });
            Token.prototype.AssertNotExited = function (message) {
                if (this.HasExited)
                    throw new ActivityController.ActionSupersededError((utils.IsVoid(message) && utils.IsString(this.Owner.Name)) ? "The requested action was superseded: " + this.Owner.Name : message);
            };
            Token.prototype.Exit = function () {
                return this.Owner.ExitToken(this);
            };
            Token.prototype.WaitForExit = function () {
                return this.ExitPromise;
            };
            return Token;
        }());
        return ActivityController;
    }());
    exports.ActivityController = ActivityController;
    (function (ActivityController) {
        var ActionSupersededError = (function (_super) {
            __extends(ActionSupersededError, _super);
            function ActionSupersededError(message) {
                if (message === void 0) { message = "The requested action was superceeded."; }
                return _super.call(this, message) || this;
            }
            ActionSupersededError = __decorate([
                utils.FixExtendBuiltIn
            ], ActionSupersededError);
            return ActionSupersededError;
        }(Error));
        ActivityController.ActionSupersededError = ActionSupersededError;
        var ReadonlyAggregateToken = (function () {
            function ReadonlyAggregateToken() {
                var tokens = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    tokens[_i] = arguments[_i];
                }
                this.Tokens = Object.freeze(utils.Collection.NonVoid(utils.Collection.MapMany(tokens, function (t) { return utils.IsArray(t) ? t : [t]; })));
            }
            Object.defineProperty(ReadonlyAggregateToken.prototype, "HasExited", {
                get: function () {
                    return utils.Collection.Any(this.Tokens, function (t) { return t.HasExited; });
                },
                enumerable: true,
                configurable: true
            });
            ReadonlyAggregateToken.prototype.AssertNotExited = function (message) {
                if (this.HasExited)
                    throw new ActivityController.ActionSupersededError(message);
            };
            ReadonlyAggregateToken.prototype.WaitForExit = function () {
                if (utils.IsVoid(this.ExitPromise))
                    this.ExitPromise = Promise.race(this.Tokens.map(function (t) { return t.WaitForExit(); }));
                return this.ExitPromise;
            };
            return ReadonlyAggregateToken;
        }());
        ActivityController.ReadonlyAggregateToken = ReadonlyAggregateToken;
        var AggregateToken = (function (_super) {
            __extends(AggregateToken, _super);
            function AggregateToken() {
                var tokens = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    tokens[_i] = arguments[_i];
                }
                return _super.apply(this, __spread(tokens)) || this;
            }
            AggregateToken.prototype.Exit = function () {
                var exitResults = this.Tokens.map(function (t) { return t.Exit(); });
                return utils.Collection.All(exitResults, function (r) { return r; });
            };
            return AggregateToken;
        }(ReadonlyAggregateToken));
        ActivityController.AggregateToken = AggregateToken;
        var ExtendedActivityController = (function () {
            function ExtendedActivityController(Name) {
                this.Name = Name;
            }
            ExtendedActivityController.IsToken = function (obj) {
                return obj instanceof ExtendedActivityController.Token;
            };
            Object.defineProperty(ExtendedActivityController.prototype, "ActiveToken", {
                get: function () {
                    return this.activeToken;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ExtendedActivityController.prototype, "IsActive", {
                get: function () {
                    return !utils.IsVoid(this.ActiveToken);
                },
                enumerable: true,
                configurable: true
            });
            ExtendedActivityController.prototype.CloseAndEnter = function (value) {
                this._ExitAnyToken(true);
                return this.Enter(value);
            };
            ExtendedActivityController.prototype.Enter = function (value, options) {
                var newToken = this.TryEnter(value);
                if (!newToken) {
                    try {
                        options && utils.IsFunction(options.onFail) && options.onFail();
                    }
                    catch (err) {
                        ng_utils_3.$exceptionHandler(err);
                    }
                    throw new utils.AlreadyDoingActionError(utils.FormatJson(templateObject_19 || (templateObject_19 = __makeTemplateObject(["The ValuedActivityController ", " is already active."], ["The ValuedActivityController ", " is already active."])), this.Name));
                }
                return newToken;
            };
            ExtendedActivityController.prototype.TryEnter = function (value) {
                if (this.IsActive)
                    return null;
                this.IgnoreReopenInactivePromise = new utils.Deferred();
                this.InactivePromise = new utils.Deferred();
                return this.activeToken = new ExtendedActivityController.Token(this, value);
            };
            ExtendedActivityController.prototype._ExitToken = function (token, reopening) {
                if (reopening === void 0) { reopening = false; }
                if (!(token instanceof ExtendedActivityController.Token))
                    throw new Error("Unexpected type of token.");
                if (token.Owner !== this)
                    throw new Error("Token is not for this ValuedActivityController.");
                if (token !== this.activeToken)
                    return false;
                this.activeToken = null;
                token.NotifyExited();
                if (!utils.IsVoid(this.InactivePromise)) {
                    this.InactivePromise.Resolve(null);
                    this.InactivePromise = null;
                }
                if (!utils.IsVoid(this.IgnoreReopenInactivePromise) && !reopening) {
                    this.IgnoreReopenInactivePromise.Resolve(null);
                    this.IgnoreReopenInactivePromise = null;
                }
                return true;
            };
            ExtendedActivityController.prototype.ExitToken = function (token) {
                return this._ExitToken(token);
            };
            ExtendedActivityController.prototype._ExitAnyToken = function (reopening) {
                if (utils.IsVoid(this.ActiveToken))
                    return false;
                return this._ExitToken(this.ActiveToken, reopening);
            };
            ExtendedActivityController.prototype.ExitAnyToken = function () {
                if (utils.IsVoid(this.ActiveToken))
                    return false;
                return this.ExitToken(this.ActiveToken);
            };
            ExtendedActivityController.prototype.WaitForInactive = function (ignoreReopen) {
                if (ignoreReopen === void 0) { ignoreReopen = true; }
                if (utils.IsVoid(this.ActiveToken))
                    return Promise.resolve();
                if (ignoreReopen) {
                    if (utils.IsVoid(this.IgnoreReopenInactivePromise))
                        this.IgnoreReopenInactivePromise = new utils.Deferred();
                    return this.IgnoreReopenInactivePromise.Promise;
                }
                else {
                    if (utils.IsVoid(this.InactivePromise))
                        this.InactivePromise = new utils.Deferred();
                    return this.InactivePromise.Promise;
                }
            };
            ExtendedActivityController.Token = (function () {
                function Token(Owner, Value) {
                    var _this = this;
                    this.Owner = Owner;
                    this.Value = Value;
                    this.ExitPromise = new Promise(function (resolve) { return _this.NotifyExited = resolve; });
                }
                Token.prototype.NotifyExited = function () {
                    throw new Error("Failed to init promise");
                };
                Object.defineProperty(Token.prototype, "HasExited", {
                    get: function () {
                        return this.Owner.ActiveToken !== this;
                    },
                    enumerable: true,
                    configurable: true
                });
                Token.prototype.AssertNotExited = function (message) {
                    if (this.HasExited)
                        throw new ActivityController.ActionSupersededError((utils.IsVoid(message) && utils.IsString(this.Owner.Name)) ? "The requested action was superseded: " + this.Owner.Name : message);
                };
                Token.prototype.Exit = function () {
                    return this.Owner.ExitToken(this);
                };
                Token.prototype.WaitForExit = function () {
                    return this.ExitPromise;
                };
                return Token;
            }());
            return ExtendedActivityController;
        }());
        ActivityController.Extended = ExtendedActivityController;
    })(ActivityController = exports.ActivityController || (exports.ActivityController = {}));
    exports.ActivityController = ActivityController;
    var BatchedInvoker = (function () {
        function BatchedInvoker(BatchCollectionWindow, InvokeBatch) {
            if (InvokeBatch === void 0) { InvokeBatch = function (invokeBatch) { return void ng_utils_3.$rootScope.$applyAsync(invokeBatch); }; }
            this.InvokeBatch = InvokeBatch;
            this.Responses = new Array();
            if (moment.isDuration(BatchCollectionWindow))
                this.Delay = BatchCollectionWindow.asMilliseconds();
        }
        BatchedInvoker.prototype.DelayedInvoke = function (fn) {
            this.Responses.push(fn);
            this.EnsureTimer();
        };
        BatchedInvoker.prototype.EnsureTimer = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!utils.IsVoid(this.Timer))
                                return [2];
                            return [4, (this.Timer = utils.Delay(this.Delay))];
                        case 1:
                            _a.sent();
                            this.Timer = null;
                            this.InvokeBatch(function () { return _this.InvokeOutstandingResponses(); });
                            return [2];
                    }
                });
            });
        };
        BatchedInvoker.prototype.InvokeOutstandingResponses = function () {
            var responses = this.Responses;
            this.Responses = [];
            try {
                for (var responses_1 = __values(responses), responses_1_1 = responses_1.next(); !responses_1_1.done; responses_1_1 = responses_1.next()) {
                    var response = responses_1_1.value;
                    try {
                        response();
                    }
                    catch (err) {
                        ng_utils_3.$exceptionHandler(err);
                    }
                }
            }
            catch (e_45_1) { e_45 = { error: e_45_1 }; }
            finally {
                try {
                    if (responses_1_1 && !responses_1_1.done && (_a = responses_1.return)) _a.call(responses_1);
                }
                finally { if (e_45) throw e_45.error; }
            }
            var e_45, _a;
        };
        return BatchedInvoker;
    }());
    exports.BatchedInvoker = BatchedInvoker;
    var LoaderBase = (function () {
        function LoaderBase(GetValue, options) {
            if (options === void 0) { options = {}; }
            this.GetValue = GetValue;
            this.LoadingValue = new ActivityController();
            this.HasFailed = false;
            this.HasLoaded = false;
            var errorValue = options.DefaultValue;
            this.GetOuterToken = options.GetOuterToken;
            this.GetDefaultValue = options.GetDefaultValue || (function () { return errorValue; });
            this.loadedValue = this.GetDefaultValue();
            this.BatchedInvoker = options.Batcher;
        }
        Object.defineProperty(LoaderBase.prototype, "IsLoading", {
            get: function () {
                return utils.IsVoid(this.Token) ? false : !this.Token.HasExited;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoaderBase.prototype, "IsValid", {
            get: function () {
                return this.HasLoaded && !this.IsLoading && !this.HasFailed;
            },
            enumerable: true,
            configurable: true
        });
        LoaderBase.prototype.Reset = function (cancelLoad) {
            if (cancelLoad === void 0) { cancelLoad = true; }
            this.CancelOutstandingRequest();
            this.HasLoaded = false;
            this.HasFailed = false;
            this.Error = null;
            this.loadedValue = this.GetDefaultValue();
        };
        LoaderBase.prototype.CancelOutstandingRequest = function () {
            this.LoadingValue.ExitAnyToken();
        };
        LoaderBase.prototype.Load = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var innerToken, outerToken, token, loadedValue_1, err_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            innerToken = this.LoadingValue.CloseAndEnter();
                            outerToken = !utils.IsVoid(this.GetOuterToken) ? utils.AssertNotVoid(this.GetOuterToken()) : null;
                            token = this.Token = utils.IsVoid(outerToken) ? innerToken : new ActivityController.AggregateToken([innerToken, outerToken]);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, this.GetValue.apply(this, __spread(args))];
                        case 3:
                            loadedValue_1 = _a.sent();
                            return [3, 5];
                        case 4:
                            err_4 = _a.sent();
                            this.Apply(function () {
                                _this.loadedValue = _this.GetDefaultValue();
                                _this.HasFailed = true;
                                _this.Error = err_4;
                                _this.HasLoaded = true;
                                token.Exit();
                            });
                            throw err_4;
                        case 5:
                            if (token.HasExited)
                                throw new ActivityController.ActionSupersededError();
                            this.Apply(function () {
                                _this.loadedValue = loadedValue_1;
                                _this.HasFailed = false;
                                _this.HasLoaded = true;
                                token.Exit();
                            });
                            token.Exit();
                            return [2, loadedValue_1];
                        case 6:
                            token.Exit();
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        };
        LoaderBase.prototype.Apply = function (fn) {
            if (!this.BatchedInvoker) {
                ng_utils_3.$rootScope.$applyAsync(fn);
                return;
            }
            this.BatchedInvoker.DelayedInvoke(fn);
        };
        LoaderBase.prototype.DurableLoad = function (options) {
            if (options === void 0) { options = {}; }
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return __awaiter(this, void 0, ng_utils_3.$q, function () {
                var delayDuration, timeoutDuration, timeout, err_5;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            delayDuration = options.delayDuration, timeoutDuration = options.timeoutDuration;
                            timeout = utils.Timeout.Start(timeoutDuration);
                            _a.label = 1;
                        case 1:
                            if (!!timeout.HasExpired) return [3, 9];
                            if (!this.Token) return [3, 3];
                            return [4, timeout.Race(this.LoadingValue.WaitForInactive())];
                        case 2:
                            _a.sent();
                            return [3, 6];
                        case 3:
                            _a.trys.push([3, 5, , 6]);
                            return [4, timeout.Race(this.Load.apply(this, __spread(args)))];
                        case 4:
                            _a.sent();
                            return [3, 6];
                        case 5:
                            err_5 = _a.sent();
                            if (err_5 instanceof utils.Timeout.TimeoutExpiredError)
                                throw err_5;
                            return [3, 6];
                        case 6:
                            if (timeout.HasExpired)
                                throw new utils.Timeout.TimeoutExpiredError(timeout);
                            if (!(this.IsLoading || this.HasFailed)) return [3, 8];
                            return [4, timeout.Race(Delay(delayDuration))];
                        case 7:
                            _a.sent();
                            return [3, 1];
                        case 8: return [2, this.loadedValue];
                        case 9: throw new utils.Timeout.TimeoutExpiredError(timeout);
                    }
                });
            });
        };
        return LoaderBase;
    }());
    var Loader = (function (_super) {
        __extends(Loader, _super);
        function Loader(GetValue, options) {
            return _super.call(this, GetValue, options) || this;
        }
        Object.defineProperty(Loader.prototype, "Value", {
            get: function () {
                return this.loadedValue;
            },
            set: function (value) {
                this.loadedValue = value;
            },
            enumerable: true,
            configurable: true
        });
        return Loader;
    }(LoaderBase));
    (function (Loader) {
        Loader.Exportable = Loader;
    })(Loader || (Loader = {}));
    var ExportableLoader = Loader.Exportable;
    exports.Loader = ExportableLoader;
    var CollectionLoader = (function (_super) {
        __extends(CollectionLoader, _super);
        function CollectionLoader(GetValues, options) {
            if (options === void 0) { options = {}; }
            var _this = _super.call(this, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(_this, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _b = (_a = CollectionLoader).FormatValues;
                            return [4, GetValues.apply(void 0, __spread(args))];
                        case 1: return [2, _b.apply(_a, [_c.sent()])];
                    }
                }); });
            }, {
                GetOuterToken: options.GetOuterToken,
                DefaultValue: (options.DefaultValues && __spread(options.DefaultValues)) || [],
                GetDefaultValue: options.GetDefaultValues && CollectionLoader.FormatValuesGetter(options.GetDefaultValues),
            }) || this;
            return _this;
        }
        Object.defineProperty(CollectionLoader, "Readonly", {
            get: function () {
                return CollectionLoader.ReadonlyCollectionLoader.Exportable;
            },
            enumerable: true,
            configurable: true
        });
        CollectionLoader.FormatValuesGetter = function (getValues) {
            return function () { return CollectionLoader.FormatValues(getValues()); };
        };
        CollectionLoader.FormatValues = function (values) {
            if (utils.IsVoid(values))
                return [];
            if (!utils.IsArray(values))
                return __spread(utils.Collection.ToIterable(values));
            return values.slice();
        };
        Object.defineProperty(CollectionLoader.prototype, "Values", {
            get: function () {
                return this.loadedValue;
            },
            set: function (value) {
                this.loadedValue = value;
            },
            enumerable: true,
            configurable: true
        });
        return CollectionLoader;
    }(LoaderBase));
    (function (CollectionLoader) {
        var ReadonlyCollectionLoader = (function (_super) {
            __extends(ReadonlyCollectionLoader, _super);
            function ReadonlyCollectionLoader(GetValues, options) {
                if (options === void 0) { options = {}; }
                var _this = _super.call(this, function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(_this, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _b = (_a = ReadonlyCollectionLoader).FormatValues;
                                return [4, GetValues.apply(void 0, __spread(args))];
                            case 1: return [2, _b.apply(_a, [_c.sent()])];
                        }
                    }); });
                }, {
                    GetOuterToken: options.GetOuterToken,
                    DefaultValue: (options.DefaultValues && __spread(options.DefaultValues)) || [],
                    GetDefaultValue: options.GetDefaultValues && ReadonlyCollectionLoader.FormatValuesGetter(options.GetDefaultValues),
                }) || this;
                return _this;
            }
            ReadonlyCollectionLoader.FormatValuesGetter = function (getValues) {
                return function () { return ReadonlyCollectionLoader.FormatValues(getValues()); };
            };
            ReadonlyCollectionLoader.FormatValues = function (values) {
                if (utils.IsVoid(values))
                    return ReadonlyCollectionLoader.Empty;
                if (!utils.IsArray(values))
                    return Object.freeze(__spread(utils.Collection.ToIterable(values)));
                if (Object.isFrozen(values))
                    return values;
                return Object.freeze(values.slice());
            };
            Object.defineProperty(ReadonlyCollectionLoader.prototype, "Values", {
                get: function () {
                    return this.loadedValue;
                },
                set: function (value) {
                    this.loadedValue = value;
                },
                enumerable: true,
                configurable: true
            });
            ReadonlyCollectionLoader.Empty = Object.freeze(new Array());
            return ReadonlyCollectionLoader;
        }(LoaderBase));
        CollectionLoader.ReadonlyCollectionLoader = ReadonlyCollectionLoader;
        (function (ReadonlyCollectionLoader) {
            ReadonlyCollectionLoader.Exportable = CollectionLoader;
        })(ReadonlyCollectionLoader = CollectionLoader.ReadonlyCollectionLoader || (CollectionLoader.ReadonlyCollectionLoader = {}));
        CollectionLoader.Exportable = CollectionLoader;
    })(CollectionLoader || (CollectionLoader = {}));
    var ExportableCollectionLoader = CollectionLoader.Exportable;
    exports.CollectionLoader = ExportableCollectionLoader;
    function CreateWatchService(scope) {
        return sss_watch_1.WatchService(ng_utils_3.$parse, scope);
    }
    exports.CreateWatchService = CreateWatchService;
    function RewriteElementDirective(definition) {
        var targetName = definition.TargetName;
        var priority = utils.IsVoid(definition.Priority) ? Number.MAX_SAFE_INTEGER - 1 : definition.Priority;
        var beforeCompile = definition.BeforeCompile || RewriteElementDirective.DefaultBeforeCompile;
        amdUtils.Directive({
            Name: utils.HasProp(definition, "SourceName") ? definition.SourceName : utils.GetComponentNameFromModuleId(definition.SourceModuleId),
            Priority: priority,
            Template: null,
            Scope: amdUtils.ScopeMode.ParentScope,
            Terminal: true,
            OnCompile: function (tElement, tAttrs) {
                var rawAttrs = Object.keys(tAttrs.$attr).map(function (name) { return ({ name: name, rawName: tAttrs.$attr[name], rawValue: tAttrs[name] }); });
                return {
                    post: function (scope, element, attrs, _, transclude) {
                        return __awaiter(this, void 0, ng_utils_3.$q, function () {
                            var contents, rewrittenElement, rawAttrs_1, rawAttrs_1_1, attr, requireName, _a, compileElement, compileScope, e_46, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        contents = element.contents();
                                        element.empty();
                                        rewrittenElement = angular.element(document.createElement(targetName));
                                        try {
                                            for (rawAttrs_1 = __values(rawAttrs), rawAttrs_1_1 = rawAttrs_1.next(); !rawAttrs_1_1.done; rawAttrs_1_1 = rawAttrs_1.next()) {
                                                attr = rawAttrs_1_1.value;
                                                rewrittenElement.attr(attr.rawName, attr.rawValue);
                                            }
                                        }
                                        catch (e_46_1) { e_46 = { error: e_46_1 }; }
                                        finally {
                                            try {
                                                if (rawAttrs_1_1 && !rawAttrs_1_1.done && (_b = rawAttrs_1.return)) _b.call(rawAttrs_1);
                                            }
                                            finally { if (e_46) throw e_46.error; }
                                        }
                                        rewrittenElement.append(contents);
                                        rewrittenElement.insertAfter(element);
                                        element.remove();
                                        if (!names.IsSelectComponent(targetName)) return [3, 2];
                                        requireName = "directive!" + targetName;
                                        if (!!require.defined(requireName)) return [3, 2];
                                        return [4, new Promise(function (resolve_2, reject_2) { require([requireName], resolve_2, reject_2); })];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        _a = beforeCompile({ Element: rewrittenElement, Scope: scope }), compileElement = _a.Element, compileScope = _a.Scope;
                                        ng_utils_3.$compile(compileElement, undefined, priority)(compileScope, undefined, {
                                            futureParentElement: rewrittenElement.parent(),
                                            parentBoundTranscludeFn: transclude,
                                        });
                                        return [2];
                                }
                            });
                        });
                    }
                };
            },
        });
    }
    exports.RewriteElementDirective = RewriteElementDirective;
    (function (RewriteElementDirective) {
        function DefaultBeforeCompile(args) {
            return args;
        }
        RewriteElementDirective.DefaultBeforeCompile = DefaultBeforeCompile;
    })(RewriteElementDirective = exports.RewriteElementDirective || (exports.RewriteElementDirective = {}));
    function RetryOnSessionFail(args) {
        return __awaiter(this, void 0, void 0, function () {
            var generateSession, invoke, sessionKey, err_6, newSessionOrKey, newSessionKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        generateSession = args.generateSession, invoke = args.invoke, sessionKey = args.sessionKey;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 6]);
                        if (utils.IsVoid(sessionKey) || utils.IsWhitespace(sessionKey))
                            throw new selcomm_types_4.Selcomm.Error.InvalidSessionKeyException();
                        return [4, invoke(sessionKey)];
                    case 2: return [2, _a.sent()];
                    case 3:
                        err_6 = _a.sent();
                        if (!(err_6 instanceof selcomm_types_4.Selcomm.Error.InvalidSessionKeyException))
                            throw err_6;
                        return [4, generateSession()];
                    case 4:
                        newSessionOrKey = _a.sent();
                        newSessionKey = utils.IsObject(newSessionOrKey) ? newSessionOrKey.SessionKey : newSessionOrKey;
                        if (utils.IsVoid(newSessionKey) || utils.IsWhitespace(newSessionKey))
                            throw new selcomm_types_4.Selcomm.Error.InvalidSessionKeyException();
                        return [4, invoke(newSessionKey)];
                    case 5: return [2, _a.sent()];
                    case 6: return [2];
                }
            });
        });
    }
    exports.RetryOnSessionFail = RetryOnSessionFail;
    var DialogContent = (function () {
        function DialogContent() {
        }
        DialogContent.GetAgreement = function (businessUnitCode) {
            switch (businessUnitCode.toUpperCase()) {
                case "GS":
                    this.dialogHtml = "By continuing, you request and authorise Pivotel Satellite Pty Limited, ABN 81 099 917 398 to arrange for any amount Pivotel Satellite Pty Limited may debit or charge to be debited from the credit card you nominated. This authority is to remain in force until further notice.\n<br/><br/>\nBy proceeding, you acknowledge that you have read and understood the terms and conditions governing the debit arrangements between you and Pivotel Satellite Pty Limited as set out in this request.\n        ";
                    break;
                case "PN":
                    this.dialogHtml = "By continuing, you request and authorise Pivotel New Zealand Limited, NZBN 9429033338835 to arrange for any amount Pivotel New Zealand Limited may debit or charge to be debited from the credit card you nominated. This authority is to remain in force until further notice.\n<br/><br/>\nBy proceeding, you acknowledge that you have read and understood the terms and conditions governing the debit arrangements between you and Pivotel New Zealand Limited as set out in this request.";
                    break;
                case "RW":
                    this.dialogHtml = "By continuing, you request and authorise Reward Mobile Pty Limited, ABN 41 111 772 206 to arrange for any amount Reward Mobile Pty Limited may debit or charge to be debited from the credit card you nominated. This authority is to remain in force until further notice.\n<br/><br/>\nBy proceeding, you acknowledge that you have read and understood the terms and conditions governing the debit arrangements between you and Reward Mobile Pty Limited as set out in this request.";
                    break;
                case "TM":
                    this.dialogHtml = "By continuing, you request and authorise Think Mobile Pty Limited, ABN 33 110 992 151 to arrange for any amount Think Mobile Pty Limited may debit or charge to be debited from the credit card you nominated. This authority is to remain in force until further notice.\n<br/><br/>\nBy proceeding, you acknowledge that you have read and understood the terms and conditions governing the debit arrangements between you and Think Mobile Pty Limited as set out in this request.";
                    break;
                default:
                    this.dialogHtml = "";
            }
            return this.dialogHtml;
        };
        DialogContent.GetDirectDebitAgreement = function (businessUnitCode) {
            switch (businessUnitCode.toUpperCase()) {
                case "GS":
                    this.dialogHtml = "You request and authorise Pivotel Satellite Pty Limited, ABN 81 099 917 398 (Debit User Identification Number 226163) to arrange for any amount Pivotel Satellite Pty Limited may debit or charge you to be debited through the Bulk Electronic Clearing System from an account held at the financial institution identified below subject to the terms and conditions of the Direct Debit request Service Agreement. This authority is to remain in force until further notice.\n<br/><br/>\nBy submitting this Direct Debit Request you acknowledge that you have read and understood the terms and conditions governing the debit arrangements between you and Pivotel Satellite Pty Limited as set out in this Direct Debit Request and in the Direct Debit Request Service Agreement. If nominating a Joint Account or your method of operation is for two parties to sign, both parties agreed to authorise this Direct Debit Request. PAYMENTS: Payments will be processed on your bill due date.\n        ";
                    break;
                case "PN":
                    this.dialogHtml = "You request and authorise Pivotel Satellite Pty Limited, ABN 81 099 917 398 (Debit User Identification Number 226163) to arrange for any amount Pivotel Satellite Pty Limited may debit or charge you to be debited through the Bulk Electronic Clearing System from an account held at the financial institution identified below subject to the terms and conditions of the Direct Debit request Service Agreement. This authority is to remain in force until further notice.\n<br/><br/>\nBy submitting this Direct Debit Request you acknowledge that you have read and understood the terms and conditions governing the debit arrangements between you and Pivotel Satellite Pty Limited as set out in this Direct Debit Request and in the Direct Debit Request Service Agreement. If nominating a Joint Account or your method of operation is for two parties to sign, both parties agreed to authorise this Direct Debit Request. PAYMENTS: Payments will be processed on your bill due date.";
                    break;
                case "RW":
                    this.dialogHtml = "You request and authorise Pivotel Satellite Pty Limited, ABN 81 099 917 398 (Debit User Identification Number 226163) to arrange for any amount Pivotel Satellite Pty Limited may debit or charge you to be debited through the Bulk Electronic Clearing System from an account held at the financial institution identified below subject to the terms and conditions of the Direct Debit request Service Agreement. This authority is to remain in force until further notice.\n<br/><br/>\nBy submitting this Direct Debit Request you acknowledge that you have read and understood the terms and conditions governing the debit arrangements between you and Pivotel Satellite Pty Limited as set out in this Direct Debit Request and in the Direct Debit Request Service Agreement. If nominating a Joint Account or your method of operation is for two parties to sign, both parties agreed to authorise this Direct Debit Request. PAYMENTS: Payments will be processed on your bill due date.";
                    break;
                case "TM":
                    this.dialogHtml = "You request and authorise Pivotel Satellite Pty Limited, ABN 81 099 917 398 (Debit User Identification Number 226163) to arrange for any amount Pivotel Satellite Pty Limited may debit or charge you to be debited through the Bulk Electronic Clearing System from an account held at the financial institution identified below subject to the terms and conditions of the Direct Debit request Service Agreement. This authority is to remain in force until further notice.\n<br/><br/>\nBy submitting this Direct Debit Request you acknowledge that you have read and understood the terms and conditions governing the debit arrangements between you and Pivotel Satellite Pty Limited as set out in this Direct Debit Request and in the Direct Debit Request Service Agreement. If nominating a Joint Account or your method of operation is for two parties to sign, both parties agreed to authorise this Direct Debit Request. PAYMENTS: Payments will be processed on your bill due date.";
                    break;
                default:
                    this.dialogHtml = "";
            }
            return this.dialogHtml;
        };
        DialogContent.dialogHtml = "";
        return DialogContent;
    }());
    exports.DialogContent = DialogContent;
    var templateObject_16, templateObject_17, templateObject_18, templateObject_19;
});
define("app/sss/execution-queue", ["require", "exports", "$timeout", "app/basic-utils"], function (require, exports, $timeout, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ExecutionQueue = (function () {
        function ExecutionQueue(processor, collisionHandlerOrDelay, delay) {
            if (delay === void 0) { delay = 0; }
            this.processor = processor;
            this.delay = delay;
            this.collisionHandler = CollisionHandlers.Default;
            this.executionItems = {};
            if (typeof collisionHandlerOrDelay === "number")
                this.delay = collisionHandlerOrDelay;
            if (typeof collisionHandlerOrDelay === "function")
                this.collisionHandler = collisionHandlerOrDelay;
        }
        ExecutionQueue.prototype.Process = function (key, value) {
            return this.processor(key, value);
        };
        ExecutionQueue.prototype.HandleCollision = function (key, newValue, oldValue) {
            return this.collisionHandler(key, newValue, oldValue);
        };
        ExecutionQueue.prototype.EnsureTimeout = function () {
            var _this = this;
            if (this.timeout)
                return this.timeout;
            var thisTimeout = this.timeout = $timeout(function () {
                if (thisTimeout !== _this.timeout)
                    return;
                _this.timeout = null;
                _this.executionItems = {};
            }, this.delay);
            return thisTimeout;
        };
        ExecutionQueue.prototype.Call = function (key, value) {
            if (Object.prototype.hasOwnProperty.call(this.executionItems, key)) {
                var existing = this.executionItems[key];
                existing.Value = this.HandleCollision(key, value, existing.Value);
                return existing.Promise;
            }
            var executionItem = new ExecutionItem(key, value, this.EnsureTimeout(), this.processor);
            this.executionItems[executionItem.Key] = executionItem;
            return executionItem.Promise;
        };
        return ExecutionQueue;
    }());
    exports.ExecutionQueue = ExecutionQueue;
    var VoidExecutionQueue = (function (_super) {
        __extends(VoidExecutionQueue, _super);
        function VoidExecutionQueue(processor, delay) {
            return _super.call(this, processor, VoidExecutionQueue.CollisionHandler, delay) || this;
        }
        VoidExecutionQueue.CollisionHandler = function (key) {
            return void 0;
        };
        VoidExecutionQueue.prototype.Call = function (key) {
            return _super.prototype.Call.call(this, key, void 0);
        };
        return VoidExecutionQueue;
    }(ExecutionQueue));
    exports.VoidExecutionQueue = VoidExecutionQueue;
    var CollisionHandlers;
    (function (CollisionHandlers) {
        function LatestCollisionHandler(key, newValue, oldValue) {
            return newValue;
        }
        CollisionHandlers.LatestCollisionHandler = LatestCollisionHandler;
        function MergeCollisionHandler(key, newValue, oldValue) {
            return utils.Extend(newValue, oldValue);
        }
        CollisionHandlers.MergeCollisionHandler = MergeCollisionHandler;
        CollisionHandlers.Default = LatestCollisionHandler;
    })(CollisionHandlers = exports.CollisionHandlers || (exports.CollisionHandlers = {}));
    var ExecutionItem = (function () {
        function ExecutionItem(Key, Value, boundPromise, process) {
            var _this = this;
            this.Key = Key;
            this.Value = Value;
            this.Promise = boundPromise.then(function () { return process(_this.Key, _this.Value); });
        }
        return ExecutionItem;
    }());
});
define("app/selcomm/auth", ["require", "exports", "app/permissions", "app/utils", "app/selcomm/selcomm-api", "$q", "$location", "$timeout", "app/sss/sites", "app/sdc/storage/sdc-storage", "app/sss/execution-queue", "app/selcomm/service-reference/selcomm-types"], function (require, exports, permissions_1, utils, api, $q, $location, $timeout, sites, storage, executionQueue, selcomm_types_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function fullSessionStoreKey(sessionStoreKey) {
        return angular.toJson({
            siteName: sites.Service.Current.Name,
            key: sessionStoreKey
        });
    }
    var FullKey = (function () {
        function FullKey(value, SiteName) {
            if (SiteName === void 0) { SiteName = sites.Service.Current.Name; }
            this.SiteName = SiteName;
            if (!angular.isString(SiteName))
                throw new Error("Bad SiteName");
            if (!value && value !== 0)
                this.Value = "";
            else
                this.Value = value.toString();
        }
        FullKey.FromJson = function (json) {
            var raw = angular.fromJson(json);
            return new FullKey(raw.Value, raw.SiteName);
        };
        FullKey.prototype.toString = function () {
            return angular.toJson(this);
        };
        return FullKey;
    }());
    var AuthArgs = (function () {
        function AuthArgs(LoginCode, Password, TfaCode) {
            this.LoginCode = LoginCode;
            this.Password = Password;
            this.TfaCode = TfaCode;
        }
        return AuthArgs;
    }());
    var Get2faVerificationCodeSendOptionsAndInfoLinkArgs = (function () {
        function Get2faVerificationCodeSendOptionsAndInfoLinkArgs(LoginCode, Password, ProviderKey, SiteName) {
            this.LoginCode = LoginCode;
            this.Password = Password;
            this.ProviderKey = ProviderKey;
            this.SiteName = SiteName;
        }
        return Get2faVerificationCodeSendOptionsAndInfoLinkArgs;
    }());
    var SendLogin2faVerificationCodeArgs = (function () {
        function SendLogin2faVerificationCodeArgs(LoginCode, Password, ProviderKey, SiteName, BySms) {
            this.LoginCode = LoginCode;
            this.Password = Password;
            this.ProviderKey = ProviderKey;
            this.SiteName = SiteName;
        }
        return SendLogin2faVerificationCodeArgs;
    }());
    var SessionService = (function () {
        function SessionService(auth, selcomm) {
            var _this = this;
            this.auth = auth;
            this.selcomm = selcomm;
            this.ExpireQueue = new executionQueue.VoidExecutionQueue(function (key) { return _this.__expire(key); });
            this.UpdateQueue = new executionQueue.ExecutionQueue(function (key, value) { return _this.__update(key, value); }, executionQueue.CollisionHandlers.MergeCollisionHandler);
            this.GetQueue = new executionQueue.VoidExecutionQueue(function (key) { return _this.__get(key); });
            this.AuthenticateQueue = new executionQueue.ExecutionQueue(function (key, args) { return _this.__authenticate(key, args); }, executionQueue.CollisionHandlers.LatestCollisionHandler);
            this.Get2faVerificationCodeSendOptionsAndInfoLinkQueue = new executionQueue.ExecutionQueue(function (key, args) {
                return _this.__get2faVerificationCodeSendOptionsAndInfoLinkQueue(args);
            }, executionQueue.CollisionHandlers.LatestCollisionHandler);
            this.SendLogin2faVerificationCodeQueue = new executionQueue.ExecutionQueue(function (key, args) {
                return _this.__sendLogin2faVerificationCodeQueue(args);
            }, executionQueue.CollisionHandlers.LatestCollisionHandler);
            this.CloneQueue = new executionQueue.VoidExecutionQueue(function (key) { return _this.__clone(key); });
        }
        SessionService.prototype.__update = function (sessionKey, newData) {
            var _this = this;
            return this.GetQueue.Call(sessionKey)
                .then(function (latest) { return angular.extend(latest, newData); })
                .then(function (newSession) { return _this.selcomm.Service.Session.ClientSessionUpdate({ ClientSession: new selcomm_types_5.Selcomm.Session.ClientSession(newSession) }); })
                .then(function (updatedSession) {
                _this.GetAll()
                    .filter(function (e) { return !!e.Session; })
                    .filter(function (e) { return e.Session.SessionKey === sessionKey; })
                    .forEach(function (e) { return _this.SetSession(e.Key, angular.extend(e.Session, updatedSession)); });
                return updatedSession;
            });
        };
        SessionService.prototype.__clone = function (sessionKey) {
            var _this = this;
            return this.selcomm.Service.Session.SessionClone({
                SessionKey: sessionKey
            }).then(function (s) { return new ExtendedSession(_this, s); });
        };
        SessionService.prototype.__expire = function (sessionKey) {
            var _this = this;
            return this.selcomm.Service.Session.SessionExpire({
                SessionKey: sessionKey
            }).then(function (d) {
                _this.GetAll()
                    .filter(function (e) { return !!e.Session; })
                    .filter(function (e) { return e.Session.SessionKey === sessionKey; })
                    .map(function (e) { return e.Key; })
                    .forEach(function (key) { return _this.RemoveSession(key); });
            });
        };
        SessionService.prototype.__get = function (sessionKey) {
            return this.selcomm.Service.Session.ClientSession({ SessionKey: sessionKey });
        };
        SessionService.prototype.__authenticate = function (sessionKey, args) {
            var fixedArgs = angular.copy(args);
            fixedArgs.SessionKey = sessionKey;
            return this.___authenticate(fixedArgs);
        };
        SessionService.prototype.___authenticate = function (args) {
            var _this = this;
            return this.selcomm.Service.Contact.Authenticate(args)
                .then(function (result) {
                return _this.GetQueue.Call(args.SessionKey)
                    .then(function (updatedSession) {
                    _this.GetAll()
                        .filter(function (e) { return !!e.Session; })
                        .filter(function (e) { return e.Session.SessionKey === args.SessionKey; })
                        .forEach(function (e) { return _this.SetSession(e.Key, angular.extend(e.Session, updatedSession)); });
                    return updatedSession;
                })
                    .then(function (s) { return result; });
            });
        };
        SessionService.prototype.__get2faVerificationCodeSendOptionsAndInfoLinkQueue = function (args) {
            var fixedArgs = angular.copy(args);
            return this.___get2faVerificationCodeSendOptionsAndInfoLinkQueue(fixedArgs);
        };
        SessionService.prototype.___get2faVerificationCodeSendOptionsAndInfoLinkQueue = function (args) {
            return this.selcomm.Service.Contact.Get2faVerificationCodeSendOptionsAndInfoLink(args);
        };
        SessionService.prototype.__sendLogin2faVerificationCodeQueue = function (args) {
            var fixedArgs = angular.copy(args);
            return this.___sendLogin2faVerificationCodeQueue(fixedArgs);
        };
        SessionService.prototype.___sendLogin2faVerificationCodeQueue = function (args) {
            return this.selcomm.Service.Contact.SendLogin2faVerificationCode(args);
        };
        Object.defineProperty(SessionService.prototype, "storage", {
            get: function () {
                return SessionService.Storage;
            },
            enumerable: true,
            configurable: true
        });
        SessionService.prototype.RemoveSession = function (key) {
            this.storage.RemoveItem(key.toString());
        };
        SessionService.prototype.SetSession = function (key, newSession) {
            this.storage.SetItem(key.toString(), newSession);
        };
        SessionService.prototype.GetSession = function (key) {
            return this.storage.GetItem(key.toString());
        };
        SessionService.prototype.GetAll = function () {
            return this.storage.Entries
                .Select(function (entry) { return ({
                Key: FullKey.FromJson(entry.Key),
                Session: entry.Value
            }); })
                .ToArray();
        };
        SessionService.prototype.GetAllSessions = function () {
            return this.storage.Entries
                .Select(function (entry) { return entry.Value; })
                .ToArray();
        };
        SessionService.prototype.GenerateNewKey = function (siteName) {
            var _this = this;
            if (siteName === void 0) { siteName = sites.Service.Current.Name; }
            var numericKeys = this.storage.Keys
                .Select(function (key) {
                try {
                    return FullKey.FromJson(key);
                }
                catch (ex) {
                    _this.storage.RemoveItem(key);
                    return null;
                }
            })
                .Where(function (key) { return !!key; })
                .Where(function (key) { return key.SiteName === siteName; })
                .Where(function (key) { return utils.IsString(key.Value) && /\d+/.test(key.Value); })
                .Select(function (key) { return Number(key.Value); })
                .ToArray();
            var availableKeys = numericKeys.concat(0).map(function (key) { return key + 1; }).filter(function (key) { return key > 0; }).filter(function (key) { return numericKeys.indexOf(key) < 0; });
            var smallestKey = availableKeys.reduce(function (largest, current) { return Math.min(largest, current); });
            var newKey = new FullKey(smallestKey, siteName);
            return newKey;
        };
        SessionService.prototype.GetAuthType = function (objectId, existingCache) {
            return $q.resolve();
        };
        SessionService.Storage = storage.Local.Prefixed("selcomm-authentication-sessions:{03FB474D-BA95-444E-A0F8-8B97C685B98F}");
        return SessionService;
    }());
    var _Authorisation;
    (function (_Authorisation) {
        var Cache = (function () {
            function Cache(authService) {
                this.authService = authService;
                this.AuthTypes = Cache.MakeByObjectId();
                this.fetchingByObjectId = Cache.MakeByObjectId();
                Object.defineProperty(this, "authService", {
                    enumerable: false,
                    value: this.authService,
                    configurable: true
                });
                Object.defineProperty(this, "fetchingByObjectId", {
                    enumerable: false,
                    value: this.authService,
                    configurable: true
                });
            }
            Cache.MakeByObjectId = function () {
                return utils.MakeNumberedCollection();
            };
            Cache.prototype.LoadPermission = function (objectId) {
                var authTypeCache = this.AuthTypes;
                var fetching = this.fetchingByObjectId;
                if (objectId in fetching)
                    return fetching[objectId];
                if (objectId in authTypeCache)
                    return null;
                return this.authService.GetAuthType(objectId, authTypeCache).then(function () {
                    delete fetching[objectId];
                });
            };
            Cache.prototype.GetAuthType = function (objectId) {
                if (objectId in this.AuthTypes)
                    return this.AuthTypes[objectId];
                else {
                    this.LoadPermission(objectId);
                    return;
                }
            };
            Cache.prototype.Clear = function () {
                this.fetchingByObjectId = Cache.MakeByObjectId();
                this.AuthTypes = Cache.MakeByObjectId();
            };
            Cache.prototype.SetAuthTypes = function (permissions) {
                try {
                    for (var _a = __values(Object.keys(permissions).map(function (k) { return Number(k); }).filter(function (id) { return !Number.isNaN(id); })), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var objectId = _b.value;
                        var newPermission = permissions[objectId];
                        if (newPermission || newPermission === 0)
                            this.AuthTypes[objectId] = newPermission;
                        else
                            delete this.AuthTypes[objectId];
                    }
                }
                catch (e_47_1) { e_47 = { error: e_47_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_47) throw e_47.error; }
                }
                var e_47, _c;
            };
            return Cache;
        }());
        _Authorisation.Cache = Cache;
    })(_Authorisation || (_Authorisation = {}));
    var ExtendedSession = (function (_super) {
        __extends(ExtendedSession, _super);
        function ExtendedSession(service, other) {
            var _this = _super.call(this, other) || this;
            _this.service = service;
            _this.PermissionCache = new _Authorisation.Cache(service);
            Object.defineProperty(_this, "service", {
                value: service,
                enumerable: false,
                writable: false
            });
            return _this;
        }
        Object.defineProperty(ExtendedSession.prototype, "IsAuthenticated", {
            get: function () {
                return !!(this.SessionKey && this.UserCode);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ExtendedSession.prototype, "isAuthenticated", {
            get: function () {
                return this.IsAuthenticated;
            },
            enumerable: true,
            configurable: true
        });
        ExtendedSession.prototype.authenticate = function () { return this.Authenticate.apply(this, arguments).then(function (result) { return selcomm_types_5.Selcomm.Authentication.AuthenticationResultType[result]; }); };
        ExtendedSession.prototype.Authenticate = function (loginCode, password, tfaCode) {
            var _this = this;
            return this.service.AuthenticateQueue.Call(this.SessionKey, new AuthArgs(loginCode, password, tfaCode)).then(function (result) {
                switch (result) {
                    case selcomm_types_5.Selcomm.Authentication.AuthenticationResultType.Success:
                        return _this.Refresh();
                    default:
                        return $q.reject({
                            AuthenticationResult: result,
                            Error: null,
                            authenticationResult: selcomm_types_5.Selcomm.Authentication.AuthenticationResultType[result],
                            error: null
                        });
                }
            }, function (err) {
                return $q.reject({
                    AuthenticationResult: selcomm_types_5.Selcomm.Authentication.AuthenticationResultType.UnknownError,
                    Error: err,
                    authenticationResult: selcomm_types_5.Selcomm.Authentication.AuthenticationResultType[selcomm_types_5.Selcomm.Authentication.AuthenticationResultType.UnknownError],
                    error: err
                });
            });
        };
        ExtendedSession.prototype.get2faVerificationCodeSendOptionsAndInfoLink = function () { return this.Get2faVerificationCodeSendOptionsAndInfoLink.apply(this, arguments).then(function (result) { return selcomm_types_5.Selcomm.Authentication.TfaVerificationCodeSendOptionsAndInfoLink; }); };
        ExtendedSession.prototype.Get2faVerificationCodeSendOptionsAndInfoLink = function (loginCode, password, providerKey, siteName) {
            return this.Refresh().then(function (err) {
                return $q.reject({
                    AuthenticationResult: selcomm_types_5.Selcomm.Authentication.AuthenticationResultType.UnknownError,
                    Error: err,
                    authenticationResult: selcomm_types_5.Selcomm.Authentication.AuthenticationResultType[selcomm_types_5.Selcomm.Authentication.AuthenticationResultType.UnknownError],
                    error: err
                });
            });
        };
        ExtendedSession.prototype.sendLogin2faVerificationCode = function () { return this.SendLogin2faVerificationCode.apply(this, arguments).then(function (result) { return selcomm_types_5.Selcomm.Authentication.TfaSendCodeReponse; }); };
        ExtendedSession.prototype.SendLogin2faVerificationCode = function (loginCode, password, providerKey, siteName, bySms) {
            return this.Refresh().then(function (err) {
                return $q.reject({
                    AuthenticationResult: selcomm_types_5.Selcomm.Authentication.AuthenticationResultType.UnknownError,
                    Error: err,
                    authenticationResult: selcomm_types_5.Selcomm.Authentication.AuthenticationResultType[selcomm_types_5.Selcomm.Authentication.AuthenticationResultType.UnknownError],
                    error: err
                });
            });
        };
        ExtendedSession.prototype.Clone = function () {
            var _this = this;
            return this.service.CloneQueue.Call(this.SessionKey).then(function (newData) { return new ExtendedSession(_this.service, newData); });
        };
        ExtendedSession.prototype.update = function () { return this.Update.apply(this, arguments); };
        ExtendedSession.prototype.Update = function (data) {
            var _this = this;
            return this.service.UpdateQueue.Call(this.SessionKey, data).then(function (newData) { return angular.extend(_this, newData); });
        };
        ExtendedSession.prototype.reload = function () { return this.Refresh.apply(this, arguments); };
        ExtendedSession.prototype.Refresh = function () {
            var _this = this;
            return this.service.GetQueue.Call(this.SessionKey).then(function (newData) { return angular.extend(_this, newData); });
        };
        ExtendedSession.prototype.Terminate = function () {
            return this.service.ExpireQueue.Call(this.SessionKey);
        };
        ExtendedSession.prototype.HasPermission = function (permission) {
            if (!permission || !Array.isArray(permission))
                return;
            return this.PermissionCache.GetAuthType(permission[0]) >= permission[1];
        };
        return ExtendedSession;
    }(selcomm_types_5.Selcomm.Session.ClientSession));
    exports.ExtendedSession = ExtendedSession;
    var Service = (function () {
        function Service(Selcomm) {
            this.Selcomm = Selcomm;
            this.Permissions = permissions_1.Permissions;
            this.sessionService = new SessionService(this, Selcomm);
        }
        Service.prototype.session = function () { return this.LocalSession.apply(this, arguments); };
        Service.prototype.LocalSession = function (key, siteNameOrNewSession, newSessionOrBlank) {
            var fullKey;
            var setMode = false;
            var newSession;
            switch (arguments.length) {
                case 1:
                    if (key instanceof FullKey)
                        fullKey = key;
                    else
                        fullKey = new FullKey(key, siteNameOrNewSession);
                    break;
                case 2:
                    if (key instanceof FullKey) {
                        setMode = true;
                        fullKey = key;
                        newSession = siteNameOrNewSession;
                    }
                    else if (angular.isString(siteNameOrNewSession))
                        fullKey = new FullKey(key, siteNameOrNewSession);
                    else {
                        setMode = true;
                        fullKey = new FullKey(key);
                        newSession = siteNameOrNewSession;
                    }
                    break;
                case 3:
                    setMode = true;
                    fullKey = new FullKey(key, siteNameOrNewSession);
                    newSession = newSessionOrBlank;
                    break;
                default:
                    throw new Error("Unexcepted arg count " + arguments.length);
            }
            if (setMode) {
                if (!newSession)
                    this.sessionService.RemoveSession(fullKey);
                else
                    this.sessionService.SetSession(fullKey, newSession);
                return void 0;
            }
            else {
                var rawValue = this.sessionService.GetSession(fullKey);
                if (!rawValue)
                    return null;
                var parsedValue = new ExtendedSession(this.sessionService, rawValue);
                return parsedValue;
            }
        };
        Service.prototype.createSession = function () { return this.StartSession.apply(this, arguments); };
        Service.prototype.StartSession = function (siteOrSiteName) {
            return __awaiter(this, void 0, $q, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.StartSessionThin(siteOrSiteName)];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        Service.prototype.StartSessionThin = function (siteOrSiteName) {
            return __awaiter(this, void 0, void 0, function () {
                var selcommSession, extendedSession;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.Service.Thin.Session.SessionCreate({
                                Arguments: new selcomm_types_5.Selcomm.Session.NewSessionArguments({ SiteName: sites.Service.NameFor(siteOrSiteName) })
                            })];
                        case 1:
                            selcommSession = _a.sent();
                            extendedSession = new ExtendedSession(this.sessionService, selcommSession);
                            return [2, extendedSession];
                    }
                });
            });
        };
        Service.prototype.urlWithSession = function () { return this.UrlWithSession.apply(this, arguments); };
        Service.prototype.UrlWithSession = function (url, localSessionKey) {
            if (localSessionKey === void 0) { localSessionKey = this.CurrentSessionStoreKey; }
            url = this.UrlWithoutSession(url);
            var exists = false;
            var fixedUrl = url.replace(/(\?)s=([^&]*)(&|$)|&s=([^&]*)/g, function (fullMatch, keep, s1, s2) {
                var s = decodeURIComponent(s1 || s2);
                if (s !== localSessionKey)
                    return keep;
                exists = true;
                return fullMatch;
            });
            var prepend;
            if (!/\?/.test(fixedUrl))
                prepend = "?";
            else
                prepend = "&";
            if (!exists)
                fixedUrl += prepend + "s=" + encodeURIComponent(localSessionKey);
            return fixedUrl;
        };
        Service.prototype.urlWithoutSession = function () { return this.UrlWithoutSession.apply(this, arguments); };
        Service.prototype.UrlWithoutSession = function (url) {
            if (!url && url !== 0)
                url = "";
            else
                url = url.toString();
            return url.replace(/(\?)s=([^&]*)(&|$)|&s=(?:[^&]*)/g, function (_, keep, s1, s2) { return keep || ""; }).replace(/\?$/, "");
        };
        Service.prototype.validateSessions = function () { return this.ValidateSessions.apply(this, arguments); };
        Service.prototype.ValidateSessions = function (sessionKeyOrPredicate) {
            var _this = this;
            var deleteKeys = [];
            var predicate;
            if (!sessionKeyOrPredicate)
                predicate = function (session) { return true; };
            else if (angular.isFunction(sessionKeyOrPredicate))
                predicate = sessionKeyOrPredicate;
            else {
                var sessionKey_1 = sessionKeyOrPredicate;
                predicate = function (session) { return session && session.SessionKey === sessionKey_1; };
            }
            var sessions = this.sessionService.GetAll().filter(function (e) {
                if (!e)
                    return false;
                if (!e.Session) {
                    _this.sessionService.RemoveSession(e.Key);
                    return false;
                }
                var session = new ExtendedSession(_this.sessionService, e.Session);
                if (!session.SessionKey) {
                    _this.sessionService.RemoveSession(e.Key);
                    return false;
                }
                return !!predicate(session);
            }).map(function (e) { return e.Session; });
            return $q.all(sessions.map(function (session) {
                return _this.Service.Session.SessionHasExpired({ SessionKey: session.SessionKey })
                    .catch(function (reason) { return true; })
                    .then(function (hasExpired) {
                    if (!hasExpired)
                        return null;
                    var entries = _this.sessionService.GetAll()
                        .filter(function (e) { return !!e.Session; })
                        .filter(function (e) { return e.Session.SessionKey === session.SessionKey; });
                    entries.forEach(function (e) {
                        console.debug("Removing session with local key " + e.Key + ", session key " + e.Session.SessionKey, e.Session);
                        _this.sessionService.RemoveSession(e.Key);
                    });
                    return new api.RemovedSession(session.SessionKey, entries.map(function (e) { return e.Key.Value; }));
                });
            })).then(function (removedSessions) {
                return removedSessions.filter(function (rs) { return !!rs; });
            });
        };
        Object.defineProperty(Service.prototype, "currentSessionStoreKey", {
            get: function () { return this.CurrentSessionStoreKey; },
            set: function (value) { this.CurrentSessionStoreKey = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Service.prototype, "CurrentSessionStoreKey", {
            get: function () {
                return $location.search().s;
            },
            set: function (newStoreKey) {
                $location.search("s", "" + newStoreKey);
            },
            enumerable: true,
            configurable: true
        });
        Service.prototype.ReplaceCurrentSessionStoreKey = function (newStoreKey) {
            var _this = this;
            $timeout(function () {
                $location.replace();
                _this.CurrentSessionStoreKey = newStoreKey;
            });
        };
        Object.defineProperty(Service.prototype, "currentSession", {
            get: function () { return this.CurrentSession; },
            set: function (value) { this.CurrentSession = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Service.prototype, "CurrentSession", {
            get: function () {
                return this.LocalSession(this.CurrentSessionStoreKey);
            },
            set: function (newSession) {
                var currentSessionStoreKey = this.CurrentSessionStoreKey;
                if (!currentSessionStoreKey) {
                    var newKey = this.AddSessionWithNewKey(newSession);
                    this.CurrentSessionStoreKey = newKey;
                }
                else {
                    var fullKey = new FullKey(currentSessionStoreKey);
                    if (!utils.IsVoid(newSession))
                        this.sessionService.SetSession(fullKey, newSession);
                    else
                        this.sessionService.RemoveSession(fullKey);
                }
            },
            enumerable: true,
            configurable: true
        });
        Service.prototype.AddSessionWithNewKey = function (newSession) {
            var key = this.sessionService.GenerateNewKey();
            this.LocalSession(key, newSession);
            return key.Value;
        };
        Object.defineProperty(Service.prototype, "Service", {
            get: function () {
                return this.Selcomm.Service;
            },
            enumerable: true,
            configurable: true
        });
        Service.prototype.HasPermission = function (permission, forceFail) {
            if (forceFail === void 0) { forceFail = false; }
            return true && !forceFail;
        };
        Service.prototype._init = function () {
            return this.ValidateSessions();
        };
        return Service;
    }());
    exports.Service = Service;
});
define("app/date-utils", ["require", "exports", "app/basic-utils", "moment"], function (require, exports, utils, moment) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MdLocaleConfigurer = (function () {
        function MdLocaleConfigurer(Module, Options) {
            if (Options === void 0) { Options = {}; }
            this.Module = Module;
            this.Options = Options;
            this.AngularFormatToMomentFormat = {};
        }
        MdLocaleConfigurer.BindToModule = function (module, options) {
            var instance = new this(module, options);
            instance.Init();
            return instance;
        };
        MdLocaleConfigurer.prototype.Init = function () {
            var _this = this;
            this.Module.config(["$mdDateLocaleProvider", function ($mdDateLocaleProvider) { return _this.BindToMd($mdDateLocaleProvider); }]);
            this.Module.run(["$locale", function ($locale) { return _this.BindToNg($locale); }]);
        };
        MdLocaleConfigurer.prototype.BindToMd = function ($mdDateLocaleProvider) {
            var _this = this;
            this.MdDateLocaleProvider = $mdDateLocaleProvider;
            $mdDateLocaleProvider.parseDate = function (date) { return _this.ParseDate(date); };
            $mdDateLocaleProvider.formatDate = function (dateString) { return _this.FormatDate(dateString); };
        };
        MdLocaleConfigurer.prototype.BindToNg = function ($locale) {
            this.Locale = $locale;
            Object.defineProperties(this.MdDateLocaleProvider, {
                months: {
                    get: function () { return $locale.DATETIME_FORMATS.MONTH; },
                },
                shortMonths: {
                    get: function () { return $locale.DATETIME_FORMATS.SHORTMONTH; },
                },
                days: {
                    get: function () { return $locale.DATETIME_FORMATS.DAY; },
                },
                shortDays: {
                    get: function () { return $locale.DATETIME_FORMATS.SHORTDAY; },
                },
            });
        };
        MdLocaleConfigurer.prototype.ParseDate = function (dateString) {
            if (!this.Locale)
                throw new Error("Not initialised yet!");
            var format = this.GetMomentFormatForAngularFormat(this.Locale.DATETIME_FORMATS.shortDate);
            var m = moment(dateString, format, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
        MdLocaleConfigurer.prototype.FormatDate = function (date) {
            if (!this.Locale)
                throw new Error("Not initialised yet!");
            var format = this.GetMomentFormatForAngularFormat(this.Locale.DATETIME_FORMATS.shortDate);
            var m = moment(date);
            return m.isValid() ? m.format(format) : "";
        };
        MdLocaleConfigurer.prototype.GetMomentFormatForAngularFormat = function (angularFormat) {
            if (!utils.HasProp(this.AngularFormatToMomentFormat, angularFormat))
                this.AngularFormatToMomentFormat[angularFormat] = this.ConvertAngularFormatToMomentFormat(angularFormat);
            return this.AngularFormatToMomentFormat[angularFormat];
        };
        MdLocaleConfigurer.prototype.ConvertAngularFormatToMomentFormat = function (angularFormat) {
            var partiallyConverted = angularFormat
                .replace(/LLLL/g, "MMMM")
                .replace(/sss/g, "SSS");
            if (utils.IsVoid(this.Options.ChangeTwoDigitYearsToFourDigit) || this.Options.ChangeTwoDigitYearsToFourDigit) {
                partiallyConverted = partiallyConverted
                    .replace(/([^y])(yy)(?!y)/g, function (fullMatch, prefix, twoDigitYear) { return prefix + "yyyy"; });
            }
            var momentFormat = partiallyConverted
                .replace(/./g, function (c) {
                switch (c) {
                    case "y":
                        return "Y";
                    case "d":
                        return "D";
                    case "E":
                        return "d";
                    case "w":
                        return "W";
                    case "G":
                        throw new Error("Eras are not supported");
                    default:
                        return c;
                }
            });
            return momentFormat;
        };
        return MdLocaleConfigurer;
    }());
    exports.MdLocaleConfigurer = MdLocaleConfigurer;
});
define("app/sdc/condensed/sdc-condensed", ["require", "exports", "app/utils", "$mdMedia"], function (require, exports, utils, $mdMedia) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-condensed";
    exports.ClassName = "sdc-condensed";
    var Controller = (function () {
        function Controller($watch, $attrs) {
            var _this = this;
            this._targets = $();
            $watch(function () { return _this.UseCondensed; }, function (useCondensed) {
                if (useCondensed) {
                    $attrs.$addClass(exports.ClassName);
                    _this._targets.addClass(exports.ClassName);
                }
                else {
                    $attrs.$removeClass(exports.ClassName);
                    _this._targets.removeClass(exports.ClassName);
                }
            });
        }
        Object.defineProperty(Controller.prototype, "UseCondensed", {
            get: function () {
                return !!this._useCondensedGetter({ $mdMedia: $mdMedia });
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Bind = function (target) {
            if (!target)
                return;
            this._targets = $(this._targets.add(target));
            if (this.UseCondensed)
                target.addClass(exports.ClassName);
            else
                target.removeClass(exports.ClassName);
        };
        Controller.prototype.Unbind = function (target) {
            if (!target)
                return;
            this._targets = $(this._targets.not(target));
        };
        __decorate([
            utils.Bind.Getter(exports.Name)
        ], Controller.prototype, "_useCondensedGetter", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            }),
            __param(0, utils.Inject("$watch")), __param(1, utils.Inject("$attrs"))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("scripts/lib/select-development/sss-directives", ["require", "exports", "scripts/lib/select-development/sss-paths", "scripts/lib/select-development/sss-watch", "scripts/lib/select-development/sss-names", "app/raw-path-utils", "app/pre-angular-bootstrap-utils", "app/sdc/md/interim-element", "ng", "ngMaterial"], function (require, exports, sss_paths_2, watch, names, paths, utils, InterimElement) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.module = angular.module("sssDirectives", ["ngMaterial"]);
    exports.module.decorator("$$interimElement", ["$delegate", "$animate", "$q", function ($$interimElement, $animate, $q) {
            return wrappingInterimElementServiceFactory;
            function wrappingInterimElementServiceFactory() {
                var originalValue = $$interimElement.apply(this, arguments);
                var underlyingShow = originalValue.show;
                return angular.extend(originalValue, {
                    show: function (baseOptions) {
                        var _this = this;
                        var rest = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            rest[_i - 1] = arguments[_i];
                        }
                        var underlyingOnShow = baseOptions && baseOptions.onShow || (function (scope, element, options) { return $animate.enter(element, options.parent); });
                        var underlyingOnRemove = baseOptions && baseOptions.onRemove || (function (scope, element) { return element && $animate.leave(element) || $q.when(); });
                        var options = angular.extend(baseOptions || {});
                        options.onShow = function (scope, element, options) {
                            var rest = [];
                            for (var _i = 3; _i < arguments.length; _i++) {
                                rest[_i - 3] = arguments[_i];
                            }
                            var target = angular.element(options.target || (options.targetEvent ? options.targetEvent.target : []));
                            if (target.length) {
                                var ctrl = target.inheritedData("$sdcCondensedController");
                                if (ctrl && !element.data("$sdcCondensedController")) {
                                    element.data("$sdcCondensedController", ctrl);
                                    ctrl.Bind(element);
                                }
                                try {
                                    for (var _a = __values(InterimElement.PassThrough.RegisteredControllerNames), _b = _a.next(); !_b.done; _b = _a.next()) {
                                        var name_4 = _b.value;
                                        var foundController = target.inheritedData(name_4);
                                        if (!foundController)
                                            continue;
                                        element.data(name_4, foundController);
                                    }
                                }
                                catch (e_48_1) { e_48 = { error: e_48_1 }; }
                                finally {
                                    try {
                                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                    }
                                    finally { if (e_48) throw e_48.error; }
                                }
                            }
                            return underlyingOnShow.call.apply(underlyingOnShow, __spread([_this, scope, element, options], rest));
                            var e_48, _c;
                        };
                        options.onRemove = function (scope, element, options) {
                            var rest = [];
                            for (var _i = 3; _i < arguments.length; _i++) {
                                rest[_i - 3] = arguments[_i];
                            }
                            var ctrl = element.data("$sdcCondensedController");
                            if (ctrl) {
                                ctrl.Unbind(element);
                            }
                            return underlyingOnRemove.call.apply(underlyingOnRemove, __spread([_this, scope, element, options], rest));
                        };
                        return underlyingShow.call.apply(underlyingShow, __spread([this, options], rest));
                    }
                });
            }
        }]);
    MakeUriMappingDirective("href", "ngHref");
    MakeUriMappingDirective("src", "ngSrc");
    exports.module.decorator("mdAutocompleteDirective", [
        "$delegate",
        "$controller",
        "$mdUtil",
        function (ddAutocomplete, $controller, $mdUtil) {
            var MdAutocompleteCtrl = $controller("MdAutocompleteCtrl", undefined, true).instance.constructor;
            var OverriddingController = (function (_super) {
                __extends(OverriddingController, _super);
                function OverriddingController($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window, $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer) {
                    var _this = _super.call(this, $scope, $element, $mdUtil, $mdConstant, $mdTheming, $window, $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer) || this;
                    var instance = Object.create(_this);
                    $scope.$on("$destroy", function () {
                        if (instance.hidden)
                            $mdUtil.enableScrolling();
                        Object.defineProperty(instance, "hidden", {
                            get: function () { return true; },
                            set: function () { },
                        });
                    });
                    return instance;
                }
                return OverriddingController;
            }(MdAutocompleteCtrl));
            ddAutocomplete[0].controller = OverriddingController;
            return ddAutocomplete;
        }
    ]);
    exports.module.directive({
        'splitter': function () {
            return {
                restrict: "E",
                transclude: true,
                template: "<span ng-transclude></span>"
            };
        },
        'viewBox': function () {
            return {
                restrict: "A",
                link: function (scope, element, attrs) {
                    attrs.$observe('viewBox', function (value) {
                        angular.forEach(element, function (element) {
                            element.setAttribute("viewBox", value);
                        });
                    });
                }
            };
        },
        "mdMenu": [function () {
                return {
                    restrict: "E",
                    require: "mdMenu",
                    link: function (scope, element, attr, mdMenu) {
                        scope['$mdCloseMenu'] = mdMenu.close;
                    }
                };
            }],
        "input": [function () {
                return {
                    restrict: "E",
                    require: "^^?sdsAddressSearch",
                    link: function (scope, element, attr, sdsAddressSearch) {
                        if (sdsAddressSearch) {
                            sdsAddressSearch.input = sdsAddressSearch.input || element;
                        }
                    }
                };
            }],
        "mdRadioGroup": ["$mdUtil", function inputTextareaDirective($mdUtil) {
                return {
                    restrict: 'E',
                    require: ['^?mdInputContainer', '?ngModel', '?^form'],
                    link: function (scope, element, attr, ctrls) {
                        var _containerCtrl = ctrls[0];
                        if (utils.IsVoid(_containerCtrl))
                            return;
                        var containerCtrl = _containerCtrl;
                        var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
                        var formCtrl = ctrls[2];
                        var isReadonly = angular.isDefined(attr['readonly']);
                        if (containerCtrl.input)
                            throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <select> child element!");
                        containerCtrl.input = element;
                        if (!element.attr('id')) {
                            element.attr('id', 'input_' + $mdUtil.nextUid());
                        }
                        var isErrorGetter = containerCtrl.isErrorGetter || defaultIsErrorGetter;
                        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
                        ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
                        ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
                        if (!isReadonly) {
                            element
                                .on('focus', function () {
                                containerCtrl.setFocused(true);
                            })
                                .on('blur', function () {
                                containerCtrl.setFocused(false);
                                inputCheckValue();
                            });
                        }
                        scope.$on('$destroy', function () {
                            containerCtrl.setFocused(false);
                            containerCtrl.setHasValue(false);
                            containerCtrl.input = null;
                        });
                        function defaultIsErrorGetter() {
                            return ngModelCtrl.$invalid && (ngModelCtrl.$dirty || utils.Form.IsSubmitted(formCtrl));
                        }
                        function ngModelPipelineCheckValue(arg) {
                            containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
                            return arg;
                        }
                        function inputCheckValue() {
                            containerCtrl.setHasValue((element.val() || []).length > 0 || (element[0]['validity'] || {}).badInput);
                        }
                    }
                };
            }],
        "select": ["$mdUtil", function inputTextareaDirective($mdUtil) {
                return {
                    restrict: 'E',
                    require: ['^?mdInputContainer', '?ngModel', '?^form'],
                    link: function (scope, element, attr, ctrls) {
                        var _containerCtrl = ctrls[0];
                        if (utils.IsVoid(_containerCtrl))
                            return;
                        var containerCtrl = _containerCtrl;
                        var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
                        var formCtrl = ctrls[2];
                        var isReadonly = angular.isDefined(attr['readonly']);
                        if (containerCtrl.input) {
                            var select = $(element);
                            var mdSelect = $(containerCtrl.input);
                            if (mdSelect.is("md-select") &&
                                select.hasClass("md-visually-hidden") &&
                                select.attr("name") === mdSelect.attr("name")) {
                                return;
                            }
                            throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <select> child element!");
                        }
                        containerCtrl.input = element;
                        element.addClass('md-input');
                        if (!element.attr('id')) {
                            element.attr('id', 'input_' + $mdUtil.nextUid());
                        }
                        var isErrorGetter = containerCtrl.isErrorGetter || defaultIsErrorGetter;
                        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
                        ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
                        ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
                        element.on('input', inputCheckValue);
                        if (!isReadonly) {
                            element
                                .on('focus', function () {
                                containerCtrl.setFocused(true);
                            })
                                .on('blur', function () {
                                containerCtrl.setFocused(false);
                                inputCheckValue();
                            });
                        }
                        scope.$on('$destroy', function () {
                            containerCtrl.setFocused(false);
                            containerCtrl.setHasValue(false);
                            containerCtrl.input = null;
                        });
                        function defaultIsErrorGetter() {
                            return ngModelCtrl.$invalid && (ngModelCtrl.$touched || utils.Form.IsSubmitted(formCtrl));
                        }
                        function ngModelPipelineCheckValue(arg) {
                            containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
                            return arg;
                        }
                        function inputCheckValue() {
                            containerCtrl.setHasValue((element.val() || []).length > 0 || (element[0]['validity'] || {}).badInput);
                        }
                    }
                };
            }],
        "mdProgressCircular": ["$mdConstant", function ($mdConstant) {
                return {
                    restrict: "E",
                    link: function (scope, element, attr) {
                        var circle = element[0];
                        attr.$observe("mdDiameter", function (diameter) {
                            circle.style[$mdConstant.CSS.TRANSFORM] = 'scale(' + ((diameter || 48) / 48).toString() + ')';
                        });
                    }
                };
            }],
        "mdInputContainer": [function () {
                return {
                    restrict: "E",
                    require: "mdInputContainer",
                    link: function postLink(scope, element, attr, controller) {
                        scope.$watchCollection(function () {
                            return {
                                label: controller.label,
                                input: controller.input
                            };
                        }, function watchCollectionAction(has) {
                            element.toggleClass("md-no-label", !has.label);
                            element.toggleClass("md-no-input", !has.input);
                        });
                    }
                };
            }],
        "mdButton": [function () {
                return {
                    priority: 1,
                    restrict: "E",
                    link: ["$self", "$attrs", function (vm, $attrs) {
                            if (!isAnchor($attrs["href"]) && !angular.isDefined($attrs["type"])) {
                                $attrs.$set("type", "button");
                            }
                            function isAnchor(attr) {
                                return angular.isDefined(attr["href"]) || angular.isDefined(attr["ngHref"]) || angular.isDefined(attr["ngLink"]) || angular.isDefined(attr["uiSref"]);
                            }
                        }]
                };
            }],
        "mdDatepicker": ["$mdUtil", function ($mdUtil) {
                return {
                    restrict: "E",
                    require: ['^?mdInputContainer', '?ngModel'],
                    link: function postLink(scope, element, attr, ctrls) {
                        var containerCtrl = ctrls[0];
                        var hasNgModel = !!ctrls[1];
                        var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
                        if (!containerCtrl)
                            return;
                        ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
                        ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
                        function ngModelPipelineCheckValue(arg) {
                            containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
                            return arg;
                        }
                    }
                };
            }],
        "label": function () {
            return {
                restrict: "E",
                priority: 1,
                require: '^?mdInputContainer',
                link: function postLink(scope, element, attr, containerCtrl) {
                    if (!containerCtrl || attr['mdFloat'])
                        return;
                    attr.$addClass('md-no-float');
                }
            };
        },
        "mdSelect": function () {
            return {
                require: '^?mdInputContainer',
                restrict: "E",
                link: function postLink(scope, element, attr, containerCtrl) {
                    if (!containerCtrl)
                        return;
                    containerCtrl.element.addClass("sdc-has-md-select");
                    scope.$on("$destroy", containerCtrl.element.removeClass.bind(containerCtrl.element, "sdc-has-md-select"));
                }
            };
        },
        "html": ["$window", function ($window) {
                var readonlyOptionTags = ["input", "textarea"];
                function isContentEditable(target) {
                    var current = target;
                    while (current) {
                        switch (current.prop("contentEdit")) {
                            case "true":
                                return true;
                            case "inherit":
                                current = current.parent();
                                break;
                            default:
                                return false;
                        }
                    }
                    return false;
                }
                function isWritableEditable(target) {
                    if (readonlyOptionTags.indexOf(target.prop("tagName").toLowerCase()) < 0)
                        return false;
                    return !target.prop("readonly");
                }
                return {
                    restrict: "E",
                    link: function postLink(scope, element, attr) {
                        element.on("keydown", function (e) {
                            var target = $(e.target);
                            if (e.keyCode !== 8) {
                                return;
                            }
                            if (!(isWritableEditable(target) || isContentEditable(target)))
                                e.preventDefault();
                        });
                    }
                };
            }],
        "ngMessages": ["$compile", function ($compile) {
                var priority = 1;
                return {
                    priority: priority,
                    terminal: true,
                    link: function postLink(scope, element, attr) {
                        if (angular.isUndefined(attr["mdAutoHide"])) {
                            attr.$set("mdAutoHide", "false");
                        }
                        $compile(element, null, priority)(scope);
                    }
                };
            }]
    });
    function MakeUriMappingDirective(attrName) {
        var readAttrs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            readAttrs[_i - 1] = arguments[_i];
        }
        var snakeCasedAttrName = utils.SnakeCase(attrName);
        var camelCasedAttrName = utils.CamelCase(attrName);
        var disablerAttribute = utils.CamelCase("no-" + snakeCasedAttrName + "-transform");
        try {
            for (var _a = __values([camelCasedAttrName].concat(readAttrs)), _b = _a.next(); !_b.done; _b = _a.next()) {
                var attr = _b.value;
                DefineDirectiveFor(attr);
            }
        }
        catch (e_49_1) { e_49 = { error: e_49_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_49) throw e_49.error; }
        }
        function DefineDirectiveFor(readAttrName) {
            var snakeCasedReadAttrName = utils.SnakeCase(readAttrName);
            var camelCasedReadAttrName = utils.CamelCase(readAttrName);
            exports.module.directive(camelCasedReadAttrName, ["$location", "$interpolate", "$parse", function ($location, $interpolate, $parse) {
                    return {
                        restrict: "A",
                        priority: 0,
                        link: function postLink($scope, $element, $attrs) {
                            var tagName = $element.prop("tagName");
                            switch (tagName) {
                                case "BASE":
                                case "SCRIPT":
                                    return;
                            }
                            if (camelCasedAttrName === camelCasedReadAttrName) {
                                try {
                                    for (var readAttrs_1 = __values(readAttrs), readAttrs_1_1 = readAttrs_1.next(); !readAttrs_1_1.done; readAttrs_1_1 = readAttrs_1.next()) {
                                        var otherAttrs = readAttrs_1_1.value;
                                        if (utils.IsSpecified($attrs[otherAttrs]))
                                            return;
                                    }
                                }
                                catch (e_50_1) { e_50 = { error: e_50_1 }; }
                                finally {
                                    try {
                                        if (readAttrs_1_1 && !readAttrs_1_1.done && (_a = readAttrs_1.return)) _a.call(readAttrs_1);
                                    }
                                    finally { if (e_50) throw e_50.error; }
                                }
                            }
                            if (!utils.IsVoid($attrs[disablerAttribute]))
                                return;
                            var unwatch = angular.noop;
                            var lastValue = $attrs[names.CamelCase(camelCasedReadAttrName)];
                            var getS = function () { return $location.search().s; };
                            $attrs.$observe(camelCasedReadAttrName, function (value) {
                                rebuildUri(value, getS());
                            });
                            $scope.$watch(getS, function (sValue) {
                                rebuildUri(lastValue, sValue);
                            });
                            function rebuildUri(attrValue, sValue) {
                                unwatch();
                                unwatch = angular.noop;
                                var builder = new sss_paths_2.UriBuilder(attrValue);
                                if (!builder.IsAbsolute && sValue) {
                                    if (builder.HasQuery) {
                                        if (!/(^|&)s=/.test(builder.Query)) {
                                            builder.Query += utils.EncodeUri(templateObject_20 || (templateObject_20 = __makeTemplateObject(["&s=", ""], ["&s=", ""])), sValue);
                                        }
                                    }
                                    else {
                                        builder.Query = utils.EncodeUri(templateObject_21 || (templateObject_21 = __makeTemplateObject(["s=", ""], ["s=", ""])), sValue);
                                    }
                                }
                                $element.attr("data-original-" + snakeCasedReadAttrName, attrValue);
                                var thisWatch = unwatch = paths.WatchedMapPath(paths.RootParsers.AtBase, {
                                    $watch: watch.WatchService($parse, $scope, null),
                                    getCurrentPath: function () { return $location.path(); },
                                    uriOrBuilder: builder,
                                    watchFn: function (outValue) {
                                        if (unwatch !== thisWatch)
                                            return;
                                        if (camelCasedAttrName !== camelCasedReadAttrName) {
                                            if ($attrs[camelCasedAttrName] !== outValue)
                                                $attrs.$set(camelCasedAttrName, outValue);
                                        }
                                        if ($element.attr(snakeCasedAttrName) !== outValue)
                                            $element.attr(snakeCasedAttrName, outValue);
                                    }
                                });
                            }
                            var e_50, _a;
                        }
                    };
                }]);
        }
        var e_49, _c;
    }
    var FixTrimWhitespace;
    (function (FixTrimWhitespace) {
        utils.Directive(exports.module, {
            Name: "ng-model",
            Restrict: utils.Target.Attribute,
            Scope: utils.ScopeMode.ParentScope,
            Priority: -10,
            Template: null,
            Require: "ng-model",
            OnLink: function (scope, element, attrs, ngModel) {
                var isPassword = element.is('[type="password"]');
                var valueMaintainer = TrimEndMaintainer.Null;
                ngModel.$parsers.push(sdcDbFixedcharParser);
                ngModel.$formatters.push(sdcDbFixedcharFormatter);
                function sdcDbFixedcharFormatter(value) {
                    if (!utils.IsString(value)) {
                        valueMaintainer = TrimEndMaintainer.Null;
                        return value;
                    }
                    var TrimmedText = (valueMaintainer = new TrimEndMaintainer(value)).TrimmedText;
                    if (!isPassword && (!attrs.ngTrim || attrs.ngTrim !== "false"))
                        return TrimmedText;
                    else
                        return value;
                }
                function sdcDbFixedcharParser(value) {
                    if (!isPassword && (!attrs.ngTrim || attrs.ngTrim !== "false"))
                        return valueMaintainer.Parse(value);
                    return value;
                }
            },
        });
        var TrimEndMaintainer = (function () {
            function TrimEndMaintainer(OriginalText) {
                this.OriginalText = OriginalText;
                this.TrimmedText = utils.TrimEnd(this.OriginalText);
            }
            TrimEndMaintainer.prototype.Parse = function (value) {
                var trimmed = utils.TrimEnd(value);
                if (trimmed !== this.TrimmedText)
                    return value;
                return this.OriginalText;
            };
            return TrimEndMaintainer;
        }());
        FixTrimWhitespace.TrimEndMaintainer = TrimEndMaintainer;
        (function (TrimEndMaintainer) {
            var _Null = (function (_super) {
                __extends(_Null, _super);
                function _Null() {
                    return _super.call(this, null) || this;
                }
                _Null.prototype.Parse = function (value) {
                    return utils.TrimEnd(value);
                };
                return _Null;
            }(TrimEndMaintainer));
            TrimEndMaintainer.Null = new _Null();
        })(TrimEndMaintainer = FixTrimWhitespace.TrimEndMaintainer || (FixTrimWhitespace.TrimEndMaintainer = {}));
    })(FixTrimWhitespace || (FixTrimWhitespace = {}));
    FixIsErrorGetter({ Name: "mdDatepicker" });
    FixIsErrorGetter({
        Name: "mdCheckbox",
        Priority: 210,
        Restrict: utils.Target.Element,
    });
    FixIsErrorGetter({
        Name: "mdSelect",
        Restrict: utils.Target.Element,
    });
    FixIsErrorGetter({
        Name: "input",
        Restrict: utils.Target.Element,
    });
    FixIsErrorGetter({
        Name: "textarea",
        Restrict: utils.Target.Element,
    });
    function DefaultIsErrorGetter(formCtrl, ngModelCtrl) {
        return ngModelCtrl.$invalid && (ngModelCtrl.$dirty || utils.Form.IsSubmitted(formCtrl));
    }
    function FixIsErrorGetter(options) {
        var isErrorGetter = options.IsErrorGetter || DefaultIsErrorGetter;
        utils.Directive(exports.module, {
            Name: options.Name,
            Restrict: options.Restrict || utils.Target.ElementOrAttribute,
            Priority: (options.Priority || 0) - 1,
            Scope: utils.ScopeMode.ParentScope,
            Template: null,
            Require: ["^^?form", "^?mdInputContainer", "?ngModel"],
            OnLink: function (scope, element, attrs, controllers) {
                var _a = __read(controllers, 3), formCtrl = _a[0], mdInputContainer = _a[1], ngModelCtrl = _a[2];
                if (!ngModelCtrl || !formCtrl || !mdInputContainer)
                    return;
                if (mdInputContainer.isErrorGetter)
                    return;
                mdInputContainer.isErrorGetter = function () { return isErrorGetter(formCtrl, ngModelCtrl); };
            }
        });
    }
    var templateObject_20, templateObject_21;
});
define("app/sds/contact/sds-contact", ["require", "exports", "app/utils", "app/selcomm/service", "module", "app/sss/application/root/sss-application-root"], function (require, exports, utils, service_1, module_1, root) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = utils.GetComponentNameFromModuleId(module_1.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller_2 = Controller;
        Object.defineProperty(Controller.prototype, "BoundContact", {
            set: function (value) {
                this._contact = Controller_2.GetContactFor(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Contact", {
            get: function () {
                return this._contact;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ContactCode", {
            get: function () {
                if (utils.IsVoid(this._contact))
                    return this._contact;
                else if (utils.IsVoid(this._contact.Code))
                    return this._contact.Code;
                else if (utils.IsWhitespace(this._contact.Code))
                    return null;
                else
                    return this._contact.Code;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsAtRoot", {
            get: function () {
                return !utils.IsVoid(this.RootController);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "HasExplicitBinding", {
            get: function () {
                return !!this.Attributes[utils.CamelCase(exports.Name)];
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.BindToSession = function () {
            var _this = this;
            if (!this.IsAtRoot || this.HasExplicitBinding)
                return;
            this.Watch.Collection(function () { return service_1.Auth.CurrentSession && {
                Code: service_1.Auth.CurrentSession.CurrentContactCode,
                FullName: service_1.Auth.CurrentSession.CurrentContactName,
            }; }, function (s) { return _this._contact = utils.IsVoid(s) ? s : Controller_2.GetContactFor(s.Code, { FullName: s.FullName }); });
        };
        Controller.GetContactFor = function (contactCode, initialiser) {
            if (utils.IsVoid(contactCode))
                return contactCode;
            else if (!utils.IsString(contactCode))
                return contactCode;
            else if (utils.IsWhitespace(contactCode))
                return null;
            else
                return new service_1.Selcomm.Contact.Contact(__assign({}, initialiser, { Code: utils.TrimEnd(contactCode) }));
        };
        __decorate([
            utils.Bind.In(exports.Name)
        ], Controller.prototype, "BoundContact", null);
        __decorate([
            utils.Bind.Controller(root.Controller, { optional: true, mode: utils.Bind.Controller.Mode.Self })
        ], Controller.prototype, "RootController", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "BindToSession", null);
        Controller = Controller_2 = __decorate([
            utils.Component({
                Name: exports.Name,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
                Restrict: utils.Target.Attribute,
            })
        ], Controller);
        return Controller;
        var Controller_2;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    function EnsureBoundTo(element) {
        element.attr(exports.Name, element.attr(exports.Name) || "");
    }
    exports.EnsureBoundTo = EnsureBoundTo;
});
define("app/sss/application/root/sss-application-root", ["require", "exports", "app/pre-angular-bootstrap-utils", "scripts/lib/select-development/sss-names", "module", "sss-config"], function (require, exports, utils, names, module_2, sss_config_1) {
    "use strict";
    var _this = this;
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.EnsureNoLegacyFallback(utils.GetComponentNameFromModuleId(module_2.id));
    var selectedContactPromise = new Promise(function (resolve_3, reject_3) { require(["app/sds/contact/sds-contact"], resolve_3, reject_3); });
    var filtersPromise = utils.Execute(function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        var filterPromises, filterPromises_1, filterPromises_1_1, filterPromise, err_7, e_51_1, e_51, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, utils.Require("domReady!")];
                case 1:
                    _b.sent();
                    filterPromises = sss_config_1.filters.map(utils.Require);
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 9, 10, 11]);
                    filterPromises_1 = __values(filterPromises), filterPromises_1_1 = filterPromises_1.next();
                    _b.label = 3;
                case 3:
                    if (!!filterPromises_1_1.done) return [3, 8];
                    filterPromise = filterPromises_1_1.value;
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 6, , 7]);
                    return [4, filterPromise];
                case 5:
                    _b.sent();
                    return [3, 7];
                case 6:
                    err_7 = _b.sent();
                    utils.Execute(function () { return __awaiter(_this, void 0, void 0, function () {
                        var $exceptionHandler;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4, utils.Require("$exceptionHandler")];
                                case 1:
                                    $exceptionHandler = _a.sent();
                                    $exceptionHandler(err_7);
                                    return [2];
                            }
                        });
                    }); });
                    return [3, 7];
                case 7:
                    filterPromises_1_1 = filterPromises_1.next();
                    return [3, 3];
                case 8: return [3, 11];
                case 9:
                    e_51_1 = _b.sent();
                    e_51 = { error: e_51_1 };
                    return [3, 11];
                case 10:
                    try {
                        if (filterPromises_1_1 && !filterPromises_1_1.done && (_a = filterPromises_1.return)) _a.call(filterPromises_1);
                    }
                    finally { if (e_51) throw e_51.error; }
                    return [7];
                case 11: return [2];
            }
        });
    }); });
    exports.Definition = Object.freeze({
        ModuleId: module_2.id,
        Restrict: utils.Target.Attribute,
        Priority: Number.MAX_VALUE,
        Terminal: true,
    });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller(Transclude, Compile, ExceptionHandler) {
            var _this = _super.call(this) || this;
            _this.Transclude = Transclude;
            _this.Compile = Compile;
            _this.ExceptionHandler = ExceptionHandler;
            _this.Init();
            return _this;
        }
        Controller.prototype.Init = function () {
            return __awaiter(this, void 0, void 0, function () {
                var err_8, dependencies, dependencies_1, dependencies_1_1, dependency, err_9, e_52_1, e_52, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            console.debug("await filtersPromise");
                            return [4, filtersPromise];
                        case 1:
                            _b.sent();
                            return [3, 3];
                        case 2:
                            err_8 = _b.sent();
                            this.ExceptionHandler(err_8);
                            return [3, 3];
                        case 3:
                            console.debug("(await selectedContactPromise).EnsureBoundTo(this.Element);");
                            return [4, selectedContactPromise];
                        case 4:
                            (_b.sent()).EnsureBoundTo(this.Element);
                            console.debug("const dependencies = names.dependenciesFor(document.documentElement).map(d => utils.Require(d));");
                            dependencies = names.DependenciesFor(document.documentElement).map(function (d) { return utils.Require(d); });
                            _b.label = 5;
                        case 5:
                            _b.trys.push([5, 12, 13, 14]);
                            dependencies_1 = __values(dependencies), dependencies_1_1 = dependencies_1.next();
                            _b.label = 6;
                        case 6:
                            if (!!dependencies_1_1.done) return [3, 11];
                            dependency = dependencies_1_1.value;
                            _b.label = 7;
                        case 7:
                            _b.trys.push([7, 9, , 10]);
                            return [4, dependency];
                        case 8:
                            _b.sent();
                            return [3, 10];
                        case 9:
                            err_9 = _b.sent();
                            this.ExceptionHandler(err_9);
                            return [3, 10];
                        case 10:
                            dependencies_1_1 = dependencies_1.next();
                            return [3, 6];
                        case 11: return [3, 14];
                        case 12:
                            e_52_1 = _b.sent();
                            e_52 = { error: e_52_1 };
                            return [3, 14];
                        case 13:
                            try {
                                if (dependencies_1_1 && !dependencies_1_1.done && (_a = dependencies_1.return)) _a.call(dependencies_1);
                            }
                            finally { if (e_52) throw e_52.error; }
                            return [7];
                        case 14:
                            console.debug("this.Compile");
                            this.Compile(this.Element, null, Number.MAX_VALUE)(this.Scope, null, {
                                parentBoundTranscludeFn: this.Transclude,
                            });
                            return [2];
                    }
                });
            });
        };
        Controller = __decorate([
            __param(0, utils.Inject("$transclude")),
            __param(1, utils.Inject("$compile")),
            __param(2, utils.Inject("$exceptionHandler"))
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    function DefineInModule(target) {
        utils.Component(target, exports.Definition)(Controller);
    }
    exports.DefineInModule = DefineInModule;
    function ApplyTo(element) {
        $(element).attr(utils.SnakeCase(utils.GetComponentName(Controller)), "");
    }
    exports.ApplyTo = ApplyTo;
});
define("app/app-main-module", ["require", "exports", "ngAmd", "sss-json!~/$$/Home/Icons", "app/pre-angular-bootstrap-utils", "app/date-utils", "scripts/lib/select-development/sss-paths", "scripts/lib/select-development/sss-directives", "app/sss/application/root/sss-application-root", "tmh.dynamicLocale", "angular-ladda", "ng.deviceDetector", "ngMaterial", "ngMessages", "LocalStorageModule", "jquery-ui", "ui.sortable", "ngCookies", "sss-md-theming", "ngFileUpload", "sssNgFileUploadFixes", "core-js", "ngWebworker", "ngNvD3", "ngSanitize"], function (require, exports, ngAmd, iIcons, utils, dateUtils, paths, sssDirectives, ApplicationRoot) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var icons = iIcons;
    var module = angular.module("app-main-module", [
        sssDirectives.module.name,
        "tmh.dynamicLocale",
        "angular-ladda",
        "ng.deviceDetector",
        "ngMaterial",
        "ngMessages",
        "LocalStorageModule",
        "ui.sortable",
        "ngCookies",
        "sssMdTheming",
        "ngFileUpload",
        "sssNgFileUploadFixes",
        "nvd3",
        "ngWebworker",
        "ngSanitize"
    ]);
    module.config(["$rootScopeProvider", function ($rootScopeProvider) {
            $rootScopeProvider.digestTtl(20);
        }]);
    module.config(["$mdIconProvider", function ($mdIconProvider) {
            try {
                for (var _a = __values(Object.keys(icons)), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var name_5 = _b.value;
                    $mdIconProvider.icon(name_5, name_5 + ".svg");
                }
            }
            catch (e_53_1) { e_53 = { error: e_53_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_53) throw e_53.error; }
            }
            var e_53, _c;
        }]);
    module.run(["$templateCache",
        function (templateCache) { return angular.forEach(icons, function (svg, name) { return templateCache.put(name + ".svg", svg); }); }]);
    function decorate(name, fn) {
        module.config(["$provide", function ($provide) { return $provide.decorator(name, fn); }]);
    }
    decorate("$q", ["$delegate", "$injector", function ($q, $injector) {
            $q["isQ"] = function isQ(val) {
                return angular.isFunction((angular.isObject(val) || angular.isFunction(val)) && val && val["then"]);
            };
            $q["try"] = function qTry(fn) {
                var exceptionHandler = $injector.get("$exceptionHandler");
                try {
                    return $q.when(fn());
                }
                catch (ex) {
                    try {
                        exceptionHandler(ex);
                    }
                    catch (badEx) {
                    }
                    return $q.reject(ex);
                }
            };
            $q["if"] = function qIf(value) {
                if (utils.IsUndefined(value))
                    return $q.resolve(value);
                else if ($q.isQ(value))
                    return $q.resolve(value);
                else
                    return value ? $q.resolve(value) : $q.reject(value);
            };
            return $q;
        }]);
    decorate("$anchorScroll", ["$delegate", "$location", function ($anchorScroll, $location) {
            function $anchorScrollFixed(id) {
                var hash;
                if (arguments.length) {
                    hash = $location.hash();
                    $location.hash(id);
                }
                var returnValue = $anchorScroll();
                if (arguments.length)
                    $location.hash(hash);
                return returnValue;
            }
            Object.defineProperties($anchorScrollFixed, {
                yOffset: {
                    enumerable: true,
                    get: function yOffset_get() {
                        return $anchorScroll.yOffset;
                    },
                    set: function yOffset_set(value) {
                        $anchorScroll.yOffset = value;
                    }
                }
            });
            return $anchorScrollFixed;
        }]);
    decorate("$parse", ["$delegate", function ($delegate) {
            return angular.extend($parse, $delegate);
            function $parse(exp, interceptorFn, expensiveChecks) {
                var result = $delegate.apply(this, arguments);
                if (result && result !== angular.noop && exp !== result) {
                    result.toString = exp_toString;
                }
                return result;
                function exp_toString() {
                    return exp ? exp.toString() : String(exp);
                }
            }
        }]);
    decorate("$exceptionHandler", ["$delegate", function ($exceptionHandler) {
            function logError(exception, cause) {
                try {
                    try {
                        $exceptionHandler(exception, cause);
                    }
                    finally {
                        require(["$http", "service!selcomm"], function ($http, selcomm) {
                            var currentSession;
                            try {
                                currentSession = selcomm.authentication.currentSession;
                            }
                            catch (ex) { }
                            var data = {
                                Message: exception && exception.message || null,
                                UserCode: currentSession && currentSession.UserCode || null,
                                CurrentContactCode: currentSession && currentSession.CurrentContactCode || null,
                                SessionKey: currentSession && currentSession.SessionKey || null,
                                Session: angular.toJson(currentSession, true) || null,
                                Exception: angular.toJson(angular.copy(exception), true) || null,
                                Description: exception && exception.description || null,
                                Name: exception && exception.name || null,
                                StackTrace: exception && exception.stack || null
                            };
                            $.post("$$/Home/LogClientException", data)
                                .then(function (id) { return console.info("Error logged as " + id, exception); });
                        });
                    }
                }
                catch (ex) {
                }
            }
            return logError;
        }]);
    module.config(["$locationProvider", function ($locationProvider) { return $locationProvider.html5Mode(true); }]);
    module.config(["$mdThemingProvider", function ($mdThemingProvider) { return $mdThemingProvider.alwaysWatchTheme(true); }]);
    module.config(["localStorageServiceProvider", function (localStorageServiceProvider) { return localStorageServiceProvider.setPrefix("SelectSoftware.AngularPortals").setStorageCookie(1, paths.ServerAppRoot); }]);
    module.config(["tmhDynamicLocaleProvider", function (tmhDynamicLocaleProvider) { return tmhDynamicLocaleProvider.defaultLocale("en-au"); }]);
    utils.Require("service!selcomm:authentication").then(function (authService) {
        authService._init();
    });
    module.config(["$mdAriaProvider", function ($mdAriaProvider) {
            $mdAriaProvider.disableWarnings();
        }]);
    module.config(["$qProvider", function ($qProvider) { return $qProvider.errorOnUnhandledRejections(false); }]);
    module.run(["$window", function ($window) {
            angular.element($window).on("dragover drop", function (e) {
                e.preventDefault();
            });
        }]);
    dateUtils.MdLocaleConfigurer.BindToModule(module);
    ApplicationRoot.DefineInModule(module);
    ApplicationRoot.ApplyTo(document.documentElement);
    ngAmd.bootstrap(module, {
        strictDi: true
    });
});
define("app/config", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Config = {
        SitesRequiringOTP: "pivotel,reward,thinkmobile",
        pivotelProviderKey: "2287290323",
        rewardProviderKey: "2301190566",
        thinkmobileProviderKey: "2221145179"
    };
});
var Global;
(function (Global) {
    var Selcomm;
    (function (Selcomm) {
        var Utils;
        (function (Utils) {
            function MakeKeyedCollection(collection, map) {
                if (map === void 0) { map = function (x) { return x; }; }
                var actual = Object.create(null);
                if (collection) {
                    try {
                        for (var _a = __values(Object.keys(collection)), _b = _a.next(); !_b.done; _b = _a.next()) {
                            var name_6 = _b.value;
                            actual[name_6] = map(collection[name_6], name_6);
                        }
                    }
                    catch (e_54_1) { e_54 = { error: e_54_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_54) throw e_54.error; }
                    }
                }
                return actual;
                var e_54, _c;
            }
            Utils.MakeKeyedCollection = MakeKeyedCollection;
            function MakeNumberedCollection(collection, map) {
                var actual = Object.create(null);
                if (collection) {
                    try {
                        for (var _a = __values(Object.keys(collection)), _b = _a.next(); !_b.done; _b = _a.next()) {
                            var number = _b.value;
                            actual[number] = map(collection[number], Number(number));
                        }
                    }
                    catch (e_55_1) { e_55 = { error: e_55_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_55) throw e_55.error; }
                    }
                }
                return actual;
                var e_55, _c;
            }
            Utils.MakeNumberedCollection = MakeNumberedCollection;
        })(Utils = Selcomm.Utils || (Selcomm.Utils = {}));
    })(Selcomm = Global.Selcomm || (Global.Selcomm = {}));
})(Global || (Global = {}));
var $scope = "$scope";
var $destroy = "$destroy";
var $watch = "$watch";
var $element = "$element";
var $attrs = "$attrs";
var $transclude = "$transclude";
if (typeof document === "object") {
    document.addEventListener("DOMContentLoaded", function (event) {
        {
            var baseUrl = JSON.parse(document.getElementById("require-js-base-url").innerHTML);
            require.config({ baseUrl: baseUrl });
        }
        {
            var requireJsConfig = JSON.parse(document.getElementById("require-js-config").innerHTML);
            require.config(requireJsConfig);
        }
        {
            var sssConfig = JSON.parse(document.getElementById("sss-config").innerHTML);
            define("sss-config", [], sssConfig);
        }
    });
}
define("app/sds/highlighter", ["require", "exports", "$sce"], function (require, exports, $sce) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Highlighter = (function () {
        function Highlighter(searchString) {
            if (angular.isArray(searchString))
                this.SearchStrings = searchString.filter(function (s) { return !!s; }).map(function (p) { return p.toLowerCase(); });
            else
                this.SearchStrings = (searchString == null ? "" : searchString).toString().split(/\s+/gi).filter(function (s) { return !!s; }).map(function (p) { return p.toLowerCase(); });
        }
        Highlighter.prototype.HtmlFor = function (text) {
            return $sce.trustAsHtml($(document.createElement("span")).append(this.BuildHighlightElement(text)).html());
        };
        Highlighter.prototype.BuildHighlightElement = function (display) {
            var sections = this.BuildHighlightSections(display);
            var elements = $();
            this.BuildHighlightSections(display);
            sections.map(function (s) {
                var element;
                if (s.Highlight)
                    element = $(document.createElement("em"));
                else
                    element = $(document.createElement("span")).css("opacity", 0.6);
                return element.text(s.Text);
            }).forEach(function (element) { return elements = elements.add(element); });
            return elements;
        };
        Highlighter.prototype.BuildHighlightSections = function (display) {
            var highlight = [];
            for (var i = 0; i < display.length; i++) {
                highlight[i] = false;
            }
            var searchIn = display.toLowerCase();
            try {
                for (var _a = __values(this.SearchStrings), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var p = _b.value;
                    var searchFrom = 0;
                    while ((searchFrom + p.length) < searchIn.length) {
                        var foundAt = searchIn.indexOf(p, searchFrom);
                        if (foundAt === -1)
                            break;
                        searchFrom = foundAt + 1;
                        for (var i = 0; i < p.length; i++) {
                            highlight[i + foundAt] = true;
                        }
                    }
                }
            }
            catch (e_56_1) { e_56 = { error: e_56_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_56) throw e_56.error; }
            }
            var parts = [];
            var startFrom = 0;
            for (var i = 0; i < highlight.length; i++) {
                if (i < (highlight.length - 1) && highlight[i] === highlight[i + 1])
                    continue;
                parts.push({
                    Text: display.substring(startFrom, i + 1),
                    Highlight: highlight[i]
                });
                startFrom = i + 1;
            }
            return parts;
            var e_56, _c;
        };
        return Highlighter;
    }());
    exports.Highlighter = Highlighter;
});
define("app/selcomm/selcomm-service", ["require", "exports", "app/selcomm/service"], function (require, exports, selcomm) {
    "use strict";
    return selcomm;
});
define("app/sdc/switch/sdc-switch-service", ["require", "exports", "$animate", "$timeout", "app/utils"], function (require, exports, $animate, $timeout, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DefinedCase = (function () {
        function DefinedCase(owner, transclude, AnchorElement) {
            this.owner = owner;
            this.transclude = transclude;
            this.AnchorElement = AnchorElement;
        }
        DefinedCase.AreEqual = function (x, y) {
            if (!x && !y)
                return true;
            if (!x || !y)
                return false;
            return x.AnchorElement === y.AnchorElement && x.transclude === y.transclude;
        };
        DefinedCase.prototype.IsIn = function (target) {
            var _this = this;
            return utils.Collection.Any(target, function (x) { return DefinedCase.AreEqual(_this, x); });
        };
        DefinedCase.prototype.IndexOfIn = function (target) {
            var _this = this;
            return utils.Collection.IndexOf(target, function (x) { return DefinedCase.AreEqual(_this, x); });
        };
        DefinedCase.prototype.Undefine = function () {
            if (!this.owner)
                return;
            var index = this.owner.indexOf(this);
            if (index < 0) {
                this.owner = null;
                return;
            }
            this.owner.splice(index, 1);
            this.owner = null;
        };
        DefinedCase.prototype.Execute = function (handleSelectedCase) {
            var _this = this;
            var postTransclude;
            this.transclude(function (caseElement, selectedScope) {
                caseElement[caseElement.length++] = document.createComment(' end sdcSwitchWhen ');
                var selected = new SelectedCase(_this, caseElement, selectedScope);
                postTransclude = handleSelectedCase(selected);
            });
            if (utils.IsFunction(postTransclude))
                postTransclude();
        };
        DefinedCase.CreateAndAttach = function (owner, transclude, element) {
            var newCase = new this(owner, transclude, element);
            owner.push(newCase);
            return newCase;
        };
        return DefinedCase;
    }());
    (function (DefinedCase) {
        var Aggregate = (function () {
            function Aggregate(children) {
                if (children === void 0) { children = []; }
                this.children = children;
                this.removed = false;
            }
            Aggregate.prototype.Undefine = function () {
                if (this.removed)
                    return;
                this.removed = true;
                try {
                    for (var _a = __values(this.children), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var child = _b.value;
                        if (!child)
                            return;
                        child.Undefine();
                    }
                }
                catch (e_57_1) { e_57 = { error: e_57_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_57) throw e_57.error; }
                }
                var e_57, _c;
            };
            return Aggregate;
        }());
        DefinedCase.Aggregate = Aggregate;
    })(DefinedCase || (DefinedCase = {}));
    var SelectedCase = (function () {
        function SelectedCase(DefinedCase, element, scope) {
            this.DefinedCase = DefinedCase;
            this.element = element;
            this.scope = scope;
        }
        Object.defineProperty(SelectedCase.prototype, "anchor", {
            get: function () {
                return this.DefinedCase.AnchorElement;
            },
            enumerable: true,
            configurable: true
        });
        SelectedCase.prototype.Hide = function () {
            var promise = $animate.addClass(this.element.getBlockNodes(), SwitchController.NG_HIDE_CLASS, {
                tempClasses: SwitchController.NG_HIDE_IN_PROGRESS_CLASS
            });
            return promise;
        };
        SelectedCase.prototype.Destroy = function () {
            if (this.removed)
                return null;
            this.scope.$destroy();
            var promise = $animate.leave(this.element.getBlockNodes());
            this.removed = true;
            return promise;
        };
        return SelectedCase;
    }());
    var SwitchController = (function () {
        function SwitchController(watchExpr, scope, hideElements) {
            var _this = this;
            this.watchExpr = watchExpr;
            this.hideElements = hideElements;
            this.previousLeaveAnimations = [];
            this.selected = [];
            this.hidden = [];
            this.cases = {};
            scope.$watch(watchExpr, function ($requestedCase) { return _this.switchTo($requestedCase); });
        }
        Object.defineProperty(SwitchController.prototype, "DefinedCases", {
            get: function () {
                return Object.freeze(Object.keys(this.cases));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SwitchController.prototype, "CurrentCase", {
            get: function () {
                return this.currentCase;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SwitchController.prototype, "RequestedCase", {
            get: function () {
                return this.requestedCase;
            },
            enumerable: true,
            configurable: true
        });
        SwitchController.prototype.When = function (when, options) {
            var newCase;
            if (utils.IsString(when))
                newCase = this.whenSingle(when, options.transclude, options.element);
            else
                newCase = this.whenMany(when, options.transclude, options.element);
            if (options.autoRemove)
                options.scope.$on("$destroy", function () { return newCase.Undefine(); });
            return newCase;
        };
        SwitchController.prototype.when = function (when, options) {
            var definedCase = this.When(when, options);
            return function () { return definedCase.Undefine(); };
        };
        SwitchController.prototype.GetCaseCollection = function (caseName) {
            var fullCaseName;
            switch (arguments.length) {
                case 0:
                    fullCaseName = "?";
                    break;
                default:
                    fullCaseName = "!" + caseName;
                    break;
            }
            return this.cases[fullCaseName] = this.cases[fullCaseName] || utils.Extend([], { FullName: fullCaseName });
        };
        SwitchController.prototype.whenMany = function (caseNames, transclude, element) {
            var _this = this;
            if (utils.IsArray(caseNames)) {
                var children = caseNames.map(function (c) { return _this.whenSingle(c, transclude, element); });
                return new DefinedCase.Aggregate(children);
            }
            else {
                var children = Object.keys(caseNames).filter(function (name) { return caseNames[name]; }).map(function (name) { return _this.whenSingle(name, transclude, element); });
                return new DefinedCase.Aggregate(children);
            }
        };
        SwitchController.prototype.whenSingle = function (caseName, transclude, element) {
            var targetCaseCollection = this.GetCaseCollection(caseName);
            var newCase = DefinedCase.CreateAndAttach(targetCaseCollection, transclude, element);
            if (!this.IsRefreshQueueued && (targetCaseCollection.FullName === this.requestedCase || this.hideElements)) {
                if (this.requestedCase !== this.currentCase)
                    this.queueRefresh();
                else
                    this.executeCase(this.currentCase === targetCaseCollection.FullName, newCase);
            }
            return newCase;
        };
        SwitchController.prototype.Default = function (options) {
            var targetCaseCollection = this.GetCaseCollection();
            var newCase = DefinedCase.CreateAndAttach(targetCaseCollection, options.transclude, options.element);
            if (!this.IsRefreshQueueued && (this.currentCase === targetCaseCollection.FullName || this.hideElements))
                this.executeCase(this.currentCase === targetCaseCollection.FullName, newCase);
            if (options.autoRemove)
                options.scope.$on("$destroy", function () { return newCase.Undefine(); });
            return newCase;
        };
        SwitchController.prototype.default = function (options) {
            var definedCase = this.Default(options);
            return function () { return definedCase.Undefine(); };
        };
        SwitchController.prototype.WhenAndDefault = function (when, defaultEnabled, options) {
            if (!utils.IsBoolean(defaultEnabled)) {
                options = defaultEnabled;
                defaultEnabled = true;
            }
            var whenCase = this.When(when, utils.Extend(options, { returnBody: false, autoRemove: false }));
            var defaultCase;
            if (defaultEnabled)
                defaultCase = this.Default(utils.Extend(options, { returnBody: false, autoRemove: false }));
            var newAggregateCase = new DefinedCase.Aggregate([whenCase, defaultCase]);
            if (options.autoRemove)
                options.scope.$on("$destroy", function () { return newAggregateCase.Undefine(); });
            return newAggregateCase;
        };
        SwitchController.prototype.whenAndDefault = function (when, defaultEnabledOrOptions, options) {
            var newCase;
            if (arguments.length === 2) {
                newCase = this.WhenAndDefault(when, true, defaultEnabledOrOptions);
            }
            else {
                newCase = this.WhenAndDefault(when, !!defaultEnabledOrOptions, options);
            }
            return function () { return newCase; };
        };
        SwitchController.prototype.switchTo = function (value) {
            var _this = this;
            this.lastValue = value;
            this.consumeRefresh();
            this.requestedCase = "!" + value;
            for (var i = 0, ii = this.previousLeaveAnimations.length; i < ii; ++i) {
                $animate.cancel(this.previousLeaveAnimations[i]);
            }
            this.previousLeaveAnimations.length = 0;
            var newTranscludes = this.cases["!" + value];
            this.currentCase = "!" + value;
            if (!newTranscludes) {
                newTranscludes = this.cases["?"];
                this.currentCase = "?";
            }
            if (!newTranscludes) {
                newTranscludes = utils.Extend([], { FullName: "!" + value });
                this.currentCase = null;
            }
            var removedSelectedCases = utils.Collection.ArrayRemoveWhere(this.selected, function (sc) { return !sc.DefinedCase.IsIn(newTranscludes); });
            try {
                for (var removedSelectedCases_1 = __values(removedSelectedCases), removedSelectedCases_1_1 = removedSelectedCases_1.next(); !removedSelectedCases_1_1.done; removedSelectedCases_1_1 = removedSelectedCases_1.next()) {
                    var removedSelectedCase = removedSelectedCases_1_1.value;
                    this.Remove(removedSelectedCase);
                }
            }
            catch (e_58_1) { e_58 = { error: e_58_1 }; }
            finally {
                try {
                    if (removedSelectedCases_1_1 && !removedSelectedCases_1_1.done && (_a = removedSelectedCases_1.return)) _a.call(removedSelectedCases_1);
                }
                finally { if (e_58) throw e_58.error; }
            }
            angular.forEach(newTranscludes, function (t) { return _this.executeCase(true, t); });
            var e_58, _a;
        };
        SwitchController.prototype.Remove = function (target) {
            var _this = this;
            var removePromise;
            if (!this.hideElements)
                removePromise = target.Destroy();
            else {
                this.hidden.push(target);
                removePromise = target.Hide();
            }
            this.previousLeaveAnimations.push(removePromise);
            removePromise.then(function () { return utils.Collection.ArrayRemoveAll(_this.previousLeaveAnimations, removePromise); });
        };
        SwitchController.prototype.executeCase = function (enabled, definedCase) {
            var _this = this;
            if (definedCase.IsIn(this.selected.map(function (sc) { return sc.DefinedCase; })))
                return;
            else {
                var hiddenI = definedCase.IndexOfIn(this.hidden.map(function (sc) { return sc.DefinedCase; }));
                if (hiddenI >= 0 && enabled) {
                    var showing = this.hidden[hiddenI];
                    $animate.removeClass(showing.element.getBlockNodes(), SwitchController.NG_HIDE_CLASS, {
                        tempClasses: SwitchController.NG_HIDE_IN_PROGRESS_CLASS
                    });
                    this.selected.push(this.hidden.splice(hiddenI, 1)[0]);
                }
                else if (enabled || this.hideElements) {
                    definedCase.Execute(function (newSelectedCase) {
                        if (enabled) {
                            $animate.enter(newSelectedCase.element, newSelectedCase.anchor.parent(), newSelectedCase.anchor);
                            _this.selected.push(newSelectedCase);
                            return angular.noop;
                        }
                        else {
                            newSelectedCase.anchor.after(newSelectedCase.element);
                            var blockNodes_1 = newSelectedCase.element.getBlockNodes();
                            _this.hidden.push(newSelectedCase);
                            return function () { return blockNodes_1.addClass(SwitchController.NG_HIDE_CLASS); };
                        }
                    });
                }
            }
        };
        ;
        Object.defineProperty(SwitchController.prototype, "IsRefreshQueueued", {
            get: function () {
                return !!this.queuedRefresh;
            },
            enumerable: true,
            configurable: true
        });
        SwitchController.prototype.queueRefresh = function () {
            var _this = this;
            console.log("Queued Refresh");
            var deferred = this.queuedRefresh = $timeout(function () {
                if (_this.consumeRefresh(deferred))
                    _this.switchTo(_this.lastValue);
            });
        };
        SwitchController.prototype.consumeRefresh = function (expected) {
            if (this.queuedRefresh && (!expected || expected === this.queuedRefresh)) {
                $timeout.cancel(this.queuedRefresh);
                this.queuedRefresh = null;
                return true;
            }
            return false;
        };
        SwitchController.NG_HIDE_CLASS = 'ng-hide';
        SwitchController.NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
        return SwitchController;
    }());
    exports.SwitchController = SwitchController;
    function on(watchExpr, options) {
        return new SwitchController(watchExpr, options.scope, options.hideElements);
    }
    exports.on = on;
});
define("app/sdc/bound/expression/sdc-bound-expression", ["require", "exports", "$parse"], function (require, exports, $parse) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function create(expr, context, locals) {
        switch (arguments.length) {
            case 2:
                if (angular.isObject(expr) && (angular.isString(context) || angular.isFunction(context))) {
                    var temp = expr;
                    expr = context;
                    context = temp;
                }
                break;
            case 3:
                if (angular.isObject(expr) && angular.isObject(context) && (angular.isString(locals) || angular.isFunction(locals))) {
                    var temp = expr;
                    expr = locals;
                    locals = temp;
                    temp = context;
                    context = locals;
                    locals = temp;
                }
                break;
        }
        var parsed = $parse(expr ? expr.toString() : "");
        if (!parsed || parsed === angular.noop)
            return parsed;
        var boundExpr = angular.extend(function (c, l) { return parsed(context, locals); }, parsed);
        if (parsed.assign) {
            boundExpr.assign = angular.extend(function (c, value, l) { return parsed.assign(context, value, locals); }, parsed.assign);
            boundExpr.set = function (value) { return parsed.assign(context, value, locals); };
        }
        boundExpr.toString = function boundExpr_toString() {
            return parsed.toString();
        };
        return boundExpr;
    }
    exports.create = create;
    function From(getter, setter) {
        return angular.extend(function () { return getter(); }, { set: setter });
    }
    exports.From = From;
    function factory(context, locals) {
        return function (expr) { return create(expr, context, locals); };
    }
    exports.factory = factory;
});
define("app/sdc/crud/sdc-crud", ["require", "exports", "module", "app/utils", "app/ng-utils", "app/sdc/switch/sdc-switch-service", "scripts/lib/select-development/sss-names", "directive!sdc-transclude-element"], function (require, exports, module_3, utils, ng_utils_4, switchService, names) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_3.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Switch = new switchService.SwitchController(function () { return _this.State; }, _this.Scope, false);
            return _this;
        }
        Controller_3 = Controller;
        Controller.ParseBoundState = function (boundState) {
            if (utils.IsVoid(boundState))
                return State.Read;
            if (State.IsName(boundState))
                return State[boundState];
            return boundState;
        };
        Object.defineProperty(Controller.prototype, "State", {
            get: function () {
                var boundState = this.GetBoundState();
                var state = Controller_3.ParseBoundState(boundState);
                return state;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Getter(Name)
        ], Controller.prototype, "GetBoundState", void 0);
        Controller = Controller_3 = __decorate([
            utils.Component({
                Name: Name,
                Template: null,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.NewInheritedScope,
            })
        ], Controller);
        return Controller;
        var Controller_3;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    var State;
    (function (State) {
        State["Create"] = "create";
        State["Read"] = "read";
        State["Update"] = "update";
        State["Delete"] = "delete";
    })(State = exports.State || (exports.State = {}));
    (function (State) {
        State.All = Object.freeze([State.Create, State.Read, State.Update, State.Delete]);
        State.Names = Object.freeze(new Array("Create", "Read", "Update", "Delete"));
        function IsName(value) {
            return State.Names.indexOf(value) >= 0;
        }
        State.IsName = IsName;
        var Bag = (function () {
            function Bag(getter, setter) {
                this.getter = getter;
                this.setter = setter;
            }
            Object.defineProperty(Bag.prototype, "Current", {
                get: function () {
                    return this.getter() || State.Read;
                },
                set: function (value) {
                    this.setter(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Bag.prototype, "IsCreate", {
                get: function () {
                    return this.Current === State.Create;
                },
                set: function (value) {
                    if (value)
                        this.Current = State.Create;
                    else if (this.Current === State.Create)
                        this.Current = State.Read;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Bag.prototype, "IsRead", {
                get: function () {
                    return this.Current === State.Read;
                },
                set: function (value) {
                    if (value)
                        this.Current = State.Read;
                    else if (this.Current === State.Read)
                        this.Current = State.Read;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Bag.prototype, "IsUpdate", {
                get: function () {
                    return this.Current === State.Update;
                },
                set: function (value) {
                    if (value)
                        this.Current = State.Update;
                    else if (this.Current === State.Update)
                        this.Current = State.Read;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Bag.prototype, "IsDelete", {
                get: function () {
                    return this.Current === State.Delete;
                },
                set: function (value) {
                    if (value)
                        this.Current = State.Delete;
                    else if (this.Current === State.Delete)
                        this.Current = State.Read;
                },
                enumerable: true,
                configurable: true
            });
            return Bag;
        }());
        State.Bag = Bag;
        (function (Bag) {
            var LegacyCompatible = (function (_super) {
                __extends(LegacyCompatible, _super);
                function LegacyCompatible() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(LegacyCompatible.prototype, "create", {
                    get: function () { return this.IsCreate; },
                    set: function (value) { this.IsCreate = value; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LegacyCompatible.prototype, "read", {
                    get: function () { return this.IsRead; },
                    set: function (value) { this.IsRead = value; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LegacyCompatible.prototype, "update", {
                    get: function () { return this.IsUpdate; },
                    set: function (value) { this.IsUpdate = value; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LegacyCompatible.prototype, "delete", {
                    get: function () { return this.IsDelete; },
                    set: function (value) { this.IsDelete = value; },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(LegacyCompatible.prototype, "name", {
                    get: function () {
                        return this.Current;
                    },
                    set: function (value) {
                        this.Current = value;
                    },
                    enumerable: true,
                    configurable: true
                });
                LegacyCompatible.CreateWithLegacyBinding = function (getter, setter) {
                    return new LegacyCompatible(getter, setter);
                };
                return LegacyCompatible;
            }(Bag));
            Bag.LegacyCompatible = LegacyCompatible;
        })(Bag = State.Bag || (State.Bag = {}));
    })(State = exports.State || (exports.State = {}));
    var ActionManager = (function () {
        function ActionManager(options) {
            this.options = options;
            this.TargetState = this.options.TargetState;
            this.options = utils.ShallowCopy(this.options);
        }
        ActionManager.prototype.GetNewStatePromise = function (context) {
            return this.options.GetNewStatePromise(context);
        };
        ActionManager.prototype.SetNewStatePromise = function (context, value) {
            this.options.SetNewStatePromise(context, value);
            return value;
        };
        ActionManager.prototype.Execute = function (context) {
            return this._Execute(context, this.options.GetState(context));
        };
        ActionManager.prototype._Execute = function (context, currentState) {
            var _this = this;
            switch (currentState) {
                case this.TargetState: {
                    var prom_1 = ng_utils_4.$q.resolve(this.options.Execute(context))
                        .then(function (result) {
                        if (prom_1 !== _this.GetNewStatePromise(context))
                            return ng_utils_4.$q.reject();
                        _this.options.OnExecuted(context, result);
                        _this.options.SetState(context, State.Read);
                        return void null;
                    });
                    this.SetNewStatePromise(context, prom_1);
                    break;
                }
                case State.Read: {
                    var prom_2 = ng_utils_4.$q.resolve(this.options.OnExecuting(context))
                        .then(function () {
                        if (prom_2 !== _this.GetNewStatePromise(context))
                            return ng_utils_4.$q.reject();
                        _this.options.SetState(context, _this.TargetState);
                        return void null;
                    });
                    this.SetNewStatePromise(context, prom_2);
                    break;
                }
                default: {
                    this.options.CancelState(context, currentState);
                    break;
                }
            }
        };
        return ActionManager;
    }());
    exports.ActionManager = ActionManager;
    (function (Controller) {
        var LegacyController = (function (_super) {
            __extends(LegacyController, _super);
            function LegacyController() {
                var _this = _super.call(this) || this;
                _this.stateBag = new State.Bag.LegacyCompatible(function () { return _this.CurrentState; }, function (value) { return _this.CurrentState = value; });
                _this.scopeExtender = function (scope) { return _this.extendScope(scope); };
                _this.switch = new switchService.SwitchController(function () { return _this.CurrentState; }, _this.Scope, false);
                _this.scopeExtender = _this.extendScope.bind(_this);
                _this.extendScope(_this.Scope);
                return _this;
            }
            LegacyController_1 = LegacyController;
            Object.defineProperty(LegacyController.prototype, "state", {
                get: function () {
                    if (this.CurrentState === State.Read)
                        return this._LastSeenLegacyState;
                    return this.CurrentState;
                },
                set: function (value) {
                    this.CurrentState = value;
                    this._LastSeenLegacyState = value;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyController.prototype, "CurrentState", {
                get: function () {
                    return utils.IsVoid(this._CurrentState) ? State.Read : this._CurrentState;
                },
                set: function (value) {
                    this._CurrentState = value;
                },
                enumerable: true,
                configurable: true
            });
            LegacyController.prototype.create = function () {
                return LegacyController_1.ActionManager_Create.Execute(this);
            };
            LegacyController.prototype.update = function () {
                return LegacyController_1.ActionManager_Update.Execute(this);
            };
            LegacyController.prototype.delete = function () {
                return LegacyController_1.ActionManager_Delete.Execute(this);
            };
            Object.defineProperty(LegacyController.prototype, "Switch", {
                get: function () {
                    return this.switch;
                },
                enumerable: true,
                configurable: true
            });
            LegacyController.prototype.extendScope = function (scope) {
                var _this = this;
                scope.$create = function () { return _this.create(); };
                scope.$update = function () { return _this.update(); };
                scope.$delete = function () { return _this.delete(); };
                scope.$cancel = function () { return _this.cancel(); };
                scope.$submit = function () { return _this.submit(); };
                scope.$state = this.stateBag;
            };
            LegacyController.prototype.cancel = function () {
                return this.CancelState(this.CurrentState);
            };
            LegacyController.prototype.submit = function () {
                switch (this.CurrentState) {
                    case State.Create:
                        return this.create();
                    case State.Read:
                    default:
                        return;
                    case State.Update:
                        return this.update();
                    case State.Delete:
                        return this.delete();
                }
            };
            LegacyController.prototype.can = function (action) {
                switch (action) {
                    default:
                        return false;
                    case State.Create:
                        return this.canCreate;
                    case State.Read:
                        return this.canRead;
                    case State.Update:
                        return this.canUpdate;
                    case State.Delete:
                        return this.canDelete;
                }
            };
            Object.defineProperty(LegacyController.prototype, "canDelete", {
                get: function () {
                    return !!(this.delete_execute && (this.delete_allowed ? this.delete_allowed() : true));
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyController.prototype, "canUpdate", {
                get: function () {
                    return !!(this.update_execute && (this.update_allowed ? this.update_allowed() : true));
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyController.prototype, "canCreate", {
                get: function () {
                    return !!(this.create_execute && (this.create_allowed ? this.create_allowed() : true));
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyController.prototype, "canRead", {
                get: function () {
                    return true;
                },
                enumerable: true,
                configurable: true
            });
            LegacyController.prototype.CancelState = function (state) {
                var _this = this;
                if (this.CurrentState !== state)
                    return ng_utils_4.$q.reject("Not at specified state.");
                var cancelling;
                switch (state) {
                    default:
                        throw new Error("Unexpected state " + state);
                    case State.Read:
                        return ng_utils_4.$q.reject("Cannot cancel read state.");
                    case State.Create:
                        cancelling = this.create_cancelling();
                        break;
                    case State.Delete:
                        cancelling = this.delete_cancelling();
                        break;
                    case State.Update:
                        cancelling = this.update_cancelling();
                        break;
                }
                var prom = this.NewStatePromise = ng_utils_4.$q.if(cancelling).then(function () {
                    if (_this.NewStatePromise !== prom)
                        return ng_utils_4.$q.reject();
                    _this.CurrentState = State.Read;
                    return void undefined;
                });
                return prom;
            };
            LegacyController.prototype.OnExecuting = function (state) {
                switch (state) {
                    case State.Create:
                        return ng_utils_4.$q.if(this.create_executing());
                    case State.Update:
                        return ng_utils_4.$q.if(this.update_executing());
                    case State.Delete:
                        return ng_utils_4.$q.if(this.delete_executing());
                    default:
                        throw new Error("Unexpected state " + state);
                }
            };
            LegacyController.prototype.OnExecuted = function (state, result) {
                switch (state) {
                    case State.Create:
                        return ng_utils_4.$q.if(this.create_executed({ $result: result }));
                    case State.Update:
                        return ng_utils_4.$q.if(this.update_executed({ $result: result }));
                    case State.Delete:
                        return ng_utils_4.$q.if(this.delete_executed({ $result: result }));
                    default:
                        throw new Error("Unexpected state " + state);
                }
            };
            LegacyController.prototype.Execute = function (state) {
                switch (state) {
                    case State.Create:
                        return ng_utils_4.$q.if(utils.AssertNotVoid(this.create_execute)());
                    case State.Update:
                        return ng_utils_4.$q.if(utils.AssertNotVoid(this.update_execute)());
                    case State.Delete:
                        return ng_utils_4.$q.if(utils.AssertNotVoid(this.delete_execute)());
                    default:
                        throw new Error("Unexpected state " + state);
                }
            };
            LegacyController.CreateActionManager = function (state) {
                return new ActionManager({
                    TargetState: state,
                    GetState: function (vm) { return vm.CurrentState; },
                    SetState: function (vm, value) { vm.CurrentState = value; },
                    GetNewStatePromise: function (vm) { return vm.NewStatePromise; },
                    SetNewStatePromise: function (vm, value) { vm.NewStatePromise = value; },
                    CancelState: function (vm, state) { return vm.CancelState(state); },
                    OnExecuting: function (vm) { return vm.OnExecuting(state); },
                    Execute: function (vm) { return vm.Execute(state); },
                    OnExecuted: function (vm, result) { return vm.OnExecuted(state, result); }
                });
            };
            LegacyController.ActionManager_Create = LegacyController_1.CreateActionManager(State.Create);
            LegacyController.ActionManager_Update = LegacyController_1.CreateActionManager(State.Update);
            LegacyController.ActionManager_Delete = LegacyController_1.CreateActionManager(State.Delete);
            __decorate([
                utils.Bind.Getter("create", { optional: true })
            ], LegacyController.prototype, "create_execute", void 0);
            __decorate([
                utils.Bind.Getter("can-create", { optional: true })
            ], LegacyController.prototype, "create_allowed", void 0);
            __decorate([
                utils.Bind.Getter("on-creating")
            ], LegacyController.prototype, "create_executing", void 0);
            __decorate([
                utils.Bind.Getter("on-cancel-create")
            ], LegacyController.prototype, "create_cancelling", void 0);
            __decorate([
                utils.Bind.Getter("on-created")
            ], LegacyController.prototype, "create_executed", void 0);
            __decorate([
                utils.Bind.Getter("update", { optional: true })
            ], LegacyController.prototype, "update_execute", void 0);
            __decorate([
                utils.Bind.Getter("can-update", { optional: true })
            ], LegacyController.prototype, "update_allowed", void 0);
            __decorate([
                utils.Bind.Getter("on-updating")
            ], LegacyController.prototype, "update_executing", void 0);
            __decorate([
                utils.Bind.Getter("on-cancel-update")
            ], LegacyController.prototype, "update_cancelling", void 0);
            __decorate([
                utils.Bind.Getter("on-updated")
            ], LegacyController.prototype, "update_executed", void 0);
            __decorate([
                utils.Bind.Getter("delete", { optional: true })
            ], LegacyController.prototype, "delete_execute", void 0);
            __decorate([
                utils.Bind.Getter("can-delete", { optional: true })
            ], LegacyController.prototype, "delete_allowed", void 0);
            __decorate([
                utils.Bind.Getter("on-deleting")
            ], LegacyController.prototype, "delete_executing", void 0);
            __decorate([
                utils.Bind.Getter("on-cancel-delete")
            ], LegacyController.prototype, "delete_cancelling", void 0);
            __decorate([
                utils.Bind.Getter("on-deleted")
            ], LegacyController.prototype, "delete_executed", void 0);
            __decorate([
                utils.Bind.TwoWay("state", { optional: true })
            ], LegacyController.prototype, "state", null);
            __decorate([
                utils.Bind.TwoWay("state-bag", { optional: true })
            ], LegacyController.prototype, "stateBag", void 0);
            __decorate([
                utils.Bind.TwoWay("scope-extender", { optional: true })
            ], LegacyController.prototype, "scopeExtender", void 0);
            LegacyController = LegacyController_1 = __decorate([
                utils.Component({
                    Name: Name,
                    Template: null,
                    Restrict: utils.Target.Element,
                    Scope: utils.ScopeMode.NewInheritedScope,
                })
            ], LegacyController);
            return LegacyController;
            var LegacyController_1;
        }(utils.Controller));
        Controller.LegacyController = LegacyController;
    })(Controller = exports.Controller || (exports.Controller = {}));
    exports.Controller = Controller;
    var definedSubComponents = new Array();
    var compiledData = "sdc-crud-service.compiled";
    function SubComponent(name) {
        var normalizedName = utils.CamelCase(name);
        function isThisOrDefined(name) {
            return name === normalizedName;
        }
        var p1 = 70000;
        utils.Directive({
            Name: name,
            Template: null,
            Restrict: utils.Target.Element | utils.Target.Attribute,
            Priority: 70000,
            Terminal: true,
            Scope: utils.ScopeMode.ParentScope,
            OnCompile: function (tElement, tAttrs) {
                var compiled = tElement.data(compiledData);
                if (compiled)
                    return null;
                tElement.data(compiledData, true);
                var normalizedTagName = names.ComponentNameNormalize(tElement[0].tagName.toLowerCase());
                if (!("sdcTranscludeElement" in tAttrs) && normalizedTagName !== "sdcTranscludeElement")
                    tElement.attr("sdc-transclude-element", "");
                return function (scope, iElement, iAttrs, controller, transcludeFn) {
                    tElement.data(compiledData, false);
                    ng_utils_4.$compile(iElement, null, p1)(scope, undefined, {
                        parentBoundTranscludeFn: transcludeFn,
                    });
                };
            }
        });
        var p2 = 15000;
        utils.Directive({
            Name: name,
            Template: null,
            Restrict: utils.Target.Element | utils.Target.Attribute,
            Require: ["^sdcCrud", "sdcTranscludeElement"],
            Priority: p2,
            Scope: utils.ScopeMode.ParentScope,
            OnCompile: function (tElement, tAttrs) {
                var normalizedTagName = names.ComponentNameNormalize(tElement[0].tagName.toLowerCase());
                var elemDir = tElement.length === 1 ? normalizedTagName : null;
                var elemDirIdx = definedSubComponents.indexOf(elemDir);
                var noneIsElement = elemDirIdx < 0;
                var thisIsElement = elemDirIdx === definedSubComponents.indexOf(normalizedName);
                return function (scope, iElement, iAttrs, controllers) {
                    var _a = __read(controllers, 2), crud = _a[0], transclude = _a[1];
                    var cases = (_b = {},
                        _b[State.Update] = isThisOrDefined("sdcUpdate"),
                        _b[State.Delete] = isThisOrDefined("sdcDelete"),
                        _b[State.Create] = isThisOrDefined("sdcCreate"),
                        _b);
                    var defaultCase = isThisOrDefined("sdcRead");
                    crud.Switch.WhenAndDefault(cases, defaultCase, {
                        transclude: transclude.$transclude,
                        element: iElement,
                        scope: scope,
                        autoRemove: true,
                    });
                    var _b;
                };
            }
        });
    }
    exports.SubComponent = SubComponent;
});
define("app/sdc/create/sdc-create", ["require", "exports", "app/sdc/crud/sdc-crud"], function (require, exports, Crud) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    Crud.SubComponent("sdc-create");
});
define("app/sdc/date/sdc-date", ["require", "exports", "app/utils", "moment", "app/ng-utils", "module"], function (require, exports, utils, moment, ng_utils_5, module_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_4.id);
    var MaxDays = 31;
    var RelativePoint;
    (function (RelativePoint) {
        RelativePoint["Start"] = "start";
        RelativePoint["End"] = "end";
    })(RelativePoint || (RelativePoint = {}));
    (function (RelativePoint) {
        function Sanitise(value, defaultValue) {
            if (defaultValue === void 0) { defaultValue = null; }
            if (utils.IsVoid(value))
                return defaultValue;
            switch (value) {
                case RelativePoint.Start:
                case RelativePoint.End:
                    return value;
                default:
                    return defaultValue;
            }
        }
        RelativePoint.Sanitise = Sanitise;
    })(RelativePoint || (RelativePoint = {}));
    var MonthType;
    (function (MonthType) {
        MonthType["Numeric"] = "numeric";
        MonthType["Short"] = "short";
        MonthType["Full"] = "full";
    })(MonthType || (MonthType = {}));
    var DateType = (function () {
        function DateType(Unit, Alignment) {
            this.Unit = Unit;
            this.Alignment = Alignment;
            this.ShowDays = DateType.ShouldShowDay(this.Unit);
            this.ShowMonth = DateType.ShouldShowMonth(this.Unit);
            Object.freeze(this);
        }
        DateType.ShouldShowDay = function (smallestDisplayUnit) {
            switch (smallestDisplayUnit) {
                case "year":
                case "years":
                case "y":
                case "quarter":
                case "quarters":
                case "Q":
                case "month":
                case "months":
                case "M":
                case "week":
                case "weeks":
                case "w":
                case "isoWeek":
                case "isoWeeks":
                case "W":
                    return false;
                default:
                    return true;
            }
        };
        DateType.ShouldShowMonth = function (smallestDisplayUnit) {
            switch (smallestDisplayUnit) {
                case "year":
                case "years":
                case "y":
                case "quarter":
                case "quarters":
                case "Q":
                    return false;
                default:
                    return true;
            }
        };
        DateType.prototype.Clamp = function (value) {
            if (utils.IsDate(value))
                return this.Clamp(moment(value)).toDate();
            if (!moment.isMoment(value))
                return value;
            switch (this.Alignment) {
                case RelativePoint.End:
                    return value.clone().endOf(this.Unit);
                case RelativePoint.Start:
                    return value.clone().startOf(this.Unit);
                default:
                    return value.clone();
            }
        };
        return DateType;
    }());
    (function (MonthType) {
        function Sanitise(value, defaultValue) {
            if (defaultValue === void 0) { defaultValue = null; }
            if (utils.IsVoid(value))
                return defaultValue;
            switch (value) {
                case MonthType.Numeric:
                case MonthType.Short:
                case MonthType.Full:
                    return value;
                default:
                    return defaultValue;
            }
        }
        MonthType.Sanitise = Sanitise;
    })(MonthType || (MonthType = {}));
    var ControllerBase = (function (_super) {
        __extends(ControllerBase, _super);
        function ControllerBase() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.InitDate = new Date();
            _this.Yesterday = _this.InitMoment.add(-1, "d");
            _this.Tomorrow = _this.InitMoment.add(1, "d");
            return _this;
        }
        ControllerBase.DaysInMonth = function (year, month) {
            var daysInMonth = moment().year(year).month(month - 1).daysInMonth();
            return new utils.IntegerRange(1, daysInMonth, utils.RangeType.Inclusive);
        };
        Object.defineProperty(ControllerBase.prototype, "InitMoment", {
            get: function () {
                return utils.AsMoment(this.InitDate);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "EffectiveMax", {
            get: function () {
                return this._EffectiveMax;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "SpecifiedMax", {
            get: function () {
                return this._SpecifiedMax;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "EffectiveMin", {
            get: function () {
                return this._EffectiveMin;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "SpecifiedMin", {
            get: function () {
                return this._SpecifiedMin;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "RequestedValidYears", {
            get: function () {
                return this._RequestedValidYears;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "RequestedValidMonths", {
            get: function () {
                return this._RequestedValidMonths;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "RequestedValidDays", {
            get: function () {
                return this._RequestedValidDays;
            },
            enumerable: true,
            configurable: true
        });
        ControllerBase.prototype.ApplyRange = function (min, max, dateType) {
            {
                var newSpecifiedMin = dateType.Clamp(utils.AsMoment(min));
                var newSpecifiedMax = dateType.Clamp(utils.AsMoment(max));
                if (utils.IsVoid(newSpecifiedMin) || utils.IsVoid(this._SpecifiedMin) || !newSpecifiedMin.isSame(this._SpecifiedMin))
                    this._SpecifiedMin = newSpecifiedMin;
                if (utils.IsVoid(newSpecifiedMax) || utils.IsVoid(this._SpecifiedMax) || !newSpecifiedMax.isSame(this._SpecifiedMax))
                    this._SpecifiedMax = newSpecifiedMax;
            }
            {
                var _a = this, SpecifiedMin = _a.SpecifiedMin, SpecifiedMax = _a.SpecifiedMax;
                var newEffectiveMin = SpecifiedMin || dateType.Clamp(this.InitMoment.subtract(ControllerBase.DefaultRange));
                var newEffectiveMax = SpecifiedMax || dateType.Clamp(this.InitMoment.add(ControllerBase.DefaultRange));
                if (utils.IsVoid(newEffectiveMin) || utils.IsVoid(this._EffectiveMin) || !newEffectiveMin.isSame(this._EffectiveMin))
                    this._EffectiveMin = newEffectiveMin;
                if (utils.IsVoid(newEffectiveMax) || utils.IsVoid(this._EffectiveMax) || !newEffectiveMax.isSame(this._EffectiveMax))
                    this._EffectiveMax = newEffectiveMax;
            }
            var _b = this, EffectiveMin = _b.EffectiveMin, EffectiveMax = _b.EffectiveMax;
            this._RequestedValidYears = new utils.IntegerRange(EffectiveMin.year(), EffectiveMax.year(), utils.RangeType.Inclusive);
            this._RequestedValidMonths = new utils.IntegerRange(EffectiveMin.month() + 1, EffectiveMax.month() + 1, utils.RangeType.Inclusive);
            this._RequestedValidDays = new utils.IntegerRange(EffectiveMin.date(), EffectiveMax.date(), utils.RangeType.Inclusive);
            this.TriggerEffectiveRebuild();
        };
        ControllerBase.prototype.TriggerEffectiveRebuild = function () {
            this._effective = null;
        };
        Object.defineProperty(ControllerBase.prototype, "Effective", {
            get: function () {
                if (!this._effective)
                    this._effective = ControllerBase.Effective(this.RequestedValidYears, this.Year, this.RequestedValidMonths, this.Month, this._RequestedValidDays, this.DateType);
                return this._effective;
            },
            enumerable: true,
            configurable: true
        });
        ControllerBase.Effective = function (requestedValidYears, selectedYear, requestedValidMonths, selectedMonth, requestedValidDays, dateType) {
            var AllMonths = ControllerBase.AllMonths;
            if (!utils.IsSpecified(selectedYear))
                return { months: AllMonths, days: ControllerBase.AllDays, };
            var baseDays = (dateType.Unit === "day" && !utils.IsVoid(selectedMonth)) ? ControllerBase.DaysInMonth(selectedYear, selectedMonth) : ControllerBase.AllDays;
            switch (requestedValidYears.Check(selectedYear)) {
                case utils.RangeCheckResult.InRangeLeftMost: {
                    var clampedMonths = AllMonths.IntersectLeft(requestedValidMonths);
                    if (dateType.Unit !== "day" || AllMonths.Check(selectedMonth) !== utils.RangeCheckResult.InRangeLeftMost)
                        return { months: clampedMonths, days: baseDays, };
                    return { months: clampedMonths, days: baseDays.IntersectLeft(requestedValidDays), };
                }
                case utils.RangeCheckResult.InRangeRightMost: {
                    var clampedMonths = AllMonths.IntersectRight(requestedValidMonths);
                    if (dateType.Unit !== "day" || AllMonths.Check(selectedMonth) !== utils.RangeCheckResult.InRangeRightMost)
                        return { months: clampedMonths, days: baseDays, };
                    return { months: clampedMonths, days: baseDays.IntersectRight(requestedValidDays), };
                }
                case utils.RangeCheckResult.InRangeBoth: {
                    var clampedMonths = AllMonths.Intersect(requestedValidMonths);
                    if (dateType.Unit === "day") {
                        switch (AllMonths.Check(selectedMonth)) {
                            case utils.RangeCheckResult.InRangeLeftMost:
                                return { months: clampedMonths, days: baseDays.IntersectLeft(requestedValidDays), };
                            case utils.RangeCheckResult.InRangeRightMost:
                                return { months: clampedMonths, days: baseDays.IntersectRight(requestedValidDays), };
                            case utils.RangeCheckResult.InRangeBoth:
                                return { months: clampedMonths, days: baseDays.Intersect(requestedValidDays), };
                            default:
                                return { months: AllMonths, days: baseDays, };
                        }
                    }
                    return { months: AllMonths, days: baseDays, };
                }
                default:
                    return { months: AllMonths, days: baseDays, };
            }
        };
        Object.defineProperty(ControllerBase.prototype, "ValidYears", {
            get: function () {
                return this.RequestedValidYears;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "ValidMonths", {
            get: function () {
                return this.Effective.months;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "ValidDays", {
            get: function () {
                return this.Effective.days;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "Year", {
            get: function () {
                return this._year;
            },
            set: function (value) {
                if (this._year === value)
                    return;
                this._year = value;
                this.TriggerEffectiveRebuild();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "Month", {
            get: function () {
                return this._month;
            },
            set: function (value) {
                if (this._month === value)
                    return;
                this._month = value;
                this.TriggerEffectiveRebuild();
            },
            enumerable: true,
            configurable: true
        });
        ControllerBase.AllMonths = new utils.IntegerRange(1, 12, utils.RangeType.Inclusive);
        ControllerBase.AllDays = new utils.IntegerRange(1, 31, utils.RangeType.Inclusive);
        ControllerBase.DefaultRange = moment.duration(120, "year");
        return ControllerBase;
    }(utils.ControllerBase));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.NgModelOptions = {
                debounce: 100,
                allowInvalid: true,
                getterSetter: true,
            };
            _this.Attributes.$addClass(Name);
            _this.Watch.Collection(function () { return ({
                RequestedMin: _this.RequestedMin,
                RequestedMax: _this.RequestedMax,
                DateType: _this.DateType,
            }); }, function ($new, $old) { return _this.ApplyRange($new.RequestedMin, $new.RequestedMax, $new.DateType); });
            _this.Watch(function () { return _this.DateType; }, function ($new, $old) { return $new !== $old && _this.UpdateViewValue(); });
            return _this;
        }
        Controller_4 = Controller;
        Controller.prototype.PadPrepend = function (value, padding, length) {
            if (padding === void 0) { padding = "0"; }
            if (length === void 0) { length = 2; }
            var valueText = String(value);
            if (valueText.length >= 2)
                return valueText;
            var remaining = length - valueText.length;
            if (remaining % padding.length === 0)
                return padding.repeat(remaining / padding.length) + valueText;
            else
                return padding.repeat(remaining / padding.length) + padding.substr(0, remaining % padding.length) + valueText;
        };
        Object.defineProperty(Controller.prototype, "RequestedMin", {
            get: function () {
                var boundMin = this.BoundMin({ $now: this.InitMoment, $yesterday: this.Yesterday, $tomorrow: this.Tomorrow });
                var newMin = utils.IsVoid(boundMin) ? boundMin : moment(boundMin);
                if (utils.IsVoid(newMin) || utils.IsVoid(this.LastRequestedMin) || !this.LastRequestedMin.isSame(newMin))
                    this.LastRequestedMin = newMin;
                return this.LastRequestedMin;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "RequestedMax", {
            get: function () {
                var boundMax = this.BoundMax({ $now: this.InitMoment, $yesterday: this.Yesterday, $tomorrow: this.Tomorrow });
                var newMax = utils.IsVoid(boundMax) ? boundMax : moment(boundMax);
                if (utils.IsVoid(newMax) || utils.IsVoid(this.LastRequestedMax) || !this.LastRequestedMax.isSame(newMax))
                    this.LastRequestedMax = newMax;
                return this.LastRequestedMax;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "DateType", {
            get: function () {
                var fixedDay = RelativePoint.Sanitise(this.BoundFixedDay);
                if (utils.IsVoid(this.cachedDateType) || fixedDay !== this.cachedDateType.BoundFixedDay) {
                    if (fixedDay) {
                        this.cachedDateType = Object.freeze({
                            BoundFixedDay: fixedDay,
                            DateType: new DateType("month", fixedDay),
                        });
                    }
                    else {
                        this.cachedDateType = Object.freeze({
                            BoundFixedDay: fixedDay,
                            DateType: new DateType("day", RelativePoint.Start),
                        });
                    }
                }
                return this.cachedDateType.DateType;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "MonthType", {
            get: function () {
                return MonthType.Sanitise(this.BoundMonthType, this.DateType.Unit === "day" ? MonthType.Full : MonthType.Numeric);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.UpdateFromController = function (value) {
            if (moment.isDate(value))
                value = moment(value);
            if (utils.IsSpecified(value) && !moment.isMoment(value))
                return this.UpdateFromController(void undefined);
            if (utils.IsSpecified(value)) {
                this.Year = value.year();
                this.Month = value.month() + 1;
                this.Day = value.date();
            }
            else {
                this.Year = undefined;
                this.Month = undefined;
                this.Day = undefined;
            }
        };
        Object.defineProperty(Controller.prototype, "ShowLabels", {
            get: function () {
                return !this.ContainerController || !this.ContainerController.label;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Style", {
            get: function () {
                if (this.ShowLabels)
                    return undefined;
                return Controller_4.HideLabels;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsReadonly", {
            get: function () {
                return utils.IsSpecified(this.Attributes["readonly"]) && this.Attributes["readonly"] !== true;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsDisabled", {
            get: function () {
                return utils.IsSpecified(this.Attributes["disabled"]) && this.Attributes["disabled"] !== false;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.GetSetViewDay = function (value) {
            if (!arguments.length)
                return this.Day;
            this.Day = value;
            this.UpdateViewValue();
        };
        Controller.prototype.ClampDay = function (applyClamp) {
            if (applyClamp === void 0) { applyClamp = true; }
            if (!applyClamp)
                return;
            var result = this.ValidDays.Check(this.Day);
            var isInRange = utils.HasFlag(result, utils.RangeCheckResult.InRange);
            switch (result) {
                case utils.RangeCheckResult.OutsideLeft:
                    this.Day = this.ValidDays.InsideLeftEdge;
                    break;
                case utils.RangeCheckResult.OutsideRight:
                    this.Day = this.ValidDays.InsideRightEdge;
                    break;
            }
        };
        Controller.prototype.GetSetViewMonth = function (value) {
            if (!arguments.length)
                return this.Month;
            var wasInRange = utils.HasFlag(this.ValidDays.Check(this.Day), utils.RangeCheckResult.InRange);
            this.Month = value;
            this.ClampDay(wasInRange);
            this.UpdateViewValue();
        };
        Controller.prototype.ClampMonth = function (applyMonthClamp, applyDayClamp) {
            if (applyMonthClamp === void 0) { applyMonthClamp = true; }
            if (applyDayClamp === void 0) { applyDayClamp = true; }
            if (!applyMonthClamp)
                return;
            var result = this.ValidMonths.Check(this.Month);
            var isInRange = utils.HasFlag(result, utils.RangeCheckResult.InRange);
            var newMonth;
            switch (result) {
                case utils.RangeCheckResult.OutsideLeft:
                    newMonth = this.ValidMonths.InsideLeftEdge;
                    break;
                case utils.RangeCheckResult.OutsideRight:
                    newMonth = this.ValidMonths.InsideRightEdge;
                    break;
                default:
                    this.ClampDay(applyDayClamp);
                    return;
            }
            this.Month = newMonth;
            this.ClampDay(applyDayClamp);
        };
        Controller.prototype.GetSetViewYear = function (value) {
            if (!arguments.length)
                return this.Year;
            var wasMonthsInRange = utils.HasFlag(this.ValidMonths.Check(this.Month), utils.RangeCheckResult.InRange);
            var wasDaysInRange = utils.HasFlag(this.ValidDays.Check(this.Day), utils.RangeCheckResult.InRange);
            this.Year = value;
            this.ClampMonth(wasMonthsInRange, wasDaysInRange);
            this.UpdateViewValue();
        };
        Object.defineProperty(Controller.prototype, "ViewDays", {
            get: function () {
                var all = this.ValidDays && this.ValidDays.All;
                if (!utils.IsSpecified(this.Day))
                    return all;
                if (all.indexOf(this.Day) >= 0)
                    return all;
                return __spread([this.Day], all);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ViewMonths", {
            get: function () {
                var all = this.ValidMonths && this.ValidMonths.All;
                if (!utils.IsSpecified(this.Month))
                    return all;
                if (all.indexOf(this.Month) >= 0)
                    return all;
                return __spread([this.Month], all);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ViewYears", {
            get: function () {
                var all = this.ValidYears && this.ValidYears.All;
                if (!utils.IsSpecified(this.Year))
                    return all;
                if (all.indexOf(this.Year) >= 0)
                    return all;
                return __spread([this.Year], all);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.MonthLabel = function (month) {
            switch (this.MonthType) {
                case MonthType.Numeric:
                    return this.PadPrepend(month, "0", 2);
                case MonthType.Short:
                    return moment.monthsShort(month - 1);
                default:
                    return moment.months(month - 1);
            }
        };
        Controller.prototype.UpdateViewValue = function () {
            var _this = this;
            var thisUpdate = this.PendingUpdate = ng_utils_5.$timeout().then(function () {
                if (thisUpdate !== _this.PendingUpdate)
                    return;
                _this._UpdateViewValue();
            });
        };
        Controller.prototype._UpdateViewValue = function () {
            var _a = this, ModelController = _a.ModelController, Year = _a.Year, Month = _a.Month, Day = _a.Day, DateType = _a.DateType;
            if (!ModelController)
                return;
            ModelController.$setDirty();
            ModelController.$setTouched();
            if (!utils.IsSpecified(Year) || !utils.IsSpecified(Month))
                return ModelController.$setViewValue(void undefined);
            if (!Controller_4.AllMonths.InRange(Month))
                return ModelController.$setViewValue(void undefined);
            var outDate = moment().year(Year).month(Month - 1);
            if (DateType.Unit === "day") {
                if (utils.IsVoid(Day)) {
                    ModelController.$setViewValue(void undefined);
                    return;
                }
                if (!Controller_4.DaysInMonth(Year, Month).InRange(Day)) {
                    ModelController.$setViewValue(void undefined);
                    return;
                }
                outDate.date(Day);
            }
            switch (DateType.Alignment) {
                case RelativePoint.Start:
                    outDate.startOf(DateType.Unit);
                    break;
                case RelativePoint.End:
                    outDate.endOf(DateType.Unit);
                    break;
                default:
                    return ModelController.$setViewValue(void undefined);
            }
            ModelController.$setViewValue(outDate);
        };
        Controller.prototype.BindToControllers = function () {
            var _this = this;
            var _a = this, ContainerController = _a.ContainerController, ModelController = _a.ModelController;
            ModelController.$parsers.push(function (viewValue) { return moment.isMoment(viewValue) ? viewValue.toDate() : viewValue; });
            ModelController.$formatters.push(function (modelValue) { return moment(modelValue); });
            ModelController.$validators["min"] = function (modelValue, viewValue) {
                if (ModelController.$isEmpty(viewValue))
                    return true;
                if (utils.IsVoid(_this.SpecifiedMin))
                    return true;
                return _this.SpecifiedMin.isSameOrBefore(viewValue);
            };
            ModelController.$validators["max"] = function (modelValue, viewValue) {
                if (ModelController.$isEmpty(viewValue))
                    return true;
                if (utils.IsVoid(_this.SpecifiedMax))
                    return true;
                return _this.SpecifiedMax.isSameOrAfter(viewValue);
            };
            ModelController.$render = function () {
                _this.PendingUpdate = null;
                var viewValue = ModelController.$viewValue;
                var fixedViewValue = _this.DateType.Clamp(viewValue);
                if (!moment(fixedViewValue).isSame(viewValue)) {
                    ModelController.$setViewValue(fixedViewValue, "clamp");
                    _this.UpdateFromController(fixedViewValue);
                    return;
                }
                _this.UpdateFromController(fixedViewValue);
            };
            var lastDateType = this.DateType;
            this.Watch.Group({
                SpecifiedMin: function () { return _this.SpecifiedMin; },
                SpecifiedMax: function () { return _this.SpecifiedMax; },
                DateType: function () { return _this.DateType; },
            }, function ($new) {
                if ($new.DateType !== lastDateType) {
                    var viewValue = ModelController.$viewValue;
                    var fixedViewValue = _this.DateType.Clamp(viewValue);
                    if (!moment(fixedViewValue).isSame(viewValue)) {
                        ModelController.$setViewValue(fixedViewValue, "clamp");
                        _this.UpdateFromController(fixedViewValue);
                        return;
                    }
                }
                lastDateType = $new.DateType;
                ModelController.$validate();
            });
            Controller_4.BindToContainer(ContainerController, ModelController, this.FormController, this.Attributes, this.Element, this.Watch);
        };
        Controller.BindToContainer = function (containerCtrl, ngModel, formCtrl, $attrs, $element, $watch) {
            function getIsReadonly() {
                return utils.IsSpecified($attrs["readonly"]);
            }
            var isReadonly = utils.IsSpecified($attrs["readonly"]);
            ngModel = ngModel || ng_utils_5.$mdUtil.fakeNgModel();
            if (!containerCtrl)
                return function () { };
            if (containerCtrl.input)
                throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <select> child element!");
            containerCtrl.input = $element;
            if (!$element.attr("id"))
                $element.attr("id", "input_" + ng_utils_5.$mdUtil.nextUid());
            function ngModelPipelineCheckValue(value) {
                containerCtrl.setHasValue(!ngModel.$isEmpty(value));
                return value;
            }
            function inputCheckValue() {
                containerCtrl.setHasValue(($element.val() || []).length > 0 || ($element[0]["validity"] || {}).badInput);
            }
            var isErrorGetter = containerCtrl.isErrorGetter || defaultIsErrorGetter;
            $watch(isErrorGetter, containerCtrl.setInvalid);
            ngModel.$parsers.push(ngModelPipelineCheckValue);
            ngModel.$formatters.push(ngModelPipelineCheckValue);
            $element.on("input", inputCheckValue);
            function focusHandler() {
                containerCtrl.setFocused(true);
            }
            function blurHandler() {
                containerCtrl.setFocused(false);
                inputCheckValue();
            }
            ;
            function applyHandlers(isReadonly) {
                $element.off("focus", focusHandler);
                $element.off("blur", blurHandler);
                if (!isReadonly) {
                    $element.on("focus", focusHandler);
                    $element.on("blur", blurHandler);
                }
            }
            function defaultIsErrorGetter() {
                return ngModel.$invalid && (ngModel.$touched || (!utils.IsVoid(formCtrl) && formCtrl.$submitted));
            }
            applyHandlers(getIsReadonly());
            $watch(getIsReadonly, applyHandlers);
            return destroy;
            function destroy() {
                containerCtrl.setFocused(false);
                containerCtrl.setHasValue(false);
                containerCtrl.input = null;
            }
        };
        Controller.HideLabels = Object.freeze({ "margin": 0 });
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "ModelController", void 0);
        __decorate([
            utils.Bind.Getter("min")
        ], Controller.prototype, "BoundMin", void 0);
        __decorate([
            utils.Bind.Getter("max")
        ], Controller.prototype, "BoundMax", void 0);
        __decorate([
            utils.Bind.Literal("fixed-day", { optional: true })
        ], Controller.prototype, "BoundFixedDay", void 0);
        __decorate([
            utils.Bind.Literal("month-type", { optional: true })
        ], Controller.prototype, "BoundMonthType", void 0);
        __decorate([
            utils.Bind.Controller("md-input-container", { mode: utils.Bind.Controller.Mode.Parents, optional: true })
        ], Controller.prototype, "ContainerController", void 0);
        __decorate([
            utils.Bind.Controller("form", { mode: utils.Bind.Controller.Mode.Parents, optional: true })
        ], Controller.prototype, "FormController", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "BindToControllers", null);
        Controller = Controller_4 = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
        var Controller_4;
    }(ControllerBase));
    exports.Controller = Controller;
});
define("app/sdc/delete/sdc-delete", ["require", "exports", "app/sdc/crud/sdc-crud"], function (require, exports, Crud) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    Crud.SubComponent("sdc-delete");
});
define("app/sdc/dynamic/sdc-dynamic", ["require", "exports", "scripts/lib/select-development/sss-decorators", "app/utils", "scripts/lib/select-development/sss-names", "scripts/lib/select-development/sss-bind-definitions", "app/ng-utils"], function (require, exports, decorators, utils, sssNames, bind, ng_utils_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AltScopeName = "__sdc-dynamic-controller";
    var AttributeDefinition = (function () {
        function AttributeDefinition(CollectionName, RawKey) {
            this.CollectionName = CollectionName;
            this.RawKey = RawKey;
            this.Expression = utils.FormatJson(templateObject_22 || (templateObject_22 = __makeTemplateObject(["this[", "][", "][", "]"], ["this[", "][", "][", "]"])), AltScopeName, CollectionName, RawKey);
            var regexResult = /(?:^{\[)(.*)(?:\]}$)/.exec(RawKey);
            if (!regexResult) {
                this.AsLiteral = false;
                this.AttrName = sssNames.ComponentNameSnakeCase(RawKey);
            }
            else {
                this.AsLiteral = true;
                this.AttrName = sssNames.ComponentNameSnakeCase(regexResult[1]);
            }
        }
        AttributeDefinition.prototype.ToAttributeDefinition = function () {
            return {
                Name: this.AttrName,
                Value: this.AttrText,
            };
        };
        AttributeDefinition.prototype.toString = function () {
            return this.AttrText;
        };
        Object.defineProperty(AttributeDefinition.prototype, "AttrText", {
            get: function () {
                return this.AsLiteral ? "{{" + this.Expression + "}}" : this.Expression;
            },
            enumerable: true,
            configurable: true
        });
        return AttributeDefinition;
    }());
    var ControllerBase = (function () {
        function ControllerBase(_$attrs, _$element, $scope) {
            this._$attrs = _$attrs;
            this._$element = _$element;
            this._elementDefinition = {
                Tag: undefined,
                Attrs: [],
                ExtendAttrs: [],
                Controllers: {},
                ParentBoundTransclude: null,
                Template: null,
                Scope: null,
            };
            this.BindTo($scope);
            this._TagGetter = this.getGetter("tag");
            this._AttrsGetter = this.getGetter("attrs");
            this._ControllersGetter = this.getGetter("controllers");
            this._ExtendAttrsGetter = this.getGetter("extendAttrs");
            this._ParentBoundTranscludeGetter = this.getGetter(null, "ParentBoundTransclude", "parentBoundTransclude", "_ParentBoundTransclude");
            this._TemplateGetter = this.getGetter(null, "Template", "template", "_Template");
            this._ContentScopeGetter = this.getGetter(null, "Scope", "scope", "_ContentScope");
        }
        Object.defineProperty(ControllerBase.prototype, "Tag", {
            get: function () {
                return this._TagGetter ? this._TagGetter() : undefined;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "Attrs", {
            get: function () {
                return (this._AttrsGetter && this._AttrsGetter()) || {};
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "ExtendAttrs", {
            get: function () {
                return (this._ExtendAttrsGetter && this._ExtendAttrsGetter()) || {};
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "Controllers", {
            get: function () {
                return (this._ControllersGetter && this._ControllersGetter()) || {};
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "ParentBoundTransclude", {
            get: function () {
                return this._ParentBoundTranscludeGetter ? this._ParentBoundTranscludeGetter() : undefined;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "Template", {
            get: function () {
                return this._TemplateGetter ? this._TemplateGetter() : undefined;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "ContentScope", {
            get: function () {
                return this._ContentScopeGetter ? this._ContentScopeGetter() : undefined;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControllerBase.prototype, "ElementDefinition", {
            get: function () {
                if (this.Tag !== this._elementDefinition.Tag)
                    this.RebuildTag();
                if (!ControllerBase.CollectionEquals(this.Attrs, this._PreviousAttrs))
                    this.RebuildAttrs();
                if (!ControllerBase.CollectionEquals(this.ExtendAttrs, this._PreviousExtendAttrs))
                    this.RebuildExtendAttrs();
                if (!ControllerBase.CollectionEquals(this.Controllers, this._PreviousControllers, function (a, b) { return a === b; }))
                    this.RebuildControllers();
                if (this.ParentBoundTransclude !== this._elementDefinition.ParentBoundTransclude)
                    this.RebuildParentBoundTransclude();
                if (this.Template !== this._PreviousTemplate)
                    this.RebuildTemplate(this.Template);
                if (this.ContentScope !== this._PreviousContentScope)
                    this.RebuildScope(this.ContentScope);
                return this._elementDefinition;
            },
            enumerable: true,
            configurable: true
        });
        ControllerBase.CollectionEquals = function (a, b, itemEquality) {
            if (a === b || !a && !b)
                return true;
            var aKeys = a ? Object.keys(a) : [];
            var bKeys = b ? Object.keys(b) : [];
            if (aKeys.length !== bKeys.length)
                return false;
            for (var aIndex = 0; aIndex < aKeys.length; aIndex++) {
                var bIndex = bKeys.indexOf(aKeys[aIndex]);
                if (bIndex < 0)
                    return false;
                if (itemEquality && !itemEquality(a[aKeys[aIndex]], b[bKeys[bIndex]]))
                    return false;
            }
            return true;
        };
        ControllerBase.prototype.RebuildTag = function () {
            var newDefinition = this.CloneElementDefinition();
            newDefinition.Tag = this.Tag;
            return this._elementDefinition = newDefinition;
        };
        ControllerBase.prototype.BuildExpressionMap = function (collectionName) {
            this["_Previous" + collectionName] = utils.ShallowCopy(this[collectionName]);
            return Object.keys(this[collectionName]).map(function (key) { return new AttributeDefinition(collectionName, key); });
        };
        ControllerBase.prototype.RebuildAttrs = function () {
            var newDefinition = this.CloneElementDefinition();
            newDefinition.Attrs = this.BuildExpressionMap("Attrs");
            return this._elementDefinition = newDefinition;
        };
        ControllerBase.prototype.RebuildExtendAttrs = function () {
            var newDefinition = this.CloneElementDefinition();
            newDefinition.ExtendAttrs = this.BuildExpressionMap("ExtendAttrs");
            return this._elementDefinition = newDefinition;
        };
        ControllerBase.prototype.RebuildControllers = function () {
            var newDefinition = this.CloneElementDefinition();
            newDefinition.Controllers = utils.ShallowCopy(this.Controllers);
            return this._elementDefinition = newDefinition;
        };
        ControllerBase.prototype.RebuildParentBoundTransclude = function () {
            var newDefinition = this.CloneElementDefinition();
            newDefinition.ParentBoundTransclude = this.ParentBoundTransclude;
            return this._elementDefinition = newDefinition;
        };
        ControllerBase.prototype.RebuildTemplate = function (template) {
            var newDefinition = this.CloneElementDefinition();
            this._PreviousTemplate = template;
            if (utils.IsVoid(template))
                newDefinition.Template = template;
            else if (!utils.IsString(template))
                newDefinition.Template = template.clone(false, false);
            else
                newDefinition.Template = this._$element.clone(false, false).html(template).contents();
            return this._elementDefinition = newDefinition;
        };
        ControllerBase.prototype.RebuildScope = function (contentScope) {
            var newDefinition = this.CloneElementDefinition();
            this._PreviousContentScope = contentScope;
            if (!contentScope)
                newDefinition.Scope = contentScope;
            else
                newDefinition.Scope = contentScope.$new();
            return this._elementDefinition = newDefinition;
        };
        ControllerBase.prototype.CloneElementDefinition = function () {
            return {
                Tag: this._elementDefinition.Tag,
                Attrs: this._elementDefinition.Attrs,
                ExtendAttrs: this._elementDefinition.ExtendAttrs,
                Controllers: this._elementDefinition.Controllers,
                ParentBoundTransclude: this._elementDefinition.ParentBoundTransclude,
                Template: this._elementDefinition.Template,
                Scope: this._elementDefinition.Scope,
            };
        };
        ControllerBase.prototype.getGetter = function (name, componentField, attrName, attrField) {
            var _this = this;
            if (componentField === void 0) { componentField = (name.substr(0, 1).toLowerCase() + name.substr(1)); }
            if (attrName === void 0) { attrName = componentField; }
            if (attrField === void 0) { attrField = "_" + attrName; }
            if (angular.isDefined(this._$attrs[attrName.toString()])) {
                return function () { return _this[attrField.toString()]; };
            }
            else if (angular.isDefined(this._$attrs["sdcDynamic"])) {
                return function () {
                    var component = _this.ComponentGetter();
                    return component ? component[componentField.toString()] : undefined;
                };
            }
            else {
                return function () { return undefined; };
            }
        };
        ControllerBase.prototype.BindTo = function ($scope) {
            $scope[AltScopeName] = this;
        };
        ControllerBase = __decorate([
            __param(0, utils.Inject("$attrs")), __param(1, utils.Inject($element)), __param(2, utils.Inject($scope))
        ], ControllerBase);
        return ControllerBase;
    }());
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller($scope, $element, $transclude, $attrs, $watch) {
            var _this = _super.call(this, $attrs, $element, $scope) || this;
            _this.$scope = $scope;
            _this.$element = $element;
            _this.$transclude = $transclude;
            _this.$attrs = $attrs;
            _this.$watch = $watch;
            _this.first = true;
            $scope.$on("$destroy", function () { return _this.destroyed = true; });
            $watch(function () { return _this.ElementDefinition; }, function (def) { return _this.SwitchElement(def); });
            return _this;
        }
        Controller_5 = Controller;
        Controller.prototype.ComponentGetter = function () {
            return this._component;
        };
        Controller.prototype.RenderElement = function (element, scope, controllers, parentBoundTransclude, animate) {
            if (this.destroyed || element !== this.childElement) {
                return;
            }
            if (!element)
                return;
            if (animate)
                ng_utils_6.$animate.enter(element, this.$element);
            else
                this.$element.append(element);
            ng_utils_6.$compile(element)(scope, undefined, {
                transcludeControllers: angular.map(controllers, function (c) { return ({ instance: c }); }),
                parentBoundTranscludeFn: parentBoundTransclude || this.$transclude,
            });
        };
        Controller.prototype.SwitchElement = function (elementDefinition) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var first, removeElement_1, Tag, Template, Scope, Attrs, ExtendAttrs, Controllers, ParentBoundTransclude, allAttrs, scope, content, newElement, dependenciesPromse, err_10;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            first = this.first;
                            this.first = false;
                            if (this.childElement) {
                                removeElement_1 = this.childElement;
                                ng_utils_6.$animate.leave(removeElement_1).then(function () { return removeElement_1.remove(); });
                            }
                            Tag = elementDefinition.Tag, Template = elementDefinition.Template, Scope = elementDefinition.Scope, Attrs = elementDefinition.Attrs, ExtendAttrs = elementDefinition.ExtendAttrs, Controllers = elementDefinition.Controllers, ParentBoundTransclude = elementDefinition.ParentBoundTransclude;
                            allAttrs = Attrs.concat(ExtendAttrs);
                            scope = (Scope || this.$scope).$new();
                            if (Tag) {
                                content = utils.Element.CreateElement(Tag);
                                utils.Element.ApplyAttributes(content, allAttrs.map(function (a) { return a.ToAttributeDefinition(); }));
                            }
                            else if (Template) {
                                content = Template.clone(true, true);
                                utils.Element.ApplyAttributes(content, allAttrs.map(function (a) { return a.ToAttributeDefinition(); }));
                                this.BindTo(scope);
                            }
                            this.childElement = content;
                            if (!content)
                                return [2];
                            newElement = content;
                            dependenciesPromse = utils.Element.RequireDependencies.IfNeeded(content);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, , 6]);
                            if (!utils.IsVoid(dependenciesPromse)) return [3, 2];
                            this.RenderElement(newElement, scope, Controllers, ParentBoundTransclude, !first);
                            return [3, 4];
                        case 2: return [4, dependenciesPromse];
                        case 3:
                            _a.sent();
                            Controller_5.BatchedAsyncRender.DelayedInvoke(function () { return _this.RenderElement(newElement, scope, Controllers, ParentBoundTransclude, !first); });
                            _a.label = 4;
                        case 4: return [3, 6];
                        case 5:
                            err_10 = _a.sent();
                            ng_utils_6.$exceptionHandler(err_10);
                            throw err_10;
                        case 6: return [2];
                    }
                });
            });
        };
        Controller.BatchedAsyncRender = new utils.BatchedInvoker(10);
        __decorate([
            utils.Bind.In("sdc-dynamic", { optional: true })
        ], Controller.prototype, "_component", void 0);
        __decorate([
            utils.Bind.In("tag", { optional: true })
        ], Controller.prototype, "_tag", void 0);
        __decorate([
            utils.Bind.In("attrs", { optional: true })
        ], Controller.prototype, "_attrs", void 0);
        __decorate([
            utils.Bind.In("controllers", { optional: true })
        ], Controller.prototype, "_controllers", void 0);
        __decorate([
            utils.Bind.In("extend-attrs", { optional: true })
        ], Controller.prototype, "_extendAttrs", void 0);
        __decorate([
            utils.Bind.In("parent-bound-transclude")
        ], Controller.prototype, "_ParentBoundTransclude", void 0);
        __decorate([
            utils.Bind.In("template")
        ], Controller.prototype, "_Template", void 0);
        __decorate([
            utils.Bind.In("scope")
        ], Controller.prototype, "_ContentScope", void 0);
        Controller = Controller_5 = __decorate([
            utils.Component({
                Name: "sdc-dynamic",
                Transclude: utils.TransclusionMode.Contents,
                Restrict: utils.Target.ElementOrAttribute,
                Template: null,
            }),
            __param(0, utils.Inject("$scope")),
            __param(1, utils.Inject("$element")),
            __param(2, utils.Inject("$transclude")),
            __param(3, utils.Inject("$attrs")),
            __param(4, utils.Inject("$watch"))
        ], Controller);
        return Controller;
        var Controller_5;
    }(ControllerBase));
    exports.Controller = Controller;
    function CreateComponent(directive, values) {
        var bindings = decorators.GetBindings(directive.prototype);
        var tagName = sssNames.CamelCase(utils.GetComponentName(directive));
        var attrs = {};
        angular.forEach(values, function (value, propertyName) {
            var bindDefinition = bindings.get(propertyName);
            if (bindDefinition instanceof bind.Attribute.InvokableExpressionBindDefinition)
                throw new Error("& is not supported for component thing in sdc-dynamic");
            var attrName = sssNames.ComponentNameSnakeCase(bindDefinition.AttributeName);
            if (bindDefinition instanceof bind.Attribute.LiteralBindDefinition)
                attrName = "{{" + attrName + "}}";
            attrs[attrName] = value;
        });
        return {
            tag: tagName,
            attrs: attrs
        };
    }
    exports.CreateComponent = CreateComponent;
    var templateObject_22;
});
define("app/sdc/focus/sdc-focus", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_5.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.FocusHandler = new ElementFocusHandler(_this.Element);
            _this.OnDispose(function () { return _this.FocusHandler = null; });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "IsFocused", {
            get: function () {
                if (utils.IsVoid(this._ActualIsFocused))
                    this._ActualIsFocused = this.FocusHandler ? this.FocusHandler.IsFocused : false;
                return this._ActualIsFocused;
            },
            set: function (value) {
                this._RequestedIsFocused = value;
                if (utils.IsVoid(value))
                    return;
                if (!this.FocusHandler)
                    return;
                this.FocusHandler.IsFocused = !!value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "FocusHandler", {
            get: function () {
                if (utils.IsVoid(this._focusHandler))
                    return this._focusHandler;
                return this._focusHandler.Handler;
            },
            set: function (value) {
                var _this = this;
                if (this._focusHandler)
                    this._focusHandler.Unbind();
                if (!value) {
                    this._focusHandler = null;
                    return;
                }
                this._focusHandler = Object.freeze({
                    Handler: value,
                    Unbind: value.BindOnFocusChange(function (isFocused) { return _this.Scope.$applyAsync(function () { return _this._ActualIsFocused = isFocused; }); }),
                });
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.TwoWay(utils.SnakeCase(Name))
        ], Controller.prototype, "IsFocused", null);
        Controller = __decorate([
            utils.Component({
                Name: Name,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    var ElementFocusHandler = (function () {
        function ElementFocusHandler(TargetElement) {
            this.TargetElement = TargetElement;
        }
        Object.defineProperty(ElementFocusHandler.prototype, "IsFocused", {
            get: function () {
                return this.TargetElement.is(document.activeElement);
            },
            set: function (value) {
                if (value)
                    this.TargetElement.focus();
                else
                    this.TargetElement.blur();
            },
            enumerable: true,
            configurable: true
        });
        ElementFocusHandler.prototype.BindOnFocusChange = function (handler) {
            var _this = this;
            var events = Object.freeze({
                "focusin": function () { return handler(true); },
                "focusout": function () { return handler(false); },
            });
            this.TargetElement.on(events);
            return function () { return _this.TargetElement.off(events); };
        };
        return ElementFocusHandler;
    }());
    exports.ElementFocusHandler = ElementFocusHandler;
});
define("app/sdc/if/sdc-if", ["require", "exports", "$animate"], function (require, exports, $animate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function Create(element, transcludeFn, options) {
        if (options === void 0) { options = {}; }
        var block;
        var childScope;
        var previousElements;
        return ifFn;
        function ifFn(display) {
            if (display)
                show();
            else
                hide();
        }
        function show() {
            if (childScope)
                return;
            transcludeFn(function (clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = document.createComment(' end sdcIf ');
                block = {
                    clone: clone
                };
                var promise = $animate.enter(clone, null, element, options.animationOptions);
                if (angular.isFunction(options.onTransclude)) {
                    options.onTransclude(clone, newScope, promise);
                }
            });
        }
        function hide() {
            if (previousElements) {
                previousElements.remove();
                previousElements = null;
            }
            if (childScope) {
                childScope.$destroy();
                childScope = null;
            }
            if (block) {
                var thisPreviousElements_1 = previousElements = block.clone.getBlockNodes();
                $animate.leave(previousElements).then(function () {
                    if (thisPreviousElements_1 !== previousElements)
                        return;
                    previousElements = null;
                });
                block = null;
            }
        }
    }
    exports.Create = Create;
    ;
});
define("app/sdc/if/sdc-if-service", ["require", "exports", "app/sdc/if/sdc-if"], function (require, exports, ifService) {
    "use strict";
    function Factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var element;
        var transcludeFn;
        var options;
        switch (arguments.length) {
            case 1:
                options = args[0];
                break;
            case 2:
                if (angular.isFunction(args[1])) {
                    element = args[0];
                    transcludeFn = args[1];
                }
                else {
                    element = args[0];
                    options = args[1];
                }
                break;
            case 3:
                if (angular.isFunction(args[0])) {
                    element = args[1];
                    transcludeFn = args[0];
                    options = args[2];
                }
                else {
                    element = args[0];
                    transcludeFn = args[1];
                    options = args[2];
                }
                break;
        }
        options = options || angular.empty;
        element = element || options.$element || options.iElement || options.element;
        transcludeFn = transcludeFn || options.$transclude || options.transcludeFn || options.transclude || angular.noop;
        return ifService.Create(element, transcludeFn, options);
    }
    return Factory;
});
define("app/sdc/is/loading/sdc-is-loading", ["require", "exports", "app/utils", "module", "template!sdc-loading", "app/ng-utils"], function (require, exports, utils, module_6, sdcLoadingTemplate, ng_utils_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_6.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.LoadingSpinner = new LoadingSpinner.Bound(_this.Element, _this.Scope, function () { return _this.Indeterminate; }, function () { return _this.Progress; });
            _this.Watch(function () { return _this.IsLoading; }, function (value) { return _this.LoadingSpinner.IsLoading = value; });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "Indeterminate", {
            get: function () {
                return utils.IsVoid(this.Progress);
            },
            enumerable: true,
            configurable: true
        });
        ;
        Object.defineProperty(Controller.prototype, "IsLoading", {
            get: function () {
                var isLoading = this.BoundIsLoading;
                if (!utils.IsObject(isLoading))
                    return !!isLoading;
                if (isLoading instanceof utils.ActivityController)
                    return isLoading.IsActive;
                else if (utils.ActivityController.IsToken(isLoading))
                    return isLoading.HasExited;
                return !!isLoading;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.In(name)
        ], Controller.prototype, "BoundIsLoading", void 0);
        __decorate([
            utils.Bind.In("loading-progress", { optional: true })
        ], Controller.prototype, "Progress", void 0);
        Controller = __decorate([
            utils.Component({
                Name: name,
                Scope: utils.ScopeMode.ParentScope,
                Priority: 1,
                Restrict: utils.Target.Attribute,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    var LoadingSpinner = (function () {
        function LoadingSpinner(TargetElement, TargetScope) {
            var _this = this;
            this.TargetElement = TargetElement;
            this.TargetScope = TargetScope;
            this.Id = LoadingSpinner.NextId++;
            this.ActivityController = new utils.ActivityController("LoadingSpinner: " + this.Id);
            this._isDisconnected = false;
            this.disposed = false;
            TargetElement.addClass("sdc-loading");
            var unwatch = this.TargetScope.$root.$watch(function () { return LoadingSpinner.GetIsDisconnected(_this.TargetScope); }, function (value) { return _this.IsDisconnected = value; });
            this.OnDestroy(unwatch);
            this.OnDestroy(function () { return _this.Dispose(); });
        }
        LoadingSpinner.prototype.CreateSpinner = function () {
            var _this = this;
            var scope = this.TargetScope.$new();
            scope["vm"] = this;
            var baseCompileNodes = LoadingSpinner.BaseTemplate.clone();
            var compileNodes;
            if (!this.TargetElement.is("table, tbody, tfoot, thead, tr"))
                compileNodes = baseCompileNodes;
            else {
                switch (this.TargetElement.prop("tagName").toLowerCase()) {
                    case "table":
                        compileNodes = angular.element(document.createElement("tbody")).append(angular.element(document.createElement("tr")).append(angular.element(document.createElement("td")).append(baseCompileNodes)));
                        break;
                    case "tbody":
                    case "tfoot":
                    case "thead":
                        compileNodes = angular.element(document.createElement("tr")).append(angular.element(document.createElement("td")).append(baseCompileNodes));
                        break;
                    case "tr":
                        compileNodes = angular.element(document.createElement("td")).append(baseCompileNodes);
                        break;
                }
                baseCompileNodes.addClass("sdc-loading-table-injector");
            }
            var element = ng_utils_7.$compile(sdcLoadingTemplate)(scope, function (clone) { return _this.TargetElement.append(clone); });
            return { Element: element, Scope: scope, };
        };
        Object.defineProperty(LoadingSpinner.prototype, "IsLoading", {
            get: function () {
                return !!this._isLoading;
            },
            set: function (value) {
                var lastValue = this._isLoading;
                value = this._isLoading = !!value;
                if (value === !!lastValue)
                    return;
                if (value)
                    this.ShowSpinner(utils.IsVoid(lastValue));
                else
                    this.HideSpinner(utils.IsVoid(lastValue));
            },
            enumerable: true,
            configurable: true
        });
        LoadingSpinner.prototype.ShowSpinner = function (fast) {
            if (fast === void 0) { fast = false; }
            return __awaiter(this, void 0, ng_utils_7.$q, function () {
                var token, spinner;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.disposed)
                                return [2];
                            if (this.IsDisconnected)
                                return [2];
                            token = this.ActivityController.CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 4, 5]);
                            if (fast)
                                this.TargetElement.addClass(LoadingSpinner.IsLoadingClass);
                            spinner = this.Spinner || this.CreateSpinner();
                            this.Spinner = spinner;
                            if (!!fast) return [3, 3];
                            return [4, ng_utils_7.$animate.addClass(this.TargetElement, LoadingSpinner.IsLoadingClass)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        LoadingSpinner.prototype.HideSpinner = function (fast) {
            if (fast === void 0) { fast = false; }
            return __awaiter(this, void 0, ng_utils_7.$q, function () {
                var token, targetSpinner;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.disposed)
                                return [2];
                            token = this.ActivityController.CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 5, 6]);
                            targetSpinner = this.Spinner;
                            if (!targetSpinner)
                                return [2];
                            if (!!fast) return [3, 3];
                            return [4, ng_utils_7.$animate.removeClass(this.TargetElement, LoadingSpinner.IsLoadingClass)];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            this.TargetElement.removeClass(LoadingSpinner.IsLoadingClass);
                            _a.label = 4;
                        case 4:
                            if (token.HasExited)
                                return [2];
                            if (targetSpinner === this.Spinner)
                                this.Spinner = null;
                            targetSpinner.Element.remove();
                            targetSpinner.Scope.$destroy();
                            return [3, 6];
                        case 5:
                            token.Exit();
                            return [7];
                        case 6: return [2];
                    }
                });
            });
        };
        Object.defineProperty(LoadingSpinner.prototype, "IsDisconnected", {
            get: function () {
                return this._isDisconnected;
            },
            set: function (value) {
                var lastValue = this._isDisconnected;
                this._isDisconnected = value;
                if (value) {
                    this.HideSpinner(true);
                }
                else {
                    if (value === lastValue)
                        return;
                    if (this._isLoading) {
                        this.ShowSpinner(true);
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        LoadingSpinner.GetIsDisconnected = function (scope) {
            if (utils.IsVoid(scope))
                return true;
            if (scope.$root === scope)
                return false;
            if (scope.$$disconnected)
                return true;
            else
                return LoadingSpinner.GetIsDisconnected(scope.$parent);
        };
        LoadingSpinner.prototype.OnDestroy = function (action) {
            this.TargetScope.$on("$destroy", action);
        };
        LoadingSpinner.prototype.Dispose = function () {
            console.log("Disposed", this.TargetElement);
            this.disposed = true;
            var spinner = this.Spinner;
            if (spinner) {
                spinner.Element.remove();
                spinner.Scope.$destroy();
            }
        };
        LoadingSpinner.NextId = 0;
        LoadingSpinner.IsLoadingClass = "sdc-is-loading";
        LoadingSpinner.BaseTemplate = $(sdcLoadingTemplate);
        return LoadingSpinner;
    }());
    exports.LoadingSpinner = LoadingSpinner;
    (function (LoadingSpinner) {
        var Bound = (function (_super) {
            __extends(Bound, _super);
            function Bound(TargetElement, TargetScope, getIndeterminate, getProgress) {
                var _this = _super.call(this, TargetElement, TargetScope) || this;
                _this.getIndeterminate = getIndeterminate;
                _this.getProgress = getProgress;
                return _this;
            }
            Object.defineProperty(Bound.prototype, "Progress", {
                get: function () {
                    return this.getProgress();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Bound.prototype, "Indeterminate", {
                get: function () {
                    return !!this.getIndeterminate();
                },
                enumerable: true,
                configurable: true
            });
            return Bound;
        }(LoadingSpinner));
        LoadingSpinner.Bound = Bound;
    })(LoadingSpinner = exports.LoadingSpinner || (exports.LoadingSpinner = {}));
    exports.LoadingSpinner = LoadingSpinner;
});
define("app/sdc/loading/sdc-loading", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "app/sdc/is/loading/sdc-is-loading"], function (require, exports, utils, ng_utils_8, service_2, sdc_is_loading_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-loading";
    var LoadingType;
    (function (LoadingType) {
        LoadingType[LoadingType["PromiseLike"] = 0] = "PromiseLike";
        LoadingType[LoadingType["PromiseCollection"] = 1] = "PromiseCollection";
        LoadingType[LoadingType["Progress"] = 2] = "Progress";
        LoadingType[LoadingType["State"] = 3] = "State";
    })(LoadingType = exports.LoadingType || (exports.LoadingType = {}));
    function SafeWatchFn(type, fn) {
        return watchFn;
        function watchFn($new, $old) {
            if (GetType($new) !== type)
                return;
            return fn($new, $old);
        }
    }
    function GetType(obj) {
        if (ng_utils_8.$q.isQ(obj))
            return LoadingType.PromiseLike;
        else if (obj instanceof service_2.Progress)
            return LoadingType.Progress;
        else if (angular.isObject(obj))
            return LoadingType.PromiseCollection;
        else
            return LoadingType.State;
    }
    exports.GetType = GetType;
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.LoadingSpinner = new sdc_is_loading_1.LoadingSpinner.Bound(_this.Element, _this.Scope, function () { return _this.Indeterminate; }, function () { return _this.Progress; });
            _this.Watch(function () { return _this.Type; }, function (newType) { return _this.StartWatch(newType); });
            _this.Watch(function () { return _this.IsLoading; }, function (newIsLoading) { return _this.UpdateClass(newIsLoading); });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "IsLoading", {
            get: function () {
                return this.isLoading;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Progress", {
            get: function () {
                return this.progress;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Unwatch = function () { };
        Object.defineProperty(Controller.prototype, "Indeterminate", {
            get: function () {
                return utils.IsNotSpecified(this.progress);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Type", {
            get: function () {
                return GetType(this.Loading);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.StartWatch = function (type) {
            var _this = this;
            this.Unwatch();
            switch (type) {
                case LoadingType.PromiseLike:
                    this.Unwatch = this.Watch(function () { return _this.Loading; }, SafeWatchFn(type, function ($new) { return _this.WatchSinglePromise($new); }));
                    break;
                case LoadingType.PromiseCollection:
                    this.Unwatch = this.Watch.Collection(function () { return _this.Loading; }, SafeWatchFn(type, function ($new) { return _this.WatchPromiseCollection($new); }));
                    break;
                case LoadingType.Progress:
                    this.Unwatch = this.Watch(function () { return _this.Loading; }, SafeWatchFn(type, function ($new) { return _this.WatchState($new ? $new.Progress : undefined); }));
                    break;
                default:
                    this.Unwatch = this.Watch(function () { return _this.Loading; }, SafeWatchFn(type, function ($new) { return _this.WatchState($new); }));
                    break;
            }
        };
        Controller.prototype.WatchPromise = function ($new) {
            var _this = this;
            this.progress = undefined;
            this.isLoading = true;
            var thisPromise = this.ActivePromise = ng_utils_8.$q.when($new).then(null, null, function (progress) {
                if (!_this.IsLastest(thisPromise))
                    return;
                _this.progress = service_2.Progress.Get(progress);
            }).finally(function () {
                if (!_this.IsLastest(thisPromise))
                    return;
                _this.progress = undefined;
                _this.isLoading = false;
            });
        };
        Controller.prototype.WatchSinglePromise = function ($new) {
            return this.WatchPromiseCollection([$new, ng_utils_8.$timeout(300)]);
        };
        Controller.prototype.WatchPromiseCollection = function ($new) {
            return this.WatchPromise(ng_utils_8.$q.all($new));
        };
        Controller.prototype.IsLastest = function (promise) {
            return promise === this.ActivePromise;
        };
        Controller.prototype.WatchState = function ($new) {
            this.ActivePromise = null;
            if (angular.isNumber($new) && !Number.isNaN($new)) {
                this.progress = service_2.Progress.Get($new);
                this.isLoading = true;
            }
            else {
                this.progress = undefined;
                this.isLoading = !!$new;
            }
        };
        Controller.prototype.UpdateClass = function (isLoading) {
            this.LoadingSpinner.IsLoading = isLoading;
        };
        __decorate([
            utils.Bind.TwoWay(exports.Name, { optional: true })
        ], Controller.prototype, "Loading", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Scope: utils.ScopeMode.ParentScope,
                Priority: 1,
                Restrict: utils.Target.Attribute,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sdc/matcher/sdc-matcher", ["require", "exports", "app/basic-utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function Create(matcherVal) {
        if (utils.IsString(matcherVal))
            return function (input) { return String(input) === matcherVal ? [input] : []; };
        else if (utils.IsArray(matcherVal))
            return CreateArrayMatcher(matcherVal);
        else if (matcherVal instanceof RegExp) {
            return matcherVal.global ? CreateGlobalRegexMatcher(matcherVal) : function (input) { return Unique(matcherVal.exec(input)); };
        }
        else {
            var matcherFn_1 = matcherVal;
            return function (input) { return Unique(matcherFn_1(input)); };
        }
    }
    exports.Create = Create;
    function CreateGlobalRegexMatcher(regex) {
        return regexGlobalMatcher;
        function regexGlobalMatcher(input) {
            var temp;
            var matches = [];
            while (temp = regex.exec(input)) {
                switch (temp.length) {
                    case 1:
                        matches.push.apply(matches, __spread(Unique(temp.slice(0, 1), matches)));
                        break;
                    default:
                        matches.push.apply(matches, __spread(Unique(temp.slice(1), matches)));
                        break;
                }
            }
            return matches;
        }
    }
    function CreateArrayMatcher(matchers) {
        var parsedMatchers = matchers.map(Create);
        return arrayMatcher;
        function arrayMatcher(input) {
            var matches = [];
            try {
                for (var parsedMatchers_1 = __values(parsedMatchers), parsedMatchers_1_1 = parsedMatchers_1.next(); !parsedMatchers_1_1.done; parsedMatchers_1_1 = parsedMatchers_1.next()) {
                    var matcher = parsedMatchers_1_1.value;
                    matches.push.apply(matches, __spread(Unique(matcher(input), matches)));
                }
            }
            catch (e_59_1) { e_59 = { error: e_59_1 }; }
            finally {
                try {
                    if (parsedMatchers_1_1 && !parsedMatchers_1_1.done && (_a = parsedMatchers_1.return)) _a.call(parsedMatchers_1);
                }
                finally { if (e_59) throw e_59.error; }
            }
            return matches;
            var e_59, _a;
        }
    }
    function Unique(source) {
        var referenceArrays = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            referenceArrays[_i - 1] = arguments[_i];
        }
        return source.filter(function (v, i) {
            if (source.indexOf(v) !== i)
                return false;
            try {
                for (var referenceArrays_1 = __values(referenceArrays), referenceArrays_1_1 = referenceArrays_1.next(); !referenceArrays_1_1.done; referenceArrays_1_1 = referenceArrays_1.next()) {
                    var referenceArray = referenceArrays_1_1.value;
                    if (referenceArray.indexOf(v) >= 0)
                        return false;
                }
            }
            catch (e_60_1) { e_60 = { error: e_60_1 }; }
            finally {
                try {
                    if (referenceArrays_1_1 && !referenceArrays_1_1.done && (_a = referenceArrays_1.return)) _a.call(referenceArrays_1);
                }
                finally { if (e_60) throw e_60.error; }
            }
            return true;
            var e_60, _a;
        });
    }
});
define("app/sdc/numeric/sdc-numeric", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller_6 = Controller;
        Controller.prototype.Init = function () {
            if (this.InputType === "number")
                throw new Error("Cannot apply " + Controller_6.Name + " on an <input type=\"number\" />.");
            this.Dispose();
            this.Parser = new Controller_6.Parser(this.ngModelController);
            this.Formatter = new Controller_6.Formatter(this.ngModelController);
        };
        Controller.prototype.Dispose = function () {
            if (this.Parser)
                this.Parser.Dispose();
            if (this.Formatter)
                this.Formatter.Dispose();
        };
        Controller.Name = "sdc-numeric";
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "ngModelController", void 0);
        __decorate([
            utils.Bind.Literal("type")
        ], Controller.prototype, "InputType", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = Controller_6 = __decorate([
            utils.Component({
                Name: Controller_6.Name,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
        var Controller_6;
    }(utils.Controller));
    exports.Controller = Controller;
    (function (Controller) {
        var Parser = (function () {
            function Parser(ngModel) {
                this.ngModel = ngModel;
                if (!ngModel)
                    throw new Error("Expected to be bound to an ngModel");
                this.Parser = function (viewValue) { return Parser.Parse(viewValue, isEmpty); };
                this.ngModel.$parsers.push(this.Parser);
                function isEmpty(value) {
                    return ngModel.$isEmpty(value);
                }
            }
            Parser.Parse = function (value, isEmpty) {
                if (isEmpty === void 0) { isEmpty = utils.IsVoid; }
                if (isEmpty(value))
                    return null;
                if (Parser.Regex.test(value))
                    return parseFloat(value);
                return void undefined;
            };
            Parser.prototype.Dispose = function () {
                utils.Collection.ArrayRemoveAll(this.ngModel.$parsers, this.Parser);
            };
            Parser.Regex = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
            return Parser;
        }());
        Controller.Parser = Parser;
        var Formatter = (function () {
            function Formatter(ngModel) {
                this.ngModel = ngModel;
                if (!ngModel)
                    throw new Error("Expected to be bound to an ngModel");
                this.Formatter = function (modelValue) { return Formatter.Format(modelValue, isEmpty); };
                this.ngModel.$formatters.push(this.Formatter);
                function isEmpty(value) {
                    return ngModel.$isEmpty(value);
                }
            }
            Formatter.Format = function (value, isEmpty) {
                if (isEmpty === void 0) { isEmpty = utils.IsVoid; }
                if (!isEmpty(value)) {
                    if (!utils.IsNumber(value))
                        throw new Error("expected \"" + value + "\" to be a number");
                    return value.toString();
                }
                return value;
            };
            Formatter.prototype.Dispose = function () {
                utils.Collection.ArrayRemoveAll(this.ngModel.$formatters, this.Formatter);
            };
            return Formatter;
        }());
        Controller.Formatter = Formatter;
    })(Controller = exports.Controller || (exports.Controller = {}));
    exports.Controller = Controller;
});
define("app/selcomm/filter/evaluate", ["require", "exports", "factory!selcomm:filter-evaluate"], function (require, exports, evalFilter) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function EvaluateFilter(data, filter) {
        return evalFilter(data, filter);
    }
    exports.EvaluateFilter = EvaluateFilter;
});
define("app/sdc/paginated/sdc-paginated", ["require", "exports", "module", "app/utils", "app/ng-utils", "app/selcomm/service", "app/sdc/bound/expression/sdc-bound-expression", "app/selcomm/filter/evaluate", "app/sdc/loading/sdc-loading", "app/selcomm/service", "service!selcomm:filter"], function (require, exports, module_7, utils, ng_utils_9, service_3, boundExpression, evaluate_1, loading, SelcommWS, filter) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = utils.GetComponentNameFromModuleId(module_7.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.sorts = new Array();
            _this.ApplyLoadingToSdcLoading = false;
            _this.LoadActivity = new utils.ActivityController("Load");
            _this.lastResponse = new InitialResponse(new Locals.LegacyCompatible({ Sorts: _this.currentSorts, PageIndex: _this.currentPageIndex, PageSize: _this.currentPageSize, Filter: _this.currentFilter, ExtendLocals: _this.currentExtendLocals, }));
            _this.CompiledExpression = new CompiledExpression(_this.Scope, _this.LoaderExpression, _this.RefreshAsExpression);
            _this.Watch.Collection(function () { return _this.sorts; }, function (newSorts) { return _this.UpdateCurrentSorts(newSorts); });
            _this.Watch.Deep(boundExpression.create(_this.getFilterExpression, _this.Scope.$parent, { $filter: filter }), function (newFilter) { return _this.UpdateCurrentFilter(newFilter); });
            _this.Watch.Deep(function () { return _this._extendLocals; }, function (newExtendLocals) { return _this.UpdateExtendLocals(newExtendLocals); });
            var lastToken = {};
            _this.Watch.Custom(function () { return ({ Sorts: _this.currentSorts, PageIndex: _this.currentPageIndex, PageSize: _this.currentPageSize, Filter: _this.currentFilter, ExtendLocals: _this.currentExtendLocals, }); }, function (r) { return Request.CreateStable(r); }, function (x, y) { return Request.AreEqual(x, y); }, function (request) { return void (!Request.AreEqual(_this.LastRequest, request) && _this.Load(request)); });
            _this.ReSetResponse();
            if (utils.IsVoid(_this.Attributes["loading"]) && utils.IsVoid(_this.Attributes["isLoading"]))
                _this.ApplyLoadingToSdcLoading = true;
            return _this;
        }
        Controller_7 = Controller;
        Object.defineProperty(Controller.prototype, "TotalItems", {
            get: function () {
                return this.totalItems;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "PageSize", {
            get: function () {
                return this.currentPageSize;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "LoaderExpression", {
            get: function () {
                return this.PrimaryExpression || this.AlternativeExpression;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "_extendLocals", {
            get: function () {
                return this.ArgumentsController ? (this.ArgumentsController.$value) : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "MultiSort", {
            get: function () {
                return Boolean(this.BoundMultiSort);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "PageNumber", {
            get: function () {
                return (this.currentPageIndex || 0) + 1;
            },
            set: function (value) {
                this.currentPageIndex = (value || 0) - 1;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "pageNumber", {
            get: function () {
                return this.PageNumber;
            },
            set: function (value) {
                this.PageNumber = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Refresh = function () {
            return this.Load({ Sorts: this.currentSorts, PageIndex: this.currentPageIndex, PageSize: this.currentPageSize, Filter: this.currentFilter, ExtendLocals: this.currentExtendLocals, });
        };
        Object.defineProperty(Controller.prototype, "IsLoading", {
            get: function () {
                return this.LoadActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "UseLoadingPromise", {
            get: function () {
                return !utils.IsNullOrWhitespace(this.Attributes["loading"]);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "loading", {
            set: function (value) {
                this._loading = value;
                var _a = this, ApplyLoadingToSdcLoading = _a.ApplyLoadingToSdcLoading, sdcLoadingController = _a.sdcLoadingController;
                if (ApplyLoadingToSdcLoading && sdcLoadingController) {
                    var originalValue = sdcLoadingController.Loading;
                    if (sdcLoadingController.Loading && utils.HasProp(sdcLoadingController.Loading, Controller_7.OriginalValue))
                        originalValue = originalValue;
                    var wrappedPromise = ng_utils_9.$q.all([ng_utils_9.$q.when(originalValue), ng_utils_9.$q.when(value)]).then(function (x) {
                        return x[0];
                    });
                    wrappedPromise[Controller_7.OriginalValue] = originalValue;
                    sdcLoadingController.Loading = wrappedPromise;
                }
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.UpdateCurrentFilter = function ($new) {
            this.currentFilter = angular.copy($new);
        };
        Controller.prototype.UpdateCurrentSorts = function ($new) {
            this.currentSorts = angular.copy($new) || [];
        };
        Controller.prototype.UpdateExtendLocals = function ($new) {
            this.currentExtendLocals = $new || {};
        };
        Controller.prototype.Load = function (request) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var token, deferred, _a, response_2, totalItems_1, actualRequest_1, err_11;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.LastRequest = Request.CreateStable(request);
                            token = this.LoadActivity.CloseAndEnter();
                            deferred = this.UseLoadingPromise ? new utils.Deferred() : null;
                            if (!utils.IsVoid(deferred))
                                this.loading = ng_utils_9.$q.resolve(deferred.Promise);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, 5, 6]);
                            return [4, utils.Delay.Thin(1)];
                        case 2:
                            _b.sent();
                            if (token.HasExited)
                                return [2];
                            return [4, this.CallLoaderClampedPage(token, request)];
                        case 3:
                            _a = _b.sent(), response_2 = _a.response, totalItems_1 = _a.totalItems, actualRequest_1 = _a.request;
                            if (utils.IsVoid(response_2) || token.HasExited)
                                return [2];
                            this.Scope.$applyAsync(function () {
                                _this.currentPageIndex = actualRequest_1.PageIndex;
                                _this.LastRequest = Request.CreateStable(actualRequest_1);
                                _this.ApplyResponse(response_2, totalItems_1);
                            });
                            if (response_2 instanceof ErrorResponse)
                                throw response_2.Error;
                            if (!utils.IsVoid(deferred))
                                deferred.Resolve(response_2.Value);
                            return [2, response_2];
                        case 4:
                            err_11 = _b.sent();
                            if (!utils.IsVoid(deferred))
                                deferred.Reject(err_11);
                            throw err_11;
                        case 5:
                            token.Exit();
                            return [7];
                        case 6: return [2];
                    }
                });
            });
        };
        Controller.prototype.CallLoaderClampedPage = function (token, request) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var locals, response, totalItems;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            locals = new Locals.LegacyCompatible(request);
                            return [4, this.CallLoader(locals)];
                        case 1:
                            response = _a.sent();
                            if (token.HasExited)
                                return [2, { totalItems: undefined, response: response, request: request, }];
                            totalItems = this.EnsureTotal(response instanceof SuccessResponse && response.GetTotal(function (t, v) { return _this.CompiledExpression.SetData(t, v); }, this.BoundTotalParser));
                            if (utils.IsVoid(totalItems) || totalItems <= 0 || locals.skip < totalItems)
                                return [2, { totalItems: totalItems, response: response, request: request }];
                            return [4, this.CallLoaderClampedPage(token, __assign({}, request, { PageIndex: Math.floor(totalItems / request.PageSize) }))];
                        case 2: return [2, _a.sent()];
                    }
                });
            });
        };
        Controller.prototype.CallLoader = function (locals) {
            return __awaiter(this, void 0, void 0, function () {
                var loadedValue, response, error_1, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, this.CompiledExpression.Loader(locals)];
                        case 1:
                            loadedValue = _a.sent();
                            response = new SuccessResponse(locals, loadedValue);
                            return [2, response];
                        case 2:
                            error_1 = _a.sent();
                            response = new ErrorResponse(locals, error_1);
                            return [2, response];
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.prototype.ReSetResponse = function () {
            this.ApplyResponse(this.lastResponse);
        };
        Controller.prototype.EnsureTotal = function (total) {
            if (!utils.IsNumber(total))
                return this.totalItems;
            return total;
        };
        Controller.prototype.GetTotal = function (response) {
            var _this = this;
            return this.EnsureTotal(response instanceof SuccessResponse && response.GetTotal(function (t, v) { return _this.CompiledExpression.SetData(t, v); }, this.BoundTotalParser));
        };
        Controller.prototype.ApplyResponse = function (response, totalItems, target) {
            var _this = this;
            if (totalItems === void 0) { totalItems = this.GetTotal(response); }
            if (target === void 0) { target = this.Scope; }
            this.lastResponse = response;
            this.totalItems = totalItems;
            var page = response.Locals.page || 0;
            var pageSize = response.Locals.pageSize;
            var pageCount = utils.IsVoid(totalItems) ? undefined : Math.ceil(totalItems / response.Locals.pageSize);
            var nextPageCount = utils.IsVoid(totalItems) ? undefined : Math.max(Math.min(pageSize, totalItems - ((page + 1) * pageSize)), 0);
            var previousPageCount = utils.IsVoid(totalItems) ? undefined : page ? this.currentPageSize : 0;
            try {
                this.Scope.$page = page;
                this.Scope.$pageCount = pageCount;
                this.Scope.$pageSize = pageSize;
                this.Scope.$totalItems = totalItems;
                this.Scope.$previousPage = utils.Extend(function () { return void (_this.currentPageIndex = page - 1); }, {
                    count: previousPageCount,
                    pageCount: page
                });
                this.Scope.$nextPage = utils.Extend(function () { return void (_this.currentPageIndex = page + 1); }, {
                    count: nextPageCount,
                    pageCount: pageCount - (page + 1)
                });
            }
            finally {
                this.CompiledExpression.SetData(this.Scope, response instanceof SuccessResponse ? response.Value : undefined);
                this.CompiledExpression.SetRefresh(this.Scope, function () { return _this.Refresh(); });
            }
        };
        Controller.OriginalValue = Symbol("sdc-paginated:sdc-loading original promise");
        __decorate([
            utils.Bind.Controller(loading.Controller, { optional: true, mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "sdcLoadingController", void 0);
        __decorate([
            utils.Bind.Controller("sdc-pagination-arguments", { optional: true, mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "ArgumentsController", void 0);
        __decorate([
            utils.Bind.Literal(exports.Name, { optional: true })
        ], Controller.prototype, "PrimaryExpression", void 0);
        __decorate([
            utils.Bind.Literal("for", { optional: true })
        ], Controller.prototype, "AlternativeExpression", void 0);
        __decorate([
            utils.Bind.TwoWay("page", { optional: true })
        ], Controller.prototype, "currentPageIndex", void 0);
        __decorate([
            utils.Bind.In("page-size", { optional: true }),
            utils.Bind.DefaultValue(10)
        ], Controller.prototype, "currentPageSize", void 0);
        __decorate([
            utils.Bind.Getter("get-total", { optional: true })
        ], Controller.prototype, "BoundTotalParser", void 0);
        __decorate([
            utils.Bind.In("multi-sort", { optional: true })
        ], Controller.prototype, "BoundMultiSort", void 0);
        __decorate([
            utils.Bind.Literal("refresh-as", { optional: true })
        ], Controller.prototype, "RefreshAsExpression", void 0);
        __decorate([
            utils.Bind.Literal("filter")
        ], Controller.prototype, "getFilterExpression", void 0);
        __decorate([
            utils.Bind.Out("is-loading", { optional: true })
        ], Controller.prototype, "IsLoading", null);
        __decorate([
            utils.Bind.TwoWay("loading", { optional: true })
        ], Controller.prototype, "loading", null);
        Controller = Controller_7 = __decorate([
            utils.Component({
                ModuleId: module_7.id,
                Restrict: utils.Target.ElementOrAttribute,
                Template: null,
                Priority: 50,
                Scope: utils.ScopeMode.NewInheritedScope,
            })
        ], Controller);
        return Controller;
        var Controller_7;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    function getValue(obj, propertyChain) {
        if (utils.IsString(propertyChain))
            propertyChain = propertyChain.split(".");
        var context = obj;
        try {
            for (var propertyChain_1 = __values(propertyChain), propertyChain_1_1 = propertyChain_1.next(); !propertyChain_1_1.done; propertyChain_1_1 = propertyChain_1.next()) {
                var prop = propertyChain_1_1.value;
                context = context[prop];
            }
        }
        catch (e_61_1) { e_61 = { error: e_61_1 }; }
        finally {
            try {
                if (propertyChain_1_1 && !propertyChain_1_1.done && (_a = propertyChain_1.return)) _a.call(propertyChain_1);
            }
            finally { if (e_61) throw e_61.error; }
        }
        return context;
        var e_61, _a;
    }
    ;
    function CreateFactory(dataSet) {
        return function paginatedFactory(args) {
            return __awaiter(this, void 0, ng_utils_9.$q, function () {
                var psf, fullData, filteredData, _a, minIndex, maxIndex, retValue;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (args["PagingSortsAndFilters"])
                                psf = args.PagingSortsAndFilters;
                            else
                                psf = psf;
                            fullData = utils.IsFunction(dataSet) ? dataSet(args).slice() : dataSet.slice();
                            if (!psf.Filter) return [3, 2];
                            return [4, evaluate_1.EvaluateFilter(fullData, psf.Filter)];
                        case 1:
                            _a = (_b.sent());
                            return [3, 3];
                        case 2:
                            _a = fullData;
                            _b.label = 3;
                        case 3:
                            filteredData = _a;
                            if (psf.Sorts && psf.Sorts.length) {
                                filteredData.sort(function (a, b) {
                                    try {
                                        for (var _a = __values(psf.Sorts), _b = _a.next(); !_b.done; _b = _a.next()) {
                                            var sort = _b.value;
                                            var aVal = getValue(a, sort.TargetProperty);
                                            var bVal = getValue(b, sort.TargetProperty);
                                            if (aVal === bVal)
                                                continue;
                                            var direction = sort.Direction;
                                            if (utils.IsString(direction))
                                                direction = service_3.Selcomm.Filters.SortDirection[direction];
                                            switch (direction) {
                                                case service_3.Selcomm.Filters.SortDirection.Ascending:
                                                    if (aVal > bVal)
                                                        return 1;
                                                    else
                                                        return -1;
                                                case service_3.Selcomm.Filters.SortDirection.Descending:
                                                    if (aVal > bVal)
                                                        return -1;
                                                    else
                                                        return 1;
                                            }
                                        }
                                    }
                                    catch (e_62_1) { e_62 = { error: e_62_1 }; }
                                    finally {
                                        try {
                                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                        }
                                        finally { if (e_62) throw e_62.error; }
                                    }
                                    return 0;
                                    var e_62, _c;
                                });
                            }
                            minIndex = psf.SkipRecords || 0;
                            maxIndex = angular.isNumber(psf.TakeRecords) ? minIndex + psf.TakeRecords : Number.POSITIVE_INFINITY;
                            retValue = utils.List.Create({
                                Items: filteredData.slice(minIndex, maxIndex),
                                TotalFilteredRecords: filteredData.TotalFilteredRecords || filteredData.length,
                                TotalUnfilteredRecords: fullData.TotalUnfilteredRecords || fullData.length,
                            });
                            return [2, retValue];
                    }
                });
            });
        };
    }
    exports.CreateFactory = CreateFactory;
    var Request;
    (function (Request) {
        function AreEqual(x, y) {
            if (utils.IsVoid(x) && utils.IsVoid(y))
                return true;
            if (utils.IsVoid(x) || utils.IsVoid(y))
                return false;
            if (x.PageIndex !== y.PageIndex || x.PageSize !== y.PageSize || x.Sorts.length !== y.Sorts.length)
                return false;
            try {
                for (var _a = __values(utils.Collection.Distinct(__spread(Object.keys(x.ExtendLocals), Object.keys(y.ExtendLocals)))), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var key = _b.value;
                    if (!utils.HasProp(x.ExtendLocals, key) || !utils.HasProp(y.ExtendLocals, key))
                        return false;
                    if (x.ExtendLocals[key] !== y.ExtendLocals[key])
                        return false;
                }
            }
            catch (e_63_1) { e_63 = { error: e_63_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_63) throw e_63.error; }
            }
            return angular.equals(x.Sorts, y.Sorts) && angular.equals(x.Filter, y.Filter);
            var e_63, _c;
        }
        Request.AreEqual = AreEqual;
        function CreateStable(other) {
            return {
                PageIndex: other.PageIndex,
                PageSize: other.PageSize,
                ExtendLocals: utils.ShallowCopy(other.ExtendLocals),
                Sorts: utils.DeepCopy(other.Sorts),
                Filter: utils.DeepCopy(other.Filter),
            };
        }
        Request.CreateStable = CreateStable;
    })(Request || (Request = {}));
    var Response = (function () {
        function Response(Locals) {
            this.Locals = Locals;
        }
        return Response;
    }());
    var SuccessResponse = (function (_super) {
        __extends(SuccessResponse, _super);
        function SuccessResponse(locals, Value) {
            var _this = _super.call(this, locals) || this;
            _this.Value = Value;
            return _this;
        }
        SuccessResponse.DefaultGetDirectTotal = function (value) {
            if (!utils.IsObjectLike(value) || !utils.HasProp(value, "TotalFilteredRecords") || !utils.IsNumber(value.TotalFilteredRecords))
                return undefined;
            return value.TotalFilteredRecords;
        };
        SuccessResponse.DefaultGetTotal = function (value) {
            var total = this.DefaultGetDirectTotal(value);
            if (!utils.IsVoid(total))
                return total;
            if (utils.HasProp(value, "data") && utils.IsObject(value.data))
                return this.DefaultGetDirectTotal(value.data);
            return undefined;
        };
        SuccessResponse.prototype.GetTotal = function (assignData, totalParser) {
            if (utils.IsVoid(totalParser))
                return SuccessResponse.DefaultGetTotal(this.Value);
            var locals = {};
            assignData(locals, this.Value);
            return totalParser(locals);
        };
        return SuccessResponse;
    }(Response));
    var ErrorResponse = (function (_super) {
        __extends(ErrorResponse, _super);
        function ErrorResponse(locals, Error) {
            var _this = _super.call(this, locals) || this;
            _this.Error = Error;
            return _this;
        }
        return ErrorResponse;
    }(Response));
    var InitialResponse = (function (_super) {
        __extends(InitialResponse, _super);
        function InitialResponse(locals) {
            return _super.call(this, locals) || this;
        }
        return InitialResponse;
    }(Response));
    var CompiledExpression = (function () {
        function CompiledExpression(Scope, expression, refreshExpression) {
            this.Scope = Scope;
            var _a = __read(expression.split(/ as /), 2), data = _a[0], loader = _a[1];
            if (!data) {
                loader = data;
                data = null;
            }
            var refresh = refreshExpression;
            if (!refresh)
                refresh = "$refresh";
            this.compiledData = ng_utils_9.$parse(data);
            this.compiledLoader = ng_utils_9.$parse(loader);
            this.compiledRefresh = ng_utils_9.$parse(refresh);
        }
        CompiledExpression.prototype.Loader = function (locals) {
            return this.compiledLoader(this.Scope.$parent, locals);
        };
        CompiledExpression.prototype.SetData = function (target, value) {
            var _this = this;
            this.Scope.$applyAsync(function () {
                _this.compiledData.assign(target, value);
                _this.compiledData.assign(_this.Scope, value);
            });
        };
        CompiledExpression.prototype.SetRefresh = function (target, value) {
            this.compiledRefresh.assign(target, value);
            this.compiledRefresh.assign(this.Scope, value);
        };
        return CompiledExpression;
    }());
    var Locals = (function () {
        function Locals(requested) {
            this.page = requested.PageIndex;
            this.pageSize = requested.PageSize;
            this.skip = requested.PageIndex * requested.PageSize || 0;
            this.take = requested.PageSize;
            this.sorts = utils.DeepCopy(requested.Sorts) || [];
            this.filter = utils.DeepCopy(requested.Filter);
            this.psf = new service_3.Selcomm.Filters.PagingSortsAndFilters({
                SkipRecords: this.skip,
                TakeRecords: this.take,
                Sorts: __spread(this.sorts),
                Filter: this.filter || null,
            });
            angular.extend(this, requested.ExtendLocals);
        }
        Object.defineProperty(Locals.prototype, "psf", {
            get: function () {
                return this.pagingSortsAndFilters;
            },
            set: function (value) {
                this.pagingSortsAndFilters = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Locals.prototype, "locals", {
            get: function () {
                return this;
            },
            enumerable: true,
            configurable: true
        });
        return Locals;
    }());
    exports.Locals = Locals;
    (function (Locals) {
        var LegacyCompatible = (function (_super) {
            __extends(LegacyCompatible, _super);
            function LegacyCompatible(requested) {
                var _this = _super.call(this, requested) || this;
                _this.SelcommWS = SelcommWS;
                return _this;
            }
            Object.defineProperty(LegacyCompatible.prototype, "$page", {
                get: function () { return this.page; },
                set: function (value) { this.page = value; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyCompatible.prototype, "$pageSize", {
                get: function () { return this.pageSize; },
                set: function (value) { this.pageSize = value; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyCompatible.prototype, "$skip", {
                get: function () { return this.skip; },
                set: function (value) { this.skip = value; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyCompatible.prototype, "$take", {
                get: function () { return this.take; },
                set: function (value) { this.take = value; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyCompatible.prototype, "$sorts", {
                get: function () { return this.sorts; },
                set: function (value) { this.sorts = value; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyCompatible.prototype, "$filter", {
                get: function () { return this.filter; },
                set: function (value) { this.filter = value; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyCompatible.prototype, "$pagingSortsAndFilters", {
                get: function () { return this.pagingSortsAndFilters; },
                set: function (value) { this.pagingSortsAndFilters = value; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyCompatible.prototype, "$psf", {
                get: function () { return this.psf; },
                set: function (value) { this.psf = value; },
                enumerable: true,
                configurable: true
            });
            return LegacyCompatible;
        }(Locals));
        Locals.LegacyCompatible = LegacyCompatible;
    })(Locals = exports.Locals || (exports.Locals = {}));
    exports.Locals = Locals;
});
define("app/sdc/pagination/controls/sdc-pagination-controls", ["require", "exports", "app/sdc/bound/expression/sdc-bound-expression", "app/sdc/paginated/sdc-paginated", "app/utils"], function (require, exports, boundExpression, paginated, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller($scope, $attrs, $watch) {
            var _this = this;
            this.AllowJump = true;
            if (this.pageExpr && this.pageSizeExpr && this.totalItemsExpr) {
                this.pageFn = boundExpression.create(this.pageExpr, $scope.$parent);
                this.pageSizeFn = boundExpression.create(this.pageSizeExpr, $scope.$parent);
                this.totalItemsFn = boundExpression.create(this.totalItemsExpr, $scope.$parent);
            }
            else if (!this.pageExpr && !this.pageSizeExpr && !this.totalItemsExpr) {
                this.pageFn = boundExpression.From(function () { return _this.Paginated && _this.Paginated.PageNumber; }, function (value) { return _this.Paginated.PageNumber = value; });
                this.pageSizeFn = boundExpression.From(function () { return _this.Paginated && _this.Paginated.PageSize; });
                this.totalItemsFn = boundExpression.From(function () { return _this.Paginated && _this.Paginated.TotalItems; });
            }
        }
        Object.defineProperty(Controller.prototype, "Page", {
            get: function () {
                return this.pageFn();
            },
            set: function (value) {
                this.pageFn.set(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "PageSize", {
            get: function () {
                return this.pageSizeFn();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "TotalItems", {
            get: function () {
                return this.totalItemsFn();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "TotalPages", {
            get: function () {
                return utils.IsVoid(this.TotalItems) ? this.TotalItems : Math.ceil(this.TotalItems / this.PageSize);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Next = function () {
            this.Page++;
        };
        Controller.prototype.Previous = function () {
            this.Page--;
        };
        Controller.prototype.Start = function () {
            this.Page = 1;
        };
        Controller.prototype.End = function () {
            this.Page = this.TotalPages || 1;
        };
        __decorate([
            utils.Bind.Controller(paginated.Controller, { optional: true, mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "Paginated", void 0);
        __decorate([
            utils.Bind.Literal("page")
        ], Controller.prototype, "pageExpr", void 0);
        __decorate([
            utils.Bind.Literal("page-size")
        ], Controller.prototype, "pageSizeExpr", void 0);
        __decorate([
            utils.Bind.Literal("total-items")
        ], Controller.prototype, "totalItemsExpr", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "sdc-pagination-controls",
                Transclude: utils.TransclusionMode.Contents,
                Restrict: utils.Target.ElementOrAttribute
            }),
            __param(0, utils.Inject("$scope")), __param(1, utils.Inject("$attrs")), __param(2, utils.Inject("$watch"))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/pages/sdc-pages", ["require", "exports", "app/sdc/bound/expression/sdc-bound-expression", "app/sdc/paginated/sdc-paginated", "app/sdc/pagination/controls/sdc-pagination-controls", "app/utils"], function (require, exports, boundExpression, paginated, controls, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Attributes.$addClass("sdc-pages");
            return _this;
        }
        Controller_8 = Controller;
        Controller.BuildPages = function (page, totalPages, pageLimit) {
            if (utils.IsVoid(totalPages) || Number.isNaN(totalPages) || utils.IsVoid(page) || Number.isNaN(page))
                return [];
            if (pageLimit == 1)
                return [page];
            if (totalPages < pageLimit)
                return new Array(totalPages).fill(null).map(function (value, i) { return i + 1; });
            if (pageLimit == 2) {
                if (page === totalPages)
                    return [page - 1, page];
                return [page, page + 1];
            }
            if (pageLimit == 3) {
                switch (page) {
                    case 1:
                        return [1, 2, totalPages];
                    case totalPages:
                        return [1, totalPages - 1, totalPages];
                    default:
                        return [1, page, totalPages];
                }
            }
            var effectivePageLimit = pageLimit - 2;
            if (page <= (pageLimit / 2)) {
                return __spread(new Array(Math.min(pageLimit - 2, totalPages)).fill(null).map(function (value, i) { return i + 1; }), [
                    null,
                    totalPages,
                ]);
            }
            if (page >= (totalPages - (pageLimit / 2))) {
                return __spread([
                    1,
                    null
                ], new Array(Math.min(pageLimit - 2, totalPages)).fill(null).map(function (value, i) { return totalPages - i; }).reverse());
            }
            else {
                var pages = new Array();
                var effectivePageLimit_1 = pageLimit - 4;
                pages.push(1);
                pages.push(null);
                var left = Math.ceil(Math.max(page - (effectivePageLimit_1 / 2), 1));
                for (var i = left; i < (left + effectivePageLimit_1) && i < totalPages; i++) {
                    pages.push(i);
                }
                pages.push(null);
                pages.push(totalPages);
                return pages;
            }
        };
        Object.defineProperty(Controller.prototype, "PageLimit", {
            get: function () {
                return utils.IsVoid(this.BoundPageLimit) ? 10 : this.BoundPageLimit;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ClampedPage", {
            get: function () {
                return utils.IsVoid(this.TotalPages) ? this.TotalPages : Math.max(Math.min(this.Page || 1, this.TotalPages), 1);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Page", {
            get: function () {
                return this.pageFn();
            },
            set: function (value) {
                this.pageFn.set(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "PageSize", {
            get: function () {
                return this.pageSizeFn();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "TotalItems", {
            get: function () {
                return this.totalItemsFn();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "TotalPages", {
            get: function () {
                return utils.IsVoid(this.TotalItems) ? this.TotalItems : Math.ceil(this.TotalItems / this.PageSize);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SelectPage = function (page) {
            if (this.Page === page)
                return;
            this.Page = page;
        };
        Controller.prototype.Initialise = function () {
            var _this = this;
            if (this.pageExpr && this.pageSizeExpr && this.totalItemsExpr) {
                this.pageFn = boundExpression.create(this.pageExpr, this.Scope.$parent);
                this.pageSizeFn = boundExpression.create(this.pageSizeExpr, this.Scope.$parent);
                this.totalItemsFn = boundExpression.create(this.totalItemsExpr, this.Scope.$parent);
            }
            else if (!this.pageExpr && !this.pageSizeExpr && !this.totalItemsExpr) {
                var _a = this, PaginatedController_1 = _a.PaginatedController, PaginationControlsController_1 = _a.PaginationControlsController;
                if (!utils.IsVoid(PaginationControlsController_1)) {
                    this.pageFn = boundExpression.From(function () { return PaginationControlsController_1.Page; }, function (value) { return PaginationControlsController_1.Page = value; });
                    this.pageSizeFn = boundExpression.From(function () { return PaginationControlsController_1.PageSize; });
                    this.totalItemsFn = boundExpression.From(function () { return PaginationControlsController_1.TotalItems; });
                    this.Watch(function () { return _this.PageLimit; }, function (pageLimit) { return PaginationControlsController_1.AllowJump = pageLimit < 3; });
                }
                else if (!utils.IsVoid(PaginatedController_1)) {
                    this.pageFn = boundExpression.From(function () { return PaginatedController_1.PageNumber; }, function (value) { return PaginatedController_1.PageNumber = value; });
                    this.pageSizeFn = boundExpression.From(function () { return PaginatedController_1.PageSize; });
                    this.totalItemsFn = boundExpression.From(function () { return PaginatedController_1.TotalItems; });
                }
                else
                    throw new Error("Need to either specify all parameters or be nested in either an `sdc-pagination-controls` or a `sdc-paginated`.");
            }
            else {
            }
            this.Watch.Group({
                page: function () { return _this.ClampedPage; },
                totalPages: function () { return _this.TotalPages; },
                pageLimit: function () { return _this.PageLimit; },
            }, function ($new) {
                if (utils.IsVoid($new.pageLimit))
                    return;
                _this.Pages = Controller_8.BuildPages($new.page, $new.totalPages, $new.pageLimit);
            });
        };
        __decorate([
            utils.Bind.Controller(paginated.Controller, { optional: true, mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "PaginatedController", void 0);
        __decorate([
            utils.Bind.Controller(controls.Controller, { optional: true, mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "PaginationControlsController", void 0);
        __decorate([
            utils.Bind.In("page-limit")
        ], Controller.prototype, "BoundPageLimit", void 0);
        __decorate([
            utils.Bind.Literal("total-items", { optional: true })
        ], Controller.prototype, "totalItemsExpr", void 0);
        __decorate([
            utils.Bind.Literal("page-size", { optional: true })
        ], Controller.prototype, "pageSizeExpr", void 0);
        __decorate([
            utils.Bind.Literal("page", { optional: true })
        ], Controller.prototype, "pageExpr", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Initialise", null);
        Controller = Controller_8 = __decorate([
            utils.Component({
                Name: "sdc-pages",
                Restrict: utils.Target.ElementOrAttribute,
            })
        ], Controller);
        return Controller;
        var Controller_8;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sdc/paginated/sdc-paginated-factory", ["require", "exports", "app/sdc/paginated/sdc-paginated"], function (require, exports, sdc_paginated_1) {
    "use strict";
    return sdc_paginated_1.CreateFactory;
});
define("app/sdc/placeholder/container/sdc-placeholder-container", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-placeholder-container";
    var Controller = (function () {
        function Controller() {
            this.Registar = new utils.Registar();
        }
        Object.defineProperty(Controller.prototype, "Transcludes", {
            get: function () {
                return this.Registar.Items;
            },
            set: function (value) { },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.TwoWay(exports.Name, { optional: true })
        ], Controller.prototype, "Transcludes", null);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
                Restrict: utils.Target.Attribute | utils.Target.Element,
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/placeholder/sdc-placeholder", ["require", "exports", "scripts/lib/select-development/sss-names", "app/sdc/placeholder/container/sdc-placeholder-container", "app/utils"], function (require, exports, name, container, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-placeholder";
    utils.MakePlaceholder(container.Controller, exports.Name, function (vm, $transclude) { return vm.Registar.Register($transclude); }, function (vm, $transclude) { return vm.Registar.Unregister($transclude); });
    utils.Directive({
        Name: exports.Name,
        Restrict: utils.Target.Attribute,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
        OnLink: function ($scope, $element, $attrs) {
            var classAdded = false;
            $attrs.$observe(name.CamelCase(exports.Name), function (expression) {
                $scope.$watch(expression, function (newValue) {
                    var addClass = !newValue;
                    if (addClass != classAdded) {
                        classAdded = addClass;
                        $attrs[addClass ? "$addClass" : "$removeClass"]("placeholder");
                    }
                });
            });
        }
    });
});
define("app/sdc/read/sdc-read", ["require", "exports", "app/sdc/crud/sdc-crud"], function (require, exports, Crud) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    Crud.SubComponent("sdc-read");
});
define("app/sdc/regex/sdc-regex", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function escape(val) {
        return ("" + val).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    exports.escape = escape;
});
define("app/sdc/sub/path/sdc-sub-path", ["require", "exports", "module", "app/utils", "app/ng-utils"], function (require, exports, module_8, utils, ng_utils_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_8.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            if (!_this.AutoConsume)
                _this.Consume("", _this.Recieved);
            else {
                var autoConsume_1 = _this.AutoConsume;
                _this.Watch.Collection(function () { return autoConsume_1({ recieved: _this.Recieved }); }, function (x) { return _this.Consume(x.consumed, x.passDown); });
            }
            return _this;
        }
        Controller_9 = Controller;
        Object.defineProperty(Controller, "Name", {
            get: function () {
                return Name;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "LeadingPath", {
            get: function () {
                return "" + this.Parent.LeadingPath + this.Parent.Consumed;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Recieved", {
            get: function () {
                return this.Parent.PassDown;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Consumed", {
            get: function () {
                return this.Attributes[Controller_9.ConsumedAttrName] || "";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "PassDown", {
            get: function () {
                return this.Attributes[Controller_9.PassDownAttrName] || "";
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Consume = function (consumed, passDown) {
            consumed = consumed || "";
            passDown = passDown || "";
            if ((consumed + passDown) !== this.Recieved)
                ng_utils_10.$log.warn("Invalid sub-path consumption request (this can happen if a consumption request recieved path changes just before a consume call is made):", { recieved: this.Recieved, consumed: consumed, passDown: passDown });
            this.Attributes.$set(Controller_9.ConsumedAttrName, consumed);
            this.Attributes.$set(Controller_9.PassDownAttrName, passDown);
        };
        Object.defineProperty(Controller.prototype, "Parent", {
            get: function () {
                return (this.FoundParent === this ? null : this.FoundParent) || Controller_9.Default;
            },
            enumerable: true,
            configurable: true
        });
        Controller.ApplyWith = function (name, priority, restrict) {
            return utils.Directive({
                Name: name,
                Priority: priority,
                Template: null,
                Terminal: true,
                Restrict: restrict,
                Scope: utils.ScopeMode.NewInheritedScope,
                OnLink: function (scope, element, attrs, controllers, transclude) {
                    if (element.attr(Controller_9.Name))
                        throw new Error("Cannot have two directives " + Controller_9.Name + " directives on the same element.");
                    element.attr(Controller_9.Name, "");
                    ng_utils_10.$compile(element, null, priority)(scope, null, {
                        parentBoundTranscludeFn: transclude,
                    });
                }
            });
        };
        Controller.PassDownAttrName = utils.CamelCase(Controller_9.Name);
        Controller.ConsumedAttrName = Controller_9.PassDownAttrName + "Consumed";
        __decorate([
            utils.Bind.Out("leading-path", { optional: true })
        ], Controller.prototype, "LeadingPath", null);
        __decorate([
            utils.Bind.Out("recieved", { optional: true })
        ], Controller.prototype, "Recieved", null);
        __decorate([
            utils.Bind.Out("consumed", { optional: true })
        ], Controller.prototype, "Consumed", null);
        __decorate([
            utils.Bind.Out("pass-down", { optional: true })
        ], Controller.prototype, "PassDown", null);
        __decorate([
            utils.Bind.Getter("auto-sub-path-consume", { optional: true })
        ], Controller.prototype, "AutoConsume", void 0);
        __decorate([
            utils.Bind.Controller(Controller_9.Name, { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "FoundParent", void 0);
        Controller = Controller_9 = __decorate([
            utils.Component({
                Name: Name,
                Restrict: utils.Target.Attribute,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
        var Controller_9;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    (function (Controller) {
        var DefaultController = (function () {
            function DefaultController() {
            }
            Object.defineProperty(DefaultController.prototype, "LeadingPath", {
                get: function () { return ""; },
                enumerable: true,
                configurable: true
            });
            ;
            Object.defineProperty(DefaultController.prototype, "Consumed", {
                get: function () { return ""; },
                enumerable: true,
                configurable: true
            });
            ;
            Object.defineProperty(DefaultController.prototype, "Recieved", {
                get: function () {
                    return ng_utils_10.$location.path();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(DefaultController.prototype, "PassDown", {
                get: function () {
                    return this.Recieved;
                },
                enumerable: true,
                configurable: true
            });
            return DefaultController;
        }());
        Controller.Default = new DefaultController();
    })(Controller = exports.Controller || (exports.Controller = {}));
    exports.Controller = Controller;
});
define("app/sdc/route/sdc-route", ["require", "exports", "app/utils", "$location", "$parse", "app/selcomm/service", "app/sdc/sub/path/sdc-sub-path"], function (require, exports, utils, $location, $parse, service_4, subPath) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-route";
    subPath.Controller.ApplyWith(exports.Name, 101, utils.Target.Attribute);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.UnwatchParts = function () { };
            if (!utils.IsSpecified(_this.Attributes["tabindex"]))
                _this.Attributes.$set("tabindex", -1);
            var unwatchRouteArgs = _this.Watch.Collection(function () { return RouterArgs.EnsureInstance(_this); }, function ($new) { return _this.UpdateRouter($new); });
            var unwatchRoute = _this.Watch.Collection(function () { return RouteArgs.EnsureInstance(_this); }, function ($new) { return _this.UpdateCurrentRoute($new); });
            _this.OnDispose(function () {
                _this.router = null;
                unwatchRoute();
                unwatchRouteArgs();
            });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "RecievedSubPath", {
            get: function () {
                return this.SubPathController.Recieved;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Router", {
            get: function () {
                return this.router;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CaseSensitive", {
            get: function () {
                return !!this.BoundCaseSensitive;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Route", {
            get: function () {
                return this._currentRoute;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "RootPath", {
            get: function () {
                return this.FormatAsPath(null);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "RootUrl", {
            get: function () {
                return this.FormatAsUrl(null);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype._Parse = function (path) {
            return this.Router.Parse(path);
        };
        Controller.prototype.Parse = function (path) {
            var route = this._Parse(path);
            return route.Assign({});
        };
        Controller.prototype.setRoute = function (value) {
            $location.path("" + this.SubPathController.LeadingPath + this.Router.Format(value, this.SubPathController.Recieved));
        };
        Controller.prototype.FormatAsPath = function (route) {
            return ((this.Router && ("" + this.SubPathController.LeadingPath + this.Router.Format(route, this.SubPathController.Recieved))) || ".");
        };
        Controller.prototype.FormatAsUrl = function (route) {
            var path = this.FormatAsPath(route);
            var url = path.replace(/^[\\\/]/, "");
            url = service_4.Auth.UrlWithSession(url);
            return url;
        };
        Controller.prototype.UpdateRouter = function (x) {
            var routerArgs = RouterArgs.EnsureInstance(x);
            var newFullRoutePattern = routerArgs.RequestedRoutePattern;
            this.router = new Router(newFullRoutePattern);
            this.UpdateCurrentRoute(this);
        };
        Controller.prototype.UpdateCurrentRoute = function (x) {
            var routeArgs = RouteArgs.EnsureInstance(x);
            if (RouteArgs.AreEqual(this.UpdateCurrentRoute_Last, routeArgs))
                return;
            this.UpdateCurrentRoute_Last = routeArgs;
            try {
                if (!routeArgs.Router)
                    return;
                var route = this._currentRoute = routeArgs.Router.Parse(routeArgs.RecievedSubPath);
                this.SubPathController.Consume(route.Consumed, route.Remaining);
                route.Assign(this.Scope);
                this.WatchParts(routeArgs.Router);
            }
            finally {
                this.lastRouter = routeArgs.Router;
            }
        };
        Controller.prototype.WatchParts = function (router) {
            var _this = this;
            this.UnwatchParts();
            var unwatch = this.UnwatchParts = this.Watch.Group.Array(router.Parts.map(function (p) { return p.expr; }), function ($new) {
                if (_this.Router !== router || unwatch !== _this.UnwatchParts)
                    return;
                var newRouteObj = {};
                for (var i = 0; i < $new.length; i++) {
                    router.Parts[i].expr.assign(newRouteObj, $new[i]);
                }
                var newPath = "" + _this.SubPathController.LeadingPath + router.Format(newRouteObj, _this.SubPathController.Recieved);
                if ($location.path().startsWith(newPath))
                    return;
                $location.path(newPath);
            });
        };
        Controller.prototype.WinRace = function () {
            this.UpdateRouter(RouterArgs.EnsureInstance(this));
            this.UpdateCurrentRoute(RouteArgs.EnsureInstance(this));
        };
        __decorate([
            utils.Bind.Literal(exports.Name)
        ], Controller.prototype, "RequestedRoutePattern", void 0);
        __decorate([
            utils.Bind.Literal("case-sensitive", { optional: true })
        ], Controller.prototype, "BoundCaseSensitive", void 0);
        __decorate([
            utils.Bind.Controller(subPath.Controller)
        ], Controller.prototype, "SubPathController", void 0);
        __decorate([
            utils.Bind.TwoWay("set-path", { optional: true })
        ], Controller.prototype, "setPath", void 0);
        __decorate([
            utils.Bind.TwoWay("resolve-path", { optional: true })
        ], Controller.prototype, "resolvePath", void 0);
        __decorate([
            utils.OnLink(utils.LinkMode.Pre)
        ], Controller.prototype, "WinRace", null);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Priority: 100,
                Template: null,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.NewInheritedScope,
                OnCompile: function (element, attrs) {
                    attrs.$set("sdcSubPath", "");
                    return null;
                }
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    var Route = (function () {
        function Route(Consumed, Remaining, Assigner) {
            this.Consumed = Consumed;
            this.Remaining = Remaining;
            this.Assigner = Assigner;
            this.Values = this.Assign({});
        }
        Object.defineProperty(Route.prototype, "FullPath", {
            get: function () {
                return this.Consumed + this.Remaining;
            },
            enumerable: true,
            configurable: true
        });
        Route.prototype.Assign = function (target) {
            return this.Assigner(target);
        };
        return Route;
    }());
    var RouteFormatter = (function () {
        function RouteFormatter(RoutePattern) {
            this.RoutePattern = RoutePattern;
            this.PartFormatters = RouteFormatter.CreateFromRoutePattern(this.RoutePattern);
        }
        RouteFormatter.prototype.Format = function (route, currentSubPath) {
            var formattedPath = "";
            var formattedMaybePath = "";
            {
                var i = 0;
                {
                    var regex = /(^(?=[^\\\/])|[\\\/])([^\\\/]*)(?=[\\\/]|$)/g;
                    var lastMatch = void 0;
                    while (lastMatch = regex.exec(currentSubPath)) {
                        var _a = __read(lastMatch, 3), fullMatch = _a[0], prefix = _a[1], pathPart = _a[2];
                        if (i >= this.PartFormatters.length)
                            break;
                        addFormattedPart(this.PartFormatters[i++], prefix, pathPart);
                    }
                }
                for (; i < this.PartFormatters.length; i++) {
                    addFormattedPart(this.PartFormatters[i]);
                }
            }
            return formattedPath;
            function addFormattedPart(formatter, prefix, pathPart) {
                if (prefix === void 0) { prefix = "/"; }
                var formattedPart = formatter.Format(pathPart, route);
                if (utils.IsVoid(formattedPart))
                    formattedMaybePath += prefix;
                else {
                    formattedPath += formattedMaybePath + prefix + formattedPart;
                    formattedMaybePath = "";
                }
            }
        };
        return RouteFormatter;
    }());
    exports.RouteFormatter = RouteFormatter;
    (function (RouteFormatter) {
        function CreateFromRoutePattern(routePattern) {
            var routePatternPartFormatters = new Array();
            var normalizedPattern = String(routePattern)
                .replace(/[\\\/]+$/, "");
            var regex = /(^(?=[^\\\/])|[\\\/])([^\\\/]*)(?=[\\\/]|$)/g;
            var lastMatch;
            while (lastMatch = regex.exec(normalizedPattern)) {
                var _a = __read(lastMatch, 3), prefix = _a[1], routePatternPart = _a[2];
                var routePatternPartFormatter = CreatePartFormatter(routePatternPart, routePatternPartFormatters.length);
                routePatternPartFormatters.push(routePatternPartFormatter);
            }
            return routePatternPartFormatters;
        }
        RouteFormatter.CreateFromRoutePattern = CreateFromRoutePattern;
        function CreatePartFormatter(part, index) {
            if (part === "*")
                return AnyPartFormatter.Instance;
            else if (/^=/.test(part))
                return new ExpressionPartFormatter(part);
            else
                return new ConstantPartFormatter(part);
        }
        RouteFormatter.CreatePartFormatter = CreatePartFormatter;
        var AnyPartFormatter = (function () {
            function AnyPartFormatter() {
            }
            AnyPartFormatter.prototype.Format = function (currentText) {
                return currentText;
            };
            AnyPartFormatter.Instance = new AnyPartFormatter();
            return AnyPartFormatter;
        }());
        RouteFormatter.AnyPartFormatter = AnyPartFormatter;
        var ConstantPartFormatter = (function () {
            function ConstantPartFormatter(Text) {
                this.Text = Text;
            }
            ConstantPartFormatter.prototype.Format = function () {
                return this.Text;
            };
            return ConstantPartFormatter;
        }());
        RouteFormatter.ConstantPartFormatter = ConstantPartFormatter;
        var ExpressionPartFormatter = (function () {
            function ExpressionPartFormatter(expression) {
                var _a = __read(/^=[\?\*]?(.+?)$/.exec(expression), 2), normalizedExpression = _a[1];
                this.GetValue = $parse(normalizedExpression);
            }
            ExpressionPartFormatter.prototype.Format = function (currentText, route) {
                return this.GetValue(route);
            };
            return ExpressionPartFormatter;
        }());
        RouteFormatter.ExpressionPartFormatter = ExpressionPartFormatter;
    })(RouteFormatter = exports.RouteFormatter || (exports.RouteFormatter = {}));
    exports.RouteFormatter = RouteFormatter;
    var Router = (function () {
        function Router(RoutePattern) {
            this.RoutePattern = RoutePattern;
            this.Parts = [];
            this._formatter = new RouteFormatter(this.RoutePattern);
            var _a = Router.ParseRoutePattern(RoutePattern), IsRooted = _a.IsRooted, Parts = _a.Parts, Regex = _a.Regex;
            this.Parts = Parts;
            this._parserRegex = Regex;
            this.IsRooted = IsRooted;
        }
        Router.CreateEmptyAssigner = function (parts) {
            if (parts === void 0) { parts = []; }
            return assign_empty;
            function assign_empty(target) {
                try {
                    for (var parts_2 = __values(parts), parts_2_1 = parts_2.next(); !parts_2_1.done; parts_2_1 = parts_2.next()) {
                        var part = parts_2_1.value;
                        part.expr.assign(target, void 0);
                    }
                }
                catch (e_64_1) { e_64 = { error: e_64_1 }; }
                finally {
                    try {
                        if (parts_2_1 && !parts_2_1.done && (_a = parts_2.return)) _a.call(parts_2);
                    }
                    finally { if (e_64) throw e_64.error; }
                }
                var e_64, _a;
            }
        };
        Router.prototype.GenerateRouteFactory = function (path) {
            if (!this._parserRegex)
                return new Route("", path, Router.CreateEmptyAssigner(this.Parts));
            var matches = this._parserRegex.exec(path);
            if (!matches)
                return new Route("", path, Router.CreateEmptyAssigner(this.Parts));
            var assigners = [];
            var skipGroups = 2;
            var i = skipGroups;
            for (; i < matches.length; i++) {
                var part = this.Parts[i - skipGroups];
                var val = matches[i];
                if (!part)
                    continue;
                assigners.push(part.createAssigner(val));
            }
            for (var r = i - skipGroups; r < this.Parts.length; r++) {
                var part_1 = this.Parts[r];
                if (!part_1)
                    continue;
                assigners.push(part_1.createAssigner());
            }
            return new Route(matches[1], matches[matches.length - 1], function assign(target) {
                for (var i_1 = 0; i_1 < assigners.length; i_1++) {
                    assigners[i_1](target);
                }
                return target;
            });
        };
        Router.prototype.Parse = function (subPath) {
            if (!this.CurrentRoute || this.CurrentRoute.FullPath !== subPath)
                this.CurrentRoute = this.GenerateRouteFactory(subPath);
            return this.CurrentRoute;
        };
        Router.prototype.Format = function (route, currentSubPath) {
            return this._formatter.Format(route, currentSubPath);
        };
        Router.ParseRoutePattern = function (routePattern) {
            var parts = [];
            var isRooted = /^~/.test(routePattern);
            var pathMatchRegex = (routePattern || "")
                .replace(/^~?[\\\/]?/, "/")
                .replace(/[\/]+$/, "")
                .replace(/([().])/g, '\\$1')
                .replace(/(\/)?=([\?\*])?([^\/]+)/g, function (_, slash, option, expression) {
                var star = option === '*';
                var preParsedExpression = expression.replace(/\\([().])/g, "$1");
                parts.push(new Router.RoutePart($parse(preParsedExpression)));
                slash = slash || '';
                if (star)
                    return slash + "(?:(.+?)(?:$|/))";
                else
                    return "(?:" + slash + "(*))?";
            })
                .replace(/([\/$])/g, '\\$1')
                .replace(/([*])/g, '[^\/]$1');
            return {
                Parts: Object.freeze(parts),
                Regex: new RegExp('^(' + pathMatchRegex + ")(/.*)?" + '$'),
                IsRooted: isRooted,
            };
        };
        return Router;
    }());
    exports.Router = Router;
    (function (Router) {
        var RoutePart = (function () {
            function RoutePart(expr) {
                this.expr = expr;
            }
            RoutePart.prototype.createAssigner = function (value) {
                var _this = this;
                return function (target) { return _this.expr.assign(target, value); };
            };
            return RoutePart;
        }());
        Router.RoutePart = RoutePart;
    })(Router = exports.Router || (exports.Router = {}));
    exports.Router = Router;
    var RouterArgs = (function () {
        function RouterArgs(source) {
            this.RequestedRoutePattern = source.RequestedRoutePattern;
            this.CaseSensitive = source.CaseSensitive;
        }
        RouterArgs.EnsureInstance = function (x) {
            if (!utils.IsSpecified(x))
                return null;
            else if (x instanceof RouterArgs)
                return x;
            else
                return new RouterArgs(x);
        };
        RouterArgs.AreEqual = function (x, y) {
            return utils.BaseAreEqual(x, y, function (x, y) { return x.RequestedRoutePattern === y.RequestedRoutePattern && x.CaseSensitive === y.CaseSensitive; });
        };
        return RouterArgs;
    }());
    var RouteArgs = (function () {
        function RouteArgs(source) {
            this.RecievedSubPath = source.RecievedSubPath;
            this.Router = source.Router;
        }
        RouteArgs.EnsureInstance = function (x) {
            if (!utils.IsSpecified(x))
                return null;
            else if (x instanceof RouteArgs)
                return x;
            else
                return new RouteArgs(x);
        };
        RouteArgs.prototype.GenerateRoute = function () {
            return this.Router.Parse(this.RecievedSubPath);
        };
        RouteArgs.AreEqual = function (x, y) {
            return utils.BaseAreEqual(x, y, function (x, y) { return x.RecievedSubPath === y.RecievedSubPath && x.Router === y.Router; });
        };
        return RouteArgs;
    }());
});
define("app/sdc/select/sdc-select", ["require", "exports", "app/utils", "$q", "$timeout", "$parse"], function (require, exports, utils, $q, $timeout, $parse) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.CompiledExpression = new CompiledExpression(_this.Expression, _this.Scope.$parent);
            _this.OptionWrappingClass = OptionBase.CreateClass(function (value) { return _this.CompiledExpression.GetId(value); });
            _this.Void = new _this.OptionWrappingClass(null);
            _this._StickyOptions = [];
            _this.SearchText = "";
            _this.SearchTextWatch = _this.Watch(function () { return _this.SearchText; }, function (searchText) { return _this.ListOpen && _this.Search(searchText); });
            _this.ListOpen = false;
            _this.Attributes.$addClass(Controller_10.Name);
            return _this;
        }
        Controller_10 = Controller;
        Controller.prototype.BindOption = function (option, transcludedScope) {
            this.CompiledExpression.AssignValue(transcludedScope, option.Value);
        };
        Object.defineProperty(Controller.prototype, "PreviousNonVoid", {
            get: function () {
                if (!utils.IsVoid(this._SelectedOption) && !utils.IsVoid(this._SelectedOption.Value))
                    return this._SelectedOption;
                if (!utils.IsVoid(this._PreviousNonVoid) && !utils.IsVoid(this._PreviousNonVoid.Value))
                    return this._PreviousNonVoid;
                return this.Void;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "_SelectedOption", {
            get: function () {
                return this.__SelectedOption;
            },
            set: function (option) {
                this.__SelectedOption = option;
                if (!utils.IsVoid(option) && !utils.IsVoid(option.Value))
                    this._PreviousNonVoid = option;
                if (!this.ListOpen)
                    this.ApplyStickyOptions();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "SelectedOption", {
            get: function () {
                return this._SelectedOption;
            },
            set: function (option) {
                this._SelectedOption = option;
                this.NgModel.$setViewValue(option || this.Void);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Init = function () {
            this.BindToNgModel();
        };
        Controller.prototype.BindToNgModel = function (ngModel) {
            var _this = this;
            if (ngModel === void 0) { ngModel = this.NgModel; }
            ngModel.$parsers.push(function (option) { return option.Value; });
            ngModel.$formatters.push(function (value) { return new _this.OptionWrappingClass(value); });
            ngModel.$render = function () { return _this.RenderNgModel(ngModel); };
        };
        Controller.prototype.RenderNgModel = function (ngModel) {
            this._SelectedOption = ngModel.$viewValue;
            if (!this.Scope.$root.$$phase)
                console.log("No Phase!?");
        };
        Object.defineProperty(Controller.prototype, "StickyOptions", {
            get: function () {
                return this._StickyOptions;
            },
            set: function (value) {
                this._StickyOptions = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.ApplyStickyOptions = function (option) {
            if (option === void 0) { option = this.PreviousNonVoid; }
            var Id = option.Id, Value = option.Value;
            if (utils.IsVoid(Value))
                this.StickyOptions = [];
            else
                this.StickyOptions = [{ Id: Id, Value: Value }];
        };
        Controller.prototype.GetOptions = function (searchText) {
            return this.CompiledExpression.GetOptions(searchText);
        };
        Controller.prototype.Search = function (searchText) {
            var _this = this;
            var thisPromise = this.LoadingOptions = this.GetOptions(searchText)
                .then(function (options) {
                if (_this.LoadingOptions !== thisPromise)
                    return;
                _this.Options = options.map(function (value) { return new _this.OptionWrappingClass(value); }).filter(function (o) { return utils.Collection.IndexOf(_this.StickyOptions, function (so) { return so.Id === o.Id; }) < 0; });
            });
            return thisPromise;
        };
        Object.defineProperty(Controller.prototype, "Options", {
            get: function () {
                return this._Options;
            },
            set: function (value) {
                this._Options = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.CancelSearch = function () {
            this.SearchText = "";
            this.Options = [];
        };
        Controller.prototype.OnListOpen = function () {
            this.ListOpen = true;
            this.CancelSearch();
            this.ApplyStickyOptions();
        };
        Controller.prototype.OnListClose = function () {
            var _this = this;
            this.ListOpen = false;
            this.Options = [];
            $timeout(function () {
                _this.ApplyStickyOptions();
            }, undefined, false);
        };
        Object.defineProperty(Controller.prototype, "IsRequired", {
            get: function () {
                var required = this.Attributes["required"];
                return !!this.Attributes["required"] || required === "";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ShowVoidOption", {
            get: function () {
                return !this.IsRequired;
            },
            enumerable: true,
            configurable: true
        });
        Controller.Name = "sdc-select";
        __decorate([
            utils.Bind.Literal("options")
        ], Controller.prototype, "Expression", void 0);
        __decorate([
            utils.Bind.Literal("search-text")
        ], Controller.prototype, "SearchPlaceolder", void 0);
        __decorate([
            utils.Bind.TranscludeSlot("sdc-void-option-content")
        ], Controller.prototype, "TranscludeVoidOptionContent", void 0);
        __decorate([
            utils.Bind.TranscludeSlot("sdc-option-content")
        ], Controller.prototype, "TranscludeOptionContent", void 0);
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModel", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = Controller_10 = __decorate([
            utils.Component({
                Name: Controller_10.Name,
            })
        ], Controller);
        return Controller;
        var Controller_10;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    var OptionBase = (function () {
        function OptionBase(Value) {
            this.Value = Value;
        }
        Object.defineProperty(OptionBase.prototype, "Id", {
            get: function () {
                if (utils.IsVoid(this.Value))
                    return "void";
                return "option:" + this.GetId(this.Value);
            },
            enumerable: true,
            configurable: true
        });
        OptionBase.CreateClass = function (generateId) {
            return (function (_super) {
                __extends(Option, _super);
                function Option(value) {
                    return _super.call(this, value) || this;
                }
                Option.prototype.GetId = function (value) {
                    return generateId(value);
                };
                return Option;
            }(OptionBase));
        };
        return OptionBase;
    }());
    var CompiledExpression = (function () {
        function CompiledExpression(Expression, Context) {
            var _this = this;
            this.Expression = Expression;
            this.Context = Context;
            var matches = /^\s*([^\s]+?)\s+in\s+([^\s]+)(?:\s+track\s+by\s+([^\s]+?))?\s*$/i.exec(Expression);
            if (!matches)
                throw new Error("Invalid expression: " + Expression);
            var _a = __read(matches, 4), aliasExpression = _a[1], optionsExpression = _a[2], trackByExpression = _a[3];
            if (!aliasExpression || !optionsExpression || (!utils.IsVoid(trackByExpression) && utils.IsNullOrWhitespace(trackByExpression)))
                throw new Error("Invalid expression: " + Expression);
            this.AliasExpression = aliasExpression;
            this.OptionsExpression = optionsExpression;
            this.TrackByExpression = trackByExpression;
            if (aliasExpression) {
                var compiledAlias_1 = $parse(aliasExpression);
                if (compiledAlias_1.assign) {
                    this.AssignValue = function (context, value) {
                        compiledAlias_1.assign(context, value);
                        return context;
                    };
                }
            }
            if (optionsExpression) {
                var compiledOptionsExpression_1 = $parse(optionsExpression);
                this.GetOptions = function (searchText) { return $q.resolve(compiledOptionsExpression_1(_this.Context, { searchText: searchText })); };
            }
            if (trackByExpression) {
                var compiledTrackBy_1 = $parse(trackByExpression);
                this.GetId = function (value) { return compiledTrackBy_1(_this.Context, _this.AssignValue({}, value)); };
            }
        }
        CompiledExpression.prototype.AssignValue = function (context, value) {
            throw new Error(utils.FormatJson(templateObject_23 || (templateObject_23 = __makeTemplateObject(["Expression ", " is not assignable."], ["Expression ", " is not assignable."])), this.AliasExpression));
        };
        CompiledExpression.prototype.GetOptions = function (searchText) {
            throw new Error(utils.FormatJson(templateObject_24 || (templateObject_24 = __makeTemplateObject(["Expression ", " is not valid."], ["Expression ", " is not valid."])), this.OptionsExpression));
        };
        CompiledExpression.prototype.GetId = function (value) {
            return String(value);
        };
        return CompiledExpression;
    }());
    var templateObject_23, templateObject_24;
});
define("app/sdc/sortable/sdc-sortable", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "app/sdc/paginated/sdc-paginated", "module"], function (require, exports, utils, ng_utils_11, service_5, paginated, module_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_9.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.ParentWatch = utils.CreateWatchService(_this.Scope.$parent);
            _this._Direction = service_5.Selcomm.Filters.SortDirection.None;
            _this.Attributes.$addClass("clickable");
            _this.Attributes.$addClass(Controller_11.ClassName);
            var result = /^\s*([^\s]+)(?:\s+as\s+([^\s]+))?\s*$/.exec(_this.Expr);
            if (utils.IsVoid(result) || utils.IsVoid(result[0]))
                throw new Error("Invalid expression for " + Name + ": " + result);
            var _a = __read(result, 2), propertyExpr = _a[0], sortTypeExpr = _a[1];
            if (sortTypeExpr)
                ng_utils_11.$log.warn("The " + Name + "[=\"<property-name> as <sort-type>\"] syntax is no longer supported.");
            var interpolatedProperty = ng_utils_11.$interpolate(propertyExpr);
            var destroyPropertyWatch = _this.ParentWatch(interpolatedProperty, function (prop) { return _this.Property = prop; });
            var handler = function (event) { return _this.SetDirection(event); };
            _this.Element.on("click", handler);
            _this.OnDispose(destroyPropertyWatch);
            _this.OnDispose(function () { return _this.Element.off("click", handler); });
            _this.Direction = Controller_11.ParseSortFromString(_this.InitialDirection);
            _this.Watch.Group({
                Property: function () { return _this.Property; },
                Direction: function () { return _this.Direction; },
                Paginated: function () { return _this.Paginated; },
            }, function (values) { return values.Paginated && _this.ApplySort(values.Paginated, _this.GenerateSort(values.Property, values.Direction)); });
            return _this;
        }
        Controller_11 = Controller;
        Object.defineProperty(Controller.prototype, "Property", {
            get: function () {
                return this._Property;
            },
            set: function (value) {
                var lastValue = this._Property;
                this._Property = value;
                if (lastValue === value)
                    return;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SetDirection = function (event, scope) {
            var _this = this;
            if (scope === void 0) { scope = this.Scope; }
            scope.$apply(function () {
                event.preventDefault();
                var newIndex = (Controller_11.SortOrder.indexOf(_this.Direction) + 1) % Controller_11.SortOrder.length;
                var newValue = Controller_11.SortOrder[newIndex];
                _this.Direction = newValue;
            });
        };
        Controller.prototype.GenerateSort = function (property, direction) {
            if (direction == service_5.Selcomm.Filters.SortDirection.None || !property || utils.IsWhitespace(property)) {
                return null;
            }
            return new SdcSortableSort(this, {
                TargetProperty: property,
                Direction: direction,
            });
        };
        Controller.prototype.ApplySort = function (paginatedController, sort) {
            var _this = this;
            if (utils.IsVoid(sort)) {
                utils.Collection.ArrayRemoveWhere(paginatedController.sorts, function (s) { return SdcSortableSort.GetIsOwnedBy(s, _this); });
                return;
            }
            if (paginatedController.MultiSort) {
                var replaced = utils.Collection.ArrayReplaceWhere(paginatedController.sorts, function (s) { return SdcSortableSort.GetIsOwnedBy(s, _this); }, function () { return sort; });
                if (!utils.Collection.Any(replaced))
                    paginatedController.sorts.push(sort);
                return;
            }
            try {
                for (var _a = __values(utils.Collection.OfType(paginatedController.sorts, SdcSortableSort).filter(function (s) { return !SdcSortableSort.GetIsOwnedBy(s, _this); })), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var sort_1 = _b.value;
                    sort_1.Owner._Direction = service_5.Selcomm.Filters.SortDirection.None;
                }
            }
            catch (e_65_1) { e_65 = { error: e_65_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_65) throw e_65.error; }
            }
            paginatedController.sorts.length = 0;
            paginatedController.sorts.push(sort);
            var e_65, _c;
        };
        Object.defineProperty(Controller.prototype, "Direction", {
            get: function () {
                return this._Direction;
            },
            set: function (value) {
                var lastValue = this._Direction;
                this._Direction = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "DirectionName", {
            get: function () {
                switch (this.Direction) {
                    case service_5.Selcomm.Filters.SortDirection.None:
                        return undefined;
                    default:
                        return Controller_11.FormatSortToString(this.Direction);
                }
            },
            set: function (value) {
                this.Direction = Controller_11.ParseSortFromString(value);
            },
            enumerable: true,
            configurable: true
        });
        Controller.FormatSortToString = function (sortDirection) {
            switch (sortDirection) {
                case service_5.Selcomm.Filters.SortDirection.Ascending:
                    return "ascending";
                case service_5.Selcomm.Filters.SortDirection.Descending:
                    return "descending";
                default:
                    return undefined;
            }
        };
        Controller.ParseSortFromString = function (sortDirection) {
            switch (sortDirection && sortDirection.toUpperCase()) {
                case "ASC":
                case "ASCENDING":
                    return service_5.Selcomm.Filters.SortDirection.Ascending;
                case "DESC":
                case "DESCENDING":
                    return service_5.Selcomm.Filters.SortDirection.Descending;
                default:
                    return service_5.Selcomm.Filters.SortDirection.None;
            }
        };
        Controller.ClassName = utils.SnakeCase(Name);
        Controller.SortOrder = Object.freeze([service_5.Selcomm.Filters.SortDirection.None, service_5.Selcomm.Filters.SortDirection.Ascending, service_5.Selcomm.Filters.SortDirection.Descending]);
        __decorate([
            utils.Bind.Literal(Name)
        ], Controller.prototype, "Expr", void 0);
        __decorate([
            utils.Bind.Literal("initial", { optional: true })
        ], Controller.prototype, "InitialDirection", void 0);
        __decorate([
            utils.Bind.Transclude()
        ], Controller.prototype, "Transclude", void 0);
        __decorate([
            utils.Bind.Controller(paginated.Controller, { mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "Paginated", void 0);
        Controller = Controller_11 = __decorate([
            utils.Component({
                Name: Name,
                Restrict: utils.Target.Attribute,
            })
        ], Controller);
        return Controller;
        var Controller_11;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    var SdcSortableSort = (function (_super) {
        __extends(SdcSortableSort, _super);
        function SdcSortableSort(Owner, args) {
            var _this = _super.call(this, args) || this;
            _this.Owner = Owner;
            utils.SetEnumerability(_this, "Owner", false);
            return _this;
        }
        SdcSortableSort.GetIsOwnedBy = function (sort, owner) {
            return !utils.IsVoid(sort) && sort instanceof SdcSortableSort && sort.Owner === owner;
        };
        return SdcSortableSort;
    }(service_5.Selcomm.Filters.Sort));
});
define("app/sdc/tab/container/sdc-tab-container", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-tab-container";
    var OrderedTab = (function () {
        function OrderedTab(Underlying) {
            this.Underlying = Underlying;
            this.Order = Number.NaN;
        }
        Object.defineProperty(OrderedTab.prototype, "Label", {
            get: function () {
                return this.Underlying.Label;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(OrderedTab.prototype, "Body", {
            get: function () {
                return this.Underlying.Body;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(OrderedTab.prototype, "OrderElement", {
            get: function () {
                return this.Underlying.OrderElement;
            },
            enumerable: true,
            configurable: true
        });
        OrderedTab.prototype.EnsureRenderContents = function () {
            return this.Underlying.EnsureRenderContents();
        };
        Object.defineProperty(OrderedTab.prototype, "RenderContents", {
            get: function () {
                return this.Underlying.RenderContents;
            },
            enumerable: true,
            configurable: true
        });
        return OrderedTab;
    }());
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Registar = new utils.Registar();
            _this.Watch.Collection(function () { return _this.GetOrderedElements(); }, function (orderedElements) { return _this.UpdateTabOrders(); });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "Tabs", {
            get: function () {
                return this.Registar.Items;
            },
            set: function (value) {
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Register = function (tab) {
            this.Registar.Register(new OrderedTab(tab));
            this._UpdateTabOrders();
        };
        Controller.prototype.Unregister = function (tab) {
            this.Registar.UnregisterWhere(function (ot) { return ot.Underlying === tab; });
        };
        Controller.prototype.GetOrderedElements = function () {
            var orderedElements = $().add(this.Registar.Items.map(function (t) { return t.OrderElement; })).toArray();
            var newIndexes = this.Registar.Items.map(function (t) { return orderedElements.indexOf(t.OrderElement); });
            return newIndexes;
        };
        Controller.prototype.UpdateTabOrders = function () {
            this._UpdateTabOrders();
        };
        Controller.prototype._UpdateTabOrders = function (newIndexes) {
            if (newIndexes === void 0) { newIndexes = this.GetOrderedElements(); }
            for (var i = 0; i < newIndexes.length; i++) {
                this.Registar.Items[i].Order = newIndexes[i];
            }
        };
        __decorate([
            utils.Bind.TwoWay(exports.Name, { optional: true })
        ], Controller.prototype, "Tabs", null);
        __decorate([
            utils.Debounce(100)
        ], Controller.prototype, "UpdateTabOrders", null);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/tab/sdc-tab", ["require", "exports", "app/sdc/tab/container/sdc-tab-container", "app/utils", "$timeout"], function (require, exports, container, utils, $timeout) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-tab";
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this._renderContents = false;
            _this.Watch(function () { return _this.Parent; }, function ($new, $old) { return _this.BindToParent($new, $old); });
            _this.Scope.$on("$destroy", function () { return _this.BindToParent(null, _this.Parent); });
            var label = _this.Element.children("sdc-tab-label").contents();
            var body = _this.Element.children("sdc-tab-body").contents();
            _this.Label = utils.TranscludeFn.CreateFromTemplate(label, _this.Scope.$parent, { parentBoundTranscludeFn: _this.Transclude });
            _this.Body = utils.TranscludeFn.CreateFromTemplate(body, _this.Scope.$parent, { parentBoundTranscludeFn: _this.Transclude });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "Self", {
            get: function () {
                return this;
            },
            set: function (value) { },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "OrderElement", {
            get: function () {
                return this.Element[0];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "RenderContents", {
            get: function () {
                return this._renderContents;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.EnsureRenderContents = function () {
            var _this = this;
            if (this._renderContents)
                return;
            $timeout(function () { return _this._renderContents = true; }, 200);
        };
        Controller.prototype.BindToParent = function ($new, $old) {
            if ($old)
                $old.Unregister(this);
            if ($new)
                $new.Register(this);
        };
        Controller.EmptyBody = Object.freeze([]);
        __decorate([
            utils.Bind.TwoWay("tab-as", { optional: true })
        ], Controller.prototype, "Self", null);
        __decorate([
            utils.Bind.Controller(container.Controller, { mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "Parent", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/table/sdc-table", ["require", "exports", "app/utils", "$mdTheming", "$compile", "$mdUtil", "module"], function (require, exports, utils, $mdTheming, $compile, $mdUtil, module_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Priority = 100;
    exports.Name = utils.SnakeCase(utils.GetComponentNameFromModuleId(module_10.id));
    utils.Directive({
        Name: exports.Name,
        Restrict: utils.Target.Attribute,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
        Priority: 100,
        Transclude: utils.TransclusionMode.Element,
        OnLink: [$element, $attrs, $transclude, $scope, function ($element, $attrs, $transclude, $scope) {
                var wrapper = utils.Element.Create("sdc-table", { "apply-theming-to-children": "" }).insertAfter($element);
                $compile(wrapper)($scope.$new(), null, { parentBoundTranscludeFn: $transclude });
            }],
    });
    utils.Directive({
        Name: exports.Name,
        Restrict: utils.Target.Element,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
        OnLink: [$element, $transclude, $attrs, function ($element, $transclude, $attrs) {
                $attrs.$addClass(exports.Name);
                if ($mdUtil.parseAttributeBoolean($attrs["apply-theming-to-children"]))
                    $mdTheming($element.children());
                else
                    $mdTheming($element);
                if ($transclude)
                    $transclude(function (clone) { return $element.append(clone); });
            }],
    });
    utils.Directive(exports.Name, {
        Name: "thead",
        Restrict: utils.Target.Element,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
        OnLink: function (scope, $element, $attrs) {
            if (!$element.is("." + exports.Name + " > table > thead"))
                return;
            $mdTheming($element);
        }
    });
});
define("app/sdc/tile/accent", ["require", "exports", "app/basic-utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AccentNames = Object.freeze(["lime", "cyan", "magenta", "red", "green", "orange", "emerald", "amber", "olive", "cobolt", "violet"]);
    function GetRandomAccentFor(seed) {
        return utils.GetRandomFor(exports.AccentNames, seed);
    }
    exports.GetRandomAccentFor = GetRandomAccentFor;
    ;
});
define("app/sdc/assign/classes/sdc-assign-classes", ["require", "exports", "app/utils", "app/sdc/matcher/sdc-matcher"], function (require, exports, utils, Matcher) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function CreateDirective(controller, assign, regexOrFn) {
        var matcher = Matcher.Create(regexOrFn);
        utils.Directive({
            Name: utils.GetComponentName(controller),
            Scope: utils.ScopeMode.ParentScope,
            Template: null,
            Require: utils.GetComponentName(controller),
            OnLink: ["$controllers", "$attrs", function (controller, $attrs) {
                    $attrs.$observe("class", updateClasses);
                    function updateClasses(classString) {
                        var allMatches = [];
                        try {
                            for (var _a = __values(String(classString).split(/\s+/).map(matcher)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                var arr = _b.value;
                                allMatches.push.apply(allMatches, __spread(arr));
                            }
                        }
                        catch (e_66_1) { e_66 = { error: e_66_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_66) throw e_66.error; }
                        }
                        assign(controller, allMatches);
                        var e_66, _c;
                    }
                }]
        });
    }
    exports.CreateDirective = CreateDirective;
    function AssignClasses(assign, regexOrFn) {
        return function (target) { return void CreateDirective(target, assign, regexOrFn); };
    }
    exports.AssignClasses = AssignClasses;
});
define("app/sdc/toggle/group/sdc-toggle-group", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller() {
            this.items = [];
        }
        Controller.prototype.register = function (item) {
            var _this = this;
            if (this.items.indexOf(item))
                this.items.push(item);
            return function () { return _this.unregister(item); };
        };
        Controller.prototype.unregister = function (item) {
            var i = this.items.indexOf(item);
            if (i >= 0) {
                this.items.splice(i, 1);
            }
        };
        Controller.prototype.close = function (predicate) {
            this.items.filter(predicate || (function (item) { return true; })).forEach(function (item) { return item.IsOpen = false; });
        };
        Controller = __decorate([
            utils.Component({
                Name: "sdc-toggle-group",
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
                Restrict: utils.Target.ElementOrAttribute,
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/toggle/sdc-toggle", ["require", "exports", "app/sdc/assign/classes/sdc-assign-classes", "app/sdc/toggle/group/sdc-toggle-group", "constant!sdc-md-palette-classes", "app/utils", "template!sdc-toggle-template", "$compile"], function (require, exports, sdc_assign_classes_1, group, paletteClasses, utils, template, $compile) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Loaded = false;
            _this.Attributes.$addClass(Controller_12.Name);
            if (_this.StartOpen)
                _this.IsOpen = _this.StartOpen();
            var label = _this.Element.children("sdc-toggle-label").contents();
            var body = _this.Element.children("sdc-toggle-body").contents();
            _this.Label = utils.TranscludeFn.CreateFromTemplate(label, _this.Scope.$parent, { parentBoundTranscludeFn: _this.Transclude });
            _this.Body = utils.TranscludeFn.CreateFromTemplate(body, _this.Scope.$parent, { parentBoundTranscludeFn: _this.Transclude });
            _this.Element.empty();
            $compile(template)(_this.Scope, function (clone) { return _this.Element.append(clone); }, { futureParentElement: _this.Element, parentBoundTranscludeFn: _this.Transclude });
            return _this;
        }
        Controller_12 = Controller;
        Controller.prototype.Toggle = function () {
            this.IsOpen = !this.IsOpen;
        };
        Controller.prototype.BindToGroup = function () {
            var _this = this;
            var group = this.DirectGroup;
            var parentGroup = utils.IsVoid(this.Parent) ? null : this.Parent.DirectGroup;
            var boundToGroup = true;
            if (group && parentGroup !== group)
                this.UnregisterFromGroup = group.register(this);
            else
                boundToGroup = false;
            this.Watch(function () { return _this.IsOpen; }, function (isOpen) {
                if (!isOpen)
                    return;
                _this.Loaded = true;
                if (boundToGroup && group)
                    group.close(function (other) { return other !== _this; });
            });
        };
        Controller.prototype.Dispose = function () {
            _super.prototype.Dispose.call(this);
            if (this.UnregisterFromGroup)
                this.UnregisterFromGroup();
        };
        Controller.Name = "sdc-toggle";
        __decorate([
            utils.Bind.Getter("start-open")
        ], Controller.prototype, "StartOpen", void 0);
        __decorate([
            utils.Bind.TwoWay("is-open", { optional: true })
        ], Controller.prototype, "IsOpen", void 0);
        __decorate([
            utils.Bind.Controller(group.Controller, { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "DirectGroup", void 0);
        __decorate([
            utils.Bind.Controller(Controller_12.Name, { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "Parent", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "BindToGroup", null);
        Controller = Controller_12 = __decorate([
            sdc_assign_classes_1.AssignClasses(function (ctrl, matches) { return ctrl.ButtonClasses = matches; }, [paletteClasses, "md-raised"]),
            utils.Component({
                Name: Controller_12.Name,
                Template: null,
            })
        ], Controller);
        return Controller;
        var Controller_12;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/transclude/sdc-transclude", ["require", "exports", "$animate", "$q", "$compile", "app/utils"], function (require, exports, $animate, $q, $compile, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MissingTranscludeError = (function (_super) {
        __extends(MissingTranscludeError, _super);
        function MissingTranscludeError(TargetElement) {
            var _this = _super.call(this, 'Illegal use of sdcTransclude directive in the template! No parent directive that requires a transclusion found.') || this;
            _this.TargetElement = TargetElement;
            return _this;
        }
        Object.defineProperty(MissingTranscludeError.prototype, "$element", {
            get: function () { return this.TargetElement; },
            enumerable: true,
            configurable: true
        });
        MissingTranscludeError = __decorate([
            utils.FixExtendBuiltIn
        ], MissingTranscludeError);
        return MissingTranscludeError;
    }(Error));
    exports.MissingTranscludeError = MissingTranscludeError;
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.FallbackLinkFn = $compile(_this.Element.contents());
            _this.Element.empty();
            return _this;
        }
        Controller_13 = Controller;
        Controller.prototype.TranscludeContents = function (cloneAttachFn) {
            var _this = this;
            var transcludeFn = this.BoundTranscludeFn || this.Transclude;
            if (!transcludeFn)
                throw new MissingTranscludeError(this.Element);
            transcludeFn(function (clone, scope) { return _this.RenderTranscludedContents(clone, scope); }, null, this.SlotName);
            if (this.SlotName && !transcludeFn.isSlotFilled(this.SlotName))
                this.UseFallbackContent();
        };
        Controller.prototype.Init = function () {
            var _this = this;
            this.TranscludeContents(function (clone, scope) { return _this.RenderContents(clone, scope); });
        };
        Controller.prototype.RenderTranscludedContents = function (clone, scope) {
            if (!Controller_13.IsWhitespace(clone))
                this.RenderContents(clone, scope);
            else {
                this.UseFallbackContent();
                scope.$destroy();
            }
        };
        Controller.prototype.RenderContents = function (clone, scope) {
            var deferred = $q.defer();
            if (this.LegacyInit) {
                var result = this.LegacyInit({
                    $scope: scope,
                    $elements: {
                        clone: clone,
                        parent: this.Element
                    },
                    $promise: deferred.promise
                });
                if (utils.IsDefined(result) && !result)
                    return;
            }
            $animate.enter(clone, this.Element).then(deferred.resolve, deferred.reject, deferred.notify);
            this.OnTransclude({
                scope: scope,
                element: clone,
                parent: this.Element,
                animation: deferred.promise,
            });
        };
        Controller.prototype.UseFallbackContent = function () {
            var _this = this;
            this.FallbackLinkFn(this.Scope, function (clone, scope) { return _this.RenderContents(clone, scope); });
        };
        Controller.IsWhitespace = function (nodes) {
            for (var i = 0, len = nodes.length; i < len; i++) {
                var node = nodes[i];
                if (node.nodeType !== 3 || node.nodeValue.trim())
                    return false;
            }
            return true;
        };
        Controller.Name = "sdc-transclude";
        __decorate([
            utils.Bind.Getter("init", { optional: true })
        ], Controller.prototype, "LegacyInit", void 0);
        __decorate([
            utils.Bind.Getter("on-transclude")
        ], Controller.prototype, "OnTransclude", void 0);
        __decorate([
            utils.Bind.In("transclude-fn", { optional: true })
        ], Controller.prototype, "BoundTranscludeFn", void 0);
        __decorate([
            utils.Bind.Literal(Controller_13.Name)
        ], Controller.prototype, "SlotName", void 0);
        __decorate([
            utils.OnLink(utils.LinkMode.Post)
        ], Controller.prototype, "Init", null);
        Controller = Controller_13 = __decorate([
            utils.Component({
                Name: Controller_13.Name,
                Terminal: true,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
                Restrict: utils.Target.ElementOrAttribute,
            })
        ], Controller);
        return Controller;
        var Controller_13;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/update/sdc-update", ["require", "exports", "app/sdc/crud/sdc-crud"], function (require, exports, Crud) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    Crud.SubComponent("sdc-update");
});
define("app/sdc/utilities/sdc-utilities-service", ["require", "exports", "app/basic-utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var html;
    (function (html) {
        function percent(fractionOrValue, MaxOrCollection) {
            return percent.fromFraction(percent.raw(fractionOrValue, MaxOrCollection));
        }
        html.percent = percent;
        (function (percent) {
            function raw(fractionOrValue, MaxOrCollection) {
                var fraction;
                var max;
                if (arguments.length === 2) {
                    if (utils.IsArray(MaxOrCollection)) {
                        try {
                            for (var MaxOrCollection_1 = __values(MaxOrCollection), MaxOrCollection_1_1 = MaxOrCollection_1.next(); !MaxOrCollection_1_1.done; MaxOrCollection_1_1 = MaxOrCollection_1.next()) {
                                var value = MaxOrCollection_1_1.value;
                                if (utils.IsUndefined(max) || value > max)
                                    max = value;
                            }
                        }
                        catch (e_67_1) { e_67 = { error: e_67_1 }; }
                        finally {
                            try {
                                if (MaxOrCollection_1_1 && !MaxOrCollection_1_1.done && (_a = MaxOrCollection_1.return)) _a.call(MaxOrCollection_1);
                            }
                            finally { if (e_67) throw e_67.error; }
                        }
                    }
                    else {
                        max = MaxOrCollection;
                    }
                    fraction = !fractionOrValue ? 0 : fractionOrValue / max;
                }
                return fraction;
                var e_67, _a;
            }
            percent.raw = raw;
            function fromFraction(fraction) {
                return fraction * 100 + "%";
            }
            percent.fromFraction = fromFraction;
            function inverse(fractionOrValue, MaxOrCollection) {
                return fromFraction(1 - raw(fractionOrValue, MaxOrCollection));
            }
            percent.inverse = inverse;
        })(percent = html.percent || (html.percent = {}));
    })(html = exports.html || (exports.html = {}));
    var section;
    (function (section) {
        var onSectionCloseMethod = "\u00BBsection_onClose";
        function onClose($scope, handler) {
            if (handler)
                return $scope[onSectionCloseMethod] = handler;
            else
                return $scope[onSectionCloseMethod];
        }
        section.onClose = onClose;
        function close($scope) {
            var current = $scope;
            while (current) {
                if (angular.isFunction(current[onSectionCloseMethod])) {
                    current[onSectionCloseMethod]();
                    return true;
                }
                else {
                    current = current.$parent;
                }
            }
            return false;
        }
        section.close = close;
    })(section = exports.section || (exports.section = {}));
});
define("app/sdc/validation/sdc-validation-service", ["require", "exports", "app/utils", "app/ng-utils"], function (require, exports, utils, ng_utils_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function AttachAsyncValidator(target, validatorKey, validator, delay) {
        if (delay === void 0) { delay = 200; }
        var currentRequest;
        target.$asyncValidators[validatorKey] = CallUnderlyingValidator;
        return DestroyValidator;
        function CallUnderlyingValidator(modelValue, viewValue) {
            return __awaiter(this, void 0, ng_utils_12.$q, function () {
                var thisRequest, _a, result, _b, err_12, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            thisRequest = currentRequest = new utils.Deferred();
                            if (!!utils.IsVoid(delay)) return [3, 2];
                            return [4, utils.Delay(delay)];
                        case 1:
                            _d.sent();
                            _d.label = 2;
                        case 2:
                            if (!(thisRequest !== currentRequest)) return [3, 4];
                            _a = HandleResult;
                            return [4, currentRequest.Promise];
                        case 3: return [2, _a.apply(void 0, [_d.sent()])];
                        case 4:
                            _d.trys.push([4, 8, , 11]);
                            return [4, validator(modelValue, viewValue)];
                        case 5:
                            result = _d.sent();
                            if (!(thisRequest !== currentRequest)) return [3, 7];
                            _b = HandleResult;
                            return [4, currentRequest.Promise];
                        case 6: return [2, _b.apply(void 0, [_d.sent()])];
                        case 7: return [3, 11];
                        case 8:
                            err_12 = _d.sent();
                            if (!(thisRequest !== currentRequest)) return [3, 10];
                            _c = HandleResult;
                            return [4, currentRequest.Promise];
                        case 9: return [2, _c.apply(void 0, [_d.sent()])];
                        case 10: throw err_12;
                        case 11: return [2, HandleResult(result)];
                    }
                });
            });
        }
        function HandleResult(result) {
            if (result)
                return ng_utils_12.$q.resolve();
            else
                return ng_utils_12.$q.reject();
        }
        function DestroyValidator() {
            if (target.$asyncValidators[validatorKey] !== CallUnderlyingValidator)
                return;
            delete target.$asyncValidators[validatorKey];
        }
        ;
    }
    exports.AttachAsyncValidator = AttachAsyncValidator;
});
define("app/sdc/visibility/sdc-visibility", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_11.id);
    var SnakeCasedName = utils.SnakeCase(Name);
    var VisibilityState;
    (function (VisibilityState) {
        VisibilityState["Collapse"] = "collapse";
        VisibilityState["Hidden"] = "hidden";
        VisibilityState["Inherit"] = "inherit";
        VisibilityState["Initial"] = "initial";
        VisibilityState["Unset"] = "unset";
        VisibilityState["Visible"] = "visible";
    })(VisibilityState = exports.VisibilityState || (exports.VisibilityState = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch(function () { return _this.State; }, function (state) { return _this.ApplyClasses(state); });
            return _this;
        }
        Controller_14 = Controller;
        Controller.ClassNameForState = function (state) {
            switch (state) {
                case VisibilityState.Collapse:
                case VisibilityState.Hidden:
                case VisibilityState.Inherit:
                case VisibilityState.Initial:
                case VisibilityState.Unset:
                case VisibilityState.Visible:
                    return SnakeCasedName + "-" + state;
            }
        };
        Controller.prototype.ApplyClasses = function (state) {
            if (state === true)
                return this.ApplyClasses(VisibilityState.Visible);
            if (state === false)
                return this.ApplyClasses(VisibilityState.Hidden);
            var newClass = utils.IsVoid(state) ? null : Controller_14.ClassNameForState(state);
            var oldClasses = Controller_14.AllClasses.filter(function (cn) { return cn !== newClass; });
            try {
                for (var oldClasses_1 = __values(oldClasses), oldClasses_1_1 = oldClasses_1.next(); !oldClasses_1_1.done; oldClasses_1_1 = oldClasses_1.next()) {
                    var oldClass = oldClasses_1_1.value;
                    this.Attributes.$removeClass(oldClass);
                }
            }
            catch (e_68_1) { e_68 = { error: e_68_1 }; }
            finally {
                try {
                    if (oldClasses_1_1 && !oldClasses_1_1.done && (_a = oldClasses_1.return)) _a.call(oldClasses_1);
                }
                finally { if (e_68) throw e_68.error; }
            }
            if (!utils.IsVoid(newClass))
                this.Attributes.$addClass(newClass);
            var e_68, _a;
        };
        Controller.AllClasses = Object.freeze([VisibilityState.Collapse, VisibilityState.Hidden, VisibilityState.Inherit, VisibilityState.Initial, VisibilityState.Unset, VisibilityState.Visible].map(function (sn) { return Controller_14.ClassNameForState(sn); }));
        __decorate([
            utils.Bind.In(SnakeCasedName)
        ], Controller.prototype, "State", void 0);
        Controller = Controller_14 = __decorate([
            utils.Component({
                Name: Name,
                Restrict: utils.Target.Attribute,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
        var Controller_14;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sdc/window/sdc-window", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WindowOpenOptions = (function () {
        function WindowOpenOptions(options) {
            if (angular.isObject(options)) {
                this.left = options.left;
                this.top = options.top;
                this.height = options.height;
                this.width = options.width;
            }
        }
        WindowOpenOptions.prototype.toString = function () {
            var parts = [];
            angular.forEach(this, function (value, key) {
                if (value || value === 0)
                    parts.push(key + "=" + value);
            });
            return parts.join(",");
        };
        return WindowOpenOptions;
    }());
    exports.WindowOpenOptions = WindowOpenOptions;
});
define("app/sds/address/sds-address", ["require", "exports", "app/utils", "app/ng-utils", "module"], function (require, exports, utils, ng_utils_13, module_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_12.id);
    var priority = 0;
    var priorityModifier = 210;
    var foo;
    utils.Directive({
        Name: Name,
        Terminal: true,
        Scope: utils.ScopeMode.NewInheritedScope,
        Template: null,
        Restrict: utils.Target.Element | utils.Target.Attribute,
        Priority: priority + priorityModifier,
        Require: "^^?sdsAddressSelect",
        OnLink: function ($scope, $element, $attrs, sdsAddressSelect, $transclude) {
            if (sdsAddressSelect) {
                angular.extend($scope, {
                    "_$sdsAddressSelectController": sdsAddressSelect
                });
                $attrs.$set("ngModel", "_$sdsAddressSelectController.newAddress");
                $attrs.$set("ngRequired", "_$sdsAddressSelectController.required");
            }
            ng_utils_13.$compile($element, null, priority + priorityModifier)($scope, null, { parentBoundTranscludeFn: $transclude });
        }
    });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super.call(this) || this;
        }
        Object.defineProperty(Controller.prototype, "ManualInput", {
            get: function () {
                return !!this.manualInput;
            },
            set: function (value) {
                this.manualInput = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Required", {
            get: function () {
                return utils.IsDefined(this.Attributes["required"]);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Address", {
            get: function () {
                return this._Address;
            },
            set: function (value) {
                this._Address = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Init = function () {
            var _this = this;
            if (!this.NgModelController)
                return;
            var ngModelCtrl = this.NgModelController;
            this.NgModelController.$render = function () { return _this.Address = ngModelCtrl.$viewValue; };
            this.Watch(function () { return _this.Address; }, function (newAddress) { return ngModelCtrl.$setViewValue(newAddress, "default"); });
            this.Attributes.$set("tabindex", -1);
        };
        Object.defineProperty(Controller.prototype, "IsInvalid", {
            get: function () {
                return this.NgModelController && this.NgModelController.$invalid;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsTouched", {
            get: function () {
                return (this.NgModelController && this.NgModelController.$touched) || utils.Form.IsSubmitted(this.ParentForm);
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Controller("ng-model", { optional: true })
        ], Controller.prototype, "NgModelController", void 0);
        __decorate([
            utils.Bind.Controller("form", { optional: true, mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "ParentForm", void 0);
        __decorate([
            utils.Bind.TwoWay("manual-input")
        ], Controller.prototype, "manualInput", void 0);
        __decorate([
            utils.Bind.Transclude()
        ], Controller.prototype, "Transclude", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = __decorate([
            utils.Component({
                Name: Name,
                Restrict: utils.Target.Element | utils.Target.Attribute,
                Priority: priority,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/address/utils", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service"], function (require, exports, utils, ng_utils_14, service_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SelcommAddressBase = service_6.Selcomm.Address.Address;
    exports.SelcommAddress = service_6.Selcomm.Address.ExtendedAddress;
    function FormatAddress(addr, lineSeperator) {
        if (lineSeperator === void 0) { lineSeperator = ", "; }
        if (!addr)
            return undefined;
        var unitSection = EmptyVoids(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", " ", "", ""], ["", " ", "", ""])), addr.UnitType, addr.UnitNumber, addr.UnitNumberSuffix);
        var levelSection = EmptyVoids(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", " ", "", ""], ["", " ", "", ""])), addr.LevelType, addr.LevelNumber, addr.LevelNumberSuffix);
        var unitAndLevelSpecified = !utils.IsWhitespace(unitSection) && !utils.IsWhitespace(levelSection);
        var formatted = EmptyVoids(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n", " ", " ", "\n", "\n", "\n", " ", "", " ", "", "", " ", " ", " ", "", " ", " ", "", "\n", " ", " ", ""], ["\n", " ", " ", "\n", "\n", "\n", " ", "", " ", "", "", " ", " ", " ", "", " ", " ", "", "\n", " ", " ", ""])), addr.FindingTitle, addr.FindingName, addr.FindingName2, addr.Company, addr.BuildingName, addr.POBoxType, addr.POBoxNumberPrefix, addr.POBoxNumber, unitSection, unitAndLevelSpecified ? "\r\n" : "", levelSection, utils.IsNotNullOrWhitespace(addr.LotNumber) ? "Lot" : "", addr.LotNumber, addr.StreetNumber, addr.StreetNumberSuffix, addr.StreetName, addr.StreetType, addr.StreetTypeSuffix, addr.Suburb, addr.State && addr.State.Code, addr.PostCode && addr.PostCode.Code).replace(/^[^\S\r\n]+|[^\S\r\n]+$/mg, "")
            .replace(/^[\r\n]+|[\r\n]+$/g, "")
            .replace(/[\r\n]+/g, lineSeperator)
            .replace(/[^\S\r\n]+/g, " ");
        return formatted;
    }
    exports.FormatAddress = FormatAddress;
    function EmptyVoids(literals) {
        var placeholders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            placeholders[_i - 1] = arguments[_i];
        }
        return utils.FormatTemplateString(function (x) { return utils.IsVoid(x) ? "" : x; }, literals, placeholders);
    }
    function ParseAddressText(addressText) {
        return __awaiter(this, void 0, ng_utils_14.$q, function () {
            var address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!utils.IsObject(addressText))
                            addressText = new service_6.Selcomm.Address.AddressSimple({ Address: addressText });
                        return [4, service_6.CachedService.Address.ParseSimpleAddress({
                                SimpleAddress: addressText,
                            })];
                    case 1:
                        address = _a.sent();
                        return [2, address];
                }
            });
        });
    }
    exports.ParseAddressText = ParseAddressText;
    function GetAddressMatches(searchString, limitTo) {
        if (limitTo === void 0) { limitTo = 15; }
        return __awaiter(this, void 0, ng_utils_14.$q, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_6.CachedService.Address.AutoComplete({
                            PartialAddress: searchString,
                            MaximumResultCount: limitTo,
                        })];
                    case 1: return [2, (_a.sent()).Items];
                }
            });
        });
    }
    exports.GetAddressMatches = GetAddressMatches;
    function GetStreetTypes() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_6.CachedService.Address.StreetTypeList({})];
                    case 1: return [2, (_a.sent()).Items];
                }
            });
        });
    }
    exports.GetStreetTypes = GetStreetTypes;
    var Locality = (function () {
        function Locality(Name, PostalCode) {
            this.Name = Name;
            this.PostalCode = PostalCode;
            this.States = new Array();
        }
        Locality.CreateFromSelcommLocality = function (selcommLocality) {
            return new Locality(selcommLocality.Name, selcommLocality.Code);
        };
        return Locality;
    }());
    exports.Locality = Locality;
    (function (Locality) {
        var State = (function () {
            function State(Id, StateCode, SortIndex, Owner) {
                this.Id = Id;
                this.StateCode = StateCode;
                this.SortIndex = SortIndex;
                this.Owner = Owner;
            }
            State.CreateFromSelcommLocality = function (selcommLocality, owner) {
                return new State(selcommLocality.Ref, selcommLocality.StateCode, selcommLocality.SortIndex, owner);
            };
            return State;
        }());
        Locality.State = State;
    })(Locality = exports.Locality || (exports.Locality = {}));
    exports.Locality = Locality;
    function GetLocalities(postalCode) {
        return __awaiter(this, void 0, ng_utils_14.$q, function () {
            var selcommLocalities, localities, localitiesByName, selcommLocalities_1, selcommLocalities_1_1, selcommLocality, locality, localityState, e_69, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!postalCode)
                            return [2, []];
                        return [4, service_6.CachedService.Address.LocalityListByPostCode({ PostCode: postalCode })];
                    case 1:
                        selcommLocalities = (_b.sent()).Items;
                        localities = utils.Collection
                            .Distinct(selcommLocalities
                            .map(function (sl) { return Locality.CreateFromSelcommLocality(sl); }), function (x, y) { return x.Name === y.Name && x.PostalCode == y.PostalCode; })
                            .map(function (l) { return [l.Name, l]; });
                        localitiesByName = new Map(localities);
                        try {
                            for (selcommLocalities_1 = __values(selcommLocalities), selcommLocalities_1_1 = selcommLocalities_1.next(); !selcommLocalities_1_1.done; selcommLocalities_1_1 = selcommLocalities_1.next()) {
                                selcommLocality = selcommLocalities_1_1.value;
                                locality = localitiesByName.get(selcommLocality.Name);
                                localityState = Locality.State.CreateFromSelcommLocality(selcommLocality, locality);
                                locality.States.push(localityState);
                            }
                        }
                        catch (e_69_1) { e_69 = { error: e_69_1 }; }
                        finally {
                            try {
                                if (selcommLocalities_1_1 && !selcommLocalities_1_1.done && (_a = selcommLocalities_1.return)) _a.call(selcommLocalities_1);
                            }
                            finally { if (e_69) throw e_69.error; }
                        }
                        return [2, __spread(localitiesByName.values())];
                }
            });
        });
    }
    exports.GetLocalities = GetLocalities;
    function GetStates(postalCode, locality) {
        return __awaiter(this, void 0, ng_utils_14.$q, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!postalCode || !locality)
                            return [2, []];
                        return [4, service_6.CachedService.Address.StateListByPostCodeLocality({
                                PostCode: postalCode,
                                Locality: locality,
                            })];
                    case 1: return [2, (_a.sent()).Items];
                }
            });
        });
    }
    exports.GetStates = GetStates;
    function AsComparable(addr) {
        var _a, _b, key, comparable, e_70_1, e_70, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (utils.IsVoid(addr))
                        addr = new exports.SelcommAddress();
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, 7, 8]);
                    _a = __values(Object.keys(addr).sort()), _b = _a.next();
                    _d.label = 2;
                case 2:
                    if (!!_b.done) return [3, 5];
                    key = _b.value;
                    comparable = FormatPropertyForCompare(addr, key);
                    if (!comparable) return [3, 4];
                    return [4, comparable];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _b = _a.next();
                    return [3, 2];
                case 5: return [3, 8];
                case 6:
                    e_70_1 = _d.sent();
                    e_70 = { error: e_70_1 };
                    return [3, 8];
                case 7:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_70) throw e_70.error; }
                    return [7];
                case 8: return [2];
            }
        });
    }
    function FormatPropertyForCompare(address, PropertyName) {
        switch (PropertyName) {
            case "AddressType":
            case "Created":
            case "CreatedBy":
            case "Id":
            case "InValid":
            case "LastUpdated":
            case "Ref":
            case "RestrictedPropertiesNames":
            case "UpdatedBy":
                return null;
            case "State":
            case "PostCode":
            case "Country":
                var code = FormatValueForCompare(address[PropertyName] && address[PropertyName].Code);
                return { PropertyName: PropertyName, Value: code };
            default:
                var Value = FormatValueForCompare(address[PropertyName]);
                return { PropertyName: PropertyName, Value: Value };
        }
    }
    function FormatValueForCompare(value) {
        if (utils.IsVoid(value))
            return value;
        if (utils.IsString(value)) {
            if (utils.IsWhitespace(value))
                return null;
            return value.trim();
        }
        if (utils.IsNumber(value))
            return value;
        if (!value)
            return null;
        return value;
    }
    function AreSame(x, y) {
        if (utils.IsVoid(x) && utils.IsVoid(y))
            return true;
        var properties = utils.Collection.IterateTogether({ x: AsComparable(x), y: AsComparable(y) });
        try {
            for (var properties_1 = __values(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
                var property = properties_1_1.value;
                if (property.x.done || property.y.done)
                    return false;
                if (property.x.value.PropertyName !== property.y.value.PropertyName)
                    return false;
                if (property.x.value.Value !== property.y.value.Value)
                    return false;
            }
        }
        catch (e_71_1) { e_71 = { error: e_71_1 }; }
        finally {
            try {
                if (properties_1_1 && !properties_1_1.done && (_a = properties_1.return)) _a.call(properties_1);
            }
            finally { if (e_71) throw e_71.error; }
        }
        return true;
        var e_71, _a;
    }
    exports.AreSame = AreSame;
    function IsPoBox(address) {
        if (!address)
            return false;
        return utils.Collection.Any([address.POBoxNumber, address.POBoxNumberPrefix, address.POBoxNumberPrefix, address.POBoxNumberSuffix, address.POBoxType], utils.IsNotNullOrWhitespace);
    }
    exports.IsPoBox = IsPoBox;
    var templateObject_25, templateObject_26, templateObject_27;
});
define("app/sds/charge/charge-utils", ["require", "exports", "app/utils", "app/selcomm/service", "filter!number"], function (require, exports, utils, service_7, numberFilter) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ChargeFrequency;
    (function (ChargeFrequency) {
        function ShortDisplayName(value) {
            if (utils.IsObject(value))
                value = value.Frequency;
            switch (value) {
                default:
                    if (utils.HasProp(service_7.Selcomm.Charges.ChargeFrequency, value))
                        throw new Error("Unsupported charge frequency: " + value + "/" + service_7.Selcomm.Charges.ChargeFrequency[value]);
                    throw new TypeError("Unknown charge frequency " + value);
                case service_7.Selcomm.Charges.ChargeFrequency.OneOff:
                    return "";
                case service_7.Selcomm.Charges.ChargeFrequency.Daily:
                    return "p/d";
                case service_7.Selcomm.Charges.ChargeFrequency.Weekly:
                    return "p/w";
                case service_7.Selcomm.Charges.ChargeFrequency.Fortnightly:
                    return "p/fn";
                case service_7.Selcomm.Charges.ChargeFrequency.Monthly:
                    return "p/m";
                case service_7.Selcomm.Charges.ChargeFrequency.Quarterly:
                    return "p/qt";
                case service_7.Selcomm.Charges.ChargeFrequency.Biennially:
                    return LongDisplayName(value);
                case service_7.Selcomm.Charges.ChargeFrequency.Annually:
                    return "p/a";
                case service_7.Selcomm.Charges.ChargeFrequency.LunarMonthly:
                case service_7.Selcomm.Charges.ChargeFrequency.BiMonthly:
                case service_7.Selcomm.Charges.ChargeFrequency.BiAnnually:
                case service_7.Selcomm.Charges.ChargeFrequency.TriAnnually:
                    return LongDisplayName(value);
            }
        }
        ChargeFrequency.ShortDisplayName = ShortDisplayName;
        function LongDisplayName(value) {
            if (utils.IsObject(value))
                value = value.Frequency;
            switch (value) {
                default:
                    if (utils.HasProp(service_7.Selcomm.Charges.ChargeFrequency, value))
                        throw new Error("Unsupported charge frequency: " + value + "/" + service_7.Selcomm.Charges.ChargeFrequency[value]);
                    throw new TypeError("Unknown charge frequency " + value);
                case service_7.Selcomm.Charges.ChargeFrequency.OneOff:
                    return "";
                case service_7.Selcomm.Charges.ChargeFrequency.Daily:
                    return "per day";
                case service_7.Selcomm.Charges.ChargeFrequency.Weekly:
                    return "per week";
                case service_7.Selcomm.Charges.ChargeFrequency.Fortnightly:
                    return "per fortnight";
                case service_7.Selcomm.Charges.ChargeFrequency.Monthly:
                    return "per month";
                case service_7.Selcomm.Charges.ChargeFrequency.LunarMonthly:
                    return "per lunar month";
                case service_7.Selcomm.Charges.ChargeFrequency.BiMonthly:
                    return "every two months";
                case service_7.Selcomm.Charges.ChargeFrequency.Quarterly:
                    return "per quarter";
                case service_7.Selcomm.Charges.ChargeFrequency.Biennially:
                    return "every two years";
                case service_7.Selcomm.Charges.ChargeFrequency.Annually:
                    return "per annum";
                case service_7.Selcomm.Charges.ChargeFrequency.BiAnnually:
                    return "every six months";
                case service_7.Selcomm.Charges.ChargeFrequency.TriAnnually:
                    return "every four months";
            }
        }
        ChargeFrequency.LongDisplayName = LongDisplayName;
    })(ChargeFrequency = exports.ChargeFrequency || (exports.ChargeFrequency = {}));
    function ChargeTotals(charges) {
        var map = utils.MakeNumberedCollection();
        try {
            for (var charges_1 = __values(charges), charges_1_1 = charges_1.next(); !charges_1_1.done; charges_1_1 = charges_1.next()) {
                var charge = charges_1_1.value;
                if (utils.IsVoid(charge))
                    continue;
                if (charge.Frequency === service_7.Selcomm.Charges.ChargeFrequency.NumberOfTimes)
                    throw new Error("Number of times charges not support at this time");
                if (charge instanceof MergedCharge)
                    map[charge.Frequency] = (map[charge.Frequency] || 0) + charge.TotalAmount;
                else if (utils.HasProp(charge, "ChargeAmount"))
                    map[charge.Frequency] = (map[charge.Frequency] || 0) + charge.ChargeAmount + charge.ChargeAmountTax;
                else
                    map[charge.Frequency] = (map[charge.Frequency] || 0) + charge.Price + charge.Tax;
            }
        }
        catch (e_72_1) { e_72 = { error: e_72_1 }; }
        finally {
            try {
                if (charges_1_1 && !charges_1_1.done && (_a = charges_1.return)) _a.call(charges_1);
            }
            finally { if (e_72) throw e_72.error; }
        }
        return Object
            .keys(map)
            .map(Number)
            .sort()
            .map(function (freq) { return new MergedCharge(freq, map[freq]); });
        var e_72, _a;
    }
    exports.ChargeTotals = ChargeTotals;
    var MergedCharge = (function () {
        function MergedCharge(Frequency, TotalAmount) {
            this.Frequency = Frequency;
            this.TotalAmount = TotalAmount;
        }
        MergedCharge.prototype.toString = function () {
            return ShortChargeDisplayText(this.Frequency, this.TotalAmount);
        };
        return MergedCharge;
    }());
    exports.MergedCharge = MergedCharge;
    function ShortChargeDisplayText(frequency) {
        var amounts = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            amounts[_i - 1] = arguments[_i];
        }
        var suffix = ChargeFrequency.ShortDisplayName(frequency);
        var total = amounts.reduce(function (t, c) { return t + c; }, 0);
        var amountText = "$" + numberFilter(total, 2);
        if (!suffix)
            return amountText;
        return amountText + " (" + suffix + ")";
    }
    exports.ShortChargeDisplayText = ShortChargeDisplayText;
    function LongChargeDisplayText(frequency) {
        var amounts = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            amounts[_i - 1] = arguments[_i];
        }
        var suffix = ChargeFrequency.LongDisplayName(frequency);
        var total = amounts.reduce(function (t, c) { return t + c; }, 0);
        var amountText = "$" + numberFilter(total, 2);
        if (!suffix)
            return amountText;
        return amountText + " " + suffix;
    }
    exports.LongChargeDisplayText = LongChargeDisplayText;
});
define("app/sds/email/utils", ["require", "exports", "app/ng-utils", "app/selcomm/service"], function (require, exports, ng_utils_15, service_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var SingleTypeCode = "{A228B8DE-6592-4FBF-AA04-7B96CEDBBECA}";
    function GetSingleType() {
        return new service_8.Selcomm.Email.ContactEmailType({
            Code: SingleTypeCode,
            Description: "Contact Email",
        });
    }
    var noEmailsMessage = "Contact has no email address, or failed to load email.";
    function GetEmailTypes() {
        return [
            new service_8.Selcomm.Email.ContactEmailType({ Description: "Contact Email", Code: SingleTypeCode }),
            new service_8.Selcomm.Email.ContactEmailType({ Description: "Bill CC(1)", Code: "E" }),
            new service_8.Selcomm.Email.ContactEmailType({ Description: "Bill CC(2)", Code: "I" }),
            new service_8.Selcomm.Email.ContactEmailType({ Description: "Bill CC(3)", Code: "G" })
        ];
    }
    exports.GetEmailTypes = GetEmailTypes;
    function RemoveEmail(email) {
        return __awaiter(this, void 0, ng_utils_15.$q, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_8.Service.Email.ContactEmailAddressDelete({
                            ContactCode: service_8.Auth.CurrentSession.CurrentContactCode,
                            InfoType: email.ContactEmailType.Code,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    exports.RemoveEmail = RemoveEmail;
    function AddEmail(email) {
        return __awaiter(this, void 0, ng_utils_15.$q, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_8.Service.Email.ContactEmailAddressAdd({
                            EmailAddress: email,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    exports.AddEmail = AddEmail;
    function UpdateEmail(email) {
        return __awaiter(this, void 0, ng_utils_15.$q, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_8.Service.Email.ContactEmailAddressUpdate({
                            ContactCode: service_8.Auth.CurrentSession.CurrentContactCode,
                            EmailAddress: email,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    exports.UpdateEmail = UpdateEmail;
});
define("app/sds/email/sds-email", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "app/sds/email/utils", "module", "app/sdc/crud/sdc-crud"], function (require, exports, utils, ng_utils_16, service_9, emailUtils, module_13, crud) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this._State = crud.State.Read;
            _this.UpdateActivity = new utils.ActivityController("Updating");
            _this.DeleteActivity = new utils.ActivityController("Deleting");
            _this.Watch(function () { return _this.Email && _this.Email.EmailAddress; }, function (emailAddress, lastEmailAddress) {
                if (lastEmailAddress === emailAddress || lastEmailAddress === _this.NewEmailAddress)
                    _this.NewEmailAddress = emailAddress;
            });
            _this.Scope.emailValidationPattern = /^([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-])+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])+([\s]*[;][\s]*([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-])+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/;
            return _this;
        }
        Object.defineProperty(Controller.prototype, "CanDelete", {
            get: function () {
                return utils.IsVoid(this.BoundCanDelete) || this.BoundCanDelete;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CanUpdate", {
            get: function () {
                return utils.IsVoid(this.BoundCanUpdate) || this.BoundCanUpdate;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "State", {
            get: function () {
                switch (this._State) {
                    case crud.State.Read:
                        if (this.IsDirty)
                            return crud.State.Update;
                        return crud.State.Read;
                    default:
                        return this._State;
                }
            },
            set: function (value) {
                this._State = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.CancelUpdate = function () {
            this.ResetInputs();
            this.State = crud.State.Read;
        };
        Controller.prototype.Delete = function () {
            return __awaiter(this, void 0, ng_utils_16.$q, function () {
                var targetEmail, token, ex_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            targetEmail = this.Email;
                            if (this.UpdateActivity.IsActive)
                                throw new utils.AlreadyDoingActionError("Cannot update while deleting");
                            token = this.DeleteActivity.Enter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            if (!this.CanDelete) {
                                utils.Toast.Simple("This email cannot be deleted");
                                throw new Error("Cannot delete email");
                            }
                            return [4, emailUtils.RemoveEmail(targetEmail)];
                        case 2:
                            _a.sent();
                            return [3, 5];
                        case 3:
                            ex_1 = _a.sent();
                            utils.Toast.Simple("An error occurred removing your email address.");
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5:
                            this.State = crud.State.Read;
                            this.OnDeleted({ email: targetEmail });
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.CancelDelete = function () {
            this.State = crud.State.Read;
        };
        Object.defineProperty(Controller.prototype, "IsProcessing", {
            get: function () {
                return this.UpdateActivity.IsActive || this.DeleteActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Update = function () {
            return __awaiter(this, void 0, ng_utils_16.$q, function () {
                var newEmail, token, ex_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            newEmail = new service_9.Selcomm.Email.ContactEmailAddress(__assign({}, this.Email, { EmailAddress: this.NewEmailAddress }));
                            if (this.DeleteActivity.IsActive)
                                throw new utils.AlreadyDoingActionError("Cannot update while deleting");
                            token = this.UpdateActivity.Enter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4, emailUtils.UpdateEmail(newEmail)];
                        case 2:
                            _a.sent();
                            return [3, 5];
                        case 3:
                            ex_2 = _a.sent();
                            utils.Toast.Simple("An error occurred saving your email address.");
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5:
                            this.Email = newEmail;
                            this.State = crud.State.Read;
                            this.OnUpdated({ email: newEmail });
                            return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "TypeDescription", {
            get: function () {
                return this.Email && this.Email.ContactEmailType && utils.TrimEnd(this.Email.ContactEmailType.Description);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "InputType", {
            get: function () {
                if (this.Email && this.Email.ContactEmailType && this.Email.ContactEmailType.Code.length > 2)
                    return "text";
                else
                    return "email";
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.EnterUpdate = function () {
            this.State = crud.State.Update;
            this.NewEmailAddressIsFocused = true;
        };
        Controller.prototype.EnterDelete = function () {
            this.State = crud.State.Delete;
        };
        Controller.prototype.Submit = function (state, form) {
            return __awaiter(this, void 0, ng_utils_16.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are invalid");
                                throw new utils.FormInvalidError(form);
                            }
                            _a = state;
                            switch (_a) {
                                case crud.State.Update: return [3, 1];
                                case crud.State.Delete: return [3, 3];
                            }
                            return [3, 5];
                        case 1: return [4, this.Update()];
                        case 2: return [2, _b.sent()];
                        case 3: return [4, this.Delete()];
                        case 4: return [2, _b.sent()];
                        case 5: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsDirty", {
            get: function () {
                return (this.NewEmailAddress || "") !== ((this.Email && this.Email.EmailAddress) || "");
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.ResetInputs = function () {
            this.NewEmailAddress = (this.Email && this.Email.EmailAddress) || "";
        };
        __decorate([
            utils.Bind.TwoWay("email")
        ], Controller.prototype, "Email", void 0);
        __decorate([
            utils.Bind.Getter("on-deleted")
        ], Controller.prototype, "OnDeleted", void 0);
        __decorate([
            utils.Bind.In("can-delete", { optional: true })
        ], Controller.prototype, "BoundCanDelete", void 0);
        __decorate([
            utils.Bind.In("can-update", { optional: true })
        ], Controller.prototype, "BoundCanUpdate", void 0);
        __decorate([
            utils.Bind.Getter("on-updated")
        ], Controller.prototype, "OnUpdated", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_13.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/menu/service", ["require", "exports", "app/selcomm/service", "app/utils"], function (require, exports, service_10, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.refreshCache = true;
    function _ParseMenuItems(menuItems, parser) {
        if (utils.IsVoid(menuItems) || menuItems.length <= 0)
            return [];
        var parsed = menuItems.map(function (item, i) { return parser.Map(item, _ParseMenuItems(item.ChildMenuItems, parser), i); });
        var filtered = parsed.filter(function (item, i) { return parser.Filter(item, i); });
        return filtered;
    }
    var AdditionalMenuItemMode;
    (function (AdditionalMenuItemMode) {
        AdditionalMenuItemMode[AdditionalMenuItemMode["Directive"] = 6] = "Directive";
        AdditionalMenuItemMode[AdditionalMenuItemMode["MenuFactory"] = 7] = "MenuFactory";
        AdditionalMenuItemMode[AdditionalMenuItemMode["MenuDirective"] = 8] = "MenuDirective";
        AdditionalMenuItemMode[AdditionalMenuItemMode["ChildItemsOnly"] = 9] = "ChildItemsOnly";
    })(AdditionalMenuItemMode || (AdditionalMenuItemMode = {}));
    var MenuItemModeHelpers;
    (function (MenuItemModeHelpers) {
        function HasContent(mode) {
            if (utils.IsVoid(mode))
                return false;
            switch (mode) {
                case exports.MenuItemMode.ChildItemsOnly:
                case exports.MenuItemMode.MenuFactory:
                    return false;
                default:
                    return true;
            }
        }
        MenuItemModeHelpers.HasContent = HasContent;
    })(MenuItemModeHelpers = exports.MenuItemModeHelpers || (exports.MenuItemModeHelpers = {}));
    exports.MenuItemMode = utils.Extend(service_10.Selcomm.Menu.MenuItemMode, AdditionalMenuItemMode, MenuItemModeHelpers);
    var ParsedMenuItem = (function (_super) {
        __extends(ParsedMenuItem, _super);
        function ParsedMenuItem(source, parsedChildren, index, parser) {
            var _this = _super.call(this, source) || this;
            _this.Parent = null;
            _this.Component = source.Component;
            _this.Hidden = source.Hidden;
            _this.glyphiconClass = source.glyphiconClass;
            _this.ChildMenuItems = (parsedChildren || []).slice();
            _this.UrlName = ParsedMenuItem.GetUrlName(source);
            {
                var parsed = ParsedMenuItem.ParseImageUrl(source);
                _this.ImageURL = parsed.ImageURL || source.ImageURL;
                _this.DisplayDetails = parsed.DisplayDetails || source["DisplayDetails"];
                _this.glyphiconClass = parsed.glyphiconClass || source["glyphiconClass"];
            }
            ParsedMenuItem.ParseCommand(_this, parser);
            _this.ParentId = ParsedMenuItem.ParseParentId(source);
            return _this;
        }
        ParsedMenuItem.Create = function (source, parsedChildren, index, parser) {
            var clone = new ParsedMenuItem(source, parsedChildren, index, parser);
            try {
                for (var _a = __values(clone.ChildMenuItems), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var child = _b.value;
                    child.Parent = clone;
                }
            }
            catch (e_73_1) { e_73 = { error: e_73_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_73) throw e_73.error; }
            }
            return clone;
            var e_73, _c;
        };
        Object.defineProperty(ParsedMenuItem.prototype, "ImageString", {
            get: function () {
                return this.ImageURL;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedMenuItem.prototype, "ItemMode", {
            get: function () {
                return utils.HasProp(service_10.Selcomm.Menu.MenuItemMode, this.ExtendedItemMode) ? this.ExtendedItemMode : service_10.Selcomm.Menu.MenuItemMode.Unknown;
            },
            set: function (value) {
                if (utils.IsVoid(value)) {
                    this.ExtendedItemMode = exports.MenuItemMode.Default;
                    return;
                }
                if (utils.IsString(value)) {
                    var textValue = value;
                    var unknown = exports.MenuItemMode.Unknown;
                    if (/^[\r\n\s]*$/.test(value))
                        this.ExtendedItemMode = exports.MenuItemMode.ChildItemsOnly;
                    else if (utils.HasProp(exports.MenuItemMode, textValue))
                        this.ItemMode = exports.MenuItemMode[textValue];
                    else
                        this.ExtendedItemMode = unknown;
                    return;
                }
                if (!utils.IsNumber(value)) {
                    if (value)
                        this.ItemMode = exports.MenuItemMode.Unknown;
                    else
                        this.ExtendedItemMode = AdditionalMenuItemMode.ChildItemsOnly;
                    return;
                }
                if (value === exports.MenuItemMode.Unknown && utils.HasProp(exports.MenuItemMode, this.ExtendedItemMode))
                    return;
                this.ExtendedItemMode = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedMenuItem.prototype, "ItemModeName", {
            get: function () {
                return exports.MenuItemMode[utils.HasProp(exports.MenuItemMode, this.ExtendedItemMode) ? this.ExtendedItemMode : service_10.Selcomm.Menu.MenuItemMode.Unknown];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedMenuItem.prototype, "HasContent", {
            get: function () {
                return exports.MenuItemMode.HasContent(this.ExtendedItemMode);
            },
            enumerable: true,
            configurable: true
        });
        ParsedMenuItem.GetUrlName = function (source) {
            return utils.Urlify(source.Caption || String(source.Id));
        };
        ParsedMenuItem.ParseImageUrl = function (source) {
            var parsed;
            try {
                parsed = angular.fromJson(source.ImageURL || "");
            }
            catch (ex) {
                parsed = source.ImageURL;
            }
            if (!utils.IsObject(parsed)) {
                return {
                    ImageURL: parsed,
                    DisplayDetails: null,
                };
            }
            var glyphicon = parsed.glyphicon;
            return {
                ImageURL: parsed.ImageURL,
                DisplayDetails: parsed,
                glyphiconClass: Object.keys(glyphicon)
                    .filter(function (k) { return glyphicon[k]; })
                    .map(function (cls) { return /^glyphicon\b/.test(cls) ? cls + " glyphicon" : cls; })
                    .join(" ")
            };
        };
        ParsedMenuItem.ParseCommand = function (target, parser) {
            var commandText = target.CommandText;
            switch (target.ExtendedItemMode) {
                case service_10.Selcomm.Menu.MenuItemMode.Default:
                case service_10.Selcomm.Menu.MenuItemMode.Unknown:
                    if (!commandText) {
                        target.ExtendedItemMode = AdditionalMenuItemMode.ChildItemsOnly;
                    }
                    else {
                        try {
                            var commandObject = angular.fromJson(commandText);
                            if (!utils.IsObject(commandObject))
                                break;
                            if (utils.HasProp(commandObject, "component") && utils.IsString(commandObject.component) && /^[a-z][0-9a-z_:.-]*$/i.test(commandObject.component)) {
                                target.Component = {
                                    tag: commandObject.component,
                                    attrs: commandObject.attrs,
                                    extendAttrs: commandObject.extendAttrs
                                };
                                target.ExtendedItemMode = AdditionalMenuItemMode.Directive;
                            }
                            if (utils.HasProp(commandObject, "tag") && utils.IsString(commandObject.tag) && /^[a-z][0-9a-z_:.-]*$/i.test(commandObject.tag)) {
                                target.Component = {
                                    tag: commandObject.tag,
                                    attrs: commandObject.attrs,
                                    extendAttrs: commandObject.extendAttrs
                                };
                                target.ExtendedItemMode = AdditionalMenuItemMode.Directive;
                            }
                        }
                        catch (ex) {
                            if (/^[a-z][0-9a-z_:.-]*$/i.test(commandText)) {
                                target.ExtendedItemMode = AdditionalMenuItemMode.Directive;
                            }
                            else if (/https?:\/\//i.test(commandText)) {
                                target.ExtendedItemMode = service_10.Selcomm.Menu.MenuItemMode.Page;
                            }
                            else if (/^menu-factory=/i.test(commandText)) {
                                target.ExtendedItemMode = AdditionalMenuItemMode.MenuFactory;
                                target.ServiceName = commandText.replace(/^menu-factory=/i, "");
                            }
                            else if (/^menu-directive=/i.test(commandText)) {
                                target.ExtendedItemMode = AdditionalMenuItemMode.MenuDirective;
                                commandText = commandText.replace(/^menu-directive=/i, "");
                            }
                        }
                    }
                    break;
            }
            switch (target.ExtendedItemMode) {
                case AdditionalMenuItemMode.MenuDirective:
                case AdditionalMenuItemMode.Directive:
                    if (!utils.IsVoid(target.Component))
                        break;
                    try {
                        target.Component = angular.fromJson(commandText);
                    }
                    catch (ex) {
                        target.Component = {
                            tag: commandText
                        };
                    }
                    break;
                case AdditionalMenuItemMode.MenuFactory:
                    target.ChildMenuItems = [];
                    var serviceName_1 = target.ServiceName;
                    if (utils.IsVoid(serviceName_1)) {
                        target.loadChildMenuItems = function () {
                            throw new Error("The menu item " + target.Id + " has a void menu factory.");
                        };
                    }
                    else {
                        target.loadChildMenuItems = function () {
                            target.loadingChildMenuItems = utils.Require(serviceName_1)
                                .then(function (serviceInstance) { return serviceInstance(target); })
                                .then(function (items) { return target.ChildMenuItems = _ParseMenuItems(items, parser); });
                        };
                    }
                    break;
            }
        };
        ParsedMenuItem.prototype.loadChildMenuItems = function () {
        };
        ParsedMenuItem.ParseParentId = function (source) {
            if (source.ParentId == source.Id)
                return null;
            return source.ParentId;
        };
        return ParsedMenuItem;
    }(service_10.Selcomm.Menu.MenuItem));
    exports.ParsedMenuItem = ParsedMenuItem;
    function _GetMenu(menuId, getterOptions, parserOrOptions, service) {
        if (parserOrOptions === void 0) { parserOrOptions = Parser.Default; }
        var data = utils.Extend({
            MenuId: menuId,
            Recurrent: true,
            RefreshCache: exports.refreshCache,
        }, getterOptions);
        return service
            .MenuForServiceDetails(data)
            .then(function (menu) { return ParseMenu(menu, Parser.FromAny(parserOrOptions)); });
    }
    function GetMenu(menuId, getterOptions, parserOrOptions) {
        if (parserOrOptions === void 0) { parserOrOptions = Parser.Default; }
        return _GetMenu(menuId, getterOptions, parserOrOptions, service_10.Service.Menu);
    }
    exports.GetMenu = GetMenu;
    (function (GetMenu) {
        function Cached(menuId, getterOptions, parserOrOptions) {
            if (parserOrOptions === void 0) { parserOrOptions = Parser.Default; }
            return _GetMenu(menuId, getterOptions, parserOrOptions, service_10.CachedService.Menu);
        }
        GetMenu.Cached = Cached;
        function Thin(menuId, getterOptions, parserOrOptions) {
            if (parserOrOptions === void 0) { parserOrOptions = Parser.Default; }
            return _GetMenu(menuId, getterOptions, parserOrOptions, service_10.Service.Thin.Menu);
        }
        GetMenu.Thin = Thin;
        (function (Thin) {
            function Cached(menuId, getterOptions, parserOrOptions) {
                if (parserOrOptions === void 0) { parserOrOptions = Parser.Default; }
                return _GetMenu(menuId, getterOptions, parserOrOptions, service_10.Service.Thin.Cached.Menu);
            }
            Thin.Cached = Cached;
        })(Thin = GetMenu.Thin || (GetMenu.Thin = {}));
    })(GetMenu = exports.GetMenu || (exports.GetMenu = {}));
    var Parser = (function () {
        function Parser(options) {
            this.filter = options.Filter || Parser.DefaultFilter;
            this.mapper = options.Mapper;
        }
        Parser.prototype.Map = function (source, sourceChildren, index) {
            return this.mapper(source, sourceChildren, index, this);
        };
        Parser.prototype.Filter = function (source, index) {
            return this.filter(source, index, this);
        };
        Parser.CreateMapped = function (options) {
            return new Parser({
                Mapper: options.Mapper,
                Filter: options.Filter,
            });
        };
        Parser.DefaultFilter = function (x) {
            return !utils.IsVoid(x);
        };
        Parser.FromAny = function (parserOrOptions) {
            if (parserOrOptions instanceof Parser)
                return parserOrOptions;
            return Parser.CreateMapped(parserOrOptions);
        };
        return Parser;
    }());
    exports.Parser = Parser;
    (function (Parser) {
        Parser.Default = Parser.CreateMapped({ Mapper: ParsedMenuItem.Create, Filter: Parser.DefaultFilter });
    })(Parser = exports.Parser || (exports.Parser = {}));
    exports.Parser = Parser;
    function ParseMenu(menu, parserOrOptions) {
        if (parserOrOptions === void 0) { parserOrOptions = Parser.Default; }
        var clone = utils.ShallowCopy(menu);
        var parsedItems = ParseMenuItems(menu.MenuItemList, Parser.FromAny(parserOrOptions));
        clone.MenuItemList = parsedItems;
        return clone;
    }
    exports.ParseMenu = ParseMenu;
    function ParseMenuItems(menuItems, parserOrOptions) {
        if (parserOrOptions === void 0) { parserOrOptions = Parser.Default; }
        var parsedItems = _ParseMenuItems(menuItems, Parser.FromAny(parserOrOptions));
        return parsedItems;
    }
    exports.ParseMenuItems = ParseMenuItems;
    function CountParentsAndSelf(menuItem) {
        var current = menuItem;
        var depth = 0;
        while (!utils.IsVoid(current)) {
            depth++;
            current = current.Parent;
        }
        return depth;
    }
    exports.CountParentsAndSelf = CountParentsAndSelf;
    function GetMenuItemChain(menuItem) {
        var current = menuItem;
        var menuItemChain = new Array();
        while (!utils.IsVoid(current)) {
            menuItemChain.unshift(current);
            current = current.Parent;
        }
        return menuItemChain;
    }
    exports.GetMenuItemChain = GetMenuItemChain;
});
define("app/sds/header/sds-header", ["require", "exports", "app/utils", "app/ng-utils", "module", "app/selcomm/service", "app/sds/contact/sds-contact", "app/sds/menu/service"], function (require, exports, utils, ng_utils_17, module_14, service_11, selectedContact, menuService) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.menuVisible = false;
            _this.loading = _this.loadMenu().then(function (menu) { return _this.menu = menu; });
            _this.LoadHomePageURLActivity = new utils.ActivityController("LoadHomePageURL");
            _this.Watch(function () { return service_11.Auth.CurrentSession && service_11.Auth.CurrentSession.BusinessUnitCode || null; }, function (businessUnitCode) { return _this.LoadHomePageURL(businessUnitCode); });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "Contact", {
            get: function () {
                return this.SelectedContactController.Contact;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.dummyLink = function (text) {
            alert("Window to link to a " + text + " account opens");
        };
        Controller.prototype.CanActionMenuItem = function (menuItemId) {
            switch (menuItemId) {
                case 3000001:
                case 3000002:
                case 3000003:
                    return !service_11.Auth.CurrentSession || utils.TrimEnd(service_11.Auth.CurrentSession.UserCode) === this.SelectedContactController.ContactCode;
                default:
                    return true;
            }
        };
        Controller.prototype.clickMenuOptions = function (menuItemId, $event) {
            if (!this.CanActionMenuItem(menuItemId))
                return;
            switch (menuItemId) {
                case 3000001:
                    this.OpenChangePassword($event);
                    break;
                case 3000002:
                    this.Logout($event);
                    break;
                case 3000003:
                    this.OpenAccountAlert($event);
                    break;
            }
        };
        Controller.prototype.Logout = function ($event) {
            if (!service_11.Auth.CurrentSession)
                return;
            service_11.Auth.CurrentSession.Terminate();
        };
        Controller.prototype.OpenChangePassword = function ($event) {
            if (!utils.IsVoid(this.BoundOpenChangePassword))
                this.BoundOpenChangePassword({ $event: $event });
            else
                ng_utils_17.$window.open(service_11.Auth.UrlWithSession(utils.Paths.MapPath("!/account/change-password")), "change-password", "dialog,width=450,height=650");
        };
        Controller.prototype.OpenAccountAlert = function ($event) {
            if (!utils.IsVoid(this.BoundOpenAccountAlert))
                this.BoundOpenAccountAlert({ $event: $event });
            else
                ng_utils_17.$window.open(service_11.Auth.UrlWithSession(utils.Paths.MapPath("!/account/account-alert")), "account-alert", "dialog,width=450,height=650");
        };
        Controller.prototype.loadMenu = function () {
            return menuService.GetMenu(3000000);
        };
        Controller.prototype.toggleMenuVisibility = function () {
            this.menuVisible = !this.menuVisible;
        };
        Controller.prototype.LoadHomePageURL = function (businessUnitCode) {
            return __awaiter(this, void 0, ng_utils_17.$q, function () {
                var token, homePageUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.LoadHomePageURLActivity.CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4, service_11.Service.Configuration.GetConfigValue({
                                    Key: "HOME_PAGE_URL_" + businessUnitCode,
                                })];
                        case 2:
                            homePageUrl = _a.sent();
                            token.AssertNotExited();
                            this.homePageURL = homePageUrl;
                            return [3, 4];
                        case 3:
                            token.Exit();
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "SelectedContactController", void 0);
        __decorate([
            utils.Bind.Transclude(utils.Bind.Transclude.Mode.Contents)
        ], Controller.prototype, "Content", void 0);
        __decorate([
            utils.Bind.Getter("open-change-password", { optional: true })
        ], Controller.prototype, "BoundOpenChangePassword", void 0);
        __decorate([
            utils.Bind.Getter("open-account-alert", { optional: true })
        ], Controller.prototype, "BoundOpenAccountAlert", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_14.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/menu/sds-menu-service", ["require", "exports", "app/sds/menu/service"], function (require, exports, service_12) {
    "use strict";
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    Object.defineProperty(exports, "__esModule", { value: true });
    __export(service_12);
});
define("app/sds/menu/sds-menu", ["require", "exports", "module", "app/utils", "app/sds/menu/service", "app/sdc/sub/path/sdc-sub-path", "app/ng-utils"], function (require, exports, module_15, utils, menuService, subPath, ng_utils_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.MenuLoader = new utils.Loader(function (maybeAwaitableMenuOrMenuId) { return __awaiter(_this, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = Controller_15).EnsureAsMenu;
                        return [4, maybeAwaitableMenuOrMenuId];
                    case 1: return [4, _b.apply(_a, [_c.sent()])];
                    case 2: return [2, _c.sent()];
                }
            }); }); });
            _this.locationChange = false;
            var menuSpecified = !utils.IsVoid(_this.Attributes[utils.CamelCase("menu")]);
            var menuIdSpecified = !utils.IsVoid(_this.Attributes[utils.CamelCase("menu-id")]);
            if (menuSpecified && menuIdSpecified)
                throw new Error("Cannot specify both [menu] and [menu-id]");
            else if (menuSpecified)
                _this.Watch(function () { return _this.BoundMenu; }, function (boundMenu) { return _this.MenuLoader.Load(boundMenu); });
            else if (menuIdSpecified)
                _this.Watch(function () { return _this.BoundMenuId; }, function (boundMenuId) { return _this.MenuLoader.Load(boundMenuId); });
            else
                throw new Error("Must specify either [menu] or [menu-id]");
            _this.Watch.Group({
                menu: function () { return _this.BoundMenu; },
                menuId: function () { return _this.BoundMenuId; },
            }, function (x) { return _this.MenuLoader.Load(x.menu || x.menuId); });
            _this.Watch.Collection(function () { return ({
                UseRouting: _this.UseRouting,
                RecievedSubPath: _this.RecievedSubPath,
            }); }, function (value, last) {
                var LastRecievedSubPath = last.RecievedSubPath;
                var UseRouting = value.UseRouting, RecievedSubPath = value.RecievedSubPath;
                if (!UseRouting)
                    return;
                if (!_this.Menu) {
                    _this.locationChange = true;
                    return;
                }
                _this.ApplyRouting(_this.RecievedSubPath, "locationChange");
            });
            _this.Watch(function () { return _this.Menu; }, function (menu) {
                if (!menu)
                    return;
                if (!_this.UseRouting) {
                    _this.menuItem = _this.FindMenuItem(_this.menuItem);
                    return;
                }
                _this.ApplyRouting(_this.RecievedSubPath, _this.locationChange ? "locationChange" : "menuChange");
                _this.locationChange = false;
            });
            return _this;
        }
        Controller_15 = Controller;
        Object.defineProperty(Controller.prototype, "SelectedMenuItem", {
            get: function () {
                return this.menuItem;
            },
            set: function (value) {
                this.menuItem = value;
                if (!this.SubPathController)
                    return;
                var foundMenuItem = this.FindMenuItemChain(value);
                if (!foundMenuItem && !utils.IsVoid(value))
                    return;
                var newSubPath = this.GetSubPath(foundMenuItem);
                ng_utils_18.$location.path(this.SubPathController.LeadingPath + newSubPath);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsLoadingMenu", {
            get: function () {
                return this.MenuLoader.IsLoading;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "UseRouting", {
            get: function () {
                return !!this.SubPathController;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "RecievedSubPath", {
            get: function () {
                return this.SubPathController && this.SubPathController.Recieved;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "menu", {
            get: function () {
                return this.MenuLoader.Value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Menu", {
            get: function () {
                return this.menu;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "RootMenuItems", {
            get: function () {
                var menu = this.Menu;
                return menu ? menu.MenuItemList : [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "MenuItems", {
            get: function () {
                return Object.freeze(!utils.IsVoid(this.SelectedMenuItem) ? this.SelectedMenuItem.ChildMenuItems : this.RootMenuItems);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.ApplyRouting = function (recievedSubPath, reason) {
            var _a = this.FindMenuItemBySubPath(recievedSubPath), Consumed = _a.Consumed, MenuItem = _a.MenuItem, PassDown = _a.PassDown;
            this.menuItem = MenuItem;
            if (this.SubPathController)
                this.SubPathController.Consume(Consumed, PassDown);
        };
        Controller.prototype.FindMenuItemBySubPath = function (subPath) {
            if (utils.IsVoid(this.Menu))
                return { Consumed: "", PassDown: subPath, MenuItem: null };
            if (/^[\\\/]?$/.test(subPath))
                return { Consumed: "", PassDown: subPath, MenuItem: null };
            var subPathParts = Controller_15.GetSubPathParts(subPath);
            var foundMenuItem = Controller_15.FindMenuItem(this.Menu.MenuItemList, function (mi) { return Controller_15.MatchesSubPath(mi, subPathParts); });
            if (!foundMenuItem)
                return { Consumed: "", PassDown: subPath, MenuItem: null };
            return utils.Extend(this.DetectRouting(foundMenuItem, subPath, subPathParts), { MenuItem: foundMenuItem, });
        };
        Controller.GetSubPathParts = function (subPath) {
            var _a = __read(/^[\\\/]?(.*)$/.exec(subPath), 2), trimmedSubPath = _a[1];
            var subPathParts = trimmedSubPath.split(/[\\\/]/g);
            return subPathParts;
        };
        Controller.prototype.GetSubPath = function (menuItem, trim, subPath) {
            if (trim === void 0) { trim = true; }
            if (subPath === void 0) { subPath = this.RecievedSubPath; }
            var slashes = subPath.split(/[^\\\/]+/g);
            var parts = menuService.GetMenuItemChain(menuItem).map(function (mi) { return mi.UrlName; });
            var first = true;
            var newSubPath = "";
            while (parts.length) {
                var slash = slashes.shift() || (first ? "" : "/");
                newSubPath += slash;
                newSubPath += parts.shift() || "";
                first = false;
            }
            return newSubPath;
        };
        Controller.prototype.GetPath = function (menuItem, trim) {
            if (trim === void 0) { trim = true; }
            if (!this.SubPathController)
                return null;
            if (utils.IsVoid(menuItem))
                return this.SubPathController.LeadingPath + (this.SubPathController.LeadingPath.endsWith("/") ? "" : "/");
            return "" + this.SubPathController.LeadingPath + this.GetSubPath(menuItem);
        };
        Controller.prototype.GetHref = function (menuItem, trim) {
            if (trim === void 0) { trim = true; }
            var path = this.GetPath(menuItem, trim);
            if (utils.IsVoid(path))
                return path;
            if (path.startsWith("/"))
                return "!/" + path;
            return path;
        };
        Controller.prototype.DetectRouting = function (menuItem, subPath, subPathParts) {
            if (subPath === void 0) { subPath = this.RecievedSubPath; }
            if (subPathParts === void 0) { subPathParts = Controller_15.GetSubPathParts(subPath); }
            if (!menuItem)
                return { Consumed: "", PassDown: subPath };
            var consumeSegments = menuService.CountParentsAndSelf(menuItem);
            var consumed = "";
            var passDown = "";
            var slashes = subPath.split(/[^\\\/]+/g);
            {
                var consumedParts = subPathParts.slice(0, consumeSegments);
                while (slashes.length && consumedParts.length) {
                    var consumedSlash = slashes.shift();
                    var consumedPart = consumedParts.shift();
                    if (consumedSlash)
                        consumed += consumedSlash;
                    if (consumedPart)
                        consumed += consumedPart;
                }
            }
            {
                var passDownParts = subPathParts.slice(consumeSegments);
                while (slashes.length || passDownParts.length) {
                    var passDownSlash = slashes.shift();
                    var passDownPart = passDownParts.shift();
                    if (passDownSlash)
                        passDown += passDownSlash;
                    if (passDownPart)
                        passDown += passDownPart;
                }
            }
            return {
                Consumed: consumed,
                PassDown: passDown,
            };
        };
        Controller.MatchesSubPath = function (menuItem, subPathParts, caseSensitive) {
            if (caseSensitive === void 0) { caseSensitive = false; }
            var menuItems = menuService.GetMenuItemChain(menuItem);
            if (menuItems.length > subPathParts.length)
                return null;
            for (var i = 0; i < menuItems.length; i++) {
                var menuItem_1 = menuItems[i];
                if (utils.IsVoid(menuItem_1.UrlName))
                    return null;
                var urlName = menuItem_1.UrlName.toLowerCase();
                var subPathSegment = subPathParts[i].toLowerCase();
                if (urlName !== subPathSegment)
                    return false;
            }
            return true;
        };
        Controller.prototype.FindMenuItem = function (menuItem) {
            if (utils.IsVoid(menuItem))
                return menuItem;
            if (utils.IsVoid(this.Menu))
                return this.Menu;
            return Controller_15.FindMenuItem(this.Menu.MenuItemList, function (mi) { return angular.equals(mi, menuItem); });
        };
        Controller.prototype.FindMenuItemChain = function (menuItem) {
            if (utils.IsVoid(menuItem))
                return menuItem;
            if (utils.IsVoid(this.Menu))
                return this.Menu;
            return Controller_15.FindMenuItem(this.Menu.MenuItemList, function (mi) { return angular.equals(mi, menuItem); });
        };
        Controller.FindMenuItem = function (menuItems, predicate) {
            if (utils.IsVoid(menuItems))
                return null;
            try {
                for (var menuItems_1 = __values(menuItems), menuItems_1_1 = menuItems_1.next(); !menuItems_1_1.done; menuItems_1_1 = menuItems_1.next()) {
                    var menuItem = menuItems_1_1.value;
                    if (utils.IsVoid(menuItem))
                        continue;
                    var foundChild = Controller_15.FindMenuItem(menuItem.ChildMenuItems, predicate);
                    if (!utils.IsVoid(foundChild))
                        return foundChild;
                    if (predicate(menuItem))
                        return menuItem;
                }
            }
            catch (e_74_1) { e_74 = { error: e_74_1 }; }
            finally {
                try {
                    if (menuItems_1_1 && !menuItems_1_1.done && (_a = menuItems_1.return)) _a.call(menuItems_1);
                }
                finally { if (e_74) throw e_74.error; }
            }
            return null;
            var e_74, _a;
        };
        Controller.EnsureAsMenu = function (menuOrMenuId) {
            if (!utils.IsNumber(menuOrMenuId))
                return ng_utils_18.$q.resolve(menuOrMenuId);
            return menuService.GetMenu(menuOrMenuId);
        };
        __decorate([
            utils.Bind.In("menu", { optional: true })
        ], Controller.prototype, "BoundMenu", void 0);
        __decorate([
            utils.Bind.In("menu-id", { optional: true })
        ], Controller.prototype, "BoundMenuId", void 0);
        __decorate([
            utils.Bind.TwoWay("selected-menu-item")
        ], Controller.prototype, "SelectedMenuItem", null);
        __decorate([
            utils.Bind.Out("is-loading-menu", { optional: true })
        ], Controller.prototype, "IsLoadingMenu", null);
        __decorate([
            utils.Bind.Controller(subPath.Controller, { optional: true })
        ], Controller.prototype, "SubPathController", void 0);
        __decorate([
            utils.Bind.Out("menu-items-as", { shallow: true })
        ], Controller.prototype, "MenuItems", null);
        Controller = Controller_15 = __decorate([
            utils.Component({
                ModuleId: module_15.id,
                Restrict: utils.Target.Element,
                Template: null,
                Scope: utils.ScopeMode.NewInheritedScope,
            })
        ], Controller);
        return Controller;
        var Controller_15;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/payment/service", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "moment", "app/sss/sites"], function (require, exports, utils, ng_utils_19, service_13, moment, sites_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var serviceStore = utils.Storage.Local.Prefixed("sds-payment-service.");
    var Result = (function () {
        function Result() {
        }
        Object.defineProperty(Result.prototype, "StatusTypeName", {
            get: function () {
                return Result.StatusType[this.StatusType];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Result.prototype, "ExpectedDurationName", {
            get: function () {
                return Result.ExpectedDuration[this.ExpectedDuration];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Result.prototype, "RequiresFurtherAssistanceName", {
            get: function () {
                return Result.RequiresFurtherAssistance[this.RequiresFurtherAssistance];
            },
            enumerable: true,
            configurable: true
        });
        return Result;
    }());
    exports.Result = Result;
    (function (Result) {
        var StatusType;
        (function (StatusType) {
            StatusType[StatusType["Unknown"] = 0] = "Unknown";
            StatusType[StatusType["Pending"] = 0] = "Pending";
            StatusType[StatusType["Resolved"] = 1] = "Resolved";
            StatusType[StatusType["Rejected"] = 2] = "Rejected";
            StatusType[StatusType["Error"] = 3] = "Error";
        })(StatusType = Result.StatusType || (Result.StatusType = {}));
        var ExpectedDuration;
        (function (ExpectedDuration) {
            ExpectedDuration[ExpectedDuration["Unknown"] = 0] = "Unknown";
            ExpectedDuration[ExpectedDuration["Final"] = 1] = "Final";
            ExpectedDuration[ExpectedDuration["Short"] = 2] = "Short";
            ExpectedDuration[ExpectedDuration["Long"] = 3] = "Long";
        })(ExpectedDuration = Result.ExpectedDuration || (Result.ExpectedDuration = {}));
        var RequiresFurtherAssistance;
        (function (RequiresFurtherAssistance) {
            RequiresFurtherAssistance[RequiresFurtherAssistance["Maybe"] = 0] = "Maybe";
            RequiresFurtherAssistance[RequiresFurtherAssistance["Yes"] = 1] = "Yes";
            RequiresFurtherAssistance[RequiresFurtherAssistance["No"] = 2] = "No";
        })(RequiresFurtherAssistance = Result.RequiresFurtherAssistance || (Result.RequiresFurtherAssistance = {}));
        var Error = (function (_super) {
            __extends(Error, _super);
            function Error(UnderlyingError) {
                var _this = _super.call(this) || this;
                _this.UnderlyingError = UnderlyingError;
                _this.StatusId = undefined;
                _this.StatusType = Result.StatusType.Error;
                _this.MustNotReAttempt = true;
                _this.ExpectedDuration = Result.ExpectedDuration.Unknown;
                _this.RequiresFurtherAssistance = Result.RequiresFurtherAssistance.Maybe;
                _this.ReceiptNumber = _this.UnderlyingError && !utils.IsVoid(_this.UnderlyingError.message) && String(_this.UnderlyingError.message) || "";
                _this.Amount = undefined;
                _this.SurchargeAmount = undefined;
                return _this;
            }
            return Error;
        }(Result));
        Result.Error = Error;
    })(Result = exports.Result || (exports.Result = {}));
    exports.Result = Result;
    var LoadedResultBase = (function (_super) {
        __extends(LoadedResultBase, _super);
        function LoadedResultBase(InitialReponse) {
            var _this = _super.call(this) || this;
            _this.InitialReponse = InitialReponse;
            return _this;
        }
        LoadedResultBase.GetStatusType = function (statusId) {
            switch (statusId) {
                case 1:
                case 2:
                case 10:
                    return Result.StatusType.Pending;
                case 3:
                    return Result.StatusType.Resolved;
                case 4:
                case 6:
                    return Result.StatusType.Rejected;
                case 7:
                    return Result.StatusType.Error;
                default:
                    return Result.StatusType.Unknown;
            }
        };
        LoadedResultBase.GetMustNotReAttempt = function (statusId) {
            switch (LoadedResultBase.GetStatusType(statusId)) {
                case Result.StatusType.Rejected:
                    return false;
                default:
                    return true;
            }
        };
        LoadedResultBase.GetExpectedDuration = function (statusId) {
            switch (statusId) {
                case 3:
                case 6:
                case 4:
                    return Result.ExpectedDuration.Final;
                case 2:
                    return Result.ExpectedDuration.Short;
                case 1:
                    return Result.ExpectedDuration.Short;
                case 7:
                default:
                    return Result.ExpectedDuration.Unknown;
                case 10:
                    return Result.ExpectedDuration.Long;
            }
        };
        LoadedResultBase.GetRequiresFurtherAssistance = function (statusId) {
            switch (statusId) {
                case 3:
                    return Result.RequiresFurtherAssistance.No;
                case 7:
                    return Result.RequiresFurtherAssistance.Yes;
                default:
                    return Result.RequiresFurtherAssistance.Maybe;
            }
        };
        Object.defineProperty(LoadedResultBase.prototype, "StatusType", {
            get: function () { return LoadedResultBase.GetStatusType(this.StatusId); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoadedResultBase.prototype, "MustNotReAttempt", {
            get: function () { return LoadedResultBase.GetMustNotReAttempt(this.StatusId); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoadedResultBase.prototype, "ExpectedDuration", {
            get: function () { return LoadedResultBase.GetExpectedDuration(this.StatusId); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoadedResultBase.prototype, "RequiresFurtherAssistance", {
            get: function () { return LoadedResultBase.GetRequiresFurtherAssistance(this.StatusId); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoadedResultBase.prototype, "ResponseDisplay", {
            get: function () {
                return this.LoadedResponse || this.InitialReponse.Response;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoadedResultBase.prototype, "Status", {
            get: function () {
                return this.ResponseDisplay.PayRequestStatus;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoadedResultBase.prototype, "StatusId", {
            get: function () {
                return this.Status.Id;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoadedResultBase.prototype, "ReceiptNumber", {
            get: function () {
                return this.ResponseDisplay.FinancialTransactionNumber;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoadedResultBase.prototype, "Amount", {
            get: function () {
                return this.ResponseDisplay.RequestAmount;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LoadedResultBase.prototype, "SurchargeAmount", {
            get: function () {
                return this.ResponseDisplay.SurchargeAmount;
            },
            enumerable: true,
            configurable: true
        });
        return LoadedResultBase;
    }(Result));
    var LoadedResult = (function (_super) {
        __extends(LoadedResult, _super);
        function LoadedResult(initialReponse) {
            return _super.call(this, initialReponse) || this;
        }
        LoadedResult.CreateAndPollForProcessed = function (initialReponse, timeout, interval) {
            return __awaiter(this, void 0, ng_utils_19.$q, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            result = new LoadedResult(initialReponse);
                            return [4, result.PollUntilProcessed(timeout, interval)];
                        case 1:
                            _a.sent();
                            return [2, result];
                    }
                });
            });
        };
        LoadedResult.prototype.UpdateFromServer = function () {
            return __awaiter(this, void 0, ng_utils_19.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this;
                            return [4, service_13.Service.Payment.PaymentRequestStatusGetForPaymentRequest({
                                    PaymentRequestId: this.InitialReponse.Response.Id,
                                })];
                        case 1: return [2, _a.LoadedResponse = _b.sent()];
                    }
                });
            });
        };
        LoadedResult.prototype.PollUntilProcessed = function (timeout, interval) {
            if (interval === void 0) { interval = 1000; }
            return __awaiter(this, void 0, ng_utils_19.$q, function () {
                var count, i, err_13;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!utils.IsNumber(timeout))
                                timeout = timeout.milliseconds();
                            if (!utils.IsNumber(interval))
                                interval = interval.milliseconds();
                            count = Math.max(1, Math.floor(timeout / interval));
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < count)) return [3, 8];
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, this.TryUpdateFromServer()];
                        case 3:
                            if (!(_a.sent()))
                                return [2];
                            return [3, 5];
                        case 4:
                            err_13 = _a.sent();
                            ng_utils_19.$exceptionHandler(err_13);
                            return [3, 5];
                        case 5: return [4, utils.Delay(interval)];
                        case 6:
                            _a.sent();
                            _a.label = 7;
                        case 7:
                            i++;
                            return [3, 1];
                        case 8: return [2];
                    }
                });
            });
        };
        LoadedResult.prototype.TryUpdateFromServer = function () {
            return __awaiter(this, void 0, ng_utils_19.$q, function () {
                var response, err_14;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, this.UpdateFromServer()];
                        case 1:
                            response = _a.sent();
                            switch (LoadedResult.GetExpectedDuration(response.PayRequestStatus.Id)) {
                                case Result.ExpectedDuration.Final:
                                case Result.ExpectedDuration.Long:
                                    return [2, false];
                                default:
                                    return [2, true];
                            }
                            return [3, 3];
                        case 2:
                            err_14 = _a.sent();
                            return [2, true];
                        case 3: return [2];
                    }
                });
            });
        };
        return LoadedResult;
    }(LoadedResultBase));
    exports.LoadedResult = LoadedResult;
    var PaymentMethodFromAccountNumberAndTypeResult = (function () {
        function PaymentMethodFromAccountNumberAndTypeResult(_PaymentMethod, ValidPaymentMethod, ValidAccountNumber) {
            this._PaymentMethod = _PaymentMethod;
            this.ValidPaymentMethod = ValidPaymentMethod;
            this.ValidAccountNumber = ValidAccountNumber;
        }
        PaymentMethodFromAccountNumberAndTypeResult.GetForAccountNumberAndType = function (accountNumber, typeCode) {
            return __awaiter(this, void 0, ng_utils_19.$q, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (utils.IsVoid(typeCode))
                                throw new Error("The typeCode must not be void.");
                            return [4, service_13.Service.Payment.PaymentMethodFromAccountNumberAndType({
                                    AccountNumber: accountNumber,
                                    PaymentMethodTypeCode: typeCode,
                                })];
                        case 1:
                            result = _a.sent();
                            return [2, PaymentMethodFromAccountNumberAndTypeResult.Parse(result)];
                    }
                });
            });
        };
        PaymentMethodFromAccountNumberAndTypeResult.Parse = function (rawResult) {
            return new PaymentMethodFromAccountNumberAndTypeResult(rawResult[0], rawResult[1], rawResult[2]);
        };
        Object.defineProperty(PaymentMethodFromAccountNumberAndTypeResult.prototype, "IsInvalid", {
            get: function () {
                return utils.IsVoid(this._PaymentMethod) || !this.ValidAccountNumber || !this.ValidPaymentMethod;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PaymentMethodFromAccountNumberAndTypeResult.prototype, "PaymentMethod", {
            get: function () {
                if (this.IsInvalid || utils.IsVoid(this._PaymentMethod))
                    throw new Error("The result was invalid");
                return this._PaymentMethod;
            },
            enumerable: true,
            configurable: true
        });
        return PaymentMethodFromAccountNumberAndTypeResult;
    }());
    exports.PaymentMethodFromAccountNumberAndTypeResult = PaymentMethodFromAccountNumberAndTypeResult;
    (function (PaymentMethodFromAccountNumberAndTypeResult) {
        var x;
    })(PaymentMethodFromAccountNumberAndTypeResult = exports.PaymentMethodFromAccountNumberAndTypeResult || (exports.PaymentMethodFromAccountNumberAndTypeResult = {}));
    exports.PaymentMethodFromAccountNumberAndTypeResult = PaymentMethodFromAccountNumberAndTypeResult;
    function GetPaymentMethodForAccountNumberAndType(accountNumber, typeCode) {
        return __awaiter(this, void 0, ng_utils_19.$q, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, PaymentMethodFromAccountNumberAndTypeResult.GetForAccountNumberAndType(accountNumber, typeCode)];
                    case 1:
                        result = _a.sent();
                        if (result.IsInvalid)
                            throw result;
                        return [2, result.PaymentMethod];
                }
            });
        });
    }
    exports.GetPaymentMethodForAccountNumberAndType = GetPaymentMethodForAccountNumberAndType;
    function SendPayment(targetAccountCode, amount, accountPaymentMethod, other) {
        return __awaiter(this, void 0, ng_utils_19.$q, function () {
            var request, response, err_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!utils.IsNumber(amount)) {
                            other = amount;
                            amount = 0;
                        }
                        request = new service_13.Selcomm.Payment.PaymentRequest(utils.Extend({
                            AccountPaymentMethod: accountPaymentMethod,
                            ContactCode: targetAccountCode,
                            RequestAmount: amount,
                            PaymentSource: new service_13.Selcomm.Payment.PaymentSource({ Id: 3 }),
                            FinancialTransaction: new service_13.Selcomm.Financials.FinancialTransaction({ Source: new service_13.Selcomm.Financials.FinancialTransactionSource({ Code: 'PT' }) }),
                        }, other));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, service_13.Service.Payment.PaymentRequestCreate({
                                PaymentRequest: request,
                                SendEmail: true,
                            })];
                    case 2:
                        response = _a.sent();
                        return [4, LoadedResult.CreateAndPollForProcessed(response, 5000)];
                    case 3: return [2, _a.sent()];
                    case 4:
                        err_15 = _a.sent();
                        return [2, new Result.Error(err_15)];
                    case 5: return [2];
                }
            });
        });
    }
    exports.SendPayment = SendPayment;
    var RegistrationType;
    (function (RegistrationType) {
        RegistrationType["Selcomm"] = "selcomm";
        RegistrationType["ThirdParty"] = "third-party";
    })(RegistrationType = exports.RegistrationType || (exports.RegistrationType = {}));
    var RegistrationTypeTargets = (function () {
        function RegistrationTypeTargets(productName, RegistrationType, RestrictedTo) {
            this.RegistrationType = RegistrationType;
            this.RestrictedTo = RestrictedTo;
            this.ProductName = utils.IsString(productName) ? productName : productName.ProductName;
            this.DisplayMode = utils.IsString(productName) ? 3 : productName.DisplayProductName;
        }
        RegistrationTypeTargets.prototype.toString = function () {
            switch (this.DisplayMode) {
                case 1:
                    return this.ProductName;
                case 2:
                    return this.getPaymentMethodsString();
                default:
                case 3:
                    return this.ProductName + " - " + this.getPaymentMethodsString();
            }
        };
        RegistrationTypeTargets.prototype.getPaymentMethodsString = function () {
            if (utils.IsVoid(this.RestrictedTo))
                return "Any payment method";
            return __spread([
                this.RestrictedTo
                    .map(function (x) { return x.Description; })
                    .slice(0, this.RestrictedTo.length - 1)
                    .join(", ")
            ], this.RestrictedTo
                .map(function (x) { return x.Description; })
                .slice(this.RestrictedTo.length - 1)).filter(function (x) { return utils.IsNotNullOrWhitespace(x); })
                .join(" and ");
        };
        return RegistrationTypeTargets;
    }());
    exports.RegistrationTypeTargets = RegistrationTypeTargets;
    (function (RegistrationTypeTargets) {
        var SelcommProductName = Object.freeze({
            ProductName: "Selcomm",
            DisplayProductName: 2,
        });
        function HardCoded() {
            switch (sites_1.Service.Current.Hash) {
                case "88a2332c85130219b24b54d8015babf30a3ebd9e7b98c18e3cd5dfa24a70bd6e":
                case "79c6e970698a5215a0058f22068aa80fc41da72e404f0d7dc9891dc6fbcd0889":
                case "1e5beccc1dfbba83df8715a2d7b8cffac5f893f9dade0785ee971d445465b497":
                case "a85fd748d6400a3aa6972d88b41869f93af12ff1fc924d6fb8390d3f83a1a24f":
                    return [new RegistrationTypeTargets(SelcommProductName, RegistrationType.ThirdParty, null)];
                default:
                    return [new RegistrationTypeTargets(SelcommProductName, RegistrationType.Selcomm, null)];
            }
        }
        function GetForBusinessUnit(businessUnit) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2, HardCoded()];
                });
            });
        }
        RegistrationTypeTargets.GetForBusinessUnit = GetForBusinessUnit;
        function GetForContact(contactCode) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2, HardCoded()];
                });
            });
        }
        RegistrationTypeTargets.GetForContact = GetForContact;
    })(RegistrationTypeTargets = exports.RegistrationTypeTargets || (exports.RegistrationTypeTargets = {}));
    exports.RegistrationTypeTargets = RegistrationTypeTargets;
    var PaymentRegisterProvider = (function () {
        function PaymentRegisterProvider() {
        }
        return PaymentRegisterProvider;
    }());
    exports.PaymentRegisterProvider = PaymentRegisterProvider;
    var ThirdParty;
    (function (ThirdParty) {
        var thirdPartyStore = serviceStore.Prefixed("third-party.");
        var PaymentMethodRegister;
        (function (PaymentMethodRegister) {
            var RegisterFailedPaymentResult = (function (_super) {
                __extends(RegisterFailedPaymentResult, _super);
                function RegisterFailedPaymentResult(Reason) {
                    var _this = _super.call(this) || this;
                    _this.Reason = Reason;
                    _this.StatusId = undefined;
                    _this.StatusType = Result.StatusType.Rejected;
                    _this.MustNotReAttempt = false;
                    _this.ExpectedDuration = Result.ExpectedDuration.Final;
                    _this.RequiresFurtherAssistance = Result.RequiresFurtherAssistance.Maybe;
                    _this.ReceiptNumber = _this.Message;
                    _this.Amount = undefined;
                    _this.SurchargeAmount = undefined;
                    return _this;
                }
                Object.defineProperty(RegisterFailedPaymentResult.prototype, "Message", {
                    get: function () {
                        if (utils.IsString(this.Reason))
                            return this.Reason;
                        if (!utils.IsObject(this.Reason) || (!utils.HasProp(this, "DisplayMessage", true) && !utils.HasProp(this, "DisplayMessage", true)))
                            return "The registered details were rejected by the third-party provider.";
                        if (utils.IsObjectLike(this.Reason)) {
                            if (utils.HasProp.OfType(this.Reason, "DisplayMessage", utils.IsString))
                                return this.Reason.DisplayMessage;
                            if (utils.HasProp.OfType(this.Reason, "message", utils.IsString))
                                return this.Reason.message;
                        }
                        if (utils.IsString(this.Reason.DisplayMessage))
                            return this.Reason.DisplayMessage;
                    },
                    enumerable: true,
                    configurable: true
                });
                return RegisterFailedPaymentResult;
            }(Result));
            PaymentMethodRegister.RegisterFailedPaymentResult = RegisterFailedPaymentResult;
            var Query;
            (function (Query) {
                var QueryPartNames;
                (function (QueryPartNames) {
                    QueryPartNames.LocalRequestId = "ri";
                    QueryPartNames.Nonce = "n";
                    QueryPartNames.All = [QueryPartNames.LocalRequestId, QueryPartNames.Nonce];
                })(QueryPartNames = Query.QueryPartNames || (Query.QueryPartNames = {}));
                function ToQueryParts(source) {
                    return [
                        new utils.Paths.QueryPart(QueryPartNames.LocalRequestId, source.key),
                        new utils.Paths.QueryPart(QueryPartNames.Nonce, source.nonce),
                    ];
                }
                Query.ToQueryParts = ToQueryParts;
                function Parse(source) {
                    var loaded = {
                        key: false,
                        nonce: false,
                    };
                    var result = {};
                    try {
                        for (var source_4 = __values(source), source_4_1 = source_4.next(); !source_4_1.done; source_4_1 = source_4.next()) {
                            var queryPart = source_4_1.value;
                            switch (queryPart.Key) {
                                case QueryPartNames.Nonce:
                                    WriteResult("nonce", queryPart.Value);
                                    break;
                                case QueryPartNames.LocalRequestId:
                                    WriteResult("key", queryPart.Value);
                                    break;
                            }
                        }
                    }
                    catch (e_75_1) { e_75 = { error: e_75_1 }; }
                    finally {
                        try {
                            if (source_4_1 && !source_4_1.done && (_a = source_4.return)) _a.call(source_4);
                        }
                        finally { if (e_75) throw e_75.error; }
                    }
                    if (!utils.Collection.ToEnumerable(Object.values(loaded)).All(function (hasLoaded) { return hasLoaded; }))
                        throw new Error("Cannot parse all payment details");
                    return result;
                    function WriteResult(key, value) {
                        loaded[key] = true;
                        result[key] = value;
                    }
                    var e_75, _a;
                }
                Query.Parse = Parse;
                var LaunchRequest;
                (function (LaunchRequest) {
                    var QueryPartNames;
                    (function (QueryPartNames) {
                        QueryPartNames.LocalRequestId = Query.QueryPartNames.LocalRequestId;
                        QueryPartNames.Nonce = Query.QueryPartNames.Nonce;
                        QueryPartNames.All = Query.QueryPartNames.All;
                    })(QueryPartNames = LaunchRequest.QueryPartNames || (LaunchRequest.QueryPartNames = {}));
                    function ToQueryParts(source) {
                        return Query.ToQueryParts(source);
                    }
                    LaunchRequest.ToQueryParts = ToQueryParts;
                    function Parse(source) {
                        return Query.Parse(source);
                    }
                    LaunchRequest.Parse = Parse;
                })(LaunchRequest = Query.LaunchRequest || (Query.LaunchRequest = {}));
                var ThirdPartyResponse;
                (function (ThirdPartyResponse) {
                    var QueryPartNames;
                    (function (QueryPartNames) {
                        QueryPartNames.LocalRequestId = Query.QueryPartNames.LocalRequestId;
                        QueryPartNames.Nonce = Query.QueryPartNames.Nonce;
                        QueryPartNames.Outcome = "o";
                        QueryPartNames.CompletionToken = "t";
                        QueryPartNames.DefaultPaymentMethod = "d";
                        QueryPartNames.All = __spread(Query.QueryPartNames.All, [QueryPartNames.Outcome, QueryPartNames.CompletionToken]);
                    })(QueryPartNames = ThirdPartyResponse.QueryPartNames || (ThirdPartyResponse.QueryPartNames = {}));
                    function ToQueryParts(source) {
                        return __spread(Query.ToQueryParts(source), [new utils.Paths.QueryPart(QueryPartNames.Outcome, source.outcome.toString())]);
                    }
                    ThirdPartyResponse.ToQueryParts = ToQueryParts;
                    function Parse(source) {
                        var loaded = {
                            completionToken: false,
                            outcome: false,
                            defaultPaymentMethod: false
                        };
                        source = __spread(source);
                        var result = Query.Parse(source);
                        try {
                            for (var source_5 = __values(source), source_5_1 = source_5.next(); !source_5_1.done; source_5_1 = source_5.next()) {
                                var queryPart = source_5_1.value;
                                switch (queryPart.Key) {
                                    case QueryPartNames.CompletionToken:
                                        WriteResult("completionToken", queryPart.Value);
                                        break;
                                    case QueryPartNames.Outcome:
                                        WriteResult("outcome", Number(queryPart.Value));
                                        break;
                                    case QueryPartNames.DefaultPaymentMethod:
                                        WriteResult("defaultPaymentMethod", Number(queryPart.Value));
                                        break;
                                }
                            }
                        }
                        catch (e_76_1) { e_76 = { error: e_76_1 }; }
                        finally {
                            try {
                                if (source_5_1 && !source_5_1.done && (_a = source_5.return)) _a.call(source_5);
                            }
                            finally { if (e_76) throw e_76.error; }
                        }
                        if (!utils.Collection.ToEnumerable(Object.values(loaded)).All(function (hasLoaded) { return hasLoaded; }))
                            throw new Error("Cannot parse all payment details");
                        return result;
                        function WriteResult(key, value) {
                            loaded[key] = true;
                            result[key] = value;
                        }
                        var e_76, _a;
                    }
                    ThirdPartyResponse.Parse = Parse;
                })(ThirdPartyResponse = Query.ThirdPartyResponse || (Query.ThirdPartyResponse = {}));
            })(Query = PaymentMethodRegister.Query || (PaymentMethodRegister.Query = {}));
            var RequestData;
            (function (RequestData) {
                RequestData.NonceDefaultLength = 16;
                function GenerateNonce(length) {
                    if (length === void 0) { length = RequestData.NonceDefaultLength; }
                    function pad(value) {
                        return value.length === 2 ? value : "0" + value;
                    }
                    var bytes = window.crypto.getRandomValues(new Uint8Array(length));
                    return __spread(bytes).map(function (v) { return pad((v & 0xFF).toString(16)); }).join("");
                }
                RequestData.GenerateNonce = GenerateNonce;
                var Base = (function () {
                    function Base(source) {
                        this.AngularPortalsRequestId = source.AngularPortalsRequestId;
                        utils.SetEnumerability(this, "expiryRaw", false);
                        if (!utils.IsVoid(source.Expiry))
                            this.expiryRaw = utils.IsString(source.Expiry) ? source.Expiry : moment(source.Expiry);
                        else
                            this.expiryRaw = moment().add(Base.DefaultExpiry);
                        this.Nonce = source.Nonce;
                    }
                    Object.defineProperty(Base, "DefaultExpiry", {
                        get: function () {
                            return moment.duration(1, "d");
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(Base.prototype, "Expiry", {
                        get: function () {
                            return moment(this.expiryRaw);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return Base;
                }());
                RequestData.Base = Base;
                var Launch = (function (_super) {
                    __extends(Launch, _super);
                    function Launch(source) {
                        var _this = _super.call(this, source) || this;
                        _this.ContactCode = source.ContactCode;
                        _this.NotFinalStep = source.NotFinalStep;
                        return _this;
                    }
                    Launch.FromJson = function (source) {
                        return new Launch(angular.fromJson(source));
                    };
                    Launch.ToJson = function (source) {
                        return angular.toJson({
                            Nonce: source.Nonce,
                            AngularPortalsRequestId: source.AngularPortalsRequestId,
                            Expiry: source.Expiry.toJSON(),
                            ContactCode: source.ContactCode,
                            NotFinalStep: source.NotFinalStep,
                        });
                    };
                    return Launch;
                }(Base));
                RequestData.Launch = Launch;
                var AwaitingThirdParty = (function (_super) {
                    __extends(AwaitingThirdParty, _super);
                    function AwaitingThirdParty(source) {
                        var _this = _super.call(this, source) || this;
                        _this.SelcommRegistrationRequestId = source.SelcommRegistrationRequestId;
                        _this.NotFinalStep = source.NotFinalStep;
                        return _this;
                    }
                    AwaitingThirdParty.FromJson = function (source) {
                        return new AwaitingThirdParty(angular.fromJson(source));
                    };
                    AwaitingThirdParty.ToJson = function (source) {
                        return angular.toJson({
                            Nonce: source.Nonce,
                            AngularPortalsRequestId: source.AngularPortalsRequestId,
                            Expiry: source.Expiry.toJSON(),
                            SelcommRegistrationRequestId: source.SelcommRegistrationRequestId,
                            NotFinalStep: source.NotFinalStep,
                        });
                    };
                    return AwaitingThirdParty;
                }(Base));
                RequestData.AwaitingThirdParty = AwaitingThirdParty;
                var Success = (function (_super) {
                    __extends(Success, _super);
                    function Success(source) {
                        var _this = _super.call(this, source) || this;
                        utils.SetEnumerability(_this, "rawAccountPaymentMethod", false);
                        utils.SetEnumerability(_this, "cachedAccountPaymentMethod", false);
                        _this.rawAccountPaymentMethod = source.AccountPaymentMethod;
                        return _this;
                    }
                    Success.FromJson = function (source) {
                        var initialiser = angular.fromJson(source);
                        return new Success(__assign({}, initialiser, { AccountPaymentMethod: utils.ReviveClasses(initialiser.AccountPaymentMethod) }));
                    };
                    Success.ToJson = function (source) {
                        return angular.toJson({
                            Nonce: source.Nonce,
                            AngularPortalsRequestId: source.AngularPortalsRequestId,
                            Expiry: source.Expiry.toJSON(),
                            AccountPaymentMethod: source.AccountPaymentMethod,
                            ThirdPartyResult: source.ThirdPartyResult,
                        });
                    };
                    Object.defineProperty(Success.prototype, "AccountPaymentMethod", {
                        get: function () {
                            if (utils.IsVoid(this.cachedAccountPaymentMethod)) {
                                if (this.rawAccountPaymentMethod instanceof service_13.Selcomm.Payment.AccountPaymentMethod)
                                    this.cachedAccountPaymentMethod = this.rawAccountPaymentMethod;
                                else
                                    this.cachedAccountPaymentMethod = utils.ReviveClasses(this.rawAccountPaymentMethod);
                            }
                            return this.cachedAccountPaymentMethod;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(Success.prototype, "ThirdPartyResult", {
                        get: function () {
                            return service_13.Selcomm.Payment.OnlineRegistrationResult.Success;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return Success;
                }(Base));
                RequestData.Success = Success;
                var Failure = (function (_super) {
                    __extends(Failure, _super);
                    function Failure(source) {
                        var _this = _super.call(this, source) || this;
                        _this.Reason = source.Reason;
                        return _this;
                    }
                    Failure.FromJson = function (source) {
                        return new Failure(angular.fromJson(source));
                    };
                    Failure.ToJson = function (source) {
                        return angular.toJson({
                            Nonce: source.Nonce,
                            AngularPortalsRequestId: source.AngularPortalsRequestId,
                            Expiry: source.Expiry.toJSON(),
                            Reason: source.Reason,
                        });
                    };
                    Object.defineProperty(Failure.prototype, "ThirdPartyResult", {
                        get: function () {
                            return service_13.Selcomm.Payment.OnlineRegistrationResult.Failure;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return Failure;
                }(Base));
                RequestData.Failure = Failure;
                var Parser;
                (function (Parser) {
                    var typeParserByName = new Map();
                    var typeParserByProto = new Map();
                    function RegisterSupport(typeParser, name) {
                        if (utils.IsVoid(name)) {
                            if (utils.IsVoid(typeParser.name))
                                throw new Error("A name must be provided");
                            name = typeParser.name;
                        }
                        if (typeParserByName.has(name) || typeParserByProto.has(typeParser.prototype))
                            throw new Error("Already registered: " + name);
                        typeParserByName.set(name, typeParser);
                        typeParserByProto.set(typeParser.prototype, { name: name, typeParser: typeParser, });
                    }
                    Parser.RegisterSupport = RegisterSupport;
                    function Format(data) {
                        var typeParser = typeParserByProto.get(Object.getPrototypeOf(data));
                        if (utils.IsVoid(typeParser))
                            throw new Error("Not registered!");
                        return JSON.stringify({
                            typeName: typeParser.name,
                            data: typeParser.typeParser.ToJson(data),
                        });
                    }
                    Parser.Format = Format;
                    function Parse(data) {
                        if (utils.IsVoid(data) || data === "undefined")
                            return void undefined;
                        var obj = angular.fromJson(data);
                        if (!utils.IsObjectLike(obj) || !utils.HasProp(obj, "typeName", true) || !utils.IsString(obj.typeName) || !utils.HasProp(obj, "data", true) || !utils.IsString(obj.data))
                            throw new Error("Invalid format");
                        var typeParser = typeParserByName.get(obj.typeName);
                        if (utils.IsVoid(typeParser))
                            throw new Error("Specified type is not supported: " + obj.typeName);
                        return typeParser.FromJson(obj.data);
                    }
                    Parser.Parse = Parse;
                })(Parser || (Parser = {}));
                Parser.RegisterSupport(Launch);
                Parser.RegisterSupport(AwaitingThirdParty);
                Parser.RegisterSupport(Success);
                Parser.RegisterSupport(Failure);
                var Store;
                (function (Store) {
                    var store = thirdPartyStore.Prefixed("request:", Parser);
                    function GetNextKey() {
                        Cleanup();
                        var allKeys = store.Keys
                            .Select(function (k) { return Number(k); })
                            .Where(function (k) { return Number.isInteger(k); })
                            .ToArray();
                        return utils.Collection.ToEnumerable(allKeys)
                            .Select(function (k) { return k + 1; })
                            .Where(function (ck) { return ck > 0; })
                            .Where(function (ck) { return allKeys.indexOf(ck) < 0; })
                            .MinOrDefault(1)
                            .toString();
                    }
                    Store.GetNextKey = GetNextKey;
                    function Cleanup() {
                        var now = moment();
                        var expiredKeys = store.Entries
                            .Where(function (e) { return utils.IsVoid(e.Value) || now.isAfter(moment(e.Value.Expiry)); })
                            .Select(function (e) { return e.Key; })
                            .ToArray();
                        try {
                            for (var expiredKeys_1 = __values(expiredKeys), expiredKeys_1_1 = expiredKeys_1.next(); !expiredKeys_1_1.done; expiredKeys_1_1 = expiredKeys_1.next()) {
                                var expiredKey = expiredKeys_1_1.value;
                                store.RemoveItem(expiredKey);
                            }
                        }
                        catch (e_77_1) { e_77 = { error: e_77_1 }; }
                        finally {
                            try {
                                if (expiredKeys_1_1 && !expiredKeys_1_1.done && (_a = expiredKeys_1.return)) _a.call(expiredKeys_1);
                            }
                            finally { if (e_77) throw e_77.error; }
                        }
                        var e_77, _a;
                    }
                    Store.Cleanup = Cleanup;
                    function Add(data) {
                        Cleanup();
                        var key = data.AngularPortalsRequestId.toString();
                        var preExisting = store.GetItem(key);
                        if (!utils.IsVoid(preExisting))
                            throw new Error("Token already recorded");
                        store.SetItem(key, data);
                    }
                    Store.Add = Add;
                    function Get(key) {
                        var value = TryGet(key).value;
                        if (utils.IsVoid(value))
                            throw new Error("No token recorded");
                        return value;
                    }
                    function TryGet(key, predicate) {
                        Cleanup();
                        if (!store.HasKey(key))
                            return { hasKey: false, value: undefined, };
                        var requestData = store.GetItem(key);
                        if (utils.IsVoid(requestData)) {
                            store.RemoveItem(key);
                            return { hasKey: false, value: undefined, };
                        }
                        if (!utils.IsVoid(predicate) && !predicate(requestData))
                            return { hasKey: true, value: undefined, };
                        return { hasKey: true, value: requestData, };
                    }
                    function GetAndRemove(key) {
                        var requestData = Get(key);
                        store.RemoveItem(key);
                        return requestData;
                    }
                    Store.GetAndRemove = GetAndRemove;
                    function GetAndRemoveWhen(key, predicate) {
                        var requestData = Get(key);
                        if (!predicate(requestData))
                            throw new Error("Invalid match");
                        store.RemoveItem(key);
                        return requestData;
                    }
                    Store.GetAndRemoveWhen = GetAndRemoveWhen;
                    function Has(key, predicate) {
                        if (!store.HasKey(key))
                            return false;
                        if (utils.IsVoid(predicate))
                            return true;
                        var value = store.GetItem(key);
                        if (utils.IsVoid(value))
                            return false;
                        return !!predicate(value);
                    }
                    Store.Has = Has;
                    function Clear(key) {
                        Cleanup();
                        return store.RemoveItem(key);
                    }
                    Store.Clear = Clear;
                })(Store = RequestData.Store || (RequestData.Store = {}));
            })(RequestData = PaymentMethodRegister.RequestData || (PaymentMethodRegister.RequestData = {}));
            var windowFeaturesObj = new utils.Window.WindowFeatures({
                Rectangle: new utils.Window.Rectangle({
                    CenterScreen: true,
                    Size: new utils.Window.Rectangle.OuterSize(500, 500),
                }),
                Chrome: new utils.Window.Chrome({
                    MenuBar: false,
                    Toolbar: false,
                    Location: false,
                    PersonalBar: false,
                    Status: false,
                }),
                WindowFunctionality: new utils.Window.Functionality({
                    Dependant: false,
                    NoOpener: false,
                }),
            });
            PaymentMethodRegister.WindowFeatures = windowFeaturesObj.Format();
            var InnerCancellationObject = (function () {
                function InnerCancellationObject() {
                    this.CanBeCancelled = true;
                    this.cancelled = false;
                    this.CurrentState = Request.State.Initialising;
                }
                Object.defineProperty(InnerCancellationObject.prototype, "IsCancellationRequested", {
                    get: function () {
                        return this.cancelled;
                    },
                    enumerable: true,
                    configurable: true
                });
                InnerCancellationObject.prototype.RequestCancellation = function () {
                    this.cancelled = true;
                };
                Object.defineProperty(InnerCancellationObject.prototype, "State", {
                    get: function () {
                        return this.CurrentState;
                    },
                    set: function (value) {
                        this.CurrentState = value;
                        ng_utils_19.$rootScope.$applyAsync();
                    },
                    enumerable: true,
                    configurable: true
                });
                return InnerCancellationObject;
            }());
            var Request = (function () {
                function Request(source, AccountPaymentMethod, RegistrationWindow) {
                    this.source = source;
                    this.AccountPaymentMethod = AccountPaymentMethod;
                    this.RegistrationWindow = RegistrationWindow;
                }
                Object.defineProperty(Request.prototype, "CanBeCancelled", {
                    get: function () {
                        return this.source.CanBeCancelled;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(Request.prototype, "IsCancellationRequested", {
                    get: function () {
                        return this.source.IsCancellationRequested;
                    },
                    enumerable: true,
                    configurable: true
                });
                Request.prototype.RequestCancellation = function () {
                    return __awaiter(this, void 0, ng_utils_19.$q, function () {
                        var err_16;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.source.RequestCancellation();
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4, this.AccountPaymentMethod];
                                case 2:
                                    _a.sent();
                                    return [3, 4];
                                case 3:
                                    err_16 = _a.sent();
                                    return [3, 4];
                                case 4: return [2];
                            }
                        });
                    });
                };
                Object.defineProperty(Request.prototype, "State", {
                    get: function () {
                        return this.source.State;
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(Request.prototype, "ThirdPartyDisplayName", {
                    get: function () {
                        return "the third-party";
                    },
                    enumerable: true,
                    configurable: true
                });
                Request.prototype.OpenModal = function (event) {
                    return __awaiter(this, void 0, void 0, function () {
                        var _this = this;
                        var dialogTag, needsDialog, componentLoaded, options;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    dialogTag = "sds-payment-thirdparty-register-modal";
                                    needsDialog = new ng_utils_19.$q(function (resolve, reject) {
                                        var unwatch = ng_utils_19.$rootScope.$watch(function () { return _this.State; }, function (state) {
                                            switch (state) {
                                                case Request.State.Initialising:
                                                    return;
                                                case Request.State.AwaitingThirdParty:
                                                case Request.State.MaybeAwaitingThirdParty:
                                                    unwatch();
                                                    resolve(state);
                                                    break;
                                                default:
                                                    unwatch();
                                                    reject(state);
                                                    break;
                                            }
                                        });
                                    });
                                    componentLoaded = utils.Require("directive!" + dialogTag);
                                    return [4, needsDialog];
                                case 1:
                                    _a.sent();
                                    return [4, componentLoaded];
                                case 2:
                                    _a.sent();
                                    options = {
                                        clickOutsideToClose: false,
                                        escapeToClose: false,
                                        hasBackdrop: true,
                                        scope: angular.extend(ng_utils_19.$rootScope.$new(), {
                                            targetRequest: this,
                                        }),
                                        targetEvent: event,
                                        template: "<" + dialogTag + " request=\"targetRequest\"></" + dialogTag + ">",
                                    };
                                    return [4, ng_utils_19.$mdDialog.show(options)];
                                case 3:
                                    _a.sent();
                                    return [2];
                            }
                        });
                    });
                };
                Request.prototype.CloseRegistrationWindow = function () {
                    if (this.State !== Request.State.Finished)
                        throw new Error("Cannot close the window unless if the request is finished. If you want to cancel the request try calling `RequestCancellation`");
                    if (!this.RegistrationWindow)
                        throw new Error("No registration window to close");
                    if (this.RegistrationWindow.closed)
                        return;
                    this.RegistrationWindow.close();
                };
                Request.prototype.TryCloseRegistrationWindow = function (logError) {
                    if (logError === void 0) { logError = true; }
                    try {
                        this.CloseRegistrationWindow();
                    }
                    catch (err) {
                        if (logError)
                            ng_utils_19.$exceptionHandler(err);
                    }
                };
                return Request;
            }());
            PaymentMethodRegister.Request = Request;
            (function (Request) {
                var CancelledError = (function (_super) {
                    __extends(CancelledError, _super);
                    function CancelledError() {
                        return _super.call(this, "Cancellation of the payment registration process was requested") || this;
                    }
                    CancelledError = __decorate([
                        utils.FixExtendBuiltIn
                    ], CancelledError);
                    return CancelledError;
                }(Error));
                Request.CancelledError = CancelledError;
                var State;
                (function (State) {
                    State["Initialising"] = "init";
                    State["AwaitingThirdParty"] = "awaiting-third-party";
                    State["MaybeAwaitingThirdParty"] = "maybe-awaiting-third-party";
                    State["Finalising"] = "finalising";
                    State["Finished"] = "finished";
                })(State = Request.State || (Request.State = {}));
            })(Request = PaymentMethodRegister.Request || (PaymentMethodRegister.Request = {}));
            var PreparedRequest = (function () {
                function PreparedRequest(Nonce, Key, LaunchUri) {
                    this.Nonce = Nonce;
                    this.Key = Key;
                    this.LaunchUri = LaunchUri;
                }
                PreparedRequest.Create = function (contactCode, options) {
                    var nonce = RequestData.GenerateNonce();
                    var key = RequestData.Store.GetNextKey();
                    var current = new utils.Paths.UriBuilder(window.location.href);
                    var safeQueryParts = current.QueryParts.filter(function (qp) { return Query.LaunchRequest.QueryPartNames.All.indexOf(qp.Key) < 0; });
                    var launchUri = new utils.Paths.UriBuilder({
                        Scheme: current.Scheme,
                        Authority: current.Authority,
                        Path: utils.Paths.MapPath.FromTrueRoot("~/" + sites_1.Service.Current.Name + "/$$/Home/ThirdPartyPaymentRegisterLaunch/"),
                        Query: __spread(safeQueryParts, Query.LaunchRequest.ToQueryParts({ key: key, nonce: nonce, })),
                    });
                    RequestData.Store.Add(new RequestData.Launch({
                        AngularPortalsRequestId: key,
                        ContactCode: contactCode,
                        Nonce: nonce,
                        NotFinalStep: options.notFinalStep,
                    }));
                    return new PreparedRequest(nonce, key, launchUri.toString());
                };
                PreparedRequest.prototype.Open = function (target, features) {
                    if (target === void 0) { target = "_blank"; }
                    if (features === void 0) { features = PaymentMethodRegister.WindowFeatures; }
                    var x = window.open(this.LaunchUri, target, features);
                    return x;
                };
                return PreparedRequest;
            }());
            PaymentMethodRegister.PreparedRequest = PreparedRequest;
            function Invoke(options) {
                var request = PrepareRequest(options);
                var window = request.Open();
                return AwaitRequest(request, window);
            }
            PaymentMethodRegister.Invoke = Invoke;
            function PrepareRequest(options) {
                return PreparedRequest.Create(options.targetContactCode, options);
            }
            PaymentMethodRegister.PrepareRequest = PrepareRequest;
            function AwaitRequest(request, registrationWindow) {
                var innerToken = new InnerCancellationObject();
                var wrappedPromise = ng_utils_19.$q.resolve(InternalAwaitRequest({ key: request.Key, nonce: request.Nonce, requestTracker: innerToken, registrationWindow: registrationWindow, }));
                wrappedPromise.catch(function (err) { return ng_utils_19.$exceptionHandler(err); });
                return new Request(innerToken, wrappedPromise, registrationWindow);
            }
            PaymentMethodRegister.AwaitRequest = AwaitRequest;
            function InternalAwaitRequest(args) {
                return __awaiter(this, void 0, void 0, function () {
                    var key, nonce, registrationWindow, requestTracker, canReadClosed, requestData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                key = args.key, nonce = args.nonce, registrationWindow = args.registrationWindow, requestTracker = args.requestTracker;
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, , 8, 9]);
                                if (utils.IsVoid(requestTracker))
                                    throw new Error("cancellationToken cannot be void");
                                canReadClosed = false;
                                try {
                                    canReadClosed = !!registrationWindow && utils.IsBoolean(registrationWindow.closed);
                                }
                                catch (err) {
                                    canReadClosed = false;
                                }
                                requestTracker.State = canReadClosed ? Request.State.AwaitingThirdParty : Request.State.MaybeAwaitingThirdParty;
                                _a.label = 2;
                            case 2:
                                _a.trys.push([2, , 6, 7]);
                                _a.label = 3;
                            case 3:
                                if (!(!RequestData.Store.Has(key, function (x) { return x instanceof RequestData.Failure || x instanceof RequestData.Success; }) && (!registrationWindow || !canReadClosed || !registrationWindow.closed))) return [3, 5];
                                if (requestTracker.IsCancellationRequested) {
                                    try {
                                        registrationWindow && registrationWindow.close();
                                    }
                                    catch (err) { }
                                    throw new Request.CancelledError();
                                }
                                return [4, new Promise(function (resolve) { return setTimeout(resolve, 200); })];
                            case 4:
                                _a.sent();
                                return [3, 3];
                            case 5: return [3, 7];
                            case 6:
                                requestTracker.State = Request.State.Finalising;
                                return [7];
                            case 7:
                                requestData = RequestData.Store.GetAndRemove(key);
                                if (requestData.Nonce !== nonce)
                                    throw new Error("Invalid nonce");
                                if (requestData instanceof RequestData.Success)
                                    return [2, utils.AssertNotVoid(requestData.AccountPaymentMethod)];
                                else if (requestData instanceof RequestData.Failure)
                                    throw new Error(requestData.Reason);
                                else
                                    throw new Error("Unexpected failure");
                                return [3, 9];
                            case 8:
                                requestTracker.State = Request.State.Finished;
                                requestTracker.CanBeCancelled = false;
                                return [7];
                            case 9: return [2];
                        }
                    });
                });
            }
        })(PaymentMethodRegister = ThirdParty.PaymentMethodRegister || (ThirdParty.PaymentMethodRegister = {}));
    })(ThirdParty = exports.ThirdParty || (exports.ThirdParty = {}));
});
define("app/sds/phone/list/sds-phone-list", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "module", "app/sss/sites"], function (require, exports, utils, ng_utils_20, service_14, module_16, sites_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_16.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Phones = new Array();
            _this.PhoneTypes = Object.freeze(new Array());
            _this.LoadingPhoneTypes = new utils.ActivityController();
            _this.LoadingPhones = new utils.ActivityController();
            _this.FailedPhonesLoad = false;
            _this.FailedPhoneTypesLoad = false;
            _this.AddingPhone = false;
            _this.LoadPhones();
            _this.LoadPhoneTypes();
            _this.Watch.Collection(function () { return _this.Phones; }, function () { return _this.AddablePhoneTypes = _this.GetAddableTypes(); });
            _this.Watch.Collection(function () { return _this.PhoneTypes; }, function () { return _this.AddablePhoneTypes = _this.GetAddableTypes(); });
            return _this;
        }
        Controller_16 = Controller;
        Controller.prototype.GetPhones = function (contactCode) {
            return __awaiter(this, void 0, ng_utils_20.$q, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_14.Service.Contact.ContactPhoneList({ ContactCode: contactCode })];
                        case 1: return [2, (_a.sent())
                                .filter(function (p) { return p.ContactPhoneType && Controller_16.HiddenPhoneTypeCodes.indexOf(p.ContactPhoneType.Code) < 0; })];
                    }
                });
            });
        };
        Controller.GetPhoneTypes = function () {
            return __awaiter(this, void 0, ng_utils_20.$q, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_14.CachedService.ContactPhone.ContactPhoneTypeList({})];
                        case 1: return [2, (_a.sent())
                                .filter(function (pt) { return Controller_16.HiddenPhoneTypeCodes.indexOf(pt.Code) < 0; })];
                    }
                });
            });
        };
        Controller.prototype.OnPhoneAdded = function (phone) {
            this.Phones.push(phone);
            this.AddingPhone = false;
        };
        Controller.prototype.CanUpdate = function (phone) {
            switch (sites_2.Site.Current.Hash) {
                case "a85fd748d6400a3aa6972d88b41869f93af12ff1fc924d6fb8390d3f83a1a24f":
                    return false;
                default:
                    return true;
            }
        };
        Controller.prototype.CanDelete = function (phone) {
            switch (sites_2.Site.Current.Hash) {
                case "a85fd748d6400a3aa6972d88b41869f93af12ff1fc924d6fb8390d3f83a1a24f":
                    return false;
                case "88a2332c85130219b24b54d8015babf30a3ebd9e7b98c18e3cd5dfa24a70bd6e":
                case "1e5beccc1dfbba83df8715a2d7b8cffac5f893f9dade0785ee971d445465b497":
                case "79c6e970698a5215a0058f22068aa80fc41da72e404f0d7dc9891dc6fbcd0889":
                    return phone && phone.ContactPhoneType && phone.ContactPhoneType.Code !== "HP";
                default:
                    return this.Phones && this.Phones.length > 1;
            }
        };
        Controller.prototype.RemoveInstance = function (phone) {
            utils.Collection.ArrayRemoveAll(this.Phones, phone);
        };
        Controller.prototype.RemoveOfType = function (phoneTypeCode) {
            utils.Collection.ArrayRemoveWhere(this.Phones, function (p) { return p.ContactPhoneType && p.ContactPhoneType.Code === phoneTypeCode; });
        };
        Controller.prototype.OnPhoneDeleted = function (phone) {
            this.RemoveOfType(phone.ContactPhoneType.Code);
        };
        Object.defineProperty(Controller.prototype, "FailedLoad", {
            get: function () {
                return this.FailedPhonesLoad || this.FailedPhoneTypesLoad;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.LoadPhoneTypes = function () {
            return __awaiter(this, void 0, ng_utils_20.$q, function () {
                var token, loadedPhoneTypes, err_17;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.LoadingPhoneTypes.CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4, Controller_16.GetPhoneTypes()];
                        case 2:
                            loadedPhoneTypes = _a.sent();
                            if (token.HasExited)
                                return [2];
                            this.PhoneTypes = loadedPhoneTypes;
                            this.FailedPhoneTypesLoad = false;
                            return [3, 5];
                        case 3:
                            err_17 = _a.sent();
                            this.PhoneTypes = [];
                            this.FailedPhoneTypesLoad = true;
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        Controller.prototype.LoadPhones = function () {
            return __awaiter(this, void 0, ng_utils_20.$q, function () {
                var token, loadedPhones, err_18, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            token = this.LoadingPhones.CloseAndEnter();
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            return [4, this.GetPhones(service_14.Auth.CurrentSession.CurrentContactCode)];
                        case 2:
                            loadedPhones = _b.sent();
                            if (token.HasExited)
                                return [2];
                            (_a = this.Phones).push.apply(_a, __spread(loadedPhones));
                            this.FailedPhonesLoad = false;
                            return [3, 5];
                        case 3:
                            err_18 = _b.sent();
                            this.Phones = [];
                            this.FailedPhonesLoad = true;
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "CanAdd", {
            get: function () {
                switch (sites_2.Site.Current.Hash) {
                    case "a85fd748d6400a3aa6972d88b41869f93af12ff1fc924d6fb8390d3f83a1a24f":
                        return false;
                    default:
                        return utils.IsVoid(this.AddablePhoneTypes) ? this.AddablePhoneTypes : this.AddablePhoneTypes.length > 0;
                }
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.GetAddableTypes = function () {
            var _this = this;
            if (!this.PhoneTypes || !this.Phones)
                return undefined;
            if (this.PhoneTypes.length <= 0 || this.Phones.length <= 0)
                return this.PhoneTypes;
            return this.PhoneTypes.filter(function (pt) { return !utils.Collection.Any(_this.Phones, function (p) { return p.ContactPhoneType && p.ContactPhoneType.Code === pt.Code; }); });
        };
        Controller.prototype.EnterAdd = function () {
            return __awaiter(this, void 0, ng_utils_20.$q, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.CanAdd && !this.FailedPhoneTypesLoad)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 4, 5]);
                            if (!this.FailedPhoneTypesLoad) return [3, 3];
                            return [4, this.LoadPhoneTypes()];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [3, 5];
                        case 4:
                            this.AddingPhone = true;
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        Controller.prototype.CancelAdd = function () {
            this.AddingPhone = false;
        };
        Controller.HiddenPhoneTypeCodes = ["CC"];
        Controller = Controller_16 = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
        var Controller_16;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/phone/sds-phone", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "module", "app/sdc/crud/sdc-crud"], function (require, exports, utils, ng_utils_21, service_15, module_17, crud) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this._State = crud.State.Read;
            _this.UpdateActivity = new utils.ActivityController("Updating");
            _this.DeleteActivity = new utils.ActivityController("Deleting");
            _this.Watch(function () { return _this.Phone && _this.Phone.Number; }, function (phoneNumber, lastPhoneNumber) {
                if (lastPhoneNumber === phoneNumber || lastPhoneNumber === _this.NewNumber)
                    _this.NewNumber = phoneNumber;
            });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "CanDelete", {
            get: function () {
                return utils.IsVoid(this.BoundCanDelete) || this.BoundCanDelete;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CanUpdate", {
            get: function () {
                return utils.IsVoid(this.BoundCanUpdate) || this.BoundCanUpdate;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "State", {
            get: function () {
                switch (this._State) {
                    case crud.State.Read:
                        if (this.IsDirty)
                            return crud.State.Update;
                        return crud.State.Read;
                    default:
                        return this._State;
                }
            },
            set: function (value) {
                this._State = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.CancelUpdate = function () {
            this.ResetInputs();
            this.State = crud.State.Read;
        };
        Controller.prototype.Delete = function () {
            return __awaiter(this, void 0, ng_utils_21.$q, function () {
                var targetPhone, token, ex_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            targetPhone = this.Phone;
                            if (this.UpdateActivity.IsActive)
                                throw new utils.AlreadyDoingActionError("Cannot update while deleting");
                            token = this.DeleteActivity.Enter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            if (!this.CanDelete) {
                                utils.Toast.Simple("This phone cannot be deleted");
                                throw new Error("Cannot delete phone");
                            }
                            return [4, service_15.Service.ContactPhone.ContactPhoneDelete({
                                    ContactPhone: targetPhone,
                                })];
                        case 2:
                            _a.sent();
                            return [3, 5];
                        case 3:
                            ex_3 = _a.sent();
                            utils.Toast.Simple("An error occurred removing your phone details.");
                            throw ex_3;
                        case 4:
                            token.Exit();
                            return [7];
                        case 5:
                            this.State = crud.State.Read;
                            this.OnDeleted({ phone: targetPhone });
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.CancelDelete = function () {
            this.State = crud.State.Read;
        };
        Object.defineProperty(Controller.prototype, "IsProcessing", {
            get: function () {
                return this.UpdateActivity.IsActive || this.DeleteActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Update = function () {
            return __awaiter(this, void 0, ng_utils_21.$q, function () {
                var newPhone, token, _a, ex_4;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            newPhone = new service_15.Selcomm.ContactPhones.ContactPhone(__assign({}, this.Phone, { Number: this.NewNumber }));
                            if (this.DeleteActivity.IsActive)
                                throw new utils.AlreadyDoingActionError("Cannot update while deleting");
                            token = this.UpdateActivity.Enter();
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            if (!this.CanUpdate) {
                                utils.Toast.Simple("This phone cannot be updated");
                                throw new Error("Cannot update phone");
                            }
                            _a = newPhone;
                            return [4, service_15.Service.ContactPhone.ContactPhoneUpdate({
                                    ContactPhone: newPhone,
                                })];
                        case 2:
                            _a.Reference = _b.sent();
                            return [3, 5];
                        case 3:
                            ex_4 = _b.sent();
                            utils.Toast.Simple("An error occurred saving your phone details.");
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5:
                            this.Phone = newPhone;
                            this.State = crud.State.Read;
                            this.OnUpdated({ phone: newPhone });
                            return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "TypeDescription", {
            get: function () {
                return this.Phone && this.Phone.ContactPhoneType && utils.TrimEnd(this.Phone.ContactPhoneType.Description);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.EnterUpdate = function () {
            this.State = crud.State.Update;
            this.NewNumberIsFocused = true;
        };
        Controller.prototype.EnterDelete = function () {
            this.State = crud.State.Delete;
        };
        Controller.prototype.Submit = function (state, form) {
            return __awaiter(this, void 0, ng_utils_21.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are invalid");
                                throw new utils.FormInvalidError(form);
                            }
                            _a = state;
                            switch (_a) {
                                case crud.State.Update: return [3, 1];
                                case crud.State.Delete: return [3, 3];
                            }
                            return [3, 5];
                        case 1: return [4, this.Update()];
                        case 2: return [2, _b.sent()];
                        case 3: return [4, this.Delete()];
                        case 4: return [2, _b.sent()];
                        case 5: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsDirty", {
            get: function () {
                return (this.NewNumber || "") !== ((this.Phone && this.Phone.Number) || "");
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.ResetInputs = function () {
            this.NewNumber = (this.Phone && this.Phone.Number) || "";
        };
        __decorate([
            utils.Bind.TwoWay("phone")
        ], Controller.prototype, "Phone", void 0);
        __decorate([
            utils.Bind.Getter("on-deleted")
        ], Controller.prototype, "OnDeleted", void 0);
        __decorate([
            utils.Bind.In("can-delete", { optional: true })
        ], Controller.prototype, "BoundCanDelete", void 0);
        __decorate([
            utils.Bind.In("can-update", { optional: true })
        ], Controller.prototype, "BoundCanUpdate", void 0);
        __decorate([
            utils.Bind.Getter("on-updated")
        ], Controller.prototype, "OnUpdated", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_17.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/service/service-utils", ["require", "exports", "app/selcomm/service"], function (require, exports, service_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function ConvertServiceDisplayToService(serviceDisplay) {
        if (!(serviceDisplay instanceof service_16.Selcomm.Service.ServiceDisplay))
            return serviceDisplay;
        var initialiser = __assign({}, serviceDisplay, { ServiceId: serviceDisplay.Id, DisconnectionDateTime: serviceDisplay.DisconnectionDateTime, ServiceType: new service_16.Selcomm.Service.ServiceType({
                Code: serviceDisplay.ServiceTypeCode,
                Description: serviceDisplay.ServiceType
            }), Subscriber: new service_16.Selcomm.Contact.Contact({
                Code: serviceDisplay.SubscriberCode,
                FullName: serviceDisplay.Subscriber,
            }) });
        return new service_16.Selcomm.Service.Service(initialiser);
    }
    exports.ConvertServiceDisplayToService = ConvertServiceDisplayToService;
    function ConvertServiceToServiceDisplay(service) {
        if (!(service instanceof service_16.Selcomm.Service.Service))
            return service;
        var initialiser = __assign({}, service, { Id: service.ServiceId, DisconnectionDateTime: service.DisconnectionDateTime, ServiceType: service.ServiceType && service.ServiceType.Description, ServiceTypeCode: service.ServiceType && service.ServiceType.Code, Subscriber: service.Subscriber && service.Subscriber.FullName, SubscriberCode: service.Subscriber && service.Subscriber.Code });
        return new service_16.Selcomm.Service.ServiceDisplay(initialiser);
    }
    exports.ConvertServiceToServiceDisplay = ConvertServiceToServiceDisplay;
    function GetChildServiceForService(parentServiceRef) {
        return __awaiter(this, void 0, void 0, function () {
            var childServices;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_16.Service.Service.ServiceChildServiceDisplayListForContact({
                            SessionKey: service_16.Auth.CurrentSession.SessionKey,
                            ServiceId: parentServiceRef,
                            ContactCode: service_16.Auth.CurrentSession.CurrentContactCode
                        })];
                    case 1:
                        childServices = _a.sent();
                        return [2, childServices];
                }
            });
        });
    }
    exports.GetChildServiceForService = GetChildServiceForService;
});
define("app/sds/underconstruction/sds-underconstruction", ["require", "exports", "app/utils", "$window"], function (require, exports, utils, $window) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sds-underconstruction";
    var Controller = (function () {
        function Controller() {
        }
        Controller.prototype.Back = function () {
            $window.history.back();
        };
        __decorate([
            utils.Bind.Literal("display-name", { optional: true })
        ], Controller.prototype, "DisplayName", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "sds-underconstruction",
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/selcomm/authentication/selcomm-authentication-service", ["require", "exports", "app/selcomm/service"], function (require, exports, selcomm) {
    "use strict";
    return selcomm.Authentication;
});
define("app/selcomm/progress/selcomm-progress-factory", ["require", "exports", "app/selcomm/selcomm-api"], function (require, exports, api) {
    "use strict";
    function selcommProgressFactory(loaded, total) {
        switch (arguments.length) {
            case 1:
                if (angular.isObject(loaded) || true) {
                    total = loaded.total;
                    loaded = loaded.loaded;
                }
                break;
        }
        return new api.Progress(loaded, total);
    }
    return angular.extend(selcommProgressFactory, {
        isProgress: function isProgress(obj) {
            if (!angular.isObject(obj))
                return false;
            return obj instanceof api.Progress;
        }
    });
});
define("app/sf/ids/sf-ids", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function extractId(idAndValue) {
        var id = null;
        if (idAndValue) {
            var results = /^(?:[1-9]\d+|\d(?=-|$)|$)/.exec(idAndValue);
            if (results && results[0]) {
                id = results[0];
            }
        }
        return id ? Number(id) : null;
    }
    exports.extractId = extractId;
    function extractIds(obj) {
        return angular["mapMany"](obj, function (idAndValue, key) {
            return (_a = {}, _a[key + "Id"] = extractId(idAndValue), _a);
            var _a;
        });
    }
    exports.extractIds = extractIds;
});
define("app/sf/map/sf-map-filter", ["require", "exports", "app/utils", "$parse"], function (require, exports, utils, $parse) {
    "use strict";
    function MapFilter(objectOrArray, selectFnOrExpr) {
        if (utils.IsVoid(objectOrArray))
            return objectOrArray;
        if (utils.IsVoid(selectFnOrExpr))
            selectFnOrExpr = "";
        if (utils.IsString(selectFnOrExpr))
            selectFnOrExpr = $parse(selectFnOrExpr);
        var select = selectFnOrExpr;
        return utils.Collection.FromArrayOrObject(objectOrArray).map(function (v) { return select(v); });
    }
    return MapFilter;
});
define("app/sf/max/sf-max-filter", ["require", "exports", "app/basic-utils", "$parse"], function (require, exports, utils, $parse) {
    "use strict";
    function MaxFilter(objectOrArray, selectOperandFnExpression) {
        if (utils.IsVoid(objectOrArray))
            return objectOrArray;
        var values = utils.Collection.FromArrayOrObject(objectOrArray);
        if (utils.IsVoid(selectOperandFnExpression))
            return utils.Collection.Max(values);
        if (utils.IsString(selectOperandFnExpression))
            selectOperandFnExpression = $parse(selectOperandFnExpression);
        var selectOperand = selectOperandFnExpression;
        return utils.Collection.Max(values, function (v) { return selectOperand(v); });
    }
    return MaxFilter;
});
define("app/sf/unit/sf-unit-filter", ["require", "exports", "filter!number", "app/basic-utils"], function (require, exports, numberFilter, utils) {
    "use strict";
    function buildArray(input, unit, useShortName, defaultName) {
        var defaultShort = useShortName || defaultName, defaultLong = useShortName;
        if (utils.IsObject(unit))
            unit = unit.Code;
        switch (unit) {
            case "AUD":
                return ["$", numberFilter(input, 2)];
            case "$":
                return ["$", numberFilter(input, 2)];
            case "g":
                return [numberFilter(input, 2), defaultShort ? " GiB" : (input === 1 ? " gibibyte" : " gibibytes")];
            case "G":
                return [numberFilter(input, 2), defaultShort ? " Gbs" : (input === 1 ? " gigabyte" : " gigabytes")];
            case "M":
                return [numberFilter(input, 2), defaultShort ? " MB" : (input === 1 ? " mebibyte" : " mebibytes")];
            case "K":
                if ((input / 1024) > 0.5) {
                    return buildArray(input / 1024, "M", useShortName, defaultName);
                }
                return [numberFilter(input, 0), defaultShort ? " KB" : (input === 1 ? " kibibyte" : " kibibytes")];
            case "B":
                if (Math.floor(input / 1024) > 0) {
                    return buildArray(input / 1024, "K", useShortName, defaultName);
                }
                return [numberFilter(input, 0), defaultLong ? " B" : (input === 1 ? " byte" : " bytes")];
            case "h":
                if (input % 1 !== 0)
                    return __spread(buildArray(Math.floor(input), unit, useShortName, defaultName), [" "], buildArray((input % 1) * 60, "m", useShortName, defaultName));
                return [numberFilter(input), defaultShort ? "h" : (input === 1 ? " hour" : " hours")];
            case "m":
                if (input > 60)
                    return __spread(buildArray(Math.floor(input / 60), "h", useShortName, defaultName), [" "], buildArray(input % 60, unit, useShortName, defaultName));
                if (input % 1 !== 0)
                    return __spread(buildArray(Math.floor(input), unit, useShortName, defaultName), [" "], buildArray((input % 1) * 60, "S", useShortName, defaultName));
                return [numberFilter(input, 0), defaultShort ? "min" : (input === 1 ? " minute" : " minutes")];
            case "S":
                if (input > 60)
                    return __spread(buildArray(Math.floor(input / 60), "m", useShortName, defaultName), [" "], buildArray(input % 60, unit, useShortName, defaultName));
                return [numberFilter(input, 0), defaultShort ? "sec" : (input === 1 ? " second" : " seconds")];
            case "%":
                return [numberFilter(input, 2), defaultShort ? " %" : " percent"];
            case "E":
                return [numberFilter(input, 0)];
            case "kW":
                return [numberFilter(input, 2), defaultShort ? " kW" : " kilowatt"];
            case "w":
                return [numberFilter(input, 2), defaultShort ? " kWh" : " kilowatt hour" + (input === 1 ? "" : "s")];
            case "d":
                return [numberFilter(input, 0), defaultShort ? " d" : (input === 1 ? " day" : " days")];
            default:
                return [numberFilter(input, 2)];
        }
    }
    return function sfUnitFilter(input, unit, useShortName) {
        var displayText = buildArray(input, unit, useShortName, angular.isUndefined(useShortName)).join("");
        return displayText;
    };
});
define("app/sf/urlify/sf-urlify-filter", ["require", "exports", "app/basic-utils"], function (require, exports, utils) {
    "use strict";
    return function sfUrlifyFilter() {
        var parts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parts[_i] = arguments[_i];
        }
        return utils.Urlify.apply(utils, __spread(parts.map(utils.ToString)));
    };
});
define("app/ss/paymentmethod/ss-paymentmethod", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "app/sdc/crud/sdc-crud", "app/selcomm/service"], function (require, exports, utils, ng_utils_22, SelcommWS, Crud, service_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.State = Crud.State.Read;
            _this.EditingAccountPaymentMethod = utils.ReviveClasses(_this.BoundAccountPaymentMethod);
            _this.UpdateActivity = new utils.ActivityController("Update payment method");
            _this.DeleteActivity = new utils.ActivityController("Delete payment method");
            return _this;
        }
        Object.defineProperty(Controller.prototype, "Updating", {
            get: function () {
                return this.State === Crud.State.Update;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "AccountPaymentMethod", {
            get: function () {
                if (this.Updating)
                    return this.EditingAccountPaymentMethod;
                else
                    return this.BoundAccountPaymentMethod;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.EnterDelete = function () {
            this.State = Crud.State.Delete;
        };
        Controller.prototype.EnterUpdate = function () {
            this.State = Crud.State.Update;
            this.EditingAccountPaymentMethod = utils.ReviveClasses(this.BoundAccountPaymentMethod);
        };
        Controller.prototype.Cancel = function () {
            this.State = Crud.State.Read;
        };
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.UpdateActivity.IsActive || this.DeleteActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SetPaymentAsDefault = function () {
            this.Agreement = this.AccountPaymentMethod.BSB != null && this.AccountPaymentMethod.BSB != "" ?
                service_17.Auth.CurrentSession.DirectDebitAgreement_HTML : service_17.Auth.CurrentSession.CreditCardAgreement_HTML;
            var confirm = ng_utils_22.$mdDialog.confirm()
                .title('Default Payment Confirmation?')
                .htmlContent(this.Agreement)
                .ok('OK')
                .cancel('CANCEL');
            var self = this;
            ng_utils_22.$mdDialog.show(confirm).then(function (result) {
                service_17.Service.Payment.AccountPaymentMethodMakeDefault({
                    Id: self.AccountPaymentMethod.Id,
                    StatusCode: self.AccountPaymentMethod.PaymentMethod.Code,
                    StartDate: new Date()
                });
                self.AccountPaymentMethod.Default = true;
                self.CurrentDefaultAccountPaymentMethod.Default = false;
                self.CurrentDefaultAccountPaymentMethod = self.AccountPaymentMethod;
            }, function () {
            });
        };
        Controller.prototype.Update = function (form) {
            return __awaiter(this, void 0, ng_utils_22.$q, function () {
                var token, result, err_19;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.DeleteActivity.IsActive) {
                                utils.Toast.Simple("We're already processing your request to delete this payment method.");
                                throw new Error("Trying to update whilst deleting");
                            }
                            token = this.UpdateActivity.TryEnter();
                            if (utils.IsVoid(token)) {
                                utils.Toast.Simple("We're already updating your payment method, please wait before trying to update it again.");
                                throw new utils.AlreadyDoingActionError(this.UpdateActivity.Name);
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some of the inputs are invalid, please verify them before continuing");
                                throw new utils.FormInvalidError(form);
                            }
                            result = void 0;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            this.EditingAccountPaymentMethod.Id = this.BoundAccountPaymentMethod.Id;
                            this.EditingAccountPaymentMethod.BSB = this.BoundAccountPaymentMethod.BSB;
                            this.EditingAccountPaymentMethod.Default = this.EditingAccountPaymentMethod.Default;
                            return [4, service_17.Service.Payment.AccountPaymentMethodUpdate({
                                    AccountPaymentMethod: this.EditingAccountPaymentMethod,
                                })];
                        case 3:
                            result = _a.sent();
                            return [3, 5];
                        case 4:
                            err_19 = _a.sent();
                            utils.Toast.Simple("An error occured while updating your payment method.");
                            throw err_19;
                        case 5:
                            this.BoundAccountPaymentMethod = this.EditingAccountPaymentMethod;
                            this.onEdit({ $updating: this.EditingAccountPaymentMethod, });
                            utils.Toast.Simple("Your payment method has been updated successfully.");
                            return [2, result];
                        case 6:
                            token.Exit();
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        };
        Controller.prototype.Delete = function (form) {
            return __awaiter(this, void 0, ng_utils_22.$q, function () {
                var token, err_20;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.DeleteActivity.IsActive) {
                                utils.Toast.Simple("We're currently trying to process your update request, wait for that to finish first.");
                                throw new Error("Trying to delete whilst updating");
                            }
                            token = this.UpdateActivity.TryEnter();
                            if (utils.IsVoid(token)) {
                                utils.Toast.Simple("We're already processing your request to delete this payment method.");
                                throw new utils.AlreadyDoingActionError(this.UpdateActivity.Name);
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some of the inputs are invalid, please verify them before continuing");
                                throw new utils.FormInvalidError(form);
                            }
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, service_17.Service.Payment.AccountPaymentMethodCancel({
                                    Id: this.BoundAccountPaymentMethod.Id,
                                    Note: "Cancelled by Contact Code : " + SelcommWS.Authentication.CurrentSession.UserCode,
                                })];
                        case 3:
                            _a.sent();
                            return [3, 5];
                        case 4:
                            err_20 = _a.sent();
                            utils.Toast.Simple("An error occurred whilst deleting your payment method.");
                            return [3, 5];
                        case 5:
                            try {
                                this.onDelete({
                                    $deleting: this.BoundAccountPaymentMethod,
                                });
                            }
                            finally {
                                utils.Toast.Simple("Your payment method has been updated successfully.");
                            }
                            return [3, 7];
                        case 6:
                            token.Exit();
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        };
        Controller.prototype.Submit = function (form) {
            switch (this.State) {
                case Crud.State.Update:
                    return this.Update(form);
                case Crud.State.Delete:
                    return this.Delete(form);
                default:
                    utils.Toast.Simple("An error occurred");
                    throw new Error("Attempting to submit on unknown action " + this.State + ": " + Crud.State[this.State]);
            }
        };
        __decorate([
            utils.Bind.Getter("on-delete")
        ], Controller.prototype, "onDelete", void 0);
        __decorate([
            utils.Bind.Getter("on-edit")
        ], Controller.prototype, "onEdit", void 0);
        __decorate([
            utils.Bind.TwoWay("account-payment-method")
        ], Controller.prototype, "BoundAccountPaymentMethod", void 0);
        __decorate([
            utils.Bind.TwoWay("current-default-account-payment-method")
        ], Controller.prototype, "CurrentDefaultAccountPaymentMethod", void 0);
        Controller = __decorate([
            utils.Component({ Name: "ss-paymentmethod" })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sss/site/sss-site-service", ["require", "exports", "app/sss/sites"], function (require, exports, sites) {
    "use strict";
    return sites.Service;
});
define("app/sv/abn/sv-abn", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_18.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller.prototype.Init = function (ngModel) {
            var _this = this;
            if (ngModel === void 0) { ngModel = this.NgModelController; }
            ngModel.$validators[name] = function (modelValue, viewValue) { return _this.Validate(ngModel, modelValue, viewValue); };
        };
        Controller.prototype.Validate = function (ngModel, modelValue, viewValue) {
            if (ngModel.$isEmpty(viewValue))
                return true;
            if (!utils.IsString(viewValue))
                return false;
            return /^\d{11}$/.test(viewValue);
        };
        Controller.prototype.Parse = function (viewValue) {
            if (!utils.IsString(viewValue))
                return viewValue;
            return viewValue.replace(/[\s-(){}\[\]\\\/<>,\.]/g, "");
        };
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModelController", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = __decorate([
            utils.Component({
                Name: name,
                Restrict: utils.Target.Attribute,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sv/acn/sv-acn", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_19.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller.prototype.Init = function (ngModel) {
            var _this = this;
            if (ngModel === void 0) { ngModel = this.NgModelController; }
            ngModel.$validators[name] = function (modelValue, viewValue) { return _this.Validate(ngModel, modelValue, viewValue); };
        };
        Controller.prototype.Validate = function (ngModel, modelValue, viewValue) {
            if (ngModel.$isEmpty(viewValue))
                return true;
            if (!utils.IsString(viewValue))
                return false;
            return /^\d{9}$/.test(viewValue);
        };
        Controller.prototype.Parse = function (viewValue) {
            if (!utils.IsString(viewValue))
                return viewValue;
            return viewValue.replace(/[\s-(){}\[\]\\\/<>,\.]/g, "");
        };
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModelController", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = __decorate([
            utils.Component({
                Name: name,
                Restrict: utils.Target.Attribute,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sv/custom/sv-custom", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_20.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ActivityControllers = utils.MakeKeyedCollection();
            return _this;
        }
        Controller.prototype.ActivityController = function (name) {
            var found = this.ActivityControllers[name];
            if (utils.IsVoid(found))
                found = this.ActivityControllers[name] = new utils.ActivityController("sv-custom: " + name);
            return found;
        };
        Controller.prototype.Locals = function (ngModel) {
            return {
                modelValue: ngModel.$modelValue,
            };
        };
        Controller.prototype.OnPostLink = function () {
            this.Init();
        };
        Controller.prototype.Init = function (ngModel) {
            var _this = this;
            if (ngModel === void 0) { ngModel = this.NgModelController; }
            this.Watch.Collection(function () { return _this.GetValidity({ $modelValue: ngModel.$modelValue, $viewValue: ngModel.$viewValue }); }, function (validityBag, lastValidityBag) {
                validityBag = validityBag || {};
                lastValidityBag = lastValidityBag || {};
                for (var name_7 in lastValidityBag) {
                    if (utils.HasProp(validityBag, name_7))
                        continue;
                    _this.ApplyResult(ngModel, name_7, true);
                }
                for (var name_8 in validityBag) {
                    var value = validityBag[name_8];
                    if (!utils.IsPromiseLike(value))
                        _this.ApplyResult(ngModel, name_8, value);
                    else
                        _this.AwaitAndApplyAsycResult(ngModel, name_8, value);
                }
            });
        };
        Controller.prototype.AwaitAndApplyAsycResult = function (ngModel, name, asyncResult) {
            return __awaiter(this, void 0, void 0, function () {
                var token, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.ActivityController(name).CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4, asyncResult];
                        case 2:
                            result = _a.sent();
                            if (token.HasExited)
                                return [2];
                            this.ApplyResult(ngModel, name, result);
                            return [3, 4];
                        case 3:
                            token.Exit();
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.ApplyResult = function (ngModel, name, result) {
            this.ActivityController(name).ExitAnyToken();
            ngModel.$setValidity(name, result);
        };
        __decorate([
            utils.Bind.Getter(name)
        ], Controller.prototype, "GetValidity", void 0);
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModelController", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "OnPostLink", null);
        Controller = __decorate([
            utils.Component({
                Name: name,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sv/equals/sv-equals", ["require", "exports", "module", "app/utils"], function (require, exports, module_21, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_21.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch(function () { return _this.ExpectedValue; }, function () { return _this.NgModelCtrl.$validate(); });
            return _this;
        }
        Controller.prototype.Validate = function (value, isEmpty) {
            return isEmpty(value) || isEmpty(this.ExpectedValue) || value === this.ExpectedValue;
        };
        Controller.prototype.InitialiseValidator = function (ngModelCtrl) {
            var _this = this;
            if (ngModelCtrl === void 0) { ngModelCtrl = this.NgModelCtrl; }
            var isEmpty = function (value) { return ngModelCtrl.$isEmpty(value); };
            ngModelCtrl.$validators[Name] = function (value) { return _this.Validate(value, isEmpty); };
        };
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModelCtrl", void 0);
        __decorate([
            utils.Bind.In(Name)
        ], Controller.prototype, "ExpectedValue", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "InitialiseValidator", null);
        Controller = __decorate([
            utils.Component({
                Name: Name,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sdc/phone/regex/sdc-phone-regex-constant", ["require", "exports", "app/basic-utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Junk;
    (function (Junk) {
        var characters = Object.freeze("[]{}()<>./\'\":;,+-_=".split(""));
        Junk.Patterns = Object.freeze(__spread(["\s"], characters.map(utils.RegexEscape)));
        Junk.Pattern = "(" + Junk.Patterns.map(function (p) { return "(" + p + ")"; }).join("|") + ")";
        function Throughout(text) {
            return Junk.Between.apply(Junk, __spread(text.split("")));
        }
        Junk.Throughout = Throughout;
        function Between() {
            var patterns = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                patterns[_i] = arguments[_i];
            }
            return patterns.join(Junk.Pattern + "*");
        }
        Junk.Between = Between;
        Junk.Regex = new RegExp(Junk.Pattern, "g");
    })(Junk = exports.Junk || (exports.Junk = {}));
    var Literal = Junk.Throughout;
    var Pattern;
    (function (Pattern) {
        Pattern.AnyNumber = "([0-9])";
        Pattern.MobileNumber = Group("[45]", Repeat(Pattern.AnyNumber, 8));
        Pattern.LandlineNumber = Group("[2378]", Repeat(Pattern.AnyNumber, 8));
        Pattern.CountryCode = Group(Literal("61"));
    })(Pattern = exports.Pattern || (exports.Pattern = {}));
    var AnyNumber = Pattern.AnyNumber;
    var CountryCode = Pattern.CountryCode;
    var MobileNumber = Pattern.MobileNumber;
    var LandlineNumber = Pattern.LandlineNumber;
    var reverseCharge = Either(Group(Either(Group(Literal("13")), Group(Literal("180"))), Repeat(AnyNumber, 4)), Group(Either(Group(Literal("1300")), Group(Literal("1800"))), Repeat(AnyNumber, 6)));
    var Universal;
    (function (Universal) {
        Universal.AnyJunk = Junk.Regex;
        Universal.AnyNumber = new RegExp(Pattern.AnyNumber, "g");
    })(Universal = exports.Universal || (exports.Universal = {}));
    var MustHaveCountryCode;
    (function (MustHaveCountryCode) {
        MustHaveCountryCode.ReverseCharge = FullRegex(CountryCode, reverseCharge);
        MustHaveCountryCode.Landline = FullRegex(CountryCode, LandlineNumber);
        MustHaveCountryCode.Mobile = FullRegex(CountryCode, Either(MobileNumber));
    })(MustHaveCountryCode = exports.MustHaveCountryCode || (exports.MustHaveCountryCode = {}));
    var MayHaveCountryCode;
    (function (MayHaveCountryCode) {
        MayHaveCountryCode.ReverseCharge = FullRegex(Either(Group(CountryCode, reverseCharge), reverseCharge));
        MayHaveCountryCode.Landline = FullRegex(Either(Group(CountryCode, LandlineNumber), Group("0", LandlineNumber)));
        MayHaveCountryCode.Mobile = FullRegex(Either(CountryCode, "0"), MobileNumber);
    })(MayHaveCountryCode = exports.MayHaveCountryCode || (exports.MayHaveCountryCode = {}));
    var MustNotHaveCountryCode;
    (function (MustNotHaveCountryCode) {
        MustNotHaveCountryCode.ReverseCharge = FullRegex(reverseCharge);
        MustNotHaveCountryCode.Landline = FullRegex(Group("0", LandlineNumber));
        MustNotHaveCountryCode.Mobile = FullRegex("0", MobileNumber);
    })(MustNotHaveCountryCode = exports.MustNotHaveCountryCode || (exports.MustNotHaveCountryCode = {}));
    function Repeat(pattern, count) {
        return "(((" + pattern + ")" + Junk.Pattern + "*){" + count + "})";
    }
    function FullRegex() {
        var parts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parts[_i] = arguments[_i];
        }
        return new RegExp("^" + Junk.Pattern + "*" + Junk.Between.apply(Junk, __spread(parts)) + "$");
    }
    function Group() {
        var parts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parts[_i] = arguments[_i];
        }
        return "(" + Junk.Between.apply(Junk, __spread(parts)) + ")";
    }
    function Optional() {
        var parts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parts[_i] = arguments[_i];
        }
        return Group.apply(void 0, __spread(parts)) + "?";
    }
    function Either() {
        var parts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parts[_i] = arguments[_i];
        }
        return Group(parts.map(function (part) { return Group(part); }).join("|"));
    }
});
define("app/sv/phone/sv-phone", ["require", "exports", "app/utils", "module", "app/sdc/phone/regex/sdc-phone-regex-constant", "app/sdc/phone/regex/sdc-phone-regex-constant"], function (require, exports, utils, module_22, sdc_phone_regex_constant_1, phoneRegexes) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_22.id);
    var RegionCodeMode;
    (function (RegionCodeMode) {
        RegionCodeMode[RegionCodeMode["MayHave"] = 0] = "MayHave";
        RegionCodeMode[RegionCodeMode["MustHave"] = 1] = "MustHave";
        RegionCodeMode[RegionCodeMode["MustNotHave"] = 2] = "MustNotHave";
    })(RegionCodeMode || (RegionCodeMode = {}));
    var Mode;
    (function (Mode) {
        Mode[Mode["Any"] = 0] = "Any";
        Mode[Mode["Landline"] = 1] = "Landline";
        Mode[Mode["LandlineOnly"] = 2] = "LandlineOnly";
        Mode[Mode["ReverseChargeOnly"] = 3] = "ReverseChargeOnly";
        Mode[Mode["MobileOnly"] = 4] = "MobileOnly";
    })(Mode || (Mode = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.regionCodeMode = RegionCodeMode.MayHave;
            _this.mode = Mode.Any;
            return _this;
        }
        Controller_17 = Controller;
        Object.defineProperty(Controller.prototype, "BoundRegionCodeMode", {
            set: function (value) {
                switch (String(value).toLowerCase()) {
                    case "true":
                    case "require":
                    case "required":
                    case "yes":
                    case "must-have":
                        this.regionCodeMode = RegionCodeMode.MustHave;
                        break;
                    case "false":
                    case "reject":
                    case "rejected":
                    case "no":
                    case "must-not-have":
                        this.regionCodeMode = RegionCodeMode.MustNotHave;
                        break;
                    default:
                        this.regionCodeMode = RegionCodeMode.MayHave;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "BoundMode", {
            set: function (value) {
                switch (value.toLowerCase()) {
                    case "land":
                    case "landline":
                        this.mode = Mode.Landline;
                        break;
                    case "land-only":
                    case "landline-only":
                        this.mode = Mode.LandlineOnly;
                        break;
                    case "reverse":
                    case "reverse-only":
                        this.mode = Mode.ReverseChargeOnly;
                        break;
                    case "mobile":
                    case "mobile-only":
                        this.mode = Mode.MobileOnly;
                        break;
                    default:
                        this.mode = Mode.Any;
                }
            },
            enumerable: true,
            configurable: true
        });
        Controller.GetRegexPoolByRegionCodeMode = function (regionCodeMode) {
            switch (regionCodeMode) {
                default:
                    throw new TypeError("Unknown RegionCodeMode: " + regionCodeMode);
                case RegionCodeMode.MayHave:
                    return phoneRegexes.MayHaveCountryCode;
                case RegionCodeMode.MustHave:
                    return phoneRegexes.MustHaveCountryCode;
                case RegionCodeMode.MustNotHave:
                    return phoneRegexes.MustNotHaveCountryCode;
            }
        };
        Controller.GetRegexesForMode = function (mode, regexPool) {
            switch (mode) {
                default:
                    throw new TypeError("Unknown Mode: " + mode);
                case Mode.Any:
                    return Object.values(regexPool).filter(function (o) { return o instanceof RegExp; });
                case Mode.Landline:
                    return [regexPool.Landline, regexPool.ReverseCharge];
                case Mode.LandlineOnly:
                    return [regexPool.Landline];
                case Mode.ReverseChargeOnly:
                    return [regexPool.ReverseCharge];
                case Mode.MobileOnly:
                    return [regexPool.Mobile];
            }
        };
        Controller.prototype.Validate = function (ngModel, modelValue, viewValue) {
            if (ngModel.$isEmpty(viewValue))
                return true;
            var regexPool = Controller_17.GetRegexPoolByRegionCodeMode(this.regionCodeMode);
            var regexes = Controller_17.GetRegexesForMode(this.mode, regexPool);
            try {
                for (var regexes_1 = __values(regexes), regexes_1_1 = regexes_1.next(); !regexes_1_1.done; regexes_1_1 = regexes_1.next()) {
                    var regex = regexes_1_1.value;
                    if (regex.test(viewValue))
                        return true;
                }
            }
            catch (e_78_1) { e_78 = { error: e_78_1 }; }
            finally {
                try {
                    if (regexes_1_1 && !regexes_1_1.done && (_a = regexes_1.return)) _a.call(regexes_1);
                }
                finally { if (e_78) throw e_78.error; }
            }
            return false;
            var e_78, _a;
        };
        Controller.prototype.Parse = function (viewValue) {
            if (!utils.IsString(viewValue))
                return viewValue;
            return viewValue.replace(sdc_phone_regex_constant_1.Junk.Regex, "");
        };
        Controller.prototype.Format = function (modelValue) {
            return modelValue;
        };
        Controller.prototype.BindToNgModel = function (ngModelController) {
            var _this = this;
            if (ngModelController === void 0) { ngModelController = this.NgModelController; }
            ngModelController.$validators.svPhone = function (modelValue, viewValue) { return _this.Validate(ngModelController, modelValue, viewValue); };
            ngModelController.$parsers.push(function (viewValue) { return _this.Parse(viewValue); });
            ngModelController.$formatters.push(function (modelValue) { return _this.Format(modelValue); });
        };
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModelController", void 0);
        __decorate([
            utils.Bind.Literal("region-code")
        ], Controller.prototype, "BoundRegionCodeMode", null);
        __decorate([
            utils.Bind.Literal(name)
        ], Controller.prototype, "BoundMode", null);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "BindToNgModel", null);
        Controller = Controller_17 = __decorate([
            utils.Component({
                Name: name,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
        var Controller_17;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("scripts/lib/select-development/sss-md-theming", ["require", "exports", "app/basic-utils", "sss-text!~/Content/angular-material/angular-material-theme.min.css", "ng", "ngMaterial"], function (require, exports, utils, extensionCss) {
    "use strict";
    var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
    var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
    var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');
    function colorToRgbaArray(clr) {
        if (angular.isArray(clr) && clr.length == 3)
            return clr;
        if (/^rgb/.test(clr)) {
            return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function (value, i) {
                return i == 3 ? parseFloat(value) : parseInt(value, 10);
            });
        }
        if (clr.charAt(0) == '#')
            clr = clr.substring(1);
        if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr))
            return;
        var dig = clr.length / 3;
        var red = clr.substr(0, dig);
        var grn = clr.substr(dig, dig);
        var blu = clr.substr(dig * 2);
        if (dig === 1) {
            red += red;
            grn += grn;
            blu += blu;
        }
        return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
    }
    function checkPaletteValid(name, map, VALID_HUE_VALUES) {
        var missingColors = VALID_HUE_VALUES.filter(function (field) {
            return !map[field];
        });
        if (missingColors.length) {
            throw new Error("Missing colors %1 in palette %2!"
                .replace('%1', missingColors.join(', '))
                .replace('%2', name));
        }
        return map;
    }
    function sanitizePalette(palette, name) {
        var defaultContrast = palette.contrastDefaultColor;
        var lightColors = palette.contrastLightColors || [];
        var strongLightColors = palette.contrastStrongLightColors || [];
        var darkColors = palette.contrastDarkColors || [];
        if (typeof lightColors === 'string')
            lightColors = lightColors.split(' ');
        if (typeof strongLightColors === 'string')
            strongLightColors = strongLightColors.split(' ');
        if (typeof darkColors === 'string')
            darkColors = darkColors.split(' ');
        delete palette.contrastDefaultColor;
        delete palette.contrastLightColors;
        delete palette.contrastStrongLightColors;
        delete palette.contrastDarkColors;
        angular.forEach(palette, function (hueValue, hueName) {
            if (angular.isObject(hueValue))
                return;
            var rgbValue = colorToRgbaArray(hueValue);
            if (!rgbValue) {
                throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
                    .replace('%1', hueValue)
                    .replace('%2', palette.name)
                    .replace('%3', hueName));
            }
            palette[hueName] = {
                hex: palette[hueName],
                value: rgbValue,
                contrast: getContrastColor()
            };
            function getContrastColor() {
                if (defaultContrast === 'light') {
                    if (darkColors.indexOf(hueName) > -1) {
                        return DARK_CONTRAST_COLOR;
                    }
                    else {
                        return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
                            : LIGHT_CONTRAST_COLOR;
                    }
                }
                else {
                    if (lightColors.indexOf(hueName) > -1) {
                        return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
                            : LIGHT_CONTRAST_COLOR;
                    }
                    else {
                        return DARK_CONTRAST_COLOR;
                    }
                }
            }
        });
    }
    var sssMdTheming = angular.module("sssMdTheming", ["ngMaterial"]);
    $mdThemingProvider_decorator.$inject = ["$mdThemingProvider", "$MD_THEME_CSS", "$provide", "$injector"];
    function $mdThemingProvider_decorator($mdThemingProvider, $MD_THEME_CSS, $provide, $injector) {
        function extendPalette(name, map) {
            return checkPaletteValid(name, angular.extend({}, RAW_PALETTES[name] || {}, map), $mdThemingProvider._VALID_HUE_VALUES);
        }
        var RAW_PALETTES = angular.copy($mdThemingProvider._PALETTES);
        $mdThemingProvider.registerStyles(extensionCss);
        $mdThemingProvider.generateThemesOnDemand(true);
        $mdThemingProvider.theme("default")
            .primaryPalette("blue-grey")
            .accentPalette("blue-grey");
        {
            var _definePalette_1 = $mdThemingProvider.definePalette;
            $mdThemingProvider.definePalette = function (name) {
                var retValue = _definePalette_1.apply(this, arguments);
                var definedPalette = this._PALETTES[name];
                RAW_PALETTES[name] = angular.copy(definedPalette);
                return this;
            };
        }
        $provide.decorator("$mdTheming", ["$delegate", function ($mdTheming) {
                $mdTheming.THEME_COLOR_TYPES = $mdThemingProvider._THEME_COLOR_TYPES;
                $mdTheming.LIGHT_DEFAULT_HUES = $mdThemingProvider._LIGHT_DEFAULT_HUES;
                $mdTheming.DARK_DEFAULT_HUES = $mdThemingProvider._DARK_DEFAULT_HUES;
                $mdTheming.DEFAULT_PALETTES = utils.ShallowCopy($mdThemingProvider._PALETTES);
                $mdTheming.RAW_PALETTES = RAW_PALETTES;
                $mdTheming.RAW_DEFAULT_PALETTES = utils.ShallowCopy(RAW_PALETTES);
                $mdTheming.setDefaultTheme = $mdThemingProvider.setDefaultTheme.bind($mdThemingProvider);
                $mdTheming.VALID_HUE_VALUES = $mdThemingProvider._VALID_HUE_VALUES;
                $mdTheming.definePalette = function (name) {
                    $mdThemingProvider.definePalette.apply($mdThemingProvider, arguments);
                    var definedPalette = $mdThemingProvider._PALETTES[name];
                    sanitizePalette(definedPalette, name);
                    return this;
                };
                $mdTheming.theme = $mdThemingProvider.theme.bind($mdThemingProvider);
                $mdTheming.extendPalette = extendPalette;
                return $mdTheming;
            }]);
    }
    sssMdTheming.config($mdThemingProvider_decorator);
    sssMdTheming.run(["$mdTheming", function ($mdTheming) {
            $mdTheming.generateTheme("default");
        }]);
    return sssMdTheming;
});
define("app/sdc/bound/expression/sdc-bound-expression-factory", ["require", "exports", "app/sdc/bound/expression/sdc-bound-expression"], function (require, exports, sdc_bound_expression_1) {
    "use strict";
    return sdc_bound_expression_1.create;
});
define("app/sdc/builder/expression/sdc-builder-expression", ["require", "exports", "$parse"], function (require, exports, $parse) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function create(expression, context) {
        var matcher = /([^;=]+)(?:=([^;=]+))?;*/g;
        var results;
        var assigners = [];
        while ((results = matcher.exec(expression))) {
            var expr = void 0;
            if (angular.isDefined(results[2])) {
                expr = assignmentExpression(results[1], results[2]);
            }
            else {
                expr = mergeExpression(results[1]);
            }
            assigners.push(expr);
        }
        var builder = function (obj) {
            if (arguments.length === 0)
                obj = {};
            for (var i = 0; i < assigners.length; i++) {
                obj = assigners[i](obj);
            }
            return obj;
        };
        builder.toString = function () { return expression; };
        return builder;
        function assignmentExpression(assignTo, getValue) {
            var assign = $parse(assignTo).assign;
            var get = $parse(getValue).bind(null, context);
            return function (obj) {
                assign(obj, get());
                return obj;
            };
        }
        function mergeExpression(getValue) {
            var get = $parse(getValue).bind(null, context);
            return function (obj) {
                return angular.merge(obj, get());
            };
        }
    }
    exports.create = create;
});
define("app/sdc/closable/section/sdc-closable-section", ["require", "exports", "app/utils", "$parse"], function (require, exports, utils, $parse) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.onClose = $parse(_this.Attributes["sdcClosableSection"]);
            _this.Attributes.$observe("sdcClosableSection", function (newExpr) { return _this.onClose = $parse(newExpr); });
            _this.close = _this.close.bind(_this);
            return _this;
        }
        Controller_18 = Controller;
        Controller.Bind = function (optional) {
            if (optional === void 0) { optional = true; }
            return utils.Bind.Controller(Controller_18, { mode: utils.Bind.Controller.Mode.SelfOrParents, optional: optional });
        };
        Controller.prototype.Close = function () {
            this.onClose(this.Scope);
        };
        Controller.prototype.close = function () {
            this.Close();
        };
        Controller.Name = "sdc-closable-section";
        Controller = Controller_18 = __decorate([
            utils.BindFunctions,
            utils.Component({
                Restrict: utils.Target.Attribute,
                Name: Controller_18.Name,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
        var Controller_18;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sdc/custom/validation/sdc-custom-validation", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_23) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller() {
        }
        __decorate([
            utils.Bind.Transclude(utils.Bind.Transclude.Mode.Contents)
        ], Controller.prototype, "TranscludeMessages", void 0);
        __decorate([
            utils.Bind.Getter("valid", { optional: true })
        ], Controller.prototype, "IsValid", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_23.id,
                Restrict: utils.Target.ElementOrAttribute,
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/date/test/sdc-date-test", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller() {
            this.Min = new Date(1900, 3, 111);
            this.Max = new Date(2100, 7, 24);
        }
        Controller = __decorate([
            utils.Component({
                Name: "sdc-date-test",
            })
        ], Controller);
        return Controller;
    }());
});
define("app/sdc/file/attach/sdc-file-attach", ["require", "exports", "app/utils", "module", "app/ng-utils", "app/selcomm/service"], function (require, exports, utils, module_24, ng_utils_23, service_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_24.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Attributes.$addClass(name);
            return _this;
        }
        Controller.prototype.NotifyFilesAttached = function (files, rejectedFiles, event) {
            if (this.Disabled)
                return;
            return this.FilesAttached(new FilesAttachedEvent.LegacyCompatible(files, rejectedFiles, event));
        };
        Object.defineProperty(Controller.prototype, "AllowMultiple", {
            get: function () {
                return ng_utils_23.$mdUtil.parseAttributeBoolean(this.BoundAllowMultiple);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Disabled", {
            get: function () {
                return ng_utils_23.$mdUtil.parseAttributeBoolean(this.BoundDisabled);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Enabled", {
            get: function () {
                return !this.Disabled;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Transclude(utils.Bind.Transclude.Mode.Contents)
        ], Controller.prototype, "Transclude", void 0);
        __decorate([
            utils.Bind.Getter("files-attached")
        ], Controller.prototype, "FilesAttached", void 0);
        __decorate([
            utils.Bind.Literal("allow-multiple", { optional: true })
        ], Controller.prototype, "BoundAllowMultiple", void 0);
        __decorate([
            utils.Bind.Literal("capture", { optional: true })
        ], Controller.prototype, "Capture", void 0);
        __decorate([
            utils.Bind.Getter("accept", { optional: true })
        ], Controller.prototype, "Accept", void 0);
        __decorate([
            utils.Bind.In("min-size", { optional: true })
        ], Controller.prototype, "MinSize", void 0);
        __decorate([
            utils.Bind.In("max-size", { optional: true })
        ], Controller.prototype, "MaxSize", void 0);
        __decorate([
            utils.Bind.Literal("disabled", { optional: true })
        ], Controller.prototype, "BoundDisabled", void 0);
        Controller = __decorate([
            utils.Component({
                Name: name,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    var AttachmentBase = (function () {
        function AttachmentBase() {
        }
        Object.defineProperty(AttachmentBase.prototype, "StateName", {
            get: function () {
                return Attachment.State[this.State];
            },
            enumerable: true,
            configurable: true
        });
        return AttachmentBase;
    }());
    exports.AttachmentBase = AttachmentBase;
    var Attachment = (function (_super) {
        __extends(Attachment, _super);
        function Attachment(File) {
            var _this = _super.call(this) || this;
            _this.File = File;
            _this.progress = NaN;
            _this.state = Attachment.State.PendingUpload;
            return _this;
        }
        Object.defineProperty(Attachment.prototype, "Progress", {
            get: function () { return this.progress; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Attachment.prototype, "State", {
            get: function () { return this.state; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Attachment.prototype, "Attachment", {
            get: function () { return this.attachment; },
            enumerable: true,
            configurable: true
        });
        Attachment.prototype.Delete = function () {
            return __awaiter(this, void 0, ng_utils_23.$q, function () {
                return __generator(this, function (_a) {
                    switch (this.state) {
                        case Attachment.State.PendingUpload:
                        case Attachment.State.FailedUpload:
                            this.state = Attachment.State.Deleted;
                            return [2];
                        case Attachment.State.Uploading:
                            throw new Error("Please wait, still uploading.");
                        case Attachment.State.Uploaded:
                        case Attachment.State.FailedDelete:
                            break;
                        default:
                            throw new Error("Already deleted attachment");
                    }
                    try {
                        this.state = Attachment.State.Deleting;
                        service_18.Service.Event.EventAttachmentDelete({
                            Id: utils.AssertNotVoid(this.attachment).AttachedEvent.Id,
                        });
                        this.state = Attachment.State.Deleted;
                    }
                    catch (err) {
                        this.state = Attachment.State.FailedDelete;
                        throw err;
                    }
                    return [2];
                });
            });
        };
        Attachment.prototype.Upload = function (eventType, contactCode) {
            return __awaiter(this, void 0, ng_utils_23.$q, function () {
                var eventId, attachment, attachmentUploadTask, _a, err_21;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            switch (this.state) {
                                case Attachment.State.Uploading:
                                    throw new utils.AlreadyDoingActionError("Upload attachment");
                                case Attachment.State.PendingUpload:
                                case Attachment.State.FailedUpload:
                                    break;
                                default:
                                    throw new Error("Already uploaded attachment");
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, , 5]);
                            this.state = Attachment.State.Uploading;
                            this.progress = NaN;
                            return [4, service_18.Service.Event.EventAdd({
                                    Event: new service_18.Selcomm.Event.Event({
                                        EventType: eventType,
                                    }),
                                    Contact: new service_18.Selcomm.Contact.Contact({
                                        Code: contactCode,
                                    })
                                })];
                        case 2:
                            eventId = _b.sent();
                            attachment = new service_18.Selcomm.Event.EventAttachment({
                                AttachedEvent: new service_18.Selcomm.Event.Event({ Id: eventId, }),
                                FileName: this.File.name,
                                FileContent: this.File,
                            });
                            attachmentUploadTask = service_18.Service.Event.EventAttachmentAdd({ EventAttachment: attachment });
                            _a = attachment;
                            return [4, attachmentUploadTask];
                        case 3:
                            _a.Id = _b.sent();
                            this.attachment = attachment;
                            this.state = Attachment.State.Uploaded;
                            return [2, attachment];
                        case 4:
                            err_21 = _b.sent();
                            this.state = Attachment.State.FailedUpload;
                            throw err_21;
                        case 5: return [2];
                    }
                });
            });
        };
        Attachment.prototype.Bind = function (eventType, contactCode) {
            return Attachment.BindTo(this, eventType, contactCode);
        };
        Attachment.BindTo = function (attachment, eventType, contactCode) {
            return new Attachment.Bound(attachment.File, eventType, contactCode);
        };
        return Attachment;
    }(AttachmentBase));
    exports.Attachment = Attachment;
    (function (Attachment) {
        var State;
        (function (State) {
            State[State["Uploaded"] = 0] = "Uploaded";
            State[State["PendingUpload"] = 1] = "PendingUpload";
            State[State["Uploading"] = 2] = "Uploading";
            State[State["FailedUpload"] = 3] = "FailedUpload";
            State[State["FailedDelete"] = 4] = "FailedDelete";
            State[State["Deleting"] = 5] = "Deleting";
            State[State["Deleted"] = 6] = "Deleted";
        })(State = Attachment.State || (Attachment.State = {}));
        var Bound = (function (_super) {
            __extends(Bound, _super);
            function Bound(file, eventType, contactCode) {
                var _this = _super.call(this) || this;
                _this.contactCode = contactCode;
                _this.EventType = utils.ShallowCopy(eventType);
                _this.Underlying = new Attachment(file);
                return _this;
            }
            Object.defineProperty(Bound.prototype, "File", {
                get: function () { return this.Underlying.File; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Bound.prototype, "Progress", {
                get: function () { return this.Underlying.Progress; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Bound.prototype, "State", {
                get: function () { return this.Underlying.State; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Bound.prototype, "Attachment", {
                get: function () { return this.Underlying.Attachment; },
                enumerable: true,
                configurable: true
            });
            Bound.prototype.Delete = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2, this.Underlying.Delete()];
                    });
                });
            };
            Bound.prototype.Upload = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2, this.Underlying.Upload(this.EventType, this.contactCode)];
                    });
                });
            };
            return Bound;
        }(AttachmentBase));
        Attachment.Bound = Bound;
    })(Attachment = exports.Attachment || (exports.Attachment = {}));
    exports.Attachment = Attachment;
    exports.default = Attachment;
    var FilesAttachedEvent = (function () {
        function FilesAttachedEvent(files, rejectedFiles, event) {
            this.files = files;
            this.rejectedFiles = rejectedFiles;
            this.event = event;
            var isFirst = true;
            var attachments;
            Object.defineProperty(this, "attachments", {
                configurable: true,
                enumerable: true,
                get: function () {
                    if (isFirst) {
                        isFirst = false;
                        attachments = !utils.IsArray(files) ? files : files.map(function (f) { return new Attachment(f); });
                    }
                    return attachments;
                },
                set: function (value) {
                    isFirst = false;
                    attachments = value;
                },
            });
        }
        return FilesAttachedEvent;
    }());
    exports.FilesAttachedEvent = FilesAttachedEvent;
    (function (FilesAttachedEvent) {
        var LegacyCompatible = (function (_super) {
            __extends(LegacyCompatible, _super);
            function LegacyCompatible(files, rejectedFiles, event) {
                return _super.call(this, files, rejectedFiles, event) || this;
            }
            Object.defineProperty(LegacyCompatible.prototype, "$files", {
                get: function () {
                    return this.files;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyCompatible.prototype, "$rejectedFiles", {
                get: function () {
                    return this.rejectedFiles;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LegacyCompatible.prototype, "$event", {
                get: function () {
                    return this.event;
                },
                enumerable: true,
                configurable: true
            });
            return LegacyCompatible;
        }(FilesAttachedEvent));
        FilesAttachedEvent.LegacyCompatible = LegacyCompatible;
    })(FilesAttachedEvent = exports.FilesAttachedEvent || (exports.FilesAttachedEvent = {}));
    exports.FilesAttachedEvent = FilesAttachedEvent;
});
define("app/sdc/href/popup/sdc-href-popup", ["require", "exports", "app/utils", "$window", "app/sdc/window/sdc-window"], function (require, exports, utils, $window, sdcWindow) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var events = "click";
    var Controller = (function () {
        function Controller($element, $scope) {
            var _this = this;
            this.$element = $element;
            this.$scope = $scope;
            var handler = function (e) {
                var $mdCloseMenu = $scope.$mdCloseMenu;
                if (utils.IsFunction($mdCloseMenu))
                    $mdCloseMenu();
                _this.HandleEvent(e);
            };
            $element.on(events, handler);
            $scope.$on("$destroy", function (evt) { return $element.off(events, handler); });
        }
        Object.defineProperty(Controller.prototype, "href", {
            get: function () {
                return this.$element.attr("href");
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.HandleEvent = function (e) {
            e.preventDefault();
            $window.open(this.href, this.target, new sdcWindow.WindowOpenOptions(this.options).toString(), true);
        };
        __decorate([
            utils.Bind.Literal("target")
        ], Controller.prototype, "target", void 0);
        __decorate([
            utils.Bind.TwoWay("sdcHrefPopup")
        ], Controller.prototype, "options", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "sdc-href-popup",
                Scope: utils.ScopeMode.ParentScope,
                Restrict: utils.Target.Attribute,
                Template: null,
            }),
            __param(0, utils.Inject("$element")), __param(1, utils.Inject("$scope"))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/if/error/sdc-if-error", ["require", "exports", "app/sdc/loading/sdc-loading", "scripts/lib/select-development/sss-names", "app/utils", "app/sdc/if/sdc-if", "$q"], function (require, exports, loading, sssNames, utils, ifService, $q) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-if-error";
    var Controller = (function () {
        function Controller($attrs, $watch, $element, $transclude) {
            var _this = this;
            this.Toggle = ifService.Create($element, $transclude);
            if (!$attrs[sssNames.CamelCase(exports.Name)])
                this.GetPassedValue = null;
            $watch(function () { return _this.Value; }, function ($new) {
                if ($q.isQ($new)) {
                    $new.then(function () {
                        if (_this.Value !== $new)
                            return;
                        _this.Toggle(false);
                    }, function () {
                        if (_this.Value !== $new)
                            return;
                        _this.Toggle(true);
                    });
                }
                else if (angular.isObject($new) && $new instanceof Error)
                    _this.Toggle(true);
                else if ($new === 1)
                    _this.Toggle(false);
                else if (!$new && $new !== 0)
                    _this.Toggle(false);
            });
        }
        Object.defineProperty(Controller.prototype, "Value", {
            get: function () {
                if (this.GetPassedValue)
                    return this.GetPassedValue();
                else if (this.ParentLoading)
                    return this.ParentLoading.Loading;
                else
                    return null;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Controller(loading.Controller, { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "ParentLoading", void 0);
        __decorate([
            utils.Bind.Getter(exports.Name, { optional: true })
        ], Controller.prototype, "GetPassedValue", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Priority: 150,
                Terminal: true,
                Restrict: utils.Target.Attribute,
                Transclude: utils.TransclusionMode.Element,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            }),
            __param(0, utils.Inject("$attrs")), __param(1, utils.Inject("$watch")), __param(2, utils.Inject("$element")), __param(3, utils.Inject("$transclude"))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/if/loading/sdc-if-loading", ["require", "exports", "app/sdc/loading/sdc-loading", "scripts/lib/select-development/sss-names", "app/utils", "app/sdc/if/sdc-if", "$q"], function (require, exports, loading, sssNames, utils, ifService, $q) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-if-loading";
    var Controller = (function () {
        function Controller($attrs, $watch, $element, $transclude) {
            var _this = this;
            this.Toggle = ifService.Create($element, $transclude);
            if (!$attrs[sssNames.CamelCase(exports.Name)])
                this.GetPassedValue = null;
            $watch(function () { return _this.Value; }, function ($new) {
                if ($q.isQ($new)) {
                    _this.Toggle(true);
                    $new.finally(function () {
                        if (_this.Value !== $new)
                            return;
                        _this.Toggle(false);
                    });
                }
                else if (angular.isObject($new) && $new instanceof Error)
                    _this.Toggle(false);
                else if ($new === 1)
                    _this.Toggle(false);
                else if ($new === 0)
                    _this.Toggle(true);
                else
                    _this.Toggle(!!$new);
            });
        }
        Object.defineProperty(Controller.prototype, "Value", {
            get: function () {
                if (this.GetPassedValue)
                    return this.GetPassedValue();
                else if (this.ParentLoading)
                    return this.ParentLoading.Loading;
                else
                    return null;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Controller(loading.Controller, { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "ParentLoading", void 0);
        __decorate([
            utils.Bind.Getter(exports.Name, { optional: true })
        ], Controller.prototype, "GetPassedValue", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Priority: 600,
                Terminal: true,
                Restrict: utils.Target.Attribute,
                Transclude: utils.TransclusionMode.Element,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            }),
            __param(0, utils.Inject("$attrs")), __param(1, utils.Inject("$watch")), __param(2, utils.Inject("$element")), __param(3, utils.Inject("$transclude"))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/form/control/hook/sdc-form-control-hook", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller(form) {
            var _this = this;
            this.controls = [];
            this.hookRemovers = [];
            this.subForms = [];
            this.subFormHookControllers = [];
            this.hookRemovers = utils.Extend([], {
                form: form,
                detach: function () { return _this.Detach(); },
            });
            if (!utils.IsSpecified(form))
                return;
            this.underlyingRemoveControl = form.$removeControl;
            if (utils.HasProp(form, "$addControl")) {
                this.underlyingAddControl = form.$addControl;
                this.hookRemovers.push(function () { return form.$addControl = _this.underlyingAddControl; });
                form.$addControl = this.Bind(Controller.AddControl);
            }
            if (utils.HasProp(form, "$removeControl")) {
                this.underlyingAddControl = form.$removeControl;
                this.hookRemovers.push(function () { return form.$removeControl = _this.underlyingRemoveControl; });
                form.$removeControl = this.Bind(Controller.RemoveControl);
            }
        }
        Object.defineProperty(Controller.prototype, "Controls", {
            get: function () {
                return this.controls;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Detach = function () {
            try {
                for (var _a = __values(this.hookRemovers), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var hookRemover = _b.value;
                    hookRemover();
                }
            }
            catch (e_79_1) { e_79 = { error: e_79_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_79) throw e_79.error; }
            }
            this.hookRemovers.length = 0;
            var e_79, _c;
        };
        Controller.prototype.ForEach = function (iterator) {
            enumerate(this.Controls);
            function enumerate(collection) {
                try {
                    for (var collection_1 = __values(collection), collection_1_1 = collection_1.next(); !collection_1_1.done; collection_1_1 = collection_1.next()) {
                        var item = collection_1_1.value;
                        if (utils.IsArray(item))
                            enumerate(item);
                        else
                            iterator(item);
                    }
                }
                catch (e_80_1) { e_80 = { error: e_80_1 }; }
                finally {
                    try {
                        if (collection_1_1 && !collection_1_1.done && (_a = collection_1.return)) _a.call(collection_1);
                    }
                    finally { if (e_80) throw e_80.error; }
                }
                var e_80, _a;
            }
        };
        Controller.prototype.ToLegacy = function () {
            return this.controls;
        };
        Controller.IsForm = function (source) {
            var asForm = source;
            return !!(asForm.$addControl && asForm.$removeControl);
        };
        Controller.prototype.underlyingAddControl = function (controller) { };
        Controller.prototype.underlyingRemoveControl = function (controller) { };
        Controller.AddControl = function (formCtrl, ctrl, control, rest) {
            if (!ctrl.underlyingAddControl)
                return;
            var result = (_a = ctrl.underlyingAddControl).call.apply(_a, __spread([formCtrl, control], rest));
            if (!Controller.IsForm(control))
                ctrl.controls.push(control);
            else {
                var subController = new Controller(control);
                ctrl.controls.push(subController.controls);
                ctrl.subForms.push(control);
                ctrl.subFormHookControllers.push(subController);
            }
            return result;
            var _a;
        };
        Controller.RemoveControl = function (formCtrl, ctrl, control, rest) {
            var i;
            (_a = ctrl.underlyingRemoveControl).call.apply(_a, __spread([formCtrl, control], rest));
            var form = control;
            while ((i = ctrl.subForms.indexOf(form)) >= 0) {
                ctrl.subForms.splice(i, 1);
                var tmp = ctrl.subFormHookControllers.splice(i, 1)[0];
                angular.arrayRemove(ctrl.controls, tmp.controls);
                tmp.Detach();
            }
            var _a;
        };
        Controller.prototype.Bind = function (fn) {
            var context = this;
            return Bound;
            function Bound(control) {
                var rest = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    rest[_i - 1] = arguments[_i];
                }
                return fn(this, context, control, rest);
            }
        };
        return Controller;
    }());
    exports.Controller = Controller;
    ;
    ;
});
define("app/sdc/inline/edit/sdc-inline-edit", ["require", "exports", "app/sdc/form/control/hook/sdc-form-control-hook", "app/utils", "$parse", "$timeout", "app/sdc/bound/expression/sdc-bound-expression"], function (require, exports, FormControlHook, utils, $parse, $timeout, boundExpression) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var nonReadStates = Object.freeze(["create", "update", "delete"]);
    exports.Name = "sdc-inline-edit";
    var ParsedExpression = (function () {
        function ParsedExpression(expr, scope) {
            this.expr = expr;
            var _a = __read(expr.split(/\bas\b/i), 2), copyExpr = _a[0], actualExpr = _a[1];
            this.GetActual = boundExpression.create(actualExpr, scope.$parent);
            this.AssignCopy = $parse(copyExpr).assign;
        }
        ParsedExpression.prototype.AssignCopy = function (context, value) { };
        ParsedExpression.prototype.GetActual = function () {
            return void (0);
        };
        return ParsedExpression;
    }());
    var Controller = (function () {
        function Controller($attrs, $scope, $transclude, $element, $watch) {
            var _this = this;
            this.$attrs = $attrs;
            this.$scope = $scope;
            this.$transclude = $transclude;
            this.$element = $element;
            this.$watch = $watch;
            if (this.formAsExpr) {
                var parsed_1 = $parse(this.formAsExpr);
                if (parsed_1 && parsed_1.assign) {
                    this.assignForm = function (form, scope) {
                        if (!utils.IsSpecified(scope))
                            scope = _this.transcludedScope;
                        parsed_1.assign(scope, form);
                    };
                }
            }
            var _a = new ParsedExpression(this.expressions, $scope), AssignCopy = _a.AssignCopy, GetActual = _a.GetActual;
            this.AssignCopy = AssignCopy;
            this.GetActual = GetActual;
            $watch(function () { return _this.form; }, function ($new) {
                _this.assignForm($new);
                _this.controls = new FormControlHook.Controller($new);
            });
            $scope.$watch(this.GetActual, function (newActual) { return _this.UpdateCopy(newActual); }, true);
            $watch.Collection(function () { return ({
                isRead: nonReadStates.indexOf(_this.state) < 0,
                areFormControlsTouched: _this.areFormControlsTouched
            }); }, function (x) { return x.areFormControlsTouched && x.isRead && _this.resetForm(); });
        }
        Controller.prototype._Init = function () {
            var _this = this;
            var transcludeParent = this.$element.contents().children(".sdc-inline-edit-contents");
            var link = function (clone, linkedScope) {
                _this.transcludedScope = linkedScope;
                transcludeParent.append(clone);
                _this.$watch.Once(function () { return _this.$scope["scopeExtender"]; }, function (scopeExtender) {
                    scopeExtender(linkedScope);
                    _this.extendScope(linkedScope);
                });
            };
            this.$transclude(link, transcludeParent);
        };
        Controller.prototype.AssignCopy = function (context, value) { };
        Controller.prototype.GetActual = function () { return void (0); };
        Object.defineProperty(Controller.prototype, "bound", {
            get: function () { return this.copy; },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.resetForm = function () {
            if (!this.form)
                return;
            this.form.$setPristine();
            this.form.$setUntouched();
        };
        Controller.prototype.cancel = function () { return !this._onCancel || this._onCancel({ $cancelled: this.copy }); };
        Controller.prototype.onCommitted = function (mode) { return !this._onCommitted || this._onCommitted(this.passBound({ $mode: mode })); };
        Controller.prototype.create = function () { return this.Invoke(this._create); };
        Controller.prototype.update = function () { return this.Invoke(this._update); };
        Controller.prototype.delete = function () { return this.Invoke(this._delete); };
        Controller.prototype.Invoke = function (boundGetter) {
            var valid = false;
            if (!this.form)
                valid = true;
            else {
                valid = this.form.$valid;
                this.controls.ForEach(function (control) { return control.$setTouched(); });
            }
            if (!valid)
                return false;
            return boundGetter(this.passBound(this.bound));
        };
        Object.defineProperty(Controller.prototype, "canCreate", {
            get: function () { return !!(this._create && (!this._canCreate || this._canCreate())); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "canUpdate", {
            get: function () { return !!(this._create && (!this._canUpdate || this._canUpdate())); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "canDelete", {
            get: function () { return !!(this._delete && (!this._canDelete || this._canDelete())); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "isFormPristine", {
            get: function () { return !this.form || this.form.$pristine; },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.passBound = function (value, args) {
            if (args === void 0) { args = {}; }
            this.AssignCopy(args, value);
            if (!("SelcommWS" in args))
                args["SelcommWS"] = value;
            return args;
        };
        Object.defineProperty(Controller.prototype, "areFormControlsTouched", {
            get: function () {
                if (!this.form)
                    return false;
                for (var errorName in this.form.$error) {
                    if (!utils.HasProp(this.form.$error, errorName))
                        continue;
                    var errorObject = this.form.$error[errorName];
                    for (var i = 0; i < errorObject.length; i++) {
                        if (!utils.HasProp(errorObject, errorName))
                            continue;
                        if (errorObject[i].$touched)
                            return true;
                    }
                }
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.UpdateCopy = function (newActual) {
            var _this = this;
            if (arguments.length)
                this.actual = newActual;
            else
                newActual = this.actual;
            var newCopy = angular.copy(newActual);
            if (!utils.IsSpecified(newCopy))
                newCopy = {};
            if (!utils.IsObject(newCopy))
                throw Error("Cannot bind to a non-object");
            if (this.form)
                this.form.$rollbackViewValue();
            this.copy = newCopy;
            if (utils.IsSpecified(this.transcludedScope))
                this.AssignCopy(this.transcludedScope, newCopy);
            $timeout(function () { return _this.form && _this.form.$commitViewValue(); });
        };
        Controller.prototype.assignForm = function (value, scope) {
        };
        Controller.prototype.extendScope = function (scope) {
            this.AssignCopy(scope, this.copy);
            this.assignForm(this.form, scope);
        };
        Object.defineProperty(Controller.prototype, "areEqual", {
            get: function () {
                return angular.equals(this.copy || null, this.actual || null);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "state", {
            get: function () {
                if (this._deleting)
                    return "delete";
                else
                    return this.areEqual ? "" : (this.editState || "update");
            },
            set: function (newState) {
                switch (newState) {
                    case "delete":
                        this._deleting = true;
                        break;
                    case "create":
                    case "update":
                        break;
                    default:
                        this._deleting = false;
                        this.UpdateCopy();
                        this.resetForm();
                        break;
                }
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "_Init", null);
        __decorate([
            utils.Bind.Literal(exports.Name)
        ], Controller.prototype, "expressions", void 0);
        __decorate([
            utils.Bind.TwoWay("edit-state")
        ], Controller.prototype, "editState", void 0);
        __decorate([
            utils.Bind.Getter("can-delete", { optional: true })
        ], Controller.prototype, "_canDelete", void 0);
        __decorate([
            utils.Bind.Getter("can-update", { optional: true })
        ], Controller.prototype, "_canUpdate", void 0);
        __decorate([
            utils.Bind.Getter("can-create", { optional: true })
        ], Controller.prototype, "_canCreate", void 0);
        __decorate([
            utils.Bind.Getter("create", { optional: true })
        ], Controller.prototype, "_create", void 0);
        __decorate([
            utils.Bind.Getter("delete", { optional: true })
        ], Controller.prototype, "_delete", void 0);
        __decorate([
            utils.Bind.Getter("update", { optional: true })
        ], Controller.prototype, "_update", void 0);
        __decorate([
            utils.Bind.Getter("on-cancel", { optional: true })
        ], Controller.prototype, "_onCancel", void 0);
        __decorate([
            utils.Bind.Getter("on-committed", { optional: true })
        ], Controller.prototype, "_onCommitted", void 0);
        __decorate([
            utils.Bind.Literal("form-as", { optional: true })
        ], Controller.prototype, "formAsExpr", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Restrict: utils.Target.Attribute,
                Transclude: utils.TransclusionMode.Contents,
            }),
            __param(0, utils.Inject($attrs)),
            __param(1, utils.Inject($scope)),
            __param(2, utils.Inject($transclude)),
            __param(3, utils.Inject($element)),
            __param(4, utils.Inject($watch))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/theme/url/sdc-theme-url", ["require", "exports", "app/utils", "app/sss/sites", "scripts/lib/select-development/sss-paths"], function (require, exports, utils, sites, paths) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function Get(subPath, siteOrSiteName) {
        if (siteOrSiteName === void 0) { siteOrSiteName = sites.Service.Current; }
        var siteName;
        if (utils.IsString(siteOrSiteName))
            siteName = siteOrSiteName;
        else
            siteName = siteOrSiteName.Name;
        return utils.Paths.MapPath(paths.Combine("!content/themes/" + utils.EncodeUriComponent(siteName), paths.StripLeadingSlashes(subPath)));
    }
    exports.Get = Get;
});
define("app/sdc/md/theming/sdc-md-theming-service", ["require", "exports", "app/sss/sites", "app/utils", "$q", "$http", "$mdTheming", "app/sdc/theme/url/sdc-theme-url"], function (require, exports, sites, utils, $q, $http, $mdTheming, ThemeUrl) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var excludePaletteKeys = ["$base"];
    var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
    var emptyTheme = {};
    try {
        for (var _a = __values($mdTheming.THEME_COLOR_TYPES), _b = _a.next(); !_b.done; _b = _a.next()) {
            var colourType = _b.value;
            emptyTheme[colourType] = null;
        }
    }
    catch (e_81_1) { e_81 = { error: e_81_1 }; }
    finally {
        try {
            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
        }
        finally { if (e_81) throw e_81.error; }
    }
    function loadSiteTheme(siteOrSiteName) {
        var siteName = sites.Service.NameFor(siteOrSiteName);
        var themeName = themeNameForSite(siteName);
        if ($mdTheming.THEMES[themeName])
            return $q.resolve(themeName);
        return $http
            .get(siteThemeFileUrl(siteName))
            .then(function (response) { return defineTheme(themeName, response.data); });
    }
    exports.loadSiteTheme = loadSiteTheme;
    function siteThemeFileUrl(siteOrSiteName) {
        return ThemeUrl.Get("md/theme.json", siteOrSiteName);
    }
    exports.siteThemeFileUrl = siteThemeFileUrl;
    function themeNameForSite(siteOrSiteName) {
        var siteName = sites.Service.NameFor(siteOrSiteName);
        return ["", "siteTheme", siteName].join("_");
    }
    exports.themeNameForSite = themeNameForSite;
    function defineTheme(themeName, themeDefinition) {
        var paletteDefinitions = {};
        {
            var normalized = utils.Extend(emptyTheme, themeDefinition);
            try {
                for (var _a = __values(Object.keys(normalized)), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var colourType = _b.value;
                    var colourTypeDefinition = normalized[colourType];
                    paletteDefinitions[colourType] = parseColourType(colourTypeDefinition, colourType);
                }
            }
            catch (e_82_1) { e_82 = { error: e_82_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_82) throw e_82.error; }
            }
        }
        var theme = $mdTheming.theme(themeName);
        try {
            for (var THEME_COLOR_TYPES_1 = __values(THEME_COLOR_TYPES), THEME_COLOR_TYPES_1_1 = THEME_COLOR_TYPES_1.next(); !THEME_COLOR_TYPES_1_1.done; THEME_COLOR_TYPES_1_1 = THEME_COLOR_TYPES_1.next()) {
                var colourType = THEME_COLOR_TYPES_1_1.value;
                var def = paletteDefinitions[colourType];
                if (!def || !def)
                    continue;
                theme[colourType + "Palette"].apply(theme, __spread(def));
            }
        }
        catch (e_83_1) { e_83 = { error: e_83_1 }; }
        finally {
            try {
                if (THEME_COLOR_TYPES_1_1 && !THEME_COLOR_TYPES_1_1.done && (_d = THEME_COLOR_TYPES_1.return)) _d.call(THEME_COLOR_TYPES_1);
            }
            finally { if (e_83) throw e_83.error; }
        }
        $mdTheming.generateTheme(themeName);
        return themeName;
        function staticValue(value) {
            var matches = /^#(.+)/.exec(value);
            if (!matches)
                return null;
            return matches[1].toLowerCase();
        }
        function crossPalleteValue(value) {
            var matches = /^(\.+)\.([^.]+)$/.exec(value);
            if (!matches)
                return null;
            return Palettes.Default.Raw[matches[1]][matches[2]];
        }
        function getPaletteName(colourType) {
            return themeName + "=" + colourType;
        }
        function EnsurePalette(colourTypeDefinition, colourType) {
            if (utils.IsString(colourTypeDefinition))
                return colourTypeDefinition;
            var paletteName = getPaletteName(colourType);
            var pallete = angular.filter(angular.map(colourTypeDefinition, function (value, key) {
                if (exports.Hues.indexOf(key) < 0) {
                    return value;
                }
                else {
                    return staticValue(value) || crossPalleteValue(value) || value;
                }
            }), function (value, key) {
                return excludePaletteKeys.indexOf(key) < 0;
            });
            var paletteDefinition;
            if (IsDerivedPalette(colourTypeDefinition))
                paletteDefinition = $mdTheming.extendPalette(colourTypeDefinition.$base, pallete);
            else
                paletteDefinition = colourTypeDefinition;
            $mdTheming.definePalette(paletteName, paletteDefinition);
            return paletteName;
        }
        function parseColourType(colourTypeDefinition, colourType) {
            switch (colourType) {
                case "accent":
                    if (!colourTypeDefinition) {
                        if (!utils.IsSpecified(themeDefinition.primary))
                            return null;
                        if (IsDerivedPalette(themeDefinition.primary))
                            return [themeDefinition.primary.$base];
                        if (IsBasePalette(themeDefinition.primary))
                            return [themeDefinition.primary];
                        return parseColourType(themeDefinition.primary, "accent");
                    }
                    break;
            }
            if (!colourTypeDefinition || colourTypeDefinition === true)
                return null;
            if (!IsPaletteAndHues(colourTypeDefinition))
                return [EnsurePalette(colourTypeDefinition, colourType)];
            return [EnsurePalette(colourTypeDefinition.$palette, colourType), colourTypeDefinition.$hues];
        }
        var e_82, _c, e_83, _d;
    }
    exports.defineTheme = defineTheme;
    var DefaultHues;
    (function (DefaultHues) {
        DefaultHues.Light = $mdTheming.LIGHT_DEFAULT_HUES;
        DefaultHues.Dark = $mdTheming.DARK_DEFAULT_HUES;
    })(DefaultHues = exports.DefaultHues || (exports.DefaultHues = {}));
    var Palettes;
    (function (Palettes) {
        var All;
        (function (All) {
            All.Actual = $mdTheming.PALETTES;
            All.Raw = $mdTheming.RAW_PALETTES;
        })(All = Palettes.All || (Palettes.All = {}));
        var Default;
        (function (Default) {
            Default.Actual = $mdTheming.DEFAULT_PALETTES;
            Default.Raw = $mdTheming.RAW_DEFAULT_PALETTES;
        })(Default = Palettes.Default || (Palettes.Default = {}));
    })(Palettes = exports.Palettes || (exports.Palettes = {}));
    exports.DefaultPaletteNames = Object.freeze(Object.keys($mdTheming.DEFAULT_PALETTES));
    exports.Hues = $mdTheming.VALID_HUE_VALUES;
    function IsDerivedPalette(target) {
        return utils.IsObjectLike(target) && utils.IsString(target.$base);
    }
    function IsBasePalette(target) {
        return utils.IsString(target);
    }
    function IsPaletteAndHues(target) {
        return utils.IsObjectLike(target) && utils.IsSpecified(target.$palette);
    }
    var e_81, _c;
});
define("app/sdc/menu/toggle/group/sdc-menu-toggle-group", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller() {
            this.items = [];
        }
        Controller.prototype.register = function (item) {
            var _this = this;
            if (this.items.indexOf(item))
                this.items.push(item);
            return function () { return _this.unregister(item); };
        };
        Controller.prototype.unregister = function (item) {
            var i = this.items.indexOf(item);
            if (i >= 0) {
                this.items.splice(i, 1);
            }
        };
        Controller.prototype.close = function (predicate) {
            this.items.filter(predicate || (function (item) { return true; })).forEach(function (item) { return item.IsOpen = false; });
        };
        Controller = __decorate([
            utils.Component({
                Name: "sdc-menu-toggle-group",
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
                Restrict: utils.Target.ElementOrAttribute,
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/menu/toggle/sdc-menu-toggle", ["require", "exports", "app/sdc/assign/classes/sdc-assign-classes", "constant!sdc-md-palette-classes", "app/utils"], function (require, exports, assignClasses, paletteClasses, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-menu-toggle";
    var Controller = (function () {
        function Controller($scope, $watch, $attrs) {
            var _this = this;
            this.TitleTranscludes = [];
            this.ContentTranscludes = [];
            this.Loaded = false;
            $attrs.$addClass("sdc-toggle");
            $attrs.$addClass(exports.Name);
            this.IsOpen = this.Inital();
            $watch.Once.Collection(function () { return ({ group: _this.Group, parentGroup: _this.Parent ? _this.Parent.Group : null }); }, function (x) {
                if (x.group && x.parentGroup !== x.group)
                    $scope.$on("$destroy", x.group.register(_this));
                else
                    _this.Group = x.group = null;
                $watch(function () { return _this.IsOpen; }, function (isOpen) {
                    if (!isOpen)
                        return;
                    _this.Loaded = true;
                    if (x.group)
                        x.group.close(function (target) { return target !== _this; });
                });
            });
        }
        Controller.prototype.Toggle = function () {
            this.IsOpen = !this.IsOpen;
        };
        __decorate([
            utils.Bind.Controller("sdc-menu-toggle-group", { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "Group", void 0);
        __decorate([
            utils.Bind.Getter("on-open")
        ], Controller.prototype, "OnOpen", void 0);
        __decorate([
            utils.Bind.Getter("on-close")
        ], Controller.prototype, "OnClose", void 0);
        __decorate([
            utils.Bind.Getter("inital")
        ], Controller.prototype, "Inital", void 0);
        __decorate([
            utils.Bind.TwoWay("is-open", { optional: true })
        ], Controller.prototype, "IsOpen", void 0);
        __decorate([
            utils.Bind.Controller(exports.Name, { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "Parent", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Transclude: utils.TransclusionMode.Contents,
            }),
            __param(0, utils.Inject($scope)), __param(1, utils.Inject($watch)), __param(2, utils.Inject($attrs))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
    assignClasses.CreateDirective(Controller, function (ctrl, matches) { return ctrl.ButtonClasses = matches; }, [paletteClasses, "md-raised"]);
});
define("app/sdc/option/content/sdc-option-content", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.EnsureNoLegacyFallback("sdc-option-content");
});
define("app/sdc/period/navigation/sdc-period-navigation", ["require", "exports", "app/utils", "moment", "$mdMedia"], function (require, exports, utils, moment, $mdMedia) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ViewingPeriod = (function () {
        function ViewingPeriod(start, leftEnd) {
            this.StartMoment = moment(start);
            this.LeftEndMoment = moment(leftEnd);
        }
        Object.defineProperty(ViewingPeriod.prototype, "StartMoment", {
            get: function () {
                return this._StartMoment.clone();
            },
            set: function (value) {
                if (this._StartMoment && this._StartMoment.isSame(value))
                    return;
                this._StartMoment = value.clone().startOf("day");
                this._StartDate = this._StartMoment.toDate();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ViewingPeriod.prototype, "LeftEndMoment", {
            get: function () {
                return this._LeftEndMoment.clone();
            },
            set: function (value) {
                if (this._LeftEndMoment && this._LeftEndMoment.isSame(value))
                    return;
                this._LeftEndMoment = value.clone().endOf("day");
                this._LeftEndDate = this.LeftEndMoment.toDate();
                this._RightEndMoment = this._LeftEndMoment.clone().add(1, "day").startOf("day");
                this._RightEndDate = this._RightEndMoment.toDate();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ViewingPeriod.prototype, "RightEndMoment", {
            get: function () {
                return this._RightEndMoment;
            },
            set: function (value) {
                if (this._RightEndMoment && this._RightEndMoment.isSame(value))
                    return;
                this._RightEndMoment = value.clone().startOf("day");
                this._RightEndDate = this._RightEndMoment.toDate();
                this._LeftEndMoment = this._RightEndMoment.clone().subtract(1, "day").endOf("day");
                this._LeftEndDate = this.LeftEndMoment.toDate();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ViewingPeriod.prototype, "LeftEndDate", {
            get: function () {
                return this._LeftEndDate;
            },
            set: function (value) {
                this.LeftEndMoment = moment(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ViewingPeriod.prototype, "StartDate", {
            get: function () {
                return this._StartDate;
            },
            set: function (value) {
                this.StartMoment = moment(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ViewingPeriod.prototype, "RightEndDate", {
            get: function () {
                return this._RightEndDate;
            },
            set: function (value) {
                this._RightEndMoment = moment(value);
            },
            enumerable: true,
            configurable: true
        });
        ViewingPeriod.CreateFromStart = function (start, getEnd) {
            return new ViewingPeriod(start, getEnd(start));
        };
        ViewingPeriod.CreateFromLeftEnd = function (getStart, leftEnd) {
            return new ViewingPeriod(getStart(leftEnd), leftEnd);
        };
        return ViewingPeriod;
    }());
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.ForwardNavigationDurations = Controller_19.DefaultForwardNavigateDurations;
            _this.BackwardNavigationDurations = Controller_19.DefaultBackwardNavigateDurations;
            _this.ViewingPeriodDurations = Controller_19.DefaultViewingPeriodDurations;
            _this.SelectedViewingPeriodDuration = utils.AsOptional(_this.ViewingPeriodDurations[0]);
            _this.ViewingPeriod = ViewingPeriod.CreateFromLeftEnd(function (end) { return _this.MakeStartFrom(end, utils.AssertNotVoid(_this.SelectedViewingPeriodDuration).Duration); }, moment());
            _this.Watch(function () { return _this.SelectedViewingPeriodDuration; }, function (newDuration) {
                if (!newDuration)
                    return;
                _this.ViewingPeriod.StartMoment = _this.MakeStartFrom(_this.ViewingPeriod.LeftEndMoment, newDuration.Duration);
            });
            _this.Watch.Collection(function () { return utils.IsUndefined(_this.BoundForwardNavigateDurations) ? Controller_19.DefaultForwardNavigateDurations : _this.BoundForwardNavigateDurations; }, function (boundForwardNavigateDurations) {
                if (boundForwardNavigateDurations === Controller_19.DefaultForwardNavigateDurations)
                    _this.BackwardNavigationDurations = Controller_19.DefaultBackwardNavigateDurations;
                else {
                    _this.ForwardNavigationDurations = boundForwardNavigateDurations;
                    _this.BackwardNavigationDurations = utils.ReverseArray(boundForwardNavigateDurations);
                }
            });
            _this.Watch.Collection(function () { return utils.IsUndefined(_this.BoundPeriodDurations) ? Controller_19.DefaultViewingPeriodDurations : _this.BoundPeriodDurations; }, function (boundPeriodDurations) {
                if (_this.ViewingPeriodDurations !== boundPeriodDurations)
                    _this.SelectedViewingPeriodDuration = null;
                _this.ViewingPeriodDurations = boundPeriodDurations;
            });
            return _this;
        }
        Controller_19 = Controller;
        Object.defineProperty(Controller.prototype, "ShowNavButtons", {
            get: function () {
                if (utils.IsVoid(this.BoundShowNavButtons))
                    return $mdMedia("gt-sm");
                else
                    return this.BoundShowNavButtons;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ShowDuration", {
            get: function () {
                if (utils.IsVoid(this.BoundShowDuration))
                    return $mdMedia("gt-xs");
                else
                    return this.BoundShowDuration;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "StartInclusive", {
            get: function () {
                return this.ViewingPeriod.StartDate;
            },
            set: function (value) {
                if (!value)
                    return;
                this.ViewingPeriod.StartDate = value;
                if (this.SelectedViewingPeriodDuration)
                    this.ViewingPeriod.LeftEndMoment = this.MakeLeftEndFrom(this.ViewingPeriod.StartMoment, this.SelectedViewingPeriodDuration.Duration);
                else if (this.ViewingPeriod.LeftEndMoment.isBefore(this.ViewingPeriod.StartMoment))
                    this.ViewingPeriod.LeftEndMoment = this.ViewingPeriod.StartMoment;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "EndInclusive", {
            get: function () {
                return this.ViewingPeriod.LeftEndDate;
            },
            set: function (value) {
                if (!value)
                    return;
                this.ViewingPeriod.LeftEndDate = value;
                if (this.SelectedViewingPeriodDuration)
                    this.ViewingPeriod.StartMoment = this.MakeStartFrom(this.ViewingPeriod.LeftEndMoment, this.SelectedViewingPeriodDuration.Duration);
                else if (this.ViewingPeriod.LeftEndMoment.isBefore(this.ViewingPeriod.StartMoment))
                    this.ViewingPeriod.StartMoment = this.ViewingPeriod.LeftEndMoment;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "EndExclusive", {
            get: function () {
                return this.ViewingPeriod.RightEndDate;
            },
            set: function (value) {
                if (!value)
                    return;
                this.ViewingPeriod.RightEndDate = value;
                if (this.SelectedViewingPeriodDuration)
                    this.ViewingPeriod.StartMoment = this.MakeStartFrom(this.ViewingPeriod.LeftEndMoment, this.SelectedViewingPeriodDuration.Duration);
                else if (this.ViewingPeriod.LeftEndMoment.isBefore(this.ViewingPeriod.StartMoment))
                    this.ViewingPeriod.StartMoment = this.ViewingPeriod.LeftEndMoment;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.JumpBackward = function (duration) {
            this.ViewingPeriod.LeftEndMoment = this.ViewingPeriod.LeftEndMoment.subtract(duration);
            this.ViewingPeriod.StartMoment = this.ViewingPeriod.StartMoment.subtract(duration);
        };
        Controller.prototype.JumpForward = function (duration) {
            this.ViewingPeriod.LeftEndMoment = this.ViewingPeriod.LeftEndMoment.add(duration);
            this.ViewingPeriod.StartMoment = this.ViewingPeriod.StartMoment.add(duration);
        };
        Controller.prototype.MakeStartFrom = function (leftEnd, viewingPeriodDurations) {
            return moment(leftEnd).subtract(viewingPeriodDurations).add(1, "day").startOf("day");
        };
        Controller.prototype.MakeLeftEndFrom = function (start, viewingPeriodDurations) {
            return moment(start).add(viewingPeriodDurations).subtract(1, "day").endOf("day");
        };
        Controller.DefaultForwardNavigateDurations = Object.freeze([
            { Label: "1 Day", Duration: moment.duration(1, "day") },
            { Label: "1 Week", Duration: moment.duration(1, "week") },
            { Label: "1 Month", Duration: moment.duration(1, "month") },
        ]);
        Controller.DefaultBackwardNavigateDurations = Object.freeze(utils.ReverseArray(Controller_19.DefaultForwardNavigateDurations));
        Controller.DefaultViewingPeriodDurations = Object.freeze([
            { Label: "1 Day", Duration: moment.duration(1, "day") },
            { Label: "1 Week", Duration: moment.duration(1, "week") },
            { Label: "1 Month", Duration: moment.duration(1, "month") },
            { Label: "1 Year", Duration: moment.duration(1, "year") },
        ]);
        __decorate([
            utils.Bind.In("show-nav-buttons", { optional: true })
        ], Controller.prototype, "BoundShowNavButtons", void 0);
        __decorate([
            utils.Bind.In("show-duration", { optional: true })
        ], Controller.prototype, "BoundShowDuration", void 0);
        __decorate([
            utils.Bind.TwoWay("start", { optional: true })
        ], Controller.prototype, "StartInclusive", null);
        __decorate([
            utils.Bind.TwoWay("end-for-inclusive", { optional: true })
        ], Controller.prototype, "EndInclusive", null);
        __decorate([
            utils.Bind.TwoWay("end", { optional: true })
        ], Controller.prototype, "EndExclusive", null);
        __decorate([
            utils.Bind.In("time-jumps", { optional: true })
        ], Controller.prototype, "BoundForwardNavigateDurations", void 0);
        __decorate([
            utils.Bind.In("period-durations", { optional: true })
        ], Controller.prototype, "BoundPeriodDurations", void 0);
        Controller = Controller_19 = __decorate([
            utils.Component({
                Name: "sdc-period-navigation",
            })
        ], Controller);
        return Controller;
        var Controller_19;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/progress/arc/sdc-progress-arc", ["require", "exports", "app/utils", "$timeout", "$window", "$mdTheming"], function (require, exports, utils, $timeout, $window, $mdTheming) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Offset = (function () {
        function Offset(args) {
            this.offset = args.offset;
            this.complete = args.complete;
            this.si = args.si;
            this.li = args.li;
            this.layers = args.layers;
            this.stack = args.stack;
        }
        return Offset;
    }());
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.offset = /firefox/i.test(navigator.userAgent) ? -89.9 : -90;
            $mdTheming(_this.Scope, _this.Element);
            _this.updateRadius();
            if (_this.initial !== null && _this.initial !== undefined && !/(^|;)\s*(Trident\/[0-7](\.[0-9]+)?)\s*($|;)/.test(navigator.userAgent)) {
                _this.strokeDashOffsets = _this.CalculateNewOffsets(parseFloat(_this.initial));
                $timeout(function () { return _this.autoUpdateStrokeDashOffset(); }, Math.random() * 500);
            }
            else {
                _this.autoUpdateStrokeDashOffset();
            }
            _this.compatibilityHacks();
            return _this;
        }
        Controller_20 = Controller;
        Object.defineProperty(Controller.prototype, "size", {
            get: function () {
                return Number(this.boundSize);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "strokeWidth", {
            get: function () {
                return Number(this.boundStrokeWidth);
            },
            enumerable: true,
            configurable: true
        });
        Controller.CalculateLayers = function (layers) {
            var clampedLayers = Controller_20.ClampLayers(layers);
            return utils.IsArray(layers) ? layers : (utils.IsVoid(layers) ? [] : [layers]);
        };
        Controller.ClampLayers = function (layers) {
            if (utils.IsNumber(layers))
                return utils.Math.Clamp(layers, 0, 1);
            if (!utils.IsArray(layers))
                return layers;
            return layers.map(function (r) { return !utils.IsArray(r) ? utils.Math.Clamp(r || 0, 0, 1) : r.map(function (r) { return utils.Math.Clamp(r || 0, 0, 1); }); });
        };
        Controller.prototype.CalculateNewOffsets = function (complete, override) {
            var layers = Controller_20.CalculateLayers(complete);
            var newOffsets = new Array();
            for (var li = 0; li < layers.length; li++) {
                var item = layers[li];
                var originalStack = utils.IsArray(item) ? item : [item];
                var newStack = new Array();
                newOffsets.push(newStack);
                for (var si = 0; si < originalStack.length; si++) {
                    var complete_1 = originalStack[si];
                    newStack.push(new Offset({
                        offset: (this.counterClockwise ? -1 : 1) * (1 - (!utils.IsVoid(override) ? override : complete_1)) * this.circumference,
                        complete: complete_1,
                        li: li,
                        si: si,
                        layers: newOffsets,
                        stack: newStack,
                    }));
                }
            }
            return newOffsets;
        };
        Controller.prototype.updateRadius = function () {
            this.strokeWidthCapped = Math.min(this.strokeWidth, this.size / 2 - 1);
            this.radius = Math.max((this.size - this.strokeWidthCapped) / 2 - 1, 0);
            this.circumference = 2 * Math.PI * this.radius;
        };
        Controller.prototype.autoUpdateStrokeDashOffset = function () {
            var _this = this;
            this.Watch.Deep(function () { return Controller_20.CalculateLayers(_this.complete); }, function (layers) { return _this.strokeDashOffsets = _this.CalculateNewOffsets(layers); });
        };
        Controller.prototype.compatibilityHacks = function () {
            var _this = this;
            this.Watch.Collection(function () { return [_this.size, _this.strokeWidth]; }, function () { return _this.updateRadius(); });
            var window = angular.element($window);
            var onResize = function (event) {
                var elm = _this.Element[0];
                var originalDisplay = elm.style.display;
                elm.style.display = 'none';
                elm.offsetHeight;
                elm.style.display = originalDisplay;
            };
            window.bind("resize", onResize);
            this.Scope.$on("$destroy", function (event) {
                window.unbind("resize", onResize);
            });
        };
        __decorate([
            utils.Bind.Literal("size"),
            utils.Bind.DefaultValue("200")
        ], Controller.prototype, "boundSize", void 0);
        __decorate([
            utils.Bind.Literal("stroke-width"),
            utils.Bind.DefaultValue("20")
        ], Controller.prototype, "boundStrokeWidth", void 0);
        __decorate([
            utils.Bind.Literal("counter-clockwise")
        ], Controller.prototype, "counterClockwise", void 0);
        __decorate([
            utils.Bind.In("complete")
        ], Controller.prototype, "complete", void 0);
        __decorate([
            utils.Bind.Literal("initial"),
            utils.Bind.DefaultValue("1")
        ], Controller.prototype, "initial", void 0);
        __decorate([
            utils.Bind.Getter("arc-class")
        ], Controller.prototype, "arcClass", void 0);
        Controller = Controller_20 = __decorate([
            utils.Component({
                Name: "sdc-progress-arc",
                Transclude: utils.TransclusionMode.Contents,
            })
        ], Controller);
        return Controller;
        var Controller_20;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/quit/protection/message/sdc-quit-protection-message", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-quit-protection-message";
    var Controller = (function () {
        function Controller() {
        }
        Object.defineProperty(Controller.prototype, "Message", {
            get: function () {
                if (!utils.IsSpecified(this.message))
                    return "";
                else
                    return String(this.message);
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Literal(exports.Name)
        ], Controller.prototype, "message", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/quit/protection/handler/sdc-quit-protection-handler", ["require", "exports", "app/utils", "$q", "$mdDialog"], function (require, exports, utils, $q, $mdDialog) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-quit-protection-handler";
    var id_curr = 1;
    var Requestor = (function () {
        function Requestor() {
            this.id = (Requestor.count++).toString();
        }
        Object.defineProperty(Requestor, "Count", {
            get: function () {
                return this.count;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Requestor.prototype, "Id", {
            get: function () {
                return this.id;
            },
            enumerable: true,
            configurable: true
        });
        Requestor.count = 0;
        return Requestor;
    }());
    exports.Requestor = Requestor;
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(Controller.prototype, "ProtectionRequested", {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Messages", {
            get: function () {
                return Controller.EmptyMessages;
            },
            enumerable: true,
            configurable: true
        });
        Controller.EmptyMessages = Object.freeze([]);
        return Controller;
    }(Requestor));
    exports.Controller = Controller;
    var defaultMessages = Object.freeze({
        Title: "Unsaved Changes",
        ActionWithSubMessages: "Continuing will cause you to lose the following unsaved changes:",
        ActionWithoutSubMessages: "Continuing will cause you to lose your unsaved changes.",
        Okay: "Okay",
        Cancel: "Cancel",
    });
    function Confirm(handler, event, messages) {
        if (messages === void 0) { messages = defaultMessages; }
        if (!utils.IsSpecified(handler))
            return $q.resolve();
        else {
            if (!handler.ProtectionRequested)
                return $q.resolve();
            var root = $("<div></div>");
            if (handler.Messages.length <= 0)
                root.text(messages.ActionWithoutSubMessages);
            else {
                root.text(messages.ActionWithSubMessages);
                var list = $("<ul></ul>").appendTo(root);
                try {
                    for (var _a = __values(handler.Messages), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var message = _b.value;
                        $("<li></li>").text(message).appendTo(list);
                    }
                }
                catch (e_84_1) { e_84 = { error: e_84_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_84) throw e_84.error; }
                }
            }
            var dialog = $mdDialog.confirm()
                .targetEvent(event)
                .title(messages.Title || defaultMessages.Title)
                .htmlContent(root.html())
                .ok(messages.Okay)
                .cancel(messages.Cancel || defaultMessages.Cancel);
            return $mdDialog.show(dialog).then(function () { }, function () { return $q.reject(); });
        }
        var e_84, _c;
    }
    exports.Confirm = Confirm;
    function GetRequested(handler, voidState) {
        if (voidState === void 0) { voidState = false; }
        if (!utils.IsSpecified(handler))
            return voidState;
        else
            return handler.ProtectionRequested;
    }
    exports.GetRequested = GetRequested;
    var DirectiveController = (function (_super) {
        __extends(DirectiveController, _super);
        function DirectiveController($scope) {
            var _this = _super.call(this) || this;
            _this.disposed = false;
            _this.ChildStates = {};
            $scope.$on("$destroy", function () { return _this.dispose(); });
            return _this;
        }
        DirectiveController.prototype.RebuildMessages = function () {
            this.messages = null;
        };
        Object.defineProperty(DirectiveController.prototype, "Self", {
            get: function () { return this; },
            set: function (value) { },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DirectiveController.prototype, "Handler", {
            get: function () {
                if (this.parent === this)
                    return;
                else
                    return this.parent;
            },
            enumerable: true,
            configurable: true
        });
        DirectiveController.prototype.OnNotify = function () {
            var _this = this;
            if (this.disposed)
                return;
            this.protectionExplcitlyRequested = false;
            if (!this.messages) {
                var messages_1 = [];
                angular.forEach(this.ChildStates, function (s) {
                    if (Array.isArray(s))
                        messages_1.push.apply(messages_1, __spread(s));
                    else if (utils.IsString(s))
                        messages_1.push(s);
                    else if (s)
                        _this.protectionExplcitlyRequested = true;
                });
                this.messages = Object.freeze(messages_1);
            }
            else {
                for (var prop in this.ChildStates) {
                    if (!utils.HasProp(this.ChildStates, prop))
                        continue;
                    if (this.ChildStates[prop] === true) {
                        this.protectionExplcitlyRequested = true;
                        break;
                    }
                }
            }
            var Handler = this.Handler;
            if (utils.IsSpecified(Handler))
                Handler.Notify(this, this.Messages.length > 0 ? this.Messages : this.protectionExplcitlyRequested);
        };
        DirectiveController.prototype.Notify = function (source, state) {
            if (this.disposed)
                return;
            var newState;
            if (!Array.isArray(state))
                newState = state;
            else if (state.length > 0)
                newState = state.slice();
            else
                newState = false;
            var oldState = utils.HasProp(this.ChildStates, source.Id) ? this.ChildStates[source.Id] : false;
            this.ChildStates[source.Id] = newState;
            if ((!utils.IsBoolean(newState) || !utils.IsBoolean(oldState)) && !angular.equals(newState, oldState))
                this.RebuildMessages();
            this.OnNotify();
        };
        DirectiveController.prototype.NotifyRemoval = function (source) {
            if (this.disposed)
                return;
            var oldState = utils.HasProp(this.ChildStates, source.Id) ? this.ChildStates[source.Id] : false;
            delete this.ChildStates[source.Id];
            if (!utils.IsBoolean(oldState))
                this.RebuildMessages();
            this.OnNotify();
        };
        Object.defineProperty(DirectiveController.prototype, "protectionRequested", {
            get: function () {
                return (this.Messages.length) > 0 ? this.messages : this.protectionExplcitlyRequested;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DirectiveController.prototype, "ProtectionRequested", {
            get: function () {
                return !!this.protectionRequested;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DirectiveController.prototype, "Messages", {
            get: function () {
                return this.messages || Controller.EmptyMessages;
            },
            enumerable: true,
            configurable: true
        });
        DirectiveController.prototype.dispose = function () {
            var Handler = this.Handler;
            this.disposed = true;
            if (utils.IsSpecified(Handler))
                Handler.NotifyRemoval(this);
            this.ChildStates = null;
            this.messages = null;
        };
        __decorate([
            utils.Bind.TwoWay(exports.Name, { optional: true })
        ], DirectiveController.prototype, "Self", null);
        __decorate([
            utils.Bind.Controller(exports.Name, { mode: utils.Bind.Controller.Mode.Parents, optional: true })
        ], DirectiveController.prototype, "parent", void 0);
        DirectiveController = __decorate([
            utils.Component({
                Name: exports.Name,
                Restrict: utils.Target.Attribute,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            }),
            __param(0, utils.Inject("$scope"))
        ], DirectiveController);
        return DirectiveController;
    }(Controller));
    exports.DirectiveController = DirectiveController;
});
define("app/sdc/quit/protection/sdc-quit-protection", ["require", "exports", "app/sdc/quit/protection/handler/sdc-quit-protection-handler", "app/utils"], function (require, exports, handler, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-quit-protection";
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller($watch, $scope) {
            var _this = _super.call(this) || this;
            $watch.Collection(function () { return ({ handler: _this.Handler, protectionRequested: _this.ProtectionRequested }); }, function ($new, $old) {
                if ($new.handler !== $old.handler) {
                    var handler_1 = $old.handler;
                    if (utils.IsSpecified(handler_1))
                        handler_1.NotifyRemoval(_this);
                }
                {
                    var handler_2 = $new.handler, protectionRequested = $new.protectionRequested;
                    if (protectionRequested)
                        protectionRequested = (_this.MessageController ? _this.MessageController.Message : "") || protectionRequested;
                    if (utils.IsSpecified(handler_2)) {
                        handler_2.Notify(_this, Controller_21.GuardRequest(protectionRequested));
                    }
                }
            });
            $scope.$on("$destroy", function () {
                var Handler = _this.Handler;
                if (utils.IsSpecified(Handler))
                    Handler.NotifyRemoval(_this);
            });
            return _this;
        }
        Controller_21 = Controller;
        Controller.GuardRequest = function (arg) {
            if (utils.IsString(arg))
                return arg;
            else
                return !!arg;
        };
        __decorate([
            utils.Bind.TwoWay(exports.Name, { optional: true })
        ], Controller.prototype, "ProtectionRequested", void 0);
        __decorate([
            utils.Bind.Controller(handler.DirectiveController, { mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "Handler", void 0);
        __decorate([
            utils.Bind.Controller(handler.DirectiveController, { mode: utils.Bind.Controller.Mode.Self, optional: true })
        ], Controller.prototype, "MessageController", void 0);
        Controller = Controller_21 = __decorate([
            utils.Component({
                Name: exports.Name,
                Restrict: utils.Target.Attribute,
                Template: null,
                Scope: utils.ScopeMode.ParentScope
            }),
            __param(0, utils.Inject("$watch")), __param(1, utils.Inject("$scope"))
        ], Controller);
        return Controller;
        var Controller_21;
    }(handler.Requestor));
    exports.Controller = Controller;
});
define("app/sdc/regex/escaped/sdc-regex-escaped-factory", ["require", "exports", "app/sdc/regex/sdc-regex"], function (require, exports, regex) {
    "use strict";
    return regex.escape;
});
define("app/sdc/route/controller/sdc-route-controller", ["require", "exports", "$parse"], function (require, exports, $parse) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Directive = {
        restrict: "A",
        scope: false,
        template: null,
        require: "sdcRoute",
        link: ["$controllers", "$scope", "$attrs", function (controller, $scope, $attrs) {
                var expr = $attrs["sdcRouteController"];
                var parsed = $parse(expr);
                parsed.assign($scope, controller);
            }]
    };
});
define("app/sdc/route/merge/sdc-route-merge", ["require", "exports", "app/utils", "app/sdc/route/sdc-route", "app/sdc/builder/expression/sdc-builder-expression", "app/selcomm/service"], function (require, exports, utils, sdcRoute, sdc_builder_expression_1, selcomm) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller($attrs, $watch, $scope) {
            var _this = this;
            this.$attrs = $attrs;
            this.$watch = $watch;
            this.$scope = $scope;
            this.assignRouteTo = sdc_builder_expression_1.create($attrs["sdcRouteMerge"], $scope);
            $watch.Deep(function () { return _this.RouteObject; }, function ($new) { return _this.route = $new; });
            $watch(function () { return _this.href; }, function ($new) { return $scope.$applyAsync(function () { return $attrs.$set("href", utils.Paths.Combine("!", $new)); }); });
        }
        Object.defineProperty(Controller.prototype, "RouteObject", {
            get: function () {
                var routeObj = {};
                if (this.routeCtrl && this.routeCtrl.Route && this.routeCtrl.Route.Assign) {
                    this.routeCtrl.Route.Assign(routeObj);
                }
                this.assignRouteTo(routeObj);
                return routeObj;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "href", {
            get: function () {
                if (this.routeCtrl)
                    return this.routeCtrl.FormatAsUrl(this.route);
                else
                    return selcomm.authentication.UrlWithoutSession(".");
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Controller(sdcRoute.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents, optional: true })
        ], Controller.prototype, "routeCtrl", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "sdc-route-merge",
                Restrict: utils.Target.ElementOrAttribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            }),
            __param(0, utils.Inject("$attrs")),
            __param(1, utils.Inject("$watch")),
            __param(2, utils.Inject("$scope"))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/route/set/sdc-route-set", ["require", "exports", "app/utils", "app/sdc/route/sdc-route", "app/sdc/builder/expression/sdc-builder-expression", "app/selcomm/service"], function (require, exports, utils, sdcRoute, builder, selcomm) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller($attrs, $watch, $scope) {
            var _this = this;
            this.$attrs = $attrs;
            this.$watch = $watch;
            this.$scope = $scope;
            this.assignRouteTo = builder.create($attrs["sdcRouteMerge"], $scope);
            $watch.Deep(function () { return _this.RouteObject; }, function ($new) { return _this.route = $new; });
            $watch(function () { return _this.href; }, function ($new) { return $scope.$applyAsync(function () { return $attrs.$set("href", utils.Paths.Combine("!", $new)); }); });
        }
        Object.defineProperty(Controller.prototype, "RouteObject", {
            get: function () {
                var routeObj = {};
                this.assignRouteTo(routeObj);
                return routeObj;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "href", {
            get: function () {
                if (this.routeCtrl)
                    return this.routeCtrl.FormatAsUrl(this.route);
                else
                    return selcomm.authentication.UrlWithoutSession(".");
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Controller(sdcRoute.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents, optional: true })
        ], Controller.prototype, "routeCtrl", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "sdc-route-set",
                Restrict: utils.Target.ElementOrAttribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            }),
            __param(0, utils.Inject("$attrs")),
            __param(1, utils.Inject("$watch")),
            __param(2, utils.Inject("$scope"))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/site/name/sdc-site-name", ["require", "exports", "app/utils", "app/sss/sites"], function (require, exports, utils, sites) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller() {
            sites.Service.Current = new sites.Site(this.Name, this.Mode, this.DisplayName, this.Hash);
        }
        __decorate([
            utils.Bind.Literal("sdc-site-name")
        ], Controller.prototype, "Name", void 0);
        __decorate([
            utils.Bind.Literal("site-mode")
        ], Controller.prototype, "Mode", void 0);
        __decorate([
            utils.Bind.Literal("site-display-name")
        ], Controller.prototype, "DisplayName", void 0);
        __decorate([
            utils.Bind.Literal("site-hash")
        ], Controller.prototype, "Hash", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "sdc-site-name",
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/stacked/section/sdc-stacked-section", ["require", "exports", "app/ng-utils", "app/utils", "scripts/lib/select-development/sss-names", "module"], function (require, exports, ng_utils_24, utils, names, module_25) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch(function () { return _this.Section; }, function (section, lastSection) {
                if (lastSection && lastSection !== section)
                    lastSection.defined--;
                if (section)
                    section.defined++;
            });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "Section", {
            get: function () {
                return Section.GetOrCreateById(this.Id);
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Literal("id")
        ], Controller.prototype, "Id", void 0);
        __decorate([
            utils.Bind.Literal("component-class")
        ], Controller.prototype, "ComponentClass", void 0);
        __decorate([
            utils.Bind.TwoWay("open-components")
        ], Controller.prototype, "OpenComponents", void 0);
        __decorate([
            utils.Bind.Transclude(utils.Bind.Transclude.Mode.Contents)
        ], Controller.prototype, "TranscludeContents", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_25.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    var Section = (function () {
        function Section(Id) {
            this.Id = Id;
            this.Components = new Array();
            this.defined = 0;
        }
        Section_1 = Section;
        Object.defineProperty(Section.prototype, "components", {
            get: function () {
                return this.Components;
            },
            set: function (value) {
                this.Clear();
                try {
                    for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
                        var component = value_1_1.value;
                        this.AddComponent(component);
                    }
                }
                catch (e_85_1) { e_85 = { error: e_85_1 }; }
                finally {
                    try {
                        if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
                    }
                    finally { if (e_85) throw e_85.error; }
                }
                var e_85, _a;
            },
            enumerable: true,
            configurable: true
        });
        Section.prototype.removeComponent = function () { return this.removeComponent.apply(this, arguments); };
        Section.prototype.RemoveComponent = function (targetComponentOrIndex) {
            if (!utils.IsObject(targetComponentOrIndex)) {
                this.Components.splice(targetComponentOrIndex, 1);
                return;
            }
            if (targetComponentOrIndex instanceof Section_1.Component) {
                utils.Collection.ArrayRemoveWhere(this.Components, function (c) { return c.definition === targetComponentOrIndex.definition; });
                return;
            }
            utils.Collection.ArrayRemoveWhere(this.Components, function (c) { return c.definition === targetComponentOrIndex; });
        };
        Section.prototype.clear = function () { return this.Clear.apply(this, arguments); };
        Section.prototype.Clear = function () {
            this.Components.length = 0;
        };
        Section.prototype.focus = function () { return this.Focus.apply(this, arguments); };
        Section.prototype.Focus = function (componentName, notFound) {
            var _this = this;
            var normalizedName = names.ComponentNameNormalize(componentName);
            var found = utils.Collection.ArrayRemoveWhere(this.Components, function (c) { return c.directiveNormalizedTag === normalizedName; }, 1);
            if (found.length && found[0]) {
                (_a = this.Components).push.apply(_a, __spread(found));
                utils.Delay().then(function () { return _this.ScrollIntoView(); });
            }
            var _a;
        };
        Section.prototype.scrollIntoView = function () { return this.ScrollIntoView.apply(this, arguments); };
        Section.prototype.ScrollIntoView = function () {
            ng_utils_24.$anchorScroll(this.Id);
        };
        Section.prototype.addComponent = function () { return this.AddComponent.apply(this, arguments); };
        Section.prototype.AddComponent = function (newComponent, insertAt) {
            return __awaiter(this, void 0, ng_utils_24.$q, function () {
                var tagParts, wrapped, isOnTop;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            tagParts = names.ComponentNameParts("" + newComponent.tag);
                            if (!names.IsSelectComponent) return [3, 2];
                            return [4, utils.Require("directive!" + newComponent)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            wrapped = new Section_1.Component(newComponent, this);
                            this.RemoveComponent(newComponent);
                            if (utils.IsNumber(insertAt)) {
                                isOnTop = this.components.length === insertAt;
                                this.Components.splice(insertAt, 0, wrapped);
                            }
                            else {
                                isOnTop = true;
                                this.Components.push(wrapped);
                            }
                            if (isOnTop)
                                this.ScrollIntoView();
                            if (!ng_utils_24.$rootScope.$$phase)
                                ng_utils_24.$rootScope.$apply();
                            return [2];
                    }
                });
            });
        };
        Section.prototype.containsDirective = function () { return this.ContainsDirective.apply(this, arguments); };
        Section.prototype.ContainsDirective = function (targetTag) {
            var normalizedTargetTag = names.ComponentNameNormalize(targetTag);
            var count = 0;
            for (var i = 0; i < this.Components.length; i++) {
                if (this.Components[i].directiveNormalizedTag === normalizedTargetTag)
                    count++;
            }
            return count;
        };
        Section.GetOrCreateById = function (id) {
            Section_1.OpenSection(id);
            return Section_1.Sections[id];
        };
        Section.OpenSection = function (id) {
            if (id in Section_1.Sections)
                return false;
            Section_1.Sections[id] = new Section_1(id);
            return true;
        };
        Section.CloseSection = function (sectionKey) {
            if (sectionKey in Section_1.Sections) {
                delete Section_1.Sections[sectionKey];
                return true;
            }
            else {
                return false;
            }
        };
        Section.Sections = Object.create(null);
        Section = Section_1 = __decorate([
            utils.BindFunctions
        ], Section);
        return Section;
        var Section_1;
    }());
    exports.Section = Section;
    (function (Section) {
        var Component = (function () {
            function Component(definition, section) {
                this.definition = definition;
                this.section = section;
                this.tag = this.definition.tag;
                this.directiveNormalizedTag = names.ComponentNameNormalize(this.tag);
            }
            Component.prototype.Close = function () {
                this.section.RemoveComponent(this);
            };
            Component.prototype.close = function () { return this.Close.apply(this, arguments); };
            Component = __decorate([
                utils.BindFunctions
            ], Component);
            return Component;
        }());
        Section.Component = Component;
    })(Section = exports.Section || (exports.Section = {}));
    exports.Section = Section;
});
define("app/sdc/stacked/section/sdc-stacked-section-service", ["require", "exports", "app/sdc/stacked/section/sdc-stacked-section"], function (require, exports, sdc_stacked_section_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function section(sectionKey) {
        return sdc_stacked_section_1.Section.GetOrCreateById(sectionKey);
    }
    exports.section = section;
    function openSection(sectionKey) {
        return sdc_stacked_section_1.Section.OpenSection(sectionKey);
    }
    exports.openSection = openSection;
    function closeSection(sectionKey) {
        return sdc_stacked_section_1.Section.CloseSection(sectionKey) && void null;
    }
    exports.closeSection = closeSection;
});
define("app/sdc/tab/body/sdc-tab-body", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.Directive({
        Name: "sdc-tab-body",
        Terminal: true,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
    });
});
define("app/sdc/tab/label/sdc-tab-label", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.Directive({
        Name: "sdc-tab-label",
        Terminal: true,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
    });
});
define("app/sds/contact/address/utils", ["require", "exports", "app/utils", "app/selcomm/service", "app/sds/address/utils"], function (require, exports, utils, service_19, addressUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ContactAddressType = service_19.Selcomm.Address.AddressType;
    var ContactAddress = (function () {
        function ContactAddress(address, addrType, contactCode) {
            this.Address = address;
            this.ContactCode = contactCode;
            this.Type = addrType;
        }
        ContactAddress.CreateFromSelcommAddress = function (address, contactCode, typesByCode) {
            var contactAddressType = (!typesByCode || !address.AddressType) ? address.AddressType : (typesByCode.get(address.AddressType.Code) || address.AddressType);
            return new ContactAddress(address, contactAddressType, contactCode);
        };
        ContactAddress.prototype.ToSelcommAddress = function () {
            var selcommAddr = utils.ShallowCopy(this.Address);
            selcommAddr.AddressType = this.Type;
            return selcommAddr;
        };
        return ContactAddress;
    }());
    exports.ContactAddress = ContactAddress;
    function GetContactAddresses(contactCode) {
        return __awaiter(this, void 0, void 0, function () {
            var addressListPromise, typesPromise, addressList, typesByCodeMap, types, err_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addressListPromise = service_19.Service.Address.AddressList({
                            ContactCode: contactCode,
                            RefreshCache: true,
                        });
                        typesPromise = GetContactAddressTypes();
                        return [4, addressListPromise];
                    case 1:
                        addressList = _a.sent();
                        typesByCodeMap = null;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, typesPromise];
                    case 3:
                        types = (_a.sent());
                        typesByCodeMap = new Map(types.map(function (t) { return [t.Code, t]; }));
                        return [3, 5];
                    case 4:
                        err_22 = _a.sent();
                        return [3, 5];
                    case 5: return [2, addressList.Items
                            .filter(function (a) { return a != null; })
                            .map(function (sa) { return ContactAddress.CreateFromSelcommAddress(sa, contactCode, typesByCodeMap); })];
                }
            });
        });
    }
    exports.GetContactAddresses = GetContactAddresses;
    function GetContactExtendedAddresses(contactCode) {
        return __awaiter(this, void 0, void 0, function () {
            var addressListPromise, typesPromise, addressList, typesByCodeMap, types, err_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addressListPromise = service_19.Service.Address.ExtendedAddressList({
                            ContactCode: contactCode,
                            RefreshCache: true,
                        });
                        typesPromise = GetContactAddressTypes();
                        return [4, addressListPromise];
                    case 1:
                        addressList = _a.sent();
                        typesByCodeMap = null;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, typesPromise];
                    case 3:
                        types = (_a.sent());
                        typesByCodeMap = new Map(types.map(function (t) { return [t.Code, t]; }));
                        return [3, 5];
                    case 4:
                        err_23 = _a.sent();
                        return [3, 5];
                    case 5: return [2, addressList.Items
                            .filter(function (a) { return a != null; })
                            .map(function (sa) { return ContactAddress.CreateFromSelcommAddress(sa, contactCode, typesByCodeMap); })];
                }
            });
        });
    }
    exports.GetContactExtendedAddresses = GetContactExtendedAddresses;
    function UpdateContactAddress(address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_19.Service.Address.AddressUpdateByContact({
                            ContactCode: utils.IsVoid(address) ? null : address.ContactCode,
                            Address: utils.IsVoid(address) ? null : address.ToSelcommAddress(),
                        })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    }
    exports.UpdateContactAddress = UpdateContactAddress;
    function AddContactAddress(address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_19.Service.Address.AddressAddByContact({
                            ContactCode: utils.IsVoid(address) ? null : address.ContactCode,
                            Address: utils.IsVoid(address) ? null : address.ToSelcommAddress(),
                        })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    }
    exports.AddContactAddress = AddContactAddress;
    function DeleteContactAddress(address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_19.Service.Address.AddressDeleteByContact({
                            ContactCode: utils.IsVoid(address) ? null : address.ContactCode,
                            Address: utils.IsVoid(address) ? null : address.ToSelcommAddress(),
                        })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    }
    exports.DeleteContactAddress = DeleteContactAddress;
    function GetContactAddressTypes(useCached) {
        if (useCached === void 0) { useCached = true; }
        return __awaiter(this, void 0, void 0, function () {
            var targetService, types;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        targetService = useCached ? service_19.CachedService : service_19.Service;
                        return [4, targetService.Address.AddressTypeList({ RefreshCache: true })];
                    case 1:
                        types = (_a.sent()).Items;
                        return [2, types];
                }
            });
        });
    }
    exports.GetContactAddressTypes = GetContactAddressTypes;
    function IsPoBox(address) {
        return addressUtils.IsPoBox(address && address.Address);
    }
    exports.IsPoBox = IsPoBox;
    function IsPoBoxAllowed(addressType) {
        if (!addressType)
            return true;
        switch (addressType.Code) {
            case "CA":
            case "PA":
                return false;
            default:
                return true;
        }
    }
    exports.IsPoBoxAllowed = IsPoBoxAllowed;
});
define("app/sdc/tabbed/components/sdc-tabbed-components", ["require", "exports", "app/utils", "app/sdc/quit/protection/handler/sdc-quit-protection-handler", "app/ng-utils", "moment"], function (require, exports, utils, quitProtection, ng_utils_25, moment) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-tabbed-components";
    var TabType;
    (function (TabType) {
        TabType[TabType["Pinned"] = 2] = "Pinned";
        TabType[TabType["Preview"] = 1] = "Preview";
        TabType[TabType["Normal"] = 0] = "Normal";
    })(TabType || (TabType = {}));
    var SyncDirection;
    (function (SyncDirection) {
        SyncDirection[SyncDirection["None"] = 0] = "None";
        SyncDirection[SyncDirection["Out"] = 1] = "Out";
        SyncDirection[SyncDirection["In"] = 2] = "In";
    })(SyncDirection || (SyncDirection = {}));
    var Tab = (function () {
        function Tab(Underlying, type) {
            this.Underlying = Underlying;
            this.type = type;
            var renderContents = moment.isDuration(this.Underlying.RenderContents) ? this.Underlying.RenderContents.asMilliseconds() : this.Underlying.RenderContents;
            if (utils.IsVoid(renderContents))
                this._renderContents = false;
            else if (!utils.IsNumber(renderContents))
                this._renderContents = !!renderContents;
            else {
                this._renderContents = false;
                this.EnsureRenderContentsDelayed(renderContents);
            }
        }
        Tab_1 = Tab;
        Object.defineProperty(Tab.prototype, "RenderContents", {
            get: function () {
                return this._renderContents;
            },
            enumerable: true,
            configurable: true
        });
        Tab.prototype.EnsureRenderContents = function () {
            this._renderContents = true;
        };
        Tab.Id = function (tab) {
            if (tab instanceof Tab_1)
                return tab.Id;
            else
                return Tab_1.TabId.GetKey(tab);
        };
        Object.defineProperty(Tab.prototype, "Id", {
            get: function () {
                return Tab_1.TabId.GetKey(this.Underlying);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tab.prototype, "Title", {
            get: function () {
                return this.Underlying.title;
            },
            set: function (value) {
                this.Underlying.title = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tab.prototype, "Component", {
            get: function () {
                return this.Underlying;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tab.prototype, "Type", {
            get: function () {
                return this.type;
            },
            set: function (value) {
                this.type = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tab.prototype, "IsPreview", {
            get: function () {
                return this.Type === TabType.Preview;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tab.prototype, "IsPinned", {
            get: function () {
                return this.Type === TabType.Pinned;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tab.prototype, "IsNormal", {
            get: function () {
                return this.Type === TabType.Normal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tab.prototype, "CanClose", {
            get: function () {
                return !this.Underlying.NoClose;
            },
            enumerable: true,
            configurable: true
        });
        Tab.prototype.IdEquals = function (tab) {
            return Tab_1.Id(tab) === this.Id;
        };
        Object.defineProperty(Tab.prototype, "IsSettingTab", {
            get: function () {
                return this.Title.toUpperCase() === "SETTINGS";
            },
            enumerable: true,
            configurable: true
        });
        Tab.prototype.CloneWithType = function (type) {
            var clone = new Tab_1(this.Underlying, type);
            clone.QuitProtectionHandler = this.QuitProtectionHandler;
            return clone;
        };
        Tab.prototype.EnsureRenderContentsDelayed = function (delay) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            ng_utils_25.$log.info("Deferring tab load for " + delay + "ms to improve performance.");
                            return [4, utils.Delay(delay, false)];
                        case 1:
                            _a.sent();
                            if (this.RenderContents) {
                                ng_utils_25.$log.info("Deferred tab (" + delay + "ms) was loaded early due to user request.");
                                return [2];
                            }
                            ng_utils_25.$log.info("Deferred tab (" + delay + "ms) being loaded.");
                            ng_utils_25.$rootScope.$applyAsync(function () { return _this.EnsureRenderContents(); });
                            return [2];
                    }
                });
            });
        };
        Tab.TabId = new utils.HashKeyFactory("tab-id");
        Tab = Tab_1 = __decorate([
            utils.BindFunctions
        ], Tab);
        return Tab;
        var Tab_1;
    }());
    var TabCollection = (function () {
        function TabCollection(getShowPlaceholderTab, getLiteralTabs, tabs) {
            if (tabs === void 0) { tabs = []; }
            this.getShowPlaceholderTab = getShowPlaceholderTab;
            this.getLiteralTabs = getLiteralTabs;
            this.NonLiteralTabs = Object.freeze(tabs.slice());
            this.NonLiteralTabIds = Object.freeze(tabs.map(function (t) { return t.Id; }));
        }
        Object.defineProperty(TabCollection.prototype, "AllTabs", {
            get: function () {
                var PlaceholderTabs = this.PlaceholderTabCount ? TabCollection.FilledPlaceholderTabs : TabCollection.EmptyPlaceholderTabs;
                return PlaceholderTabs.concat(this.LiteralTabs).concat(this.NonLiteralTabs);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TabCollection.prototype, "NonLiteralTabsPreviewTabIndex", {
            get: function () {
                var index = utils.Collection.IndexOf(this.NonLiteralTabs, function (t) { return t.IsPreview; });
                if (index < 0)
                    return void null;
                return index;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TabCollection.prototype, "PreviewTabIndex", {
            get: function () {
                var index = this.NonLiteralTabsPreviewTabIndex;
                if (utils.IsVoid(index))
                    return index;
                return this.IndexOffset + index;
            },
            enumerable: true,
            configurable: true
        });
        TabCollection.prototype.GetOrCreateNonLiteral = function (source) {
            var found = this.GetNonLiteral(source);
            return utils.IsSpecified(found) ? found : new Tab(source, TabType.Normal);
        };
        TabCollection.prototype.GetNonLiteral = function (source) {
            var id = Tab.Id(source);
            var index = this.NonLiteralTabIds.indexOf(id);
            if (id < 0)
                return;
            return this.NonLiteralTabs[id];
        };
        TabCollection.prototype.GetIndexOf = function (source) {
            var index = this.NonLiteralTabIds.indexOf(Tab.Id(source));
            if (index < 0)
                return void null;
            return index;
        };
        Object.defineProperty(TabCollection.prototype, "PlaceholderTabCount", {
            get: function () {
                return !this.getShowPlaceholderTab ? 0 : (this.getShowPlaceholderTab() ? 1 : 0);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TabCollection.prototype, "LiteralTabs", {
            get: function () {
                if (!this.getLiteralTabs)
                    return [];
                return this.getLiteralTabs() || [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TabCollection.prototype, "IndexOffset", {
            get: function () {
                return this.PlaceholderTabCount + this.LiteralTabs.length;
            },
            enumerable: true,
            configurable: true
        });
        TabCollection.EmptyPlaceholderTabs = Object.freeze([]);
        TabCollection.FilledPlaceholderTabs = Object.freeze([null]);
        return TabCollection;
    }());
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.TabType = TabType;
            _this.ExtendAttrs = { "{[layout-fill]}": "", };
            _this.DisplaySimTab = true;
            _this.DisplayAlertIcon = false;
            _this.ShowSIMReplacement = false;
            _this.tabCollection = new TabCollection(function () { return _this.ShowPlaceholderTab; }, function () { return _this.LiteralTabs; });
            _this.SelectedIndex = 0;
            _this.MdTabsId = exports.Name + "_md-tabs_" + ++Controller_22.LastMdTabsId;
            _this.Watch(function () { return _this.HasTabs; }, function (hasTabs) {
                if (!hasTabs)
                    _this.ShowPlaceholderTab = true;
                else if (_this.AutoClosePlaceholderTab)
                    _this.ShowPlaceholderTab = false;
                _this.CanClosePlaceholderTab = hasTabs;
            });
            _this.Watch.Collection(function () { return _this.Normal; }, function () { return _this.RebuildTabs(); });
            _this.Watch.Collection(function () { return ({
                LiteralCount: !_this.LiteralTabs ? 0 : _this.LiteralTabs.length,
                Offset: _this.tabCollection.IndexOffset
            }); }, function ($new, $old) {
                if (_this.SelectedIndex > $new.Offset)
                    _this.SelectedIndex += $new.LiteralCount - $old.LiteralCount;
            });
            _this.Watch.Collection(function () { return _this.Preview; }, function ($new, $old) {
                if (utils.IsSpecified($old)) {
                    var oldPreview = _this.tabCollection.GetNonLiteral($old);
                    if (utils.IsSpecified(oldPreview) && oldPreview.QuitProtectionHandler && oldPreview.QuitProtectionHandler.ProtectionRequested) {
                        _this.Normal.unshift($old);
                        return;
                    }
                }
                var collection = _this.RebuildTabs();
            });
            _this.Watch.Collection(function () { return _this.Pinned; }, function () { return _this.RebuildTabs(); });
            if (!utils.IsVoid(_this.Attributes["selectedTab"]))
                _this.EnsureSelectedTabWatches();
            var handler = function (eventObj) { return _this.EnsureTabLoadedAndDigest(Controller_22.GetTab(eventObj.target, "md-tabs#" + _this.MdTabsId)); };
            var selector = "md-tabs#" + _this.MdTabsId + " > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item";
            var events = "mouseenter focusin touchstart mousedown";
            _this.Element.on(events, selector, handler);
            _this.OnDispose(function () { return _this.Element.off(events, selector, handler); });
            ng_utils_25.$rootScope.$on('display-sim-replacement-tab-' + _this.ServiceNumber.Id, function (event, data) {
                _this.DisplaySimTab = data.IsEligibleForReplacement;
                _this.DisplayAlertIcon = !data.IsSIMReplacementRequested;
            });
            _this.ShowSIMReplacement = ng_utils_25.$cookies.get("DisplaySIMReplacement") === "True";
            return _this;
        }
        Controller_22 = Controller;
        Object.defineProperty(Controller.prototype, "Classes", {
            get: function () {
                return !this.Preview ? this.BoundClasses : "has-preview-tab " + this.BoundClasses;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "boundPinned", {
            get: function () {
                return this._pinned;
            },
            set: function (value) {
                this._pinned = value;
                if (utils.IsSpecified(value))
                    this.Pinned = value;
                else
                    this.Pinned = [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "selectedTab", {
            set: function (selectedTab) {
                if (utils.IsVoid(selectedTab))
                    this.SelectedTab = null;
                else if (selectedTab instanceof Tab)
                    this.SelectedTab = selectedTab.Underlying;
                else
                    this.SelectedTab = selectedTab.Underlying;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "boundNormal", {
            get: function () {
                return this._normal;
            },
            set: function (value) {
                this._normal = value;
                if (utils.IsSpecified(value))
                    this.Normal = value;
                else
                    this.Normal = [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Tabs", {
            get: function () {
                return this.tabCollection.NonLiteralTabs;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ShowPlaceholderTab", {
            get: function () {
                return !!this.PlaceholderTabAlwaysOpen || this._showPlaceholderTab;
            },
            set: function (value) {
                this._showPlaceholderTab = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CanClosePlaceholderTab", {
            get: function () {
                return !this.PlaceholderTabAlwaysOpen && this._canClosePlaceholderTab;
            },
            set: function (value) {
                this._canClosePlaceholderTab = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.OnTabSelect = function (tab) {
            tab.EnsureRenderContents();
            if (tab.IsSettingTab) {
                var name_9 = this.ServiceNumber + "_SettingTab";
                window.sessionStorage.setItem(name_9, "1");
            }
        };
        Controller.prototype.OnTabDeSelect = function () {
            var name = this.ServiceNumber + "_SettingTab";
            window.sessionStorage.removeItem(name);
        };
        Object.defineProperty(Controller.prototype, "HasTabs", {
            get: function () {
                return (this.Tabs && this.Tabs.length > 0) || (this.LiteralTabs && this.LiteralTabs.length > 0) || false;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.CloseTab = function (event, tab) {
            var _this = this;
            if (!tab || !tab.CanClose)
                return;
            quitProtection.Confirm(tab.QuitProtectionHandler, event, {
                ActionWithSubMessages: "Closing the tab \"" + tab.Title + "\" will cause you to lose the following unsaved changes:",
                ActionWithoutSubMessages: "Closing the tab \"" + tab.Title + "\" will cause you to lose unsaved changes.",
                Okay: "Close Tab",
            }).then(function () {
                switch (tab.Type) {
                    case TabType.Normal:
                        {
                            var index = utils.Collection.IndexOf(_this.Normal, tab.IdEquals);
                            if (index >= 0)
                                _this.Normal.splice(index, 1);
                        }
                        break;
                    case TabType.Preview:
                        {
                            if (tab.Id === Tab.Id(_this.Preview))
                                _this.Preview = null;
                        }
                        break;
                    case TabType.Pinned:
                        {
                            var index = utils.Collection.IndexOf(_this.Pinned, tab.IdEquals);
                            if (index >= 0)
                                _this.Pinned.splice(index, 1);
                        }
                        break;
                }
            });
        };
        Controller.prototype.CommitPreviewTab = function (tab) {
            if (!utils.IsSpecified(tab))
                return;
            if (!tab.IsPreview)
                return;
            this.Normal.unshift(tab.Underlying);
            this.Preview = null;
        };
        Controller.prototype.PinTab = function (tab) {
            if (!utils.IsSpecified(tab))
                return;
            else {
                switch (tab.Type) {
                    case TabType.Pinned:
                        return;
                    case TabType.Normal:
                        var index = utils.Collection.IndexOf(this.Normal, tab.IdEquals);
                        if (index >= 0)
                            this.Normal.splice(index, 1);
                        break;
                    case TabType.Preview:
                        if (tab.IdEquals(this.Preview))
                            this.Preview = null;
                        break;
                }
                this.Pinned.push(tab.Underlying);
            }
        };
        Controller.prototype.ClosePlaceholderTab = function () {
            this.ShowPlaceholderTab = false;
        };
        Controller.prototype.RebuildTabs = function (ensureSelectedIsRendered) {
            var _this = this;
            if (ensureSelectedIsRendered === void 0) { ensureSelectedIsRendered = true; }
            var Preview = this.Preview;
            this.tabCollection = new TabCollection(function () { return _this.ShowPlaceholderTab; }, function () { return _this.LiteralTabs; }, __spread(this.Pinned.map(function (t) { return _this.tabCollection.GetOrCreateNonLiteral(t).CloneWithType(TabType.Pinned); }), (utils.IsSpecified(Preview) ? [this.tabCollection.GetOrCreateNonLiteral(Preview).CloneWithType(TabType.Preview)] : []), this.Normal.map(function (t) { return _this.tabCollection.GetOrCreateNonLiteral(t).CloneWithType(TabType.Normal); })));
            if (ensureSelectedIsRendered) {
                var selectedTab = this.tabCollection.AllTabs[this.SelectedIndex];
                if (selectedTab && selectedTab instanceof Tab)
                    selectedTab.EnsureRenderContents();
            }
            return this.tabCollection;
        };
        Controller.prototype.ApplySelectedTabToIndex = function (selectedTab) {
            if (!this.tabCollection)
                return;
            var AllTabs = this.tabCollection.AllTabs;
            if (!AllTabs.length)
                return;
            var newSelectedIndex = utils.Collection.IndexOf(AllTabs, function (t) {
                if (utils.IsVoid(t))
                    return false;
                else if (t instanceof Tab)
                    return t.Underlying === selectedTab;
                else
                    return t.Underlying === selectedTab;
            });
            if (newSelectedIndex < 0) {
                this.selectedTab = AllTabs[this.SelectedIndex];
                return;
            }
            this.SelectedIndex = newSelectedIndex;
        };
        Controller.prototype.ApplySelectedIndexToSelectedTab = function (index, tabCollection) {
            if (index === void 0) { index = this.SelectedIndex; }
            if (tabCollection === void 0) { tabCollection = this.tabCollection; }
            if (!tabCollection)
                return;
            var AllTabs = tabCollection.AllTabs;
            if (!AllTabs.length)
                return;
            var selectedTab = utils.AsOptional(AllTabs[index]);
            if (index >= AllTabs.length) {
                return;
            }
            this.selectedTab = selectedTab;
        };
        Controller.GetTab = function (element, rootSelector) {
            if (!element)
                return null;
            var target = $(element).closest("md-tab-item, " + rootSelector);
            if (target.is(rootSelector))
                return null;
            var children = $(target).children(":not(.md-ripple-container)");
            if (children.length < 1)
                return null;
            var scope = children.scope();
            if (!scope)
                return null;
            var tab = scope.tab;
            if (!tab || !(tab instanceof Tab))
                return null;
            return tab;
        };
        Controller.prototype.EnsureTabLoadedAndDigest = function (tab) {
            if (utils.IsVoid(tab))
                return;
            if (tab.RenderContents)
                return;
            tab.EnsureRenderContents();
            this.Scope.$applyAsync();
        };
        Controller.prototype.DeferredSync = function (direction, action) {
            action();
        };
        Controller.prototype.EnsureSelectedTabWatches = function () {
            var _this = this;
            this.Watch.Collection(function () { return _this.tabCollection.LiteralTabs; }, function () { return _this.DeferredSync(SyncDirection.Out, function () { return _this.ApplySelectedIndexToSelectedTab(); }); });
            this.Watch.Group({
                SelectedIndex: function () { return _this.SelectedIndex; },
                tabCollection: function () { return _this.tabCollection; },
            }, function ($new) { return _this.DeferredSync(SyncDirection.Out, function () { return _this.ApplySelectedIndexToSelectedTab($new.SelectedIndex, $new.tabCollection); }); });
            this.Watch(function () { return _this.SelectedTab; }, function (selectedTab) { return _this.DeferredSync(SyncDirection.In, function () { return _this.ApplySelectedTabToIndex(selectedTab); }); });
            this.EnsureSelectedTabWatches = function () { };
        };
        Controller.LastMdTabsId = 0;
        __decorate([
            utils.Bind.Literal("class")
        ], Controller.prototype, "BoundClasses", void 0);
        __decorate([
            utils.Bind.Literal("md-dynamic-height"),
            utils.Bind.DefaultValue(false)
        ], Controller.prototype, "MdDynamicHeight", void 0);
        __decorate([
            utils.Bind.TwoWay("preview-tab", { optional: true })
        ], Controller.prototype, "Preview", void 0);
        __decorate([
            utils.Bind.TwoWay("pinned-tabs", { optional: true }),
            utils.Bind.DefaultValue([])
        ], Controller.prototype, "boundPinned", null);
        __decorate([
            utils.Bind.TwoWay("selected-tab", { optional: true })
        ], Controller.prototype, "SelectedTab", void 0);
        __decorate([
            utils.Bind.TwoWay("activatetab", { optional: true })
        ], Controller.prototype, "ChangeIndex", void 0);
        __decorate([
            utils.Bind.In("current-service", { optional: true })
        ], Controller.prototype, "ServiceNumber", void 0);
        __decorate([
            utils.Bind.TwoWay("tabs", { optional: true }),
            utils.Bind.DefaultValue([])
        ], Controller.prototype, "boundNormal", null);
        __decorate([
            utils.Bind.TwoWay("default-tab-label", { optional: true }),
            utils.Bind.DefaultValue("No Tabs")
        ], Controller.prototype, "PlaceholderTabLabel", void 0);
        __decorate([
            utils.Bind.TwoWay("default-tab-always-open", { optional: true })
        ], Controller.prototype, "PlaceholderTabAlwaysOpen", void 0);
        __decorate([
            utils.Bind.TwoWay("auto-close-default-tab", { optional: true }),
            utils.Bind.DefaultValue(true)
        ], Controller.prototype, "AutoClosePlaceholderTab", void 0);
        Controller = Controller_22 = __decorate([
            utils.Component({
                Name: "sdc-tabbed-components",
                Transclude: utils.TransclusionMode.Contents
            })
        ], Controller);
        return Controller;
        var Controller_22;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/theme/url/sdc-theme-url-service", ["require", "exports", "app/sdc/theme/url/sdc-theme-url"], function (require, exports, sdc_theme_url_1) {
    "use strict";
    function urlForSite(siteName, subPath) {
        return sdc_theme_url_1.Get(subPath, siteName);
    }
    sdcContentUrlService["forSite"] = function (siteName, subPath) { return sdc_theme_url_1.Get(subPath, siteName); };
    function sdcContentUrlService(subPath) {
        return sdc_theme_url_1.Get(subPath);
    }
    return sdcContentUrlService;
});
define("app/sdc/tile/accent/sdc-tile-accent-service", ["require", "exports", "app/sdc/tile/accent"], function (require, exports, accent_1) {
    "use strict";
    return accent_1.GetRandomAccentFor;
});
define("app/sdc/title/controller/sdc-title-controller", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_26) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_26.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch(function () { return _this.FormatTitle(_this.Title); }, function (newDisplayTitle) { return _this.displayTitle = newDisplayTitle; });
            return _this;
        }
        Controller.prototype.FormatTitle = function (title) {
            if (utils.IsVoid(this.BoundFormatTitle))
                return title;
            return this.BoundFormatTitle({ $title: title });
        };
        Object.defineProperty(Controller.prototype, "title", {
            get: function () {
                return this.Title;
            },
            set: function (value) {
                this.Title = value;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Getter(name, { optional: true })
        ], Controller.prototype, "BoundFormatTitle", void 0);
        Controller = __decorate([
            utils.Component({
                Name: name,
                Restrict: utils.Target.Attribute | utils.Target.Element,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sdc/toggle/body/sdc-toggle-body", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.Directive({
        Name: "sdc-toggle-body",
        Terminal: true,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
    });
});
define("app/sdc/toggle/label/sdc-toggle-label", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.Directive({
        Name: "sdc-toggle-label",
        Terminal: true,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
    });
});
define("app/sdc/transclude/fn/sdc-transclude-fn", ["require", "exports", "$animate", "$compile", "app/utils"], function (require, exports, $animate, $compile, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.FallbackLinkFn = $compile(_this.Element.contents());
            _this.Element.empty();
            return _this;
        }
        Controller_23 = Controller;
        Controller.prototype.TranscludeContents = function (cloneAttachFn) {
            var _this = this;
            var transcludeFn = this.BoundTranscludeFn;
            if (!transcludeFn) {
                this.UseFallbackContent();
                return;
            }
            transcludeFn(function (clone, scope) { return _this.RenderTranscludedContents(clone, scope); }, null);
        };
        Controller.prototype.Init = function () {
            var _this = this;
            this.TranscludeContents(function (clone, scope) { return _this.RenderContents(clone, scope); });
        };
        Controller.prototype.RenderTranscludedContents = function (clone, scope) {
            if (!utils.IsWhitespace(clone))
                this.RenderContents(clone, scope);
            else {
                this.UseFallbackContent();
                scope.$destroy();
            }
        };
        Controller.prototype.ApplyTranscludeWatch = function (clone, scope) {
            return this.TranscludeWatch({ transcludedScope: scope, element: clone, parent: this.Element });
        };
        Controller.prototype.RenderContents = function (clone, scope) {
            var _this = this;
            this.ApplyTranscludeWatch(clone, scope);
            scope.$watch(function () { return _this.ApplyTranscludeWatch(clone, scope); });
            this.OnTransclude({
                transcludedScope: scope,
                scope: scope,
                element: clone,
                parent: this.Element,
                animation: this.IsComment ? $animate.enter(clone, this.Element.parent(), this.Element) : $animate.enter(clone, this.Element),
            });
        };
        Controller.prototype.UseFallbackContent = function () {
            var _this = this;
            this.FallbackLinkFn(this.Scope, function (clone, scope) { return _this.RenderContents(clone, scope); });
        };
        Object.defineProperty(Controller.prototype, "IsComment", {
            get: function () {
                return this.Element[0].nodeType === 8;
            },
            enumerable: true,
            configurable: true
        });
        Controller.Name = "sdc-transclude-fn";
        __decorate([
            utils.Bind.Getter("on-transclude")
        ], Controller.prototype, "OnTransclude", void 0);
        __decorate([
            utils.Bind.Getter("transclude-watch")
        ], Controller.prototype, "TranscludeWatch", void 0);
        __decorate([
            utils.Bind.In(Controller_23.Name)
        ], Controller.prototype, "BoundTranscludeFn", void 0);
        __decorate([
            utils.OnLink(utils.LinkMode.Post)
        ], Controller.prototype, "Init", null);
        Controller = Controller_23 = __decorate([
            utils.Component({
                Name: Controller_23.Name,
                Terminal: true,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
                Restrict: utils.Target.Attribute | utils.Target.Comment,
            })
        ], Controller);
        return Controller;
        var Controller_23;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sdc/transclude/for/sdc-transclude-for", ["require", "exports", "app/utils", "$parse", "$animate"], function (require, exports, utils, $parse, $animate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.RemovePrevious = function () { };
            var expr = _this.AttrDefinedExpr || _this.ElementDefinedExpr;
            var _a = Controller_24.ParseExpression(expr, _this.Scope), getter = _a.getter, setter = _a.setter;
            var transclude = utils.AssertNotVoid(_this.Transclude);
            _this.Watch(getter, function (value) {
                _this.RemovePrevious();
                transclude(function (clone, scope) {
                    setter(scope, value);
                    clone[clone.length++] = document.createComment(" end sdcTranscludeFor: " + expr + " ");
                    $animate.enter(clone, _this.Element.parent(), _this.Element);
                    var remover = _this.RemovePrevious = function () {
                        if (_this.RemovePrevious === remover)
                            _this.RemovePrevious = function () { };
                        scope.$destroy();
                        var elements = clone.getBlockNodes();
                        $animate.leave(elements).then(function () { return elements.remove(); });
                    };
                });
            });
            return _this;
        }
        Controller_24 = Controller;
        Controller.ParseExpression = function (expr, scope) {
            var _a = __read(expr.split(/\s+as\s+/), 3), asExpr = _a[0], valueExpr = _a[1], tooManyParts = _a[2];
            if (!valueExpr) {
                valueExpr = asExpr;
                asExpr = "";
            }
            if (!utils.IsVoid(tooManyParts) || !valueExpr)
                throw new Error("Invalid expression " + expr);
            var parsedValueExpr = $parse(valueExpr);
            var parsedAsExprAssigner = $parse(asExpr).assign;
            return {
                getter: function () { return parsedValueExpr(scope.$parent); },
                setter: function (targetScope, value) { parsedAsExprAssigner && parsedAsExprAssigner(targetScope, value); }
            };
        };
        Controller.Name = "sdc-transclude-for";
        Controller.Priority = 1300;
        __decorate([
            utils.Bind.Literal(Controller_24.Name)
        ], Controller.prototype, "AttrDefinedExpr", void 0);
        __decorate([
            utils.Bind.Literal("for")
        ], Controller.prototype, "ElementDefinedExpr", void 0);
        Controller = Controller_24 = __decorate([
            utils.Component({
                Name: Controller_24.Name,
                Restrict: utils.Target.ElementOrAttribute,
                Scope: new utils.IsolateScope(),
                Template: null,
                Priority: Controller_24.Priority,
                Transclude: utils.TransclusionMode.Element,
            })
        ], Controller);
        return Controller;
        var Controller_24;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/transclude/here/sdc-transclude-here", ["require", "exports", "app/utils", "$animate"], function (require, exports, utils, $animate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-transclude-here";
    var Controller = (function () {
        function Controller($watch, $element) {
            var _this = this;
            var element = $element[0];
            var removePrevious = angular.noop;
            $watch(function () { return _this.TranscludeFn; }, function (transcludeFn) {
                removePrevious();
                removePrevious = angular.noop;
                if (!transcludeFn)
                    return;
                transcludeFn(function (clone) {
                    if (!clone.length)
                        return;
                    if (element.nodeType !== 8)
                        $animate.enter(clone, $element);
                    else
                        $animate.enter(clone, $element.parent(), $element);
                    removePrevious = function () { return $animate.leave(clone); };
                });
            });
        }
        __decorate([
            utils.Bind.TwoWay(exports.Name)
        ], Controller.prototype, "TranscludeFn", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Restrict: utils.Target.Attribute | utils.Target.Comment,
                Template: null,
            }),
            __param(0, utils.Inject("$watch")), __param(1, utils.Inject("$element"))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sds/account/alert/sds-account-alert", ["require", "exports", "app/utils", "app/selcomm/service", "app/selcomm/service", "app/sds/contact/sds-contact", "app/sss/sites", "module", "app/ng-utils", "app/sdc/closable/section/sdc-closable-section"], function (require, exports, utils, service_20, SelcommWS, selectedContact, sites, module_27, ng_utils_26, closableSection) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_27.id);
    var SpendAlertState = (function () {
        function SpendAlertState(TargetSpendAlert) {
            this.Initial = Object.freeze(utils.DeepCopy(TargetSpendAlert));
            this.NewValue = utils.DeepCopy(TargetSpendAlert);
        }
        SpendAlertState.prototype.Reset = function () {
            this.NewValue = utils.DeepCopy(this.Initial);
        };
        SpendAlertState.prototype.Saved = function () {
            this.Initial = utils.DeepCopy(this.NewValue);
        };
        return SpendAlertState;
    }());
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.SpendAlertsLoader = new utils.Loader(function () { return Controller_25.GetSpendAlert(); });
            _this.SpendAlertsLoader.Load();
            return _this;
        }
        Controller_25 = Controller;
        Controller.GetSpendAlert = function () {
            return __awaiter(this, void 0, void 0, function () {
                var loadedSpendAlert;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_20.Service.Alert.SpendAlert({
                                ContactCode: SelcommWS.Authentication.CurrentSession.UserCode,
                                ServiceRef: 0,
                            })];
                        case 1:
                            loadedSpendAlert = _a.sent();
                            if (loadedSpendAlert.AlertEnabled && !loadedSpendAlert.SendSMS && !loadedSpendAlert.SendEmail)
                                loadedSpendAlert.AlertEnabled = false;
                            return [2, new SpendAlertState(loadedSpendAlert)];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "SpendAlertsState", {
            get: function () {
                return this.SpendAlertsLoader.Value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "SpendAlert", {
            get: function () {
                return this.SpendAlertsState && this.SpendAlertsState.NewValue;
            },
            set: function (value) {
                if (!this.SpendAlertsLoader.Value) {
                    throw Error("Not ready yet!");
                }
                this.SpendAlertsLoader.Value.NewValue = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "SpendAlertOG", {
            get: function () {
                return this.SpendAlertsState && this.SpendAlertsState.Initial;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SpendAlertStateCompare = function () {
            if (angular.equals(this.SpendAlert, this.SpendAlertOG))
                return true;
            else
                return false;
        };
        Controller.prototype.close = function () {
            if (this.ClosableSection)
                this.ClosableSection.Close();
            this.SpendAlertsState && this.SpendAlertsState.Reset();
        };
        Controller.prototype.saveSpendAlert = function (event) {
            return __awaiter(this, void 0, ng_utils_26.$q, function () {
                var _this = this;
                var title, content, confirm_1, result, _a, err_24, reason_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!this.SpendAlert.AlertEnabled) return [3, 8];
                            title = "IMPORTANT";
                            content = "Disabling spend alerts means you will no longer receive any usage notifications on all services connected to this account.";
                            if (sites.Service.Current.Name == "thinkmobile") {
                                content = "Disabling spend alerts means you will no longer receive any usage notifications on all services connected to this account. Please consider this carefully as you remain liable for any usage exceeding the data allocation in your plan or additional costs incurred. Contact Customer Care for further advice.";
                            }
                            confirm_1 = ng_utils_26.$mdDialog.confirm()
                                .targetEvent(event)
                                .title(title)
                                .textContent(content)
                                .ok('I understand')
                                .cancel('Cancel');
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 7, , 8]);
                            return [4, ng_utils_26.$mdDialog
                                    .show(confirm_1)
                                    .then(function () { return true; }, function () { return false; })];
                        case 2:
                            result = _b.sent();
                            if (!!result) return [3, 3];
                            this.callReset();
                            return [2];
                        case 3:
                            _b.trys.push([3, 5, , 6]);
                            _a = this;
                            return [4, service_20.Service.Alert.SpendAlertUpdate({
                                    spendAlert: this.SpendAlert
                                })];
                        case 4:
                            _a.savingSpendAlerts = _b.sent();
                            this.OnSaveSuccess();
                            return [3, 6];
                        case 5:
                            err_24 = _b.sent();
                            this.OnSaveFail();
                            throw err_24;
                        case 6: return [3, 8];
                        case 7:
                            reason_1 = _b.sent();
                            throw reason_1;
                        case 8:
                            this.savingSpendAlerts = service_20.Service.Alert.SpendAlertUpdate({
                                spendAlert: this.SpendAlert
                            }).then(function () { return _this.OnSaveSuccess(); }, function () { return _this.OnSaveFail(); });
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.callReset = function () {
            this.SpendAlertsLoader.Load();
        };
        Controller.prototype.OnSaveSuccess = function () {
            utils.Toast.Simple(" Spend Alert Successfully Updated.");
            if (this.ClosableSection)
                this.ClosableSection.Close();
            this.SpendAlertsState && this.SpendAlertsState.Saved();
        };
        Controller.prototype.OnSaveFail = function () {
            utils.Toast.Simple("  Save Failed, Please Try Again.");
        };
        Controller.prototype.AllowSpendAlertUpdate = function () {
            if (angular.equals(this.SpendAlert, this.SpendAlertOG))
                return true;
            else
                return false;
        };
        Controller.prototype.AccountAlertStatus = function () {
            return __awaiter(this, void 0, ng_utils_26.$q, function () {
                return __generator(this, function (_a) {
                    if (!this.SpendAlert.AlertEnabled) {
                        this.AlertsEnabled = false;
                    }
                    else
                        this.AlertsEnabled = true;
                    return [2];
                });
            });
        };
        Controller.prototype.SMSAlertStatus = function () {
            return __awaiter(this, void 0, ng_utils_26.$q, function () {
                return __generator(this, function (_a) {
                    if (!this.SpendAlert.SendSMS)
                        this.SmsAlert = false;
                    else
                        this.SmsAlert = true;
                    return [2];
                });
            });
        };
        Controller.prototype.EmailAlertStatus = function () {
            return __awaiter(this, void 0, ng_utils_26.$q, function () {
                return __generator(this, function (_a) {
                    if (!this.SpendAlert.SendEmail)
                        this.EmailAlert = false;
                    else
                        this.EmailAlert = true;
                    return [2];
                });
            });
        };
        Object.defineProperty(Controller.prototype, "AlertsEnabled", {
            get: function () {
                return this.SpendAlert.AlertEnabled;
            },
            set: function (value) {
                if (!value) {
                    this.SpendAlert.AlertEnabled = false;
                    this.SpendAlert.SendSMS = false;
                    this.SpendAlert.SendEmail = false;
                }
                else {
                    this.SpendAlert.AlertEnabled = true;
                    this.SpendAlert.SendSMS = true;
                    this.SpendAlert.SendEmail = true;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "SmsAlert", {
            get: function () {
                return this.SpendAlert.AlertEnabled && this.SpendAlert.SendSMS;
            },
            set: function (value) {
                if (!value) {
                    this.SpendAlert.SendSMS = false;
                    if (!this.SpendAlert.SendEmail)
                        this.SpendAlert.AlertEnabled = false;
                }
                else
                    this.SpendAlert.AlertEnabled = true;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "EmailAlert", {
            get: function () {
                return this.SpendAlert.AlertEnabled && this.SpendAlert.SendEmail;
            },
            set: function (value) {
                if (!value) {
                    this.SpendAlert.SendEmail = false;
                    if (!this.SpendAlert.SendSMS)
                        this.SpendAlert.AlertEnabled = false;
                }
                else
                    this.SpendAlert.AlertEnabled = true;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents })
        ], Controller.prototype, "SelectedContact", void 0);
        __decorate([
            utils.Bind.Controller(closableSection.Controller, { optional: true, mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "ClosableSection", void 0);
        Controller = Controller_25 = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
        var Controller_25;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/address/input/sds-address-input", ["require", "exports", "app/utils", "app/ng-utils", "module", "app/sds/address/utils", "app/selcomm/service"], function (require, exports, utils, ng_utils_27, module_28, addressUtils, service_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.PostalCode = "";
            _this.Localities = new Array();
            _this.StreetTypes = new Array();
            _this.States = new Array();
            _this.UpdateLocalitiesActivity = new utils.ActivityController("UpdateLocalities");
            _this.UpdateStatesActivity = new utils.ActivityController("UpdateStates");
            _this.LoadStreetTypesActivity = new utils.ActivityController();
            var cachedLocality, cachedState;
            _this.Attributes.$set("tabindex", "-1");
            _this.Watch(function () { return _this.PostalCode; }, function (postalCode) { return _this.UpdateLocalities(postalCode); });
            _this.Watch.Group({
                postalCode: function () { return _this.PostalCode; },
                locality: function () { return _this.Locality && _this.Locality.Name; },
            }, function (values) { return _this.UpdateStates(values.postalCode, values.locality); });
            _this.LoadStreetTypes();
            return _this;
        }
        Object.defineProperty(Controller.prototype, "Required", {
            get: function () {
                return ng_utils_27.$mdUtil.parseAttributeBoolean(this.BoundRequired);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.UpdateLocalities = function (postalCode) {
            return __awaiter(this, void 0, ng_utils_27.$q, function () {
                var token, localities, lastLocality_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.Locality) {
                                this.LastLocality = this.Locality;
                                this.Locality = null;
                            }
                            token = this.UpdateLocalitiesActivity.CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4, addressUtils.GetLocalities(postalCode)];
                        case 2:
                            localities = _a.sent();
                            if (token.HasExited)
                                return [2];
                            this.Localities = localities;
                            return [3, 4];
                        case 3:
                            if (token.HasExited)
                                return [2];
                            token.Exit();
                            lastLocality_1 = this.LastLocality;
                            this.LastLocality = null;
                            switch (this.Localities.length) {
                                case 1:
                                    this.Locality = this.Localities[0];
                                    break;
                                case 0:
                                    this.Locality = null;
                                    break;
                                default:
                                    if (!lastLocality_1)
                                        return [2];
                                    this.Locality = utils.Collection.FirstOrDefault(this.Localities, function (l) { return l.Name === lastLocality_1.Name; });
                            }
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.UpdateStates = function (postalCode, localityName) {
            return __awaiter(this, void 0, ng_utils_27.$q, function () {
                var token, states, lastState_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.State) {
                                this.LastState = this.State;
                                this.State = null;
                            }
                            token = this.UpdateStatesActivity.CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4, addressUtils.GetStates(postalCode, localityName)];
                        case 2:
                            states = _a.sent();
                            if (token.HasExited)
                                return [2];
                            this.States = states;
                            return [3, 4];
                        case 3:
                            if (token.HasExited)
                                return [2];
                            token.Exit();
                            lastState_1 = this.LastState;
                            this.LastState = null;
                            switch (this.States.length) {
                                case 1:
                                    this.State = this.States[0];
                                    break;
                                case 0:
                                    this.State = null;
                                    break;
                                default:
                                    if (!lastState_1)
                                        return [2];
                                    this.State = utils.Collection.FirstOrDefault(this.States, function (s) { return s.Name === lastState_1.Name; });
                            }
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.LoadStreetTypes = function () {
            return __awaiter(this, void 0, ng_utils_27.$q, function () {
                var token, streetTypes;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.LoadStreetTypesActivity.CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4, addressUtils.GetStreetTypes()];
                        case 2:
                            streetTypes = _a.sent();
                            if (token.HasExited)
                                return [2];
                            this.StreetTypes = streetTypes;
                            return [3, 4];
                        case 3:
                            token.Exit();
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.OnLink = function () {
            this.BindToNgModel();
        };
        Controller.prototype.BindToNgModel = function (ngModelCtrl) {
            var _this = this;
            if (ngModelCtrl === void 0) { ngModelCtrl = this.NgModel; }
            if (!ngModelCtrl)
                return;
            ngModelCtrl.$render = function () { return _this.RenderFrom(ngModelCtrl); };
            this.Watch.Deep(function () { return _this.GetAddressIfSpecified(); }, function (address, lastAddress) { return address !== lastAddress && _this.updateViewValue(ngModelCtrl, address); });
        };
        Controller.prototype.GetAddressIfSpecified = function () {
            var dynamicValues = {
                UnitType: this.UnitType,
                UnitNumber: this.UnitNumber,
                StreetNumber: this.StreetNumber,
                StreetName: this.StreetName,
                StreetType: !this.StreetType ? null : this.StreetType.Code,
                PostalCodeCode: this.PostalCode,
                Locality: !this.Locality ? null : this.Locality.Name,
                Suburb: !this.Locality ? null : this.Locality.Name,
                StateCode: !this.State ? null : this.State.Code,
            };
            if (utils.Collection.All(Object.values(dynamicValues), function (v) { return utils.IsVoid(v) || (utils.IsString(v) && utils.IsWhitespace(v)); }))
                return null;
            return new service_21.Selcomm.Address.ExtendedAddress(__assign({}, dynamicValues, { PostCode: !dynamicValues.PostalCodeCode ? null : new service_21.Selcomm.Address.PostCode({ Code: dynamicValues.PostalCodeCode, }), State: !dynamicValues.StateCode ? null : new service_21.Selcomm.Address.State({ Code: dynamicValues.StateCode, }), Country: new service_21.Selcomm.Address.Country({ Code: "AU", }) }));
        };
        Controller.prototype.RenderFrom = function (ngModelCtrl) {
            var addr = ngModelCtrl.$viewValue;
            if (!addr)
                return;
            this.UnitType = addr.UnitType || "";
            this.UnitNumber = addr.UnitNumber || "";
            this.StreetNumber = addr.StreetNumber || "";
            this.StreetName = addr.StreetName || "";
            this.StreetType = !utils.IsNotNullOrWhitespace(addr.StreetType) ? null : new service_21.Selcomm.Address.StreetType({ Code: addr.StreetType, });
            if (!addr.PostCode || !utils.IsNotNullOrWhitespace(addr.PostCode.Code)) {
                this.PostalCode = "";
                this.Locality = null;
                this.State = null;
                return;
            }
            this.PostalCode = addr.PostCode.Code;
            if (!utils.IsNotNullOrWhitespace(addr.Locality)) {
                this.Locality = null;
                this.State = null;
                return;
            }
            this.Locality = new addressUtils.Locality(addr.Locality, addr.PostCode.Code);
            if (!utils.IsNotNullOrWhitespace(addr.StateCode)) {
                this.State = null;
                return;
            }
            this.State = new service_21.Selcomm.Address.State({ Code: addr.StateCode });
        };
        Controller.prototype.RenderAddress = function (addr) {
            if (!addr) {
                return this.ResetForm();
            }
            this.UnitType = addr.UnitType || "";
            this.UnitNumber = addr.UnitNumber || "";
            this.StreetNumber = addr.StreetNumber || "";
            this.StreetName = addr.StreetName || "";
            this.StreetType = !utils.IsNotNullOrWhitespace(addr.StreetType) ? null : new service_21.Selcomm.Address.StreetType({ Code: addr.StreetType, });
            if (!addr.PostCode || !utils.IsNotNullOrWhitespace(addr.PostCode.Code)) {
                this.PostalCode = "";
                this.Locality = null;
                this.State = null;
                return;
            }
            this.PostalCode = addr.PostCode.Code;
            if (!utils.IsNotNullOrWhitespace(addr.Locality)) {
                this.Locality = null;
                this.State = null;
                return;
            }
            this.Locality = new addressUtils.Locality(addr.Locality, addr.PostCode.Code);
            if (!utils.IsNotNullOrWhitespace(addr.StateCode)) {
                this.State = null;
                return;
            }
            this.State = new service_21.Selcomm.Address.State({ Code: addr.StateCode });
        };
        Controller.prototype.ResetForm = function () {
            this.UnitType = "";
            this.UnitNumber = "";
            this.StreetNumber = "";
            this.StreetName = "";
            this.StreetType = null;
            this.PostalCode = "";
            this.Locality = null;
            this.State = null;
        };
        Controller.prototype.updateViewValue = function (ngModelCtrl, newAddress) {
            ngModelCtrl.$setViewValue(newAddress, "default");
        };
        __decorate([
            utils.Bind.Controller("ng-model", { optional: true })
        ], Controller.prototype, "NgModel", void 0);
        __decorate([
            utils.Bind.Literal("form-layout"),
            utils.Bind.DefaultValue("gt-md")
        ], Controller.prototype, "Layout", void 0);
        __decorate([
            utils.Bind.Literal("required", { optional: true })
        ], Controller.prototype, "BoundRequired", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "OnLink", null);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_28.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/address/pobox/sds-address-pobox", ["require", "exports", "app/utils", "module", "app/sds/address/utils", "app/sds/address/utils", "app/sds/contact/address/utils"], function (require, exports, utils, module_29, addressUtils, utils_3, utils_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_29.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller_26 = Controller;
        Object.defineProperty(Controller.prototype, "Mode", {
            get: function () {
                return this.BoundMode || Mode.Require;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.AttachValidator = function (ngModelCtrl) {
            var _this = this;
            if (ngModelCtrl === void 0) { ngModelCtrl = this.NgModelCtrl; }
            var modes = [Mode.Reject, Mode.Require];
            var validators = new Map(modes
                .map(function (mode) { return [
                Name + "-" + mode,
                function (modelValue, viewValue) { return _this.Mode !== mode || Controller_26.ValidateNgModel(mode, ngModelCtrl, modelValue, viewValue); }
            ]; }));
            try {
                for (var validators_1 = __values(validators), validators_1_1 = validators_1.next(); !validators_1_1.done; validators_1_1 = validators_1.next()) {
                    var entry = validators_1_1.value;
                    var _a = __read(entry, 2), name_10 = _a[0], validator = _a[1];
                    ngModelCtrl.$validators[name_10] = validator;
                }
            }
            catch (e_86_1) { e_86 = { error: e_86_1 }; }
            finally {
                try {
                    if (validators_1_1 && !validators_1_1.done && (_b = validators_1.return)) _b.call(validators_1);
                }
                finally { if (e_86) throw e_86.error; }
            }
            this.OnDispose(function () {
                try {
                    for (var validators_2 = __values(validators), validators_2_1 = validators_2.next(); !validators_2_1.done; validators_2_1 = validators_2.next()) {
                        var entry = validators_2_1.value;
                        var _a = __read(entry, 2), name_11 = _a[0], validator = _a[1];
                        if (ngModelCtrl.$validators[name_11] === validator)
                            delete ngModelCtrl.$validators[name_11];
                    }
                }
                catch (e_87_1) { e_87 = { error: e_87_1 }; }
                finally {
                    try {
                        if (validators_2_1 && !validators_2_1.done && (_b = validators_2.return)) _b.call(validators_2);
                    }
                    finally { if (e_87) throw e_87.error; }
                }
                var e_87, _b;
            });
            var e_86, _b;
        };
        Controller.ValidateNgModel = function (mode, ngModelCtrl, modelValue, viewValue) {
            var validateTarget;
            if (!ngModelCtrl.$isEmpty(viewValue) && Controller_26.IsValidatable(viewValue))
                validateTarget = viewValue;
            else if (!ngModelCtrl.$isEmpty(modelValue) && Controller_26.IsValidatable(modelValue))
                validateTarget = modelValue;
            else
                return ngModelCtrl.$isEmpty(viewValue) || ngModelCtrl.$isEmpty(modelValue);
            return Controller_26.Validate(mode, validateTarget);
        };
        Controller.IsValidatable = function (value) {
            return value instanceof utils_4.ContactAddress || value instanceof utils_3.SelcommAddress;
        };
        Controller.Validate = function (mode, value) {
            if (mode === Mode.Allow)
                return true;
            var isPoBox = addressUtils.IsPoBox(value instanceof utils_4.ContactAddress ? value.Address : value);
            switch (mode) {
                case Mode.Require:
                    return isPoBox;
                case Mode.Reject:
                    return !isPoBox;
                default:
                    throw new Error("Unknown mode: " + mode);
            }
        };
        __decorate([
            utils.Bind.Literal(Name)
        ], Controller.prototype, "BoundMode", void 0);
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModelCtrl", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "AttachValidator", null);
        Controller = Controller_26 = __decorate([
            utils.Component({
                Name: Name,
                Restrict: utils.Target.Attribute,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
        var Controller_26;
    }(utils.Controller));
    exports.Controller = Controller;
    var Mode;
    (function (Mode) {
        Mode["Allow"] = "allow";
        Mode["Reject"] = "reject";
        Mode["Require"] = "require";
    })(Mode = exports.Mode || (exports.Mode = {}));
});
define("app/sds/address/search/sds-address-search", ["require", "exports", "app/utils", "app/ng-utils", "module", "app/sds/address/utils", "app/selcomm/service", "app/sds/address/sds-address", "app/sdc/focus/sdc-focus", "template!sds-address-search-auto"], function (require, exports, utils, ng_utils_28, module_30, addressUtils, service_22, address, focus, addressSearchAutoTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_30.id);
    var priority = 0;
    var priorityModifier = 10;
    var Item = (function () {
        function Item() {
        }
        Item.prototype.toString = function () {
            return this.DisplayText;
        };
        return Item;
    }());
    exports.Item = Item;
    var MatchedAddressItem = (function (_super) {
        __extends(MatchedAddressItem, _super);
        function MatchedAddressItem(Address, SearchText) {
            var _this = _super.call(this) || this;
            _this.Address = Address;
            _this.SearchText = SearchText;
            _this.Type = "matched-address";
            return _this;
        }
        Object.defineProperty(MatchedAddressItem.prototype, "DisplayText", {
            get: function () {
                return this.Address.Address;
            },
            enumerable: true,
            configurable: true
        });
        return MatchedAddressItem;
    }(Item));
    exports.MatchedAddressItem = MatchedAddressItem;
    var ManualInputItem = (function (_super) {
        __extends(ManualInputItem, _super);
        function ManualInputItem(options) {
            var _this = _super.call(this) || this;
            _this.Type = "manual-input";
            _this.Transclude = ManualInputItem.MakeTransclude(options);
            return _this;
        }
        Object.defineProperty(ManualInputItem.prototype, "DisplayText", {
            get: function () {
                return "";
            },
            enumerable: true,
            configurable: true
        });
        ManualInputItem.MakeTransclude = function (options) {
            var addressItems = options.addressItems, onSelected = options.onSelected, searchText = options.searchText, transcludeFn = options.transcludeFn, useAutoTemplate = options.useAutoTemplate;
            return utils.TranscludeFn.CreateBasic(function (args) {
                return utils.TranscludeFn.CallWithArgs(transcludeFn, __assign({}, args, { cloneAttachFn: function (clone, scope) {
                        scope.items = addressItems;
                        scope.searchText = searchText;
                        if (!utils.IsWhitespace(clone))
                            return args.cloneAttachFn(clone, scope);
                        scope.onSelected = onSelected;
                        var template = useAutoTemplate ? addressSearchAutoTemplate : "<div>Address not found</div>";
                        return ng_utils_28.$compile(addressSearchAutoTemplate)(scope, args.cloneAttachFn, {
                            futureParentElement: args.futureParentElement,
                        });
                    } }));
            });
        };
        return ManualInputItem;
    }(Item));
    exports.ManualInputItem = ManualInputItem;
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.TextAddressMatchAddressMap = new Map();
            _this.MinLength = 3;
            _this.SelectAddressActivity = new utils.ActivityController();
            _this.Attributes.$addClass(Controller_27.ClassName);
            _this.Watch.Collection(function () { return utils.IsVoid(_this.BoundTextAddressMatch) ? [] : (utils.IsIterable(_this.BoundTextAddressMatch) ? __spread(_this.BoundTextAddressMatch) : [_this.BoundTextAddressMatch]); }, function (fastMatchAddresses) { return _this.BuildTextMatchMap(fastMatchAddresses); });
            return _this;
        }
        Controller_27 = Controller;
        Object.defineProperty(Controller.prototype, "Disabled", {
            get: function () {
                return !utils.IsVoid(this.Element.attr("disabled"));
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SelectItem = function (searchText, item) {
            if (!(item instanceof MatchedAddressItem))
                return;
            this.SelectAddress(searchText, item.Address);
        };
        Controller.prototype.SelectAddress = function (searchText, addr) {
            return __awaiter(this, void 0, ng_utils_28.$q, function () {
                var token, address_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.SelectAddressActivity.CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            if (!!addr) return [3, 2];
                            this.SelectedAddress = null;
                            if (this.NgModelCtrl)
                                this.NgModelCtrl.$setViewValue(null, "default");
                            return [2];
                        case 2:
                            if (!(addr instanceof service_22.Selcomm.Address.ExtendedAddress)) return [3, 3];
                            this.SelectedAddress = addr;
                            return [3, 5];
                        case 3: return [4, addressUtils.ParseAddressText(addr)];
                        case 4:
                            address_1 = _a.sent();
                            if (token.HasExited)
                                return [2];
                            this.SelectedAddress = address_1;
                            _a.label = 5;
                        case 5:
                            if (this.NgModelCtrl)
                                this.NgModelCtrl.$setViewValue(this.SelectedAddress, "defaults");
                            return [3, 7];
                        case 6:
                            token.Exit();
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        };
        Controller.prototype.GetAddressMatches = function (searchText) {
            return __awaiter(this, void 0, ng_utils_28.$q, function () {
                var _this = this;
                var matchedAddresses, matchedAddressItems;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log("Get matches for: " + searchText);
                            return [4, addressUtils.GetAddressMatches(searchText)];
                        case 1:
                            matchedAddresses = _a.sent();
                            matchedAddressItems = matchedAddresses.map(function (ma) { return new MatchedAddressItem(ma, searchText); });
                            return [2, __spread(matchedAddressItems, [
                                    new ManualInputItem({
                                        addressItems: matchedAddressItems,
                                        onSelected: function (searchText, token) { return _this.SelectManualInput(searchText, token); },
                                        searchText: searchText,
                                        transcludeFn: this.Transclude,
                                        useAutoTemplate: !utils.IsVoid(this.AddressCtrl),
                                    }),
                                ])];
                    }
                });
            });
        };
        Controller.prototype.SelectManualInput = function (searchText, token) {
            return __awaiter(this, void 0, void 0, function () {
                var controller, address_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            controller = utils.AssertNotVoid(this.AddressCtrl);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4, addressUtils.ParseAddressText(searchText)];
                        case 2:
                            address_2 = (_a.sent()) || new service_22.Selcomm.Address.ExtendedAddress();
                            if (token.HasExited)
                                return [2];
                            controller.ManualInput = true;
                            controller.Address = address_2;
                            return [3, 4];
                        case 3:
                            if (token.HasExited)
                                return [2];
                            controller.ManualInput = true;
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.BuildTextMatchMap = function (addresses) {
            var entries = utils.Collection.Distinct(addresses.map(function (addr) { return [(addr instanceof service_22.Selcomm.Address.AddressSimple) ? addr.Address : addressUtils.FormatAddress(addr), utils.DeepCopy(addr)]; }), function (x, y) { return x[0] === y[0]; });
            this.TextAddressMatchAddressMap = new Map(entries);
        };
        Controller.prototype.OnLink = function () {
            var _this = this;
            var ngModelCtrl = this.BoundNgModelCtrl || ng_utils_28.$mdUtil.fakeNgModel();
            this.BindToNgModel(ngModelCtrl);
            if (this.InputContainerCtrl)
                this.BindToInputContainer(this.InputContainerCtrl, ngModelCtrl);
            if (this.AddressCtrl)
                this.BindToAddressCtrl(this.AddressCtrl);
            if (this.BoundFocusCtrl) {
                this.BoundFocusCtrl.FocusHandler = null;
                this.Watch.Once.Collection(function () { return _this.Element.find('input').toArray(); }, function (inputs) { return _this.BoundFocusCtrl && (_this.BoundFocusCtrl.FocusHandler = new focus.ElementFocusHandler($(inputs))); });
            }
        };
        Controller.prototype.BindToNgModel = function (ngModelCtrl) {
            var _this = this;
            this.NgModelCtrl = ngModelCtrl;
            ngModelCtrl.$render = function () { return _this.RenderFrom(ngModelCtrl); };
            var handler = function () { return ngModelCtrl.$setTouched(); };
            this.Watch.Once(function () { return _this.input; }, function (input) {
                if (!input)
                    return;
                input.on("blur", handler);
                _this.OnDispose(function () { return input.off("blur", handler); });
            });
        };
        Controller.prototype.RenderFrom = function (ngModelCtrl) {
            this.SelectedAddress = utils.DeepCopy(ngModelCtrl.$viewValue);
            var searchText = this.CurrentSearchText = addressUtils.FormatAddress(ngModelCtrl.$viewValue) || "";
            this.MinLength = searchText ? searchText.length + 1 : 1;
        };
        Controller.prototype.OnSearchTextChanged = function (searchText) {
            if (this.SelectedAddress && (addressUtils.FormatAddress(this.SelectedAddress) || "") === searchText)
                return;
            console.log("OnSearchTextChanged: " + searchText);
            var address = utils.DeepCopy(this.TextAddressMatchAddressMap.get(searchText.trim()) || null);
            this.SelectAddress(searchText, address);
            if (this.NgModelCtrl)
                this.NgModelCtrl.$setDirty();
            this.MinLength = 3;
        };
        Controller.prototype.BindToInputContainer = function (containerCtrl, ngModelCtrl) {
            var _this = this;
            if (containerCtrl.input)
                throw new Error("<md-input-container> can only have *one* <input> or <textarea> child element!");
            this.Attributes.$addClass("md-input");
            if (!this.Element.attr("id"))
                this.Element.attr("id", "input_" + ng_utils_28.$mdUtil.nextUid());
            containerCtrl.isErrorGetter = function () { return _this.IsInvalid(ngModelCtrl) && _this.IsTouched(ngModelCtrl); };
            ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
            ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
            function ngModelPipelineCheckValue(arg) {
                containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
                return arg;
            }
        };
        Controller.prototype.IsInvalid = function (ngModelCtrl) {
            return ngModelCtrl.$invalid || (this.AddressCtrl && this.AddressCtrl.IsInvalid);
        };
        Controller.prototype.IsTouched = function (ngModelCtrl) {
            return ngModelCtrl.$touched || utils.Form.IsSubmitted(this.ParentForm) || this.AddressCtrl && this.AddressCtrl.IsTouched;
        };
        Controller.prototype.BindToAddressCtrl = function (addressCtrl) {
        };
        Controller.ClassName = utils.SnakeCase(Name);
        __decorate([
            utils.Bind.Transclude()
        ], Controller.prototype, "Transclude", void 0);
        __decorate([
            utils.Bind.Controller("ng-model", { optional: true, })
        ], Controller.prototype, "BoundNgModelCtrl", void 0);
        __decorate([
            utils.Bind.Controller(focus.Controller, { optional: true, })
        ], Controller.prototype, "BoundFocusCtrl", void 0);
        __decorate([
            utils.Bind.Controller("md-input-container", { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "InputContainerCtrl", void 0);
        __decorate([
            utils.Bind.Controller("form", { optional: true, mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "ParentForm", void 0);
        __decorate([
            utils.Bind.In("text-address-match", { optional: true })
        ], Controller.prototype, "BoundTextAddressMatch", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "OnLink", null);
        __decorate([
            utils.Bind.Controller(address.Controller, { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "AddressCtrl", void 0);
        Controller = Controller_27 = __decorate([
            utils.Component({
                Name: Name,
                Priority: priority,
            })
        ], Controller);
        return Controller;
        var Controller_27;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    utils.Directive({
        Name: Name,
        Priority: priority + priorityModifier,
        Terminal: true,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
        Require: "^^?" + utils.GetComponentName(address.Controller),
        OnLink: function (scope, element, attrs, addressCtrl, transclude) {
            if (addressCtrl) {
                scope["_$sdsAddressController"] = addressCtrl;
                attrs.$set("ngModel", "_$sdsAddressController.Address");
                attrs.$set("ngRequired", "_$sdsAddressController.Required");
            }
            ng_utils_28.$compile(element, null, priority + priorityModifier)(scope, null, { parentBoundTranscludeFn: transclude });
        }
    });
});
define("app/sds/address/select/sds-address-select", ["require", "exports", "app/utils", "module", "app/sds/address/utils"], function (require, exports, utils, module_31, addressUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Mode;
    (function (Mode) {
        Mode["Select"] = "select";
        Mode["New"] = "new";
    })(Mode || (Mode = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this._addresses = new Array();
            _this.Mode = Mode.Select;
            _this.Addresses = new Array();
            _this.NotNewAddress = _this.NotNewAddress.bind(_this);
            _this.Watch.Collection(function () { return _this.__addresses; }, function (addresses) { return _this.UpdateInternalBoundAddresses(addresses); });
            _this.Watch.Group({
                addresses: function () { return _this._addresses; },
                required: function () { return _this._required; },
            }, function ($new) { return _this.UpdateAddressDisplayList($new.addresses, $new.required); });
            return _this;
        }
        Controller.prototype.NotNewAddress = function (addr) {
            return addr !== this.newAddress;
        };
        Controller.prototype.AddressLabel = function (addr) {
            if (!addr)
                return "";
            return addressUtils.FormatAddress(addr);
        };
        Object.defineProperty(Controller.prototype, "AllowAddressSelection", {
            get: function () {
                return this.Addresses && this.Addresses.length > 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "address", {
            get: function () {
                switch (this.Mode) {
                    case Mode.New:
                        return this.newAddress;
                    case Mode.Select:
                        return this.SelectedAddress;
                }
            },
            set: function (value) {
                switch (this.Mode) {
                    case Mode.New:
                        if (angular.equals(value, this.newAddress))
                            return;
                        this.newAddress = utils.DeepCopy(value);
                        break;
                    case Mode.Select:
                        if (angular.equals(value, this.SelectedAddress)) {
                            return;
                        }
                        this.SelectedAddress = value;
                        break;
                }
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.required = function () {
            return this._required && this.Mode === Mode.New;
        };
        Controller.prototype.UpdateInternalBoundAddresses = function (addresses) {
            var addrs = [];
            var addrStrings = [];
            try {
                for (var addresses_1 = __values(addresses), addresses_1_1 = addresses_1.next(); !addresses_1_1.done; addresses_1_1 = addresses_1.next()) {
                    var addr = addresses_1_1.value;
                    var asString = addr.toString();
                    if (addrStrings.indexOf(asString) < 0) {
                        addrs.push(addr);
                        addrStrings.push(asString);
                    }
                }
            }
            catch (e_88_1) { e_88 = { error: e_88_1 }; }
            finally {
                try {
                    if (addresses_1_1 && !addresses_1_1.done && (_a = addresses_1.return)) _a.call(addresses_1);
                }
                finally { if (e_88) throw e_88.error; }
            }
            this._addresses = addrs;
            var e_88, _a;
        };
        Controller.prototype.UpdateAddressDisplayList = function (addresses, required) {
            addresses = utils.Collection.NonVoid(addresses);
            if (!required)
                addresses = __spread([null], addresses);
            else
                addresses = __spread(addresses);
            this.Addresses = addresses;
            var priorSelectedAddress = this.SelectedAddress;
            this.SelectedAddress = utils.Collection.FirstOrDefault(this.Addresses, function (addr) { return angular.equals(addr, priorSelectedAddress); });
            if (this.newAddress) {
                this.Mode = Mode.New;
                return;
            }
            if (!this.SelectedAddress && priorSelectedAddress) {
                this.newAddress = utils.DeepCopy(priorSelectedAddress);
                this.SelectedAddress = addresses.length ? addresses[0] : null;
                this.Mode = Mode.New;
            }
            else {
                if (this.SelectedAddress) {
                    this.Mode = Mode.Select;
                }
                else if (addresses.length) {
                    this.SelectedAddress = addresses[0];
                    this.Mode = Mode.Select;
                }
                else {
                    this.Mode = Mode.New;
                }
            }
        };
        Object.defineProperty(Controller.prototype, "_required", {
            get: function () {
                return angular.isDefined(this.Attributes.required);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.BindNgModel = function (ngModelCtrl) {
            var _this = this;
            if (ngModelCtrl === void 0) { ngModelCtrl = this.NgModelCtrl; }
            if (!ngModelCtrl)
                return;
            this.Attributes.$set("tabindex", -1);
            this.Watch(function () { return _this.address; }, function (address) { return ngModelCtrl.$setViewValue(utils.DeepCopy(address), "default"); });
            ngModelCtrl.$render = function () { return _this.address = ngModelCtrl.$viewValue; };
        };
        __decorate([
            utils.Bind.Transclude()
        ], Controller.prototype, "Transclude", void 0);
        __decorate([
            utils.Bind.Controller("ng-model", { optional: true })
        ], Controller.prototype, "NgModelCtrl", void 0);
        __decorate([
            utils.Bind.In("addresses")
        ], Controller.prototype, "__addresses", void 0);
        __decorate([
            utils.Bind.Literal("display-name")
        ], Controller.prototype, "DisplayName", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "BindNgModel", null);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_31.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/authentication/changepassword/sds-authentication-changepassword", ["require", "exports", "module", "app/utils", "app/ng-utils", "app/selcomm/service", "app/sdc/closable/section/sdc-closable-section", "app/sds/contact/sds-contact"], function (require, exports, module_32, utils, ng_utils_29, service_23, closableSection, selectedContact) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var template = new Promise(function (resolve_4, reject_4) { require(["template!sds-authentication-changepassword-dialog"], resolve_4, reject_4); });
    function ChangePassword(contactCode, previousPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, ChangePassword.Thin({
                            ContactCode: contactCode,
                            OldPassword: previousPassword,
                            NewPassword: newPassword,
                        })];
                    case 1:
                        result = _a.sent();
                        switch (result) {
                            case ChangePassword.WellKnownResult.Success:
                                return [2];
                            case ChangePassword.WellKnownResult.InvalidPreviousPassword:
                                throw new ChangePassword.InvalidPreviousPasswordError();
                            case ChangePassword.WellKnownResult.LoginBlocked:
                                throw new ChangePassword.LoginBlockedError();
                            case ChangePassword.WellKnownResult.UnknownError:
                                throw new ChangePassword.UnknownError(result);
                            default:
                                throw new ChangePassword.InvalidResponse(result);
                        }
                        return [2];
                }
            });
        });
    }
    exports.ChangePassword = ChangePassword;
    (function (ChangePassword) {
        function Thin(request) {
            return service_23.Service.Thin.Contact.PasswordUpdate(request);
        }
        ChangePassword.Thin = Thin;
        var WellKnownError = (function (_super) {
            __extends(WellKnownError, _super);
            function WellKnownError() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WellKnownError = __decorate([
                utils.FixExtendBuiltIn
            ], WellKnownError);
            return WellKnownError;
        }(Error));
        ChangePassword.WellKnownError = WellKnownError;
        var InvalidPreviousPasswordError = (function (_super) {
            __extends(InvalidPreviousPasswordError, _super);
            function InvalidPreviousPasswordError() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.DisplayMessage = "The previous password was invalid.";
                return _this;
            }
            InvalidPreviousPasswordError = __decorate([
                utils.FixExtendBuiltIn
            ], InvalidPreviousPasswordError);
            return InvalidPreviousPasswordError;
        }(WellKnownError));
        ChangePassword.InvalidPreviousPasswordError = InvalidPreviousPasswordError;
        var LoginBlockedError = (function (_super) {
            __extends(LoginBlockedError, _super);
            function LoginBlockedError() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.DisplayMessage = "Your account is blocked, please contact customer support.";
                return _this;
            }
            LoginBlockedError = __decorate([
                utils.FixExtendBuiltIn
            ], LoginBlockedError);
            return LoginBlockedError;
        }(WellKnownError));
        ChangePassword.LoginBlockedError = LoginBlockedError;
        var UnknownError = (function (_super) {
            __extends(UnknownError, _super);
            function UnknownError(Response) {
                var _this = _super.call(this, "Unknown response: " + Response) || this;
                _this.Response = Response;
                return _this;
            }
            UnknownError = __decorate([
                utils.FixExtendBuiltIn
            ], UnknownError);
            return UnknownError;
        }(Error));
        ChangePassword.UnknownError = UnknownError;
        var InvalidResponse = (function (_super) {
            __extends(InvalidResponse, _super);
            function InvalidResponse() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.DisplayMessage = "Unable to change password due to some technical issue. Please try again later";
                return _this;
            }
            InvalidResponse = __decorate([
                utils.FixExtendBuiltIn
            ], InvalidResponse);
            return InvalidResponse;
        }(Error));
        ChangePassword.InvalidResponse = InvalidResponse;
        var WellKnownResult;
        (function (WellKnownResult) {
            WellKnownResult["UnknownError"] = "Unable to change password due to some technical issue. Please contact support team.";
            WellKnownResult["Success"] = "succeed";
            WellKnownResult["InvalidPreviousPassword"] = "Current password is incorrect. Please try again.";
            WellKnownResult["LoginBlocked"] = "Your account is blocked. Please contact support.";
        })(WellKnownResult = ChangePassword.WellKnownResult || (ChangePassword.WellKnownResult = {}));
    })(ChangePassword = exports.ChangePassword || (exports.ChangePassword = {}));
    var Result;
    (function (Result) {
        Result["ChangePassword"] = "change-password";
        Result["Success"] = "success";
    })(Result || (Result = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.ChangePasswordActivity = new utils.ActivityController("");
            _this.CurrentPassword = "";
            _this.NewPassword = "";
            _this.ConfirmNewPassword = "";
            _this.Result = Result.ChangePassword;
            return _this;
        }
        Object.defineProperty(Controller.prototype, "ContactCode", {
            get: function () {
                return utils.AssertNotVoid(utils.AssertNotVoid(this.SelectedContactController).ContactCode);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.ChangePasswordActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Submit = function (contactCode, currentPassword, newPassword, form) {
            if (contactCode === void 0) { contactCode = this.ContactCode; }
            if (currentPassword === void 0) { currentPassword = this.CurrentPassword; }
            if (newPassword === void 0) { newPassword = this.NewPassword; }
            return __awaiter(this, void 0, ng_utils_29.$q, function () {
                var notifiedError, token, err_25;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            notifiedError = false;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, , 7]);
                            token = this.ChangePasswordActivity.TryEnter();
                            if (utils.IsVoid(token)) {
                                notifiedError = true;
                                utils.Toast.Simple("Hold on, we're still trying to process your previous request");
                                throw new utils.AlreadyDoingActionError(this.ChangePasswordActivity.Name);
                            }
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, , 4, 5]);
                            if (!utils.IsVoid(form) && !form.$valid) {
                                notifiedError = true;
                                utils.Toast.Simple("Some inputs are invalid");
                                throw new utils.FormInvalidError(form);
                            }
                            return [4, ChangePassword(contactCode, currentPassword, newPassword)];
                        case 3:
                            _a.sent();
                            if (!this.CanClose) {
                                this.Result = Result.Success;
                                return [2];
                            }
                            utils.Toast.Simple("Your password has been successfully updated.");
                            this.Close();
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5: return [3, 7];
                        case 6:
                            err_25 = _a.sent();
                            if (!notifiedError) {
                                if (err_25 instanceof ChangePassword.WellKnownError)
                                    utils.Toast.Simple(err_25.DisplayMessage);
                                else
                                    utils.Toast.Simple("An error occurred whilst trying to change your password, contact support if the issue persists");
                            }
                            throw err_25;
                        case 7: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "CanClose", {
            get: function () {
                return !utils.IsVoid(this.OverridingClose) || !utils.IsVoid(this.ClosableSection);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Close = function () {
            if (!utils.IsVoid(this.OverridingClose))
                this.OverridingClose();
            if (!utils.IsVoid(this.ClosableSection))
                this.ClosableSection.Close();
        };
        __decorate([
            utils.Bind.Controller(closableSection.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents, })
        ], Controller.prototype, "ClosableSection", void 0);
        __decorate([
            utils.Bind.Getter("cancel"),
            utils.Bind.DefaultValue(null)
        ], Controller.prototype, "OverridingClose", void 0);
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "SelectedContactController", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_32.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    function ShowChangePasswordDialog(extender) {
        return __awaiter(this, void 0, void 0, function () {
            function close() {
                ng_utils_29.$mdDialog.hide();
            }
            function cancel() {
                ng_utils_29.$mdDialog.cancel();
            }
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = ng_utils_29.$mdDialog).show;
                        _c = {};
                        return [4, template];
                    case 1:
                        _b.apply(_a, [__assign.apply(void 0, [(_c.template = _d.sent(), _c), extender, { scope: angular.extend(extender && extender.scope || ng_utils_29.$rootScope, {
                                        close: close,
                                        cancel: cancel,
                                    }) }])]);
                        return [2];
                }
            });
        });
    }
});
define("app/sds/authentication/required/sds-authentication-required", ["require", "exports", "module", "app/utils", "app/ng-utils", "moment", "app/selcomm/service"], function (require, exports, module_33, utils, ng_utils_30, moment, service_24) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ComparableSessionDetails = (function () {
        function ComparableSessionDetails(source) {
            this.SessionKey = source.SessionKey;
            this.UserCode = source.UserCode;
        }
        ComparableSessionDetails.AreEqual = function (x, y) {
            if (utils.IsVoid(x) && utils.IsVoid(y))
                return true;
            if (utils.IsVoid(x) || utils.IsVoid(y))
                return false;
            return x.SessionKey === y.SessionKey && x.UserCode === y.UserCode;
        };
        ComparableSessionDetails.ConvertFrom = function (source) {
            return utils.IsVoid(source) ? source : new ComparableSessionDetails(source);
        };
        ComparableSessionDetails.Empty = new ComparableSessionDetails({ SessionKey: null, UserCode: null });
        return ComparableSessionDetails;
    }());
    var AuthenticatedStatus;
    (function (AuthenticatedStatus) {
        AuthenticatedStatus["NotAuthenticated"] = "not-authenticated";
        AuthenticatedStatus["Authenticated"] = "authenticated";
        AuthenticatedStatus["NotRequired"] = "not-required";
        AuthenticatedStatus["Verifying"] = "verifying";
    })(AuthenticatedStatus = exports.AuthenticatedStatus || (exports.AuthenticatedStatus = {}));
    var DeferredVerifyState;
    (function (DeferredVerifyState) {
        DeferredVerifyState["NotVerifying"] = "not-verifying";
        DeferredVerifyState["Standard"] = "standard";
        DeferredVerifyState["Silent"] = "silent";
    })(DeferredVerifyState = exports.DeferredVerifyState || (exports.DeferredVerifyState = {}));
    (function (AuthenticatedStatus) {
        function Get(session) {
            return (!utils.IsVoid(session) && !utils.IsNullOrWhitespace(session.UserCode)) ? AuthenticatedStatus.Authenticated : AuthenticatedStatus.NotAuthenticated;
        }
        AuthenticatedStatus.Get = Get;
    })(AuthenticatedStatus = exports.AuthenticatedStatus || (exports.AuthenticatedStatus = {}));
    var foo = AuthenticatedStatus.Authenticated + AuthenticatedStatus.NotAuthenticated;
    exports.Name = utils.GetComponentNameFromModuleId(module_33.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.demo = !utils.IsUndefined(_this.Attributes.demoLogin);
            _this.forceDemo = !utils.IsUndefined(_this.Attributes.showDemoFeatures);
            _this.FullVerifySessionActivity = new utils.ActivityController.Extended("VerifySessionActivity");
            console.log("sds-authentication-required init");
            _this.Attributes.$addClass(exports.Name);
            var isDisposed = false;
            _this.OnDispose(function () { return isDisposed = true; });
            var _lastSession;
            _this.Watch(function () {
                var _loop_6 = function () {
                    try {
                        var lastSession_1 = _lastSession;
                        var currentSession_1 = service_24.Auth.CurrentSession;
                        _lastSession = ComparableSessionDetails.ConvertFrom(currentSession_1);
                        if (ComparableSessionDetails.AreEqual(lastSession_1, currentSession_1) || utils.IsVoid(currentSession_1))
                            return { value: void 0 };
                        utils.Execute(function () { return __awaiter(_this, void 0, void 0, function () {
                            var token, err_26;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        token = this.FullVerifySessionActivity.CloseAndEnter({ IsSilent: false });
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, 4, 5]);
                                        return [4, this.VerifySessionFull(token, currentSession_1, lastSession_1)];
                                    case 2:
                                        _a.sent();
                                        return [3, 5];
                                    case 3:
                                        err_26 = _a.sent();
                                        ng_utils_30.$exceptionHandler(err_26);
                                        return [3, 5];
                                    case 4:
                                        token.Exit();
                                        return [7];
                                    case 5: return [2];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        ng_utils_30.$exceptionHandler(err);
                    }
                };
                while (!isDisposed) {
                    var state_1 = _loop_6();
                    if (typeof state_1 === "object")
                        return state_1.value;
                }
            });
            utils.Execute(function () { return __awaiter(_this, void 0, void 0, function () {
                var lastSession, currentSession, token, err_27;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!isDisposed) return [3, 9];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 7, , 8]);
                            return [4, utils.Delay(this.sessionCheckInterval)];
                        case 2:
                            _a.sent();
                            lastSession = _lastSession;
                            currentSession = service_24.Auth.CurrentSession;
                            _lastSession = ComparableSessionDetails.ConvertFrom(currentSession);
                            if (utils.IsVoid(currentSession))
                                return [2];
                            token = this.FullVerifySessionActivity.TryEnter({ IsSilent: true });
                            if (!token)
                                return [3, 0];
                            _a.label = 3;
                        case 3:
                            _a.trys.push([3, , 5, 6]);
                            return [4, this.VerifySessionFull(token, currentSession, lastSession)];
                        case 4:
                            _a.sent();
                            return [3, 6];
                        case 5:
                            token.Exit();
                            return [7];
                        case 6: return [3, 8];
                        case 7:
                            err_27 = _a.sent();
                            ng_utils_30.$exceptionHandler(err_27);
                            return [3, 8];
                        case 8: return [3, 0];
                        case 9: return [2];
                    }
                });
            }); });
            return _this;
        }
        Controller_28 = Controller;
        Object.defineProperty(Controller.prototype, "sessionCheckInterval", {
            get: function () {
                return Controller_28.SessionCheckInterval;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.hasExpired = function (sessionKey) {
            return __awaiter(this, void 0, void 0, function () {
                var ex_5;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!sessionKey)
                                return [2, true];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, service_24.Service.Thin.Session.SessionHasExpired({ SessionKey: sessionKey })];
                        case 2: return [2, _a.sent()];
                        case 3:
                            ex_5 = _a.sent();
                            return [2, true];
                        case 4: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsAuthenticationRequired", {
            get: function () {
                return this.RequiredCtrl ? this.RequiredCtrl.$value : true;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "DeferredVerifyState", {
            get: function () {
                if (!this.FullVerifySessionActivity.ActiveToken)
                    return DeferredVerifyState.NotVerifying;
                return this.FullVerifySessionActivity.ActiveToken.Value.IsSilent ? DeferredVerifyState.Silent : DeferredVerifyState.Standard;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                switch (this.DeferredVerifyState) {
                    case DeferredVerifyState.Standard:
                        return true;
                    default:
                        return false;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "AuthenticationStatus", {
            get: function () {
                if (!this.IsAuthenticationRequired)
                    return AuthenticatedStatus.NotRequired;
                return AuthenticatedStatus.Get(service_24.Auth.CurrentSession);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ComparableSession", {
            get: function () {
                return ComparableSessionDetails.ConvertFrom(service_24.Auth.CurrentSession);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.VerifySessionFull = function (token, session, lastSession) {
            return __awaiter(this, void 0, ng_utils_30.$q, function () {
                var hasExpired, newStatus;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_24.Service.Thin.Session.SessionHasExpired({ SessionKey: session.SessionKey })];
                        case 1:
                            hasExpired = _a.sent();
                            token.AssertNotExited();
                            if (!hasExpired)
                                return [2];
                            if (ComparableSessionDetails.AreEqual(session, service_24.Auth.CurrentSession))
                                service_24.Auth.CurrentSession = null;
                            return [2];
                    }
                });
            });
        };
        Controller.SessionCheckInterval = moment.duration(5, "minutes").asMilliseconds();
        __decorate([
            utils.Bind.Literal("demo-login")
        ], Controller.prototype, "_demo", void 0);
        __decorate([
            utils.Bind.Literal("show-demo-features")
        ], Controller.prototype, "_forceDemo", void 0);
        __decorate([
            utils.Bind.Controller("?sds:authentication-required-if")
        ], Controller.prototype, "RequiredCtrl", void 0);
        __decorate([
            utils.Bind.Transclude(utils.Bind.Transclude.Mode.Contents)
        ], Controller.prototype, "Transclude", void 0);
        Controller = Controller_28 = __decorate([
            utils.Component({
                Name: exports.Name,
                Restrict: utils.Target.ElementOrAttribute,
            })
        ], Controller);
        return Controller;
        var Controller_28;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/authentication/login/sds-authentication-login", ["require", "exports", "module", "app/utils", "app/ng-utils", "app/selcomm/service", "app/config", "app/sds/authentication/required/sds-authentication-required", "app/sss/sites"], function (require, exports, module_34, utils, ng_utils_31, service_25, config_1, authRequired, sites_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_34.id);
    var LoginType;
    (function (LoginType) {
        LoginType["SelcommLogin"] = "selcomm";
        LoginType["Google"] = "google";
        LoginType["Facebook"] = "facebook";
        LoginType["Microsoft"] = "Microsoft";
    })(LoginType = exports.LoginType || (exports.LoginType = {}));
    var Mode;
    (function (Mode) {
        Mode["SignIn"] = "sign-in";
        Mode["NewUser"] = "new-user";
        Mode["ForgotPassword"] = "forgot-password";
        Mode["ResetPassword"] = "reset-password";
        Mode["ResetPasswordKey"] = "reset-password-key";
        Mode["SetupAccountPassword"] = "setup-account-password";
        Mode["MustChangePassword"] = "must-change-password";
    })(Mode = exports.Mode || (exports.Mode = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.LoginCode = "";
            _this.Password = "";
            _this.TfaVerificationCodeMoreInfoLink = "";
            _this.Have2FaOtpEmail = false;
            _this.Have2FaOtpPhForSms = false;
            _this.TfaVerificationCode = "";
            _this.Mode = Mode.SignIn;
            _this.disableOtpTimerId = -1;
            _this.SignInActivity = new utils.ActivityController("Sign in");
            console.log("sds-authentication-login init");
            if (!utils.IsVoid(_this.HeaderTransclude))
                _this.HeaderTransclude(function (clone) { return _this.Element.children(":first-child").append(clone); });
            _this.ExtractTokens().catch(ng_utils_31.$exceptionHandler);
            return _this;
        }
        Object.defineProperty(Controller.prototype, "ShowDemoFeatures", {
            get: function () {
                return ng_utils_31.$mdUtil.parseAttributeBoolean(this.BoundShowDemoFeatures);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.DummySignIn = function (loginType) {
            return __awaiter(this, void 0, ng_utils_31.$q, function () {
                var token;
                return __generator(this, function (_a) {
                    token = this.SignInActivity.CloseAndEnter();
                    try {
                        switch (loginType) {
                            case LoginType.Google:
                                alert("Google+ login shows here.");
                                break;
                            case LoginType.Facebook:
                                alert("Facebook login shows here.");
                                break;
                            case LoginType.Microsoft:
                                alert("Microsoft login shows here.");
                                break;
                            case LoginType.SelcommLogin:
                                alert("Selcomm login shows here");
                        }
                    }
                    finally {
                        token.Exit();
                    }
                    return [2];
                });
            });
        };
        Controller.prototype.OpenNewUser = function (contactCode) {
            if (!utils.IsNullOrEmpty(contactCode) && !utils.IsWhitespace(contactCode)) {
                this.LoginCode = contactCode;
            }
            this.Mode = Mode.NewUser;
        };
        Controller.prototype.OpenResetPassword = function (resetPasswordToken) {
            this.ResetPasswordToken = resetPasswordToken;
            this.Mode = Mode.ResetPassword;
        };
        Controller.prototype.OpenResetPasswordKey = function (resetPasswordKey) {
            this.ResetPasswordKey = resetPasswordKey;
            this.Mode = Mode.ResetPasswordKey;
        };
        Controller.prototype.OpenSetupAccountPasswordPassword = function (setupAccountPasswordToken) {
            this.SetupAccountPasswordToken = setupAccountPasswordToken;
            this.Mode = Mode.SetupAccountPassword;
        };
        Controller.prototype.ReturnToSignIn = function () {
            this.Mode = Mode.SignIn;
        };
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.SignInActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SelcommSignIn = function (siteName, loginCode, password, tfaVerificationCode, form) {
            if (siteName === void 0) { siteName = sites_3.Site.Current.Name; }
            return __awaiter(this, void 0, ng_utils_31.$q, function () {
                var token, unauthenticatedSession, err_28, authenticatedSession, err_29, authResult;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.FormCanBeSubmitted())
                                return [2];
                            token = this.SignInActivity.Enter({ onFail: function () { return void utils.Toast.Simple("Hold on, we're already trying to sign you in."); } });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 10, 11]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("There is an issue with some inputs, check them before trying again.");
                                throw new utils.FormInvalidError(form);
                            }
                            unauthenticatedSession = void 0;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, this.GenerateNewSession()];
                        case 3:
                            unauthenticatedSession = _a.sent();
                            return [3, 5];
                        case 4:
                            err_28 = _a.sent();
                            if (!token.HasExited)
                                utils.Toast.Simple("An error occurred while logging you in, contact customer-care for further assistance.");
                            throw err_28;
                        case 5:
                            token.AssertNotExited();
                            _a.label = 6;
                        case 6:
                            _a.trys.push([6, 8, , 9]);
                            return [4, unauthenticatedSession.Authenticate(loginCode, password, tfaVerificationCode)];
                        case 7:
                            authenticatedSession = _a.sent();
                            token.AssertNotExited();
                            service_25.Auth.CurrentSession = authenticatedSession;
                            return [3, 9];
                        case 8:
                            err_29 = _a.sent();
                            if (!err_29 || !utils.IsNumber(err_29.AuthenticationResult) || token.HasExited)
                                throw err_29;
                            authResult = err_29.AuthenticationResult;
                            switch (authResult) {
                                case service_25.Selcomm.Authentication.AuthenticationResultType.LoginCodeOrPasswordError:
                                    utils.Toast.Simple("The login code or password you entered was not correct. Please try again.");
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.TFACodeNotFound:
                                    utils.Toast.Simple("No verification code has been requested. Please request an Email or SMS verification code and try again.");
                                    this.TfaVerificationCode = "";
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.TFACodeRetriesExceeded:
                                    utils.Toast.Simple("Too many attempt have been made to supply the correct verification code. Your login has now been blocked. Please contact customer-care for further assistance.");
                                    this.TfaVerificationCode = "";
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.TFACodeIncorrect:
                                    utils.Toast.Simple("The verification code was not correct. Please try again.");
                                    this.TfaVerificationCode = "";
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.TFACodeExpired:
                                    utils.Toast.Simple("The verification code has expired. Please request a new code.");
                                    this.TfaVerificationCode = "";
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.NotAuthorised:
                                    ng_utils_31.$mdDialog.show(ng_utils_31.$mdDialog
                                        .alert()
                                        .clickOutsideToClose(false)
                                        .title("Not authorised")
                                        .textContent("That account is not authorised to log in. Please contact customer-care for further assistance.")
                                        .ok('OK'));
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.MustChangePassword:
                                    utils.Toast.Simple("A password change is required before continuing. Please check your registered email adress for further instructions.");
                                    this.Mode = Mode.ResetPassword;
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.LoginBlocked:
                                    ng_utils_31.$mdDialog.show(ng_utils_31.$mdDialog
                                        .alert()
                                        .clickOutsideToClose(false)
                                        .title("Account Blocked")
                                        .textContent("That account has been blocked. Please contact customer-care for further assistance.")
                                        .ok('OK'));
                                    this.ResetPage();
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.WrongSite:
                                    ng_utils_31.$mdDialog.show(ng_utils_31.$mdDialog
                                        .alert()
                                        .clickOutsideToClose(false)
                                        .title("Wrong Site")
                                        .textContent("Please login to our site in your territory.")
                                        .ok('OK'));
                                    this.ResetPage();
                                    break;
                                default:
                                    utils.Toast.Simple("An error occurred while logging you in. Please contact customer-care for further assistance.");
                                    break;
                            }
                            throw err_29;
                        case 9: return [3, 11];
                        case 10:
                            token.Exit();
                            return [7];
                        case 11: return [2];
                    }
                });
            });
        };
        Controller.prototype.GetAccount2FAContacts = function () {
            return __awaiter(this, void 0, ng_utils_31.$q, function () {
                var token, provKey, response, ex_6, errResp;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.SignInActivity.Enter({ onFail: function () { return void utils.Toast.Simple("Hold on, we're already trying to send you a code."); } });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            provKey = config_1.Config[sites_3.Site.Current.Name + 'ProviderKey'];
                            return [4, service_25.Service.Contact.Get2faVerificationCodeSendOptionsAndInfoLink({ LoginCode: this.LoginCode.trim(), Password: this.Password.trim(), ProviderKey: provKey, SiteName: sites_3.Site.Current.Name })];
                        case 2:
                            response = _a.sent();
                            return [2, response];
                        case 3:
                            ex_6 = _a.sent();
                            console.log(ex_6);
                            errResp = new service_25.Selcomm.Authentication.TfaVerificationCodeSendOptionsAndInfoLink({
                                Status: service_25.Selcomm.Authentication.AuthenticationResultType.UnknownError,
                                ObvoscatedEmailAddr: null,
                                ObvoscatedPhoneNum: null,
                                TfaMoreInfoHelpUrl: null,
                                ErrorMessage: ex_6.Messsage
                            });
                            return [2, errResp];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        Controller.prototype.TfaThisSite = function () {
            var sitesRequiringTfa = config_1.Config.SitesRequiringOTP;
            if (sitesRequiringTfa == null)
                return false;
            var sites = sitesRequiringTfa.split(',');
            return sites.indexOf(sites_3.Site.Current.Name.toLowerCase()) >= 0;
        };
        Controller.prototype.TfaSectionCanBeVisible = function () {
            if (!this.TfaThisSite()) {
                return false;
            }
            return (this.Have2FaOtpPhForSms || this.Have2FaOtpEmail);
        };
        Controller.prototype.ResetPage = function () {
            $('#btnSubmit').hide();
            $('#tfaSection').hide();
            this.TfaVerificationCode = "";
            this.Password = "";
            this.LoginCode = "";
        };
        Controller.prototype.UpdateLoginView = function (evt) {
            return __awaiter(this, void 0, void 0, function () {
                var prevCode, prevPwd, resp, msg, title;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            evt.preventDefault();
                            if (!this.TfaThisSite()) {
                                $('#tfaSection').hide();
                                if ((this.LoginCode != null) && (this.LoginCode.trim().length >= 6)) {
                                    $('#btnSubmit').show();
                                }
                                return [2];
                            }
                            if (!((this.LoginCode != null) && (this.LoginCode.trim().length >= 6))) return [3, 3];
                            prevCode = $('#prevLoginCode').val();
                            prevPwd = $('#prevPassword').val();
                            if (!((this.LoginCode != prevCode) || (this.Password != prevPwd))) return [3, 2];
                            $('#tfaVerificationCode').val('');
                            if (!((this.LoginCode.trim().length >= 6) && (this.Password.trim().length > 1))) return [3, 2];
                            return [4, this.GetAccount2FAContacts()];
                        case 1:
                            resp = _a.sent();
                            if ((resp == null) || (resp.Status != service_25.Selcomm.Authentication.AuthenticationResultType.Success)) {
                                this.Have2FaOtpEmail = false;
                                this.Have2FaOtpPhForSms = false;
                                $('#prevLoginCode').val('');
                                $('#prevPassword').val('');
                                $('#tfaSection').hide();
                                $('#btnSubmit').hide();
                                console.log('TFA: GetContacts err resp: ' + resp);
                                msg = "";
                                title = "";
                                if (resp != null) {
                                    switch (resp.Status) {
                                        case service_25.Selcomm.Authentication.AuthenticationResultType.NotAuthorised:
                                        case service_25.Selcomm.Authentication.AuthenticationResultType.LoginCodeOrPasswordError:
                                            $('#password').focus();
                                            title = "Unauthorised";
                                            msg = "The login code or password provided are not valid. Please correct them & try again.";
                                            break;
                                        case service_25.Selcomm.Authentication.AuthenticationResultType.LoginBlocked:
                                            title = "Account Blocked";
                                            msg = "Your account is blocked so login can not proceed. Please contact customer-care for further assistance.";
                                            break;
                                        case service_25.Selcomm.Authentication.AuthenticationResultType.MustChangePassword:
                                            title = "Password Expired";
                                            msg = "Your password has expired and must be changed before you can login. Please contact customer-care for further assistance.";
                                            break;
                                        default:
                                            title = "Error";
                                            if ((resp != null) && (resp.ErrorMessage != null))
                                                msg = resp.ErrorMessage;
                                            else
                                                msg = "An unknown error occured";
                                            msg += ". Please try again or contact customer-care for further assistance.";
                                            break;
                                    }
                                }
                                if (msg != "") {
                                    ng_utils_31.$mdDialog.show(ng_utils_31.$mdDialog
                                        .alert()
                                        .clickOutsideToClose(false)
                                        .title(title)
                                        .textContent(msg)
                                        .ok('OK'));
                                }
                                return [2];
                            }
                            else {
                                $('#prevLoginCode').val(this.LoginCode.trim());
                                $('#prevPassword').val(this.Password.trim());
                                if ((resp.ObvoscatedEmailAddr == null) && (resp.ObvoscatedPhoneNum == null)) {
                                    this.Have2FaOtpEmail = false;
                                    this.Have2FaOtpPhForSms = false;
                                    $('#tfaSection').hide();
                                    $('#btnSubmit').hide();
                                    ng_utils_31.$mdDialog.show(ng_utils_31.$mdDialog
                                        .alert()
                                        .clickOutsideToClose(false)
                                        .title("No Contact")
                                        .textContent("Your account does not have an Email address or mobile number for verification purposes. Please contact Customer Care.")
                                        .ok('OK'));
                                    return [2];
                                }
                                if (resp.ObvoscatedEmailAddr != null) {
                                    this.Have2FaOtpEmail = true;
                                    $('#btn2faViaEmail').attr('title', 'Send Code via eMail to ' + resp.ObvoscatedEmailAddr);
                                    $('#btn2faViaEmail').show();
                                }
                                else {
                                    this.Have2FaOtpEmail = false;
                                    $('#btn2faViaEmail').hide();
                                    $('#btn2faViaSMS').attr('title', '');
                                }
                                if (resp.ObvoscatedPhoneNum != null) {
                                    this.Have2FaOtpPhForSms = true;
                                    $('#btn2faViaSMS').attr('title', 'Send Code via SMS to ' + resp.ObvoscatedPhoneNum);
                                    $('#btn2faViaSMS').show();
                                }
                                else {
                                    this.Have2FaOtpPhForSms = false;
                                    $('#btn2faViaSMS').attr('title', '');
                                    $('#btn2faViaSMS').hide();
                                }
                                if (resp.TfaMoreInfoHelpUrl != null) {
                                    this.TfaVerificationCodeMoreInfoLink = resp.TfaMoreInfoHelpUrl;
                                    $('#lnk2faVerificationCodeMoreInfo').show();
                                }
                                else {
                                    $('#lnk2faVerificationCodeMoreInfo').hide();
                                }
                            }
                            _a.label = 2;
                        case 2:
                            if (this.Password != '') {
                                if (this.TfaSectionCanBeVisible()) {
                                    $('#tfaSection').show();
                                    if (this.TfaVerificationCode != '') {
                                        $('#btnSubmit').show();
                                    }
                                    else {
                                        $('#btnSubmit').hide();
                                    }
                                }
                                else {
                                    $('#tfaSection').hide();
                                }
                            }
                            else {
                                $('#tfaSection').hide();
                                $('#btnSubmit').hide();
                            }
                            return [3, 4];
                        case 3:
                            $('#prevLoginCode').val('');
                            $('#prevPassword').val('');
                            $('#prevPwd').val('');
                            $('#tfaVerificationCode').val('');
                            $('#tfaSection').hide();
                            $('#btnSubmit').hide();
                            _a.label = 4;
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.FormCanBeSubmitted = function () {
            if ((this.LoginCode.trim().length < 6) || (this.Password.trim().length < 3))
                return false;
            if (this.TfaThisSite() && (this.TfaVerificationCode.trim().length < 6))
                return false;
            return true;
        };
        Controller.prototype.UpdateSubmitButtonVisibility = function () {
            if (this.FormCanBeSubmitted()) {
                $('#btnSubmit').show();
            }
            else {
                $('#btnSubmit').hide();
            }
        };
        Controller.prototype.RemapEnterKey = function (evt) {
            evt.preventDefault();
            var elmtId = document.activeElement.id;
            if (elmtId == 'txtLoginCode')
                $('#txtPassword').focus();
            else
                $('#' + elmtId).blur();
        };
        Controller.prototype.EnableOtpSendButtons = function () {
            $('#btn2faViaEmail').removeAttr('disabled');
            $('#btn2faViaSMS').removeAttr('disabled');
            if (this.disableOtpTimerId > 0)
                clearTimeout(this.disableOtpTimerId);
            this.disableOtpTimerId = -1;
        };
        Controller.prototype.BrieflyDisableOtpSendButtons = function () {
            $('#btn2faViaEmail').attr('disabled', 'disabled');
            $('#btn2faViaSMS').attr('disabled', 'disabled');
            this.disableOtpTimerId = setTimeout(this.EnableOtpSendButtons, 30000);
        };
        Controller.prototype.SendLogin2faVerificationCode = function (viaSms) {
            return __awaiter(this, void 0, void 0, function () {
                var response, errorMsg, token, provKey, ex_7, title, msg;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            response = null;
                            errorMsg = "reason unknown";
                            token = this.SignInActivity.Enter({ onFail: function () { return void utils.Toast.Simple("Hold on, we're already trying to send you a code."); } });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            provKey = config_1.Config[sites_3.Site.Current.Name + 'ProviderKey'];
                            return [4, service_25.Service.Contact.SendLogin2faVerificationCode({ LoginCode: this.LoginCode, Password: this.Password, ProviderKey: provKey, SiteName: sites_3.Site.Current.Name, BySms: viaSms })];
                        case 2:
                            response = _a.sent();
                            return [3, 5];
                        case 3:
                            ex_7 = _a.sent();
                            console.log(ex_7);
                            errorMsg = ex_7.message;
                            response = null;
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5:
                            if ((response == null) || (response.Status == null)) {
                                response = new service_25.Selcomm.Authentication.TfaSendCodeReponse({
                                    Status: service_25.Selcomm.Authentication.AuthenticationResultType.UnknownError,
                                    ObvoscatedEmailAddr: null,
                                    ObvoscatedPhoneNum: null,
                                    ErrorMessage: errorMsg
                                });
                            }
                            title = "";
                            msg = "";
                            switch (response.Status) {
                                case service_25.Selcomm.Authentication.AuthenticationResultType.Success:
                                    $('#tfaVerificationCode').focus();
                                    title = "Verification Code Sent By " + (viaSms ? "SMS" : "eMail");
                                    msg = "Please check your " + (viaSms ? "Phone with number " + response.ObvoscatedPhoneNum : "eMail " + response.ObvoscatedEmailAddr + ", including junk-mail folders,") + " for the verification code, and enter it below. Please note, your one-time code will expire in 5 minutes and is limited to 5 attempts.";
                                    this.BrieflyDisableOtpSendButtons();
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.NotAuthorised:
                                case service_25.Selcomm.Authentication.AuthenticationResultType.LoginCodeOrPasswordError:
                                    $('#password').focus();
                                    title = "Unauthorised";
                                    msg = "The login code or password provided are not valid. Please correct them & try again.";
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.LoginBlocked:
                                    title = "Account Blocked";
                                    msg = "Your account is blocked so login can not proceed. Please contact Customer Care for further assistance.";
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.MustChangePassword:
                                    title = "Password Expired";
                                    msg = "Your password has expired and must be changed before you can login. Please use the 'Forgotten password' link or contact Customer Care.";
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.InvalidPhoneNum:
                                    title = "Invalid Phone Number";
                                    msg = "The phone number found to send the code to you is invalid. Please contact customer-care for further assistance.";
                                    break;
                                case service_25.Selcomm.Authentication.AuthenticationResultType.InvalidEmailAddress:
                                    title = "Invalid eMail Address";
                                    msg = "The eMail Address found to send the code to you is invalid. Please contact customer-care for further assistance.";
                                    break;
                                default:
                                    title = "Verification Code Send Failed";
                                    msg = "We were unable to send you the verification code: " + response.ErrorMessage + ". Please try again, or contact customer-care for further assistance if the problem continues.";
                                    break;
                            }
                            ng_utils_31.$mdDialog.show(ng_utils_31.$mdDialog
                                .alert()
                                .clickOutsideToClose(false)
                                .title(title)
                                .textContent(msg)
                                .ok('OK'));
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.StartForgotPassword = function () {
            this.Mode = Mode.ForgotPassword;
        };
        Controller.prototype.StartNewUser = function () {
            this.Mode = Mode.NewUser;
        };
        Controller.prototype.mustchangepassword = function () {
            this.Mode = Mode.MustChangePassword;
        };
        Controller.prototype.ExtractTokens = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var newSession, GenerateNewSessionOnce, RetryOnSessionFail, resetPasswordTokenPromise, resetPasswordKeyPromise, setupAccountPasswordTokenPromise, resetPasswordToken, resetPasswordKey, setupAccountPasswordToken, isValid, err_30, isValid, err_31, isValid, err_32;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            GenerateNewSessionOnce = function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!!utils.IsVoid(newSession)) return [3, 2];
                                            return [4, newSession];
                                        case 1: return [2, _a.sent()];
                                        case 2: return [4, (newSession = this.GenerateNewSession())];
                                        case 3: return [2, _a.sent()];
                                    }
                                });
                            }); };
                            RetryOnSessionFail = function (action) {
                                return _this.RetryOnSessionFail(_this.CleanSessionKey, function (sessionkey) {
                                    return action(sessionkey);
                                }, GenerateNewSessionOnce);
                            };
                            resetPasswordTokenPromise = this.ExtractToken("reset-password");
                            resetPasswordKeyPromise = this.ExtractToken("reset-password-key");
                            setupAccountPasswordTokenPromise = this.ExtractToken("setup-account-password");
                            return [4, resetPasswordTokenPromise];
                        case 1:
                            resetPasswordToken = _a.sent();
                            return [4, resetPasswordKeyPromise];
                        case 2:
                            resetPasswordKey = _a.sent();
                            return [4, setupAccountPasswordTokenPromise];
                        case 3:
                            setupAccountPasswordToken = _a.sent();
                            if (!utils.IsVoid(resetPasswordToken) && !utils.IsVoid(setupAccountPasswordToken)) {
                                this.Scope.$applyAsync(function () { return utils.Toast.Simple("An error occurred."); });
                                ng_utils_31.$exceptionHandler(new Error("Invalid attempt to set-password and reset-password"));
                            }
                            if (!!utils.IsVoid(resetPasswordKey)) return [3, 8];
                            isValid = void 0;
                            _a.label = 4;
                        case 4:
                            _a.trys.push([4, 6, , 7]);
                            return [4, RetryOnSessionFail(function (sessionKey) { return _this.ValidateEncryptedKey(sessionKey, resetPasswordKey); })];
                        case 5:
                            isValid = _a.sent();
                            return [3, 7];
                        case 6:
                            err_30 = _a.sent();
                            utils.Toast.Simple("This link has expired. Please request a new forgotten password reset email.");
                            return [3, 7];
                        case 7:
                            if (!isValid) {
                                this.Scope.$applyAsync(function () { return utils.Toast.Simple("This link has expired. Please request a new forgotten password reset email."); });
                            }
                            this.Scope.$applyAsync(function () { return _this.OpenResetPasswordKey(resetPasswordKey); });
                            return [3, 18];
                        case 8:
                            if (!!utils.IsVoid(resetPasswordToken)) return [3, 13];
                            isValid = void 0;
                            _a.label = 9;
                        case 9:
                            _a.trys.push([9, 11, , 12]);
                            return [4, RetryOnSessionFail(function (sessionKey) { return _this.ValidateEncryptedToken(sessionKey, resetPasswordToken); })];
                        case 10:
                            isValid = _a.sent();
                            return [3, 12];
                        case 11:
                            err_31 = _a.sent();
                            throw new Error("Failed to validate resetPasswordToken token.");
                        case 12:
                            if (!isValid) {
                                this.Scope.$applyAsync(function () { return utils.Toast.Simple("The reset password request has either expired or was invalid."); });
                                throw new Error("Invalid resetPasswordToken.");
                            }
                            this.Scope.$applyAsync(function () { return _this.OpenResetPassword(resetPasswordToken); });
                            return [3, 18];
                        case 13:
                            if (!!utils.IsVoid(setupAccountPasswordToken)) return [3, 18];
                            isValid = void 0;
                            _a.label = 14;
                        case 14:
                            _a.trys.push([14, 16, , 17]);
                            return [4, RetryOnSessionFail(function (sessionKey) { return _this.ValidateEncryptedToken(sessionKey, setupAccountPasswordToken); })];
                        case 15:
                            isValid = _a.sent();
                            return [3, 17];
                        case 16:
                            err_32 = _a.sent();
                            throw new Error("Failed to validate setupAccountPasswordToken token.");
                        case 17:
                            if (!isValid) {
                                this.Scope.$applyAsync(function () { return utils.Toast.Simple("The setup account password request has either expired or was invalid."); });
                                throw new Error("Invalid setupAccountPasswordToken.");
                            }
                            this.Scope.$applyAsync(function () { return _this.OpenSetupAccountPasswordPassword(setupAccountPasswordToken); });
                            _a.label = 18;
                        case 18: return [2];
                    }
                });
            });
        };
        Controller.prototype.ValidateEncryptedToken = function (sessionKey, encryptedToken) {
            return __awaiter(this, void 0, void 0, function () {
                var err_33;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, service_25.Service.Thin.Account.ValidateEncryptedToken({ SessionKey: sessionKey, EncryptedToken: encryptedToken, })];
                        case 1: return [2, _a.sent()];
                        case 2:
                            err_33 = _a.sent();
                            if (err_33 instanceof service_25.System.ServiceModel.FaultException) {
                                if (/^\s*Invalid\s+password\s+reset\s+token\s*\.?\s*$/i.test(err_33.Message)) {
                                    return [2, false];
                                }
                            }
                            throw err_33;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.prototype.ValidateEncryptedKey = function (sessionKey, encryptedToken) {
            return __awaiter(this, void 0, void 0, function () {
                var err_34;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, service_25.Service.Thin.Account.ValidateEncryptedKey({ SessionKey: sessionKey, EncryptedKey: encryptedToken, })];
                        case 1: return [2, _a.sent()];
                        case 2:
                            err_34 = _a.sent();
                            if (err_34 instanceof service_25.System.ServiceModel.FaultException) {
                                if (/^\s*Invalid\s+password\s+reset\s+token\s*\.?\s*$/i.test(err_34.Message)) {
                                    return [2, false];
                                }
                            }
                            throw err_34;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.prototype.ExtractToken = function (tokenName) {
            var search = ng_utils_31.$location.search();
            var token = utils.IsVoid(search[tokenName]) ? null : String(search[tokenName]);
            if (utils.IsVoid(token) || utils.IsWhitespace(token))
                return null;
            this.Scope.$applyAsync(function () {
                var search = ng_utils_31.$location.search();
                if (search[tokenName] !== token)
                    return;
                delete search[tokenName];
                ng_utils_31.$location.search(search);
                ng_utils_31.$location.replace();
            });
            return token;
        };
        Controller.prototype.GenerateNewSession = function () {
            return __awaiter(this, void 0, void 0, function () {
                var session;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_25.Auth.StartSessionThin(sites_3.Site.Current)];
                        case 1:
                            session = _a.sent();
                            this.CleanSessionKey = session.SessionKey;
                            return [2, session];
                    }
                });
            });
        };
        Controller.prototype.RetryOnSessionFail = function (sessionKey, action, generateSession) {
            var _this = this;
            if (generateSession === void 0) { generateSession = function () { return _this.GenerateNewSession(); }; }
            return utils.RetryOnSessionFail({
                sessionKey: sessionKey,
                generateSession: generateSession,
                invoke: action,
            });
        };
        __decorate([
            utils.Bind.TranscludeSlot("header", { optional: true })
        ], Controller.prototype, "HeaderTransclude", void 0);
        __decorate([
            utils.Bind.Literal("show-demo-features")
        ], Controller.prototype, "BoundShowDemoFeatures", void 0);
        __decorate([
            utils.Bind.Controller(authRequired.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents, optional: true })
        ], Controller.prototype, "TranscludeSlot", void 0);
        __decorate([
            utils.Bind.TranscludeSlot("contents", { optional: true })
        ], Controller.prototype, "Transclude", void 0);
        Controller = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/contact/address/sds-contact-address", ["require", "exports", "app/utils", "module", "app/ng-utils", "app/selcomm/service", "app/sds/contact/address/utils", "app/sdc/crud/sdc-crud", "app/sds/address/utils", "app/selcomm/service"], function (require, exports, utils, module_35, ng_utils_32, service_26, contactAddressUtils, crud, addressUtils, service_27) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.ManualInput = false;
            _this._State = crud.State.Read;
            _this.UpdateActivity = new utils.ActivityController("Updating contact address");
            _this.createNewEvent = false;
            _this.DeleteActivity = new utils.ActivityController("Deleting contact address");
            _this.Watch.Deep(function () { return _this.ContactAddress && _this.ContactAddress.Address; }, function (address, lastAddress) {
                if (lastAddress === address || angular.equals(lastAddress, _this.NewAddress))
                    _this.NewAddress = utils.DeepCopy(address);
            });
            return _this;
        }
        Controller_29 = Controller;
        Object.defineProperty(Controller.prototype, "CanDelete", {
            get: function () {
                return utils.IsVoid(this.BoundCanDelete) || this.BoundCanDelete;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CanUpdate", {
            get: function () {
                return utils.IsVoid(this.BoundCanUpdate) || this.BoundCanUpdate;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Disabled", {
            get: function () {
                return !utils.IsVoid(this.Attributes["disabled"]) && this.Attributes["disabled"] !== false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "State", {
            get: function () {
                switch (this._State) {
                    case crud.State.Read:
                        if (this.IsDirty)
                            return crud.State.Update;
                        return crud.State.Read;
                    default:
                        return this._State;
                }
            },
            set: function (value) {
                this._State = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.HideManualInput = function () {
            this.ManualInput = false;
            return true;
        };
        Controller.FormatAddressDescription = function (addressDescription, defaultAddressDescripton) {
            if (defaultAddressDescripton === void 0) { defaultAddressDescripton = ""; }
            addressDescription = addressDescription || defaultAddressDescripton;
            if (/(\s|^)address\s*$/i.test(addressDescription)) {
                return addressDescription;
            }
            else {
                return addressDescription + " Address";
            }
        };
        Controller.prototype.Update = function () {
            return __awaiter(this, void 0, ng_utils_32.$q, function () {
                var _this = this;
                var newContactAddress, token, AddrId, addType, ipndAddress, eventId;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            newContactAddress = new contactAddressUtils.ContactAddress(this.NewAddress, this.ContactAddress.Type, this.ContactAddress.ContactCode);
                            token = this.UpdateActivity.TryEnter();
                            if (!token)
                                throw new utils.AlreadyDoingActionError("Update contact address");
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 8, 9]);
                            if (!this.CanUpdate) {
                                utils.Toast.Simple("This address cannot be updated");
                                throw new Error("Cannot Update address");
                            }
                            return [4, contactAddressUtils.UpdateContactAddress(newContactAddress)];
                        case 2:
                            AddrId = _a.sent();
                            if (!(this.ContactAddress.Type.Code == "CA")) return [3, 4];
                            addType = __assign({}, this.ContactAddress.Type);
                            addType.Code = "IP";
                            ipndAddress = new contactAddressUtils.ContactAddress(this.NewAddress, addType, this.ContactAddress.ContactCode);
                            return [4, contactAddressUtils.UpdateContactAddress(ipndAddress)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (!(AddrId > 0)) return [3, 7];
                            return [4, service_27.Service.Configuration.GetConfigValue({
                                    Key: "CREATE_ADDR_DTL_CHANGE_EVNT_" + service_27.Auth.CurrentSession.BusinessUnitCode,
                                    AlternateKey: "CREATE_ADDR_DTL_CHANGE_EVNT",
                                    DefaultValue: "N"
                                }).then(function (r) { return _this.createNewEvent = (r == "Y") ? true : false; })];
                        case 5:
                            _a.sent();
                            if (!this.createNewEvent) return [3, 7];
                            return [4, service_27.Service.Event.EventAdd({
                                    Event: new service_26.Selcomm.Event.Event({
                                        EventType: new service_26.Selcomm.Event.EventType({
                                            EventType: "CS",
                                            EventCode: "AD",
                                        }),
                                        Note: "Address updated via Selfcare"
                                    }),
                                    Contact: new service_26.Selcomm.Contact.Contact({
                                        Code: service_27.Auth.CurrentSession.CurrentContactCode,
                                    })
                                })];
                        case 6:
                            eventId = _a.sent();
                            _a.label = 7;
                        case 7:
                            this.ManualInput = false;
                            this.OnUpdate({ contactAddress: newContactAddress });
                            return [3, 9];
                        case 8:
                            token.Exit();
                            return [7];
                        case 9: return [2];
                    }
                });
            });
        };
        Controller.prototype.Delete = function () {
            return __awaiter(this, void 0, ng_utils_32.$q, function () {
                var newContactAddress, token;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            newContactAddress = new contactAddressUtils.ContactAddress(this.NewAddress, this.ContactAddress.Type, this.ContactAddress.ContactCode);
                            token = this.UpdateActivity.TryEnter();
                            if (!token)
                                throw new utils.AlreadyDoingActionError("Delete contact address");
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            if (!this.CanDelete) {
                                utils.Toast.Simple("This address cannot be deleted");
                                throw new Error("Cannot Delete address");
                            }
                            return [4, contactAddressUtils.DeleteContactAddress(newContactAddress)];
                        case 2:
                            _a.sent();
                            this.ManualInput = false;
                            this.OnDelete({ contactAddress: newContactAddress });
                            return [3, 4];
                        case 3:
                            token.Exit();
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "DisplayLabel", {
            get: function () {
                return Controller_29.FormatAddressDescription(this.ContactAddress && this.ContactAddress.Type && this.ContactAddress.Type.Description, "Address");
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.EnterUpdate = function () {
            this.State = crud.State.Update;
            this.AddressIsFocused = true;
        };
        Controller.prototype.EnterDelete = function () {
            this.State = crud.State.Delete;
        };
        Object.defineProperty(Controller.prototype, "AllowPoBox", {
            get: function () {
                return contactAddressUtils.IsPoBoxAllowed(this.ContactAddress && this.ContactAddress.Type);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.CancelUpdate = function () {
            this.ResetInputs();
            this.State = crud.State.Read;
        };
        Controller.prototype.CancelDelete = function () {
            this.State = crud.State.Read;
        };
        Object.defineProperty(Controller.prototype, "IsProcessing", {
            get: function () {
                return this.UpdateActivity.IsActive || this.DeleteActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Submit = function (state, form) {
            return __awaiter(this, void 0, ng_utils_32.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Ensure you have selected an address");
                                throw new utils.FormInvalidError(form);
                            }
                            _a = state;
                            switch (_a) {
                                case crud.State.Update: return [3, 1];
                                case crud.State.Delete: return [3, 3];
                            }
                            return [3, 5];
                        case 1: return [4, this.Update()];
                        case 2: return [2, _b.sent()];
                        case 3: return [4, this.Delete()];
                        case 4: return [2, _b.sent()];
                        case 5: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsDirty", {
            get: function () {
                return !addressUtils.AreSame(this.NewAddress, this.ContactAddress && this.ContactAddress.Address);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.ResetInputs = function () {
            this.ManualInput = false;
            this.NewAddress = utils.ShallowCopy(this.ContactAddress.Address);
        };
        __decorate([
            utils.Bind.In("contact-address")
        ], Controller.prototype, "ContactAddress", void 0);
        __decorate([
            utils.Bind.Getter("on-deleted")
        ], Controller.prototype, "OnDelete", void 0);
        __decorate([
            utils.Bind.Getter("on-updated")
        ], Controller.prototype, "OnUpdate", void 0);
        __decorate([
            utils.Bind.In("can-delete", { optional: true })
        ], Controller.prototype, "BoundCanDelete", void 0);
        __decorate([
            utils.Bind.In("can-update", { optional: true })
        ], Controller.prototype, "BoundCanUpdate", void 0);
        Controller = Controller_29 = __decorate([
            utils.Component({
                ModuleId: module_35.id,
            })
        ], Controller);
        return Controller;
        var Controller_29;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/device/reads/sds-device-reads", ["require", "exports", "$q", "filter!date", "app/utils", "app/selcomm/service", "moment"], function (require, exports, $q, dateFilter, utils, service_28, moment) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DerivedReadElement = (function () {
        function DerivedReadElement() {
        }
        return DerivedReadElement;
    }());
    var Controller = (function () {
        function Controller($watch) {
            var _this = this;
            this.ChartOptions = utils.ChartOptionsLineChart({
                X: {
                    ValueSelectorFunction: function (d) { return d.x; },
                    Label: "Time",
                    TickFormat: function (d) { return dateFilter(new Date(d), "yyyy-MM-dd HH:mm:ss"); },
                    RotateLabels: 10,
                },
                Y: {
                    ValueSelectorFunction: function (d) { return d.y; },
                    Label: "kWh per hour",
                    TickFormat: function (d) { return d.toFixed(3); },
                },
                NoDataMessage: Controller_30.NoDataMessage,
            });
            $watch.Collection(function () { return ({ start: _this.RangeStart, end: _this.RangeEnd }); }, function ($new, $old) { return _this.LoadReadsForPeriod(moment($new.start), moment($new.end)); });
        }
        Controller_30 = Controller;
        Controller.prototype.LoadReadsForPeriod = function (Start, End) {
            var _this = this;
            var Now = moment();
            var capStart = moment.min(Start, Now);
            var capEnd = moment.min(End, Now);
            var psf = new service_28.Selcomm.Filters.PagingSortsAndFilters({
                Sorts: [service_28.Sort("FromDate", service_28.Sort.Direction.Ascending)],
                Filter: new service_28.Selcomm.Filters.AllFilterGroup({
                    Filters: [
                        new service_28.Selcomm.Filters.BetweenPropertyFilter({
                            PropertyName: "FromDate",
                            StartValue: capStart,
                            EndValue: capEnd,
                        }),
                        new service_28.Selcomm.Filters.BasicPropertyFilter({
                            PropertyName: "Device.Id",
                            Value: this.DaDevice.$value.Id,
                        }), new service_28.Selcomm.Filters.BasicPropertyFilter({
                            PropertyName: "Type.Id",
                            Value: 1,
                        }),
                    ]
                }),
            });
            var prom = service_28.Service.Device.MediationDataList({ ResultPresentation: psf });
            prom = prom.then(function (result) {
                _this.ErrorMessage = null;
                _this.ChartData = _this.convertChartData(result);
                (_this.ChartOptions.chart).xDomain = [Start.toDate(), End.toDate()];
                (_this.ChartOptions.chart).forceY = [0];
                var tickUnit;
                var tickSpacing = 1;
                if (End.diff(Start, "months") > 15)
                    tickUnit = "years";
                else if (End.diff(Start, "weeks") > 15)
                    tickUnit = "months";
                else if (End.diff(Start, "days") > 15)
                    tickUnit = "weeks";
                else if (End.diff(Start, "hours") > 36)
                    tickUnit = "days";
                else if (End.diff(Start, "hours") > 15) {
                    tickUnit = "hours";
                    tickSpacing = 2;
                }
                else
                    tickUnit = "hours";
                var tickDate = Start.startOf(tickUnit);
                var ticks = [];
                while (tickDate.isSameOrBefore(End)) {
                    ticks.push(tickDate.toDate());
                    tickDate.add(tickSpacing, tickUnit);
                }
                (_this.ChartOptions.chart).xAxis.tickValues = ticks;
                return result;
            }, function ($err) {
                _this.ErrorMessage = "An error has happened.";
                return $q.reject($err);
            });
            this.Loading = prom;
        };
        Controller.prototype.convertChartData = function (result) {
            var series = {};
            var previous = {};
            for (var i = 0; i < result.Items.length; i++) {
                var thisRead = result.Items[i];
                var thisType = thisRead.Type.Id;
                var thisSeries = series[thisType];
                var thisPrev = previous[thisType];
                if (!thisSeries)
                    thisSeries = series[thisType] = [];
                var newRead = void 0;
                if (thisPrev) {
                    if (thisType == 1) {
                        var elapsed = moment(thisRead.FromDate).diff(moment(thisPrev.FromDate), "hours", true);
                        var midTime = moment(thisRead.FromDate).subtract(elapsed * 0.5, "hours");
                        var consumption = (thisRead.Value - thisPrev.Value);
                        if (elapsed > 0)
                            newRead = { x: midTime.toDate(), y: consumption / elapsed, read: thisRead };
                    }
                    else {
                    }
                    if (newRead)
                        thisSeries.push(newRead);
                }
                if (newRead || !thisPrev)
                    previous[thisType] = thisRead;
            }
            var outResult = [];
            for (var itm in series) {
                if (series[itm] && series[itm].length > 0)
                    outResult.push({ key: "Hourly rate of: " + series[itm][0].read.Type.Name, values: series[itm] });
            }
            return outResult;
        };
        Controller.NoDataMessage = "No data to display";
        __decorate([
            utils.Bind.Controller("da-device", { mode: utils.Bind.ControllerMode.SelfOrParents, optional: false })
        ], Controller.prototype, "DaDevice", void 0);
        Controller = Controller_30 = __decorate([
            utils.Component({
                Name: "sds-device-reads"
            }),
            __param(0, utils.Inject($watch))
        ], Controller);
        return Controller;
        var Controller_30;
    }());
    exports.Controller = Controller;
});
define("app/sds/email/list/sds-email-list", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "module", "app/sds/email/utils"], function (require, exports, utils, ng_utils_33, service_29, module_36, emailUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.EmailsAddresses = new Array();
            _this.EmailTypes = new Array();
            _this.AllEmailTypes = Object.freeze(new Array());
            _this.LoadingEmails = new utils.ActivityController();
            _this.FailedEmailsLoad = false;
            _this.AddingEmail = false;
            _this.LoadEmails();
            _this.EmailTypes = emailUtils.GetEmailTypes();
            _this.Watch.Collection(function () { return _this.EmailsAddresses; }, function () { return _this.AddableEmailTypes = _this.GetAddableTypes(); });
            _this.Watch.Collection(function () { return _this.EmailTypes; }, function () { return _this.AddableEmailTypes = _this.GetAddableTypes(); });
            return _this;
        }
        Controller.prototype.Add = function (email) {
            this.EmailsAddresses.push(email);
        };
        Controller.prototype.RemoveInstanceByType = function (email) {
            this.RemoveOfType(email.ContactEmailType.Code);
        };
        Controller.prototype.GetEmails = function (contactCode) {
            return __awaiter(this, void 0, ng_utils_33.$q, function () {
                var emails, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_29.Service.Email.EmailAddresses({ ContactCode: contactCode })];
                        case 1:
                            emails = _a.sent();
                            for (i = 0; i < emails.length; i++) {
                                switch (emails[i].ContactEmailType.Code) {
                                    case "E":
                                        emails[i].ContactEmailType.Description = "Bill CC(1)";
                                        break;
                                    case "I":
                                        emails[i].ContactEmailType.Description = "Bill CC(2)";
                                        break;
                                    case "G":
                                        emails[i].ContactEmailType.Description = "Bill CC(3)";
                                        break;
                                    default:
                                        emails[i].ContactEmailType.Description = "Contact Email";
                                }
                            }
                            return [2, emails];
                    }
                });
            });
        };
        Controller.prototype.RemoveOfType = function (typeCode) {
            utils.Collection.ArrayRemoveWhere(this.EmailsAddresses, function (e) { return e.ContactEmailType && e.ContactEmailType.Code === typeCode; });
        };
        Controller.prototype.OnEmailDeleted = function (email) {
            this.RemoveOfType(email.ContactEmailType.Code);
            this.AddableEmailTypes = this.GetAddableTypes();
        };
        Controller.prototype.RemoveInstance = function (email) {
            utils.Collection.ArrayRemoveAll(this.EmailsAddresses, email);
        };
        Controller.prototype.CanDelete = function (email) {
            if (email.ContactEmailType.Description === "Contact Email")
                return false;
            return true;
        };
        Object.defineProperty(Controller.prototype, "FailedLoad", {
            get: function () {
                return this.FailedEmailsLoad;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.LoadEmails = function () {
            return __awaiter(this, void 0, ng_utils_33.$q, function () {
                var token, loadedEmails, err_35, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            token = this.LoadingEmails.CloseAndEnter();
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            return [4, this.GetEmails(service_29.Auth.CurrentSession.CurrentContactCode)];
                        case 2:
                            loadedEmails = _b.sent();
                            if (token.HasExited)
                                return [2];
                            (_a = this.EmailsAddresses).push.apply(_a, __spread(loadedEmails));
                            this.FailedEmailsLoad = false;
                            return [3, 5];
                        case 3:
                            err_35 = _b.sent();
                            this.EmailsAddresses = [];
                            this.FailedEmailsLoad = true;
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsAdding", {
            get: function () {
                return this.AddingEmail;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CanAdd", {
            get: function () {
                return utils.IsVoid(this.AddableEmailTypes) ? this.AddableEmailTypes : this.AddableEmailTypes.length > 0;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.OnEmailAdded = function (email) {
            this.EmailsAddresses.push(email);
            this.AddingEmail = false;
            this.AddableEmailTypes = this.GetAddableTypes();
        };
        Controller.prototype.GetAddableTypes = function () {
            var _this = this;
            if (!this.EmailsAddresses)
                return this.EmailTypes;
            if (!this.EmailTypes)
                return undefined;
            if (this.EmailTypes.length <= 0 || this.EmailsAddresses.length <= 0)
                return this.EmailTypes;
            return this.EmailTypes.filter(function (pt) { return !utils.Collection.Any(_this.EmailsAddresses, function (p) { return p.ContactEmailType && p.ContactEmailType.Code === pt.Code; }); });
        };
        Controller.prototype.EnterAdd = function () {
            if (!this.CanAdd)
                return;
            this.AddingEmail = true;
        };
        Controller.prototype.CancelAdd = function () {
            this.AddingEmail = false;
        };
        Controller = __decorate([
            utils.Component({
                ModuleId: module_36.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/email/new/sds-email-new", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "module", "app/sds/email/utils"], function (require, exports, utils, ng_utils_34, service_30, module_37, emailUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.CreateActivity = new utils.ActivityController();
            _this.LoadingAvailableEmailTypes = new utils.ActivityController();
            _this.Init();
            return _this;
        }
        Controller_31 = Controller;
        Object.defineProperty(Controller.prototype, "CanCancel", {
            get: function () {
                return !utils.IsVoid(this.Cancel);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Create = function (form) {
            return __awaiter(this, void 0, ng_utils_34.$q, function () {
                var targetEmail, token, ex_8;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are not valid, try again after checking them.");
                                return [2];
                            }
                            targetEmail = new service_30.Selcomm.Email.ContactEmailAddress({
                                EmailAddress: this.EmailAddress,
                                ContactEmailType: utils.AssertNotVoid(this.EmailType),
                                ContactCode: service_30.Auth.CurrentSession.CurrentContactCode,
                            });
                            token = this.CreateActivity.TryEnter();
                            if (!token) {
                                throw new utils.AlreadyDoingActionError("Create Email");
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4, emailUtils.AddEmail(targetEmail)];
                        case 2:
                            _a.sent();
                            return [3, 5];
                        case 3:
                            ex_8 = _a.sent();
                            utils.Toast.Simple("An error occurred saving your new email address.");
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5:
                            this.OnCreated({ email: targetEmail });
                            return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "InputType", {
            get: function () {
                if (this.EmailType && this.EmailType.Code.length > 2)
                    return "text";
                else
                    return "email";
            },
            enumerable: true,
            configurable: true
        });
        Controller.GetEmailTypes = function () {
            return emailUtils.GetEmailTypes();
        };
        Object.defineProperty(Controller.prototype, "DisplayLabel", {
            get: function () {
                return "New Email Address";
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Init = function () {
            return __awaiter(this, void 0, ng_utils_34.$q, function () {
                return __generator(this, function (_a) {
                    if (!this.Attributes["emailTypes"])
                        this.AvailableEmailTypes = Controller_31.GetEmailTypes();
                    if (!this.EmailType && this.AvailableEmailTypes && this.AvailableEmailTypes.length)
                        this.EmailType = utils.Collection.FirstOrDefault(this.AvailableEmailTypes);
                    return [2];
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsProcessing", {
            get: function () {
                return this.LoadingAvailableEmailTypes.IsActive || this.CreateActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Getter("on-created")
        ], Controller.prototype, "OnCreated", void 0);
        __decorate([
            utils.Bind.In("email-types", { optional: true })
        ], Controller.prototype, "AvailableEmailTypes", void 0);
        __decorate([
            utils.Bind.Getter("cancel", { optional: true })
        ], Controller.prototype, "Cancel", void 0);
        Controller = Controller_31 = __decorate([
            utils.Component({
                ModuleId: module_37.id,
            })
        ], Controller);
        return Controller;
        var Controller_31;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/http/error/sds-http-error", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super.call(this) || this;
        }
        Object.defineProperty(Controller.prototype, "BoundStatusCode", {
            get: function () {
                return this.boundStatusCode;
            },
            set: function (value) {
                this.boundStatusCode = value;
                this.httpStatusCode = HttpStatusCode.TryParse(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "HttpStatusCode", {
            get: function () {
                return this.httpStatusCode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "StatusCode", {
            get: function () {
                return this.httpStatusCode && this.httpStatusCode.toString() || null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Title", {
            get: function () {
                var httpStatusCode = this.HttpStatusCode;
                if (!httpStatusCode)
                    return "Unknown Error";
                var humanName = httpStatusCode.CodeHumanName;
                return humanName ? httpStatusCode + " " + httpStatusCode.CodeHumanName : httpStatusCode + " Error";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Description", {
            get: function () {
                if (!utils.IsVoid(this.BoundStatusDescription))
                    return this.BoundStatusDescription;
                return this.HttpStatusCode && this.HttpStatusCode.DefaultMessage || "Oops, something went wrong. Contact support for further assistance.";
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Literal("status-code")
        ], Controller.prototype, "BoundStatusCode", null);
        __decorate([
            utils.Bind.Literal("status-description", { optional: true })
        ], Controller.prototype, "BoundStatusDescription", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "sds-http-error",
                Transclude: new utils.MultislotTransclusion({
                    "additional-details": "?additional-details",
                }),
            })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
    var HttpStatusCode = (function () {
        function HttpStatusCode(Code, SubCode) {
            this.Code = Code;
            this.SubCode = SubCode;
        }
        HttpStatusCode.TryParse = function (httpError) {
            if (!httpError)
                return null;
            var result = /^(\d+)(?:\.(\d+))?$/.exec(httpError);
            if (!result)
                return null;
            var _a = __read(result, 3), _ = _a[0], code = _a[1], subCode = _a[2];
            if (!code)
                return null;
            return new HttpStatusCode(code, subCode || null);
        };
        Object.defineProperty(HttpStatusCode.prototype, "CodeHumanName", {
            get: function () {
                if (!(this.Code in HttpStatusCode.CodeDisplayNames))
                    return null;
                return HttpStatusCode.CodeDisplayNames[this.Code].HumanName;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(HttpStatusCode.prototype, "DefaultMessage", {
            get: function () {
                if (!(this.Code in HttpStatusCode.CodeDisplayNames))
                    return null;
                return HttpStatusCode.CodeDisplayNames[this.Code].DefaultMessage;
            },
            enumerable: true,
            configurable: true
        });
        HttpStatusCode.prototype.toString = function () {
            if (!this.SubCode)
                return this.Code;
            return this.Code + "." + this.SubCode;
        };
        HttpStatusCode.CodeDisplayNames = utils.MakeKeyedCollection({
            "400": { HumanName: "Bad request", TechnicalName: "BadRequest", },
            "401": { HumanName: "Unauthorised", TechnicalName: "Unauthorized", },
            "403": { HumanName: "Forbidden", TechnicalName: "Forbidden", },
            "404": { HumanName: "Not found", TechnicalName: "NotFound", DefaultMessage: "We encountered an issue trying to find this page. Ensure the url is correct or contact support for further assistance.", },
            "410": { HumanName: "Permanently unavailable", TechnicalName: "Gone", },
            "500": { HumanName: "Internal server error", TechnicalName: "InternalServerError", },
            "503": { HumanName: "Temporarily unavailable", TechnicalName: "ServiceUnavailable", },
        });
        return HttpStatusCode;
    }());
    exports.HttpStatusCode = HttpStatusCode;
});
define("app/sds/menu/content/sds-menu-content", ["require", "exports", "module", "app/utils", "app/sds/menu/service", "app/selcomm/service"], function (require, exports, module_38, utils, menuService, service_31) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch.Collection(function () { return _this.BoundAttrs; }, function (boundAttrs) { return _this.ExtendAttrs = utils.Extend(Controller_32.BaseAttrs, boundAttrs); });
            return _this;
        }
        Controller_32 = Controller;
        Object.defineProperty(Controller.prototype, "Mode", {
            get: function () {
                if (utils.IsVoid(this.MenuItem))
                    return Controller_32.DefaultMode;
                return this.MenuItem.ExtendedItemMode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ModeName", {
            get: function () {
                return menuService.MenuItemMode[this.Mode];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Component", {
            get: function () {
                return this.MenuItem && this.MenuItem.Component;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Attrs", {
            get: function () {
                return this.Component && this.Component.attrs;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Tag", {
            get: function () {
                return this.Component && this.Component.tag;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Caption", {
            get: function () {
                return this.MenuItem && this.MenuItem.Caption;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Id", {
            get: function () {
                return this.MenuItem && this.MenuItem.Id;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ItemMode", {
            get: function () {
                return this.MenuItem && this.MenuItem.ItemMode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ItemModeName", {
            get: function () {
                return service_31.Selcomm.Menu.MenuItemMode[this.ItemMode];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CommandText", {
            get: function () {
                return this.MenuItem && this.MenuItem.CommandText;
            },
            enumerable: true,
            configurable: true
        });
        Controller.DefaultMode = menuService.MenuItemMode.ChildItemsOnly;
        Controller.Name = utils.GetComponentNameFromModuleId(module_38.id);
        Controller.BaseAttrs = Object.freeze({ 'layout-fill': '' });
        __decorate([
            utils.Bind.In("attrs")
        ], Controller.prototype, "BoundAttrs", void 0);
        __decorate([
            utils.Bind.In("menu-item")
        ], Controller.prototype, "MenuItem", void 0);
        Controller = Controller_32 = __decorate([
            utils.Component({
                Name: Controller_32.Name,
            })
        ], Controller);
        return Controller;
        var Controller_32;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/menu/image/sds-menu-image", ["require", "exports", "app/utils", "module", "$compile", "$animate", "$q"], function (require, exports, utils, module_39, $compile, $animate, $q) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_39.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.ChildScopes = new Array();
            _this.Attributes.$addClass(Name);
            if (!_this.Attributes["imageString"]) {
                Object.defineProperty(_this, "ImageString", {
                    get: function () { return _this.MenuItem && _this.MenuItem.ImageURL; },
                });
            }
            _this.Watch(function () { return _this.ImageString; }, function (imageString) { return _this.RenderImageString(imageString); });
            _this.Watch(function () { return _this.Size; }, function (size) {
                if (utils.IsVoid(size))
                    return;
                _this.Element.css("width", size);
                _this.Element.css("height", size);
                _this.Element.css("line-height", size);
            });
            return _this;
        }
        Controller.prototype.RenderImageString = function (imageString) {
            this.DestroyCurrent();
            if (utils.IsVoid(imageString))
                return;
            var _a = __read(/^(?:(.+?)=)?(.*)$/.exec(imageString), 3), imageType = _a[1], content = _a[2];
            return this.Render(imageType, content);
        };
        Controller.prototype.DestroyCurrent = function () {
            return __awaiter(this, void 0, $q, function () {
                var scopes, scopes_1, scopes_1_1, scope, e_89, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            scopes = this.ChildScopes;
                            this.ChildScopes = [];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 3, 4]);
                            return [4, $animate.leave(this.Element.contents())];
                        case 2:
                            _b.sent();
                            return [3, 4];
                        case 3:
                            try {
                                for (scopes_1 = __values(scopes), scopes_1_1 = scopes_1.next(); !scopes_1_1.done; scopes_1_1 = scopes_1.next()) {
                                    scope = scopes_1_1.value;
                                    scope.$destroy();
                                }
                            }
                            catch (e_89_1) { e_89 = { error: e_89_1 }; }
                            finally {
                                try {
                                    if (scopes_1_1 && !scopes_1_1.done && (_a = scopes_1.return)) _a.call(scopes_1);
                                }
                                finally { if (e_89) throw e_89.error; }
                            }
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.Render = function (imageType, content) {
            switch (imageType) {
                case "image-uri":
                    return this.RenderImageUri(content);
                case "md-svg-icon":
                    return this.RenderMdSvgIcon(content);
            }
            try {
                var parsed = utils.FromJson(content);
                if (utils.IsObject(parsed)) {
                    if (utils.HasProp(parsed, "glyphicon")) {
                        if (utils.IsString(parsed.glyphicon))
                            return this.RenderGlyphiconIcon(parsed.glyphicon);
                        if (utils.IsObject(parsed.glyphicon)) {
                            var glyphiconMap_1 = parsed.glyphicon;
                            var validGlyphicons = Object.keys(parsed.glyphicon).filter(function (key) { return !!glyphiconMap_1[key]; }).filter(function (key) { return !!key; });
                            if (validGlyphicons.length === 1) {
                                var _a = __read(/^(?:(glyphicon|fa)\b)?.+$/.exec(validGlyphicons[0]), 2), glyphiconName = _a[0], glyphiconType = _a[1];
                                return this.RenderGlyphiconIcon([glyphiconType, glyphiconName].filter(function (s) { return !!s; }).join(" "));
                            }
                        }
                        return;
                    }
                }
            }
            catch (err) { }
            return this.Render("image-uri", content);
        };
        Controller.prototype.RenderGlyphiconIcon = function (glyphiconClass) {
            var glyphicon = $(document.createElement("i"));
            glyphicon.addClass(glyphiconClass);
            this.RenderElement(glyphicon);
        };
        Controller.prototype.RenderMdSvgIcon = function (name) {
            var mdIcon = $(document.createElement("md-icon"));
            mdIcon.attr("md-svg-icon", name);
            this.RenderElement(mdIcon);
        };
        Controller.prototype.RenderImageUri = function (uri) {
            var image = $(document.createElement("img"));
            image.attr("src", uri);
            image.attr("alt", this.MenuItem && this.MenuItem.Caption || "");
            this.RenderElement(image);
        };
        Controller.prototype.RenderElement = function (element, scope) {
            var _this = this;
            if (scope === void 0) { scope = this.Scope.$new(); }
            this.ChildScopes.push(scope);
            $compile(element)(scope, function (clone) { return $animate.enter(clone, _this.Element); }, {
                futureParentElement: this.Element
            });
        };
        __decorate([
            utils.Bind.In("menu-item", { optional: true, })
        ], Controller.prototype, "MenuItem", void 0);
        __decorate([
            utils.Bind.In("image-string", { optional: true, })
        ], Controller.prototype, "ImageString", void 0);
        __decorate([
            utils.Bind.Literal("size", { optional: true })
        ], Controller.prototype, "Size", void 0);
        Controller = __decorate([
            utils.Component({
                Name: Name,
                Template: "",
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/menu/items/sds-menu-items", ["require", "exports", "module", "app/utils", "app/sds/menu/sds-menu"], function (require, exports, module_40, utils, parent) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller_33 = Controller;
        Object.defineProperty(Controller.prototype, "HasItems", {
            get: function () {
                return this.MenuItems.length > 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "MenuItems", {
            get: function () {
                return this.BoundMenuItems || [];
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Href = function (menuItem) {
            return utils.IsVoid(this.FoundSdsMenu) ? null : this.FoundSdsMenu.GetHref(menuItem);
        };
        Controller.prototype.InjectLocals = function (menuItem, transcludedScope) {
            transcludedScope.menuItem = menuItem;
            transcludedScope.href = this.Href(menuItem);
        };
        Controller.Name = utils.GetComponentNameFromModuleId(module_40.id);
        __decorate([
            utils.Bind.In("menu-items")
        ], Controller.prototype, "BoundMenuItems", void 0);
        __decorate([
            utils.Bind.Out("has-items", { optional: true })
        ], Controller.prototype, "HasItems", null);
        __decorate([
            utils.Bind.Controller(parent.Controller, { mode: utils.Bind.Controller.Mode.Parents, optional: true })
        ], Controller.prototype, "FoundSdsMenu", void 0);
        __decorate([
            utils.Bind.TranscludeSlot("menu-item", { optional: true })
        ], Controller.prototype, "MenuItemTransclude", void 0);
        Controller = Controller_33 = __decorate([
            utils.Component({
                Name: Controller_33.Name,
            })
        ], Controller);
        return Controller;
        var Controller_33;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/menu/parents/sds-menu-parents", ["require", "exports", "module", "app/utils", "app/sds/menu/sds-menu", "app/sds/menu/service"], function (require, exports, module_41, utils, parent, menuService) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller_34 = Controller;
        Object.defineProperty(Controller.prototype, "MenuItems", {
            get: function () {
                if (utils.IsVoid(this.lastMenuItems) || this.lastMenuItems.MenuItem !== this.MenuItem)
                    this.lastMenuItems = { MenuItem: this.MenuItem, MenuItems: menuService.GetMenuItemChain(this.MenuItem) };
                return this.lastMenuItems.MenuItems;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Href = function (menuItem, trim) {
            return utils.IsVoid(this.FoundSdsMenu) ? null : this.FoundSdsMenu.GetHref(menuItem, trim);
        };
        Controller.prototype.InjectLocals = function (menuItem, ngRepeatScope, transcludedScope) {
            transcludedScope.menuItem = menuItem;
            transcludedScope.href = this.Href(menuItem, !ngRepeatScope.$last);
            transcludedScope.last = ngRepeatScope.$last;
        };
        Controller.prototype.InjectHomeItemLocals = function (transcludedScope) {
            transcludedScope.href = this.Href(null, true);
        };
        Controller.Name = utils.GetComponentNameFromModuleId(module_41.id);
        __decorate([
            utils.Bind.In("menu-item")
        ], Controller.prototype, "MenuItem", void 0);
        __decorate([
            utils.Bind.TranscludeSlot("home-item", { optional: true })
        ], Controller.prototype, "HomeItemTransclude", void 0);
        __decorate([
            utils.Bind.TranscludeSlot("menu-item", { optional: true })
        ], Controller.prototype, "MenuItemTransclude", void 0);
        __decorate([
            utils.Bind.Controller(parent.Controller, { mode: utils.Bind.Controller.Mode.Parents, optional: true })
        ], Controller.prototype, "FoundSdsMenu", void 0);
        Controller = Controller_34 = __decorate([
            utils.Component({
                Name: Controller_34.Name,
            })
        ], Controller);
        return Controller;
        var Controller_34;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/menu/tiles/sds-menu-tiles", ["require", "exports", "$parse", "app/sdc/bound/expression/sdc-bound-expression", "app/utils", "app/sds/menu/service", "app/sdc/tile/accent", "template!sds-menu-tiles-items-recurse"], function (require, exports, $parse, boundExpression, utils, menuService, accent) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function DemoGlyphiconClass(menuItem) {
        if ("glyphiconClass" in menuItem)
            return;
        menuItem.glyphiconClass = "glyphicon glyphicon-" + utils.GetRandomFor(exports.DemoGlyphicons, menuItem.Caption || menuItem.Id);
    }
    function ColourClass(menuItem) {
        if (menuItem.class)
            return;
        menuItem.class = "accent-" + accent.GetRandomAccentFor(menuItem.Caption || menuItem.Id);
    }
    exports.DemoGlyphicons = Object.freeze(["envelope", "search", "cog", "file", "time", "signal", "inbox", "list-alt", "lock", "flag", "tags", "book", "facetime-video", "picture", "map-marker", "adjust", "check", "leaf", "fire", "plane", "gift", "calendar", "shopping-cart", "folder-close", "comment", "hdd", "bullhorn", "briefcase"]);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            if (!utils.IsVoid(_this.menuIdExpr) && !utils.IsVoid(_this.menuExpr))
                throw new Error("Cannot define both [menu-id] and [menu]");
            if (!utils.IsVoid(_this.menuIdExpr))
                _this.InitWithMenuId(_this.menuIdExpr);
            else if (!utils.IsVoid(_this.menuExpr))
                _this.InitWithMenu(_this.menuExpr);
            else
                throw new Error("Must define at least one of [menu-id] or [menu]");
            return _this;
        }
        Controller_35 = Controller;
        Object.defineProperty(Controller.prototype, "IsDemoMode", {
            get: function () {
                return !utils.IsVoid(this._demo);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.assignSelected = function () {
        };
        Controller.prototype.InitExpr = function (expr) {
            var splitExpr = expr.split(/\s+as\s+/i);
            var selectedExpr;
            var mainExpr;
            switch (splitExpr.length) {
                case 1:
                    mainExpr = splitExpr[0];
                    break;
                case 2:
                    var selectedExpr_1 = $parse(splitExpr[0]);
                    this.assignSelected = selectedExpr_1.assign.bind(selectedExpr_1.assign);
                    mainExpr = splitExpr[1];
                    break;
                default:
                    throw new Error("Invalid expression passed to " + Controller_35.Name + ": " + expr);
            }
            if (!utils.IsVoid(selectedExpr)) {
                var parsedSelectedExpr = $parse(selectedExpr);
                this.assignSelected = parsedSelectedExpr.assign.bind(parsedSelectedExpr);
            }
            return boundExpression.create(mainExpr, this.Scope.$parent);
        };
        Controller.prototype.InitWithMenuId = function (menuIdExpr) {
            var _this = this;
            var parsedMenuIdExpr = this.InitExpr(menuIdExpr);
            this.loading = true;
            this.Watch(parsedMenuIdExpr, function (menuId) { return _this.loading = menuService
                .GetMenu(menuId, {}, { Mapper: Controller_35.ParseMenuItem })
                .then(function (menu) { return _this.Menu = menu; }); });
        };
        Controller.prototype.InitWithMenu = function (menuExpr) {
            var _this = this;
            var parsedMenuExpr = this.InitExpr(menuExpr);
            this.Watch(parsedMenuExpr, function (menu, lastMenu) {
                if (menu === lastMenu)
                    return;
                _this.Menu = menuService.ParseMenu(menu);
            });
            this.Menu = menuService.ParseMenu(parsedMenuExpr());
        };
        Object.defineProperty(Controller.prototype, "menu", {
            get: function () { return this.Menu; },
            enumerable: true,
            configurable: true
        });
        Controller.ParseMenuItem = function (source, parsedChildren, index, parser) {
            var menuItem = menuService.ParsedMenuItem.Create(source, parsedChildren, index, parser);
            if (menuItem.class)
                return menuItem;
            menuItem.class = "accent-" + accent.GetRandomAccentFor(menuItem.Caption || menuItem.Id);
            return menuItem;
        };
        Controller.Name = "sds-menu-tiles";
        __decorate([
            utils.Bind.Literal("menu-id", { optional: true })
        ], Controller.prototype, "menuIdExpr", void 0);
        __decorate([
            utils.Bind.Literal("menu", { optional: true })
        ], Controller.prototype, "menuExpr", void 0);
        __decorate([
            utils.Bind.TwoWay("attrs", { optional: true })
        ], Controller.prototype, "attrs", void 0);
        __decorate([
            utils.Bind.TwoWay("selected", { optional: true })
        ], Controller.prototype, "selected", void 0);
        __decorate([
            utils.Bind.TwoWay("use-routing", { optional: true }),
            utils.Bind.DefaultValue(true)
        ], Controller.prototype, "useRouting", void 0);
        __decorate([
            utils.Bind.TwoWay("display-breadcrumbs", { optional: true }),
            utils.Bind.DefaultValue(true)
        ], Controller.prototype, "displayBreadcrumbs", void 0);
        __decorate([
            utils.Bind.TwoWay("animation-enabled", { optional: true }),
            utils.Bind.DefaultValue(true)
        ], Controller.prototype, "animationEnabled", void 0);
        __decorate([
            utils.Bind.Literal("demo", { optional: true })
        ], Controller.prototype, "_demo", void 0);
        Controller = Controller_35 = __decorate([
            utils.Component({
                Name: Controller_35.Name,
                Transclude: utils.TransclusionMode.Contents,
            })
        ], Controller);
        return Controller;
        var Controller_35;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sds/order/uc1/sds-order-uc1", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_42) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_42.id);
    var Controller = (function () {
        function Controller() {
        }
        Controller_36 = Controller;
        Controller.Bind = function (required) {
            if (required === void 0) { required = true; }
            return utils.Bind.Controller(Controller_36, { mode: utils.Bind.Controller.Mode.SelfOrParents, optional: !required });
        };
        __decorate([
            utils.Bind.In(name)
        ], Controller.prototype, "Order", void 0);
        Controller = Controller_36 = __decorate([
            utils.Component({
                Name: name,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
                Restrict: utils.Target.Attribute,
            })
        ], Controller);
        return Controller;
        var Controller_36;
    }());
    exports.Controller = Controller;
});
define("app/sds/phone/new/sds-phone-new", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "module"], function (require, exports, utils, ng_utils_35, service_32, module_43) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.CreateActivity = new utils.ActivityController();
            _this.LoadingAvailablePhoneTypes = new utils.ActivityController();
            _this.Init();
            return _this;
        }
        Controller_37 = Controller;
        Object.defineProperty(Controller.prototype, "CanCancel", {
            get: function () {
                return !utils.IsVoid(this.Cancel);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Create = function (form) {
            return __awaiter(this, void 0, ng_utils_35.$q, function () {
                var targetPhone, token, ex_9;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are not valid, try again after checking them.");
                                return [2];
                            }
                            targetPhone = new service_32.Selcomm.ContactPhones.ContactPhone({
                                Number: this.PhoneNumber,
                                ContactPhoneType: utils.AssertNotVoid(this.PhoneType),
                                ContactCode: service_32.Auth.CurrentSession.CurrentContactCode,
                            });
                            token = this.CreateActivity.TryEnter();
                            if (!token) {
                                throw new utils.AlreadyDoingActionError("Create Phone");
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4, service_32.Service.ContactPhone.ContactPhoneAdd({
                                    ContactPhone: targetPhone,
                                })];
                        case 2:
                            _a.sent();
                            return [3, 5];
                        case 3:
                            ex_9 = _a.sent();
                            utils.Toast.Simple("An error occurred saving your new phone details.");
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5:
                            this.OnCreated({ phone: targetPhone });
                            return [2];
                    }
                });
            });
        };
        Controller.GetPhoneTypes = function () {
            return __awaiter(this, void 0, ng_utils_35.$q, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_32.CachedService.ContactPhone.ContactPhoneTypeList({})];
                        case 1: return [2, (_a.sent())
                                .filter(function (pt) { return Controller_37.HiddenPhoneTypeCodes.indexOf(pt.Code) < 0; })];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "DisplayLabel", {
            get: function () {
                return "New Phone Number";
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Init = function () {
            return __awaiter(this, void 0, ng_utils_35.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!this.Attributes["phoneTypes"]) return [3, 2];
                            _a = this;
                            return [4, Controller_37.GetPhoneTypes()];
                        case 1:
                            _a.AvailablePhoneTypes = _b.sent();
                            _b.label = 2;
                        case 2:
                            if (!this.PhoneType && this.AvailablePhoneTypes && this.AvailablePhoneTypes.length === 1)
                                this.PhoneType = utils.Collection.FirstOrDefault(this.AvailablePhoneTypes);
                            return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsProcessing", {
            get: function () {
                return this.LoadingAvailablePhoneTypes.IsActive || this.CreateActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.HiddenPhoneTypeCodes = ["CC"];
        __decorate([
            utils.Bind.Getter("on-created")
        ], Controller.prototype, "OnCreated", void 0);
        __decorate([
            utils.Bind.In("phone-types", { optional: true })
        ], Controller.prototype, "AvailablePhoneTypes", void 0);
        __decorate([
            utils.Bind.Getter("cancel", { optional: true })
        ], Controller.prototype, "Cancel", void 0);
        Controller = Controller_37 = __decorate([
            utils.Component({
                ModuleId: module_43.id,
            })
        ], Controller);
        return Controller;
        var Controller_37;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/service/alert/sds-service-alert", ["require", "exports", "app/utils", "app/selcomm/service", "app/sss/sites", "app/sds/contact/sds-contact", "app/ng-utils", "module"], function (require, exports, utils, service_33, sites, selectedContact, ng_utils_36, module_44) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_44.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.displaySpendAlerts = true;
            _this.saveButtonNarrative = "Save Spend Alerts";
            _this.buttonState = "";
            _this.saved = false;
            return _this;
        }
        Object.defineProperty(Controller.prototype, "CanDisplaySettings", {
            get: function () {
                if (utils.IsVoid(this.service))
                    return false;
                return this.service.ServiceStatusPhase === service_33.Selcomm.Service.ServiceStatusPhase.Connected;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.OnSaveSuccess = function () {
            this.saveButtonNarrative = "  Successfully Saved.";
            this.buttonState = "success";
            this.saved = true;
        };
        Controller.prototype.OnSaveFail = function () {
            this.saveButtonNarrative = "  Save Failed, Please Try Again.";
            this.buttonState = "failed";
            this.saved = false;
        };
        Controller.prototype.saveSpendAlert = function () {
            return __awaiter(this, void 0, ng_utils_36.$q, function () {
                var _this = this;
                var title, content, confirm_2, result, reason_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (utils.IsVoid(this.originalSpendAlert))
                                throw new Error("No this.originalSpendAlert");
                            if (utils.IsVoid(this.spendAlert))
                                throw new Error("No this.spendAlert");
                            if (!!this.spendAlert.alertTypes.global.state) return [3, 4];
                            title = "IMPORTANT";
                            content = "Disabling spend alerts means you will no longer receive any usage notifications on this service.";
                            if (sites.Service.Current.Name == "thinkmobile") {
                                content = "Disabling spend alerts means you will no longer receive any usage notifications on this service. Please consider this carefully as you remain liable for any usage exceeding the data allocation in your plan or additional costs incurred. Contact Customer Care for further advice.";
                            }
                            confirm_2 = ng_utils_36.$mdDialog.confirm()
                                .targetEvent(event)
                                .title(title)
                                .textContent(content)
                                .ok('I understand')
                                .cancel('Cancel');
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, ng_utils_36.$mdDialog
                                    .show(confirm_2)
                                    .then(function () { return true; }, function () { return false; })];
                        case 2:
                            result = _a.sent();
                            if (!result) {
                                this.loadSpendAlerts();
                                return [2];
                            }
                            return [3, 4];
                        case 3:
                            reason_2 = _a.sent();
                            throw reason_2;
                        case 4:
                            this.savingSpendAlerts = service_33.Service.Alert.SpendAlertUpdate({
                                spendAlert: new service_33.Selcomm.Alert.SpendAlert({
                                    Alert1Percentage: this.originalSpendAlert.Alert1Percentage,
                                    Alert2Percentage: this.originalSpendAlert.Alert2Percentage,
                                    Alert3Percentage: this.originalSpendAlert.Alert3Percentage,
                                    Alert4Percentage: this.originalSpendAlert.Alert4Percentage,
                                    Alert5Percentage: this.originalSpendAlert.Alert5Percentage,
                                    AlertEnabled: this.spendAlert.alertTypes.global.state,
                                    ContactCode: service_33.Auth.CurrentSession.CurrentContactCode,
                                    ID: this.originalSpendAlert.ID,
                                    SendEmail: this.spendAlert.alertTypes.email.state,
                                    SendSMS: this.spendAlert.alertTypes.sms.state,
                                    ServiceRef: this.service.Id,
                                }),
                            }).then(function () { return _this.OnSaveSuccess(); }, function () { return _this.OnSaveFail(); });
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.alertColourBands = function (item) {
            if (item.si === 0) {
                return "md-warn md-hue-2";
            }
            else {
                var colour = void 0;
                switch ((item.si - 1) % 2) {
                    case 0:
                        colour = "md-accent";
                        break;
                    case 1:
                        colour = "md-primary";
                        break;
                }
                var hue = Math.floor((item.si - 1) / 2) % 4;
                switch (hue) {
                    case 0:
                        return colour;
                    default:
                        return colour + " md-hue-" + hue;
                }
            }
        };
        Controller.prototype.loadAttributes = function (serviceReference) {
            return service_33.Service.Service.ServiceAttributeList({
                Service: new service_33.Selcomm.Service.Service({ ServiceId: serviceReference }),
            });
        };
        Controller.prototype.loadAttributePossibleValues = function (stringTypeCode) {
            return service_33.Service.Validation.StringTypePossibleValues({
                StringTypeCode: stringTypeCode,
            });
        };
        Controller.prototype.loadSpendAlerts = function () {
            return __awaiter(this, void 0, ng_utils_36.$q, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2, this.loadingSpendAlerts = utils.Execute(function () { return __awaiter(_this, void 0, ng_utils_36.$q, function () {
                            var spendAlertWrapper, err_36;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4, SpendAlert.Wrapper.Get(utils.AssertNotVoid(this.SelectedContact.ContactCode), this.service.Id)];
                                    case 1:
                                        spendAlertWrapper = _a.sent();
                                        this.failedLoad = false;
                                        this.spendAlert = spendAlertWrapper.Parsed;
                                        this.originalSpendAlert = spendAlertWrapper.Original;
                                        return [2, spendAlertWrapper];
                                    case 2:
                                        err_36 = _a.sent();
                                        this.failedLoad = true;
                                        throw err_36;
                                    case 3: return [2];
                                }
                            });
                        }); })];
                });
            });
        };
        Controller.prototype.ShouldShow = function (spendAlertState) {
            return !(spendAlertState instanceof SpendAlert.State.Global);
        };
        Controller.prototype.Init = function () {
            switch (sites.Service.Current.Mode) {
                case sites.Site.Mode.EnergyDemo:
                    this.displaySpendAlerts = false;
                    break;
                default:
                    this.loadSpendAlerts();
                    break;
            }
        };
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents })
        ], Controller.prototype, "SelectedContact", void 0);
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "service", void 0);
        __decorate([
            utils.Bind.In("load-offset", { optional: true })
        ], Controller.prototype, "Offset", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
    var SpendAlert;
    (function (SpendAlert) {
        var Wrapper = (function () {
            function Wrapper(Original) {
                this.Original = Original;
                var alertPercentages = [Original.Alert1Percentage, Original.Alert2Percentage, Original.Alert3Percentage, Original.Alert4Percentage, Original.Alert5Percentage];
                this.Parsed = new SpendAlert.State.Collection({
                    alertMeAt: utils.Collection.NonVoid(alertPercentages).map(function (p) { return p / 100; }),
                    alertTypes: {
                        global: { state: Original.AlertEnabled, },
                        email: { state: Original.SendEmail, },
                        sms: { state: Original.SendSMS, },
                    }
                });
            }
            Wrapper.Get = function (targetAccountCode, serviceId) {
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = Wrapper.bind;
                                return [4, service_33.Service.Alert.SpendAlert({
                                        ContactCode: targetAccountCode,
                                        ServiceRef: serviceId,
                                    })];
                            case 1: return [2, new (_a.apply(Wrapper, [void 0, _b.sent()]))()];
                        }
                    });
                });
            };
            return Wrapper;
        }());
        SpendAlert.Wrapper = Wrapper;
        var State = (function () {
            function State(displayName, displayOrder) {
                this.displayName = displayName;
                this.displayOrder = displayOrder;
            }
            Object.defineProperty(State.prototype, "state", {
                get: function () {
                    return this.GetState();
                },
                set: function (value) {
                    this.SetState(value);
                },
                enumerable: true,
                configurable: true
            });
            State.prototype.ApplyExtender = function (extender) {
                if (utils.IsVoid(extender))
                    return;
                if (!utils.IsVoid(extender.state))
                    this.state = extender.state;
            };
            return State;
        }());
        SpendAlert.State = State;
        (function (State) {
            var Global = (function (_super) {
                __extends(Global, _super);
                function Global(displayName, displayOrder, owner) {
                    var _this = _super.call(this, displayName, displayOrder) || this;
                    _this.owner = owner;
                    return _this;
                }
                Global.prototype.GetState = function () {
                    return this.owner._global && (this.owner._sms || this.owner._email);
                };
                Global.prototype.SetState = function (value) {
                    if (value) {
                        this.owner._email = true;
                        this.owner._sms = true;
                    }
                    this.owner._global = value;
                };
                return Global;
            }(State));
            State.Global = Global;
            var Email = (function (_super) {
                __extends(Email, _super);
                function Email(displayName, displayOrder, owner) {
                    var _this = _super.call(this, displayName, displayOrder) || this;
                    _this.owner = owner;
                    _this.subState = true;
                    return _this;
                }
                Email.prototype.GetState = function () {
                    return this.owner._global && this.owner._email;
                };
                Email.prototype.SetState = function (value) {
                    if (value) {
                        if (!this.owner._global) {
                            this.owner._global = true;
                            this.owner._sms = false;
                        }
                        this.owner._email = true;
                    }
                    else {
                        if (!this.owner._sms) {
                            this.owner._global = value;
                        }
                        else {
                            this.owner._email = value;
                        }
                    }
                };
                return Email;
            }(State));
            State.Email = Email;
            var Sms = (function (_super) {
                __extends(Sms, _super);
                function Sms(displayName, displayOrder, owner) {
                    var _this = _super.call(this, displayName, displayOrder) || this;
                    _this.owner = owner;
                    _this.subState = true;
                    return _this;
                }
                Sms.prototype.GetState = function () {
                    return this.owner._global && this.owner._sms;
                };
                Sms.prototype.SetState = function (value) {
                    if (value) {
                        if (!this.owner._global) {
                            this.owner._global = true;
                            this.owner._email = false;
                        }
                        this.owner._sms = true;
                    }
                    else {
                        if (!this.owner._email) {
                            this.owner._global = value;
                        }
                        else {
                            this.owner._sms = value;
                        }
                    }
                };
                return Sms;
            }(State));
            State.Sms = Sms;
            var Collection = (function () {
                function Collection(extenders) {
                    this.AlertStates = {
                        _global: true,
                        _email: false,
                        _sms: true,
                    };
                    this._global = true;
                    this._email = false;
                    this._sms = true;
                    this.alertTypes = {
                        global: new State.Global("Spend Alerts", 0, this.AlertStates),
                        email: new State.Email("Alert me by Email", 1, this.AlertStates),
                        sms: new State.Sms("Alert me by SMS", 2, this.AlertStates),
                    };
                    if (!utils.IsVoid(extenders.alertTypes)) {
                        try {
                            for (var _a = __values(Object.keys(this.alertTypes)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                var key = _b.value;
                                var value = this.alertTypes[key];
                                if (value instanceof State) {
                                    if (!utils.HasProp(extenders.alertTypes, key))
                                        continue;
                                    var spendAlertExtender = extenders.alertTypes[key];
                                    value.ApplyExtender(spendAlertExtender);
                                }
                            }
                        }
                        catch (e_90_1) { e_90 = { error: e_90_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_90) throw e_90.error; }
                        }
                    }
                    this.alertMeAt = new (Array.bind.apply(Array, __spread([void 0], (extenders.alertMeAt || []))))().sort(function (a, b) { return b - a; });
                    var e_90, _c;
                }
                return Collection;
            }());
            State.Collection = Collection;
        })(State = SpendAlert.State || (SpendAlert.State = {}));
    })(SpendAlert || (SpendAlert = {}));
});
define("app/sds/service/details/sds-service-details", ["require", "exports", "app/utils", "$q", "app/selcomm/service"], function (require, exports, utils, $q, service_34) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var basic = Object.freeze(__spread(["SERVICE NUMBER", "PHONE NUMBER", "MOBILE NUMBER", "SRVC_NO"], ["SRVC_NARR", "TYPE", "SRVC_TYPE_NARR"], ["STATUS", "SRVC_STATUS"], ["DATE CONNECTED", "CONN_DATE"], ["PACKAGE", "PACK_NARR", "PACKAGE OPTION", "PACKAGE START", "CONTRACT", "CONTRACT_NARR"]));
    var excluded = Object.freeze(["dealer_id", "subscriber_code", "prodcode", "pkg_code", "pkg_option", "ChargedTo", "PASSWORD", "SRVC_REF"]);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch(function () { return _this.Service; }, function (service) { return _this.Loading = _this.LoadDetails(service); });
            return _this;
        }
        Controller_38 = Controller;
        Object.defineProperty(Controller.prototype, "Flex", {
            get: function () {
                return this.BoundFlex || Controller_38.DefaultFlex;
            },
            enumerable: true,
            configurable: true
        });
        Controller.GetDetails = function (service) {
            return __awaiter(this, void 0, $q, function () {
                var loadedDetails, filteredDetails;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (utils.IsVoid(service))
                                return [2, []];
                            return [4, service_34.Service.Service.DisplayDetailsUIAttributeItemList({
                                    ServiceId: service.Id,
                                })];
                        case 1:
                            loadedDetails = _a.sent();
                            filteredDetails = loadedDetails.filter(function (detail) {
                                var attrId = utils.TrimEnd(detail.AttributeId);
                                if (/password/i.test(attrId))
                                    return false;
                                if (excluded.indexOf(attrId) >= 0)
                                    return false;
                                if (basic.indexOf(attrId) < 0)
                                    return false;
                                return true;
                            });
                            return [2, filteredDetails];
                    }
                });
            });
        };
        Controller.prototype.LoadDetails = function (service) {
            return __awaiter(this, void 0, $q, function () {
                var filteredDetails;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, Controller_38.GetDetails(service)];
                        case 1:
                            filteredDetails = _a.sent();
                            this.Details = filteredDetails;
                            return [2, filteredDetails];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "Service", void 0);
        __decorate([
            utils.Bind.In("attr-flex", { optional: true })
        ], Controller.prototype, "BoundFlex", void 0);
        Controller = Controller_38 = __decorate([
            utils.Component({
                Name: "sds-service-details",
            })
        ], Controller);
        return Controller;
        var Controller_38;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    (function (Controller) {
        Controller.DefaultFlex = {
            "default": 100,
            "gt-sm": 33,
        };
    })(Controller = exports.Controller || (exports.Controller = {}));
    exports.Controller = Controller;
});
define("app/sds/service/select/sds-service-select", ["require", "exports", "app/utils", "$q", "app/selcomm/service", "module", "app/sds/service/service-utils"], function (require, exports, utils, $q, service_35, module_45, serviceUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller_39 = Controller;
        Object.defineProperty(Controller.prototype, "SelectedService", {
            get: function () {
                return this._SelectedService;
            },
            set: function (value) {
                this._SelectedService = value;
                this.NgModel.$setViewValue(this._SelectedService);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Init = function () {
            this.BindToNgModel();
        };
        Controller.prototype.BindToNgModel = function (ngModel) {
            var _this = this;
            if (ngModel === void 0) { ngModel = this.NgModel; }
            ngModel.$render = function () { return _this.RenderNgModel(ngModel); };
            ngModel.$formatters.push(function (value) { return Controller_39.Format(value); });
            ngModel.$parsers.push(function (value) { return Controller_39.Parse(value); });
        };
        Controller.Format = function (value) {
            if (value instanceof service_35.Selcomm.Service.ServiceDisplay)
                return utils.ShallowCopy(value);
            if (value instanceof service_35.Selcomm.Service.Service)
                return serviceUtils.ConvertServiceToServiceDisplay(value);
            return value;
        };
        Controller.Parse = function (value) {
            if (value instanceof service_35.Selcomm.Service.ServiceDisplay)
                return serviceUtils.ConvertServiceDisplayToService(value);
            return value;
        };
        Controller.prototype.RenderNgModel = function (ngModel) {
            this._SelectedService = ngModel.$viewValue;
        };
        Controller.prototype.GetServices = function (searchText) {
            var searchParts = utils.Text.AllMatches(/\w+/g, searchText).map(function (m) { return m[0]; }).filter(function (p) { return !!p; });
            if (!searchParts.length)
                return $q.resolve(utils.List.Create({ Items: [], TotalFilteredRecords: 0, TotalUnfilteredRecords: 0 }));
            var allFilters = service_35.Filter.All();
            try {
                for (var searchParts_1 = __values(searchParts), searchParts_1_1 = searchParts_1.next(); !searchParts_1_1.done; searchParts_1_1 = searchParts_1.next()) {
                    var searchPart = searchParts_1_1.value;
                    allFilters.Filters.push(service_35.Filter.Any(service_35.Filter.For().On("Id").Equals(Number.parseInt(searchPart)), service_35.Filter.For().On("ServiceNumber").Keyword(searchPart)));
                }
            }
            catch (e_91_1) { e_91 = { error: e_91_1 }; }
            finally {
                try {
                    if (searchParts_1_1 && !searchParts_1_1.done && (_a = searchParts_1.return)) _a.call(searchParts_1);
                }
                finally { if (e_91) throw e_91.error; }
            }
            if (!utils.IsVoid(this.SelectedService)) {
                allFilters.Filters.push(service_35.Filter.For()
                    .On("Id").NotEquals(this.SelectedService.Id));
            }
            return service_35.Service.Service.ServiceDisplayList({
                PagingSortsAndFilters: new service_35.Selcomm.Filters.PagingSortsAndFilters({
                    TakeRecords: 20,
                    Filter: allFilters
                }),
            })
                .then(utils.List.Create);
            var e_91, _a;
        };
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModel", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = Controller_39 = __decorate([
            utils.Component({
                ModuleId: module_45.id,
            })
        ], Controller);
        return Controller;
        var Controller_39;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/service/settings/sds-service-settings", ["require", "exports", "app/utils", "app/selcomm/service", "app/sds/service/service-utils", "module"], function (require, exports, utils, service_36, service_utils_1, module_46) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_46.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.IsSettingTabOpened = false;
            var name = _this.service.ServiceNumber + " - " + _this.service.ServiceType + "_SettingTab";
            _this.Watch(function () { return window.sessionStorage.getItem(name); }, function (IsSettingTab) { return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(this.IsSettingTabOpened == false && IsSettingTab === "1")) return [3, 2];
                            this.IsSettingTabOpened = true;
                            if (!this.IsSettingTabOpened) return [3, 2];
                            _a = this;
                            return [4, service_utils_1.GetChildServiceForService(this.service.Id)];
                        case 1:
                            _a.childServices = _b.sent();
                            _b.label = 2;
                        case 2: return [2];
                    }
                });
            }); });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "CanDisplaySettings", {
            get: function () {
                if (utils.IsVoid(this.service))
                    return false;
                return this.service.ServiceStatusPhase === service_36.Selcomm.Service.ServiceStatusPhase.Connected;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsSITEService", {
            get: function () {
                if (utils.IsVoid(this.service))
                    return false;
                return this.service.ServiceTypeCode.toUpperCase() == "SITE";
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.CanDisplaySetting = function (service) {
            if (utils.IsVoid(service))
                return false;
            return service.ServiceStatusPhase === service_36.Selcomm.Service.ServiceStatusPhase.Connected;
        };
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "service", void 0);
        __decorate([
            utils.Bind.In("load-offset", { optional: true })
        ], Controller.prototype, "Offset", void 0);
        Controller = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sds/service/usage/sds-service-usage", ["require", "exports", "service!sss-site", "app/utils", "app/sds/service/service-utils", "module"], function (require, exports, siteService, utils, service_utils_2, module_47) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_47.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.LoadChildService();
            return _this;
        }
        Object.defineProperty(Controller.prototype, "IsSITEService", {
            get: function () {
                if (utils.IsVoid(this.service))
                    return false;
                return this.service.ServiceTypeCode.toUpperCase() == "SITE";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "mode", {
            get: function () {
                switch (siteService.current.mode) {
                    case "EnergyDemo":
                        return "energy";
                    default:
                        return "telco";
                }
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.LoadChildService = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!this.IsSITEService) return [3, 2];
                            _a = this;
                            return [4, service_utils_2.GetChildServiceForService(this.service.Id)];
                        case 1:
                            _a.childServices = _b.sent();
                            _b.label = 2;
                        case 2: return [2];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "service", void 0);
        Controller = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/service/usage/utils", ["require", "exports", "app/utils", "moment", "app/sss/sites", "app/selcomm/service"], function (require, exports, utils, moment, sites, service_37) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function GetUsage(serviceId) {
        return __awaiter(this, void 0, void 0, function () {
            var usage, err_37, fixedUsage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, service_37.Service.Thin.Service.ServiceUsageGraphDisplayList({
                                ServiceRef: serviceId,
                            })];
                    case 1:
                        usage = _a.sent();
                        return [3, 3];
                    case 2:
                        err_37 = _a.sent();
                        if (!GetIsDemoUsageAllowed())
                            throw err_37;
                        usage = GenerateDemoUsage(sites.Service.Current.Mode);
                        return [3, 3];
                    case 3:
                        if ((!usage || !usage.ServiceUsage || usage.ServiceUsage.length <= 0) && GetIsDemoUsageAllowed())
                            usage = GenerateDemoUsage(sites.Service.Current.Mode);
                        if (utils.IsVoid(usage))
                            return [2, usage];
                        fixedUsage = ParsedBundleUsageList.TryCreate(usage);
                        return [2, fixedUsage];
                }
            });
        });
    }
    exports.GetUsage = GetUsage;
    function GetIsDemoUsageAllowed() {
        return sites.Service.Current.Mode && sites.Service.Current.Mode !== sites.Site.Mode.Default;
    }
    exports.GetIsDemoUsageAllowed = GetIsDemoUsageAllowed;
    var ParsedUsagePeriod = (function () {
        function ParsedUsagePeriod(source) {
            if (source === void 0) { source = {}; }
            this.StartMoment = source.StartMoment;
            this.EndMoment = source.EndMoment;
            this.UsagePeriod = source.UsagePeriod;
        }
        Object.defineProperty(ParsedUsagePeriod.prototype, "TotalDays", {
            get: function () {
                if (utils.IsVoid(this.StartMoment) || utils.IsVoid(this.EndMoment))
                    return Number.POSITIVE_INFINITY;
                return this.EndMoment.diff(this.StartMoment, "days");
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedUsagePeriod.prototype, "DaysIn", {
            get: function () {
                if (utils.IsVoid(this.StartMoment))
                    return Number.POSITIVE_INFINITY;
                return this.ClampedNow.diff(this.StartMoment, "days");
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedUsagePeriod.prototype, "DaysRemaining", {
            get: function () {
                return this.TotalDays - this.DaysIn;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedUsagePeriod.prototype, "Complete", {
            get: function () {
                if (utils.IsVoid(this.EndMoment))
                    return 0;
                var now = moment();
                if (utils.IsVoid(this.StartMoment)) {
                    if (this.EndMoment.isAfter(now))
                        return 1;
                    else
                        return 0;
                }
                var clampedNow = this.ClampedMoment(now);
                return clampedNow.diff(this.StartMoment, "days") / this.EndMoment.diff(this.StartMoment, "days");
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedUsagePeriod.prototype, "ClampedNow", {
            get: function () {
                return this.ClampedMoment(moment());
            },
            enumerable: true,
            configurable: true
        });
        ParsedUsagePeriod.prototype.ClampedMoment = function (source) {
            if (utils.IsVoid(this.StartMoment) && utils.IsVoid(this.EndMoment))
                return source;
            if (utils.IsVoid(this.StartMoment))
                return source.isAfter(this.EndMoment) ? this.EndMoment : source;
            if (utils.IsVoid(this.EndMoment))
                return source.isBefore(this.StartMoment) ? this.StartMoment : source;
            if (this.StartMoment.isAfter(this.EndMoment))
                return source;
            if (source.isAfter(this.EndMoment))
                return this.EndMoment;
            if (source.isBefore(this.StartMoment))
                return this.StartMoment;
            return source;
        };
        ParsedUsagePeriod.GetLatest = function (usage) {
            return utils.Collection.GetArray(usage)
                .map(function (u) { return u.Period; })
                .reduce(function (prev, curr) {
                if (utils.IsVoid(curr) || utils.IsVoid(curr.StartMoment) || utils.IsVoid(curr.EndMoment) || utils.IsVoid(curr.UsagePeriod))
                    return prev;
                if (!utils.IsVoid(prev) && curr.StartMoment.isSame(prev.StartMoment) && curr.EndMoment.isSame(prev.EndMoment))
                    return prev;
                var currPeriod = new ParsedUsagePeriod(curr);
                if (utils.IsVoid(prev) || currPeriod.UsagePeriod > prev.UsagePeriod)
                    return currPeriod;
                return prev;
            }, null);
        };
        return ParsedUsagePeriod;
    }());
    exports.ParsedUsagePeriod = ParsedUsagePeriod;
    var ParsedBundleUsage = (function (_super) {
        __extends(ParsedBundleUsage, _super);
        function ParsedBundleUsage(args) {
            var _this = _super.call(this, args) || this;
            ParsedBundleUsage.FixAmounts(_this);
            return _this;
        }
        Object.defineProperty(ParsedBundleUsage.prototype, "StartDate", {
            get: function () {
                return this.Period.StartMoment && this.Period.StartMoment.toDate();
            },
            set: function (value) {
                this.Period = new ParsedUsagePeriod({
                    UsagePeriod: this.Period && this.Period.UsagePeriod,
                    StartMoment: moment(value),
                    EndMoment: this.Period && this.Period.EndMoment,
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedBundleUsage.prototype, "EndDate", {
            get: function () {
                return this.Period.EndMoment && this.Period.EndMoment.toDate();
            },
            set: function (value) {
                this.Period = new ParsedUsagePeriod({
                    UsagePeriod: this.Period && this.Period.UsagePeriod,
                    StartMoment: this.Period && this.Period.StartMoment,
                    EndMoment: moment(value),
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedBundleUsage.prototype, "UsagePeriod", {
            get: function () {
                return this.Period.UsagePeriod;
            },
            set: function (value) {
                this.Period = new ParsedUsagePeriod({
                    UsagePeriod: value,
                    StartMoment: this.Period && this.Period.StartMoment,
                    EndMoment: this.Period && this.Period.EndMoment,
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedBundleUsage.prototype, "UsageComplete", {
            get: function () {
                return this.AmountUsedThisPeriod / this.TotalAvailableAmount;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ParsedBundleUsage.prototype, "UsageRemaining", {
            get: function () {
                return this.TotalAvailableAmount - this.AmountUsedThisPeriod;
            },
            enumerable: true,
            configurable: true
        });
        ParsedBundleUsage.FixAmounts = function (target) {
            switch (target.Unit) {
                case "$":
                    target.AmountUsedThisPeriod *= 1.1;
                    target.TotalAvailableAmount *= 1.1;
                    break;
            }
        };
        return ParsedBundleUsage;
    }(service_37.Selcomm.Usage.ServiceUsageGraphDisplay));
    exports.ParsedBundleUsage = ParsedBundleUsage;
    var ParsedBundleUsageList = (function () {
        function ParsedBundleUsageList(source) {
            if (utils.IsVoid(source) || !source.ServiceUsage || source.ServiceUsage.length <= 0)
                throw new Error("Cannot parse usage");
            this.Bundles = Object.freeze(source.ServiceUsage.map(function (u) { return new ParsedBundleUsage(u); }));
            this.LastPeriod = ParsedUsagePeriod.GetLatest(this.Bundles);
        }
        ParsedBundleUsageList.TryCreate = function (source) {
            if (utils.IsVoid(source) || utils.IsVoid(source.ServiceUsage) || source.ServiceUsage.length <= 0)
                return null;
            return new ParsedBundleUsageList(source);
        };
        return ParsedBundleUsageList;
    }());
    exports.ParsedBundleUsageList = ParsedBundleUsageList;
    function GenerateDemoUsage(mode) {
        switch (mode) {
            case sites.Site.Mode.TelcoDemo:
                return GenerateTelcoDemoUsage();
            default:
                return null;
        }
    }
    exports.GenerateDemoUsage = GenerateDemoUsage;
    function RandomOffsetDays(periodDuration) {
        switch (Math.floor(Math.random() * 5)) {
            case 0:
                return -periodDuration / 2;
            case 1:
                return -periodDuration / 2 + Math.random();
            default:
                return Math.round(Math.random() * periodDuration) - periodDuration / 2;
            case 2:
                return periodDuration / 2 - Math.random();
            case 3:
                return periodDuration / 2;
        }
    }
    function RandomDuration() {
        var modifer = Math.floor(Math.random() * 4);
        return modifer + 28;
    }
    function GenerateTelcoDemoUsage() {
        var now = moment();
        var periodDuration = RandomDuration();
        var randomOffset = RandomOffsetDays(periodDuration);
        var endDate = now.clone().add(periodDuration / 2, "d").add(randomOffset, "d").toDate();
        var startDate = now.clone().subtract(periodDuration / 2, "d").add(randomOffset, "d").toDate();
        var period = now.year() * 100 + now.month();
        return new service_37.Selcomm.Usage.ClientServiceUsageGraphDisplayList({
            ServiceUsageType: service_37.Selcomm.Usage.UsageGraphType.Bundled,
            ServiceUsage: [new service_37.Selcomm.Usage.ServiceUsageGraphDisplay({
                    AmountUsedOtherPeriods: 0,
                    AmountUsedThisPeriod: Math.random() * (100 / 1.1),
                    BillPeriod: period,
                    DiscountID: null,
                    EndDate: endDate,
                    Narrative: "Calls",
                    ServiceReference: null,
                    StartDate: startDate,
                    TotalAvailableAmount: 100 / 1.1,
                    Type: null,
                    Unit: "$",
                    UnitNarrative: null,
                    UsageNarrative: null,
                    UsagePeriod: period,
                    UsageTiers: null,
                }), new service_37.Selcomm.Usage.ServiceUsageGraphDisplay({
                    AmountUsedOtherPeriods: 0,
                    AmountUsedThisPeriod: Math.random() * 2048,
                    BillPeriod: period,
                    DiscountID: null,
                    EndDate: endDate,
                    Narrative: "Data",
                    ServiceReference: null,
                    StartDate: startDate,
                    TotalAvailableAmount: 2000,
                    Type: null,
                    Unit: "M",
                    UnitNarrative: null,
                    UsageNarrative: null,
                    UsagePeriod: period,
                    UsageTiers: null,
                }), new service_37.Selcomm.Usage.ServiceUsageGraphDisplay({
                    AmountUsedOtherPeriods: 0,
                    AmountUsedThisPeriod: Math.round(Math.random() * 200),
                    BillPeriod: period,
                    DiscountID: null,
                    EndDate: endDate,
                    Narrative: "SMS / MMS",
                    ServiceReference: null,
                    StartDate: startDate,
                    TotalAvailableAmount: 200,
                    Type: null,
                    Unit: "E",
                    UnitNarrative: null,
                    UsageNarrative: null,
                    UsagePeriod: period,
                    UsageTiers: null,
                }), new service_37.Selcomm.Usage.ServiceUsageGraphDisplay({
                    AmountUsedOtherPeriods: 0,
                    AmountUsedThisPeriod: Math.random() * (50 / 1.1),
                    BillPeriod: period,
                    DiscountID: null,
                    EndDate: endDate,
                    Narrative: "Non-Included Usage",
                    ServiceReference: null,
                    StartDate: startDate,
                    TotalAvailableAmount: 0,
                    Type: null,
                    Unit: "$",
                    UnitNarrative: null,
                    UsageNarrative: null,
                    UsagePeriod: period,
                    UsageTiers: null,
                })],
        });
    }
    exports.GenerateTelcoDemoUsage = GenerateTelcoDemoUsage;
});
define("app/sds/string/type/sds-string-type", ["require", "exports", "app/selcomm/service"], function (require, exports, service_38) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function validate(stringTypeCode, value) {
        return service_38.Service.Validation.StringValidate({
            TestString: value,
            StringType: stringTypeCode,
        });
    }
    exports.validate = validate;
    function validateForServiceType(stringTypeCode, serviceTypeCode, value) {
        return service_38.Service.Validation.StringValidateForServiceTypeCode({
            TestString: value,
            StringType: stringTypeCode,
            ServiceTypeCode: serviceTypeCode,
        });
    }
    exports.validateForServiceType = validateForServiceType;
});
define("app/selcomm/authentication/test/selcomm-authentication-test", ["require", "exports", "app/utils", "app/selcomm/authentication/selcomm-authentication-service"], function (require, exports, utils, auth) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller() {
        }
        Object.defineProperty(Controller.prototype, "CurrentLocalSessionKey", {
            get: function () {
                return auth.CurrentSessionStoreKey;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CurrentSessionKey", {
            get: function () {
                return auth.CurrentSession ? auth.CurrentSession.SessionKey : null;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Login = function (loginCode, password, tfaCode) {
            auth.StartSession("demo")
                .then(function (session) { return session.Authenticate(loginCode, password, tfaCode).then(function (result) { return session; }); })
                .then(function (session) {
                auth.CurrentSessionStoreKey = auth.AddSessionWithNewKey(session);
            });
        };
        Controller = __decorate([
            utils.Component({ Name: "selcomm-authentication-test" })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sf/as/html/sf-as-html-filter", ["require", "exports", "app/basic-utils", "scripts/lib/select-development/sss-names"], function (require, exports, utils, names) {
    "use strict";
    function Normalise(obj) {
        if (!obj || utils.IsVoid(obj.tag))
            return { tag: null, attributes: {}, };
        return {
            tag: String(obj.tag),
            attributes: angular.map(obj.attributes, String)
        };
    }
    return function asHtml(obj) {
        var _a = Normalise(obj), tag = _a.tag, attributes = _a.attributes;
        if (utils.IsVoid(tag))
            return "";
        return names.HtmlFor(tag, attributes);
    };
});
define("app/ss/bill/download/ss-bill-download-service", ["require", "exports", "app/selcomm/service", "app/utils"], function (require, exports, service_39, utils) {
    "use strict";
    function BillService(targetAccount, billOrBillNumber, billType) {
        if (billType === void 0) { billType = "pdf"; }
        var billNumber = (utils.IsObject(billOrBillNumber) ? billOrBillNumber.Number : billOrBillNumber).trim();
        service_39.DownloadService.Bill.BillFile({
            BillNumber: billNumber,
            BillType: billType,
            ContactCode: service_39.Auth.CurrentSession.CurrentContactCode,
        });
    }
    (function (BillService) {
        function GetDeets(billType) {
            switch (billType) {
                case "excel":
                    return { mimeType: "application/vnd.ms-excel", fileExtension: "xls" };
                case "pdf":
                default:
                    return { mimeType: "application/pdf", fileExtension: "pdf" };
            }
        }
        BillService.GetDeets = GetDeets;
    })(BillService || (BillService = {}));
    return BillService;
});
define("app/ss/bill/latest/ss-bill-latest", ["require", "exports", "app/utils", "service!sdc-stacked-section", "app/ng-utils", "module", "app/selcomm/service", "app/sds/contact/sds-contact"], function (require, exports, utils, _stackedSectionService, ng_utils_37, module_48, service_40, contact) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var stackedSectionService = _stackedSectionService;
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.AmountOwingLoader = new utils.Loader(function (contactCode) { return Controller_40.getAmountOwing(contactCode); });
            _this.LatestBillLoader = new utils.Loader(function (contactCode) { return Controller_40.getLatestBill(contactCode); });
            _this.currentDate = new Date();
            _this.AccountDueSummaryLoader = new utils.Loader(function (contactCode) { return _this.getAccountDueSummary(contactCode); });
            _this.ExcelBillDisplayLoader = new utils.Loader(function (busUnit) { return _this.getExcelBillDisplay(busUnit); });
            _this.ExcelBillDisplay = false;
            return _this;
        }
        Controller_40 = Controller;
        Object.defineProperty(Controller.prototype, "ContactCode", {
            get: function () {
                return utils.IsVoid(this.ContactController) ? this.ContactController : this.ContactController.ContactCode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CanMakePayments", {
            get: function () {
                return !utils.IsVoid(this.BoundOpenMakePayment);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "paymentsEnabled", {
            get: function () {
                return utils.IsVoid(this.AmountOwning) ? true : this.AmountOwning.Balance > 0;
            },
            enumerable: true,
            configurable: true
        });
        Controller.getLatestBill = function (contactCode) {
            return __awaiter(this, void 0, ng_utils_37.$q, function () {
                var billList, _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _b = (_a = utils.List).Create;
                            return [4, service_40.Service.Bill.BillList({
                                    PagingSortsAndFilters: new service_40.Selcomm.Filters.PagingSortsAndFilters({
                                        SkipRecords: 0,
                                        TakeRecords: 1,
                                        Sorts: [service_40.SortService.For().On("Sequence").Descending()],
                                    }),
                                })];
                        case 1:
                            billList = _b.apply(_a, [_c.sent()]);
                            return [2, utils.Collection.FirstOrDefault(billList)];
                    }
                });
            });
        };
        Controller.prototype.OpenMakePayment = function ($event) {
            if (utils.IsVoid(this.BoundOpenMakePayment)) {
                utils.Toast.Simple("Payments are not available at this time.");
                return;
            }
            this.BoundOpenMakePayment({
                $event: $event,
                defaultAmount: this.DefaultPaymentAmount,
            });
        };
        Object.defineProperty(Controller.prototype, "DefaultPaymentAmount", {
            get: function () {
                if (!utils.IsVoid(this.AmountOwning) && this.AmountOwning.Balance > 0)
                    return this.AmountOwning.Balance;
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.downloadBill = function () {
            if (utils.IsVoid(this.latestBill) || utils.IsVoid(this.ContactController) || utils.IsNullOrWhitespace(this.ContactController.ContactCode)) {
                utils.Toast.Simple("We cannot download your last bill at this time.");
                return;
            }
            service_40.DownloadService.Bill.BillFile({
                BillNumber: this.latestBill && this.latestBill.Number.trim(),
                BillType: "pdf",
                ContactCode: this.ContactController.ContactCode,
            });
        };
        Controller.prototype.downloadExcelBill = function () {
            service_40.DownloadService.Bill.BillFile({
                BillNumber: this.latestBill && this.latestBill.Number.trim(),
                BillType: "excel",
                ContactCode: this.ContactController.ContactCode,
            });
        };
        Controller.getAmountOwing = function (contactCode) {
            return service_40.Service.Account.AccountBalance({
                AccountNumber: contactCode,
                IncludeUnbilledUsage: false,
                IncludeOneOffAndRecurringCharges: true
            });
        };
        Object.defineProperty(Controller.prototype, "AmountOwning", {
            get: function () {
                return this.AmountOwingLoader.Value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "latestBill", {
            get: function () {
                return this.LatestBillLoader.Value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.AmountOwingLoader.IsLoading || this.LatestBillLoader.IsLoading || this.ExcelBillDisplayLoader.IsLoading;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Init = function () {
            return __awaiter(this, void 0, void 0, function () {
                var contactCode, bill, busUnitCode;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            contactCode = this.ContactCode;
                            if (utils.IsVoid(contactCode)) {
                                utils.Toast.Simple("An error occurred loading your balance details.");
                                throw new Error("No contact available");
                            }
                            this.AmountOwingLoader.DurableLoad({
                                delayDuration: 500,
                                timeoutDuration: 20000,
                            }, contactCode);
                            return [4, this.LatestBillLoader.DurableLoad({
                                    delayDuration: 500,
                                    timeoutDuration: 20000,
                                }, contactCode)];
                        case 1:
                            bill = _a.sent();
                            this.AccountDueSummaryLoader.DurableLoad({
                                delayDuration: 500,
                                timeoutDuration: 20000,
                            }, contactCode);
                            busUnitCode = service_40.Auth.CurrentSession.BusinessUnitCode;
                            this.ExcelBillDisplayLoader.DurableLoad({
                                delayDuration: 500,
                                timeoutDuration: 20000,
                            }, busUnitCode);
                            return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "AccountDueSummary", {
            get: function () {
                return this.AccountDueSummaryLoader.Value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.getAccountDueSummary = function (contactCode) {
            return service_40.Service.Account.AccountBalanceSummary({
                ContactCode: contactCode,
            });
        };
        Controller.prototype.getExcelBillDisplay = function (businessUnitCode) {
            var _this = this;
            service_40.Service.Configuration.GetConfigValue({
                Key: "SHOW_EXCEL_BILL_BUTTON_" + businessUnitCode,
                AlternateKey: "SHOW_EXCEL_BILL_BUTTON",
                DefaultValue: 'N',
            }).then(function (r) { return _this.ExcelBillDisplay = (r == "Y") ? true : false; });
        };
        __decorate([
            utils.Bind.Controller(contact.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "ContactController", void 0);
        __decorate([
            utils.Bind.Getter("open-make-payment", { optional: true })
        ], Controller.prototype, "BoundOpenMakePayment", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = Controller_40 = __decorate([
            utils.Component({
                ModuleId: module_48.id,
            })
        ], Controller);
        return Controller;
        var Controller_40;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/payment/history/ss-payment-history", ["require", "exports", "app/utils", "app/selcomm/service"], function (require, exports, utils, service_41) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.PageSize = 20;
            _this.TransactionsList = new utils.md.DynamicItems(_this.PageSize, function (paging) { return Controller_41.GetTransactions(paging.SkipRecords, paging.TakeRecords); });
            return _this;
        }
        Controller_41 = Controller;
        Controller.GetTransactions = function (skipRecords, takeRecords) {
            return service_41.Service.Financial.FinancialTransactionList({
                PagingSortsAndFilters: new service_41.Selcomm.Filters.PagingSortsAndFilters({
                    SkipRecords: skipRecords,
                    TakeRecords: takeRecords,
                    Filter: service_41.Filter.For().On("Type").On("Code").In(["R", "RF", "I"]),
                })
            });
        };
        Controller = Controller_41 = __decorate([
            utils.Component({
                Name: "ss-payment-history",
            })
        ], Controller);
        return Controller;
        var Controller_41;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/ss/payment/makepayment/ss-payment-makepayment", ["require", "exports", "app/utils", "app/selcomm/service", "app/sdc/closable/section/sdc-closable-section", "app/sds/payment/service", "$q", "app/sds/contact/sds-contact"], function (require, exports, utils, service_42, closableSection, payment, $q, selectedContact) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Steps = utils.StepPath.Create(Controller_42.Step.SelectPaymentMethod);
            _this.AvailableRegistrationTypeTargetsLoader = new utils.CollectionLoader(function (contactCode) { return payment.RegistrationTypeTargets.GetForContact(contactCode); });
            _this.SubmitPaymentActivity = new utils.ActivityController("submit-payment");
            _this.ThirdPartyRegisterActivity = new utils.ActivityController("third-party-register");
            _this.IsDisposed = false;
            _this.OnDispose(function () { return _this.IsDisposed = true; });
            _this.Watch(function () { return _this.SelectedContact.ContactCode; }, function (contactCode) { return _this.AvailableRegistrationTypeTargetsLoader.Load(utils.AssertNotVoid(contactCode)); });
            _this.Watch.Collection(function () { return _this.AvailableRegistrationTypeTargets; }, function (available) {
                if (available.length === 1)
                    _this.SelectedRegistrationTypeTarget = available[0];
                if (!utils.IsVoid(_this.SelectedRegistrationTypeTarget) && available.indexOf(_this.SelectedRegistrationTypeTarget) < 0)
                    _this.SelectedRegistrationTypeTarget = null;
            });
            _this.Watch(function () { return utils.IsVoid(_this.SelectedRegistrationTypeTarget) ? _this.SelectedRegistrationTypeTarget : _this.SelectedRegistrationTypeTarget.RegistrationType; }, function (registrationType, lastRegistrationType) {
                switch (_this.CurrentStep) {
                    case Controller_42.Step.EnterDetails:
                        _this.GoBackUntil(Controller_42.Step.SelectRegistrationType);
                        break;
                }
            });
            _this.Watch.Group({
                step: function () { return _this.CurrentStep; },
                isValid: function () { return _this.AvailableRegistrationTypeTargetsLoader.IsValid; },
            }, function (x) {
                var step = x.step, isValid = x.isValid;
                if (_this.CurrentStep !== step)
                    return;
                if (step !== Controller_42.Step.SelectRegistrationType)
                    return;
                if (!isValid || !_this.AvailableRegistrationTypeTargetsLoader.IsValid)
                    return;
                if (_this.AvailableRegistrationTypeTargets.length !== 1)
                    return;
                if (_this.AvailableRegistrationTypeTargets[0].RegistrationType === payment.RegistrationType.ThirdParty)
                    return;
                switch (_this.Steps.Momentum) {
                    case utils.StepPath.Direction.Forward:
                        _this.Steps.NavigateForward(Controller_42.Step.EnterDetails);
                        break;
                    case utils.StepPath.Direction.Back:
                        _this.Steps.GoBack();
                        break;
                }
            });
            _this.Agreement = service_42.Auth.CurrentSession.CreditCardAgreement_HTML === "null" ? "" : service_42.Auth.CurrentSession.CreditCardAgreement_HTML;
            return _this;
        }
        Controller_42 = Controller;
        Object.defineProperty(Controller.prototype, "IsExistingPaymentMethod", {
            get: function () {
                return Boolean(this.AccountPaymentMethod && this.AccountPaymentMethod.Id);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CurrentStep", {
            get: function () {
                return this.Steps.CurrentStep;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SelectAccountPaymentMethod = function (form) {
            if ((form && !form.$valid)) {
                utils.Toast.Simple("Confirm that all fields are filled out correctly before trying to send your payment.");
                return;
            }
            this.AccountPaymentMethod = this.SelectedAccountPaymentMethod;
            this.Steps.NavigateForward(utils.IsVoid(this.AccountPaymentMethod) ? Controller_42.Step.SelectRegistrationType : Controller_42.Step.EnterDetails);
        };
        Object.defineProperty(Controller.prototype, "AvailableRegistrationTypeTargets", {
            get: function () {
                return this.AvailableRegistrationTypeTargetsLoader.Values;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "SendingPayment", {
            get: function () {
                return this.SubmitPaymentActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SubmitPayment = function (form) {
            return __awaiter(this, void 0, $q, function () {
                var token, result_1, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.SubmitPaymentActivity.TryEnter();
                            if (!token) {
                                utils.Toast.Simple("You can only send one payment at a time.");
                                throw new utils.AlreadyDoingActionError(this.SubmitPaymentActivity.Name);
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Confirm that all fields are filled out correctly before trying to send your payment.");
                                throw new utils.FormInvalidError(form);
                            }
                            if (!this.AccountPaymentMethod || !this.AccountPaymentMethod.Id) {
                                result_1 = this.AssertCanSelcommRegister(this.AccountPaymentMethod);
                                if (!utils.IsVoid(result_1)) {
                                    utils.Toast.Simple(result_1.DisplayMessage);
                                    throw new Error(result_1.SystemMessage);
                                }
                            }
                            if (utils.IsVoid(this.PaymentAmount) || utils.IsVoid(this.AccountPaymentMethod)) {
                                utils.Toast.Simple("Confirm that all fields are filled out correctly before trying to send your payment.");
                                throw new Error("Missing PaymentAmount or method.");
                            }
                            if (utils.IsVoid(this.SelectedContact.ContactCode)) {
                                utils.Toast.Simple("An error occurred, if contacting support please provide the following code: 94470C32-9955-4C14-9A33-C0003B6A66AD.");
                                throw new Error("Cannot determine the contact code: 94470C32-9955-4C14-9A33-C0003B6A66AD");
                            }
                            return [4, payment.SendPayment(this.SelectedContact.ContactCode, this.PaymentAmount, this.AccountPaymentMethod)];
                        case 2:
                            result = _a.sent();
                            this.ApplyResult(result);
                            return [2, result];
                        case 3:
                            token.Exit();
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.AcceptThirdPartyRegistered = function (accountPaymentMethod) {
            this.SelectedAccountPaymentMethod = accountPaymentMethod;
            this.AccountPaymentMethod = accountPaymentMethod;
        };
        Controller.prototype.RejectThirdPartyRegisterFailure = function (reason) {
            this.ApplyResult(new payment.ThirdParty.PaymentMethodRegister.RegisterFailedPaymentResult(reason));
        };
        Controller.prototype.AssertCanSelcommRegister = function (accountPaymentMethod) {
            if (!this.AvailableRegistrationTypeTargetsLoader.IsValid || utils.IsVoid(this.AvailableRegistrationTypeTargets) || this.AvailableRegistrationTypeTargets.length < 1) {
                return {
                    DisplayMessage: "Hold on, we're trying to determine how you can enter your details.",
                    SystemMessage: "Still waiting on this.RegistrationTypeLoader",
                };
            }
            if (utils.IsVoid(accountPaymentMethod)) {
                return;
            }
            else {
                var canRegisterWithSelcomm = utils.Collection
                    .ToEnumerable(this.AvailableRegistrationTypeTargets)
                    .Where(function (rtt) { return rtt.RegistrationType === payment.RegistrationType.Selcomm; })
                    .Any(function (rtt) {
                    return utils.IsVoid(rtt.RestrictedTo) ||
                        rtt.RestrictedTo.findIndex(function (p) { return p instanceof service_42.Selcomm.Payment.PaymentMethod ? p.Code === accountPaymentMethod.PaymentMethod.Code : p.Code == accountPaymentMethod.PaymentMethod.Type.Code; }) >= 0;
                });
                if (canRegisterWithSelcomm)
                    return;
                return {
                    DisplayMessage: "We need to register your payment details with a third-party. Please review the instructions above.",
                    SystemMessage: "Cannot do selcomm registration",
                };
            }
        };
        Controller.prototype.ApplyResult = function (result) {
            this.Result = result;
            this.Steps.NavigateForward(Controller_42.Step.Result);
        };
        Controller.prototype.GoBack = function (target) {
            if (!this.Steps.Any())
                throw new Error("Already at the first step!");
            this.Steps.GoBack();
        };
        Controller.prototype.GoBackUntil = function (targetStep) {
            if (!this.Steps.Any())
                throw new Error("Already at the first step!");
            this.Steps.GoBackWhile(function (c) { return c !== targetStep; });
        };
        Object.defineProperty(Controller.prototype, "CanClose", {
            get: function () {
                return !utils.IsVoid(this.BoundCancel) || !utils.IsVoid(this.ClosableSection);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Close = function () {
            if (this.BoundCancel)
                this.BoundCancel();
            else if (this.ClosableSection)
                this.ClosableSection.Close();
        };
        Object.defineProperty(Controller.prototype, "ResultWarn", {
            get: function () {
                if (!this.Result)
                    return false;
                switch (this.Result.StatusType) {
                    case payment.Result.StatusType.Pending:
                    case payment.Result.StatusType.Resolved:
                        return false;
                    default:
                        return true;
                }
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SelectRegistrationTypeTarget = function (target, event, form) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, token, request, _b, _c, err_38;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if ((form && !form.$valid)) {
                                utils.Toast.Simple("Confirm that all fields are filled out correctly before trying to send your payment.");
                                return [2];
                            }
                            if (utils.IsVoid(target)) {
                                utils.Toast.Simple("Select an option above.");
                                throw new Error("Invalid target");
                            }
                            _a = target.RegistrationType;
                            switch (_a) {
                                case payment.RegistrationType.Selcomm: return [3, 1];
                                case payment.RegistrationType.ThirdParty: return [3, 2];
                            }
                            return [3, 11];
                        case 1:
                            this.Steps.NavigateForward(Controller_42.Step.EnterDetails);
                            return [2];
                        case 2:
                            token = this.ThirdPartyRegisterActivity.CloseAndEnter();
                            _d.label = 3;
                        case 3:
                            _d.trys.push([3, , 9, 10]);
                            request = payment.ThirdParty.PaymentMethodRegister.Invoke({
                                targetContactCode: utils.AssertNotVoid(this.SelectedContact.ContactCode),
                                notFinalStep: true,
                            });
                            _d.label = 4;
                        case 4:
                            _d.trys.push([4, 6, 7, 8]);
                            request.OpenModal(event);
                            _b = this;
                            _c = this;
                            return [4, request.AccountPaymentMethod];
                        case 5:
                            _b.SelectedAccountPaymentMethod = _c.AccountPaymentMethod = _d.sent();
                            this.Steps.NavigateForward(Controller_42.Step.EnterDetails);
                            return [3, 8];
                        case 6:
                            err_38 = _d.sent();
                            if (err_38 instanceof payment.ThirdParty.PaymentMethodRegister.Request.CancelledError)
                                return [2];
                            this.ApplyResult(new payment.ThirdParty.PaymentMethodRegister.RegisterFailedPaymentResult(err_38));
                            return [3, 8];
                        case 7:
                            if (!this.IsDisposed)
                                request.TryCloseRegistrationWindow();
                            return [7];
                        case 8: return [3, 10];
                        case 9:
                            token.Exit();
                            return [7];
                        case 10: return [2];
                        case 11: return [2];
                    }
                });
            });
        };
        Controller.prototype.IsRegistrationFailure = function (result) {
            if (utils.IsVoid(result))
                return false;
            return result instanceof payment.ThirdParty.PaymentMethodRegister.RegisterFailedPaymentResult;
        };
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents })
        ], Controller.prototype, "SelectedContact", void 0);
        __decorate([
            utils.Bind.Controller(closableSection.Controller, { optional: true, mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "ClosableSection", void 0);
        __decorate([
            utils.Bind.In("default-amount", { optional: true })
        ], Controller.prototype, "DefaultAmount", void 0);
        __decorate([
            utils.Bind.Getter("cancel", { optional: true })
        ], Controller.prototype, "BoundCancel", void 0);
        Controller = Controller_42 = __decorate([
            utils.Component({
                Name: "ss-payment-makepayment",
            })
        ], Controller);
        return Controller;
        var Controller_42;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    (function (Controller) {
        var Step;
        (function (Step) {
            Step["SelectPaymentMethod"] = "select-payment-method";
            Step["SelectRegistrationType"] = "select-registration-type";
            Step["EnterDetails"] = "enter-details";
            Step["Result"] = "display-result";
        })(Step = Controller.Step || (Controller.Step = {}));
        ;
    })(Controller = exports.Controller || (exports.Controller = {}));
    exports.Controller = Controller;
});
define("app/ss/payment/settings/ss-payment-settings", ["require", "exports", "app/utils", "module", "app/ng-utils", "app/selcomm/service"], function (require, exports, utils, module_49, ng_utils_38, service_43) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.AllLoader = new utils.CollectionLoader.Readonly(function () { return service_43.Service.Payment.AccountPaymentMethodList({ ContactCode: service_43.Auth.CurrentSession.CurrentContactCode }); });
            _this.ValidLoader = new utils.CollectionLoader.Readonly(function () { return service_43.Service.Payment.AccountPaymentMethodListValidOnline({ ContactCode: service_43.Auth.CurrentSession.CurrentContactCode }); });
            _this.SaveNewDefaultActivity = new utils.ActivityController("SaveNewDefault");
            _this.ValidLoader.DurableLoad({ delayDuration: 200, timeoutDuration: null, });
            _this.AllLoader.DurableLoad({ delayDuration: 200, timeoutDuration: null, });
            return _this;
        }
        Controller_43 = Controller;
        Object.defineProperty(Controller.prototype, "AutoPaymentsEnabled", {
            get: function () {
                if (!utils.IsVoid(this.NewAutoPaymentsState))
                    return this.NewAutoPaymentsState;
                var defaultApm = this.GetCurrentDefault();
                return !utils.IsVoid(defaultApm) && !Controller_43.IsRemittance(defaultApm);
            },
            set: function (value) {
                this.NewAutoPaymentsState = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "DefaultAccountPaymentMethod", {
            get: function () {
                if (!this.AutoPaymentsEnabled)
                    return utils.Collection.FirstOrDefault(this.All, function (apm) { return Controller_43.IsRemittance(apm); });
                if (!utils.IsVoid(this.NewDefaultAccountPaymentMethod))
                    return this.NewDefaultAccountPaymentMethod;
                return this.GetCurrentDefault(utils.Collection.FirstOrDefault(this.Valid));
            },
            set: function (value) {
                this.NewDefaultAccountPaymentMethod = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "AvailableDefaults", {
            get: function () {
                return this.Valid.filter(function (apm) { return !Controller_43.IsRemittance(apm); });
            },
            enumerable: true,
            configurable: true
        });
        Controller.IsRemittance = function (target) {
            if (utils.IsString(target))
                return target === "R";
            if (target instanceof service_43.Selcomm.Payment.PaymentMethodType)
                return Controller_43.IsRemittance(target.Code);
            if (target instanceof service_43.Selcomm.Payment.PaymentMethod)
                return Controller_43.IsRemittance(target.Type);
            if (target instanceof service_43.Selcomm.Payment.AccountPaymentMethod)
                return Controller_43.IsRemittance(target.PaymentMethod);
            throw new Error();
        };
        Controller.prototype.GetCurrentDefault = function (valueIfNotFound) {
            var defaultApm = valueIfNotFound;
            if (this.ValidLoader.HasLoaded)
                defaultApm = utils.Collection.FirstOrDefault(this.ValidLoader.Values, function (apm) { return apm.Default; }, valueIfNotFound);
            if (this.AllLoader.HasLoaded && !defaultApm)
                defaultApm = utils.Collection.FirstOrDefault(this.ValidLoader.Values, function (apm) { return apm.Default; }, valueIfNotFound);
            return defaultApm;
        };
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.AllLoader.IsLoading || this.ValidLoader.IsLoading || this.SaveNewDefaultActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "All", {
            get: function () {
                return this.AllLoader.Values;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Valid", {
            get: function () {
                return this.ValidLoader.Values;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SaveNewDefault = function (newDefault, form) {
            return __awaiter(this, void 0, ng_utils_38.$q, function () {
                var token, newDefaultId, _a, _b, apm, err_39, e_92, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            token = this.SaveNewDefaultActivity.Enter();
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 3, 4, 5]);
                            newDefaultId = newDefault.Id;
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Confirm the details are correct and try again.");
                                throw new utils.FormInvalidError(form);
                            }
                            return [4, service_43.Service.Payment.AccountPaymentMethodMakeDefault({
                                    Id: newDefaultId,
                                })];
                        case 2:
                            _d.sent();
                            try {
                                for (_a = __values(__spread(this.All, this.Valid)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                    apm = _b.value;
                                    apm.Default = apm.Id === newDefaultId;
                                }
                            }
                            catch (e_92_1) { e_92 = { error: e_92_1 }; }
                            finally {
                                try {
                                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                }
                                finally { if (e_92) throw e_92.error; }
                            }
                            utils.Toast.Simple("Successfully updated your automatic payment details.");
                            this.OnDefaultUpdated({ newDefault: newDefault, });
                            return [3, 5];
                        case 3:
                            err_39 = _d.sent();
                            utils.Toast.Simple("An error occurred");
                            throw err_39;
                        case 4:
                            token.Exit();
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "NoChange", {
            get: function () {
                var oldDefault = this.GetCurrentDefault();
                var newDefault = this.DefaultAccountPaymentMethod;
                if ((utils.IsVoid(oldDefault) || Controller_43.IsRemittance(oldDefault)) && (utils.IsVoid(newDefault) || Controller_43.IsRemittance(newDefault)))
                    return true;
                if ((utils.IsVoid(oldDefault) || Controller_43.IsRemittance(oldDefault)) || (utils.IsVoid(newDefault) || Controller_43.IsRemittance(newDefault)))
                    return false;
                return oldDefault.Id === newDefault.Id;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Getter("on-default-updated")
        ], Controller.prototype, "OnDefaultUpdated", void 0);
        Controller = Controller_43 = __decorate([
            utils.Component({
                ModuleId: module_49.id,
            })
        ], Controller);
        return Controller;
        var Controller_43;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/paymentmethod/create/ss-paymentmethod-create", ["require", "exports", "module", "app/utils", "app/ng-utils", "app/sds/payment/service", "app/sds/contact/sds-contact", "app/sdc/closable/section/sdc-closable-section"], function (require, exports, module_50, utils, ng_utils_39, payment, selectedContact, closableSection) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.AvailableRegistrationOptionsLoader = new utils.CollectionLoader.Readonly(function (contactCode) { return payment.RegistrationTypeTargets.GetForContact(contactCode); });
            _this.StepPath = utils.StepPath.Create(Controller_44.Step.SelectRegistrationOption);
            _this.Watch(function () { return _this.SelectedContact && _this.SelectedContact.ContactCode; }, function (contactCode) { return utils.IsVoid(contactCode) ? _this.AvailableRegistrationOptionsLoader.Reset() : _this.AvailableRegistrationOptionsLoader.Load(contactCode); });
            _this.Watch(function () { return utils.IsVoid(_this.SelectedRegistrationOption) || _this.AvailableRegistrationOptions.includes(_this.SelectedRegistrationOption); }, function (isValidOption) { return _this.SelectedRegistrationOption = null; });
            _this.Watch(function () { return _this.AvailableRegistrationOptions.length === 1 ? _this.AvailableRegistrationOptions[0] : null; }, function (singleRegOption) { return !utils.IsVoid(singleRegOption) && (_this.SelectedRegistrationOption = singleRegOption); });
            _this.Watch.Group({
                step: function () { return _this.CurrentStep; },
                isValid: function () { return _this.AvailableRegistrationOptionsLoader.IsValid; },
                avalRegTypeTargets: function () { return _this.AvailableRegistrationOptions; },
            }, function (x) {
                var step = x.step, isValid = x.isValid, avalRegTypeTargets = x.avalRegTypeTargets;
                if (step !== _this.CurrentStep)
                    return;
                if (_this.AvailableRegistrationOptions !== avalRegTypeTargets)
                    return;
                if (!isValid || !_this.AvailableRegistrationOptionsLoader.IsValid)
                    return;
                switch (step) {
                    case Controller_44.Step.SelectRegistrationOption:
                        if (avalRegTypeTargets.length !== 1)
                            break;
                        var onlyTarget = avalRegTypeTargets[0];
                        switch (onlyTarget.RegistrationType) {
                            case payment.RegistrationType.Selcomm:
                                switch (_this.StepPath.Momentum) {
                                    case utils.StepPath.Direction.Forward:
                                        _this.StepPath.NavigateForward(Controller_44.Step.SelcommRegistration);
                                        break;
                                    case utils.StepPath.Direction.Back:
                                        if (_this.ClosableSection)
                                            _this.ClosableSection.Close();
                                        else
                                            _this.StepPath.NavigateForward(Controller_44.Step.SelcommRegistration);
                                        break;
                                }
                                break;
                        }
                        break;
                }
            });
            return _this;
        }
        Controller_44 = Controller;
        Object.defineProperty(Controller.prototype, "AvailableRegistrationOptions", {
            get: function () {
                return this.AvailableRegistrationOptionsLoader.Values;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CurrentStep", {
            get: function () {
                return this.StepPath.CurrentStep;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SelectRegistrationOption = function (registrationOption, event, form) {
            return __awaiter(this, void 0, ng_utils_39.$q, function () {
                var request;
                return __generator(this, function (_a) {
                    if (form && !form.$valid) {
                        utils.Toast.Simple("Some inputs are invalid");
                        throw new utils.FormInvalidError(form);
                    }
                    if (utils.IsVoid(registrationOption)) {
                        switch (this.AvailableRegistrationOptions.length) {
                            case 0:
                                utils.Toast.Simple("An internal error occurred");
                                throw new Error("No registration options");
                            case 1:
                                if (!this.AvailableRegistrationOptionsLoader.IsValid) {
                                    utils.Toast.Simple("An internal error occurred");
                                    throw new Error("No registration options");
                                }
                                this.SelectedRegistrationOption = registrationOption = this.AvailableRegistrationOptions[0];
                                break;
                            default:
                                utils.Toast.Simple("Select an option from above");
                                throw new Error("No registration option selected");
                        }
                    }
                    switch (registrationOption.RegistrationType) {
                        case payment.RegistrationType.Selcomm:
                            this.StepPath.NavigateForward(Controller_44.Step.SelcommRegistration);
                            break;
                        case payment.RegistrationType.ThirdParty:
                            request = payment.ThirdParty.PaymentMethodRegister.Invoke({
                                targetContactCode: utils.AssertNotVoid(this.SelectedContact.ContactCode),
                                notFinalStep: true,
                            });
                            this.ShowThirdPartyRegistrationDialog(request, event);
                            this.AwaitThirdPartyRegister(request);
                            break;
                    }
                    return [2];
                });
            });
        };
        Controller.prototype.AwaitThirdPartyRegister = function (request) {
            return __awaiter(this, void 0, ng_utils_39.$q, function () {
                var accountPaymentMethod;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, request.AccountPaymentMethod];
                        case 1:
                            accountPaymentMethod = _a.sent();
                            this.BoundOnCreate({ accountPaymentMethod: accountPaymentMethod });
                            return [2, accountPaymentMethod];
                    }
                });
            });
        };
        Controller.prototype.OnSelcommCreate = function (accountPaymentMethod) {
            try {
                this.BoundOnCreate({ accountPaymentMethod: accountPaymentMethod });
            }
            finally {
                if (this.ClosableSection)
                    this.ClosableSection.Close();
            }
        };
        Controller.prototype.ShowThirdPartyRegistrationDialog = function (request, event) {
            return __awaiter(this, void 0, ng_utils_39.$q, function () {
                var alert, dialog;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            alert = ng_utils_39.$mdDialog
                                .alert()
                                .disableParentScroll(false)
                                .title("Payment Registration")
                                .textContent("We have opened a new window where you can register your payment method. If you cannot find the window make sure that it has not been blocked by any pop-up blockers in your browser.")
                                .ok("Dismiss");
                            if (!utils.IsVoid(event))
                                alert.targetEvent(event);
                            dialog = ng_utils_39.$mdDialog.show(alert);
                            return [4, dialog];
                        case 1:
                            _a.sent();
                            if (this.ClosableSection)
                                this.ClosableSection.Close();
                            return [2];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents, })
        ], Controller.prototype, "SelectedContact", void 0);
        __decorate([
            utils.Bind.Controller(closableSection.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents, optional: true, })
        ], Controller.prototype, "ClosableSection", void 0);
        __decorate([
            utils.Bind.Getter("on-create")
        ], Controller.prototype, "BoundOnCreate", void 0);
        __decorate([
            utils.Bind.TranscludeSlot("additional-actions", { optional: true })
        ], Controller.prototype, "AdditionalActions", void 0);
        Controller = Controller_44 = __decorate([
            utils.Component({
                ModuleId: module_50.id,
            })
        ], Controller);
        return Controller;
        var Controller_44;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    (function (Controller) {
        var Step;
        (function (Step) {
            Step["SelectRegistrationOption"] = "select-registration-option";
            Step["SelcommRegistration"] = "selcomm-registration";
        })(Step = Controller.Step || (Controller.Step = {}));
    })(Controller = exports.Controller || (exports.Controller = {}));
    exports.Controller = Controller;
});
define("app/ss/paymentmethod/fancy/ss-paymentmethod-fancy", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller() {
        }
        Object.defineProperty(Controller.prototype, "PaymentMethod", {
            get: function () {
                return this.AccountPaymentMethod && this.AccountPaymentMethod.PaymentMethod;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "PaymentMethodCode", {
            get: function () {
                if (!this.PaymentMethod)
                    return undefined;
                return this.PaymentMethod.Code;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "PaymentMethodType", {
            get: function () {
                return this.PaymentMethod && this.PaymentMethod.Type;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "PaymentMethodTypeCode", {
            get: function () {
                if (!this.PaymentMethodType)
                    return undefined;
                return this.PaymentMethodType.Code;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Glyphicon", {
            get: function () {
                switch (this.PaymentMethodTypeCode) {
                    case "C":
                        switch (this.PaymentMethodCode) {
                            case "VI":
                                return { Glyphicon: new FontAwesomeGlyphicon("cc-visa"), generic: false, };
                            case "MC":
                                return { Glyphicon: new FontAwesomeGlyphicon("cc-mastercard"), generic: false, };
                            default:
                                return { Glyphicon: new FontAwesomeGlyphicon("credit-card"), generic: true };
                        }
                    case "D":
                        return { Glyphicon: new FontAwesomeGlyphicon("credit-card"), generic: true };
                }
                return null;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.In("account-payment-method")
        ], Controller.prototype, "AccountPaymentMethod", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "ss-paymentmethod-fancy",
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
    var FontAwesomeGlyphicon = (function () {
        function FontAwesomeGlyphicon(Name) {
            this.Name = Name;
        }
        Object.defineProperty(FontAwesomeGlyphicon.prototype, "Class", {
            get: function () {
                return "fa fa-" + this.Name;
            },
            enumerable: true,
            configurable: true
        });
        return FontAwesomeGlyphicon;
    }());
});
define("app/ss/paymentmethod/select/ss-paymentmethod-select", ["require", "exports", "app/utils", "app/selcomm/service", "app/sds/contact/sds-contact", "moment"], function (require, exports, utils, service_44, selectedContact, moment) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.AccountPaymentMethodsLoader = new utils.CollectionLoader(function (contactCode) { return Controller_45.LoadAccountPaymentMethods(contactCode); });
            _this.Watch(function () { return _this.Form && _this.Form.$dirty; }, function (dirty) { return dirty && _this.NgModel.$setDirty(); });
            return _this;
        }
        Controller_45 = Controller;
        Controller.prototype.SelectedGetterSetter = function (value) {
            if (arguments.length === 0)
                return this.GetSelected();
            this.SetSelected(value);
        };
        Object.defineProperty(Controller.prototype, "AccountPaymentMethods", {
            get: function () {
                return this.AccountPaymentMethodsLoader.Values;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.GetSelected = function () {
            return this.Selected;
        };
        Controller.prototype.SetSelected = function (value) {
            this.Selected = value;
            this.NgModel.$setViewValue(value);
        };
        Controller.prototype.BindNgModel = function (ngModel) {
            var _this = this;
            if (ngModel === void 0) { ngModel = this.NgModel; }
            ngModel.$isEmpty = Controller_45.IsEmpty;
            ngModel.$render = function () { return _this.Render(ngModel.$viewValue); };
        };
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.AccountPaymentMethodsLoader.IsLoading;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.LoadPaymentMethods = function (contactCode) {
            if (contactCode === void 0) { contactCode = this.SelectedContact.ContactCode; }
            return __awaiter(this, void 0, void 0, function () {
                var accountPaymentMethods, priorSelected, _a, defaultAccountPaymentMethod, secondDefault;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (utils.IsVoid(contactCode) || utils.IsWhitespace(contactCode)) {
                                utils.Toast.Simple("An error occurred whilst trying to load the payment methods.");
                                this.AccountPaymentMethodsLoader.Reset();
                                throw new Error("No ContactCode for payment method load.");
                            }
                            return [4, this.AccountPaymentMethodsLoader.DurableLoad({
                                    timeoutDuration: 20000,
                                    delayDuration: 500,
                                }, contactCode)];
                        case 1:
                            accountPaymentMethods = _b.sent();
                            priorSelected = this.Selected;
                            if (!utils.IsVoid(priorSelected)) {
                                this.Selected = utils.Collection.FirstOrDefault(accountPaymentMethods, function (apm) { return apm.Id === priorSelected.Id; });
                            }
                            else {
                                _a = __read(accountPaymentMethods.filter(function (apm) { return apm.Default; }), 2), defaultAccountPaymentMethod = _a[0], secondDefault = _a[1];
                                if (!utils.IsVoid(secondDefault))
                                    return [2];
                                if (!defaultAccountPaymentMethod)
                                    return [2];
                                this.SetSelected(defaultAccountPaymentMethod);
                            }
                            return [2];
                    }
                });
            });
        };
        Controller.LoadAccountPaymentMethods = function (contactCode) {
            return __awaiter(this, void 0, void 0, function () {
                var now, accountPaymentMethods;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            now = moment().add("d", -1);
                            return [4, service_44.Service.Payment.AccountPaymentMethodListValid({ ContactCode: utils.AssertNotVoid(contactCode) })];
                        case 1:
                            accountPaymentMethods = _a.sent();
                            return [2, accountPaymentMethods.filter(function (x) { return Controller_45.IsUsable(x, now); })];
                    }
                });
            });
        };
        Controller.prototype.Render = function (value) {
            this.Selected = value;
            if (utils.IsVoid(value))
                return;
            for (var i = 0; i < this.AccountPaymentMethods.length; i++) {
                var accountPaymentMethod = this.AccountPaymentMethods[i];
                if (value.Id !== accountPaymentMethod.Id)
                    continue;
                if (value === accountPaymentMethod)
                    return;
                this.AccountPaymentMethods[i] = value;
                return;
            }
            this.AccountPaymentMethods.push(value);
        };
        Controller.IsEmpty = function (value) {
            return !!value || value === null;
        };
        Controller.IsUsable = function (paymentMethod, asOf) {
            if (!paymentMethod)
                return false;
            if (paymentMethod instanceof service_44.Selcomm.Payment.AccountPaymentMethod) {
                if (paymentMethod.PaymentMethod.Type.ExpiryDateRequired && !utils.IsVoid(paymentMethod.ExpiryDate)) {
                    return asOf.isSameOrBefore(paymentMethod.ExpiryDate, "d");
                }
                return Controller_45.IsUsable(paymentMethod.PaymentMethod, asOf);
            }
            if (paymentMethod instanceof service_44.Selcomm.Payment.PaymentMethod)
                return Controller_45.IsUsable(paymentMethod.Type, asOf);
            switch (paymentMethod.Code) {
                case "D":
                case "C":
                    return true;
                default:
                    return false;
            }
        };
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents })
        ], Controller.prototype, "SelectedContact", void 0);
        __decorate([
            utils.Bind.Controller("ng-model", { optional: true, })
        ], Controller.prototype, "NgModel", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "BindNgModel", null);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "LoadPaymentMethods", null);
        Controller = Controller_45 = __decorate([
            utils.Component({
                Name: "ss-paymentmethod-select",
            })
        ], Controller);
        return Controller;
        var Controller_45;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/service/barring/ss-service-barring", ["require", "exports", "app/utils", "app/selcomm/service"], function (require, exports, utils, service_45) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BarState = (function () {
        function BarState(options) {
            this.unbarRequest = options.unbarRequest;
            this.barRequest = options.barRequest;
        }
        Object.defineProperty(BarState.prototype, "activationRequested", {
            get: function () {
                return this._requested === BarState.RequestType.activate;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BarState.prototype, "deactivationRequested", {
            get: function () {
                return this._requested === BarState.RequestType.deactivate;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BarState.prototype, "errorOccured", {
            get: function () {
                return this._requested === BarState.RequestType.error;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BarState.prototype, "serverMessage", {
            get: function () {
                return this.messageFromServer;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BarState.prototype, "requestDeactivation", {
            get: function () {
                return this.unbarRequest ? this._requestDeactivation : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BarState.prototype, "requestActivation", {
            get: function () {
                return this.barRequest ? this._requestActivation : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BarState.prototype, "request", {
            get: function () {
                return this.requestDeactivation && this.requestActivation ? null : this.requestDeactivation || this.requestActivation;
            },
            enumerable: true,
            configurable: true
        });
        BarState.prototype._requestDeactivation = function (optionsOrServiceReference) {
            return this._sendRequest(BarState.RequestType.deactivate, utils.AssertNotVoid(this.unbarRequest), optionsOrServiceReference);
        };
        BarState.prototype._requestActivation = function (optionsOrServiceReference) {
            return this._sendRequest(BarState.RequestType.activate, utils.AssertNotVoid(this.barRequest), optionsOrServiceReference);
        };
        BarState.prototype._sendRequest = function (sucessState, baseRequest, optionsOrServiceReference) {
            var _this = this;
            if (!utils.IsObject(optionsOrServiceReference))
                optionsOrServiceReference = { ServiceReference: optionsOrServiceReference };
            return service_45.Service.Service.ServiceBarUnbarRequest({
                serviceBarRequest: new service_45.Selcomm.Service.ServiceBarRequest(utils.Extend(baseRequest, optionsOrServiceReference)),
            })
                .then(function (result) {
                _this.messageFromServer = result.Message;
                switch (result.Status) {
                    case 0:
                        _this._requested = sucessState;
                        return true;
                    case 2:
                        throw { code: result.Status };
                    default:
                        throw false;
                }
            }).catch(function (err) {
                _this._requested = BarState.RequestType.error;
                _this.messageFromServer = "Error occured! Please contact support.";
                throw err;
            });
        };
        return BarState;
    }());
    (function (BarState) {
        var RequestType;
        (function (RequestType) {
            RequestType[RequestType["activate"] = 1] = "activate";
            RequestType[RequestType["deactivate"] = 2] = "deactivate";
            RequestType[RequestType["error"] = 3] = "error";
        })(RequestType = BarState.RequestType || (BarState.RequestType = {}));
    })(BarState || (BarState = {}));
    var Controller = (function () {
        function Controller() {
            this.adminBar = new BarState({
                barRequest: {
                    BarReference: "CMAB",
                    ReasonCode: "CR",
                    BulkApply: service_45.Selcomm.Service.BarUnBarBulkApply.N,
                    Note: "Admin bar request"
                }
            });
            this.voicemailBar = new BarState({
                barRequest: {
                    BarReference: "CMDV",
                    ReasonCode: "NR",
                    BulkApply: service_45.Selcomm.Service.BarUnBarBulkApply.N,
                    Note: "Voicemail bar request"
                },
                unbarRequest: {
                    BarReference: "CMCV",
                    ReasonCode: "NR",
                    BulkApply: service_45.Selcomm.Service.BarUnBarBulkApply.N,
                    Note: "Voicemail unbar request"
                }
            });
            this.internationalRoamingBar = new BarState({
                barRequest: {
                    BarReference: "CMIR",
                    ReasonCode: "NR",
                    BulkApply: service_45.Selcomm.Service.BarUnBarBulkApply.N,
                    Note: "International roaming bar request"
                },
                unbarRequest: {
                    BarReference: "CMRI",
                    ReasonCode: "NR",
                    BulkApply: service_45.Selcomm.Service.BarUnBarBulkApply.N,
                    Note: "International roaming unbar request"
                }
            });
            this.loadServiceBarUnbarActions();
        }
        Controller.prototype.loadServiceActions = function (serviceReference) {
            return service_45.Service.Service.ServiceActionDisplayListByServiceID({
                Action: service_45.Selcomm.Service.ServiceActionCategoryType.BarUnbarService,
                ServiceId: serviceReference,
            });
        };
        Controller.prototype.loadServiceBarUnbarActions = function () {
            var _this = this;
            var bars = {
                adminBar: Object.create(this.adminBar),
                voicemailBar: Object.create(this.voicemailBar),
                internationalRoamingBar: Object.create(this.internationalRoamingBar)
            };
            var thisLoading = this.loading = this.loadServiceActions(this.service.Id)
                .then(function (serviceActionDisplayList) {
                var _loop_7 = function (key) {
                    var bar = _this[key];
                    if (!(bar instanceof BarState))
                        return "continue";
                    if (!utils.IsVoid(bar.barRequest)) {
                        var barRequest_1 = bar.barRequest;
                        if (!utils.Collection.Any(serviceActionDisplayList, function (sa) { return barRequest_1.BarReference === sa.Reference; }))
                            bar.barRequest = null;
                    }
                    if (!utils.IsVoid(bar.unbarRequest)) {
                        var unbarRequest_1 = bar.unbarRequest;
                        if (!utils.Collection.Any(serviceActionDisplayList, function (sa) { return unbarRequest_1.BarReference === sa.Reference; }))
                            bar.unbarRequest = null;
                    }
                    if (utils.IsVoid(bar.unbarRequest) && utils.IsVoid(bar.barRequest))
                        _this[key] = null;
                };
                for (var key in _this) {
                    _loop_7(key);
                }
                _this.failedLoad = false;
            })
                .catch(function (err) { return _this.failedLoad = true; })
                .finally(function () {
                if (_this.loading !== thisLoading)
                    return;
                _this.loading = null;
            });
        };
        Object.defineProperty(Controller.prototype, "CanDisplayBarring", {
            get: function () {
                if (utils.IsVoid(this.service))
                    return false;
                return this.service.ServiceStatusPhase === service_45.Selcomm.Service.ServiceStatusPhase.Connected;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "service", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "ss-service-barring",
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/ss/service/overview/ss-service-overview", ["require", "exports", "app/utils", "app/sds/menu/service", "app/selcomm/service", "app/ng-utils"], function (require, exports, utils, menuService, service_46, ng_utils_40) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.IsValidSimForChange = false;
            _this.menuVisible = false;
            _this.LoadingTabs = null;
            _this.EditingServiceName = false;
            _this.UpdatingServiceAction = new utils.ActivityController();
            _this.Watch(function () { return _this.service; }, function (service) {
                var attrs = Controller_46.MakeAttrs(service);
                var menuArgs = {
                    ServiceTypeCode: service.ServiceTypeCode,
                    ServiceSystemStatusCode: service.ServiceSystemStatusCode
                };
                _this.LoadingTabs = menuService.GetMenu.Cached(3001000, menuArgs, Controller_46.MenuItem.Parser)
                    .then(function (menu) { return _this.Tabs = Controller_46.CreateTabsFromMenu(menu, attrs, _this.Offset || 0); });
            });
            _this.CurrentServiceName = _this.NewServiceName = _this.service.UserLabel;
            return _this;
        }
        Controller_46 = Controller;
        Controller.prototype.selectMenuItem = function (menuItem, noMenuToggle) {
            if (noMenuToggle === void 0) { noMenuToggle = false; }
            if (!menuItem) {
                menuItem = this.menu.MenuItemList[0];
            }
            menuItem.loaded = true;
            this.selectedMenuItem = menuItem;
            !noMenuToggle && this.toggleMenu();
        };
        Controller.prototype.isSelected = function (menuItem) {
            return menuItem === this.selectedMenuItem;
        };
        Controller.prototype.mdHue = function (number) {
            var number = number % 4;
            if (number === 0)
                return "";
            return "md-hue-" + number;
        };
        Controller.prototype.toggleMenu = function () {
            this.menuVisible = !this.menuVisible;
        };
        Controller.prototype.EnterEditServiceName = function () {
            this.EditingServiceName = true;
            this.NewServiceName = this.CurrentServiceName;
        };
        Controller.prototype.CancelEditServiceName = function () {
            this.EditingServiceName = false;
        };
        Controller.prototype.UpdateServiceName = function (serviceRef, newServiceName) {
            return __awaiter(this, void 0, ng_utils_40.$q, function () {
                var token, err_40;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.UpdatingServiceAction.Enter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4, service_46.Service.Service.ServiceUpdateServiceNarrative({
                                    ServiceReference: serviceRef,
                                    Narrative: newServiceName,
                                })];
                        case 2:
                            _a.sent();
                            if (token.HasExited)
                                return [2];
                            return [3, 5];
                        case 3:
                            err_40 = _a.sent();
                            if (token.HasExited)
                                return [2];
                            utils.Toast.Simple("Oops! something went wrong. Please try again!");
                            throw err_40;
                        case 4:
                            token.Exit();
                            return [7];
                        case 5:
                            this.CurrentServiceName = newServiceName;
                            utils.Toast.Simple("Your service name updated successfully");
                            this.EditingServiceName = false;
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.SubmitServiceNameForm = function (form) {
            if (form && !form.$valid) {
                utils.Toast.Simple("Some options are not valid, review them before trying again.");
                throw new utils.FormInvalidError(form);
            }
            if (!this.EditingServiceName) {
                this.EnterEditServiceName();
                return;
            }
            this.UpdateServiceName(this.service.Id, this.NewServiceName || "");
        };
        Controller.CreateTabsFromMenu = function (menu, attrs, offset) {
            return menu.MenuItemList.map(function (mi, i) { return Controller_46.CreateTabFromMenuItem(mi, attrs, offset, i); });
        };
        Controller.CreateTabFromMenuItem = function (menuItem, attrs, offset, index) {
            var component = utils.AssertNotVoid(menuItem.Component);
            return {
                title: menuItem.Caption || "",
                tag: component.tag,
                attrs: attrs,
                RenderContents: false,
                NoClose: true,
            };
        };
        Controller.MakeAttrs = function (service) {
            return {
                service: service,
                "{[flex]}": "",
                "{[layout]}": "column",
            };
        };
        Object.defineProperty(Controller.prototype, "MdInputStyle", {
            get: function () {
                if (this.EditingServiceName)
                    return null;
                if (!utils.IsVoid(this.CurrentServiceName) && !utils.IsWhitespace(this.CurrentServiceName))
                    return { "border-color": "transparent", };
                return {
                    "border-color": "transparent",
                    "opacity": "0.75",
                    "font-style": "italic",
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ServiceNameDisplay", {
            get: function () {
                if (this.EditingServiceName)
                    return this.NewServiceName;
                if (utils.IsVoid(this.CurrentServiceName) || utils.IsWhitespace(this.CurrentServiceName))
                    return "Name your service";
                return this.CurrentServiceName;
            },
            set: function (value) {
                this.NewServiceName = value;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "service", void 0);
        __decorate([
            utils.Bind.In("load-offset", { optional: true })
        ], Controller.prototype, "Offset", void 0);
        Controller = Controller_46 = __decorate([
            utils.Component({
                Name: "ss-service-overview",
            })
        ], Controller);
        return Controller;
        var Controller_46;
    }(utils.Controller));
    exports.Controller = Controller;
    (function (Controller) {
        var MenuItem = (function (_super) {
            __extends(MenuItem, _super);
            function MenuItem() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.loaded = false;
                return _this;
            }
            MenuItem.Create = function (source, parsedChildren, index, parser) {
                return new MenuItem(source, parsedChildren, index, parser);
            };
            return MenuItem;
        }(menuService.ParsedMenuItem));
        Controller.MenuItem = MenuItem;
        (function (MenuItem) {
            MenuItem.Parser = menuService.Parser.CreateMapped({ Mapper: MenuItem.Create });
        })(MenuItem = Controller.MenuItem || (Controller.MenuItem = {}));
    })(Controller = exports.Controller || (exports.Controller = {}));
    exports.Controller = Controller;
});
define("app/ss/service/simchange/ss-service-simchange", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service"], function (require, exports, utils, ng_utils_41, service_47) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.today = new Date();
            _this.doesDAExists = false;
            _this.confirmSimChange = false;
            _this.simChange = new service_47.Selcomm.SIM.SimChangeValidatorResponse();
            _this.CheckSimChangebility();
            console.log("Delivery Address in simchange: ");
            _this.deliveryAddress = _this.AddressLoader.Values;
            console.log(_this.deliveryAddress);
            return _this;
        }
        Controller.prototype.Continue = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this;
                            return [4, this.AddressLoader.Values];
                        case 1:
                            _a.deliveryAddress = _b.sent();
                            this.confirmSimChange = true;
                            this.doesDAExists = this.AddressLoader.Values != undefined && this.AddressLoader.Values != null && this.AddressLoader.Values.length > 0;
                            console.log("flags: " + this.doesDAExists + "," + this.confirmSimChange);
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.Cancel = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.confirmSimChange = false;
                    return [2];
                });
            });
        };
        Controller.prototype.ChangeSim = function () {
            return __awaiter(this, void 0, ng_utils_41.$q, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('sending request');
                            return [4, service_47.Service.SIM.SimChange({
                                    ConnectionRef: this.service.Id.toString(),
                                    ConnectBarred: this.simChange.BarValue,
                                    NoteText: this.note,
                                    SimNumber: this.simChange.SIMStartingNumber,
                                    StartDate: this.simChange.MinDate.toUTCString()
                                })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.CheckSimChangebility = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            console.log(this.deliveryAddress);
                            _a = this;
                            return [4, service_47.Service.SIM.CheckSimChangeable({
                                    ConnectionRef: this.service.Id.toString()
                                })];
                        case 1:
                            _a.simChange = _b.sent();
                            this.simChange.MinDate = new Date(this.simChange.MinDate);
                            return [2];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.TwoWay("address-loader", { optional: true })
        ], Controller.prototype, "AddressLoader", void 0);
        __decorate([
            utils.Bind.In("current-service", { optional: true })
        ], Controller.prototype, "service", void 0);
        __decorate([
            utils.Bind.TwoWay("delivery-address", { optional: true })
        ], Controller.prototype, "deliveryAddress", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "ss-service-simchange",
            })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/ss/service/simreplacement/ss-service-simreplacement", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "app/sds/contact/address/utils"], function (require, exports, utils, ng_utils_42, service_48, contactAddressUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.doesDAExists = false;
            _this.confirmSimReplacement = false;
            _this.isLoading = false;
            _this.isComplete = false;
            _this.AddingContactAddress = false;
            _this.simValidation = new service_48.Selcomm.SIM.SIMReplacementValidationResponse();
            _this.AddableAddressTypes = new Array(1);
            _this.ContactAddressesLoader = new utils.CollectionLoader(function () { return contactAddressUtils.GetContactExtendedAddresses(service_48.Auth.CurrentSession.CurrentContactCode).then(function (addrs) { return addrs.filter(function (addr) { return IsDisplayableContactAddress(addr); }); }); });
            _this.LoadAddress();
            console.log("value: " + _this.IsForAllService);
            if (!_this.IsForAllService) {
                _this.CheckSimReplacement();
            }
            else {
                _this.simValidation.IsEligibleForReplacement = true;
                _this.GetServiceTypeCount();
            }
            _this.AddableAddressTypes[0] = new service_48.Selcomm.Address.AddressType({
                Code: "DA",
                Description: "Delivery Address",
                ContactRelated: true,
                ServiceRelated: true,
                DisplayOrder: 1
            });
            return _this;
        }
        Controller.prototype.Continue = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.isLoading = true;
                            if (this.deliveryAddress == null || this.deliveryAddress.length == 0) {
                                this.LoadAddress();
                            }
                            _a = this;
                            return [4, this.ContactAddressesLoader.Values];
                        case 1:
                            _a.deliveryAddress = _b.sent();
                            this.confirmSimReplacement = true;
                            this.doesDAExists = this.ContactAddressesLoader.Values != undefined && this.ContactAddressesLoader.Values != null && this.ContactAddressesLoader.Values.length > 0;
                            this.isLoading = false;
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.Cancel = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.confirmSimReplacement = false;
                    return [2];
                });
            });
        };
        Controller.prototype.SendReplacementRequest = function () {
            return __awaiter(this, void 0, ng_utils_42.$q, function () {
                var response, e_93;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            response = "";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, 7, 8]);
                            this.isLoading = true;
                            if (!this.IsForAllService) return [3, 3];
                            return [4, service_48.Service.SIM.SimReplacementForAllApplicable({
                                    Account: service_48.Auth.CurrentSession.UserCode
                                })];
                        case 2:
                            response = _a.sent();
                            return [3, 5];
                        case 3: return [4, service_48.Service.SIM.ReplaceSIM({
                                ConnectionRef: this.service.Id.toString()
                            })];
                        case 4:
                            response = _a.sent();
                            _a.label = 5;
                        case 5: return [3, 8];
                        case 6:
                            e_93 = _a.sent();
                            response = e_93;
                            this.confirmSimReplacement = false;
                            return [3, 8];
                        case 7:
                            this.isComplete = true;
                            this.simValidation.ErrorMessage = response;
                            this.isLoading = false;
                            return [7];
                        case 8: return [2];
                    }
                });
            });
        };
        Controller.prototype.CheckSimReplacement = function () {
            return __awaiter(this, void 0, ng_utils_42.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this;
                            return [4, service_48.Service.SIM.CheckSimReplaceable({
                                    ConnectionRef: this.service.Id.toString()
                                })];
                        case 1:
                            _a.simValidation = _b.sent();
                            ng_utils_42.$rootScope.$emit('display-sim-replacement-tab-' + this.service.Id, this.simValidation);
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.GetServiceTypeCount = function () {
            return __awaiter(this, void 0, ng_utils_42.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this;
                            return [4, service_48.Service.SIM.GetReplaceableSIMCount({
                                    Account: service_48.Auth.CurrentSession.UserCode
                                })];
                        case 1:
                            _a.serviceTypes = _b.sent();
                            if (this.serviceTypes != null && this.serviceTypes.length > 0) {
                                ng_utils_42.$rootScope.$emit('display-sim-replacement-alert', true);
                                this.simValidation.IsSIMReplacementRequested = false;
                                this.simValidation.IsEligibleForReplacement = true;
                            }
                            else {
                                ng_utils_42.$rootScope.$emit('display-sim-replacement-alert', false);
                                this.simValidation.IsSIMReplacementRequested = true;
                                this.simValidation.IsEligibleForReplacement = false;
                                this.simValidation.ErrorMessage = "There are no SIMs eligible for replacement or you have existing SIM replacement requests.";
                            }
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.OnContactAddressAdded = function (contactAddress) {
            this.deliveryAddress.push(contactAddress);
            console.log(contactAddress);
            this.AddingContactAddress = false;
            this.confirmSimReplacement = true;
            this.doesDAExists = true;
        };
        Controller.prototype.ReplaceInstanceByType = function (contactAddress) {
            this.deliveryAddress[0] = contactAddress;
        };
        Controller.prototype.CancelAdd = function () {
            this.AddingContactAddress = false;
        };
        Controller.prototype.LoadAddress = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.ContactAddressesLoader.Load()];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.TwoWay("for-all-service", { optional: true })
        ], Controller.prototype, "IsForAllService", void 0);
        __decorate([
            utils.Bind.In("current-service", { optional: true })
        ], Controller.prototype, "service", void 0);
        __decorate([
            utils.Bind.TwoWay("delivery-address", { optional: true })
        ], Controller.prototype, "deliveryAddress", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "ss-service-simreplacement",
            })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
    function IsDisplayableContactAddress(contactAddress) {
        if (!contactAddress)
            return true;
        return IsDisplayableContactAddressType(contactAddress.Type);
        ;
    }
    function IsDisplayableContactAddressType(contactAddressType, allowVoids) {
        if (allowVoids === void 0) { allowVoids = false; }
        if (utils.IsVoid(contactAddressType))
            return allowVoids;
        switch (contactAddressType.Code) {
            case "DA":
                return true;
            default:
                return false;
        }
    }
});
define("app/ss/site/background/ss-site-background", ["require", "exports", "app/utils", "module", "$mdUtil", "app/ng-utils"], function (require, exports, utils, module_51, $mdUtil, ng_utils_43) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_51.id);
    var cssClass = name;
    var fixedClass = name + "-is-fixed";
    var wrapperClass = name + "-fixed-wrapper";
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Attributes.$addClass(name);
            _this.TranscludeContents(function (clone) {
                var cloneBlock = utils.Element.AsBlock(clone, name);
                var contentWrapper = $(document.createElement("div")).addClass(wrapperClass);
                if (_this.IsFixed)
                    _this.Element.append(cloneBlock);
                else
                    _this.Element.append(contentWrapper.append(cloneBlock));
                _this.Watch(function () { return _this.IsFixed; }, function (isFixed, lastIsFixed) {
                    if (isFixed)
                        _this.Attributes.$addClass(fixedClass);
                    else
                        _this.Attributes.$removeClass(fixedClass);
                    if (isFixed === lastIsFixed)
                        return;
                    if (isFixed) {
                        ng_utils_43.$animate.move(utils.Element.GetBlockNodes(cloneBlock), _this.Element);
                        contentWrapper.detach();
                    }
                    else {
                        _this.Element.append(contentWrapper);
                        ng_utils_43.$animate.move(utils.Element.GetBlockNodes(cloneBlock), contentWrapper);
                    }
                });
            });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "BoundFixed", {
            get: function () {
                return this.Attributes["fixed"];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsFixed", {
            get: function () {
                return $mdUtil.parseAttributeBoolean(this.BoundFixed);
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Transclude(utils.Bind.Transclude.Mode.Contents)
        ], Controller.prototype, "TranscludeContents", void 0);
        Controller = __decorate([
            utils.Component({
                Name: name,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    var DocumentSiteBackgroundToken = (function () {
        function DocumentSiteBackgroundToken() {
        }
        DocumentSiteBackgroundToken.prototype.Dispose = function () {
            utils.Collection.ArrayRemoveAll(DocumentApplicationTokens, this);
            if (DocumentApplicationTokens.length <= 0)
                htmlTag.removeClass(cssClass);
        };
        return DocumentSiteBackgroundToken;
    }());
    var DocumentApplicationTokens = new Array();
    var htmlTag = $(document.documentElement);
    var destroyWatch = null;
    function DestroyWatch() {
        if (!destroyWatch)
            return;
        destroyWatch();
        destroyWatch = null;
    }
    function ApplyToBody() {
        if (DocumentApplicationTokens.length <= 0) {
            htmlTag.addClass(cssClass);
            DestroyWatch();
            destroyWatch = ng_utils_43.$rootScope.$watch(function () { return utils.Paths.MapPath("!theme/images/ss/background.jpg"); }, function (path) { return htmlTag.css("background-image", "url(" + path + ")"); });
        }
        var newToken = new DocumentSiteBackgroundToken();
        DocumentApplicationTokens.push(newToken);
        return newToken;
    }
    exports.ApplyToBody = ApplyToBody;
    function RemoveFromBody(token) {
        utils.Collection.ArrayRemoveAll(DocumentApplicationTokens, token);
        if (DocumentApplicationTokens.length <= 0) {
            htmlTag.removeClass(cssClass);
            DestroyWatch();
        }
    }
    exports.RemoveFromBody = RemoveFromBody;
});
define("app/ss/site/home/ss-site-home", ["require", "exports", "app/utils", "app/selcomm/service"], function (require, exports, utils, service_49) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Select = (function () {
        function Select(args) {
            this.DisplayName = args.DisplayName;
            this.Options = Object.freeze(__spread(args.Options));
            if (!utils.HasProp(args, "Default"))
                this.SelectedOption = this.Options[0];
            else {
                var defaultValue = !utils.IsNumber(args.Default) ? args.Default : this.Options[args.Default];
                if (this.Options.indexOf(defaultValue) < 0)
                    throw new Error("Invalid default option specified");
                else
                    this.SelectedOption = defaultValue;
            }
        }
        return Select;
    }());
    (function (Select) {
        var Option = (function () {
            function Option(DisplayName, value) {
                this.DisplayName = DisplayName;
                this.Value = utils.DeepCopy(value);
            }
            return Option;
        }());
        Select.Option = Option;
    })(Select || (Select = {}));
    var DisplayService = (function (_super) {
        __extends(DisplayService, _super);
        function DisplayService() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DisplayService.prototype.toString = function () {
            return this.ServiceNumber + " - " + this.ServiceType;
        };
        DisplayService.GetAllMatching = function (psf) {
            return __awaiter(this, void 0, void 0, function () {
                var serviceList;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_49.Service.Service.ServiceDisplayList({
                                PagingSortsAndFilters: new service_49.Selcomm.Filters.PagingSortsAndFilters({
                                    SkipRecords: psf.SkipRecords,
                                    TakeRecords: psf.TakeRecords,
                                    Filter: psf.Filter,
                                    Sorts: psf.Sorts || new Array(new service_49.Selcomm.Filters.Sort({
                                        TargetProperty: "ServiceNumber",
                                        Direction: service_49.Selcomm.Filters.SortDirection.Ascending,
                                    }), new service_49.Selcomm.Filters.Sort({
                                        TargetProperty: "ServiceType",
                                        Direction: service_49.Selcomm.Filters.SortDirection.Ascending,
                                    }))
                                }),
                                LoadDirectChild: false
                            })];
                        case 1:
                            serviceList = _a.sent();
                            return [2, utils.List.Create({
                                    TotalFilteredRecords: serviceList.TotalFilteredRecords,
                                    TotalUnfilteredRecords: serviceList.TotalUnfilteredRecords,
                                    Items: serviceList.Items.map(function (sd) { return new DisplayService(sd); }),
                                })];
                    }
                });
            });
        };
        return DisplayService;
    }(service_49.Selcomm.Service.ServiceDisplay));
    var DisplayItem = (function () {
        function DisplayItem() {
        }
        return DisplayItem;
    }());
    var PlaceholderItem = (function (_super) {
        __extends(PlaceholderItem, _super);
        function PlaceholderItem(UnderlyingItem, TimedArray) {
            var _this = _super.call(this) || this;
            _this.UnderlyingItem = UnderlyingItem;
            _this.TimedArray = TimedArray;
            return _this;
        }
        Object.defineProperty(PlaceholderItem.prototype, "TrackableId", {
            get: function () {
                return "PlaceholderItem:" + this.UnderlyingItem.TrackableId;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PlaceholderItem.prototype, "TypeName", {
            get: function () {
                return PlaceholderItem.TypeName;
            },
            enumerable: true,
            configurable: true
        });
        PlaceholderItem.prototype.LoadNow = function () {
            this.TimedArray.LoadNow(this);
        };
        PlaceholderItem.TypeName = "placeholder-item";
        return PlaceholderItem;
    }(DisplayItem));
    var ServiceItem = (function (_super) {
        __extends(ServiceItem, _super);
        function ServiceItem(Service) {
            var _this = _super.call(this) || this;
            _this.Service = Service;
            return _this;
        }
        Object.defineProperty(ServiceItem.prototype, "TrackableId", {
            get: function () {
                return "ServiceItem:" + this.Service.Id;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ServiceItem.prototype, "TypeName", {
            get: function () {
                return ServiceItem.TypeName;
            },
            enumerable: true,
            configurable: true
        });
        ServiceItem.TypeName = "service-item";
        return ServiceItem;
    }(DisplayItem));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.LoadingServices = new utils.ActivityController();
            _this.IsLoading = true;
            _this.DisplayLimit = 5;
            _this.NewSimpleSearchText = "";
            _this.SimpleSearchForm = new SimpleSearchForm();
            _this.CurrentSearchForm = _this.SimpleSearchForm;
            _this.Watch.Deep(function () { return _this.CurrentSearchForm.GenerateFilter(); }, function (newFilter) {
                _this.Filter = newFilter;
            });
            _this.GetServices(new service_49.Selcomm.Filters.PagingSortsAndFilters({ SkipRecords: 0, TakeRecords: 0, Filter: null, Sorts: null, }));
            return _this;
        }
        Controller.prototype.GetServices = function (psf) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var services, bpf;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, DisplayService.GetAllMatching(psf)];
                        case 1:
                            services = _a.sent();
                            bpf = service_49.Selcomm.Filters.BasicPropertyFilter;
                            if (utils.IsVoid(psf.Filter) && this.TotalServiceCount !== services.TotalFilteredRecords)
                                this.Scope.$applyAsync(function () { return _this.TotalServiceCount = services.TotalFilteredRecords; });
                            else if (psf.Filter instanceof service_49.Selcomm.Filters.NotFilter && psf.Filter.Filter instanceof service_49.Selcomm.Filters.InPropertyFilter && psf.Filter.Filter.PropertyName === "ServiceStatusCode" && utils.Collection.SequenceEqual(psf.Filter.Filter.Values, ["DIS"]) && this.TotalConnectedServiceCount !== services.TotalFilteredRecords)
                                this.Scope.$applyAsync(function () { return _this.TotalConnectedServiceCount = services.TotalFilteredRecords; });
                            return [2, services];
                    }
                });
            });
        };
        Controller.prototype.GetServicesForDisplay = function (psf) {
            return __awaiter(this, void 0, void 0, function () {
                var serviceList;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.GetServices(psf)];
                        case 1:
                            serviceList = _a.sent();
                            return [2, {
                                    Items: utils.Collection.DeferredArray(serviceList.Items.map(function (s) { return new ServiceItem(s); }), function () { return utils.Delay(2000); }, function (value, i, array) { return new PlaceholderItem(value, array); }),
                                    TotalFilteredRecords: serviceList.TotalFilteredRecords,
                                    TotalUnfilteredRecords: serviceList.TotalUnfilteredRecords,
                                }];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsSimpleSearch", {
            get: function () {
                return this.CurrentSearchForm instanceof SimpleSearchForm;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.ApplySimpleSearchText = function (newSearchText) {
            if (newSearchText === void 0) { newSearchText = (this.NewSimpleSearchText || ""); }
            this.CurrentSearchForm.SearchText = newSearchText;
        };
        Controller.prototype.ResetNewSearch = function () {
            this.NewSimpleSearchText = this.CurrentSearchForm.SearchText;
        };
        Controller.prototype.ClearSearch = function () {
            this.CurrentSearchForm.SearchText = this.NewSimpleSearchText = "";
        };
        Controller.prototype.ApplySearch = function (searchForm) {
            var newFilter = searchForm.GenerateFilter();
            if (angular.equals(newFilter, this.Filter))
                this.Filter = null;
            else
                this.Filter = newFilter;
        };
        Object.defineProperty(Controller.prototype, "ShowFilters", {
            get: function () {
                if (utils.IsVoid(this.TotalServiceCount) || utils.IsVoid(this.TotalConnectedServiceCount))
                    return false;
                return this.TotalServiceCount !== this.TotalConnectedServiceCount;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ShowSearch", {
            get: function () {
                return utils.IsVoid(this.TotalServiceCount) ? false : this.TotalServiceCount > this.DisplayLimit;
            },
            enumerable: true,
            configurable: true
        });
        Controller = __decorate([
            utils.Component({
                Name: "ss-site-home",
            })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
    var ServiceDisplayFilter = service_49.Filter.For();
    var SimpleSearchForm = (function () {
        function SimpleSearchForm(selectableFilters) {
            if (selectableFilters === void 0) { selectableFilters = SimpleSearchForm.GenerateDefaultSelectableFilters(); }
            this.SearchText = "";
            this.SelectableFilters = Object.freeze(__spread(selectableFilters));
        }
        Object.defineProperty(SimpleSearchForm.prototype, "SelectableFilter", {
            get: function () {
                var selectableFilters = utils.Collection.NonVoid(this.SelectableFilters
                    .map(function (sf) { return sf.SelectedOption ? sf.SelectedOption.Value : null; }));
                switch (selectableFilters.length) {
                    case 0:
                        return null;
                    case 1:
                        return selectableFilters[0];
                    default:
                        return service_49.Filter.All.apply(service_49.Filter, __spread(selectableFilters));
                }
            },
            enumerable: true,
            configurable: true
        });
        SimpleSearchForm.prototype.GenerateFilter = function () {
            var selectableFilters = this.SelectableFilter;
            var searchTextFilter = utils.IsNullOrWhitespace(this.SearchText) ? null : service_49.Filter.Any(ServiceDisplayFilter.On("ServiceNumber").Keyword(this.SearchText), ServiceDisplayFilter.On("UserLabel").Keyword(this.SearchText), ServiceDisplayFilter.On("ServiceType").Keyword(this.SearchText));
            if (!selectableFilters)
                return searchTextFilter;
            if (!searchTextFilter)
                return selectableFilters;
            return service_49.Filter.All(searchTextFilter, selectableFilters);
        };
        return SimpleSearchForm;
    }());
    (function (SimpleSearchForm) {
        var ServiceStatusFilter = ServiceDisplayFilter.On("ServiceStatusCode");
        function GenerateDefaultSelectableFilters() {
            return [
                new Select({
                    DisplayName: "Status",
                    Options: [
                        new Select.Option("Any", null),
                        new Select.Option("Connected", ServiceStatusFilter.NotIn(["DIS"])),
                        new Select.Option("Disconnected", ServiceStatusFilter.In(["DIS"])),
                    ],
                    Default: 1,
                }),
            ];
        }
        SimpleSearchForm.GenerateDefaultSelectableFilters = GenerateDefaultSelectableFilters;
    })(SimpleSearchForm || (SimpleSearchForm = {}));
});
define("app/ss/site/main/ss-site-main", ["require", "exports", "app/utils", "app/ss/site/background/ss-site-background", "$document"], function (require, exports, utils, siteBackground, $document) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.authActions = {
                "New User": alert.bind(window, "New User!"),
                "Forgot Password": alert.bind(window, "Forgot Password")
            };
            $document.addClass("foo");
            _this.Attributes.$addClass(Controller_47.Name);
            var token = siteBackground.ApplyToBody();
            _this.OnDispose(function () { return token.Dispose(); });
            return _this;
        }
        Controller_47 = Controller;
        Controller.Name = "ss-site-main";
        Controller = Controller_47 = __decorate([
            utils.Component({
                Name: Controller_47.Name,
            })
        ], Controller);
        return Controller;
        var Controller_47;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/site/wallet/ss-site-wallet", ["require", "exports", "app/utils", "module", "app/ng-utils", "app/selcomm/service", "app/sds/payment/service", "app/sds/contact/sds-contact", "app/sdc/closable/section/sdc-closable-section", "app/basic-utils"], function (require, exports, utils, module_52, ng_utils_44, service_50, payment, selectedContact, closableSection, basic_utils_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ValidPaymentMethodTypeCodes = ["D", "C"];
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.isOpen = true;
            _this.showDirectDebitPaymentMenu = false;
            _this.ShowPaymentSettings = false;
            _this.AccountPaymentMethodsLoader = new utils.CollectionLoader(function () { return _this.GetDisplayableAccountPaymentMethods(); });
            _this.ShowAddForm = false;
            _this.ShowBankForm = false;
            _this.ShowSelcommForm = false;
            _this.AvailableRegistrationOptionsLoader = new utils.CollectionLoader.Readonly(function (contactCode) { return payment.RegistrationTypeTargets.GetForContact(contactCode); });
            _this.StepPath = utils.StepPath.Create(Controller_48.Step.SelectRegistrationOption);
            _this.Watch(function () { return _this.showDirectDebitPaymentMenu = service_50.Auth.CurrentSession.EnableDirectDebitPaymentMethod; });
            _this.Watch(function () { return _this.SelectedContact && _this.SelectedContact.ContactCode; }, function (contactCode) { return utils.IsVoid(contactCode) ? _this.AvailableRegistrationOptionsLoader.Reset() : _this.AvailableRegistrationOptionsLoader.Load(contactCode); });
            _this.Watch(function () { return _this.AvailableRegistrationOptions.length === 1 ? _this.AvailableRegistrationOptions[0] : null; }, function (singleRegOption) { return !utils.IsVoid(singleRegOption) && (_this.SelectedRegistrationOption = singleRegOption); });
            return _this;
        }
        Controller_48 = Controller;
        Controller.prototype.TogglePaymentSettings = function () {
            this.ShowPaymentSettings = !this.ShowPaymentSettings;
        };
        Controller.prototype.GetDisplayableAccountPaymentMethods = function () {
            return __awaiter(this, void 0, void 0, function () {
                var accountPaymentMethods;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_50.Service.Payment.AccountPaymentMethodListValid({
                                ContactCode: utils.AssertNotVoid(this.SelectedContact.ContactCode),
                            })];
                        case 1:
                            accountPaymentMethods = _a.sent();
                            if (!accountPaymentMethods)
                                return [2, []];
                            return [2, accountPaymentMethods.filter(function (apm) { return Controller_48.IsDisplayable; }).reverse()];
                    }
                });
            });
        };
        Controller.prototype.OnDefaultUpdated = function (newDefault) {
            this.ShowPaymentSettings = false;
            this.UpdateDefaults(newDefault);
        };
        Object.defineProperty(Controller.prototype, "AccountPaymentMethods", {
            get: function () {
                var paymentMethods = this.AccountPaymentMethodsLoader.Values;
                this.currentDefaultPaymentMethod = paymentMethods.filter(function (pm) { return pm.Default == true; })[0];
                return paymentMethods;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "GetAccountPaymentDefaultMethod", {
            get: function () {
                return this.currentDefaultPaymentMethod;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Remove = function (deleting) {
            if (!deleting)
                return;
            utils.Collection.ArrayRemoveWhere(this.AccountPaymentMethods, function (apm) { return apm.Id === deleting.Id; });
        };
        Controller.prototype.UpdateDefaults = function (newDefault) {
            if (!newDefault || !newDefault.Default)
                return;
            try {
                for (var _a = __values(this.AccountPaymentMethods), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var apm = _b.value;
                    apm.Default = apm.Id === newDefault.Id;
                }
            }
            catch (e_94_1) { e_94 = { error: e_94_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_94) throw e_94.error; }
            }
            var e_94, _c;
        };
        Controller.prototype.Add = function (accountPaymentMethod) {
            if (accountPaymentMethod.Default) {
                try {
                    for (var _a = __values(this.AccountPaymentMethods), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var preExisting = _b.value;
                        if (preExisting.Default)
                            preExisting.Default = false;
                    }
                }
                catch (e_95_1) { e_95 = { error: e_95_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_95) throw e_95.error; }
                }
            }
            this.AccountPaymentMethods.push(accountPaymentMethod);
            var e_95, _c;
        };
        Controller.IsDisplayable = function (accountPaymentMethod) {
            if (!accountPaymentMethod || !accountPaymentMethod.PaymentMethod || !accountPaymentMethod.PaymentMethod.Type)
                return false;
            return ValidPaymentMethodTypeCodes.indexOf(accountPaymentMethod.PaymentMethod.Type.Code) >= 0;
        };
        Controller.prototype.Update = function (updating) {
            utils.Collection.ArrayReplaceWhere(this.AccountPaymentMethods, function (apm) { return apm.Id === updating.Id; }, function () { return updating; });
            this.UpdateDefaults(updating);
        };
        Controller.prototype.EnterAdd = function (event) {
            this.ShowCreditCardAgreement("0", event);
        };
        Controller.prototype.EnterAddBank = function () {
            this.ShowBankAgreement("0");
        };
        Controller.prototype.EnterAddDefaut = function (event) {
            this.ShowCreditCardAgreement("1", event);
        };
        Controller.prototype.EnterAddBankDefault = function () {
            this.ShowBankAgreement("1");
        };
        Controller.prototype.ExitAdd = function () {
            this.ShowAddForm = false;
            this.ShowBankForm = false;
            this.ShowSelcommForm = false;
            ng_utils_44.$window.localStorage.removeItem("IsDefaultPayment");
        };
        Object.defineProperty(Controller.prototype, "IsPaymentMethodsBusy", {
            get: function () {
                return this.AccountPaymentMethodsLoader.IsLoading;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.LoadAcconutPaymentMethods = function () {
            this.AccountPaymentMethodsLoader.Load();
        };
        Controller.prototype.openMenu = function ($mdOpenMenu, event) {
        };
        Controller.prototype.BankPaymentCreated = function (payMethod) {
            this.Add(payMethod);
            this.ShowBankForm = false;
        };
        Controller.prototype.ShowCreditCardAgreement = function (isDefault, event) {
            if (utils.IsVoid(this.SelectedRegistrationOption)) {
                switch (this.AvailableRegistrationOptions.length) {
                    case 0:
                        utils.Toast.Simple("An internal error occurred");
                        throw new Error("No registration options");
                    case 1:
                        if (!this.AvailableRegistrationOptionsLoader.IsValid) {
                            utils.Toast.Simple("An internal error occurred");
                            throw new Error("No registration options");
                        }
                        this.SelectedRegistrationOption = this.AvailableRegistrationOptions[0];
                        break;
                    default:
                        utils.Toast.Simple("Select an option from above");
                        throw new Error("No registration option selected");
                }
            }
            var agreement = service_50.Auth.CurrentSession.CreditCardAgreement_HTML;
            if (agreement !== "null" && basic_utils_2.IsNotNullOrEmpty(agreement)) {
                if (this.SelectedRegistrationOption.RegistrationType === payment.RegistrationType.ThirdParty) {
                    agreement += "<br/><br/><hr/><p>You will need to enter your payment details in a new window to continue.</p>";
                }
                var confirm = ng_utils_44.$mdDialog.confirm()
                    .title('Agreement Confirmation')
                    .htmlContent(agreement)
                    .ok('CONTINUE')
                    .cancel('CANCEL');
                var self_1 = this;
                ng_utils_44.$mdDialog.show(confirm).then(function (result) {
                    ng_utils_44.$window.localStorage.setItem("IsDefaultPayment", isDefault);
                    self_1.ProceedCreditCardRegistration(event);
                }, function () {
                    ng_utils_44.$window.localStorage.removeItem("IsDefaultPayment");
                });
            }
            else {
                ng_utils_44.$window.localStorage.setItem("IsDefaultPayment", isDefault);
                this.ProceedCreditCardRegistration(event);
            }
        };
        Controller.prototype.ShowBankAgreement = function (isDefault) {
            var agreement = service_50.Auth.CurrentSession.DirectDebitAgreement_HTML;
            if (agreement !== "null" && basic_utils_2.IsNotNullOrEmpty(agreement)) {
                var confirm_3 = ng_utils_44.$mdDialog.confirm()
                    .title('Agreement Confirmation')
                    .htmlContent(agreement)
                    .ok('OK')
                    .cancel('CANCEL');
                var self_2 = this;
                ng_utils_44.$mdDialog.show(confirm_3).then(function (result) {
                    self_2.ShowAddForm = false;
                    self_2.ShowSelcommForm = false;
                    self_2.ShowBankForm = true;
                    ng_utils_44.$window.localStorage.setItem("IsDefaultPayment", isDefault);
                }, function () {
                    ng_utils_44.$window.localStorage.removeItem("IsDefaultPayment");
                });
            }
            else {
                ng_utils_44.$window.localStorage.setItem("IsDefaultPayment", isDefault);
                this.ShowAddForm = false;
                this.ShowSelcommForm = false;
                this.ShowBankForm = true;
            }
        };
        Controller.prototype.ProceedCreditCardRegistration = function (event) {
            switch (this.SelectedRegistrationOption.RegistrationType) {
                case payment.RegistrationType.Selcomm:
                    this.ShowSelcommForm = true;
                    this.ShowBankForm = false;
                    this.ShowAddForm = false;
                    this.StepPath.NavigateForward(Controller_48.Step.SelcommRegistration);
                    break;
                case payment.RegistrationType.ThirdParty:
                    this.ShowAddForm = true;
                    this.ShowBankForm = false;
                    this.ShowSelcommForm = false;
                    var request = payment.ThirdParty.PaymentMethodRegister.Invoke({
                        targetContactCode: utils.AssertNotVoid(this.SelectedContact.ContactCode),
                        notFinalStep: true,
                    });
                    this.ShowThirdPartyRegistrationDialog(request, event);
                    this.AwaitThirdPartyRegister(request);
                    break;
            }
        };
        Object.defineProperty(Controller.prototype, "AvailableRegistrationOptions", {
            get: function () {
                return this.AvailableRegistrationOptionsLoader.Values;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CurrentStep", {
            get: function () {
                return this.StepPath.CurrentStep;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.AwaitThirdPartyRegister = function (request) {
            return __awaiter(this, void 0, ng_utils_44.$q, function () {
                var accountPaymentMethod;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, request.AccountPaymentMethod];
                        case 1:
                            accountPaymentMethod = _a.sent();
                            this.Add(accountPaymentMethod);
                            return [2, accountPaymentMethod];
                    }
                });
            });
        };
        Controller.prototype.ShowThirdPartyRegistrationDialog = function (request, event) {
            return __awaiter(this, void 0, ng_utils_44.$q, function () {
                var alert, dialog;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            alert = ng_utils_44.$mdDialog
                                .alert()
                                .disableParentScroll(false)
                                .title("Payment Registration")
                                .textContent("We have opened a new window where you can register your payment method. If you cannot find the window make sure that it has not been blocked by any pop-up blockers in your browser.")
                                .ok("Dismiss");
                            if (!utils.IsVoid(event))
                                alert.targetEvent(event);
                            dialog = ng_utils_44.$mdDialog.show(alert);
                            return [4, dialog];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents })
        ], Controller.prototype, "SelectedContact", void 0);
        __decorate([
            utils.Bind.Controller(closableSection.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents, optional: true, })
        ], Controller.prototype, "ClosableSection", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "LoadAcconutPaymentMethods", null);
        Controller = Controller_48 = __decorate([
            utils.Component({
                ModuleId: module_52.id,
            })
        ], Controller);
        return Controller;
        var Controller_48;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    (function (Controller) {
        var Step;
        (function (Step) {
            Step["SelectRegistrationOption"] = "select-registration-option";
            Step["SelcommRegistration"] = "selcomm-registration";
        })(Step = Controller.Step || (Controller.Step = {}));
    })(Controller = exports.Controller || (exports.Controller = {}));
    exports.Controller = Controller;
});
define("app/sv/not/equals/sv-not-equals", ["require", "exports", "module", "app/utils"], function (require, exports, module_53, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_53.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch(function () { return _this.RejectedValue; }, function () { return _this.NgModelCtrl.$validate(); });
            return _this;
        }
        Controller.prototype.Validate = function (value, isEmpty) {
            return isEmpty(value) || isEmpty(this.RejectedValue) || value !== this.RejectedValue;
        };
        Controller.prototype.InitialiseValidator = function (ngModelCtrl) {
            var _this = this;
            if (ngModelCtrl === void 0) { ngModelCtrl = this.NgModelCtrl; }
            var isEmpty = function (value) { return ngModelCtrl.$isEmpty(value); };
            ngModelCtrl.$validators[Name] = function (value) { return _this.Validate(value, isEmpty); };
        };
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModelCtrl", void 0);
        __decorate([
            utils.Bind.In(Name)
        ], Controller.prototype, "RejectedValue", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "InitialiseValidator", null);
        Controller = __decorate([
            utils.Component({
                Name: Name,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("scripts/lib/select-development/require-loaders/app-modules-plugin-definition", ["require", "exports", "core-js"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function GetModules(starMap) {
        var aliasMap = {};
        for (var alias in starMap) {
            if (!Object.prototype.hasOwnProperty.call(starMap, alias))
                continue;
            var path = starMap[alias];
            if (!path.startsWith("app/"))
                continue;
            if (!Object.prototype.hasOwnProperty.call(aliasMap, path))
                aliasMap[path] = [];
            aliasMap[path].push(alias);
        }
        var moduleNames = [];
        moduleNames.$modules = {};
        var _loop_8 = function (path) {
            if (!Object.prototype.hasOwnProperty.call(aliasMap, path))
                return "continue";
            var aliases = aliasMap[path].sort(function (a, b) { return a.length - b.length; });
            var name_12 = aliases[0];
            moduleNames.push(name_12);
            aliases.forEach(function (alias) { return moduleNames.$modules[alias] = name_12; });
        };
        for (var path in aliasMap) {
            _loop_8(path);
        }
        Object.freeze(moduleNames.$modules);
        Object.freeze(moduleNames);
        return moduleNames;
    }
    function load(name, req, onload, config) {
        onload(GetModules(config.map["*"]));
    }
    exports.load = load;
    function normalize() {
        return "";
    }
    exports.normalize = normalize;
});
define("scripts/lib/select-development/require-loaders/component-common", ["require", "exports", "scripts/lib/select-development/sss-names"], function (require, exports, names) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function normalizeModuleName(fullName) {
        var matches = /^((?:[^!]+!)?)(.*)$/.exec(fullName);
        var prefix = matches[1], name = matches[2];
        if (names.IsSelectComponent(name)) {
            var normalized = prefix + names.ComponentNameNormalize(name);
            return normalized;
        }
        else {
            return fullName;
        }
    }
    exports.normalizeModuleName = normalizeModuleName;
    function normalizeInjections(injected) {
        if (!angular.isArray(injected)) {
            return injected;
        }
        var fixed = injected.slice();
        angular.forEach(fixed, function (value, i) {
            function set(newVal) { fixed[i] = newVal; }
            set(function () {
                if (angular.isString(value) || angular.isFunction(value)) {
                    return value;
                }
                else if (angular.isArray(value)) {
                    return normalizeInjections(value);
                }
                else if (angular.isObject(value)) {
                    if (angular.isString(value.name)) {
                        return value.name;
                    }
                    else {
                        return value.valueOf();
                    }
                }
                else {
                    return value;
                }
            });
        });
        return fixed;
    }
    exports.normalizeInjections = normalizeInjections;
    function isInjectorInvokable(fn, strictDi) {
        if (typeof fn !== "function")
            return false;
        if (fn.length && strictDi) {
            return false;
        }
        else {
            return true;
        }
    }
    exports.isInjectorInvokable = isInjectorInvokable;
    var BasicLoader = (function () {
        function BasicLoader(typeName) {
            this.typeName = typeName;
            switch (typeName) {
                case names.CanonicalDefinitionName.Type.Factory:
                case names.CanonicalDefinitionName.Type.Filter:
                case names.CanonicalDefinitionName.Type.Service:
                    this.wrapDefinition = BasicLoader.wrap;
                    break;
                case names.CanonicalDefinitionName.Type.Provider:
                    this.wrapDefinition = BasicLoader.wrapProvider;
                    break;
                default:
                    this.wrapDefinition = BasicLoader.noWrap;
                    break;
            }
            switch (typeName) {
                case names.CanonicalDefinitionName.Type.Factory:
                case names.CanonicalDefinitionName.Type.Service:
                case names.CanonicalDefinitionName.Type.Constant:
                    this.suffix = "";
                    break;
                default:
                    this.suffix = typeName[0].toUpperCase() + typeName.slice(1);
                    break;
            }
        }
        BasicLoader.noWrap = function (definition) {
            return definition;
        };
        BasicLoader.wrap = function (definition) {
            return function wrappedDefinition() {
                return definition;
            };
        };
        BasicLoader.wrapProvider = function (definition) {
            if (angular.isFunction(definition)) {
                return definition;
            }
            else {
                return function implicitProviderConstructor() {
                    angular.extend(this, definition);
                };
            }
        };
        BasicLoader.prototype.valueOf = function () {
            return this.name;
        };
        BasicLoader.prototype.load = function (fullName, req, onload, config) {
            var _this = this;
            if (config.isBuild)
                return onload(null);
            var matches = /^((?:[^!]+!)?)(.*)$/.exec(fullName);
            var prefix = matches[1];
            var name = matches[2];
            var defineOnly;
            switch (prefix || "") {
                case "defined!":
                    defineOnly = true;
                    break;
                case "":
                    defineOnly = false;
                    break;
                default:
                    return onload.error(new Error("Unknown prefix: " + prefix));
            }
            var injectionName = name + this.suffix;
            if (names.IsSelectComponent(name)) {
                req(["ngAmd", "" + names.CanonicalDefinitionName(name, this.typeName)], function (ngAmd, definition) {
                    try {
                        ngAmd[_this.typeName](name, _this.wrapDefinition(definition));
                        if (defineOnly) {
                            onload(injectionName);
                        }
                        else {
                            _this.get(ngAmd, injectionName).then(onload, onload.error);
                        }
                    }
                    catch (ex) {
                        onload.error(ex);
                    }
                }, onload.error);
            }
            else {
                if (defineOnly) {
                    onload(injectionName);
                }
                else {
                    req(["ngAmd"], function (ngAmd) {
                        _this.get(ngAmd, injectionName).then(onload, onload.error);
                    });
                }
            }
        };
        BasicLoader.prototype.normalize = function (fullName) {
            return normalizeModuleName(fullName);
        };
        BasicLoader.prototype.get = function (ngAmd, name) {
            var injectorType;
            switch (this.typeName) {
                case names.CanonicalDefinitionName.Type.Constant:
                case names.CanonicalDefinitionName.Type.Provider:
                    injectorType = "config";
                    break;
                default:
                    injectorType = "inject";
                    break;
            }
            return ngAmd[injectorType]([name, function (definition) { return definition; }]);
        };
        return BasicLoader;
    }());
    exports.BasicLoader = BasicLoader;
    (function (BasicLoader) {
        BasicLoader.Type = names.CanonicalDefinitionName.Type;
    })(BasicLoader = exports.BasicLoader || (exports.BasicLoader = {}));
    exports.BasicLoader = BasicLoader;
});
define("scripts/lib/select-development/require-loaders/constant", ["require", "exports", "scripts/lib/select-development/require-loaders/component-common"], function (require, exports, component_common_1) {
    "use strict";
    return new component_common_1.BasicLoader(component_common_1.BasicLoader.Type.Constant);
});
define("scripts/lib/select-development/require-loaders/directive-legacy", ["require", "exports", "app/basic-utils", "scripts/lib/select-development/sss-bind-definitions", "scripts/lib/select-development/sss-watch", "scripts/lib/select-development/sss-names"], function (require, exports, utils, binds, sss_watch_2, names) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var deprecatedDirectiveDefinitionProperties = {
        "model": "controller.bind",
        "requireAs": "require"
    };
    var validControllerProperties = ["bind", "properties", "prototype", "constructor", "defaults"];
    var PropertyFor = (function () {
        function PropertyFor(context, property) {
            this.context = context;
            this.exists = false;
            this.hasOwn = true;
            var curr = context;
            try {
                for (var _a = __values(property.split('.')), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var prop = _b.value;
                    if (!PropertyFor.canHaveOwnProperties(curr)) {
                        this.hasOwn = false;
                        curr = undefined;
                        return;
                    }
                    this.hasOwn = this.hasOwn && utils.HasProp(curr, prop);
                    if (!this.hasOwn && !(prop in curr)) {
                        curr = undefined;
                        return;
                    }
                    curr = curr[prop];
                }
            }
            catch (e_96_1) { e_96 = { error: e_96_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_96) throw e_96.error; }
            }
            this.value = curr;
            this.exists = true;
            var e_96, _c;
        }
        PropertyFor.Get = function (context, property) {
            return new PropertyFor(context, property);
        };
        PropertyFor.prototype.defaultTo = function (defaultValue) {
            return this.hasOwn ? this.value : defaultValue;
        };
        PropertyFor.prototype.or = function (otherProperty) {
            return this.hasOwn ? this : PropertyFor.Get(this.context, otherProperty);
        };
        PropertyFor.canHaveOwnProperties = function (target) {
            return angular.isFunction(target) || angular.isObject(target);
        };
        return PropertyFor;
    }());
    function propertyFor(context, property) {
        return PropertyFor.Get(context, property);
    }
    function getParseService() {
        return require("$parse");
    }
    function $parse(expression) {
        return getParseService()(expression);
    }
    normalizeDirectiveDefinition.$inject = ["$definition", "$injector", "$locals", "$log", "$name"];
    function normalizeDirectiveDefinition(options) {
        var $definition = options.definition;
        var $name = options.name;
        var requiresTemplate = false;
        var normalizedDefinition;
        var first;
        if (angular.isObject($definition) && !angular.isArray($definition) && Object.hasOwnProperty.call($definition, "Directive")) {
            options.definition = $definition = $definition.Directive;
        }
        var definitions;
        if (!angular.isArray($definition))
            definitions = [$definition];
        else {
            first = $definition[0];
            if (angular.isString(first)) {
                definitions = [$definition];
            }
            else
                definitions = $definition;
        }
        definitions = definitions.map(function (def) {
            if (angular.isObject(def) && angular.isFunction(def.toDirective))
                return def.toDirective($name);
            else
                return def;
        });
        normalizedDefinition = angular.map(definitions, function (definition) {
            var constructor;
            var constructorFn;
            if (!definition) {
                definition = {};
            }
            if (angular.isFunction(definition)) {
                var asFn = definition;
                if (PropertyFor.Get(definition, "requiresTemplate").defaultTo(true)) {
                    requiresTemplate = true;
                }
                constructorFn = constructor = asFn;
                if (asFn.length !== (asFn.$inject || angular.emptyArray).length) {
                    console.error("The constructor function does not conform to the strict dependency requirements.", {
                        definition: asFn,
                        name: names.Standardify($name)
                    });
                }
            }
            else if (angular.isArray(definition)) {
                if (PropertyFor.Get(definition, "requiresTemplate").defaultTo(true)) {
                    requiresTemplate = true;
                }
                constructor = definition;
                constructorFn = constructor[constructor.length - 1];
                if (!angular.isFunction(constructor[constructor.length - 1])) {
                    console.error("The last item in the constructor array was not a function.", {
                        definition: definition,
                        name: names.Standardify($name)
                    });
                }
                else if (constructorFn.length !== constructor.length - 1) {
                    console.error("The constructor function does not conform to the strict dependency requirements.", {
                        definition: definition,
                        name: names.Standardify($name)
                    });
                }
            }
            else if (angular.isObject(definition)) {
                if (!PropertyFor.Get(definition, "template").hasOwn) {
                    requiresTemplate = true;
                }
                constructorFn = constructor = function __implicitConstructor() {
                    return definition;
                };
            }
            else {
                throw angular.extend(new Error("Unknown definition type"), {
                    definition: definition
                });
            }
            constructor.__definition = definition;
            return wrapDirectiveConstructor(angular.extend({}, options, {
                constructor: constructor
            }));
        });
        return {
            requiresTemplate: requiresTemplate,
            directiveDefinitions: normalizedDefinition
        };
    }
    function ImplicitControllerConstructor() {
    }
    function wrapDirectiveConstructor(options) {
        var $constructor = options.constructor, $name = options.name, $template = options.template, sdcSafeApplyFactory = options.sdcSafeApplyFactory;
        wrappedDirectiveConstructor.$inject = ["$injector", "$log", "$parse", "$exceptionHandler"];
        wrappedDirectiveConstructor["__original"] = options.constructor;
        return wrappedDirectiveConstructor;
        function wrappedDirectiveConstructor($injector, $log, $parse, $exceptionHandler) {
            try {
                return (function () {
                    var originalDefinition = $injector.invoke($constructor, this, {
                        $name: $name,
                        $template: $template
                    });
                    var preLinkOverrides = [];
                    var postLinkOverrides = [];
                    var definition = angular.copy(originalDefinition);
                    var fixControllers;
                    var scopelessBind;
                    var requireAliases = [];
                    var requireProperties = [];
                    var defaults;
                    var additionalControllerAs = angular.emptyArray;
                    var debug = definition.debugger ? function () {
                        originalDefinition;
                        debugger;
                    } : angular.noop;
                    debug();
                    function wrapLinkFn(originalFn, overrdingFns) {
                        return function extendedFn(scope, iElement, iAttrs, controller, transcludeFn) {
                            function autoInject(fn) {
                                debug();
                                if ((angular.isArray(fn) && angular.isFunction(fn[fn.length - 1])) || (angular.isFunction(fn) && angular.isArray(fn.$inject))) {
                                    return $injector.invoke(fn, self, angular.extend({}, locals, {
                                        $scope: scope,
                                        $element: iElement,
                                        $attrs: iAttrs,
                                        $controllers: controller,
                                        $transclude: transcludeFn,
                                        $watch: sss_watch_2.WatchService($parse, scope, controller ? controller.$self : null),
                                        $name: $name,
                                        $template: $template,
                                        $set: function $set(propertyName) {
                                            var assigner;
                                            var format;
                                            if (arguments.length > 1) {
                                                assigner = $parse(arguments[1]).assign;
                                                var args_1 = Array.prototype.slice.call(arguments, 2);
                                                format = (function format(value) {
                                                    return this.apply(controller && controller.$self || scope, [value].concat(args_1));
                                                }).bind(arguments[0]);
                                            }
                                            else {
                                                assigner = $parse(propertyName).assign;
                                                format = function passthrough(value) { return value; };
                                            }
                                            return setter;
                                            function setter(value) {
                                                value = format(value);
                                                assigner((controller && controller.$self) ? {
                                                    vm: controller.$self
                                                } : scope, value);
                                                return value;
                                            }
                                        }
                                    }));
                                }
                                else if (angular.isFunction(fn)) {
                                    return fn.apply(self, [scope, iElement, iAttrs, controller, transcludeFn]);
                                }
                            }
                            function updateLocals(value, key) {
                                switch (key) {
                                    case "scope":
                                        scope = value;
                                        break;
                                    case "iElement":
                                        iElement = value;
                                        break;
                                    case "iAttrs":
                                        iAttrs = value;
                                        break;
                                    case "controller":
                                        controller = value;
                                        break;
                                    case "transcludeFn":
                                        transcludeFn = value;
                                        break;
                                    default:
                                        locals[key] = value;
                                }
                            }
                            var self = this, locals = {};
                            angular.forEach(overrdingFns, function (fn) {
                                angular.forEach(autoInject(fn), updateLocals);
                            });
                            return autoInject(originalFn);
                        };
                    }
                    function wrapPreLink(originalLink) {
                        return wrapLinkFn(originalLink, preLinkOverrides);
                    }
                    function wrapPostLink(originalLink) {
                        return wrapLinkFn(originalLink, postLinkOverrides);
                    }
                    function wrapLink(link) {
                        if (property("compile").hasOwn) {
                            return link;
                        }
                        else {
                            return wrapPostLink(link);
                        }
                    }
                    fixControllersOnLink.$inject = ["$controllers", "$scope"];
                    function fixControllersOnLink($controllers, $scope) {
                        var updater = { controller: {}, $self: $controllers[requireAliases.indexOf("$self")], $parent: $controllers[requireAliases.indexOf("$parent")] };
                        var $self = updater.$self, $parent = updater.$parent, controllers = updater.controller;
                        if (fixControllers) {
                            updater.controller = fixControllers($controllers);
                            return updater;
                        }
                        else {
                            if (property("$scope").hasOwn) {
                                angular.forEach(additionalControllerAs, function (propName) {
                                    $scope[propName] = $self;
                                });
                            }
                            angular.forEach($controllers, function (controller, i) {
                                var alias = requireAliases[i];
                                var property = requireProperties[i];
                                controllers[alias] = controller;
                                if ($self && definition.controller) {
                                    if (!property) {
                                        Object.defineProperty($self, alias, {
                                            configurable: true,
                                            enumerable: true,
                                            get: function getController() {
                                                return controllers[alias];
                                            },
                                            set: function setController(value) {
                                                return controllers[alias] = value;
                                            }
                                        });
                                    }
                                    else {
                                        var parsedPropertyExpr_1 = $parse(property);
                                        Object.defineProperty($self, alias, {
                                            configurable: true,
                                            enumerable: true,
                                            get: function getController() {
                                                return parsedPropertyExpr_1(controllers[alias]);
                                            },
                                            set: function setController(value) {
                                                return parsedPropertyExpr_1.assign(controllers[alias], value);
                                            }
                                        });
                                    }
                                }
                            });
                        }
                        return updater;
                    }
                    postLinkOverrides.push(fixControllersOnLink);
                    preLinkOverrides.push(fixControllersOnLink);
                    function normalizeControllerAs(controllerAs) {
                        if (angular.isArray(controllerAs)) {
                            additionalControllerAs = controllerAs.slice(1);
                            return controllerAs.length ? controllerAs[0] : null;
                        }
                        else {
                            return controllerAs;
                        }
                    }
                    function wrapObjectController(controller) {
                        var constructor;
                        var properties;
                        var prototype;
                        var constructorFn;
                        var scopeProperty;
                        if (!controller || angular.isArray(controller)) {
                            return controller;
                        }
                        defaults = controller.defaults;
                        constructor = angular.isFunction(controller) ? controller : (controller.constructor !== Object.prototype.constructor && controller.constructor) || ImplicitControllerConstructor;
                        properties = controller.properties;
                        prototype = controller.prototype;
                        constructorFn = angular.isArray(constructor) ? constructor[constructor.length - 1] : constructor;
                        scopeProperty = property("scope").value;
                        if (scopeProperty || scopeProperty === false && !angular.isFunction(controller.bind)) {
                            scopelessBind = controller.bind;
                        }
                        else {
                            scopelessBind = controller.scopelessBind;
                            if (controller.bind && !angular.isFunction(controller.bind)) {
                                definition.scope = controller.bind;
                            }
                            else if (controller.scopelessBind) {
                                definition.scope = false;
                            }
                        }
                        scopelessBind = angular.copy(scopelessBind);
                        if (properties) {
                            properties = {};
                            angular.forEach(controller.properties, function (value, key) {
                                if (angular.isString(value)) {
                                    value = (function (parsedExpr, fullExpr) {
                                        expr_get.toString = expr_ToString;
                                        expr_set.toString = expr_ToString;
                                        return {
                                            get: expr_get,
                                            set: parsedExpr.assign ? expr_get : undefined
                                        };
                                        function expr_ToString() {
                                            return fullExpr;
                                        }
                                        function expr_get() {
                                            return parsedExpr(this, {
                                                vm: this
                                            });
                                        }
                                        function expr_set(value) {
                                            return parsedExpr.assign(this, value, {
                                                vm: this
                                            });
                                        }
                                    }($parse(value), value));
                                }
                                else if (angular.isObject(value)) {
                                    properties[key] = value;
                                }
                                else if (angular.isFunction(value)) {
                                    if (value.length === 0) {
                                        properties[key] = {
                                            get: value
                                        };
                                    }
                                }
                            });
                            prototype = Object.create(prototype || Object.prototype, properties);
                        }
                        if (prototype) {
                            constructorFn.prototype = prototype;
                        }
                        return constructor;
                    }
                    function warpControllerConstructor(controller) {
                        debug();
                        if (!controller) {
                            return controller;
                        }
                        var debugHelpers = Symbol("__debugHelpers");
                        function wrappingController($scope, $element, $attrs, $transclude, $injector, $parse, $interpolate) {
                            debug();
                            var vm = this;
                            var constructorLocals = {
                                $scope: $scope,
                                $element: $element,
                                $attrs: $attrs,
                                $transclude: $transclude,
                                $self: vm,
                                $watch: sss_watch_2.WatchService($parse, $scope, vm),
                                $safeApply: sdcSafeApplyFactory($scope),
                                $using: function $using(disposeFn) {
                                    if (angular.isFunction(disposeFn)) {
                                        $scope.$on("$destroy", disposeFn.bind(vm));
                                    }
                                },
                                $name: $name,
                                $template: $template,
                                $set: function $set(propertyName) {
                                    var assigner;
                                    var format;
                                    if (arguments.length > 1) {
                                        assigner = $parse(arguments[1]).assign;
                                        var args_2 = Array.prototype.slice.call(arguments, 2);
                                        format = (function format(value) {
                                            return this.apply(controller && controller.$self || $scope, [value].concat(args_2));
                                        }).bind(arguments[0]);
                                    }
                                    else {
                                        assigner = $parse(propertyName).assign;
                                        format = function passthrough(value) { return value; };
                                    }
                                    return setter;
                                    function setter(value) {
                                        value = format(value);
                                        assigner({
                                            vm: vm
                                        }, value);
                                        return value;
                                    }
                                }
                            };
                            (function (defaults) {
                                if (defaults) {
                                    angular.forEach(angular.extend({}, angular.isObject(definition.scope) ? definition.scope : angular.empty, scopelessBind), function (remoteName, localName) {
                                        remoteName = remoteName.replace(/^[@=&]\??/, "");
                                        if (!remoteName) {
                                            remoteName = localName;
                                        }
                                        if (!angular.isDefined($attrs[remoteName])) {
                                            if (Object.hasOwnProperty.call(defaults, localName)) {
                                                vm[localName] = defaults[localName];
                                            }
                                        }
                                        delete defaults[localName];
                                    });
                                }
                                angular.forEach(defaults, function (value, key) {
                                    vm[key] = value;
                                });
                            }(angular.copy(defaults)));
                            var scopelessBindingDefinitions = binds.Attribute.ParseBinds($name, scopelessBind);
                            binds.Attribute.Controller.ApplyTo({
                                interpolateService: $interpolate,
                                parseService: $parse,
                                name: $name,
                                destination: vm,
                                attrs: $attrs,
                                newScope: $scope,
                                useParentScope: !!definition.scope,
                                definitions: scopelessBindingDefinitions,
                            });
                            angular.forEach(additionalControllerAs, function (prop) {
                                $scope[prop] = vm;
                            });
                            if (!("__$$name" in vm)) {
                                this.__$$name = $name;
                            }
                            this[debugHelpers] = {
                                locals: constructorLocals
                            };
                            return $injector.invoke(controller, vm, constructorLocals);
                        }
                        angular.extend(wrappingController, {
                            $inject: ["$scope", "$element", "$attrs", "$transclude", "$injector", "$parse", "$interpolate"],
                            prototype: angular.isArray(controller) ? controller[controller.length - 1].prototype : controller.prototype
                        });
                        return wrappingController;
                    }
                    function requireAsObj(originalRequire) {
                        var require;
                        var alwaysRequire = {
                            $self: "?" + $name,
                            $parent: "^^?" + $name
                        };
                        if (!originalRequire) {
                            fixControllers = angular.noop;
                            require = {};
                        }
                        else if (!angular.isObject(originalRequire)) {
                            fixControllers = function fixSingleController(controllersObj) {
                                return controllersObj[0];
                            };
                            require = {
                                0: originalRequire
                            };
                        }
                        else if (angular.isArray(originalRequire)) {
                            fixControllers = function fixArrayControllers(controllersObj) {
                                var returnArr = [];
                                angular.forEach(originalRequire, function (v, key) {
                                    returnArr[key] = controllersObj[key];
                                });
                                return returnArr;
                            };
                            require = angular.copy(originalRequire, {});
                        }
                        else {
                            require = angular.copy(originalRequire);
                        }
                        return angular.extend(require, alwaysRequire);
                    }
                    function requireObjAsArray(require) {
                        var reqArr = [];
                        angular.forEach(require, function (controllerName, localAlias) {
                            var actualRequire;
                            var matches;
                            var property;
                            if (controllerName) {
                                switch (controllerName) {
                                    case "^":
                                    case "^^":
                                    case "?":
                                    case "?^":
                                    case "?^^":
                                        controllerName += localAlias;
                                        break;
                                    case "=":
                                        controllerName = localAlias;
                                        break;
                                }
                                if (matches = /^([^.]+)\.(.*)$/.exec(controllerName)) {
                                    actualRequire = matches[1];
                                    property = matches[2];
                                }
                                else {
                                    actualRequire = controllerName;
                                }
                            }
                            else {
                                actualRequire = localAlias;
                            }
                            reqArr.push(actualRequire);
                            requireProperties.push(property);
                            requireAliases.push(localAlias);
                        });
                        return reqArr;
                    }
                    function normalizeRequireNames(require) {
                        return angular.map(require, function (value) {
                            return names.NormalizeControllerRequire(value);
                        });
                    }
                    function wrapCompile(compile) {
                        if (angular.isObject(compile)) {
                            compile = (function (original) {
                                return function implicitCompile() {
                                    return original;
                                };
                            }(angular.copy(compile)));
                        }
                        if (preLinkOverrides.length) {
                            if (property("compile").hasOwn) {
                                return function () {
                                    var link = compile.apply(this, arguments);
                                    if (angular.isFunction(link)) {
                                        return {
                                            pre: wrapPreLink(),
                                            post: postLinkOverrides.length ? wrapPostLink(link) : link
                                        };
                                    }
                                    else if (angular.isObject(link)) {
                                        return {
                                            pre: wrapPreLink(link.pre),
                                            post: postLinkOverrides.length ? wrapPostLink(link) : link
                                        };
                                    }
                                    else {
                                        return {
                                            pre: wrapPreLink
                                        };
                                    }
                                };
                            }
                            else {
                                return function () {
                                    return {
                                        pre: wrapPreLink(definition.link && definition.link.pre),
                                        post: definition.link && wrapPostLink(definition.link)
                                    };
                                };
                            }
                        }
                        else if (postLinkOverrides.length) {
                            if (!property("compile").hasOwn) {
                                return function () {
                                    var link = compile.apply(this, arguments);
                                    if (angular.isFunction(link)) {
                                        return wrapPostLink(link);
                                    }
                                    else if (angular.isObject(link)) {
                                        return {
                                            pre: link.pre,
                                            post: wrapPostLink(link.post)
                                        };
                                    }
                                    else {
                                        return wrapPostLink();
                                    }
                                };
                            }
                        }
                        return void 0;
                    }
                    function warnDeprecatedOnCompile(compile, deprecated) {
                        var message;
                        var obj = angular.empty;
                        if (!deprecated) {
                            return compile;
                        }
                        else if (angular.isString(deprecated)) {
                            message = ['The directive "', $name, '" is deprecated, ', deprecated.trim()].join("");
                            obj = {
                                alternative: deprecated
                            };
                        }
                        else {
                            message = ['The directive "', $name, '" is deprecated.'].join("");
                        }
                        return function warnDeprecatedThenCompile() {
                            $log.warn(message, angular.extend({
                                directive: $name
                            }, obj));
                            return compile.apply(this, arguments);
                        };
                    }
                    function property(property) {
                        return PropertyFor.Get(definition, property);
                    }
                    var deprecatedProperties = angular.filter(angular.map(deprecatedDirectiveDefinitionProperties, function (alternative, deprecatedProperty) {
                        var prop = PropertyFor.Get(definition, deprecatedProperty);
                        if (!prop.hasOwn)
                            return null;
                        return alternative;
                    }), function (x) { return !!x; });
                    if (Object.keys(deprecatedProperties).length) {
                        $log.warn("Deprecated properties used in \"" + names.Standardify($name) + "\"", {
                            directiveName: names.Standardify($name),
                            deprecatedProperties: deprecatedProperties
                        });
                    }
                    if (angular.isObject(definition.controller) && !angular.isArray(definition.controller)) {
                        var invalidControllerProperties = Object.keys(definition.controller).filter(function (n) { return validControllerProperties.indexOf(n) < 0; });
                        if (Object.keys(invalidControllerProperties).length) {
                            $log.error(['Unknown properties on controller object for "', names.Standardify($name), '", all unknown properties will be ignored: '].join(""), {
                                directiveName: names.Standardify($name),
                                unknownProperties: invalidControllerProperties
                            });
                        }
                    }
                    function firstPass(definition) {
                        return angular.extend(definition, {
                            name: $name,
                            restrict: property("restrict").defaultTo("E"),
                            template: property("template").defaultTo(($template && $template.text) || undefined),
                            scope: property("scope").or("model").value,
                            bindToController: property("bindToController").defaultTo(definition.controller && (!property("scope").hasOwn || definition.scope)),
                            controllerAs: normalizeControllerAs(property("controllerAs").defaultTo((definition.controller && !property("scope").hasOwn) ? ["vm", "model"] : undefined)),
                            require: normalizeRequireNames(requireObjAsArray(requireAsObj(property("requireAs").defaultTo(definition.require)))),
                            link: property("link.post").or("link").value
                        });
                    }
                    function secondPass(definition) {
                        return angular.extend(definition, {
                            controller: warpControllerConstructor(wrapObjectController(definition.controller)),
                            compile: wrapCompile(definition.compile),
                            link: (angular.isFunction(definition.link) || angular.isArray(definition.link)) ? definition.link : undefined
                        });
                    }
                    function thirdPass(definition) {
                        return angular.extend(definition, {
                            scope: (definition.scope === undefined) ? {} : definition.scope,
                            link: wrapLink(definition.link)
                        });
                    }
                    definition = thirdPass(secondPass(firstPass(definition)));
                    debug();
                    return definition;
                }).apply(this, arguments);
            }
            catch (ex) {
                debugger;
                $exceptionHandler(ex, "directive.js");
                throw ex;
            }
        }
        ;
    }
    function Load(fullName, req, onload, config, componentDefinition, name, defineOnly) {
        var rethrow = (function (error) {
            return function handleError(ex) {
                console.error("Error caused by directive definition", ex);
                console.log("-----------------Directive ERROR-----------------");
                console.log(ex.message);
                console.log();
                console.log("-----------------STACK-----------------");
                console.log(ex.stack);
                console.log();
                console.log("-----------------Directive ERROR END-----------------");
                var result;
                try {
                    req(["$exceptionHandler"], function ($exceptionHandler) {
                        $exceptionHandler(ex, "Error caused by directive definition.");
                    });
                }
                finally {
                    result = error(ex);
                }
                return result;
            };
        }(onload.error));
        req(["template", "ngAmd"], function (template, ngAmd) {
            var injectionName;
            var templateModuleId;
            templateModuleId = names.TemplateModuleId(name);
            injectionName = name + "Directive";
            try {
                var templateObj_1 = {
                    moduleId: templateModuleId,
                    loaded: false,
                    text: null
                }, normalizedDefinition_1 = normalizeDirectiveDefinition({
                    name: name,
                    definition: componentDefinition,
                    template: templateObj_1,
                    sssNames: names,
                    sdcSafeApplyFactory: sdcSafeApply
                });
                templateObj_1.loaded = !!normalizedDefinition_1.requiresTemplate;
                req(normalizedDefinition_1.requiresTemplate ? [templateModuleId] : [], function (templateText) {
                    try {
                        templateObj_1.text = templateText;
                        angular.forEach(normalizedDefinition_1.directiveDefinitions, ngAmd.directive.bind(ngAmd, name));
                        if (defineOnly) {
                            onload(injectionName);
                        }
                        else {
                            ngAmd.inject([injectionName, function (directiveDefinition) {
                                    onload(directiveDefinition);
                                }]);
                        }
                    }
                    catch (ex) {
                        rethrow(ex);
                    }
                }, rethrow);
            }
            catch (ex) {
                rethrow(ex);
            }
        }, rethrow);
    }
    exports.Load = Load;
    function sdcSafeApply($scope) {
        return function safeApply(fn) {
            if ($scope.$root.$$phase) {
                return $scope.$eval(fn);
            }
            else {
                return $scope.$apply(fn);
            }
        };
    }
});
define("scripts/lib/select-development/require-loaders/directive", ["require", "exports", "app/amd-directive-registar", "scripts/lib/select-development/require-loaders/directive-legacy", "scripts/lib/select-development/sss-names", "scripts/lib/select-development/require-loaders/component-common"], function (require, exports, directives, legacy, names, component_common_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.normalize = component_common_2.normalizeModuleName;
    function load(fullName, req, onload, config) {
        if (config.isBuild) {
            onload();
            return;
        }
        try {
            var _a = GetName(fullName), name_13 = _a.name, defineOnly_1 = _a.defineOnly;
            var directiveModuleId = names.DirectiveDefinitionModuleId(name_13);
            directives.OpenRegistar(name_13);
            req([directiveModuleId], function (componentDefinition) {
                if (!directives.RegisterInUse(name_13))
                    return legacy.Load(fullName, req, onload, config, componentDefinition, name_13, defineOnly_1);
                directives.GetRegistarPromise(name_13).then(onload, onload);
            }, rethrow);
        }
        catch (err) {
            rethrow(err);
        }
        function rethrow(ex) {
            console.error("Error caused by directive definition", ex);
            console.log("-----------------Directive ERROR-----------------");
            console.log(ex.message);
            console.log();
            console.log("-----------------STACK-----------------");
            console.log(ex.stack);
            console.log();
            console.log("-----------------Directive ERROR END-----------------");
            var result;
            try {
                req(["$exceptionHandler"], function ($exceptionHandler) {
                    $exceptionHandler(ex, "Error caused by directive definition.");
                });
            }
            finally {
                result = onload.error(ex);
            }
            return result;
        }
        ;
    }
    exports.load = load;
    function GetName(fullName) {
        var prefixI = fullName.indexOf("!");
        var prefix;
        var name;
        if (prefixI >= 0) {
            prefix = fullName.substr(0, prefixI);
            name = fullName.substr(prefixI + 1);
        }
        else {
            name = fullName;
        }
        var defineOnly;
        switch (prefix || "") {
            case "defined":
                defineOnly = true;
                break;
            case "":
                defineOnly = false;
                break;
            default:
                throw new Error("Unknown prefix: " + prefix);
        }
        return {
            name: name,
            defineOnly: defineOnly,
        };
    }
});
define("scripts/lib/select-development/require-loaders/factory", ["require", "exports", "scripts/lib/select-development/require-loaders/component-common"], function (require, exports, component_common_3) {
    "use strict";
    return new component_common_3.BasicLoader(component_common_3.BasicLoader.Type.Factory);
});
define("scripts/lib/select-development/require-loaders/filter", ["require", "exports", "scripts/lib/select-development/require-loaders/component-common"], function (require, exports, component_common_4) {
    "use strict";
    return new component_common_4.BasicLoader(component_common_4.BasicLoader.Type.Filter);
});
define("app-modules-loader", ["app-modules-plugin-definition"], function (x) { return x; });
define("directive", ["directive-loader"], function (x) { return x; });
define("template", ["template-loader"], function (x) { return x; });
define("filter", ["filter-loader"], function (x) { return x; });
define("factory", ["factory-loader"], function (x) { return x; });
define("service", ["service-loader"], function (x) { return x; });
define("value", ["value-loader"], function (x) { return x; });
define("constant", ["constant-loader"], function (x) { return x; });
define("provider", ["provider-loader"], function (x) { return x; });
define("site-theme", ["site-theme-loader"], function (x) { return x; });
define("component-common", ["component-common-loader"], function (x) { return x; });
define("sss-text", ["sss-text-loader"], function (x) { return x; });
define("sss-json", ["sss-json-loader"], function (x) { return x; });
define("scripts/lib/select-development/require-loaders/provider", ["require", "exports", "scripts/lib/select-development/require-loaders/component-common"], function (require, exports, component_common_5) {
    "use strict";
    return new component_common_5.BasicLoader(component_common_5.BasicLoader.Type.Provider);
});
define("scripts/lib/select-development/require-loaders/service", ["require", "exports", "scripts/lib/select-development/require-loaders/component-common"], function (require, exports, component_common_6) {
    "use strict";
    return new component_common_6.BasicLoader(component_common_6.BasicLoader.Type.Service);
});
define("scripts/lib/select-development/require-loaders/site-theme", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function load(siteName, req, onload, config) {
        if (config.isBuild) {
            onload();
        }
        else {
            req(["service!sdc-md-theming"], function (sdcMdThemingService) {
                sdcMdThemingService.loadSiteTheme(siteName).then(onload, onload.error);
            }, onload.error);
        }
    }
    exports.load = load;
});
define("scripts/lib/select-development/require-loaders/sss-json-loader", ["require", "exports", "app/raw-path-utils", "json"], function (require, exports, paths, json) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function load(name, req, onload, config) {
        if (config.isBuild)
            return onload(null);
        json.load(paths.MapPath(paths.RootParsers.AtServerRoot, location.pathname, name), req, onload, config);
    }
    exports.load = load;
    ;
    function normalize(name, normalize) {
        return json.normalize(name, normalize);
    }
    exports.normalize = normalize;
});
define("scripts/lib/select-development/require-loaders/sss-text-loader", ["require", "exports", "app/raw-path-utils", "text"], function (require, exports, paths, text) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function load(name, req, onload, config) {
        if (config.isBuild)
            return onload(null);
        text.load(paths.MapPath(paths.RootParsers.AtServerRoot, location.pathname, name), req, onload, config);
    }
    exports.load = load;
    ;
});
define("scripts/lib/select-development/require-loaders/template", ["require", "exports", "text", "module", "scripts/lib/select-development/sss-names", "app/basic-utils"], function (require, exports, text, thisModule, names, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var masterConfig = (thisModule.config && thisModule.config()) || {};
    var hasLocation = typeof location !== 'undefined' && location.href;
    var defaultProtocol = hasLocation && location.protocol && location.protocol.replace(/\:/, '');
    var defaultHostName = hasLocation && location.hostname;
    var defaultPort = hasLocation && (location.port || undefined);
    var dependencyMap = {};
    var buildMap = {};
    function textLoad(name, req, onLoad, config) {
        if (config && config.isBuild && !config.inlineText) {
            onLoad();
            return;
        }
        masterConfig.isBuild = config && config.isBuild;
        var parsed = text.parseName(name), nonStripName = parsed.moduleName +
            (parsed.ext ? '.' + parsed.ext : ''), url = req.toUrl(nonStripName + ".").replace(/[\.]+$/, ""), useXhr = (masterConfig.useXhr) ||
            text.useXhr;
        if (url.indexOf('empty:') === 0) {
            onLoad();
            return;
        }
        if (!hasLocation || useXhr(url, defaultProtocol, defaultHostName, defaultPort)) {
            text.get(url.replace(/\.$/, ""), function (content) {
                text.finishLoad(name, parsed.strip, content, onLoad);
            }, function (err) {
                if (onLoad.error) {
                    onLoad.error(err);
                }
            });
        }
        else {
            req([nonStripName], function (content) {
                text.finishLoad(parsed.moduleName + '.' + parsed.ext, parsed.strip, content, onLoad);
            });
        }
    }
    exports.id = thisModule.id;
    function load(name, req, onload, config) {
        var directiveId = "directive";
        function isRecursive(dependency) {
            var dependencyDeps = dependencyMap[dependency.substr(directiveId.length + 1)];
            if (dependencyDeps && dependencyDeps.indexOf("directive!" + name) >= 0) {
                return false;
            }
            return true;
        }
        var onLoadWrapper = utils.Extend(function (content) {
            var targetJquery = jQuery || $;
            var dependencies = (dependencyMap[name] = names.DependenciesFor(targetJquery.parseHTML(content), name)).filter(isRecursive);
            if (dependencies.length !== dependencyMap[name].length) {
                console.warn('Circular dependencies in "template!' + name + '" this may cause a stack overflow error in angular, consider using "sdc-require" to control coniditional circular templates:', dependencyMap[name].filter(function (dep) { return dependencies.indexOf(dep) < 0; }));
            }
            if (config.isBuild) {
                buildMap[name] = content;
            }
            if (config.isBuild || !dependencies.length)
                return onload(content);
            else
                return req(dependencies, function () { return onload(content); }, function (err) { return onload.error(err); });
        }, {
            error: function (error) { return onload.error(error); },
            fromText: function (text) { return onload.fromText(text); }
        });
        return textLoad(names.TemplateDefinitionModuleId(name) + ".", req, onLoadWrapper, config);
    }
    exports.load = load;
    function normalize(name, normalize) {
        var normalized = name, withoutExtension = normalized.replace(/.html$/, "");
        if (withoutExtension !== normalized) {
            normalized = normalize(names.ComponentNameNormalize(withoutExtension.replace(/^([^\/]*\/)*/, "")));
        }
        normalized = normalize(names.ComponentNameNormalize(normalized));
        return normalized;
    }
    exports.normalize = normalize;
    function write(pluginName, moduleName, write) {
        var dependencies = [];
        if (moduleName in dependencyMap) {
            dependencies = dependencies.concat(dependencyMap[moduleName]);
        }
        write(["define('", pluginName, "!", moduleName, "',['", dependencies.map(function (dep) { return text.jsEscape(dep); }).join("','"), "'],function(template){return '", text.jsEscape(buildMap[moduleName]), "';});\n"].join(""));
    }
    exports.write = write;
});
define("scripts/lib/select-development/require-loaders/value", ["require", "exports", "scripts/lib/select-development/require-loaders/component-common"], function (require, exports, component_common_7) {
    "use strict";
    return new component_common_7.BasicLoader(component_common_7.BasicLoader.Type.Value);
});
define("app/sdc/dynamic/panel/controller/sdc-dynamic-panel-controller", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller_49 = Controller;
        Controller.prototype.asComponent = function (tagOrComponent, attrsOrTitle, extendAttrsOrTitle, titleOrVoid) {
            if (utils.IsString(tagOrComponent)) {
                var tag = tagOrComponent;
                var title = void 0;
                var attrs = void 0;
                var extendAttrs = void 0;
                if (utils.IsString(attrsOrTitle))
                    title = attrsOrTitle;
                else {
                    attrs = attrsOrTitle;
                    if (utils.IsString(extendAttrsOrTitle))
                        title = extendAttrsOrTitle;
                    else
                        title = titleOrVoid;
                }
                return {
                    tag: tag,
                    attrs: attrs,
                    extendAttrs: extendAttrs,
                    title: title,
                };
            }
            else if (utils.IsObject(tagOrComponent)) {
                var clone = utils.ShallowCopy(tagOrComponent);
                clone.attrs = (utils.IsString(attrsOrTitle) ? null : attrsOrTitle) || clone.attrs;
                clone.extendAttrs = (utils.IsString(extendAttrsOrTitle) ? null : extendAttrsOrTitle) || clone.extendAttrs;
                clone.title = titleOrVoid || clone.title;
                return clone;
            }
            else
                return null;
        };
        Controller.prototype.OpenComponent = function (tagOrComponent, attrsOrTitle, extendAttrsOrTitle, titleOrVoid) {
            return this.__openComponent({
                component: this.asComponent(tagOrComponent, attrsOrTitle, extendAttrsOrTitle, titleOrVoid)
            });
        };
        Controller.prototype.openComponent = function (tagOrComponent, attrsOrTitle, extendAttrsOrTitle, titleOrVoid) {
            return this.OpenComponent.apply(this, arguments);
        };
        Controller.Name = "sdc-dynamic-panel-controller";
        __decorate([
            utils.Bind.Getter(Controller_49.Name)
        ], Controller.prototype, "__openComponent", void 0);
        Controller = Controller_49 = __decorate([
            utils.InterimElement.PassThrough,
            utils.Component({
                Name: Controller_49.Name,
                Restrict: utils.Target.Attribute | utils.Target.Element,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
        var Controller_49;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/dynamic/panel/open/sdc-dynamic-panel-open", ["require", "exports", "app/utils", "app/sdc/dynamic/panel/controller/sdc-dynamic-panel-controller", "$q"], function (require, exports, utils, parent, $q) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Content = $();
            var handler = function () { return _this.Scope.$apply(function () { return _this.Open(); }); };
            _this.Element.on("click", handler);
            _this.OnDispose(function () { return _this.Element.off("click", handler); });
            return _this;
        }
        Controller_50 = Controller;
        Object.defineProperty(Controller.prototype, "dynamicPanelController", {
            get: function () {
                return this.Parent;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Component", {
            get: function () {
                return this.getComponent();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "Attrs", {
            get: function () {
                return this.getAttrs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ExtendAttrs", {
            get: function () {
                return this.getExtendAttrs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "label", {
            get: function () { return this.Label; },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Open = function () {
            var _this = this;
            var component = this.getComponent();
            if (utils.IsObject(component)) {
                this.Parent.OpenComponent(component, this.Attrs, this.ExtendAttrs, this.Label);
                return;
            }
            var scope = this.Scope.$new();
            var result = this.BeforeOpen();
            if (!utils.IsSpecified(result)) {
                this.OpenElement(component, scope);
                return;
            }
            $q.resolve(result).then(function () { return _this.OpenElement(component, scope); });
        };
        Controller.prototype.OpenElement = function (tag, scope) {
            var content = this.Content.clone();
            var template = utils.IsVoid(tag) ? content : utils.Element.CreateElement(tag).append(content);
            this.Parent.OpenComponent({
                Template: template,
                attrs: this.Attrs,
                extendAttrs: this.ExtendAttrs,
                ParentBoundTransclude: this.Transclude,
                Scope: scope,
                title: this.label,
            });
        };
        Controller.prototype.RegisterContent = function (scope, element) {
            var _this = this;
            var clone = element.clone();
            this.Content = $(this.Content.add(clone));
            return function () { return _this.UnregisterContent(clone); };
        };
        Controller.prototype.UnregisterContent = function (element) {
            this.Content = this.Content.not(element);
        };
        Controller.Name = "sdc-dynamic-panel-open";
        __decorate([
            utils.Bind.Controller(parent.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents, optional: true })
        ], Controller.prototype, "Parent", void 0);
        __decorate([
            utils.Bind.Getter(Controller_50.Name)
        ], Controller.prototype, "getComponent", void 0);
        __decorate([
            utils.Bind.Getter("attrs")
        ], Controller.prototype, "getAttrs", void 0);
        __decorate([
            utils.Bind.Getter("extend-attrs")
        ], Controller.prototype, "getExtendAttrs", void 0);
        __decorate([
            utils.Bind.Literal("label")
        ], Controller.prototype, "Label", void 0);
        __decorate([
            utils.Bind.Getter("before-open")
        ], Controller.prototype, "BeforeOpen", void 0);
        Controller = Controller_50 = __decorate([
            utils.Component({
                Name: Controller_50.Name,
                Restrict: utils.Target.Attribute,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
        var Controller_50;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/form/control/hook/sdc-form-control-hook-factory", ["require", "exports", "app/sdc/form/control/hook/sdc-form-control-hook"], function (require, exports, sdc_form_control_hook_1) {
    "use strict";
    return function sdcFormControlHookFactory(form) {
        var controller = new sdc_form_control_hook_1.Controller(form);
        return controller.ToLegacy();
    };
});
define("app/sdc/if/not/error/sdc-if-not-error", ["require", "exports", "app/sdc/loading/sdc-loading", "scripts/lib/select-development/sss-names", "app/utils", "app/sdc/if/sdc-if", "$q"], function (require, exports, loading, sssNames, utils, ifService, $q) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Name = "sdc-if-not-error";
    var Controller = (function () {
        function Controller($attrs, $watch, $element, $transclude) {
            var _this = this;
            this.Toggle = ifService.Create($element, $transclude);
            if (!$attrs[sssNames.CamelCase(exports.Name)])
                this.GetPassedValue = null;
            $watch(function () { return _this.Value; }, function ($new) {
                if ($q.isQ($new)) {
                    $new.then(function () {
                        if (_this.Value !== $new)
                            return;
                        _this.Toggle(true);
                    }, function () {
                        if (_this.Value !== $new)
                            return;
                        _this.Toggle(false);
                    });
                }
                else if (angular.isObject($new) && $new instanceof Error)
                    _this.Toggle(false);
                else if ($new === 1)
                    _this.Toggle(true);
                else if (!$new && $new !== 0) {
                    _this.Toggle(true);
                }
            });
        }
        Object.defineProperty(Controller.prototype, "Value", {
            get: function () {
                if (this.GetPassedValue)
                    return this.GetPassedValue();
                else if (this.ParentLoading)
                    return this.ParentLoading.Loading;
                else
                    return null;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Controller(loading.Controller, { optional: true, mode: utils.Bind.Controller.Mode.Parents })
        ], Controller.prototype, "ParentLoading", void 0);
        __decorate([
            utils.Bind.Getter(exports.Name, { optional: true })
        ], Controller.prototype, "GetPassedValue", void 0);
        Controller = __decorate([
            utils.Component({
                Name: exports.Name,
                Priority: 600,
                Terminal: true,
                Restrict: utils.Target.Attribute,
                Transclude: utils.TransclusionMode.Element,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            }),
            __param(0, utils.Inject("$attrs")), __param(1, utils.Inject("$watch")), __param(2, utils.Inject("$element")), __param(3, utils.Inject("$transclude"))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/md/icon/search/sdc-md-icon-search", ["require", "exports", "app/utils", "$http"], function (require, exports, utils, $http) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BatchSize = 1;
    var Controller = (function () {
        function Controller() {
            var _this = this;
            this.IconNames = [];
            $http.get(utils.Paths.MapPath("~/$$/Home/IconNames"))
                .then(function (response) { return response.data.sort(); })
                .then(function (iconNames) {
                _this.IconNames = iconNames;
            });
        }
        Controller = __decorate([
            utils.Component({ Name: "sdc-md-icon-search" })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sdc/md/theming/auto/sdc-md-theming-auto", ["require", "exports", "app/utils", "app/sss/sites", "app/sdc/md/theming/sdc-md-theming-service"], function (require, exports, utils, sites, themingService) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.ThemeName = "default";
            _this.Watch(function () { return sites.Service.Current.Name; }, function () { return _this.ApplyThemeNameForSite(sites.Service.Current); });
            return _this;
        }
        Controller_51 = Controller;
        Controller.prototype.ApplyThemeName = function (themeName) {
            this.ThemeName = themeName;
        };
        Controller.prototype.ApplyThemeNameForSite = function (siteOrSiteName) {
            var _this = this;
            return themingService
                .loadSiteTheme(sites.Service.NameFor(siteOrSiteName))
                .then(function (themeName) { return _this.ApplyThemeName(themeName); }, function (err) { return _this.ApplyThemeName("default"); });
        };
        Controller.Name = "sdc-md-theming-auto";
        __decorate([
            utils.Bind.TwoWay(Controller_51.Name)
        ], Controller.prototype, "ThemeName", void 0);
        Controller = Controller_51 = __decorate([
            utils.Component({
                Name: Controller_51.Name,
                Scope: utils.ScopeMode.ParentScope,
                Restrict: utils.Target.Attribute,
                Template: null,
            })
        ], Controller);
        return Controller;
        var Controller_51;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/menu/toggle/content/sdc-menu-toggle-content", ["require", "exports", "app/utils", "app/sdc/menu/toggle/sdc-menu-toggle"], function (require, exports, utils, parent) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.MakePlaceholder(parent.Controller, "sdc-menu-toggle-content", function (parent, $transclude) { return parent.ContentTranscludes.push($transclude); }, function (parent, $transclude) { return utils.Collection.ArrayRemoveAll(parent.ContentTranscludes, $transclude); });
});
define("app/sdc/menu/toggle/title/sdc-menu-toggle-title", ["require", "exports", "app/utils", "app/sdc/menu/toggle/sdc-menu-toggle"], function (require, exports, utils, parent) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.MakePlaceholder(parent.Controller, "sdc-menu-toggle-title", function (parent, $transclude) { return parent.TitleTranscludes.push($transclude); }, function (parent, $transclude) { return utils.Collection.ArrayRemoveAll(parent.TitleTranscludes, $transclude); });
});
define("app/sdc/site/icon/auto/sdc-site-icon-auto", ["require", "exports", "app/utils", "app/ng-utils", "app/sss/sites", "module"], function (require, exports, utils, ng_utils_45, sites_4, module_54) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ParsedFavicon = (function () {
        function ParsedFavicon(Underlying) {
            this.Underlying = Underlying;
            this.Size = this.Underlying.ImageSizeString || "";
            this.Href = utils.Paths.MapPath(this.Underlying.NgHref);
            this.MimeType = this.Underlying.MimeType;
        }
        ParsedFavicon.prototype.ApplyToJQuery = function (target) {
            target.attr({
                "href": this.Href,
                "type": this.MimeType,
            });
            if (this.Size)
                target.attr("sizes", this.Size);
            else
                target.removeAttr("sizes");
        };
        ParsedFavicon.WipeJQuery = function (target) {
            target.attr({
                "href": "about:blank",
                "type": "",
            });
        };
        return ParsedFavicon;
    }());
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.SiteNameWatch = _this.Watch(function () { return sites_4.Service.Current.Name; }, function (siteName, lastSiteName) { return _this.UpdateFavicons(siteName, lastSiteName); });
            _this.UpdateSiteIconsActivity = new utils.ActivityController(module_54.id + ": UpdateSiteIcons");
            return _this;
        }
        Controller.prototype.UpdateFavicons = function (siteName, lastSiteName) {
            return __awaiter(this, void 0, ng_utils_45.$q, function () {
                var token, rawFavicons;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (lastSiteName.toLowerCase() === siteName.toLowerCase())
                                return [2];
                            token = this.UpdateSiteIconsActivity.CloseAndEnter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4, this.GetSiteIcons(siteName)];
                        case 2:
                            rawFavicons = _a.sent();
                            if (token.HasExited)
                                return [2];
                            this.ApplyFavicons(rawFavicons.map(function (favicon) { return new ParsedFavicon(favicon); }));
                            return [3, 4];
                        case 3:
                            token.Exit();
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.ApplyFavicons = function (favicons) {
            var unlinkedFavicons = __spread(favicons);
            var existingLinks = this.Element.children("link[rel=\"icon\"]");
            var linksBySize = utils.MakeKeyedCollection({});
            var unusedLinks = new Array();
            for (var i = 0; i < existingLinks.length; i++) {
                var found = $(existingLinks[i]);
                linksBySize[found.attr("sizes") || ""] = found;
                unusedLinks.push(found);
            }
            try {
                for (var favicons_1 = __values(favicons), favicons_1_1 = favicons_1.next(); !favicons_1_1.done; favicons_1_1 = favicons_1.next()) {
                    var favicon = favicons_1_1.value;
                    var target = linksBySize[favicon.Size];
                    if (utils.IsVoid(target))
                        continue;
                    favicon.ApplyToJQuery(target);
                    utils.Collection.ArrayRemoveAll(unusedLinks, target);
                    utils.Collection.ArrayRemoveAll(unlinkedFavicons, favicon);
                }
            }
            catch (e_97_1) { e_97 = { error: e_97_1 }; }
            finally {
                try {
                    if (favicons_1_1 && !favicons_1_1.done && (_a = favicons_1.return)) _a.call(favicons_1);
                }
                finally { if (e_97) throw e_97.error; }
            }
            try {
                for (var unlinkedFavicons_1 = __values(unlinkedFavicons), unlinkedFavicons_1_1 = unlinkedFavicons_1.next(); !unlinkedFavicons_1_1.done; unlinkedFavicons_1_1 = unlinkedFavicons_1.next()) {
                    var favicon = unlinkedFavicons_1_1.value;
                    var target = unusedLinks.pop() || this.CreateNewLink();
                    favicon.ApplyToJQuery(target);
                }
            }
            catch (e_98_1) { e_98 = { error: e_98_1 }; }
            finally {
                try {
                    if (unlinkedFavicons_1_1 && !unlinkedFavicons_1_1.done && (_b = unlinkedFavicons_1.return)) _b.call(unlinkedFavicons_1);
                }
                finally { if (e_98) throw e_98.error; }
            }
            if (unusedLinks.length) {
                var defaultFavicon = utils.Collection.FirstOrDefault(favicons, function (f) { return f.Size === "16x16"; }, utils.Collection.FirstOrDefault(favicons, function (f) { return !!f.Size; }, utils.Collection.FirstOrDefault(favicons)));
                if (defaultFavicon) {
                    try {
                        for (var unusedLinks_1 = __values(unusedLinks), unusedLinks_1_1 = unusedLinks_1.next(); !unusedLinks_1_1.done; unusedLinks_1_1 = unusedLinks_1.next()) {
                            var unusedLink = unusedLinks_1_1.value;
                            defaultFavicon.ApplyToJQuery(unusedLink);
                        }
                    }
                    catch (e_99_1) { e_99 = { error: e_99_1 }; }
                    finally {
                        try {
                            if (unusedLinks_1_1 && !unusedLinks_1_1.done && (_c = unusedLinks_1.return)) _c.call(unusedLinks_1);
                        }
                        finally { if (e_99) throw e_99.error; }
                    }
                }
                else {
                    try {
                        for (var unusedLinks_2 = __values(unusedLinks), unusedLinks_2_1 = unusedLinks_2.next(); !unusedLinks_2_1.done; unusedLinks_2_1 = unusedLinks_2.next()) {
                            var unusedLink = unusedLinks_2_1.value;
                            ParsedFavicon.WipeJQuery(unusedLink);
                        }
                    }
                    catch (e_100_1) { e_100 = { error: e_100_1 }; }
                    finally {
                        try {
                            if (unusedLinks_2_1 && !unusedLinks_2_1.done && (_d = unusedLinks_2.return)) _d.call(unusedLinks_2);
                        }
                        finally { if (e_100) throw e_100.error; }
                    }
                }
            }
            var e_97, _a, e_98, _b, e_99, _c, e_100, _d;
        };
        Controller.prototype.CreateNewLink = function () {
            var newLink = $(document.createElement("link")).attr("no-href-transform", "");
            this.Element.append(newLink);
            return newLink;
        };
        Controller.prototype.GetSiteIcons = function (siteName) {
            var path = utils.Paths.MapPath.FromTrueRoot("~/" + siteName + "/$$/Home/AvailableFavicons");
            return ng_utils_45.$http
                .get(path)
                .then(function (result) { return result.data; });
        };
        Controller = __decorate([
            utils.Component({
                ModuleId: module_54.id,
                Restrict: utils.Target.Attribute,
                Scope: utils.ScopeMode.ParentScope,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sdc/void/option/content/sdc-void-option-content", ["require", "exports", "app/utils"], function (require, exports, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.EnsureNoLegacyFallback("sdc-void-option-content");
});
define("app/sds/address/input/prompt/sds-address-input-prompt", ["require", "exports", "app/utils", "app/ng-utils", "module"], function (require, exports, utils, ng_utils_46, module_55) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller() {
            this.EnableManualInputActivity = new utils.ActivityController();
        }
        Controller.prototype.EnableManualInput = function () {
            return __awaiter(this, void 0, ng_utils_46.$q, function () {
                var token;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.EnableManualInputActivity.Enter();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4, this.RaiseSelected({ searchText: this.SearchText, token: token })];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            token.Exit();
                            return [7];
                        case 4: return [2];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.In("search-text")
        ], Controller.prototype, "SearchText", void 0);
        __decorate([
            utils.Bind.Getter("on-selected")
        ], Controller.prototype, "RaiseSelected", void 0);
        __decorate([
            utils.Bind.Transclude()
        ], Controller.prototype, "Transclude", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_55.id,
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sds/authentication/changepassword/card/sds-authentication-changepassword-card", ["require", "exports", "module", "app/utils"], function (require, exports, module_56, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller = __decorate([
            utils.Component({
                ModuleId: module_56.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/authentication/changepassword/recovery/sds-authentication-changepassword-recovery", ["require", "exports", "module", "app/utils", "app/ng-utils", "app/selcomm/service", "app/sdc/closable/section/sdc-closable-section", "app/sds/contact/sds-contact"], function (require, exports, module_57, utils, ng_utils_47, service_51, closableSection, selectedContact) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var template = new Promise(function (resolve_5, reject_5) { require(["template!sds-authentication-changepassword-dialog"], resolve_5, reject_5); });
    function ChangePassword(contactCode, previousPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, ChangePassword.Thin({
                            ContactCode: contactCode,
                            OldPassword: previousPassword,
                            NewPassword: newPassword,
                        })];
                    case 1:
                        result = _a.sent();
                        switch (result) {
                            case ChangePassword.WellKnownResult.Success:
                                return [2];
                            case ChangePassword.WellKnownResult.InvalidPreviousPassword:
                                throw new ChangePassword.InvalidPreviousPasswordError();
                            case ChangePassword.WellKnownResult.LoginBlocked:
                                throw new ChangePassword.LoginBlockedError();
                            case ChangePassword.WellKnownResult.UnknownError:
                                throw new ChangePassword.UnknownError(result);
                            default:
                                throw new ChangePassword.InvalidResponse(result);
                        }
                        return [2];
                }
            });
        });
    }
    exports.ChangePassword = ChangePassword;
    (function (ChangePassword) {
        function Thin(request) {
            return service_51.Service.Thin.Contact.PasswordUpdate(request);
        }
        ChangePassword.Thin = Thin;
        var WellKnownError = (function (_super) {
            __extends(WellKnownError, _super);
            function WellKnownError() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WellKnownError = __decorate([
                utils.FixExtendBuiltIn
            ], WellKnownError);
            return WellKnownError;
        }(Error));
        ChangePassword.WellKnownError = WellKnownError;
        var InvalidPreviousPasswordError = (function (_super) {
            __extends(InvalidPreviousPasswordError, _super);
            function InvalidPreviousPasswordError() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.DisplayMessage = "The previous password was invalid.";
                return _this;
            }
            InvalidPreviousPasswordError = __decorate([
                utils.FixExtendBuiltIn
            ], InvalidPreviousPasswordError);
            return InvalidPreviousPasswordError;
        }(WellKnownError));
        ChangePassword.InvalidPreviousPasswordError = InvalidPreviousPasswordError;
        var LoginBlockedError = (function (_super) {
            __extends(LoginBlockedError, _super);
            function LoginBlockedError() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.DisplayMessage = "Your account is blocked, please contact customer support.";
                return _this;
            }
            LoginBlockedError = __decorate([
                utils.FixExtendBuiltIn
            ], LoginBlockedError);
            return LoginBlockedError;
        }(WellKnownError));
        ChangePassword.LoginBlockedError = LoginBlockedError;
        var UnknownError = (function (_super) {
            __extends(UnknownError, _super);
            function UnknownError(Response) {
                var _this = _super.call(this, "Unknown response: " + Response) || this;
                _this.Response = Response;
                return _this;
            }
            UnknownError = __decorate([
                utils.FixExtendBuiltIn
            ], UnknownError);
            return UnknownError;
        }(Error));
        ChangePassword.UnknownError = UnknownError;
        var InvalidResponse = (function (_super) {
            __extends(InvalidResponse, _super);
            function InvalidResponse() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.DisplayMessage = "Unable to change password due to some technical issue. Please try again later";
                return _this;
            }
            InvalidResponse = __decorate([
                utils.FixExtendBuiltIn
            ], InvalidResponse);
            return InvalidResponse;
        }(Error));
        ChangePassword.InvalidResponse = InvalidResponse;
        var WellKnownResult;
        (function (WellKnownResult) {
            WellKnownResult["UnknownError"] = "Unable to change password due to some technical issue. Please contact support team.";
            WellKnownResult["Success"] = "succeed";
            WellKnownResult["InvalidPreviousPassword"] = "Current password is incorrect. Please try again.";
            WellKnownResult["LoginBlocked"] = "Your account is blocked. Please contact support.";
        })(WellKnownResult = ChangePassword.WellKnownResult || (ChangePassword.WellKnownResult = {}));
    })(ChangePassword = exports.ChangePassword || (exports.ChangePassword = {}));
    var Result;
    (function (Result) {
        Result["ChangePassword"] = "change-password";
        Result["Success"] = "success";
    })(Result || (Result = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.ChangePasswordActivity = new utils.ActivityController("");
            _this.CurrentPassword = "";
            _this.NewPassword = "";
            _this.ConfirmNewPassword = "";
            _this.Result = Result.ChangePassword;
            return _this;
        }
        Object.defineProperty(Controller.prototype, "ContactCode", {
            get: function () {
                return utils.AssertNotVoid(utils.AssertNotVoid(this.SelectedContactController).ContactCode);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.ChangePasswordActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Submit = function (contactCode, currentPassword, newPassword, form) {
            if (contactCode === void 0) { contactCode = this.ContactCode; }
            if (currentPassword === void 0) { currentPassword = this.CurrentPassword; }
            if (newPassword === void 0) { newPassword = this.NewPassword; }
            return __awaiter(this, void 0, ng_utils_47.$q, function () {
                var notifiedError, token, err_41;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            notifiedError = false;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, , 7]);
                            token = this.ChangePasswordActivity.TryEnter();
                            if (utils.IsVoid(token)) {
                                notifiedError = true;
                                utils.Toast.Simple("Hold on, we're still trying to process your previous request");
                                throw new utils.AlreadyDoingActionError(this.ChangePasswordActivity.Name);
                            }
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, , 4, 5]);
                            if (!utils.IsVoid(form) && !form.$valid) {
                                notifiedError = true;
                                utils.Toast.Simple("Some inputs are invalid");
                                throw new utils.FormInvalidError(form);
                            }
                            return [4, ChangePassword(contactCode, currentPassword, newPassword)];
                        case 3:
                            _a.sent();
                            if (!this.CanClose) {
                                this.Result = Result.Success;
                                return [2];
                            }
                            utils.Toast.Simple("Your password has been successfully updated.");
                            this.Close();
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5: return [3, 7];
                        case 6:
                            err_41 = _a.sent();
                            if (!notifiedError) {
                                if (err_41 instanceof ChangePassword.WellKnownError)
                                    utils.Toast.Simple(err_41.DisplayMessage);
                                else
                                    utils.Toast.Simple("An error occurred whilst trying to change your password, contact support if the issue persists");
                            }
                            throw err_41;
                        case 7: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "CanClose", {
            get: function () {
                return !utils.IsVoid(this.OverridingClose) || !utils.IsVoid(this.ClosableSection);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Close = function () {
            if (!utils.IsVoid(this.OverridingClose))
                this.OverridingClose();
            if (!utils.IsVoid(this.ClosableSection))
                this.ClosableSection.Close();
        };
        __decorate([
            utils.Bind.Controller(closableSection.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents, })
        ], Controller.prototype, "ClosableSection", void 0);
        __decorate([
            utils.Bind.Getter("cancel"),
            utils.Bind.DefaultValue(null)
        ], Controller.prototype, "OverridingClose", void 0);
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "SelectedContactController", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_57.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    function ShowChangePasswordDialog(extender) {
        return __awaiter(this, void 0, void 0, function () {
            function close() {
                ng_utils_47.$mdDialog.hide();
            }
            function cancel() {
                ng_utils_47.$mdDialog.cancel();
            }
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = ng_utils_47.$mdDialog).show;
                        _c = {};
                        return [4, template];
                    case 1:
                        _b.apply(_a, [__assign.apply(void 0, [(_c.template = _d.sent(), _c), extender, { scope: angular.extend(extender && extender.scope || ng_utils_47.$rootScope, {
                                        close: close,
                                        cancel: cancel,
                                    }) }])]);
                        return [2];
                }
            });
        });
    }
});
define("app/sds/authentication/login/forgotpassword/sds-authentication-login-forgotpassword", ["require", "exports", "module", "app/utils", "app/ng-utils", "app/selcomm/service", "app/sss/sites"], function (require, exports, module_58, utils, ng_utils_48, service_52, sites_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Step;
    (function (Step) {
        Step["AwaitingContactCode"] = "awaiting-contact-code";
        Step["NoAccount"] = "no-account";
        Step["InvalidAccount"] = "invalid-account";
        Step["BlockedAccount"] = "blocked-account";
        Step["NoEmail"] = "no-email";
        Step["AwaitingToken"] = "awaiting-token";
    })(Step || (Step = {}));
    var path = utils.StepPath.Create(Step.AwaitingContactCode);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.VerifyCanResetPasswordActivity = new utils.ActivityController("inputAccountNoActivity");
            _this.ContactCode = _this.BoundContactCode || "";
            _this.contactStatusValid = false;
            _this.StepPath = utils.StepPath.Create(Step.AwaitingContactCode);
            _this.CustomerCareDetailsLoader = new utils.Loader(function (businessUnitCode) { return _this.getCustomerCareDetails(businessUnitCode); });
            _this.LoadCustomerCareDetailsActivity = new utils.ActivityController("loadCustomerCareDetailsNoActivity");
            return _this;
        }
        Controller_52 = Controller;
        Controller.prototype.ClearResetSession = function () {
            var _this = this;
            this.OnDispose(function () {
                if (!utils.IsVoid(_this.ResetSession))
                    _this.ResetSession.Terminate();
            });
        };
        Controller.prototype.Cancel = function () {
            return this.BoundClose();
        };
        Object.defineProperty(Controller.prototype, "Step", {
            get: function () {
                return this.StepPath.CurrentStep;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.VerifyCanResetPasswordActivity.IsActive || this.CustomerCareDetailsLoader.IsLoading || this.LoadCustomerCareDetailsActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.IsFinished = function () {
        };
        Controller.prototype.VerifyCanResetPassword = function (contactCode, form) {
            return __awaiter(this, void 0, ng_utils_48.$q, function () {
                var _this = this;
                var token, newSession, GenerateNewSessionOnce, RetryOnSessionFail, base, uriBuilder, launchUri_1, passwordResetPromise, resetPassword, last;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.VerifyCanResetPasswordActivity.Enter({ onFail: function () { return void utils.Toast.Simple("Hold on, we're still trying to process your previous request."); }, });
                            GenerateNewSessionOnce = function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!!utils.IsVoid(newSession)) return [3, 2];
                                            return [4, newSession];
                                        case 1: return [2, _a.sent()];
                                        case 2: return [4, (newSession = this.GenerateNewSession())];
                                        case 3: return [2, _a.sent()];
                                    }
                                });
                            }); };
                            RetryOnSessionFail = function (action) {
                                return _this.RetryOnSessionFail(function (sessionkey) {
                                    token.AssertNotExited();
                                    return action(sessionkey);
                                }, GenerateNewSessionOnce);
                            };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 7, 8]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are invalid, verify them before continuing.");
                                throw new utils.FormInvalidError(form);
                            }
                            base = new utils.Paths.UriBuilder(window.location.href);
                            base.Path = utils.Paths.MapPath.FromTrueRoot("~/" + sites_5.default.Current.Name + "/PasswordRecoveryLanding/");
                            uriBuilder = new utils.Paths.UriBuilder(base);
                            launchUri_1 = new utils.Paths.UriBuilder({
                                Scheme: uriBuilder.Scheme,
                                Authority: uriBuilder.Authority,
                                Path: utils.Paths.MapPath.FromTrueRoot("~/" + sites_5.default.Current.Name + "/PasswordRecoveryLanding/"),
                                Query: [],
                            });
                            passwordResetPromise = RetryOnSessionFail(function (sessionKey) { return service_52.Service.Thin.Account.AccountPasswordResetSimpleRequestKey({
                                SessionKey: sessionKey,
                                AccountNumber: contactCode,
                                Url: launchUri_1.toString() + "?reset-password-key=<?auth-token>"
                            }); });
                            return [4, Controller_52.RaiseErrors(passwordResetPromise)];
                        case 2:
                            resetPassword = _a.sent();
                            console.log("Returned: " + resetPassword[0] + " BU: " + resetPassword[1]);
                            last = sites_5.default.Current.Name;
                            console.log("path part: " + last);
                            if (!(resetPassword[0] == 1)) return [3, 4];
                            return [4, this.getCustomerCareDetails("path:" + last)];
                        case 3:
                            _a.sent();
                            return [3, 6];
                        case 4: return [4, this.getCustomerCareDetails(resetPassword[1])];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6:
                            switch (resetPassword[0]) {
                                case 0:
                                    this.StepPath.NavigateForward(Step.AwaitingToken);
                                    break;
                                case 1:
                                    this.StepPath.NavigateForward(Step.NoAccount);
                                    throw new Error("Invalid contactCode: " + contactCode);
                                case 2:
                                    this.StepPath.NavigateForward(Step.BlockedAccount);
                                    throw new Error("Account blocked: " + contactCode);
                                case 3:
                                    this.StepPath.NavigateForward(Step.InvalidAccount);
                                    throw new Error("Account blocked: " + contactCode);
                                case 4:
                                    this.StepPath.NavigateForward(Step.NoEmail);
                                    throw new Error("No email for: " + contactCode);
                                case 5:
                                    throw new Error("Request failed: " + contactCode);
                                default:
                                    throw new Error("Returned " + resetPassword);
                            }
                            return [3, 8];
                        case 7:
                            token.Exit();
                            return [7];
                        case 8: return [2];
                    }
                });
            });
        };
        Controller.prototype.IsNotEmpty = function (Value) {
            if (utils.IsVoid(Value))
                return false;
            var str = Value;
            return str.trim().length > 0;
        };
        Controller.prototype.getCustomerCareDetails = function (businessUnitCode) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var dtls, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_52.Service.BusinessUnit.AllCustomerCareDetails({ SessionKey: this.SessionKey, BusinessUnitCode: businessUnitCode })];
                        case 1:
                            dtls = _a.sent();
                            this.Details = dtls.Items.filter(function (x) { return _this.IsNotEmpty(x.ContactNumber); });
                            for (i = 0; i < dtls.Items.length; i++) {
                                console.log(i + " name: " + dtls.Items[i].Name + " number: " + dtls.Items[i].ContactNumber + " website: " + dtls.Items[i].WebsiteUrl);
                            }
                            this.CareNumber = this.Details[0].ContactNumber;
                            this.LoginPage = this.Details[0].ContactFax;
                            return [2, dtls];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "CustomerCareDetails", {
            get: function () {
                return this.CustomerCareDetailsLoader.Value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "hasNumber", {
            get: function () {
                console.log("has number ?? " + (utils.IsVoid(this.CustomerCareDetails) ? "void" : this.CustomerCareDetails[0].Value));
                return !utils.IsVoid(this.CustomerCareDetails);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.GotoStart = function () {
            this.StepPath.NavigateForward(Step.AwaitingContactCode);
        };
        Controller.prototype.RetryOnSessionFail = function (action, generateSession) {
            var _this = this;
            if (generateSession === void 0) { generateSession = function () { return _this.GenerateNewSession(); }; }
            return utils.RetryOnSessionFail({
                sessionKey: this.SessionKey,
                generateSession: generateSession,
                invoke: action,
            });
        };
        Controller.RaiseErrors = function (promise) {
            return __awaiter(this, void 0, void 0, function () {
                var err_42;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, promise];
                        case 1: return [2, _a.sent()];
                        case 2:
                            err_42 = _a.sent();
                            Controller_52.NotifyError(err_42);
                            throw err_42;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.NotifyError = function (err) {
            utils.Toast.Simple("An error occurred while trying to reset your password");
            ng_utils_48.$exceptionHandler(err);
        };
        Controller.prototype.GenerateNewSession = function () {
            return __awaiter(this, void 0, void 0, function () {
                var session;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_52.Auth.StartSessionThin(sites_5.default.Current)];
                        case 1:
                            session = _a.sent();
                            this.SessionKey = session.SessionKey;
                            return [2, session];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.Getter("open-reset-password")
        ], Controller.prototype, "BoundOpenResetPassword", void 0);
        __decorate([
            utils.Bind.Getter("close")
        ], Controller.prototype, "BoundClose", void 0);
        __decorate([
            utils.Bind.In("contact-code", { optional: true })
        ], Controller.prototype, "BoundContactCode", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "ClearResetSession", null);
        Controller = Controller_52 = __decorate([
            utils.Component({
                ModuleId: module_58.id,
            })
        ], Controller);
        return Controller;
        var Controller_52;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/authentication/login/newuser/sds-authentication-login-newuser", ["require", "exports", "app/utils", "app/selcomm/service", "app/ng-utils", "app/sss/sites", "module"], function (require, exports, utils, service_53, ng_utils_49, sites_6, module_59) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_59.id);
    var Step;
    (function (Step) {
        Step["Initial"] = "initial";
        Step["VerifySetupAccountPasswordToken"] = "verify-setup-account-password-token";
    })(Step || (Step = {}));
    function VerifyNewUser(contactCode, billNumber, sessionKey) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, service_53.Service.Thin.Account.NewUserVerify(__assign({ ContactCode: contactCode, BillNumber: billNumber }, (utils.IsVoid(sessionKey) ? {} : { SessionKey: sessionKey, })))];
                    case 1:
                        result = _a.sent();
                        if (!result)
                            throw new VerifyNewUser.InvalidUserOrBillError();
                        return [2];
                }
            });
        });
    }
    exports.VerifyNewUser = VerifyNewUser;
    (function (VerifyNewUser) {
        var InvalidUserOrBillError = (function () {
            function InvalidUserOrBillError() {
            }
            InvalidUserOrBillError = __decorate([
                utils.FixExtendBuiltIn
            ], InvalidUserOrBillError);
            return InvalidUserOrBillError;
        }());
        VerifyNewUser.InvalidUserOrBillError = InvalidUserOrBillError;
    })(VerifyNewUser = exports.VerifyNewUser || (exports.VerifyNewUser = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ContactCode = _this.BoundContactCode ? String(_this.BoundContactCode) : "";
            _this.StepPath = utils.StepPath.Create(Step.Initial);
            _this.SubmitNewUserRequestActivity = new utils.ActivityController("SubmitNewUserRequest");
            _this.VerifyTokenActivity = new utils.ActivityController("VerifyToken");
            return _this;
        }
        Object.defineProperty(Controller.prototype, "Step", {
            get: function () {
                return this.StepPath.CurrentStep;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.SubmitNewUserRequestActivity.IsActive || this.VerifyTokenActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.SubmitNewUserRequest = function (contactCode, billNumber, form) {
            return __awaiter(this, void 0, ng_utils_49.$q, function () {
                var _this = this;
                var token, err_43;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.SubmitNewUserRequestActivity.Enter({ onFail: function () { return void utils.Toast.Simple("Hold on, we're still processing your previous request."); }, });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are invalid, verify them before continuing.");
                                throw new utils.FormInvalidError(form);
                            }
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, this.RetryOnSessionFail(function (sessionKey) { return VerifyNewUser(contactCode, billNumber, sessionKey); }, function () { return _this.GenerateNewSession(); })];
                        case 3:
                            _a.sent();
                            this.StepPath.NavigateForward(Step.VerifySetupAccountPasswordToken);
                            return [3, 5];
                        case 4:
                            err_43 = _a.sent();
                            if (err_43 instanceof VerifyNewUser.InvalidUserOrBillError)
                                utils.Toast.Simple("New user request failed. Ensure the \"Customer Account Number\" is correct and that \"Bill/Invoice Number\" is valid.");
                            else
                                utils.Toast.Simple("An error occurred, contact support for further assistance.");
                            throw err_43;
                        case 5: return [3, 7];
                        case 6:
                            token.Exit();
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        };
        Controller.prototype.VerifyToken = function (setupPasswordToken, form) {
            if (setupPasswordToken === void 0) { setupPasswordToken = this.SetupPasswordToken; }
            return __awaiter(this, void 0, ng_utils_49.$q, function () {
                var _this = this;
                var token, result, err_44;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.VerifyTokenActivity.Enter({ onFail: function () { return void utils.Toast.Simple("Hold on, we're still processing your previous request."); } });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are invalid, verify them before continuing.");
                                throw new utils.FormInvalidError(form);
                            }
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, this.RetryOnSessionFail(function (sessionKey) { return service_53.Service.Thin.Account.ValidateEncryptedToken({ SessionKey: sessionKey, EncryptedToken: setupPasswordToken, }); }, function () { return _this.GenerateNewSession(); })];
                        case 3:
                            result = _a.sent();
                            if (!result)
                                throw new Error("Invalid token");
                            this.OpenSetupAccountPassword({ setupPasswordToken: setupPasswordToken });
                            return [3, 5];
                        case 4:
                            err_44 = _a.sent();
                            utils.Toast.Simple("An error occurred, make sure that token is correct.");
                            throw err_44;
                        case 5: return [3, 7];
                        case 6:
                            token.Exit();
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        };
        Controller.prototype.GenerateNewSession = function () {
            return __awaiter(this, void 0, void 0, function () {
                var session;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_53.Auth.StartSessionThin(sites_6.Site.Current)];
                        case 1:
                            session = _a.sent();
                            this.SessionKey = session.SessionKey;
                            return [2, session];
                    }
                });
            });
        };
        Controller.prototype.RetryOnSessionFail = function (action, generateSession) {
            var _this = this;
            if (generateSession === void 0) { generateSession = function () { return _this.GenerateNewSession(); }; }
            return utils.RetryOnSessionFail({
                sessionKey: this.SessionKey,
                generateSession: generateSession,
                invoke: action,
            });
        };
        __decorate([
            utils.Bind.In("contact-code", { optional: true })
        ], Controller.prototype, "BoundContactCode", void 0);
        __decorate([
            utils.Bind.Getter("close")
        ], Controller.prototype, "Close", void 0);
        __decorate([
            utils.Bind.Getter("open-setup-account-password")
        ], Controller.prototype, "OpenSetupAccountPassword", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_59.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/authentication/login/resetpassword/sds-authentication-login-resetpassword", ["require", "exports", "app/utils", "app/selcomm/service", "app/ng-utils", "module", "app/sss/sites"], function (require, exports, utils, service_54, ng_utils_50, module_60, sites_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_60.id);
    var Step;
    (function (Step) {
        Step["Initial"] = "initial";
        Step["Success"] = "success";
    })(Step || (Step = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Password = "";
            _this.ConfirmPassword = "";
            _this.ResettingPassword = new utils.ActivityController("Resetting Password");
            _this.StepPath = utils.StepPath.Create(Step.Initial);
            if (!_this.SessionKey)
                _this.GenerateNewSession();
            return _this;
        }
        Controller_53 = Controller;
        Controller.prototype.Close = function () {
            this.BoundClose();
        };
        Controller.prototype.ResetPassword = function (resetPasswordToken, password, form) {
            return __awaiter(this, void 0, ng_utils_50.$q, function () {
                var _this = this;
                var token, result, err_45;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.ResettingPassword.Enter({ onFail: function () { return void utils.Toast.Simple("Hold on, we're already processing your previous request."); } });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are invalid, verify them before continuing.");
                                throw new utils.FormInvalidError(form);
                            }
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, this.RetryOnSessionFail(function (sessionKey) { return service_54.Service.Account.AccountPasswordResetByToken({
                                    SessionKey: sessionKey,
                                    NewPassword: password,
                                    TokenKey: resetPasswordToken,
                                }); }, function () { return _this.GenerateNewSession(); })];
                        case 3:
                            result = _a.sent();
                            if (!result)
                                throw new Error("Reset failed");
                            this.StepPath.NavigateForward(Step.Success);
                            return [3, 5];
                        case 4:
                            err_45 = _a.sent();
                            Controller_53.NotifyError(err_45);
                            throw err_45;
                        case 5: return [3, 7];
                        case 6:
                            token.Exit();
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "Step", {
            get: function () {
                return this.StepPath.CurrentStep;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.ResettingPassword.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.RaiseErrors = function (promise) {
            return __awaiter(this, void 0, void 0, function () {
                var err_46;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, promise];
                        case 1: return [2, _a.sent()];
                        case 2:
                            err_46 = _a.sent();
                            Controller_53.NotifyError(err_46);
                            throw err_46;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.RaiseErrors = function (promise) {
            return __awaiter(this, void 0, void 0, function () {
                var err_47;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, promise];
                        case 1: return [2, _a.sent()];
                        case 2:
                            err_47 = _a.sent();
                            Controller_53.NotifyError(err_47);
                            throw err_47;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.NotifyError = function (err) {
            utils.Toast.Simple("An error occurred while trying to reset your password");
            ng_utils_50.$exceptionHandler(err);
        };
        Controller.prototype.RetryOnSessionFail = function (action, generateSession) {
            var _this = this;
            if (generateSession === void 0) { generateSession = function () { return _this.GenerateNewSession(); }; }
            return utils.RetryOnSessionFail({
                sessionKey: this.SessionKey,
                generateSession: generateSession,
                invoke: action,
            });
        };
        Controller.prototype.GenerateNewSession = function () {
            return __awaiter(this, void 0, ng_utils_50.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = service_54.Auth;
                            return [4, service_54.Auth.StartSessionThin(sites_7.default.Current)];
                        case 1: return [2, _a.CurrentSession = _b.sent()];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "SessionKey", {
            get: function () {
                return !service_54.Auth.CurrentSession ? null : service_54.Auth.CurrentSession.SessionKey;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.In("reset-password-token")
        ], Controller.prototype, "ResetPasswordToken", void 0);
        __decorate([
            utils.Bind.Getter("close")
        ], Controller.prototype, "BoundClose", void 0);
        Controller = Controller_53 = __decorate([
            utils.Component({
                ModuleId: module_60.id,
            })
        ], Controller);
        return Controller;
        var Controller_53;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/authentication/login/resetpasswordkey/sds-authentication-login-resetpasswordkey", ["require", "exports", "app/pre-angular-bootstrap-utils", "app/utils", "app/selcomm/service", "app/ng-utils", "module", "app/sss/sites"], function (require, exports, pre_angular_bootstrap_utils_2, utils, service_55, ng_utils_51, module_61, sites_8) {
    "use strict";
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    Object.defineProperty(exports, "__esModule", { value: true });
    __export(pre_angular_bootstrap_utils_2);
    var Name = utils.GetComponentNameFromModuleId(module_61.id);
    var Step;
    (function (Step) {
        Step["Initial"] = "initial";
        Step["Success"] = "success";
    })(Step || (Step = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Password = "";
            _this.ConfirmPassword = "";
            _this.ResettingPassword = new utils.ActivityController("Resetting Password");
            _this.StepPath = utils.StepPath.Create(Step.Initial);
            if (!_this.SessionKey)
                _this.GenerateNewSession();
            console.log("sds-authentication-resetpasswordkey init");
            var isDisposed = false;
            _this.OnDispose(function () { return isDisposed = true; });
            utils.Execute(function () { return __awaiter(_this, void 0, void 0, function () {
                var err_48;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!isDisposed) return [3, 7];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, , 6]);
                            return [4, utils.Delay(1000)];
                        case 2:
                            _a.sent();
                            if (!(this.Step == Step.Success && !isDisposed)) return [3, 4];
                            return [4, utils.Delay(10000)];
                        case 3:
                            _a.sent();
                            if (!isDisposed) {
                                this.Close();
                            }
                            _a.label = 4;
                        case 4: return [3, 6];
                        case 5:
                            err_48 = _a.sent();
                            ng_utils_51.$exceptionHandler(err_48);
                            return [3, 6];
                        case 6: return [3, 0];
                        case 7: return [2];
                    }
                });
            }); });
            return _this;
        }
        Controller_54 = Controller;
        Controller.prototype.Close = function () {
            this.BoundClose();
        };
        Controller.prototype.ResetPassword = function (resetPasswordKey, password, form) {
            return __awaiter(this, void 0, ng_utils_51.$q, function () {
                var _this = this;
                var token, result, err_49;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.ResettingPassword.Enter({ onFail: function () { return void utils.Toast.Simple("Hold on, we're already processing your previous request."); } });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are invalid, verify them before continuing.");
                                throw new utils.FormInvalidError(form);
                            }
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, this.RetryOnSessionFail(function (sessionKey) { return service_55.Service.Account.AccountPasswordReset({
                                    SessionKey: sessionKey,
                                    NewPassword: password,
                                    PasswordResetKey: resetPasswordKey,
                                }); }, function () { return _this.GenerateNewSession(); })];
                        case 3:
                            result = _a.sent();
                            if (!result)
                                throw new Error("Reset failed");
                            this.StepPath.NavigateForward(Step.Success);
                            return [3, 5];
                        case 4:
                            err_49 = _a.sent();
                            Controller_54.NotifyError(err_49);
                            throw err_49;
                        case 5: return [3, 7];
                        case 6:
                            token.Exit();
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "Step", {
            get: function () {
                return this.StepPath.CurrentStep;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.ResettingPassword.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.RaiseErrors = function (promise) {
            return __awaiter(this, void 0, void 0, function () {
                var err_50;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, promise];
                        case 1: return [2, _a.sent()];
                        case 2:
                            err_50 = _a.sent();
                            Controller_54.NotifyError(err_50);
                            throw err_50;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.RaiseErrors = function (promise) {
            return __awaiter(this, void 0, void 0, function () {
                var err_51;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, promise];
                        case 1: return [2, _a.sent()];
                        case 2:
                            err_51 = _a.sent();
                            Controller_54.NotifyError(err_51);
                            throw err_51;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.NotifyError = function (err) {
            utils.Toast.Simple("An error occurred while trying to reset your password");
            ng_utils_51.$exceptionHandler(err);
        };
        Controller.prototype.RetryOnSessionFail = function (action, generateSession) {
            var _this = this;
            if (generateSession === void 0) { generateSession = function () { return _this.GenerateNewSession(); }; }
            return utils.RetryOnSessionFail({
                sessionKey: this.SessionKey,
                generateSession: generateSession,
                invoke: action,
            });
        };
        Controller.prototype.GenerateNewSession = function () {
            return __awaiter(this, void 0, ng_utils_51.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = service_55.Auth;
                            return [4, service_55.Auth.StartSessionThin(sites_8.default.Current)];
                        case 1: return [2, _a.CurrentSession = _b.sent()];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "SessionKey", {
            get: function () {
                return !service_55.Auth.CurrentSession ? null : service_55.Auth.CurrentSession.SessionKey;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.In("reset-password-key")
        ], Controller.prototype, "ResetPasswordKey", void 0);
        __decorate([
            utils.Bind.Getter("close")
        ], Controller.prototype, "BoundClose", void 0);
        Controller = Controller_54 = __decorate([
            utils.Component({
                ModuleId: module_61.id,
            })
        ], Controller);
        return Controller;
        var Controller_54;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/authentication/required/if/sds-authentication-required-if", ["require", "exports", "module", "app/utils"], function (require, exports, module_62, utils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_62.id);
    var Controller = (function () {
        function Controller() {
        }
        Object.defineProperty(Controller.prototype, "AuthenticationRequired", {
            get: function () {
                return !!this._Value;
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.In(Name)
        ], Controller.prototype, "_Value", void 0);
        Controller = __decorate([
            utils.Component({
                Name: Name,
                Restrict: utils.Target.Attribute,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sds/contact/address/list/sds-contact-address-list", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "module", "app/sds/contact/address/utils", "app/sss/sites"], function (require, exports, utils, ng_utils_52, service_56, module_63, contactAddressUtils, sites_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function IsDisplayableContactAddressType(contactAddressType, allowVoids) {
        if (allowVoids === void 0) { allowVoids = false; }
        if (utils.IsVoid(contactAddressType))
            return allowVoids;
        switch (contactAddressType.Code) {
            case "IP":
                return false;
            default:
                return true;
        }
    }
    function IsDisplayableContactAddress(contactAddress) {
        if (!contactAddress)
            return true;
        return IsDisplayableContactAddressType(contactAddress.Type);
        ;
    }
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.AddressTypesLoader = new utils.CollectionLoader.Readonly(function () { return contactAddressUtils.GetContactAddressTypes().then(function (ats) { return ats.filter(function (at) { return IsDisplayableContactAddressType(at); }); }); });
            _this.ContactAddressesLoader = new utils.CollectionLoader(function () { return contactAddressUtils.GetContactExtendedAddresses(service_56.Auth.CurrentSession.CurrentContactCode).then(function (addrs) { return addrs.filter(function (addr) { return IsDisplayableContactAddress(addr); }); }); });
            _this.AddingContactAddress = false;
            _this.ContactAddressesLoader.Load();
            _this.AddressTypesLoader.Load();
            _this.Watch.Collection(function () { return _this.ContactAddresses; }, function () { return _this.AddableAddressTypes = _this.GetAddableTypes(); });
            _this.Watch(function () { return _this.AddressTypes; }, function () { return _this.AddableAddressTypes = _this.GetAddableTypes(); });
            return _this;
        }
        Controller.prototype.Add = function (contactAddress) {
            this.ContactAddresses.push(contactAddress);
        };
        Controller.prototype.RemoveInstanceByType = function (contactAddress) {
            this.RemoveOfType(contactAddress.Type.Code);
        };
        Controller.prototype.RemoveOfType = function (typeCode) {
            utils.Collection.ArrayRemoveWhere(this.ContactAddresses, function (a) { return a.Type && a.Type.Code === typeCode; });
        };
        Controller.prototype.RemoveInstance = function (contactAddress) {
            utils.Collection.ArrayRemoveAll(this.ContactAddresses, contactAddress);
        };
        Controller.prototype.ReplaceInstanceByType = function (contactAddress) {
            this.ReplaceOfType(contactAddress.Type.Code, contactAddress);
        };
        Controller.prototype.ReplaceOfType = function (typeCode, contactAddress) {
            utils.Collection.ArrayReplaceWhere(this.ContactAddresses, function (a) { return a.Type && a.Type.Code === typeCode; }, function () { return contactAddress; });
        };
        Object.defineProperty(Controller.prototype, "AvailableTypes", {
            get: function () {
                var _this = this;
                return this.AddressTypes.filter(function (et) { return !utils.Collection.Any(_this.ContactAddresses, function (e) { return e.Type && e.Type.Code === et.Code; }); });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "ContactAddresses", {
            get: function () {
                return this.ContactAddressesLoader.Values;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "AddressTypes", {
            get: function () {
                return this.AddressTypesLoader.Values;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "CanAdd", {
            get: function () {
                switch (sites_9.default.Current.Hash) {
                    case "a85fd748d6400a3aa6972d88b41869f93af12ff1fc924d6fb8390d3f83a1a24f":
                        return false;
                    default:
                        return utils.IsVoid(this.AddableAddressTypes) ? this.AddableAddressTypes : this.AddableAddressTypes.length > 0;
                }
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.CanDelete = function (contactAddress) {
            if (!contactAddress || !contactAddress.Type || !contactAddress.Type.Code)
                return false;
            switch (sites_9.default.Current.Hash) {
                case "88a2332c85130219b24b54d8015babf30a3ebd9e7b98c18e3cd5dfa24a70bd6e":
                case "1e5beccc1dfbba83df8715a2d7b8cffac5f893f9dade0785ee971d445465b497":
                case "79c6e970698a5215a0058f22068aa80fc41da72e404f0d7dc9891dc6fbcd0889":
                case "a85fd748d6400a3aa6972d88b41869f93af12ff1fc924d6fb8390d3f83a1a24f":
                    return false;
                default:
                    return utils.TrimEnd(contactAddress.Type.Code) !== "BA";
            }
        };
        Controller.prototype.CanUpdate = function (contactAddress) {
            switch (sites_9.default.Current.Hash) {
                case "a85fd748d6400a3aa6972d88b41869f93af12ff1fc924d6fb8390d3f83a1a24f":
                    return false;
                default:
                    return true;
            }
        };
        Controller.prototype.OnContactAddressAdded = function (contactAddress) {
            this.ContactAddresses.push(contactAddress);
            this.AddingContactAddress = false;
        };
        Controller.prototype.GetAddableTypes = function () {
            var _this = this;
            if (!this.AddressTypes || !this.ContactAddresses)
                return undefined;
            if (this.AddressTypes.length <= 0 || this.ContactAddresses.length <= 0)
                return this.AddressTypes;
            return this.AddressTypes.filter(function (pt) { return !utils.Collection.Any(_this.ContactAddresses, function (p) { return p.Type && p.Type.Code === pt.Code; }); });
        };
        Controller.prototype.EnterAdd = function () {
            return __awaiter(this, void 0, ng_utils_52.$q, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.CanAdd && !this.AddressTypesLoader.HasFailed)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 4, 5]);
                            if (!this.AddressTypesLoader.HasFailed) return [3, 3];
                            return [4, this.AddressTypesLoader.Load()];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [3, 5];
                        case 4:
                            this.AddingContactAddress = true;
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        Controller.prototype.CancelAdd = function () {
            this.AddingContactAddress = false;
        };
        Controller = __decorate([
            utils.Component({
                ModuleId: module_63.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/contact/address/new/sds-contact-address-new", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "module", "app/sds/contact/address/utils"], function (require, exports, utils, ng_utils_53, service_57, module_64, contactAddressUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.CreateActivity = new utils.ActivityController();
            _this.LoadingAvailableContactAddressTypes = new utils.ActivityController();
            _this.Init();
            return _this;
        }
        Controller_55 = Controller;
        Object.defineProperty(Controller.prototype, "CanCancel", {
            get: function () {
                return !utils.IsVoid(this.Cancel);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "AllowPoBox", {
            get: function () {
                return contactAddressUtils.IsPoBoxAllowed(this.ContactAddressType);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Create = function (form) {
            return __awaiter(this, void 0, ng_utils_53.$q, function () {
                var addType, targetContactAddress, token, addId, ipndAddType, ipndAddress, ex_10;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are not valid, try again after checking them.");
                                return [2];
                            }
                            addType = utils.AssertNotVoid(this.ContactAddressType);
                            targetContactAddress = new contactAddressUtils.ContactAddress(this.Address, addType, service_57.Auth.CurrentSession.CurrentContactCode);
                            token = this.CreateActivity.TryEnter();
                            if (!token) {
                                throw new utils.AlreadyDoingActionError("Create Address");
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, 6, 7]);
                            return [4, contactAddressUtils.AddContactAddress(targetContactAddress)];
                        case 2:
                            addId = _a.sent();
                            if (!(addType.Code == "CA")) return [3, 4];
                            ipndAddType = __assign({}, addType);
                            ipndAddType.Code = "IP";
                            ipndAddress = new contactAddressUtils.ContactAddress(this.Address, ipndAddType, service_57.Auth.CurrentSession.CurrentContactCode);
                            return [4, contactAddressUtils.AddContactAddress(ipndAddress)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4: return [3, 7];
                        case 5:
                            ex_10 = _a.sent();
                            utils.Toast.Simple("An error occurred saving your new address.");
                            throw ex_10;
                        case 6:
                            token.Exit();
                            return [7];
                        case 7:
                            this.OnCreated({ contactAddress: targetContactAddress });
                            return [2];
                    }
                });
            });
        };
        Controller.GetContactAddressTypes = function () {
            return __awaiter(this, void 0, ng_utils_53.$q, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, contactAddressUtils.GetContactAddressTypes()];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "DisplayLabel", {
            get: function () {
                return "New Address";
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Init = function () {
            return __awaiter(this, void 0, ng_utils_53.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!!this.Attributes["contactAddressTypes"]) return [3, 2];
                            _a = this;
                            return [4, Controller_55.GetContactAddressTypes()];
                        case 1:
                            _a.AvailableContactAddressTypes = _b.sent();
                            _b.label = 2;
                        case 2:
                            if (!this.ContactAddressType && this.AvailableContactAddressTypes && this.AvailableContactAddressTypes.length === 1)
                                this.ContactAddressType = utils.Collection.FirstOrDefault(this.AvailableContactAddressTypes);
                            return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsProcessing", {
            get: function () {
                return this.LoadingAvailableContactAddressTypes.IsActive || this.CreateActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.HiddenPhoneTypeCodes = ["CC"];
        __decorate([
            utils.Bind.Getter("on-created")
        ], Controller.prototype, "OnCreated", void 0);
        __decorate([
            utils.Bind.In("contact-address-types", { optional: true })
        ], Controller.prototype, "AvailableContactAddressTypes", void 0);
        __decorate([
            utils.Bind.Getter("cancel", { optional: true })
        ], Controller.prototype, "Cancel", void 0);
        Controller = Controller_55 = __decorate([
            utils.Component({
                ModuleId: module_64.id,
            })
        ], Controller);
        return Controller;
        var Controller_55;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/menu/tiles/items/sds-menu-tiles-items", ["require", "exports", "app/utils", "$timeout", "$location", "$compile", "template!sds-menu-tiles-items-default-transclude"], function (require, exports, utils, $timeout, $location, $compile, defaultTranscludeTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Breadcrumb = (function () {
        function Breadcrumb(curr, next) {
            this.curr = curr;
            this.next = next;
        }
        Breadcrumb.prototype.UpdateTo = function (existing) {
            if (!existing)
                return this;
            existing.curr = this.curr;
            existing.next = this.next;
            return existing;
        };
        return Breadcrumb;
    }());
    var RoutingController = (function () {
        function RoutingController($scope, $element, $attrs, $transclude, $watch) {
            var _this = this;
            this.$scope = $scope;
            this.$element = $element;
            this.$attrs = $attrs;
            this.$transclude = $transclude;
            this.$watch = $watch;
            this.getMenuItems = function () { return _this._menuItems; };
            $watch.Collection(function () { return _this.menuItems; }, function () { return _this.selected = _this.getMenuItem(_this.subPath); });
            $watch(function () { return _this.generateHrefTo(_this.selected); }, function ($new) { return _this.hrefToThis = $new; });
            $watch(function () { return _this.subPath; }, function (path) { return _this.selected = _this.getMenuItem(path); });
        }
        Object.defineProperty(RoutingController.prototype, "selected", {
            get: function () {
                return this._selected;
            },
            set: function (value) {
                var _this = this;
                var thisTimeout;
                this._selected = value;
                this.subPath = Controller.GetUrlName(value);
                this.recurseClass = "inital";
                this._delayTimeout = thisTimeout = $timeout(function () { return _this._delayTimeout === thisTimeout && (_this.recurseClass = ""); }, 1);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(RoutingController.prototype, "menuItems", {
            get: function () {
                return this.getMenuItems() || [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(RoutingController.prototype, "owner", {
            get: function () {
                return angular.isFunction(this._owner) ? this._owner() : undefined;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(RoutingController.prototype, "root", {
            get: function () {
                var current = this;
                while (current.owner) {
                    current = current.owner;
                }
                return current;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(RoutingController.prototype, "absUrl", {
            get: function () {
                return this.useRouting ? $location.absUrl() : undefined;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(RoutingController.prototype, "hrefBeforeThis", {
            get: function () {
                return this.useRouting && this.router ? this.router.RootUrl : undefined;
            },
            enumerable: true,
            configurable: true
        });
        RoutingController.prototype.bindTo = function (parent) {
            var _this = this;
            if (angular.isUndefined(this.$attrs["menuItems"]) && parent) {
                this.getLoading = function () { return parent.selected ? parent.selected.loadingChildMenuItems : undefined; };
                this.getMenuItems = function () { return parent.selected ? parent.selected.ChildMenuItems : undefined; };
            }
            else {
                this.loadMenuItems();
                this.getLoading = function () { return _this._isLoading; };
            }
        };
        RoutingController.prototype.getMenuItem = function (subPath) {
            if (Controller.isTargetMenuItem(this.selected, subPath))
                return this.selected;
            var found = this.menuItems.filter(function (menuItem) { return Controller.isTargetMenuItem(menuItem, subPath); });
            if (found && found.length)
                return found[0];
            else
                return null;
        };
        RoutingController.prototype.generateHrefTo = function (target) {
            if (this.useRouting && this.router)
                return this.router.FormatAsUrl({ vm: { subPath: Controller.GetUrlName(target) } });
            return null;
        };
        RoutingController.isTargetMenuItem = function (menuItem, subPath) {
            return Controller.GetUrlName(menuItem) === subPath;
        };
        RoutingController.GetUrlName = function (menuItem) {
            return (menuItem && (menuItem.UrlName || String(menuItem.Id))) || null;
        };
        __decorate([
            utils.Bind.TwoWay("menuItems", { optional: true })
        ], RoutingController.prototype, "_menuItems", void 0);
        __decorate([
            utils.Bind.TwoWay("attrs", { optional: true })
        ], RoutingController.prototype, "attrs", void 0);
        __decorate([
            utils.Bind.Getter("owner")
        ], RoutingController.prototype, "_owner", void 0);
        __decorate([
            utils.Bind.Literal("rootName", { optional: true })
        ], RoutingController.prototype, "rootName", void 0);
        __decorate([
            utils.Bind.TwoWay("isLoading", { optional: true })
        ], RoutingController.prototype, "_isLoading", void 0);
        __decorate([
            utils.Bind.Getter("loadMenuItems")
        ], RoutingController.prototype, "loadMenuItems", void 0);
        __decorate([
            utils.Bind.TwoWay("useRouting", { optional: true }), utils.Bind.DefaultValue(false)
        ], RoutingController.prototype, "useRouting", void 0);
        __decorate([
            utils.Bind.TwoWay("selected", { optional: true })
        ], RoutingController.prototype, "selected", null);
        return RoutingController;
    }());
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller($scope, $element, $attrs, $transclude, $watch) {
            return _super.call(this, $scope, $element, $attrs, $transclude, $watch) || this;
        }
        Controller_56 = Controller;
        Controller.prototype.BindToParent = function () {
            this.bindTo(this.Parent);
        };
        Object.defineProperty(Controller.prototype, "Breadcrumbs", {
            get: function () {
                var found = this._breadcrumbs;
                var i;
                if (!found) {
                    found = [];
                }
                if (this.selfAndParents) {
                    for (i = 0; i < this.selfAndParents.length; i++) {
                        var curr = this.selfAndParents[i];
                        var next = i < this.selfAndParents.length ? this.selfAndParents[i + 1] : null;
                        if (curr.selected)
                            found[i] = new Breadcrumb(curr, next).UpdateTo(found[i]);
                        else
                            break;
                    }
                    if (found.length !== i)
                        found.length = i;
                }
                return this._breadcrumbs = found;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.transcludeTo = function (target, selected) {
            this.$transclude(this.$scope.$new(), function (clone, scope) {
                target.element.empty();
                if (clone.length) {
                    target.element.append(clone);
                }
                else {
                    scope["$selected"] = selected;
                    $compile(defaultTranscludeTemplate)(scope, function (clone, scope) {
                        target.element.append(clone);
                    });
                }
            });
        };
        Controller.prototype.bindTo = function (parent) {
            _super.prototype.bindTo.call(this, parent);
            this.selfAndParents = [];
            var current = this;
            while (current) {
                this.selfAndParents.unshift(current);
                current = current.owner;
            }
        };
        Controller.Name = "sds-menu-tiles-items";
        __decorate([
            utils.Bind.Controller(Controller_56.Name, { mode: utils.Bind.ControllerMode.Parents, optional: true })
        ], Controller.prototype, "Parent", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "BindToParent", null);
        __decorate([
            utils.Bind.TwoWay("displayBreadcrumbs", { optional: true }), utils.Bind.DefaultValue(true)
        ], Controller.prototype, "displayBreadcrumbs", void 0);
        __decorate([
            utils.Bind.TwoWay("animationEnabled", { optional: true }), utils.Bind.DefaultValue(true)
        ], Controller.prototype, "animationEnabled", void 0);
        Controller = Controller_56 = __decorate([
            utils.Component({
                Name: Controller_56.Name,
                Transclude: utils.TransclusionMode.Contents,
            }),
            __param(0, utils.Inject("$scope")),
            __param(1, utils.Inject("$element")),
            __param(2, utils.Inject("$attrs")),
            __param(3, utils.Inject("$transclude")),
            __param(4, utils.Inject("$watch"))
        ], Controller);
        return Controller;
        var Controller_56;
    }(RoutingController));
    exports.Controller = Controller;
});
define("app/sds/order/uc1/item/sds-order-uc1-item", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_65) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_65.id);
    var Controller = (function () {
        function Controller() {
        }
        Controller_57 = Controller;
        Controller.Bind = function (required) {
            if (required === void 0) { required = true; }
            return utils.Bind.Controller(Controller_57, { mode: utils.Bind.Controller.Mode.SelfOrParents, optional: !required });
        };
        __decorate([
            utils.Bind.In(name)
        ], Controller.prototype, "Order", void 0);
        Controller = Controller_57 = __decorate([
            utils.Component({
                Name: name,
            })
        ], Controller);
        return Controller;
        var Controller_57;
    }());
    exports.Controller = Controller;
});
define("app/sds/payment/method/detect/sds-payment-method-detect", ["require", "exports", "app/utils", "$q", "app/sdc/validation/sdc-validation-service", "app/sds/payment/service", "module"], function (require, exports, utils, $q, validation, payment, module_66) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_66.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch(function () { return _this.PaymentMethodTypeCode; }, function () { return _this.NgModel.$validate(); });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "PaymentMethodTypeCode", {
            get: function () {
                return this.BoundPaymentMethodType && (utils.IsString(this.BoundPaymentMethodType) ? this.BoundPaymentMethodType : this.BoundPaymentMethodType.Code);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Validate = function (ngModel, accountNumber, viewValue) {
            return __awaiter(this, void 0, $q, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (ngModel.$isEmpty(viewValue))
                                return [2, true];
                            return [4, payment.PaymentMethodFromAccountNumberAndTypeResult.GetForAccountNumberAndType(accountNumber, this.PaymentMethodTypeCode)];
                        case 1:
                            result = _a.sent();
                            if (result.IsInvalid)
                                return [2, false];
                            this.PaymentMethod = result.PaymentMethod;
                            return [2, true];
                    }
                });
            });
        };
        Controller.prototype.BindToNgModel = function (ngModel) {
            var _this = this;
            if (ngModel === void 0) { ngModel = this.NgModel; }
            validation.AttachAsyncValidator(ngModel, name, function (modelValue, viewValue) { return _this.Validate(ngModel, modelValue, viewValue); });
        };
        __decorate([
            utils.Bind.TwoWay(name)
        ], Controller.prototype, "PaymentMethod", void 0);
        __decorate([
            utils.Bind.In("payment-method-type")
        ], Controller.prototype, "BoundPaymentMethodType", void 0);
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModel", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "BindToNgModel", null);
        Controller = __decorate([
            utils.Component({
                Name: name,
                Restrict: utils.Target.Attribute,
                Template: null,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
    (function (Controller) {
        var x;
    })(Controller = exports.Controller || (exports.Controller = {}));
    exports.Controller = Controller;
});
define("app/sds/service/usage/history/sds-service-usage-history", ["require", "exports", "app/utils", "app/sds/service/service-utils", "module"], function (require, exports, utils, service_utils_3, module_67) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_67.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.LoadChildService();
            return _this;
        }
        Object.defineProperty(Controller.prototype, "IsSITEService", {
            get: function () {
                if (utils.IsVoid(this.service))
                    return false;
                return this.service.ServiceTypeCode.toUpperCase() == "SITE";
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.LoadChildService = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!this.IsSITEService) return [3, 2];
                            _a = this;
                            return [4, service_utils_3.GetChildServiceForService(this.service.Id)];
                        case 1:
                            _a.childServices = _b.sent();
                            _b.label = 2;
                        case 2: return [2];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "service", void 0);
        Controller = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/service/usage/nondiscounted/sds-service-usage-nondiscounted", ["require", "exports", "app/utils", "app/sds/service/service-utils", "module"], function (require, exports, utils, service_utils_4, module_68) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_68.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.LoadChildService();
            return _this;
        }
        Object.defineProperty(Controller.prototype, "IsSITEService", {
            get: function () {
                if (utils.IsVoid(this.service))
                    return false;
                return this.service.ServiceTypeCode.toUpperCase() == "SITE";
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.LoadChildService = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!this.IsSITEService) return [3, 2];
                            _a = this;
                            return [4, service_utils_4.GetChildServiceForService(this.service.Id)];
                        case 1:
                            _a.childServices = _b.sent();
                            _b.label = 2;
                        case 2: return [2];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "service", void 0);
        Controller = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/service/usage/telco/sds-service-usage-telco", ["require", "exports", "app/utils", "module", "app/sds/service/usage/utils"], function (require, exports, utils, module_69, usageUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_69.id);
    var NumberType;
    (function (NumberType) {
        NumberType["ExactlyZero"] = "0";
        NumberType["LessThanOne"] = "<1";
        NumberType["ExactlyOne"] = "1";
        NumberType["MoreThanOne"] = ">1";
    })(NumberType || (NumberType = {}));
    (function (NumberType) {
        function Get(source) {
            switch (source) {
                case 0:
                    return NumberType.ExactlyZero;
                case 1:
                    return NumberType.ExactlyOne;
                default:
                    if (source > 1)
                        return NumberType.MoreThanOne;
                    else
                        return NumberType.LessThanOne;
            }
        }
        NumberType.Get = Get;
    })(NumberType || (NumberType = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.UsageLoader = new utils.Loader(function () { return usageUtils.GetUsage(_this.service.Id); }, { Batcher: Controller_58.UsageLoaderBatcher, });
            _this.UsageLoader.Load();
            return _this;
        }
        Controller_58 = Controller;
        Controller.prototype.ClassForUsage = function (bundle) {
            if (!utils.IsVoid(bundle)) {
                if (bundle.UsageComplete >= 1)
                    return "md-warn";
                if (bundle.UsageComplete > (bundle.Period.Complete * 1.25))
                    return "md-accent";
                if (bundle.UsageComplete < (bundle.Period.Complete * 0.75))
                    return "md-primary";
            }
            return "md-primary";
        };
        Controller.prototype.GetNumberType = function (source) {
            return NumberType.Get(source);
        };
        Object.defineProperty(Controller.prototype, "Usage", {
            get: function () {
                return this.UsageLoader.Value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.UsageLoaderBatcher = new utils.BatchedInvoker(500);
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "service", void 0);
        Controller = Controller_58 = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
        var Controller_58;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/string/type/valid/sds-string-type-valid", ["require", "exports", "app/utils", "app/ng-utils", "app/sdc/validation/sdc-validation-service", "app/selcomm/service"], function (require, exports, utils, ng_utils_54, validation, service_58) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super.call(this) || this;
        }
        Controller_59 = Controller;
        Controller.prototype.AttachValidator = function () {
            var _this = this;
            var detachValidator = validation.AttachAsyncValidator(this.NgModelController, Controller_59.ValidatorName, function (modelValue, viewValue) { return _this.Validate(modelValue, viewValue); }, null);
            this.OnDispose(detachValidator);
        };
        Controller.prototype.Validate = function (modelValue, viewValue) {
            return __awaiter(this, void 0, ng_utils_54.$q, function () {
                var result, err_52;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            if (!this.ValidateEmpty && (this.NgModelController.$isEmpty(viewValue) || !this.StringTypeCode))
                                return [2, true];
                            return [4, this.ValidateValue(modelValue)];
                        case 1:
                            result = _a.sent();
                            this.ValidationCategory = result ? result.ValidationCategory : "";
                            if ((result && result.ValidationMessage) || !this.RetainLastMessage)
                                this.ValidationMessage = result.ValidationMessage;
                            if (!result)
                                return [2, true];
                            switch (result.Result) {
                                case service_58.Selcomm.Validation.ValidationResults.Okay:
                                case service_58.Selcomm.Validation.ValidationResults.Warning:
                                    return [2, true];
                                default:
                                    return [2, false];
                            }
                            return [3, 3];
                        case 2:
                            err_52 = _a.sent();
                            this.ValidationCategory = void null;
                            this.ValidationMessage = "An error has occurred";
                            throw err_52;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.prototype.ValidateValue = function (value, stringTypeCode) {
            if (stringTypeCode === void 0) { stringTypeCode = this.StringTypeCode; }
            if (!utils.IsVoid(this.ServiceTypeCtrl)) {
                return service_58.Service.Validation.StringValidateForServiceTypeCode({
                    TestString: value,
                    StringType: stringTypeCode,
                    ServiceTypeCode: this.ServiceTypeCtrl.serviceTypeCode,
                });
            }
            return service_58.Service.Validation.StringValidate({
                TestString: value,
                StringType: stringTypeCode,
            });
        };
        Object.defineProperty(Controller.prototype, "ValidateEmpty", {
            get: function () {
                return ng_utils_54.$mdUtil.parseAttributeBoolean(this.BoundValidateEmpty);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "RetainLastMessage", {
            get: function () {
                if (utils.IsVoid(this.BoundRetainLastMessage))
                    return true;
                switch (this.BoundRetainLastMessage) {
                    case "true":
                    case "1":
                    case "retain-last-message":
                    case "yes":
                        return true;
                    default:
                        return false;
                }
            },
            enumerable: true,
            configurable: true
        });
        Controller.Name = "sds-string-type-valid";
        Controller.ValidatorName = utils.Ng.CamelCase(Controller_59.Name);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "AttachValidator", null);
        __decorate([
            utils.Bind.Literal(Controller_59.Name)
        ], Controller.prototype, "StringTypeCode", void 0);
        __decorate([
            utils.Bind.TwoWay("validation-category", { optional: true })
        ], Controller.prototype, "ValidationCategory", void 0);
        __decorate([
            utils.Bind.TwoWay("validation-message", { optional: true })
        ], Controller.prototype, "ValidationMessage", void 0);
        __decorate([
            utils.Bind.Literal("retain-last-message", { optional: true })
        ], Controller.prototype, "BoundRetainLastMessage", void 0);
        __decorate([
            utils.Bind.Literal("validate-empty", { optional: true })
        ], Controller.prototype, "BoundValidateEmpty", void 0);
        __decorate([
            utils.Bind.Controller("sds-service-type", { optional: true })
        ], Controller.prototype, "ServiceTypeCtrl", void 0);
        __decorate([
            utils.Bind.Controller("ng-model")
        ], Controller.prototype, "NgModelController", void 0);
        Controller = Controller_59 = __decorate([
            utils.Component({
                Name: Controller_59.Name,
                Template: null,
                Scope: utils.ScopeMode.ParentScope,
                Restrict: utils.Target.Attribute,
            })
        ], Controller);
        return Controller;
        var Controller_59;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/ss/bill/history/graph/ss-bill-history-graph", ["require", "exports", "app/ng-utils", "app/utils", "app/selcomm/service", "module", "app/sds/contact/sds-contact", "app/sdc/utilities/sdc-utilities-service"], function (require, exports, ng_utils_55, utils, service_59, module_70, selectedContact, sssUtilities) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.initial = 0;
            _this.billStorageName = "BillFormat";
            _this.Init();
            return _this;
        }
        Controller.prototype.billHeight = function (target) {
            if (!utils.IsVoid(this.initial) && this.initial <= this.bills.indexOf(target))
                return 0;
            else
                return sssUtilities.html.percent(target.NewCharges || 0, this.bills.max || 0);
        };
        Controller.prototype.GetBills = function (count) {
            return __awaiter(this, void 0, ng_utils_55.$q, function () {
                var billList, i, bills, i_2, MaxBill, max, midpoint, midpointBill;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, service_59.Service.Bill.BillList({
                                PagingSortsAndFilters: new service_59.Selcomm.Filters.PagingSortsAndFilters({
                                    SkipRecords: 0,
                                    TakeRecords: count,
                                    Sorts: [service_59.SortService.For().On("Sequence").Descending()],
                                })
                            })];
                        case 1:
                            billList = _a.sent();
                            bills = billList && billList.Items;
                            this.excelBillEnabled = billList.ExcelBillEnabled;
                            bills.length = count;
                            for (i_2 = 0; i_2 < count; i_2++) {
                                if (!bills[i_2])
                                    bills[i_2] = new service_59.Selcomm.Bill.Bill();
                            }
                            MaxBill = utils.AssertNotVoid(utils.Collection.Max(bills, function (b) { return b.NewCharges; }));
                            max = MaxBill.NewCharges;
                            midpoint = max / 2;
                            midpointBill = bills.reduce(function (prev, curr) { return (Math.abs(midpoint - prev.NewCharges) > Math.abs(midpoint - curr.NewCharges)) ? curr : prev; });
                            return [2, utils.Extend(bills, {
                                    isEmpty: bills.length === 0,
                                    max: max,
                                    midpoint: midpoint,
                                    midpointBill: midpointBill,
                                })];
                    }
                });
            });
        };
        Controller.prototype.billClass = function () {
            return "md-accent";
        };
        Controller.prototype.mdHue = function (x) {
            var mx = x % 4;
            return !mx ? "" : "md-hue-" + mx;
        };
        Controller.prototype.downloadBill = function (bill) {
            service_59.DownloadService.Bill.BillFile({
                ContactCode: service_59.Auth.CurrentSession.CurrentContactCode.trim(),
                BillNumber: bill.Number.trim(),
                BillType: this.defaultBillFormat.toLowerCase(),
                ShowErrorNotification: true
            });
        };
        Controller.prototype.Animate = function (to) {
            return __awaiter(this, void 0, ng_utils_55.$q, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (utils.IsVoid(this.initial))
                                return [2];
                            this.initial++;
                            _a.label = 1;
                        case 1:
                            if (!(this.initial < (this.bills && this.bills.length || 0))) return [3, 3];
                            return [4, utils.Delay(Math.random() * 250)];
                        case 2:
                            _a.sent();
                            this.initial++;
                            return [3, 1];
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.prototype.Init = function () {
            return __awaiter(this, void 0, void 0, function () {
                var bills, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this;
                            return [4, (this.loadingBills = this.GetBills(6))];
                        case 1:
                            bills = _a.bills = _b.sent();
                            this.GetBillFormat(this.excelBillEnabled);
                            this.Animate(bills.length);
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.GetBillFormat = function (excelBillEnabled) {
            return __awaiter(this, void 0, void 0, function () {
                var billFormat;
                return __generator(this, function (_a) {
                    if (!excelBillEnabled) {
                        ng_utils_55.$window.localStorage.removeItem(this.billStorageName);
                    }
                    billFormat = ng_utils_55.$window.localStorage.getItem(this.billStorageName);
                    if (billFormat == null) {
                        billFormat = "Pdf";
                        ng_utils_55.$window.localStorage.setItem(this.billStorageName, billFormat);
                    }
                    this.defaultBillFormat = billFormat;
                    return [2];
                });
            });
        };
        Controller.prototype.SetBillFormat = function (billFormat) {
            this.defaultBillFormat = billFormat;
            ng_utils_55.$window.localStorage.setItem(this.billStorageName, billFormat);
        };
        Object.defineProperty(Controller.prototype, "midPoint", {
            get: function () {
                return (this.bills && this.bills.midpointBill && this.bills.midpointBill.NewCharges || 0) / ((this.bills && this.bills.max || 0) * 100);
            },
            enumerable: true,
            configurable: true
        });
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.Controller.Mode.SelfOrParents })
        ], Controller.prototype, "TargetContactController", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_70.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/payment/makepayment/amount/ss-payment-makepayment-amount", ["require", "exports", "app/utils", "app/selcomm/service", "$q", "app/sds/contact/sds-contact", "module"], function (require, exports, utils, service_60, $q, selectedContact, module_71) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.IsSurchargeCalculated = false;
            _this.PaymentSurcharge = 0;
            return _this;
        }
        Object.defineProperty(Controller.prototype, "DefaultAmount", {
            get: function () {
                return this.BoundDefaultAmount || 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "PaymentAmount", {
            get: function () {
                return this.ManualInput ? this.ManualAmount : this.DefaultAmount;
            },
            set: function (value) {
                if (utils.IsVoid(value)) {
                    this.ManualInput = false;
                    return;
                }
                this.ManualInput = true;
                this.ManualAmount = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.LoadSurcharge = function (paymentRequestAmount, paymentMethodCode) {
            var _this = this;
            if (!paymentMethodCode)
                return $q.reject();
            this.PaymentSurcharge = null;
            this.IsSurchargeCalculated = false;
            var promise = this.SurchargeLoading = service_60.Service.Payment.PaymentSurchargeAmount({
                PaymentMethodCode: paymentMethodCode,
                PaymentRequestAmount: paymentRequestAmount,
                ContactCode: utils.AssertNotVoid(this.SelectedContact.ContactCode),
                PaymentSourceId: 3,
            })
                .then(function (paymentSurcharge) {
                if (promise !== _this.SurchargeLoading)
                    return paymentSurcharge;
                _this.PaymentSurcharge = paymentSurcharge;
                _this.IsSurchargeCalculated = true;
                return paymentSurcharge;
            });
            return promise;
        };
        Controller.prototype.Init = function () {
            var _this = this;
            this.Watch.Collection(function () { return ({
                PaymentMethodCode: _this.PaymentMethod && _this.PaymentMethod.Code,
                PaymentRequestAmount: _this.PaymentAmount
            }); }, function (args) { return _this.LoadSurcharge(args.PaymentRequestAmount, args.PaymentMethodCode); });
        };
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents })
        ], Controller.prototype, "SelectedContact", void 0);
        __decorate([
            utils.Bind.In("payment-method")
        ], Controller.prototype, "PaymentMethod", void 0);
        __decorate([
            utils.Bind.In("default-amount")
        ], Controller.prototype, "BoundDefaultAmount", void 0);
        __decorate([
            utils.Bind.TwoWay("is-surcharge-calculated")
        ], Controller.prototype, "IsSurchargeCalculated", void 0);
        __decorate([
            utils.Bind.TwoWay("amount")
        ], Controller.prototype, "PaymentAmount", null);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_71.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/payment/makepayment/result/ss-payment-makepayment-result", ["require", "exports", "app/utils", "app/sds/payment/service"], function (require, exports, utils, payment) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Controller.prototype.IsRegistrationFailure = function (result) {
            if (utils.IsVoid(result))
                return false;
            return result instanceof payment.ThirdParty.PaymentMethodRegister.RegisterFailedPaymentResult;
        };
        __decorate([
            utils.Bind.In("result")
        ], Controller.prototype, "Result", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "ss-payment-makepayment-result",
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/paymentmethod/create/selcomm/ss-paymentmethod-create-selcomm", ["require", "exports", "module", "app/utils", "app/ng-utils", "app/selcomm/service", "moment", "app/sds/contact/sds-contact"], function (require, exports, module_72, utils, ng_utils_56, service_61, moment, selectedContact) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.PaymentMethodTypesLoader = new utils.CollectionLoader(function (contactCode) { return service_61.CachedService.Payment.PaymentMethodTypeListOnline({ ContactCode: contactCode, RefreshCache: true, }); });
            _this.AccountName = "";
            _this.AccountNumber = "";
            _this.Bsb = "";
            _this.ExpiryDate = moment().endOf("m").toDate();
            _this.CreateAsDefault = false;
            _this.CreateRequests = 0;
            _this.Watch(function () { return _this.SelectedContact ? _this.SelectedContact.ContactCode : null; }, function (contactCode) { return utils.IsVoid(contactCode) ? _this.PaymentMethodTypesLoader.Reset() : _this.PaymentMethodTypesLoader.Load(contactCode); });
            return _this;
        }
        Controller_60 = Controller;
        Object.defineProperty(Controller.prototype, "PaymentMethodTypes", {
            get: function () {
                return this.PaymentMethodTypesLoader.Values;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.CreateRequests > 0 || this.PaymentMethodTypesLoader.IsLoading;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Create = function (form) {
            return __awaiter(this, void 0, ng_utils_56.$q, function () {
                var accountPaymentMethod, id_1, err_53, fullAccountPaymentMethod;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.CreateRequests++;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 7, 8]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are invalid");
                                throw new utils.FormInvalidError(form);
                            }
                            if (utils.IsVoid(this.PaymentMethodType))
                                throw new Error("No PaymentMethodType");
                            if (utils.IsVoid(this.PaymentMethod))
                                throw new Error("No PaymentMethod");
                            accountPaymentMethod = new service_61.Selcomm.Payment.AccountPaymentMethod({
                                AccountName: this.AccountName,
                                AccountNumber: this.AccountNumber,
                                BSB: this.Bsb,
                                ExpiryDate: this.ExpiryDate,
                                Default: this.CreateAsDefault,
                                PaymentMethod: this.PaymentMethod,
                            });
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, service_61.Service.Payment.AccountPaymentMethodAdd({
                                    ContactCode: service_61.Auth.CurrentSession.CurrentContactCode,
                                    AccountPaymentMethod: accountPaymentMethod,
                                })];
                        case 3:
                            id_1 = _a.sent();
                            accountPaymentMethod.Id = id_1;
                            return [3, 5];
                        case 4:
                            err_53 = _a.sent();
                            utils.Toast.Simple("We couldn't save your new " + accountPaymentMethod.PaymentMethod.Description + ", please confirm the details are correct and try again.");
                            throw err_53;
                        case 5: return [4, Controller_60.EnsureMasked(accountPaymentMethod)];
                        case 6:
                            fullAccountPaymentMethod = _a.sent();
                            utils.Toast.Simple("Saved new " + accountPaymentMethod.PaymentMethod.Description + " payment method.");
                            this.BoundOnCreate({ accountPaymentMethod: fullAccountPaymentMethod });
                            return [2, fullAccountPaymentMethod];
                        case 7:
                            this.CreateRequests--;
                            return [7];
                        case 8: return [2];
                    }
                });
            });
        };
        Controller.EnsureMasked = function (apm) {
            return __awaiter(this, void 0, void 0, function () {
                var i, loadedAccountPaymentMethod, err_54;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < 10)) return [3, 6];
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, service_61.Service.Payment.AccountPaymentMethod({ Id: apm.Id })];
                        case 3:
                            loadedAccountPaymentMethod = _a.sent();
                            if (!utils.IsVoid(loadedAccountPaymentMethod))
                                return [2, loadedAccountPaymentMethod];
                            return [3, 5];
                        case 4:
                            err_54 = _a.sent();
                            return [3, 5];
                        case 5:
                            i++;
                            return [3, 1];
                        case 6: return [2, new service_61.Selcomm.Payment.AccountPaymentMethod(__assign({}, apm, { AccountNumber: (apm.AccountNumber || "").replace(/[^\s]/g, "X"), BSB: (apm.BSB || "").replace(/[^\s]/g, "X") }))];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents, })
        ], Controller.prototype, "SelectedContact", void 0);
        __decorate([
            utils.Bind.Getter("on-create")
        ], Controller.prototype, "BoundOnCreate", void 0);
        __decorate([
            utils.Bind.TranscludeSlot("additional-actions", { optional: true })
        ], Controller.prototype, "AdditionalActions", void 0);
        Controller = Controller_60 = __decorate([
            utils.Component({
                ModuleId: module_72.id,
            })
        ], Controller);
        return Controller;
        var Controller_60;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/site/main/authenticated/ss-site-main-authenticated", ["require", "exports", "app/utils", "app/ng-utils", "app/sds/menu/service", "$q", "module"], function (require, exports, utils, ng_utils_57, menuService, $q, module_73) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = utils.GetComponentNameFromModuleId(module_73.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller($watch) {
            var _this = _super.call(this) || this;
            _this.ContentId = "ss-site-main-authenticated-main-content";
            _this._currentRoute = "MyHome";
            _this.BoundSection = "";
            _this.BillHistory = true;
            _this.ChangePassword = false;
            _this.MakePayment = false;
            _this.AccountAlert = false;
            _this.MakeSimReplacement = false;
            _this.ShowSIMReplacement = false;
            _this.IsSIMReplacementAvailable = true;
            _this.LoadingMenu = _this.GetMenu().then(function (menu) { return _this.Menu = menu; });
            _this.Attributes.$addClass(name);
            $watch.Collection(function () { return ({
                section: _this.Section,
                menuItems: _this.MenuItems
            }); }, function ($new) {
                var selected = _this.SelectedMenuItem = _this.MenuItems.reduce(function (select, menuItem) {
                    if (!menuItem)
                        return select;
                    if (menuItem.UrlName === $new["section"])
                        return menuItem;
                    if (!select && menuItem.ItemDefault)
                        return menuItem;
                    return select;
                }, null);
                if (selected) {
                    _this["title"] = selected.Caption;
                }
                else {
                    _this["title"] = "";
                }
            });
            ng_utils_57.$rootScope.$on('display-sim-replacement-alert', function (event, data) {
                _this.IsSIMReplacementAvailable = data;
            });
            _this.ShowSIMReplacement = ng_utils_57.$cookies.get("DisplaySIMReplacement") === "True";
            return _this;
        }
        Controller_61 = Controller;
        Controller.prototype.RenderMenuHref = function (urlName) {
            return utils.Paths.Combine("!/", (this.LeadingPath + "/").replace(/^[\\\/]/, ""), urlName);
        };
        Controller.prototype.GetMenu = function () {
            return __awaiter(this, void 0, $q, function () {
                var menu, _a, _b, menuItem, e_101, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4, menuService.GetMenu(100887)];
                        case 1:
                            menu = _d.sent();
                            try {
                                for (_a = __values(menu.MenuItemList), _b = _a.next(); !_b.done; _b = _a.next()) {
                                    menuItem = _b.value;
                                    menuItem.ItemDefault = menuItem.Id === 100887;
                                }
                            }
                            catch (e_101_1) { e_101 = { error: e_101_1 }; }
                            finally {
                                try {
                                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                }
                                finally { if (e_101) throw e_101.error; }
                            }
                            return [2, menu];
                    }
                });
            });
        };
        Controller.prototype.MenuButtonClass = function (menuItem) {
            if (!this.IsSelected(menuItem))
                return "";
            return "md-raised md-background md-hue-1";
        };
        Controller.prototype.IsSelected = function (menuItem) {
            return this.Section ? menuItem.UrlName === this.Section : menuItem.ItemDefault;
        };
        Object.defineProperty(Controller.prototype, "MenuItems", {
            get: function () {
                return (this.Menu && this.Menu.MenuItemList) || Controller_61.EmptyMenuItems;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "DefaultMenuItem", {
            get: function () {
                return utils.Collection.FirstOrDefault(this.MenuItems, function (mi) { return mi.ItemDefault; });
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.GetByUrlName = function (urlName) {
            if (utils.IsVoid(urlName))
                return null;
            var urlNameLower = urlName;
            return utils.Collection.FirstOrDefault(this.MenuItems, function (mi) { return mi.UrlName.toLowerCase() === urlNameLower; });
        };
        Object.defineProperty(Controller.prototype, "Section", {
            get: function () {
                var menuItem = this.GetByUrlName(this.BoundSection) || this.DefaultMenuItem;
                var urlName = menuItem && menuItem.UrlName;
                return urlName || "";
            },
            set: function (value) {
                if (value.toLowerCase() === this.BoundSection.toLowerCase())
                    return;
                this.BoundSection = value;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.OpenChangePassword = function () {
            this.ChangePassword = true;
            this.BillHistory = false;
            this.MakePayment = false;
            this.AccountAlert = false;
            this.MakeSimReplacement = false;
        };
        Controller.prototype.CloseChangePassword = function () {
            this.ChangePassword = false;
            this.BillHistory = true;
        };
        Controller.prototype.OpenAccountAlert = function () {
            this.AccountAlert = true;
            this.ChangePassword = false;
            this.BillHistory = false;
            this.MakePayment = false;
            this.MakeSimReplacement = false;
        };
        Controller.prototype.CloseAccountAlert = function () {
            this.AccountAlert = false;
            this.BillHistory = true;
        };
        Controller.prototype.OpenMakePayment = function (defaultAmount) {
            this.MakePayment = true;
            this.ChangePassword = false;
            this.BillHistory = false;
            this.AccountAlert = false;
            this.MakeSimReplacement = false;
            this.MakePaymentDefaultAmount = defaultAmount;
        };
        Controller.prototype.CloseMakePayment = function () {
            this.MakePayment = false;
            this.BillHistory = true;
        };
        Controller.prototype.OpenSimReplacement = function () {
            this.MakeSimReplacement = true;
            this.AccountAlert = false;
            this.ChangePassword = false;
            this.BillHistory = false;
            this.MakePayment = false;
        };
        Controller.prototype.CloseSimReplacement = function () {
            this.MakeSimReplacement = false;
            this.BillHistory = true;
        };
        Object.defineProperty(Controller.prototype, "title", {
            get: function () {
                return this.titleCtrl ? this.titleCtrl : undefined;
            },
            set: function (value) {
                this.titleCtrl && (this.titleCtrl.title = value);
            },
            enumerable: true,
            configurable: true
        });
        Controller.EmptyMenuItems = Object.freeze(new Array());
        __decorate([
            utils.Bind.Controller("^?sdc-title-controller", { mode: utils.Bind.Controller.Mode.SelfOrParents, optional: true })
        ], Controller.prototype, "titleCtrl", void 0);
        Controller = Controller_61 = __decorate([
            utils.Component({ Name: name }),
            __param(0, utils.Inject("$watch"))
        ], Controller);
        return Controller;
        var Controller_61;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/site/wallet/directdebit/ss-site-wallet-directdebit", ["require", "exports", "app/utils", "module", "app/ng-utils", "app/selcomm/service"], function (require, exports, utils, module_74, ng_utils_58, service_62) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.CreateActivity = new utils.ActivityController();
            _this.ShowBankForm = true;
            _this.bank = new service_62.Selcomm.Payment.AccountPaymentMethod();
            _this.bank.AccountName = service_62.Auth.CurrentSession.CurrentContactName;
            _this.bank.StartDate = new Date();
            return _this;
        }
        Controller.prototype.Cancel = function () {
            this.ShowBankForm = false;
            ng_utils_58.$window.localStorage.removeItem("IsDefaultPayment");
        };
        Controller.prototype.Create = function (form) {
            return __awaiter(this, void 0, ng_utils_58.$q, function () {
                var token, payId, ex_11;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are not valid, try again after checking them.");
                                return [2];
                            }
                            token = this.CreateActivity.TryEnter();
                            payId = 0;
                            if (!token) {
                                throw new utils.AlreadyDoingActionError("Previous payment method is still being processed. Please wait.");
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4, this.CreateBankPayMethod()];
                        case 2:
                            payId = _a.sent();
                            return [3, 5];
                        case 3:
                            ex_11 = _a.sent();
                            utils.Toast.Simple(ex_11.Message);
                            return [3, 5];
                        case 4:
                            token.Exit();
                            return [7];
                        case 5:
                            if (payId > 0) {
                                this.OnCreated({ payMethod: this.payMethod });
                            }
                            return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "IsProcessing", {
            get: function () {
                return this.CreateActivity.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.CheckDefaultValidity = function (form) {
            var currentDate = new Date();
            this.form = form;
            var isDefaultPayment = ng_utils_58.$window.localStorage.getItem("IsDefaultPayment") === "1";
            if (isDefaultPayment && this.bank.StartDate > currentDate) {
                this.form.startdate.$setValidity('dateError', false);
            }
            else {
                this.form.startdate.$setValidity('dateError', true);
            }
        };
        Controller.prototype.IsDefaultPaymentOption = function () {
            var currentDate = new Date();
            var isDefaultPayment = ng_utils_58.$window.localStorage.getItem("IsDefaultPayment") === "1";
            if (isDefaultPayment) {
                if (this.bank.StartDate > currentDate)
                    isDefaultPayment = false;
            }
            return isDefaultPayment;
        };
        Controller.prototype.CreateBankPayMethod = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.payMethod = new service_62.Selcomm.Payment.AccountPaymentMethod;
                    this.payMethod.AccountName = this.bank.AccountName;
                    this.payMethod.AccountNumber = this.bank.AccountNumber;
                    this.payMethod.BSB = this.bank.BSB;
                    this.payMethod.StartDate = this.bank.StartDate;
                    this.payMethod.SubscriberOwns = true;
                    this.payMethod.ContactCode = service_62.Auth.CurrentSession.CurrentContactCode;
                    this.payMethod.Default = this.IsDefaultPaymentOption();
                    this.payMethod.Protected = false;
                    this.payMethod.Masked = false;
                    this.payMethod.PaymentMethod = new service_62.Selcomm.Payment.PaymentMethod();
                    this.payMethod.PaymentMethod.Code = "DD";
                    this.payMethod.PaymentMethod.Description = "DIRECT DEBIT";
                    this.payMethod.PaymentMethod.Type = new service_62.Selcomm.Payment.PaymentMethodType();
                    this.payMethod.PaymentMethod.Type.Code = "D";
                    this.payMethod.PaymentMethod.Type.BSBRequired = true;
                    this.payMethod.PaymentMethod.Type.Description = "DIRECT DEBIT";
                    return [2, service_62.Service.Payment.AccountPaymentMethodAdd({
                            AccountPaymentMethod: this.payMethod,
                            ContactCode: service_62.Auth.CurrentSession.CurrentContactCode,
                            CreateOption: service_62.Selcomm.Payment.NewAccountPaymentMethodOption.NewOrReopen,
                            SessionKey: service_62.Auth.CurrentSession.SessionKey
                        })];
                });
            });
        };
        __decorate([
            utils.Bind.TwoWay("on-cancel", { optional: true })
        ], Controller.prototype, "ShowBankForm", void 0);
        __decorate([
            utils.Bind.Getter("on-created")
        ], Controller.prototype, "OnCreated", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_74.id,
            })
        ], Controller);
        return Controller;
    }(utils.Controller));
    exports.Controller = Controller;
});
define("app/sdc/dynamic/panel/open/content/sdc-dynamic-panel-open-content", ["require", "exports", "app/utils", "app/sdc/dynamic/panel/open/sdc-dynamic-panel-open"], function (require, exports, utils, parent) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    utils.Directive({
        Name: "sdc-dynamic-panel-open-content",
        Terminal: true,
        Scope: utils.ScopeMode.ParentScope,
        Template: null,
        MultiElement: true,
        Restrict: utils.Target.Element,
        Require: "^^" + parent.Controller.Name,
        OnLink: function (scope, element, attrs, parent) {
            var unregister = parent.RegisterContent(scope, element.contents());
            element.remove();
            scope.$on("$destroy", unregister);
        }
    });
});
define("app/sdc/quit/protection/handler/root/sdc-quit-protection-handler-root", ["require", "exports", "app/utils", "app/sdc/quit/protection/handler/sdc-quit-protection-handler", "$window"], function (require, exports, utils, handler, $window) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var fullTitle = ["Closing this page will cause you to lose the following unsaved changes:"];
    var targetEvent = "beforeunload";
    var Controller = (function () {
        function Controller($scope) {
            var _this = this;
            var window = angular.element($window);
            var eventHandler = function () { return _this.OnUnload(); };
            window.on(targetEvent, eventHandler);
            $scope.$on($destroy, function () { return window.off(targetEvent, eventHandler); });
        }
        Controller.prototype.OnUnload = function () {
            var Handler = this.Handler;
            if (!utils.IsSpecified(Handler) || !Handler.ProtectionRequested)
                return;
            else {
                if (!Handler.Messages || Handler.Messages.length <= 0) {
                    return "Closing this page will cause you to lose your unsaved changes.";
                }
                else {
                    return fullTitle.concat(Handler.Messages.map(function (m) { return " \u2022 " + m; })).join("\r\n");
                }
            }
        };
        __decorate([
            utils.Bind.Controller(handler.DirectiveController)
        ], Controller.prototype, "Handler", void 0);
        Controller = __decorate([
            utils.Component({
                Name: "sdc-quit-protection-handler-root",
                Restrict: utils.Target.Attribute,
                Template: null,
            }),
            __param(0, utils.Inject($scope))
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/sds/payment/thirdparty/register/landing/sds-payment-thirdparty-register-landing", ["require", "exports", "app/utils", "app/sds/payment/service", "module", "app/ng-utils", "app/selcomm/service"], function (require, exports, utils, payments, module_75, ng_utils_59, service_63) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var RequestData = payments.ThirdParty.PaymentMethodRegister.RequestData;
    var Status;
    (function (Status) {
        Status["Failure"] = "failure";
        Status["Pending"] = "pending";
        Status["Success"] = "success";
    })(Status || (Status = {}));
    (function (Status) {
        function IsHalting(status) {
            switch (status) {
                case Status.Pending:
                case Status.Failure:
                    return true;
                case Status.Success:
                    return false;
            }
        }
        Status.IsHalting = IsHalting;
    })(Status || (Status = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.NotFinalStep = true;
            _this.ParseStatus = Status.Pending;
            _this.CompleteStatus = Status.Pending;
            _this.WriteStatus = Status.Pending;
            _this.ParseCompleteAndWrite();
            return _this;
        }
        Object.defineProperty(Controller.prototype, "ResultTypeName", {
            get: function () {
                return utils.IsVoid(this.ResultType) ? this.ResultType : service_63.Selcomm.Payment.OnlineRegistrationResult[this.ResultType];
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Parse = function () {
            this.NotFinalStep = true;
            this.ResultType = undefined;
            this.ParseStatus = Status.Pending;
            try {
                var parsed = payments.ThirdParty.PaymentMethodRegister.Query.ThirdPartyResponse
                    .Parse(utils.Paths.QueryPart.Parse(ng_utils_59.$location.search()));
                this.ResultType = parsed.outcome;
                this.ParseStatus = Status.Success;
                return parsed;
            }
            catch (err) {
                this.ParseStatus = Status.Failure;
                ng_utils_59.$exceptionHandler(err);
                throw err;
            }
        };
        Controller.prototype.Complete = function (data) {
            return __awaiter(this, void 0, void 0, function () {
                var completionToken, outcome, defaultPaymentMethod, key, nonce, source, accPayMeth, requestData, err_55;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.CompleteStatus = Status.Pending;
                            this.NotFinalStep = true;
                            completionToken = data.completionToken, outcome = data.outcome, defaultPaymentMethod = data.defaultPaymentMethod, key = data.key, nonce = data.nonce;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            source = RequestData.Store.GetAndRemoveWhen(key, function (x) { return x.Nonce === nonce && x instanceof RequestData.AwaitingThirdParty; });
                            this.NotFinalStep = source.NotFinalStep;
                            return [4, service_63.Service.Payment.AccountPaymentMethodOnlineComplete({
                                    CompletionToken: completionToken,
                                    RegistrationRequestId: source.SelcommRegistrationRequestId,
                                    result: outcome,
                                    IsDefaultPayment: Boolean(defaultPaymentMethod)
                                })];
                        case 2:
                            accPayMeth = _a.sent();
                            requestData = void 0;
                            switch (data.outcome) {
                                case service_63.Selcomm.Payment.OnlineRegistrationResult.Success:
                                    requestData = new RequestData.Success(__assign({}, source, { Expiry: null, AccountPaymentMethod: accPayMeth }));
                                    break;
                                case service_63.Selcomm.Payment.OnlineRegistrationResult.Failure:
                                    this.CompleteStatus = Status.Success;
                                    requestData = new RequestData.Failure(__assign({}, source, { Expiry: null, Reason: "Rejected by the provider." }));
                                    break;
                            }
                            this.CompleteStatus = Status.Success;
                            return [2, requestData];
                        case 3:
                            err_55 = _a.sent();
                            this.CompleteStatus = Status.Failure;
                            ng_utils_59.$exceptionHandler(err_55);
                            return [2, new RequestData.Failure({
                                    Nonce: nonce,
                                    AngularPortalsRequestId: data.key,
                                    Expiry: null,
                                    Reason: "An error occured during processing the response from the provider.",
                                })];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.Write = function (data) {
            this.WriteStatus = Status.Pending;
            try {
                RequestData.Store.Add(data);
                this.WriteStatus = Status.Success;
            }
            catch (err) {
                this.WriteStatus = Status.Failure;
                ng_utils_59.$exceptionHandler(err);
                throw err;
            }
        };
        Object.defineProperty(Controller.prototype, "OrderedStatuses", {
            get: function () {
                return [this.ParseStatus, this.CompleteStatus, this.WriteStatus];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "OverallStatus", {
            get: function () {
                return utils.Collection.FirstOrDefault(this.OrderedStatuses, Status.IsHalting, this.OrderedStatuses[this.OrderedStatuses.length - 1]);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.ParseCompleteAndWrite = function () {
            return __awaiter(this, void 0, ng_utils_59.$q, function () {
                var thirdPartyResult, requestData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            thirdPartyResult = this.Parse();
                            return [4, this.Complete(thirdPartyResult)];
                        case 1:
                            requestData = _a.sent();
                            this.Write(requestData);
                            return [2];
                    }
                });
            });
        };
        Controller = __decorate([
            utils.Component({
                ModuleId: module_75.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/payment/thirdparty/register/launch/sds-payment-thirdparty-register-launch", ["require", "exports", "app/utils", "app/sds/payment/service", "module", "app/ng-utils", "app/selcomm/service", "app/sss/sites"], function (require, exports, utils, payments, module_76, ng_utils_60, service_64, sites_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var RequestData = payments.ThirdParty.PaymentMethodRegister.RequestData;
    var Status;
    (function (Status) {
        Status["LocalFailure"] = "local-failure";
        Status["RemoteFailure"] = "remote-failure";
        Status["Pending"] = "pending";
        Status["Success"] = "success";
    })(Status || (Status = {}));
    (function (Status) {
        function IsHalting(status) {
            switch (status) {
                case Status.Pending:
                case Status.RemoteFailure:
                case Status.LocalFailure:
                    return true;
                case Status.Success:
                    return false;
            }
        }
        Status.IsHalting = IsHalting;
    })(Status || (Status = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.ParseStatus = Status.Pending;
            _this.LaunchStatus = Status.Pending;
            _this.WriteStatus = Status.Pending;
            _this.ParseCompleteAndWrite();
            return _this;
        }
        Controller.prototype.Parse = function () {
            this.ParseStatus = Status.Pending;
            try {
                var parsed = payments.ThirdParty.PaymentMethodRegister.Query.LaunchRequest
                    .Parse(utils.Paths.QueryPart.Parse(ng_utils_60.$location.search()));
                this.ParseStatus = Status.Success;
                return parsed;
            }
            catch (err) {
                this.ParseStatus = Status.LocalFailure;
                ng_utils_60.$exceptionHandler(err);
                throw err;
            }
        };
        Controller.prototype.Launch = function (data) {
            return __awaiter(this, void 0, void 0, function () {
                var key, nonce, contactCode, notFinalStep, successUri, failureUri, launchData, base, safeQueryParts, successUriBuilder, failureUriBuilder, isDefaultPaymentMethod, token, err_56;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.LaunchStatus = Status.Pending;
                            key = data.key, nonce = data.nonce;
                            try {
                                launchData = RequestData.Store.GetAndRemoveWhen(key, function (x) { return x.Nonce === nonce && x instanceof RequestData.Launch; });
                                contactCode = launchData.ContactCode;
                                notFinalStep = launchData.NotFinalStep;
                                base = new utils.Paths.UriBuilder(window.location.href);
                                base.Path = utils.Paths.MapPath.FromTrueRoot("~/" + sites_10.Service.Current.Name + "/$$/Home/ThirdPartyPaymentRegisterLanding/");
                                base.Fragment = "";
                                safeQueryParts = base.QueryParts.filter(function (qp) { return payments.ThirdParty.PaymentMethodRegister.Query.ThirdPartyResponse.QueryPartNames.All.indexOf(qp.Key) < 0; });
                                successUriBuilder = new utils.Paths.UriBuilder(base);
                                failureUriBuilder = new utils.Paths.UriBuilder(base);
                                isDefaultPaymentMethod = ng_utils_60.$window.localStorage.getItem("IsDefaultPayment");
                                if (isDefaultPaymentMethod === null) {
                                    isDefaultPaymentMethod = "1";
                                }
                                successUriBuilder.QueryParts = __spread(safeQueryParts, payments.ThirdParty.PaymentMethodRegister.Query.ThirdPartyResponse.ToQueryParts({ outcome: service_64.Selcomm.Payment.OnlineRegistrationResult.Success, key: key, nonce: nonce, }), [
                                    new utils.Paths.QueryPart(payments.ThirdParty.PaymentMethodRegister.Query.ThirdPartyResponse.QueryPartNames.DefaultPaymentMethod, isDefaultPaymentMethod),
                                    new utils.Paths.QueryPart(payments.ThirdParty.PaymentMethodRegister.Query.ThirdPartyResponse.QueryPartNames.CompletionToken, "")
                                ]);
                                failureUriBuilder.QueryParts = __spread(safeQueryParts, payments.ThirdParty.PaymentMethodRegister.Query.ThirdPartyResponse.ToQueryParts({ outcome: service_64.Selcomm.Payment.OnlineRegistrationResult.Failure, key: key, nonce: nonce, }), [
                                    new utils.Paths.QueryPart(payments.ThirdParty.PaymentMethodRegister.Query.ThirdPartyResponse.QueryPartNames.DefaultPaymentMethod, isDefaultPaymentMethod),
                                    new utils.Paths.QueryPart(payments.ThirdParty.PaymentMethodRegister.Query.ThirdPartyResponse.QueryPartNames.CompletionToken, "")
                                ]);
                                successUri = successUriBuilder.toString();
                                failureUri = failureUriBuilder.toString();
                            }
                            catch (err) {
                                this.LaunchStatus = Status.LocalFailure;
                                ng_utils_60.$exceptionHandler(err);
                                return [2, {
                                        registrationUrl: null,
                                        requestData: new RequestData.Failure({
                                            Nonce: nonce,
                                            AngularPortalsRequestId: data.key,
                                            Expiry: null,
                                            Reason: "An error occured during processing the response from the provider.",
                                        }),
                                    }];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, service_64.Service.Payment.AccountPaymentMethodOnlineRegister({
                                    ContactCode: contactCode,
                                    PaymentSourceId: 3,
                                    FailureURL: failureUri,
                                    SuccessURL: successUri,
                                })];
                        case 2:
                            token = _a.sent();
                            this.LaunchStatus = Status.Success;
                            return [2, {
                                    registrationUrl: token.RegistrationURL,
                                    requestData: new RequestData.AwaitingThirdParty({
                                        Nonce: nonce,
                                        AngularPortalsRequestId: key,
                                        SelcommRegistrationRequestId: token.RegistrationRequestId,
                                        NotFinalStep: notFinalStep,
                                    }),
                                }];
                        case 3:
                            err_56 = _a.sent();
                            this.LaunchStatus = Status.RemoteFailure;
                            ng_utils_60.$exceptionHandler(err_56);
                            return [2, {
                                    registrationUrl: null,
                                    requestData: new RequestData.Failure({
                                        Nonce: nonce,
                                        AngularPortalsRequestId: data.key,
                                        Expiry: null,
                                        Reason: "An error occured during processing the response from the provider.",
                                    }),
                                }];
                        case 4: return [2];
                    }
                });
            });
        };
        Controller.prototype.Write = function (data) {
            this.WriteStatus = Status.Pending;
            try {
                RequestData.Store.Add(data);
                this.WriteStatus = Status.Success;
            }
            catch (err) {
                this.WriteStatus = Status.LocalFailure;
                ng_utils_60.$exceptionHandler(err);
                throw err;
            }
        };
        Object.defineProperty(Controller.prototype, "OrderedStatuses", {
            get: function () {
                return [this.ParseStatus, this.LaunchStatus, this.WriteStatus];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "OverallStatus", {
            get: function () {
                return utils.Collection.FirstOrDefault(this.OrderedStatuses, Status.IsHalting, this.OrderedStatuses[this.OrderedStatuses.length - 1]);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.ParseCompleteAndWrite = function () {
            return __awaiter(this, void 0, ng_utils_60.$q, function () {
                var launchRequest, _a, registrationUrl, requestData, err;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            launchRequest = this.Parse();
                            return [4, this.Launch(launchRequest)];
                        case 1:
                            _a = _b.sent(), registrationUrl = _a.registrationUrl, requestData = _a.requestData;
                            this.Write(requestData);
                            if (!utils.IsVoid(registrationUrl))
                                ng_utils_60.$window.location.assign(registrationUrl);
                            else {
                                if (this.LaunchStatus == Status.Success && this.ParseStatus == Status.Success && this.WriteStatus == Status.Success) {
                                    this.LaunchStatus = Status.LocalFailure;
                                    err = new Error("Failed to generate a registration url");
                                    ng_utils_60.$exceptionHandler(err);
                                    throw err;
                                }
                            }
                            return [2];
                    }
                });
            });
        };
        Controller = __decorate([
            utils.Component({
                ModuleId: module_76.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/payment/thirdparty/register/modal/sds-payment-thirdparty-register-modal", ["require", "exports", "app/utils", "app/ng-utils", "app/sds/payment/service", "module"], function (require, exports, utils, ng_utils_61, paymentService, module_77) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch(function () { return _this.Request.State; }, function (state) {
                switch (state) {
                    case paymentService.ThirdParty.PaymentMethodRegister.Request.State.Finalising:
                    case paymentService.ThirdParty.PaymentMethodRegister.Request.State.Finished:
                        _this.Close();
                }
            });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "CanCancel", {
            get: function () {
                return this.Request.CanBeCancelled;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "RequestState", {
            get: function () {
                return this.Request.State;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Cancel = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.Request.RequestCancellation()];
                        case 1:
                            _a.sent();
                            this.Close();
                            return [2];
                    }
                });
            });
        };
        Controller.prototype.Close = function () {
            ng_utils_61.$mdDialog.cancel();
        };
        __decorate([
            utils.Bind.In("request")
        ], Controller.prototype, "Request", void 0);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_77.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/payment/thirdparty/register/test/sds-payment-thirdparty-register-test", ["require", "exports", "app/utils", "app/sds/payment/service", "module", "app/ng-utils", "app/selcomm/service"], function (require, exports, utils, payments, module_78, ng_utils_62, service_65) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.DoingTheThing = new utils.ActivityController();
            return _this;
        }
        Controller.prototype.Go = function () {
            return __awaiter(this, void 0, ng_utils_62.$q, function () {
                var token, request, _a, err_57;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            token = this.DoingTheThing.Enter();
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, 5, 6]);
                            return [4, payments.ThirdParty.PaymentMethodRegister.Invoke({
                                    targetContactCode: service_65.Auth.CurrentSession.CurrentContactCode,
                                    notFinalStep: false,
                                })];
                        case 2:
                            request = _b.sent();
                            _a = this;
                            return [4, request.AccountPaymentMethod];
                        case 3:
                            _a.Result = _b.sent();
                            return [3, 6];
                        case 4:
                            err_57 = _b.sent();
                            this.Result = err_57;
                            return [3, 6];
                        case 5:
                            token.Exit();
                            return [7];
                        case 6: return [2];
                    }
                });
            });
        };
        Controller = __decorate([
            utils.Component({
                ModuleId: module_78.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/service/usage/history/component/sds-service-usage-history-component", ["require", "exports", "app/utils", "app/ng-utils", "app/selcomm/service", "module"], function (require, exports, utils, ng_utils_63, service_66, module_79) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_79.id);
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.CurrentPeriodOnly = true;
            _this.pageNumber = 1;
            return _this;
        }
        Object.defineProperty(Controller.prototype, "ServiceId", {
            get: function () {
                return !utils.IsObject(this.service) ? this.service : (utils.HasProp(this.service, "Id") ? this.service.Id : this.service.ServiceId);
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.PrintIf = function (value, valueToPrint) {
            return utils.IsNotNullOrWhitespace(value) ? valueToPrint : "";
        };
        Controller.prototype.GetUsage = function (serviceId, psf) {
            if (serviceId === void 0) { serviceId = this.ServiceId; }
            return __awaiter(this, void 0, ng_utils_63.$q, function () {
                var usageTransactions, _a, _b, usageTransactions_1, usageTransactions_1_1, usageTransaction, altQuantity, e_102, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (utils.IsVoid(serviceId))
                                return [2, utils.List.Create({ Items: [], TotalFilteredRecords: 0, TotalUnfilteredRecords: 0 })];
                            _b = (_a = utils.List).Create;
                            return [4, service_66.Service.Service.UsageTransactionDisplayListForService({
                                    ServiceID: serviceId,
                                    Psf: psf,
                                })];
                        case 1:
                            usageTransactions = _b.apply(_a, [_d.sent()]);
                            try {
                                for (usageTransactions_1 = __values(usageTransactions), usageTransactions_1_1 = usageTransactions_1.next(); !usageTransactions_1_1.done; usageTransactions_1_1 = usageTransactions_1.next()) {
                                    usageTransaction = usageTransactions_1_1.value;
                                    switch (usageTransaction.UnitOfMeasure) {
                                        case "E":
                                            if (usageTransaction.UnitQuantity !== 0)
                                                break;
                                            altQuantity = Number.parseInt(usageTransaction.Band1RateUnit);
                                            if (Number.isNaN(altQuantity))
                                                break;
                                            usageTransaction.UnitQuantity = altQuantity;
                                            break;
                                    }
                                }
                            }
                            catch (e_102_1) { e_102 = { error: e_102_1 }; }
                            finally {
                                try {
                                    if (usageTransactions_1_1 && !usageTransactions_1_1.done && (_c = usageTransactions_1.return)) _c.call(usageTransactions_1);
                                }
                                finally { if (e_102) throw e_102.error; }
                            }
                            return [2, usageTransactions];
                    }
                });
            });
        };
        __decorate([
            utils.Bind.In("service")
        ], Controller.prototype, "service", void 0);
        __decorate([
            utils.Bind.Literal("no-header", { optional: true })
        ], Controller.prototype, "_noHeader", void 0);
        Controller = __decorate([
            utils.Component({
                Name: Name,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/ss/payment/makepayment/amount/existing/ss-payment-makepayment-amount-existing", ["require", "exports", "app/utils", "module"], function (require, exports, utils, module_80) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function () {
        function Controller() {
        }
        Controller = __decorate([
            utils.Component({
                ModuleId: module_80.id,
            })
        ], Controller);
        return Controller;
    }());
    exports.Controller = Controller;
});
define("app/ss/payment/makepayment/amount/new/ss-payment-makepayment-amount-new", ["require", "exports", "app/utils", "app/selcomm/service", "app/sds/contact/sds-contact", "module"], function (require, exports, utils, service_67, selectedContact, module_81) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Watch.Collection(function () { return ({
                AccountName: _this.AccountName,
                BSB: _this.Bsb,
                AccountNumber: _this.AccountNumber,
                PaymentMethod: _this.DetectedPaymentMethod,
                ExpiryDate: _this.ExpiryDate,
            }); }, function (values) {
                if (utils.IsVoid(values.PaymentMethod))
                    return;
                _this.AccountPaymentMethod = new service_67.Selcomm.Payment.AccountPaymentMethod(values);
            });
            return _this;
        }
        Object.defineProperty(Controller.prototype, "SelectedPaymentMethodTypeCode", {
            get: function () { return this.SelectedPaymentMethodType && this.SelectedPaymentMethodType.Code; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsCredit", {
            get: function () {
                return this.SelectedPaymentMethodTypeCode === "C";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsDebit", {
            get: function () {
                return this.SelectedPaymentMethodTypeCode === "D";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "bsbOrder", {
            get: function () {
                return this.IsCredit ? 4 : 2;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.Init = function () {
            var _this = this;
            var loadingPaymentMethodTypes = service_67.Service.Payment.PaymentMethodTypeListOnline({ ContactCode: utils.AssertNotVoid(this.SelectedContact.ContactCode) })
                .then(function (paymentMethodTypes) {
                _this.AvailablePaymentMethodTypes = paymentMethodTypes;
                _this.SelectedPaymentMethodType = paymentMethodTypes[0];
            });
        };
        __decorate([
            utils.Bind.Controller(selectedContact.Controller, { mode: utils.Bind.ControllerMode.SelfOrParents })
        ], Controller.prototype, "SelectedContact", void 0);
        __decorate([
            utils.Bind.TwoWay("account-payment-method")
        ], Controller.prototype, "AccountPaymentMethod", void 0);
        __decorate([
            utils.OnLink()
        ], Controller.prototype, "Init", null);
        Controller = __decorate([
            utils.Component({
                ModuleId: module_81.id,
            })
        ], Controller);
        return Controller;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
define("app/sds/authentication/login/setup/account/password/sds-authentication-login-setup-account-password", ["require", "exports", "app/utils", "app/selcomm/service", "app/ng-utils", "module", "app/sss/sites"], function (require, exports, utils, service_68, ng_utils_64, module_82, sites_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Name = utils.GetComponentNameFromModuleId(module_82.id);
    var Step;
    (function (Step) {
        Step["Initial"] = "initial";
        Step["Success"] = "success";
    })(Step || (Step = {}));
    var Controller = (function (_super) {
        __extends(Controller, _super);
        function Controller() {
            var _this = _super.call(this) || this;
            _this.Password = "";
            _this.ConfirmPassword = "";
            _this.ResettingPassword = new utils.ActivityController("Resetting Password");
            _this.StepPath = utils.StepPath.Create(Step.Initial);
            _this.GenerateNewSession();
            return _this;
        }
        Controller_62 = Controller;
        Controller.prototype.Close = function () {
            this.BoundClose();
        };
        Controller.prototype.SetupAccount = function (setupAccountPasswordToken, password, form) {
            return __awaiter(this, void 0, ng_utils_64.$q, function () {
                var _this = this;
                var token, result, err_58;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = this.ResettingPassword.Enter({ onFail: function () { return void utils.Toast.Simple("Hold on, we're already processing your previous request."); } });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            if (form && !form.$valid) {
                                utils.Toast.Simple("Some inputs are invalid, verify them before continuing.");
                                throw new utils.FormInvalidError(form);
                            }
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, this.RetryOnSessionFail(function (sessionKey) { return service_68.Service.Account.AccountPasswordSetUp({
                                    SessionKey: sessionKey,
                                    Password: password,
                                    TokenKey: setupAccountPasswordToken,
                                }); }, function () { return _this.GenerateNewSession(); })];
                        case 3:
                            result = _a.sent();
                            if (!result)
                                throw new Error("Failed to set up account.");
                            this.StepPath.NavigateForward(Step.Success);
                            return [3, 5];
                        case 4:
                            err_58 = _a.sent();
                            Controller_62.NotifyError(err_58);
                            throw err_58;
                        case 5: return [3, 7];
                        case 6:
                            token.Exit();
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        };
        Object.defineProperty(Controller.prototype, "Step", {
            get: function () {
                return this.StepPath.CurrentStep;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "IsBusy", {
            get: function () {
                return this.ResettingPassword.IsActive;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "SessionKey", {
            get: function () {
                return !service_68.Auth.CurrentSession ? null : service_68.Auth.CurrentSession.SessionKey;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.GenerateNewSession = function () {
            return __awaiter(this, void 0, ng_utils_64.$q, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = service_68.Auth;
                            return [4, service_68.Auth.StartSessionThin(sites_11.default.Current)];
                        case 1: return [2, _a.CurrentSession = _b.sent()];
                    }
                });
            });
        };
        Controller.prototype.RetryOnSessionFail = function (action, generateSession) {
            var _this = this;
            if (generateSession === void 0) { generateSession = function () { return _this.GenerateNewSession(); }; }
            return utils.RetryOnSessionFail({
                sessionKey: this.SessionKey,
                generateSession: generateSession,
                invoke: action,
            });
        };
        Controller.prototype.RaiseErrors = function (promise) {
            return __awaiter(this, void 0, void 0, function () {
                var err_59;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, promise];
                        case 1: return [2, _a.sent()];
                        case 2:
                            err_59 = _a.sent();
                            Controller_62.NotifyError(err_59);
                            throw err_59;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.RaiseErrors = function (promise) {
            return __awaiter(this, void 0, void 0, function () {
                var err_60;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, promise];
                        case 1: return [2, _a.sent()];
                        case 2:
                            err_60 = _a.sent();
                            Controller_62.NotifyError(err_60);
                            throw err_60;
                        case 3: return [2];
                    }
                });
            });
        };
        Controller.NotifyError = function (err) {
            utils.Toast.Simple("An error occurred while trying to set up your account");
            ng_utils_64.$exceptionHandler(err);
        };
        __decorate([
            utils.Bind.In("setup-account-password-token")
        ], Controller.prototype, "SetupAccountPasswordToken", void 0);
        __decorate([
            utils.Bind.Getter("close")
        ], Controller.prototype, "BoundClose", void 0);
        Controller = Controller_62 = __decorate([
            utils.Component({
                ModuleId: module_82.id,
            })
        ], Controller);
        return Controller;
        var Controller_62;
    }(utils.ControllerBase));
    exports.Controller = Controller;
});
//# sourceMappingURL=typescript-output.js.map;
